const AYATH = [
  {
    id: "1",
    sura: "1",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    ayatBN: "শুরু করছি আল্লাহর নামে যিনি পরম করুণাময়, অতি দয়ালু।",
    ayatEN: "In the name of Allah, Most Gracious, Most Merciful.",
  },
  {
    id: "2",
    sura: "1",
    VerseIDAr: "2",
    ayatAR: "الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
    ayatBN: "যাবতীয় প্রশংসা আল্লাহ তাআলার যিনি সকল সৃষ্টি জগতের পালনকর্তা।",
  },
  { id: "3", sura: "1", VerseIDAr: "3", ayatAR: "الرَّحْمَٰنِ الرَّحِيمِ" },
  { id: "4", sura: "1", VerseIDAr: "4", ayatAR: "مَالِكِ يَوْمِ الدِّينِ" },
  {
    id: "5",
    sura: "1",
    VerseIDAr: "5",
    ayatAR: "إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ",
  },
  {
    id: "6",
    sura: "1",
    VerseIDAr: "6",
    ayatAR: "اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ",
  },
  {
    id: "7",
    sura: "1",
    VerseIDAr: "7",
    ayatAR:
      "صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ",
  },
  {
    id: "8",
    sura: "2",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  {
    id: "9",
    sura: "2",
    VerseIDAr: "2",
    ayatAR: "ذَٰلِكَ الْكِتَابُ لَا رَيْبَ ۛ فِيهِ ۛ هُدًى لِلْمُتَّقِينَ",
  },
  {
    id: "10",
    sura: "2",
    VerseIDAr: "3",
    ayatAR:
      "الَّذِينَ يُؤْمِنُونَ بِالْغَيْبِ وَيُقِيمُونَ الصَّلَاةَ وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "11",
    sura: "2",
    VerseIDAr: "4",
    ayatAR:
      "وَالَّذِينَ يُؤْمِنُونَ بِمَا أُنْزِلَ إِلَيْكَ وَمَا أُنْزِلَ مِنْ قَبْلِكَ وَبِالْآخِرَةِ هُمْ يُوقِنُونَ",
  },
  {
    id: "12",
    sura: "2",
    VerseIDAr: "5",
    ayatAR:
      "أُولَٰئِكَ عَلَىٰ هُدًى مِنْ رَبِّهِمْ ۖ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "13",
    sura: "2",
    VerseIDAr: "6",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا سَوَاءٌ عَلَيْهِمْ أَأَنْذَرْتَهُمْ أَمْ لَمْ تُنْذِرْهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "14",
    sura: "2",
    VerseIDAr: "7",
    ayatAR:
      "خَتَمَ اللَّهُ عَلَىٰ قُلُوبِهِمْ وَعَلَىٰ سَمْعِهِمْ ۖ وَعَلَىٰ أَبْصَارِهِمْ غِشَاوَةٌ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "15",
    sura: "2",
    VerseIDAr: "8",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَقُولُ آمَنَّا بِاللَّهِ وَبِالْيَوْمِ الْآخِرِ وَمَا هُمْ بِمُؤْمِنِينَ",
  },
  {
    id: "16",
    sura: "2",
    VerseIDAr: "9",
    ayatAR:
      "يُخَادِعُونَ اللَّهَ وَالَّذِينَ آمَنُوا وَمَا يَخْدَعُونَ إِلَّا أَنْفُسَهُمْ وَمَا يَشْعُرُونَ",
  },
  {
    id: "17",
    sura: "2",
    VerseIDAr: "10",
    ayatAR:
      "فِي قُلُوبِهِمْ مَرَضٌ فَزَادَهُمُ اللَّهُ مَرَضًا ۖ وَلَهُمْ عَذَابٌ أَلِيمٌ بِمَا كَانُوا يَكْذِبُونَ",
  },
  {
    id: "18",
    sura: "2",
    VerseIDAr: "11",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ لَا تُفْسِدُوا فِي الْأَرْضِ قَالُوا إِنَّمَا نَحْنُ مُصْلِحُونَ",
  },
  {
    id: "19",
    sura: "2",
    VerseIDAr: "12",
    ayatAR: "أَلَا إِنَّهُمْ هُمُ الْمُفْسِدُونَ وَلَٰكِنْ لَا يَشْعُرُونَ",
  },
  {
    id: "20",
    sura: "2",
    VerseIDAr: "13",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ آمِنُوا كَمَا آمَنَ النَّاسُ قَالُوا أَنُؤْمِنُ كَمَا آمَنَ السُّفَهَاءُ ۗ أَلَا إِنَّهُمْ هُمُ السُّفَهَاءُ وَلَٰكِنْ لَا يَعْلَمُونَ",
  },
  {
    id: "21",
    sura: "2",
    VerseIDAr: "14",
    ayatAR:
      "وَإِذَا لَقُوا الَّذِينَ آمَنُوا قَالُوا آمَنَّا وَإِذَا خَلَوْا إِلَىٰ شَيَاطِينِهِمْ قَالُوا إِنَّا مَعَكُمْ إِنَّمَا نَحْنُ مُسْتَهْزِئُونَ",
  },
  {
    id: "22",
    sura: "2",
    VerseIDAr: "15",
    ayatAR:
      "اللَّهُ يَسْتَهْزِئُ بِهِمْ وَيَمُدُّهُمْ فِي طُغْيَانِهِمْ يَعْمَهُونَ",
  },
  {
    id: "23",
    sura: "2",
    VerseIDAr: "16",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ اشْتَرَوُا الضَّلَالَةَ بِالْهُدَىٰ فَمَا رَبِحَتْ تِجَارَتُهُمْ وَمَا كَانُوا مُهْتَدِينَ",
  },
  {
    id: "24",
    sura: "2",
    VerseIDAr: "17",
    ayatAR:
      "مَثَلُهُمْ كَمَثَلِ الَّذِي اسْتَوْقَدَ نَارًا فَلَمَّا أَضَاءَتْ مَا حَوْلَهُ ذَهَبَ اللَّهُ بِنُورِهِمْ وَتَرَكَهُمْ فِي ظُلُمَاتٍ لَا يُبْصِرُونَ",
  },
  {
    id: "25",
    sura: "2",
    VerseIDAr: "18",
    ayatAR: "صُمٌّ بُكْمٌ عُمْيٌ فَهُمْ لَا يَرْجِعُونَ",
  },
  {
    id: "26",
    sura: "2",
    VerseIDAr: "19",
    ayatAR:
      "أَوْ كَصَيِّبٍ مِنَ السَّمَاءِ فِيهِ ظُلُمَاتٌ وَرَعْدٌ وَبَرْقٌ يَجْعَلُونَ أَصَابِعَهُمْ فِي آذَانِهِمْ مِنَ الصَّوَاعِقِ حَذَرَ الْمَوْتِ ۚ وَاللَّهُ مُحِيطٌ بِالْكَافِرِينَ",
  },
  {
    id: "27",
    sura: "2",
    VerseIDAr: "20",
    ayatAR:
      "يَكَادُ الْبَرْقُ يَخْطَفُ أَبْصَارَهُمْ ۖ كُلَّمَا أَضَاءَ لَهُمْ مَشَوْا فِيهِ وَإِذَا أَظْلَمَ عَلَيْهِمْ قَامُوا ۚ وَلَوْ شَاءَ اللَّهُ لَذَهَبَ بِسَمْعِهِمْ وَأَبْصَارِهِمْ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "28",
    sura: "2",
    VerseIDAr: "21",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ اعْبُدُوا رَبَّكُمُ الَّذِي خَلَقَكُمْ وَالَّذِينَ مِنْ قَبْلِكُمْ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "29",
    sura: "2",
    VerseIDAr: "22",
    ayatAR:
      "الَّذِي جَعَلَ لَكُمُ الْأَرْضَ فِرَاشًا وَالسَّمَاءَ بِنَاءً وَأَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَخْرَجَ بِهِ مِنَ الثَّمَرَاتِ رِزْقًا لَكُمْ ۖ فَلَا تَجْعَلُوا لِلَّهِ أَنْدَادًا وَأَنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "30",
    sura: "2",
    VerseIDAr: "23",
    ayatAR:
      "وَإِنْ كُنْتُمْ فِي رَيْبٍ مِمَّا نَزَّلْنَا عَلَىٰ عَبْدِنَا فَأْتُوا بِسُورَةٍ مِنْ مِثْلِهِ وَادْعُوا شُهَدَاءَكُمْ مِنْ دُونِ اللَّهِ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "31",
    sura: "2",
    VerseIDAr: "24",
    ayatAR:
      "فَإِنْ لَمْ تَفْعَلُوا وَلَنْ تَفْعَلُوا فَاتَّقُوا النَّارَ الَّتِي وَقُودُهَا النَّاسُ وَالْحِجَارَةُ ۖ أُعِدَّتْ لِلْكَافِرِينَ",
  },
  {
    id: "32",
    sura: "2",
    VerseIDAr: "25",
    ayatAR:
      "وَبَشِّرِ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ أَنَّ لَهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ كُلَّمَا رُزِقُوا مِنْهَا مِنْ ثَمَرَةٍ رِزْقًا ۙ قَالُوا هَٰذَا الَّذِي رُزِقْنَا مِنْ قَبْلُ ۖ وَأُتُوا بِهِ مُتَشَابِهًا ۖ وَلَهُمْ فِيهَا أَزْوَاجٌ مُطَهَّرَةٌ ۖ وَهُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "33",
    sura: "2",
    VerseIDAr: "26",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَسْتَحْيِي أَنْ يَضْرِبَ مَثَلًا مَا بَعُوضَةً فَمَا فَوْقَهَا ۚ فَأَمَّا الَّذِينَ آمَنُوا فَيَعْلَمُونَ أَنَّهُ الْحَقُّ مِنْ رَبِّهِمْ ۖ وَأَمَّا الَّذِينَ كَفَرُوا فَيَقُولُونَ مَاذَا أَرَادَ اللَّهُ بِهَٰذَا مَثَلًا ۘ يُضِلُّ بِهِ كَثِيرًا وَيَهْدِي بِهِ كَثِيرًا ۚ وَمَا يُضِلُّ بِهِ إِلَّا الْفَاسِقِينَ",
  },
  {
    id: "34",
    sura: "2",
    VerseIDAr: "27",
    ayatAR:
      "الَّذِينَ يَنْقُضُونَ عَهْدَ اللَّهِ مِنْ بَعْدِ مِيثَاقِهِ وَيَقْطَعُونَ مَا أَمَرَ اللَّهُ بِهِ أَنْ يُوصَلَ وَيُفْسِدُونَ فِي الْأَرْضِ ۚ أُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "35",
    sura: "2",
    VerseIDAr: "28",
    ayatAR:
      "كَيْفَ تَكْفُرُونَ بِاللَّهِ وَكُنْتُمْ أَمْوَاتًا فَأَحْيَاكُمْ ۖ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ثُمَّ إِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "36",
    sura: "2",
    VerseIDAr: "29",
    ayatAR:
      "هُوَ الَّذِي خَلَقَ لَكُمْ مَا فِي الْأَرْضِ جَمِيعًا ثُمَّ اسْتَوَىٰ إِلَى السَّمَاءِ فَسَوَّاهُنَّ سَبْعَ سَمَاوَاتٍ ۚ وَهُوَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "37",
    sura: "2",
    VerseIDAr: "30",
    ayatAR:
      "وَإِذْ قَالَ رَبُّكَ لِلْمَلَائِكَةِ إِنِّي جَاعِلٌ فِي الْأَرْضِ خَلِيفَةً ۖ قَالُوا أَتَجْعَلُ فِيهَا مَنْ يُفْسِدُ فِيهَا وَيَسْفِكُ الدِّمَاءَ وَنَحْنُ نُسَبِّحُ بِحَمْدِكَ وَنُقَدِّسُ لَكَ ۖ قَالَ إِنِّي أَعْلَمُ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "38",
    sura: "2",
    VerseIDAr: "31",
    ayatAR:
      "وَعَلَّمَ آدَمَ الْأَسْمَاءَ كُلَّهَا ثُمَّ عَرَضَهُمْ عَلَى الْمَلَائِكَةِ فَقَالَ أَنْبِئُونِي بِأَسْمَاءِ هَٰؤُلَاءِ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "39",
    sura: "2",
    VerseIDAr: "32",
    ayatAR:
      "قَالُوا سُبْحَانَكَ لَا عِلْمَ لَنَا إِلَّا مَا عَلَّمْتَنَا ۖ إِنَّكَ أَنْتَ الْعَلِيمُ الْحَكِيمُ",
  },
  {
    id: "40",
    sura: "2",
    VerseIDAr: "33",
    ayatAR:
      "قَالَ يَا آدَمُ أَنْبِئْهُمْ بِأَسْمَائِهِمْ ۖ فَلَمَّا أَنْبَأَهُمْ بِأَسْمَائِهِمْ قَالَ أَلَمْ أَقُلْ لَكُمْ إِنِّي أَعْلَمُ غَيْبَ السَّمَاوَاتِ وَالْأَرْضِ وَأَعْلَمُ مَا تُبْدُونَ وَمَا كُنْتُمْ تَكْتُمُونَ",
  },
  {
    id: "41",
    sura: "2",
    VerseIDAr: "34",
    ayatAR:
      "وَإِذْ قُلْنَا لِلْمَلَائِكَةِ اسْجُدُوا لِآدَمَ فَسَجَدُوا إِلَّا إِبْلِيسَ أَبَىٰ وَاسْتَكْبَرَ وَكَانَ مِنَ الْكَافِرِينَ",
  },
  {
    id: "42",
    sura: "2",
    VerseIDAr: "35",
    ayatAR:
      "وَقُلْنَا يَا آدَمُ اسْكُنْ أَنْتَ وَزَوْجُكَ الْجَنَّةَ وَكُلَا مِنْهَا رَغَدًا حَيْثُ شِئْتُمَا وَلَا تَقْرَبَا هَٰذِهِ الشَّجَرَةَ فَتَكُونَا مِنَ الظَّالِمِينَ",
  },
  {
    id: "43",
    sura: "2",
    VerseIDAr: "36",
    ayatAR:
      "فَأَزَلَّهُمَا الشَّيْطَانُ عَنْهَا فَأَخْرَجَهُمَا مِمَّا كَانَا فِيهِ ۖ وَقُلْنَا اهْبِطُوا بَعْضُكُمْ لِبَعْضٍ عَدُوٌّ ۖ وَلَكُمْ فِي الْأَرْضِ مُسْتَقَرٌّ وَمَتَاعٌ إِلَىٰ حِينٍ",
  },
  {
    id: "44",
    sura: "2",
    VerseIDAr: "37",
    ayatAR:
      "فَتَلَقَّىٰ آدَمُ مِنْ رَبِّهِ كَلِمَاتٍ فَتَابَ عَلَيْهِ ۚ إِنَّهُ هُوَ التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "45",
    sura: "2",
    VerseIDAr: "38",
    ayatAR:
      "قُلْنَا اهْبِطُوا مِنْهَا جَمِيعًا ۖ فَإِمَّا يَأْتِيَنَّكُمْ مِنِّي هُدًى فَمَنْ تَبِعَ هُدَايَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "46",
    sura: "2",
    VerseIDAr: "39",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا أُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "47",
    sura: "2",
    VerseIDAr: "40",
    ayatAR:
      "يَا بَنِي إِسْرَائِيلَ اذْكُرُوا نِعْمَتِيَ الَّتِي أَنْعَمْتُ عَلَيْكُمْ وَأَوْفُوا بِعَهْدِي أُوفِ بِعَهْدِكُمْ وَإِيَّايَ فَارْهَبُونِ",
  },
  {
    id: "48",
    sura: "2",
    VerseIDAr: "41",
    ayatAR:
      "وَآمِنُوا بِمَا أَنْزَلْتُ مُصَدِّقًا لِمَا مَعَكُمْ وَلَا تَكُونُوا أَوَّلَ كَافِرٍ بِهِ ۖ وَلَا تَشْتَرُوا بِآيَاتِي ثَمَنًا قَلِيلًا وَإِيَّايَ فَاتَّقُونِ",
  },
  {
    id: "49",
    sura: "2",
    VerseIDAr: "42",
    ayatAR:
      "وَلَا تَلْبِسُوا الْحَقَّ بِالْبَاطِلِ وَتَكْتُمُوا الْحَقَّ وَأَنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "50",
    sura: "2",
    VerseIDAr: "43",
    ayatAR:
      "وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَارْكَعُوا مَعَ الرَّاكِعِينَ",
  },
  {
    id: "51",
    sura: "2",
    VerseIDAr: "44",
    ayatAR:
      "أَتَأْمُرُونَ النَّاسَ بِالْبِرِّ وَتَنْسَوْنَ أَنْفُسَكُمْ وَأَنْتُمْ تَتْلُونَ الْكِتَابَ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "52",
    sura: "2",
    VerseIDAr: "45",
    ayatAR:
      "وَاسْتَعِينُوا بِالصَّبْرِ وَالصَّلَاةِ ۚ وَإِنَّهَا لَكَبِيرَةٌ إِلَّا عَلَى الْخَاشِعِينَ",
  },
  {
    id: "53",
    sura: "2",
    VerseIDAr: "46",
    ayatAR:
      "الَّذِينَ يَظُنُّونَ أَنَّهُمْ مُلَاقُو رَبِّهِمْ وَأَنَّهُمْ إِلَيْهِ رَاجِعُونَ",
  },
  {
    id: "54",
    sura: "2",
    VerseIDAr: "47",
    ayatAR:
      "يَا بَنِي إِسْرَائِيلَ اذْكُرُوا نِعْمَتِيَ الَّتِي أَنْعَمْتُ عَلَيْكُمْ وَأَنِّي فَضَّلْتُكُمْ عَلَى الْعَالَمِينَ",
  },
  {
    id: "55",
    sura: "2",
    VerseIDAr: "48",
    ayatAR:
      "وَاتَّقُوا يَوْمًا لَا تَجْزِي نَفْسٌ عَنْ نَفْسٍ شَيْئًا وَلَا يُقْبَلُ مِنْهَا شَفَاعَةٌ وَلَا يُؤْخَذُ مِنْهَا عَدْلٌ وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "56",
    sura: "2",
    VerseIDAr: "49",
    ayatAR:
      "وَإِذْ نَجَّيْنَاكُمْ مِنْ آلِ فِرْعَوْنَ يَسُومُونَكُمْ سُوءَ الْعَذَابِ يُذَبِّحُونَ أَبْنَاءَكُمْ وَيَسْتَحْيُونَ نِسَاءَكُمْ ۚ وَفِي ذَٰلِكُمْ بَلَاءٌ مِنْ رَبِّكُمْ عَظِيمٌ",
  },
  {
    id: "57",
    sura: "2",
    VerseIDAr: "50",
    ayatAR:
      "وَإِذْ فَرَقْنَا بِكُمُ الْبَحْرَ فَأَنْجَيْنَاكُمْ وَأَغْرَقْنَا آلَ فِرْعَوْنَ وَأَنْتُمْ تَنْظُرُونَ",
  },
  {
    id: "58",
    sura: "2",
    VerseIDAr: "51",
    ayatAR:
      "وَإِذْ وَاعَدْنَا مُوسَىٰ أَرْبَعِينَ لَيْلَةً ثُمَّ اتَّخَذْتُمُ الْعِجْلَ مِنْ بَعْدِهِ وَأَنْتُمْ ظَالِمُونَ",
  },
  {
    id: "59",
    sura: "2",
    VerseIDAr: "52",
    ayatAR:
      "ثُمَّ عَفَوْنَا عَنْكُمْ مِنْ بَعْدِ ذَٰلِكَ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "60",
    sura: "2",
    VerseIDAr: "53",
    ayatAR:
      "وَإِذْ آتَيْنَا مُوسَى الْكِتَابَ وَالْفُرْقَانَ لَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "61",
    sura: "2",
    VerseIDAr: "54",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ يَا قَوْمِ إِنَّكُمْ ظَلَمْتُمْ أَنْفُسَكُمْ بِاتِّخَاذِكُمُ الْعِجْلَ فَتُوبُوا إِلَىٰ بَارِئِكُمْ فَاقْتُلُوا أَنْفُسَكُمْ ذَٰلِكُمْ خَيْرٌ لَكُمْ عِنْدَ بَارِئِكُمْ فَتَابَ عَلَيْكُمْ ۚ إِنَّهُ هُوَ التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "62",
    sura: "2",
    VerseIDAr: "55",
    ayatAR:
      "وَإِذْ قُلْتُمْ يَا مُوسَىٰ لَنْ نُؤْمِنَ لَكَ حَتَّىٰ نَرَى اللَّهَ جَهْرَةً فَأَخَذَتْكُمُ الصَّاعِقَةُ وَأَنْتُمْ تَنْظُرُونَ",
  },
  {
    id: "63",
    sura: "2",
    VerseIDAr: "56",
    ayatAR:
      "ثُمَّ بَعَثْنَاكُمْ مِنْ بَعْدِ مَوْتِكُمْ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "64",
    sura: "2",
    VerseIDAr: "57",
    ayatAR:
      "وَظَلَّلْنَا عَلَيْكُمُ الْغَمَامَ وَأَنْزَلْنَا عَلَيْكُمُ الْمَنَّ وَالسَّلْوَىٰ ۖ كُلُوا مِنْ طَيِّبَاتِ مَا رَزَقْنَاكُمْ ۖ وَمَا ظَلَمُونَا وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "65",
    sura: "2",
    VerseIDAr: "58",
    ayatAR:
      "وَإِذْ قُلْنَا ادْخُلُوا هَٰذِهِ الْقَرْيَةَ فَكُلُوا مِنْهَا حَيْثُ شِئْتُمْ رَغَدًا وَادْخُلُوا الْبَابَ سُجَّدًا وَقُولُوا حِطَّةٌ نَغْفِرْ لَكُمْ خَطَايَاكُمْ ۚ وَسَنَزِيدُ الْمُحْسِنِينَ",
  },
  {
    id: "66",
    sura: "2",
    VerseIDAr: "59",
    ayatAR:
      "فَبَدَّلَ الَّذِينَ ظَلَمُوا قَوْلًا غَيْرَ الَّذِي قِيلَ لَهُمْ فَأَنْزَلْنَا عَلَى الَّذِينَ ظَلَمُوا رِجْزًا مِنَ السَّمَاءِ بِمَا كَانُوا يَفْسُقُونَ",
  },
  {
    id: "67",
    sura: "2",
    VerseIDAr: "60",
    ayatAR:
      "وَإِذِ اسْتَسْقَىٰ مُوسَىٰ لِقَوْمِهِ فَقُلْنَا اضْرِبْ بِعَصَاكَ الْحَجَرَ ۖ فَانْفَجَرَتْ مِنْهُ اثْنَتَا عَشْرَةَ عَيْنًا ۖ قَدْ عَلِمَ كُلُّ أُنَاسٍ مَشْرَبَهُمْ ۖ كُلُوا وَاشْرَبُوا مِنْ رِزْقِ اللَّهِ وَلَا تَعْثَوْا فِي الْأَرْضِ مُفْسِدِينَ",
  },
  {
    id: "68",
    sura: "2",
    VerseIDAr: "61",
    ayatAR:
      "وَإِذْ قُلْتُمْ يَا مُوسَىٰ لَنْ نَصْبِرَ عَلَىٰ طَعَامٍ وَاحِدٍ فَادْعُ لَنَا رَبَّكَ يُخْرِجْ لَنَا مِمَّا تُنْبِتُ الْأَرْضُ مِنْ بَقْلِهَا وَقِثَّائِهَا وَفُومِهَا وَعَدَسِهَا وَبَصَلِهَا ۖ قَالَ أَتَسْتَبْدِلُونَ الَّذِي هُوَ أَدْنَىٰ بِالَّذِي هُوَ خَيْرٌ ۚ اهْبِطُوا مِصْرًا فَإِنَّ لَكُمْ مَا سَأَلْتُمْ ۗ وَضُرِبَتْ عَلَيْهِمُ الذِّلَّةُ وَالْمَسْكَنَةُ وَبَاءُوا بِغَضَبٍ مِنَ اللَّهِ ۗ ذَٰلِكَ بِأَنَّهُمْ كَانُوا يَكْفُرُونَ بِآيَاتِ اللَّهِ وَيَقْتُلُونَ النَّبِيِّينَ بِغَيْرِ الْحَقِّ ۗ ذَٰلِكَ بِمَا عَصَوْا وَكَانُوا يَعْتَدُونَ",
  },
  {
    id: "69",
    sura: "2",
    VerseIDAr: "62",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَالَّذِينَ هَادُوا وَالنَّصَارَىٰ وَالصَّابِئِينَ مَنْ آمَنَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَعَمِلَ صَالِحًا فَلَهُمْ أَجْرُهُمْ عِنْدَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "70",
    sura: "2",
    VerseIDAr: "63",
    ayatAR:
      "وَإِذْ أَخَذْنَا مِيثَاقَكُمْ وَرَفَعْنَا فَوْقَكُمُ الطُّورَ خُذُوا مَا آتَيْنَاكُمْ بِقُوَّةٍ وَاذْكُرُوا مَا فِيهِ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "71",
    sura: "2",
    VerseIDAr: "64",
    ayatAR:
      "ثُمَّ تَوَلَّيْتُمْ مِنْ بَعْدِ ذَٰلِكَ ۖ فَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ لَكُنْتُمْ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "72",
    sura: "2",
    VerseIDAr: "65",
    ayatAR:
      "وَلَقَدْ عَلِمْتُمُ الَّذِينَ اعْتَدَوْا مِنْكُمْ فِي السَّبْتِ فَقُلْنَا لَهُمْ كُونُوا قِرَدَةً خَاسِئِينَ",
  },
  {
    id: "73",
    sura: "2",
    VerseIDAr: "66",
    ayatAR:
      "فَجَعَلْنَاهَا نَكَالًا لِمَا بَيْنَ يَدَيْهَا وَمَا خَلْفَهَا وَمَوْعِظَةً لِلْمُتَّقِينَ",
  },
  {
    id: "74",
    sura: "2",
    VerseIDAr: "67",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ إِنَّ اللَّهَ يَأْمُرُكُمْ أَنْ تَذْبَحُوا بَقَرَةً ۖ قَالُوا أَتَتَّخِذُنَا هُزُوًا ۖ قَالَ أَعُوذُ بِاللَّهِ أَنْ أَكُونَ مِنَ الْجَاهِلِينَ",
  },
  {
    id: "75",
    sura: "2",
    VerseIDAr: "68",
    ayatAR:
      "قَالُوا ادْعُ لَنَا رَبَّكَ يُبَيِّنْ لَنَا مَا هِيَ ۚ قَالَ إِنَّهُ يَقُولُ إِنَّهَا بَقَرَةٌ لَا فَارِضٌ وَلَا بِكْرٌ عَوَانٌ بَيْنَ ذَٰلِكَ ۖ فَافْعَلُوا مَا تُؤْمَرُونَ",
  },
  {
    id: "76",
    sura: "2",
    VerseIDAr: "69",
    ayatAR:
      "قَالُوا ادْعُ لَنَا رَبَّكَ يُبَيِّنْ لَنَا مَا لَوْنُهَا ۚ قَالَ إِنَّهُ يَقُولُ إِنَّهَا بَقَرَةٌ صَفْرَاءُ فَاقِعٌ لَوْنُهَا تَسُرُّ النَّاظِرِينَ",
  },
  {
    id: "77",
    sura: "2",
    VerseIDAr: "70",
    ayatAR:
      "قَالُوا ادْعُ لَنَا رَبَّكَ يُبَيِّنْ لَنَا مَا هِيَ إِنَّ الْبَقَرَ تَشَابَهَ عَلَيْنَا وَإِنَّا إِنْ شَاءَ اللَّهُ لَمُهْتَدُونَ",
  },
  {
    id: "78",
    sura: "2",
    VerseIDAr: "71",
    ayatAR:
      "قَالَ إِنَّهُ يَقُولُ إِنَّهَا بَقَرَةٌ لَا ذَلُولٌ تُثِيرُ الْأَرْضَ وَلَا تَسْقِي الْحَرْثَ مُسَلَّمَةٌ لَا شِيَةَ فِيهَا ۚ قَالُوا الْآنَ جِئْتَ بِالْحَقِّ ۚ فَذَبَحُوهَا وَمَا كَادُوا يَفْعَلُونَ",
  },
  {
    id: "79",
    sura: "2",
    VerseIDAr: "72",
    ayatAR:
      "وَإِذْ قَتَلْتُمْ نَفْسًا فَادَّارَأْتُمْ فِيهَا ۖ وَاللَّهُ مُخْرِجٌ مَا كُنْتُمْ تَكْتُمُونَ",
  },
  {
    id: "80",
    sura: "2",
    VerseIDAr: "73",
    ayatAR:
      "فَقُلْنَا اضْرِبُوهُ بِبَعْضِهَا ۚ كَذَٰلِكَ يُحْيِي اللَّهُ الْمَوْتَىٰ وَيُرِيكُمْ آيَاتِهِ لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "81",
    sura: "2",
    VerseIDAr: "74",
    ayatAR:
      "ثُمَّ قَسَتْ قُلُوبُكُمْ مِنْ بَعْدِ ذَٰلِكَ فَهِيَ كَالْحِجَارَةِ أَوْ أَشَدُّ قَسْوَةً ۚ وَإِنَّ مِنَ الْحِجَارَةِ لَمَا يَتَفَجَّرُ مِنْهُ الْأَنْهَارُ ۚ وَإِنَّ مِنْهَا لَمَا يَشَّقَّقُ فَيَخْرُجُ مِنْهُ الْمَاءُ ۚ وَإِنَّ مِنْهَا لَمَا يَهْبِطُ مِنْ خَشْيَةِ اللَّهِ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "82",
    sura: "2",
    VerseIDAr: "75",
    ayatAR:
      "أَفَتَطْمَعُونَ أَنْ يُؤْمِنُوا لَكُمْ وَقَدْ كَانَ فَرِيقٌ مِنْهُمْ يَسْمَعُونَ كَلَامَ اللَّهِ ثُمَّ يُحَرِّفُونَهُ مِنْ بَعْدِ مَا عَقَلُوهُ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "83",
    sura: "2",
    VerseIDAr: "76",
    ayatAR:
      "وَإِذَا لَقُوا الَّذِينَ آمَنُوا قَالُوا آمَنَّا وَإِذَا خَلَا بَعْضُهُمْ إِلَىٰ بَعْضٍ قَالُوا أَتُحَدِّثُونَهُمْ بِمَا فَتَحَ اللَّهُ عَلَيْكُمْ لِيُحَاجُّوكُمْ بِهِ عِنْدَ رَبِّكُمْ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "84",
    sura: "2",
    VerseIDAr: "77",
    ayatAR:
      "أَوَلَا يَعْلَمُونَ أَنَّ اللَّهَ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ",
  },
  {
    id: "85",
    sura: "2",
    VerseIDAr: "78",
    ayatAR:
      "وَمِنْهُمْ أُمِّيُّونَ لَا يَعْلَمُونَ الْكِتَابَ إِلَّا أَمَانِيَّ وَإِنْ هُمْ إِلَّا يَظُنُّونَ",
  },
  {
    id: "86",
    sura: "2",
    VerseIDAr: "79",
    ayatAR:
      "فَوَيْلٌ لِلَّذِينَ يَكْتُبُونَ الْكِتَابَ بِأَيْدِيهِمْ ثُمَّ يَقُولُونَ هَٰذَا مِنْ عِنْدِ اللَّهِ لِيَشْتَرُوا بِهِ ثَمَنًا قَلِيلًا ۖ فَوَيْلٌ لَهُمْ مِمَّا كَتَبَتْ أَيْدِيهِمْ وَوَيْلٌ لَهُمْ مِمَّا يَكْسِبُونَ",
  },
  {
    id: "87",
    sura: "2",
    VerseIDAr: "80",
    ayatAR:
      "وَقَالُوا لَنْ تَمَسَّنَا النَّارُ إِلَّا أَيَّامًا مَعْدُودَةً ۚ قُلْ أَتَّخَذْتُمْ عِنْدَ اللَّهِ عَهْدًا فَلَنْ يُخْلِفَ اللَّهُ عَهْدَهُ ۖ أَمْ تَقُولُونَ عَلَى اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "88",
    sura: "2",
    VerseIDAr: "81",
    ayatAR:
      "بَلَىٰ مَنْ كَسَبَ سَيِّئَةً وَأَحَاطَتْ بِهِ خَطِيئَتُهُ فَأُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "89",
    sura: "2",
    VerseIDAr: "82",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ أُولَٰئِكَ أَصْحَابُ الْجَنَّةِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "90",
    sura: "2",
    VerseIDAr: "83",
    ayatAR:
      "وَإِذْ أَخَذْنَا مِيثَاقَ بَنِي إِسْرَائِيلَ لَا تَعْبُدُونَ إِلَّا اللَّهَ وَبِالْوَالِدَيْنِ إِحْسَانًا وَذِي الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينِ وَقُولُوا لِلنَّاسِ حُسْنًا وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ ثُمَّ تَوَلَّيْتُمْ إِلَّا قَلِيلًا مِنْكُمْ وَأَنْتُمْ مُعْرِضُونَ",
  },
  {
    id: "91",
    sura: "2",
    VerseIDAr: "84",
    ayatAR:
      "وَإِذْ أَخَذْنَا مِيثَاقَكُمْ لَا تَسْفِكُونَ دِمَاءَكُمْ وَلَا تُخْرِجُونَ أَنْفُسَكُمْ مِنْ دِيَارِكُمْ ثُمَّ أَقْرَرْتُمْ وَأَنْتُمْ تَشْهَدُونَ",
  },
  {
    id: "92",
    sura: "2",
    VerseIDAr: "85",
    ayatAR:
      "ثُمَّ أَنْتُمْ هَٰؤُلَاءِ تَقْتُلُونَ أَنْفُسَكُمْ وَتُخْرِجُونَ فَرِيقًا مِنْكُمْ مِنْ دِيَارِهِمْ تَظَاهَرُونَ عَلَيْهِمْ بِالْإِثْمِ وَالْعُدْوَانِ وَإِنْ يَأْتُوكُمْ أُسَارَىٰ تُفَادُوهُمْ وَهُوَ مُحَرَّمٌ عَلَيْكُمْ إِخْرَاجُهُمْ ۚ أَفَتُؤْمِنُونَ بِبَعْضِ الْكِتَابِ وَتَكْفُرُونَ بِبَعْضٍ ۚ فَمَا جَزَاءُ مَنْ يَفْعَلُ ذَٰلِكَ مِنْكُمْ إِلَّا خِزْيٌ فِي الْحَيَاةِ الدُّنْيَا ۖ وَيَوْمَ الْقِيَامَةِ يُرَدُّونَ إِلَىٰ أَشَدِّ الْعَذَابِ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "93",
    sura: "2",
    VerseIDAr: "86",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ اشْتَرَوُا الْحَيَاةَ الدُّنْيَا بِالْآخِرَةِ ۖ فَلَا يُخَفَّفُ عَنْهُمُ الْعَذَابُ وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "94",
    sura: "2",
    VerseIDAr: "87",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ وَقَفَّيْنَا مِنْ بَعْدِهِ بِالرُّسُلِ ۖ وَآتَيْنَا عِيسَى ابْنَ مَرْيَمَ الْبَيِّنَاتِ وَأَيَّدْنَاهُ بِرُوحِ الْقُدُسِ ۗ أَفَكُلَّمَا جَاءَكُمْ رَسُولٌ بِمَا لَا تَهْوَىٰ أَنْفُسُكُمُ اسْتَكْبَرْتُمْ فَفَرِيقًا كَذَّبْتُمْ وَفَرِيقًا تَقْتُلُونَ",
  },
  {
    id: "95",
    sura: "2",
    VerseIDAr: "88",
    ayatAR:
      "وَقَالُوا قُلُوبُنَا غُلْفٌ ۚ بَلْ لَعَنَهُمُ اللَّهُ بِكُفْرِهِمْ فَقَلِيلًا مَا يُؤْمِنُونَ",
  },
  {
    id: "96",
    sura: "2",
    VerseIDAr: "89",
    ayatAR:
      "وَلَمَّا جَاءَهُمْ كِتَابٌ مِنْ عِنْدِ اللَّهِ مُصَدِّقٌ لِمَا مَعَهُمْ وَكَانُوا مِنْ قَبْلُ يَسْتَفْتِحُونَ عَلَى الَّذِينَ كَفَرُوا فَلَمَّا جَاءَهُمْ مَا عَرَفُوا كَفَرُوا بِهِ ۚ فَلَعْنَةُ اللَّهِ عَلَى الْكَافِرِينَ",
  },
  {
    id: "97",
    sura: "2",
    VerseIDAr: "90",
    ayatAR:
      "بِئْسَمَا اشْتَرَوْا بِهِ أَنْفُسَهُمْ أَنْ يَكْفُرُوا بِمَا أَنْزَلَ اللَّهُ بَغْيًا أَنْ يُنَزِّلَ اللَّهُ مِنْ فَضْلِهِ عَلَىٰ مَنْ يَشَاءُ مِنْ عِبَادِهِ ۖ فَبَاءُوا بِغَضَبٍ عَلَىٰ غَضَبٍ ۚ وَلِلْكَافِرِينَ عَذَابٌ مُهِينٌ",
  },
  {
    id: "98",
    sura: "2",
    VerseIDAr: "91",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ آمِنُوا بِمَا أَنْزَلَ اللَّهُ قَالُوا نُؤْمِنُ بِمَا أُنْزِلَ عَلَيْنَا وَيَكْفُرُونَ بِمَا وَرَاءَهُ وَهُوَ الْحَقُّ مُصَدِّقًا لِمَا مَعَهُمْ ۗ قُلْ فَلِمَ تَقْتُلُونَ أَنْبِيَاءَ اللَّهِ مِنْ قَبْلُ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "99",
    sura: "2",
    VerseIDAr: "92",
    ayatAR:
      "وَلَقَدْ جَاءَكُمْ مُوسَىٰ بِالْبَيِّنَاتِ ثُمَّ اتَّخَذْتُمُ الْعِجْلَ مِنْ بَعْدِهِ وَأَنْتُمْ ظَالِمُونَ",
  },
  {
    id: "100",
    sura: "2",
    VerseIDAr: "93",
    ayatAR:
      "وَإِذْ أَخَذْنَا مِيثَاقَكُمْ وَرَفَعْنَا فَوْقَكُمُ الطُّورَ خُذُوا مَا آتَيْنَاكُمْ بِقُوَّةٍ وَاسْمَعُوا ۖ قَالُوا سَمِعْنَا وَعَصَيْنَا وَأُشْرِبُوا فِي قُلُوبِهِمُ الْعِجْلَ بِكُفْرِهِمْ ۚ قُلْ بِئْسَمَا يَأْمُرُكُمْ بِهِ إِيمَانُكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "101",
    sura: "2",
    VerseIDAr: "94",
    ayatAR:
      "قُلْ إِنْ كَانَتْ لَكُمُ الدَّارُ الْآخِرَةُ عِنْدَ اللَّهِ خَالِصَةً مِنْ دُونِ النَّاسِ فَتَمَنَّوُا الْمَوْتَ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "102",
    sura: "2",
    VerseIDAr: "95",
    ayatAR:
      "وَلَنْ يَتَمَنَّوْهُ أَبَدًا بِمَا قَدَّمَتْ أَيْدِيهِمْ ۗ وَاللَّهُ عَلِيمٌ بِالظَّالِمِينَ",
  },
  {
    id: "103",
    sura: "2",
    VerseIDAr: "96",
    ayatAR:
      "وَلَتَجِدَنَّهُمْ أَحْرَصَ النَّاسِ عَلَىٰ حَيَاةٍ وَمِنَ الَّذِينَ أَشْرَكُوا ۚ يَوَدُّ أَحَدُهُمْ لَوْ يُعَمَّرُ أَلْفَ سَنَةٍ وَمَا هُوَ بِمُزَحْزِحِهِ مِنَ الْعَذَابِ أَنْ يُعَمَّرَ ۗ وَاللَّهُ بَصِيرٌ بِمَا يَعْمَلُونَ",
  },
  {
    id: "104",
    sura: "2",
    VerseIDAr: "97",
    ayatAR:
      "قُلْ مَنْ كَانَ عَدُوًّا لِجِبْرِيلَ فَإِنَّهُ نَزَّلَهُ عَلَىٰ قَلْبِكَ بِإِذْنِ اللَّهِ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ وَهُدًى وَبُشْرَىٰ لِلْمُؤْمِنِينَ",
  },
  {
    id: "105",
    sura: "2",
    VerseIDAr: "98",
    ayatAR:
      "مَنْ كَانَ عَدُوًّا لِلَّهِ وَمَلَائِكَتِهِ وَرُسُلِهِ وَجِبْرِيلَ وَمِيكَالَ فَإِنَّ اللَّهَ عَدُوٌّ لِلْكَافِرِينَ",
  },
  {
    id: "106",
    sura: "2",
    VerseIDAr: "99",
    ayatAR:
      "وَلَقَدْ أَنْزَلْنَا إِلَيْكَ آيَاتٍ بَيِّنَاتٍ ۖ وَمَا يَكْفُرُ بِهَا إِلَّا الْفَاسِقُونَ",
  },
  {
    id: "107",
    sura: "2",
    VerseIDAr: "100",
    ayatAR:
      "أَوَكُلَّمَا عَاهَدُوا عَهْدًا نَبَذَهُ فَرِيقٌ مِنْهُمْ ۚ بَلْ أَكْثَرُهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "108",
    sura: "2",
    VerseIDAr: "101",
    ayatAR:
      "وَلَمَّا جَاءَهُمْ رَسُولٌ مِنْ عِنْدِ اللَّهِ مُصَدِّقٌ لِمَا مَعَهُمْ نَبَذَ فَرِيقٌ مِنَ الَّذِينَ أُوتُوا الْكِتَابَ كِتَابَ اللَّهِ وَرَاءَ ظُهُورِهِمْ كَأَنَّهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "109",
    sura: "2",
    VerseIDAr: "102",
    ayatAR:
      "وَاتَّبَعُوا مَا تَتْلُو الشَّيَاطِينُ عَلَىٰ مُلْكِ سُلَيْمَانَ ۖ وَمَا كَفَرَ سُلَيْمَانُ وَلَٰكِنَّ الشَّيَاطِينَ كَفَرُوا يُعَلِّمُونَ النَّاسَ السِّحْرَ وَمَا أُنْزِلَ عَلَى الْمَلَكَيْنِ بِبَابِلَ هَارُوتَ وَمَارُوتَ ۚ وَمَا يُعَلِّمَانِ مِنْ أَحَدٍ حَتَّىٰ يَقُولَا إِنَّمَا نَحْنُ فِتْنَةٌ فَلَا تَكْفُرْ ۖ فَيَتَعَلَّمُونَ مِنْهُمَا مَا يُفَرِّقُونَ بِهِ بَيْنَ الْمَرْءِ وَزَوْجِهِ ۚ وَمَا هُمْ بِضَارِّينَ بِهِ مِنْ أَحَدٍ إِلَّا بِإِذْنِ اللَّهِ ۚ وَيَتَعَلَّمُونَ مَا يَضُرُّهُمْ وَلَا يَنْفَعُهُمْ ۚ وَلَقَدْ عَلِمُوا لَمَنِ اشْتَرَاهُ مَا لَهُ فِي الْآخِرَةِ مِنْ خَلَاقٍ ۚ وَلَبِئْسَ مَا شَرَوْا بِهِ أَنْفُسَهُمْ ۚ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "110",
    sura: "2",
    VerseIDAr: "103",
    ayatAR:
      "وَلَوْ أَنَّهُمْ آمَنُوا وَاتَّقَوْا لَمَثُوبَةٌ مِنْ عِنْدِ اللَّهِ خَيْرٌ ۖ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "111",
    sura: "2",
    VerseIDAr: "104",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَقُولُوا رَاعِنَا وَقُولُوا انْظُرْنَا وَاسْمَعُوا ۗ وَلِلْكَافِرِينَ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "112",
    sura: "2",
    VerseIDAr: "105",
    ayatAR:
      "مَا يَوَدُّ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ وَلَا الْمُشْرِكِينَ أَنْ يُنَزَّلَ عَلَيْكُمْ مِنْ خَيْرٍ مِنْ رَبِّكُمْ ۗ وَاللَّهُ يَخْتَصُّ بِرَحْمَتِهِ مَنْ يَشَاءُ ۚ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "113",
    sura: "2",
    VerseIDAr: "106",
    ayatAR:
      "مَا نَنْسَخْ مِنْ آيَةٍ أَوْ نُنْسِهَا نَأْتِ بِخَيْرٍ مِنْهَا أَوْ مِثْلِهَا ۗ أَلَمْ تَعْلَمْ أَنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "114",
    sura: "2",
    VerseIDAr: "107",
    ayatAR:
      "أَلَمْ تَعْلَمْ أَنَّ اللَّهَ لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۗ وَمَا لَكُمْ مِنْ دُونِ اللَّهِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "115",
    sura: "2",
    VerseIDAr: "108",
    ayatAR:
      "أَمْ تُرِيدُونَ أَنْ تَسْأَلُوا رَسُولَكُمْ كَمَا سُئِلَ مُوسَىٰ مِنْ قَبْلُ ۗ وَمَنْ يَتَبَدَّلِ الْكُفْرَ بِالْإِيمَانِ فَقَدْ ضَلَّ سَوَاءَ السَّبِيلِ",
  },
  {
    id: "116",
    sura: "2",
    VerseIDAr: "109",
    ayatAR:
      "وَدَّ كَثِيرٌ مِنْ أَهْلِ الْكِتَابِ لَوْ يَرُدُّونَكُمْ مِنْ بَعْدِ إِيمَانِكُمْ كُفَّارًا حَسَدًا مِنْ عِنْدِ أَنْفُسِهِمْ مِنْ بَعْدِ مَا تَبَيَّنَ لَهُمُ الْحَقُّ ۖ فَاعْفُوا وَاصْفَحُوا حَتَّىٰ يَأْتِيَ اللَّهُ بِأَمْرِهِ ۗ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "117",
    sura: "2",
    VerseIDAr: "110",
    ayatAR:
      "وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ ۚ وَمَا تُقَدِّمُوا لِأَنْفُسِكُمْ مِنْ خَيْرٍ تَجِدُوهُ عِنْدَ اللَّهِ ۗ إِنَّ اللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "118",
    sura: "2",
    VerseIDAr: "111",
    ayatAR:
      "وَقَالُوا لَنْ يَدْخُلَ الْجَنَّةَ إِلَّا مَنْ كَانَ هُودًا أَوْ نَصَارَىٰ ۗ تِلْكَ أَمَانِيُّهُمْ ۗ قُلْ هَاتُوا بُرْهَانَكُمْ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "119",
    sura: "2",
    VerseIDAr: "112",
    ayatAR:
      "بَلَىٰ مَنْ أَسْلَمَ وَجْهَهُ لِلَّهِ وَهُوَ مُحْسِنٌ فَلَهُ أَجْرُهُ عِنْدَ رَبِّهِ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "120",
    sura: "2",
    VerseIDAr: "113",
    ayatAR:
      "وَقَالَتِ الْيَهُودُ لَيْسَتِ النَّصَارَىٰ عَلَىٰ شَيْءٍ وَقَالَتِ النَّصَارَىٰ لَيْسَتِ الْيَهُودُ عَلَىٰ شَيْءٍ وَهُمْ يَتْلُونَ الْكِتَابَ ۗ كَذَٰلِكَ قَالَ الَّذِينَ لَا يَعْلَمُونَ مِثْلَ قَوْلِهِمْ ۚ فَاللَّهُ يَحْكُمُ بَيْنَهُمْ يَوْمَ الْقِيَامَةِ فِيمَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "121",
    sura: "2",
    VerseIDAr: "114",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنْ مَنَعَ مَسَاجِدَ اللَّهِ أَنْ يُذْكَرَ فِيهَا اسْمُهُ وَسَعَىٰ فِي خَرَابِهَا ۚ أُولَٰئِكَ مَا كَانَ لَهُمْ أَنْ يَدْخُلُوهَا إِلَّا خَائِفِينَ ۚ لَهُمْ فِي الدُّنْيَا خِزْيٌ وَلَهُمْ فِي الْآخِرَةِ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "122",
    sura: "2",
    VerseIDAr: "115",
    ayatAR:
      "وَلِلَّهِ الْمَشْرِقُ وَالْمَغْرِبُ ۚ فَأَيْنَمَا تُوَلُّوا فَثَمَّ وَجْهُ اللَّهِ ۚ إِنَّ اللَّهَ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "123",
    sura: "2",
    VerseIDAr: "116",
    ayatAR:
      "وَقَالُوا اتَّخَذَ اللَّهُ وَلَدًا ۗ سُبْحَانَهُ ۖ بَلْ لَهُ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ كُلٌّ لَهُ قَانِتُونَ",
  },
  {
    id: "124",
    sura: "2",
    VerseIDAr: "117",
    ayatAR:
      "بَدِيعُ السَّمَاوَاتِ وَالْأَرْضِ ۖ وَإِذَا قَضَىٰ أَمْرًا فَإِنَّمَا يَقُولُ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "125",
    sura: "2",
    VerseIDAr: "118",
    ayatAR:
      "وَقَالَ الَّذِينَ لَا يَعْلَمُونَ لَوْلَا يُكَلِّمُنَا اللَّهُ أَوْ تَأْتِينَا آيَةٌ ۗ كَذَٰلِكَ قَالَ الَّذِينَ مِنْ قَبْلِهِمْ مِثْلَ قَوْلِهِمْ ۘ تَشَابَهَتْ قُلُوبُهُمْ ۗ قَدْ بَيَّنَّا الْآيَاتِ لِقَوْمٍ يُوقِنُونَ",
  },
  {
    id: "126",
    sura: "2",
    VerseIDAr: "119",
    ayatAR:
      "إِنَّا أَرْسَلْنَاكَ بِالْحَقِّ بَشِيرًا وَنَذِيرًا ۖ وَلَا تُسْأَلُ عَنْ أَصْحَابِ الْجَحِيمِ",
  },
  {
    id: "127",
    sura: "2",
    VerseIDAr: "120",
    ayatAR:
      "وَلَنْ تَرْضَىٰ عَنْكَ الْيَهُودُ وَلَا النَّصَارَىٰ حَتَّىٰ تَتَّبِعَ مِلَّتَهُمْ ۗ قُلْ إِنَّ هُدَى اللَّهِ هُوَ الْهُدَىٰ ۗ وَلَئِنِ اتَّبَعْتَ أَهْوَاءَهُمْ بَعْدَ الَّذِي جَاءَكَ مِنَ الْعِلْمِ ۙ مَا لَكَ مِنَ اللَّهِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "128",
    sura: "2",
    VerseIDAr: "121",
    ayatAR:
      "الَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يَتْلُونَهُ حَقَّ تِلَاوَتِهِ أُولَٰئِكَ يُؤْمِنُونَ بِهِ ۗ وَمَنْ يَكْفُرْ بِهِ فَأُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "129",
    sura: "2",
    VerseIDAr: "122",
    ayatAR:
      "يَا بَنِي إِسْرَائِيلَ اذْكُرُوا نِعْمَتِيَ الَّتِي أَنْعَمْتُ عَلَيْكُمْ وَأَنِّي فَضَّلْتُكُمْ عَلَى الْعَالَمِينَ",
  },
  {
    id: "130",
    sura: "2",
    VerseIDAr: "123",
    ayatAR:
      "وَاتَّقُوا يَوْمًا لَا تَجْزِي نَفْسٌ عَنْ نَفْسٍ شَيْئًا وَلَا يُقْبَلُ مِنْهَا عَدْلٌ وَلَا تَنْفَعُهَا شَفَاعَةٌ وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "131",
    sura: "2",
    VerseIDAr: "124",
    ayatAR:
      "وَإِذِ ابْتَلَىٰ إِبْرَاهِيمَ رَبُّهُ بِكَلِمَاتٍ فَأَتَمَّهُنَّ ۖ قَالَ إِنِّي جَاعِلُكَ لِلنَّاسِ إِمَامًا ۖ قَالَ وَمِنْ ذُرِّيَّتِي ۖ قَالَ لَا يَنَالُ عَهْدِي الظَّالِمِينَ",
  },
  {
    id: "132",
    sura: "2",
    VerseIDAr: "125",
    ayatAR:
      "وَإِذْ جَعَلْنَا الْبَيْتَ مَثَابَةً لِلنَّاسِ وَأَمْنًا وَاتَّخِذُوا مِنْ مَقَامِ إِبْرَاهِيمَ مُصَلًّى ۖ وَعَهِدْنَا إِلَىٰ إِبْرَاهِيمَ وَإِسْمَاعِيلَ أَنْ طَهِّرَا بَيْتِيَ لِلطَّائِفِينَ وَالْعَاكِفِينَ وَالرُّكَّعِ السُّجُودِ",
  },
  {
    id: "133",
    sura: "2",
    VerseIDAr: "126",
    ayatAR:
      "وَإِذْ قَالَ إِبْرَاهِيمُ رَبِّ اجْعَلْ هَٰذَا بَلَدًا آمِنًا وَارْزُقْ أَهْلَهُ مِنَ الثَّمَرَاتِ مَنْ آمَنَ مِنْهُمْ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۖ قَالَ وَمَنْ كَفَرَ فَأُمَتِّعُهُ قَلِيلًا ثُمَّ أَضْطَرُّهُ إِلَىٰ عَذَابِ النَّارِ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "134",
    sura: "2",
    VerseIDAr: "127",
    ayatAR:
      "وَإِذْ يَرْفَعُ إِبْرَاهِيمُ الْقَوَاعِدَ مِنَ الْبَيْتِ وَإِسْمَاعِيلُ رَبَّنَا تَقَبَّلْ مِنَّا ۖ إِنَّكَ أَنْتَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "135",
    sura: "2",
    VerseIDAr: "128",
    ayatAR:
      "رَبَّنَا وَاجْعَلْنَا مُسْلِمَيْنِ لَكَ وَمِنْ ذُرِّيَّتِنَا أُمَّةً مُسْلِمَةً لَكَ وَأَرِنَا مَنَاسِكَنَا وَتُبْ عَلَيْنَا ۖ إِنَّكَ أَنْتَ التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "136",
    sura: "2",
    VerseIDAr: "129",
    ayatAR:
      "رَبَّنَا وَابْعَثْ فِيهِمْ رَسُولًا مِنْهُمْ يَتْلُو عَلَيْهِمْ آيَاتِكَ وَيُعَلِّمُهُمُ الْكِتَابَ وَالْحِكْمَةَ وَيُزَكِّيهِمْ ۚ إِنَّكَ أَنْتَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "137",
    sura: "2",
    VerseIDAr: "130",
    ayatAR:
      "وَمَنْ يَرْغَبُ عَنْ مِلَّةِ إِبْرَاهِيمَ إِلَّا مَنْ سَفِهَ نَفْسَهُ ۚ وَلَقَدِ اصْطَفَيْنَاهُ فِي الدُّنْيَا ۖ وَإِنَّهُ فِي الْآخِرَةِ لَمِنَ الصَّالِحِينَ",
  },
  {
    id: "138",
    sura: "2",
    VerseIDAr: "131",
    ayatAR:
      "إِذْ قَالَ لَهُ رَبُّهُ أَسْلِمْ ۖ قَالَ أَسْلَمْتُ لِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "139",
    sura: "2",
    VerseIDAr: "132",
    ayatAR:
      "وَوَصَّىٰ بِهَا إِبْرَاهِيمُ بَنِيهِ وَيَعْقُوبُ يَا بَنِيَّ إِنَّ اللَّهَ اصْطَفَىٰ لَكُمُ الدِّينَ فَلَا تَمُوتُنَّ إِلَّا وَأَنْتُمْ مُسْلِمُونَ",
  },
  {
    id: "140",
    sura: "2",
    VerseIDAr: "133",
    ayatAR:
      "أَمْ كُنْتُمْ شُهَدَاءَ إِذْ حَضَرَ يَعْقُوبَ الْمَوْتُ إِذْ قَالَ لِبَنِيهِ مَا تَعْبُدُونَ مِنْ بَعْدِي قَالُوا نَعْبُدُ إِلَٰهَكَ وَإِلَٰهَ آبَائِكَ إِبْرَاهِيمَ وَإِسْمَاعِيلَ وَإِسْحَاقَ إِلَٰهًا وَاحِدًا وَنَحْنُ لَهُ مُسْلِمُونَ",
  },
  {
    id: "141",
    sura: "2",
    VerseIDAr: "134",
    ayatAR:
      "تِلْكَ أُمَّةٌ قَدْ خَلَتْ ۖ لَهَا مَا كَسَبَتْ وَلَكُمْ مَا كَسَبْتُمْ ۖ وَلَا تُسْأَلُونَ عَمَّا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "142",
    sura: "2",
    VerseIDAr: "135",
    ayatAR:
      "وَقَالُوا كُونُوا هُودًا أَوْ نَصَارَىٰ تَهْتَدُوا ۗ قُلْ بَلْ مِلَّةَ إِبْرَاهِيمَ حَنِيفًا ۖ وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "143",
    sura: "2",
    VerseIDAr: "136",
    ayatAR:
      "قُولُوا آمَنَّا بِاللَّهِ وَمَا أُنْزِلَ إِلَيْنَا وَمَا أُنْزِلَ إِلَىٰ إِبْرَاهِيمَ وَإِسْمَاعِيلَ وَإِسْحَاقَ وَيَعْقُوبَ وَالْأَسْبَاطِ وَمَا أُوتِيَ مُوسَىٰ وَعِيسَىٰ وَمَا أُوتِيَ النَّبِيُّونَ مِنْ رَبِّهِمْ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْهُمْ وَنَحْنُ لَهُ مُسْلِمُونَ",
  },
  {
    id: "144",
    sura: "2",
    VerseIDAr: "137",
    ayatAR:
      "فَإِنْ آمَنُوا بِمِثْلِ مَا آمَنْتُمْ بِهِ فَقَدِ اهْتَدَوْا ۖ وَإِنْ تَوَلَّوْا فَإِنَّمَا هُمْ فِي شِقَاقٍ ۖ فَسَيَكْفِيكَهُمُ اللَّهُ ۚ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "145",
    sura: "2",
    VerseIDAr: "138",
    ayatAR:
      "صِبْغَةَ اللَّهِ ۖ وَمَنْ أَحْسَنُ مِنَ اللَّهِ صِبْغَةً ۖ وَنَحْنُ لَهُ عَابِدُونَ",
  },
  {
    id: "146",
    sura: "2",
    VerseIDAr: "139",
    ayatAR:
      "قُلْ أَتُحَاجُّونَنَا فِي اللَّهِ وَهُوَ رَبُّنَا وَرَبُّكُمْ وَلَنَا أَعْمَالُنَا وَلَكُمْ أَعْمَالُكُمْ وَنَحْنُ لَهُ مُخْلِصُونَ",
  },
  {
    id: "147",
    sura: "2",
    VerseIDAr: "140",
    ayatAR:
      "أَمْ تَقُولُونَ إِنَّ إِبْرَاهِيمَ وَإِسْمَاعِيلَ وَإِسْحَاقَ وَيَعْقُوبَ وَالْأَسْبَاطَ كَانُوا هُودًا أَوْ نَصَارَىٰ ۗ قُلْ أَأَنْتُمْ أَعْلَمُ أَمِ اللَّهُ ۗ وَمَنْ أَظْلَمُ مِمَّنْ كَتَمَ شَهَادَةً عِنْدَهُ مِنَ اللَّهِ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "148",
    sura: "2",
    VerseIDAr: "141",
    ayatAR:
      "تِلْكَ أُمَّةٌ قَدْ خَلَتْ ۖ لَهَا مَا كَسَبَتْ وَلَكُمْ مَا كَسَبْتُمْ ۖ وَلَا تُسْأَلُونَ عَمَّا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "149",
    sura: "2",
    VerseIDAr: "142",
    ayatAR:
      "سَيَقُولُ السُّفَهَاءُ مِنَ النَّاسِ مَا وَلَّاهُمْ عَنْ قِبْلَتِهِمُ الَّتِي كَانُوا عَلَيْهَا ۚ قُلْ لِلَّهِ الْمَشْرِقُ وَالْمَغْرِبُ ۚ يَهْدِي مَنْ يَشَاءُ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "150",
    sura: "2",
    VerseIDAr: "143",
    ayatAR:
      "وَكَذَٰلِكَ جَعَلْنَاكُمْ أُمَّةً وَسَطًا لِتَكُونُوا شُهَدَاءَ عَلَى النَّاسِ وَيَكُونَ الرَّسُولُ عَلَيْكُمْ شَهِيدًا ۗ وَمَا جَعَلْنَا الْقِبْلَةَ الَّتِي كُنْتَ عَلَيْهَا إِلَّا لِنَعْلَمَ مَنْ يَتَّبِعُ الرَّسُولَ مِمَّنْ يَنْقَلِبُ عَلَىٰ عَقِبَيْهِ ۚ وَإِنْ كَانَتْ لَكَبِيرَةً إِلَّا عَلَى الَّذِينَ هَدَى اللَّهُ ۗ وَمَا كَانَ اللَّهُ لِيُضِيعَ إِيمَانَكُمْ ۚ إِنَّ اللَّهَ بِالنَّاسِ لَرَءُوفٌ رَحِيمٌ",
  },
  {
    id: "151",
    sura: "2",
    VerseIDAr: "144",
    ayatAR:
      "قَدْ نَرَىٰ تَقَلُّبَ وَجْهِكَ فِي السَّمَاءِ ۖ فَلَنُوَلِّيَنَّكَ قِبْلَةً تَرْضَاهَا ۚ فَوَلِّ وَجْهَكَ شَطْرَ الْمَسْجِدِ الْحَرَامِ ۚ وَحَيْثُ مَا كُنْتُمْ فَوَلُّوا وُجُوهَكُمْ شَطْرَهُ ۗ وَإِنَّ الَّذِينَ أُوتُوا الْكِتَابَ لَيَعْلَمُونَ أَنَّهُ الْحَقُّ مِنْ رَبِّهِمْ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا يَعْمَلُونَ",
  },
  {
    id: "152",
    sura: "2",
    VerseIDAr: "145",
    ayatAR:
      "وَلَئِنْ أَتَيْتَ الَّذِينَ أُوتُوا الْكِتَابَ بِكُلِّ آيَةٍ مَا تَبِعُوا قِبْلَتَكَ ۚ وَمَا أَنْتَ بِتَابِعٍ قِبْلَتَهُمْ ۚ وَمَا بَعْضُهُمْ بِتَابِعٍ قِبْلَةَ بَعْضٍ ۚ وَلَئِنِ اتَّبَعْتَ أَهْوَاءَهُمْ مِنْ بَعْدِ مَا جَاءَكَ مِنَ الْعِلْمِ ۙ إِنَّكَ إِذًا لَمِنَ الظَّالِمِينَ",
  },
  {
    id: "153",
    sura: "2",
    VerseIDAr: "146",
    ayatAR:
      "الَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يَعْرِفُونَهُ كَمَا يَعْرِفُونَ أَبْنَاءَهُمْ ۖ وَإِنَّ فَرِيقًا مِنْهُمْ لَيَكْتُمُونَ الْحَقَّ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "154",
    sura: "2",
    VerseIDAr: "147",
    ayatAR: "الْحَقُّ مِنْ رَبِّكَ ۖ فَلَا تَكُونَنَّ مِنَ الْمُمْتَرِينَ",
  },
  {
    id: "155",
    sura: "2",
    VerseIDAr: "148",
    ayatAR:
      "وَلِكُلٍّ وِجْهَةٌ هُوَ مُوَلِّيهَا ۖ فَاسْتَبِقُوا الْخَيْرَاتِ ۚ أَيْنَ مَا تَكُونُوا يَأْتِ بِكُمُ اللَّهُ جَمِيعًا ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "156",
    sura: "2",
    VerseIDAr: "149",
    ayatAR:
      "وَمِنْ حَيْثُ خَرَجْتَ فَوَلِّ وَجْهَكَ شَطْرَ الْمَسْجِدِ الْحَرَامِ ۖ وَإِنَّهُ لَلْحَقُّ مِنْ رَبِّكَ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "157",
    sura: "2",
    VerseIDAr: "150",
    ayatAR:
      "وَمِنْ حَيْثُ خَرَجْتَ فَوَلِّ وَجْهَكَ شَطْرَ الْمَسْجِدِ الْحَرَامِ ۚ وَحَيْثُ مَا كُنْتُمْ فَوَلُّوا وُجُوهَكُمْ شَطْرَهُ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَيْكُمْ حُجَّةٌ إِلَّا الَّذِينَ ظَلَمُوا مِنْهُمْ فَلَا تَخْشَوْهُمْ وَاخْشَوْنِي وَلِأُتِمَّ نِعْمَتِي عَلَيْكُمْ وَلَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "158",
    sura: "2",
    VerseIDAr: "151",
    ayatAR:
      "كَمَا أَرْسَلْنَا فِيكُمْ رَسُولًا مِنْكُمْ يَتْلُو عَلَيْكُمْ آيَاتِنَا وَيُزَكِّيكُمْ وَيُعَلِّمُكُمُ الْكِتَابَ وَالْحِكْمَةَ وَيُعَلِّمُكُمْ مَا لَمْ تَكُونُوا تَعْلَمُونَ",
  },
  {
    id: "159",
    sura: "2",
    VerseIDAr: "152",
    ayatAR: "فَاذْكُرُونِي أَذْكُرْكُمْ وَاشْكُرُوا لِي وَلَا تَكْفُرُونِ",
  },
  {
    id: "160",
    sura: "2",
    VerseIDAr: "153",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اسْتَعِينُوا بِالصَّبْرِ وَالصَّلَاةِ ۚ إِنَّ اللَّهَ مَعَ الصَّابِرِينَ",
  },
  {
    id: "161",
    sura: "2",
    VerseIDAr: "154",
    ayatAR:
      "وَلَا تَقُولُوا لِمَنْ يُقْتَلُ فِي سَبِيلِ اللَّهِ أَمْوَاتٌ ۚ بَلْ أَحْيَاءٌ وَلَٰكِنْ لَا تَشْعُرُونَ",
  },
  {
    id: "162",
    sura: "2",
    VerseIDAr: "155",
    ayatAR:
      "وَلَنَبْلُوَنَّكُمْ بِشَيْءٍ مِنَ الْخَوْفِ وَالْجُوعِ وَنَقْصٍ مِنَ الْأَمْوَالِ وَالْأَنْفُسِ وَالثَّمَرَاتِ ۗ وَبَشِّرِ الصَّابِرِينَ",
  },
  {
    id: "163",
    sura: "2",
    VerseIDAr: "156",
    ayatAR:
      "الَّذِينَ إِذَا أَصَابَتْهُمْ مُصِيبَةٌ قَالُوا إِنَّا لِلَّهِ وَإِنَّا إِلَيْهِ رَاجِعُونَ",
  },
  {
    id: "164",
    sura: "2",
    VerseIDAr: "157",
    ayatAR:
      "أُولَٰئِكَ عَلَيْهِمْ صَلَوَاتٌ مِنْ رَبِّهِمْ وَرَحْمَةٌ ۖ وَأُولَٰئِكَ هُمُ الْمُهْتَدُونَ",
  },
  {
    id: "165",
    sura: "2",
    VerseIDAr: "158",
    ayatAR:
      "إِنَّ الصَّفَا وَالْمَرْوَةَ مِنْ شَعَائِرِ اللَّهِ ۖ فَمَنْ حَجَّ الْبَيْتَ أَوِ اعْتَمَرَ فَلَا جُنَاحَ عَلَيْهِ أَنْ يَطَّوَّفَ بِهِمَا ۚ وَمَنْ تَطَوَّعَ خَيْرًا فَإِنَّ اللَّهَ شَاكِرٌ عَلِيمٌ",
  },
  {
    id: "166",
    sura: "2",
    VerseIDAr: "159",
    ayatAR:
      "إِنَّ الَّذِينَ يَكْتُمُونَ مَا أَنْزَلْنَا مِنَ الْبَيِّنَاتِ وَالْهُدَىٰ مِنْ بَعْدِ مَا بَيَّنَّاهُ لِلنَّاسِ فِي الْكِتَابِ ۙ أُولَٰئِكَ يَلْعَنُهُمُ اللَّهُ وَيَلْعَنُهُمُ اللَّاعِنُونَ",
  },
  {
    id: "167",
    sura: "2",
    VerseIDAr: "160",
    ayatAR:
      "إِلَّا الَّذِينَ تَابُوا وَأَصْلَحُوا وَبَيَّنُوا فَأُولَٰئِكَ أَتُوبُ عَلَيْهِمْ ۚ وَأَنَا التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "168",
    sura: "2",
    VerseIDAr: "161",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَمَاتُوا وَهُمْ كُفَّارٌ أُولَٰئِكَ عَلَيْهِمْ لَعْنَةُ اللَّهِ وَالْمَلَائِكَةِ وَالنَّاسِ أَجْمَعِينَ",
  },
  {
    id: "169",
    sura: "2",
    VerseIDAr: "162",
    ayatAR:
      "خَالِدِينَ فِيهَا ۖ لَا يُخَفَّفُ عَنْهُمُ الْعَذَابُ وَلَا هُمْ يُنْظَرُونَ",
  },
  {
    id: "170",
    sura: "2",
    VerseIDAr: "163",
    ayatAR:
      "وَإِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ ۖ لَا إِلَٰهَ إِلَّا هُوَ الرَّحْمَٰنُ الرَّحِيمُ",
  },
  {
    id: "171",
    sura: "2",
    VerseIDAr: "164",
    ayatAR:
      "إِنَّ فِي خَلْقِ السَّمَاوَاتِ وَالْأَرْضِ وَاخْتِلَافِ اللَّيْلِ وَالنَّهَارِ وَالْفُلْكِ الَّتِي تَجْرِي فِي الْبَحْرِ بِمَا يَنْفَعُ النَّاسَ وَمَا أَنْزَلَ اللَّهُ مِنَ السَّمَاءِ مِنْ مَاءٍ فَأَحْيَا بِهِ الْأَرْضَ بَعْدَ مَوْتِهَا وَبَثَّ فِيهَا مِنْ كُلِّ دَابَّةٍ وَتَصْرِيفِ الرِّيَاحِ وَالسَّحَابِ الْمُسَخَّرِ بَيْنَ السَّمَاءِ وَالْأَرْضِ لَآيَاتٍ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "172",
    sura: "2",
    VerseIDAr: "165",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَتَّخِذُ مِنْ دُونِ اللَّهِ أَنْدَادًا يُحِبُّونَهُمْ كَحُبِّ اللَّهِ ۖ وَالَّذِينَ آمَنُوا أَشَدُّ حُبًّا لِلَّهِ ۗ وَلَوْ يَرَى الَّذِينَ ظَلَمُوا إِذْ يَرَوْنَ الْعَذَابَ أَنَّ الْقُوَّةَ لِلَّهِ جَمِيعًا وَأَنَّ اللَّهَ شَدِيدُ الْعَذَابِ",
  },
  {
    id: "173",
    sura: "2",
    VerseIDAr: "166",
    ayatAR:
      "إِذْ تَبَرَّأَ الَّذِينَ اتُّبِعُوا مِنَ الَّذِينَ اتَّبَعُوا وَرَأَوُا الْعَذَابَ وَتَقَطَّعَتْ بِهِمُ الْأَسْبَابُ",
  },
  {
    id: "174",
    sura: "2",
    VerseIDAr: "167",
    ayatAR:
      "وَقَالَ الَّذِينَ اتَّبَعُوا لَوْ أَنَّ لَنَا كَرَّةً فَنَتَبَرَّأَ مِنْهُمْ كَمَا تَبَرَّءُوا مِنَّا ۗ كَذَٰلِكَ يُرِيهِمُ اللَّهُ أَعْمَالَهُمْ حَسَرَاتٍ عَلَيْهِمْ ۖ وَمَا هُمْ بِخَارِجِينَ مِنَ النَّارِ",
  },
  {
    id: "175",
    sura: "2",
    VerseIDAr: "168",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ كُلُوا مِمَّا فِي الْأَرْضِ حَلَالًا طَيِّبًا وَلَا تَتَّبِعُوا خُطُوَاتِ الشَّيْطَانِ ۚ إِنَّهُ لَكُمْ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "176",
    sura: "2",
    VerseIDAr: "169",
    ayatAR:
      "إِنَّمَا يَأْمُرُكُمْ بِالسُّوءِ وَالْفَحْشَاءِ وَأَنْ تَقُولُوا عَلَى اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "177",
    sura: "2",
    VerseIDAr: "170",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمُ اتَّبِعُوا مَا أَنْزَلَ اللَّهُ قَالُوا بَلْ نَتَّبِعُ مَا أَلْفَيْنَا عَلَيْهِ آبَاءَنَا ۗ أَوَلَوْ كَانَ آبَاؤُهُمْ لَا يَعْقِلُونَ شَيْئًا وَلَا يَهْتَدُونَ",
  },
  {
    id: "178",
    sura: "2",
    VerseIDAr: "171",
    ayatAR:
      "وَمَثَلُ الَّذِينَ كَفَرُوا كَمَثَلِ الَّذِي يَنْعِقُ بِمَا لَا يَسْمَعُ إِلَّا دُعَاءً وَنِدَاءً ۚ صُمٌّ بُكْمٌ عُمْيٌ فَهُمْ لَا يَعْقِلُونَ",
  },
  {
    id: "179",
    sura: "2",
    VerseIDAr: "172",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُلُوا مِنْ طَيِّبَاتِ مَا رَزَقْنَاكُمْ وَاشْكُرُوا لِلَّهِ إِنْ كُنْتُمْ إِيَّاهُ تَعْبُدُونَ",
  },
  {
    id: "180",
    sura: "2",
    VerseIDAr: "173",
    ayatAR:
      "إِنَّمَا حَرَّمَ عَلَيْكُمُ الْمَيْتَةَ وَالدَّمَ وَلَحْمَ الْخِنْزِيرِ وَمَا أُهِلَّ بِهِ لِغَيْرِ اللَّهِ ۖ فَمَنِ اضْطُرَّ غَيْرَ بَاغٍ وَلَا عَادٍ فَلَا إِثْمَ عَلَيْهِ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "181",
    sura: "2",
    VerseIDAr: "174",
    ayatAR:
      "إِنَّ الَّذِينَ يَكْتُمُونَ مَا أَنْزَلَ اللَّهُ مِنَ الْكِتَابِ وَيَشْتَرُونَ بِهِ ثَمَنًا قَلِيلًا ۙ أُولَٰئِكَ مَا يَأْكُلُونَ فِي بُطُونِهِمْ إِلَّا النَّارَ وَلَا يُكَلِّمُهُمُ اللَّهُ يَوْمَ الْقِيَامَةِ وَلَا يُزَكِّيهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "182",
    sura: "2",
    VerseIDAr: "175",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ اشْتَرَوُا الضَّلَالَةَ بِالْهُدَىٰ وَالْعَذَابَ بِالْمَغْفِرَةِ ۚ فَمَا أَصْبَرَهُمْ عَلَى النَّارِ",
  },
  {
    id: "183",
    sura: "2",
    VerseIDAr: "176",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ نَزَّلَ الْكِتَابَ بِالْحَقِّ ۗ وَإِنَّ الَّذِينَ اخْتَلَفُوا فِي الْكِتَابِ لَفِي شِقَاقٍ بَعِيدٍ",
  },
  {
    id: "184",
    sura: "2",
    VerseIDAr: "177",
    ayatAR:
      "لَيْسَ الْبِرَّ أَنْ تُوَلُّوا وُجُوهَكُمْ قِبَلَ الْمَشْرِقِ وَالْمَغْرِبِ وَلَٰكِنَّ الْبِرَّ مَنْ آمَنَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَالْمَلَائِكَةِ وَالْكِتَابِ وَالنَّبِيِّينَ وَآتَى الْمَالَ عَلَىٰ حُبِّهِ ذَوِي الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينَ وَابْنَ السَّبِيلِ وَالسَّائِلِينَ وَفِي الرِّقَابِ وَأَقَامَ الصَّلَاةَ وَآتَى الزَّكَاةَ وَالْمُوفُونَ بِعَهْدِهِمْ إِذَا عَاهَدُوا ۖ وَالصَّابِرِينَ فِي الْبَأْسَاءِ وَالضَّرَّاءِ وَحِينَ الْبَأْسِ ۗ أُولَٰئِكَ الَّذِينَ صَدَقُوا ۖ وَأُولَٰئِكَ هُمُ الْمُتَّقُونَ",
  },
  {
    id: "185",
    sura: "2",
    VerseIDAr: "178",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُتِبَ عَلَيْكُمُ الْقِصَاصُ فِي الْقَتْلَى ۖ الْحُرُّ بِالْحُرِّ وَالْعَبْدُ بِالْعَبْدِ وَالْأُنْثَىٰ بِالْأُنْثَىٰ ۚ فَمَنْ عُفِيَ لَهُ مِنْ أَخِيهِ شَيْءٌ فَاتِّبَاعٌ بِالْمَعْرُوفِ وَأَدَاءٌ إِلَيْهِ بِإِحْسَانٍ ۗ ذَٰلِكَ تَخْفِيفٌ مِنْ رَبِّكُمْ وَرَحْمَةٌ ۗ فَمَنِ اعْتَدَىٰ بَعْدَ ذَٰلِكَ فَلَهُ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "186",
    sura: "2",
    VerseIDAr: "179",
    ayatAR:
      "وَلَكُمْ فِي الْقِصَاصِ حَيَاةٌ يَا أُولِي الْأَلْبَابِ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "187",
    sura: "2",
    VerseIDAr: "180",
    ayatAR:
      "كُتِبَ عَلَيْكُمْ إِذَا حَضَرَ أَحَدَكُمُ الْمَوْتُ إِنْ تَرَكَ خَيْرًا الْوَصِيَّةُ لِلْوَالِدَيْنِ وَالْأَقْرَبِينَ بِالْمَعْرُوفِ ۖ حَقًّا عَلَى الْمُتَّقِينَ",
  },
  {
    id: "188",
    sura: "2",
    VerseIDAr: "181",
    ayatAR:
      "فَمَنْ بَدَّلَهُ بَعْدَمَا سَمِعَهُ فَإِنَّمَا إِثْمُهُ عَلَى الَّذِينَ يُبَدِّلُونَهُ ۚ إِنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "189",
    sura: "2",
    VerseIDAr: "182",
    ayatAR:
      "فَمَنْ خَافَ مِنْ مُوصٍ جَنَفًا أَوْ إِثْمًا فَأَصْلَحَ بَيْنَهُمْ فَلَا إِثْمَ عَلَيْهِ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "190",
    sura: "2",
    VerseIDAr: "183",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُتِبَ عَلَيْكُمُ الصِّيَامُ كَمَا كُتِبَ عَلَى الَّذِينَ مِنْ قَبْلِكُمْ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "191",
    sura: "2",
    VerseIDAr: "184",
    ayatAR:
      "أَيَّامًا مَعْدُودَاتٍ ۚ فَمَنْ كَانَ مِنْكُمْ مَرِيضًا أَوْ عَلَىٰ سَفَرٍ فَعِدَّةٌ مِنْ أَيَّامٍ أُخَرَ ۚ وَعَلَى الَّذِينَ يُطِيقُونَهُ فِدْيَةٌ طَعَامُ مِسْكِينٍ ۖ فَمَنْ تَطَوَّعَ خَيْرًا فَهُوَ خَيْرٌ لَهُ ۚ وَأَنْ تَصُومُوا خَيْرٌ لَكُمْ ۖ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "192",
    sura: "2",
    VerseIDAr: "185",
    ayatAR:
      "شَهْرُ رَمَضَانَ الَّذِي أُنْزِلَ فِيهِ الْقُرْآنُ هُدًى لِلنَّاسِ وَبَيِّنَاتٍ مِنَ الْهُدَىٰ وَالْفُرْقَانِ ۚ فَمَنْ شَهِدَ مِنْكُمُ الشَّهْرَ فَلْيَصُمْهُ ۖ وَمَنْ كَانَ مَرِيضًا أَوْ عَلَىٰ سَفَرٍ فَعِدَّةٌ مِنْ أَيَّامٍ أُخَرَ ۗ يُرِيدُ اللَّهُ بِكُمُ الْيُسْرَ وَلَا يُرِيدُ بِكُمُ الْعُسْرَ وَلِتُكْمِلُوا الْعِدَّةَ وَلِتُكَبِّرُوا اللَّهَ عَلَىٰ مَا هَدَاكُمْ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "193",
    sura: "2",
    VerseIDAr: "186",
    ayatAR:
      "وَإِذَا سَأَلَكَ عِبَادِي عَنِّي فَإِنِّي قَرِيبٌ ۖ أُجِيبُ دَعْوَةَ الدَّاعِ إِذَا دَعَانِ ۖ فَلْيَسْتَجِيبُوا لِي وَلْيُؤْمِنُوا بِي لَعَلَّهُمْ يَرْشُدُونَ",
  },
  {
    id: "194",
    sura: "2",
    VerseIDAr: "187",
    ayatAR:
      "أُحِلَّ لَكُمْ لَيْلَةَ الصِّيَامِ الرَّفَثُ إِلَىٰ نِسَائِكُمْ ۚ هُنَّ لِبَاسٌ لَكُمْ وَأَنْتُمْ لِبَاسٌ لَهُنَّ ۗ عَلِمَ اللَّهُ أَنَّكُمْ كُنْتُمْ تَخْتَانُونَ أَنْفُسَكُمْ فَتَابَ عَلَيْكُمْ وَعَفَا عَنْكُمْ ۖ فَالْآنَ بَاشِرُوهُنَّ وَابْتَغُوا مَا كَتَبَ اللَّهُ لَكُمْ ۚ وَكُلُوا وَاشْرَبُوا حَتَّىٰ يَتَبَيَّنَ لَكُمُ الْخَيْطُ الْأَبْيَضُ مِنَ الْخَيْطِ الْأَسْوَدِ مِنَ الْفَجْرِ ۖ ثُمَّ أَتِمُّوا الصِّيَامَ إِلَى اللَّيْلِ ۚ وَلَا تُبَاشِرُوهُنَّ وَأَنْتُمْ عَاكِفُونَ فِي الْمَسَاجِدِ ۗ تِلْكَ حُدُودُ اللَّهِ فَلَا تَقْرَبُوهَا ۗ كَذَٰلِكَ يُبَيِّنُ اللَّهُ آيَاتِهِ لِلنَّاسِ لَعَلَّهُمْ يَتَّقُونَ",
  },
  {
    id: "195",
    sura: "2",
    VerseIDAr: "188",
    ayatAR:
      "وَلَا تَأْكُلُوا أَمْوَالَكُمْ بَيْنَكُمْ بِالْبَاطِلِ وَتُدْلُوا بِهَا إِلَى الْحُكَّامِ لِتَأْكُلُوا فَرِيقًا مِنْ أَمْوَالِ النَّاسِ بِالْإِثْمِ وَأَنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "196",
    sura: "2",
    VerseIDAr: "189",
    ayatAR:
      "يَسْأَلُونَكَ عَنِ الْأَهِلَّةِ ۖ قُلْ هِيَ مَوَاقِيتُ لِلنَّاسِ وَالْحَجِّ ۗ وَلَيْسَ الْبِرُّ بِأَنْ تَأْتُوا الْبُيُوتَ مِنْ ظُهُورِهَا وَلَٰكِنَّ الْبِرَّ مَنِ اتَّقَىٰ ۗ وَأْتُوا الْبُيُوتَ مِنْ أَبْوَابِهَا ۚ وَاتَّقُوا اللَّهَ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "197",
    sura: "2",
    VerseIDAr: "190",
    ayatAR:
      "وَقَاتِلُوا فِي سَبِيلِ اللَّهِ الَّذِينَ يُقَاتِلُونَكُمْ وَلَا تَعْتَدُوا ۚ إِنَّ اللَّهَ لَا يُحِبُّ الْمُعْتَدِينَ",
  },
  {
    id: "198",
    sura: "2",
    VerseIDAr: "191",
    ayatAR:
      "وَاقْتُلُوهُمْ حَيْثُ ثَقِفْتُمُوهُمْ وَأَخْرِجُوهُمْ مِنْ حَيْثُ أَخْرَجُوكُمْ ۚ وَالْفِتْنَةُ أَشَدُّ مِنَ الْقَتْلِ ۚ وَلَا تُقَاتِلُوهُمْ عِنْدَ الْمَسْجِدِ الْحَرَامِ حَتَّىٰ يُقَاتِلُوكُمْ فِيهِ ۖ فَإِنْ قَاتَلُوكُمْ فَاقْتُلُوهُمْ ۗ كَذَٰلِكَ جَزَاءُ الْكَافِرِينَ",
  },
  {
    id: "199",
    sura: "2",
    VerseIDAr: "192",
    ayatAR: "فَإِنِ انْتَهَوْا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "200",
    sura: "2",
    VerseIDAr: "193",
    ayatAR:
      "وَقَاتِلُوهُمْ حَتَّىٰ لَا تَكُونَ فِتْنَةٌ وَيَكُونَ الدِّينُ لِلَّهِ ۖ فَإِنِ انْتَهَوْا فَلَا عُدْوَانَ إِلَّا عَلَى الظَّالِمِينَ",
  },
  {
    id: "201",
    sura: "2",
    VerseIDAr: "194",
    ayatAR:
      "الشَّهْرُ الْحَرَامُ بِالشَّهْرِ الْحَرَامِ وَالْحُرُمَاتُ قِصَاصٌ ۚ فَمَنِ اعْتَدَىٰ عَلَيْكُمْ فَاعْتَدُوا عَلَيْهِ بِمِثْلِ مَا اعْتَدَىٰ عَلَيْكُمْ ۚ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّ اللَّهَ مَعَ الْمُتَّقِينَ",
  },
  {
    id: "202",
    sura: "2",
    VerseIDAr: "195",
    ayatAR:
      "وَأَنْفِقُوا فِي سَبِيلِ اللَّهِ وَلَا تُلْقُوا بِأَيْدِيكُمْ إِلَى التَّهْلُكَةِ ۛ وَأَحْسِنُوا ۛ إِنَّ اللَّهَ يُحِبُّ الْمُحْسِنِينَ",
  },
  {
    id: "203",
    sura: "2",
    VerseIDAr: "196",
    ayatAR:
      "وَأَتِمُّوا الْحَجَّ وَالْعُمْرَةَ لِلَّهِ ۚ فَإِنْ أُحْصِرْتُمْ فَمَا اسْتَيْسَرَ مِنَ الْهَدْيِ ۖ وَلَا تَحْلِقُوا رُءُوسَكُمْ حَتَّىٰ يَبْلُغَ الْهَدْيُ مَحِلَّهُ ۚ فَمَنْ كَانَ مِنْكُمْ مَرِيضًا أَوْ بِهِ أَذًى مِنْ رَأْسِهِ فَفِدْيَةٌ مِنْ صِيَامٍ أَوْ صَدَقَةٍ أَوْ نُسُكٍ ۚ فَإِذَا أَمِنْتُمْ فَمَنْ تَمَتَّعَ بِالْعُمْرَةِ إِلَى الْحَجِّ فَمَا اسْتَيْسَرَ مِنَ الْهَدْيِ ۚ فَمَنْ لَمْ يَجِدْ فَصِيَامُ ثَلَاثَةِ أَيَّامٍ فِي الْحَجِّ وَسَبْعَةٍ إِذَا رَجَعْتُمْ ۗ تِلْكَ عَشَرَةٌ كَامِلَةٌ ۗ ذَٰلِكَ لِمَنْ لَمْ يَكُنْ أَهْلُهُ حَاضِرِي الْمَسْجِدِ الْحَرَامِ ۚ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "204",
    sura: "2",
    VerseIDAr: "197",
    ayatAR:
      "الْحَجُّ أَشْهُرٌ مَعْلُومَاتٌ ۚ فَمَنْ فَرَضَ فِيهِنَّ الْحَجَّ فَلَا رَفَثَ وَلَا فُسُوقَ وَلَا جِدَالَ فِي الْحَجِّ ۗ وَمَا تَفْعَلُوا مِنْ خَيْرٍ يَعْلَمْهُ اللَّهُ ۗ وَتَزَوَّدُوا فَإِنَّ خَيْرَ الزَّادِ التَّقْوَىٰ ۚ وَاتَّقُونِ يَا أُولِي الْأَلْبَابِ",
  },
  {
    id: "205",
    sura: "2",
    VerseIDAr: "198",
    ayatAR:
      "لَيْسَ عَلَيْكُمْ جُنَاحٌ أَنْ تَبْتَغُوا فَضْلًا مِنْ رَبِّكُمْ ۚ فَإِذَا أَفَضْتُمْ مِنْ عَرَفَاتٍ فَاذْكُرُوا اللَّهَ عِنْدَ الْمَشْعَرِ الْحَرَامِ ۖ وَاذْكُرُوهُ كَمَا هَدَاكُمْ وَإِنْ كُنْتُمْ مِنْ قَبْلِهِ لَمِنَ الضَّالِّينَ",
  },
  {
    id: "206",
    sura: "2",
    VerseIDAr: "199",
    ayatAR:
      "ثُمَّ أَفِيضُوا مِنْ حَيْثُ أَفَاضَ النَّاسُ وَاسْتَغْفِرُوا اللَّهَ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "207",
    sura: "2",
    VerseIDAr: "200",
    ayatAR:
      "فَإِذَا قَضَيْتُمْ مَنَاسِكَكُمْ فَاذْكُرُوا اللَّهَ كَذِكْرِكُمْ آبَاءَكُمْ أَوْ أَشَدَّ ذِكْرًا ۗ فَمِنَ النَّاسِ مَنْ يَقُولُ رَبَّنَا آتِنَا فِي الدُّنْيَا وَمَا لَهُ فِي الْآخِرَةِ مِنْ خَلَاقٍ",
  },
  {
    id: "208",
    sura: "2",
    VerseIDAr: "201",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَقُولُ رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
  },
  {
    id: "209",
    sura: "2",
    VerseIDAr: "202",
    ayatAR:
      "أُولَٰئِكَ لَهُمْ نَصِيبٌ مِمَّا كَسَبُوا ۚ وَاللَّهُ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "210",
    sura: "2",
    VerseIDAr: "203",
    ayatAR:
      "وَاذْكُرُوا اللَّهَ فِي أَيَّامٍ مَعْدُودَاتٍ ۚ فَمَنْ تَعَجَّلَ فِي يَوْمَيْنِ فَلَا إِثْمَ عَلَيْهِ وَمَنْ تَأَخَّرَ فَلَا إِثْمَ عَلَيْهِ ۚ لِمَنِ اتَّقَىٰ ۗ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّكُمْ إِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "211",
    sura: "2",
    VerseIDAr: "204",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يُعْجِبُكَ قَوْلُهُ فِي الْحَيَاةِ الدُّنْيَا وَيُشْهِدُ اللَّهَ عَلَىٰ مَا فِي قَلْبِهِ وَهُوَ أَلَدُّ الْخِصَامِ",
  },
  {
    id: "212",
    sura: "2",
    VerseIDAr: "205",
    ayatAR:
      "وَإِذَا تَوَلَّىٰ سَعَىٰ فِي الْأَرْضِ لِيُفْسِدَ فِيهَا وَيُهْلِكَ الْحَرْثَ وَالنَّسْلَ ۗ وَاللَّهُ لَا يُحِبُّ الْفَسَادَ",
  },
  {
    id: "213",
    sura: "2",
    VerseIDAr: "206",
    ayatAR:
      "وَإِذَا قِيلَ لَهُ اتَّقِ اللَّهَ أَخَذَتْهُ الْعِزَّةُ بِالْإِثْمِ ۚ فَحَسْبُهُ جَهَنَّمُ ۚ وَلَبِئْسَ الْمِهَادُ",
  },
  {
    id: "214",
    sura: "2",
    VerseIDAr: "207",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَشْرِي نَفْسَهُ ابْتِغَاءَ مَرْضَاتِ اللَّهِ ۗ وَاللَّهُ رَءُوفٌ بِالْعِبَادِ",
  },
  {
    id: "215",
    sura: "2",
    VerseIDAr: "208",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا ادْخُلُوا فِي السِّلْمِ كَافَّةً وَلَا تَتَّبِعُوا خُطُوَاتِ الشَّيْطَانِ ۚ إِنَّهُ لَكُمْ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "216",
    sura: "2",
    VerseIDAr: "209",
    ayatAR:
      "فَإِنْ زَلَلْتُمْ مِنْ بَعْدِ مَا جَاءَتْكُمُ الْبَيِّنَاتُ فَاعْلَمُوا أَنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "217",
    sura: "2",
    VerseIDAr: "210",
    ayatAR:
      "هَلْ يَنْظُرُونَ إِلَّا أَنْ يَأْتِيَهُمُ اللَّهُ فِي ظُلَلٍ مِنَ الْغَمَامِ وَالْمَلَائِكَةُ وَقُضِيَ الْأَمْرُ ۚ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "218",
    sura: "2",
    VerseIDAr: "211",
    ayatAR:
      "سَلْ بَنِي إِسْرَائِيلَ كَمْ آتَيْنَاهُمْ مِنْ آيَةٍ بَيِّنَةٍ ۗ وَمَنْ يُبَدِّلْ نِعْمَةَ اللَّهِ مِنْ بَعْدِ مَا جَاءَتْهُ فَإِنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "219",
    sura: "2",
    VerseIDAr: "212",
    ayatAR:
      "زُيِّنَ لِلَّذِينَ كَفَرُوا الْحَيَاةُ الدُّنْيَا وَيَسْخَرُونَ مِنَ الَّذِينَ آمَنُوا ۘ وَالَّذِينَ اتَّقَوْا فَوْقَهُمْ يَوْمَ الْقِيَامَةِ ۗ وَاللَّهُ يَرْزُقُ مَنْ يَشَاءُ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "220",
    sura: "2",
    VerseIDAr: "213",
    ayatAR:
      "كَانَ النَّاسُ أُمَّةً وَاحِدَةً فَبَعَثَ اللَّهُ النَّبِيِّينَ مُبَشِّرِينَ وَمُنْذِرِينَ وَأَنْزَلَ مَعَهُمُ الْكِتَابَ بِالْحَقِّ لِيَحْكُمَ بَيْنَ النَّاسِ فِيمَا اخْتَلَفُوا فِيهِ ۚ وَمَا اخْتَلَفَ فِيهِ إِلَّا الَّذِينَ أُوتُوهُ مِنْ بَعْدِ مَا جَاءَتْهُمُ الْبَيِّنَاتُ بَغْيًا بَيْنَهُمْ ۖ فَهَدَى اللَّهُ الَّذِينَ آمَنُوا لِمَا اخْتَلَفُوا فِيهِ مِنَ الْحَقِّ بِإِذْنِهِ ۗ وَاللَّهُ يَهْدِي مَنْ يَشَاءُ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "221",
    sura: "2",
    VerseIDAr: "214",
    ayatAR:
      "أَمْ حَسِبْتُمْ أَنْ تَدْخُلُوا الْجَنَّةَ وَلَمَّا يَأْتِكُمْ مَثَلُ الَّذِينَ خَلَوْا مِنْ قَبْلِكُمْ ۖ مَسَّتْهُمُ الْبَأْسَاءُ وَالضَّرَّاءُ وَزُلْزِلُوا حَتَّىٰ يَقُولَ الرَّسُولُ وَالَّذِينَ آمَنُوا مَعَهُ مَتَىٰ نَصْرُ اللَّهِ ۗ أَلَا إِنَّ نَصْرَ اللَّهِ قَرِيبٌ",
  },
  {
    id: "222",
    sura: "2",
    VerseIDAr: "215",
    ayatAR:
      "يَسْأَلُونَكَ مَاذَا يُنْفِقُونَ ۖ قُلْ مَا أَنْفَقْتُمْ مِنْ خَيْرٍ فَلِلْوَالِدَيْنِ وَالْأَقْرَبِينَ وَالْيَتَامَىٰ وَالْمَسَاكِينِ وَابْنِ السَّبِيلِ ۗ وَمَا تَفْعَلُوا مِنْ خَيْرٍ فَإِنَّ اللَّهَ بِهِ عَلِيمٌ",
  },
  {
    id: "223",
    sura: "2",
    VerseIDAr: "216",
    ayatAR:
      "كُتِبَ عَلَيْكُمُ الْقِتَالُ وَهُوَ كُرْهٌ لَكُمْ ۖ وَعَسَىٰ أَنْ تَكْرَهُوا شَيْئًا وَهُوَ خَيْرٌ لَكُمْ ۖ وَعَسَىٰ أَنْ تُحِبُّوا شَيْئًا وَهُوَ شَرٌّ لَكُمْ ۗ وَاللَّهُ يَعْلَمُ وَأَنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "224",
    sura: "2",
    VerseIDAr: "217",
    ayatAR:
      "يَسْأَلُونَكَ عَنِ الشَّهْرِ الْحَرَامِ قِتَالٍ فِيهِ ۖ قُلْ قِتَالٌ فِيهِ كَبِيرٌ ۖ وَصَدٌّ عَنْ سَبِيلِ اللَّهِ وَكُفْرٌ بِهِ وَالْمَسْجِدِ الْحَرَامِ وَإِخْرَاجُ أَهْلِهِ مِنْهُ أَكْبَرُ عِنْدَ اللَّهِ ۚ وَالْفِتْنَةُ أَكْبَرُ مِنَ الْقَتْلِ ۗ وَلَا يَزَالُونَ يُقَاتِلُونَكُمْ حَتَّىٰ يَرُدُّوكُمْ عَنْ دِينِكُمْ إِنِ اسْتَطَاعُوا ۚ وَمَنْ يَرْتَدِدْ مِنْكُمْ عَنْ دِينِهِ فَيَمُتْ وَهُوَ كَافِرٌ فَأُولَٰئِكَ حَبِطَتْ أَعْمَالُهُمْ فِي الدُّنْيَا وَالْآخِرَةِ ۖ وَأُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "225",
    sura: "2",
    VerseIDAr: "218",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَالَّذِينَ هَاجَرُوا وَجَاهَدُوا فِي سَبِيلِ اللَّهِ أُولَٰئِكَ يَرْجُونَ رَحْمَتَ اللَّهِ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "226",
    sura: "2",
    VerseIDAr: "219",
    ayatAR:
      "يَسْأَلُونَكَ عَنِ الْخَمْرِ وَالْمَيْسِرِ ۖ قُلْ فِيهِمَا إِثْمٌ كَبِيرٌ وَمَنَافِعُ لِلنَّاسِ وَإِثْمُهُمَا أَكْبَرُ مِنْ نَفْعِهِمَا ۗ وَيَسْأَلُونَكَ مَاذَا يُنْفِقُونَ قُلِ الْعَفْوَ ۗ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمُ الْآيَاتِ لَعَلَّكُمْ تَتَفَكَّرُونَ",
  },
  {
    id: "227",
    sura: "2",
    VerseIDAr: "220",
    ayatAR:
      "فِي الدُّنْيَا وَالْآخِرَةِ ۗ وَيَسْأَلُونَكَ عَنِ الْيَتَامَىٰ ۖ قُلْ إِصْلَاحٌ لَهُمْ خَيْرٌ ۖ وَإِنْ تُخَالِطُوهُمْ فَإِخْوَانُكُمْ ۚ وَاللَّهُ يَعْلَمُ الْمُفْسِدَ مِنَ الْمُصْلِحِ ۚ وَلَوْ شَاءَ اللَّهُ لَأَعْنَتَكُمْ ۚ إِنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "228",
    sura: "2",
    VerseIDAr: "221",
    ayatAR:
      "وَلَا تَنْكِحُوا الْمُشْرِكَاتِ حَتَّىٰ يُؤْمِنَّ ۚ وَلَأَمَةٌ مُؤْمِنَةٌ خَيْرٌ مِنْ مُشْرِكَةٍ وَلَوْ أَعْجَبَتْكُمْ ۗ وَلَا تُنْكِحُوا الْمُشْرِكِينَ حَتَّىٰ يُؤْمِنُوا ۚ وَلَعَبْدٌ مُؤْمِنٌ خَيْرٌ مِنْ مُشْرِكٍ وَلَوْ أَعْجَبَكُمْ ۗ أُولَٰئِكَ يَدْعُونَ إِلَى النَّارِ ۖ وَاللَّهُ يَدْعُو إِلَى الْجَنَّةِ وَالْمَغْفِرَةِ بِإِذْنِهِ ۖ وَيُبَيِّنُ آيَاتِهِ لِلنَّاسِ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "229",
    sura: "2",
    VerseIDAr: "222",
    ayatAR:
      "وَيَسْأَلُونَكَ عَنِ الْمَحِيضِ ۖ قُلْ هُوَ أَذًى فَاعْتَزِلُوا النِّسَاءَ فِي الْمَحِيضِ ۖ وَلَا تَقْرَبُوهُنَّ حَتَّىٰ يَطْهُرْنَ ۖ فَإِذَا تَطَهَّرْنَ فَأْتُوهُنَّ مِنْ حَيْثُ أَمَرَكُمُ اللَّهُ ۚ إِنَّ اللَّهَ يُحِبُّ التَّوَّابِينَ وَيُحِبُّ الْمُتَطَهِّرِينَ",
  },
  {
    id: "230",
    sura: "2",
    VerseIDAr: "223",
    ayatAR:
      "نِسَاؤُكُمْ حَرْثٌ لَكُمْ فَأْتُوا حَرْثَكُمْ أَنَّىٰ شِئْتُمْ ۖ وَقَدِّمُوا لِأَنْفُسِكُمْ ۚ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّكُمْ مُلَاقُوهُ ۗ وَبَشِّرِ الْمُؤْمِنِينَ",
  },
  {
    id: "231",
    sura: "2",
    VerseIDAr: "224",
    ayatAR:
      "وَلَا تَجْعَلُوا اللَّهَ عُرْضَةً لِأَيْمَانِكُمْ أَنْ تَبَرُّوا وَتَتَّقُوا وَتُصْلِحُوا بَيْنَ النَّاسِ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "232",
    sura: "2",
    VerseIDAr: "225",
    ayatAR:
      "لَا يُؤَاخِذُكُمُ اللَّهُ بِاللَّغْوِ فِي أَيْمَانِكُمْ وَلَٰكِنْ يُؤَاخِذُكُمْ بِمَا كَسَبَتْ قُلُوبُكُمْ ۗ وَاللَّهُ غَفُورٌ حَلِيمٌ",
  },
  {
    id: "233",
    sura: "2",
    VerseIDAr: "226",
    ayatAR:
      "لِلَّذِينَ يُؤْلُونَ مِنْ نِسَائِهِمْ تَرَبُّصُ أَرْبَعَةِ أَشْهُرٍ ۖ فَإِنْ فَاءُوا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "234",
    sura: "2",
    VerseIDAr: "227",
    ayatAR: "وَإِنْ عَزَمُوا الطَّلَاقَ فَإِنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "235",
    sura: "2",
    VerseIDAr: "228",
    ayatAR:
      "وَالْمُطَلَّقَاتُ يَتَرَبَّصْنَ بِأَنْفُسِهِنَّ ثَلَاثَةَ قُرُوءٍ ۚ وَلَا يَحِلُّ لَهُنَّ أَنْ يَكْتُمْنَ مَا خَلَقَ اللَّهُ فِي أَرْحَامِهِنَّ إِنْ كُنَّ يُؤْمِنَّ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۚ وَبُعُولَتُهُنَّ أَحَقُّ بِرَدِّهِنَّ فِي ذَٰلِكَ إِنْ أَرَادُوا إِصْلَاحًا ۚ وَلَهُنَّ مِثْلُ الَّذِي عَلَيْهِنَّ بِالْمَعْرُوفِ ۚ وَلِلرِّجَالِ عَلَيْهِنَّ دَرَجَةٌ ۗ وَاللَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "236",
    sura: "2",
    VerseIDAr: "229",
    ayatAR:
      "الطَّلَاقُ مَرَّتَانِ ۖ فَإِمْسَاكٌ بِمَعْرُوفٍ أَوْ تَسْرِيحٌ بِإِحْسَانٍ ۗ وَلَا يَحِلُّ لَكُمْ أَنْ تَأْخُذُوا مِمَّا آتَيْتُمُوهُنَّ شَيْئًا إِلَّا أَنْ يَخَافَا أَلَّا يُقِيمَا حُدُودَ اللَّهِ ۖ فَإِنْ خِفْتُمْ أَلَّا يُقِيمَا حُدُودَ اللَّهِ فَلَا جُنَاحَ عَلَيْهِمَا فِيمَا افْتَدَتْ بِهِ ۗ تِلْكَ حُدُودُ اللَّهِ فَلَا تَعْتَدُوهَا ۚ وَمَنْ يَتَعَدَّ حُدُودَ اللَّهِ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "237",
    sura: "2",
    VerseIDAr: "230",
    ayatAR:
      "فَإِنْ طَلَّقَهَا فَلَا تَحِلُّ لَهُ مِنْ بَعْدُ حَتَّىٰ تَنْكِحَ زَوْجًا غَيْرَهُ ۗ فَإِنْ طَلَّقَهَا فَلَا جُنَاحَ عَلَيْهِمَا أَنْ يَتَرَاجَعَا إِنْ ظَنَّا أَنْ يُقِيمَا حُدُودَ اللَّهِ ۗ وَتِلْكَ حُدُودُ اللَّهِ يُبَيِّنُهَا لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "238",
    sura: "2",
    VerseIDAr: "231",
    ayatAR:
      "وَإِذَا طَلَّقْتُمُ النِّسَاءَ فَبَلَغْنَ أَجَلَهُنَّ فَأَمْسِكُوهُنَّ بِمَعْرُوفٍ أَوْ سَرِّحُوهُنَّ بِمَعْرُوفٍ ۚ وَلَا تُمْسِكُوهُنَّ ضِرَارًا لِتَعْتَدُوا ۚ وَمَنْ يَفْعَلْ ذَٰلِكَ فَقَدْ ظَلَمَ نَفْسَهُ ۚ وَلَا تَتَّخِذُوا آيَاتِ اللَّهِ هُزُوًا ۚ وَاذْكُرُوا نِعْمَتَ اللَّهِ عَلَيْكُمْ وَمَا أَنْزَلَ عَلَيْكُمْ مِنَ الْكِتَابِ وَالْحِكْمَةِ يَعِظُكُمْ بِهِ ۚ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "239",
    sura: "2",
    VerseIDAr: "232",
    ayatAR:
      "وَإِذَا طَلَّقْتُمُ النِّسَاءَ فَبَلَغْنَ أَجَلَهُنَّ فَلَا تَعْضُلُوهُنَّ أَنْ يَنْكِحْنَ أَزْوَاجَهُنَّ إِذَا تَرَاضَوْا بَيْنَهُمْ بِالْمَعْرُوفِ ۗ ذَٰلِكَ يُوعَظُ بِهِ مَنْ كَانَ مِنْكُمْ يُؤْمِنُ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۗ ذَٰلِكُمْ أَزْكَىٰ لَكُمْ وَأَطْهَرُ ۗ وَاللَّهُ يَعْلَمُ وَأَنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "240",
    sura: "2",
    VerseIDAr: "233",
    ayatAR:
      "وَالْوَالِدَاتُ يُرْضِعْنَ أَوْلَادَهُنَّ حَوْلَيْنِ كَامِلَيْنِ ۖ لِمَنْ أَرَادَ أَنْ يُتِمَّ الرَّضَاعَةَ ۚ وَعَلَى الْمَوْلُودِ لَهُ رِزْقُهُنَّ وَكِسْوَتُهُنَّ بِالْمَعْرُوفِ ۚ لَا تُكَلَّفُ نَفْسٌ إِلَّا وُسْعَهَا ۚ لَا تُضَارَّ وَالِدَةٌ بِوَلَدِهَا وَلَا مَوْلُودٌ لَهُ بِوَلَدِهِ ۚ وَعَلَى الْوَارِثِ مِثْلُ ذَٰلِكَ ۗ فَإِنْ أَرَادَا فِصَالًا عَنْ تَرَاضٍ مِنْهُمَا وَتَشَاوُرٍ فَلَا جُنَاحَ عَلَيْهِمَا ۗ وَإِنْ أَرَدْتُمْ أَنْ تَسْتَرْضِعُوا أَوْلَادَكُمْ فَلَا جُنَاحَ عَلَيْكُمْ إِذَا سَلَّمْتُمْ مَا آتَيْتُمْ بِالْمَعْرُوفِ ۗ وَاتَّقُوا اللَّهَ وَاعْلَمُوا أَنَّ اللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "241",
    sura: "2",
    VerseIDAr: "234",
    ayatAR:
      "وَالَّذِينَ يُتَوَفَّوْنَ مِنْكُمْ وَيَذَرُونَ أَزْوَاجًا يَتَرَبَّصْنَ بِأَنْفُسِهِنَّ أَرْبَعَةَ أَشْهُرٍ وَعَشْرًا ۖ فَإِذَا بَلَغْنَ أَجَلَهُنَّ فَلَا جُنَاحَ عَلَيْكُمْ فِيمَا فَعَلْنَ فِي أَنْفُسِهِنَّ بِالْمَعْرُوفِ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "242",
    sura: "2",
    VerseIDAr: "235",
    ayatAR:
      "وَلَا جُنَاحَ عَلَيْكُمْ فِيمَا عَرَّضْتُمْ بِهِ مِنْ خِطْبَةِ النِّسَاءِ أَوْ أَكْنَنْتُمْ فِي أَنْفُسِكُمْ ۚ عَلِمَ اللَّهُ أَنَّكُمْ سَتَذْكُرُونَهُنَّ وَلَٰكِنْ لَا تُوَاعِدُوهُنَّ سِرًّا إِلَّا أَنْ تَقُولُوا قَوْلًا مَعْرُوفًا ۚ وَلَا تَعْزِمُوا عُقْدَةَ النِّكَاحِ حَتَّىٰ يَبْلُغَ الْكِتَابُ أَجَلَهُ ۚ وَاعْلَمُوا أَنَّ اللَّهَ يَعْلَمُ مَا فِي أَنْفُسِكُمْ فَاحْذَرُوهُ ۚ وَاعْلَمُوا أَنَّ اللَّهَ غَفُورٌ حَلِيمٌ",
  },
  {
    id: "243",
    sura: "2",
    VerseIDAr: "236",
    ayatAR:
      "لَا جُنَاحَ عَلَيْكُمْ إِنْ طَلَّقْتُمُ النِّسَاءَ مَا لَمْ تَمَسُّوهُنَّ أَوْ تَفْرِضُوا لَهُنَّ فَرِيضَةً ۚ وَمَتِّعُوهُنَّ عَلَى الْمُوسِعِ قَدَرُهُ وَعَلَى الْمُقْتِرِ قَدَرُهُ مَتَاعًا بِالْمَعْرُوفِ ۖ حَقًّا عَلَى الْمُحْسِنِينَ",
  },
  {
    id: "244",
    sura: "2",
    VerseIDAr: "237",
    ayatAR:
      "وَإِنْ طَلَّقْتُمُوهُنَّ مِنْ قَبْلِ أَنْ تَمَسُّوهُنَّ وَقَدْ فَرَضْتُمْ لَهُنَّ فَرِيضَةً فَنِصْفُ مَا فَرَضْتُمْ إِلَّا أَنْ يَعْفُونَ أَوْ يَعْفُوَ الَّذِي بِيَدِهِ عُقْدَةُ النِّكَاحِ ۚ وَأَنْ تَعْفُوا أَقْرَبُ لِلتَّقْوَىٰ ۚ وَلَا تَنْسَوُا الْفَضْلَ بَيْنَكُمْ ۚ إِنَّ اللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "245",
    sura: "2",
    VerseIDAr: "238",
    ayatAR:
      "حَافِظُوا عَلَى الصَّلَوَاتِ وَالصَّلَاةِ الْوُسْطَىٰ وَقُومُوا لِلَّهِ قَانِتِينَ",
  },
  {
    id: "246",
    sura: "2",
    VerseIDAr: "239",
    ayatAR:
      "فَإِنْ خِفْتُمْ فَرِجَالًا أَوْ رُكْبَانًا ۖ فَإِذَا أَمِنْتُمْ فَاذْكُرُوا اللَّهَ كَمَا عَلَّمَكُمْ مَا لَمْ تَكُونُوا تَعْلَمُونَ",
  },
  {
    id: "247",
    sura: "2",
    VerseIDAr: "240",
    ayatAR:
      "وَالَّذِينَ يُتَوَفَّوْنَ مِنْكُمْ وَيَذَرُونَ أَزْوَاجًا وَصِيَّةً لِأَزْوَاجِهِمْ مَتَاعًا إِلَى الْحَوْلِ غَيْرَ إِخْرَاجٍ ۚ فَإِنْ خَرَجْنَ فَلَا جُنَاحَ عَلَيْكُمْ فِي مَا فَعَلْنَ فِي أَنْفُسِهِنَّ مِنْ مَعْرُوفٍ ۗ وَاللَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "248",
    sura: "2",
    VerseIDAr: "241",
    ayatAR:
      "وَلِلْمُطَلَّقَاتِ مَتَاعٌ بِالْمَعْرُوفِ ۖ حَقًّا عَلَى الْمُتَّقِينَ",
  },
  {
    id: "249",
    sura: "2",
    VerseIDAr: "242",
    ayatAR:
      "كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمْ آيَاتِهِ لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "250",
    sura: "2",
    VerseIDAr: "243",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ خَرَجُوا مِنْ دِيَارِهِمْ وَهُمْ أُلُوفٌ حَذَرَ الْمَوْتِ فَقَالَ لَهُمُ اللَّهُ مُوتُوا ثُمَّ أَحْيَاهُمْ ۚ إِنَّ اللَّهَ لَذُو فَضْلٍ عَلَى النَّاسِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَشْكُرُونَ",
  },
  {
    id: "251",
    sura: "2",
    VerseIDAr: "244",
    ayatAR:
      "وَقَاتِلُوا فِي سَبِيلِ اللَّهِ وَاعْلَمُوا أَنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "252",
    sura: "2",
    VerseIDAr: "245",
    ayatAR:
      "مَنْ ذَا الَّذِي يُقْرِضُ اللَّهَ قَرْضًا حَسَنًا فَيُضَاعِفَهُ لَهُ أَضْعَافًا كَثِيرَةً ۚ وَاللَّهُ يَقْبِضُ وَيَبْسُطُ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "253",
    sura: "2",
    VerseIDAr: "246",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الْمَلَإِ مِنْ بَنِي إِسْرَائِيلَ مِنْ بَعْدِ مُوسَىٰ إِذْ قَالُوا لِنَبِيٍّ لَهُمُ ابْعَثْ لَنَا مَلِكًا نُقَاتِلْ فِي سَبِيلِ اللَّهِ ۖ قَالَ هَلْ عَسَيْتُمْ إِنْ كُتِبَ عَلَيْكُمُ الْقِتَالُ أَلَّا تُقَاتِلُوا ۖ قَالُوا وَمَا لَنَا أَلَّا نُقَاتِلَ فِي سَبِيلِ اللَّهِ وَقَدْ أُخْرِجْنَا مِنْ دِيَارِنَا وَأَبْنَائِنَا ۖ فَلَمَّا كُتِبَ عَلَيْهِمُ الْقِتَالُ تَوَلَّوْا إِلَّا قَلِيلًا مِنْهُمْ ۗ وَاللَّهُ عَلِيمٌ بِالظَّالِمِينَ",
  },
  {
    id: "254",
    sura: "2",
    VerseIDAr: "247",
    ayatAR:
      "وَقَالَ لَهُمْ نَبِيُّهُمْ إِنَّ اللَّهَ قَدْ بَعَثَ لَكُمْ طَالُوتَ مَلِكًا ۚ قَالُوا أَنَّىٰ يَكُونُ لَهُ الْمُلْكُ عَلَيْنَا وَنَحْنُ أَحَقُّ بِالْمُلْكِ مِنْهُ وَلَمْ يُؤْتَ سَعَةً مِنَ الْمَالِ ۚ قَالَ إِنَّ اللَّهَ اصْطَفَاهُ عَلَيْكُمْ وَزَادَهُ بَسْطَةً فِي الْعِلْمِ وَالْجِسْمِ ۖ وَاللَّهُ يُؤْتِي مُلْكَهُ مَنْ يَشَاءُ ۚ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "255",
    sura: "2",
    VerseIDAr: "248",
    ayatAR:
      "وَقَالَ لَهُمْ نَبِيُّهُمْ إِنَّ آيَةَ مُلْكِهِ أَنْ يَأْتِيَكُمُ التَّابُوتُ فِيهِ سَكِينَةٌ مِنْ رَبِّكُمْ وَبَقِيَّةٌ مِمَّا تَرَكَ آلُ مُوسَىٰ وَآلُ هَارُونَ تَحْمِلُهُ الْمَلَائِكَةُ ۚ إِنَّ فِي ذَٰلِكَ لَآيَةً لَكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "256",
    sura: "2",
    VerseIDAr: "249",
    ayatAR:
      "فَلَمَّا فَصَلَ طَالُوتُ بِالْجُنُودِ قَالَ إِنَّ اللَّهَ مُبْتَلِيكُمْ بِنَهَرٍ فَمَنْ شَرِبَ مِنْهُ فَلَيْسَ مِنِّي وَمَنْ لَمْ يَطْعَمْهُ فَإِنَّهُ مِنِّي إِلَّا مَنِ اغْتَرَفَ غُرْفَةً بِيَدِهِ ۚ فَشَرِبُوا مِنْهُ إِلَّا قَلِيلًا مِنْهُمْ ۚ فَلَمَّا جَاوَزَهُ هُوَ وَالَّذِينَ آمَنُوا مَعَهُ قَالُوا لَا طَاقَةَ لَنَا الْيَوْمَ بِجَالُوتَ وَجُنُودِهِ ۚ قَالَ الَّذِينَ يَظُنُّونَ أَنَّهُمْ مُلَاقُو اللَّهِ كَمْ مِنْ فِئَةٍ قَلِيلَةٍ غَلَبَتْ فِئَةً كَثِيرَةً بِإِذْنِ اللَّهِ ۗ وَاللَّهُ مَعَ الصَّابِرِينَ",
  },
  {
    id: "257",
    sura: "2",
    VerseIDAr: "250",
    ayatAR:
      "وَلَمَّا بَرَزُوا لِجَالُوتَ وَجُنُودِهِ قَالُوا رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَثَبِّتْ أَقْدَامَنَا وَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
  },
  {
    id: "258",
    sura: "2",
    VerseIDAr: "251",
    ayatAR:
      "فَهَزَمُوهُمْ بِإِذْنِ اللَّهِ وَقَتَلَ دَاوُودُ جَالُوتَ وَآتَاهُ اللَّهُ الْمُلْكَ وَالْحِكْمَةَ وَعَلَّمَهُ مِمَّا يَشَاءُ ۗ وَلَوْلَا دَفْعُ اللَّهِ النَّاسَ بَعْضَهُمْ بِبَعْضٍ لَفَسَدَتِ الْأَرْضُ وَلَٰكِنَّ اللَّهَ ذُو فَضْلٍ عَلَى الْعَالَمِينَ",
  },
  {
    id: "259",
    sura: "2",
    VerseIDAr: "252",
    ayatAR:
      "تِلْكَ آيَاتُ اللَّهِ نَتْلُوهَا عَلَيْكَ بِالْحَقِّ ۚ وَإِنَّكَ لَمِنَ الْمُرْسَلِينَ",
  },
  {
    id: "260",
    sura: "2",
    VerseIDAr: "253",
    ayatAR:
      "تِلْكَ الرُّسُلُ فَضَّلْنَا بَعْضَهُمْ عَلَىٰ بَعْضٍ ۘ مِنْهُمْ مَنْ كَلَّمَ اللَّهُ ۖ وَرَفَعَ بَعْضَهُمْ دَرَجَاتٍ ۚ وَآتَيْنَا عِيسَى ابْنَ مَرْيَمَ الْبَيِّنَاتِ وَأَيَّدْنَاهُ بِرُوحِ الْقُدُسِ ۗ وَلَوْ شَاءَ اللَّهُ مَا اقْتَتَلَ الَّذِينَ مِنْ بَعْدِهِمْ مِنْ بَعْدِ مَا جَاءَتْهُمُ الْبَيِّنَاتُ وَلَٰكِنِ اخْتَلَفُوا فَمِنْهُمْ مَنْ آمَنَ وَمِنْهُمْ مَنْ كَفَرَ ۚ وَلَوْ شَاءَ اللَّهُ مَا اقْتَتَلُوا وَلَٰكِنَّ اللَّهَ يَفْعَلُ مَا يُرِيدُ",
  },
  {
    id: "261",
    sura: "2",
    VerseIDAr: "254",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا أَنْفِقُوا مِمَّا رَزَقْنَاكُمْ مِنْ قَبْلِ أَنْ يَأْتِيَ يَوْمٌ لَا بَيْعٌ فِيهِ وَلَا خُلَّةٌ وَلَا شَفَاعَةٌ ۗ وَالْكَافِرُونَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "262",
    sura: "2",
    VerseIDAr: "255",
    ayatAR:
      "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ",
  },
  {
    id: "263",
    sura: "2",
    VerseIDAr: "256",
    ayatAR:
      "لَا إِكْرَاهَ فِي الدِّينِ ۖ قَدْ تَبَيَّنَ الرُّشْدُ مِنَ الْغَيِّ ۚ فَمَنْ يَكْفُرْ بِالطَّاغُوتِ وَيُؤْمِنْ بِاللَّهِ فَقَدِ اسْتَمْسَكَ بِالْعُرْوَةِ الْوُثْقَىٰ لَا انْفِصَامَ لَهَا ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "264",
    sura: "2",
    VerseIDAr: "257",
    ayatAR:
      "اللَّهُ وَلِيُّ الَّذِينَ آمَنُوا يُخْرِجُهُمْ مِنَ الظُّلُمَاتِ إِلَى النُّورِ ۖ وَالَّذِينَ كَفَرُوا أَوْلِيَاؤُهُمُ الطَّاغُوتُ يُخْرِجُونَهُمْ مِنَ النُّورِ إِلَى الظُّلُمَاتِ ۗ أُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "265",
    sura: "2",
    VerseIDAr: "258",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِي حَاجَّ إِبْرَاهِيمَ فِي رَبِّهِ أَنْ آتَاهُ اللَّهُ الْمُلْكَ إِذْ قَالَ إِبْرَاهِيمُ رَبِّيَ الَّذِي يُحْيِي وَيُمِيتُ قَالَ أَنَا أُحْيِي وَأُمِيتُ ۖ قَالَ إِبْرَاهِيمُ فَإِنَّ اللَّهَ يَأْتِي بِالشَّمْسِ مِنَ الْمَشْرِقِ فَأْتِ بِهَا مِنَ الْمَغْرِبِ فَبُهِتَ الَّذِي كَفَرَ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "266",
    sura: "2",
    VerseIDAr: "259",
    ayatAR:
      "أَوْ كَالَّذِي مَرَّ عَلَىٰ قَرْيَةٍ وَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا قَالَ أَنَّىٰ يُحْيِي هَٰذِهِ اللَّهُ بَعْدَ مَوْتِهَا ۖ فَأَمَاتَهُ اللَّهُ مِائَةَ عَامٍ ثُمَّ بَعَثَهُ ۖ قَالَ كَمْ لَبِثْتَ ۖ قَالَ لَبِثْتُ يَوْمًا أَوْ بَعْضَ يَوْمٍ ۖ قَالَ بَلْ لَبِثْتَ مِائَةَ عَامٍ فَانْظُرْ إِلَىٰ طَعَامِكَ وَشَرَابِكَ لَمْ يَتَسَنَّهْ ۖ وَانْظُرْ إِلَىٰ حِمَارِكَ وَلِنَجْعَلَكَ آيَةً لِلنَّاسِ ۖ وَانْظُرْ إِلَى الْعِظَامِ كَيْفَ نُنْشِزُهَا ثُمَّ نَكْسُوهَا لَحْمًا ۚ فَلَمَّا تَبَيَّنَ لَهُ قَالَ أَعْلَمُ أَنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "267",
    sura: "2",
    VerseIDAr: "260",
    ayatAR:
      "وَإِذْ قَالَ إِبْرَاهِيمُ رَبِّ أَرِنِي كَيْفَ تُحْيِي الْمَوْتَىٰ ۖ قَالَ أَوَلَمْ تُؤْمِنْ ۖ قَالَ بَلَىٰ وَلَٰكِنْ لِيَطْمَئِنَّ قَلْبِي ۖ قَالَ فَخُذْ أَرْبَعَةً مِنَ الطَّيْرِ فَصُرْهُنَّ إِلَيْكَ ثُمَّ اجْعَلْ عَلَىٰ كُلِّ جَبَلٍ مِنْهُنَّ جُزْءًا ثُمَّ ادْعُهُنَّ يَأْتِينَكَ سَعْيًا ۚ وَاعْلَمْ أَنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "268",
    sura: "2",
    VerseIDAr: "261",
    ayatAR:
      "مَثَلُ الَّذِينَ يُنْفِقُونَ أَمْوَالَهُمْ فِي سَبِيلِ اللَّهِ كَمَثَلِ حَبَّةٍ أَنْبَتَتْ سَبْعَ سَنَابِلَ فِي كُلِّ سُنْبُلَةٍ مِائَةُ حَبَّةٍ ۗ وَاللَّهُ يُضَاعِفُ لِمَنْ يَشَاءُ ۗ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "269",
    sura: "2",
    VerseIDAr: "262",
    ayatAR:
      "الَّذِينَ يُنْفِقُونَ أَمْوَالَهُمْ فِي سَبِيلِ اللَّهِ ثُمَّ لَا يُتْبِعُونَ مَا أَنْفَقُوا مَنًّا وَلَا أَذًى ۙ لَهُمْ أَجْرُهُمْ عِنْدَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "270",
    sura: "2",
    VerseIDAr: "263",
    ayatAR:
      "قَوْلٌ مَعْرُوفٌ وَمَغْفِرَةٌ خَيْرٌ مِنْ صَدَقَةٍ يَتْبَعُهَا أَذًى ۗ وَاللَّهُ غَنِيٌّ حَلِيمٌ",
  },
  {
    id: "271",
    sura: "2",
    VerseIDAr: "264",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تُبْطِلُوا صَدَقَاتِكُمْ بِالْمَنِّ وَالْأَذَىٰ كَالَّذِي يُنْفِقُ مَالَهُ رِئَاءَ النَّاسِ وَلَا يُؤْمِنُ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۖ فَمَثَلُهُ كَمَثَلِ صَفْوَانٍ عَلَيْهِ تُرَابٌ فَأَصَابَهُ وَابِلٌ فَتَرَكَهُ صَلْدًا ۖ لَا يَقْدِرُونَ عَلَىٰ شَيْءٍ مِمَّا كَسَبُوا ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْكَافِرِينَ",
  },
  {
    id: "272",
    sura: "2",
    VerseIDAr: "265",
    ayatAR:
      "وَمَثَلُ الَّذِينَ يُنْفِقُونَ أَمْوَالَهُمُ ابْتِغَاءَ مَرْضَاتِ اللَّهِ وَتَثْبِيتًا مِنْ أَنْفُسِهِمْ كَمَثَلِ جَنَّةٍ بِرَبْوَةٍ أَصَابَهَا وَابِلٌ فَآتَتْ أُكُلَهَا ضِعْفَيْنِ فَإِنْ لَمْ يُصِبْهَا وَابِلٌ فَطَلٌّ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "273",
    sura: "2",
    VerseIDAr: "266",
    ayatAR:
      "أَيَوَدُّ أَحَدُكُمْ أَنْ تَكُونَ لَهُ جَنَّةٌ مِنْ نَخِيلٍ وَأَعْنَابٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ لَهُ فِيهَا مِنْ كُلِّ الثَّمَرَاتِ وَأَصَابَهُ الْكِبَرُ وَلَهُ ذُرِّيَّةٌ ضُعَفَاءُ فَأَصَابَهَا إِعْصَارٌ فِيهِ نَارٌ فَاحْتَرَقَتْ ۗ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمُ الْآيَاتِ لَعَلَّكُمْ تَتَفَكَّرُونَ",
  },
  {
    id: "274",
    sura: "2",
    VerseIDAr: "267",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا أَنْفِقُوا مِنْ طَيِّبَاتِ مَا كَسَبْتُمْ وَمِمَّا أَخْرَجْنَا لَكُمْ مِنَ الْأَرْضِ ۖ وَلَا تَيَمَّمُوا الْخَبِيثَ مِنْهُ تُنْفِقُونَ وَلَسْتُمْ بِآخِذِيهِ إِلَّا أَنْ تُغْمِضُوا فِيهِ ۚ وَاعْلَمُوا أَنَّ اللَّهَ غَنِيٌّ حَمِيدٌ",
  },
  {
    id: "275",
    sura: "2",
    VerseIDAr: "268",
    ayatAR:
      "الشَّيْطَانُ يَعِدُكُمُ الْفَقْرَ وَيَأْمُرُكُمْ بِالْفَحْشَاءِ ۖ وَاللَّهُ يَعِدُكُمْ مَغْفِرَةً مِنْهُ وَفَضْلًا ۗ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "276",
    sura: "2",
    VerseIDAr: "269",
    ayatAR:
      "يُؤْتِي الْحِكْمَةَ مَنْ يَشَاءُ ۚ وَمَنْ يُؤْتَ الْحِكْمَةَ فَقَدْ أُوتِيَ خَيْرًا كَثِيرًا ۗ وَمَا يَذَّكَّرُ إِلَّا أُولُو الْأَلْبَابِ",
  },
  {
    id: "277",
    sura: "2",
    VerseIDAr: "270",
    ayatAR:
      "وَمَا أَنْفَقْتُمْ مِنْ نَفَقَةٍ أَوْ نَذَرْتُمْ مِنْ نَذْرٍ فَإِنَّ اللَّهَ يَعْلَمُهُ ۗ وَمَا لِلظَّالِمِينَ مِنْ أَنْصَارٍ",
  },
  {
    id: "278",
    sura: "2",
    VerseIDAr: "271",
    ayatAR:
      "إِنْ تُبْدُوا الصَّدَقَاتِ فَنِعِمَّا هِيَ ۖ وَإِنْ تُخْفُوهَا وَتُؤْتُوهَا الْفُقَرَاءَ فَهُوَ خَيْرٌ لَكُمْ ۚ وَيُكَفِّرُ عَنْكُمْ مِنْ سَيِّئَاتِكُمْ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "279",
    sura: "2",
    VerseIDAr: "272",
    ayatAR:
      "لَيْسَ عَلَيْكَ هُدَاهُمْ وَلَٰكِنَّ اللَّهَ يَهْدِي مَنْ يَشَاءُ ۗ وَمَا تُنْفِقُوا مِنْ خَيْرٍ فَلِأَنْفُسِكُمْ ۚ وَمَا تُنْفِقُونَ إِلَّا ابْتِغَاءَ وَجْهِ اللَّهِ ۚ وَمَا تُنْفِقُوا مِنْ خَيْرٍ يُوَفَّ إِلَيْكُمْ وَأَنْتُمْ لَا تُظْلَمُونَ",
  },
  {
    id: "280",
    sura: "2",
    VerseIDAr: "273",
    ayatAR:
      "لِلْفُقَرَاءِ الَّذِينَ أُحْصِرُوا فِي سَبِيلِ اللَّهِ لَا يَسْتَطِيعُونَ ضَرْبًا فِي الْأَرْضِ يَحْسَبُهُمُ الْجَاهِلُ أَغْنِيَاءَ مِنَ التَّعَفُّفِ تَعْرِفُهُمْ بِسِيمَاهُمْ لَا يَسْأَلُونَ النَّاسَ إِلْحَافًا ۗ وَمَا تُنْفِقُوا مِنْ خَيْرٍ فَإِنَّ اللَّهَ بِهِ عَلِيمٌ",
  },
  {
    id: "281",
    sura: "2",
    VerseIDAr: "274",
    ayatAR:
      "الَّذِينَ يُنْفِقُونَ أَمْوَالَهُمْ بِاللَّيْلِ وَالنَّهَارِ سِرًّا وَعَلَانِيَةً فَلَهُمْ أَجْرُهُمْ عِنْدَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "282",
    sura: "2",
    VerseIDAr: "275",
    ayatAR:
      "الَّذِينَ يَأْكُلُونَ الرِّبَا لَا يَقُومُونَ إِلَّا كَمَا يَقُومُ الَّذِي يَتَخَبَّطُهُ الشَّيْطَانُ مِنَ الْمَسِّ ۚ ذَٰلِكَ بِأَنَّهُمْ قَالُوا إِنَّمَا الْبَيْعُ مِثْلُ الرِّبَا ۗ وَأَحَلَّ اللَّهُ الْبَيْعَ وَحَرَّمَ الرِّبَا ۚ فَمَنْ جَاءَهُ مَوْعِظَةٌ مِنْ رَبِّهِ فَانْتَهَىٰ فَلَهُ مَا سَلَفَ وَأَمْرُهُ إِلَى اللَّهِ ۖ وَمَنْ عَادَ فَأُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "283",
    sura: "2",
    VerseIDAr: "276",
    ayatAR:
      "يَمْحَقُ اللَّهُ الرِّبَا وَيُرْبِي الصَّدَقَاتِ ۗ وَاللَّهُ لَا يُحِبُّ كُلَّ كَفَّارٍ أَثِيمٍ",
  },
  {
    id: "284",
    sura: "2",
    VerseIDAr: "277",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَأَقَامُوا الصَّلَاةَ وَآتَوُا الزَّكَاةَ لَهُمْ أَجْرُهُمْ عِنْدَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "285",
    sura: "2",
    VerseIDAr: "278",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَذَرُوا مَا بَقِيَ مِنَ الرِّبَا إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "286",
    sura: "2",
    VerseIDAr: "279",
    ayatAR:
      "فَإِنْ لَمْ تَفْعَلُوا فَأْذَنُوا بِحَرْبٍ مِنَ اللَّهِ وَرَسُولِهِ ۖ وَإِنْ تُبْتُمْ فَلَكُمْ رُءُوسُ أَمْوَالِكُمْ لَا تَظْلِمُونَ وَلَا تُظْلَمُونَ",
  },
  {
    id: "287",
    sura: "2",
    VerseIDAr: "280",
    ayatAR:
      "وَإِنْ كَانَ ذُو عُسْرَةٍ فَنَظِرَةٌ إِلَىٰ مَيْسَرَةٍ ۚ وَأَنْ تَصَدَّقُوا خَيْرٌ لَكُمْ ۖ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "288",
    sura: "2",
    VerseIDAr: "281",
    ayatAR:
      "وَاتَّقُوا يَوْمًا تُرْجَعُونَ فِيهِ إِلَى اللَّهِ ۖ ثُمَّ تُوَفَّىٰ كُلُّ نَفْسٍ مَا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "289",
    sura: "2",
    VerseIDAr: "282",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا تَدَايَنْتُمْ بِدَيْنٍ إِلَىٰ أَجَلٍ مُسَمًّى فَاكْتُبُوهُ ۚ وَلْيَكْتُبْ بَيْنَكُمْ كَاتِبٌ بِالْعَدْلِ ۚ وَلَا يَأْبَ كَاتِبٌ أَنْ يَكْتُبَ كَمَا عَلَّمَهُ اللَّهُ ۚ فَلْيَكْتُبْ وَلْيُمْلِلِ الَّذِي عَلَيْهِ الْحَقُّ وَلْيَتَّقِ اللَّهَ رَبَّهُ وَلَا يَبْخَسْ مِنْهُ شَيْئًا ۚ فَإِنْ كَانَ الَّذِي عَلَيْهِ الْحَقُّ سَفِيهًا أَوْ ضَعِيفًا أَوْ لَا يَسْتَطِيعُ أَنْ يُمِلَّ هُوَ فَلْيُمْلِلْ وَلِيُّهُ بِالْعَدْلِ ۚ وَاسْتَشْهِدُوا شَهِيدَيْنِ مِنْ رِجَالِكُمْ ۖ فَإِنْ لَمْ يَكُونَا رَجُلَيْنِ فَرَجُلٌ وَامْرَأَتَانِ مِمَّنْ تَرْضَوْنَ مِنَ الشُّهَدَاءِ أَنْ تَضِلَّ إِحْدَاهُمَا فَتُذَكِّرَ إِحْدَاهُمَا الْأُخْرَىٰ ۚ وَلَا يَأْبَ الشُّهَدَاءُ إِذَا مَا دُعُوا ۚ وَلَا تَسْأَمُوا أَنْ تَكْتُبُوهُ صَغِيرًا أَوْ كَبِيرًا إِلَىٰ أَجَلِهِ ۚ ذَٰلِكُمْ أَقْسَطُ عِنْدَ اللَّهِ وَأَقْوَمُ لِلشَّهَادَةِ وَأَدْنَىٰ أَلَّا تَرْتَابُوا ۖ إِلَّا أَنْ تَكُونَ تِجَارَةً حَاضِرَةً تُدِيرُونَهَا بَيْنَكُمْ فَلَيْسَ عَلَيْكُمْ جُنَاحٌ أَلَّا تَكْتُبُوهَا ۗ وَأَشْهِدُوا إِذَا تَبَايَعْتُمْ ۚ وَلَا يُضَارَّ كَاتِبٌ وَلَا شَهِيدٌ ۚ وَإِنْ تَفْعَلُوا فَإِنَّهُ فُسُوقٌ بِكُمْ ۗ وَاتَّقُوا اللَّهَ ۖ وَيُعَلِّمُكُمُ اللَّهُ ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "290",
    sura: "2",
    VerseIDAr: "283",
    ayatAR:
      "وَإِنْ كُنْتُمْ عَلَىٰ سَفَرٍ وَلَمْ تَجِدُوا كَاتِبًا فَرِهَانٌ مَقْبُوضَةٌ ۖ فَإِنْ أَمِنَ بَعْضُكُمْ بَعْضًا فَلْيُؤَدِّ الَّذِي اؤْتُمِنَ أَمَانَتَهُ وَلْيَتَّقِ اللَّهَ رَبَّهُ ۗ وَلَا تَكْتُمُوا الشَّهَادَةَ ۚ وَمَنْ يَكْتُمْهَا فَإِنَّهُ آثِمٌ قَلْبُهُ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ عَلِيمٌ",
  },
  {
    id: "291",
    sura: "2",
    VerseIDAr: "284",
    ayatAR:
      "لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَإِنْ تُبْدُوا مَا فِي أَنْفُسِكُمْ أَوْ تُخْفُوهُ يُحَاسِبْكُمْ بِهِ اللَّهُ ۖ فَيَغْفِرُ لِمَنْ يَشَاءُ وَيُعَذِّبُ مَنْ يَشَاءُ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "292",
    sura: "2",
    VerseIDAr: "285",
    ayatAR:
      "آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ ۚ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ ۚ وَقَالُوا سَمِعْنَا وَأَطَعْنَا ۖ غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ",
  },
  {
    id: "293",
    sura: "2",
    VerseIDAr: "286",
    ayatAR:
      "لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا ۚ لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ ۗ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا ۚ رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا ۚ رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ ۖ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا ۚ أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
  },
  {
    id: "294",
    sura: "3",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  {
    id: "295",
    sura: "3",
    VerseIDAr: "2",
    ayatAR: "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ",
  },
  {
    id: "296",
    sura: "3",
    VerseIDAr: "3",
    ayatAR:
      "نَزَّلَ عَلَيْكَ الْكِتَابَ بِالْحَقِّ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ وَأَنْزَلَ التَّوْرَاةَ وَالْإِنْجِيلَ",
  },
  {
    id: "297",
    sura: "3",
    VerseIDAr: "4",
    ayatAR:
      "مِنْ قَبْلُ هُدًى لِلنَّاسِ وَأَنْزَلَ الْفُرْقَانَ ۗ إِنَّ الَّذِينَ كَفَرُوا بِآيَاتِ اللَّهِ لَهُمْ عَذَابٌ شَدِيدٌ ۗ وَاللَّهُ عَزِيزٌ ذُو انْتِقَامٍ",
  },
  {
    id: "298",
    sura: "3",
    VerseIDAr: "5",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَخْفَىٰ عَلَيْهِ شَيْءٌ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ",
  },
  {
    id: "299",
    sura: "3",
    VerseIDAr: "6",
    ayatAR:
      "هُوَ الَّذِي يُصَوِّرُكُمْ فِي الْأَرْحَامِ كَيْفَ يَشَاءُ ۚ لَا إِلَٰهَ إِلَّا هُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "300",
    sura: "3",
    VerseIDAr: "7",
    ayatAR:
      "هُوَ الَّذِي أَنْزَلَ عَلَيْكَ الْكِتَابَ مِنْهُ آيَاتٌ مُحْكَمَاتٌ هُنَّ أُمُّ الْكِتَابِ وَأُخَرُ مُتَشَابِهَاتٌ ۖ فَأَمَّا الَّذِينَ فِي قُلُوبِهِمْ زَيْغٌ فَيَتَّبِعُونَ مَا تَشَابَهَ مِنْهُ ابْتِغَاءَ الْفِتْنَةِ وَابْتِغَاءَ تَأْوِيلِهِ ۗ وَمَا يَعْلَمُ تَأْوِيلَهُ إِلَّا اللَّهُ ۗ وَالرَّاسِخُونَ فِي الْعِلْمِ يَقُولُونَ آمَنَّا بِهِ كُلٌّ مِنْ عِنْدِ رَبِّنَا ۗ وَمَا يَذَّكَّرُ إِلَّا أُولُو الْأَلْبَابِ",
  },
  {
    id: "301",
    sura: "3",
    VerseIDAr: "8",
    ayatAR:
      "رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِنْ لَدُنْكَ رَحْمَةً ۚ إِنَّكَ أَنْتَ الْوَهَّابُ",
  },
  {
    id: "302",
    sura: "3",
    VerseIDAr: "9",
    ayatAR:
      "رَبَّنَا إِنَّكَ جَامِعُ النَّاسِ لِيَوْمٍ لَا رَيْبَ فِيهِ ۚ إِنَّ اللَّهَ لَا يُخْلِفُ الْمِيعَادَ",
  },
  {
    id: "303",
    sura: "3",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا لَنْ تُغْنِيَ عَنْهُمْ أَمْوَالُهُمْ وَلَا أَوْلَادُهُمْ مِنَ اللَّهِ شَيْئًا ۖ وَأُولَٰئِكَ هُمْ وَقُودُ النَّارِ",
  },
  {
    id: "304",
    sura: "3",
    VerseIDAr: "11",
    ayatAR:
      "كَدَأْبِ آلِ فِرْعَوْنَ وَالَّذِينَ مِنْ قَبْلِهِمْ ۚ كَذَّبُوا بِآيَاتِنَا فَأَخَذَهُمُ اللَّهُ بِذُنُوبِهِمْ ۗ وَاللَّهُ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "305",
    sura: "3",
    VerseIDAr: "12",
    ayatAR:
      "قُلْ لِلَّذِينَ كَفَرُوا سَتُغْلَبُونَ وَتُحْشَرُونَ إِلَىٰ جَهَنَّمَ ۚ وَبِئْسَ الْمِهَادُ",
  },
  {
    id: "306",
    sura: "3",
    VerseIDAr: "13",
    ayatAR:
      "قَدْ كَانَ لَكُمْ آيَةٌ فِي فِئَتَيْنِ الْتَقَتَا ۖ فِئَةٌ تُقَاتِلُ فِي سَبِيلِ اللَّهِ وَأُخْرَىٰ كَافِرَةٌ يَرَوْنَهُمْ مِثْلَيْهِمْ رَأْيَ الْعَيْنِ ۚ وَاللَّهُ يُؤَيِّدُ بِنَصْرِهِ مَنْ يَشَاءُ ۗ إِنَّ فِي ذَٰلِكَ لَعِبْرَةً لِأُولِي الْأَبْصَارِ",
  },
  {
    id: "307",
    sura: "3",
    VerseIDAr: "14",
    ayatAR:
      "زُيِّنَ لِلنَّاسِ حُبُّ الشَّهَوَاتِ مِنَ النِّسَاءِ وَالْبَنِينَ وَالْقَنَاطِيرِ الْمُقَنْطَرَةِ مِنَ الذَّهَبِ وَالْفِضَّةِ وَالْخَيْلِ الْمُسَوَّمَةِ وَالْأَنْعَامِ وَالْحَرْثِ ۗ ذَٰلِكَ مَتَاعُ الْحَيَاةِ الدُّنْيَا ۖ وَاللَّهُ عِنْدَهُ حُسْنُ الْمَآبِ",
  },
  {
    id: "308",
    sura: "3",
    VerseIDAr: "15",
    ayatAR:
      "قُلْ أَؤُنَبِّئُكُمْ بِخَيْرٍ مِنْ ذَٰلِكُمْ ۚ لِلَّذِينَ اتَّقَوْا عِنْدَ رَبِّهِمْ جَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا وَأَزْوَاجٌ مُطَهَّرَةٌ وَرِضْوَانٌ مِنَ اللَّهِ ۗ وَاللَّهُ بَصِيرٌ بِالْعِبَادِ",
  },
  {
    id: "309",
    sura: "3",
    VerseIDAr: "16",
    ayatAR:
      "الَّذِينَ يَقُولُونَ رَبَّنَا إِنَّنَا آمَنَّا فَاغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ النَّارِ",
  },
  {
    id: "310",
    sura: "3",
    VerseIDAr: "17",
    ayatAR:
      "الصَّابِرِينَ وَالصَّادِقِينَ وَالْقَانِتِينَ وَالْمُنْفِقِينَ وَالْمُسْتَغْفِرِينَ بِالْأَسْحَارِ",
  },
  {
    id: "311",
    sura: "3",
    VerseIDAr: "18",
    ayatAR:
      "شَهِدَ اللَّهُ أَنَّهُ لَا إِلَٰهَ إِلَّا هُوَ وَالْمَلَائِكَةُ وَأُولُو الْعِلْمِ قَائِمًا بِالْقِسْطِ ۚ لَا إِلَٰهَ إِلَّا هُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "312",
    sura: "3",
    VerseIDAr: "19",
    ayatAR:
      "إِنَّ الدِّينَ عِنْدَ اللَّهِ الْإِسْلَامُ ۗ وَمَا اخْتَلَفَ الَّذِينَ أُوتُوا الْكِتَابَ إِلَّا مِنْ بَعْدِ مَا جَاءَهُمُ الْعِلْمُ بَغْيًا بَيْنَهُمْ ۗ وَمَنْ يَكْفُرْ بِآيَاتِ اللَّهِ فَإِنَّ اللَّهَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "313",
    sura: "3",
    VerseIDAr: "20",
    ayatAR:
      "فَإِنْ حَاجُّوكَ فَقُلْ أَسْلَمْتُ وَجْهِيَ لِلَّهِ وَمَنِ اتَّبَعَنِ ۗ وَقُلْ لِلَّذِينَ أُوتُوا الْكِتَابَ وَالْأُمِّيِّينَ أَأَسْلَمْتُمْ ۚ فَإِنْ أَسْلَمُوا فَقَدِ اهْتَدَوْا ۖ وَإِنْ تَوَلَّوْا فَإِنَّمَا عَلَيْكَ الْبَلَاغُ ۗ وَاللَّهُ بَصِيرٌ بِالْعِبَادِ",
  },
  {
    id: "314",
    sura: "3",
    VerseIDAr: "21",
    ayatAR:
      "إِنَّ الَّذِينَ يَكْفُرُونَ بِآيَاتِ اللَّهِ وَيَقْتُلُونَ النَّبِيِّينَ بِغَيْرِ حَقٍّ وَيَقْتُلُونَ الَّذِينَ يَأْمُرُونَ بِالْقِسْطِ مِنَ النَّاسِ فَبَشِّرْهُمْ بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "315",
    sura: "3",
    VerseIDAr: "22",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ حَبِطَتْ أَعْمَالُهُمْ فِي الدُّنْيَا وَالْآخِرَةِ وَمَا لَهُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "316",
    sura: "3",
    VerseIDAr: "23",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ أُوتُوا نَصِيبًا مِنَ الْكِتَابِ يُدْعَوْنَ إِلَىٰ كِتَابِ اللَّهِ لِيَحْكُمَ بَيْنَهُمْ ثُمَّ يَتَوَلَّىٰ فَرِيقٌ مِنْهُمْ وَهُمْ مُعْرِضُونَ",
  },
  {
    id: "317",
    sura: "3",
    VerseIDAr: "24",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ قَالُوا لَنْ تَمَسَّنَا النَّارُ إِلَّا أَيَّامًا مَعْدُودَاتٍ ۖ وَغَرَّهُمْ فِي دِينِهِمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "318",
    sura: "3",
    VerseIDAr: "25",
    ayatAR:
      "فَكَيْفَ إِذَا جَمَعْنَاهُمْ لِيَوْمٍ لَا رَيْبَ فِيهِ وَوُفِّيَتْ كُلُّ نَفْسٍ مَا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "319",
    sura: "3",
    VerseIDAr: "26",
    ayatAR:
      "قُلِ اللَّهُمَّ مَالِكَ الْمُلْكِ تُؤْتِي الْمُلْكَ مَنْ تَشَاءُ وَتَنْزِعُ الْمُلْكَ مِمَّنْ تَشَاءُ وَتُعِزُّ مَنْ تَشَاءُ وَتُذِلُّ مَنْ تَشَاءُ ۖ بِيَدِكَ الْخَيْرُ ۖ إِنَّكَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "320",
    sura: "3",
    VerseIDAr: "27",
    ayatAR:
      "تُولِجُ اللَّيْلَ فِي النَّهَارِ وَتُولِجُ النَّهَارَ فِي اللَّيْلِ ۖ وَتُخْرِجُ الْحَيَّ مِنَ الْمَيِّتِ وَتُخْرِجُ الْمَيِّتَ مِنَ الْحَيِّ ۖ وَتَرْزُقُ مَنْ تَشَاءُ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "321",
    sura: "3",
    VerseIDAr: "28",
    ayatAR:
      "لَا يَتَّخِذِ الْمُؤْمِنُونَ الْكَافِرِينَ أَوْلِيَاءَ مِنْ دُونِ الْمُؤْمِنِينَ ۖ وَمَنْ يَفْعَلْ ذَٰلِكَ فَلَيْسَ مِنَ اللَّهِ فِي شَيْءٍ إِلَّا أَنْ تَتَّقُوا مِنْهُمْ تُقَاةً ۗ وَيُحَذِّرُكُمُ اللَّهُ نَفْسَهُ ۗ وَإِلَى اللَّهِ الْمَصِيرُ",
  },
  {
    id: "322",
    sura: "3",
    VerseIDAr: "29",
    ayatAR:
      "قُلْ إِنْ تُخْفُوا مَا فِي صُدُورِكُمْ أَوْ تُبْدُوهُ يَعْلَمْهُ اللَّهُ ۗ وَيَعْلَمُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "323",
    sura: "3",
    VerseIDAr: "30",
    ayatAR:
      "يَوْمَ تَجِدُ كُلُّ نَفْسٍ مَا عَمِلَتْ مِنْ خَيْرٍ مُحْضَرًا وَمَا عَمِلَتْ مِنْ سُوءٍ تَوَدُّ لَوْ أَنَّ بَيْنَهَا وَبَيْنَهُ أَمَدًا بَعِيدًا ۗ وَيُحَذِّرُكُمُ اللَّهُ نَفْسَهُ ۗ وَاللَّهُ رَءُوفٌ بِالْعِبَادِ",
  },
  {
    id: "324",
    sura: "3",
    VerseIDAr: "31",
    ayatAR:
      "قُلْ إِنْ كُنْتُمْ تُحِبُّونَ اللَّهَ فَاتَّبِعُونِي يُحْبِبْكُمُ اللَّهُ وَيَغْفِرْ لَكُمْ ذُنُوبَكُمْ ۗ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "325",
    sura: "3",
    VerseIDAr: "32",
    ayatAR:
      "قُلْ أَطِيعُوا اللَّهَ وَالرَّسُولَ ۖ فَإِنْ تَوَلَّوْا فَإِنَّ اللَّهَ لَا يُحِبُّ الْكَافِرِينَ",
  },
  {
    id: "326",
    sura: "3",
    VerseIDAr: "33",
    ayatAR:
      "إِنَّ اللَّهَ اصْطَفَىٰ آدَمَ وَنُوحًا وَآلَ إِبْرَاهِيمَ وَآلَ عِمْرَانَ عَلَى الْعَالَمِينَ",
  },
  {
    id: "327",
    sura: "3",
    VerseIDAr: "34",
    ayatAR: "ذُرِّيَّةً بَعْضُهَا مِنْ بَعْضٍ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "328",
    sura: "3",
    VerseIDAr: "35",
    ayatAR:
      "إِذْ قَالَتِ امْرَأَتُ عِمْرَانَ رَبِّ إِنِّي نَذَرْتُ لَكَ مَا فِي بَطْنِي مُحَرَّرًا فَتَقَبَّلْ مِنِّي ۖ إِنَّكَ أَنْتَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "329",
    sura: "3",
    VerseIDAr: "36",
    ayatAR:
      "فَلَمَّا وَضَعَتْهَا قَالَتْ رَبِّ إِنِّي وَضَعْتُهَا أُنْثَىٰ وَاللَّهُ أَعْلَمُ بِمَا وَضَعَتْ وَلَيْسَ الذَّكَرُ كَالْأُنْثَىٰ ۖ وَإِنِّي سَمَّيْتُهَا مَرْيَمَ وَإِنِّي أُعِيذُهَا بِكَ وَذُرِّيَّتَهَا مِنَ الشَّيْطَانِ الرَّجِيمِ",
  },
  {
    id: "330",
    sura: "3",
    VerseIDAr: "37",
    ayatAR:
      "فَتَقَبَّلَهَا رَبُّهَا بِقَبُولٍ حَسَنٍ وَأَنْبَتَهَا نَبَاتًا حَسَنًا وَكَفَّلَهَا زَكَرِيَّا ۖ كُلَّمَا دَخَلَ عَلَيْهَا زَكَرِيَّا الْمِحْرَابَ وَجَدَ عِنْدَهَا رِزْقًا ۖ قَالَ يَا مَرْيَمُ أَنَّىٰ لَكِ هَٰذَا ۖ قَالَتْ هُوَ مِنْ عِنْدِ اللَّهِ ۖ إِنَّ اللَّهَ يَرْزُقُ مَنْ يَشَاءُ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "331",
    sura: "3",
    VerseIDAr: "38",
    ayatAR:
      "هُنَالِكَ دَعَا زَكَرِيَّا رَبَّهُ ۖ قَالَ رَبِّ هَبْ لِي مِنْ لَدُنْكَ ذُرِّيَّةً طَيِّبَةً ۖ إِنَّكَ سَمِيعُ الدُّعَاءِ",
  },
  {
    id: "332",
    sura: "3",
    VerseIDAr: "39",
    ayatAR:
      "فَنَادَتْهُ الْمَلَائِكَةُ وَهُوَ قَائِمٌ يُصَلِّي فِي الْمِحْرَابِ أَنَّ اللَّهَ يُبَشِّرُكَ بِيَحْيَىٰ مُصَدِّقًا بِكَلِمَةٍ مِنَ اللَّهِ وَسَيِّدًا وَحَصُورًا وَنَبِيًّا مِنَ الصَّالِحِينَ",
  },
  {
    id: "333",
    sura: "3",
    VerseIDAr: "40",
    ayatAR:
      "قَالَ رَبِّ أَنَّىٰ يَكُونُ لِي غُلَامٌ وَقَدْ بَلَغَنِيَ الْكِبَرُ وَامْرَأَتِي عَاقِرٌ ۖ قَالَ كَذَٰلِكَ اللَّهُ يَفْعَلُ مَا يَشَاءُ",
  },
  {
    id: "334",
    sura: "3",
    VerseIDAr: "41",
    ayatAR:
      "قَالَ رَبِّ اجْعَلْ لِي آيَةً ۖ قَالَ آيَتُكَ أَلَّا تُكَلِّمَ النَّاسَ ثَلَاثَةَ أَيَّامٍ إِلَّا رَمْزًا ۗ وَاذْكُرْ رَبَّكَ كَثِيرًا وَسَبِّحْ بِالْعَشِيِّ وَالْإِبْكَارِ",
  },
  {
    id: "335",
    sura: "3",
    VerseIDAr: "42",
    ayatAR:
      "وَإِذْ قَالَتِ الْمَلَائِكَةُ يَا مَرْيَمُ إِنَّ اللَّهَ اصْطَفَاكِ وَطَهَّرَكِ وَاصْطَفَاكِ عَلَىٰ نِسَاءِ الْعَالَمِينَ",
  },
  {
    id: "336",
    sura: "3",
    VerseIDAr: "43",
    ayatAR:
      "يَا مَرْيَمُ اقْنُتِي لِرَبِّكِ وَاسْجُدِي وَارْكَعِي مَعَ الرَّاكِعِينَ",
  },
  {
    id: "337",
    sura: "3",
    VerseIDAr: "44",
    ayatAR:
      "ذَٰلِكَ مِنْ أَنْبَاءِ الْغَيْبِ نُوحِيهِ إِلَيْكَ ۚ وَمَا كُنْتَ لَدَيْهِمْ إِذْ يُلْقُونَ أَقْلَامَهُمْ أَيُّهُمْ يَكْفُلُ مَرْيَمَ وَمَا كُنْتَ لَدَيْهِمْ إِذْ يَخْتَصِمُونَ",
  },
  {
    id: "338",
    sura: "3",
    VerseIDAr: "45",
    ayatAR:
      "إِذْ قَالَتِ الْمَلَائِكَةُ يَا مَرْيَمُ إِنَّ اللَّهَ يُبَشِّرُكِ بِكَلِمَةٍ مِنْهُ اسْمُهُ الْمَسِيحُ عِيسَى ابْنُ مَرْيَمَ وَجِيهًا فِي الدُّنْيَا وَالْآخِرَةِ وَمِنَ الْمُقَرَّبِينَ",
  },
  {
    id: "339",
    sura: "3",
    VerseIDAr: "46",
    ayatAR: "وَيُكَلِّمُ النَّاسَ فِي الْمَهْدِ وَكَهْلًا وَمِنَ الصَّالِحِينَ",
  },
  {
    id: "340",
    sura: "3",
    VerseIDAr: "47",
    ayatAR:
      "قَالَتْ رَبِّ أَنَّىٰ يَكُونُ لِي وَلَدٌ وَلَمْ يَمْسَسْنِي بَشَرٌ ۖ قَالَ كَذَٰلِكِ اللَّهُ يَخْلُقُ مَا يَشَاءُ ۚ إِذَا قَضَىٰ أَمْرًا فَإِنَّمَا يَقُولُ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "341",
    sura: "3",
    VerseIDAr: "48",
    ayatAR:
      "وَيُعَلِّمُهُ الْكِتَابَ وَالْحِكْمَةَ وَالتَّوْرَاةَ وَالْإِنْجِيلَ",
  },
  {
    id: "342",
    sura: "3",
    VerseIDAr: "49",
    ayatAR:
      "وَرَسُولًا إِلَىٰ بَنِي إِسْرَائِيلَ أَنِّي قَدْ جِئْتُكُمْ بِآيَةٍ مِنْ رَبِّكُمْ ۖ أَنِّي أَخْلُقُ لَكُمْ مِنَ الطِّينِ كَهَيْئَةِ الطَّيْرِ فَأَنْفُخُ فِيهِ فَيَكُونُ طَيْرًا بِإِذْنِ اللَّهِ ۖ وَأُبْرِئُ الْأَكْمَهَ وَالْأَبْرَصَ وَأُحْيِي الْمَوْتَىٰ بِإِذْنِ اللَّهِ ۖ وَأُنَبِّئُكُمْ بِمَا تَأْكُلُونَ وَمَا تَدَّخِرُونَ فِي بُيُوتِكُمْ ۚ إِنَّ فِي ذَٰلِكَ لَآيَةً لَكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "343",
    sura: "3",
    VerseIDAr: "50",
    ayatAR:
      "وَمُصَدِّقًا لِمَا بَيْنَ يَدَيَّ مِنَ التَّوْرَاةِ وَلِأُحِلَّ لَكُمْ بَعْضَ الَّذِي حُرِّمَ عَلَيْكُمْ ۚ وَجِئْتُكُمْ بِآيَةٍ مِنْ رَبِّكُمْ فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "344",
    sura: "3",
    VerseIDAr: "51",
    ayatAR:
      "إِنَّ اللَّهَ رَبِّي وَرَبُّكُمْ فَاعْبُدُوهُ ۗ هَٰذَا صِرَاطٌ مُسْتَقِيمٌ",
  },
  {
    id: "345",
    sura: "3",
    VerseIDAr: "52",
    ayatAR:
      "فَلَمَّا أَحَسَّ عِيسَىٰ مِنْهُمُ الْكُفْرَ قَالَ مَنْ أَنْصَارِي إِلَى اللَّهِ ۖ قَالَ الْحَوَارِيُّونَ نَحْنُ أَنْصَارُ اللَّهِ آمَنَّا بِاللَّهِ وَاشْهَدْ بِأَنَّا مُسْلِمُونَ",
  },
  {
    id: "346",
    sura: "3",
    VerseIDAr: "53",
    ayatAR:
      "رَبَّنَا آمَنَّا بِمَا أَنْزَلْتَ وَاتَّبَعْنَا الرَّسُولَ فَاكْتُبْنَا مَعَ الشَّاهِدِينَ",
  },
  {
    id: "347",
    sura: "3",
    VerseIDAr: "54",
    ayatAR: "وَمَكَرُوا وَمَكَرَ اللَّهُ ۖ وَاللَّهُ خَيْرُ الْمَاكِرِينَ",
  },
  {
    id: "348",
    sura: "3",
    VerseIDAr: "55",
    ayatAR:
      "إِذْ قَالَ اللَّهُ يَا عِيسَىٰ إِنِّي مُتَوَفِّيكَ وَرَافِعُكَ إِلَيَّ وَمُطَهِّرُكَ مِنَ الَّذِينَ كَفَرُوا وَجَاعِلُ الَّذِينَ اتَّبَعُوكَ فَوْقَ الَّذِينَ كَفَرُوا إِلَىٰ يَوْمِ الْقِيَامَةِ ۖ ثُمَّ إِلَيَّ مَرْجِعُكُمْ فَأَحْكُمُ بَيْنَكُمْ فِيمَا كُنْتُمْ فِيهِ تَخْتَلِفُونَ",
  },
  {
    id: "349",
    sura: "3",
    VerseIDAr: "56",
    ayatAR:
      "فَأَمَّا الَّذِينَ كَفَرُوا فَأُعَذِّبُهُمْ عَذَابًا شَدِيدًا فِي الدُّنْيَا وَالْآخِرَةِ وَمَا لَهُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "350",
    sura: "3",
    VerseIDAr: "57",
    ayatAR:
      "وَأَمَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَيُوَفِّيهِمْ أُجُورَهُمْ ۗ وَاللَّهُ لَا يُحِبُّ الظَّالِمِينَ",
  },
  {
    id: "351",
    sura: "3",
    VerseIDAr: "58",
    ayatAR: "ذَٰلِكَ نَتْلُوهُ عَلَيْكَ مِنَ الْآيَاتِ وَالذِّكْرِ الْحَكِيمِ",
  },
  {
    id: "352",
    sura: "3",
    VerseIDAr: "59",
    ayatAR:
      "إِنَّ مَثَلَ عِيسَىٰ عِنْدَ اللَّهِ كَمَثَلِ آدَمَ ۖ خَلَقَهُ مِنْ تُرَابٍ ثُمَّ قَالَ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "353",
    sura: "3",
    VerseIDAr: "60",
    ayatAR: "الْحَقُّ مِنْ رَبِّكَ فَلَا تَكُنْ مِنَ الْمُمْتَرِينَ",
  },
  {
    id: "354",
    sura: "3",
    VerseIDAr: "61",
    ayatAR:
      "فَمَنْ حَاجَّكَ فِيهِ مِنْ بَعْدِ مَا جَاءَكَ مِنَ الْعِلْمِ فَقُلْ تَعَالَوْا نَدْعُ أَبْنَاءَنَا وَأَبْنَاءَكُمْ وَنِسَاءَنَا وَنِسَاءَكُمْ وَأَنْفُسَنَا وَأَنْفُسَكُمْ ثُمَّ نَبْتَهِلْ فَنَجْعَلْ لَعْنَتَ اللَّهِ عَلَى الْكَاذِبِينَ",
  },
  {
    id: "355",
    sura: "3",
    VerseIDAr: "62",
    ayatAR:
      "إِنَّ هَٰذَا لَهُوَ الْقَصَصُ الْحَقُّ ۚ وَمَا مِنْ إِلَٰهٍ إِلَّا اللَّهُ ۚ وَإِنَّ اللَّهَ لَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "356",
    sura: "3",
    VerseIDAr: "63",
    ayatAR: "فَإِنْ تَوَلَّوْا فَإِنَّ اللَّهَ عَلِيمٌ بِالْمُفْسِدِينَ",
  },
  {
    id: "357",
    sura: "3",
    VerseIDAr: "64",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ تَعَالَوْا إِلَىٰ كَلِمَةٍ سَوَاءٍ بَيْنَنَا وَبَيْنَكُمْ أَلَّا نَعْبُدَ إِلَّا اللَّهَ وَلَا نُشْرِكَ بِهِ شَيْئًا وَلَا يَتَّخِذَ بَعْضُنَا بَعْضًا أَرْبَابًا مِنْ دُونِ اللَّهِ ۚ فَإِنْ تَوَلَّوْا فَقُولُوا اشْهَدُوا بِأَنَّا مُسْلِمُونَ",
  },
  {
    id: "358",
    sura: "3",
    VerseIDAr: "65",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ لِمَ تُحَاجُّونَ فِي إِبْرَاهِيمَ وَمَا أُنْزِلَتِ التَّوْرَاةُ وَالْإِنْجِيلُ إِلَّا مِنْ بَعْدِهِ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "359",
    sura: "3",
    VerseIDAr: "66",
    ayatAR:
      "هَا أَنْتُمْ هَٰؤُلَاءِ حَاجَجْتُمْ فِيمَا لَكُمْ بِهِ عِلْمٌ فَلِمَ تُحَاجُّونَ فِيمَا لَيْسَ لَكُمْ بِهِ عِلْمٌ ۚ وَاللَّهُ يَعْلَمُ وَأَنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "360",
    sura: "3",
    VerseIDAr: "67",
    ayatAR:
      "مَا كَانَ إِبْرَاهِيمُ يَهُودِيًّا وَلَا نَصْرَانِيًّا وَلَٰكِنْ كَانَ حَنِيفًا مُسْلِمًا وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "361",
    sura: "3",
    VerseIDAr: "68",
    ayatAR:
      "إِنَّ أَوْلَى النَّاسِ بِإِبْرَاهِيمَ لَلَّذِينَ اتَّبَعُوهُ وَهَٰذَا النَّبِيُّ وَالَّذِينَ آمَنُوا ۗ وَاللَّهُ وَلِيُّ الْمُؤْمِنِينَ",
  },
  {
    id: "362",
    sura: "3",
    VerseIDAr: "69",
    ayatAR:
      "وَدَّتْ طَائِفَةٌ مِنْ أَهْلِ الْكِتَابِ لَوْ يُضِلُّونَكُمْ وَمَا يُضِلُّونَ إِلَّا أَنْفُسَهُمْ وَمَا يَشْعُرُونَ",
  },
  {
    id: "363",
    sura: "3",
    VerseIDAr: "70",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ لِمَ تَكْفُرُونَ بِآيَاتِ اللَّهِ وَأَنْتُمْ تَشْهَدُونَ",
  },
  {
    id: "364",
    sura: "3",
    VerseIDAr: "71",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ لِمَ تَلْبِسُونَ الْحَقَّ بِالْبَاطِلِ وَتَكْتُمُونَ الْحَقَّ وَأَنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "365",
    sura: "3",
    VerseIDAr: "72",
    ayatAR:
      "وَقَالَتْ طَائِفَةٌ مِنْ أَهْلِ الْكِتَابِ آمِنُوا بِالَّذِي أُنْزِلَ عَلَى الَّذِينَ آمَنُوا وَجْهَ النَّهَارِ وَاكْفُرُوا آخِرَهُ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "366",
    sura: "3",
    VerseIDAr: "73",
    ayatAR:
      "وَلَا تُؤْمِنُوا إِلَّا لِمَنْ تَبِعَ دِينَكُمْ قُلْ إِنَّ الْهُدَىٰ هُدَى اللَّهِ أَنْ يُؤْتَىٰ أَحَدٌ مِثْلَ مَا أُوتِيتُمْ أَوْ يُحَاجُّوكُمْ عِنْدَ رَبِّكُمْ ۗ قُلْ إِنَّ الْفَضْلَ بِيَدِ اللَّهِ يُؤْتِيهِ مَنْ يَشَاءُ ۗ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "367",
    sura: "3",
    VerseIDAr: "74",
    ayatAR:
      "يَخْتَصُّ بِرَحْمَتِهِ مَنْ يَشَاءُ ۗ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "368",
    sura: "3",
    VerseIDAr: "75",
    ayatAR:
      "وَمِنْ أَهْلِ الْكِتَابِ مَنْ إِنْ تَأْمَنْهُ بِقِنْطَارٍ يُؤَدِّهِ إِلَيْكَ وَمِنْهُمْ مَنْ إِنْ تَأْمَنْهُ بِدِينَارٍ لَا يُؤَدِّهِ إِلَيْكَ إِلَّا مَا دُمْتَ عَلَيْهِ قَائِمًا ۗ ذَٰلِكَ بِأَنَّهُمْ قَالُوا لَيْسَ عَلَيْنَا فِي الْأُمِّيِّينَ سَبِيلٌ وَيَقُولُونَ عَلَى اللَّهِ الْكَذِبَ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "369",
    sura: "3",
    VerseIDAr: "76",
    ayatAR:
      "بَلَىٰ مَنْ أَوْفَىٰ بِعَهْدِهِ وَاتَّقَىٰ فَإِنَّ اللَّهَ يُحِبُّ الْمُتَّقِينَ",
  },
  {
    id: "370",
    sura: "3",
    VerseIDAr: "77",
    ayatAR:
      "إِنَّ الَّذِينَ يَشْتَرُونَ بِعَهْدِ اللَّهِ وَأَيْمَانِهِمْ ثَمَنًا قَلِيلًا أُولَٰئِكَ لَا خَلَاقَ لَهُمْ فِي الْآخِرَةِ وَلَا يُكَلِّمُهُمُ اللَّهُ وَلَا يَنْظُرُ إِلَيْهِمْ يَوْمَ الْقِيَامَةِ وَلَا يُزَكِّيهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "371",
    sura: "3",
    VerseIDAr: "78",
    ayatAR:
      "وَإِنَّ مِنْهُمْ لَفَرِيقًا يَلْوُونَ أَلْسِنَتَهُمْ بِالْكِتَابِ لِتَحْسَبُوهُ مِنَ الْكِتَابِ وَمَا هُوَ مِنَ الْكِتَابِ وَيَقُولُونَ هُوَ مِنْ عِنْدِ اللَّهِ وَمَا هُوَ مِنْ عِنْدِ اللَّهِ وَيَقُولُونَ عَلَى اللَّهِ الْكَذِبَ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "372",
    sura: "3",
    VerseIDAr: "79",
    ayatAR:
      "مَا كَانَ لِبَشَرٍ أَنْ يُؤْتِيَهُ اللَّهُ الْكِتَابَ وَالْحُكْمَ وَالنُّبُوَّةَ ثُمَّ يَقُولَ لِلنَّاسِ كُونُوا عِبَادًا لِي مِنْ دُونِ اللَّهِ وَلَٰكِنْ كُونُوا رَبَّانِيِّينَ بِمَا كُنْتُمْ تُعَلِّمُونَ الْكِتَابَ وَبِمَا كُنْتُمْ تَدْرُسُونَ",
  },
  {
    id: "373",
    sura: "3",
    VerseIDAr: "80",
    ayatAR:
      "وَلَا يَأْمُرَكُمْ أَنْ تَتَّخِذُوا الْمَلَائِكَةَ وَالنَّبِيِّينَ أَرْبَابًا ۗ أَيَأْمُرُكُمْ بِالْكُفْرِ بَعْدَ إِذْ أَنْتُمْ مُسْلِمُونَ",
  },
  {
    id: "374",
    sura: "3",
    VerseIDAr: "81",
    ayatAR:
      "وَإِذْ أَخَذَ اللَّهُ مِيثَاقَ النَّبِيِّينَ لَمَا آتَيْتُكُمْ مِنْ كِتَابٍ وَحِكْمَةٍ ثُمَّ جَاءَكُمْ رَسُولٌ مُصَدِّقٌ لِمَا مَعَكُمْ لَتُؤْمِنُنَّ بِهِ وَلَتَنْصُرُنَّهُ ۚ قَالَ أَأَقْرَرْتُمْ وَأَخَذْتُمْ عَلَىٰ ذَٰلِكُمْ إِصْرِي ۖ قَالُوا أَقْرَرْنَا ۚ قَالَ فَاشْهَدُوا وَأَنَا مَعَكُمْ مِنَ الشَّاهِدِينَ",
  },
  {
    id: "375",
    sura: "3",
    VerseIDAr: "82",
    ayatAR: "فَمَنْ تَوَلَّىٰ بَعْدَ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "376",
    sura: "3",
    VerseIDAr: "83",
    ayatAR:
      "أَفَغَيْرَ دِينِ اللَّهِ يَبْغُونَ وَلَهُ أَسْلَمَ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ طَوْعًا وَكَرْهًا وَإِلَيْهِ يُرْجَعُونَ",
  },
  {
    id: "377",
    sura: "3",
    VerseIDAr: "84",
    ayatAR:
      "قُلْ آمَنَّا بِاللَّهِ وَمَا أُنْزِلَ عَلَيْنَا وَمَا أُنْزِلَ عَلَىٰ إِبْرَاهِيمَ وَإِسْمَاعِيلَ وَإِسْحَاقَ وَيَعْقُوبَ وَالْأَسْبَاطِ وَمَا أُوتِيَ مُوسَىٰ وَعِيسَىٰ وَالنَّبِيُّونَ مِنْ رَبِّهِمْ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْهُمْ وَنَحْنُ لَهُ مُسْلِمُونَ",
  },
  {
    id: "378",
    sura: "3",
    VerseIDAr: "85",
    ayatAR:
      "وَمَنْ يَبْتَغِ غَيْرَ الْإِسْلَامِ دِينًا فَلَنْ يُقْبَلَ مِنْهُ وَهُوَ فِي الْآخِرَةِ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "379",
    sura: "3",
    VerseIDAr: "86",
    ayatAR:
      "كَيْفَ يَهْدِي اللَّهُ قَوْمًا كَفَرُوا بَعْدَ إِيمَانِهِمْ وَشَهِدُوا أَنَّ الرَّسُولَ حَقٌّ وَجَاءَهُمُ الْبَيِّنَاتُ ۚ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "380",
    sura: "3",
    VerseIDAr: "87",
    ayatAR:
      "أُولَٰئِكَ جَزَاؤُهُمْ أَنَّ عَلَيْهِمْ لَعْنَةَ اللَّهِ وَالْمَلَائِكَةِ وَالنَّاسِ أَجْمَعِينَ",
  },
  {
    id: "381",
    sura: "3",
    VerseIDAr: "88",
    ayatAR:
      "خَالِدِينَ فِيهَا لَا يُخَفَّفُ عَنْهُمُ الْعَذَابُ وَلَا هُمْ يُنْظَرُونَ",
  },
  {
    id: "382",
    sura: "3",
    VerseIDAr: "89",
    ayatAR:
      "إِلَّا الَّذِينَ تَابُوا مِنْ بَعْدِ ذَٰلِكَ وَأَصْلَحُوا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "383",
    sura: "3",
    VerseIDAr: "90",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا بَعْدَ إِيمَانِهِمْ ثُمَّ ازْدَادُوا كُفْرًا لَنْ تُقْبَلَ تَوْبَتُهُمْ وَأُولَٰئِكَ هُمُ الضَّالُّونَ",
  },
  {
    id: "384",
    sura: "3",
    VerseIDAr: "91",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَمَاتُوا وَهُمْ كُفَّارٌ فَلَنْ يُقْبَلَ مِنْ أَحَدِهِمْ مِلْءُ الْأَرْضِ ذَهَبًا وَلَوِ افْتَدَىٰ بِهِ ۗ أُولَٰئِكَ لَهُمْ عَذَابٌ أَلِيمٌ وَمَا لَهُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "385",
    sura: "3",
    VerseIDAr: "92",
    ayatAR:
      "لَنْ تَنَالُوا الْبِرَّ حَتَّىٰ تُنْفِقُوا مِمَّا تُحِبُّونَ ۚ وَمَا تُنْفِقُوا مِنْ شَيْءٍ فَإِنَّ اللَّهَ بِهِ عَلِيمٌ",
  },
  {
    id: "386",
    sura: "3",
    VerseIDAr: "93",
    ayatAR:
      "كُلُّ الطَّعَامِ كَانَ حِلًّا لِبَنِي إِسْرَائِيلَ إِلَّا مَا حَرَّمَ إِسْرَائِيلُ عَلَىٰ نَفْسِهِ مِنْ قَبْلِ أَنْ تُنَزَّلَ التَّوْرَاةُ ۗ قُلْ فَأْتُوا بِالتَّوْرَاةِ فَاتْلُوهَا إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "387",
    sura: "3",
    VerseIDAr: "94",
    ayatAR:
      "فَمَنِ افْتَرَىٰ عَلَى اللَّهِ الْكَذِبَ مِنْ بَعْدِ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "388",
    sura: "3",
    VerseIDAr: "95",
    ayatAR:
      "قُلْ صَدَقَ اللَّهُ ۗ فَاتَّبِعُوا مِلَّةَ إِبْرَاهِيمَ حَنِيفًا وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "389",
    sura: "3",
    VerseIDAr: "96",
    ayatAR:
      "إِنَّ أَوَّلَ بَيْتٍ وُضِعَ لِلنَّاسِ لَلَّذِي بِبَكَّةَ مُبَارَكًا وَهُدًى لِلْعَالَمِينَ",
  },
  {
    id: "390",
    sura: "3",
    VerseIDAr: "97",
    ayatAR:
      "فِيهِ آيَاتٌ بَيِّنَاتٌ مَقَامُ إِبْرَاهِيمَ ۖ وَمَنْ دَخَلَهُ كَانَ آمِنًا ۗ وَلِلَّهِ عَلَى النَّاسِ حِجُّ الْبَيْتِ مَنِ اسْتَطَاعَ إِلَيْهِ سَبِيلًا ۚ وَمَنْ كَفَرَ فَإِنَّ اللَّهَ غَنِيٌّ عَنِ الْعَالَمِينَ",
  },
  {
    id: "391",
    sura: "3",
    VerseIDAr: "98",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ لِمَ تَكْفُرُونَ بِآيَاتِ اللَّهِ وَاللَّهُ شَهِيدٌ عَلَىٰ مَا تَعْمَلُونَ",
  },
  {
    id: "392",
    sura: "3",
    VerseIDAr: "99",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ لِمَ تَصُدُّونَ عَنْ سَبِيلِ اللَّهِ مَنْ آمَنَ تَبْغُونَهَا عِوَجًا وَأَنْتُمْ شُهَدَاءُ ۗ وَمَا اللَّهُ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "393",
    sura: "3",
    VerseIDAr: "100",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنْ تُطِيعُوا فَرِيقًا مِنَ الَّذِينَ أُوتُوا الْكِتَابَ يَرُدُّوكُمْ بَعْدَ إِيمَانِكُمْ كَافِرِينَ",
  },
  {
    id: "394",
    sura: "3",
    VerseIDAr: "101",
    ayatAR:
      "وَكَيْفَ تَكْفُرُونَ وَأَنْتُمْ تُتْلَىٰ عَلَيْكُمْ آيَاتُ اللَّهِ وَفِيكُمْ رَسُولُهُ ۗ وَمَنْ يَعْتَصِمْ بِاللَّهِ فَقَدْ هُدِيَ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "395",
    sura: "3",
    VerseIDAr: "102",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ حَقَّ تُقَاتِهِ وَلَا تَمُوتُنَّ إِلَّا وَأَنْتُمْ مُسْلِمُونَ",
  },
  {
    id: "396",
    sura: "3",
    VerseIDAr: "103",
    ayatAR:
      "وَاعْتَصِمُوا بِحَبْلِ اللَّهِ جَمِيعًا وَلَا تَفَرَّقُوا ۚ وَاذْكُرُوا نِعْمَتَ اللَّهِ عَلَيْكُمْ إِذْ كُنْتُمْ أَعْدَاءً فَأَلَّفَ بَيْنَ قُلُوبِكُمْ فَأَصْبَحْتُمْ بِنِعْمَتِهِ إِخْوَانًا وَكُنْتُمْ عَلَىٰ شَفَا حُفْرَةٍ مِنَ النَّارِ فَأَنْقَذَكُمْ مِنْهَا ۗ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمْ آيَاتِهِ لَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "397",
    sura: "3",
    VerseIDAr: "104",
    ayatAR:
      "وَلْتَكُنْ مِنْكُمْ أُمَّةٌ يَدْعُونَ إِلَى الْخَيْرِ وَيَأْمُرُونَ بِالْمَعْرُوفِ وَيَنْهَوْنَ عَنِ الْمُنْكَرِ ۚ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "398",
    sura: "3",
    VerseIDAr: "105",
    ayatAR:
      "وَلَا تَكُونُوا كَالَّذِينَ تَفَرَّقُوا وَاخْتَلَفُوا مِنْ بَعْدِ مَا جَاءَهُمُ الْبَيِّنَاتُ ۚ وَأُولَٰئِكَ لَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "399",
    sura: "3",
    VerseIDAr: "106",
    ayatAR:
      "يَوْمَ تَبْيَضُّ وُجُوهٌ وَتَسْوَدُّ وُجُوهٌ ۚ فَأَمَّا الَّذِينَ اسْوَدَّتْ وُجُوهُهُمْ أَكَفَرْتُمْ بَعْدَ إِيمَانِكُمْ فَذُوقُوا الْعَذَابَ بِمَا كُنْتُمْ تَكْفُرُونَ",
  },
  {
    id: "400",
    sura: "3",
    VerseIDAr: "107",
    ayatAR:
      "وَأَمَّا الَّذِينَ ابْيَضَّتْ وُجُوهُهُمْ فَفِي رَحْمَةِ اللَّهِ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "401",
    sura: "3",
    VerseIDAr: "108",
    ayatAR:
      "تِلْكَ آيَاتُ اللَّهِ نَتْلُوهَا عَلَيْكَ بِالْحَقِّ ۗ وَمَا اللَّهُ يُرِيدُ ظُلْمًا لِلْعَالَمِينَ",
  },
  {
    id: "402",
    sura: "3",
    VerseIDAr: "109",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "403",
    sura: "3",
    VerseIDAr: "110",
    ayatAR:
      "كُنْتُمْ خَيْرَ أُمَّةٍ أُخْرِجَتْ لِلنَّاسِ تَأْمُرُونَ بِالْمَعْرُوفِ وَتَنْهَوْنَ عَنِ الْمُنْكَرِ وَتُؤْمِنُونَ بِاللَّهِ ۗ وَلَوْ آمَنَ أَهْلُ الْكِتَابِ لَكَانَ خَيْرًا لَهُمْ ۚ مِنْهُمُ الْمُؤْمِنُونَ وَأَكْثَرُهُمُ الْفَاسِقُونَ",
  },
  {
    id: "404",
    sura: "3",
    VerseIDAr: "111",
    ayatAR:
      "لَنْ يَضُرُّوكُمْ إِلَّا أَذًى ۖ وَإِنْ يُقَاتِلُوكُمْ يُوَلُّوكُمُ الْأَدْبَارَ ثُمَّ لَا يُنْصَرُونَ",
  },
  {
    id: "405",
    sura: "3",
    VerseIDAr: "112",
    ayatAR:
      "ضُرِبَتْ عَلَيْهِمُ الذِّلَّةُ أَيْنَ مَا ثُقِفُوا إِلَّا بِحَبْلٍ مِنَ اللَّهِ وَحَبْلٍ مِنَ النَّاسِ وَبَاءُوا بِغَضَبٍ مِنَ اللَّهِ وَضُرِبَتْ عَلَيْهِمُ الْمَسْكَنَةُ ۚ ذَٰلِكَ بِأَنَّهُمْ كَانُوا يَكْفُرُونَ بِآيَاتِ اللَّهِ وَيَقْتُلُونَ الْأَنْبِيَاءَ بِغَيْرِ حَقٍّ ۚ ذَٰلِكَ بِمَا عَصَوْا وَكَانُوا يَعْتَدُونَ",
  },
  {
    id: "406",
    sura: "3",
    VerseIDAr: "113",
    ayatAR:
      "لَيْسُوا سَوَاءً ۗ مِنْ أَهْلِ الْكِتَابِ أُمَّةٌ قَائِمَةٌ يَتْلُونَ آيَاتِ اللَّهِ آنَاءَ اللَّيْلِ وَهُمْ يَسْجُدُونَ",
  },
  {
    id: "407",
    sura: "3",
    VerseIDAr: "114",
    ayatAR:
      "يُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَيَأْمُرُونَ بِالْمَعْرُوفِ وَيَنْهَوْنَ عَنِ الْمُنْكَرِ وَيُسَارِعُونَ فِي الْخَيْرَاتِ وَأُولَٰئِكَ مِنَ الصَّالِحِينَ",
  },
  {
    id: "408",
    sura: "3",
    VerseIDAr: "115",
    ayatAR:
      "وَمَا يَفْعَلُوا مِنْ خَيْرٍ فَلَنْ يُكْفَرُوهُ ۗ وَاللَّهُ عَلِيمٌ بِالْمُتَّقِينَ",
  },
  {
    id: "409",
    sura: "3",
    VerseIDAr: "116",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا لَنْ تُغْنِيَ عَنْهُمْ أَمْوَالُهُمْ وَلَا أَوْلَادُهُمْ مِنَ اللَّهِ شَيْئًا ۖ وَأُولَٰئِكَ أَصْحَابُ النَّارِ ۚ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "410",
    sura: "3",
    VerseIDAr: "117",
    ayatAR:
      "مَثَلُ مَا يُنْفِقُونَ فِي هَٰذِهِ الْحَيَاةِ الدُّنْيَا كَمَثَلِ رِيحٍ فِيهَا صِرٌّ أَصَابَتْ حَرْثَ قَوْمٍ ظَلَمُوا أَنْفُسَهُمْ فَأَهْلَكَتْهُ ۚ وَمَا ظَلَمَهُمُ اللَّهُ وَلَٰكِنْ أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "411",
    sura: "3",
    VerseIDAr: "118",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا بِطَانَةً مِنْ دُونِكُمْ لَا يَأْلُونَكُمْ خَبَالًا وَدُّوا مَا عَنِتُّمْ قَدْ بَدَتِ الْبَغْضَاءُ مِنْ أَفْوَاهِهِمْ وَمَا تُخْفِي صُدُورُهُمْ أَكْبَرُ ۚ قَدْ بَيَّنَّا لَكُمُ الْآيَاتِ ۖ إِنْ كُنْتُمْ تَعْقِلُونَ",
  },
  {
    id: "412",
    sura: "3",
    VerseIDAr: "119",
    ayatAR:
      "هَا أَنْتُمْ أُولَاءِ تُحِبُّونَهُمْ وَلَا يُحِبُّونَكُمْ وَتُؤْمِنُونَ بِالْكِتَابِ كُلِّهِ وَإِذَا لَقُوكُمْ قَالُوا آمَنَّا وَإِذَا خَلَوْا عَضُّوا عَلَيْكُمُ الْأَنَامِلَ مِنَ الْغَيْظِ ۚ قُلْ مُوتُوا بِغَيْظِكُمْ ۗ إِنَّ اللَّهَ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "413",
    sura: "3",
    VerseIDAr: "120",
    ayatAR:
      "إِنْ تَمْسَسْكُمْ حَسَنَةٌ تَسُؤْهُمْ وَإِنْ تُصِبْكُمْ سَيِّئَةٌ يَفْرَحُوا بِهَا ۖ وَإِنْ تَصْبِرُوا وَتَتَّقُوا لَا يَضُرُّكُمْ كَيْدُهُمْ شَيْئًا ۗ إِنَّ اللَّهَ بِمَا يَعْمَلُونَ مُحِيطٌ",
  },
  {
    id: "414",
    sura: "3",
    VerseIDAr: "121",
    ayatAR:
      "وَإِذْ غَدَوْتَ مِنْ أَهْلِكَ تُبَوِّئُ الْمُؤْمِنِينَ مَقَاعِدَ لِلْقِتَالِ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "415",
    sura: "3",
    VerseIDAr: "122",
    ayatAR:
      "إِذْ هَمَّتْ طَائِفَتَانِ مِنْكُمْ أَنْ تَفْشَلَا وَاللَّهُ وَلِيُّهُمَا ۗ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "416",
    sura: "3",
    VerseIDAr: "123",
    ayatAR:
      "وَلَقَدْ نَصَرَكُمُ اللَّهُ بِبَدْرٍ وَأَنْتُمْ أَذِلَّةٌ ۖ فَاتَّقُوا اللَّهَ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "417",
    sura: "3",
    VerseIDAr: "124",
    ayatAR:
      "إِذْ تَقُولُ لِلْمُؤْمِنِينَ أَلَنْ يَكْفِيَكُمْ أَنْ يُمِدَّكُمْ رَبُّكُمْ بِثَلَاثَةِ آلَافٍ مِنَ الْمَلَائِكَةِ مُنْزَلِينَ",
  },
  {
    id: "418",
    sura: "3",
    VerseIDAr: "125",
    ayatAR:
      "بَلَىٰ ۚ إِنْ تَصْبِرُوا وَتَتَّقُوا وَيَأْتُوكُمْ مِنْ فَوْرِهِمْ هَٰذَا يُمْدِدْكُمْ رَبُّكُمْ بِخَمْسَةِ آلَافٍ مِنَ الْمَلَائِكَةِ مُسَوِّمِينَ",
  },
  {
    id: "419",
    sura: "3",
    VerseIDAr: "126",
    ayatAR:
      "وَمَا جَعَلَهُ اللَّهُ إِلَّا بُشْرَىٰ لَكُمْ وَلِتَطْمَئِنَّ قُلُوبُكُمْ بِهِ ۗ وَمَا النَّصْرُ إِلَّا مِنْ عِنْدِ اللَّهِ الْعَزِيزِ الْحَكِيمِ",
  },
  {
    id: "420",
    sura: "3",
    VerseIDAr: "127",
    ayatAR:
      "لِيَقْطَعَ طَرَفًا مِنَ الَّذِينَ كَفَرُوا أَوْ يَكْبِتَهُمْ فَيَنْقَلِبُوا خَائِبِينَ",
  },
  {
    id: "421",
    sura: "3",
    VerseIDAr: "128",
    ayatAR:
      "لَيْسَ لَكَ مِنَ الْأَمْرِ شَيْءٌ أَوْ يَتُوبَ عَلَيْهِمْ أَوْ يُعَذِّبَهُمْ فَإِنَّهُمْ ظَالِمُونَ",
  },
  {
    id: "422",
    sura: "3",
    VerseIDAr: "129",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ يَغْفِرُ لِمَنْ يَشَاءُ وَيُعَذِّبُ مَنْ يَشَاءُ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "423",
    sura: "3",
    VerseIDAr: "130",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَأْكُلُوا الرِّبَا أَضْعَافًا مُضَاعَفَةً ۖ وَاتَّقُوا اللَّهَ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "424",
    sura: "3",
    VerseIDAr: "131",
    ayatAR: "وَاتَّقُوا النَّارَ الَّتِي أُعِدَّتْ لِلْكَافِرِينَ",
  },
  {
    id: "425",
    sura: "3",
    VerseIDAr: "132",
    ayatAR: "وَأَطِيعُوا اللَّهَ وَالرَّسُولَ لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "426",
    sura: "3",
    VerseIDAr: "133",
    ayatAR:
      "وَسَارِعُوا إِلَىٰ مَغْفِرَةٍ مِنْ رَبِّكُمْ وَجَنَّةٍ عَرْضُهَا السَّمَاوَاتُ وَالْأَرْضُ أُعِدَّتْ لِلْمُتَّقِينَ",
  },
  {
    id: "427",
    sura: "3",
    VerseIDAr: "134",
    ayatAR:
      "الَّذِينَ يُنْفِقُونَ فِي السَّرَّاءِ وَالضَّرَّاءِ وَالْكَاظِمِينَ الْغَيْظَ وَالْعَافِينَ عَنِ النَّاسِ ۗ وَاللَّهُ يُحِبُّ الْمُحْسِنِينَ",
  },
  {
    id: "428",
    sura: "3",
    VerseIDAr: "135",
    ayatAR:
      "وَالَّذِينَ إِذَا فَعَلُوا فَاحِشَةً أَوْ ظَلَمُوا أَنْفُسَهُمْ ذَكَرُوا اللَّهَ فَاسْتَغْفَرُوا لِذُنُوبِهِمْ وَمَنْ يَغْفِرُ الذُّنُوبَ إِلَّا اللَّهُ وَلَمْ يُصِرُّوا عَلَىٰ مَا فَعَلُوا وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "429",
    sura: "3",
    VerseIDAr: "136",
    ayatAR:
      "أُولَٰئِكَ جَزَاؤُهُمْ مَغْفِرَةٌ مِنْ رَبِّهِمْ وَجَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ وَنِعْمَ أَجْرُ الْعَامِلِينَ",
  },
  {
    id: "430",
    sura: "3",
    VerseIDAr: "137",
    ayatAR:
      "قَدْ خَلَتْ مِنْ قَبْلِكُمْ سُنَنٌ فَسِيرُوا فِي الْأَرْضِ فَانْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الْمُكَذِّبِينَ",
  },
  {
    id: "431",
    sura: "3",
    VerseIDAr: "138",
    ayatAR: "هَٰذَا بَيَانٌ لِلنَّاسِ وَهُدًى وَمَوْعِظَةٌ لِلْمُتَّقِينَ",
  },
  {
    id: "432",
    sura: "3",
    VerseIDAr: "139",
    ayatAR:
      "وَلَا تَهِنُوا وَلَا تَحْزَنُوا وَأَنْتُمُ الْأَعْلَوْنَ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "433",
    sura: "3",
    VerseIDAr: "140",
    ayatAR:
      "إِنْ يَمْسَسْكُمْ قَرْحٌ فَقَدْ مَسَّ الْقَوْمَ قَرْحٌ مِثْلُهُ ۚ وَتِلْكَ الْأَيَّامُ نُدَاوِلُهَا بَيْنَ النَّاسِ وَلِيَعْلَمَ اللَّهُ الَّذِينَ آمَنُوا وَيَتَّخِذَ مِنْكُمْ شُهَدَاءَ ۗ وَاللَّهُ لَا يُحِبُّ الظَّالِمِينَ",
  },
  {
    id: "434",
    sura: "3",
    VerseIDAr: "141",
    ayatAR: "وَلِيُمَحِّصَ اللَّهُ الَّذِينَ آمَنُوا وَيَمْحَقَ الْكَافِرِينَ",
  },
  {
    id: "435",
    sura: "3",
    VerseIDAr: "142",
    ayatAR:
      "أَمْ حَسِبْتُمْ أَنْ تَدْخُلُوا الْجَنَّةَ وَلَمَّا يَعْلَمِ اللَّهُ الَّذِينَ جَاهَدُوا مِنْكُمْ وَيَعْلَمَ الصَّابِرِينَ",
  },
  {
    id: "436",
    sura: "3",
    VerseIDAr: "143",
    ayatAR:
      "وَلَقَدْ كُنْتُمْ تَمَنَّوْنَ الْمَوْتَ مِنْ قَبْلِ أَنْ تَلْقَوْهُ فَقَدْ رَأَيْتُمُوهُ وَأَنْتُمْ تَنْظُرُونَ",
  },
  {
    id: "437",
    sura: "3",
    VerseIDAr: "144",
    ayatAR:
      "وَمَا مُحَمَّدٌ إِلَّا رَسُولٌ قَدْ خَلَتْ مِنْ قَبْلِهِ الرُّسُلُ ۚ أَفَإِنْ مَاتَ أَوْ قُتِلَ انْقَلَبْتُمْ عَلَىٰ أَعْقَابِكُمْ ۚ وَمَنْ يَنْقَلِبْ عَلَىٰ عَقِبَيْهِ فَلَنْ يَضُرَّ اللَّهَ شَيْئًا ۗ وَسَيَجْزِي اللَّهُ الشَّاكِرِينَ",
  },
  {
    id: "438",
    sura: "3",
    VerseIDAr: "145",
    ayatAR:
      "وَمَا كَانَ لِنَفْسٍ أَنْ تَمُوتَ إِلَّا بِإِذْنِ اللَّهِ كِتَابًا مُؤَجَّلًا ۗ وَمَنْ يُرِدْ ثَوَابَ الدُّنْيَا نُؤْتِهِ مِنْهَا وَمَنْ يُرِدْ ثَوَابَ الْآخِرَةِ نُؤْتِهِ مِنْهَا ۚ وَسَنَجْزِي الشَّاكِرِينَ",
  },
  {
    id: "439",
    sura: "3",
    VerseIDAr: "146",
    ayatAR:
      "وَكَأَيِّنْ مِنْ نَبِيٍّ قَاتَلَ مَعَهُ رِبِّيُّونَ كَثِيرٌ فَمَا وَهَنُوا لِمَا أَصَابَهُمْ فِي سَبِيلِ اللَّهِ وَمَا ضَعُفُوا وَمَا اسْتَكَانُوا ۗ وَاللَّهُ يُحِبُّ الصَّابِرِينَ",
  },
  {
    id: "440",
    sura: "3",
    VerseIDAr: "147",
    ayatAR:
      "وَمَا كَانَ قَوْلَهُمْ إِلَّا أَنْ قَالُوا رَبَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
  },
  {
    id: "441",
    sura: "3",
    VerseIDAr: "148",
    ayatAR:
      "فَآتَاهُمُ اللَّهُ ثَوَابَ الدُّنْيَا وَحُسْنَ ثَوَابِ الْآخِرَةِ ۗ وَاللَّهُ يُحِبُّ الْمُحْسِنِينَ",
  },
  {
    id: "442",
    sura: "3",
    VerseIDAr: "149",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنْ تُطِيعُوا الَّذِينَ كَفَرُوا يَرُدُّوكُمْ عَلَىٰ أَعْقَابِكُمْ فَتَنْقَلِبُوا خَاسِرِينَ",
  },
  {
    id: "443",
    sura: "3",
    VerseIDAr: "150",
    ayatAR: "بَلِ اللَّهُ مَوْلَاكُمْ ۖ وَهُوَ خَيْرُ النَّاصِرِينَ",
  },
  {
    id: "444",
    sura: "3",
    VerseIDAr: "151",
    ayatAR:
      "سَنُلْقِي فِي قُلُوبِ الَّذِينَ كَفَرُوا الرُّعْبَ بِمَا أَشْرَكُوا بِاللَّهِ مَا لَمْ يُنَزِّلْ بِهِ سُلْطَانًا ۖ وَمَأْوَاهُمُ النَّارُ ۚ وَبِئْسَ مَثْوَى الظَّالِمِينَ",
  },
  {
    id: "445",
    sura: "3",
    VerseIDAr: "152",
    ayatAR:
      "وَلَقَدْ صَدَقَكُمُ اللَّهُ وَعْدَهُ إِذْ تَحُسُّونَهُمْ بِإِذْنِهِ ۖ حَتَّىٰ إِذَا فَشِلْتُمْ وَتَنَازَعْتُمْ فِي الْأَمْرِ وَعَصَيْتُمْ مِنْ بَعْدِ مَا أَرَاكُمْ مَا تُحِبُّونَ ۚ مِنْكُمْ مَنْ يُرِيدُ الدُّنْيَا وَمِنْكُمْ مَنْ يُرِيدُ الْآخِرَةَ ۚ ثُمَّ صَرَفَكُمْ عَنْهُمْ لِيَبْتَلِيَكُمْ ۖ وَلَقَدْ عَفَا عَنْكُمْ ۗ وَاللَّهُ ذُو فَضْلٍ عَلَى الْمُؤْمِنِينَ",
  },
  {
    id: "446",
    sura: "3",
    VerseIDAr: "153",
    ayatAR:
      "إِذْ تُصْعِدُونَ وَلَا تَلْوُونَ عَلَىٰ أَحَدٍ وَالرَّسُولُ يَدْعُوكُمْ فِي أُخْرَاكُمْ فَأَثَابَكُمْ غَمًّا بِغَمٍّ لِكَيْلَا تَحْزَنُوا عَلَىٰ مَا فَاتَكُمْ وَلَا مَا أَصَابَكُمْ ۗ وَاللَّهُ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "447",
    sura: "3",
    VerseIDAr: "154",
    ayatAR:
      "ثُمَّ أَنْزَلَ عَلَيْكُمْ مِنْ بَعْدِ الْغَمِّ أَمَنَةً نُعَاسًا يَغْشَىٰ طَائِفَةً مِنْكُمْ ۖ وَطَائِفَةٌ قَدْ أَهَمَّتْهُمْ أَنْفُسُهُمْ يَظُنُّونَ بِاللَّهِ غَيْرَ الْحَقِّ ظَنَّ الْجَاهِلِيَّةِ ۖ يَقُولُونَ هَلْ لَنَا مِنَ الْأَمْرِ مِنْ شَيْءٍ ۗ قُلْ إِنَّ الْأَمْرَ كُلَّهُ لِلَّهِ ۗ يُخْفُونَ فِي أَنْفُسِهِمْ مَا لَا يُبْدُونَ لَكَ ۖ يَقُولُونَ لَوْ كَانَ لَنَا مِنَ الْأَمْرِ شَيْءٌ مَا قُتِلْنَا هَاهُنَا ۗ قُلْ لَوْ كُنْتُمْ فِي بُيُوتِكُمْ لَبَرَزَ الَّذِينَ كُتِبَ عَلَيْهِمُ الْقَتْلُ إِلَىٰ مَضَاجِعِهِمْ ۖ وَلِيَبْتَلِيَ اللَّهُ مَا فِي صُدُورِكُمْ وَلِيُمَحِّصَ مَا فِي قُلُوبِكُمْ ۗ وَاللَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "448",
    sura: "3",
    VerseIDAr: "155",
    ayatAR:
      "إِنَّ الَّذِينَ تَوَلَّوْا مِنْكُمْ يَوْمَ الْتَقَى الْجَمْعَانِ إِنَّمَا اسْتَزَلَّهُمُ الشَّيْطَانُ بِبَعْضِ مَا كَسَبُوا ۖ وَلَقَدْ عَفَا اللَّهُ عَنْهُمْ ۗ إِنَّ اللَّهَ غَفُورٌ حَلِيمٌ",
  },
  {
    id: "449",
    sura: "3",
    VerseIDAr: "156",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَكُونُوا كَالَّذِينَ كَفَرُوا وَقَالُوا لِإِخْوَانِهِمْ إِذَا ضَرَبُوا فِي الْأَرْضِ أَوْ كَانُوا غُزًّى لَوْ كَانُوا عِنْدَنَا مَا مَاتُوا وَمَا قُتِلُوا لِيَجْعَلَ اللَّهُ ذَٰلِكَ حَسْرَةً فِي قُلُوبِهِمْ ۗ وَاللَّهُ يُحْيِي وَيُمِيتُ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "450",
    sura: "3",
    VerseIDAr: "157",
    ayatAR:
      "وَلَئِنْ قُتِلْتُمْ فِي سَبِيلِ اللَّهِ أَوْ مُتُّمْ لَمَغْفِرَةٌ مِنَ اللَّهِ وَرَحْمَةٌ خَيْرٌ مِمَّا يَجْمَعُونَ",
  },
  {
    id: "451",
    sura: "3",
    VerseIDAr: "158",
    ayatAR: "وَلَئِنْ مُتُّمْ أَوْ قُتِلْتُمْ لَإِلَى اللَّهِ تُحْشَرُونَ",
  },
  {
    id: "452",
    sura: "3",
    VerseIDAr: "159",
    ayatAR:
      "فَبِمَا رَحْمَةٍ مِنَ اللَّهِ لِنْتَ لَهُمْ ۖ وَلَوْ كُنْتَ فَظًّا غَلِيظَ الْقَلْبِ لَانْفَضُّوا مِنْ حَوْلِكَ ۖ فَاعْفُ عَنْهُمْ وَاسْتَغْفِرْ لَهُمْ وَشَاوِرْهُمْ فِي الْأَمْرِ ۖ فَإِذَا عَزَمْتَ فَتَوَكَّلْ عَلَى اللَّهِ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُتَوَكِّلِينَ",
  },
  {
    id: "453",
    sura: "3",
    VerseIDAr: "160",
    ayatAR:
      "إِنْ يَنْصُرْكُمُ اللَّهُ فَلَا غَالِبَ لَكُمْ ۖ وَإِنْ يَخْذُلْكُمْ فَمَنْ ذَا الَّذِي يَنْصُرُكُمْ مِنْ بَعْدِهِ ۗ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "454",
    sura: "3",
    VerseIDAr: "161",
    ayatAR:
      "وَمَا كَانَ لِنَبِيٍّ أَنْ يَغُلَّ ۚ وَمَنْ يَغْلُلْ يَأْتِ بِمَا غَلَّ يَوْمَ الْقِيَامَةِ ۚ ثُمَّ تُوَفَّىٰ كُلُّ نَفْسٍ مَا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "455",
    sura: "3",
    VerseIDAr: "162",
    ayatAR:
      "أَفَمَنِ اتَّبَعَ رِضْوَانَ اللَّهِ كَمَنْ بَاءَ بِسَخَطٍ مِنَ اللَّهِ وَمَأْوَاهُ جَهَنَّمُ ۚ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "456",
    sura: "3",
    VerseIDAr: "163",
    ayatAR:
      "هُمْ دَرَجَاتٌ عِنْدَ اللَّهِ ۗ وَاللَّهُ بَصِيرٌ بِمَا يَعْمَلُونَ",
  },
  {
    id: "457",
    sura: "3",
    VerseIDAr: "164",
    ayatAR:
      "لَقَدْ مَنَّ اللَّهُ عَلَى الْمُؤْمِنِينَ إِذْ بَعَثَ فِيهِمْ رَسُولًا مِنْ أَنْفُسِهِمْ يَتْلُو عَلَيْهِمْ آيَاتِهِ وَيُزَكِّيهِمْ وَيُعَلِّمُهُمُ الْكِتَابَ وَالْحِكْمَةَ وَإِنْ كَانُوا مِنْ قَبْلُ لَفِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "458",
    sura: "3",
    VerseIDAr: "165",
    ayatAR:
      "أَوَلَمَّا أَصَابَتْكُمْ مُصِيبَةٌ قَدْ أَصَبْتُمْ مِثْلَيْهَا قُلْتُمْ أَنَّىٰ هَٰذَا ۖ قُلْ هُوَ مِنْ عِنْدِ أَنْفُسِكُمْ ۗ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "459",
    sura: "3",
    VerseIDAr: "166",
    ayatAR:
      "وَمَا أَصَابَكُمْ يَوْمَ الْتَقَى الْجَمْعَانِ فَبِإِذْنِ اللَّهِ وَلِيَعْلَمَ الْمُؤْمِنِينَ",
  },
  {
    id: "460",
    sura: "3",
    VerseIDAr: "167",
    ayatAR:
      "وَلِيَعْلَمَ الَّذِينَ نَافَقُوا ۚ وَقِيلَ لَهُمْ تَعَالَوْا قَاتِلُوا فِي سَبِيلِ اللَّهِ أَوِ ادْفَعُوا ۖ قَالُوا لَوْ نَعْلَمُ قِتَالًا لَاتَّبَعْنَاكُمْ ۗ هُمْ لِلْكُفْرِ يَوْمَئِذٍ أَقْرَبُ مِنْهُمْ لِلْإِيمَانِ ۚ يَقُولُونَ بِأَفْوَاهِهِمْ مَا لَيْسَ فِي قُلُوبِهِمْ ۗ وَاللَّهُ أَعْلَمُ بِمَا يَكْتُمُونَ",
  },
  {
    id: "461",
    sura: "3",
    VerseIDAr: "168",
    ayatAR:
      "الَّذِينَ قَالُوا لِإِخْوَانِهِمْ وَقَعَدُوا لَوْ أَطَاعُونَا مَا قُتِلُوا ۗ قُلْ فَادْرَءُوا عَنْ أَنْفُسِكُمُ الْمَوْتَ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "462",
    sura: "3",
    VerseIDAr: "169",
    ayatAR:
      "وَلَا تَحْسَبَنَّ الَّذِينَ قُتِلُوا فِي سَبِيلِ اللَّهِ أَمْوَاتًا ۚ بَلْ أَحْيَاءٌ عِنْدَ رَبِّهِمْ يُرْزَقُونَ",
  },
  {
    id: "463",
    sura: "3",
    VerseIDAr: "170",
    ayatAR:
      "فَرِحِينَ بِمَا آتَاهُمُ اللَّهُ مِنْ فَضْلِهِ وَيَسْتَبْشِرُونَ بِالَّذِينَ لَمْ يَلْحَقُوا بِهِمْ مِنْ خَلْفِهِمْ أَلَّا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "464",
    sura: "3",
    VerseIDAr: "171",
    ayatAR:
      "يَسْتَبْشِرُونَ بِنِعْمَةٍ مِنَ اللَّهِ وَفَضْلٍ وَأَنَّ اللَّهَ لَا يُضِيعُ أَجْرَ الْمُؤْمِنِينَ",
  },
  {
    id: "465",
    sura: "3",
    VerseIDAr: "172",
    ayatAR:
      "الَّذِينَ اسْتَجَابُوا لِلَّهِ وَالرَّسُولِ مِنْ بَعْدِ مَا أَصَابَهُمُ الْقَرْحُ ۚ لِلَّذِينَ أَحْسَنُوا مِنْهُمْ وَاتَّقَوْا أَجْرٌ عَظِيمٌ",
  },
  {
    id: "466",
    sura: "3",
    VerseIDAr: "173",
    ayatAR:
      "الَّذِينَ قَالَ لَهُمُ النَّاسُ إِنَّ النَّاسَ قَدْ جَمَعُوا لَكُمْ فَاخْشَوْهُمْ فَزَادَهُمْ إِيمَانًا وَقَالُوا حَسْبُنَا اللَّهُ وَنِعْمَ الْوَكِيلُ",
  },
  {
    id: "467",
    sura: "3",
    VerseIDAr: "174",
    ayatAR:
      "فَانْقَلَبُوا بِنِعْمَةٍ مِنَ اللَّهِ وَفَضْلٍ لَمْ يَمْسَسْهُمْ سُوءٌ وَاتَّبَعُوا رِضْوَانَ اللَّهِ ۗ وَاللَّهُ ذُو فَضْلٍ عَظِيمٍ",
  },
  {
    id: "468",
    sura: "3",
    VerseIDAr: "175",
    ayatAR:
      "إِنَّمَا ذَٰلِكُمُ الشَّيْطَانُ يُخَوِّفُ أَوْلِيَاءَهُ فَلَا تَخَافُوهُمْ وَخَافُونِ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "469",
    sura: "3",
    VerseIDAr: "176",
    ayatAR:
      "وَلَا يَحْزُنْكَ الَّذِينَ يُسَارِعُونَ فِي الْكُفْرِ ۚ إِنَّهُمْ لَنْ يَضُرُّوا اللَّهَ شَيْئًا ۗ يُرِيدُ اللَّهُ أَلَّا يَجْعَلَ لَهُمْ حَظًّا فِي الْآخِرَةِ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "470",
    sura: "3",
    VerseIDAr: "177",
    ayatAR:
      "إِنَّ الَّذِينَ اشْتَرَوُا الْكُفْرَ بِالْإِيمَانِ لَنْ يَضُرُّوا اللَّهَ شَيْئًا وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "471",
    sura: "3",
    VerseIDAr: "178",
    ayatAR:
      "وَلَا يَحْسَبَنَّ الَّذِينَ كَفَرُوا أَنَّمَا نُمْلِي لَهُمْ خَيْرٌ لِأَنْفُسِهِمْ ۚ إِنَّمَا نُمْلِي لَهُمْ لِيَزْدَادُوا إِثْمًا ۚ وَلَهُمْ عَذَابٌ مُهِينٌ",
  },
  {
    id: "472",
    sura: "3",
    VerseIDAr: "179",
    ayatAR:
      "مَا كَانَ اللَّهُ لِيَذَرَ الْمُؤْمِنِينَ عَلَىٰ مَا أَنْتُمْ عَلَيْهِ حَتَّىٰ يَمِيزَ الْخَبِيثَ مِنَ الطَّيِّبِ ۗ وَمَا كَانَ اللَّهُ لِيُطْلِعَكُمْ عَلَى الْغَيْبِ وَلَٰكِنَّ اللَّهَ يَجْتَبِي مِنْ رُسُلِهِ مَنْ يَشَاءُ ۖ فَآمِنُوا بِاللَّهِ وَرُسُلِهِ ۚ وَإِنْ تُؤْمِنُوا وَتَتَّقُوا فَلَكُمْ أَجْرٌ عَظِيمٌ",
  },
  {
    id: "473",
    sura: "3",
    VerseIDAr: "180",
    ayatAR:
      "وَلَا يَحْسَبَنَّ الَّذِينَ يَبْخَلُونَ بِمَا آتَاهُمُ اللَّهُ مِنْ فَضْلِهِ هُوَ خَيْرًا لَهُمْ ۖ بَلْ هُوَ شَرٌّ لَهُمْ ۖ سَيُطَوَّقُونَ مَا بَخِلُوا بِهِ يَوْمَ الْقِيَامَةِ ۗ وَلِلَّهِ مِيرَاثُ السَّمَاوَاتِ وَالْأَرْضِ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "474",
    sura: "3",
    VerseIDAr: "181",
    ayatAR:
      "لَقَدْ سَمِعَ اللَّهُ قَوْلَ الَّذِينَ قَالُوا إِنَّ اللَّهَ فَقِيرٌ وَنَحْنُ أَغْنِيَاءُ ۘ سَنَكْتُبُ مَا قَالُوا وَقَتْلَهُمُ الْأَنْبِيَاءَ بِغَيْرِ حَقٍّ وَنَقُولُ ذُوقُوا عَذَابَ الْحَرِيقِ",
  },
  {
    id: "475",
    sura: "3",
    VerseIDAr: "182",
    ayatAR:
      "ذَٰلِكَ بِمَا قَدَّمَتْ أَيْدِيكُمْ وَأَنَّ اللَّهَ لَيْسَ بِظَلَّامٍ لِلْعَبِيدِ",
  },
  {
    id: "476",
    sura: "3",
    VerseIDAr: "183",
    ayatAR:
      "الَّذِينَ قَالُوا إِنَّ اللَّهَ عَهِدَ إِلَيْنَا أَلَّا نُؤْمِنَ لِرَسُولٍ حَتَّىٰ يَأْتِيَنَا بِقُرْبَانٍ تَأْكُلُهُ النَّارُ ۗ قُلْ قَدْ جَاءَكُمْ رُسُلٌ مِنْ قَبْلِي بِالْبَيِّنَاتِ وَبِالَّذِي قُلْتُمْ فَلِمَ قَتَلْتُمُوهُمْ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "477",
    sura: "3",
    VerseIDAr: "184",
    ayatAR:
      "فَإِنْ كَذَّبُوكَ فَقَدْ كُذِّبَ رُسُلٌ مِنْ قَبْلِكَ جَاءُوا بِالْبَيِّنَاتِ وَالزُّبُرِ وَالْكِتَابِ الْمُنِيرِ",
  },
  {
    id: "478",
    sura: "3",
    VerseIDAr: "185",
    ayatAR:
      "كُلُّ نَفْسٍ ذَائِقَةُ الْمَوْتِ ۗ وَإِنَّمَا تُوَفَّوْنَ أُجُورَكُمْ يَوْمَ الْقِيَامَةِ ۖ فَمَنْ زُحْزِحَ عَنِ النَّارِ وَأُدْخِلَ الْجَنَّةَ فَقَدْ فَازَ ۗ وَمَا الْحَيَاةُ الدُّنْيَا إِلَّا مَتَاعُ الْغُرُورِ",
  },
  {
    id: "479",
    sura: "3",
    VerseIDAr: "186",
    ayatAR:
      "لَتُبْلَوُنَّ فِي أَمْوَالِكُمْ وَأَنْفُسِكُمْ وَلَتَسْمَعُنَّ مِنَ الَّذِينَ أُوتُوا الْكِتَابَ مِنْ قَبْلِكُمْ وَمِنَ الَّذِينَ أَشْرَكُوا أَذًى كَثِيرًا ۚ وَإِنْ تَصْبِرُوا وَتَتَّقُوا فَإِنَّ ذَٰلِكَ مِنْ عَزْمِ الْأُمُورِ",
  },
  {
    id: "480",
    sura: "3",
    VerseIDAr: "187",
    ayatAR:
      "وَإِذْ أَخَذَ اللَّهُ مِيثَاقَ الَّذِينَ أُوتُوا الْكِتَابَ لَتُبَيِّنُنَّهُ لِلنَّاسِ وَلَا تَكْتُمُونَهُ فَنَبَذُوهُ وَرَاءَ ظُهُورِهِمْ وَاشْتَرَوْا بِهِ ثَمَنًا قَلِيلًا ۖ فَبِئْسَ مَا يَشْتَرُونَ",
  },
  {
    id: "481",
    sura: "3",
    VerseIDAr: "188",
    ayatAR:
      "لَا تَحْسَبَنَّ الَّذِينَ يَفْرَحُونَ بِمَا أَتَوْا وَيُحِبُّونَ أَنْ يُحْمَدُوا بِمَا لَمْ يَفْعَلُوا فَلَا تَحْسَبَنَّهُمْ بِمَفَازَةٍ مِنَ الْعَذَابِ ۖ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "482",
    sura: "3",
    VerseIDAr: "189",
    ayatAR:
      "وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "483",
    sura: "3",
    VerseIDAr: "190",
    ayatAR:
      "إِنَّ فِي خَلْقِ السَّمَاوَاتِ وَالْأَرْضِ وَاخْتِلَافِ اللَّيْلِ وَالنَّهَارِ لَآيَاتٍ لِأُولِي الْأَلْبَابِ",
  },
  {
    id: "484",
    sura: "3",
    VerseIDAr: "191",
    ayatAR:
      "الَّذِينَ يَذْكُرُونَ اللَّهَ قِيَامًا وَقُعُودًا وَعَلَىٰ جُنُوبِهِمْ وَيَتَفَكَّرُونَ فِي خَلْقِ السَّمَاوَاتِ وَالْأَرْضِ رَبَّنَا مَا خَلَقْتَ هَٰذَا بَاطِلًا سُبْحَانَكَ فَقِنَا عَذَابَ النَّارِ",
  },
  {
    id: "485",
    sura: "3",
    VerseIDAr: "192",
    ayatAR:
      "رَبَّنَا إِنَّكَ مَنْ تُدْخِلِ النَّارَ فَقَدْ أَخْزَيْتَهُ ۖ وَمَا لِلظَّالِمِينَ مِنْ أَنْصَارٍ",
  },
  {
    id: "486",
    sura: "3",
    VerseIDAr: "193",
    ayatAR:
      "رَبَّنَا إِنَّنَا سَمِعْنَا مُنَادِيًا يُنَادِي لِلْإِيمَانِ أَنْ آمِنُوا بِرَبِّكُمْ فَآمَنَّا ۚ رَبَّنَا فَاغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّئَاتِنَا وَتَوَفَّنَا مَعَ الْأَبْرَارِ",
  },
  {
    id: "487",
    sura: "3",
    VerseIDAr: "194",
    ayatAR:
      "رَبَّنَا وَآتِنَا مَا وَعَدْتَنَا عَلَىٰ رُسُلِكَ وَلَا تُخْزِنَا يَوْمَ الْقِيَامَةِ ۗ إِنَّكَ لَا تُخْلِفُ الْمِيعَادَ",
  },
  {
    id: "488",
    sura: "3",
    VerseIDAr: "195",
    ayatAR:
      "فَاسْتَجَابَ لَهُمْ رَبُّهُمْ أَنِّي لَا أُضِيعُ عَمَلَ عَامِلٍ مِنْكُمْ مِنْ ذَكَرٍ أَوْ أُنْثَىٰ ۖ بَعْضُكُمْ مِنْ بَعْضٍ ۖ فَالَّذِينَ هَاجَرُوا وَأُخْرِجُوا مِنْ دِيَارِهِمْ وَأُوذُوا فِي سَبِيلِي وَقَاتَلُوا وَقُتِلُوا لَأُكَفِّرَنَّ عَنْهُمْ سَيِّئَاتِهِمْ وَلَأُدْخِلَنَّهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ثَوَابًا مِنْ عِنْدِ اللَّهِ ۗ وَاللَّهُ عِنْدَهُ حُسْنُ الثَّوَابِ",
  },
  {
    id: "489",
    sura: "3",
    VerseIDAr: "196",
    ayatAR: "لَا يَغُرَّنَّكَ تَقَلُّبُ الَّذِينَ كَفَرُوا فِي الْبِلَادِ",
  },
  {
    id: "490",
    sura: "3",
    VerseIDAr: "197",
    ayatAR: "مَتَاعٌ قَلِيلٌ ثُمَّ مَأْوَاهُمْ جَهَنَّمُ ۚ وَبِئْسَ الْمِهَادُ",
  },
  {
    id: "491",
    sura: "3",
    VerseIDAr: "198",
    ayatAR:
      "لَٰكِنِ الَّذِينَ اتَّقَوْا رَبَّهُمْ لَهُمْ جَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا نُزُلًا مِنْ عِنْدِ اللَّهِ ۗ وَمَا عِنْدَ اللَّهِ خَيْرٌ لِلْأَبْرَارِ",
  },
  {
    id: "492",
    sura: "3",
    VerseIDAr: "199",
    ayatAR:
      "وَإِنَّ مِنْ أَهْلِ الْكِتَابِ لَمَنْ يُؤْمِنُ بِاللَّهِ وَمَا أُنْزِلَ إِلَيْكُمْ وَمَا أُنْزِلَ إِلَيْهِمْ خَاشِعِينَ لِلَّهِ لَا يَشْتَرُونَ بِآيَاتِ اللَّهِ ثَمَنًا قَلِيلًا ۗ أُولَٰئِكَ لَهُمْ أَجْرُهُمْ عِنْدَ رَبِّهِمْ ۗ إِنَّ اللَّهَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "493",
    sura: "3",
    VerseIDAr: "200",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اصْبِرُوا وَصَابِرُوا وَرَابِطُوا وَاتَّقُوا اللَّهَ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "494",
    sura: "4",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا النَّاسُ اتَّقُوا رَبَّكُمُ الَّذِي خَلَقَكُمْ مِنْ نَفْسٍ وَاحِدَةٍ وَخَلَقَ مِنْهَا زَوْجَهَا وَبَثَّ مِنْهُمَا رِجَالًا كَثِيرًا وَنِسَاءً ۚ وَاتَّقُوا اللَّهَ الَّذِي تَسَاءَلُونَ بِهِ وَالْأَرْحَامَ ۚ إِنَّ اللَّهَ كَانَ عَلَيْكُمْ رَقِيبًا",
  },
  {
    id: "495",
    sura: "4",
    VerseIDAr: "2",
    ayatAR:
      "وَآتُوا الْيَتَامَىٰ أَمْوَالَهُمْ ۖ وَلَا تَتَبَدَّلُوا الْخَبِيثَ بِالطَّيِّبِ ۖ وَلَا تَأْكُلُوا أَمْوَالَهُمْ إِلَىٰ أَمْوَالِكُمْ ۚ إِنَّهُ كَانَ حُوبًا كَبِيرًا",
  },
  {
    id: "496",
    sura: "4",
    VerseIDAr: "3",
    ayatAR:
      "وَإِنْ خِفْتُمْ أَلَّا تُقْسِطُوا فِي الْيَتَامَىٰ فَانْكِحُوا مَا طَابَ لَكُمْ مِنَ النِّسَاءِ مَثْنَىٰ وَثُلَاثَ وَرُبَاعَ ۖ فَإِنْ خِفْتُمْ أَلَّا تَعْدِلُوا فَوَاحِدَةً أَوْ مَا مَلَكَتْ أَيْمَانُكُمْ ۚ ذَٰلِكَ أَدْنَىٰ أَلَّا تَعُولُوا",
  },
  {
    id: "497",
    sura: "4",
    VerseIDAr: "4",
    ayatAR:
      "وَآتُوا النِّسَاءَ صَدُقَاتِهِنَّ نِحْلَةً ۚ فَإِنْ طِبْنَ لَكُمْ عَنْ شَيْءٍ مِنْهُ نَفْسًا فَكُلُوهُ هَنِيئًا مَرِيئًا",
  },
  {
    id: "498",
    sura: "4",
    VerseIDAr: "5",
    ayatAR:
      "وَلَا تُؤْتُوا السُّفَهَاءَ أَمْوَالَكُمُ الَّتِي جَعَلَ اللَّهُ لَكُمْ قِيَامًا وَارْزُقُوهُمْ فِيهَا وَاكْسُوهُمْ وَقُولُوا لَهُمْ قَوْلًا مَعْرُوفًا",
  },
  {
    id: "499",
    sura: "4",
    VerseIDAr: "6",
    ayatAR:
      "وَابْتَلُوا الْيَتَامَىٰ حَتَّىٰ إِذَا بَلَغُوا النِّكَاحَ فَإِنْ آنَسْتُمْ مِنْهُمْ رُشْدًا فَادْفَعُوا إِلَيْهِمْ أَمْوَالَهُمْ ۖ وَلَا تَأْكُلُوهَا إِسْرَافًا وَبِدَارًا أَنْ يَكْبَرُوا ۚ وَمَنْ كَانَ غَنِيًّا فَلْيَسْتَعْفِفْ ۖ وَمَنْ كَانَ فَقِيرًا فَلْيَأْكُلْ بِالْمَعْرُوفِ ۚ فَإِذَا دَفَعْتُمْ إِلَيْهِمْ أَمْوَالَهُمْ فَأَشْهِدُوا عَلَيْهِمْ ۚ وَكَفَىٰ بِاللَّهِ حَسِيبًا",
  },
  {
    id: "500",
    sura: "4",
    VerseIDAr: "7",
    ayatAR:
      "لِلرِّجَالِ نَصِيبٌ مِمَّا تَرَكَ الْوَالِدَانِ وَالْأَقْرَبُونَ وَلِلنِّسَاءِ نَصِيبٌ مِمَّا تَرَكَ الْوَالِدَانِ وَالْأَقْرَبُونَ مِمَّا قَلَّ مِنْهُ أَوْ كَثُرَ ۚ نَصِيبًا مَفْرُوضًا",
  },
  {
    id: "501",
    sura: "4",
    VerseIDAr: "8",
    ayatAR:
      "وَإِذَا حَضَرَ الْقِسْمَةَ أُولُو الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينُ فَارْزُقُوهُمْ مِنْهُ وَقُولُوا لَهُمْ قَوْلًا مَعْرُوفًا",
  },
  {
    id: "502",
    sura: "4",
    VerseIDAr: "9",
    ayatAR:
      "وَلْيَخْشَ الَّذِينَ لَوْ تَرَكُوا مِنْ خَلْفِهِمْ ذُرِّيَّةً ضِعَافًا خَافُوا عَلَيْهِمْ فَلْيَتَّقُوا اللَّهَ وَلْيَقُولُوا قَوْلًا سَدِيدًا",
  },
  {
    id: "503",
    sura: "4",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّ الَّذِينَ يَأْكُلُونَ أَمْوَالَ الْيَتَامَىٰ ظُلْمًا إِنَّمَا يَأْكُلُونَ فِي بُطُونِهِمْ نَارًا ۖ وَسَيَصْلَوْنَ سَعِيرًا",
  },
  {
    id: "504",
    sura: "4",
    VerseIDAr: "11",
    ayatAR:
      "يُوصِيكُمُ اللَّهُ فِي أَوْلَادِكُمْ ۖ لِلذَّكَرِ مِثْلُ حَظِّ الْأُنْثَيَيْنِ ۚ فَإِنْ كُنَّ نِسَاءً فَوْقَ اثْنَتَيْنِ فَلَهُنَّ ثُلُثَا مَا تَرَكَ ۖ وَإِنْ كَانَتْ وَاحِدَةً فَلَهَا النِّصْفُ ۚ وَلِأَبَوَيْهِ لِكُلِّ وَاحِدٍ مِنْهُمَا السُّدُسُ مِمَّا تَرَكَ إِنْ كَانَ لَهُ وَلَدٌ ۚ فَإِنْ لَمْ يَكُنْ لَهُ وَلَدٌ وَوَرِثَهُ أَبَوَاهُ فَلِأُمِّهِ الثُّلُثُ ۚ فَإِنْ كَانَ لَهُ إِخْوَةٌ فَلِأُمِّهِ السُّدُسُ ۚ مِنْ بَعْدِ وَصِيَّةٍ يُوصِي بِهَا أَوْ دَيْنٍ ۗ آبَاؤُكُمْ وَأَبْنَاؤُكُمْ لَا تَدْرُونَ أَيُّهُمْ أَقْرَبُ لَكُمْ نَفْعًا ۚ فَرِيضَةً مِنَ اللَّهِ ۗ إِنَّ اللَّهَ كَانَ عَلِيمًا حَكِيمًا",
  },
  {
    id: "505",
    sura: "4",
    VerseIDAr: "12",
    ayatAR:
      "وَلَكُمْ نِصْفُ مَا تَرَكَ أَزْوَاجُكُمْ إِنْ لَمْ يَكُنْ لَهُنَّ وَلَدٌ ۚ فَإِنْ كَانَ لَهُنَّ وَلَدٌ فَلَكُمُ الرُّبُعُ مِمَّا تَرَكْنَ ۚ مِنْ بَعْدِ وَصِيَّةٍ يُوصِينَ بِهَا أَوْ دَيْنٍ ۚ وَلَهُنَّ الرُّبُعُ مِمَّا تَرَكْتُمْ إِنْ لَمْ يَكُنْ لَكُمْ وَلَدٌ ۚ فَإِنْ كَانَ لَكُمْ وَلَدٌ فَلَهُنَّ الثُّمُنُ مِمَّا تَرَكْتُمْ ۚ مِنْ بَعْدِ وَصِيَّةٍ تُوصُونَ بِهَا أَوْ دَيْنٍ ۗ وَإِنْ كَانَ رَجُلٌ يُورَثُ كَلَالَةً أَوِ امْرَأَةٌ وَلَهُ أَخٌ أَوْ أُخْتٌ فَلِكُلِّ وَاحِدٍ مِنْهُمَا السُّدُسُ ۚ فَإِنْ كَانُوا أَكْثَرَ مِنْ ذَٰلِكَ فَهُمْ شُرَكَاءُ فِي الثُّلُثِ ۚ مِنْ بَعْدِ وَصِيَّةٍ يُوصَىٰ بِهَا أَوْ دَيْنٍ غَيْرَ مُضَارٍّ ۚ وَصِيَّةً مِنَ اللَّهِ ۗ وَاللَّهُ عَلِيمٌ حَلِيمٌ",
  },
  {
    id: "506",
    sura: "4",
    VerseIDAr: "13",
    ayatAR:
      "تِلْكَ حُدُودُ اللَّهِ ۚ وَمَنْ يُطِعِ اللَّهَ وَرَسُولَهُ يُدْخِلْهُ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ وَذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "507",
    sura: "4",
    VerseIDAr: "14",
    ayatAR:
      "وَمَنْ يَعْصِ اللَّهَ وَرَسُولَهُ وَيَتَعَدَّ حُدُودَهُ يُدْخِلْهُ نَارًا خَالِدًا فِيهَا وَلَهُ عَذَابٌ مُهِينٌ",
  },
  {
    id: "508",
    sura: "4",
    VerseIDAr: "15",
    ayatAR:
      "وَاللَّاتِي يَأْتِينَ الْفَاحِشَةَ مِنْ نِسَائِكُمْ فَاسْتَشْهِدُوا عَلَيْهِنَّ أَرْبَعَةً مِنْكُمْ ۖ فَإِنْ شَهِدُوا فَأَمْسِكُوهُنَّ فِي الْبُيُوتِ حَتَّىٰ يَتَوَفَّاهُنَّ الْمَوْتُ أَوْ يَجْعَلَ اللَّهُ لَهُنَّ سَبِيلًا",
  },
  {
    id: "509",
    sura: "4",
    VerseIDAr: "16",
    ayatAR:
      "وَاللَّذَانِ يَأْتِيَانِهَا مِنْكُمْ فَآذُوهُمَا ۖ فَإِنْ تَابَا وَأَصْلَحَا فَأَعْرِضُوا عَنْهُمَا ۗ إِنَّ اللَّهَ كَانَ تَوَّابًا رَحِيمًا",
  },
  {
    id: "510",
    sura: "4",
    VerseIDAr: "17",
    ayatAR:
      "إِنَّمَا التَّوْبَةُ عَلَى اللَّهِ لِلَّذِينَ يَعْمَلُونَ السُّوءَ بِجَهَالَةٍ ثُمَّ يَتُوبُونَ مِنْ قَرِيبٍ فَأُولَٰئِكَ يَتُوبُ اللَّهُ عَلَيْهِمْ ۗ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "511",
    sura: "4",
    VerseIDAr: "18",
    ayatAR:
      "وَلَيْسَتِ التَّوْبَةُ لِلَّذِينَ يَعْمَلُونَ السَّيِّئَاتِ حَتَّىٰ إِذَا حَضَرَ أَحَدَهُمُ الْمَوْتُ قَالَ إِنِّي تُبْتُ الْآنَ وَلَا الَّذِينَ يَمُوتُونَ وَهُمْ كُفَّارٌ ۚ أُولَٰئِكَ أَعْتَدْنَا لَهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "512",
    sura: "4",
    VerseIDAr: "19",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا يَحِلُّ لَكُمْ أَنْ تَرِثُوا النِّسَاءَ كَرْهًا ۖ وَلَا تَعْضُلُوهُنَّ لِتَذْهَبُوا بِبَعْضِ مَا آتَيْتُمُوهُنَّ إِلَّا أَنْ يَأْتِينَ بِفَاحِشَةٍ مُبَيِّنَةٍ ۚ وَعَاشِرُوهُنَّ بِالْمَعْرُوفِ ۚ فَإِنْ كَرِهْتُمُوهُنَّ فَعَسَىٰ أَنْ تَكْرَهُوا شَيْئًا وَيَجْعَلَ اللَّهُ فِيهِ خَيْرًا كَثِيرًا",
  },
  {
    id: "513",
    sura: "4",
    VerseIDAr: "20",
    ayatAR:
      "وَإِنْ أَرَدْتُمُ اسْتِبْدَالَ زَوْجٍ مَكَانَ زَوْجٍ وَآتَيْتُمْ إِحْدَاهُنَّ قِنْطَارًا فَلَا تَأْخُذُوا مِنْهُ شَيْئًا ۚ أَتَأْخُذُونَهُ بُهْتَانًا وَإِثْمًا مُبِينًا",
  },
  {
    id: "514",
    sura: "4",
    VerseIDAr: "21",
    ayatAR:
      "وَكَيْفَ تَأْخُذُونَهُ وَقَدْ أَفْضَىٰ بَعْضُكُمْ إِلَىٰ بَعْضٍ وَأَخَذْنَ مِنْكُمْ مِيثَاقًا غَلِيظًا",
  },
  {
    id: "515",
    sura: "4",
    VerseIDAr: "22",
    ayatAR:
      "وَلَا تَنْكِحُوا مَا نَكَحَ آبَاؤُكُمْ مِنَ النِّسَاءِ إِلَّا مَا قَدْ سَلَفَ ۚ إِنَّهُ كَانَ فَاحِشَةً وَمَقْتًا وَسَاءَ سَبِيلًا",
  },
  {
    id: "516",
    sura: "4",
    VerseIDAr: "23",
    ayatAR:
      "حُرِّمَتْ عَلَيْكُمْ أُمَّهَاتُكُمْ وَبَنَاتُكُمْ وَأَخَوَاتُكُمْ وَعَمَّاتُكُمْ وَخَالَاتُكُمْ وَبَنَاتُ الْأَخِ وَبَنَاتُ الْأُخْتِ وَأُمَّهَاتُكُمُ اللَّاتِي أَرْضَعْنَكُمْ وَأَخَوَاتُكُمْ مِنَ الرَّضَاعَةِ وَأُمَّهَاتُ نِسَائِكُمْ وَرَبَائِبُكُمُ اللَّاتِي فِي حُجُورِكُمْ مِنْ نِسَائِكُمُ اللَّاتِي دَخَلْتُمْ بِهِنَّ فَإِنْ لَمْ تَكُونُوا دَخَلْتُمْ بِهِنَّ فَلَا جُنَاحَ عَلَيْكُمْ وَحَلَائِلُ أَبْنَائِكُمُ الَّذِينَ مِنْ أَصْلَابِكُمْ وَأَنْ تَجْمَعُوا بَيْنَ الْأُخْتَيْنِ إِلَّا مَا قَدْ سَلَفَ ۗ إِنَّ اللَّهَ كَانَ غَفُورًا رَحِيمًا",
  },
  {
    id: "517",
    sura: "4",
    VerseIDAr: "24",
    ayatAR:
      "وَالْمُحْصَنَاتُ مِنَ النِّسَاءِ إِلَّا مَا مَلَكَتْ أَيْمَانُكُمْ ۖ كِتَابَ اللَّهِ عَلَيْكُمْ ۚ وَأُحِلَّ لَكُمْ مَا وَرَاءَ ذَٰلِكُمْ أَنْ تَبْتَغُوا بِأَمْوَالِكُمْ مُحْصِنِينَ غَيْرَ مُسَافِحِينَ ۚ فَمَا اسْتَمْتَعْتُمْ بِهِ مِنْهُنَّ فَآتُوهُنَّ أُجُورَهُنَّ فَرِيضَةً ۚ وَلَا جُنَاحَ عَلَيْكُمْ فِيمَا تَرَاضَيْتُمْ بِهِ مِنْ بَعْدِ الْفَرِيضَةِ ۚ إِنَّ اللَّهَ كَانَ عَلِيمًا حَكِيمًا",
  },
  {
    id: "518",
    sura: "4",
    VerseIDAr: "25",
    ayatAR:
      "وَمَنْ لَمْ يَسْتَطِعْ مِنْكُمْ طَوْلًا أَنْ يَنْكِحَ الْمُحْصَنَاتِ الْمُؤْمِنَاتِ فَمِنْ مَا مَلَكَتْ أَيْمَانُكُمْ مِنْ فَتَيَاتِكُمُ الْمُؤْمِنَاتِ ۚ وَاللَّهُ أَعْلَمُ بِإِيمَانِكُمْ ۚ بَعْضُكُمْ مِنْ بَعْضٍ ۚ فَانْكِحُوهُنَّ بِإِذْنِ أَهْلِهِنَّ وَآتُوهُنَّ أُجُورَهُنَّ بِالْمَعْرُوفِ مُحْصَنَاتٍ غَيْرَ مُسَافِحَاتٍ وَلَا مُتَّخِذَاتِ أَخْدَانٍ ۚ فَإِذَا أُحْصِنَّ فَإِنْ أَتَيْنَ بِفَاحِشَةٍ فَعَلَيْهِنَّ نِصْفُ مَا عَلَى الْمُحْصَنَاتِ مِنَ الْعَذَابِ ۚ ذَٰلِكَ لِمَنْ خَشِيَ الْعَنَتَ مِنْكُمْ ۚ وَأَنْ تَصْبِرُوا خَيْرٌ لَكُمْ ۗ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "519",
    sura: "4",
    VerseIDAr: "26",
    ayatAR:
      "يُرِيدُ اللَّهُ لِيُبَيِّنَ لَكُمْ وَيَهْدِيَكُمْ سُنَنَ الَّذِينَ مِنْ قَبْلِكُمْ وَيَتُوبَ عَلَيْكُمْ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "520",
    sura: "4",
    VerseIDAr: "27",
    ayatAR:
      "وَاللَّهُ يُرِيدُ أَنْ يَتُوبَ عَلَيْكُمْ وَيُرِيدُ الَّذِينَ يَتَّبِعُونَ الشَّهَوَاتِ أَنْ تَمِيلُوا مَيْلًا عَظِيمًا",
  },
  {
    id: "521",
    sura: "4",
    VerseIDAr: "28",
    ayatAR:
      "يُرِيدُ اللَّهُ أَنْ يُخَفِّفَ عَنْكُمْ ۚ وَخُلِقَ الْإِنْسَانُ ضَعِيفًا",
  },
  {
    id: "522",
    sura: "4",
    VerseIDAr: "29",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَأْكُلُوا أَمْوَالَكُمْ بَيْنَكُمْ بِالْبَاطِلِ إِلَّا أَنْ تَكُونَ تِجَارَةً عَنْ تَرَاضٍ مِنْكُمْ ۚ وَلَا تَقْتُلُوا أَنْفُسَكُمْ ۚ إِنَّ اللَّهَ كَانَ بِكُمْ رَحِيمًا",
  },
  {
    id: "523",
    sura: "4",
    VerseIDAr: "30",
    ayatAR:
      "وَمَنْ يَفْعَلْ ذَٰلِكَ عُدْوَانًا وَظُلْمًا فَسَوْفَ نُصْلِيهِ نَارًا ۚ وَكَانَ ذَٰلِكَ عَلَى اللَّهِ يَسِيرًا",
  },
  {
    id: "524",
    sura: "4",
    VerseIDAr: "31",
    ayatAR:
      "إِنْ تَجْتَنِبُوا كَبَائِرَ مَا تُنْهَوْنَ عَنْهُ نُكَفِّرْ عَنْكُمْ سَيِّئَاتِكُمْ وَنُدْخِلْكُمْ مُدْخَلًا كَرِيمًا",
  },
  {
    id: "525",
    sura: "4",
    VerseIDAr: "32",
    ayatAR:
      "وَلَا تَتَمَنَّوْا مَا فَضَّلَ اللَّهُ بِهِ بَعْضَكُمْ عَلَىٰ بَعْضٍ ۚ لِلرِّجَالِ نَصِيبٌ مِمَّا اكْتَسَبُوا ۖ وَلِلنِّسَاءِ نَصِيبٌ مِمَّا اكْتَسَبْنَ ۚ وَاسْأَلُوا اللَّهَ مِنْ فَضْلِهِ ۗ إِنَّ اللَّهَ كَانَ بِكُلِّ شَيْءٍ عَلِيمًا",
  },
  {
    id: "526",
    sura: "4",
    VerseIDAr: "33",
    ayatAR:
      "وَلِكُلٍّ جَعَلْنَا مَوَالِيَ مِمَّا تَرَكَ الْوَالِدَانِ وَالْأَقْرَبُونَ ۚ وَالَّذِينَ عَقَدَتْ أَيْمَانُكُمْ فَآتُوهُمْ نَصِيبَهُمْ ۚ إِنَّ اللَّهَ كَانَ عَلَىٰ كُلِّ شَيْءٍ شَهِيدًا",
  },
  {
    id: "527",
    sura: "4",
    VerseIDAr: "34",
    ayatAR:
      "الرِّجَالُ قَوَّامُونَ عَلَى النِّسَاءِ بِمَا فَضَّلَ اللَّهُ بَعْضَهُمْ عَلَىٰ بَعْضٍ وَبِمَا أَنْفَقُوا مِنْ أَمْوَالِهِمْ ۚ فَالصَّالِحَاتُ قَانِتَاتٌ حَافِظَاتٌ لِلْغَيْبِ بِمَا حَفِظَ اللَّهُ ۚ وَاللَّاتِي تَخَافُونَ نُشُوزَهُنَّ فَعِظُوهُنَّ وَاهْجُرُوهُنَّ فِي الْمَضَاجِعِ وَاضْرِبُوهُنَّ ۖ فَإِنْ أَطَعْنَكُمْ فَلَا تَبْغُوا عَلَيْهِنَّ سَبِيلًا ۗ إِنَّ اللَّهَ كَانَ عَلِيًّا كَبِيرًا",
  },
  {
    id: "528",
    sura: "4",
    VerseIDAr: "35",
    ayatAR:
      "وَإِنْ خِفْتُمْ شِقَاقَ بَيْنِهِمَا فَابْعَثُوا حَكَمًا مِنْ أَهْلِهِ وَحَكَمًا مِنْ أَهْلِهَا إِنْ يُرِيدَا إِصْلَاحًا يُوَفِّقِ اللَّهُ بَيْنَهُمَا ۗ إِنَّ اللَّهَ كَانَ عَلِيمًا خَبِيرًا",
  },
  {
    id: "529",
    sura: "4",
    VerseIDAr: "36",
    ayatAR:
      "وَاعْبُدُوا اللَّهَ وَلَا تُشْرِكُوا بِهِ شَيْئًا ۖ وَبِالْوَالِدَيْنِ إِحْسَانًا وَبِذِي الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينِ وَالْجَارِ ذِي الْقُرْبَىٰ وَالْجَارِ الْجُنُبِ وَالصَّاحِبِ بِالْجَنْبِ وَابْنِ السَّبِيلِ وَمَا مَلَكَتْ أَيْمَانُكُمْ ۗ إِنَّ اللَّهَ لَا يُحِبُّ مَنْ كَانَ مُخْتَالًا فَخُورًا",
  },
  {
    id: "530",
    sura: "4",
    VerseIDAr: "37",
    ayatAR:
      "الَّذِينَ يَبْخَلُونَ وَيَأْمُرُونَ النَّاسَ بِالْبُخْلِ وَيَكْتُمُونَ مَا آتَاهُمُ اللَّهُ مِنْ فَضْلِهِ ۗ وَأَعْتَدْنَا لِلْكَافِرِينَ عَذَابًا مُهِينًا",
  },
  {
    id: "531",
    sura: "4",
    VerseIDAr: "38",
    ayatAR:
      "وَالَّذِينَ يُنْفِقُونَ أَمْوَالَهُمْ رِئَاءَ النَّاسِ وَلَا يُؤْمِنُونَ بِاللَّهِ وَلَا بِالْيَوْمِ الْآخِرِ ۗ وَمَنْ يَكُنِ الشَّيْطَانُ لَهُ قَرِينًا فَسَاءَ قَرِينًا",
  },
  {
    id: "532",
    sura: "4",
    VerseIDAr: "39",
    ayatAR:
      "وَمَاذَا عَلَيْهِمْ لَوْ آمَنُوا بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَأَنْفَقُوا مِمَّا رَزَقَهُمُ اللَّهُ ۚ وَكَانَ اللَّهُ بِهِمْ عَلِيمًا",
  },
  {
    id: "533",
    sura: "4",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَظْلِمُ مِثْقَالَ ذَرَّةٍ ۖ وَإِنْ تَكُ حَسَنَةً يُضَاعِفْهَا وَيُؤْتِ مِنْ لَدُنْهُ أَجْرًا عَظِيمًا",
  },
  {
    id: "534",
    sura: "4",
    VerseIDAr: "41",
    ayatAR:
      "فَكَيْفَ إِذَا جِئْنَا مِنْ كُلِّ أُمَّةٍ بِشَهِيدٍ وَجِئْنَا بِكَ عَلَىٰ هَٰؤُلَاءِ شَهِيدًا",
  },
  {
    id: "535",
    sura: "4",
    VerseIDAr: "42",
    ayatAR:
      "يَوْمَئِذٍ يَوَدُّ الَّذِينَ كَفَرُوا وَعَصَوُا الرَّسُولَ لَوْ تُسَوَّىٰ بِهِمُ الْأَرْضُ وَلَا يَكْتُمُونَ اللَّهَ حَدِيثًا",
  },
  {
    id: "536",
    sura: "4",
    VerseIDAr: "43",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَقْرَبُوا الصَّلَاةَ وَأَنْتُمْ سُكَارَىٰ حَتَّىٰ تَعْلَمُوا مَا تَقُولُونَ وَلَا جُنُبًا إِلَّا عَابِرِي سَبِيلٍ حَتَّىٰ تَغْتَسِلُوا ۚ وَإِنْ كُنْتُمْ مَرْضَىٰ أَوْ عَلَىٰ سَفَرٍ أَوْ جَاءَ أَحَدٌ مِنْكُمْ مِنَ الْغَائِطِ أَوْ لَامَسْتُمُ النِّسَاءَ فَلَمْ تَجِدُوا مَاءً فَتَيَمَّمُوا صَعِيدًا طَيِّبًا فَامْسَحُوا بِوُجُوهِكُمْ وَأَيْدِيكُمْ ۗ إِنَّ اللَّهَ كَانَ عَفُوًّا غَفُورًا",
  },
  {
    id: "537",
    sura: "4",
    VerseIDAr: "44",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ أُوتُوا نَصِيبًا مِنَ الْكِتَابِ يَشْتَرُونَ الضَّلَالَةَ وَيُرِيدُونَ أَنْ تَضِلُّوا السَّبِيلَ",
  },
  {
    id: "538",
    sura: "4",
    VerseIDAr: "45",
    ayatAR:
      "وَاللَّهُ أَعْلَمُ بِأَعْدَائِكُمْ ۚ وَكَفَىٰ بِاللَّهِ وَلِيًّا وَكَفَىٰ بِاللَّهِ نَصِيرًا",
  },
  {
    id: "539",
    sura: "4",
    VerseIDAr: "46",
    ayatAR:
      "مِنَ الَّذِينَ هَادُوا يُحَرِّفُونَ الْكَلِمَ عَنْ مَوَاضِعِهِ وَيَقُولُونَ سَمِعْنَا وَعَصَيْنَا وَاسْمَعْ غَيْرَ مُسْمَعٍ وَرَاعِنَا لَيًّا بِأَلْسِنَتِهِمْ وَطَعْنًا فِي الدِّينِ ۚ وَلَوْ أَنَّهُمْ قَالُوا سَمِعْنَا وَأَطَعْنَا وَاسْمَعْ وَانْظُرْنَا لَكَانَ خَيْرًا لَهُمْ وَأَقْوَمَ وَلَٰكِنْ لَعَنَهُمُ اللَّهُ بِكُفْرِهِمْ فَلَا يُؤْمِنُونَ إِلَّا قَلِيلًا",
  },
  {
    id: "540",
    sura: "4",
    VerseIDAr: "47",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ أُوتُوا الْكِتَابَ آمِنُوا بِمَا نَزَّلْنَا مُصَدِّقًا لِمَا مَعَكُمْ مِنْ قَبْلِ أَنْ نَطْمِسَ وُجُوهًا فَنَرُدَّهَا عَلَىٰ أَدْبَارِهَا أَوْ نَلْعَنَهُمْ كَمَا لَعَنَّا أَصْحَابَ السَّبْتِ ۚ وَكَانَ أَمْرُ اللَّهِ مَفْعُولًا",
  },
  {
    id: "541",
    sura: "4",
    VerseIDAr: "48",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَغْفِرُ أَنْ يُشْرَكَ بِهِ وَيَغْفِرُ مَا دُونَ ذَٰلِكَ لِمَنْ يَشَاءُ ۚ وَمَنْ يُشْرِكْ بِاللَّهِ فَقَدِ افْتَرَىٰ إِثْمًا عَظِيمًا",
  },
  {
    id: "542",
    sura: "4",
    VerseIDAr: "49",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ يُزَكُّونَ أَنْفُسَهُمْ ۚ بَلِ اللَّهُ يُزَكِّي مَنْ يَشَاءُ وَلَا يُظْلَمُونَ فَتِيلًا",
  },
  {
    id: "543",
    sura: "4",
    VerseIDAr: "50",
    ayatAR:
      "انْظُرْ كَيْفَ يَفْتَرُونَ عَلَى اللَّهِ الْكَذِبَ ۖ وَكَفَىٰ بِهِ إِثْمًا مُبِينًا",
  },
  {
    id: "544",
    sura: "4",
    VerseIDAr: "51",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ أُوتُوا نَصِيبًا مِنَ الْكِتَابِ يُؤْمِنُونَ بِالْجِبْتِ وَالطَّاغُوتِ وَيَقُولُونَ لِلَّذِينَ كَفَرُوا هَٰؤُلَاءِ أَهْدَىٰ مِنَ الَّذِينَ آمَنُوا سَبِيلًا",
  },
  {
    id: "545",
    sura: "4",
    VerseIDAr: "52",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ لَعَنَهُمُ اللَّهُ ۖ وَمَنْ يَلْعَنِ اللَّهُ فَلَنْ تَجِدَ لَهُ نَصِيرًا",
  },
  {
    id: "546",
    sura: "4",
    VerseIDAr: "53",
    ayatAR:
      "أَمْ لَهُمْ نَصِيبٌ مِنَ الْمُلْكِ فَإِذًا لَا يُؤْتُونَ النَّاسَ نَقِيرًا",
  },
  {
    id: "547",
    sura: "4",
    VerseIDAr: "54",
    ayatAR:
      "أَمْ يَحْسُدُونَ النَّاسَ عَلَىٰ مَا آتَاهُمُ اللَّهُ مِنْ فَضْلِهِ ۖ فَقَدْ آتَيْنَا آلَ إِبْرَاهِيمَ الْكِتَابَ وَالْحِكْمَةَ وَآتَيْنَاهُمْ مُلْكًا عَظِيمًا",
  },
  {
    id: "548",
    sura: "4",
    VerseIDAr: "55",
    ayatAR:
      "فَمِنْهُمْ مَنْ آمَنَ بِهِ وَمِنْهُمْ مَنْ صَدَّ عَنْهُ ۚ وَكَفَىٰ بِجَهَنَّمَ سَعِيرًا",
  },
  {
    id: "549",
    sura: "4",
    VerseIDAr: "56",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا بِآيَاتِنَا سَوْفَ نُصْلِيهِمْ نَارًا كُلَّمَا نَضِجَتْ جُلُودُهُمْ بَدَّلْنَاهُمْ جُلُودًا غَيْرَهَا لِيَذُوقُوا الْعَذَابَ ۗ إِنَّ اللَّهَ كَانَ عَزِيزًا حَكِيمًا",
  },
  {
    id: "550",
    sura: "4",
    VerseIDAr: "57",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ سَنُدْخِلُهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۖ لَهُمْ فِيهَا أَزْوَاجٌ مُطَهَّرَةٌ ۖ وَنُدْخِلُهُمْ ظِلًّا ظَلِيلًا",
  },
  {
    id: "551",
    sura: "4",
    VerseIDAr: "58",
    ayatAR:
      "إِنَّ اللَّهَ يَأْمُرُكُمْ أَنْ تُؤَدُّوا الْأَمَانَاتِ إِلَىٰ أَهْلِهَا وَإِذَا حَكَمْتُمْ بَيْنَ النَّاسِ أَنْ تَحْكُمُوا بِالْعَدْلِ ۚ إِنَّ اللَّهَ نِعِمَّا يَعِظُكُمْ بِهِ ۗ إِنَّ اللَّهَ كَانَ سَمِيعًا بَصِيرًا",
  },
  {
    id: "552",
    sura: "4",
    VerseIDAr: "59",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا أَطِيعُوا اللَّهَ وَأَطِيعُوا الرَّسُولَ وَأُولِي الْأَمْرِ مِنْكُمْ ۖ فَإِنْ تَنَازَعْتُمْ فِي شَيْءٍ فَرُدُّوهُ إِلَى اللَّهِ وَالرَّسُولِ إِنْ كُنْتُمْ تُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۚ ذَٰلِكَ خَيْرٌ وَأَحْسَنُ تَأْوِيلًا",
  },
  {
    id: "553",
    sura: "4",
    VerseIDAr: "60",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ يَزْعُمُونَ أَنَّهُمْ آمَنُوا بِمَا أُنْزِلَ إِلَيْكَ وَمَا أُنْزِلَ مِنْ قَبْلِكَ يُرِيدُونَ أَنْ يَتَحَاكَمُوا إِلَى الطَّاغُوتِ وَقَدْ أُمِرُوا أَنْ يَكْفُرُوا بِهِ وَيُرِيدُ الشَّيْطَانُ أَنْ يُضِلَّهُمْ ضَلَالًا بَعِيدًا",
  },
  {
    id: "554",
    sura: "4",
    VerseIDAr: "61",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ تَعَالَوْا إِلَىٰ مَا أَنْزَلَ اللَّهُ وَإِلَى الرَّسُولِ رَأَيْتَ الْمُنَافِقِينَ يَصُدُّونَ عَنْكَ صُدُودًا",
  },
  {
    id: "555",
    sura: "4",
    VerseIDAr: "62",
    ayatAR:
      "فَكَيْفَ إِذَا أَصَابَتْهُمْ مُصِيبَةٌ بِمَا قَدَّمَتْ أَيْدِيهِمْ ثُمَّ جَاءُوكَ يَحْلِفُونَ بِاللَّهِ إِنْ أَرَدْنَا إِلَّا إِحْسَانًا وَتَوْفِيقًا",
  },
  {
    id: "556",
    sura: "4",
    VerseIDAr: "63",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ يَعْلَمُ اللَّهُ مَا فِي قُلُوبِهِمْ فَأَعْرِضْ عَنْهُمْ وَعِظْهُمْ وَقُلْ لَهُمْ فِي أَنْفُسِهِمْ قَوْلًا بَلِيغًا",
  },
  {
    id: "557",
    sura: "4",
    VerseIDAr: "64",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ رَسُولٍ إِلَّا لِيُطَاعَ بِإِذْنِ اللَّهِ ۚ وَلَوْ أَنَّهُمْ إِذْ ظَلَمُوا أَنْفُسَهُمْ جَاءُوكَ فَاسْتَغْفَرُوا اللَّهَ وَاسْتَغْفَرَ لَهُمُ الرَّسُولُ لَوَجَدُوا اللَّهَ تَوَّابًا رَحِيمًا",
  },
  {
    id: "558",
    sura: "4",
    VerseIDAr: "65",
    ayatAR:
      "فَلَا وَرَبِّكَ لَا يُؤْمِنُونَ حَتَّىٰ يُحَكِّمُوكَ فِيمَا شَجَرَ بَيْنَهُمْ ثُمَّ لَا يَجِدُوا فِي أَنْفُسِهِمْ حَرَجًا مِمَّا قَضَيْتَ وَيُسَلِّمُوا تَسْلِيمًا",
  },
  {
    id: "559",
    sura: "4",
    VerseIDAr: "66",
    ayatAR:
      "وَلَوْ أَنَّا كَتَبْنَا عَلَيْهِمْ أَنِ اقْتُلُوا أَنْفُسَكُمْ أَوِ اخْرُجُوا مِنْ دِيَارِكُمْ مَا فَعَلُوهُ إِلَّا قَلِيلٌ مِنْهُمْ ۖ وَلَوْ أَنَّهُمْ فَعَلُوا مَا يُوعَظُونَ بِهِ لَكَانَ خَيْرًا لَهُمْ وَأَشَدَّ تَثْبِيتًا",
  },
  {
    id: "560",
    sura: "4",
    VerseIDAr: "67",
    ayatAR: "وَإِذًا لَآتَيْنَاهُمْ مِنْ لَدُنَّا أَجْرًا عَظِيمًا",
  },
  {
    id: "561",
    sura: "4",
    VerseIDAr: "68",
    ayatAR: "وَلَهَدَيْنَاهُمْ صِرَاطًا مُسْتَقِيمًا",
  },
  {
    id: "562",
    sura: "4",
    VerseIDAr: "69",
    ayatAR:
      "وَمَنْ يُطِعِ اللَّهَ وَالرَّسُولَ فَأُولَٰئِكَ مَعَ الَّذِينَ أَنْعَمَ اللَّهُ عَلَيْهِمْ مِنَ النَّبِيِّينَ وَالصِّدِّيقِينَ وَالشُّهَدَاءِ وَالصَّالِحِينَ ۚ وَحَسُنَ أُولَٰئِكَ رَفِيقًا",
  },
  {
    id: "563",
    sura: "4",
    VerseIDAr: "70",
    ayatAR: "ذَٰلِكَ الْفَضْلُ مِنَ اللَّهِ ۚ وَكَفَىٰ بِاللَّهِ عَلِيمًا",
  },
  {
    id: "564",
    sura: "4",
    VerseIDAr: "71",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا خُذُوا حِذْرَكُمْ فَانْفِرُوا ثُبَاتٍ أَوِ انْفِرُوا جَمِيعًا",
  },
  {
    id: "565",
    sura: "4",
    VerseIDAr: "72",
    ayatAR:
      "وَإِنَّ مِنْكُمْ لَمَنْ لَيُبَطِّئَنَّ فَإِنْ أَصَابَتْكُمْ مُصِيبَةٌ قَالَ قَدْ أَنْعَمَ اللَّهُ عَلَيَّ إِذْ لَمْ أَكُنْ مَعَهُمْ شَهِيدًا",
  },
  {
    id: "566",
    sura: "4",
    VerseIDAr: "73",
    ayatAR:
      "وَلَئِنْ أَصَابَكُمْ فَضْلٌ مِنَ اللَّهِ لَيَقُولَنَّ كَأَنْ لَمْ تَكُنْ بَيْنَكُمْ وَبَيْنَهُ مَوَدَّةٌ يَا لَيْتَنِي كُنْتُ مَعَهُمْ فَأَفُوزَ فَوْزًا عَظِيمًا",
  },
  {
    id: "567",
    sura: "4",
    VerseIDAr: "74",
    ayatAR:
      "فَلْيُقَاتِلْ فِي سَبِيلِ اللَّهِ الَّذِينَ يَشْرُونَ الْحَيَاةَ الدُّنْيَا بِالْآخِرَةِ ۚ وَمَنْ يُقَاتِلْ فِي سَبِيلِ اللَّهِ فَيُقْتَلْ أَوْ يَغْلِبْ فَسَوْفَ نُؤْتِيهِ أَجْرًا عَظِيمًا",
  },
  {
    id: "568",
    sura: "4",
    VerseIDAr: "75",
    ayatAR:
      "وَمَا لَكُمْ لَا تُقَاتِلُونَ فِي سَبِيلِ اللَّهِ وَالْمُسْتَضْعَفِينَ مِنَ الرِّجَالِ وَالنِّسَاءِ وَالْوِلْدَانِ الَّذِينَ يَقُولُونَ رَبَّنَا أَخْرِجْنَا مِنْ هَٰذِهِ الْقَرْيَةِ الظَّالِمِ أَهْلُهَا وَاجْعَلْ لَنَا مِنْ لَدُنْكَ وَلِيًّا وَاجْعَلْ لَنَا مِنْ لَدُنْكَ نَصِيرًا",
  },
  {
    id: "569",
    sura: "4",
    VerseIDAr: "76",
    ayatAR:
      "الَّذِينَ آمَنُوا يُقَاتِلُونَ فِي سَبِيلِ اللَّهِ ۖ وَالَّذِينَ كَفَرُوا يُقَاتِلُونَ فِي سَبِيلِ الطَّاغُوتِ فَقَاتِلُوا أَوْلِيَاءَ الشَّيْطَانِ ۖ إِنَّ كَيْدَ الشَّيْطَانِ كَانَ ضَعِيفًا",
  },
  {
    id: "570",
    sura: "4",
    VerseIDAr: "77",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ قِيلَ لَهُمْ كُفُّوا أَيْدِيَكُمْ وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ فَلَمَّا كُتِبَ عَلَيْهِمُ الْقِتَالُ إِذَا فَرِيقٌ مِنْهُمْ يَخْشَوْنَ النَّاسَ كَخَشْيَةِ اللَّهِ أَوْ أَشَدَّ خَشْيَةً ۚ وَقَالُوا رَبَّنَا لِمَ كَتَبْتَ عَلَيْنَا الْقِتَالَ لَوْلَا أَخَّرْتَنَا إِلَىٰ أَجَلٍ قَرِيبٍ ۗ قُلْ مَتَاعُ الدُّنْيَا قَلِيلٌ وَالْآخِرَةُ خَيْرٌ لِمَنِ اتَّقَىٰ وَلَا تُظْلَمُونَ فَتِيلًا",
  },
  {
    id: "571",
    sura: "4",
    VerseIDAr: "78",
    ayatAR:
      "أَيْنَمَا تَكُونُوا يُدْرِكْكُمُ الْمَوْتُ وَلَوْ كُنْتُمْ فِي بُرُوجٍ مُشَيَّدَةٍ ۗ وَإِنْ تُصِبْهُمْ حَسَنَةٌ يَقُولُوا هَٰذِهِ مِنْ عِنْدِ اللَّهِ ۖ وَإِنْ تُصِبْهُمْ سَيِّئَةٌ يَقُولُوا هَٰذِهِ مِنْ عِنْدِكَ ۚ قُلْ كُلٌّ مِنْ عِنْدِ اللَّهِ ۖ فَمَالِ هَٰؤُلَاءِ الْقَوْمِ لَا يَكَادُونَ يَفْقَهُونَ حَدِيثًا",
  },
  {
    id: "572",
    sura: "4",
    VerseIDAr: "79",
    ayatAR:
      "مَا أَصَابَكَ مِنْ حَسَنَةٍ فَمِنَ اللَّهِ ۖ وَمَا أَصَابَكَ مِنْ سَيِّئَةٍ فَمِنْ نَفْسِكَ ۚ وَأَرْسَلْنَاكَ لِلنَّاسِ رَسُولًا ۚ وَكَفَىٰ بِاللَّهِ شَهِيدًا",
  },
  {
    id: "573",
    sura: "4",
    VerseIDAr: "80",
    ayatAR:
      "مَنْ يُطِعِ الرَّسُولَ فَقَدْ أَطَاعَ اللَّهَ ۖ وَمَنْ تَوَلَّىٰ فَمَا أَرْسَلْنَاكَ عَلَيْهِمْ حَفِيظًا",
  },
  {
    id: "574",
    sura: "4",
    VerseIDAr: "81",
    ayatAR:
      "وَيَقُولُونَ طَاعَةٌ فَإِذَا بَرَزُوا مِنْ عِنْدِكَ بَيَّتَ طَائِفَةٌ مِنْهُمْ غَيْرَ الَّذِي تَقُولُ ۖ وَاللَّهُ يَكْتُبُ مَا يُبَيِّتُونَ ۖ فَأَعْرِضْ عَنْهُمْ وَتَوَكَّلْ عَلَى اللَّهِ ۚ وَكَفَىٰ بِاللَّهِ وَكِيلًا",
  },
  {
    id: "575",
    sura: "4",
    VerseIDAr: "82",
    ayatAR:
      "أَفَلَا يَتَدَبَّرُونَ الْقُرْآنَ ۚ وَلَوْ كَانَ مِنْ عِنْدِ غَيْرِ اللَّهِ لَوَجَدُوا فِيهِ اخْتِلَافًا كَثِيرًا",
  },
  {
    id: "576",
    sura: "4",
    VerseIDAr: "83",
    ayatAR:
      "وَإِذَا جَاءَهُمْ أَمْرٌ مِنَ الْأَمْنِ أَوِ الْخَوْفِ أَذَاعُوا بِهِ ۖ وَلَوْ رَدُّوهُ إِلَى الرَّسُولِ وَإِلَىٰ أُولِي الْأَمْرِ مِنْهُمْ لَعَلِمَهُ الَّذِينَ يَسْتَنْبِطُونَهُ مِنْهُمْ ۗ وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ لَاتَّبَعْتُمُ الشَّيْطَانَ إِلَّا قَلِيلًا",
  },
  {
    id: "577",
    sura: "4",
    VerseIDAr: "84",
    ayatAR:
      "فَقَاتِلْ فِي سَبِيلِ اللَّهِ لَا تُكَلَّفُ إِلَّا نَفْسَكَ ۚ وَحَرِّضِ الْمُؤْمِنِينَ ۖ عَسَى اللَّهُ أَنْ يَكُفَّ بَأْسَ الَّذِينَ كَفَرُوا ۚ وَاللَّهُ أَشَدُّ بَأْسًا وَأَشَدُّ تَنْكِيلًا",
  },
  {
    id: "578",
    sura: "4",
    VerseIDAr: "85",
    ayatAR:
      "مَنْ يَشْفَعْ شَفَاعَةً حَسَنَةً يَكُنْ لَهُ نَصِيبٌ مِنْهَا ۖ وَمَنْ يَشْفَعْ شَفَاعَةً سَيِّئَةً يَكُنْ لَهُ كِفْلٌ مِنْهَا ۗ وَكَانَ اللَّهُ عَلَىٰ كُلِّ شَيْءٍ مُقِيتًا",
  },
  {
    id: "579",
    sura: "4",
    VerseIDAr: "86",
    ayatAR:
      "وَإِذَا حُيِّيتُمْ بِتَحِيَّةٍ فَحَيُّوا بِأَحْسَنَ مِنْهَا أَوْ رُدُّوهَا ۗ إِنَّ اللَّهَ كَانَ عَلَىٰ كُلِّ شَيْءٍ حَسِيبًا",
  },
  {
    id: "580",
    sura: "4",
    VerseIDAr: "87",
    ayatAR:
      "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ ۚ لَيَجْمَعَنَّكُمْ إِلَىٰ يَوْمِ الْقِيَامَةِ لَا رَيْبَ فِيهِ ۗ وَمَنْ أَصْدَقُ مِنَ اللَّهِ حَدِيثًا",
  },
  {
    id: "581",
    sura: "4",
    VerseIDAr: "88",
    ayatAR:
      "فَمَا لَكُمْ فِي الْمُنَافِقِينَ فِئَتَيْنِ وَاللَّهُ أَرْكَسَهُمْ بِمَا كَسَبُوا ۚ أَتُرِيدُونَ أَنْ تَهْدُوا مَنْ أَضَلَّ اللَّهُ ۖ وَمَنْ يُضْلِلِ اللَّهُ فَلَنْ تَجِدَ لَهُ سَبِيلًا",
  },
  {
    id: "582",
    sura: "4",
    VerseIDAr: "89",
    ayatAR:
      "وَدُّوا لَوْ تَكْفُرُونَ كَمَا كَفَرُوا فَتَكُونُونَ سَوَاءً ۖ فَلَا تَتَّخِذُوا مِنْهُمْ أَوْلِيَاءَ حَتَّىٰ يُهَاجِرُوا فِي سَبِيلِ اللَّهِ ۚ فَإِنْ تَوَلَّوْا فَخُذُوهُمْ وَاقْتُلُوهُمْ حَيْثُ وَجَدْتُمُوهُمْ ۖ وَلَا تَتَّخِذُوا مِنْهُمْ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "583",
    sura: "4",
    VerseIDAr: "90",
    ayatAR:
      "إِلَّا الَّذِينَ يَصِلُونَ إِلَىٰ قَوْمٍ بَيْنَكُمْ وَبَيْنَهُمْ مِيثَاقٌ أَوْ جَاءُوكُمْ حَصِرَتْ صُدُورُهُمْ أَنْ يُقَاتِلُوكُمْ أَوْ يُقَاتِلُوا قَوْمَهُمْ ۚ وَلَوْ شَاءَ اللَّهُ لَسَلَّطَهُمْ عَلَيْكُمْ فَلَقَاتَلُوكُمْ ۚ فَإِنِ اعْتَزَلُوكُمْ فَلَمْ يُقَاتِلُوكُمْ وَأَلْقَوْا إِلَيْكُمُ السَّلَمَ فَمَا جَعَلَ اللَّهُ لَكُمْ عَلَيْهِمْ سَبِيلًا",
  },
  {
    id: "584",
    sura: "4",
    VerseIDAr: "91",
    ayatAR:
      "سَتَجِدُونَ آخَرِينَ يُرِيدُونَ أَنْ يَأْمَنُوكُمْ وَيَأْمَنُوا قَوْمَهُمْ كُلَّ مَا رُدُّوا إِلَى الْفِتْنَةِ أُرْكِسُوا فِيهَا ۚ فَإِنْ لَمْ يَعْتَزِلُوكُمْ وَيُلْقُوا إِلَيْكُمُ السَّلَمَ وَيَكُفُّوا أَيْدِيَهُمْ فَخُذُوهُمْ وَاقْتُلُوهُمْ حَيْثُ ثَقِفْتُمُوهُمْ ۚ وَأُولَٰئِكُمْ جَعَلْنَا لَكُمْ عَلَيْهِمْ سُلْطَانًا مُبِينًا",
  },
  {
    id: "585",
    sura: "4",
    VerseIDAr: "92",
    ayatAR:
      "وَمَا كَانَ لِمُؤْمِنٍ أَنْ يَقْتُلَ مُؤْمِنًا إِلَّا خَطَأً ۚ وَمَنْ قَتَلَ مُؤْمِنًا خَطَأً فَتَحْرِيرُ رَقَبَةٍ مُؤْمِنَةٍ وَدِيَةٌ مُسَلَّمَةٌ إِلَىٰ أَهْلِهِ إِلَّا أَنْ يَصَّدَّقُوا ۚ فَإِنْ كَانَ مِنْ قَوْمٍ عَدُوٍّ لَكُمْ وَهُوَ مُؤْمِنٌ فَتَحْرِيرُ رَقَبَةٍ مُؤْمِنَةٍ ۖ وَإِنْ كَانَ مِنْ قَوْمٍ بَيْنَكُمْ وَبَيْنَهُمْ مِيثَاقٌ فَدِيَةٌ مُسَلَّمَةٌ إِلَىٰ أَهْلِهِ وَتَحْرِيرُ رَقَبَةٍ مُؤْمِنَةٍ ۖ فَمَنْ لَمْ يَجِدْ فَصِيَامُ شَهْرَيْنِ مُتَتَابِعَيْنِ تَوْبَةً مِنَ اللَّهِ ۗ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "586",
    sura: "4",
    VerseIDAr: "93",
    ayatAR:
      "وَمَنْ يَقْتُلْ مُؤْمِنًا مُتَعَمِّدًا فَجَزَاؤُهُ جَهَنَّمُ خَالِدًا فِيهَا وَغَضِبَ اللَّهُ عَلَيْهِ وَلَعَنَهُ وَأَعَدَّ لَهُ عَذَابًا عَظِيمًا",
  },
  {
    id: "587",
    sura: "4",
    VerseIDAr: "94",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا ضَرَبْتُمْ فِي سَبِيلِ اللَّهِ فَتَبَيَّنُوا وَلَا تَقُولُوا لِمَنْ أَلْقَىٰ إِلَيْكُمُ السَّلَامَ لَسْتَ مُؤْمِنًا تَبْتَغُونَ عَرَضَ الْحَيَاةِ الدُّنْيَا فَعِنْدَ اللَّهِ مَغَانِمُ كَثِيرَةٌ ۚ كَذَٰلِكَ كُنْتُمْ مِنْ قَبْلُ فَمَنَّ اللَّهُ عَلَيْكُمْ فَتَبَيَّنُوا ۚ إِنَّ اللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًا",
  },
  {
    id: "588",
    sura: "4",
    VerseIDAr: "95",
    ayatAR:
      "لَا يَسْتَوِي الْقَاعِدُونَ مِنَ الْمُؤْمِنِينَ غَيْرُ أُولِي الضَّرَرِ وَالْمُجَاهِدُونَ فِي سَبِيلِ اللَّهِ بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ ۚ فَضَّلَ اللَّهُ الْمُجَاهِدِينَ بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ عَلَى الْقَاعِدِينَ دَرَجَةً ۚ وَكُلًّا وَعَدَ اللَّهُ الْحُسْنَىٰ ۚ وَفَضَّلَ اللَّهُ الْمُجَاهِدِينَ عَلَى الْقَاعِدِينَ أَجْرًا عَظِيمًا",
  },
  {
    id: "589",
    sura: "4",
    VerseIDAr: "96",
    ayatAR:
      "دَرَجَاتٍ مِنْهُ وَمَغْفِرَةً وَرَحْمَةً ۚ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "590",
    sura: "4",
    VerseIDAr: "97",
    ayatAR:
      "إِنَّ الَّذِينَ تَوَفَّاهُمُ الْمَلَائِكَةُ ظَالِمِي أَنْفُسِهِمْ قَالُوا فِيمَ كُنْتُمْ ۖ قَالُوا كُنَّا مُسْتَضْعَفِينَ فِي الْأَرْضِ ۚ قَالُوا أَلَمْ تَكُنْ أَرْضُ اللَّهِ وَاسِعَةً فَتُهَاجِرُوا فِيهَا ۚ فَأُولَٰئِكَ مَأْوَاهُمْ جَهَنَّمُ ۖ وَسَاءَتْ مَصِيرًا",
  },
  {
    id: "591",
    sura: "4",
    VerseIDAr: "98",
    ayatAR:
      "إِلَّا الْمُسْتَضْعَفِينَ مِنَ الرِّجَالِ وَالنِّسَاءِ وَالْوِلْدَانِ لَا يَسْتَطِيعُونَ حِيلَةً وَلَا يَهْتَدُونَ سَبِيلًا",
  },
  {
    id: "592",
    sura: "4",
    VerseIDAr: "99",
    ayatAR:
      "فَأُولَٰئِكَ عَسَى اللَّهُ أَنْ يَعْفُوَ عَنْهُمْ ۚ وَكَانَ اللَّهُ عَفُوًّا غَفُورًا",
  },
  {
    id: "593",
    sura: "4",
    VerseIDAr: "100",
    ayatAR:
      "وَمَنْ يُهَاجِرْ فِي سَبِيلِ اللَّهِ يَجِدْ فِي الْأَرْضِ مُرَاغَمًا كَثِيرًا وَسَعَةً ۚ وَمَنْ يَخْرُجْ مِنْ بَيْتِهِ مُهَاجِرًا إِلَى اللَّهِ وَرَسُولِهِ ثُمَّ يُدْرِكْهُ الْمَوْتُ فَقَدْ وَقَعَ أَجْرُهُ عَلَى اللَّهِ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "594",
    sura: "4",
    VerseIDAr: "101",
    ayatAR:
      "وَإِذَا ضَرَبْتُمْ فِي الْأَرْضِ فَلَيْسَ عَلَيْكُمْ جُنَاحٌ أَنْ تَقْصُرُوا مِنَ الصَّلَاةِ إِنْ خِفْتُمْ أَنْ يَفْتِنَكُمُ الَّذِينَ كَفَرُوا ۚ إِنَّ الْكَافِرِينَ كَانُوا لَكُمْ عَدُوًّا مُبِينًا",
  },
  {
    id: "595",
    sura: "4",
    VerseIDAr: "102",
    ayatAR:
      "وَإِذَا كُنْتَ فِيهِمْ فَأَقَمْتَ لَهُمُ الصَّلَاةَ فَلْتَقُمْ طَائِفَةٌ مِنْهُمْ مَعَكَ وَلْيَأْخُذُوا أَسْلِحَتَهُمْ فَإِذَا سَجَدُوا فَلْيَكُونُوا مِنْ وَرَائِكُمْ وَلْتَأْتِ طَائِفَةٌ أُخْرَىٰ لَمْ يُصَلُّوا فَلْيُصَلُّوا مَعَكَ وَلْيَأْخُذُوا حِذْرَهُمْ وَأَسْلِحَتَهُمْ ۗ وَدَّ الَّذِينَ كَفَرُوا لَوْ تَغْفُلُونَ عَنْ أَسْلِحَتِكُمْ وَأَمْتِعَتِكُمْ فَيَمِيلُونَ عَلَيْكُمْ مَيْلَةً وَاحِدَةً ۚ وَلَا جُنَاحَ عَلَيْكُمْ إِنْ كَانَ بِكُمْ أَذًى مِنْ مَطَرٍ أَوْ كُنْتُمْ مَرْضَىٰ أَنْ تَضَعُوا أَسْلِحَتَكُمْ ۖ وَخُذُوا حِذْرَكُمْ ۗ إِنَّ اللَّهَ أَعَدَّ لِلْكَافِرِينَ عَذَابًا مُهِينًا",
  },
  {
    id: "596",
    sura: "4",
    VerseIDAr: "103",
    ayatAR:
      "فَإِذَا قَضَيْتُمُ الصَّلَاةَ فَاذْكُرُوا اللَّهَ قِيَامًا وَقُعُودًا وَعَلَىٰ جُنُوبِكُمْ ۚ فَإِذَا اطْمَأْنَنْتُمْ فَأَقِيمُوا الصَّلَاةَ ۚ إِنَّ الصَّلَاةَ كَانَتْ عَلَى الْمُؤْمِنِينَ كِتَابًا مَوْقُوتًا",
  },
  {
    id: "597",
    sura: "4",
    VerseIDAr: "104",
    ayatAR:
      "وَلَا تَهِنُوا فِي ابْتِغَاءِ الْقَوْمِ ۖ إِنْ تَكُونُوا تَأْلَمُونَ فَإِنَّهُمْ يَأْلَمُونَ كَمَا تَأْلَمُونَ ۖ وَتَرْجُونَ مِنَ اللَّهِ مَا لَا يَرْجُونَ ۗ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "598",
    sura: "4",
    VerseIDAr: "105",
    ayatAR:
      "إِنَّا أَنْزَلْنَا إِلَيْكَ الْكِتَابَ بِالْحَقِّ لِتَحْكُمَ بَيْنَ النَّاسِ بِمَا أَرَاكَ اللَّهُ ۚ وَلَا تَكُنْ لِلْخَائِنِينَ خَصِيمًا",
  },
  {
    id: "599",
    sura: "4",
    VerseIDAr: "106",
    ayatAR: "وَاسْتَغْفِرِ اللَّهَ ۖ إِنَّ اللَّهَ كَانَ غَفُورًا رَحِيمًا",
  },
  {
    id: "600",
    sura: "4",
    VerseIDAr: "107",
    ayatAR:
      "وَلَا تُجَادِلْ عَنِ الَّذِينَ يَخْتَانُونَ أَنْفُسَهُمْ ۚ إِنَّ اللَّهَ لَا يُحِبُّ مَنْ كَانَ خَوَّانًا أَثِيمًا",
  },
  {
    id: "601",
    sura: "4",
    VerseIDAr: "108",
    ayatAR:
      "يَسْتَخْفُونَ مِنَ النَّاسِ وَلَا يَسْتَخْفُونَ مِنَ اللَّهِ وَهُوَ مَعَهُمْ إِذْ يُبَيِّتُونَ مَا لَا يَرْضَىٰ مِنَ الْقَوْلِ ۚ وَكَانَ اللَّهُ بِمَا يَعْمَلُونَ مُحِيطًا",
  },
  {
    id: "602",
    sura: "4",
    VerseIDAr: "109",
    ayatAR:
      "هَا أَنْتُمْ هَٰؤُلَاءِ جَادَلْتُمْ عَنْهُمْ فِي الْحَيَاةِ الدُّنْيَا فَمَنْ يُجَادِلُ اللَّهَ عَنْهُمْ يَوْمَ الْقِيَامَةِ أَمْ مَنْ يَكُونُ عَلَيْهِمْ وَكِيلًا",
  },
  {
    id: "603",
    sura: "4",
    VerseIDAr: "110",
    ayatAR:
      "وَمَنْ يَعْمَلْ سُوءًا أَوْ يَظْلِمْ نَفْسَهُ ثُمَّ يَسْتَغْفِرِ اللَّهَ يَجِدِ اللَّهَ غَفُورًا رَحِيمًا",
  },
  {
    id: "604",
    sura: "4",
    VerseIDAr: "111",
    ayatAR:
      "وَمَنْ يَكْسِبْ إِثْمًا فَإِنَّمَا يَكْسِبُهُ عَلَىٰ نَفْسِهِ ۚ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "605",
    sura: "4",
    VerseIDAr: "112",
    ayatAR:
      "وَمَنْ يَكْسِبْ خَطِيئَةً أَوْ إِثْمًا ثُمَّ يَرْمِ بِهِ بَرِيئًا فَقَدِ احْتَمَلَ بُهْتَانًا وَإِثْمًا مُبِينًا",
  },
  {
    id: "606",
    sura: "4",
    VerseIDAr: "113",
    ayatAR:
      "وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكَ وَرَحْمَتُهُ لَهَمَّتْ طَائِفَةٌ مِنْهُمْ أَنْ يُضِلُّوكَ وَمَا يُضِلُّونَ إِلَّا أَنْفُسَهُمْ ۖ وَمَا يَضُرُّونَكَ مِنْ شَيْءٍ ۚ وَأَنْزَلَ اللَّهُ عَلَيْكَ الْكِتَابَ وَالْحِكْمَةَ وَعَلَّمَكَ مَا لَمْ تَكُنْ تَعْلَمُ ۚ وَكَانَ فَضْلُ اللَّهِ عَلَيْكَ عَظِيمًا",
  },
  {
    id: "607",
    sura: "4",
    VerseIDAr: "114",
    ayatAR:
      "لَا خَيْرَ فِي كَثِيرٍ مِنْ نَجْوَاهُمْ إِلَّا مَنْ أَمَرَ بِصَدَقَةٍ أَوْ مَعْرُوفٍ أَوْ إِصْلَاحٍ بَيْنَ النَّاسِ ۚ وَمَنْ يَفْعَلْ ذَٰلِكَ ابْتِغَاءَ مَرْضَاتِ اللَّهِ فَسَوْفَ نُؤْتِيهِ أَجْرًا عَظِيمًا",
  },
  {
    id: "608",
    sura: "4",
    VerseIDAr: "115",
    ayatAR:
      "وَمَنْ يُشَاقِقِ الرَّسُولَ مِنْ بَعْدِ مَا تَبَيَّنَ لَهُ الْهُدَىٰ وَيَتَّبِعْ غَيْرَ سَبِيلِ الْمُؤْمِنِينَ نُوَلِّهِ مَا تَوَلَّىٰ وَنُصْلِهِ جَهَنَّمَ ۖ وَسَاءَتْ مَصِيرًا",
  },
  {
    id: "609",
    sura: "4",
    VerseIDAr: "116",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَغْفِرُ أَنْ يُشْرَكَ بِهِ وَيَغْفِرُ مَا دُونَ ذَٰلِكَ لِمَنْ يَشَاءُ ۚ وَمَنْ يُشْرِكْ بِاللَّهِ فَقَدْ ضَلَّ ضَلَالًا بَعِيدًا",
  },
  {
    id: "610",
    sura: "4",
    VerseIDAr: "117",
    ayatAR:
      "إِنْ يَدْعُونَ مِنْ دُونِهِ إِلَّا إِنَاثًا وَإِنْ يَدْعُونَ إِلَّا شَيْطَانًا مَرِيدًا",
  },
  {
    id: "611",
    sura: "4",
    VerseIDAr: "118",
    ayatAR:
      "لَعَنَهُ اللَّهُ ۘ وَقَالَ لَأَتَّخِذَنَّ مِنْ عِبَادِكَ نَصِيبًا مَفْرُوضًا",
  },
  {
    id: "612",
    sura: "4",
    VerseIDAr: "119",
    ayatAR:
      "وَلَأُضِلَّنَّهُمْ وَلَأُمَنِّيَنَّهُمْ وَلَآمُرَنَّهُمْ فَلَيُبَتِّكُنَّ آذَانَ الْأَنْعَامِ وَلَآمُرَنَّهُمْ فَلَيُغَيِّرُنَّ خَلْقَ اللَّهِ ۚ وَمَنْ يَتَّخِذِ الشَّيْطَانَ وَلِيًّا مِنْ دُونِ اللَّهِ فَقَدْ خَسِرَ خُسْرَانًا مُبِينًا",
  },
  {
    id: "613",
    sura: "4",
    VerseIDAr: "120",
    ayatAR:
      "يَعِدُهُمْ وَيُمَنِّيهِمْ ۖ وَمَا يَعِدُهُمُ الشَّيْطَانُ إِلَّا غُرُورًا",
  },
  {
    id: "614",
    sura: "4",
    VerseIDAr: "121",
    ayatAR: "أُولَٰئِكَ مَأْوَاهُمْ جَهَنَّمُ وَلَا يَجِدُونَ عَنْهَا مَحِيصًا",
  },
  {
    id: "615",
    sura: "4",
    VerseIDAr: "122",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ سَنُدْخِلُهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۖ وَعْدَ اللَّهِ حَقًّا ۚ وَمَنْ أَصْدَقُ مِنَ اللَّهِ قِيلًا",
  },
  {
    id: "616",
    sura: "4",
    VerseIDAr: "123",
    ayatAR:
      "لَيْسَ بِأَمَانِيِّكُمْ وَلَا أَمَانِيِّ أَهْلِ الْكِتَابِ ۗ مَنْ يَعْمَلْ سُوءًا يُجْزَ بِهِ وَلَا يَجِدْ لَهُ مِنْ دُونِ اللَّهِ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "617",
    sura: "4",
    VerseIDAr: "124",
    ayatAR:
      "وَمَنْ يَعْمَلْ مِنَ الصَّالِحَاتِ مِنْ ذَكَرٍ أَوْ أُنْثَىٰ وَهُوَ مُؤْمِنٌ فَأُولَٰئِكَ يَدْخُلُونَ الْجَنَّةَ وَلَا يُظْلَمُونَ نَقِيرًا",
  },
  {
    id: "618",
    sura: "4",
    VerseIDAr: "125",
    ayatAR:
      "وَمَنْ أَحْسَنُ دِينًا مِمَّنْ أَسْلَمَ وَجْهَهُ لِلَّهِ وَهُوَ مُحْسِنٌ وَاتَّبَعَ مِلَّةَ إِبْرَاهِيمَ حَنِيفًا ۗ وَاتَّخَذَ اللَّهُ إِبْرَاهِيمَ خَلِيلًا",
  },
  {
    id: "619",
    sura: "4",
    VerseIDAr: "126",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ وَكَانَ اللَّهُ بِكُلِّ شَيْءٍ مُحِيطًا",
  },
  {
    id: "620",
    sura: "4",
    VerseIDAr: "127",
    ayatAR:
      "وَيَسْتَفْتُونَكَ فِي النِّسَاءِ ۖ قُلِ اللَّهُ يُفْتِيكُمْ فِيهِنَّ وَمَا يُتْلَىٰ عَلَيْكُمْ فِي الْكِتَابِ فِي يَتَامَى النِّسَاءِ اللَّاتِي لَا تُؤْتُونَهُنَّ مَا كُتِبَ لَهُنَّ وَتَرْغَبُونَ أَنْ تَنْكِحُوهُنَّ وَالْمُسْتَضْعَفِينَ مِنَ الْوِلْدَانِ وَأَنْ تَقُومُوا لِلْيَتَامَىٰ بِالْقِسْطِ ۚ وَمَا تَفْعَلُوا مِنْ خَيْرٍ فَإِنَّ اللَّهَ كَانَ بِهِ عَلِيمًا",
  },
  {
    id: "621",
    sura: "4",
    VerseIDAr: "128",
    ayatAR:
      "وَإِنِ امْرَأَةٌ خَافَتْ مِنْ بَعْلِهَا نُشُوزًا أَوْ إِعْرَاضًا فَلَا جُنَاحَ عَلَيْهِمَا أَنْ يُصْلِحَا بَيْنَهُمَا صُلْحًا ۚ وَالصُّلْحُ خَيْرٌ ۗ وَأُحْضِرَتِ الْأَنْفُسُ الشُّحَّ ۚ وَإِنْ تُحْسِنُوا وَتَتَّقُوا فَإِنَّ اللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًا",
  },
  {
    id: "622",
    sura: "4",
    VerseIDAr: "129",
    ayatAR:
      "وَلَنْ تَسْتَطِيعُوا أَنْ تَعْدِلُوا بَيْنَ النِّسَاءِ وَلَوْ حَرَصْتُمْ ۖ فَلَا تَمِيلُوا كُلَّ الْمَيْلِ فَتَذَرُوهَا كَالْمُعَلَّقَةِ ۚ وَإِنْ تُصْلِحُوا وَتَتَّقُوا فَإِنَّ اللَّهَ كَانَ غَفُورًا رَحِيمًا",
  },
  {
    id: "623",
    sura: "4",
    VerseIDAr: "130",
    ayatAR:
      "وَإِنْ يَتَفَرَّقَا يُغْنِ اللَّهُ كُلًّا مِنْ سَعَتِهِ ۚ وَكَانَ اللَّهُ وَاسِعًا حَكِيمًا",
  },
  {
    id: "624",
    sura: "4",
    VerseIDAr: "131",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَلَقَدْ وَصَّيْنَا الَّذِينَ أُوتُوا الْكِتَابَ مِنْ قَبْلِكُمْ وَإِيَّاكُمْ أَنِ اتَّقُوا اللَّهَ ۚ وَإِنْ تَكْفُرُوا فَإِنَّ لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ وَكَانَ اللَّهُ غَنِيًّا حَمِيدًا",
  },
  {
    id: "625",
    sura: "4",
    VerseIDAr: "132",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ وَكَفَىٰ بِاللَّهِ وَكِيلًا",
  },
  {
    id: "626",
    sura: "4",
    VerseIDAr: "133",
    ayatAR:
      "إِنْ يَشَأْ يُذْهِبْكُمْ أَيُّهَا النَّاسُ وَيَأْتِ بِآخَرِينَ ۚ وَكَانَ اللَّهُ عَلَىٰ ذَٰلِكَ قَدِيرًا",
  },
  {
    id: "627",
    sura: "4",
    VerseIDAr: "134",
    ayatAR:
      "مَنْ كَانَ يُرِيدُ ثَوَابَ الدُّنْيَا فَعِنْدَ اللَّهِ ثَوَابُ الدُّنْيَا وَالْآخِرَةِ ۚ وَكَانَ اللَّهُ سَمِيعًا بَصِيرًا",
  },
  {
    id: "628",
    sura: "4",
    VerseIDAr: "135",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُونُوا قَوَّامِينَ بِالْقِسْطِ شُهَدَاءَ لِلَّهِ وَلَوْ عَلَىٰ أَنْفُسِكُمْ أَوِ الْوَالِدَيْنِ وَالْأَقْرَبِينَ ۚ إِنْ يَكُنْ غَنِيًّا أَوْ فَقِيرًا فَاللَّهُ أَوْلَىٰ بِهِمَا ۖ فَلَا تَتَّبِعُوا الْهَوَىٰ أَنْ تَعْدِلُوا ۚ وَإِنْ تَلْوُوا أَوْ تُعْرِضُوا فَإِنَّ اللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًا",
  },
  {
    id: "629",
    sura: "4",
    VerseIDAr: "136",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا آمِنُوا بِاللَّهِ وَرَسُولِهِ وَالْكِتَابِ الَّذِي نَزَّلَ عَلَىٰ رَسُولِهِ وَالْكِتَابِ الَّذِي أَنْزَلَ مِنْ قَبْلُ ۚ وَمَنْ يَكْفُرْ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ وَالْيَوْمِ الْآخِرِ فَقَدْ ضَلَّ ضَلَالًا بَعِيدًا",
  },
  {
    id: "630",
    sura: "4",
    VerseIDAr: "137",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا ثُمَّ كَفَرُوا ثُمَّ آمَنُوا ثُمَّ كَفَرُوا ثُمَّ ازْدَادُوا كُفْرًا لَمْ يَكُنِ اللَّهُ لِيَغْفِرَ لَهُمْ وَلَا لِيَهْدِيَهُمْ سَبِيلًا",
  },
  {
    id: "631",
    sura: "4",
    VerseIDAr: "138",
    ayatAR: "بَشِّرِ الْمُنَافِقِينَ بِأَنَّ لَهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "632",
    sura: "4",
    VerseIDAr: "139",
    ayatAR:
      "الَّذِينَ يَتَّخِذُونَ الْكَافِرِينَ أَوْلِيَاءَ مِنْ دُونِ الْمُؤْمِنِينَ ۚ أَيَبْتَغُونَ عِنْدَهُمُ الْعِزَّةَ فَإِنَّ الْعِزَّةَ لِلَّهِ جَمِيعًا",
  },
  {
    id: "633",
    sura: "4",
    VerseIDAr: "140",
    ayatAR:
      "وَقَدْ نَزَّلَ عَلَيْكُمْ فِي الْكِتَابِ أَنْ إِذَا سَمِعْتُمْ آيَاتِ اللَّهِ يُكْفَرُ بِهَا وَيُسْتَهْزَأُ بِهَا فَلَا تَقْعُدُوا مَعَهُمْ حَتَّىٰ يَخُوضُوا فِي حَدِيثٍ غَيْرِهِ ۚ إِنَّكُمْ إِذًا مِثْلُهُمْ ۗ إِنَّ اللَّهَ جَامِعُ الْمُنَافِقِينَ وَالْكَافِرِينَ فِي جَهَنَّمَ جَمِيعًا",
  },
  {
    id: "634",
    sura: "4",
    VerseIDAr: "141",
    ayatAR:
      "الَّذِينَ يَتَرَبَّصُونَ بِكُمْ فَإِنْ كَانَ لَكُمْ فَتْحٌ مِنَ اللَّهِ قَالُوا أَلَمْ نَكُنْ مَعَكُمْ وَإِنْ كَانَ لِلْكَافِرِينَ نَصِيبٌ قَالُوا أَلَمْ نَسْتَحْوِذْ عَلَيْكُمْ وَنَمْنَعْكُمْ مِنَ الْمُؤْمِنِينَ ۚ فَاللَّهُ يَحْكُمُ بَيْنَكُمْ يَوْمَ الْقِيَامَةِ ۗ وَلَنْ يَجْعَلَ اللَّهُ لِلْكَافِرِينَ عَلَى الْمُؤْمِنِينَ سَبِيلًا",
  },
  {
    id: "635",
    sura: "4",
    VerseIDAr: "142",
    ayatAR:
      "إِنَّ الْمُنَافِقِينَ يُخَادِعُونَ اللَّهَ وَهُوَ خَادِعُهُمْ وَإِذَا قَامُوا إِلَى الصَّلَاةِ قَامُوا كُسَالَىٰ يُرَاءُونَ النَّاسَ وَلَا يَذْكُرُونَ اللَّهَ إِلَّا قَلِيلًا",
  },
  {
    id: "636",
    sura: "4",
    VerseIDAr: "143",
    ayatAR:
      "مُذَبْذَبِينَ بَيْنَ ذَٰلِكَ لَا إِلَىٰ هَٰؤُلَاءِ وَلَا إِلَىٰ هَٰؤُلَاءِ ۚ وَمَنْ يُضْلِلِ اللَّهُ فَلَنْ تَجِدَ لَهُ سَبِيلًا",
  },
  {
    id: "637",
    sura: "4",
    VerseIDAr: "144",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا الْكَافِرِينَ أَوْلِيَاءَ مِنْ دُونِ الْمُؤْمِنِينَ ۚ أَتُرِيدُونَ أَنْ تَجْعَلُوا لِلَّهِ عَلَيْكُمْ سُلْطَانًا مُبِينًا",
  },
  {
    id: "638",
    sura: "4",
    VerseIDAr: "145",
    ayatAR:
      "إِنَّ الْمُنَافِقِينَ فِي الدَّرْكِ الْأَسْفَلِ مِنَ النَّارِ وَلَنْ تَجِدَ لَهُمْ نَصِيرًا",
  },
  {
    id: "639",
    sura: "4",
    VerseIDAr: "146",
    ayatAR:
      "إِلَّا الَّذِينَ تَابُوا وَأَصْلَحُوا وَاعْتَصَمُوا بِاللَّهِ وَأَخْلَصُوا دِينَهُمْ لِلَّهِ فَأُولَٰئِكَ مَعَ الْمُؤْمِنِينَ ۖ وَسَوْفَ يُؤْتِ اللَّهُ الْمُؤْمِنِينَ أَجْرًا عَظِيمًا",
  },
  {
    id: "640",
    sura: "4",
    VerseIDAr: "147",
    ayatAR:
      "مَا يَفْعَلُ اللَّهُ بِعَذَابِكُمْ إِنْ شَكَرْتُمْ وَآمَنْتُمْ ۚ وَكَانَ اللَّهُ شَاكِرًا عَلِيمًا",
  },
  {
    id: "641",
    sura: "4",
    VerseIDAr: "148",
    ayatAR:
      "لَا يُحِبُّ اللَّهُ الْجَهْرَ بِالسُّوءِ مِنَ الْقَوْلِ إِلَّا مَنْ ظُلِمَ ۚ وَكَانَ اللَّهُ سَمِيعًا عَلِيمًا",
  },
  {
    id: "642",
    sura: "4",
    VerseIDAr: "149",
    ayatAR:
      "إِنْ تُبْدُوا خَيْرًا أَوْ تُخْفُوهُ أَوْ تَعْفُوا عَنْ سُوءٍ فَإِنَّ اللَّهَ كَانَ عَفُوًّا قَدِيرًا",
  },
  {
    id: "643",
    sura: "4",
    VerseIDAr: "150",
    ayatAR:
      "إِنَّ الَّذِينَ يَكْفُرُونَ بِاللَّهِ وَرُسُلِهِ وَيُرِيدُونَ أَنْ يُفَرِّقُوا بَيْنَ اللَّهِ وَرُسُلِهِ وَيَقُولُونَ نُؤْمِنُ بِبَعْضٍ وَنَكْفُرُ بِبَعْضٍ وَيُرِيدُونَ أَنْ يَتَّخِذُوا بَيْنَ ذَٰلِكَ سَبِيلًا",
  },
  {
    id: "644",
    sura: "4",
    VerseIDAr: "151",
    ayatAR:
      "أُولَٰئِكَ هُمُ الْكَافِرُونَ حَقًّا ۚ وَأَعْتَدْنَا لِلْكَافِرِينَ عَذَابًا مُهِينًا",
  },
  {
    id: "645",
    sura: "4",
    VerseIDAr: "152",
    ayatAR:
      "وَالَّذِينَ آمَنُوا بِاللَّهِ وَرُسُلِهِ وَلَمْ يُفَرِّقُوا بَيْنَ أَحَدٍ مِنْهُمْ أُولَٰئِكَ سَوْفَ يُؤْتِيهِمْ أُجُورَهُمْ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "646",
    sura: "4",
    VerseIDAr: "153",
    ayatAR:
      "يَسْأَلُكَ أَهْلُ الْكِتَابِ أَنْ تُنَزِّلَ عَلَيْهِمْ كِتَابًا مِنَ السَّمَاءِ ۚ فَقَدْ سَأَلُوا مُوسَىٰ أَكْبَرَ مِنْ ذَٰلِكَ فَقَالُوا أَرِنَا اللَّهَ جَهْرَةً فَأَخَذَتْهُمُ الصَّاعِقَةُ بِظُلْمِهِمْ ۚ ثُمَّ اتَّخَذُوا الْعِجْلَ مِنْ بَعْدِ مَا جَاءَتْهُمُ الْبَيِّنَاتُ فَعَفَوْنَا عَنْ ذَٰلِكَ ۚ وَآتَيْنَا مُوسَىٰ سُلْطَانًا مُبِينًا",
  },
  {
    id: "647",
    sura: "4",
    VerseIDAr: "154",
    ayatAR:
      "وَرَفَعْنَا فَوْقَهُمُ الطُّورَ بِمِيثَاقِهِمْ وَقُلْنَا لَهُمُ ادْخُلُوا الْبَابَ سُجَّدًا وَقُلْنَا لَهُمْ لَا تَعْدُوا فِي السَّبْتِ وَأَخَذْنَا مِنْهُمْ مِيثَاقًا غَلِيظًا",
  },
  {
    id: "648",
    sura: "4",
    VerseIDAr: "155",
    ayatAR:
      "فَبِمَا نَقْضِهِمْ مِيثَاقَهُمْ وَكُفْرِهِمْ بِآيَاتِ اللَّهِ وَقَتْلِهِمُ الْأَنْبِيَاءَ بِغَيْرِ حَقٍّ وَقَوْلِهِمْ قُلُوبُنَا غُلْفٌ ۚ بَلْ طَبَعَ اللَّهُ عَلَيْهَا بِكُفْرِهِمْ فَلَا يُؤْمِنُونَ إِلَّا قَلِيلًا",
  },
  {
    id: "649",
    sura: "4",
    VerseIDAr: "156",
    ayatAR: "وَبِكُفْرِهِمْ وَقَوْلِهِمْ عَلَىٰ مَرْيَمَ بُهْتَانًا عَظِيمًا",
  },
  {
    id: "650",
    sura: "4",
    VerseIDAr: "157",
    ayatAR:
      "وَقَوْلِهِمْ إِنَّا قَتَلْنَا الْمَسِيحَ عِيسَى ابْنَ مَرْيَمَ رَسُولَ اللَّهِ وَمَا قَتَلُوهُ وَمَا صَلَبُوهُ وَلَٰكِنْ شُبِّهَ لَهُمْ ۚ وَإِنَّ الَّذِينَ اخْتَلَفُوا فِيهِ لَفِي شَكٍّ مِنْهُ ۚ مَا لَهُمْ بِهِ مِنْ عِلْمٍ إِلَّا اتِّبَاعَ الظَّنِّ ۚ وَمَا قَتَلُوهُ يَقِينًا",
  },
  {
    id: "651",
    sura: "4",
    VerseIDAr: "158",
    ayatAR:
      "بَلْ رَفَعَهُ اللَّهُ إِلَيْهِ ۚ وَكَانَ اللَّهُ عَزِيزًا حَكِيمًا",
  },
  {
    id: "652",
    sura: "4",
    VerseIDAr: "159",
    ayatAR:
      "وَإِنْ مِنْ أَهْلِ الْكِتَابِ إِلَّا لَيُؤْمِنَنَّ بِهِ قَبْلَ مَوْتِهِ ۖ وَيَوْمَ الْقِيَامَةِ يَكُونُ عَلَيْهِمْ شَهِيدًا",
  },
  {
    id: "653",
    sura: "4",
    VerseIDAr: "160",
    ayatAR:
      "فَبِظُلْمٍ مِنَ الَّذِينَ هَادُوا حَرَّمْنَا عَلَيْهِمْ طَيِّبَاتٍ أُحِلَّتْ لَهُمْ وَبِصَدِّهِمْ عَنْ سَبِيلِ اللَّهِ كَثِيرًا",
  },
  {
    id: "654",
    sura: "4",
    VerseIDAr: "161",
    ayatAR:
      "وَأَخْذِهِمُ الرِّبَا وَقَدْ نُهُوا عَنْهُ وَأَكْلِهِمْ أَمْوَالَ النَّاسِ بِالْبَاطِلِ ۚ وَأَعْتَدْنَا لِلْكَافِرِينَ مِنْهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "655",
    sura: "4",
    VerseIDAr: "162",
    ayatAR:
      "لَٰكِنِ الرَّاسِخُونَ فِي الْعِلْمِ مِنْهُمْ وَالْمُؤْمِنُونَ يُؤْمِنُونَ بِمَا أُنْزِلَ إِلَيْكَ وَمَا أُنْزِلَ مِنْ قَبْلِكَ ۚ وَالْمُقِيمِينَ الصَّلَاةَ ۚ وَالْمُؤْتُونَ الزَّكَاةَ وَالْمُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ أُولَٰئِكَ سَنُؤْتِيهِمْ أَجْرًا عَظِيمًا",
  },
  {
    id: "656",
    sura: "4",
    VerseIDAr: "163",
    ayatAR:
      "إِنَّا أَوْحَيْنَا إِلَيْكَ كَمَا أَوْحَيْنَا إِلَىٰ نُوحٍ وَالنَّبِيِّينَ مِنْ بَعْدِهِ ۚ وَأَوْحَيْنَا إِلَىٰ إِبْرَاهِيمَ وَإِسْمَاعِيلَ وَإِسْحَاقَ وَيَعْقُوبَ وَالْأَسْبَاطِ وَعِيسَىٰ وَأَيُّوبَ وَيُونُسَ وَهَارُونَ وَسُلَيْمَانَ ۚ وَآتَيْنَا دَاوُودَ زَبُورًا",
  },
  {
    id: "657",
    sura: "4",
    VerseIDAr: "164",
    ayatAR:
      "وَرُسُلًا قَدْ قَصَصْنَاهُمْ عَلَيْكَ مِنْ قَبْلُ وَرُسُلًا لَمْ نَقْصُصْهُمْ عَلَيْكَ ۚ وَكَلَّمَ اللَّهُ مُوسَىٰ تَكْلِيمًا",
  },
  {
    id: "658",
    sura: "4",
    VerseIDAr: "165",
    ayatAR:
      "رُسُلًا مُبَشِّرِينَ وَمُنْذِرِينَ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَى اللَّهِ حُجَّةٌ بَعْدَ الرُّسُلِ ۚ وَكَانَ اللَّهُ عَزِيزًا حَكِيمًا",
  },
  {
    id: "659",
    sura: "4",
    VerseIDAr: "166",
    ayatAR:
      "لَٰكِنِ اللَّهُ يَشْهَدُ بِمَا أَنْزَلَ إِلَيْكَ ۖ أَنْزَلَهُ بِعِلْمِهِ ۖ وَالْمَلَائِكَةُ يَشْهَدُونَ ۚ وَكَفَىٰ بِاللَّهِ شَهِيدًا",
  },
  {
    id: "660",
    sura: "4",
    VerseIDAr: "167",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَصَدُّوا عَنْ سَبِيلِ اللَّهِ قَدْ ضَلُّوا ضَلَالًا بَعِيدًا",
  },
  {
    id: "661",
    sura: "4",
    VerseIDAr: "168",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَظَلَمُوا لَمْ يَكُنِ اللَّهُ لِيَغْفِرَ لَهُمْ وَلَا لِيَهْدِيَهُمْ طَرِيقًا",
  },
  {
    id: "662",
    sura: "4",
    VerseIDAr: "169",
    ayatAR:
      "إِلَّا طَرِيقَ جَهَنَّمَ خَالِدِينَ فِيهَا أَبَدًا ۚ وَكَانَ ذَٰلِكَ عَلَى اللَّهِ يَسِيرًا",
  },
  {
    id: "663",
    sura: "4",
    VerseIDAr: "170",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ قَدْ جَاءَكُمُ الرَّسُولُ بِالْحَقِّ مِنْ رَبِّكُمْ فَآمِنُوا خَيْرًا لَكُمْ ۚ وَإِنْ تَكْفُرُوا فَإِنَّ لِلَّهِ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "664",
    sura: "4",
    VerseIDAr: "171",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ لَا تَغْلُوا فِي دِينِكُمْ وَلَا تَقُولُوا عَلَى اللَّهِ إِلَّا الْحَقَّ ۚ إِنَّمَا الْمَسِيحُ عِيسَى ابْنُ مَرْيَمَ رَسُولُ اللَّهِ وَكَلِمَتُهُ أَلْقَاهَا إِلَىٰ مَرْيَمَ وَرُوحٌ مِنْهُ ۖ فَآمِنُوا بِاللَّهِ وَرُسُلِهِ ۖ وَلَا تَقُولُوا ثَلَاثَةٌ ۚ انْتَهُوا خَيْرًا لَكُمْ ۚ إِنَّمَا اللَّهُ إِلَٰهٌ وَاحِدٌ ۖ سُبْحَانَهُ أَنْ يَكُونَ لَهُ وَلَدٌ ۘ لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَكَفَىٰ بِاللَّهِ وَكِيلًا",
  },
  {
    id: "665",
    sura: "4",
    VerseIDAr: "172",
    ayatAR:
      "لَنْ يَسْتَنْكِفَ الْمَسِيحُ أَنْ يَكُونَ عَبْدًا لِلَّهِ وَلَا الْمَلَائِكَةُ الْمُقَرَّبُونَ ۚ وَمَنْ يَسْتَنْكِفْ عَنْ عِبَادَتِهِ وَيَسْتَكْبِرْ فَسَيَحْشُرُهُمْ إِلَيْهِ جَمِيعًا",
  },
  {
    id: "666",
    sura: "4",
    VerseIDAr: "173",
    ayatAR:
      "فَأَمَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَيُوَفِّيهِمْ أُجُورَهُمْ وَيَزِيدُهُمْ مِنْ فَضْلِهِ ۖ وَأَمَّا الَّذِينَ اسْتَنْكَفُوا وَاسْتَكْبَرُوا فَيُعَذِّبُهُمْ عَذَابًا أَلِيمًا وَلَا يَجِدُونَ لَهُمْ مِنْ دُونِ اللَّهِ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "667",
    sura: "4",
    VerseIDAr: "174",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ قَدْ جَاءَكُمْ بُرْهَانٌ مِنْ رَبِّكُمْ وَأَنْزَلْنَا إِلَيْكُمْ نُورًا مُبِينًا",
  },
  {
    id: "668",
    sura: "4",
    VerseIDAr: "175",
    ayatAR:
      "فَأَمَّا الَّذِينَ آمَنُوا بِاللَّهِ وَاعْتَصَمُوا بِهِ فَسَيُدْخِلُهُمْ فِي رَحْمَةٍ مِنْهُ وَفَضْلٍ وَيَهْدِيهِمْ إِلَيْهِ صِرَاطًا مُسْتَقِيمًا",
  },
  {
    id: "669",
    sura: "4",
    VerseIDAr: "176",
    ayatAR:
      "يَسْتَفْتُونَكَ قُلِ اللَّهُ يُفْتِيكُمْ فِي الْكَلَالَةِ ۚ إِنِ امْرُؤٌ هَلَكَ لَيْسَ لَهُ وَلَدٌ وَلَهُ أُخْتٌ فَلَهَا نِصْفُ مَا تَرَكَ ۚ وَهُوَ يَرِثُهَا إِنْ لَمْ يَكُنْ لَهَا وَلَدٌ ۚ فَإِنْ كَانَتَا اثْنَتَيْنِ فَلَهُمَا الثُّلُثَانِ مِمَّا تَرَكَ ۚ وَإِنْ كَانُوا إِخْوَةً رِجَالًا وَنِسَاءً فَلِلذَّكَرِ مِثْلُ حَظِّ الْأُنْثَيَيْنِ ۗ يُبَيِّنُ اللَّهُ لَكُمْ أَنْ تَضِلُّوا ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "670",
    sura: "5",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا الَّذِينَ آمَنُوا أَوْفُوا بِالْعُقُودِ ۚ أُحِلَّتْ لَكُمْ بَهِيمَةُ الْأَنْعَامِ إِلَّا مَا يُتْلَىٰ عَلَيْكُمْ غَيْرَ مُحِلِّي الصَّيْدِ وَأَنْتُمْ حُرُمٌ ۗ إِنَّ اللَّهَ يَحْكُمُ مَا يُرِيدُ",
  },
  {
    id: "671",
    sura: "5",
    VerseIDAr: "2",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تُحِلُّوا شَعَائِرَ اللَّهِ وَلَا الشَّهْرَ الْحَرَامَ وَلَا الْهَدْيَ وَلَا الْقَلَائِدَ وَلَا آمِّينَ الْبَيْتَ الْحَرَامَ يَبْتَغُونَ فَضْلًا مِنْ رَبِّهِمْ وَرِضْوَانًا ۚ وَإِذَا حَلَلْتُمْ فَاصْطَادُوا ۚ وَلَا يَجْرِمَنَّكُمْ شَنَآنُ قَوْمٍ أَنْ صَدُّوكُمْ عَنِ الْمَسْجِدِ الْحَرَامِ أَنْ تَعْتَدُوا ۘ وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ ۖ وَلَا تَعَاوَنُوا عَلَى الْإِثْمِ وَالْعُدْوَانِ ۚ وَاتَّقُوا اللَّهَ ۖ إِنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "672",
    sura: "5",
    VerseIDAr: "3",
    ayatAR:
      "حُرِّمَتْ عَلَيْكُمُ الْمَيْتَةُ وَالدَّمُ وَلَحْمُ الْخِنْزِيرِ وَمَا أُهِلَّ لِغَيْرِ اللَّهِ بِهِ وَالْمُنْخَنِقَةُ وَالْمَوْقُوذَةُ وَالْمُتَرَدِّيَةُ وَالنَّطِيحَةُ وَمَا أَكَلَ السَّبُعُ إِلَّا مَا ذَكَّيْتُمْ وَمَا ذُبِحَ عَلَى النُّصُبِ وَأَنْ تَسْتَقْسِمُوا بِالْأَزْلَامِ ۚ ذَٰلِكُمْ فِسْقٌ ۗ الْيَوْمَ يَئِسَ الَّذِينَ كَفَرُوا مِنْ دِينِكُمْ فَلَا تَخْشَوْهُمْ وَاخْشَوْنِ ۚ الْيَوْمَ أَكْمَلْتُ لَكُمْ دِينَكُمْ وَأَتْمَمْتُ عَلَيْكُمْ نِعْمَتِي وَرَضِيتُ لَكُمُ الْإِسْلَامَ دِينًا ۚ فَمَنِ اضْطُرَّ فِي مَخْمَصَةٍ غَيْرَ مُتَجَانِفٍ لِإِثْمٍ ۙ فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "673",
    sura: "5",
    VerseIDAr: "4",
    ayatAR:
      "يَسْأَلُونَكَ مَاذَا أُحِلَّ لَهُمْ ۖ قُلْ أُحِلَّ لَكُمُ الطَّيِّبَاتُ ۙ وَمَا عَلَّمْتُمْ مِنَ الْجَوَارِحِ مُكَلِّبِينَ تُعَلِّمُونَهُنَّ مِمَّا عَلَّمَكُمُ اللَّهُ ۖ فَكُلُوا مِمَّا أَمْسَكْنَ عَلَيْكُمْ وَاذْكُرُوا اسْمَ اللَّهِ عَلَيْهِ ۖ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "674",
    sura: "5",
    VerseIDAr: "5",
    ayatAR:
      "الْيَوْمَ أُحِلَّ لَكُمُ الطَّيِّبَاتُ ۖ وَطَعَامُ الَّذِينَ أُوتُوا الْكِتَابَ حِلٌّ لَكُمْ وَطَعَامُكُمْ حِلٌّ لَهُمْ ۖ وَالْمُحْصَنَاتُ مِنَ الْمُؤْمِنَاتِ وَالْمُحْصَنَاتُ مِنَ الَّذِينَ أُوتُوا الْكِتَابَ مِنْ قَبْلِكُمْ إِذَا آتَيْتُمُوهُنَّ أُجُورَهُنَّ مُحْصِنِينَ غَيْرَ مُسَافِحِينَ وَلَا مُتَّخِذِي أَخْدَانٍ ۗ وَمَنْ يَكْفُرْ بِالْإِيمَانِ فَقَدْ حَبِطَ عَمَلُهُ وَهُوَ فِي الْآخِرَةِ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "675",
    sura: "5",
    VerseIDAr: "6",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا قُمْتُمْ إِلَى الصَّلَاةِ فَاغْسِلُوا وُجُوهَكُمْ وَأَيْدِيَكُمْ إِلَى الْمَرَافِقِ وَامْسَحُوا بِرُءُوسِكُمْ وَأَرْجُلَكُمْ إِلَى الْكَعْبَيْنِ ۚ وَإِنْ كُنْتُمْ جُنُبًا فَاطَّهَّرُوا ۚ وَإِنْ كُنْتُمْ مَرْضَىٰ أَوْ عَلَىٰ سَفَرٍ أَوْ جَاءَ أَحَدٌ مِنْكُمْ مِنَ الْغَائِطِ أَوْ لَامَسْتُمُ النِّسَاءَ فَلَمْ تَجِدُوا مَاءً فَتَيَمَّمُوا صَعِيدًا طَيِّبًا فَامْسَحُوا بِوُجُوهِكُمْ وَأَيْدِيكُمْ مِنْهُ ۚ مَا يُرِيدُ اللَّهُ لِيَجْعَلَ عَلَيْكُمْ مِنْ حَرَجٍ وَلَٰكِنْ يُرِيدُ لِيُطَهِّرَكُمْ وَلِيُتِمَّ نِعْمَتَهُ عَلَيْكُمْ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "676",
    sura: "5",
    VerseIDAr: "7",
    ayatAR:
      "وَاذْكُرُوا نِعْمَةَ اللَّهِ عَلَيْكُمْ وَمِيثَاقَهُ الَّذِي وَاثَقَكُمْ بِهِ إِذْ قُلْتُمْ سَمِعْنَا وَأَطَعْنَا ۖ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "677",
    sura: "5",
    VerseIDAr: "8",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُونُوا قَوَّامِينَ لِلَّهِ شُهَدَاءَ بِالْقِسْطِ ۖ وَلَا يَجْرِمَنَّكُمْ شَنَآنُ قَوْمٍ عَلَىٰ أَلَّا تَعْدِلُوا ۚ اعْدِلُوا هُوَ أَقْرَبُ لِلتَّقْوَىٰ ۖ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "678",
    sura: "5",
    VerseIDAr: "9",
    ayatAR:
      "وَعَدَ اللَّهُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ ۙ لَهُمْ مَغْفِرَةٌ وَأَجْرٌ عَظِيمٌ",
  },
  {
    id: "679",
    sura: "5",
    VerseIDAr: "10",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا أُولَٰئِكَ أَصْحَابُ الْجَحِيمِ",
  },
  {
    id: "680",
    sura: "5",
    VerseIDAr: "11",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اذْكُرُوا نِعْمَتَ اللَّهِ عَلَيْكُمْ إِذْ هَمَّ قَوْمٌ أَنْ يَبْسُطُوا إِلَيْكُمْ أَيْدِيَهُمْ فَكَفَّ أَيْدِيَهُمْ عَنْكُمْ ۖ وَاتَّقُوا اللَّهَ ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "681",
    sura: "5",
    VerseIDAr: "12",
    ayatAR:
      "وَلَقَدْ أَخَذَ اللَّهُ مِيثَاقَ بَنِي إِسْرَائِيلَ وَبَعَثْنَا مِنْهُمُ اثْنَيْ عَشَرَ نَقِيبًا ۖ وَقَالَ اللَّهُ إِنِّي مَعَكُمْ ۖ لَئِنْ أَقَمْتُمُ الصَّلَاةَ وَآتَيْتُمُ الزَّكَاةَ وَآمَنْتُمْ بِرُسُلِي وَعَزَّرْتُمُوهُمْ وَأَقْرَضْتُمُ اللَّهَ قَرْضًا حَسَنًا لَأُكَفِّرَنَّ عَنْكُمْ سَيِّئَاتِكُمْ وَلَأُدْخِلَنَّكُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۚ فَمَنْ كَفَرَ بَعْدَ ذَٰلِكَ مِنْكُمْ فَقَدْ ضَلَّ سَوَاءَ السَّبِيلِ",
  },
  {
    id: "682",
    sura: "5",
    VerseIDAr: "13",
    ayatAR:
      "فَبِمَا نَقْضِهِمْ مِيثَاقَهُمْ لَعَنَّاهُمْ وَجَعَلْنَا قُلُوبَهُمْ قَاسِيَةً ۖ يُحَرِّفُونَ الْكَلِمَ عَنْ مَوَاضِعِهِ ۙ وَنَسُوا حَظًّا مِمَّا ذُكِّرُوا بِهِ ۚ وَلَا تَزَالُ تَطَّلِعُ عَلَىٰ خَائِنَةٍ مِنْهُمْ إِلَّا قَلِيلًا مِنْهُمْ ۖ فَاعْفُ عَنْهُمْ وَاصْفَحْ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُحْسِنِينَ",
  },
  {
    id: "683",
    sura: "5",
    VerseIDAr: "14",
    ayatAR:
      "وَمِنَ الَّذِينَ قَالُوا إِنَّا نَصَارَىٰ أَخَذْنَا مِيثَاقَهُمْ فَنَسُوا حَظًّا مِمَّا ذُكِّرُوا بِهِ فَأَغْرَيْنَا بَيْنَهُمُ الْعَدَاوَةَ وَالْبَغْضَاءَ إِلَىٰ يَوْمِ الْقِيَامَةِ ۚ وَسَوْفَ يُنَبِّئُهُمُ اللَّهُ بِمَا كَانُوا يَصْنَعُونَ",
  },
  {
    id: "684",
    sura: "5",
    VerseIDAr: "15",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ قَدْ جَاءَكُمْ رَسُولُنَا يُبَيِّنُ لَكُمْ كَثِيرًا مِمَّا كُنْتُمْ تُخْفُونَ مِنَ الْكِتَابِ وَيَعْفُو عَنْ كَثِيرٍ ۚ قَدْ جَاءَكُمْ مِنَ اللَّهِ نُورٌ وَكِتَابٌ مُبِينٌ",
  },
  {
    id: "685",
    sura: "5",
    VerseIDAr: "16",
    ayatAR:
      "يَهْدِي بِهِ اللَّهُ مَنِ اتَّبَعَ رِضْوَانَهُ سُبُلَ السَّلَامِ وَيُخْرِجُهُمْ مِنَ الظُّلُمَاتِ إِلَى النُّورِ بِإِذْنِهِ وَيَهْدِيهِمْ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "686",
    sura: "5",
    VerseIDAr: "17",
    ayatAR:
      "لَقَدْ كَفَرَ الَّذِينَ قَالُوا إِنَّ اللَّهَ هُوَ الْمَسِيحُ ابْنُ مَرْيَمَ ۚ قُلْ فَمَنْ يَمْلِكُ مِنَ اللَّهِ شَيْئًا إِنْ أَرَادَ أَنْ يُهْلِكَ الْمَسِيحَ ابْنَ مَرْيَمَ وَأُمَّهُ وَمَنْ فِي الْأَرْضِ جَمِيعًا ۗ وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا ۚ يَخْلُقُ مَا يَشَاءُ ۚ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "687",
    sura: "5",
    VerseIDAr: "18",
    ayatAR:
      "وَقَالَتِ الْيَهُودُ وَالنَّصَارَىٰ نَحْنُ أَبْنَاءُ اللَّهِ وَأَحِبَّاؤُهُ ۚ قُلْ فَلِمَ يُعَذِّبُكُمْ بِذُنُوبِكُمْ ۖ بَلْ أَنْتُمْ بَشَرٌ مِمَّنْ خَلَقَ ۚ يَغْفِرُ لِمَنْ يَشَاءُ وَيُعَذِّبُ مَنْ يَشَاءُ ۚ وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا ۖ وَإِلَيْهِ الْمَصِيرُ",
  },
  {
    id: "688",
    sura: "5",
    VerseIDAr: "19",
    ayatAR:
      "يَا أَهْلَ الْكِتَابِ قَدْ جَاءَكُمْ رَسُولُنَا يُبَيِّنُ لَكُمْ عَلَىٰ فَتْرَةٍ مِنَ الرُّسُلِ أَنْ تَقُولُوا مَا جَاءَنَا مِنْ بَشِيرٍ وَلَا نَذِيرٍ ۖ فَقَدْ جَاءَكُمْ بَشِيرٌ وَنَذِيرٌ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "689",
    sura: "5",
    VerseIDAr: "20",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ يَا قَوْمِ اذْكُرُوا نِعْمَةَ اللَّهِ عَلَيْكُمْ إِذْ جَعَلَ فِيكُمْ أَنْبِيَاءَ وَجَعَلَكُمْ مُلُوكًا وَآتَاكُمْ مَا لَمْ يُؤْتِ أَحَدًا مِنَ الْعَالَمِينَ",
  },
  {
    id: "690",
    sura: "5",
    VerseIDAr: "21",
    ayatAR:
      "يَا قَوْمِ ادْخُلُوا الْأَرْضَ الْمُقَدَّسَةَ الَّتِي كَتَبَ اللَّهُ لَكُمْ وَلَا تَرْتَدُّوا عَلَىٰ أَدْبَارِكُمْ فَتَنْقَلِبُوا خَاسِرِينَ",
  },
  {
    id: "691",
    sura: "5",
    VerseIDAr: "22",
    ayatAR:
      "قَالُوا يَا مُوسَىٰ إِنَّ فِيهَا قَوْمًا جَبَّارِينَ وَإِنَّا لَنْ نَدْخُلَهَا حَتَّىٰ يَخْرُجُوا مِنْهَا فَإِنْ يَخْرُجُوا مِنْهَا فَإِنَّا دَاخِلُونَ",
  },
  {
    id: "692",
    sura: "5",
    VerseIDAr: "23",
    ayatAR:
      "قَالَ رَجُلَانِ مِنَ الَّذِينَ يَخَافُونَ أَنْعَمَ اللَّهُ عَلَيْهِمَا ادْخُلُوا عَلَيْهِمُ الْبَابَ فَإِذَا دَخَلْتُمُوهُ فَإِنَّكُمْ غَالِبُونَ ۚ وَعَلَى اللَّهِ فَتَوَكَّلُوا إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "693",
    sura: "5",
    VerseIDAr: "24",
    ayatAR:
      "قَالُوا يَا مُوسَىٰ إِنَّا لَنْ نَدْخُلَهَا أَبَدًا مَا دَامُوا فِيهَا ۖ فَاذْهَبْ أَنْتَ وَرَبُّكَ فَقَاتِلَا إِنَّا هَاهُنَا قَاعِدُونَ",
  },
  {
    id: "694",
    sura: "5",
    VerseIDAr: "25",
    ayatAR:
      "قَالَ رَبِّ إِنِّي لَا أَمْلِكُ إِلَّا نَفْسِي وَأَخِي ۖ فَافْرُقْ بَيْنَنَا وَبَيْنَ الْقَوْمِ الْفَاسِقِينَ",
  },
  {
    id: "695",
    sura: "5",
    VerseIDAr: "26",
    ayatAR:
      "قَالَ فَإِنَّهَا مُحَرَّمَةٌ عَلَيْهِمْ ۛ أَرْبَعِينَ سَنَةً ۛ يَتِيهُونَ فِي الْأَرْضِ ۚ فَلَا تَأْسَ عَلَى الْقَوْمِ الْفَاسِقِينَ",
  },
  {
    id: "696",
    sura: "5",
    VerseIDAr: "27",
    ayatAR:
      "وَاتْلُ عَلَيْهِمْ نَبَأَ ابْنَيْ آدَمَ بِالْحَقِّ إِذْ قَرَّبَا قُرْبَانًا فَتُقُبِّلَ مِنْ أَحَدِهِمَا وَلَمْ يُتَقَبَّلْ مِنَ الْآخَرِ قَالَ لَأَقْتُلَنَّكَ ۖ قَالَ إِنَّمَا يَتَقَبَّلُ اللَّهُ مِنَ الْمُتَّقِينَ",
  },
  {
    id: "697",
    sura: "5",
    VerseIDAr: "28",
    ayatAR:
      "لَئِنْ بَسَطْتَ إِلَيَّ يَدَكَ لِتَقْتُلَنِي مَا أَنَا بِبَاسِطٍ يَدِيَ إِلَيْكَ لِأَقْتُلَكَ ۖ إِنِّي أَخَافُ اللَّهَ رَبَّ الْعَالَمِينَ",
  },
  {
    id: "698",
    sura: "5",
    VerseIDAr: "29",
    ayatAR:
      "إِنِّي أُرِيدُ أَنْ تَبُوءَ بِإِثْمِي وَإِثْمِكَ فَتَكُونَ مِنْ أَصْحَابِ النَّارِ ۚ وَذَٰلِكَ جَزَاءُ الظَّالِمِينَ",
  },
  {
    id: "699",
    sura: "5",
    VerseIDAr: "30",
    ayatAR:
      "فَطَوَّعَتْ لَهُ نَفْسُهُ قَتْلَ أَخِيهِ فَقَتَلَهُ فَأَصْبَحَ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "700",
    sura: "5",
    VerseIDAr: "31",
    ayatAR:
      "فَبَعَثَ اللَّهُ غُرَابًا يَبْحَثُ فِي الْأَرْضِ لِيُرِيَهُ كَيْفَ يُوَارِي سَوْءَةَ أَخِيهِ ۚ قَالَ يَا وَيْلَتَا أَعَجَزْتُ أَنْ أَكُونَ مِثْلَ هَٰذَا الْغُرَابِ فَأُوَارِيَ سَوْءَةَ أَخِي ۖ فَأَصْبَحَ مِنَ النَّادِمِينَ",
  },
  {
    id: "701",
    sura: "5",
    VerseIDAr: "32",
    ayatAR:
      "مِنْ أَجْلِ ذَٰلِكَ كَتَبْنَا عَلَىٰ بَنِي إِسْرَائِيلَ أَنَّهُ مَنْ قَتَلَ نَفْسًا بِغَيْرِ نَفْسٍ أَوْ فَسَادٍ فِي الْأَرْضِ فَكَأَنَّمَا قَتَلَ النَّاسَ جَمِيعًا وَمَنْ أَحْيَاهَا فَكَأَنَّمَا أَحْيَا النَّاسَ جَمِيعًا ۚ وَلَقَدْ جَاءَتْهُمْ رُسُلُنَا بِالْبَيِّنَاتِ ثُمَّ إِنَّ كَثِيرًا مِنْهُمْ بَعْدَ ذَٰلِكَ فِي الْأَرْضِ لَمُسْرِفُونَ",
  },
  {
    id: "702",
    sura: "5",
    VerseIDAr: "33",
    ayatAR:
      "إِنَّمَا جَزَاءُ الَّذِينَ يُحَارِبُونَ اللَّهَ وَرَسُولَهُ وَيَسْعَوْنَ فِي الْأَرْضِ فَسَادًا أَنْ يُقَتَّلُوا أَوْ يُصَلَّبُوا أَوْ تُقَطَّعَ أَيْدِيهِمْ وَأَرْجُلُهُمْ مِنْ خِلَافٍ أَوْ يُنْفَوْا مِنَ الْأَرْضِ ۚ ذَٰلِكَ لَهُمْ خِزْيٌ فِي الدُّنْيَا ۖ وَلَهُمْ فِي الْآخِرَةِ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "703",
    sura: "5",
    VerseIDAr: "34",
    ayatAR:
      "إِلَّا الَّذِينَ تَابُوا مِنْ قَبْلِ أَنْ تَقْدِرُوا عَلَيْهِمْ ۖ فَاعْلَمُوا أَنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "704",
    sura: "5",
    VerseIDAr: "35",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَابْتَغُوا إِلَيْهِ الْوَسِيلَةَ وَجَاهِدُوا فِي سَبِيلِهِ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "705",
    sura: "5",
    VerseIDAr: "36",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا لَوْ أَنَّ لَهُمْ مَا فِي الْأَرْضِ جَمِيعًا وَمِثْلَهُ مَعَهُ لِيَفْتَدُوا بِهِ مِنْ عَذَابِ يَوْمِ الْقِيَامَةِ مَا تُقُبِّلَ مِنْهُمْ ۖ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "706",
    sura: "5",
    VerseIDAr: "37",
    ayatAR:
      "يُرِيدُونَ أَنْ يَخْرُجُوا مِنَ النَّارِ وَمَا هُمْ بِخَارِجِينَ مِنْهَا ۖ وَلَهُمْ عَذَابٌ مُقِيمٌ",
  },
  {
    id: "707",
    sura: "5",
    VerseIDAr: "38",
    ayatAR:
      "وَالسَّارِقُ وَالسَّارِقَةُ فَاقْطَعُوا أَيْدِيَهُمَا جَزَاءً بِمَا كَسَبَا نَكَالًا مِنَ اللَّهِ ۗ وَاللَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "708",
    sura: "5",
    VerseIDAr: "39",
    ayatAR:
      "فَمَنْ تَابَ مِنْ بَعْدِ ظُلْمِهِ وَأَصْلَحَ فَإِنَّ اللَّهَ يَتُوبُ عَلَيْهِ ۗ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "709",
    sura: "5",
    VerseIDAr: "40",
    ayatAR:
      "أَلَمْ تَعْلَمْ أَنَّ اللَّهَ لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ يُعَذِّبُ مَنْ يَشَاءُ وَيَغْفِرُ لِمَنْ يَشَاءُ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "710",
    sura: "5",
    VerseIDAr: "41",
    ayatAR:
      "يَا أَيُّهَا الرَّسُولُ لَا يَحْزُنْكَ الَّذِينَ يُسَارِعُونَ فِي الْكُفْرِ مِنَ الَّذِينَ قَالُوا آمَنَّا بِأَفْوَاهِهِمْ وَلَمْ تُؤْمِنْ قُلُوبُهُمْ ۛ وَمِنَ الَّذِينَ هَادُوا ۛ سَمَّاعُونَ لِلْكَذِبِ سَمَّاعُونَ لِقَوْمٍ آخَرِينَ لَمْ يَأْتُوكَ ۖ يُحَرِّفُونَ الْكَلِمَ مِنْ بَعْدِ مَوَاضِعِهِ ۖ يَقُولُونَ إِنْ أُوتِيتُمْ هَٰذَا فَخُذُوهُ وَإِنْ لَمْ تُؤْتَوْهُ فَاحْذَرُوا ۚ وَمَنْ يُرِدِ اللَّهُ فِتْنَتَهُ فَلَنْ تَمْلِكَ لَهُ مِنَ اللَّهِ شَيْئًا ۚ أُولَٰئِكَ الَّذِينَ لَمْ يُرِدِ اللَّهُ أَنْ يُطَهِّرَ قُلُوبَهُمْ ۚ لَهُمْ فِي الدُّنْيَا خِزْيٌ ۖ وَلَهُمْ فِي الْآخِرَةِ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "711",
    sura: "5",
    VerseIDAr: "42",
    ayatAR:
      "سَمَّاعُونَ لِلْكَذِبِ أَكَّالُونَ لِلسُّحْتِ ۚ فَإِنْ جَاءُوكَ فَاحْكُمْ بَيْنَهُمْ أَوْ أَعْرِضْ عَنْهُمْ ۖ وَإِنْ تُعْرِضْ عَنْهُمْ فَلَنْ يَضُرُّوكَ شَيْئًا ۖ وَإِنْ حَكَمْتَ فَاحْكُمْ بَيْنَهُمْ بِالْقِسْطِ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُقْسِطِينَ",
  },
  {
    id: "712",
    sura: "5",
    VerseIDAr: "43",
    ayatAR:
      "وَكَيْفَ يُحَكِّمُونَكَ وَعِنْدَهُمُ التَّوْرَاةُ فِيهَا حُكْمُ اللَّهِ ثُمَّ يَتَوَلَّوْنَ مِنْ بَعْدِ ذَٰلِكَ ۚ وَمَا أُولَٰئِكَ بِالْمُؤْمِنِينَ",
  },
  {
    id: "713",
    sura: "5",
    VerseIDAr: "44",
    ayatAR:
      "إِنَّا أَنْزَلْنَا التَّوْرَاةَ فِيهَا هُدًى وَنُورٌ ۚ يَحْكُمُ بِهَا النَّبِيُّونَ الَّذِينَ أَسْلَمُوا لِلَّذِينَ هَادُوا وَالرَّبَّانِيُّونَ وَالْأَحْبَارُ بِمَا اسْتُحْفِظُوا مِنْ كِتَابِ اللَّهِ وَكَانُوا عَلَيْهِ شُهَدَاءَ ۚ فَلَا تَخْشَوُا النَّاسَ وَاخْشَوْنِ وَلَا تَشْتَرُوا بِآيَاتِي ثَمَنًا قَلِيلًا ۚ وَمَنْ لَمْ يَحْكُمْ بِمَا أَنْزَلَ اللَّهُ فَأُولَٰئِكَ هُمُ الْكَافِرُونَ",
  },
  {
    id: "714",
    sura: "5",
    VerseIDAr: "45",
    ayatAR:
      "وَكَتَبْنَا عَلَيْهِمْ فِيهَا أَنَّ النَّفْسَ بِالنَّفْسِ وَالْعَيْنَ بِالْعَيْنِ وَالْأَنْفَ بِالْأَنْفِ وَالْأُذُنَ بِالْأُذُنِ وَالسِّنَّ بِالسِّنِّ وَالْجُرُوحَ قِصَاصٌ ۚ فَمَنْ تَصَدَّقَ بِهِ فَهُوَ كَفَّارَةٌ لَهُ ۚ وَمَنْ لَمْ يَحْكُمْ بِمَا أَنْزَلَ اللَّهُ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "715",
    sura: "5",
    VerseIDAr: "46",
    ayatAR:
      "وَقَفَّيْنَا عَلَىٰ آثَارِهِمْ بِعِيسَى ابْنِ مَرْيَمَ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ مِنَ التَّوْرَاةِ ۖ وَآتَيْنَاهُ الْإِنْجِيلَ فِيهِ هُدًى وَنُورٌ وَمُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ مِنَ التَّوْرَاةِ وَهُدًى وَمَوْعِظَةً لِلْمُتَّقِينَ",
  },
  {
    id: "716",
    sura: "5",
    VerseIDAr: "47",
    ayatAR:
      "وَلْيَحْكُمْ أَهْلُ الْإِنْجِيلِ بِمَا أَنْزَلَ اللَّهُ فِيهِ ۚ وَمَنْ لَمْ يَحْكُمْ بِمَا أَنْزَلَ اللَّهُ فَأُولَٰئِكَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "717",
    sura: "5",
    VerseIDAr: "48",
    ayatAR:
      "وَأَنْزَلْنَا إِلَيْكَ الْكِتَابَ بِالْحَقِّ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ مِنَ الْكِتَابِ وَمُهَيْمِنًا عَلَيْهِ ۖ فَاحْكُمْ بَيْنَهُمْ بِمَا أَنْزَلَ اللَّهُ ۖ وَلَا تَتَّبِعْ أَهْوَاءَهُمْ عَمَّا جَاءَكَ مِنَ الْحَقِّ ۚ لِكُلٍّ جَعَلْنَا مِنْكُمْ شِرْعَةً وَمِنْهَاجًا ۚ وَلَوْ شَاءَ اللَّهُ لَجَعَلَكُمْ أُمَّةً وَاحِدَةً وَلَٰكِنْ لِيَبْلُوَكُمْ فِي مَا آتَاكُمْ ۖ فَاسْتَبِقُوا الْخَيْرَاتِ ۚ إِلَى اللَّهِ مَرْجِعُكُمْ جَمِيعًا فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ فِيهِ تَخْتَلِفُونَ",
  },
  {
    id: "718",
    sura: "5",
    VerseIDAr: "49",
    ayatAR:
      "وَأَنِ احْكُمْ بَيْنَهُمْ بِمَا أَنْزَلَ اللَّهُ وَلَا تَتَّبِعْ أَهْوَاءَهُمْ وَاحْذَرْهُمْ أَنْ يَفْتِنُوكَ عَنْ بَعْضِ مَا أَنْزَلَ اللَّهُ إِلَيْكَ ۖ فَإِنْ تَوَلَّوْا فَاعْلَمْ أَنَّمَا يُرِيدُ اللَّهُ أَنْ يُصِيبَهُمْ بِبَعْضِ ذُنُوبِهِمْ ۗ وَإِنَّ كَثِيرًا مِنَ النَّاسِ لَفَاسِقُونَ",
  },
  {
    id: "719",
    sura: "5",
    VerseIDAr: "50",
    ayatAR:
      "أَفَحُكْمَ الْجَاهِلِيَّةِ يَبْغُونَ ۚ وَمَنْ أَحْسَنُ مِنَ اللَّهِ حُكْمًا لِقَوْمٍ يُوقِنُونَ",
  },
  {
    id: "720",
    sura: "5",
    VerseIDAr: "51",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا الْيَهُودَ وَالنَّصَارَىٰ أَوْلِيَاءَ ۘ بَعْضُهُمْ أَوْلِيَاءُ بَعْضٍ ۚ وَمَنْ يَتَوَلَّهُمْ مِنْكُمْ فَإِنَّهُ مِنْهُمْ ۗ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "721",
    sura: "5",
    VerseIDAr: "52",
    ayatAR:
      "فَتَرَى الَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ يُسَارِعُونَ فِيهِمْ يَقُولُونَ نَخْشَىٰ أَنْ تُصِيبَنَا دَائِرَةٌ ۚ فَعَسَى اللَّهُ أَنْ يَأْتِيَ بِالْفَتْحِ أَوْ أَمْرٍ مِنْ عِنْدِهِ فَيُصْبِحُوا عَلَىٰ مَا أَسَرُّوا فِي أَنْفُسِهِمْ نَادِمِينَ",
  },
  {
    id: "722",
    sura: "5",
    VerseIDAr: "53",
    ayatAR:
      "وَيَقُولُ الَّذِينَ آمَنُوا أَهَٰؤُلَاءِ الَّذِينَ أَقْسَمُوا بِاللَّهِ جَهْدَ أَيْمَانِهِمْ ۙ إِنَّهُمْ لَمَعَكُمْ ۚ حَبِطَتْ أَعْمَالُهُمْ فَأَصْبَحُوا خَاسِرِينَ",
  },
  {
    id: "723",
    sura: "5",
    VerseIDAr: "54",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا مَنْ يَرْتَدَّ مِنْكُمْ عَنْ دِينِهِ فَسَوْفَ يَأْتِي اللَّهُ بِقَوْمٍ يُحِبُّهُمْ وَيُحِبُّونَهُ أَذِلَّةٍ عَلَى الْمُؤْمِنِينَ أَعِزَّةٍ عَلَى الْكَافِرِينَ يُجَاهِدُونَ فِي سَبِيلِ اللَّهِ وَلَا يَخَافُونَ لَوْمَةَ لَائِمٍ ۚ ذَٰلِكَ فَضْلُ اللَّهِ يُؤْتِيهِ مَنْ يَشَاءُ ۚ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "724",
    sura: "5",
    VerseIDAr: "55",
    ayatAR:
      "إِنَّمَا وَلِيُّكُمُ اللَّهُ وَرَسُولُهُ وَالَّذِينَ آمَنُوا الَّذِينَ يُقِيمُونَ الصَّلَاةَ وَيُؤْتُونَ الزَّكَاةَ وَهُمْ رَاكِعُونَ",
  },
  {
    id: "725",
    sura: "5",
    VerseIDAr: "56",
    ayatAR:
      "وَمَنْ يَتَوَلَّ اللَّهَ وَرَسُولَهُ وَالَّذِينَ آمَنُوا فَإِنَّ حِزْبَ اللَّهِ هُمُ الْغَالِبُونَ",
  },
  {
    id: "726",
    sura: "5",
    VerseIDAr: "57",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا الَّذِينَ اتَّخَذُوا دِينَكُمْ هُزُوًا وَلَعِبًا مِنَ الَّذِينَ أُوتُوا الْكِتَابَ مِنْ قَبْلِكُمْ وَالْكُفَّارَ أَوْلِيَاءَ ۚ وَاتَّقُوا اللَّهَ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "727",
    sura: "5",
    VerseIDAr: "58",
    ayatAR:
      "وَإِذَا نَادَيْتُمْ إِلَى الصَّلَاةِ اتَّخَذُوهَا هُزُوًا وَلَعِبًا ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌ لَا يَعْقِلُونَ",
  },
  {
    id: "728",
    sura: "5",
    VerseIDAr: "59",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ هَلْ تَنْقِمُونَ مِنَّا إِلَّا أَنْ آمَنَّا بِاللَّهِ وَمَا أُنْزِلَ إِلَيْنَا وَمَا أُنْزِلَ مِنْ قَبْلُ وَأَنَّ أَكْثَرَكُمْ فَاسِقُونَ",
  },
  {
    id: "729",
    sura: "5",
    VerseIDAr: "60",
    ayatAR:
      "قُلْ هَلْ أُنَبِّئُكُمْ بِشَرٍّ مِنْ ذَٰلِكَ مَثُوبَةً عِنْدَ اللَّهِ ۚ مَنْ لَعَنَهُ اللَّهُ وَغَضِبَ عَلَيْهِ وَجَعَلَ مِنْهُمُ الْقِرَدَةَ وَالْخَنَازِيرَ وَعَبَدَ الطَّاغُوتَ ۚ أُولَٰئِكَ شَرٌّ مَكَانًا وَأَضَلُّ عَنْ سَوَاءِ السَّبِيلِ",
  },
  {
    id: "730",
    sura: "5",
    VerseIDAr: "61",
    ayatAR:
      "وَإِذَا جَاءُوكُمْ قَالُوا آمَنَّا وَقَدْ دَخَلُوا بِالْكُفْرِ وَهُمْ قَدْ خَرَجُوا بِهِ ۚ وَاللَّهُ أَعْلَمُ بِمَا كَانُوا يَكْتُمُونَ",
  },
  {
    id: "731",
    sura: "5",
    VerseIDAr: "62",
    ayatAR:
      "وَتَرَىٰ كَثِيرًا مِنْهُمْ يُسَارِعُونَ فِي الْإِثْمِ وَالْعُدْوَانِ وَأَكْلِهِمُ السُّحْتَ ۚ لَبِئْسَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "732",
    sura: "5",
    VerseIDAr: "63",
    ayatAR:
      "لَوْلَا يَنْهَاهُمُ الرَّبَّانِيُّونَ وَالْأَحْبَارُ عَنْ قَوْلِهِمُ الْإِثْمَ وَأَكْلِهِمُ السُّحْتَ ۚ لَبِئْسَ مَا كَانُوا يَصْنَعُونَ",
  },
  {
    id: "733",
    sura: "5",
    VerseIDAr: "64",
    ayatAR:
      "وَقَالَتِ الْيَهُودُ يَدُ اللَّهِ مَغْلُولَةٌ ۚ غُلَّتْ أَيْدِيهِمْ وَلُعِنُوا بِمَا قَالُوا ۘ بَلْ يَدَاهُ مَبْسُوطَتَانِ يُنْفِقُ كَيْفَ يَشَاءُ ۚ وَلَيَزِيدَنَّ كَثِيرًا مِنْهُمْ مَا أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ طُغْيَانًا وَكُفْرًا ۚ وَأَلْقَيْنَا بَيْنَهُمُ الْعَدَاوَةَ وَالْبَغْضَاءَ إِلَىٰ يَوْمِ الْقِيَامَةِ ۚ كُلَّمَا أَوْقَدُوا نَارًا لِلْحَرْبِ أَطْفَأَهَا اللَّهُ ۚ وَيَسْعَوْنَ فِي الْأَرْضِ فَسَادًا ۚ وَاللَّهُ لَا يُحِبُّ الْمُفْسِدِينَ",
  },
  {
    id: "734",
    sura: "5",
    VerseIDAr: "65",
    ayatAR:
      "وَلَوْ أَنَّ أَهْلَ الْكِتَابِ آمَنُوا وَاتَّقَوْا لَكَفَّرْنَا عَنْهُمْ سَيِّئَاتِهِمْ وَلَأَدْخَلْنَاهُمْ جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "735",
    sura: "5",
    VerseIDAr: "66",
    ayatAR:
      "وَلَوْ أَنَّهُمْ أَقَامُوا التَّوْرَاةَ وَالْإِنْجِيلَ وَمَا أُنْزِلَ إِلَيْهِمْ مِنْ رَبِّهِمْ لَأَكَلُوا مِنْ فَوْقِهِمْ وَمِنْ تَحْتِ أَرْجُلِهِمْ ۚ مِنْهُمْ أُمَّةٌ مُقْتَصِدَةٌ ۖ وَكَثِيرٌ مِنْهُمْ سَاءَ مَا يَعْمَلُونَ",
  },
  {
    id: "736",
    sura: "5",
    VerseIDAr: "67",
    ayatAR:
      "يَا أَيُّهَا الرَّسُولُ بَلِّغْ مَا أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ ۖ وَإِنْ لَمْ تَفْعَلْ فَمَا بَلَّغْتَ رِسَالَتَهُ ۚ وَاللَّهُ يَعْصِمُكَ مِنَ النَّاسِ ۗ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الْكَافِرِينَ",
  },
  {
    id: "737",
    sura: "5",
    VerseIDAr: "68",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ لَسْتُمْ عَلَىٰ شَيْءٍ حَتَّىٰ تُقِيمُوا التَّوْرَاةَ وَالْإِنْجِيلَ وَمَا أُنْزِلَ إِلَيْكُمْ مِنْ رَبِّكُمْ ۗ وَلَيَزِيدَنَّ كَثِيرًا مِنْهُمْ مَا أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ طُغْيَانًا وَكُفْرًا ۖ فَلَا تَأْسَ عَلَى الْقَوْمِ الْكَافِرِينَ",
  },
  {
    id: "738",
    sura: "5",
    VerseIDAr: "69",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَالَّذِينَ هَادُوا وَالصَّابِئُونَ وَالنَّصَارَىٰ مَنْ آمَنَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَعَمِلَ صَالِحًا فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "739",
    sura: "5",
    VerseIDAr: "70",
    ayatAR:
      "لَقَدْ أَخَذْنَا مِيثَاقَ بَنِي إِسْرَائِيلَ وَأَرْسَلْنَا إِلَيْهِمْ رُسُلًا ۖ كُلَّمَا جَاءَهُمْ رَسُولٌ بِمَا لَا تَهْوَىٰ أَنْفُسُهُمْ فَرِيقًا كَذَّبُوا وَفَرِيقًا يَقْتُلُونَ",
  },
  {
    id: "740",
    sura: "5",
    VerseIDAr: "71",
    ayatAR:
      "وَحَسِبُوا أَلَّا تَكُونَ فِتْنَةٌ فَعَمُوا وَصَمُّوا ثُمَّ تَابَ اللَّهُ عَلَيْهِمْ ثُمَّ عَمُوا وَصَمُّوا كَثِيرٌ مِنْهُمْ ۚ وَاللَّهُ بَصِيرٌ بِمَا يَعْمَلُونَ",
  },
  {
    id: "741",
    sura: "5",
    VerseIDAr: "72",
    ayatAR:
      "لَقَدْ كَفَرَ الَّذِينَ قَالُوا إِنَّ اللَّهَ هُوَ الْمَسِيحُ ابْنُ مَرْيَمَ ۖ وَقَالَ الْمَسِيحُ يَا بَنِي إِسْرَائِيلَ اعْبُدُوا اللَّهَ رَبِّي وَرَبَّكُمْ ۖ إِنَّهُ مَنْ يُشْرِكْ بِاللَّهِ فَقَدْ حَرَّمَ اللَّهُ عَلَيْهِ الْجَنَّةَ وَمَأْوَاهُ النَّارُ ۖ وَمَا لِلظَّالِمِينَ مِنْ أَنْصَارٍ",
  },
  {
    id: "742",
    sura: "5",
    VerseIDAr: "73",
    ayatAR:
      "لَقَدْ كَفَرَ الَّذِينَ قَالُوا إِنَّ اللَّهَ ثَالِثُ ثَلَاثَةٍ ۘ وَمَا مِنْ إِلَٰهٍ إِلَّا إِلَٰهٌ وَاحِدٌ ۚ وَإِنْ لَمْ يَنْتَهُوا عَمَّا يَقُولُونَ لَيَمَسَّنَّ الَّذِينَ كَفَرُوا مِنْهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "743",
    sura: "5",
    VerseIDAr: "74",
    ayatAR:
      "أَفَلَا يَتُوبُونَ إِلَى اللَّهِ وَيَسْتَغْفِرُونَهُ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "744",
    sura: "5",
    VerseIDAr: "75",
    ayatAR:
      "مَا الْمَسِيحُ ابْنُ مَرْيَمَ إِلَّا رَسُولٌ قَدْ خَلَتْ مِنْ قَبْلِهِ الرُّسُلُ وَأُمُّهُ صِدِّيقَةٌ ۖ كَانَا يَأْكُلَانِ الطَّعَامَ ۗ انْظُرْ كَيْفَ نُبَيِّنُ لَهُمُ الْآيَاتِ ثُمَّ انْظُرْ أَنَّىٰ يُؤْفَكُونَ",
  },
  {
    id: "745",
    sura: "5",
    VerseIDAr: "76",
    ayatAR:
      "قُلْ أَتَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَا يَمْلِكُ لَكُمْ ضَرًّا وَلَا نَفْعًا ۚ وَاللَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "746",
    sura: "5",
    VerseIDAr: "77",
    ayatAR:
      "قُلْ يَا أَهْلَ الْكِتَابِ لَا تَغْلُوا فِي دِينِكُمْ غَيْرَ الْحَقِّ وَلَا تَتَّبِعُوا أَهْوَاءَ قَوْمٍ قَدْ ضَلُّوا مِنْ قَبْلُ وَأَضَلُّوا كَثِيرًا وَضَلُّوا عَنْ سَوَاءِ السَّبِيلِ",
  },
  {
    id: "747",
    sura: "5",
    VerseIDAr: "78",
    ayatAR:
      "لُعِنَ الَّذِينَ كَفَرُوا مِنْ بَنِي إِسْرَائِيلَ عَلَىٰ لِسَانِ دَاوُودَ وَعِيسَى ابْنِ مَرْيَمَ ۚ ذَٰلِكَ بِمَا عَصَوْا وَكَانُوا يَعْتَدُونَ",
  },
  {
    id: "748",
    sura: "5",
    VerseIDAr: "79",
    ayatAR:
      "كَانُوا لَا يَتَنَاهَوْنَ عَنْ مُنْكَرٍ فَعَلُوهُ ۚ لَبِئْسَ مَا كَانُوا يَفْعَلُونَ",
  },
  {
    id: "749",
    sura: "5",
    VerseIDAr: "80",
    ayatAR:
      "تَرَىٰ كَثِيرًا مِنْهُمْ يَتَوَلَّوْنَ الَّذِينَ كَفَرُوا ۚ لَبِئْسَ مَا قَدَّمَتْ لَهُمْ أَنْفُسُهُمْ أَنْ سَخِطَ اللَّهُ عَلَيْهِمْ وَفِي الْعَذَابِ هُمْ خَالِدُونَ",
  },
  {
    id: "750",
    sura: "5",
    VerseIDAr: "81",
    ayatAR:
      "وَلَوْ كَانُوا يُؤْمِنُونَ بِاللَّهِ وَالنَّبِيِّ وَمَا أُنْزِلَ إِلَيْهِ مَا اتَّخَذُوهُمْ أَوْلِيَاءَ وَلَٰكِنَّ كَثِيرًا مِنْهُمْ فَاسِقُونَ",
  },
  {
    id: "751",
    sura: "5",
    VerseIDAr: "82",
    ayatAR:
      "لَتَجِدَنَّ أَشَدَّ النَّاسِ عَدَاوَةً لِلَّذِينَ آمَنُوا الْيَهُودَ وَالَّذِينَ أَشْرَكُوا ۖ وَلَتَجِدَنَّ أَقْرَبَهُمْ مَوَدَّةً لِلَّذِينَ آمَنُوا الَّذِينَ قَالُوا إِنَّا نَصَارَىٰ ۚ ذَٰلِكَ بِأَنَّ مِنْهُمْ قِسِّيسِينَ وَرُهْبَانًا وَأَنَّهُمْ لَا يَسْتَكْبِرُونَ",
  },
  {
    id: "752",
    sura: "5",
    VerseIDAr: "83",
    ayatAR:
      "وَإِذَا سَمِعُوا مَا أُنْزِلَ إِلَى الرَّسُولِ تَرَىٰ أَعْيُنَهُمْ تَفِيضُ مِنَ الدَّمْعِ مِمَّا عَرَفُوا مِنَ الْحَقِّ ۖ يَقُولُونَ رَبَّنَا آمَنَّا فَاكْتُبْنَا مَعَ الشَّاهِدِينَ",
  },
  {
    id: "753",
    sura: "5",
    VerseIDAr: "84",
    ayatAR:
      "وَمَا لَنَا لَا نُؤْمِنُ بِاللَّهِ وَمَا جَاءَنَا مِنَ الْحَقِّ وَنَطْمَعُ أَنْ يُدْخِلَنَا رَبُّنَا مَعَ الْقَوْمِ الصَّالِحِينَ",
  },
  {
    id: "754",
    sura: "5",
    VerseIDAr: "85",
    ayatAR:
      "فَأَثَابَهُمُ اللَّهُ بِمَا قَالُوا جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ وَذَٰلِكَ جَزَاءُ الْمُحْسِنِينَ",
  },
  {
    id: "755",
    sura: "5",
    VerseIDAr: "86",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا أُولَٰئِكَ أَصْحَابُ الْجَحِيمِ",
  },
  {
    id: "756",
    sura: "5",
    VerseIDAr: "87",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تُحَرِّمُوا طَيِّبَاتِ مَا أَحَلَّ اللَّهُ لَكُمْ وَلَا تَعْتَدُوا ۚ إِنَّ اللَّهَ لَا يُحِبُّ الْمُعْتَدِينَ",
  },
  {
    id: "757",
    sura: "5",
    VerseIDAr: "88",
    ayatAR:
      "وَكُلُوا مِمَّا رَزَقَكُمُ اللَّهُ حَلَالًا طَيِّبًا ۚ وَاتَّقُوا اللَّهَ الَّذِي أَنْتُمْ بِهِ مُؤْمِنُونَ",
  },
  {
    id: "758",
    sura: "5",
    VerseIDAr: "89",
    ayatAR:
      "لَا يُؤَاخِذُكُمُ اللَّهُ بِاللَّغْوِ فِي أَيْمَانِكُمْ وَلَٰكِنْ يُؤَاخِذُكُمْ بِمَا عَقَّدْتُمُ الْأَيْمَانَ ۖ فَكَفَّارَتُهُ إِطْعَامُ عَشَرَةِ مَسَاكِينَ مِنْ أَوْسَطِ مَا تُطْعِمُونَ أَهْلِيكُمْ أَوْ كِسْوَتُهُمْ أَوْ تَحْرِيرُ رَقَبَةٍ ۖ فَمَنْ لَمْ يَجِدْ فَصِيَامُ ثَلَاثَةِ أَيَّامٍ ۚ ذَٰلِكَ كَفَّارَةُ أَيْمَانِكُمْ إِذَا حَلَفْتُمْ ۚ وَاحْفَظُوا أَيْمَانَكُمْ ۚ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمْ آيَاتِهِ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "759",
    sura: "5",
    VerseIDAr: "90",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنَّمَا الْخَمْرُ وَالْمَيْسِرُ وَالْأَنْصَابُ وَالْأَزْلَامُ رِجْسٌ مِنْ عَمَلِ الشَّيْطَانِ فَاجْتَنِبُوهُ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "760",
    sura: "5",
    VerseIDAr: "91",
    ayatAR:
      "إِنَّمَا يُرِيدُ الشَّيْطَانُ أَنْ يُوقِعَ بَيْنَكُمُ الْعَدَاوَةَ وَالْبَغْضَاءَ فِي الْخَمْرِ وَالْمَيْسِرِ وَيَصُدَّكُمْ عَنْ ذِكْرِ اللَّهِ وَعَنِ الصَّلَاةِ ۖ فَهَلْ أَنْتُمْ مُنْتَهُونَ",
  },
  {
    id: "761",
    sura: "5",
    VerseIDAr: "92",
    ayatAR:
      "وَأَطِيعُوا اللَّهَ وَأَطِيعُوا الرَّسُولَ وَاحْذَرُوا ۚ فَإِنْ تَوَلَّيْتُمْ فَاعْلَمُوا أَنَّمَا عَلَىٰ رَسُولِنَا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "762",
    sura: "5",
    VerseIDAr: "93",
    ayatAR:
      "لَيْسَ عَلَى الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ جُنَاحٌ فِيمَا طَعِمُوا إِذَا مَا اتَّقَوْا وَآمَنُوا وَعَمِلُوا الصَّالِحَاتِ ثُمَّ اتَّقَوْا وَآمَنُوا ثُمَّ اتَّقَوْا وَأَحْسَنُوا ۗ وَاللَّهُ يُحِبُّ الْمُحْسِنِينَ",
  },
  {
    id: "763",
    sura: "5",
    VerseIDAr: "94",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَيَبْلُوَنَّكُمُ اللَّهُ بِشَيْءٍ مِنَ الصَّيْدِ تَنَالُهُ أَيْدِيكُمْ وَرِمَاحُكُمْ لِيَعْلَمَ اللَّهُ مَنْ يَخَافُهُ بِالْغَيْبِ ۚ فَمَنِ اعْتَدَىٰ بَعْدَ ذَٰلِكَ فَلَهُ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "764",
    sura: "5",
    VerseIDAr: "95",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَقْتُلُوا الصَّيْدَ وَأَنْتُمْ حُرُمٌ ۚ وَمَنْ قَتَلَهُ مِنْكُمْ مُتَعَمِّدًا فَجَزَاءٌ مِثْلُ مَا قَتَلَ مِنَ النَّعَمِ يَحْكُمُ بِهِ ذَوَا عَدْلٍ مِنْكُمْ هَدْيًا بَالِغَ الْكَعْبَةِ أَوْ كَفَّارَةٌ طَعَامُ مَسَاكِينَ أَوْ عَدْلُ ذَٰلِكَ صِيَامًا لِيَذُوقَ وَبَالَ أَمْرِهِ ۗ عَفَا اللَّهُ عَمَّا سَلَفَ ۚ وَمَنْ عَادَ فَيَنْتَقِمُ اللَّهُ مِنْهُ ۗ وَاللَّهُ عَزِيزٌ ذُو انْتِقَامٍ",
  },
  {
    id: "765",
    sura: "5",
    VerseIDAr: "96",
    ayatAR:
      "أُحِلَّ لَكُمْ صَيْدُ الْبَحْرِ وَطَعَامُهُ مَتَاعًا لَكُمْ وَلِلسَّيَّارَةِ ۖ وَحُرِّمَ عَلَيْكُمْ صَيْدُ الْبَرِّ مَا دُمْتُمْ حُرُمًا ۗ وَاتَّقُوا اللَّهَ الَّذِي إِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "766",
    sura: "5",
    VerseIDAr: "97",
    ayatAR:
      "جَعَلَ اللَّهُ الْكَعْبَةَ الْبَيْتَ الْحَرَامَ قِيَامًا لِلنَّاسِ وَالشَّهْرَ الْحَرَامَ وَالْهَدْيَ وَالْقَلَائِدَ ۚ ذَٰلِكَ لِتَعْلَمُوا أَنَّ اللَّهَ يَعْلَمُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ وَأَنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "767",
    sura: "5",
    VerseIDAr: "98",
    ayatAR:
      "اعْلَمُوا أَنَّ اللَّهَ شَدِيدُ الْعِقَابِ وَأَنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "768",
    sura: "5",
    VerseIDAr: "99",
    ayatAR:
      "مَا عَلَى الرَّسُولِ إِلَّا الْبَلَاغُ ۗ وَاللَّهُ يَعْلَمُ مَا تُبْدُونَ وَمَا تَكْتُمُونَ",
  },
  {
    id: "769",
    sura: "5",
    VerseIDAr: "100",
    ayatAR:
      "قُلْ لَا يَسْتَوِي الْخَبِيثُ وَالطَّيِّبُ وَلَوْ أَعْجَبَكَ كَثْرَةُ الْخَبِيثِ ۚ فَاتَّقُوا اللَّهَ يَا أُولِي الْأَلْبَابِ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "770",
    sura: "5",
    VerseIDAr: "101",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَسْأَلُوا عَنْ أَشْيَاءَ إِنْ تُبْدَ لَكُمْ تَسُؤْكُمْ وَإِنْ تَسْأَلُوا عَنْهَا حِينَ يُنَزَّلُ الْقُرْآنُ تُبْدَ لَكُمْ عَفَا اللَّهُ عَنْهَا ۗ وَاللَّهُ غَفُورٌ حَلِيمٌ",
  },
  {
    id: "771",
    sura: "5",
    VerseIDAr: "102",
    ayatAR:
      "قَدْ سَأَلَهَا قَوْمٌ مِنْ قَبْلِكُمْ ثُمَّ أَصْبَحُوا بِهَا كَافِرِينَ",
  },
  {
    id: "772",
    sura: "5",
    VerseIDAr: "103",
    ayatAR:
      "مَا جَعَلَ اللَّهُ مِنْ بَحِيرَةٍ وَلَا سَائِبَةٍ وَلَا وَصِيلَةٍ وَلَا حَامٍ ۙ وَلَٰكِنَّ الَّذِينَ كَفَرُوا يَفْتَرُونَ عَلَى اللَّهِ الْكَذِبَ ۖ وَأَكْثَرُهُمْ لَا يَعْقِلُونَ",
  },
  {
    id: "773",
    sura: "5",
    VerseIDAr: "104",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ تَعَالَوْا إِلَىٰ مَا أَنْزَلَ اللَّهُ وَإِلَى الرَّسُولِ قَالُوا حَسْبُنَا مَا وَجَدْنَا عَلَيْهِ آبَاءَنَا ۚ أَوَلَوْ كَانَ آبَاؤُهُمْ لَا يَعْلَمُونَ شَيْئًا وَلَا يَهْتَدُونَ",
  },
  {
    id: "774",
    sura: "5",
    VerseIDAr: "105",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا عَلَيْكُمْ أَنْفُسَكُمْ ۖ لَا يَضُرُّكُمْ مَنْ ضَلَّ إِذَا اهْتَدَيْتُمْ ۚ إِلَى اللَّهِ مَرْجِعُكُمْ جَمِيعًا فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "775",
    sura: "5",
    VerseIDAr: "106",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا شَهَادَةُ بَيْنِكُمْ إِذَا حَضَرَ أَحَدَكُمُ الْمَوْتُ حِينَ الْوَصِيَّةِ اثْنَانِ ذَوَا عَدْلٍ مِنْكُمْ أَوْ آخَرَانِ مِنْ غَيْرِكُمْ إِنْ أَنْتُمْ ضَرَبْتُمْ فِي الْأَرْضِ فَأَصَابَتْكُمْ مُصِيبَةُ الْمَوْتِ ۚ تَحْبِسُونَهُمَا مِنْ بَعْدِ الصَّلَاةِ فَيُقْسِمَانِ بِاللَّهِ إِنِ ارْتَبْتُمْ لَا نَشْتَرِي بِهِ ثَمَنًا وَلَوْ كَانَ ذَا قُرْبَىٰ ۙ وَلَا نَكْتُمُ شَهَادَةَ اللَّهِ إِنَّا إِذًا لَمِنَ الْآثِمِينَ",
  },
  {
    id: "776",
    sura: "5",
    VerseIDAr: "107",
    ayatAR:
      "فَإِنْ عُثِرَ عَلَىٰ أَنَّهُمَا اسْتَحَقَّا إِثْمًا فَآخَرَانِ يَقُومَانِ مَقَامَهُمَا مِنَ الَّذِينَ اسْتَحَقَّ عَلَيْهِمُ الْأَوْلَيَانِ فَيُقْسِمَانِ بِاللَّهِ لَشَهَادَتُنَا أَحَقُّ مِنْ شَهَادَتِهِمَا وَمَا اعْتَدَيْنَا إِنَّا إِذًا لَمِنَ الظَّالِمِينَ",
  },
  {
    id: "777",
    sura: "5",
    VerseIDAr: "108",
    ayatAR:
      "ذَٰلِكَ أَدْنَىٰ أَنْ يَأْتُوا بِالشَّهَادَةِ عَلَىٰ وَجْهِهَا أَوْ يَخَافُوا أَنْ تُرَدَّ أَيْمَانٌ بَعْدَ أَيْمَانِهِمْ ۗ وَاتَّقُوا اللَّهَ وَاسْمَعُوا ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْفَاسِقِينَ",
  },
  {
    id: "778",
    sura: "5",
    VerseIDAr: "109",
    ayatAR:
      "يَوْمَ يَجْمَعُ اللَّهُ الرُّسُلَ فَيَقُولُ مَاذَا أُجِبْتُمْ ۖ قَالُوا لَا عِلْمَ لَنَا ۖ إِنَّكَ أَنْتَ عَلَّامُ الْغُيُوبِ",
  },
  {
    id: "779",
    sura: "5",
    VerseIDAr: "110",
    ayatAR:
      "إِذْ قَالَ اللَّهُ يَا عِيسَى ابْنَ مَرْيَمَ اذْكُرْ نِعْمَتِي عَلَيْكَ وَعَلَىٰ وَالِدَتِكَ إِذْ أَيَّدْتُكَ بِرُوحِ الْقُدُسِ تُكَلِّمُ النَّاسَ فِي الْمَهْدِ وَكَهْلًا ۖ وَإِذْ عَلَّمْتُكَ الْكِتَابَ وَالْحِكْمَةَ وَالتَّوْرَاةَ وَالْإِنْجِيلَ ۖ وَإِذْ تَخْلُقُ مِنَ الطِّينِ كَهَيْئَةِ الطَّيْرِ بِإِذْنِي فَتَنْفُخُ فِيهَا فَتَكُونُ طَيْرًا بِإِذْنِي ۖ وَتُبْرِئُ الْأَكْمَهَ وَالْأَبْرَصَ بِإِذْنِي ۖ وَإِذْ تُخْرِجُ الْمَوْتَىٰ بِإِذْنِي ۖ وَإِذْ كَفَفْتُ بَنِي إِسْرَائِيلَ عَنْكَ إِذْ جِئْتَهُمْ بِالْبَيِّنَاتِ فَقَالَ الَّذِينَ كَفَرُوا مِنْهُمْ إِنْ هَٰذَا إِلَّا سِحْرٌ مُبِينٌ",
  },
  {
    id: "780",
    sura: "5",
    VerseIDAr: "111",
    ayatAR:
      "وَإِذْ أَوْحَيْتُ إِلَى الْحَوَارِيِّينَ أَنْ آمِنُوا بِي وَبِرَسُولِي قَالُوا آمَنَّا وَاشْهَدْ بِأَنَّنَا مُسْلِمُونَ",
  },
  {
    id: "781",
    sura: "5",
    VerseIDAr: "112",
    ayatAR:
      "إِذْ قَالَ الْحَوَارِيُّونَ يَا عِيسَى ابْنَ مَرْيَمَ هَلْ يَسْتَطِيعُ رَبُّكَ أَنْ يُنَزِّلَ عَلَيْنَا مَائِدَةً مِنَ السَّمَاءِ ۖ قَالَ اتَّقُوا اللَّهَ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "782",
    sura: "5",
    VerseIDAr: "113",
    ayatAR:
      "قَالُوا نُرِيدُ أَنْ نَأْكُلَ مِنْهَا وَتَطْمَئِنَّ قُلُوبُنَا وَنَعْلَمَ أَنْ قَدْ صَدَقْتَنَا وَنَكُونَ عَلَيْهَا مِنَ الشَّاهِدِينَ",
  },
  {
    id: "783",
    sura: "5",
    VerseIDAr: "114",
    ayatAR:
      "قَالَ عِيسَى ابْنُ مَرْيَمَ اللَّهُمَّ رَبَّنَا أَنْزِلْ عَلَيْنَا مَائِدَةً مِنَ السَّمَاءِ تَكُونُ لَنَا عِيدًا لِأَوَّلِنَا وَآخِرِنَا وَآيَةً مِنْكَ ۖ وَارْزُقْنَا وَأَنْتَ خَيْرُ الرَّازِقِينَ",
  },
  {
    id: "784",
    sura: "5",
    VerseIDAr: "115",
    ayatAR:
      "قَالَ اللَّهُ إِنِّي مُنَزِّلُهَا عَلَيْكُمْ ۖ فَمَنْ يَكْفُرْ بَعْدُ مِنْكُمْ فَإِنِّي أُعَذِّبُهُ عَذَابًا لَا أُعَذِّبُهُ أَحَدًا مِنَ الْعَالَمِينَ",
  },
  {
    id: "785",
    sura: "5",
    VerseIDAr: "116",
    ayatAR:
      "وَإِذْ قَالَ اللَّهُ يَا عِيسَى ابْنَ مَرْيَمَ أَأَنْتَ قُلْتَ لِلنَّاسِ اتَّخِذُونِي وَأُمِّيَ إِلَٰهَيْنِ مِنْ دُونِ اللَّهِ ۖ قَالَ سُبْحَانَكَ مَا يَكُونُ لِي أَنْ أَقُولَ مَا لَيْسَ لِي بِحَقٍّ ۚ إِنْ كُنْتُ قُلْتُهُ فَقَدْ عَلِمْتَهُ ۚ تَعْلَمُ مَا فِي نَفْسِي وَلَا أَعْلَمُ مَا فِي نَفْسِكَ ۚ إِنَّكَ أَنْتَ عَلَّامُ الْغُيُوبِ",
  },
  {
    id: "786",
    sura: "5",
    VerseIDAr: "117",
    ayatAR:
      "مَا قُلْتُ لَهُمْ إِلَّا مَا أَمَرْتَنِي بِهِ أَنِ اعْبُدُوا اللَّهَ رَبِّي وَرَبَّكُمْ ۚ وَكُنْتُ عَلَيْهِمْ شَهِيدًا مَا دُمْتُ فِيهِمْ ۖ فَلَمَّا تَوَفَّيْتَنِي كُنْتَ أَنْتَ الرَّقِيبَ عَلَيْهِمْ ۚ وَأَنْتَ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "787",
    sura: "5",
    VerseIDAr: "118",
    ayatAR:
      "إِنْ تُعَذِّبْهُمْ فَإِنَّهُمْ عِبَادُكَ ۖ وَإِنْ تَغْفِرْ لَهُمْ فَإِنَّكَ أَنْتَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "788",
    sura: "5",
    VerseIDAr: "119",
    ayatAR:
      "قَالَ اللَّهُ هَٰذَا يَوْمُ يَنْفَعُ الصَّادِقِينَ صِدْقُهُمْ ۚ لَهُمْ جَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۚ رَضِيَ اللَّهُ عَنْهُمْ وَرَضُوا عَنْهُ ۚ ذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "789",
    sura: "5",
    VerseIDAr: "120",
    ayatAR:
      "لِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا فِيهِنَّ ۚ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "790",
    sura: "6",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْحَمْدُ لِلَّهِ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَجَعَلَ الظُّلُمَاتِ وَالنُّورَ ۖ ثُمَّ الَّذِينَ كَفَرُوا بِرَبِّهِمْ يَعْدِلُونَ",
  },
  {
    id: "791",
    sura: "6",
    VerseIDAr: "2",
    ayatAR:
      "هُوَ الَّذِي خَلَقَكُمْ مِنْ طِينٍ ثُمَّ قَضَىٰ أَجَلًا ۖ وَأَجَلٌ مُسَمًّى عِنْدَهُ ۖ ثُمَّ أَنْتُمْ تَمْتَرُونَ",
  },
  {
    id: "792",
    sura: "6",
    VerseIDAr: "3",
    ayatAR:
      "وَهُوَ اللَّهُ فِي السَّمَاوَاتِ وَفِي الْأَرْضِ ۖ يَعْلَمُ سِرَّكُمْ وَجَهْرَكُمْ وَيَعْلَمُ مَا تَكْسِبُونَ",
  },
  {
    id: "793",
    sura: "6",
    VerseIDAr: "4",
    ayatAR:
      "وَمَا تَأْتِيهِمْ مِنْ آيَةٍ مِنْ آيَاتِ رَبِّهِمْ إِلَّا كَانُوا عَنْهَا مُعْرِضِينَ",
  },
  {
    id: "794",
    sura: "6",
    VerseIDAr: "5",
    ayatAR:
      "فَقَدْ كَذَّبُوا بِالْحَقِّ لَمَّا جَاءَهُمْ ۖ فَسَوْفَ يَأْتِيهِمْ أَنْبَاءُ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "795",
    sura: "6",
    VerseIDAr: "6",
    ayatAR:
      "أَلَمْ يَرَوْا كَمْ أَهْلَكْنَا مِنْ قَبْلِهِمْ مِنْ قَرْنٍ مَكَّنَّاهُمْ فِي الْأَرْضِ مَا لَمْ نُمَكِّنْ لَكُمْ وَأَرْسَلْنَا السَّمَاءَ عَلَيْهِمْ مِدْرَارًا وَجَعَلْنَا الْأَنْهَارَ تَجْرِي مِنْ تَحْتِهِمْ فَأَهْلَكْنَاهُمْ بِذُنُوبِهِمْ وَأَنْشَأْنَا مِنْ بَعْدِهِمْ قَرْنًا آخَرِينَ",
  },
  {
    id: "796",
    sura: "6",
    VerseIDAr: "7",
    ayatAR:
      "وَلَوْ نَزَّلْنَا عَلَيْكَ كِتَابًا فِي قِرْطَاسٍ فَلَمَسُوهُ بِأَيْدِيهِمْ لَقَالَ الَّذِينَ كَفَرُوا إِنْ هَٰذَا إِلَّا سِحْرٌ مُبِينٌ",
  },
  {
    id: "797",
    sura: "6",
    VerseIDAr: "8",
    ayatAR:
      "وَقَالُوا لَوْلَا أُنْزِلَ عَلَيْهِ مَلَكٌ ۖ وَلَوْ أَنْزَلْنَا مَلَكًا لَقُضِيَ الْأَمْرُ ثُمَّ لَا يُنْظَرُونَ",
  },
  {
    id: "798",
    sura: "6",
    VerseIDAr: "9",
    ayatAR:
      "وَلَوْ جَعَلْنَاهُ مَلَكًا لَجَعَلْنَاهُ رَجُلًا وَلَلَبَسْنَا عَلَيْهِمْ مَا يَلْبِسُونَ",
  },
  {
    id: "799",
    sura: "6",
    VerseIDAr: "10",
    ayatAR:
      "وَلَقَدِ اسْتُهْزِئَ بِرُسُلٍ مِنْ قَبْلِكَ فَحَاقَ بِالَّذِينَ سَخِرُوا مِنْهُمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "800",
    sura: "6",
    VerseIDAr: "11",
    ayatAR:
      "قُلْ سِيرُوا فِي الْأَرْضِ ثُمَّ انْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الْمُكَذِّبِينَ",
  },
  {
    id: "801",
    sura: "6",
    VerseIDAr: "12",
    ayatAR:
      "قُلْ لِمَنْ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ قُلْ لِلَّهِ ۚ كَتَبَ عَلَىٰ نَفْسِهِ الرَّحْمَةَ ۚ لَيَجْمَعَنَّكُمْ إِلَىٰ يَوْمِ الْقِيَامَةِ لَا رَيْبَ فِيهِ ۚ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ فَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "802",
    sura: "6",
    VerseIDAr: "13",
    ayatAR:
      "وَلَهُ مَا سَكَنَ فِي اللَّيْلِ وَالنَّهَارِ ۚ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "803",
    sura: "6",
    VerseIDAr: "14",
    ayatAR:
      "قُلْ أَغَيْرَ اللَّهِ أَتَّخِذُ وَلِيًّا فَاطِرِ السَّمَاوَاتِ وَالْأَرْضِ وَهُوَ يُطْعِمُ وَلَا يُطْعَمُ ۗ قُلْ إِنِّي أُمِرْتُ أَنْ أَكُونَ أَوَّلَ مَنْ أَسْلَمَ ۖ وَلَا تَكُونَنَّ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "804",
    sura: "6",
    VerseIDAr: "15",
    ayatAR: "قُلْ إِنِّي أَخَافُ إِنْ عَصَيْتُ رَبِّي عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "805",
    sura: "6",
    VerseIDAr: "16",
    ayatAR:
      "مَنْ يُصْرَفْ عَنْهُ يَوْمَئِذٍ فَقَدْ رَحِمَهُ ۚ وَذَٰلِكَ الْفَوْزُ الْمُبِينُ",
  },
  {
    id: "806",
    sura: "6",
    VerseIDAr: "17",
    ayatAR:
      "وَإِنْ يَمْسَسْكَ اللَّهُ بِضُرٍّ فَلَا كَاشِفَ لَهُ إِلَّا هُوَ ۖ وَإِنْ يَمْسَسْكَ بِخَيْرٍ فَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "807",
    sura: "6",
    VerseIDAr: "18",
    ayatAR: "وَهُوَ الْقَاهِرُ فَوْقَ عِبَادِهِ ۚ وَهُوَ الْحَكِيمُ الْخَبِيرُ",
  },
  {
    id: "808",
    sura: "6",
    VerseIDAr: "19",
    ayatAR:
      "قُلْ أَيُّ شَيْءٍ أَكْبَرُ شَهَادَةً ۖ قُلِ اللَّهُ ۖ شَهِيدٌ بَيْنِي وَبَيْنَكُمْ ۚ وَأُوحِيَ إِلَيَّ هَٰذَا الْقُرْآنُ لِأُنْذِرَكُمْ بِهِ وَمَنْ بَلَغَ ۚ أَئِنَّكُمْ لَتَشْهَدُونَ أَنَّ مَعَ اللَّهِ آلِهَةً أُخْرَىٰ ۚ قُلْ لَا أَشْهَدُ ۚ قُلْ إِنَّمَا هُوَ إِلَٰهٌ وَاحِدٌ وَإِنَّنِي بَرِيءٌ مِمَّا تُشْرِكُونَ",
  },
  {
    id: "809",
    sura: "6",
    VerseIDAr: "20",
    ayatAR:
      "الَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يَعْرِفُونَهُ كَمَا يَعْرِفُونَ أَبْنَاءَهُمُ ۘ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ فَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "810",
    sura: "6",
    VerseIDAr: "21",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَوْ كَذَّبَ بِآيَاتِهِ ۗ إِنَّهُ لَا يُفْلِحُ الظَّالِمُونَ",
  },
  {
    id: "811",
    sura: "6",
    VerseIDAr: "22",
    ayatAR:
      "وَيَوْمَ نَحْشُرُهُمْ جَمِيعًا ثُمَّ نَقُولُ لِلَّذِينَ أَشْرَكُوا أَيْنَ شُرَكَاؤُكُمُ الَّذِينَ كُنْتُمْ تَزْعُمُونَ",
  },
  {
    id: "812",
    sura: "6",
    VerseIDAr: "23",
    ayatAR:
      "ثُمَّ لَمْ تَكُنْ فِتْنَتُهُمْ إِلَّا أَنْ قَالُوا وَاللَّهِ رَبِّنَا مَا كُنَّا مُشْرِكِينَ",
  },
  {
    id: "813",
    sura: "6",
    VerseIDAr: "24",
    ayatAR:
      "انْظُرْ كَيْفَ كَذَبُوا عَلَىٰ أَنْفُسِهِمْ ۚ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "814",
    sura: "6",
    VerseIDAr: "25",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَسْتَمِعُ إِلَيْكَ ۖ وَجَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَنْ يَفْقَهُوهُ وَفِي آذَانِهِمْ وَقْرًا ۚ وَإِنْ يَرَوْا كُلَّ آيَةٍ لَا يُؤْمِنُوا بِهَا ۚ حَتَّىٰ إِذَا جَاءُوكَ يُجَادِلُونَكَ يَقُولُ الَّذِينَ كَفَرُوا إِنْ هَٰذَا إِلَّا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "815",
    sura: "6",
    VerseIDAr: "26",
    ayatAR:
      "وَهُمْ يَنْهَوْنَ عَنْهُ وَيَنْأَوْنَ عَنْهُ ۖ وَإِنْ يُهْلِكُونَ إِلَّا أَنْفُسَهُمْ وَمَا يَشْعُرُونَ",
  },
  {
    id: "816",
    sura: "6",
    VerseIDAr: "27",
    ayatAR:
      "وَلَوْ تَرَىٰ إِذْ وُقِفُوا عَلَى النَّارِ فَقَالُوا يَا لَيْتَنَا نُرَدُّ وَلَا نُكَذِّبَ بِآيَاتِ رَبِّنَا وَنَكُونَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "817",
    sura: "6",
    VerseIDAr: "28",
    ayatAR:
      "بَلْ بَدَا لَهُمْ مَا كَانُوا يُخْفُونَ مِنْ قَبْلُ ۖ وَلَوْ رُدُّوا لَعَادُوا لِمَا نُهُوا عَنْهُ وَإِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "818",
    sura: "6",
    VerseIDAr: "29",
    ayatAR:
      "وَقَالُوا إِنْ هِيَ إِلَّا حَيَاتُنَا الدُّنْيَا وَمَا نَحْنُ بِمَبْعُوثِينَ",
  },
  {
    id: "819",
    sura: "6",
    VerseIDAr: "30",
    ayatAR:
      "وَلَوْ تَرَىٰ إِذْ وُقِفُوا عَلَىٰ رَبِّهِمْ ۚ قَالَ أَلَيْسَ هَٰذَا بِالْحَقِّ ۚ قَالُوا بَلَىٰ وَرَبِّنَا ۚ قَالَ فَذُوقُوا الْعَذَابَ بِمَا كُنْتُمْ تَكْفُرُونَ",
  },
  {
    id: "820",
    sura: "6",
    VerseIDAr: "31",
    ayatAR:
      "قَدْ خَسِرَ الَّذِينَ كَذَّبُوا بِلِقَاءِ اللَّهِ ۖ حَتَّىٰ إِذَا جَاءَتْهُمُ السَّاعَةُ بَغْتَةً قَالُوا يَا حَسْرَتَنَا عَلَىٰ مَا فَرَّطْنَا فِيهَا وَهُمْ يَحْمِلُونَ أَوْزَارَهُمْ عَلَىٰ ظُهُورِهِمْ ۚ أَلَا سَاءَ مَا يَزِرُونَ",
  },
  {
    id: "821",
    sura: "6",
    VerseIDAr: "32",
    ayatAR:
      "وَمَا الْحَيَاةُ الدُّنْيَا إِلَّا لَعِبٌ وَلَهْوٌ ۖ وَلَلدَّارُ الْآخِرَةُ خَيْرٌ لِلَّذِينَ يَتَّقُونَ ۗ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "822",
    sura: "6",
    VerseIDAr: "33",
    ayatAR:
      "قَدْ نَعْلَمُ إِنَّهُ لَيَحْزُنُكَ الَّذِي يَقُولُونَ ۖ فَإِنَّهُمْ لَا يُكَذِّبُونَكَ وَلَٰكِنَّ الظَّالِمِينَ بِآيَاتِ اللَّهِ يَجْحَدُونَ",
  },
  {
    id: "823",
    sura: "6",
    VerseIDAr: "34",
    ayatAR:
      "وَلَقَدْ كُذِّبَتْ رُسُلٌ مِنْ قَبْلِكَ فَصَبَرُوا عَلَىٰ مَا كُذِّبُوا وَأُوذُوا حَتَّىٰ أَتَاهُمْ نَصْرُنَا ۚ وَلَا مُبَدِّلَ لِكَلِمَاتِ اللَّهِ ۚ وَلَقَدْ جَاءَكَ مِنْ نَبَإِ الْمُرْسَلِينَ",
  },
  {
    id: "824",
    sura: "6",
    VerseIDAr: "35",
    ayatAR:
      "وَإِنْ كَانَ كَبُرَ عَلَيْكَ إِعْرَاضُهُمْ فَإِنِ اسْتَطَعْتَ أَنْ تَبْتَغِيَ نَفَقًا فِي الْأَرْضِ أَوْ سُلَّمًا فِي السَّمَاءِ فَتَأْتِيَهُمْ بِآيَةٍ ۚ وَلَوْ شَاءَ اللَّهُ لَجَمَعَهُمْ عَلَى الْهُدَىٰ ۚ فَلَا تَكُونَنَّ مِنَ الْجَاهِلِينَ",
  },
  {
    id: "825",
    sura: "6",
    VerseIDAr: "36",
    ayatAR:
      "إِنَّمَا يَسْتَجِيبُ الَّذِينَ يَسْمَعُونَ ۘ وَالْمَوْتَىٰ يَبْعَثُهُمُ اللَّهُ ثُمَّ إِلَيْهِ يُرْجَعُونَ",
  },
  {
    id: "826",
    sura: "6",
    VerseIDAr: "37",
    ayatAR:
      "وَقَالُوا لَوْلَا نُزِّلَ عَلَيْهِ آيَةٌ مِنْ رَبِّهِ ۚ قُلْ إِنَّ اللَّهَ قَادِرٌ عَلَىٰ أَنْ يُنَزِّلَ آيَةً وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "827",
    sura: "6",
    VerseIDAr: "38",
    ayatAR:
      "وَمَا مِنْ دَابَّةٍ فِي الْأَرْضِ وَلَا طَائِرٍ يَطِيرُ بِجَنَاحَيْهِ إِلَّا أُمَمٌ أَمْثَالُكُمْ ۚ مَا فَرَّطْنَا فِي الْكِتَابِ مِنْ شَيْءٍ ۚ ثُمَّ إِلَىٰ رَبِّهِمْ يُحْشَرُونَ",
  },
  {
    id: "828",
    sura: "6",
    VerseIDAr: "39",
    ayatAR:
      "وَالَّذِينَ كَذَّبُوا بِآيَاتِنَا صُمٌّ وَبُكْمٌ فِي الظُّلُمَاتِ ۗ مَنْ يَشَإِ اللَّهُ يُضْلِلْهُ وَمَنْ يَشَأْ يَجْعَلْهُ عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "829",
    sura: "6",
    VerseIDAr: "40",
    ayatAR:
      "قُلْ أَرَأَيْتَكُمْ إِنْ أَتَاكُمْ عَذَابُ اللَّهِ أَوْ أَتَتْكُمُ السَّاعَةُ أَغَيْرَ اللَّهِ تَدْعُونَ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "830",
    sura: "6",
    VerseIDAr: "41",
    ayatAR:
      "بَلْ إِيَّاهُ تَدْعُونَ فَيَكْشِفُ مَا تَدْعُونَ إِلَيْهِ إِنْ شَاءَ وَتَنْسَوْنَ مَا تُشْرِكُونَ",
  },
  {
    id: "831",
    sura: "6",
    VerseIDAr: "42",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا إِلَىٰ أُمَمٍ مِنْ قَبْلِكَ فَأَخَذْنَاهُمْ بِالْبَأْسَاءِ وَالضَّرَّاءِ لَعَلَّهُمْ يَتَضَرَّعُونَ",
  },
  {
    id: "832",
    sura: "6",
    VerseIDAr: "43",
    ayatAR:
      "فَلَوْلَا إِذْ جَاءَهُمْ بَأْسُنَا تَضَرَّعُوا وَلَٰكِنْ قَسَتْ قُلُوبُهُمْ وَزَيَّنَ لَهُمُ الشَّيْطَانُ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "833",
    sura: "6",
    VerseIDAr: "44",
    ayatAR:
      "فَلَمَّا نَسُوا مَا ذُكِّرُوا بِهِ فَتَحْنَا عَلَيْهِمْ أَبْوَابَ كُلِّ شَيْءٍ حَتَّىٰ إِذَا فَرِحُوا بِمَا أُوتُوا أَخَذْنَاهُمْ بَغْتَةً فَإِذَا هُمْ مُبْلِسُونَ",
  },
  {
    id: "834",
    sura: "6",
    VerseIDAr: "45",
    ayatAR:
      "فَقُطِعَ دَابِرُ الْقَوْمِ الَّذِينَ ظَلَمُوا ۚ وَالْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "835",
    sura: "6",
    VerseIDAr: "46",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ أَخَذَ اللَّهُ سَمْعَكُمْ وَأَبْصَارَكُمْ وَخَتَمَ عَلَىٰ قُلُوبِكُمْ مَنْ إِلَٰهٌ غَيْرُ اللَّهِ يَأْتِيكُمْ بِهِ ۗ انْظُرْ كَيْفَ نُصَرِّفُ الْآيَاتِ ثُمَّ هُمْ يَصْدِفُونَ",
  },
  {
    id: "836",
    sura: "6",
    VerseIDAr: "47",
    ayatAR:
      "قُلْ أَرَأَيْتَكُمْ إِنْ أَتَاكُمْ عَذَابُ اللَّهِ بَغْتَةً أَوْ جَهْرَةً هَلْ يُهْلَكُ إِلَّا الْقَوْمُ الظَّالِمُونَ",
  },
  {
    id: "837",
    sura: "6",
    VerseIDAr: "48",
    ayatAR:
      "وَمَا نُرْسِلُ الْمُرْسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنْذِرِينَ ۖ فَمَنْ آمَنَ وَأَصْلَحَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "838",
    sura: "6",
    VerseIDAr: "49",
    ayatAR:
      "وَالَّذِينَ كَذَّبُوا بِآيَاتِنَا يَمَسُّهُمُ الْعَذَابُ بِمَا كَانُوا يَفْسُقُونَ",
  },
  {
    id: "839",
    sura: "6",
    VerseIDAr: "50",
    ayatAR:
      "قُلْ لَا أَقُولُ لَكُمْ عِنْدِي خَزَائِنُ اللَّهِ وَلَا أَعْلَمُ الْغَيْبَ وَلَا أَقُولُ لَكُمْ إِنِّي مَلَكٌ ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰ إِلَيَّ ۚ قُلْ هَلْ يَسْتَوِي الْأَعْمَىٰ وَالْبَصِيرُ ۚ أَفَلَا تَتَفَكَّرُونَ",
  },
  {
    id: "840",
    sura: "6",
    VerseIDAr: "51",
    ayatAR:
      "وَأَنْذِرْ بِهِ الَّذِينَ يَخَافُونَ أَنْ يُحْشَرُوا إِلَىٰ رَبِّهِمْ ۙ لَيْسَ لَهُمْ مِنْ دُونِهِ وَلِيٌّ وَلَا شَفِيعٌ لَعَلَّهُمْ يَتَّقُونَ",
  },
  {
    id: "841",
    sura: "6",
    VerseIDAr: "52",
    ayatAR:
      "وَلَا تَطْرُدِ الَّذِينَ يَدْعُونَ رَبَّهُمْ بِالْغَدَاةِ وَالْعَشِيِّ يُرِيدُونَ وَجْهَهُ ۖ مَا عَلَيْكَ مِنْ حِسَابِهِمْ مِنْ شَيْءٍ وَمَا مِنْ حِسَابِكَ عَلَيْهِمْ مِنْ شَيْءٍ فَتَطْرُدَهُمْ فَتَكُونَ مِنَ الظَّالِمِينَ",
  },
  {
    id: "842",
    sura: "6",
    VerseIDAr: "53",
    ayatAR:
      "وَكَذَٰلِكَ فَتَنَّا بَعْضَهُمْ بِبَعْضٍ لِيَقُولُوا أَهَٰؤُلَاءِ مَنَّ اللَّهُ عَلَيْهِمْ مِنْ بَيْنِنَا ۗ أَلَيْسَ اللَّهُ بِأَعْلَمَ بِالشَّاكِرِينَ",
  },
  {
    id: "843",
    sura: "6",
    VerseIDAr: "54",
    ayatAR:
      "وَإِذَا جَاءَكَ الَّذِينَ يُؤْمِنُونَ بِآيَاتِنَا فَقُلْ سَلَامٌ عَلَيْكُمْ ۖ كَتَبَ رَبُّكُمْ عَلَىٰ نَفْسِهِ الرَّحْمَةَ ۖ أَنَّهُ مَنْ عَمِلَ مِنْكُمْ سُوءًا بِجَهَالَةٍ ثُمَّ تَابَ مِنْ بَعْدِهِ وَأَصْلَحَ فَأَنَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "844",
    sura: "6",
    VerseIDAr: "55",
    ayatAR:
      "وَكَذَٰلِكَ نُفَصِّلُ الْآيَاتِ وَلِتَسْتَبِينَ سَبِيلُ الْمُجْرِمِينَ",
  },
  {
    id: "845",
    sura: "6",
    VerseIDAr: "56",
    ayatAR:
      "قُلْ إِنِّي نُهِيتُ أَنْ أَعْبُدَ الَّذِينَ تَدْعُونَ مِنْ دُونِ اللَّهِ ۚ قُلْ لَا أَتَّبِعُ أَهْوَاءَكُمْ ۙ قَدْ ضَلَلْتُ إِذًا وَمَا أَنَا مِنَ الْمُهْتَدِينَ",
  },
  {
    id: "846",
    sura: "6",
    VerseIDAr: "57",
    ayatAR:
      "قُلْ إِنِّي عَلَىٰ بَيِّنَةٍ مِنْ رَبِّي وَكَذَّبْتُمْ بِهِ ۚ مَا عِنْدِي مَا تَسْتَعْجِلُونَ بِهِ ۚ إِنِ الْحُكْمُ إِلَّا لِلَّهِ ۖ يَقُصُّ الْحَقَّ ۖ وَهُوَ خَيْرُ الْفَاصِلِينَ",
  },
  {
    id: "847",
    sura: "6",
    VerseIDAr: "58",
    ayatAR:
      "قُلْ لَوْ أَنَّ عِنْدِي مَا تَسْتَعْجِلُونَ بِهِ لَقُضِيَ الْأَمْرُ بَيْنِي وَبَيْنَكُمْ ۗ وَاللَّهُ أَعْلَمُ بِالظَّالِمِينَ",
  },
  {
    id: "848",
    sura: "6",
    VerseIDAr: "59",
    ayatAR:
      "وَعِنْدَهُ مَفَاتِحُ الْغَيْبِ لَا يَعْلَمُهَا إِلَّا هُوَ ۚ وَيَعْلَمُ مَا فِي الْبَرِّ وَالْبَحْرِ ۚ وَمَا تَسْقُطُ مِنْ وَرَقَةٍ إِلَّا يَعْلَمُهَا وَلَا حَبَّةٍ فِي ظُلُمَاتِ الْأَرْضِ وَلَا رَطْبٍ وَلَا يَابِسٍ إِلَّا فِي كِتَابٍ مُبِينٍ",
  },
  {
    id: "849",
    sura: "6",
    VerseIDAr: "60",
    ayatAR:
      "وَهُوَ الَّذِي يَتَوَفَّاكُمْ بِاللَّيْلِ وَيَعْلَمُ مَا جَرَحْتُمْ بِالنَّهَارِ ثُمَّ يَبْعَثُكُمْ فِيهِ لِيُقْضَىٰ أَجَلٌ مُسَمًّى ۖ ثُمَّ إِلَيْهِ مَرْجِعُكُمْ ثُمَّ يُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "850",
    sura: "6",
    VerseIDAr: "61",
    ayatAR:
      "وَهُوَ الْقَاهِرُ فَوْقَ عِبَادِهِ ۖ وَيُرْسِلُ عَلَيْكُمْ حَفَظَةً حَتَّىٰ إِذَا جَاءَ أَحَدَكُمُ الْمَوْتُ تَوَفَّتْهُ رُسُلُنَا وَهُمْ لَا يُفَرِّطُونَ",
  },
  {
    id: "851",
    sura: "6",
    VerseIDAr: "62",
    ayatAR:
      "ثُمَّ رُدُّوا إِلَى اللَّهِ مَوْلَاهُمُ الْحَقِّ ۚ أَلَا لَهُ الْحُكْمُ وَهُوَ أَسْرَعُ الْحَاسِبِينَ",
  },
  {
    id: "852",
    sura: "6",
    VerseIDAr: "63",
    ayatAR:
      "قُلْ مَنْ يُنَجِّيكُمْ مِنْ ظُلُمَاتِ الْبَرِّ وَالْبَحْرِ تَدْعُونَهُ تَضَرُّعًا وَخُفْيَةً لَئِنْ أَنْجَانَا مِنْ هَٰذِهِ لَنَكُونَنَّ مِنَ الشَّاكِرِينَ",
  },
  {
    id: "853",
    sura: "6",
    VerseIDAr: "64",
    ayatAR:
      "قُلِ اللَّهُ يُنَجِّيكُمْ مِنْهَا وَمِنْ كُلِّ كَرْبٍ ثُمَّ أَنْتُمْ تُشْرِكُونَ",
  },
  {
    id: "854",
    sura: "6",
    VerseIDAr: "65",
    ayatAR:
      "قُلْ هُوَ الْقَادِرُ عَلَىٰ أَنْ يَبْعَثَ عَلَيْكُمْ عَذَابًا مِنْ فَوْقِكُمْ أَوْ مِنْ تَحْتِ أَرْجُلِكُمْ أَوْ يَلْبِسَكُمْ شِيَعًا وَيُذِيقَ بَعْضَكُمْ بَأْسَ بَعْضٍ ۗ انْظُرْ كَيْفَ نُصَرِّفُ الْآيَاتِ لَعَلَّهُمْ يَفْقَهُونَ",
  },
  {
    id: "855",
    sura: "6",
    VerseIDAr: "66",
    ayatAR:
      "وَكَذَّبَ بِهِ قَوْمُكَ وَهُوَ الْحَقُّ ۚ قُلْ لَسْتُ عَلَيْكُمْ بِوَكِيلٍ",
  },
  {
    id: "856",
    sura: "6",
    VerseIDAr: "67",
    ayatAR: "لِكُلِّ نَبَإٍ مُسْتَقَرٌّ ۚ وَسَوْفَ تَعْلَمُونَ",
  },
  {
    id: "857",
    sura: "6",
    VerseIDAr: "68",
    ayatAR:
      "وَإِذَا رَأَيْتَ الَّذِينَ يَخُوضُونَ فِي آيَاتِنَا فَأَعْرِضْ عَنْهُمْ حَتَّىٰ يَخُوضُوا فِي حَدِيثٍ غَيْرِهِ ۚ وَإِمَّا يُنْسِيَنَّكَ الشَّيْطَانُ فَلَا تَقْعُدْ بَعْدَ الذِّكْرَىٰ مَعَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "858",
    sura: "6",
    VerseIDAr: "69",
    ayatAR:
      "وَمَا عَلَى الَّذِينَ يَتَّقُونَ مِنْ حِسَابِهِمْ مِنْ شَيْءٍ وَلَٰكِنْ ذِكْرَىٰ لَعَلَّهُمْ يَتَّقُونَ",
  },
  {
    id: "859",
    sura: "6",
    VerseIDAr: "70",
    ayatAR:
      "وَذَرِ الَّذِينَ اتَّخَذُوا دِينَهُمْ لَعِبًا وَلَهْوًا وَغَرَّتْهُمُ الْحَيَاةُ الدُّنْيَا ۚ وَذَكِّرْ بِهِ أَنْ تُبْسَلَ نَفْسٌ بِمَا كَسَبَتْ لَيْسَ لَهَا مِنْ دُونِ اللَّهِ وَلِيٌّ وَلَا شَفِيعٌ وَإِنْ تَعْدِلْ كُلَّ عَدْلٍ لَا يُؤْخَذْ مِنْهَا ۗ أُولَٰئِكَ الَّذِينَ أُبْسِلُوا بِمَا كَسَبُوا ۖ لَهُمْ شَرَابٌ مِنْ حَمِيمٍ وَعَذَابٌ أَلِيمٌ بِمَا كَانُوا يَكْفُرُونَ",
  },
  {
    id: "860",
    sura: "6",
    VerseIDAr: "71",
    ayatAR:
      "قُلْ أَنَدْعُو مِنْ دُونِ اللَّهِ مَا لَا يَنْفَعُنَا وَلَا يَضُرُّنَا وَنُرَدُّ عَلَىٰ أَعْقَابِنَا بَعْدَ إِذْ هَدَانَا اللَّهُ كَالَّذِي اسْتَهْوَتْهُ الشَّيَاطِينُ فِي الْأَرْضِ حَيْرَانَ لَهُ أَصْحَابٌ يَدْعُونَهُ إِلَى الْهُدَى ائْتِنَا ۗ قُلْ إِنَّ هُدَى اللَّهِ هُوَ الْهُدَىٰ ۖ وَأُمِرْنَا لِنُسْلِمَ لِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "861",
    sura: "6",
    VerseIDAr: "72",
    ayatAR:
      "وَأَنْ أَقِيمُوا الصَّلَاةَ وَاتَّقُوهُ ۚ وَهُوَ الَّذِي إِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "862",
    sura: "6",
    VerseIDAr: "73",
    ayatAR:
      "وَهُوَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ ۖ وَيَوْمَ يَقُولُ كُنْ فَيَكُونُ ۚ قَوْلُهُ الْحَقُّ ۚ وَلَهُ الْمُلْكُ يَوْمَ يُنْفَخُ فِي الصُّورِ ۚ عَالِمُ الْغَيْبِ وَالشَّهَادَةِ ۚ وَهُوَ الْحَكِيمُ الْخَبِيرُ",
  },
  {
    id: "863",
    sura: "6",
    VerseIDAr: "74",
    ayatAR:
      "وَإِذْ قَالَ إِبْرَاهِيمُ لِأَبِيهِ آزَرَ أَتَتَّخِذُ أَصْنَامًا آلِهَةً ۖ إِنِّي أَرَاكَ وَقَوْمَكَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "864",
    sura: "6",
    VerseIDAr: "75",
    ayatAR:
      "وَكَذَٰلِكَ نُرِي إِبْرَاهِيمَ مَلَكُوتَ السَّمَاوَاتِ وَالْأَرْضِ وَلِيَكُونَ مِنَ الْمُوقِنِينَ",
  },
  {
    id: "865",
    sura: "6",
    VerseIDAr: "76",
    ayatAR:
      "فَلَمَّا جَنَّ عَلَيْهِ اللَّيْلُ رَأَىٰ كَوْكَبًا ۖ قَالَ هَٰذَا رَبِّي ۖ فَلَمَّا أَفَلَ قَالَ لَا أُحِبُّ الْآفِلِينَ",
  },
  {
    id: "866",
    sura: "6",
    VerseIDAr: "77",
    ayatAR:
      "فَلَمَّا رَأَى الْقَمَرَ بَازِغًا قَالَ هَٰذَا رَبِّي ۖ فَلَمَّا أَفَلَ قَالَ لَئِنْ لَمْ يَهْدِنِي رَبِّي لَأَكُونَنَّ مِنَ الْقَوْمِ الضَّالِّينَ",
  },
  {
    id: "867",
    sura: "6",
    VerseIDAr: "78",
    ayatAR:
      "فَلَمَّا رَأَى الشَّمْسَ بَازِغَةً قَالَ هَٰذَا رَبِّي هَٰذَا أَكْبَرُ ۖ فَلَمَّا أَفَلَتْ قَالَ يَا قَوْمِ إِنِّي بَرِيءٌ مِمَّا تُشْرِكُونَ",
  },
  {
    id: "868",
    sura: "6",
    VerseIDAr: "79",
    ayatAR:
      "إِنِّي وَجَّهْتُ وَجْهِيَ لِلَّذِي فَطَرَ السَّمَاوَاتِ وَالْأَرْضَ حَنِيفًا ۖ وَمَا أَنَا مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "869",
    sura: "6",
    VerseIDAr: "80",
    ayatAR:
      "وَحَاجَّهُ قَوْمُهُ ۚ قَالَ أَتُحَاجُّونِّي فِي اللَّهِ وَقَدْ هَدَانِ ۚ وَلَا أَخَافُ مَا تُشْرِكُونَ بِهِ إِلَّا أَنْ يَشَاءَ رَبِّي شَيْئًا ۗ وَسِعَ رَبِّي كُلَّ شَيْءٍ عِلْمًا ۗ أَفَلَا تَتَذَكَّرُونَ",
  },
  {
    id: "870",
    sura: "6",
    VerseIDAr: "81",
    ayatAR:
      "وَكَيْفَ أَخَافُ مَا أَشْرَكْتُمْ وَلَا تَخَافُونَ أَنَّكُمْ أَشْرَكْتُمْ بِاللَّهِ مَا لَمْ يُنَزِّلْ بِهِ عَلَيْكُمْ سُلْطَانًا ۚ فَأَيُّ الْفَرِيقَيْنِ أَحَقُّ بِالْأَمْنِ ۖ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "871",
    sura: "6",
    VerseIDAr: "82",
    ayatAR:
      "الَّذِينَ آمَنُوا وَلَمْ يَلْبِسُوا إِيمَانَهُمْ بِظُلْمٍ أُولَٰئِكَ لَهُمُ الْأَمْنُ وَهُمْ مُهْتَدُونَ",
  },
  {
    id: "872",
    sura: "6",
    VerseIDAr: "83",
    ayatAR:
      "وَتِلْكَ حُجَّتُنَا آتَيْنَاهَا إِبْرَاهِيمَ عَلَىٰ قَوْمِهِ ۚ نَرْفَعُ دَرَجَاتٍ مَنْ نَشَاءُ ۗ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٌ",
  },
  {
    id: "873",
    sura: "6",
    VerseIDAr: "84",
    ayatAR:
      "وَوَهَبْنَا لَهُ إِسْحَاقَ وَيَعْقُوبَ ۚ كُلًّا هَدَيْنَا ۚ وَنُوحًا هَدَيْنَا مِنْ قَبْلُ ۖ وَمِنْ ذُرِّيَّتِهِ دَاوُودَ وَسُلَيْمَانَ وَأَيُّوبَ وَيُوسُفَ وَمُوسَىٰ وَهَارُونَ ۚ وَكَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "874",
    sura: "6",
    VerseIDAr: "85",
    ayatAR:
      "وَزَكَرِيَّا وَيَحْيَىٰ وَعِيسَىٰ وَإِلْيَاسَ ۖ كُلٌّ مِنَ الصَّالِحِينَ",
  },
  {
    id: "875",
    sura: "6",
    VerseIDAr: "86",
    ayatAR:
      "وَإِسْمَاعِيلَ وَالْيَسَعَ وَيُونُسَ وَلُوطًا ۚ وَكُلًّا فَضَّلْنَا عَلَى الْعَالَمِينَ",
  },
  {
    id: "876",
    sura: "6",
    VerseIDAr: "87",
    ayatAR:
      "وَمِنْ آبَائِهِمْ وَذُرِّيَّاتِهِمْ وَإِخْوَانِهِمْ ۖ وَاجْتَبَيْنَاهُمْ وَهَدَيْنَاهُمْ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "877",
    sura: "6",
    VerseIDAr: "88",
    ayatAR:
      "ذَٰلِكَ هُدَى اللَّهِ يَهْدِي بِهِ مَنْ يَشَاءُ مِنْ عِبَادِهِ ۚ وَلَوْ أَشْرَكُوا لَحَبِطَ عَنْهُمْ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "878",
    sura: "6",
    VerseIDAr: "89",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ آتَيْنَاهُمُ الْكِتَابَ وَالْحُكْمَ وَالنُّبُوَّةَ ۚ فَإِنْ يَكْفُرْ بِهَا هَٰؤُلَاءِ فَقَدْ وَكَّلْنَا بِهَا قَوْمًا لَيْسُوا بِهَا بِكَافِرِينَ",
  },
  {
    id: "879",
    sura: "6",
    VerseIDAr: "90",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ هَدَى اللَّهُ ۖ فَبِهُدَاهُمُ اقْتَدِهْ ۗ قُلْ لَا أَسْأَلُكُمْ عَلَيْهِ أَجْرًا ۖ إِنْ هُوَ إِلَّا ذِكْرَىٰ لِلْعَالَمِينَ",
  },
  {
    id: "880",
    sura: "6",
    VerseIDAr: "91",
    ayatAR:
      "وَمَا قَدَرُوا اللَّهَ حَقَّ قَدْرِهِ إِذْ قَالُوا مَا أَنْزَلَ اللَّهُ عَلَىٰ بَشَرٍ مِنْ شَيْءٍ ۗ قُلْ مَنْ أَنْزَلَ الْكِتَابَ الَّذِي جَاءَ بِهِ مُوسَىٰ نُورًا وَهُدًى لِلنَّاسِ ۖ تَجْعَلُونَهُ قَرَاطِيسَ تُبْدُونَهَا وَتُخْفُونَ كَثِيرًا ۖ وَعُلِّمْتُمْ مَا لَمْ تَعْلَمُوا أَنْتُمْ وَلَا آبَاؤُكُمْ ۖ قُلِ اللَّهُ ۖ ثُمَّ ذَرْهُمْ فِي خَوْضِهِمْ يَلْعَبُونَ",
  },
  {
    id: "881",
    sura: "6",
    VerseIDAr: "92",
    ayatAR:
      "وَهَٰذَا كِتَابٌ أَنْزَلْنَاهُ مُبَارَكٌ مُصَدِّقُ الَّذِي بَيْنَ يَدَيْهِ وَلِتُنْذِرَ أُمَّ الْقُرَىٰ وَمَنْ حَوْلَهَا ۚ وَالَّذِينَ يُؤْمِنُونَ بِالْآخِرَةِ يُؤْمِنُونَ بِهِ ۖ وَهُمْ عَلَىٰ صَلَاتِهِمْ يُحَافِظُونَ",
  },
  {
    id: "882",
    sura: "6",
    VerseIDAr: "93",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَوْ قَالَ أُوحِيَ إِلَيَّ وَلَمْ يُوحَ إِلَيْهِ شَيْءٌ وَمَنْ قَالَ سَأُنْزِلُ مِثْلَ مَا أَنْزَلَ اللَّهُ ۗ وَلَوْ تَرَىٰ إِذِ الظَّالِمُونَ فِي غَمَرَاتِ الْمَوْتِ وَالْمَلَائِكَةُ بَاسِطُو أَيْدِيهِمْ أَخْرِجُوا أَنْفُسَكُمُ ۖ الْيَوْمَ تُجْزَوْنَ عَذَابَ الْهُونِ بِمَا كُنْتُمْ تَقُولُونَ عَلَى اللَّهِ غَيْرَ الْحَقِّ وَكُنْتُمْ عَنْ آيَاتِهِ تَسْتَكْبِرُونَ",
  },
  {
    id: "883",
    sura: "6",
    VerseIDAr: "94",
    ayatAR:
      "وَلَقَدْ جِئْتُمُونَا فُرَادَىٰ كَمَا خَلَقْنَاكُمْ أَوَّلَ مَرَّةٍ وَتَرَكْتُمْ مَا خَوَّلْنَاكُمْ وَرَاءَ ظُهُورِكُمْ ۖ وَمَا نَرَىٰ مَعَكُمْ شُفَعَاءَكُمُ الَّذِينَ زَعَمْتُمْ أَنَّهُمْ فِيكُمْ شُرَكَاءُ ۚ لَقَدْ تَقَطَّعَ بَيْنَكُمْ وَضَلَّ عَنْكُمْ مَا كُنْتُمْ تَزْعُمُونَ",
  },
  {
    id: "884",
    sura: "6",
    VerseIDAr: "95",
    ayatAR:
      "إِنَّ اللَّهَ فَالِقُ الْحَبِّ وَالنَّوَىٰ ۖ يُخْرِجُ الْحَيَّ مِنَ الْمَيِّتِ وَمُخْرِجُ الْمَيِّتِ مِنَ الْحَيِّ ۚ ذَٰلِكُمُ اللَّهُ ۖ فَأَنَّىٰ تُؤْفَكُونَ",
  },
  {
    id: "885",
    sura: "6",
    VerseIDAr: "96",
    ayatAR:
      "فَالِقُ الْإِصْبَاحِ وَجَعَلَ اللَّيْلَ سَكَنًا وَالشَّمْسَ وَالْقَمَرَ حُسْبَانًا ۚ ذَٰلِكَ تَقْدِيرُ الْعَزِيزِ الْعَلِيمِ",
  },
  {
    id: "886",
    sura: "6",
    VerseIDAr: "97",
    ayatAR:
      "وَهُوَ الَّذِي جَعَلَ لَكُمُ النُّجُومَ لِتَهْتَدُوا بِهَا فِي ظُلُمَاتِ الْبَرِّ وَالْبَحْرِ ۗ قَدْ فَصَّلْنَا الْآيَاتِ لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "887",
    sura: "6",
    VerseIDAr: "98",
    ayatAR:
      "وَهُوَ الَّذِي أَنْشَأَكُمْ مِنْ نَفْسٍ وَاحِدَةٍ فَمُسْتَقَرٌّ وَمُسْتَوْدَعٌ ۗ قَدْ فَصَّلْنَا الْآيَاتِ لِقَوْمٍ يَفْقَهُونَ",
  },
  {
    id: "888",
    sura: "6",
    VerseIDAr: "99",
    ayatAR:
      "وَهُوَ الَّذِي أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَخْرَجْنَا بِهِ نَبَاتَ كُلِّ شَيْءٍ فَأَخْرَجْنَا مِنْهُ خَضِرًا نُخْرِجُ مِنْهُ حَبًّا مُتَرَاكِبًا وَمِنَ النَّخْلِ مِنْ طَلْعِهَا قِنْوَانٌ دَانِيَةٌ وَجَنَّاتٍ مِنْ أَعْنَابٍ وَالزَّيْتُونَ وَالرُّمَّانَ مُشْتَبِهًا وَغَيْرَ مُتَشَابِهٍ ۗ انْظُرُوا إِلَىٰ ثَمَرِهِ إِذَا أَثْمَرَ وَيَنْعِهِ ۚ إِنَّ فِي ذَٰلِكُمْ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "889",
    sura: "6",
    VerseIDAr: "100",
    ayatAR:
      "وَجَعَلُوا لِلَّهِ شُرَكَاءَ الْجِنَّ وَخَلَقَهُمْ ۖ وَخَرَقُوا لَهُ بَنِينَ وَبَنَاتٍ بِغَيْرِ عِلْمٍ ۚ سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يَصِفُونَ",
  },
  {
    id: "890",
    sura: "6",
    VerseIDAr: "101",
    ayatAR:
      "بَدِيعُ السَّمَاوَاتِ وَالْأَرْضِ ۖ أَنَّىٰ يَكُونُ لَهُ وَلَدٌ وَلَمْ تَكُنْ لَهُ صَاحِبَةٌ ۖ وَخَلَقَ كُلَّ شَيْءٍ ۖ وَهُوَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "891",
    sura: "6",
    VerseIDAr: "102",
    ayatAR:
      "ذَٰلِكُمُ اللَّهُ رَبُّكُمْ ۖ لَا إِلَٰهَ إِلَّا هُوَ ۖ خَالِقُ كُلِّ شَيْءٍ فَاعْبُدُوهُ ۚ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ وَكِيلٌ",
  },
  {
    id: "892",
    sura: "6",
    VerseIDAr: "103",
    ayatAR:
      "لَا تُدْرِكُهُ الْأَبْصَارُ وَهُوَ يُدْرِكُ الْأَبْصَارَ ۖ وَهُوَ اللَّطِيفُ الْخَبِيرُ",
  },
  {
    id: "893",
    sura: "6",
    VerseIDAr: "104",
    ayatAR:
      "قَدْ جَاءَكُمْ بَصَائِرُ مِنْ رَبِّكُمْ ۖ فَمَنْ أَبْصَرَ فَلِنَفْسِهِ ۖ وَمَنْ عَمِيَ فَعَلَيْهَا ۚ وَمَا أَنَا عَلَيْكُمْ بِحَفِيظٍ",
  },
  {
    id: "894",
    sura: "6",
    VerseIDAr: "105",
    ayatAR:
      "وَكَذَٰلِكَ نُصَرِّفُ الْآيَاتِ وَلِيَقُولُوا دَرَسْتَ وَلِنُبَيِّنَهُ لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "895",
    sura: "6",
    VerseIDAr: "106",
    ayatAR:
      "اتَّبِعْ مَا أُوحِيَ إِلَيْكَ مِنْ رَبِّكَ ۖ لَا إِلَٰهَ إِلَّا هُوَ ۖ وَأَعْرِضْ عَنِ الْمُشْرِكِينَ",
  },
  {
    id: "896",
    sura: "6",
    VerseIDAr: "107",
    ayatAR:
      "وَلَوْ شَاءَ اللَّهُ مَا أَشْرَكُوا ۗ وَمَا جَعَلْنَاكَ عَلَيْهِمْ حَفِيظًا ۖ وَمَا أَنْتَ عَلَيْهِمْ بِوَكِيلٍ",
  },
  {
    id: "897",
    sura: "6",
    VerseIDAr: "108",
    ayatAR:
      "وَلَا تَسُبُّوا الَّذِينَ يَدْعُونَ مِنْ دُونِ اللَّهِ فَيَسُبُّوا اللَّهَ عَدْوًا بِغَيْرِ عِلْمٍ ۗ كَذَٰلِكَ زَيَّنَّا لِكُلِّ أُمَّةٍ عَمَلَهُمْ ثُمَّ إِلَىٰ رَبِّهِمْ مَرْجِعُهُمْ فَيُنَبِّئُهُمْ بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "898",
    sura: "6",
    VerseIDAr: "109",
    ayatAR:
      "وَأَقْسَمُوا بِاللَّهِ جَهْدَ أَيْمَانِهِمْ لَئِنْ جَاءَتْهُمْ آيَةٌ لَيُؤْمِنُنَّ بِهَا ۚ قُلْ إِنَّمَا الْآيَاتُ عِنْدَ اللَّهِ ۖ وَمَا يُشْعِرُكُمْ أَنَّهَا إِذَا جَاءَتْ لَا يُؤْمِنُونَ",
  },
  {
    id: "899",
    sura: "6",
    VerseIDAr: "110",
    ayatAR:
      "وَنُقَلِّبُ أَفْئِدَتَهُمْ وَأَبْصَارَهُمْ كَمَا لَمْ يُؤْمِنُوا بِهِ أَوَّلَ مَرَّةٍ وَنَذَرُهُمْ فِي طُغْيَانِهِمْ يَعْمَهُونَ",
  },
  {
    id: "900",
    sura: "6",
    VerseIDAr: "111",
    ayatAR:
      "وَلَوْ أَنَّنَا نَزَّلْنَا إِلَيْهِمُ الْمَلَائِكَةَ وَكَلَّمَهُمُ الْمَوْتَىٰ وَحَشَرْنَا عَلَيْهِمْ كُلَّ شَيْءٍ قُبُلًا مَا كَانُوا لِيُؤْمِنُوا إِلَّا أَنْ يَشَاءَ اللَّهُ وَلَٰكِنَّ أَكْثَرَهُمْ يَجْهَلُونَ",
  },
  {
    id: "901",
    sura: "6",
    VerseIDAr: "112",
    ayatAR:
      "وَكَذَٰلِكَ جَعَلْنَا لِكُلِّ نَبِيٍّ عَدُوًّا شَيَاطِينَ الْإِنْسِ وَالْجِنِّ يُوحِي بَعْضُهُمْ إِلَىٰ بَعْضٍ زُخْرُفَ الْقَوْلِ غُرُورًا ۚ وَلَوْ شَاءَ رَبُّكَ مَا فَعَلُوهُ ۖ فَذَرْهُمْ وَمَا يَفْتَرُونَ",
  },
  {
    id: "902",
    sura: "6",
    VerseIDAr: "113",
    ayatAR:
      "وَلِتَصْغَىٰ إِلَيْهِ أَفْئِدَةُ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ وَلِيَرْضَوْهُ وَلِيَقْتَرِفُوا مَا هُمْ مُقْتَرِفُونَ",
  },
  {
    id: "903",
    sura: "6",
    VerseIDAr: "114",
    ayatAR:
      "أَفَغَيْرَ اللَّهِ أَبْتَغِي حَكَمًا وَهُوَ الَّذِي أَنْزَلَ إِلَيْكُمُ الْكِتَابَ مُفَصَّلًا ۚ وَالَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يَعْلَمُونَ أَنَّهُ مُنَزَّلٌ مِنْ رَبِّكَ بِالْحَقِّ ۖ فَلَا تَكُونَنَّ مِنَ الْمُمْتَرِينَ",
  },
  {
    id: "904",
    sura: "6",
    VerseIDAr: "115",
    ayatAR:
      "وَتَمَّتْ كَلِمَتُ رَبِّكَ صِدْقًا وَعَدْلًا ۚ لَا مُبَدِّلَ لِكَلِمَاتِهِ ۚ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "905",
    sura: "6",
    VerseIDAr: "116",
    ayatAR:
      "وَإِنْ تُطِعْ أَكْثَرَ مَنْ فِي الْأَرْضِ يُضِلُّوكَ عَنْ سَبِيلِ اللَّهِ ۚ إِنْ يَتَّبِعُونَ إِلَّا الظَّنَّ وَإِنْ هُمْ إِلَّا يَخْرُصُونَ",
  },
  {
    id: "906",
    sura: "6",
    VerseIDAr: "117",
    ayatAR:
      "إِنَّ رَبَّكَ هُوَ أَعْلَمُ مَنْ يَضِلُّ عَنْ سَبِيلِهِ ۖ وَهُوَ أَعْلَمُ بِالْمُهْتَدِينَ",
  },
  {
    id: "907",
    sura: "6",
    VerseIDAr: "118",
    ayatAR:
      "فَكُلُوا مِمَّا ذُكِرَ اسْمُ اللَّهِ عَلَيْهِ إِنْ كُنْتُمْ بِآيَاتِهِ مُؤْمِنِينَ",
  },
  {
    id: "908",
    sura: "6",
    VerseIDAr: "119",
    ayatAR:
      "وَمَا لَكُمْ أَلَّا تَأْكُلُوا مِمَّا ذُكِرَ اسْمُ اللَّهِ عَلَيْهِ وَقَدْ فَصَّلَ لَكُمْ مَا حَرَّمَ عَلَيْكُمْ إِلَّا مَا اضْطُرِرْتُمْ إِلَيْهِ ۗ وَإِنَّ كَثِيرًا لَيُضِلُّونَ بِأَهْوَائِهِمْ بِغَيْرِ عِلْمٍ ۗ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِالْمُعْتَدِينَ",
  },
  {
    id: "909",
    sura: "6",
    VerseIDAr: "120",
    ayatAR:
      "وَذَرُوا ظَاهِرَ الْإِثْمِ وَبَاطِنَهُ ۚ إِنَّ الَّذِينَ يَكْسِبُونَ الْإِثْمَ سَيُجْزَوْنَ بِمَا كَانُوا يَقْتَرِفُونَ",
  },
  {
    id: "910",
    sura: "6",
    VerseIDAr: "121",
    ayatAR:
      "وَلَا تَأْكُلُوا مِمَّا لَمْ يُذْكَرِ اسْمُ اللَّهِ عَلَيْهِ وَإِنَّهُ لَفِسْقٌ ۗ وَإِنَّ الشَّيَاطِينَ لَيُوحُونَ إِلَىٰ أَوْلِيَائِهِمْ لِيُجَادِلُوكُمْ ۖ وَإِنْ أَطَعْتُمُوهُمْ إِنَّكُمْ لَمُشْرِكُونَ",
  },
  {
    id: "911",
    sura: "6",
    VerseIDAr: "122",
    ayatAR:
      "أَوَمَنْ كَانَ مَيْتًا فَأَحْيَيْنَاهُ وَجَعَلْنَا لَهُ نُورًا يَمْشِي بِهِ فِي النَّاسِ كَمَنْ مَثَلُهُ فِي الظُّلُمَاتِ لَيْسَ بِخَارِجٍ مِنْهَا ۚ كَذَٰلِكَ زُيِّنَ لِلْكَافِرِينَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "912",
    sura: "6",
    VerseIDAr: "123",
    ayatAR:
      "وَكَذَٰلِكَ جَعَلْنَا فِي كُلِّ قَرْيَةٍ أَكَابِرَ مُجْرِمِيهَا لِيَمْكُرُوا فِيهَا ۖ وَمَا يَمْكُرُونَ إِلَّا بِأَنْفُسِهِمْ وَمَا يَشْعُرُونَ",
  },
  {
    id: "913",
    sura: "6",
    VerseIDAr: "124",
    ayatAR:
      "وَإِذَا جَاءَتْهُمْ آيَةٌ قَالُوا لَنْ نُؤْمِنَ حَتَّىٰ نُؤْتَىٰ مِثْلَ مَا أُوتِيَ رُسُلُ اللَّهِ ۘ اللَّهُ أَعْلَمُ حَيْثُ يَجْعَلُ رِسَالَتَهُ ۗ سَيُصِيبُ الَّذِينَ أَجْرَمُوا صَغَارٌ عِنْدَ اللَّهِ وَعَذَابٌ شَدِيدٌ بِمَا كَانُوا يَمْكُرُونَ",
  },
  {
    id: "914",
    sura: "6",
    VerseIDAr: "125",
    ayatAR:
      "فَمَنْ يُرِدِ اللَّهُ أَنْ يَهْدِيَهُ يَشْرَحْ صَدْرَهُ لِلْإِسْلَامِ ۖ وَمَنْ يُرِدْ أَنْ يُضِلَّهُ يَجْعَلْ صَدْرَهُ ضَيِّقًا حَرَجًا كَأَنَّمَا يَصَّعَّدُ فِي السَّمَاءِ ۚ كَذَٰلِكَ يَجْعَلُ اللَّهُ الرِّجْسَ عَلَى الَّذِينَ لَا يُؤْمِنُونَ",
  },
  {
    id: "915",
    sura: "6",
    VerseIDAr: "126",
    ayatAR:
      "وَهَٰذَا صِرَاطُ رَبِّكَ مُسْتَقِيمًا ۗ قَدْ فَصَّلْنَا الْآيَاتِ لِقَوْمٍ يَذَّكَّرُونَ",
  },
  {
    id: "916",
    sura: "6",
    VerseIDAr: "127",
    ayatAR:
      "لَهُمْ دَارُ السَّلَامِ عِنْدَ رَبِّهِمْ ۖ وَهُوَ وَلِيُّهُمْ بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "917",
    sura: "6",
    VerseIDAr: "128",
    ayatAR:
      "وَيَوْمَ يَحْشُرُهُمْ جَمِيعًا يَا مَعْشَرَ الْجِنِّ قَدِ اسْتَكْثَرْتُمْ مِنَ الْإِنْسِ ۖ وَقَالَ أَوْلِيَاؤُهُمْ مِنَ الْإِنْسِ رَبَّنَا اسْتَمْتَعَ بَعْضُنَا بِبَعْضٍ وَبَلَغْنَا أَجَلَنَا الَّذِي أَجَّلْتَ لَنَا ۚ قَالَ النَّارُ مَثْوَاكُمْ خَالِدِينَ فِيهَا إِلَّا مَا شَاءَ اللَّهُ ۗ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٌ",
  },
  {
    id: "918",
    sura: "6",
    VerseIDAr: "129",
    ayatAR:
      "وَكَذَٰلِكَ نُوَلِّي بَعْضَ الظَّالِمِينَ بَعْضًا بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "919",
    sura: "6",
    VerseIDAr: "130",
    ayatAR:
      "يَا مَعْشَرَ الْجِنِّ وَالْإِنْسِ أَلَمْ يَأْتِكُمْ رُسُلٌ مِنْكُمْ يَقُصُّونَ عَلَيْكُمْ آيَاتِي وَيُنْذِرُونَكُمْ لِقَاءَ يَوْمِكُمْ هَٰذَا ۚ قَالُوا شَهِدْنَا عَلَىٰ أَنْفُسِنَا ۖ وَغَرَّتْهُمُ الْحَيَاةُ الدُّنْيَا وَشَهِدُوا عَلَىٰ أَنْفُسِهِمْ أَنَّهُمْ كَانُوا كَافِرِينَ",
  },
  {
    id: "920",
    sura: "6",
    VerseIDAr: "131",
    ayatAR:
      "ذَٰلِكَ أَنْ لَمْ يَكُنْ رَبُّكَ مُهْلِكَ الْقُرَىٰ بِظُلْمٍ وَأَهْلُهَا غَافِلُونَ",
  },
  {
    id: "921",
    sura: "6",
    VerseIDAr: "132",
    ayatAR:
      "وَلِكُلٍّ دَرَجَاتٌ مِمَّا عَمِلُوا ۚ وَمَا رَبُّكَ بِغَافِلٍ عَمَّا يَعْمَلُونَ",
  },
  {
    id: "922",
    sura: "6",
    VerseIDAr: "133",
    ayatAR:
      "وَرَبُّكَ الْغَنِيُّ ذُو الرَّحْمَةِ ۚ إِنْ يَشَأْ يُذْهِبْكُمْ وَيَسْتَخْلِفْ مِنْ بَعْدِكُمْ مَا يَشَاءُ كَمَا أَنْشَأَكُمْ مِنْ ذُرِّيَّةِ قَوْمٍ آخَرِينَ",
  },
  {
    id: "923",
    sura: "6",
    VerseIDAr: "134",
    ayatAR: "إِنَّ مَا تُوعَدُونَ لَآتٍ ۖ وَمَا أَنْتُمْ بِمُعْجِزِينَ",
  },
  {
    id: "924",
    sura: "6",
    VerseIDAr: "135",
    ayatAR:
      "قُلْ يَا قَوْمِ اعْمَلُوا عَلَىٰ مَكَانَتِكُمْ إِنِّي عَامِلٌ ۖ فَسَوْفَ تَعْلَمُونَ مَنْ تَكُونُ لَهُ عَاقِبَةُ الدَّارِ ۗ إِنَّهُ لَا يُفْلِحُ الظَّالِمُونَ",
  },
  {
    id: "925",
    sura: "6",
    VerseIDAr: "136",
    ayatAR:
      "وَجَعَلُوا لِلَّهِ مِمَّا ذَرَأَ مِنَ الْحَرْثِ وَالْأَنْعَامِ نَصِيبًا فَقَالُوا هَٰذَا لِلَّهِ بِزَعْمِهِمْ وَهَٰذَا لِشُرَكَائِنَا ۖ فَمَا كَانَ لِشُرَكَائِهِمْ فَلَا يَصِلُ إِلَى اللَّهِ ۖ وَمَا كَانَ لِلَّهِ فَهُوَ يَصِلُ إِلَىٰ شُرَكَائِهِمْ ۗ سَاءَ مَا يَحْكُمُونَ",
  },
  {
    id: "926",
    sura: "6",
    VerseIDAr: "137",
    ayatAR:
      "وَكَذَٰلِكَ زَيَّنَ لِكَثِيرٍ مِنَ الْمُشْرِكِينَ قَتْلَ أَوْلَادِهِمْ شُرَكَاؤُهُمْ لِيُرْدُوهُمْ وَلِيَلْبِسُوا عَلَيْهِمْ دِينَهُمْ ۖ وَلَوْ شَاءَ اللَّهُ مَا فَعَلُوهُ ۖ فَذَرْهُمْ وَمَا يَفْتَرُونَ",
  },
  {
    id: "927",
    sura: "6",
    VerseIDAr: "138",
    ayatAR:
      "وَقَالُوا هَٰذِهِ أَنْعَامٌ وَحَرْثٌ حِجْرٌ لَا يَطْعَمُهَا إِلَّا مَنْ نَشَاءُ بِزَعْمِهِمْ وَأَنْعَامٌ حُرِّمَتْ ظُهُورُهَا وَأَنْعَامٌ لَا يَذْكُرُونَ اسْمَ اللَّهِ عَلَيْهَا افْتِرَاءً عَلَيْهِ ۚ سَيَجْزِيهِمْ بِمَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "928",
    sura: "6",
    VerseIDAr: "139",
    ayatAR:
      "وَقَالُوا مَا فِي بُطُونِ هَٰذِهِ الْأَنْعَامِ خَالِصَةٌ لِذُكُورِنَا وَمُحَرَّمٌ عَلَىٰ أَزْوَاجِنَا ۖ وَإِنْ يَكُنْ مَيْتَةً فَهُمْ فِيهِ شُرَكَاءُ ۚ سَيَجْزِيهِمْ وَصْفَهُمْ ۚ إِنَّهُ حَكِيمٌ عَلِيمٌ",
  },
  {
    id: "929",
    sura: "6",
    VerseIDAr: "140",
    ayatAR:
      "قَدْ خَسِرَ الَّذِينَ قَتَلُوا أَوْلَادَهُمْ سَفَهًا بِغَيْرِ عِلْمٍ وَحَرَّمُوا مَا رَزَقَهُمُ اللَّهُ افْتِرَاءً عَلَى اللَّهِ ۚ قَدْ ضَلُّوا وَمَا كَانُوا مُهْتَدِينَ",
  },
  {
    id: "930",
    sura: "6",
    VerseIDAr: "141",
    ayatAR:
      "وَهُوَ الَّذِي أَنْشَأَ جَنَّاتٍ مَعْرُوشَاتٍ وَغَيْرَ مَعْرُوشَاتٍ وَالنَّخْلَ وَالزَّرْعَ مُخْتَلِفًا أُكُلُهُ وَالزَّيْتُونَ وَالرُّمَّانَ مُتَشَابِهًا وَغَيْرَ مُتَشَابِهٍ ۚ كُلُوا مِنْ ثَمَرِهِ إِذَا أَثْمَرَ وَآتُوا حَقَّهُ يَوْمَ حَصَادِهِ ۖ وَلَا تُسْرِفُوا ۚ إِنَّهُ لَا يُحِبُّ الْمُسْرِفِينَ",
  },
  {
    id: "931",
    sura: "6",
    VerseIDAr: "142",
    ayatAR:
      "وَمِنَ الْأَنْعَامِ حَمُولَةً وَفَرْشًا ۚ كُلُوا مِمَّا رَزَقَكُمُ اللَّهُ وَلَا تَتَّبِعُوا خُطُوَاتِ الشَّيْطَانِ ۚ إِنَّهُ لَكُمْ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "932",
    sura: "6",
    VerseIDAr: "143",
    ayatAR:
      "ثَمَانِيَةَ أَزْوَاجٍ ۖ مِنَ الضَّأْنِ اثْنَيْنِ وَمِنَ الْمَعْزِ اثْنَيْنِ ۗ قُلْ آلذَّكَرَيْنِ حَرَّمَ أَمِ الْأُنْثَيَيْنِ أَمَّا اشْتَمَلَتْ عَلَيْهِ أَرْحَامُ الْأُنْثَيَيْنِ ۖ نَبِّئُونِي بِعِلْمٍ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "933",
    sura: "6",
    VerseIDAr: "144",
    ayatAR:
      "وَمِنَ الْإِبِلِ اثْنَيْنِ وَمِنَ الْبَقَرِ اثْنَيْنِ ۗ قُلْ آلذَّكَرَيْنِ حَرَّمَ أَمِ الْأُنْثَيَيْنِ أَمَّا اشْتَمَلَتْ عَلَيْهِ أَرْحَامُ الْأُنْثَيَيْنِ ۖ أَمْ كُنْتُمْ شُهَدَاءَ إِذْ وَصَّاكُمُ اللَّهُ بِهَٰذَا ۚ فَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا لِيُضِلَّ النَّاسَ بِغَيْرِ عِلْمٍ ۗ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "934",
    sura: "6",
    VerseIDAr: "145",
    ayatAR:
      "قُلْ لَا أَجِدُ فِي مَا أُوحِيَ إِلَيَّ مُحَرَّمًا عَلَىٰ طَاعِمٍ يَطْعَمُهُ إِلَّا أَنْ يَكُونَ مَيْتَةً أَوْ دَمًا مَسْفُوحًا أَوْ لَحْمَ خِنْزِيرٍ فَإِنَّهُ رِجْسٌ أَوْ فِسْقًا أُهِلَّ لِغَيْرِ اللَّهِ بِهِ ۚ فَمَنِ اضْطُرَّ غَيْرَ بَاغٍ وَلَا عَادٍ فَإِنَّ رَبَّكَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "935",
    sura: "6",
    VerseIDAr: "146",
    ayatAR:
      "وَعَلَى الَّذِينَ هَادُوا حَرَّمْنَا كُلَّ ذِي ظُفُرٍ ۖ وَمِنَ الْبَقَرِ وَالْغَنَمِ حَرَّمْنَا عَلَيْهِمْ شُحُومَهُمَا إِلَّا مَا حَمَلَتْ ظُهُورُهُمَا أَوِ الْحَوَايَا أَوْ مَا اخْتَلَطَ بِعَظْمٍ ۚ ذَٰلِكَ جَزَيْنَاهُمْ بِبَغْيِهِمْ ۖ وَإِنَّا لَصَادِقُونَ",
  },
  {
    id: "936",
    sura: "6",
    VerseIDAr: "147",
    ayatAR:
      "فَإِنْ كَذَّبُوكَ فَقُلْ رَبُّكُمْ ذُو رَحْمَةٍ وَاسِعَةٍ وَلَا يُرَدُّ بَأْسُهُ عَنِ الْقَوْمِ الْمُجْرِمِينَ",
  },
  {
    id: "937",
    sura: "6",
    VerseIDAr: "148",
    ayatAR:
      "سَيَقُولُ الَّذِينَ أَشْرَكُوا لَوْ شَاءَ اللَّهُ مَا أَشْرَكْنَا وَلَا آبَاؤُنَا وَلَا حَرَّمْنَا مِنْ شَيْءٍ ۚ كَذَٰلِكَ كَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ حَتَّىٰ ذَاقُوا بَأْسَنَا ۗ قُلْ هَلْ عِنْدَكُمْ مِنْ عِلْمٍ فَتُخْرِجُوهُ لَنَا ۖ إِنْ تَتَّبِعُونَ إِلَّا الظَّنَّ وَإِنْ أَنْتُمْ إِلَّا تَخْرُصُونَ",
  },
  {
    id: "938",
    sura: "6",
    VerseIDAr: "149",
    ayatAR:
      "قُلْ فَلِلَّهِ الْحُجَّةُ الْبَالِغَةُ ۖ فَلَوْ شَاءَ لَهَدَاكُمْ أَجْمَعِينَ",
  },
  {
    id: "939",
    sura: "6",
    VerseIDAr: "150",
    ayatAR:
      "قُلْ هَلُمَّ شُهَدَاءَكُمُ الَّذِينَ يَشْهَدُونَ أَنَّ اللَّهَ حَرَّمَ هَٰذَا ۖ فَإِنْ شَهِدُوا فَلَا تَشْهَدْ مَعَهُمْ ۚ وَلَا تَتَّبِعْ أَهْوَاءَ الَّذِينَ كَذَّبُوا بِآيَاتِنَا وَالَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ وَهُمْ بِرَبِّهِمْ يَعْدِلُونَ",
  },
  {
    id: "940",
    sura: "6",
    VerseIDAr: "151",
    ayatAR:
      "قُلْ تَعَالَوْا أَتْلُ مَا حَرَّمَ رَبُّكُمْ عَلَيْكُمْ ۖ أَلَّا تُشْرِكُوا بِهِ شَيْئًا ۖ وَبِالْوَالِدَيْنِ إِحْسَانًا ۖ وَلَا تَقْتُلُوا أَوْلَادَكُمْ مِنْ إِمْلَاقٍ ۖ نَحْنُ نَرْزُقُكُمْ وَإِيَّاهُمْ ۖ وَلَا تَقْرَبُوا الْفَوَاحِشَ مَا ظَهَرَ مِنْهَا وَمَا بَطَنَ ۖ وَلَا تَقْتُلُوا النَّفْسَ الَّتِي حَرَّمَ اللَّهُ إِلَّا بِالْحَقِّ ۚ ذَٰلِكُمْ وَصَّاكُمْ بِهِ لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "941",
    sura: "6",
    VerseIDAr: "152",
    ayatAR:
      "وَلَا تَقْرَبُوا مَالَ الْيَتِيمِ إِلَّا بِالَّتِي هِيَ أَحْسَنُ حَتَّىٰ يَبْلُغَ أَشُدَّهُ ۖ وَأَوْفُوا الْكَيْلَ وَالْمِيزَانَ بِالْقِسْطِ ۖ لَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَا ۖ وَإِذَا قُلْتُمْ فَاعْدِلُوا وَلَوْ كَانَ ذَا قُرْبَىٰ ۖ وَبِعَهْدِ اللَّهِ أَوْفُوا ۚ ذَٰلِكُمْ وَصَّاكُمْ بِهِ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "942",
    sura: "6",
    VerseIDAr: "153",
    ayatAR:
      "وَأَنَّ هَٰذَا صِرَاطِي مُسْتَقِيمًا فَاتَّبِعُوهُ ۖ وَلَا تَتَّبِعُوا السُّبُلَ فَتَفَرَّقَ بِكُمْ عَنْ سَبِيلِهِ ۚ ذَٰلِكُمْ وَصَّاكُمْ بِهِ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "943",
    sura: "6",
    VerseIDAr: "154",
    ayatAR:
      "ثُمَّ آتَيْنَا مُوسَى الْكِتَابَ تَمَامًا عَلَى الَّذِي أَحْسَنَ وَتَفْصِيلًا لِكُلِّ شَيْءٍ وَهُدًى وَرَحْمَةً لَعَلَّهُمْ بِلِقَاءِ رَبِّهِمْ يُؤْمِنُونَ",
  },
  {
    id: "944",
    sura: "6",
    VerseIDAr: "155",
    ayatAR:
      "وَهَٰذَا كِتَابٌ أَنْزَلْنَاهُ مُبَارَكٌ فَاتَّبِعُوهُ وَاتَّقُوا لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "945",
    sura: "6",
    VerseIDAr: "156",
    ayatAR:
      "أَنْ تَقُولُوا إِنَّمَا أُنْزِلَ الْكِتَابُ عَلَىٰ طَائِفَتَيْنِ مِنْ قَبْلِنَا وَإِنْ كُنَّا عَنْ دِرَاسَتِهِمْ لَغَافِلِينَ",
  },
  {
    id: "946",
    sura: "6",
    VerseIDAr: "157",
    ayatAR:
      "أَوْ تَقُولُوا لَوْ أَنَّا أُنْزِلَ عَلَيْنَا الْكِتَابُ لَكُنَّا أَهْدَىٰ مِنْهُمْ ۚ فَقَدْ جَاءَكُمْ بَيِّنَةٌ مِنْ رَبِّكُمْ وَهُدًى وَرَحْمَةٌ ۚ فَمَنْ أَظْلَمُ مِمَّنْ كَذَّبَ بِآيَاتِ اللَّهِ وَصَدَفَ عَنْهَا ۗ سَنَجْزِي الَّذِينَ يَصْدِفُونَ عَنْ آيَاتِنَا سُوءَ الْعَذَابِ بِمَا كَانُوا يَصْدِفُونَ",
  },
  {
    id: "947",
    sura: "6",
    VerseIDAr: "158",
    ayatAR:
      "هَلْ يَنْظُرُونَ إِلَّا أَنْ تَأْتِيَهُمُ الْمَلَائِكَةُ أَوْ يَأْتِيَ رَبُّكَ أَوْ يَأْتِيَ بَعْضُ آيَاتِ رَبِّكَ ۗ يَوْمَ يَأْتِي بَعْضُ آيَاتِ رَبِّكَ لَا يَنْفَعُ نَفْسًا إِيمَانُهَا لَمْ تَكُنْ آمَنَتْ مِنْ قَبْلُ أَوْ كَسَبَتْ فِي إِيمَانِهَا خَيْرًا ۗ قُلِ انْتَظِرُوا إِنَّا مُنْتَظِرُونَ",
  },
  {
    id: "948",
    sura: "6",
    VerseIDAr: "159",
    ayatAR:
      "إِنَّ الَّذِينَ فَرَّقُوا دِينَهُمْ وَكَانُوا شِيَعًا لَسْتَ مِنْهُمْ فِي شَيْءٍ ۚ إِنَّمَا أَمْرُهُمْ إِلَى اللَّهِ ثُمَّ يُنَبِّئُهُمْ بِمَا كَانُوا يَفْعَلُونَ",
  },
  {
    id: "949",
    sura: "6",
    VerseIDAr: "160",
    ayatAR:
      "مَنْ جَاءَ بِالْحَسَنَةِ فَلَهُ عَشْرُ أَمْثَالِهَا ۖ وَمَنْ جَاءَ بِالسَّيِّئَةِ فَلَا يُجْزَىٰ إِلَّا مِثْلَهَا وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "950",
    sura: "6",
    VerseIDAr: "161",
    ayatAR:
      "قُلْ إِنَّنِي هَدَانِي رَبِّي إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ دِينًا قِيَمًا مِلَّةَ إِبْرَاهِيمَ حَنِيفًا ۚ وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "951",
    sura: "6",
    VerseIDAr: "162",
    ayatAR:
      "قُلْ إِنَّ صَلَاتِي وَنُسُكِي وَمَحْيَايَ وَمَمَاتِي لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "952",
    sura: "6",
    VerseIDAr: "163",
    ayatAR:
      "لَا شَرِيكَ لَهُ ۖ وَبِذَٰلِكَ أُمِرْتُ وَأَنَا أَوَّلُ الْمُسْلِمِينَ",
  },
  {
    id: "953",
    sura: "6",
    VerseIDAr: "164",
    ayatAR:
      "قُلْ أَغَيْرَ اللَّهِ أَبْغِي رَبًّا وَهُوَ رَبُّ كُلِّ شَيْءٍ ۚ وَلَا تَكْسِبُ كُلُّ نَفْسٍ إِلَّا عَلَيْهَا ۚ وَلَا تَزِرُ وَازِرَةٌ وِزْرَ أُخْرَىٰ ۚ ثُمَّ إِلَىٰ رَبِّكُمْ مَرْجِعُكُمْ فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ فِيهِ تَخْتَلِفُونَ",
  },
  {
    id: "954",
    sura: "6",
    VerseIDAr: "165",
    ayatAR:
      "وَهُوَ الَّذِي جَعَلَكُمْ خَلَائِفَ الْأَرْضِ وَرَفَعَ بَعْضَكُمْ فَوْقَ بَعْضٍ دَرَجَاتٍ لِيَبْلُوَكُمْ فِي مَا آتَاكُمْ ۗ إِنَّ رَبَّكَ سَرِيعُ الْعِقَابِ وَإِنَّهُ لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "955",
    sura: "7",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ المص",
  },
  {
    id: "956",
    sura: "7",
    VerseIDAr: "2",
    ayatAR:
      "كِتَابٌ أُنْزِلَ إِلَيْكَ فَلَا يَكُنْ فِي صَدْرِكَ حَرَجٌ مِنْهُ لِتُنْذِرَ بِهِ وَذِكْرَىٰ لِلْمُؤْمِنِينَ",
  },
  {
    id: "957",
    sura: "7",
    VerseIDAr: "3",
    ayatAR:
      "اتَّبِعُوا مَا أُنْزِلَ إِلَيْكُمْ مِنْ رَبِّكُمْ وَلَا تَتَّبِعُوا مِنْ دُونِهِ أَوْلِيَاءَ ۗ قَلِيلًا مَا تَذَكَّرُونَ",
  },
  {
    id: "958",
    sura: "7",
    VerseIDAr: "4",
    ayatAR:
      "وَكَمْ مِنْ قَرْيَةٍ أَهْلَكْنَاهَا فَجَاءَهَا بَأْسُنَا بَيَاتًا أَوْ هُمْ قَائِلُونَ",
  },
  {
    id: "959",
    sura: "7",
    VerseIDAr: "5",
    ayatAR:
      "فَمَا كَانَ دَعْوَاهُمْ إِذْ جَاءَهُمْ بَأْسُنَا إِلَّا أَنْ قَالُوا إِنَّا كُنَّا ظَالِمِينَ",
  },
  {
    id: "960",
    sura: "7",
    VerseIDAr: "6",
    ayatAR:
      "فَلَنَسْأَلَنَّ الَّذِينَ أُرْسِلَ إِلَيْهِمْ وَلَنَسْأَلَنَّ الْمُرْسَلِينَ",
  },
  {
    id: "961",
    sura: "7",
    VerseIDAr: "7",
    ayatAR: "فَلَنَقُصَّنَّ عَلَيْهِمْ بِعِلْمٍ ۖ وَمَا كُنَّا غَائِبِينَ",
  },
  {
    id: "962",
    sura: "7",
    VerseIDAr: "8",
    ayatAR:
      "وَالْوَزْنُ يَوْمَئِذٍ الْحَقُّ ۚ فَمَنْ ثَقُلَتْ مَوَازِينُهُ فَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "963",
    sura: "7",
    VerseIDAr: "9",
    ayatAR:
      "وَمَنْ خَفَّتْ مَوَازِينُهُ فَأُولَٰئِكَ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ بِمَا كَانُوا بِآيَاتِنَا يَظْلِمُونَ",
  },
  {
    id: "964",
    sura: "7",
    VerseIDAr: "10",
    ayatAR:
      "وَلَقَدْ مَكَّنَّاكُمْ فِي الْأَرْضِ وَجَعَلْنَا لَكُمْ فِيهَا مَعَايِشَ ۗ قَلِيلًا مَا تَشْكُرُونَ",
  },
  {
    id: "965",
    sura: "7",
    VerseIDAr: "11",
    ayatAR:
      "وَلَقَدْ خَلَقْنَاكُمْ ثُمَّ صَوَّرْنَاكُمْ ثُمَّ قُلْنَا لِلْمَلَائِكَةِ اسْجُدُوا لِآدَمَ فَسَجَدُوا إِلَّا إِبْلِيسَ لَمْ يَكُنْ مِنَ السَّاجِدِينَ",
  },
  {
    id: "966",
    sura: "7",
    VerseIDAr: "12",
    ayatAR:
      "قَالَ مَا مَنَعَكَ أَلَّا تَسْجُدَ إِذْ أَمَرْتُكَ ۖ قَالَ أَنَا خَيْرٌ مِنْهُ خَلَقْتَنِي مِنْ نَارٍ وَخَلَقْتَهُ مِنْ طِينٍ",
  },
  {
    id: "967",
    sura: "7",
    VerseIDAr: "13",
    ayatAR:
      "قَالَ فَاهْبِطْ مِنْهَا فَمَا يَكُونُ لَكَ أَنْ تَتَكَبَّرَ فِيهَا فَاخْرُجْ إِنَّكَ مِنَ الصَّاغِرِينَ",
  },
  {
    id: "968",
    sura: "7",
    VerseIDAr: "14",
    ayatAR: "قَالَ أَنْظِرْنِي إِلَىٰ يَوْمِ يُبْعَثُونَ",
  },
  {
    id: "969",
    sura: "7",
    VerseIDAr: "15",
    ayatAR: "قَالَ إِنَّكَ مِنَ الْمُنْظَرِينَ",
  },
  {
    id: "970",
    sura: "7",
    VerseIDAr: "16",
    ayatAR:
      "قَالَ فَبِمَا أَغْوَيْتَنِي لَأَقْعُدَنَّ لَهُمْ صِرَاطَكَ الْمُسْتَقِيمَ",
  },
  {
    id: "971",
    sura: "7",
    VerseIDAr: "17",
    ayatAR:
      "ثُمَّ لَآتِيَنَّهُمْ مِنْ بَيْنِ أَيْدِيهِمْ وَمِنْ خَلْفِهِمْ وَعَنْ أَيْمَانِهِمْ وَعَنْ شَمَائِلِهِمْ ۖ وَلَا تَجِدُ أَكْثَرَهُمْ شَاكِرِينَ",
  },
  {
    id: "972",
    sura: "7",
    VerseIDAr: "18",
    ayatAR:
      "قَالَ اخْرُجْ مِنْهَا مَذْءُومًا مَدْحُورًا ۖ لَمَنْ تَبِعَكَ مِنْهُمْ لَأَمْلَأَنَّ جَهَنَّمَ مِنْكُمْ أَجْمَعِينَ",
  },
  {
    id: "973",
    sura: "7",
    VerseIDAr: "19",
    ayatAR:
      "وَيَا آدَمُ اسْكُنْ أَنْتَ وَزَوْجُكَ الْجَنَّةَ فَكُلَا مِنْ حَيْثُ شِئْتُمَا وَلَا تَقْرَبَا هَٰذِهِ الشَّجَرَةَ فَتَكُونَا مِنَ الظَّالِمِينَ",
  },
  {
    id: "974",
    sura: "7",
    VerseIDAr: "20",
    ayatAR:
      "فَوَسْوَسَ لَهُمَا الشَّيْطَانُ لِيُبْدِيَ لَهُمَا مَا وُورِيَ عَنْهُمَا مِنْ سَوْآتِهِمَا وَقَالَ مَا نَهَاكُمَا رَبُّكُمَا عَنْ هَٰذِهِ الشَّجَرَةِ إِلَّا أَنْ تَكُونَا مَلَكَيْنِ أَوْ تَكُونَا مِنَ الْخَالِدِينَ",
  },
  {
    id: "975",
    sura: "7",
    VerseIDAr: "21",
    ayatAR: "وَقَاسَمَهُمَا إِنِّي لَكُمَا لَمِنَ النَّاصِحِينَ",
  },
  {
    id: "976",
    sura: "7",
    VerseIDAr: "22",
    ayatAR:
      "فَدَلَّاهُمَا بِغُرُورٍ ۚ فَلَمَّا ذَاقَا الشَّجَرَةَ بَدَتْ لَهُمَا سَوْآتُهُمَا وَطَفِقَا يَخْصِفَانِ عَلَيْهِمَا مِنْ وَرَقِ الْجَنَّةِ ۖ وَنَادَاهُمَا رَبُّهُمَا أَلَمْ أَنْهَكُمَا عَنْ تِلْكُمَا الشَّجَرَةِ وَأَقُلْ لَكُمَا إِنَّ الشَّيْطَانَ لَكُمَا عَدُوٌّ مُبِينٌ",
  },
  {
    id: "977",
    sura: "7",
    VerseIDAr: "23",
    ayatAR:
      "قَالَا رَبَّنَا ظَلَمْنَا أَنْفُسَنَا وَإِنْ لَمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "978",
    sura: "7",
    VerseIDAr: "24",
    ayatAR:
      "قَالَ اهْبِطُوا بَعْضُكُمْ لِبَعْضٍ عَدُوٌّ ۖ وَلَكُمْ فِي الْأَرْضِ مُسْتَقَرٌّ وَمَتَاعٌ إِلَىٰ حِينٍ",
  },
  {
    id: "979",
    sura: "7",
    VerseIDAr: "25",
    ayatAR: "قَالَ فِيهَا تَحْيَوْنَ وَفِيهَا تَمُوتُونَ وَمِنْهَا تُخْرَجُونَ",
  },
  {
    id: "980",
    sura: "7",
    VerseIDAr: "26",
    ayatAR:
      "يَا بَنِي آدَمَ قَدْ أَنْزَلْنَا عَلَيْكُمْ لِبَاسًا يُوَارِي سَوْآتِكُمْ وَرِيشًا ۖ وَلِبَاسُ التَّقْوَىٰ ذَٰلِكَ خَيْرٌ ۚ ذَٰلِكَ مِنْ آيَاتِ اللَّهِ لَعَلَّهُمْ يَذَّكَّرُونَ",
  },
  {
    id: "981",
    sura: "7",
    VerseIDAr: "27",
    ayatAR:
      "يَا بَنِي آدَمَ لَا يَفْتِنَنَّكُمُ الشَّيْطَانُ كَمَا أَخْرَجَ أَبَوَيْكُمْ مِنَ الْجَنَّةِ يَنْزِعُ عَنْهُمَا لِبَاسَهُمَا لِيُرِيَهُمَا سَوْآتِهِمَا ۗ إِنَّهُ يَرَاكُمْ هُوَ وَقَبِيلُهُ مِنْ حَيْثُ لَا تَرَوْنَهُمْ ۗ إِنَّا جَعَلْنَا الشَّيَاطِينَ أَوْلِيَاءَ لِلَّذِينَ لَا يُؤْمِنُونَ",
  },
  {
    id: "982",
    sura: "7",
    VerseIDAr: "28",
    ayatAR:
      "وَإِذَا فَعَلُوا فَاحِشَةً قَالُوا وَجَدْنَا عَلَيْهَا آبَاءَنَا وَاللَّهُ أَمَرَنَا بِهَا ۗ قُلْ إِنَّ اللَّهَ لَا يَأْمُرُ بِالْفَحْشَاءِ ۖ أَتَقُولُونَ عَلَى اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "983",
    sura: "7",
    VerseIDAr: "29",
    ayatAR:
      "قُلْ أَمَرَ رَبِّي بِالْقِسْطِ ۖ وَأَقِيمُوا وُجُوهَكُمْ عِنْدَ كُلِّ مَسْجِدٍ وَادْعُوهُ مُخْلِصِينَ لَهُ الدِّينَ ۚ كَمَا بَدَأَكُمْ تَعُودُونَ",
  },
  {
    id: "984",
    sura: "7",
    VerseIDAr: "30",
    ayatAR:
      "فَرِيقًا هَدَىٰ وَفَرِيقًا حَقَّ عَلَيْهِمُ الضَّلَالَةُ ۗ إِنَّهُمُ اتَّخَذُوا الشَّيَاطِينَ أَوْلِيَاءَ مِنْ دُونِ اللَّهِ وَيَحْسَبُونَ أَنَّهُمْ مُهْتَدُونَ",
  },
  {
    id: "985",
    sura: "7",
    VerseIDAr: "31",
    ayatAR:
      "يَا بَنِي آدَمَ خُذُوا زِينَتَكُمْ عِنْدَ كُلِّ مَسْجِدٍ وَكُلُوا وَاشْرَبُوا وَلَا تُسْرِفُوا ۚ إِنَّهُ لَا يُحِبُّ الْمُسْرِفِينَ",
  },
  {
    id: "986",
    sura: "7",
    VerseIDAr: "32",
    ayatAR:
      "قُلْ مَنْ حَرَّمَ زِينَةَ اللَّهِ الَّتِي أَخْرَجَ لِعِبَادِهِ وَالطَّيِّبَاتِ مِنَ الرِّزْقِ ۚ قُلْ هِيَ لِلَّذِينَ آمَنُوا فِي الْحَيَاةِ الدُّنْيَا خَالِصَةً يَوْمَ الْقِيَامَةِ ۗ كَذَٰلِكَ نُفَصِّلُ الْآيَاتِ لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "987",
    sura: "7",
    VerseIDAr: "33",
    ayatAR:
      "قُلْ إِنَّمَا حَرَّمَ رَبِّيَ الْفَوَاحِشَ مَا ظَهَرَ مِنْهَا وَمَا بَطَنَ وَالْإِثْمَ وَالْبَغْيَ بِغَيْرِ الْحَقِّ وَأَنْ تُشْرِكُوا بِاللَّهِ مَا لَمْ يُنَزِّلْ بِهِ سُلْطَانًا وَأَنْ تَقُولُوا عَلَى اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "988",
    sura: "7",
    VerseIDAr: "34",
    ayatAR:
      "وَلِكُلِّ أُمَّةٍ أَجَلٌ ۖ فَإِذَا جَاءَ أَجَلُهُمْ لَا يَسْتَأْخِرُونَ سَاعَةً ۖ وَلَا يَسْتَقْدِمُونَ",
  },
  {
    id: "989",
    sura: "7",
    VerseIDAr: "35",
    ayatAR:
      "يَا بَنِي آدَمَ إِمَّا يَأْتِيَنَّكُمْ رُسُلٌ مِنْكُمْ يَقُصُّونَ عَلَيْكُمْ آيَاتِي ۙ فَمَنِ اتَّقَىٰ وَأَصْلَحَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "990",
    sura: "7",
    VerseIDAr: "36",
    ayatAR:
      "وَالَّذِينَ كَذَّبُوا بِآيَاتِنَا وَاسْتَكْبَرُوا عَنْهَا أُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "991",
    sura: "7",
    VerseIDAr: "37",
    ayatAR:
      "فَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَوْ كَذَّبَ بِآيَاتِهِ ۚ أُولَٰئِكَ يَنَالُهُمْ نَصِيبُهُمْ مِنَ الْكِتَابِ ۖ حَتَّىٰ إِذَا جَاءَتْهُمْ رُسُلُنَا يَتَوَفَّوْنَهُمْ قَالُوا أَيْنَ مَا كُنْتُمْ تَدْعُونَ مِنْ دُونِ اللَّهِ ۖ قَالُوا ضَلُّوا عَنَّا وَشَهِدُوا عَلَىٰ أَنْفُسِهِمْ أَنَّهُمْ كَانُوا كَافِرِينَ",
  },
  {
    id: "992",
    sura: "7",
    VerseIDAr: "38",
    ayatAR:
      "قَالَ ادْخُلُوا فِي أُمَمٍ قَدْ خَلَتْ مِنْ قَبْلِكُمْ مِنَ الْجِنِّ وَالْإِنْسِ فِي النَّارِ ۖ كُلَّمَا دَخَلَتْ أُمَّةٌ لَعَنَتْ أُخْتَهَا ۖ حَتَّىٰ إِذَا ادَّارَكُوا فِيهَا جَمِيعًا قَالَتْ أُخْرَاهُمْ لِأُولَاهُمْ رَبَّنَا هَٰؤُلَاءِ أَضَلُّونَا فَآتِهِمْ عَذَابًا ضِعْفًا مِنَ النَّارِ ۖ قَالَ لِكُلٍّ ضِعْفٌ وَلَٰكِنْ لَا تَعْلَمُونَ",
  },
  {
    id: "993",
    sura: "7",
    VerseIDAr: "39",
    ayatAR:
      "وَقَالَتْ أُولَاهُمْ لِأُخْرَاهُمْ فَمَا كَانَ لَكُمْ عَلَيْنَا مِنْ فَضْلٍ فَذُوقُوا الْعَذَابَ بِمَا كُنْتُمْ تَكْسِبُونَ",
  },
  {
    id: "994",
    sura: "7",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّ الَّذِينَ كَذَّبُوا بِآيَاتِنَا وَاسْتَكْبَرُوا عَنْهَا لَا تُفَتَّحُ لَهُمْ أَبْوَابُ السَّمَاءِ وَلَا يَدْخُلُونَ الْجَنَّةَ حَتَّىٰ يَلِجَ الْجَمَلُ فِي سَمِّ الْخِيَاطِ ۚ وَكَذَٰلِكَ نَجْزِي الْمُجْرِمِينَ",
  },
  {
    id: "995",
    sura: "7",
    VerseIDAr: "41",
    ayatAR:
      "لَهُمْ مِنْ جَهَنَّمَ مِهَادٌ وَمِنْ فَوْقِهِمْ غَوَاشٍ ۚ وَكَذَٰلِكَ نَجْزِي الظَّالِمِينَ",
  },
  {
    id: "996",
    sura: "7",
    VerseIDAr: "42",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَا أُولَٰئِكَ أَصْحَابُ الْجَنَّةِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "997",
    sura: "7",
    VerseIDAr: "43",
    ayatAR:
      "وَنَزَعْنَا مَا فِي صُدُورِهِمْ مِنْ غِلٍّ تَجْرِي مِنْ تَحْتِهِمُ الْأَنْهَارُ ۖ وَقَالُوا الْحَمْدُ لِلَّهِ الَّذِي هَدَانَا لِهَٰذَا وَمَا كُنَّا لِنَهْتَدِيَ لَوْلَا أَنْ هَدَانَا اللَّهُ ۖ لَقَدْ جَاءَتْ رُسُلُ رَبِّنَا بِالْحَقِّ ۖ وَنُودُوا أَنْ تِلْكُمُ الْجَنَّةُ أُورِثْتُمُوهَا بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "998",
    sura: "7",
    VerseIDAr: "44",
    ayatAR:
      "وَنَادَىٰ أَصْحَابُ الْجَنَّةِ أَصْحَابَ النَّارِ أَنْ قَدْ وَجَدْنَا مَا وَعَدَنَا رَبُّنَا حَقًّا فَهَلْ وَجَدْتُمْ مَا وَعَدَ رَبُّكُمْ حَقًّا ۖ قَالُوا نَعَمْ ۚ فَأَذَّنَ مُؤَذِّنٌ بَيْنَهُمْ أَنْ لَعْنَةُ اللَّهِ عَلَى الظَّالِمِينَ",
  },
  {
    id: "999",
    sura: "7",
    VerseIDAr: "45",
    ayatAR:
      "الَّذِينَ يَصُدُّونَ عَنْ سَبِيلِ اللَّهِ وَيَبْغُونَهَا عِوَجًا وَهُمْ بِالْآخِرَةِ كَافِرُونَ",
  },
  {
    id: "1000",
    sura: "7",
    VerseIDAr: "46",
    ayatAR:
      "وَبَيْنَهُمَا حِجَابٌ ۚ وَعَلَى الْأَعْرَافِ رِجَالٌ يَعْرِفُونَ كُلًّا بِسِيمَاهُمْ ۚ وَنَادَوْا أَصْحَابَ الْجَنَّةِ أَنْ سَلَامٌ عَلَيْكُمْ ۚ لَمْ يَدْخُلُوهَا وَهُمْ يَطْمَعُونَ",
  },
  {
    id: "1001",
    sura: "7",
    VerseIDAr: "47",
    ayatAR:
      "وَإِذَا صُرِفَتْ أَبْصَارُهُمْ تِلْقَاءَ أَصْحَابِ النَّارِ قَالُوا رَبَّنَا لَا تَجْعَلْنَا مَعَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "1002",
    sura: "7",
    VerseIDAr: "48",
    ayatAR:
      "وَنَادَىٰ أَصْحَابُ الْأَعْرَافِ رِجَالًا يَعْرِفُونَهُمْ بِسِيمَاهُمْ قَالُوا مَا أَغْنَىٰ عَنْكُمْ جَمْعُكُمْ وَمَا كُنْتُمْ تَسْتَكْبِرُونَ",
  },
  {
    id: "1003",
    sura: "7",
    VerseIDAr: "49",
    ayatAR:
      "أَهَٰؤُلَاءِ الَّذِينَ أَقْسَمْتُمْ لَا يَنَالُهُمُ اللَّهُ بِرَحْمَةٍ ۚ ادْخُلُوا الْجَنَّةَ لَا خَوْفٌ عَلَيْكُمْ وَلَا أَنْتُمْ تَحْزَنُونَ",
  },
  {
    id: "1004",
    sura: "7",
    VerseIDAr: "50",
    ayatAR:
      "وَنَادَىٰ أَصْحَابُ النَّارِ أَصْحَابَ الْجَنَّةِ أَنْ أَفِيضُوا عَلَيْنَا مِنَ الْمَاءِ أَوْ مِمَّا رَزَقَكُمُ اللَّهُ ۚ قَالُوا إِنَّ اللَّهَ حَرَّمَهُمَا عَلَى الْكَافِرِينَ",
  },
  {
    id: "1005",
    sura: "7",
    VerseIDAr: "51",
    ayatAR:
      "الَّذِينَ اتَّخَذُوا دِينَهُمْ لَهْوًا وَلَعِبًا وَغَرَّتْهُمُ الْحَيَاةُ الدُّنْيَا ۚ فَالْيَوْمَ نَنْسَاهُمْ كَمَا نَسُوا لِقَاءَ يَوْمِهِمْ هَٰذَا وَمَا كَانُوا بِآيَاتِنَا يَجْحَدُونَ",
  },
  {
    id: "1006",
    sura: "7",
    VerseIDAr: "52",
    ayatAR:
      "وَلَقَدْ جِئْنَاهُمْ بِكِتَابٍ فَصَّلْنَاهُ عَلَىٰ عِلْمٍ هُدًى وَرَحْمَةً لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1007",
    sura: "7",
    VerseIDAr: "53",
    ayatAR:
      "هَلْ يَنْظُرُونَ إِلَّا تَأْوِيلَهُ ۚ يَوْمَ يَأْتِي تَأْوِيلُهُ يَقُولُ الَّذِينَ نَسُوهُ مِنْ قَبْلُ قَدْ جَاءَتْ رُسُلُ رَبِّنَا بِالْحَقِّ فَهَلْ لَنَا مِنْ شُفَعَاءَ فَيَشْفَعُوا لَنَا أَوْ نُرَدُّ فَنَعْمَلَ غَيْرَ الَّذِي كُنَّا نَعْمَلُ ۚ قَدْ خَسِرُوا أَنْفُسَهُمْ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "1008",
    sura: "7",
    VerseIDAr: "54",
    ayatAR:
      "إِنَّ رَبَّكُمُ اللَّهُ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ فِي سِتَّةِ أَيَّامٍ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ يُغْشِي اللَّيْلَ النَّهَارَ يَطْلُبُهُ حَثِيثًا وَالشَّمْسَ وَالْقَمَرَ وَالنُّجُومَ مُسَخَّرَاتٍ بِأَمْرِهِ ۗ أَلَا لَهُ الْخَلْقُ وَالْأَمْرُ ۗ تَبَارَكَ اللَّهُ رَبُّ الْعَالَمِينَ",
  },
  {
    id: "1009",
    sura: "7",
    VerseIDAr: "55",
    ayatAR:
      "ادْعُوا رَبَّكُمْ تَضَرُّعًا وَخُفْيَةً ۚ إِنَّهُ لَا يُحِبُّ الْمُعْتَدِينَ",
  },
  {
    id: "1010",
    sura: "7",
    VerseIDAr: "56",
    ayatAR:
      "وَلَا تُفْسِدُوا فِي الْأَرْضِ بَعْدَ إِصْلَاحِهَا وَادْعُوهُ خَوْفًا وَطَمَعًا ۚ إِنَّ رَحْمَتَ اللَّهِ قَرِيبٌ مِنَ الْمُحْسِنِينَ",
  },
  {
    id: "1011",
    sura: "7",
    VerseIDAr: "57",
    ayatAR:
      "وَهُوَ الَّذِي يُرْسِلُ الرِّيَاحَ بُشْرًا بَيْنَ يَدَيْ رَحْمَتِهِ ۖ حَتَّىٰ إِذَا أَقَلَّتْ سَحَابًا ثِقَالًا سُقْنَاهُ لِبَلَدٍ مَيِّتٍ فَأَنْزَلْنَا بِهِ الْمَاءَ فَأَخْرَجْنَا بِهِ مِنْ كُلِّ الثَّمَرَاتِ ۚ كَذَٰلِكَ نُخْرِجُ الْمَوْتَىٰ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "1012",
    sura: "7",
    VerseIDAr: "58",
    ayatAR:
      "وَالْبَلَدُ الطَّيِّبُ يَخْرُجُ نَبَاتُهُ بِإِذْنِ رَبِّهِ ۖ وَالَّذِي خَبُثَ لَا يَخْرُجُ إِلَّا نَكِدًا ۚ كَذَٰلِكَ نُصَرِّفُ الْآيَاتِ لِقَوْمٍ يَشْكُرُونَ",
  },
  {
    id: "1013",
    sura: "7",
    VerseIDAr: "59",
    ayatAR:
      "لَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِ فَقَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ إِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "1014",
    sura: "7",
    VerseIDAr: "60",
    ayatAR:
      "قَالَ الْمَلَأُ مِنْ قَوْمِهِ إِنَّا لَنَرَاكَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "1015",
    sura: "7",
    VerseIDAr: "61",
    ayatAR:
      "قَالَ يَا قَوْمِ لَيْسَ بِي ضَلَالَةٌ وَلَٰكِنِّي رَسُولٌ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "1016",
    sura: "7",
    VerseIDAr: "62",
    ayatAR:
      "أُبَلِّغُكُمْ رِسَالَاتِ رَبِّي وَأَنْصَحُ لَكُمْ وَأَعْلَمُ مِنَ اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "1017",
    sura: "7",
    VerseIDAr: "63",
    ayatAR:
      "أَوَعَجِبْتُمْ أَنْ جَاءَكُمْ ذِكْرٌ مِنْ رَبِّكُمْ عَلَىٰ رَجُلٍ مِنْكُمْ لِيُنْذِرَكُمْ وَلِتَتَّقُوا وَلَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "1018",
    sura: "7",
    VerseIDAr: "64",
    ayatAR:
      "فَكَذَّبُوهُ فَأَنْجَيْنَاهُ وَالَّذِينَ مَعَهُ فِي الْفُلْكِ وَأَغْرَقْنَا الَّذِينَ كَذَّبُوا بِآيَاتِنَا ۚ إِنَّهُمْ كَانُوا قَوْمًا عَمِينَ",
  },
  {
    id: "1019",
    sura: "7",
    VerseIDAr: "65",
    ayatAR:
      "وَإِلَىٰ عَادٍ أَخَاهُمْ هُودًا ۗ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۚ أَفَلَا تَتَّقُونَ",
  },
  {
    id: "1020",
    sura: "7",
    VerseIDAr: "66",
    ayatAR:
      "قَالَ الْمَلَأُ الَّذِينَ كَفَرُوا مِنْ قَوْمِهِ إِنَّا لَنَرَاكَ فِي سَفَاهَةٍ وَإِنَّا لَنَظُنُّكَ مِنَ الْكَاذِبِينَ",
  },
  {
    id: "1021",
    sura: "7",
    VerseIDAr: "67",
    ayatAR:
      "قَالَ يَا قَوْمِ لَيْسَ بِي سَفَاهَةٌ وَلَٰكِنِّي رَسُولٌ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "1022",
    sura: "7",
    VerseIDAr: "68",
    ayatAR: "أُبَلِّغُكُمْ رِسَالَاتِ رَبِّي وَأَنَا لَكُمْ نَاصِحٌ أَمِينٌ",
  },
  {
    id: "1023",
    sura: "7",
    VerseIDAr: "69",
    ayatAR:
      "أَوَعَجِبْتُمْ أَنْ جَاءَكُمْ ذِكْرٌ مِنْ رَبِّكُمْ عَلَىٰ رَجُلٍ مِنْكُمْ لِيُنْذِرَكُمْ ۚ وَاذْكُرُوا إِذْ جَعَلَكُمْ خُلَفَاءَ مِنْ بَعْدِ قَوْمِ نُوحٍ وَزَادَكُمْ فِي الْخَلْقِ بَسْطَةً ۖ فَاذْكُرُوا آلَاءَ اللَّهِ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "1024",
    sura: "7",
    VerseIDAr: "70",
    ayatAR:
      "قَالُوا أَجِئْتَنَا لِنَعْبُدَ اللَّهَ وَحْدَهُ وَنَذَرَ مَا كَانَ يَعْبُدُ آبَاؤُنَا ۖ فَأْتِنَا بِمَا تَعِدُنَا إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "1025",
    sura: "7",
    VerseIDAr: "71",
    ayatAR:
      "قَالَ قَدْ وَقَعَ عَلَيْكُمْ مِنْ رَبِّكُمْ رِجْسٌ وَغَضَبٌ ۖ أَتُجَادِلُونَنِي فِي أَسْمَاءٍ سَمَّيْتُمُوهَا أَنْتُمْ وَآبَاؤُكُمْ مَا نَزَّلَ اللَّهُ بِهَا مِنْ سُلْطَانٍ ۚ فَانْتَظِرُوا إِنِّي مَعَكُمْ مِنَ الْمُنْتَظِرِينَ",
  },
  {
    id: "1026",
    sura: "7",
    VerseIDAr: "72",
    ayatAR:
      "فَأَنْجَيْنَاهُ وَالَّذِينَ مَعَهُ بِرَحْمَةٍ مِنَّا وَقَطَعْنَا دَابِرَ الَّذِينَ كَذَّبُوا بِآيَاتِنَا ۖ وَمَا كَانُوا مُؤْمِنِينَ",
  },
  {
    id: "1027",
    sura: "7",
    VerseIDAr: "73",
    ayatAR:
      "وَإِلَىٰ ثَمُودَ أَخَاهُمْ صَالِحًا ۗ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ قَدْ جَاءَتْكُمْ بَيِّنَةٌ مِنْ رَبِّكُمْ ۖ هَٰذِهِ نَاقَةُ اللَّهِ لَكُمْ آيَةً ۖ فَذَرُوهَا تَأْكُلْ فِي أَرْضِ اللَّهِ ۖ وَلَا تَمَسُّوهَا بِسُوءٍ فَيَأْخُذَكُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1028",
    sura: "7",
    VerseIDAr: "74",
    ayatAR:
      "وَاذْكُرُوا إِذْ جَعَلَكُمْ خُلَفَاءَ مِنْ بَعْدِ عَادٍ وَبَوَّأَكُمْ فِي الْأَرْضِ تَتَّخِذُونَ مِنْ سُهُولِهَا قُصُورًا وَتَنْحِتُونَ الْجِبَالَ بُيُوتًا ۖ فَاذْكُرُوا آلَاءَ اللَّهِ وَلَا تَعْثَوْا فِي الْأَرْضِ مُفْسِدِينَ",
  },
  {
    id: "1029",
    sura: "7",
    VerseIDAr: "75",
    ayatAR:
      "قَالَ الْمَلَأُ الَّذِينَ اسْتَكْبَرُوا مِنْ قَوْمِهِ لِلَّذِينَ اسْتُضْعِفُوا لِمَنْ آمَنَ مِنْهُمْ أَتَعْلَمُونَ أَنَّ صَالِحًا مُرْسَلٌ مِنْ رَبِّهِ ۚ قَالُوا إِنَّا بِمَا أُرْسِلَ بِهِ مُؤْمِنُونَ",
  },
  {
    id: "1030",
    sura: "7",
    VerseIDAr: "76",
    ayatAR:
      "قَالَ الَّذِينَ اسْتَكْبَرُوا إِنَّا بِالَّذِي آمَنْتُمْ بِهِ كَافِرُونَ",
  },
  {
    id: "1031",
    sura: "7",
    VerseIDAr: "77",
    ayatAR:
      "فَعَقَرُوا النَّاقَةَ وَعَتَوْا عَنْ أَمْرِ رَبِّهِمْ وَقَالُوا يَا صَالِحُ ائْتِنَا بِمَا تَعِدُنَا إِنْ كُنْتَ مِنَ الْمُرْسَلِينَ",
  },
  {
    id: "1032",
    sura: "7",
    VerseIDAr: "78",
    ayatAR: "فَأَخَذَتْهُمُ الرَّجْفَةُ فَأَصْبَحُوا فِي دَارِهِمْ جَاثِمِينَ",
  },
  {
    id: "1033",
    sura: "7",
    VerseIDAr: "79",
    ayatAR:
      "فَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَا قَوْمِ لَقَدْ أَبْلَغْتُكُمْ رِسَالَةَ رَبِّي وَنَصَحْتُ لَكُمْ وَلَٰكِنْ لَا تُحِبُّونَ النَّاصِحِينَ",
  },
  {
    id: "1034",
    sura: "7",
    VerseIDAr: "80",
    ayatAR:
      "وَلُوطًا إِذْ قَالَ لِقَوْمِهِ أَتَأْتُونَ الْفَاحِشَةَ مَا سَبَقَكُمْ بِهَا مِنْ أَحَدٍ مِنَ الْعَالَمِينَ",
  },
  {
    id: "1035",
    sura: "7",
    VerseIDAr: "81",
    ayatAR:
      "إِنَّكُمْ لَتَأْتُونَ الرِّجَالَ شَهْوَةً مِنْ دُونِ النِّسَاءِ ۚ بَلْ أَنْتُمْ قَوْمٌ مُسْرِفُونَ",
  },
  {
    id: "1036",
    sura: "7",
    VerseIDAr: "82",
    ayatAR:
      "وَمَا كَانَ جَوَابَ قَوْمِهِ إِلَّا أَنْ قَالُوا أَخْرِجُوهُمْ مِنْ قَرْيَتِكُمْ ۖ إِنَّهُمْ أُنَاسٌ يَتَطَهَّرُونَ",
  },
  {
    id: "1037",
    sura: "7",
    VerseIDAr: "83",
    ayatAR:
      "فَأَنْجَيْنَاهُ وَأَهْلَهُ إِلَّا امْرَأَتَهُ كَانَتْ مِنَ الْغَابِرِينَ",
  },
  {
    id: "1038",
    sura: "7",
    VerseIDAr: "84",
    ayatAR:
      "وَأَمْطَرْنَا عَلَيْهِمْ مَطَرًا ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُجْرِمِينَ",
  },
  {
    id: "1039",
    sura: "7",
    VerseIDAr: "85",
    ayatAR:
      "وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًا ۗ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ قَدْ جَاءَتْكُمْ بَيِّنَةٌ مِنْ رَبِّكُمْ ۖ فَأَوْفُوا الْكَيْلَ وَالْمِيزَانَ وَلَا تَبْخَسُوا النَّاسَ أَشْيَاءَهُمْ وَلَا تُفْسِدُوا فِي الْأَرْضِ بَعْدَ إِصْلَاحِهَا ۚ ذَٰلِكُمْ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "1040",
    sura: "7",
    VerseIDAr: "86",
    ayatAR:
      "وَلَا تَقْعُدُوا بِكُلِّ صِرَاطٍ تُوعِدُونَ وَتَصُدُّونَ عَنْ سَبِيلِ اللَّهِ مَنْ آمَنَ بِهِ وَتَبْغُونَهَا عِوَجًا ۚ وَاذْكُرُوا إِذْ كُنْتُمْ قَلِيلًا فَكَثَّرَكُمْ ۖ وَانْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الْمُفْسِدِينَ",
  },
  {
    id: "1041",
    sura: "7",
    VerseIDAr: "87",
    ayatAR:
      "وَإِنْ كَانَ طَائِفَةٌ مِنْكُمْ آمَنُوا بِالَّذِي أُرْسِلْتُ بِهِ وَطَائِفَةٌ لَمْ يُؤْمِنُوا فَاصْبِرُوا حَتَّىٰ يَحْكُمَ اللَّهُ بَيْنَنَا ۚ وَهُوَ خَيْرُ الْحَاكِمِينَ",
  },
  {
    id: "1042",
    sura: "7",
    VerseIDAr: "88",
    ayatAR:
      "قَالَ الْمَلَأُ الَّذِينَ اسْتَكْبَرُوا مِنْ قَوْمِهِ لَنُخْرِجَنَّكَ يَا شُعَيْبُ وَالَّذِينَ آمَنُوا مَعَكَ مِنْ قَرْيَتِنَا أَوْ لَتَعُودُنَّ فِي مِلَّتِنَا ۚ قَالَ أَوَلَوْ كُنَّا كَارِهِينَ",
  },
  {
    id: "1043",
    sura: "7",
    VerseIDAr: "89",
    ayatAR:
      "قَدِ افْتَرَيْنَا عَلَى اللَّهِ كَذِبًا إِنْ عُدْنَا فِي مِلَّتِكُمْ بَعْدَ إِذْ نَجَّانَا اللَّهُ مِنْهَا ۚ وَمَا يَكُونُ لَنَا أَنْ نَعُودَ فِيهَا إِلَّا أَنْ يَشَاءَ اللَّهُ رَبُّنَا ۚ وَسِعَ رَبُّنَا كُلَّ شَيْءٍ عِلْمًا ۚ عَلَى اللَّهِ تَوَكَّلْنَا ۚ رَبَّنَا افْتَحْ بَيْنَنَا وَبَيْنَ قَوْمِنَا بِالْحَقِّ وَأَنْتَ خَيْرُ الْفَاتِحِينَ",
  },
  {
    id: "1044",
    sura: "7",
    VerseIDAr: "90",
    ayatAR:
      "وَقَالَ الْمَلَأُ الَّذِينَ كَفَرُوا مِنْ قَوْمِهِ لَئِنِ اتَّبَعْتُمْ شُعَيْبًا إِنَّكُمْ إِذًا لَخَاسِرُونَ",
  },
  {
    id: "1045",
    sura: "7",
    VerseIDAr: "91",
    ayatAR: "فَأَخَذَتْهُمُ الرَّجْفَةُ فَأَصْبَحُوا فِي دَارِهِمْ جَاثِمِينَ",
  },
  {
    id: "1046",
    sura: "7",
    VerseIDAr: "92",
    ayatAR:
      "الَّذِينَ كَذَّبُوا شُعَيْبًا كَأَنْ لَمْ يَغْنَوْا فِيهَا ۚ الَّذِينَ كَذَّبُوا شُعَيْبًا كَانُوا هُمُ الْخَاسِرِينَ",
  },
  {
    id: "1047",
    sura: "7",
    VerseIDAr: "93",
    ayatAR:
      "فَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَا قَوْمِ لَقَدْ أَبْلَغْتُكُمْ رِسَالَاتِ رَبِّي وَنَصَحْتُ لَكُمْ ۖ فَكَيْفَ آسَىٰ عَلَىٰ قَوْمٍ كَافِرِينَ",
  },
  {
    id: "1048",
    sura: "7",
    VerseIDAr: "94",
    ayatAR:
      "وَمَا أَرْسَلْنَا فِي قَرْيَةٍ مِنْ نَبِيٍّ إِلَّا أَخَذْنَا أَهْلَهَا بِالْبَأْسَاءِ وَالضَّرَّاءِ لَعَلَّهُمْ يَضَّرَّعُونَ",
  },
  {
    id: "1049",
    sura: "7",
    VerseIDAr: "95",
    ayatAR:
      "ثُمَّ بَدَّلْنَا مَكَانَ السَّيِّئَةِ الْحَسَنَةَ حَتَّىٰ عَفَوْا وَقَالُوا قَدْ مَسَّ آبَاءَنَا الضَّرَّاءُ وَالسَّرَّاءُ فَأَخَذْنَاهُمْ بَغْتَةً وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "1050",
    sura: "7",
    VerseIDAr: "96",
    ayatAR:
      "وَلَوْ أَنَّ أَهْلَ الْقُرَىٰ آمَنُوا وَاتَّقَوْا لَفَتَحْنَا عَلَيْهِمْ بَرَكَاتٍ مِنَ السَّمَاءِ وَالْأَرْضِ وَلَٰكِنْ كَذَّبُوا فَأَخَذْنَاهُمْ بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "1051",
    sura: "7",
    VerseIDAr: "97",
    ayatAR:
      "أَفَأَمِنَ أَهْلُ الْقُرَىٰ أَنْ يَأْتِيَهُمْ بَأْسُنَا بَيَاتًا وَهُمْ نَائِمُونَ",
  },
  {
    id: "1052",
    sura: "7",
    VerseIDAr: "98",
    ayatAR:
      "أَوَأَمِنَ أَهْلُ الْقُرَىٰ أَنْ يَأْتِيَهُمْ بَأْسُنَا ضُحًى وَهُمْ يَلْعَبُونَ",
  },
  {
    id: "1053",
    sura: "7",
    VerseIDAr: "99",
    ayatAR:
      "أَفَأَمِنُوا مَكْرَ اللَّهِ ۚ فَلَا يَأْمَنُ مَكْرَ اللَّهِ إِلَّا الْقَوْمُ الْخَاسِرُونَ",
  },
  {
    id: "1054",
    sura: "7",
    VerseIDAr: "100",
    ayatAR:
      "أَوَلَمْ يَهْدِ لِلَّذِينَ يَرِثُونَ الْأَرْضَ مِنْ بَعْدِ أَهْلِهَا أَنْ لَوْ نَشَاءُ أَصَبْنَاهُمْ بِذُنُوبِهِمْ ۚ وَنَطْبَعُ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَسْمَعُونَ",
  },
  {
    id: "1055",
    sura: "7",
    VerseIDAr: "101",
    ayatAR:
      "تِلْكَ الْقُرَىٰ نَقُصُّ عَلَيْكَ مِنْ أَنْبَائِهَا ۚ وَلَقَدْ جَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ فَمَا كَانُوا لِيُؤْمِنُوا بِمَا كَذَّبُوا مِنْ قَبْلُ ۚ كَذَٰلِكَ يَطْبَعُ اللَّهُ عَلَىٰ قُلُوبِ الْكَافِرِينَ",
  },
  {
    id: "1056",
    sura: "7",
    VerseIDAr: "102",
    ayatAR:
      "وَمَا وَجَدْنَا لِأَكْثَرِهِمْ مِنْ عَهْدٍ ۖ وَإِنْ وَجَدْنَا أَكْثَرَهُمْ لَفَاسِقِينَ",
  },
  {
    id: "1057",
    sura: "7",
    VerseIDAr: "103",
    ayatAR:
      "ثُمَّ بَعَثْنَا مِنْ بَعْدِهِمْ مُوسَىٰ بِآيَاتِنَا إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ فَظَلَمُوا بِهَا ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُفْسِدِينَ",
  },
  {
    id: "1058",
    sura: "7",
    VerseIDAr: "104",
    ayatAR:
      "وَقَالَ مُوسَىٰ يَا فِرْعَوْنُ إِنِّي رَسُولٌ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "1059",
    sura: "7",
    VerseIDAr: "105",
    ayatAR:
      "حَقِيقٌ عَلَىٰ أَنْ لَا أَقُولَ عَلَى اللَّهِ إِلَّا الْحَقَّ ۚ قَدْ جِئْتُكُمْ بِبَيِّنَةٍ مِنْ رَبِّكُمْ فَأَرْسِلْ مَعِيَ بَنِي إِسْرَائِيلَ",
  },
  {
    id: "1060",
    sura: "7",
    VerseIDAr: "106",
    ayatAR:
      "قَالَ إِنْ كُنْتَ جِئْتَ بِآيَةٍ فَأْتِ بِهَا إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "1061",
    sura: "7",
    VerseIDAr: "107",
    ayatAR: "فَأَلْقَىٰ عَصَاهُ فَإِذَا هِيَ ثُعْبَانٌ مُبِينٌ",
  },
  {
    id: "1062",
    sura: "7",
    VerseIDAr: "108",
    ayatAR: "وَنَزَعَ يَدَهُ فَإِذَا هِيَ بَيْضَاءُ لِلنَّاظِرِينَ",
  },
  {
    id: "1063",
    sura: "7",
    VerseIDAr: "109",
    ayatAR:
      "قَالَ الْمَلَأُ مِنْ قَوْمِ فِرْعَوْنَ إِنَّ هَٰذَا لَسَاحِرٌ عَلِيمٌ",
  },
  {
    id: "1064",
    sura: "7",
    VerseIDAr: "110",
    ayatAR: "يُرِيدُ أَنْ يُخْرِجَكُمْ مِنْ أَرْضِكُمْ ۖ فَمَاذَا تَأْمُرُونَ",
  },
  {
    id: "1065",
    sura: "7",
    VerseIDAr: "111",
    ayatAR: "قَالُوا أَرْجِهْ وَأَخَاهُ وَأَرْسِلْ فِي الْمَدَائِنِ حَاشِرِينَ",
  },
  {
    id: "1066",
    sura: "7",
    VerseIDAr: "112",
    ayatAR: "يَأْتُوكَ بِكُلِّ سَاحِرٍ عَلِيمٍ",
  },
  {
    id: "1067",
    sura: "7",
    VerseIDAr: "113",
    ayatAR:
      "وَجَاءَ السَّحَرَةُ فِرْعَوْنَ قَالُوا إِنَّ لَنَا لَأَجْرًا إِنْ كُنَّا نَحْنُ الْغَالِبِينَ",
  },
  {
    id: "1068",
    sura: "7",
    VerseIDAr: "114",
    ayatAR: "قَالَ نَعَمْ وَإِنَّكُمْ لَمِنَ الْمُقَرَّبِينَ",
  },
  {
    id: "1069",
    sura: "7",
    VerseIDAr: "115",
    ayatAR:
      "قَالُوا يَا مُوسَىٰ إِمَّا أَنْ تُلْقِيَ وَإِمَّا أَنْ نَكُونَ نَحْنُ الْمُلْقِينَ",
  },
  {
    id: "1070",
    sura: "7",
    VerseIDAr: "116",
    ayatAR:
      "قَالَ أَلْقُوا ۖ فَلَمَّا أَلْقَوْا سَحَرُوا أَعْيُنَ النَّاسِ وَاسْتَرْهَبُوهُمْ وَجَاءُوا بِسِحْرٍ عَظِيمٍ",
  },
  {
    id: "1071",
    sura: "7",
    VerseIDAr: "117",
    ayatAR:
      "وَأَوْحَيْنَا إِلَىٰ مُوسَىٰ أَنْ أَلْقِ عَصَاكَ ۖ فَإِذَا هِيَ تَلْقَفُ مَا يَأْفِكُونَ",
  },
  {
    id: "1072",
    sura: "7",
    VerseIDAr: "118",
    ayatAR: "فَوَقَعَ الْحَقُّ وَبَطَلَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1073",
    sura: "7",
    VerseIDAr: "119",
    ayatAR: "فَغُلِبُوا هُنَالِكَ وَانْقَلَبُوا صَاغِرِينَ",
  },
  {
    id: "1074",
    sura: "7",
    VerseIDAr: "120",
    ayatAR: "وَأُلْقِيَ السَّحَرَةُ سَاجِدِينَ",
  },
  {
    id: "1075",
    sura: "7",
    VerseIDAr: "121",
    ayatAR: "قَالُوا آمَنَّا بِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "1076",
    sura: "7",
    VerseIDAr: "122",
    ayatAR: "رَبِّ مُوسَىٰ وَهَارُونَ",
  },
  {
    id: "1077",
    sura: "7",
    VerseIDAr: "123",
    ayatAR:
      "قَالَ فِرْعَوْنُ آمَنْتُمْ بِهِ قَبْلَ أَنْ آذَنَ لَكُمْ ۖ إِنَّ هَٰذَا لَمَكْرٌ مَكَرْتُمُوهُ فِي الْمَدِينَةِ لِتُخْرِجُوا مِنْهَا أَهْلَهَا ۖ فَسَوْفَ تَعْلَمُونَ",
  },
  {
    id: "1078",
    sura: "7",
    VerseIDAr: "124",
    ayatAR:
      "لَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُمْ مِنْ خِلَافٍ ثُمَّ لَأُصَلِّبَنَّكُمْ أَجْمَعِينَ",
  },
  {
    id: "1079",
    sura: "7",
    VerseIDAr: "125",
    ayatAR: "قَالُوا إِنَّا إِلَىٰ رَبِّنَا مُنْقَلِبُونَ",
  },
  {
    id: "1080",
    sura: "7",
    VerseIDAr: "126",
    ayatAR:
      "وَمَا تَنْقِمُ مِنَّا إِلَّا أَنْ آمَنَّا بِآيَاتِ رَبِّنَا لَمَّا جَاءَتْنَا ۚ رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَتَوَفَّنَا مُسْلِمِينَ",
  },
  {
    id: "1081",
    sura: "7",
    VerseIDAr: "127",
    ayatAR:
      "وَقَالَ الْمَلَأُ مِنْ قَوْمِ فِرْعَوْنَ أَتَذَرُ مُوسَىٰ وَقَوْمَهُ لِيُفْسِدُوا فِي الْأَرْضِ وَيَذَرَكَ وَآلِهَتَكَ ۚ قَالَ سَنُقَتِّلُ أَبْنَاءَهُمْ وَنَسْتَحْيِي نِسَاءَهُمْ وَإِنَّا فَوْقَهُمْ قَاهِرُونَ",
  },
  {
    id: "1082",
    sura: "7",
    VerseIDAr: "128",
    ayatAR:
      "قَالَ مُوسَىٰ لِقَوْمِهِ اسْتَعِينُوا بِاللَّهِ وَاصْبِرُوا ۖ إِنَّ الْأَرْضَ لِلَّهِ يُورِثُهَا مَنْ يَشَاءُ مِنْ عِبَادِهِ ۖ وَالْعَاقِبَةُ لِلْمُتَّقِينَ",
  },
  {
    id: "1083",
    sura: "7",
    VerseIDAr: "129",
    ayatAR:
      "قَالُوا أُوذِينَا مِنْ قَبْلِ أَنْ تَأْتِيَنَا وَمِنْ بَعْدِ مَا جِئْتَنَا ۚ قَالَ عَسَىٰ رَبُّكُمْ أَنْ يُهْلِكَ عَدُوَّكُمْ وَيَسْتَخْلِفَكُمْ فِي الْأَرْضِ فَيَنْظُرَ كَيْفَ تَعْمَلُونَ",
  },
  {
    id: "1084",
    sura: "7",
    VerseIDAr: "130",
    ayatAR:
      "وَلَقَدْ أَخَذْنَا آلَ فِرْعَوْنَ بِالسِّنِينَ وَنَقْصٍ مِنَ الثَّمَرَاتِ لَعَلَّهُمْ يَذَّكَّرُونَ",
  },
  {
    id: "1085",
    sura: "7",
    VerseIDAr: "131",
    ayatAR:
      "فَإِذَا جَاءَتْهُمُ الْحَسَنَةُ قَالُوا لَنَا هَٰذِهِ ۖ وَإِنْ تُصِبْهُمْ سَيِّئَةٌ يَطَّيَّرُوا بِمُوسَىٰ وَمَنْ مَعَهُ ۗ أَلَا إِنَّمَا طَائِرُهُمْ عِنْدَ اللَّهِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "1086",
    sura: "7",
    VerseIDAr: "132",
    ayatAR:
      "وَقَالُوا مَهْمَا تَأْتِنَا بِهِ مِنْ آيَةٍ لِتَسْحَرَنَا بِهَا فَمَا نَحْنُ لَكَ بِمُؤْمِنِينَ",
  },
  {
    id: "1087",
    sura: "7",
    VerseIDAr: "133",
    ayatAR:
      "فَأَرْسَلْنَا عَلَيْهِمُ الطُّوفَانَ وَالْجَرَادَ وَالْقُمَّلَ وَالضَّفَادِعَ وَالدَّمَ آيَاتٍ مُفَصَّلَاتٍ فَاسْتَكْبَرُوا وَكَانُوا قَوْمًا مُجْرِمِينَ",
  },
  {
    id: "1088",
    sura: "7",
    VerseIDAr: "134",
    ayatAR:
      "وَلَمَّا وَقَعَ عَلَيْهِمُ الرِّجْزُ قَالُوا يَا مُوسَى ادْعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِنْدَكَ ۖ لَئِنْ كَشَفْتَ عَنَّا الرِّجْزَ لَنُؤْمِنَنَّ لَكَ وَلَنُرْسِلَنَّ مَعَكَ بَنِي إِسْرَائِيلَ",
  },
  {
    id: "1089",
    sura: "7",
    VerseIDAr: "135",
    ayatAR:
      "فَلَمَّا كَشَفْنَا عَنْهُمُ الرِّجْزَ إِلَىٰ أَجَلٍ هُمْ بَالِغُوهُ إِذَا هُمْ يَنْكُثُونَ",
  },
  {
    id: "1090",
    sura: "7",
    VerseIDAr: "136",
    ayatAR:
      "فَانْتَقَمْنَا مِنْهُمْ فَأَغْرَقْنَاهُمْ فِي الْيَمِّ بِأَنَّهُمْ كَذَّبُوا بِآيَاتِنَا وَكَانُوا عَنْهَا غَافِلِينَ",
  },
  {
    id: "1091",
    sura: "7",
    VerseIDAr: "137",
    ayatAR:
      "وَأَوْرَثْنَا الْقَوْمَ الَّذِينَ كَانُوا يُسْتَضْعَفُونَ مَشَارِقَ الْأَرْضِ وَمَغَارِبَهَا الَّتِي بَارَكْنَا فِيهَا ۖ وَتَمَّتْ كَلِمَتُ رَبِّكَ الْحُسْنَىٰ عَلَىٰ بَنِي إِسْرَائِيلَ بِمَا صَبَرُوا ۖ وَدَمَّرْنَا مَا كَانَ يَصْنَعُ فِرْعَوْنُ وَقَوْمُهُ وَمَا كَانُوا يَعْرِشُونَ",
  },
  {
    id: "1092",
    sura: "7",
    VerseIDAr: "138",
    ayatAR:
      "وَجَاوَزْنَا بِبَنِي إِسْرَائِيلَ الْبَحْرَ فَأَتَوْا عَلَىٰ قَوْمٍ يَعْكُفُونَ عَلَىٰ أَصْنَامٍ لَهُمْ ۚ قَالُوا يَا مُوسَى اجْعَلْ لَنَا إِلَٰهًا كَمَا لَهُمْ آلِهَةٌ ۚ قَالَ إِنَّكُمْ قَوْمٌ تَجْهَلُونَ",
  },
  {
    id: "1093",
    sura: "7",
    VerseIDAr: "139",
    ayatAR:
      "إِنَّ هَٰؤُلَاءِ مُتَبَّرٌ مَا هُمْ فِيهِ وَبَاطِلٌ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1094",
    sura: "7",
    VerseIDAr: "140",
    ayatAR:
      "قَالَ أَغَيْرَ اللَّهِ أَبْغِيكُمْ إِلَٰهًا وَهُوَ فَضَّلَكُمْ عَلَى الْعَالَمِينَ",
  },
  {
    id: "1095",
    sura: "7",
    VerseIDAr: "141",
    ayatAR:
      "وَإِذْ أَنْجَيْنَاكُمْ مِنْ آلِ فِرْعَوْنَ يَسُومُونَكُمْ سُوءَ الْعَذَابِ ۖ يُقَتِّلُونَ أَبْنَاءَكُمْ وَيَسْتَحْيُونَ نِسَاءَكُمْ ۚ وَفِي ذَٰلِكُمْ بَلَاءٌ مِنْ رَبِّكُمْ عَظِيمٌ",
  },
  {
    id: "1096",
    sura: "7",
    VerseIDAr: "142",
    ayatAR:
      "وَوَاعَدْنَا مُوسَىٰ ثَلَاثِينَ لَيْلَةً وَأَتْمَمْنَاهَا بِعَشْرٍ فَتَمَّ مِيقَاتُ رَبِّهِ أَرْبَعِينَ لَيْلَةً ۚ وَقَالَ مُوسَىٰ لِأَخِيهِ هَارُونَ اخْلُفْنِي فِي قَوْمِي وَأَصْلِحْ وَلَا تَتَّبِعْ سَبِيلَ الْمُفْسِدِينَ",
  },
  {
    id: "1097",
    sura: "7",
    VerseIDAr: "143",
    ayatAR:
      "وَلَمَّا جَاءَ مُوسَىٰ لِمِيقَاتِنَا وَكَلَّمَهُ رَبُّهُ قَالَ رَبِّ أَرِنِي أَنْظُرْ إِلَيْكَ ۚ قَالَ لَنْ تَرَانِي وَلَٰكِنِ انْظُرْ إِلَى الْجَبَلِ فَإِنِ اسْتَقَرَّ مَكَانَهُ فَسَوْفَ تَرَانِي ۚ فَلَمَّا تَجَلَّىٰ رَبُّهُ لِلْجَبَلِ جَعَلَهُ دَكًّا وَخَرَّ مُوسَىٰ صَعِقًا ۚ فَلَمَّا أَفَاقَ قَالَ سُبْحَانَكَ تُبْتُ إِلَيْكَ وَأَنَا أَوَّلُ الْمُؤْمِنِينَ",
  },
  {
    id: "1098",
    sura: "7",
    VerseIDAr: "144",
    ayatAR:
      "قَالَ يَا مُوسَىٰ إِنِّي اصْطَفَيْتُكَ عَلَى النَّاسِ بِرِسَالَاتِي وَبِكَلَامِي فَخُذْ مَا آتَيْتُكَ وَكُنْ مِنَ الشَّاكِرِينَ",
  },
  {
    id: "1099",
    sura: "7",
    VerseIDAr: "145",
    ayatAR:
      "وَكَتَبْنَا لَهُ فِي الْأَلْوَاحِ مِنْ كُلِّ شَيْءٍ مَوْعِظَةً وَتَفْصِيلًا لِكُلِّ شَيْءٍ فَخُذْهَا بِقُوَّةٍ وَأْمُرْ قَوْمَكَ يَأْخُذُوا بِأَحْسَنِهَا ۚ سَأُرِيكُمْ دَارَ الْفَاسِقِينَ",
  },
  {
    id: "1100",
    sura: "7",
    VerseIDAr: "146",
    ayatAR:
      "سَأَصْرِفُ عَنْ آيَاتِيَ الَّذِينَ يَتَكَبَّرُونَ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ وَإِنْ يَرَوْا كُلَّ آيَةٍ لَا يُؤْمِنُوا بِهَا وَإِنْ يَرَوْا سَبِيلَ الرُّشْدِ لَا يَتَّخِذُوهُ سَبِيلًا وَإِنْ يَرَوْا سَبِيلَ الْغَيِّ يَتَّخِذُوهُ سَبِيلًا ۚ ذَٰلِكَ بِأَنَّهُمْ كَذَّبُوا بِآيَاتِنَا وَكَانُوا عَنْهَا غَافِلِينَ",
  },
  {
    id: "1101",
    sura: "7",
    VerseIDAr: "147",
    ayatAR:
      "وَالَّذِينَ كَذَّبُوا بِآيَاتِنَا وَلِقَاءِ الْآخِرَةِ حَبِطَتْ أَعْمَالُهُمْ ۚ هَلْ يُجْزَوْنَ إِلَّا مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1102",
    sura: "7",
    VerseIDAr: "148",
    ayatAR:
      "وَاتَّخَذَ قَوْمُ مُوسَىٰ مِنْ بَعْدِهِ مِنْ حُلِيِّهِمْ عِجْلًا جَسَدًا لَهُ خُوَارٌ ۚ أَلَمْ يَرَوْا أَنَّهُ لَا يُكَلِّمُهُمْ وَلَا يَهْدِيهِمْ سَبِيلًا ۘ اتَّخَذُوهُ وَكَانُوا ظَالِمِينَ",
  },
  {
    id: "1103",
    sura: "7",
    VerseIDAr: "149",
    ayatAR:
      "وَلَمَّا سُقِطَ فِي أَيْدِيهِمْ وَرَأَوْا أَنَّهُمْ قَدْ ضَلُّوا قَالُوا لَئِنْ لَمْ يَرْحَمْنَا رَبُّنَا وَيَغْفِرْ لَنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "1104",
    sura: "7",
    VerseIDAr: "150",
    ayatAR:
      "وَلَمَّا رَجَعَ مُوسَىٰ إِلَىٰ قَوْمِهِ غَضْبَانَ أَسِفًا قَالَ بِئْسَمَا خَلَفْتُمُونِي مِنْ بَعْدِي ۖ أَعَجِلْتُمْ أَمْرَ رَبِّكُمْ ۖ وَأَلْقَى الْأَلْوَاحَ وَأَخَذَ بِرَأْسِ أَخِيهِ يَجُرُّهُ إِلَيْهِ ۚ قَالَ ابْنَ أُمَّ إِنَّ الْقَوْمَ اسْتَضْعَفُونِي وَكَادُوا يَقْتُلُونَنِي فَلَا تُشْمِتْ بِيَ الْأَعْدَاءَ وَلَا تَجْعَلْنِي مَعَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "1105",
    sura: "7",
    VerseIDAr: "151",
    ayatAR:
      "قَالَ رَبِّ اغْفِرْ لِي وَلِأَخِي وَأَدْخِلْنَا فِي رَحْمَتِكَ ۖ وَأَنْتَ أَرْحَمُ الرَّاحِمِينَ",
  },
  {
    id: "1106",
    sura: "7",
    VerseIDAr: "152",
    ayatAR:
      "إِنَّ الَّذِينَ اتَّخَذُوا الْعِجْلَ سَيَنَالُهُمْ غَضَبٌ مِنْ رَبِّهِمْ وَذِلَّةٌ فِي الْحَيَاةِ الدُّنْيَا ۚ وَكَذَٰلِكَ نَجْزِي الْمُفْتَرِينَ",
  },
  {
    id: "1107",
    sura: "7",
    VerseIDAr: "153",
    ayatAR:
      "وَالَّذِينَ عَمِلُوا السَّيِّئَاتِ ثُمَّ تَابُوا مِنْ بَعْدِهَا وَآمَنُوا إِنَّ رَبَّكَ مِنْ بَعْدِهَا لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "1108",
    sura: "7",
    VerseIDAr: "154",
    ayatAR:
      "وَلَمَّا سَكَتَ عَنْ مُوسَى الْغَضَبُ أَخَذَ الْأَلْوَاحَ ۖ وَفِي نُسْخَتِهَا هُدًى وَرَحْمَةٌ لِلَّذِينَ هُمْ لِرَبِّهِمْ يَرْهَبُونَ",
  },
  {
    id: "1109",
    sura: "7",
    VerseIDAr: "155",
    ayatAR:
      "وَاخْتَارَ مُوسَىٰ قَوْمَهُ سَبْعِينَ رَجُلًا لِمِيقَاتِنَا ۖ فَلَمَّا أَخَذَتْهُمُ الرَّجْفَةُ قَالَ رَبِّ لَوْ شِئْتَ أَهْلَكْتَهُمْ مِنْ قَبْلُ وَإِيَّايَ ۖ أَتُهْلِكُنَا بِمَا فَعَلَ السُّفَهَاءُ مِنَّا ۖ إِنْ هِيَ إِلَّا فِتْنَتُكَ تُضِلُّ بِهَا مَنْ تَشَاءُ وَتَهْدِي مَنْ تَشَاءُ ۖ أَنْتَ وَلِيُّنَا فَاغْفِرْ لَنَا وَارْحَمْنَا ۖ وَأَنْتَ خَيْرُ الْغَافِرِينَ",
  },
  {
    id: "1110",
    sura: "7",
    VerseIDAr: "156",
    ayatAR:
      "وَاكْتُبْ لَنَا فِي هَٰذِهِ الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ إِنَّا هُدْنَا إِلَيْكَ ۚ قَالَ عَذَابِي أُصِيبُ بِهِ مَنْ أَشَاءُ ۖ وَرَحْمَتِي وَسِعَتْ كُلَّ شَيْءٍ ۚ فَسَأَكْتُبُهَا لِلَّذِينَ يَتَّقُونَ وَيُؤْتُونَ الزَّكَاةَ وَالَّذِينَ هُمْ بِآيَاتِنَا يُؤْمِنُونَ",
  },
  {
    id: "1111",
    sura: "7",
    VerseIDAr: "157",
    ayatAR:
      "الَّذِينَ يَتَّبِعُونَ الرَّسُولَ النَّبِيَّ الْأُمِّيَّ الَّذِي يَجِدُونَهُ مَكْتُوبًا عِنْدَهُمْ فِي التَّوْرَاةِ وَالْإِنْجِيلِ يَأْمُرُهُمْ بِالْمَعْرُوفِ وَيَنْهَاهُمْ عَنِ الْمُنْكَرِ وَيُحِلُّ لَهُمُ الطَّيِّبَاتِ وَيُحَرِّمُ عَلَيْهِمُ الْخَبَائِثَ وَيَضَعُ عَنْهُمْ إِصْرَهُمْ وَالْأَغْلَالَ الَّتِي كَانَتْ عَلَيْهِمْ ۚ فَالَّذِينَ آمَنُوا بِهِ وَعَزَّرُوهُ وَنَصَرُوهُ وَاتَّبَعُوا النُّورَ الَّذِي أُنْزِلَ مَعَهُ ۙ أُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "1112",
    sura: "7",
    VerseIDAr: "158",
    ayatAR:
      "قُلْ يَا أَيُّهَا النَّاسُ إِنِّي رَسُولُ اللَّهِ إِلَيْكُمْ جَمِيعًا الَّذِي لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۖ لَا إِلَٰهَ إِلَّا هُوَ يُحْيِي وَيُمِيتُ ۖ فَآمِنُوا بِاللَّهِ وَرَسُولِهِ النَّبِيِّ الْأُمِّيِّ الَّذِي يُؤْمِنُ بِاللَّهِ وَكَلِمَاتِهِ وَاتَّبِعُوهُ لَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "1113",
    sura: "7",
    VerseIDAr: "159",
    ayatAR:
      "وَمِنْ قَوْمِ مُوسَىٰ أُمَّةٌ يَهْدُونَ بِالْحَقِّ وَبِهِ يَعْدِلُونَ",
  },
  {
    id: "1114",
    sura: "7",
    VerseIDAr: "160",
    ayatAR:
      "وَقَطَّعْنَاهُمُ اثْنَتَيْ عَشْرَةَ أَسْبَاطًا أُمَمًا ۚ وَأَوْحَيْنَا إِلَىٰ مُوسَىٰ إِذِ اسْتَسْقَاهُ قَوْمُهُ أَنِ اضْرِبْ بِعَصَاكَ الْحَجَرَ ۖ فَانْبَجَسَتْ مِنْهُ اثْنَتَا عَشْرَةَ عَيْنًا ۖ قَدْ عَلِمَ كُلُّ أُنَاسٍ مَشْرَبَهُمْ ۚ وَظَلَّلْنَا عَلَيْهِمُ الْغَمَامَ وَأَنْزَلْنَا عَلَيْهِمُ الْمَنَّ وَالسَّلْوَىٰ ۖ كُلُوا مِنْ طَيِّبَاتِ مَا رَزَقْنَاكُمْ ۚ وَمَا ظَلَمُونَا وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "1115",
    sura: "7",
    VerseIDAr: "161",
    ayatAR:
      "وَإِذْ قِيلَ لَهُمُ اسْكُنُوا هَٰذِهِ الْقَرْيَةَ وَكُلُوا مِنْهَا حَيْثُ شِئْتُمْ وَقُولُوا حِطَّةٌ وَادْخُلُوا الْبَابَ سُجَّدًا نَغْفِرْ لَكُمْ خَطِيئَاتِكُمْ ۚ سَنَزِيدُ الْمُحْسِنِينَ",
  },
  {
    id: "1116",
    sura: "7",
    VerseIDAr: "162",
    ayatAR:
      "فَبَدَّلَ الَّذِينَ ظَلَمُوا مِنْهُمْ قَوْلًا غَيْرَ الَّذِي قِيلَ لَهُمْ فَأَرْسَلْنَا عَلَيْهِمْ رِجْزًا مِنَ السَّمَاءِ بِمَا كَانُوا يَظْلِمُونَ",
  },
  {
    id: "1117",
    sura: "7",
    VerseIDAr: "163",
    ayatAR:
      "وَاسْأَلْهُمْ عَنِ الْقَرْيَةِ الَّتِي كَانَتْ حَاضِرَةَ الْبَحْرِ إِذْ يَعْدُونَ فِي السَّبْتِ إِذْ تَأْتِيهِمْ حِيتَانُهُمْ يَوْمَ سَبْتِهِمْ شُرَّعًا وَيَوْمَ لَا يَسْبِتُونَ ۙ لَا تَأْتِيهِمْ ۚ كَذَٰلِكَ نَبْلُوهُمْ بِمَا كَانُوا يَفْسُقُونَ",
  },
  {
    id: "1118",
    sura: "7",
    VerseIDAr: "164",
    ayatAR:
      "وَإِذْ قَالَتْ أُمَّةٌ مِنْهُمْ لِمَ تَعِظُونَ قَوْمًا ۙ اللَّهُ مُهْلِكُهُمْ أَوْ مُعَذِّبُهُمْ عَذَابًا شَدِيدًا ۖ قَالُوا مَعْذِرَةً إِلَىٰ رَبِّكُمْ وَلَعَلَّهُمْ يَتَّقُونَ",
  },
  {
    id: "1119",
    sura: "7",
    VerseIDAr: "165",
    ayatAR:
      "فَلَمَّا نَسُوا مَا ذُكِّرُوا بِهِ أَنْجَيْنَا الَّذِينَ يَنْهَوْنَ عَنِ السُّوءِ وَأَخَذْنَا الَّذِينَ ظَلَمُوا بِعَذَابٍ بَئِيسٍ بِمَا كَانُوا يَفْسُقُونَ",
  },
  {
    id: "1120",
    sura: "7",
    VerseIDAr: "166",
    ayatAR:
      "فَلَمَّا عَتَوْا عَنْ مَا نُهُوا عَنْهُ قُلْنَا لَهُمْ كُونُوا قِرَدَةً خَاسِئِينَ",
  },
  {
    id: "1121",
    sura: "7",
    VerseIDAr: "167",
    ayatAR:
      "وَإِذْ تَأَذَّنَ رَبُّكَ لَيَبْعَثَنَّ عَلَيْهِمْ إِلَىٰ يَوْمِ الْقِيَامَةِ مَنْ يَسُومُهُمْ سُوءَ الْعَذَابِ ۗ إِنَّ رَبَّكَ لَسَرِيعُ الْعِقَابِ ۖ وَإِنَّهُ لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "1122",
    sura: "7",
    VerseIDAr: "168",
    ayatAR:
      "وَقَطَّعْنَاهُمْ فِي الْأَرْضِ أُمَمًا ۖ مِنْهُمُ الصَّالِحُونَ وَمِنْهُمْ دُونَ ذَٰلِكَ ۖ وَبَلَوْنَاهُمْ بِالْحَسَنَاتِ وَالسَّيِّئَاتِ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "1123",
    sura: "7",
    VerseIDAr: "169",
    ayatAR:
      "فَخَلَفَ مِنْ بَعْدِهِمْ خَلْفٌ وَرِثُوا الْكِتَابَ يَأْخُذُونَ عَرَضَ هَٰذَا الْأَدْنَىٰ وَيَقُولُونَ سَيُغْفَرُ لَنَا وَإِنْ يَأْتِهِمْ عَرَضٌ مِثْلُهُ يَأْخُذُوهُ ۚ أَلَمْ يُؤْخَذْ عَلَيْهِمْ مِيثَاقُ الْكِتَابِ أَنْ لَا يَقُولُوا عَلَى اللَّهِ إِلَّا الْحَقَّ وَدَرَسُوا مَا فِيهِ ۗ وَالدَّارُ الْآخِرَةُ خَيْرٌ لِلَّذِينَ يَتَّقُونَ ۗ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "1124",
    sura: "7",
    VerseIDAr: "170",
    ayatAR:
      "وَالَّذِينَ يُمَسِّكُونَ بِالْكِتَابِ وَأَقَامُوا الصَّلَاةَ إِنَّا لَا نُضِيعُ أَجْرَ الْمُصْلِحِينَ",
  },
  {
    id: "1125",
    sura: "7",
    VerseIDAr: "171",
    ayatAR:
      "وَإِذْ نَتَقْنَا الْجَبَلَ فَوْقَهُمْ كَأَنَّهُ ظُلَّةٌ وَظَنُّوا أَنَّهُ وَاقِعٌ بِهِمْ خُذُوا مَا آتَيْنَاكُمْ بِقُوَّةٍ وَاذْكُرُوا مَا فِيهِ لَعَلَّكُمْ تَتَّقُونَ",
  },
  {
    id: "1126",
    sura: "7",
    VerseIDAr: "172",
    ayatAR:
      "وَإِذْ أَخَذَ رَبُّكَ مِنْ بَنِي آدَمَ مِنْ ظُهُورِهِمْ ذُرِّيَّتَهُمْ وَأَشْهَدَهُمْ عَلَىٰ أَنْفُسِهِمْ أَلَسْتُ بِرَبِّكُمْ ۖ قَالُوا بَلَىٰ ۛ شَهِدْنَا ۛ أَنْ تَقُولُوا يَوْمَ الْقِيَامَةِ إِنَّا كُنَّا عَنْ هَٰذَا غَافِلِينَ",
  },
  {
    id: "1127",
    sura: "7",
    VerseIDAr: "173",
    ayatAR:
      "أَوْ تَقُولُوا إِنَّمَا أَشْرَكَ آبَاؤُنَا مِنْ قَبْلُ وَكُنَّا ذُرِّيَّةً مِنْ بَعْدِهِمْ ۖ أَفَتُهْلِكُنَا بِمَا فَعَلَ الْمُبْطِلُونَ",
  },
  {
    id: "1128",
    sura: "7",
    VerseIDAr: "174",
    ayatAR: "وَكَذَٰلِكَ نُفَصِّلُ الْآيَاتِ وَلَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "1129",
    sura: "7",
    VerseIDAr: "175",
    ayatAR:
      "وَاتْلُ عَلَيْهِمْ نَبَأَ الَّذِي آتَيْنَاهُ آيَاتِنَا فَانْسَلَخَ مِنْهَا فَأَتْبَعَهُ الشَّيْطَانُ فَكَانَ مِنَ الْغَاوِينَ",
  },
  {
    id: "1130",
    sura: "7",
    VerseIDAr: "176",
    ayatAR:
      "وَلَوْ شِئْنَا لَرَفَعْنَاهُ بِهَا وَلَٰكِنَّهُ أَخْلَدَ إِلَى الْأَرْضِ وَاتَّبَعَ هَوَاهُ ۚ فَمَثَلُهُ كَمَثَلِ الْكَلْبِ إِنْ تَحْمِلْ عَلَيْهِ يَلْهَثْ أَوْ تَتْرُكْهُ يَلْهَثْ ۚ ذَٰلِكَ مَثَلُ الْقَوْمِ الَّذِينَ كَذَّبُوا بِآيَاتِنَا ۚ فَاقْصُصِ الْقَصَصَ لَعَلَّهُمْ يَتَفَكَّرُونَ",
  },
  {
    id: "1131",
    sura: "7",
    VerseIDAr: "177",
    ayatAR:
      "سَاءَ مَثَلًا الْقَوْمُ الَّذِينَ كَذَّبُوا بِآيَاتِنَا وَأَنْفُسَهُمْ كَانُوا يَظْلِمُونَ",
  },
  {
    id: "1132",
    sura: "7",
    VerseIDAr: "178",
    ayatAR:
      "مَنْ يَهْدِ اللَّهُ فَهُوَ الْمُهْتَدِي ۖ وَمَنْ يُضْلِلْ فَأُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "1133",
    sura: "7",
    VerseIDAr: "179",
    ayatAR:
      "وَلَقَدْ ذَرَأْنَا لِجَهَنَّمَ كَثِيرًا مِنَ الْجِنِّ وَالْإِنْسِ ۖ لَهُمْ قُلُوبٌ لَا يَفْقَهُونَ بِهَا وَلَهُمْ أَعْيُنٌ لَا يُبْصِرُونَ بِهَا وَلَهُمْ آذَانٌ لَا يَسْمَعُونَ بِهَا ۚ أُولَٰئِكَ كَالْأَنْعَامِ بَلْ هُمْ أَضَلُّ ۚ أُولَٰئِكَ هُمُ الْغَافِلُونَ",
  },
  {
    id: "1134",
    sura: "7",
    VerseIDAr: "180",
    ayatAR:
      "وَلِلَّهِ الْأَسْمَاءُ الْحُسْنَىٰ فَادْعُوهُ بِهَا ۖ وَذَرُوا الَّذِينَ يُلْحِدُونَ فِي أَسْمَائِهِ ۚ سَيُجْزَوْنَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1135",
    sura: "7",
    VerseIDAr: "181",
    ayatAR:
      "وَمِمَّنْ خَلَقْنَا أُمَّةٌ يَهْدُونَ بِالْحَقِّ وَبِهِ يَعْدِلُونَ",
  },
  {
    id: "1136",
    sura: "7",
    VerseIDAr: "182",
    ayatAR:
      "وَالَّذِينَ كَذَّبُوا بِآيَاتِنَا سَنَسْتَدْرِجُهُمْ مِنْ حَيْثُ لَا يَعْلَمُونَ",
  },
  {
    id: "1137",
    sura: "7",
    VerseIDAr: "183",
    ayatAR: "وَأُمْلِي لَهُمْ ۚ إِنَّ كَيْدِي مَتِينٌ",
  },
  {
    id: "1138",
    sura: "7",
    VerseIDAr: "184",
    ayatAR:
      "أَوَلَمْ يَتَفَكَّرُوا ۗ مَا بِصَاحِبِهِمْ مِنْ جِنَّةٍ ۚ إِنْ هُوَ إِلَّا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "1139",
    sura: "7",
    VerseIDAr: "185",
    ayatAR:
      "أَوَلَمْ يَنْظُرُوا فِي مَلَكُوتِ السَّمَاوَاتِ وَالْأَرْضِ وَمَا خَلَقَ اللَّهُ مِنْ شَيْءٍ وَأَنْ عَسَىٰ أَنْ يَكُونَ قَدِ اقْتَرَبَ أَجَلُهُمْ ۖ فَبِأَيِّ حَدِيثٍ بَعْدَهُ يُؤْمِنُونَ",
  },
  {
    id: "1140",
    sura: "7",
    VerseIDAr: "186",
    ayatAR:
      "مَنْ يُضْلِلِ اللَّهُ فَلَا هَادِيَ لَهُ ۚ وَيَذَرُهُمْ فِي طُغْيَانِهِمْ يَعْمَهُونَ",
  },
  {
    id: "1141",
    sura: "7",
    VerseIDAr: "187",
    ayatAR:
      "يَسْأَلُونَكَ عَنِ السَّاعَةِ أَيَّانَ مُرْسَاهَا ۖ قُلْ إِنَّمَا عِلْمُهَا عِنْدَ رَبِّي ۖ لَا يُجَلِّيهَا لِوَقْتِهَا إِلَّا هُوَ ۚ ثَقُلَتْ فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ لَا تَأْتِيكُمْ إِلَّا بَغْتَةً ۗ يَسْأَلُونَكَ كَأَنَّكَ حَفِيٌّ عَنْهَا ۖ قُلْ إِنَّمَا عِلْمُهَا عِنْدَ اللَّهِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "1142",
    sura: "7",
    VerseIDAr: "188",
    ayatAR:
      "قُلْ لَا أَمْلِكُ لِنَفْسِي نَفْعًا وَلَا ضَرًّا إِلَّا مَا شَاءَ اللَّهُ ۚ وَلَوْ كُنْتُ أَعْلَمُ الْغَيْبَ لَاسْتَكْثَرْتُ مِنَ الْخَيْرِ وَمَا مَسَّنِيَ السُّوءُ ۚ إِنْ أَنَا إِلَّا نَذِيرٌ وَبَشِيرٌ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1143",
    sura: "7",
    VerseIDAr: "189",
    ayatAR:
      "هُوَ الَّذِي خَلَقَكُمْ مِنْ نَفْسٍ وَاحِدَةٍ وَجَعَلَ مِنْهَا زَوْجَهَا لِيَسْكُنَ إِلَيْهَا ۖ فَلَمَّا تَغَشَّاهَا حَمَلَتْ حَمْلًا خَفِيفًا فَمَرَّتْ بِهِ ۖ فَلَمَّا أَثْقَلَتْ دَعَوَا اللَّهَ رَبَّهُمَا لَئِنْ آتَيْتَنَا صَالِحًا لَنَكُونَنَّ مِنَ الشَّاكِرِينَ",
  },
  {
    id: "1144",
    sura: "7",
    VerseIDAr: "190",
    ayatAR:
      "فَلَمَّا آتَاهُمَا صَالِحًا جَعَلَا لَهُ شُرَكَاءَ فِيمَا آتَاهُمَا ۚ فَتَعَالَى اللَّهُ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "1145",
    sura: "7",
    VerseIDAr: "191",
    ayatAR: "أَيُشْرِكُونَ مَا لَا يَخْلُقُ شَيْئًا وَهُمْ يُخْلَقُونَ",
  },
  {
    id: "1146",
    sura: "7",
    VerseIDAr: "192",
    ayatAR:
      "وَلَا يَسْتَطِيعُونَ لَهُمْ نَصْرًا وَلَا أَنْفُسَهُمْ يَنْصُرُونَ",
  },
  {
    id: "1147",
    sura: "7",
    VerseIDAr: "193",
    ayatAR:
      "وَإِنْ تَدْعُوهُمْ إِلَى الْهُدَىٰ لَا يَتَّبِعُوكُمْ ۚ سَوَاءٌ عَلَيْكُمْ أَدَعَوْتُمُوهُمْ أَمْ أَنْتُمْ صَامِتُونَ",
  },
  {
    id: "1148",
    sura: "7",
    VerseIDAr: "194",
    ayatAR:
      "إِنَّ الَّذِينَ تَدْعُونَ مِنْ دُونِ اللَّهِ عِبَادٌ أَمْثَالُكُمْ ۖ فَادْعُوهُمْ فَلْيَسْتَجِيبُوا لَكُمْ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "1149",
    sura: "7",
    VerseIDAr: "195",
    ayatAR:
      "أَلَهُمْ أَرْجُلٌ يَمْشُونَ بِهَا ۖ أَمْ لَهُمْ أَيْدٍ يَبْطِشُونَ بِهَا ۖ أَمْ لَهُمْ أَعْيُنٌ يُبْصِرُونَ بِهَا ۖ أَمْ لَهُمْ آذَانٌ يَسْمَعُونَ بِهَا ۗ قُلِ ادْعُوا شُرَكَاءَكُمْ ثُمَّ كِيدُونِ فَلَا تُنْظِرُونِ",
  },
  {
    id: "1150",
    sura: "7",
    VerseIDAr: "196",
    ayatAR:
      "إِنَّ وَلِيِّيَ اللَّهُ الَّذِي نَزَّلَ الْكِتَابَ ۖ وَهُوَ يَتَوَلَّى الصَّالِحِينَ",
  },
  {
    id: "1151",
    sura: "7",
    VerseIDAr: "197",
    ayatAR:
      "وَالَّذِينَ تَدْعُونَ مِنْ دُونِهِ لَا يَسْتَطِيعُونَ نَصْرَكُمْ وَلَا أَنْفُسَهُمْ يَنْصُرُونَ",
  },
  {
    id: "1152",
    sura: "7",
    VerseIDAr: "198",
    ayatAR:
      "وَإِنْ تَدْعُوهُمْ إِلَى الْهُدَىٰ لَا يَسْمَعُوا ۖ وَتَرَاهُمْ يَنْظُرُونَ إِلَيْكَ وَهُمْ لَا يُبْصِرُونَ",
  },
  {
    id: "1153",
    sura: "7",
    VerseIDAr: "199",
    ayatAR: "خُذِ الْعَفْوَ وَأْمُرْ بِالْعُرْفِ وَأَعْرِضْ عَنِ الْجَاهِلِينَ",
  },
  {
    id: "1154",
    sura: "7",
    VerseIDAr: "200",
    ayatAR:
      "وَإِمَّا يَنْزَغَنَّكَ مِنَ الشَّيْطَانِ نَزْغٌ فَاسْتَعِذْ بِاللَّهِ ۚ إِنَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1155",
    sura: "7",
    VerseIDAr: "201",
    ayatAR:
      "إِنَّ الَّذِينَ اتَّقَوْا إِذَا مَسَّهُمْ طَائِفٌ مِنَ الشَّيْطَانِ تَذَكَّرُوا فَإِذَا هُمْ مُبْصِرُونَ",
  },
  {
    id: "1156",
    sura: "7",
    VerseIDAr: "202",
    ayatAR: "وَإِخْوَانُهُمْ يَمُدُّونَهُمْ فِي الْغَيِّ ثُمَّ لَا يُقْصِرُونَ",
  },
  {
    id: "1157",
    sura: "7",
    VerseIDAr: "203",
    ayatAR:
      "وَإِذَا لَمْ تَأْتِهِمْ بِآيَةٍ قَالُوا لَوْلَا اجْتَبَيْتَهَا ۚ قُلْ إِنَّمَا أَتَّبِعُ مَا يُوحَىٰ إِلَيَّ مِنْ رَبِّي ۚ هَٰذَا بَصَائِرُ مِنْ رَبِّكُمْ وَهُدًى وَرَحْمَةٌ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1158",
    sura: "7",
    VerseIDAr: "204",
    ayatAR:
      "وَإِذَا قُرِئَ الْقُرْآنُ فَاسْتَمِعُوا لَهُ وَأَنْصِتُوا لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "1159",
    sura: "7",
    VerseIDAr: "205",
    ayatAR:
      "وَاذْكُرْ رَبَّكَ فِي نَفْسِكَ تَضَرُّعًا وَخِيفَةً وَدُونَ الْجَهْرِ مِنَ الْقَوْلِ بِالْغُدُوِّ وَالْآصَالِ وَلَا تَكُنْ مِنَ الْغَافِلِينَ",
  },
  {
    id: "1160",
    sura: "7",
    VerseIDAr: "206",
    ayatAR:
      "إِنَّ الَّذِينَ عِنْدَ رَبِّكَ لَا يَسْتَكْبِرُونَ عَنْ عِبَادَتِهِ وَيُسَبِّحُونَهُ وَلَهُ يَسْجُدُونَ ۩",
  },
  {
    id: "1161",
    sura: "8",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَسْأَلُونَكَ عَنِ الْأَنْفَالِ ۖ قُلِ الْأَنْفَالُ لِلَّهِ وَالرَّسُولِ ۖ فَاتَّقُوا اللَّهَ وَأَصْلِحُوا ذَاتَ بَيْنِكُمْ ۖ وَأَطِيعُوا اللَّهَ وَرَسُولَهُ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "1162",
    sura: "8",
    VerseIDAr: "2",
    ayatAR:
      "إِنَّمَا الْمُؤْمِنُونَ الَّذِينَ إِذَا ذُكِرَ اللَّهُ وَجِلَتْ قُلُوبُهُمْ وَإِذَا تُلِيَتْ عَلَيْهِمْ آيَاتُهُ زَادَتْهُمْ إِيمَانًا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ",
  },
  {
    id: "1163",
    sura: "8",
    VerseIDAr: "3",
    ayatAR:
      "الَّذِينَ يُقِيمُونَ الصَّلَاةَ وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "1164",
    sura: "8",
    VerseIDAr: "4",
    ayatAR:
      "أُولَٰئِكَ هُمُ الْمُؤْمِنُونَ حَقًّا ۚ لَهُمْ دَرَجَاتٌ عِنْدَ رَبِّهِمْ وَمَغْفِرَةٌ وَرِزْقٌ كَرِيمٌ",
  },
  {
    id: "1165",
    sura: "8",
    VerseIDAr: "5",
    ayatAR:
      "كَمَا أَخْرَجَكَ رَبُّكَ مِنْ بَيْتِكَ بِالْحَقِّ وَإِنَّ فَرِيقًا مِنَ الْمُؤْمِنِينَ لَكَارِهُونَ",
  },
  {
    id: "1166",
    sura: "8",
    VerseIDAr: "6",
    ayatAR:
      "يُجَادِلُونَكَ فِي الْحَقِّ بَعْدَمَا تَبَيَّنَ كَأَنَّمَا يُسَاقُونَ إِلَى الْمَوْتِ وَهُمْ يَنْظُرُونَ",
  },
  {
    id: "1167",
    sura: "8",
    VerseIDAr: "7",
    ayatAR:
      "وَإِذْ يَعِدُكُمُ اللَّهُ إِحْدَى الطَّائِفَتَيْنِ أَنَّهَا لَكُمْ وَتَوَدُّونَ أَنَّ غَيْرَ ذَاتِ الشَّوْكَةِ تَكُونُ لَكُمْ وَيُرِيدُ اللَّهُ أَنْ يُحِقَّ الْحَقَّ بِكَلِمَاتِهِ وَيَقْطَعَ دَابِرَ الْكَافِرِينَ",
  },
  {
    id: "1168",
    sura: "8",
    VerseIDAr: "8",
    ayatAR:
      "لِيُحِقَّ الْحَقَّ وَيُبْطِلَ الْبَاطِلَ وَلَوْ كَرِهَ الْمُجْرِمُونَ",
  },
  {
    id: "1169",
    sura: "8",
    VerseIDAr: "9",
    ayatAR:
      "إِذْ تَسْتَغِيثُونَ رَبَّكُمْ فَاسْتَجَابَ لَكُمْ أَنِّي مُمِدُّكُمْ بِأَلْفٍ مِنَ الْمَلَائِكَةِ مُرْدِفِينَ",
  },
  {
    id: "1170",
    sura: "8",
    VerseIDAr: "10",
    ayatAR:
      "وَمَا جَعَلَهُ اللَّهُ إِلَّا بُشْرَىٰ وَلِتَطْمَئِنَّ بِهِ قُلُوبُكُمْ ۚ وَمَا النَّصْرُ إِلَّا مِنْ عِنْدِ اللَّهِ ۚ إِنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1171",
    sura: "8",
    VerseIDAr: "11",
    ayatAR:
      "إِذْ يُغَشِّيكُمُ النُّعَاسَ أَمَنَةً مِنْهُ وَيُنَزِّلُ عَلَيْكُمْ مِنَ السَّمَاءِ مَاءً لِيُطَهِّرَكُمْ بِهِ وَيُذْهِبَ عَنْكُمْ رِجْزَ الشَّيْطَانِ وَلِيَرْبِطَ عَلَىٰ قُلُوبِكُمْ وَيُثَبِّتَ بِهِ الْأَقْدَامَ",
  },
  {
    id: "1172",
    sura: "8",
    VerseIDAr: "12",
    ayatAR:
      "إِذْ يُوحِي رَبُّكَ إِلَى الْمَلَائِكَةِ أَنِّي مَعَكُمْ فَثَبِّتُوا الَّذِينَ آمَنُوا ۚ سَأُلْقِي فِي قُلُوبِ الَّذِينَ كَفَرُوا الرُّعْبَ فَاضْرِبُوا فَوْقَ الْأَعْنَاقِ وَاضْرِبُوا مِنْهُمْ كُلَّ بَنَانٍ",
  },
  {
    id: "1173",
    sura: "8",
    VerseIDAr: "13",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ شَاقُّوا اللَّهَ وَرَسُولَهُ ۚ وَمَنْ يُشَاقِقِ اللَّهَ وَرَسُولَهُ فَإِنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "1174",
    sura: "8",
    VerseIDAr: "14",
    ayatAR: "ذَٰلِكُمْ فَذُوقُوهُ وَأَنَّ لِلْكَافِرِينَ عَذَابَ النَّارِ",
  },
  {
    id: "1175",
    sura: "8",
    VerseIDAr: "15",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا لَقِيتُمُ الَّذِينَ كَفَرُوا زَحْفًا فَلَا تُوَلُّوهُمُ الْأَدْبَارَ",
  },
  {
    id: "1176",
    sura: "8",
    VerseIDAr: "16",
    ayatAR:
      "وَمَنْ يُوَلِّهِمْ يَوْمَئِذٍ دُبُرَهُ إِلَّا مُتَحَرِّفًا لِقِتَالٍ أَوْ مُتَحَيِّزًا إِلَىٰ فِئَةٍ فَقَدْ بَاءَ بِغَضَبٍ مِنَ اللَّهِ وَمَأْوَاهُ جَهَنَّمُ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "1177",
    sura: "8",
    VerseIDAr: "17",
    ayatAR:
      "فَلَمْ تَقْتُلُوهُمْ وَلَٰكِنَّ اللَّهَ قَتَلَهُمْ ۚ وَمَا رَمَيْتَ إِذْ رَمَيْتَ وَلَٰكِنَّ اللَّهَ رَمَىٰ ۚ وَلِيُبْلِيَ الْمُؤْمِنِينَ مِنْهُ بَلَاءً حَسَنًا ۚ إِنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1178",
    sura: "8",
    VerseIDAr: "18",
    ayatAR: "ذَٰلِكُمْ وَأَنَّ اللَّهَ مُوهِنُ كَيْدِ الْكَافِرِينَ",
  },
  {
    id: "1179",
    sura: "8",
    VerseIDAr: "19",
    ayatAR:
      "إِنْ تَسْتَفْتِحُوا فَقَدْ جَاءَكُمُ الْفَتْحُ ۖ وَإِنْ تَنْتَهُوا فَهُوَ خَيْرٌ لَكُمْ ۖ وَإِنْ تَعُودُوا نَعُدْ وَلَنْ تُغْنِيَ عَنْكُمْ فِئَتُكُمْ شَيْئًا وَلَوْ كَثُرَتْ وَأَنَّ اللَّهَ مَعَ الْمُؤْمِنِينَ",
  },
  {
    id: "1180",
    sura: "8",
    VerseIDAr: "20",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا أَطِيعُوا اللَّهَ وَرَسُولَهُ وَلَا تَوَلَّوْا عَنْهُ وَأَنْتُمْ تَسْمَعُونَ",
  },
  {
    id: "1181",
    sura: "8",
    VerseIDAr: "21",
    ayatAR:
      "وَلَا تَكُونُوا كَالَّذِينَ قَالُوا سَمِعْنَا وَهُمْ لَا يَسْمَعُونَ",
  },
  {
    id: "1182",
    sura: "8",
    VerseIDAr: "22",
    ayatAR:
      "إِنَّ شَرَّ الدَّوَابِّ عِنْدَ اللَّهِ الصُّمُّ الْبُكْمُ الَّذِينَ لَا يَعْقِلُونَ",
  },
  {
    id: "1183",
    sura: "8",
    VerseIDAr: "23",
    ayatAR:
      "وَلَوْ عَلِمَ اللَّهُ فِيهِمْ خَيْرًا لَأَسْمَعَهُمْ ۖ وَلَوْ أَسْمَعَهُمْ لَتَوَلَّوْا وَهُمْ مُعْرِضُونَ",
  },
  {
    id: "1184",
    sura: "8",
    VerseIDAr: "24",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اسْتَجِيبُوا لِلَّهِ وَلِلرَّسُولِ إِذَا دَعَاكُمْ لِمَا يُحْيِيكُمْ ۖ وَاعْلَمُوا أَنَّ اللَّهَ يَحُولُ بَيْنَ الْمَرْءِ وَقَلْبِهِ وَأَنَّهُ إِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "1185",
    sura: "8",
    VerseIDAr: "25",
    ayatAR:
      "وَاتَّقُوا فِتْنَةً لَا تُصِيبَنَّ الَّذِينَ ظَلَمُوا مِنْكُمْ خَاصَّةً ۖ وَاعْلَمُوا أَنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "1186",
    sura: "8",
    VerseIDAr: "26",
    ayatAR:
      "وَاذْكُرُوا إِذْ أَنْتُمْ قَلِيلٌ مُسْتَضْعَفُونَ فِي الْأَرْضِ تَخَافُونَ أَنْ يَتَخَطَّفَكُمُ النَّاسُ فَآوَاكُمْ وَأَيَّدَكُمْ بِنَصْرِهِ وَرَزَقَكُمْ مِنَ الطَّيِّبَاتِ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "1187",
    sura: "8",
    VerseIDAr: "27",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَخُونُوا اللَّهَ وَالرَّسُولَ وَتَخُونُوا أَمَانَاتِكُمْ وَأَنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "1188",
    sura: "8",
    VerseIDAr: "28",
    ayatAR:
      "وَاعْلَمُوا أَنَّمَا أَمْوَالُكُمْ وَأَوْلَادُكُمْ فِتْنَةٌ وَأَنَّ اللَّهَ عِنْدَهُ أَجْرٌ عَظِيمٌ",
  },
  {
    id: "1189",
    sura: "8",
    VerseIDAr: "29",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنْ تَتَّقُوا اللَّهَ يَجْعَلْ لَكُمْ فُرْقَانًا وَيُكَفِّرْ عَنْكُمْ سَيِّئَاتِكُمْ وَيَغْفِرْ لَكُمْ ۗ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "1190",
    sura: "8",
    VerseIDAr: "30",
    ayatAR:
      "وَإِذْ يَمْكُرُ بِكَ الَّذِينَ كَفَرُوا لِيُثْبِتُوكَ أَوْ يَقْتُلُوكَ أَوْ يُخْرِجُوكَ ۚ وَيَمْكُرُونَ وَيَمْكُرُ اللَّهُ ۖ وَاللَّهُ خَيْرُ الْمَاكِرِينَ",
  },
  {
    id: "1191",
    sura: "8",
    VerseIDAr: "31",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا قَالُوا قَدْ سَمِعْنَا لَوْ نَشَاءُ لَقُلْنَا مِثْلَ هَٰذَا ۙ إِنْ هَٰذَا إِلَّا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "1192",
    sura: "8",
    VerseIDAr: "32",
    ayatAR:
      "وَإِذْ قَالُوا اللَّهُمَّ إِنْ كَانَ هَٰذَا هُوَ الْحَقَّ مِنْ عِنْدِكَ فَأَمْطِرْ عَلَيْنَا حِجَارَةً مِنَ السَّمَاءِ أَوِ ائْتِنَا بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "1193",
    sura: "8",
    VerseIDAr: "33",
    ayatAR:
      "وَمَا كَانَ اللَّهُ لِيُعَذِّبَهُمْ وَأَنْتَ فِيهِمْ ۚ وَمَا كَانَ اللَّهُ مُعَذِّبَهُمْ وَهُمْ يَسْتَغْفِرُونَ",
  },
  {
    id: "1194",
    sura: "8",
    VerseIDAr: "34",
    ayatAR:
      "وَمَا لَهُمْ أَلَّا يُعَذِّبَهُمُ اللَّهُ وَهُمْ يَصُدُّونَ عَنِ الْمَسْجِدِ الْحَرَامِ وَمَا كَانُوا أَوْلِيَاءَهُ ۚ إِنْ أَوْلِيَاؤُهُ إِلَّا الْمُتَّقُونَ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "1195",
    sura: "8",
    VerseIDAr: "35",
    ayatAR:
      "وَمَا كَانَ صَلَاتُهُمْ عِنْدَ الْبَيْتِ إِلَّا مُكَاءً وَتَصْدِيَةً ۚ فَذُوقُوا الْعَذَابَ بِمَا كُنْتُمْ تَكْفُرُونَ",
  },
  {
    id: "1196",
    sura: "8",
    VerseIDAr: "36",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا يُنْفِقُونَ أَمْوَالَهُمْ لِيَصُدُّوا عَنْ سَبِيلِ اللَّهِ ۚ فَسَيُنْفِقُونَهَا ثُمَّ تَكُونُ عَلَيْهِمْ حَسْرَةً ثُمَّ يُغْلَبُونَ ۗ وَالَّذِينَ كَفَرُوا إِلَىٰ جَهَنَّمَ يُحْشَرُونَ",
  },
  {
    id: "1197",
    sura: "8",
    VerseIDAr: "37",
    ayatAR:
      "لِيَمِيزَ اللَّهُ الْخَبِيثَ مِنَ الطَّيِّبِ وَيَجْعَلَ الْخَبِيثَ بَعْضَهُ عَلَىٰ بَعْضٍ فَيَرْكُمَهُ جَمِيعًا فَيَجْعَلَهُ فِي جَهَنَّمَ ۚ أُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "1198",
    sura: "8",
    VerseIDAr: "38",
    ayatAR:
      "قُلْ لِلَّذِينَ كَفَرُوا إِنْ يَنْتَهُوا يُغْفَرْ لَهُمْ مَا قَدْ سَلَفَ وَإِنْ يَعُودُوا فَقَدْ مَضَتْ سُنَّتُ الْأَوَّلِينَ",
  },
  {
    id: "1199",
    sura: "8",
    VerseIDAr: "39",
    ayatAR:
      "وَقَاتِلُوهُمْ حَتَّىٰ لَا تَكُونَ فِتْنَةٌ وَيَكُونَ الدِّينُ كُلُّهُ لِلَّهِ ۚ فَإِنِ انْتَهَوْا فَإِنَّ اللَّهَ بِمَا يَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "1200",
    sura: "8",
    VerseIDAr: "40",
    ayatAR:
      "وَإِنْ تَوَلَّوْا فَاعْلَمُوا أَنَّ اللَّهَ مَوْلَاكُمْ ۚ نِعْمَ الْمَوْلَىٰ وَنِعْمَ النَّصِيرُ",
  },
  {
    id: "1201",
    sura: "8",
    VerseIDAr: "41",
    ayatAR:
      "وَاعْلَمُوا أَنَّمَا غَنِمْتُمْ مِنْ شَيْءٍ فَأَنَّ لِلَّهِ خُمُسَهُ وَلِلرَّسُولِ وَلِذِي الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينِ وَابْنِ السَّبِيلِ إِنْ كُنْتُمْ آمَنْتُمْ بِاللَّهِ وَمَا أَنْزَلْنَا عَلَىٰ عَبْدِنَا يَوْمَ الْفُرْقَانِ يَوْمَ الْتَقَى الْجَمْعَانِ ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "1202",
    sura: "8",
    VerseIDAr: "42",
    ayatAR:
      "إِذْ أَنْتُمْ بِالْعُدْوَةِ الدُّنْيَا وَهُمْ بِالْعُدْوَةِ الْقُصْوَىٰ وَالرَّكْبُ أَسْفَلَ مِنْكُمْ ۚ وَلَوْ تَوَاعَدْتُمْ لَاخْتَلَفْتُمْ فِي الْمِيعَادِ ۙ وَلَٰكِنْ لِيَقْضِيَ اللَّهُ أَمْرًا كَانَ مَفْعُولًا لِيَهْلِكَ مَنْ هَلَكَ عَنْ بَيِّنَةٍ وَيَحْيَىٰ مَنْ حَيَّ عَنْ بَيِّنَةٍ ۗ وَإِنَّ اللَّهَ لَسَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1203",
    sura: "8",
    VerseIDAr: "43",
    ayatAR:
      "إِذْ يُرِيكَهُمُ اللَّهُ فِي مَنَامِكَ قَلِيلًا ۖ وَلَوْ أَرَاكَهُمْ كَثِيرًا لَفَشِلْتُمْ وَلَتَنَازَعْتُمْ فِي الْأَمْرِ وَلَٰكِنَّ اللَّهَ سَلَّمَ ۗ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "1204",
    sura: "8",
    VerseIDAr: "44",
    ayatAR:
      "وَإِذْ يُرِيكُمُوهُمْ إِذِ الْتَقَيْتُمْ فِي أَعْيُنِكُمْ قَلِيلًا وَيُقَلِّلُكُمْ فِي أَعْيُنِهِمْ لِيَقْضِيَ اللَّهُ أَمْرًا كَانَ مَفْعُولًا ۗ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "1205",
    sura: "8",
    VerseIDAr: "45",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا لَقِيتُمْ فِئَةً فَاثْبُتُوا وَاذْكُرُوا اللَّهَ كَثِيرًا لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "1206",
    sura: "8",
    VerseIDAr: "46",
    ayatAR:
      "وَأَطِيعُوا اللَّهَ وَرَسُولَهُ وَلَا تَنَازَعُوا فَتَفْشَلُوا وَتَذْهَبَ رِيحُكُمْ ۖ وَاصْبِرُوا ۚ إِنَّ اللَّهَ مَعَ الصَّابِرِينَ",
  },
  {
    id: "1207",
    sura: "8",
    VerseIDAr: "47",
    ayatAR:
      "وَلَا تَكُونُوا كَالَّذِينَ خَرَجُوا مِنْ دِيَارِهِمْ بَطَرًا وَرِئَاءَ النَّاسِ وَيَصُدُّونَ عَنْ سَبِيلِ اللَّهِ ۚ وَاللَّهُ بِمَا يَعْمَلُونَ مُحِيطٌ",
  },
  {
    id: "1208",
    sura: "8",
    VerseIDAr: "48",
    ayatAR:
      "وَإِذْ زَيَّنَ لَهُمُ الشَّيْطَانُ أَعْمَالَهُمْ وَقَالَ لَا غَالِبَ لَكُمُ الْيَوْمَ مِنَ النَّاسِ وَإِنِّي جَارٌ لَكُمْ ۖ فَلَمَّا تَرَاءَتِ الْفِئَتَانِ نَكَصَ عَلَىٰ عَقِبَيْهِ وَقَالَ إِنِّي بَرِيءٌ مِنْكُمْ إِنِّي أَرَىٰ مَا لَا تَرَوْنَ إِنِّي أَخَافُ اللَّهَ ۚ وَاللَّهُ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "1209",
    sura: "8",
    VerseIDAr: "49",
    ayatAR:
      "إِذْ يَقُولُ الْمُنَافِقُونَ وَالَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ غَرَّ هَٰؤُلَاءِ دِينُهُمْ ۗ وَمَنْ يَتَوَكَّلْ عَلَى اللَّهِ فَإِنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1210",
    sura: "8",
    VerseIDAr: "50",
    ayatAR:
      "وَلَوْ تَرَىٰ إِذْ يَتَوَفَّى الَّذِينَ كَفَرُوا ۙ الْمَلَائِكَةُ يَضْرِبُونَ وُجُوهَهُمْ وَأَدْبَارَهُمْ وَذُوقُوا عَذَابَ الْحَرِيقِ",
  },
  {
    id: "1211",
    sura: "8",
    VerseIDAr: "51",
    ayatAR:
      "ذَٰلِكَ بِمَا قَدَّمَتْ أَيْدِيكُمْ وَأَنَّ اللَّهَ لَيْسَ بِظَلَّامٍ لِلْعَبِيدِ",
  },
  {
    id: "1212",
    sura: "8",
    VerseIDAr: "52",
    ayatAR:
      "كَدَأْبِ آلِ فِرْعَوْنَ ۙ وَالَّذِينَ مِنْ قَبْلِهِمْ ۚ كَفَرُوا بِآيَاتِ اللَّهِ فَأَخَذَهُمُ اللَّهُ بِذُنُوبِهِمْ ۗ إِنَّ اللَّهَ قَوِيٌّ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "1213",
    sura: "8",
    VerseIDAr: "53",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ لَمْ يَكُ مُغَيِّرًا نِعْمَةً أَنْعَمَهَا عَلَىٰ قَوْمٍ حَتَّىٰ يُغَيِّرُوا مَا بِأَنْفُسِهِمْ ۙ وَأَنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1214",
    sura: "8",
    VerseIDAr: "54",
    ayatAR:
      "كَدَأْبِ آلِ فِرْعَوْنَ ۙ وَالَّذِينَ مِنْ قَبْلِهِمْ ۚ كَذَّبُوا بِآيَاتِ رَبِّهِمْ فَأَهْلَكْنَاهُمْ بِذُنُوبِهِمْ وَأَغْرَقْنَا آلَ فِرْعَوْنَ ۚ وَكُلٌّ كَانُوا ظَالِمِينَ",
  },
  {
    id: "1215",
    sura: "8",
    VerseIDAr: "55",
    ayatAR:
      "إِنَّ شَرَّ الدَّوَابِّ عِنْدَ اللَّهِ الَّذِينَ كَفَرُوا فَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "1216",
    sura: "8",
    VerseIDAr: "56",
    ayatAR:
      "الَّذِينَ عَاهَدْتَ مِنْهُمْ ثُمَّ يَنْقُضُونَ عَهْدَهُمْ فِي كُلِّ مَرَّةٍ وَهُمْ لَا يَتَّقُونَ",
  },
  {
    id: "1217",
    sura: "8",
    VerseIDAr: "57",
    ayatAR:
      "فَإِمَّا تَثْقَفَنَّهُمْ فِي الْحَرْبِ فَشَرِّدْ بِهِمْ مَنْ خَلْفَهُمْ لَعَلَّهُمْ يَذَّكَّرُونَ",
  },
  {
    id: "1218",
    sura: "8",
    VerseIDAr: "58",
    ayatAR:
      "وَإِمَّا تَخَافَنَّ مِنْ قَوْمٍ خِيَانَةً فَانْبِذْ إِلَيْهِمْ عَلَىٰ سَوَاءٍ ۚ إِنَّ اللَّهَ لَا يُحِبُّ الْخَائِنِينَ",
  },
  {
    id: "1219",
    sura: "8",
    VerseIDAr: "59",
    ayatAR:
      "وَلَا يَحْسَبَنَّ الَّذِينَ كَفَرُوا سَبَقُوا ۚ إِنَّهُمْ لَا يُعْجِزُونَ",
  },
  {
    id: "1220",
    sura: "8",
    VerseIDAr: "60",
    ayatAR:
      "وَأَعِدُّوا لَهُمْ مَا اسْتَطَعْتُمْ مِنْ قُوَّةٍ وَمِنْ رِبَاطِ الْخَيْلِ تُرْهِبُونَ بِهِ عَدُوَّ اللَّهِ وَعَدُوَّكُمْ وَآخَرِينَ مِنْ دُونِهِمْ لَا تَعْلَمُونَهُمُ اللَّهُ يَعْلَمُهُمْ ۚ وَمَا تُنْفِقُوا مِنْ شَيْءٍ فِي سَبِيلِ اللَّهِ يُوَفَّ إِلَيْكُمْ وَأَنْتُمْ لَا تُظْلَمُونَ",
  },
  {
    id: "1221",
    sura: "8",
    VerseIDAr: "61",
    ayatAR:
      "وَإِنْ جَنَحُوا لِلسَّلْمِ فَاجْنَحْ لَهَا وَتَوَكَّلْ عَلَى اللَّهِ ۚ إِنَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "1222",
    sura: "8",
    VerseIDAr: "62",
    ayatAR:
      "وَإِنْ يُرِيدُوا أَنْ يَخْدَعُوكَ فَإِنَّ حَسْبَكَ اللَّهُ ۚ هُوَ الَّذِي أَيَّدَكَ بِنَصْرِهِ وَبِالْمُؤْمِنِينَ",
  },
  {
    id: "1223",
    sura: "8",
    VerseIDAr: "63",
    ayatAR:
      "وَأَلَّفَ بَيْنَ قُلُوبِهِمْ ۚ لَوْ أَنْفَقْتَ مَا فِي الْأَرْضِ جَمِيعًا مَا أَلَّفْتَ بَيْنَ قُلُوبِهِمْ وَلَٰكِنَّ اللَّهَ أَلَّفَ بَيْنَهُمْ ۚ إِنَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1224",
    sura: "8",
    VerseIDAr: "64",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ حَسْبُكَ اللَّهُ وَمَنِ اتَّبَعَكَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "1225",
    sura: "8",
    VerseIDAr: "65",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ حَرِّضِ الْمُؤْمِنِينَ عَلَى الْقِتَالِ ۚ إِنْ يَكُنْ مِنْكُمْ عِشْرُونَ صَابِرُونَ يَغْلِبُوا مِائَتَيْنِ ۚ وَإِنْ يَكُنْ مِنْكُمْ مِائَةٌ يَغْلِبُوا أَلْفًا مِنَ الَّذِينَ كَفَرُوا بِأَنَّهُمْ قَوْمٌ لَا يَفْقَهُونَ",
  },
  {
    id: "1226",
    sura: "8",
    VerseIDAr: "66",
    ayatAR:
      "الْآنَ خَفَّفَ اللَّهُ عَنْكُمْ وَعَلِمَ أَنَّ فِيكُمْ ضَعْفًا ۚ فَإِنْ يَكُنْ مِنْكُمْ مِائَةٌ صَابِرَةٌ يَغْلِبُوا مِائَتَيْنِ ۚ وَإِنْ يَكُنْ مِنْكُمْ أَلْفٌ يَغْلِبُوا أَلْفَيْنِ بِإِذْنِ اللَّهِ ۗ وَاللَّهُ مَعَ الصَّابِرِينَ",
  },
  {
    id: "1227",
    sura: "8",
    VerseIDAr: "67",
    ayatAR:
      "مَا كَانَ لِنَبِيٍّ أَنْ يَكُونَ لَهُ أَسْرَىٰ حَتَّىٰ يُثْخِنَ فِي الْأَرْضِ ۚ تُرِيدُونَ عَرَضَ الدُّنْيَا وَاللَّهُ يُرِيدُ الْآخِرَةَ ۗ وَاللَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1228",
    sura: "8",
    VerseIDAr: "68",
    ayatAR:
      "لَوْلَا كِتَابٌ مِنَ اللَّهِ سَبَقَ لَمَسَّكُمْ فِيمَا أَخَذْتُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "1229",
    sura: "8",
    VerseIDAr: "69",
    ayatAR:
      "فَكُلُوا مِمَّا غَنِمْتُمْ حَلَالًا طَيِّبًا ۚ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1230",
    sura: "8",
    VerseIDAr: "70",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ قُلْ لِمَنْ فِي أَيْدِيكُمْ مِنَ الْأَسْرَىٰ إِنْ يَعْلَمِ اللَّهُ فِي قُلُوبِكُمْ خَيْرًا يُؤْتِكُمْ خَيْرًا مِمَّا أُخِذَ مِنْكُمْ وَيَغْفِرْ لَكُمْ ۗ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1231",
    sura: "8",
    VerseIDAr: "71",
    ayatAR:
      "وَإِنْ يُرِيدُوا خِيَانَتَكَ فَقَدْ خَانُوا اللَّهَ مِنْ قَبْلُ فَأَمْكَنَ مِنْهُمْ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1232",
    sura: "8",
    VerseIDAr: "72",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَهَاجَرُوا وَجَاهَدُوا بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ فِي سَبِيلِ اللَّهِ وَالَّذِينَ آوَوْا وَنَصَرُوا أُولَٰئِكَ بَعْضُهُمْ أَوْلِيَاءُ بَعْضٍ ۚ وَالَّذِينَ آمَنُوا وَلَمْ يُهَاجِرُوا مَا لَكُمْ مِنْ وَلَايَتِهِمْ مِنْ شَيْءٍ حَتَّىٰ يُهَاجِرُوا ۚ وَإِنِ اسْتَنْصَرُوكُمْ فِي الدِّينِ فَعَلَيْكُمُ النَّصْرُ إِلَّا عَلَىٰ قَوْمٍ بَيْنَكُمْ وَبَيْنَهُمْ مِيثَاقٌ ۗ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "1233",
    sura: "8",
    VerseIDAr: "73",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا بَعْضُهُمْ أَوْلِيَاءُ بَعْضٍ ۚ إِلَّا تَفْعَلُوهُ تَكُنْ فِتْنَةٌ فِي الْأَرْضِ وَفَسَادٌ كَبِيرٌ",
  },
  {
    id: "1234",
    sura: "8",
    VerseIDAr: "74",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَهَاجَرُوا وَجَاهَدُوا فِي سَبِيلِ اللَّهِ وَالَّذِينَ آوَوْا وَنَصَرُوا أُولَٰئِكَ هُمُ الْمُؤْمِنُونَ حَقًّا ۚ لَهُمْ مَغْفِرَةٌ وَرِزْقٌ كَرِيمٌ",
  },
  {
    id: "1235",
    sura: "8",
    VerseIDAr: "75",
    ayatAR:
      "وَالَّذِينَ آمَنُوا مِنْ بَعْدُ وَهَاجَرُوا وَجَاهَدُوا مَعَكُمْ فَأُولَٰئِكَ مِنْكُمْ ۚ وَأُولُو الْأَرْحَامِ بَعْضُهُمْ أَوْلَىٰ بِبَعْضٍ فِي كِتَابِ اللَّهِ ۗ إِنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "1236",
    sura: "9",
    VerseIDAr: "1",
    ayatAR:
      "بَرَاءَةٌ مِنَ اللَّهِ وَرَسُولِهِ إِلَى الَّذِينَ عَاهَدْتُمْ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "1237",
    sura: "9",
    VerseIDAr: "2",
    ayatAR:
      "فَسِيحُوا فِي الْأَرْضِ أَرْبَعَةَ أَشْهُرٍ وَاعْلَمُوا أَنَّكُمْ غَيْرُ مُعْجِزِي اللَّهِ ۙ وَأَنَّ اللَّهَ مُخْزِي الْكَافِرِينَ",
  },
  {
    id: "1238",
    sura: "9",
    VerseIDAr: "3",
    ayatAR:
      "وَأَذَانٌ مِنَ اللَّهِ وَرَسُولِهِ إِلَى النَّاسِ يَوْمَ الْحَجِّ الْأَكْبَرِ أَنَّ اللَّهَ بَرِيءٌ مِنَ الْمُشْرِكِينَ ۙ وَرَسُولُهُ ۚ فَإِنْ تُبْتُمْ فَهُوَ خَيْرٌ لَكُمْ ۖ وَإِنْ تَوَلَّيْتُمْ فَاعْلَمُوا أَنَّكُمْ غَيْرُ مُعْجِزِي اللَّهِ ۗ وَبَشِّرِ الَّذِينَ كَفَرُوا بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "1239",
    sura: "9",
    VerseIDAr: "4",
    ayatAR:
      "إِلَّا الَّذِينَ عَاهَدْتُمْ مِنَ الْمُشْرِكِينَ ثُمَّ لَمْ يَنْقُصُوكُمْ شَيْئًا وَلَمْ يُظَاهِرُوا عَلَيْكُمْ أَحَدًا فَأَتِمُّوا إِلَيْهِمْ عَهْدَهُمْ إِلَىٰ مُدَّتِهِمْ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُتَّقِينَ",
  },
  {
    id: "1240",
    sura: "9",
    VerseIDAr: "5",
    ayatAR:
      "فَإِذَا انْسَلَخَ الْأَشْهُرُ الْحُرُمُ فَاقْتُلُوا الْمُشْرِكِينَ حَيْثُ وَجَدْتُمُوهُمْ وَخُذُوهُمْ وَاحْصُرُوهُمْ وَاقْعُدُوا لَهُمْ كُلَّ مَرْصَدٍ ۚ فَإِنْ تَابُوا وَأَقَامُوا الصَّلَاةَ وَآتَوُا الزَّكَاةَ فَخَلُّوا سَبِيلَهُمْ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1241",
    sura: "9",
    VerseIDAr: "6",
    ayatAR:
      "وَإِنْ أَحَدٌ مِنَ الْمُشْرِكِينَ اسْتَجَارَكَ فَأَجِرْهُ حَتَّىٰ يَسْمَعَ كَلَامَ اللَّهِ ثُمَّ أَبْلِغْهُ مَأْمَنَهُ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌ لَا يَعْلَمُونَ",
  },
  {
    id: "1242",
    sura: "9",
    VerseIDAr: "7",
    ayatAR:
      "كَيْفَ يَكُونُ لِلْمُشْرِكِينَ عَهْدٌ عِنْدَ اللَّهِ وَعِنْدَ رَسُولِهِ إِلَّا الَّذِينَ عَاهَدْتُمْ عِنْدَ الْمَسْجِدِ الْحَرَامِ ۖ فَمَا اسْتَقَامُوا لَكُمْ فَاسْتَقِيمُوا لَهُمْ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُتَّقِينَ",
  },
  {
    id: "1243",
    sura: "9",
    VerseIDAr: "8",
    ayatAR:
      "كَيْفَ وَإِنْ يَظْهَرُوا عَلَيْكُمْ لَا يَرْقُبُوا فِيكُمْ إِلًّا وَلَا ذِمَّةً ۚ يُرْضُونَكُمْ بِأَفْوَاهِهِمْ وَتَأْبَىٰ قُلُوبُهُمْ وَأَكْثَرُهُمْ فَاسِقُونَ",
  },
  {
    id: "1244",
    sura: "9",
    VerseIDAr: "9",
    ayatAR:
      "اشْتَرَوْا بِآيَاتِ اللَّهِ ثَمَنًا قَلِيلًا فَصَدُّوا عَنْ سَبِيلِهِ ۚ إِنَّهُمْ سَاءَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1245",
    sura: "9",
    VerseIDAr: "10",
    ayatAR:
      "لَا يَرْقُبُونَ فِي مُؤْمِنٍ إِلًّا وَلَا ذِمَّةً ۚ وَأُولَٰئِكَ هُمُ الْمُعْتَدُونَ",
  },
  {
    id: "1246",
    sura: "9",
    VerseIDAr: "11",
    ayatAR:
      "فَإِنْ تَابُوا وَأَقَامُوا الصَّلَاةَ وَآتَوُا الزَّكَاةَ فَإِخْوَانُكُمْ فِي الدِّينِ ۗ وَنُفَصِّلُ الْآيَاتِ لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "1247",
    sura: "9",
    VerseIDAr: "12",
    ayatAR:
      "وَإِنْ نَكَثُوا أَيْمَانَهُمْ مِنْ بَعْدِ عَهْدِهِمْ وَطَعَنُوا فِي دِينِكُمْ فَقَاتِلُوا أَئِمَّةَ الْكُفْرِ ۙ إِنَّهُمْ لَا أَيْمَانَ لَهُمْ لَعَلَّهُمْ يَنْتَهُونَ",
  },
  {
    id: "1248",
    sura: "9",
    VerseIDAr: "13",
    ayatAR:
      "أَلَا تُقَاتِلُونَ قَوْمًا نَكَثُوا أَيْمَانَهُمْ وَهَمُّوا بِإِخْرَاجِ الرَّسُولِ وَهُمْ بَدَءُوكُمْ أَوَّلَ مَرَّةٍ ۚ أَتَخْشَوْنَهُمْ ۚ فَاللَّهُ أَحَقُّ أَنْ تَخْشَوْهُ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "1249",
    sura: "9",
    VerseIDAr: "14",
    ayatAR:
      "قَاتِلُوهُمْ يُعَذِّبْهُمُ اللَّهُ بِأَيْدِيكُمْ وَيُخْزِهِمْ وَيَنْصُرْكُمْ عَلَيْهِمْ وَيَشْفِ صُدُورَ قَوْمٍ مُؤْمِنِينَ",
  },
  {
    id: "1250",
    sura: "9",
    VerseIDAr: "15",
    ayatAR:
      "وَيُذْهِبْ غَيْظَ قُلُوبِهِمْ ۗ وَيَتُوبُ اللَّهُ عَلَىٰ مَنْ يَشَاءُ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1251",
    sura: "9",
    VerseIDAr: "16",
    ayatAR:
      "أَمْ حَسِبْتُمْ أَنْ تُتْرَكُوا وَلَمَّا يَعْلَمِ اللَّهُ الَّذِينَ جَاهَدُوا مِنْكُمْ وَلَمْ يَتَّخِذُوا مِنْ دُونِ اللَّهِ وَلَا رَسُولِهِ وَلَا الْمُؤْمِنِينَ وَلِيجَةً ۚ وَاللَّهُ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "1252",
    sura: "9",
    VerseIDAr: "17",
    ayatAR:
      "مَا كَانَ لِلْمُشْرِكِينَ أَنْ يَعْمُرُوا مَسَاجِدَ اللَّهِ شَاهِدِينَ عَلَىٰ أَنْفُسِهِمْ بِالْكُفْرِ ۚ أُولَٰئِكَ حَبِطَتْ أَعْمَالُهُمْ وَفِي النَّارِ هُمْ خَالِدُونَ",
  },
  {
    id: "1253",
    sura: "9",
    VerseIDAr: "18",
    ayatAR:
      "إِنَّمَا يَعْمُرُ مَسَاجِدَ اللَّهِ مَنْ آمَنَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَأَقَامَ الصَّلَاةَ وَآتَى الزَّكَاةَ وَلَمْ يَخْشَ إِلَّا اللَّهَ ۖ فَعَسَىٰ أُولَٰئِكَ أَنْ يَكُونُوا مِنَ الْمُهْتَدِينَ",
  },
  {
    id: "1254",
    sura: "9",
    VerseIDAr: "19",
    ayatAR:
      "أَجَعَلْتُمْ سِقَايَةَ الْحَاجِّ وَعِمَارَةَ الْمَسْجِدِ الْحَرَامِ كَمَنْ آمَنَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَجَاهَدَ فِي سَبِيلِ اللَّهِ ۚ لَا يَسْتَوُونَ عِنْدَ اللَّهِ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "1255",
    sura: "9",
    VerseIDAr: "20",
    ayatAR:
      "الَّذِينَ آمَنُوا وَهَاجَرُوا وَجَاهَدُوا فِي سَبِيلِ اللَّهِ بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ أَعْظَمُ دَرَجَةً عِنْدَ اللَّهِ ۚ وَأُولَٰئِكَ هُمُ الْفَائِزُونَ",
  },
  {
    id: "1256",
    sura: "9",
    VerseIDAr: "21",
    ayatAR:
      "يُبَشِّرُهُمْ رَبُّهُمْ بِرَحْمَةٍ مِنْهُ وَرِضْوَانٍ وَجَنَّاتٍ لَهُمْ فِيهَا نَعِيمٌ مُقِيمٌ",
  },
  {
    id: "1257",
    sura: "9",
    VerseIDAr: "22",
    ayatAR: "خَالِدِينَ فِيهَا أَبَدًا ۚ إِنَّ اللَّهَ عِنْدَهُ أَجْرٌ عَظِيمٌ",
  },
  {
    id: "1258",
    sura: "9",
    VerseIDAr: "23",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا آبَاءَكُمْ وَإِخْوَانَكُمْ أَوْلِيَاءَ إِنِ اسْتَحَبُّوا الْكُفْرَ عَلَى الْإِيمَانِ ۚ وَمَنْ يَتَوَلَّهُمْ مِنْكُمْ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "1259",
    sura: "9",
    VerseIDAr: "24",
    ayatAR:
      "قُلْ إِنْ كَانَ آبَاؤُكُمْ وَأَبْنَاؤُكُمْ وَإِخْوَانُكُمْ وَأَزْوَاجُكُمْ وَعَشِيرَتُكُمْ وَأَمْوَالٌ اقْتَرَفْتُمُوهَا وَتِجَارَةٌ تَخْشَوْنَ كَسَادَهَا وَمَسَاكِنُ تَرْضَوْنَهَا أَحَبَّ إِلَيْكُمْ مِنَ اللَّهِ وَرَسُولِهِ وَجِهَادٍ فِي سَبِيلِهِ فَتَرَبَّصُوا حَتَّىٰ يَأْتِيَ اللَّهُ بِأَمْرِهِ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْفَاسِقِينَ",
  },
  {
    id: "1260",
    sura: "9",
    VerseIDAr: "25",
    ayatAR:
      "لَقَدْ نَصَرَكُمُ اللَّهُ فِي مَوَاطِنَ كَثِيرَةٍ ۙ وَيَوْمَ حُنَيْنٍ ۙ إِذْ أَعْجَبَتْكُمْ كَثْرَتُكُمْ فَلَمْ تُغْنِ عَنْكُمْ شَيْئًا وَضَاقَتْ عَلَيْكُمُ الْأَرْضُ بِمَا رَحُبَتْ ثُمَّ وَلَّيْتُمْ مُدْبِرِينَ",
  },
  {
    id: "1261",
    sura: "9",
    VerseIDAr: "26",
    ayatAR:
      "ثُمَّ أَنْزَلَ اللَّهُ سَكِينَتَهُ عَلَىٰ رَسُولِهِ وَعَلَى الْمُؤْمِنِينَ وَأَنْزَلَ جُنُودًا لَمْ تَرَوْهَا وَعَذَّبَ الَّذِينَ كَفَرُوا ۚ وَذَٰلِكَ جَزَاءُ الْكَافِرِينَ",
  },
  {
    id: "1262",
    sura: "9",
    VerseIDAr: "27",
    ayatAR:
      "ثُمَّ يَتُوبُ اللَّهُ مِنْ بَعْدِ ذَٰلِكَ عَلَىٰ مَنْ يَشَاءُ ۗ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1263",
    sura: "9",
    VerseIDAr: "28",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنَّمَا الْمُشْرِكُونَ نَجَسٌ فَلَا يَقْرَبُوا الْمَسْجِدَ الْحَرَامَ بَعْدَ عَامِهِمْ هَٰذَا ۚ وَإِنْ خِفْتُمْ عَيْلَةً فَسَوْفَ يُغْنِيكُمُ اللَّهُ مِنْ فَضْلِهِ إِنْ شَاءَ ۚ إِنَّ اللَّهَ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1264",
    sura: "9",
    VerseIDAr: "29",
    ayatAR:
      "قَاتِلُوا الَّذِينَ لَا يُؤْمِنُونَ بِاللَّهِ وَلَا بِالْيَوْمِ الْآخِرِ وَلَا يُحَرِّمُونَ مَا حَرَّمَ اللَّهُ وَرَسُولُهُ وَلَا يَدِينُونَ دِينَ الْحَقِّ مِنَ الَّذِينَ أُوتُوا الْكِتَابَ حَتَّىٰ يُعْطُوا الْجِزْيَةَ عَنْ يَدٍ وَهُمْ صَاغِرُونَ",
  },
  {
    id: "1265",
    sura: "9",
    VerseIDAr: "30",
    ayatAR:
      "وَقَالَتِ الْيَهُودُ عُزَيْرٌ ابْنُ اللَّهِ وَقَالَتِ النَّصَارَى الْمَسِيحُ ابْنُ اللَّهِ ۖ ذَٰلِكَ قَوْلُهُمْ بِأَفْوَاهِهِمْ ۖ يُضَاهِئُونَ قَوْلَ الَّذِينَ كَفَرُوا مِنْ قَبْلُ ۚ قَاتَلَهُمُ اللَّهُ ۚ أَنَّىٰ يُؤْفَكُونَ",
  },
  {
    id: "1266",
    sura: "9",
    VerseIDAr: "31",
    ayatAR:
      "اتَّخَذُوا أَحْبَارَهُمْ وَرُهْبَانَهُمْ أَرْبَابًا مِنْ دُونِ اللَّهِ وَالْمَسِيحَ ابْنَ مَرْيَمَ وَمَا أُمِرُوا إِلَّا لِيَعْبُدُوا إِلَٰهًا وَاحِدًا ۖ لَا إِلَٰهَ إِلَّا هُوَ ۚ سُبْحَانَهُ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "1267",
    sura: "9",
    VerseIDAr: "32",
    ayatAR:
      "يُرِيدُونَ أَنْ يُطْفِئُوا نُورَ اللَّهِ بِأَفْوَاهِهِمْ وَيَأْبَى اللَّهُ إِلَّا أَنْ يُتِمَّ نُورَهُ وَلَوْ كَرِهَ الْكَافِرُونَ",
  },
  {
    id: "1268",
    sura: "9",
    VerseIDAr: "33",
    ayatAR:
      "هُوَ الَّذِي أَرْسَلَ رَسُولَهُ بِالْهُدَىٰ وَدِينِ الْحَقِّ لِيُظْهِرَهُ عَلَى الدِّينِ كُلِّهِ وَلَوْ كَرِهَ الْمُشْرِكُونَ",
  },
  {
    id: "1269",
    sura: "9",
    VerseIDAr: "34",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنَّ كَثِيرًا مِنَ الْأَحْبَارِ وَالرُّهْبَانِ لَيَأْكُلُونَ أَمْوَالَ النَّاسِ بِالْبَاطِلِ وَيَصُدُّونَ عَنْ سَبِيلِ اللَّهِ ۗ وَالَّذِينَ يَكْنِزُونَ الذَّهَبَ وَالْفِضَّةَ وَلَا يُنْفِقُونَهَا فِي سَبِيلِ اللَّهِ فَبَشِّرْهُمْ بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "1270",
    sura: "9",
    VerseIDAr: "35",
    ayatAR:
      "يَوْمَ يُحْمَىٰ عَلَيْهَا فِي نَارِ جَهَنَّمَ فَتُكْوَىٰ بِهَا جِبَاهُهُمْ وَجُنُوبُهُمْ وَظُهُورُهُمْ ۖ هَٰذَا مَا كَنَزْتُمْ لِأَنْفُسِكُمْ فَذُوقُوا مَا كُنْتُمْ تَكْنِزُونَ",
  },
  {
    id: "1271",
    sura: "9",
    VerseIDAr: "36",
    ayatAR:
      "إِنَّ عِدَّةَ الشُّهُورِ عِنْدَ اللَّهِ اثْنَا عَشَرَ شَهْرًا فِي كِتَابِ اللَّهِ يَوْمَ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ مِنْهَا أَرْبَعَةٌ حُرُمٌ ۚ ذَٰلِكَ الدِّينُ الْقَيِّمُ ۚ فَلَا تَظْلِمُوا فِيهِنَّ أَنْفُسَكُمْ ۚ وَقَاتِلُوا الْمُشْرِكِينَ كَافَّةً كَمَا يُقَاتِلُونَكُمْ كَافَّةً ۚ وَاعْلَمُوا أَنَّ اللَّهَ مَعَ الْمُتَّقِينَ",
  },
  {
    id: "1272",
    sura: "9",
    VerseIDAr: "37",
    ayatAR:
      "إِنَّمَا النَّسِيءُ زِيَادَةٌ فِي الْكُفْرِ ۖ يُضَلُّ بِهِ الَّذِينَ كَفَرُوا يُحِلُّونَهُ عَامًا وَيُحَرِّمُونَهُ عَامًا لِيُوَاطِئُوا عِدَّةَ مَا حَرَّمَ اللَّهُ فَيُحِلُّوا مَا حَرَّمَ اللَّهُ ۚ زُيِّنَ لَهُمْ سُوءُ أَعْمَالِهِمْ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْكَافِرِينَ",
  },
  {
    id: "1273",
    sura: "9",
    VerseIDAr: "38",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا مَا لَكُمْ إِذَا قِيلَ لَكُمُ انْفِرُوا فِي سَبِيلِ اللَّهِ اثَّاقَلْتُمْ إِلَى الْأَرْضِ ۚ أَرَضِيتُمْ بِالْحَيَاةِ الدُّنْيَا مِنَ الْآخِرَةِ ۚ فَمَا مَتَاعُ الْحَيَاةِ الدُّنْيَا فِي الْآخِرَةِ إِلَّا قَلِيلٌ",
  },
  {
    id: "1274",
    sura: "9",
    VerseIDAr: "39",
    ayatAR:
      "إِلَّا تَنْفِرُوا يُعَذِّبْكُمْ عَذَابًا أَلِيمًا وَيَسْتَبْدِلْ قَوْمًا غَيْرَكُمْ وَلَا تَضُرُّوهُ شَيْئًا ۗ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "1275",
    sura: "9",
    VerseIDAr: "40",
    ayatAR:
      "إِلَّا تَنْصُرُوهُ فَقَدْ نَصَرَهُ اللَّهُ إِذْ أَخْرَجَهُ الَّذِينَ كَفَرُوا ثَانِيَ اثْنَيْنِ إِذْ هُمَا فِي الْغَارِ إِذْ يَقُولُ لِصَاحِبِهِ لَا تَحْزَنْ إِنَّ اللَّهَ مَعَنَا ۖ فَأَنْزَلَ اللَّهُ سَكِينَتَهُ عَلَيْهِ وَأَيَّدَهُ بِجُنُودٍ لَمْ تَرَوْهَا وَجَعَلَ كَلِمَةَ الَّذِينَ كَفَرُوا السُّفْلَىٰ ۗ وَكَلِمَةُ اللَّهِ هِيَ الْعُلْيَا ۗ وَاللَّهُ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1276",
    sura: "9",
    VerseIDAr: "41",
    ayatAR:
      "انْفِرُوا خِفَافًا وَثِقَالًا وَجَاهِدُوا بِأَمْوَالِكُمْ وَأَنْفُسِكُمْ فِي سَبِيلِ اللَّهِ ۚ ذَٰلِكُمْ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "1277",
    sura: "9",
    VerseIDAr: "42",
    ayatAR:
      "لَوْ كَانَ عَرَضًا قَرِيبًا وَسَفَرًا قَاصِدًا لَاتَّبَعُوكَ وَلَٰكِنْ بَعُدَتْ عَلَيْهِمُ الشُّقَّةُ ۚ وَسَيَحْلِفُونَ بِاللَّهِ لَوِ اسْتَطَعْنَا لَخَرَجْنَا مَعَكُمْ يُهْلِكُونَ أَنْفُسَهُمْ وَاللَّهُ يَعْلَمُ إِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "1278",
    sura: "9",
    VerseIDAr: "43",
    ayatAR:
      "عَفَا اللَّهُ عَنْكَ لِمَ أَذِنْتَ لَهُمْ حَتَّىٰ يَتَبَيَّنَ لَكَ الَّذِينَ صَدَقُوا وَتَعْلَمَ الْكَاذِبِينَ",
  },
  {
    id: "1279",
    sura: "9",
    VerseIDAr: "44",
    ayatAR:
      "لَا يَسْتَأْذِنُكَ الَّذِينَ يُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ أَنْ يُجَاهِدُوا بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ ۗ وَاللَّهُ عَلِيمٌ بِالْمُتَّقِينَ",
  },
  {
    id: "1280",
    sura: "9",
    VerseIDAr: "45",
    ayatAR:
      "إِنَّمَا يَسْتَأْذِنُكَ الَّذِينَ لَا يُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَارْتَابَتْ قُلُوبُهُمْ فَهُمْ فِي رَيْبِهِمْ يَتَرَدَّدُونَ",
  },
  {
    id: "1281",
    sura: "9",
    VerseIDAr: "46",
    ayatAR:
      "وَلَوْ أَرَادُوا الْخُرُوجَ لَأَعَدُّوا لَهُ عُدَّةً وَلَٰكِنْ كَرِهَ اللَّهُ انْبِعَاثَهُمْ فَثَبَّطَهُمْ وَقِيلَ اقْعُدُوا مَعَ الْقَاعِدِينَ",
  },
  {
    id: "1282",
    sura: "9",
    VerseIDAr: "47",
    ayatAR:
      "لَوْ خَرَجُوا فِيكُمْ مَا زَادُوكُمْ إِلَّا خَبَالًا وَلَأَوْضَعُوا خِلَالَكُمْ يَبْغُونَكُمُ الْفِتْنَةَ وَفِيكُمْ سَمَّاعُونَ لَهُمْ ۗ وَاللَّهُ عَلِيمٌ بِالظَّالِمِينَ",
  },
  {
    id: "1283",
    sura: "9",
    VerseIDAr: "48",
    ayatAR:
      "لَقَدِ ابْتَغَوُا الْفِتْنَةَ مِنْ قَبْلُ وَقَلَّبُوا لَكَ الْأُمُورَ حَتَّىٰ جَاءَ الْحَقُّ وَظَهَرَ أَمْرُ اللَّهِ وَهُمْ كَارِهُونَ",
  },
  {
    id: "1284",
    sura: "9",
    VerseIDAr: "49",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَقُولُ ائْذَنْ لِي وَلَا تَفْتِنِّي ۚ أَلَا فِي الْفِتْنَةِ سَقَطُوا ۗ وَإِنَّ جَهَنَّمَ لَمُحِيطَةٌ بِالْكَافِرِينَ",
  },
  {
    id: "1285",
    sura: "9",
    VerseIDAr: "50",
    ayatAR:
      "إِنْ تُصِبْكَ حَسَنَةٌ تَسُؤْهُمْ ۖ وَإِنْ تُصِبْكَ مُصِيبَةٌ يَقُولُوا قَدْ أَخَذْنَا أَمْرَنَا مِنْ قَبْلُ وَيَتَوَلَّوْا وَهُمْ فَرِحُونَ",
  },
  {
    id: "1286",
    sura: "9",
    VerseIDAr: "51",
    ayatAR:
      "قُلْ لَنْ يُصِيبَنَا إِلَّا مَا كَتَبَ اللَّهُ لَنَا هُوَ مَوْلَانَا ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "1287",
    sura: "9",
    VerseIDAr: "52",
    ayatAR:
      "قُلْ هَلْ تَرَبَّصُونَ بِنَا إِلَّا إِحْدَى الْحُسْنَيَيْنِ ۖ وَنَحْنُ نَتَرَبَّصُ بِكُمْ أَنْ يُصِيبَكُمُ اللَّهُ بِعَذَابٍ مِنْ عِنْدِهِ أَوْ بِأَيْدِينَا ۖ فَتَرَبَّصُوا إِنَّا مَعَكُمْ مُتَرَبِّصُونَ",
  },
  {
    id: "1288",
    sura: "9",
    VerseIDAr: "53",
    ayatAR:
      "قُلْ أَنْفِقُوا طَوْعًا أَوْ كَرْهًا لَنْ يُتَقَبَّلَ مِنْكُمْ ۖ إِنَّكُمْ كُنْتُمْ قَوْمًا فَاسِقِينَ",
  },
  {
    id: "1289",
    sura: "9",
    VerseIDAr: "54",
    ayatAR:
      "وَمَا مَنَعَهُمْ أَنْ تُقْبَلَ مِنْهُمْ نَفَقَاتُهُمْ إِلَّا أَنَّهُمْ كَفَرُوا بِاللَّهِ وَبِرَسُولِهِ وَلَا يَأْتُونَ الصَّلَاةَ إِلَّا وَهُمْ كُسَالَىٰ وَلَا يُنْفِقُونَ إِلَّا وَهُمْ كَارِهُونَ",
  },
  {
    id: "1290",
    sura: "9",
    VerseIDAr: "55",
    ayatAR:
      "فَلَا تُعْجِبْكَ أَمْوَالُهُمْ وَلَا أَوْلَادُهُمْ ۚ إِنَّمَا يُرِيدُ اللَّهُ لِيُعَذِّبَهُمْ بِهَا فِي الْحَيَاةِ الدُّنْيَا وَتَزْهَقَ أَنْفُسُهُمْ وَهُمْ كَافِرُونَ",
  },
  {
    id: "1291",
    sura: "9",
    VerseIDAr: "56",
    ayatAR:
      "وَيَحْلِفُونَ بِاللَّهِ إِنَّهُمْ لَمِنْكُمْ وَمَا هُمْ مِنْكُمْ وَلَٰكِنَّهُمْ قَوْمٌ يَفْرَقُونَ",
  },
  {
    id: "1292",
    sura: "9",
    VerseIDAr: "57",
    ayatAR:
      "لَوْ يَجِدُونَ مَلْجَأً أَوْ مَغَارَاتٍ أَوْ مُدَّخَلًا لَوَلَّوْا إِلَيْهِ وَهُمْ يَجْمَحُونَ",
  },
  {
    id: "1293",
    sura: "9",
    VerseIDAr: "58",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَلْمِزُكَ فِي الصَّدَقَاتِ فَإِنْ أُعْطُوا مِنْهَا رَضُوا وَإِنْ لَمْ يُعْطَوْا مِنْهَا إِذَا هُمْ يَسْخَطُونَ",
  },
  {
    id: "1294",
    sura: "9",
    VerseIDAr: "59",
    ayatAR:
      "وَلَوْ أَنَّهُمْ رَضُوا مَا آتَاهُمُ اللَّهُ وَرَسُولُهُ وَقَالُوا حَسْبُنَا اللَّهُ سَيُؤْتِينَا اللَّهُ مِنْ فَضْلِهِ وَرَسُولُهُ إِنَّا إِلَى اللَّهِ رَاغِبُونَ",
  },
  {
    id: "1295",
    sura: "9",
    VerseIDAr: "60",
    ayatAR:
      "إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ قُلُوبُهُمْ وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ ۖ فَرِيضَةً مِنَ اللَّهِ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1296",
    sura: "9",
    VerseIDAr: "61",
    ayatAR:
      "وَمِنْهُمُ الَّذِينَ يُؤْذُونَ النَّبِيَّ وَيَقُولُونَ هُوَ أُذُنٌ ۚ قُلْ أُذُنُ خَيْرٍ لَكُمْ يُؤْمِنُ بِاللَّهِ وَيُؤْمِنُ لِلْمُؤْمِنِينَ وَرَحْمَةٌ لِلَّذِينَ آمَنُوا مِنْكُمْ ۚ وَالَّذِينَ يُؤْذُونَ رَسُولَ اللَّهِ لَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1297",
    sura: "9",
    VerseIDAr: "62",
    ayatAR:
      "يَحْلِفُونَ بِاللَّهِ لَكُمْ لِيُرْضُوكُمْ وَاللَّهُ وَرَسُولُهُ أَحَقُّ أَنْ يُرْضُوهُ إِنْ كَانُوا مُؤْمِنِينَ",
  },
  {
    id: "1298",
    sura: "9",
    VerseIDAr: "63",
    ayatAR:
      "أَلَمْ يَعْلَمُوا أَنَّهُ مَنْ يُحَادِدِ اللَّهَ وَرَسُولَهُ فَأَنَّ لَهُ نَارَ جَهَنَّمَ خَالِدًا فِيهَا ۚ ذَٰلِكَ الْخِزْيُ الْعَظِيمُ",
  },
  {
    id: "1299",
    sura: "9",
    VerseIDAr: "64",
    ayatAR:
      "يَحْذَرُ الْمُنَافِقُونَ أَنْ تُنَزَّلَ عَلَيْهِمْ سُورَةٌ تُنَبِّئُهُمْ بِمَا فِي قُلُوبِهِمْ ۚ قُلِ اسْتَهْزِئُوا إِنَّ اللَّهَ مُخْرِجٌ مَا تَحْذَرُونَ",
  },
  {
    id: "1300",
    sura: "9",
    VerseIDAr: "65",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ لَيَقُولُنَّ إِنَّمَا كُنَّا نَخُوضُ وَنَلْعَبُ ۚ قُلْ أَبِاللَّهِ وَآيَاتِهِ وَرَسُولِهِ كُنْتُمْ تَسْتَهْزِئُونَ",
  },
  {
    id: "1301",
    sura: "9",
    VerseIDAr: "66",
    ayatAR:
      "لَا تَعْتَذِرُوا قَدْ كَفَرْتُمْ بَعْدَ إِيمَانِكُمْ ۚ إِنْ نَعْفُ عَنْ طَائِفَةٍ مِنْكُمْ نُعَذِّبْ طَائِفَةً بِأَنَّهُمْ كَانُوا مُجْرِمِينَ",
  },
  {
    id: "1302",
    sura: "9",
    VerseIDAr: "67",
    ayatAR:
      "الْمُنَافِقُونَ وَالْمُنَافِقَاتُ بَعْضُهُمْ مِنْ بَعْضٍ ۚ يَأْمُرُونَ بِالْمُنْكَرِ وَيَنْهَوْنَ عَنِ الْمَعْرُوفِ وَيَقْبِضُونَ أَيْدِيَهُمْ ۚ نَسُوا اللَّهَ فَنَسِيَهُمْ ۗ إِنَّ الْمُنَافِقِينَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "1303",
    sura: "9",
    VerseIDAr: "68",
    ayatAR:
      "وَعَدَ اللَّهُ الْمُنَافِقِينَ وَالْمُنَافِقَاتِ وَالْكُفَّارَ نَارَ جَهَنَّمَ خَالِدِينَ فِيهَا ۚ هِيَ حَسْبُهُمْ ۚ وَلَعَنَهُمُ اللَّهُ ۖ وَلَهُمْ عَذَابٌ مُقِيمٌ",
  },
  {
    id: "1304",
    sura: "9",
    VerseIDAr: "69",
    ayatAR:
      "كَالَّذِينَ مِنْ قَبْلِكُمْ كَانُوا أَشَدَّ مِنْكُمْ قُوَّةً وَأَكْثَرَ أَمْوَالًا وَأَوْلَادًا فَاسْتَمْتَعُوا بِخَلَاقِهِمْ فَاسْتَمْتَعْتُمْ بِخَلَاقِكُمْ كَمَا اسْتَمْتَعَ الَّذِينَ مِنْ قَبْلِكُمْ بِخَلَاقِهِمْ وَخُضْتُمْ كَالَّذِي خَاضُوا ۚ أُولَٰئِكَ حَبِطَتْ أَعْمَالُهُمْ فِي الدُّنْيَا وَالْآخِرَةِ ۖ وَأُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "1305",
    sura: "9",
    VerseIDAr: "70",
    ayatAR:
      "أَلَمْ يَأْتِهِمْ نَبَأُ الَّذِينَ مِنْ قَبْلِهِمْ قَوْمِ نُوحٍ وَعَادٍ وَثَمُودَ وَقَوْمِ إِبْرَاهِيمَ وَأَصْحَابِ مَدْيَنَ وَالْمُؤْتَفِكَاتِ ۚ أَتَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ ۖ فَمَا كَانَ اللَّهُ لِيَظْلِمَهُمْ وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "1306",
    sura: "9",
    VerseIDAr: "71",
    ayatAR:
      "وَالْمُؤْمِنُونَ وَالْمُؤْمِنَاتُ بَعْضُهُمْ أَوْلِيَاءُ بَعْضٍ ۚ يَأْمُرُونَ بِالْمَعْرُوفِ وَيَنْهَوْنَ عَنِ الْمُنْكَرِ وَيُقِيمُونَ الصَّلَاةَ وَيُؤْتُونَ الزَّكَاةَ وَيُطِيعُونَ اللَّهَ وَرَسُولَهُ ۚ أُولَٰئِكَ سَيَرْحَمُهُمُ اللَّهُ ۗ إِنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "1307",
    sura: "9",
    VerseIDAr: "72",
    ayatAR:
      "وَعَدَ اللَّهُ الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا وَمَسَاكِنَ طَيِّبَةً فِي جَنَّاتِ عَدْنٍ ۚ وَرِضْوَانٌ مِنَ اللَّهِ أَكْبَرُ ۚ ذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "1308",
    sura: "9",
    VerseIDAr: "73",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ جَاهِدِ الْكُفَّارَ وَالْمُنَافِقِينَ وَاغْلُظْ عَلَيْهِمْ ۚ وَمَأْوَاهُمْ جَهَنَّمُ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "1309",
    sura: "9",
    VerseIDAr: "74",
    ayatAR:
      "يَحْلِفُونَ بِاللَّهِ مَا قَالُوا وَلَقَدْ قَالُوا كَلِمَةَ الْكُفْرِ وَكَفَرُوا بَعْدَ إِسْلَامِهِمْ وَهَمُّوا بِمَا لَمْ يَنَالُوا ۚ وَمَا نَقَمُوا إِلَّا أَنْ أَغْنَاهُمُ اللَّهُ وَرَسُولُهُ مِنْ فَضْلِهِ ۚ فَإِنْ يَتُوبُوا يَكُ خَيْرًا لَهُمْ ۖ وَإِنْ يَتَوَلَّوْا يُعَذِّبْهُمُ اللَّهُ عَذَابًا أَلِيمًا فِي الدُّنْيَا وَالْآخِرَةِ ۚ وَمَا لَهُمْ فِي الْأَرْضِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "1310",
    sura: "9",
    VerseIDAr: "75",
    ayatAR:
      "وَمِنْهُمْ مَنْ عَاهَدَ اللَّهَ لَئِنْ آتَانَا مِنْ فَضْلِهِ لَنَصَّدَّقَنَّ وَلَنَكُونَنَّ مِنَ الصَّالِحِينَ",
  },
  {
    id: "1311",
    sura: "9",
    VerseIDAr: "76",
    ayatAR:
      "فَلَمَّا آتَاهُمْ مِنْ فَضْلِهِ بَخِلُوا بِهِ وَتَوَلَّوْا وَهُمْ مُعْرِضُونَ",
  },
  {
    id: "1312",
    sura: "9",
    VerseIDAr: "77",
    ayatAR:
      "فَأَعْقَبَهُمْ نِفَاقًا فِي قُلُوبِهِمْ إِلَىٰ يَوْمِ يَلْقَوْنَهُ بِمَا أَخْلَفُوا اللَّهَ مَا وَعَدُوهُ وَبِمَا كَانُوا يَكْذِبُونَ",
  },
  {
    id: "1313",
    sura: "9",
    VerseIDAr: "78",
    ayatAR:
      "أَلَمْ يَعْلَمُوا أَنَّ اللَّهَ يَعْلَمُ سِرَّهُمْ وَنَجْوَاهُمْ وَأَنَّ اللَّهَ عَلَّامُ الْغُيُوبِ",
  },
  {
    id: "1314",
    sura: "9",
    VerseIDAr: "79",
    ayatAR:
      "الَّذِينَ يَلْمِزُونَ الْمُطَّوِّعِينَ مِنَ الْمُؤْمِنِينَ فِي الصَّدَقَاتِ وَالَّذِينَ لَا يَجِدُونَ إِلَّا جُهْدَهُمْ فَيَسْخَرُونَ مِنْهُمْ ۙ سَخِرَ اللَّهُ مِنْهُمْ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1315",
    sura: "9",
    VerseIDAr: "80",
    ayatAR:
      "اسْتَغْفِرْ لَهُمْ أَوْ لَا تَسْتَغْفِرْ لَهُمْ إِنْ تَسْتَغْفِرْ لَهُمْ سَبْعِينَ مَرَّةً فَلَنْ يَغْفِرَ اللَّهُ لَهُمْ ۚ ذَٰلِكَ بِأَنَّهُمْ كَفَرُوا بِاللَّهِ وَرَسُولِهِ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْفَاسِقِينَ",
  },
  {
    id: "1316",
    sura: "9",
    VerseIDAr: "81",
    ayatAR:
      "فَرِحَ الْمُخَلَّفُونَ بِمَقْعَدِهِمْ خِلَافَ رَسُولِ اللَّهِ وَكَرِهُوا أَنْ يُجَاهِدُوا بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ فِي سَبِيلِ اللَّهِ وَقَالُوا لَا تَنْفِرُوا فِي الْحَرِّ ۗ قُلْ نَارُ جَهَنَّمَ أَشَدُّ حَرًّا ۚ لَوْ كَانُوا يَفْقَهُونَ",
  },
  {
    id: "1317",
    sura: "9",
    VerseIDAr: "82",
    ayatAR:
      "فَلْيَضْحَكُوا قَلِيلًا وَلْيَبْكُوا كَثِيرًا جَزَاءً بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "1318",
    sura: "9",
    VerseIDAr: "83",
    ayatAR:
      "فَإِنْ رَجَعَكَ اللَّهُ إِلَىٰ طَائِفَةٍ مِنْهُمْ فَاسْتَأْذَنُوكَ لِلْخُرُوجِ فَقُلْ لَنْ تَخْرُجُوا مَعِيَ أَبَدًا وَلَنْ تُقَاتِلُوا مَعِيَ عَدُوًّا ۖ إِنَّكُمْ رَضِيتُمْ بِالْقُعُودِ أَوَّلَ مَرَّةٍ فَاقْعُدُوا مَعَ الْخَالِفِينَ",
  },
  {
    id: "1319",
    sura: "9",
    VerseIDAr: "84",
    ayatAR:
      "وَلَا تُصَلِّ عَلَىٰ أَحَدٍ مِنْهُمْ مَاتَ أَبَدًا وَلَا تَقُمْ عَلَىٰ قَبْرِهِ ۖ إِنَّهُمْ كَفَرُوا بِاللَّهِ وَرَسُولِهِ وَمَاتُوا وَهُمْ فَاسِقُونَ",
  },
  {
    id: "1320",
    sura: "9",
    VerseIDAr: "85",
    ayatAR:
      "وَلَا تُعْجِبْكَ أَمْوَالُهُمْ وَأَوْلَادُهُمْ ۚ إِنَّمَا يُرِيدُ اللَّهُ أَنْ يُعَذِّبَهُمْ بِهَا فِي الدُّنْيَا وَتَزْهَقَ أَنْفُسُهُمْ وَهُمْ كَافِرُونَ",
  },
  {
    id: "1321",
    sura: "9",
    VerseIDAr: "86",
    ayatAR:
      "وَإِذَا أُنْزِلَتْ سُورَةٌ أَنْ آمِنُوا بِاللَّهِ وَجَاهِدُوا مَعَ رَسُولِهِ اسْتَأْذَنَكَ أُولُو الطَّوْلِ مِنْهُمْ وَقَالُوا ذَرْنَا نَكُنْ مَعَ الْقَاعِدِينَ",
  },
  {
    id: "1322",
    sura: "9",
    VerseIDAr: "87",
    ayatAR:
      "رَضُوا بِأَنْ يَكُونُوا مَعَ الْخَوَالِفِ وَطُبِعَ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَفْقَهُونَ",
  },
  {
    id: "1323",
    sura: "9",
    VerseIDAr: "88",
    ayatAR:
      "لَٰكِنِ الرَّسُولُ وَالَّذِينَ آمَنُوا مَعَهُ جَاهَدُوا بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ ۚ وَأُولَٰئِكَ لَهُمُ الْخَيْرَاتُ ۖ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "1324",
    sura: "9",
    VerseIDAr: "89",
    ayatAR:
      "أَعَدَّ اللَّهُ لَهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ ذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "1325",
    sura: "9",
    VerseIDAr: "90",
    ayatAR:
      "وَجَاءَ الْمُعَذِّرُونَ مِنَ الْأَعْرَابِ لِيُؤْذَنَ لَهُمْ وَقَعَدَ الَّذِينَ كَذَبُوا اللَّهَ وَرَسُولَهُ ۚ سَيُصِيبُ الَّذِينَ كَفَرُوا مِنْهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1326",
    sura: "9",
    VerseIDAr: "91",
    ayatAR:
      "لَيْسَ عَلَى الضُّعَفَاءِ وَلَا عَلَى الْمَرْضَىٰ وَلَا عَلَى الَّذِينَ لَا يَجِدُونَ مَا يُنْفِقُونَ حَرَجٌ إِذَا نَصَحُوا لِلَّهِ وَرَسُولِهِ ۚ مَا عَلَى الْمُحْسِنِينَ مِنْ سَبِيلٍ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1327",
    sura: "9",
    VerseIDAr: "92",
    ayatAR:
      "وَلَا عَلَى الَّذِينَ إِذَا مَا أَتَوْكَ لِتَحْمِلَهُمْ قُلْتَ لَا أَجِدُ مَا أَحْمِلُكُمْ عَلَيْهِ تَوَلَّوْا وَأَعْيُنُهُمْ تَفِيضُ مِنَ الدَّمْعِ حَزَنًا أَلَّا يَجِدُوا مَا يُنْفِقُونَ",
  },
  {
    id: "1328",
    sura: "9",
    VerseIDAr: "93",
    ayatAR:
      "إِنَّمَا السَّبِيلُ عَلَى الَّذِينَ يَسْتَأْذِنُونَكَ وَهُمْ أَغْنِيَاءُ ۚ رَضُوا بِأَنْ يَكُونُوا مَعَ الْخَوَالِفِ وَطَبَعَ اللَّهُ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "1329",
    sura: "9",
    VerseIDAr: "94",
    ayatAR:
      "يَعْتَذِرُونَ إِلَيْكُمْ إِذَا رَجَعْتُمْ إِلَيْهِمْ ۚ قُلْ لَا تَعْتَذِرُوا لَنْ نُؤْمِنَ لَكُمْ قَدْ نَبَّأَنَا اللَّهُ مِنْ أَخْبَارِكُمْ ۚ وَسَيَرَى اللَّهُ عَمَلَكُمْ وَرَسُولُهُ ثُمَّ تُرَدُّونَ إِلَىٰ عَالِمِ الْغَيْبِ وَالشَّهَادَةِ فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1330",
    sura: "9",
    VerseIDAr: "95",
    ayatAR:
      "سَيَحْلِفُونَ بِاللَّهِ لَكُمْ إِذَا انْقَلَبْتُمْ إِلَيْهِمْ لِتُعْرِضُوا عَنْهُمْ ۖ فَأَعْرِضُوا عَنْهُمْ ۖ إِنَّهُمْ رِجْسٌ ۖ وَمَأْوَاهُمْ جَهَنَّمُ جَزَاءً بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "1331",
    sura: "9",
    VerseIDAr: "96",
    ayatAR:
      "يَحْلِفُونَ لَكُمْ لِتَرْضَوْا عَنْهُمْ ۖ فَإِنْ تَرْضَوْا عَنْهُمْ فَإِنَّ اللَّهَ لَا يَرْضَىٰ عَنِ الْقَوْمِ الْفَاسِقِينَ",
  },
  {
    id: "1332",
    sura: "9",
    VerseIDAr: "97",
    ayatAR:
      "الْأَعْرَابُ أَشَدُّ كُفْرًا وَنِفَاقًا وَأَجْدَرُ أَلَّا يَعْلَمُوا حُدُودَ مَا أَنْزَلَ اللَّهُ عَلَىٰ رَسُولِهِ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1333",
    sura: "9",
    VerseIDAr: "98",
    ayatAR:
      "وَمِنَ الْأَعْرَابِ مَنْ يَتَّخِذُ مَا يُنْفِقُ مَغْرَمًا وَيَتَرَبَّصُ بِكُمُ الدَّوَائِرَ ۚ عَلَيْهِمْ دَائِرَةُ السَّوْءِ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1334",
    sura: "9",
    VerseIDAr: "99",
    ayatAR:
      "وَمِنَ الْأَعْرَابِ مَنْ يُؤْمِنُ بِاللَّهِ وَالْيَوْمِ الْآخِرِ وَيَتَّخِذُ مَا يُنْفِقُ قُرُبَاتٍ عِنْدَ اللَّهِ وَصَلَوَاتِ الرَّسُولِ ۚ أَلَا إِنَّهَا قُرْبَةٌ لَهُمْ ۚ سَيُدْخِلُهُمُ اللَّهُ فِي رَحْمَتِهِ ۗ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1335",
    sura: "9",
    VerseIDAr: "100",
    ayatAR:
      "وَالسَّابِقُونَ الْأَوَّلُونَ مِنَ الْمُهَاجِرِينَ وَالْأَنْصَارِ وَالَّذِينَ اتَّبَعُوهُمْ بِإِحْسَانٍ رَضِيَ اللَّهُ عَنْهُمْ وَرَضُوا عَنْهُ وَأَعَدَّ لَهُمْ جَنَّاتٍ تَجْرِي تَحْتَهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۚ ذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "1336",
    sura: "9",
    VerseIDAr: "101",
    ayatAR:
      "وَمِمَّنْ حَوْلَكُمْ مِنَ الْأَعْرَابِ مُنَافِقُونَ ۖ وَمِنْ أَهْلِ الْمَدِينَةِ ۖ مَرَدُوا عَلَى النِّفَاقِ لَا تَعْلَمُهُمْ ۖ نَحْنُ نَعْلَمُهُمْ ۚ سَنُعَذِّبُهُمْ مَرَّتَيْنِ ثُمَّ يُرَدُّونَ إِلَىٰ عَذَابٍ عَظِيمٍ",
  },
  {
    id: "1337",
    sura: "9",
    VerseIDAr: "102",
    ayatAR:
      "وَآخَرُونَ اعْتَرَفُوا بِذُنُوبِهِمْ خَلَطُوا عَمَلًا صَالِحًا وَآخَرَ سَيِّئًا عَسَى اللَّهُ أَنْ يَتُوبَ عَلَيْهِمْ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1338",
    sura: "9",
    VerseIDAr: "103",
    ayatAR:
      "خُذْ مِنْ أَمْوَالِهِمْ صَدَقَةً تُطَهِّرُهُمْ وَتُزَكِّيهِمْ بِهَا وَصَلِّ عَلَيْهِمْ ۖ إِنَّ صَلَاتَكَ سَكَنٌ لَهُمْ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "1339",
    sura: "9",
    VerseIDAr: "104",
    ayatAR:
      "أَلَمْ يَعْلَمُوا أَنَّ اللَّهَ هُوَ يَقْبَلُ التَّوْبَةَ عَنْ عِبَادِهِ وَيَأْخُذُ الصَّدَقَاتِ وَأَنَّ اللَّهَ هُوَ التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "1340",
    sura: "9",
    VerseIDAr: "105",
    ayatAR:
      "وَقُلِ اعْمَلُوا فَسَيَرَى اللَّهُ عَمَلَكُمْ وَرَسُولُهُ وَالْمُؤْمِنُونَ ۖ وَسَتُرَدُّونَ إِلَىٰ عَالِمِ الْغَيْبِ وَالشَّهَادَةِ فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1341",
    sura: "9",
    VerseIDAr: "106",
    ayatAR:
      "وَآخَرُونَ مُرْجَوْنَ لِأَمْرِ اللَّهِ إِمَّا يُعَذِّبُهُمْ وَإِمَّا يَتُوبُ عَلَيْهِمْ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1342",
    sura: "9",
    VerseIDAr: "107",
    ayatAR:
      "وَالَّذِينَ اتَّخَذُوا مَسْجِدًا ضِرَارًا وَكُفْرًا وَتَفْرِيقًا بَيْنَ الْمُؤْمِنِينَ وَإِرْصَادًا لِمَنْ حَارَبَ اللَّهَ وَرَسُولَهُ مِنْ قَبْلُ ۚ وَلَيَحْلِفُنَّ إِنْ أَرَدْنَا إِلَّا الْحُسْنَىٰ ۖ وَاللَّهُ يَشْهَدُ إِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "1343",
    sura: "9",
    VerseIDAr: "108",
    ayatAR:
      "لَا تَقُمْ فِيهِ أَبَدًا ۚ لَمَسْجِدٌ أُسِّسَ عَلَى التَّقْوَىٰ مِنْ أَوَّلِ يَوْمٍ أَحَقُّ أَنْ تَقُومَ فِيهِ ۚ فِيهِ رِجَالٌ يُحِبُّونَ أَنْ يَتَطَهَّرُوا ۚ وَاللَّهُ يُحِبُّ الْمُطَّهِّرِينَ",
  },
  {
    id: "1344",
    sura: "9",
    VerseIDAr: "109",
    ayatAR:
      "أَفَمَنْ أَسَّسَ بُنْيَانَهُ عَلَىٰ تَقْوَىٰ مِنَ اللَّهِ وَرِضْوَانٍ خَيْرٌ أَمْ مَنْ أَسَّسَ بُنْيَانَهُ عَلَىٰ شَفَا جُرُفٍ هَارٍ فَانْهَارَ بِهِ فِي نَارِ جَهَنَّمَ ۗ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "1345",
    sura: "9",
    VerseIDAr: "110",
    ayatAR:
      "لَا يَزَالُ بُنْيَانُهُمُ الَّذِي بَنَوْا رِيبَةً فِي قُلُوبِهِمْ إِلَّا أَنْ تَقَطَّعَ قُلُوبُهُمْ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1346",
    sura: "9",
    VerseIDAr: "111",
    ayatAR:
      "إِنَّ اللَّهَ اشْتَرَىٰ مِنَ الْمُؤْمِنِينَ أَنْفُسَهُمْ وَأَمْوَالَهُمْ بِأَنَّ لَهُمُ الْجَنَّةَ ۚ يُقَاتِلُونَ فِي سَبِيلِ اللَّهِ فَيَقْتُلُونَ وَيُقْتَلُونَ ۖ وَعْدًا عَلَيْهِ حَقًّا فِي التَّوْرَاةِ وَالْإِنْجِيلِ وَالْقُرْآنِ ۚ وَمَنْ أَوْفَىٰ بِعَهْدِهِ مِنَ اللَّهِ ۚ فَاسْتَبْشِرُوا بِبَيْعِكُمُ الَّذِي بَايَعْتُمْ بِهِ ۚ وَذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "1347",
    sura: "9",
    VerseIDAr: "112",
    ayatAR:
      "التَّائِبُونَ الْعَابِدُونَ الْحَامِدُونَ السَّائِحُونَ الرَّاكِعُونَ السَّاجِدُونَ الْآمِرُونَ بِالْمَعْرُوفِ وَالنَّاهُونَ عَنِ الْمُنْكَرِ وَالْحَافِظُونَ لِحُدُودِ اللَّهِ ۗ وَبَشِّرِ الْمُؤْمِنِينَ",
  },
  {
    id: "1348",
    sura: "9",
    VerseIDAr: "113",
    ayatAR:
      "مَا كَانَ لِلنَّبِيِّ وَالَّذِينَ آمَنُوا أَنْ يَسْتَغْفِرُوا لِلْمُشْرِكِينَ وَلَوْ كَانُوا أُولِي قُرْبَىٰ مِنْ بَعْدِ مَا تَبَيَّنَ لَهُمْ أَنَّهُمْ أَصْحَابُ الْجَحِيمِ",
  },
  {
    id: "1349",
    sura: "9",
    VerseIDAr: "114",
    ayatAR:
      "وَمَا كَانَ اسْتِغْفَارُ إِبْرَاهِيمَ لِأَبِيهِ إِلَّا عَنْ مَوْعِدَةٍ وَعَدَهَا إِيَّاهُ فَلَمَّا تَبَيَّنَ لَهُ أَنَّهُ عَدُوٌّ لِلَّهِ تَبَرَّأَ مِنْهُ ۚ إِنَّ إِبْرَاهِيمَ لَأَوَّاهٌ حَلِيمٌ",
  },
  {
    id: "1350",
    sura: "9",
    VerseIDAr: "115",
    ayatAR:
      "وَمَا كَانَ اللَّهُ لِيُضِلَّ قَوْمًا بَعْدَ إِذْ هَدَاهُمْ حَتَّىٰ يُبَيِّنَ لَهُمْ مَا يَتَّقُونَ ۚ إِنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "1351",
    sura: "9",
    VerseIDAr: "116",
    ayatAR:
      "إِنَّ اللَّهَ لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۖ يُحْيِي وَيُمِيتُ ۚ وَمَا لَكُمْ مِنْ دُونِ اللَّهِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "1352",
    sura: "9",
    VerseIDAr: "117",
    ayatAR:
      "لَقَدْ تَابَ اللَّهُ عَلَى النَّبِيِّ وَالْمُهَاجِرِينَ وَالْأَنْصَارِ الَّذِينَ اتَّبَعُوهُ فِي سَاعَةِ الْعُسْرَةِ مِنْ بَعْدِ مَا كَادَ يَزِيغُ قُلُوبُ فَرِيقٍ مِنْهُمْ ثُمَّ تَابَ عَلَيْهِمْ ۚ إِنَّهُ بِهِمْ رَءُوفٌ رَحِيمٌ",
  },
  {
    id: "1353",
    sura: "9",
    VerseIDAr: "118",
    ayatAR:
      "وَعَلَى الثَّلَاثَةِ الَّذِينَ خُلِّفُوا حَتَّىٰ إِذَا ضَاقَتْ عَلَيْهِمُ الْأَرْضُ بِمَا رَحُبَتْ وَضَاقَتْ عَلَيْهِمْ أَنْفُسُهُمْ وَظَنُّوا أَنْ لَا مَلْجَأَ مِنَ اللَّهِ إِلَّا إِلَيْهِ ثُمَّ تَابَ عَلَيْهِمْ لِيَتُوبُوا ۚ إِنَّ اللَّهَ هُوَ التَّوَّابُ الرَّحِيمُ",
  },
  {
    id: "1354",
    sura: "9",
    VerseIDAr: "119",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَكُونُوا مَعَ الصَّادِقِينَ",
  },
  {
    id: "1355",
    sura: "9",
    VerseIDAr: "120",
    ayatAR:
      "مَا كَانَ لِأَهْلِ الْمَدِينَةِ وَمَنْ حَوْلَهُمْ مِنَ الْأَعْرَابِ أَنْ يَتَخَلَّفُوا عَنْ رَسُولِ اللَّهِ وَلَا يَرْغَبُوا بِأَنْفُسِهِمْ عَنْ نَفْسِهِ ۚ ذَٰلِكَ بِأَنَّهُمْ لَا يُصِيبُهُمْ ظَمَأٌ وَلَا نَصَبٌ وَلَا مَخْمَصَةٌ فِي سَبِيلِ اللَّهِ وَلَا يَطَئُونَ مَوْطِئًا يَغِيظُ الْكُفَّارَ وَلَا يَنَالُونَ مِنْ عَدُوٍّ نَيْلًا إِلَّا كُتِبَ لَهُمْ بِهِ عَمَلٌ صَالِحٌ ۚ إِنَّ اللَّهَ لَا يُضِيعُ أَجْرَ الْمُحْسِنِينَ",
  },
  {
    id: "1356",
    sura: "9",
    VerseIDAr: "121",
    ayatAR:
      "وَلَا يُنْفِقُونَ نَفَقَةً صَغِيرَةً وَلَا كَبِيرَةً وَلَا يَقْطَعُونَ وَادِيًا إِلَّا كُتِبَ لَهُمْ لِيَجْزِيَهُمُ اللَّهُ أَحْسَنَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1357",
    sura: "9",
    VerseIDAr: "122",
    ayatAR:
      "وَمَا كَانَ الْمُؤْمِنُونَ لِيَنْفِرُوا كَافَّةً ۚ فَلَوْلَا نَفَرَ مِنْ كُلِّ فِرْقَةٍ مِنْهُمْ طَائِفَةٌ لِيَتَفَقَّهُوا فِي الدِّينِ وَلِيُنْذِرُوا قَوْمَهُمْ إِذَا رَجَعُوا إِلَيْهِمْ لَعَلَّهُمْ يَحْذَرُونَ",
  },
  {
    id: "1358",
    sura: "9",
    VerseIDAr: "123",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا قَاتِلُوا الَّذِينَ يَلُونَكُمْ مِنَ الْكُفَّارِ وَلْيَجِدُوا فِيكُمْ غِلْظَةً ۚ وَاعْلَمُوا أَنَّ اللَّهَ مَعَ الْمُتَّقِينَ",
  },
  {
    id: "1359",
    sura: "9",
    VerseIDAr: "124",
    ayatAR:
      "وَإِذَا مَا أُنْزِلَتْ سُورَةٌ فَمِنْهُمْ مَنْ يَقُولُ أَيُّكُمْ زَادَتْهُ هَٰذِهِ إِيمَانًا ۚ فَأَمَّا الَّذِينَ آمَنُوا فَزَادَتْهُمْ إِيمَانًا وَهُمْ يَسْتَبْشِرُونَ",
  },
  {
    id: "1360",
    sura: "9",
    VerseIDAr: "125",
    ayatAR:
      "وَأَمَّا الَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ فَزَادَتْهُمْ رِجْسًا إِلَىٰ رِجْسِهِمْ وَمَاتُوا وَهُمْ كَافِرُونَ",
  },
  {
    id: "1361",
    sura: "9",
    VerseIDAr: "126",
    ayatAR:
      "أَوَلَا يَرَوْنَ أَنَّهُمْ يُفْتَنُونَ فِي كُلِّ عَامٍ مَرَّةً أَوْ مَرَّتَيْنِ ثُمَّ لَا يَتُوبُونَ وَلَا هُمْ يَذَّكَّرُونَ",
  },
  {
    id: "1362",
    sura: "9",
    VerseIDAr: "127",
    ayatAR:
      "وَإِذَا مَا أُنْزِلَتْ سُورَةٌ نَظَرَ بَعْضُهُمْ إِلَىٰ بَعْضٍ هَلْ يَرَاكُمْ مِنْ أَحَدٍ ثُمَّ انْصَرَفُوا ۚ صَرَفَ اللَّهُ قُلُوبَهُمْ بِأَنَّهُمْ قَوْمٌ لَا يَفْقَهُونَ",
  },
  {
    id: "1363",
    sura: "9",
    VerseIDAr: "128",
    ayatAR:
      "لَقَدْ جَاءَكُمْ رَسُولٌ مِنْ أَنْفُسِكُمْ عَزِيزٌ عَلَيْهِ مَا عَنِتُّمْ حَرِيصٌ عَلَيْكُمْ بِالْمُؤْمِنِينَ رَءُوفٌ رَحِيمٌ",
  },
  {
    id: "1364",
    sura: "9",
    VerseIDAr: "129",
    ayatAR:
      "فَإِنْ تَوَلَّوْا فَقُلْ حَسْبِيَ اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ ۖ عَلَيْهِ تَوَكَّلْتُ ۖ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ",
  },
  {
    id: "1365",
    sura: "10",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الر ۚ تِلْكَ آيَاتُ الْكِتَابِ الْحَكِيمِ",
  },
  {
    id: "1366",
    sura: "10",
    VerseIDAr: "2",
    ayatAR:
      "أَكَانَ لِلنَّاسِ عَجَبًا أَنْ أَوْحَيْنَا إِلَىٰ رَجُلٍ مِنْهُمْ أَنْ أَنْذِرِ النَّاسَ وَبَشِّرِ الَّذِينَ آمَنُوا أَنَّ لَهُمْ قَدَمَ صِدْقٍ عِنْدَ رَبِّهِمْ ۗ قَالَ الْكَافِرُونَ إِنَّ هَٰذَا لَسَاحِرٌ مُبِينٌ",
  },
  {
    id: "1367",
    sura: "10",
    VerseIDAr: "3",
    ayatAR:
      "إِنَّ رَبَّكُمُ اللَّهُ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ فِي سِتَّةِ أَيَّامٍ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ ۖ يُدَبِّرُ الْأَمْرَ ۖ مَا مِنْ شَفِيعٍ إِلَّا مِنْ بَعْدِ إِذْنِهِ ۚ ذَٰلِكُمُ اللَّهُ رَبُّكُمْ فَاعْبُدُوهُ ۚ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "1368",
    sura: "10",
    VerseIDAr: "4",
    ayatAR:
      "إِلَيْهِ مَرْجِعُكُمْ جَمِيعًا ۖ وَعْدَ اللَّهِ حَقًّا ۚ إِنَّهُ يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ لِيَجْزِيَ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ بِالْقِسْطِ ۚ وَالَّذِينَ كَفَرُوا لَهُمْ شَرَابٌ مِنْ حَمِيمٍ وَعَذَابٌ أَلِيمٌ بِمَا كَانُوا يَكْفُرُونَ",
  },
  {
    id: "1369",
    sura: "10",
    VerseIDAr: "5",
    ayatAR:
      "هُوَ الَّذِي جَعَلَ الشَّمْسَ ضِيَاءً وَالْقَمَرَ نُورًا وَقَدَّرَهُ مَنَازِلَ لِتَعْلَمُوا عَدَدَ السِّنِينَ وَالْحِسَابَ ۚ مَا خَلَقَ اللَّهُ ذَٰلِكَ إِلَّا بِالْحَقِّ ۚ يُفَصِّلُ الْآيَاتِ لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "1370",
    sura: "10",
    VerseIDAr: "6",
    ayatAR:
      "إِنَّ فِي اخْتِلَافِ اللَّيْلِ وَالنَّهَارِ وَمَا خَلَقَ اللَّهُ فِي السَّمَاوَاتِ وَالْأَرْضِ لَآيَاتٍ لِقَوْمٍ يَتَّقُونَ",
  },
  {
    id: "1371",
    sura: "10",
    VerseIDAr: "7",
    ayatAR:
      "إِنَّ الَّذِينَ لَا يَرْجُونَ لِقَاءَنَا وَرَضُوا بِالْحَيَاةِ الدُّنْيَا وَاطْمَأَنُّوا بِهَا وَالَّذِينَ هُمْ عَنْ آيَاتِنَا غَافِلُونَ",
  },
  {
    id: "1372",
    sura: "10",
    VerseIDAr: "8",
    ayatAR: "أُولَٰئِكَ مَأْوَاهُمُ النَّارُ بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "1373",
    sura: "10",
    VerseIDAr: "9",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ يَهْدِيهِمْ رَبُّهُمْ بِإِيمَانِهِمْ ۖ تَجْرِي مِنْ تَحْتِهِمُ الْأَنْهَارُ فِي جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "1374",
    sura: "10",
    VerseIDAr: "10",
    ayatAR:
      "دَعْوَاهُمْ فِيهَا سُبْحَانَكَ اللَّهُمَّ وَتَحِيَّتُهُمْ فِيهَا سَلَامٌ ۚ وَآخِرُ دَعْوَاهُمْ أَنِ الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "1375",
    sura: "10",
    VerseIDAr: "11",
    ayatAR:
      "وَلَوْ يُعَجِّلُ اللَّهُ لِلنَّاسِ الشَّرَّ اسْتِعْجَالَهُمْ بِالْخَيْرِ لَقُضِيَ إِلَيْهِمْ أَجَلُهُمْ ۖ فَنَذَرُ الَّذِينَ لَا يَرْجُونَ لِقَاءَنَا فِي طُغْيَانِهِمْ يَعْمَهُونَ",
  },
  {
    id: "1376",
    sura: "10",
    VerseIDAr: "12",
    ayatAR:
      "وَإِذَا مَسَّ الْإِنْسَانَ الضُّرُّ دَعَانَا لِجَنْبِهِ أَوْ قَاعِدًا أَوْ قَائِمًا فَلَمَّا كَشَفْنَا عَنْهُ ضُرَّهُ مَرَّ كَأَنْ لَمْ يَدْعُنَا إِلَىٰ ضُرٍّ مَسَّهُ ۚ كَذَٰلِكَ زُيِّنَ لِلْمُسْرِفِينَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1377",
    sura: "10",
    VerseIDAr: "13",
    ayatAR:
      "وَلَقَدْ أَهْلَكْنَا الْقُرُونَ مِنْ قَبْلِكُمْ لَمَّا ظَلَمُوا ۙ وَجَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ وَمَا كَانُوا لِيُؤْمِنُوا ۚ كَذَٰلِكَ نَجْزِي الْقَوْمَ الْمُجْرِمِينَ",
  },
  {
    id: "1378",
    sura: "10",
    VerseIDAr: "14",
    ayatAR:
      "ثُمَّ جَعَلْنَاكُمْ خَلَائِفَ فِي الْأَرْضِ مِنْ بَعْدِهِمْ لِنَنْظُرَ كَيْفَ تَعْمَلُونَ",
  },
  {
    id: "1379",
    sura: "10",
    VerseIDAr: "15",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ ۙ قَالَ الَّذِينَ لَا يَرْجُونَ لِقَاءَنَا ائْتِ بِقُرْآنٍ غَيْرِ هَٰذَا أَوْ بَدِّلْهُ ۚ قُلْ مَا يَكُونُ لِي أَنْ أُبَدِّلَهُ مِنْ تِلْقَاءِ نَفْسِي ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰ إِلَيَّ ۖ إِنِّي أَخَافُ إِنْ عَصَيْتُ رَبِّي عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "1380",
    sura: "10",
    VerseIDAr: "16",
    ayatAR:
      "قُلْ لَوْ شَاءَ اللَّهُ مَا تَلَوْتُهُ عَلَيْكُمْ وَلَا أَدْرَاكُمْ بِهِ ۖ فَقَدْ لَبِثْتُ فِيكُمْ عُمُرًا مِنْ قَبْلِهِ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "1381",
    sura: "10",
    VerseIDAr: "17",
    ayatAR:
      "فَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَوْ كَذَّبَ بِآيَاتِهِ ۚ إِنَّهُ لَا يُفْلِحُ الْمُجْرِمُونَ",
  },
  {
    id: "1382",
    sura: "10",
    VerseIDAr: "18",
    ayatAR:
      "وَيَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَا يَضُرُّهُمْ وَلَا يَنْفَعُهُمْ وَيَقُولُونَ هَٰؤُلَاءِ شُفَعَاؤُنَا عِنْدَ اللَّهِ ۚ قُلْ أَتُنَبِّئُونَ اللَّهَ بِمَا لَا يَعْلَمُ فِي السَّمَاوَاتِ وَلَا فِي الْأَرْضِ ۚ سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "1383",
    sura: "10",
    VerseIDAr: "19",
    ayatAR:
      "وَمَا كَانَ النَّاسُ إِلَّا أُمَّةً وَاحِدَةً فَاخْتَلَفُوا ۚ وَلَوْلَا كَلِمَةٌ سَبَقَتْ مِنْ رَبِّكَ لَقُضِيَ بَيْنَهُمْ فِيمَا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "1384",
    sura: "10",
    VerseIDAr: "20",
    ayatAR:
      "وَيَقُولُونَ لَوْلَا أُنْزِلَ عَلَيْهِ آيَةٌ مِنْ رَبِّهِ ۖ فَقُلْ إِنَّمَا الْغَيْبُ لِلَّهِ فَانْتَظِرُوا إِنِّي مَعَكُمْ مِنَ الْمُنْتَظِرِينَ",
  },
  {
    id: "1385",
    sura: "10",
    VerseIDAr: "21",
    ayatAR:
      "وَإِذَا أَذَقْنَا النَّاسَ رَحْمَةً مِنْ بَعْدِ ضَرَّاءَ مَسَّتْهُمْ إِذَا لَهُمْ مَكْرٌ فِي آيَاتِنَا ۚ قُلِ اللَّهُ أَسْرَعُ مَكْرًا ۚ إِنَّ رُسُلَنَا يَكْتُبُونَ مَا تَمْكُرُونَ",
  },
  {
    id: "1386",
    sura: "10",
    VerseIDAr: "22",
    ayatAR:
      "هُوَ الَّذِي يُسَيِّرُكُمْ فِي الْبَرِّ وَالْبَحْرِ ۖ حَتَّىٰ إِذَا كُنْتُمْ فِي الْفُلْكِ وَجَرَيْنَ بِهِمْ بِرِيحٍ طَيِّبَةٍ وَفَرِحُوا بِهَا جَاءَتْهَا رِيحٌ عَاصِفٌ وَجَاءَهُمُ الْمَوْجُ مِنْ كُلِّ مَكَانٍ وَظَنُّوا أَنَّهُمْ أُحِيطَ بِهِمْ ۙ دَعَوُا اللَّهَ مُخْلِصِينَ لَهُ الدِّينَ لَئِنْ أَنْجَيْتَنَا مِنْ هَٰذِهِ لَنَكُونَنَّ مِنَ الشَّاكِرِينَ",
  },
  {
    id: "1387",
    sura: "10",
    VerseIDAr: "23",
    ayatAR:
      "فَلَمَّا أَنْجَاهُمْ إِذَا هُمْ يَبْغُونَ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ ۗ يَا أَيُّهَا النَّاسُ إِنَّمَا بَغْيُكُمْ عَلَىٰ أَنْفُسِكُمْ ۖ مَتَاعَ الْحَيَاةِ الدُّنْيَا ۖ ثُمَّ إِلَيْنَا مَرْجِعُكُمْ فَنُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1388",
    sura: "10",
    VerseIDAr: "24",
    ayatAR:
      "إِنَّمَا مَثَلُ الْحَيَاةِ الدُّنْيَا كَمَاءٍ أَنْزَلْنَاهُ مِنَ السَّمَاءِ فَاخْتَلَطَ بِهِ نَبَاتُ الْأَرْضِ مِمَّا يَأْكُلُ النَّاسُ وَالْأَنْعَامُ حَتَّىٰ إِذَا أَخَذَتِ الْأَرْضُ زُخْرُفَهَا وَازَّيَّنَتْ وَظَنَّ أَهْلُهَا أَنَّهُمْ قَادِرُونَ عَلَيْهَا أَتَاهَا أَمْرُنَا لَيْلًا أَوْ نَهَارًا فَجَعَلْنَاهَا حَصِيدًا كَأَنْ لَمْ تَغْنَ بِالْأَمْسِ ۚ كَذَٰلِكَ نُفَصِّلُ الْآيَاتِ لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "1389",
    sura: "10",
    VerseIDAr: "25",
    ayatAR:
      "وَاللَّهُ يَدْعُو إِلَىٰ دَارِ السَّلَامِ وَيَهْدِي مَنْ يَشَاءُ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "1390",
    sura: "10",
    VerseIDAr: "26",
    ayatAR:
      "لِلَّذِينَ أَحْسَنُوا الْحُسْنَىٰ وَزِيَادَةٌ ۖ وَلَا يَرْهَقُ وُجُوهَهُمْ قَتَرٌ وَلَا ذِلَّةٌ ۚ أُولَٰئِكَ أَصْحَابُ الْجَنَّةِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "1391",
    sura: "10",
    VerseIDAr: "27",
    ayatAR:
      "وَالَّذِينَ كَسَبُوا السَّيِّئَاتِ جَزَاءُ سَيِّئَةٍ بِمِثْلِهَا وَتَرْهَقُهُمْ ذِلَّةٌ ۖ مَا لَهُمْ مِنَ اللَّهِ مِنْ عَاصِمٍ ۖ كَأَنَّمَا أُغْشِيَتْ وُجُوهُهُمْ قِطَعًا مِنَ اللَّيْلِ مُظْلِمًا ۚ أُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "1392",
    sura: "10",
    VerseIDAr: "28",
    ayatAR:
      "وَيَوْمَ نَحْشُرُهُمْ جَمِيعًا ثُمَّ نَقُولُ لِلَّذِينَ أَشْرَكُوا مَكَانَكُمْ أَنْتُمْ وَشُرَكَاؤُكُمْ ۚ فَزَيَّلْنَا بَيْنَهُمْ ۖ وَقَالَ شُرَكَاؤُهُمْ مَا كُنْتُمْ إِيَّانَا تَعْبُدُونَ",
  },
  {
    id: "1393",
    sura: "10",
    VerseIDAr: "29",
    ayatAR:
      "فَكَفَىٰ بِاللَّهِ شَهِيدًا بَيْنَنَا وَبَيْنَكُمْ إِنْ كُنَّا عَنْ عِبَادَتِكُمْ لَغَافِلِينَ",
  },
  {
    id: "1394",
    sura: "10",
    VerseIDAr: "30",
    ayatAR:
      "هُنَالِكَ تَبْلُو كُلُّ نَفْسٍ مَا أَسْلَفَتْ ۚ وَرُدُّوا إِلَى اللَّهِ مَوْلَاهُمُ الْحَقِّ ۖ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "1395",
    sura: "10",
    VerseIDAr: "31",
    ayatAR:
      "قُلْ مَنْ يَرْزُقُكُمْ مِنَ السَّمَاءِ وَالْأَرْضِ أَمَّنْ يَمْلِكُ السَّمْعَ وَالْأَبْصَارَ وَمَنْ يُخْرِجُ الْحَيَّ مِنَ الْمَيِّتِ وَيُخْرِجُ الْمَيِّتَ مِنَ الْحَيِّ وَمَنْ يُدَبِّرُ الْأَمْرَ ۚ فَسَيَقُولُونَ اللَّهُ ۚ فَقُلْ أَفَلَا تَتَّقُونَ",
  },
  {
    id: "1396",
    sura: "10",
    VerseIDAr: "32",
    ayatAR:
      "فَذَٰلِكُمُ اللَّهُ رَبُّكُمُ الْحَقُّ ۖ فَمَاذَا بَعْدَ الْحَقِّ إِلَّا الضَّلَالُ ۖ فَأَنَّىٰ تُصْرَفُونَ",
  },
  {
    id: "1397",
    sura: "10",
    VerseIDAr: "33",
    ayatAR:
      "كَذَٰلِكَ حَقَّتْ كَلِمَتُ رَبِّكَ عَلَى الَّذِينَ فَسَقُوا أَنَّهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "1398",
    sura: "10",
    VerseIDAr: "34",
    ayatAR:
      "قُلْ هَلْ مِنْ شُرَكَائِكُمْ مَنْ يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ ۚ قُلِ اللَّهُ يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ ۖ فَأَنَّىٰ تُؤْفَكُونَ",
  },
  {
    id: "1399",
    sura: "10",
    VerseIDAr: "35",
    ayatAR:
      "قُلْ هَلْ مِنْ شُرَكَائِكُمْ مَنْ يَهْدِي إِلَى الْحَقِّ ۚ قُلِ اللَّهُ يَهْدِي لِلْحَقِّ ۗ أَفَمَنْ يَهْدِي إِلَى الْحَقِّ أَحَقُّ أَنْ يُتَّبَعَ أَمَّنْ لَا يَهِدِّي إِلَّا أَنْ يُهْدَىٰ ۖ فَمَا لَكُمْ كَيْفَ تَحْكُمُونَ",
  },
  {
    id: "1400",
    sura: "10",
    VerseIDAr: "36",
    ayatAR:
      "وَمَا يَتَّبِعُ أَكْثَرُهُمْ إِلَّا ظَنًّا ۚ إِنَّ الظَّنَّ لَا يُغْنِي مِنَ الْحَقِّ شَيْئًا ۚ إِنَّ اللَّهَ عَلِيمٌ بِمَا يَفْعَلُونَ",
  },
  {
    id: "1401",
    sura: "10",
    VerseIDAr: "37",
    ayatAR:
      "وَمَا كَانَ هَٰذَا الْقُرْآنُ أَنْ يُفْتَرَىٰ مِنْ دُونِ اللَّهِ وَلَٰكِنْ تَصْدِيقَ الَّذِي بَيْنَ يَدَيْهِ وَتَفْصِيلَ الْكِتَابِ لَا رَيْبَ فِيهِ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "1402",
    sura: "10",
    VerseIDAr: "38",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَاهُ ۖ قُلْ فَأْتُوا بِسُورَةٍ مِثْلِهِ وَادْعُوا مَنِ اسْتَطَعْتُمْ مِنْ دُونِ اللَّهِ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "1403",
    sura: "10",
    VerseIDAr: "39",
    ayatAR:
      "بَلْ كَذَّبُوا بِمَا لَمْ يُحِيطُوا بِعِلْمِهِ وَلَمَّا يَأْتِهِمْ تَأْوِيلُهُ ۚ كَذَٰلِكَ كَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الظَّالِمِينَ",
  },
  {
    id: "1404",
    sura: "10",
    VerseIDAr: "40",
    ayatAR:
      "وَمِنْهُمْ مَنْ يُؤْمِنُ بِهِ وَمِنْهُمْ مَنْ لَا يُؤْمِنُ بِهِ ۚ وَرَبُّكَ أَعْلَمُ بِالْمُفْسِدِينَ",
  },
  {
    id: "1405",
    sura: "10",
    VerseIDAr: "41",
    ayatAR:
      "وَإِنْ كَذَّبُوكَ فَقُلْ لِي عَمَلِي وَلَكُمْ عَمَلُكُمْ ۖ أَنْتُمْ بَرِيئُونَ مِمَّا أَعْمَلُ وَأَنَا بَرِيءٌ مِمَّا تَعْمَلُونَ",
  },
  {
    id: "1406",
    sura: "10",
    VerseIDAr: "42",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَسْتَمِعُونَ إِلَيْكَ ۚ أَفَأَنْتَ تُسْمِعُ الصُّمَّ وَلَوْ كَانُوا لَا يَعْقِلُونَ",
  },
  {
    id: "1407",
    sura: "10",
    VerseIDAr: "43",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَنْظُرُ إِلَيْكَ ۚ أَفَأَنْتَ تَهْدِي الْعُمْيَ وَلَوْ كَانُوا لَا يُبْصِرُونَ",
  },
  {
    id: "1408",
    sura: "10",
    VerseIDAr: "44",
    ayatAR:
      "إِنَّ اللَّهَ لَا يَظْلِمُ النَّاسَ شَيْئًا وَلَٰكِنَّ النَّاسَ أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "1409",
    sura: "10",
    VerseIDAr: "45",
    ayatAR:
      "وَيَوْمَ يَحْشُرُهُمْ كَأَنْ لَمْ يَلْبَثُوا إِلَّا سَاعَةً مِنَ النَّهَارِ يَتَعَارَفُونَ بَيْنَهُمْ ۚ قَدْ خَسِرَ الَّذِينَ كَذَّبُوا بِلِقَاءِ اللَّهِ وَمَا كَانُوا مُهْتَدِينَ",
  },
  {
    id: "1410",
    sura: "10",
    VerseIDAr: "46",
    ayatAR:
      "وَإِمَّا نُرِيَنَّكَ بَعْضَ الَّذِي نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِلَيْنَا مَرْجِعُهُمْ ثُمَّ اللَّهُ شَهِيدٌ عَلَىٰ مَا يَفْعَلُونَ",
  },
  {
    id: "1411",
    sura: "10",
    VerseIDAr: "47",
    ayatAR:
      "وَلِكُلِّ أُمَّةٍ رَسُولٌ ۖ فَإِذَا جَاءَ رَسُولُهُمْ قُضِيَ بَيْنَهُمْ بِالْقِسْطِ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "1412",
    sura: "10",
    VerseIDAr: "48",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "1413",
    sura: "10",
    VerseIDAr: "49",
    ayatAR:
      "قُلْ لَا أَمْلِكُ لِنَفْسِي ضَرًّا وَلَا نَفْعًا إِلَّا مَا شَاءَ اللَّهُ ۗ لِكُلِّ أُمَّةٍ أَجَلٌ ۚ إِذَا جَاءَ أَجَلُهُمْ فَلَا يَسْتَأْخِرُونَ سَاعَةً ۖ وَلَا يَسْتَقْدِمُونَ",
  },
  {
    id: "1414",
    sura: "10",
    VerseIDAr: "50",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ أَتَاكُمْ عَذَابُهُ بَيَاتًا أَوْ نَهَارًا مَاذَا يَسْتَعْجِلُ مِنْهُ الْمُجْرِمُونَ",
  },
  {
    id: "1415",
    sura: "10",
    VerseIDAr: "51",
    ayatAR:
      "أَثُمَّ إِذَا مَا وَقَعَ آمَنْتُمْ بِهِ ۚ آلْآنَ وَقَدْ كُنْتُمْ بِهِ تَسْتَعْجِلُونَ",
  },
  {
    id: "1416",
    sura: "10",
    VerseIDAr: "52",
    ayatAR:
      "ثُمَّ قِيلَ لِلَّذِينَ ظَلَمُوا ذُوقُوا عَذَابَ الْخُلْدِ هَلْ تُجْزَوْنَ إِلَّا بِمَا كُنْتُمْ تَكْسِبُونَ",
  },
  {
    id: "1417",
    sura: "10",
    VerseIDAr: "53",
    ayatAR:
      "وَيَسْتَنْبِئُونَكَ أَحَقٌّ هُوَ ۖ قُلْ إِي وَرَبِّي إِنَّهُ لَحَقٌّ ۖ وَمَا أَنْتُمْ بِمُعْجِزِينَ",
  },
  {
    id: "1418",
    sura: "10",
    VerseIDAr: "54",
    ayatAR:
      "وَلَوْ أَنَّ لِكُلِّ نَفْسٍ ظَلَمَتْ مَا فِي الْأَرْضِ لَافْتَدَتْ بِهِ ۗ وَأَسَرُّوا النَّدَامَةَ لَمَّا رَأَوُا الْعَذَابَ ۖ وَقُضِيَ بَيْنَهُمْ بِالْقِسْطِ ۚ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "1419",
    sura: "10",
    VerseIDAr: "55",
    ayatAR:
      "أَلَا إِنَّ لِلَّهِ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۗ أَلَا إِنَّ وَعْدَ اللَّهِ حَقٌّ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "1420",
    sura: "10",
    VerseIDAr: "56",
    ayatAR: "هُوَ يُحْيِي وَيُمِيتُ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "1421",
    sura: "10",
    VerseIDAr: "57",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ قَدْ جَاءَتْكُمْ مَوْعِظَةٌ مِنْ رَبِّكُمْ وَشِفَاءٌ لِمَا فِي الصُّدُورِ وَهُدًى وَرَحْمَةٌ لِلْمُؤْمِنِينَ",
  },
  {
    id: "1422",
    sura: "10",
    VerseIDAr: "58",
    ayatAR:
      "قُلْ بِفَضْلِ اللَّهِ وَبِرَحْمَتِهِ فَبِذَٰلِكَ فَلْيَفْرَحُوا هُوَ خَيْرٌ مِمَّا يَجْمَعُونَ",
  },
  {
    id: "1423",
    sura: "10",
    VerseIDAr: "59",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ مَا أَنْزَلَ اللَّهُ لَكُمْ مِنْ رِزْقٍ فَجَعَلْتُمْ مِنْهُ حَرَامًا وَحَلَالًا قُلْ آللَّهُ أَذِنَ لَكُمْ ۖ أَمْ عَلَى اللَّهِ تَفْتَرُونَ",
  },
  {
    id: "1424",
    sura: "10",
    VerseIDAr: "60",
    ayatAR:
      "وَمَا ظَنُّ الَّذِينَ يَفْتَرُونَ عَلَى اللَّهِ الْكَذِبَ يَوْمَ الْقِيَامَةِ ۗ إِنَّ اللَّهَ لَذُو فَضْلٍ عَلَى النَّاسِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَشْكُرُونَ",
  },
  {
    id: "1425",
    sura: "10",
    VerseIDAr: "61",
    ayatAR:
      "وَمَا تَكُونُ فِي شَأْنٍ وَمَا تَتْلُو مِنْهُ مِنْ قُرْآنٍ وَلَا تَعْمَلُونَ مِنْ عَمَلٍ إِلَّا كُنَّا عَلَيْكُمْ شُهُودًا إِذْ تُفِيضُونَ فِيهِ ۚ وَمَا يَعْزُبُ عَنْ رَبِّكَ مِنْ مِثْقَالِ ذَرَّةٍ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ وَلَا أَصْغَرَ مِنْ ذَٰلِكَ وَلَا أَكْبَرَ إِلَّا فِي كِتَابٍ مُبِينٍ",
  },
  {
    id: "1426",
    sura: "10",
    VerseIDAr: "62",
    ayatAR:
      "أَلَا إِنَّ أَوْلِيَاءَ اللَّهِ لَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "1427",
    sura: "10",
    VerseIDAr: "63",
    ayatAR: "الَّذِينَ آمَنُوا وَكَانُوا يَتَّقُونَ",
  },
  {
    id: "1428",
    sura: "10",
    VerseIDAr: "64",
    ayatAR:
      "لَهُمُ الْبُشْرَىٰ فِي الْحَيَاةِ الدُّنْيَا وَفِي الْآخِرَةِ ۚ لَا تَبْدِيلَ لِكَلِمَاتِ اللَّهِ ۚ ذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "1429",
    sura: "10",
    VerseIDAr: "65",
    ayatAR:
      "وَلَا يَحْزُنْكَ قَوْلُهُمْ ۘ إِنَّ الْعِزَّةَ لِلَّهِ جَمِيعًا ۚ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "1430",
    sura: "10",
    VerseIDAr: "66",
    ayatAR:
      "أَلَا إِنَّ لِلَّهِ مَنْ فِي السَّمَاوَاتِ وَمَنْ فِي الْأَرْضِ ۗ وَمَا يَتَّبِعُ الَّذِينَ يَدْعُونَ مِنْ دُونِ اللَّهِ شُرَكَاءَ ۚ إِنْ يَتَّبِعُونَ إِلَّا الظَّنَّ وَإِنْ هُمْ إِلَّا يَخْرُصُونَ",
  },
  {
    id: "1431",
    sura: "10",
    VerseIDAr: "67",
    ayatAR:
      "هُوَ الَّذِي جَعَلَ لَكُمُ اللَّيْلَ لِتَسْكُنُوا فِيهِ وَالنَّهَارَ مُبْصِرًا ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَسْمَعُونَ",
  },
  {
    id: "1432",
    sura: "10",
    VerseIDAr: "68",
    ayatAR:
      "قَالُوا اتَّخَذَ اللَّهُ وَلَدًا ۗ سُبْحَانَهُ ۖ هُوَ الْغَنِيُّ ۖ لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ إِنْ عِنْدَكُمْ مِنْ سُلْطَانٍ بِهَٰذَا ۚ أَتَقُولُونَ عَلَى اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "1433",
    sura: "10",
    VerseIDAr: "69",
    ayatAR:
      "قُلْ إِنَّ الَّذِينَ يَفْتَرُونَ عَلَى اللَّهِ الْكَذِبَ لَا يُفْلِحُونَ",
  },
  {
    id: "1434",
    sura: "10",
    VerseIDAr: "70",
    ayatAR:
      "مَتَاعٌ فِي الدُّنْيَا ثُمَّ إِلَيْنَا مَرْجِعُهُمْ ثُمَّ نُذِيقُهُمُ الْعَذَابَ الشَّدِيدَ بِمَا كَانُوا يَكْفُرُونَ",
  },
  {
    id: "1435",
    sura: "10",
    VerseIDAr: "71",
    ayatAR:
      "وَاتْلُ عَلَيْهِمْ نَبَأَ نُوحٍ إِذْ قَالَ لِقَوْمِهِ يَا قَوْمِ إِنْ كَانَ كَبُرَ عَلَيْكُمْ مَقَامِي وَتَذْكِيرِي بِآيَاتِ اللَّهِ فَعَلَى اللَّهِ تَوَكَّلْتُ فَأَجْمِعُوا أَمْرَكُمْ وَشُرَكَاءَكُمْ ثُمَّ لَا يَكُنْ أَمْرُكُمْ عَلَيْكُمْ غُمَّةً ثُمَّ اقْضُوا إِلَيَّ وَلَا تُنْظِرُونِ",
  },
  {
    id: "1436",
    sura: "10",
    VerseIDAr: "72",
    ayatAR:
      "فَإِنْ تَوَلَّيْتُمْ فَمَا سَأَلْتُكُمْ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَى اللَّهِ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "1437",
    sura: "10",
    VerseIDAr: "73",
    ayatAR:
      "فَكَذَّبُوهُ فَنَجَّيْنَاهُ وَمَنْ مَعَهُ فِي الْفُلْكِ وَجَعَلْنَاهُمْ خَلَائِفَ وَأَغْرَقْنَا الَّذِينَ كَذَّبُوا بِآيَاتِنَا ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُنْذَرِينَ",
  },
  {
    id: "1438",
    sura: "10",
    VerseIDAr: "74",
    ayatAR:
      "ثُمَّ بَعَثْنَا مِنْ بَعْدِهِ رُسُلًا إِلَىٰ قَوْمِهِمْ فَجَاءُوهُمْ بِالْبَيِّنَاتِ فَمَا كَانُوا لِيُؤْمِنُوا بِمَا كَذَّبُوا بِهِ مِنْ قَبْلُ ۚ كَذَٰلِكَ نَطْبَعُ عَلَىٰ قُلُوبِ الْمُعْتَدِينَ",
  },
  {
    id: "1439",
    sura: "10",
    VerseIDAr: "75",
    ayatAR:
      "ثُمَّ بَعَثْنَا مِنْ بَعْدِهِمْ مُوسَىٰ وَهَارُونَ إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ بِآيَاتِنَا فَاسْتَكْبَرُوا وَكَانُوا قَوْمًا مُجْرِمِينَ",
  },
  {
    id: "1440",
    sura: "10",
    VerseIDAr: "76",
    ayatAR:
      "فَلَمَّا جَاءَهُمُ الْحَقُّ مِنْ عِنْدِنَا قَالُوا إِنَّ هَٰذَا لَسِحْرٌ مُبِينٌ",
  },
  {
    id: "1441",
    sura: "10",
    VerseIDAr: "77",
    ayatAR:
      "قَالَ مُوسَىٰ أَتَقُولُونَ لِلْحَقِّ لَمَّا جَاءَكُمْ ۖ أَسِحْرٌ هَٰذَا وَلَا يُفْلِحُ السَّاحِرُونَ",
  },
  {
    id: "1442",
    sura: "10",
    VerseIDAr: "78",
    ayatAR:
      "قَالُوا أَجِئْتَنَا لِتَلْفِتَنَا عَمَّا وَجَدْنَا عَلَيْهِ آبَاءَنَا وَتَكُونَ لَكُمَا الْكِبْرِيَاءُ فِي الْأَرْضِ وَمَا نَحْنُ لَكُمَا بِمُؤْمِنِينَ",
  },
  {
    id: "1443",
    sura: "10",
    VerseIDAr: "79",
    ayatAR: "وَقَالَ فِرْعَوْنُ ائْتُونِي بِكُلِّ سَاحِرٍ عَلِيمٍ",
  },
  {
    id: "1444",
    sura: "10",
    VerseIDAr: "80",
    ayatAR:
      "فَلَمَّا جَاءَ السَّحَرَةُ قَالَ لَهُمْ مُوسَىٰ أَلْقُوا مَا أَنْتُمْ مُلْقُونَ",
  },
  {
    id: "1445",
    sura: "10",
    VerseIDAr: "81",
    ayatAR:
      "فَلَمَّا أَلْقَوْا قَالَ مُوسَىٰ مَا جِئْتُمْ بِهِ السِّحْرُ ۖ إِنَّ اللَّهَ سَيُبْطِلُهُ ۖ إِنَّ اللَّهَ لَا يُصْلِحُ عَمَلَ الْمُفْسِدِينَ",
  },
  {
    id: "1446",
    sura: "10",
    VerseIDAr: "82",
    ayatAR:
      "وَيُحِقُّ اللَّهُ الْحَقَّ بِكَلِمَاتِهِ وَلَوْ كَرِهَ الْمُجْرِمُونَ",
  },
  {
    id: "1447",
    sura: "10",
    VerseIDAr: "83",
    ayatAR:
      "فَمَا آمَنَ لِمُوسَىٰ إِلَّا ذُرِّيَّةٌ مِنْ قَوْمِهِ عَلَىٰ خَوْفٍ مِنْ فِرْعَوْنَ وَمَلَئِهِمْ أَنْ يَفْتِنَهُمْ ۚ وَإِنَّ فِرْعَوْنَ لَعَالٍ فِي الْأَرْضِ وَإِنَّهُ لَمِنَ الْمُسْرِفِينَ",
  },
  {
    id: "1448",
    sura: "10",
    VerseIDAr: "84",
    ayatAR:
      "وَقَالَ مُوسَىٰ يَا قَوْمِ إِنْ كُنْتُمْ آمَنْتُمْ بِاللَّهِ فَعَلَيْهِ تَوَكَّلُوا إِنْ كُنْتُمْ مُسْلِمِينَ",
  },
  {
    id: "1449",
    sura: "10",
    VerseIDAr: "85",
    ayatAR:
      "فَقَالُوا عَلَى اللَّهِ تَوَكَّلْنَا رَبَّنَا لَا تَجْعَلْنَا فِتْنَةً لِلْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "1450",
    sura: "10",
    VerseIDAr: "86",
    ayatAR: "وَنَجِّنَا بِرَحْمَتِكَ مِنَ الْقَوْمِ الْكَافِرِينَ",
  },
  {
    id: "1451",
    sura: "10",
    VerseIDAr: "87",
    ayatAR:
      "وَأَوْحَيْنَا إِلَىٰ مُوسَىٰ وَأَخِيهِ أَنْ تَبَوَّآ لِقَوْمِكُمَا بِمِصْرَ بُيُوتًا وَاجْعَلُوا بُيُوتَكُمْ قِبْلَةً وَأَقِيمُوا الصَّلَاةَ ۗ وَبَشِّرِ الْمُؤْمِنِينَ",
  },
  {
    id: "1452",
    sura: "10",
    VerseIDAr: "88",
    ayatAR:
      "وَقَالَ مُوسَىٰ رَبَّنَا إِنَّكَ آتَيْتَ فِرْعَوْنَ وَمَلَأَهُ زِينَةً وَأَمْوَالًا فِي الْحَيَاةِ الدُّنْيَا رَبَّنَا لِيُضِلُّوا عَنْ سَبِيلِكَ ۖ رَبَّنَا اطْمِسْ عَلَىٰ أَمْوَالِهِمْ وَاشْدُدْ عَلَىٰ قُلُوبِهِمْ فَلَا يُؤْمِنُوا حَتَّىٰ يَرَوُا الْعَذَابَ الْأَلِيمَ",
  },
  {
    id: "1453",
    sura: "10",
    VerseIDAr: "89",
    ayatAR:
      "قَالَ قَدْ أُجِيبَتْ دَعْوَتُكُمَا فَاسْتَقِيمَا وَلَا تَتَّبِعَانِّ سَبِيلَ الَّذِينَ لَا يَعْلَمُونَ",
  },
  {
    id: "1454",
    sura: "10",
    VerseIDAr: "90",
    ayatAR:
      "وَجَاوَزْنَا بِبَنِي إِسْرَائِيلَ الْبَحْرَ فَأَتْبَعَهُمْ فِرْعَوْنُ وَجُنُودُهُ بَغْيًا وَعَدْوًا ۖ حَتَّىٰ إِذَا أَدْرَكَهُ الْغَرَقُ قَالَ آمَنْتُ أَنَّهُ لَا إِلَٰهَ إِلَّا الَّذِي آمَنَتْ بِهِ بَنُو إِسْرَائِيلَ وَأَنَا مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "1455",
    sura: "10",
    VerseIDAr: "91",
    ayatAR: "آلْآنَ وَقَدْ عَصَيْتَ قَبْلُ وَكُنْتَ مِنَ الْمُفْسِدِينَ",
  },
  {
    id: "1456",
    sura: "10",
    VerseIDAr: "92",
    ayatAR:
      "فَالْيَوْمَ نُنَجِّيكَ بِبَدَنِكَ لِتَكُونَ لِمَنْ خَلْفَكَ آيَةً ۚ وَإِنَّ كَثِيرًا مِنَ النَّاسِ عَنْ آيَاتِنَا لَغَافِلُونَ",
  },
  {
    id: "1457",
    sura: "10",
    VerseIDAr: "93",
    ayatAR:
      "وَلَقَدْ بَوَّأْنَا بَنِي إِسْرَائِيلَ مُبَوَّأَ صِدْقٍ وَرَزَقْنَاهُمْ مِنَ الطَّيِّبَاتِ فَمَا اخْتَلَفُوا حَتَّىٰ جَاءَهُمُ الْعِلْمُ ۚ إِنَّ رَبَّكَ يَقْضِي بَيْنَهُمْ يَوْمَ الْقِيَامَةِ فِيمَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "1458",
    sura: "10",
    VerseIDAr: "94",
    ayatAR:
      "فَإِنْ كُنْتَ فِي شَكٍّ مِمَّا أَنْزَلْنَا إِلَيْكَ فَاسْأَلِ الَّذِينَ يَقْرَءُونَ الْكِتَابَ مِنْ قَبْلِكَ ۚ لَقَدْ جَاءَكَ الْحَقُّ مِنْ رَبِّكَ فَلَا تَكُونَنَّ مِنَ الْمُمْتَرِينَ",
  },
  {
    id: "1459",
    sura: "10",
    VerseIDAr: "95",
    ayatAR:
      "وَلَا تَكُونَنَّ مِنَ الَّذِينَ كَذَّبُوا بِآيَاتِ اللَّهِ فَتَكُونَ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "1460",
    sura: "10",
    VerseIDAr: "96",
    ayatAR:
      "إِنَّ الَّذِينَ حَقَّتْ عَلَيْهِمْ كَلِمَتُ رَبِّكَ لَا يُؤْمِنُونَ",
  },
  {
    id: "1461",
    sura: "10",
    VerseIDAr: "97",
    ayatAR:
      "وَلَوْ جَاءَتْهُمْ كُلُّ آيَةٍ حَتَّىٰ يَرَوُا الْعَذَابَ الْأَلِيمَ",
  },
  {
    id: "1462",
    sura: "10",
    VerseIDAr: "98",
    ayatAR:
      "فَلَوْلَا كَانَتْ قَرْيَةٌ آمَنَتْ فَنَفَعَهَا إِيمَانُهَا إِلَّا قَوْمَ يُونُسَ لَمَّا آمَنُوا كَشَفْنَا عَنْهُمْ عَذَابَ الْخِزْيِ فِي الْحَيَاةِ الدُّنْيَا وَمَتَّعْنَاهُمْ إِلَىٰ حِينٍ",
  },
  {
    id: "1463",
    sura: "10",
    VerseIDAr: "99",
    ayatAR:
      "وَلَوْ شَاءَ رَبُّكَ لَآمَنَ مَنْ فِي الْأَرْضِ كُلُّهُمْ جَمِيعًا ۚ أَفَأَنْتَ تُكْرِهُ النَّاسَ حَتَّىٰ يَكُونُوا مُؤْمِنِينَ",
  },
  {
    id: "1464",
    sura: "10",
    VerseIDAr: "100",
    ayatAR:
      "وَمَا كَانَ لِنَفْسٍ أَنْ تُؤْمِنَ إِلَّا بِإِذْنِ اللَّهِ ۚ وَيَجْعَلُ الرِّجْسَ عَلَى الَّذِينَ لَا يَعْقِلُونَ",
  },
  {
    id: "1465",
    sura: "10",
    VerseIDAr: "101",
    ayatAR:
      "قُلِ انْظُرُوا مَاذَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ وَمَا تُغْنِي الْآيَاتُ وَالنُّذُرُ عَنْ قَوْمٍ لَا يُؤْمِنُونَ",
  },
  {
    id: "1466",
    sura: "10",
    VerseIDAr: "102",
    ayatAR:
      "فَهَلْ يَنْتَظِرُونَ إِلَّا مِثْلَ أَيَّامِ الَّذِينَ خَلَوْا مِنْ قَبْلِهِمْ ۚ قُلْ فَانْتَظِرُوا إِنِّي مَعَكُمْ مِنَ الْمُنْتَظِرِينَ",
  },
  {
    id: "1467",
    sura: "10",
    VerseIDAr: "103",
    ayatAR:
      "ثُمَّ نُنَجِّي رُسُلَنَا وَالَّذِينَ آمَنُوا ۚ كَذَٰلِكَ حَقًّا عَلَيْنَا نُنْجِ الْمُؤْمِنِينَ",
  },
  {
    id: "1468",
    sura: "10",
    VerseIDAr: "104",
    ayatAR:
      "قُلْ يَا أَيُّهَا النَّاسُ إِنْ كُنْتُمْ فِي شَكٍّ مِنْ دِينِي فَلَا أَعْبُدُ الَّذِينَ تَعْبُدُونَ مِنْ دُونِ اللَّهِ وَلَٰكِنْ أَعْبُدُ اللَّهَ الَّذِي يَتَوَفَّاكُمْ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "1469",
    sura: "10",
    VerseIDAr: "105",
    ayatAR:
      "وَأَنْ أَقِمْ وَجْهَكَ لِلدِّينِ حَنِيفًا وَلَا تَكُونَنَّ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "1470",
    sura: "10",
    VerseIDAr: "106",
    ayatAR:
      "وَلَا تَدْعُ مِنْ دُونِ اللَّهِ مَا لَا يَنْفَعُكَ وَلَا يَضُرُّكَ ۖ فَإِنْ فَعَلْتَ فَإِنَّكَ إِذًا مِنَ الظَّالِمِينَ",
  },
  {
    id: "1471",
    sura: "10",
    VerseIDAr: "107",
    ayatAR:
      "وَإِنْ يَمْسَسْكَ اللَّهُ بِضُرٍّ فَلَا كَاشِفَ لَهُ إِلَّا هُوَ ۖ وَإِنْ يُرِدْكَ بِخَيْرٍ فَلَا رَادَّ لِفَضْلِهِ ۚ يُصِيبُ بِهِ مَنْ يَشَاءُ مِنْ عِبَادِهِ ۚ وَهُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "1472",
    sura: "10",
    VerseIDAr: "108",
    ayatAR:
      "قُلْ يَا أَيُّهَا النَّاسُ قَدْ جَاءَكُمُ الْحَقُّ مِنْ رَبِّكُمْ ۖ فَمَنِ اهْتَدَىٰ فَإِنَّمَا يَهْتَدِي لِنَفْسِهِ ۖ وَمَنْ ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۖ وَمَا أَنَا عَلَيْكُمْ بِوَكِيلٍ",
  },
  {
    id: "1473",
    sura: "10",
    VerseIDAr: "109",
    ayatAR:
      "وَاتَّبِعْ مَا يُوحَىٰ إِلَيْكَ وَاصْبِرْ حَتَّىٰ يَحْكُمَ اللَّهُ ۚ وَهُوَ خَيْرُ الْحَاكِمِينَ",
  },
  {
    id: "1474",
    sura: "11",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الر ۚ كِتَابٌ أُحْكِمَتْ آيَاتُهُ ثُمَّ فُصِّلَتْ مِنْ لَدُنْ حَكِيمٍ خَبِيرٍ",
  },
  {
    id: "1475",
    sura: "11",
    VerseIDAr: "2",
    ayatAR:
      "أَلَّا تَعْبُدُوا إِلَّا اللَّهَ ۚ إِنَّنِي لَكُمْ مِنْهُ نَذِيرٌ وَبَشِيرٌ",
  },
  {
    id: "1476",
    sura: "11",
    VerseIDAr: "3",
    ayatAR:
      "وَأَنِ اسْتَغْفِرُوا رَبَّكُمْ ثُمَّ تُوبُوا إِلَيْهِ يُمَتِّعْكُمْ مَتَاعًا حَسَنًا إِلَىٰ أَجَلٍ مُسَمًّى وَيُؤْتِ كُلَّ ذِي فَضْلٍ فَضْلَهُ ۖ وَإِنْ تَوَلَّوْا فَإِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ كَبِيرٍ",
  },
  {
    id: "1477",
    sura: "11",
    VerseIDAr: "4",
    ayatAR: "إِلَى اللَّهِ مَرْجِعُكُمْ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "1478",
    sura: "11",
    VerseIDAr: "5",
    ayatAR:
      "أَلَا إِنَّهُمْ يَثْنُونَ صُدُورَهُمْ لِيَسْتَخْفُوا مِنْهُ ۚ أَلَا حِينَ يَسْتَغْشُونَ ثِيَابَهُمْ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ ۚ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "1479",
    sura: "11",
    VerseIDAr: "6",
    ayatAR:
      "وَمَا مِنْ دَابَّةٍ فِي الْأَرْضِ إِلَّا عَلَى اللَّهِ رِزْقُهَا وَيَعْلَمُ مُسْتَقَرَّهَا وَمُسْتَوْدَعَهَا ۚ كُلٌّ فِي كِتَابٍ مُبِينٍ",
  },
  {
    id: "1480",
    sura: "11",
    VerseIDAr: "7",
    ayatAR:
      "وَهُوَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ فِي سِتَّةِ أَيَّامٍ وَكَانَ عَرْشُهُ عَلَى الْمَاءِ لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًا ۗ وَلَئِنْ قُلْتَ إِنَّكُمْ مَبْعُوثُونَ مِنْ بَعْدِ الْمَوْتِ لَيَقُولَنَّ الَّذِينَ كَفَرُوا إِنْ هَٰذَا إِلَّا سِحْرٌ مُبِينٌ",
  },
  {
    id: "1481",
    sura: "11",
    VerseIDAr: "8",
    ayatAR:
      "وَلَئِنْ أَخَّرْنَا عَنْهُمُ الْعَذَابَ إِلَىٰ أُمَّةٍ مَعْدُودَةٍ لَيَقُولُنَّ مَا يَحْبِسُهُ ۗ أَلَا يَوْمَ يَأْتِيهِمْ لَيْسَ مَصْرُوفًا عَنْهُمْ وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "1482",
    sura: "11",
    VerseIDAr: "9",
    ayatAR:
      "وَلَئِنْ أَذَقْنَا الْإِنْسَانَ مِنَّا رَحْمَةً ثُمَّ نَزَعْنَاهَا مِنْهُ إِنَّهُ لَيَئُوسٌ كَفُورٌ",
  },
  {
    id: "1483",
    sura: "11",
    VerseIDAr: "10",
    ayatAR:
      "وَلَئِنْ أَذَقْنَاهُ نَعْمَاءَ بَعْدَ ضَرَّاءَ مَسَّتْهُ لَيَقُولَنَّ ذَهَبَ السَّيِّئَاتُ عَنِّي ۚ إِنَّهُ لَفَرِحٌ فَخُورٌ",
  },
  {
    id: "1484",
    sura: "11",
    VerseIDAr: "11",
    ayatAR:
      "إِلَّا الَّذِينَ صَبَرُوا وَعَمِلُوا الصَّالِحَاتِ أُولَٰئِكَ لَهُمْ مَغْفِرَةٌ وَأَجْرٌ كَبِيرٌ",
  },
  {
    id: "1485",
    sura: "11",
    VerseIDAr: "12",
    ayatAR:
      "فَلَعَلَّكَ تَارِكٌ بَعْضَ مَا يُوحَىٰ إِلَيْكَ وَضَائِقٌ بِهِ صَدْرُكَ أَنْ يَقُولُوا لَوْلَا أُنْزِلَ عَلَيْهِ كَنْزٌ أَوْ جَاءَ مَعَهُ مَلَكٌ ۚ إِنَّمَا أَنْتَ نَذِيرٌ ۚ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ وَكِيلٌ",
  },
  {
    id: "1486",
    sura: "11",
    VerseIDAr: "13",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَاهُ ۖ قُلْ فَأْتُوا بِعَشْرِ سُوَرٍ مِثْلِهِ مُفْتَرَيَاتٍ وَادْعُوا مَنِ اسْتَطَعْتُمْ مِنْ دُونِ اللَّهِ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "1487",
    sura: "11",
    VerseIDAr: "14",
    ayatAR:
      "فَإِلَّمْ يَسْتَجِيبُوا لَكُمْ فَاعْلَمُوا أَنَّمَا أُنْزِلَ بِعِلْمِ اللَّهِ وَأَنْ لَا إِلَٰهَ إِلَّا هُوَ ۖ فَهَلْ أَنْتُمْ مُسْلِمُونَ",
  },
  {
    id: "1488",
    sura: "11",
    VerseIDAr: "15",
    ayatAR:
      "مَنْ كَانَ يُرِيدُ الْحَيَاةَ الدُّنْيَا وَزِينَتَهَا نُوَفِّ إِلَيْهِمْ أَعْمَالَهُمْ فِيهَا وَهُمْ فِيهَا لَا يُبْخَسُونَ",
  },
  {
    id: "1489",
    sura: "11",
    VerseIDAr: "16",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ لَيْسَ لَهُمْ فِي الْآخِرَةِ إِلَّا النَّارُ ۖ وَحَبِطَ مَا صَنَعُوا فِيهَا وَبَاطِلٌ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1490",
    sura: "11",
    VerseIDAr: "17",
    ayatAR:
      "أَفَمَنْ كَانَ عَلَىٰ بَيِّنَةٍ مِنْ رَبِّهِ وَيَتْلُوهُ شَاهِدٌ مِنْهُ وَمِنْ قَبْلِهِ كِتَابُ مُوسَىٰ إِمَامًا وَرَحْمَةً ۚ أُولَٰئِكَ يُؤْمِنُونَ بِهِ ۚ وَمَنْ يَكْفُرْ بِهِ مِنَ الْأَحْزَابِ فَالنَّارُ مَوْعِدُهُ ۚ فَلَا تَكُ فِي مِرْيَةٍ مِنْهُ ۚ إِنَّهُ الْحَقُّ مِنْ رَبِّكَ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يُؤْمِنُونَ",
  },
  {
    id: "1491",
    sura: "11",
    VerseIDAr: "18",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا ۚ أُولَٰئِكَ يُعْرَضُونَ عَلَىٰ رَبِّهِمْ وَيَقُولُ الْأَشْهَادُ هَٰؤُلَاءِ الَّذِينَ كَذَبُوا عَلَىٰ رَبِّهِمْ ۚ أَلَا لَعْنَةُ اللَّهِ عَلَى الظَّالِمِينَ",
  },
  {
    id: "1492",
    sura: "11",
    VerseIDAr: "19",
    ayatAR:
      "الَّذِينَ يَصُدُّونَ عَنْ سَبِيلِ اللَّهِ وَيَبْغُونَهَا عِوَجًا وَهُمْ بِالْآخِرَةِ هُمْ كَافِرُونَ",
  },
  {
    id: "1493",
    sura: "11",
    VerseIDAr: "20",
    ayatAR:
      "أُولَٰئِكَ لَمْ يَكُونُوا مُعْجِزِينَ فِي الْأَرْضِ وَمَا كَانَ لَهُمْ مِنْ دُونِ اللَّهِ مِنْ أَوْلِيَاءَ ۘ يُضَاعَفُ لَهُمُ الْعَذَابُ ۚ مَا كَانُوا يَسْتَطِيعُونَ السَّمْعَ وَمَا كَانُوا يُبْصِرُونَ",
  },
  {
    id: "1494",
    sura: "11",
    VerseIDAr: "21",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "1495",
    sura: "11",
    VerseIDAr: "22",
    ayatAR: "لَا جَرَمَ أَنَّهُمْ فِي الْآخِرَةِ هُمُ الْأَخْسَرُونَ",
  },
  {
    id: "1496",
    sura: "11",
    VerseIDAr: "23",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَأَخْبَتُوا إِلَىٰ رَبِّهِمْ أُولَٰئِكَ أَصْحَابُ الْجَنَّةِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "1497",
    sura: "11",
    VerseIDAr: "24",
    ayatAR:
      "مَثَلُ الْفَرِيقَيْنِ كَالْأَعْمَىٰ وَالْأَصَمِّ وَالْبَصِيرِ وَالسَّمِيعِ ۚ هَلْ يَسْتَوِيَانِ مَثَلًا ۚ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "1498",
    sura: "11",
    VerseIDAr: "25",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِ إِنِّي لَكُمْ نَذِيرٌ مُبِينٌ",
  },
  {
    id: "1499",
    sura: "11",
    VerseIDAr: "26",
    ayatAR:
      "أَنْ لَا تَعْبُدُوا إِلَّا اللَّهَ ۖ إِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ أَلِيمٍ",
  },
  {
    id: "1500",
    sura: "11",
    VerseIDAr: "27",
    ayatAR:
      "فَقَالَ الْمَلَأُ الَّذِينَ كَفَرُوا مِنْ قَوْمِهِ مَا نَرَاكَ إِلَّا بَشَرًا مِثْلَنَا وَمَا نَرَاكَ اتَّبَعَكَ إِلَّا الَّذِينَ هُمْ أَرَاذِلُنَا بَادِيَ الرَّأْيِ وَمَا نَرَىٰ لَكُمْ عَلَيْنَا مِنْ فَضْلٍ بَلْ نَظُنُّكُمْ كَاذِبِينَ",
  },
  {
    id: "1501",
    sura: "11",
    VerseIDAr: "28",
    ayatAR:
      "قَالَ يَا قَوْمِ أَرَأَيْتُمْ إِنْ كُنْتُ عَلَىٰ بَيِّنَةٍ مِنْ رَبِّي وَآتَانِي رَحْمَةً مِنْ عِنْدِهِ فَعُمِّيَتْ عَلَيْكُمْ أَنُلْزِمُكُمُوهَا وَأَنْتُمْ لَهَا كَارِهُونَ",
  },
  {
    id: "1502",
    sura: "11",
    VerseIDAr: "29",
    ayatAR:
      "وَيَا قَوْمِ لَا أَسْأَلُكُمْ عَلَيْهِ مَالًا ۖ إِنْ أَجْرِيَ إِلَّا عَلَى اللَّهِ ۚ وَمَا أَنَا بِطَارِدِ الَّذِينَ آمَنُوا ۚ إِنَّهُمْ مُلَاقُو رَبِّهِمْ وَلَٰكِنِّي أَرَاكُمْ قَوْمًا تَجْهَلُونَ",
  },
  {
    id: "1503",
    sura: "11",
    VerseIDAr: "30",
    ayatAR:
      "وَيَا قَوْمِ مَنْ يَنْصُرُنِي مِنَ اللَّهِ إِنْ طَرَدْتُهُمْ ۚ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "1504",
    sura: "11",
    VerseIDAr: "31",
    ayatAR:
      "وَلَا أَقُولُ لَكُمْ عِنْدِي خَزَائِنُ اللَّهِ وَلَا أَعْلَمُ الْغَيْبَ وَلَا أَقُولُ إِنِّي مَلَكٌ وَلَا أَقُولُ لِلَّذِينَ تَزْدَرِي أَعْيُنُكُمْ لَنْ يُؤْتِيَهُمُ اللَّهُ خَيْرًا ۖ اللَّهُ أَعْلَمُ بِمَا فِي أَنْفُسِهِمْ ۖ إِنِّي إِذًا لَمِنَ الظَّالِمِينَ",
  },
  {
    id: "1505",
    sura: "11",
    VerseIDAr: "32",
    ayatAR:
      "قَالُوا يَا نُوحُ قَدْ جَادَلْتَنَا فَأَكْثَرْتَ جِدَالَنَا فَأْتِنَا بِمَا تَعِدُنَا إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "1506",
    sura: "11",
    VerseIDAr: "33",
    ayatAR:
      "قَالَ إِنَّمَا يَأْتِيكُمْ بِهِ اللَّهُ إِنْ شَاءَ وَمَا أَنْتُمْ بِمُعْجِزِينَ",
  },
  {
    id: "1507",
    sura: "11",
    VerseIDAr: "34",
    ayatAR:
      "وَلَا يَنْفَعُكُمْ نُصْحِي إِنْ أَرَدْتُ أَنْ أَنْصَحَ لَكُمْ إِنْ كَانَ اللَّهُ يُرِيدُ أَنْ يُغْوِيَكُمْ ۚ هُوَ رَبُّكُمْ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "1508",
    sura: "11",
    VerseIDAr: "35",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَاهُ ۖ قُلْ إِنِ افْتَرَيْتُهُ فَعَلَيَّ إِجْرَامِي وَأَنَا بَرِيءٌ مِمَّا تُجْرِمُونَ",
  },
  {
    id: "1509",
    sura: "11",
    VerseIDAr: "36",
    ayatAR:
      "وَأُوحِيَ إِلَىٰ نُوحٍ أَنَّهُ لَنْ يُؤْمِنَ مِنْ قَوْمِكَ إِلَّا مَنْ قَدْ آمَنَ فَلَا تَبْتَئِسْ بِمَا كَانُوا يَفْعَلُونَ",
  },
  {
    id: "1510",
    sura: "11",
    VerseIDAr: "37",
    ayatAR:
      "وَاصْنَعِ الْفُلْكَ بِأَعْيُنِنَا وَوَحْيِنَا وَلَا تُخَاطِبْنِي فِي الَّذِينَ ظَلَمُوا ۚ إِنَّهُمْ مُغْرَقُونَ",
  },
  {
    id: "1511",
    sura: "11",
    VerseIDAr: "38",
    ayatAR:
      "وَيَصْنَعُ الْفُلْكَ وَكُلَّمَا مَرَّ عَلَيْهِ مَلَأٌ مِنْ قَوْمِهِ سَخِرُوا مِنْهُ ۚ قَالَ إِنْ تَسْخَرُوا مِنَّا فَإِنَّا نَسْخَرُ مِنْكُمْ كَمَا تَسْخَرُونَ",
  },
  {
    id: "1512",
    sura: "11",
    VerseIDAr: "39",
    ayatAR:
      "فَسَوْفَ تَعْلَمُونَ مَنْ يَأْتِيهِ عَذَابٌ يُخْزِيهِ وَيَحِلُّ عَلَيْهِ عَذَابٌ مُقِيمٌ",
  },
  {
    id: "1513",
    sura: "11",
    VerseIDAr: "40",
    ayatAR:
      "حَتَّىٰ إِذَا جَاءَ أَمْرُنَا وَفَارَ التَّنُّورُ قُلْنَا احْمِلْ فِيهَا مِنْ كُلٍّ زَوْجَيْنِ اثْنَيْنِ وَأَهْلَكَ إِلَّا مَنْ سَبَقَ عَلَيْهِ الْقَوْلُ وَمَنْ آمَنَ ۚ وَمَا آمَنَ مَعَهُ إِلَّا قَلِيلٌ",
  },
  {
    id: "1514",
    sura: "11",
    VerseIDAr: "41",
    ayatAR:
      "وَقَالَ ارْكَبُوا فِيهَا بِسْمِ اللَّهِ مَجْرَاهَا وَمُرْسَاهَا ۚ إِنَّ رَبِّي لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "1515",
    sura: "11",
    VerseIDAr: "42",
    ayatAR:
      "وَهِيَ تَجْرِي بِهِمْ فِي مَوْجٍ كَالْجِبَالِ وَنَادَىٰ نُوحٌ ابْنَهُ وَكَانَ فِي مَعْزِلٍ يَا بُنَيَّ ارْكَبْ مَعَنَا وَلَا تَكُنْ مَعَ الْكَافِرِينَ",
  },
  {
    id: "1516",
    sura: "11",
    VerseIDAr: "43",
    ayatAR:
      "قَالَ سَآوِي إِلَىٰ جَبَلٍ يَعْصِمُنِي مِنَ الْمَاءِ ۚ قَالَ لَا عَاصِمَ الْيَوْمَ مِنْ أَمْرِ اللَّهِ إِلَّا مَنْ رَحِمَ ۚ وَحَالَ بَيْنَهُمَا الْمَوْجُ فَكَانَ مِنَ الْمُغْرَقِينَ",
  },
  {
    id: "1517",
    sura: "11",
    VerseIDAr: "44",
    ayatAR:
      "وَقِيلَ يَا أَرْضُ ابْلَعِي مَاءَكِ وَيَا سَمَاءُ أَقْلِعِي وَغِيضَ الْمَاءُ وَقُضِيَ الْأَمْرُ وَاسْتَوَتْ عَلَى الْجُودِيِّ ۖ وَقِيلَ بُعْدًا لِلْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "1518",
    sura: "11",
    VerseIDAr: "45",
    ayatAR:
      "وَنَادَىٰ نُوحٌ رَبَّهُ فَقَالَ رَبِّ إِنَّ ابْنِي مِنْ أَهْلِي وَإِنَّ وَعْدَكَ الْحَقُّ وَأَنْتَ أَحْكَمُ الْحَاكِمِينَ",
  },
  {
    id: "1519",
    sura: "11",
    VerseIDAr: "46",
    ayatAR:
      "قَالَ يَا نُوحُ إِنَّهُ لَيْسَ مِنْ أَهْلِكَ ۖ إِنَّهُ عَمَلٌ غَيْرُ صَالِحٍ ۖ فَلَا تَسْأَلْنِ مَا لَيْسَ لَكَ بِهِ عِلْمٌ ۖ إِنِّي أَعِظُكَ أَنْ تَكُونَ مِنَ الْجَاهِلِينَ",
  },
  {
    id: "1520",
    sura: "11",
    VerseIDAr: "47",
    ayatAR:
      "قَالَ رَبِّ إِنِّي أَعُوذُ بِكَ أَنْ أَسْأَلَكَ مَا لَيْسَ لِي بِهِ عِلْمٌ ۖ وَإِلَّا تَغْفِرْ لِي وَتَرْحَمْنِي أَكُنْ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "1521",
    sura: "11",
    VerseIDAr: "48",
    ayatAR:
      "قِيلَ يَا نُوحُ اهْبِطْ بِسَلَامٍ مِنَّا وَبَرَكَاتٍ عَلَيْكَ وَعَلَىٰ أُمَمٍ مِمَّنْ مَعَكَ ۚ وَأُمَمٌ سَنُمَتِّعُهُمْ ثُمَّ يَمَسُّهُمْ مِنَّا عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1522",
    sura: "11",
    VerseIDAr: "49",
    ayatAR:
      "تِلْكَ مِنْ أَنْبَاءِ الْغَيْبِ نُوحِيهَا إِلَيْكَ ۖ مَا كُنْتَ تَعْلَمُهَا أَنْتَ وَلَا قَوْمُكَ مِنْ قَبْلِ هَٰذَا ۖ فَاصْبِرْ ۖ إِنَّ الْعَاقِبَةَ لِلْمُتَّقِينَ",
  },
  {
    id: "1523",
    sura: "11",
    VerseIDAr: "50",
    ayatAR:
      "وَإِلَىٰ عَادٍ أَخَاهُمْ هُودًا ۚ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ إِنْ أَنْتُمْ إِلَّا مُفْتَرُونَ",
  },
  {
    id: "1524",
    sura: "11",
    VerseIDAr: "51",
    ayatAR:
      "يَا قَوْمِ لَا أَسْأَلُكُمْ عَلَيْهِ أَجْرًا ۖ إِنْ أَجْرِيَ إِلَّا عَلَى الَّذِي فَطَرَنِي ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "1525",
    sura: "11",
    VerseIDAr: "52",
    ayatAR:
      "وَيَا قَوْمِ اسْتَغْفِرُوا رَبَّكُمْ ثُمَّ تُوبُوا إِلَيْهِ يُرْسِلِ السَّمَاءَ عَلَيْكُمْ مِدْرَارًا وَيَزِدْكُمْ قُوَّةً إِلَىٰ قُوَّتِكُمْ وَلَا تَتَوَلَّوْا مُجْرِمِينَ",
  },
  {
    id: "1526",
    sura: "11",
    VerseIDAr: "53",
    ayatAR:
      "قَالُوا يَا هُودُ مَا جِئْتَنَا بِبَيِّنَةٍ وَمَا نَحْنُ بِتَارِكِي آلِهَتِنَا عَنْ قَوْلِكَ وَمَا نَحْنُ لَكَ بِمُؤْمِنِينَ",
  },
  {
    id: "1527",
    sura: "11",
    VerseIDAr: "54",
    ayatAR:
      "إِنْ نَقُولُ إِلَّا اعْتَرَاكَ بَعْضُ آلِهَتِنَا بِسُوءٍ ۗ قَالَ إِنِّي أُشْهِدُ اللَّهَ وَاشْهَدُوا أَنِّي بَرِيءٌ مِمَّا تُشْرِكُونَ",
  },
  {
    id: "1528",
    sura: "11",
    VerseIDAr: "55",
    ayatAR: "مِنْ دُونِهِ ۖ فَكِيدُونِي جَمِيعًا ثُمَّ لَا تُنْظِرُونِ",
  },
  {
    id: "1529",
    sura: "11",
    VerseIDAr: "56",
    ayatAR:
      "إِنِّي تَوَكَّلْتُ عَلَى اللَّهِ رَبِّي وَرَبِّكُمْ ۚ مَا مِنْ دَابَّةٍ إِلَّا هُوَ آخِذٌ بِنَاصِيَتِهَا ۚ إِنَّ رَبِّي عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "1530",
    sura: "11",
    VerseIDAr: "57",
    ayatAR:
      "فَإِنْ تَوَلَّوْا فَقَدْ أَبْلَغْتُكُمْ مَا أُرْسِلْتُ بِهِ إِلَيْكُمْ ۚ وَيَسْتَخْلِفُ رَبِّي قَوْمًا غَيْرَكُمْ وَلَا تَضُرُّونَهُ شَيْئًا ۚ إِنَّ رَبِّي عَلَىٰ كُلِّ شَيْءٍ حَفِيظٌ",
  },
  {
    id: "1531",
    sura: "11",
    VerseIDAr: "58",
    ayatAR:
      "وَلَمَّا جَاءَ أَمْرُنَا نَجَّيْنَا هُودًا وَالَّذِينَ آمَنُوا مَعَهُ بِرَحْمَةٍ مِنَّا وَنَجَّيْنَاهُمْ مِنْ عَذَابٍ غَلِيظٍ",
  },
  {
    id: "1532",
    sura: "11",
    VerseIDAr: "59",
    ayatAR:
      "وَتِلْكَ عَادٌ ۖ جَحَدُوا بِآيَاتِ رَبِّهِمْ وَعَصَوْا رُسُلَهُ وَاتَّبَعُوا أَمْرَ كُلِّ جَبَّارٍ عَنِيدٍ",
  },
  {
    id: "1533",
    sura: "11",
    VerseIDAr: "60",
    ayatAR:
      "وَأُتْبِعُوا فِي هَٰذِهِ الدُّنْيَا لَعْنَةً وَيَوْمَ الْقِيَامَةِ ۗ أَلَا إِنَّ عَادًا كَفَرُوا رَبَّهُمْ ۗ أَلَا بُعْدًا لِعَادٍ قَوْمِ هُودٍ",
  },
  {
    id: "1534",
    sura: "11",
    VerseIDAr: "61",
    ayatAR:
      "وَإِلَىٰ ثَمُودَ أَخَاهُمْ صَالِحًا ۚ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ هُوَ أَنْشَأَكُمْ مِنَ الْأَرْضِ وَاسْتَعْمَرَكُمْ فِيهَا فَاسْتَغْفِرُوهُ ثُمَّ تُوبُوا إِلَيْهِ ۚ إِنَّ رَبِّي قَرِيبٌ مُجِيبٌ",
  },
  {
    id: "1535",
    sura: "11",
    VerseIDAr: "62",
    ayatAR:
      "قَالُوا يَا صَالِحُ قَدْ كُنْتَ فِينَا مَرْجُوًّا قَبْلَ هَٰذَا ۖ أَتَنْهَانَا أَنْ نَعْبُدَ مَا يَعْبُدُ آبَاؤُنَا وَإِنَّنَا لَفِي شَكٍّ مِمَّا تَدْعُونَا إِلَيْهِ مُرِيبٍ",
  },
  {
    id: "1536",
    sura: "11",
    VerseIDAr: "63",
    ayatAR:
      "قَالَ يَا قَوْمِ أَرَأَيْتُمْ إِنْ كُنْتُ عَلَىٰ بَيِّنَةٍ مِنْ رَبِّي وَآتَانِي مِنْهُ رَحْمَةً فَمَنْ يَنْصُرُنِي مِنَ اللَّهِ إِنْ عَصَيْتُهُ ۖ فَمَا تَزِيدُونَنِي غَيْرَ تَخْسِيرٍ",
  },
  {
    id: "1537",
    sura: "11",
    VerseIDAr: "64",
    ayatAR:
      "وَيَا قَوْمِ هَٰذِهِ نَاقَةُ اللَّهِ لَكُمْ آيَةً فَذَرُوهَا تَأْكُلْ فِي أَرْضِ اللَّهِ وَلَا تَمَسُّوهَا بِسُوءٍ فَيَأْخُذَكُمْ عَذَابٌ قَرِيبٌ",
  },
  {
    id: "1538",
    sura: "11",
    VerseIDAr: "65",
    ayatAR:
      "فَعَقَرُوهَا فَقَالَ تَمَتَّعُوا فِي دَارِكُمْ ثَلَاثَةَ أَيَّامٍ ۖ ذَٰلِكَ وَعْدٌ غَيْرُ مَكْذُوبٍ",
  },
  {
    id: "1539",
    sura: "11",
    VerseIDAr: "66",
    ayatAR:
      "فَلَمَّا جَاءَ أَمْرُنَا نَجَّيْنَا صَالِحًا وَالَّذِينَ آمَنُوا مَعَهُ بِرَحْمَةٍ مِنَّا وَمِنْ خِزْيِ يَوْمِئِذٍ ۗ إِنَّ رَبَّكَ هُوَ الْقَوِيُّ الْعَزِيزُ",
  },
  {
    id: "1540",
    sura: "11",
    VerseIDAr: "67",
    ayatAR:
      "وَأَخَذَ الَّذِينَ ظَلَمُوا الصَّيْحَةُ فَأَصْبَحُوا فِي دِيَارِهِمْ جَاثِمِينَ",
  },
  {
    id: "1541",
    sura: "11",
    VerseIDAr: "68",
    ayatAR:
      "كَأَنْ لَمْ يَغْنَوْا فِيهَا ۗ أَلَا إِنَّ ثَمُودَ كَفَرُوا رَبَّهُمْ ۗ أَلَا بُعْدًا لِثَمُودَ",
  },
  {
    id: "1542",
    sura: "11",
    VerseIDAr: "69",
    ayatAR:
      "وَلَقَدْ جَاءَتْ رُسُلُنَا إِبْرَاهِيمَ بِالْبُشْرَىٰ قَالُوا سَلَامًا ۖ قَالَ سَلَامٌ ۖ فَمَا لَبِثَ أَنْ جَاءَ بِعِجْلٍ حَنِيذٍ",
  },
  {
    id: "1543",
    sura: "11",
    VerseIDAr: "70",
    ayatAR:
      "فَلَمَّا رَأَىٰ أَيْدِيَهُمْ لَا تَصِلُ إِلَيْهِ نَكِرَهُمْ وَأَوْجَسَ مِنْهُمْ خِيفَةً ۚ قَالُوا لَا تَخَفْ إِنَّا أُرْسِلْنَا إِلَىٰ قَوْمِ لُوطٍ",
  },
  {
    id: "1544",
    sura: "11",
    VerseIDAr: "71",
    ayatAR:
      "وَامْرَأَتُهُ قَائِمَةٌ فَضَحِكَتْ فَبَشَّرْنَاهَا بِإِسْحَاقَ وَمِنْ وَرَاءِ إِسْحَاقَ يَعْقُوبَ",
  },
  {
    id: "1545",
    sura: "11",
    VerseIDAr: "72",
    ayatAR:
      "قَالَتْ يَا وَيْلَتَىٰ أَأَلِدُ وَأَنَا عَجُوزٌ وَهَٰذَا بَعْلِي شَيْخًا ۖ إِنَّ هَٰذَا لَشَيْءٌ عَجِيبٌ",
  },
  {
    id: "1546",
    sura: "11",
    VerseIDAr: "73",
    ayatAR:
      "قَالُوا أَتَعْجَبِينَ مِنْ أَمْرِ اللَّهِ ۖ رَحْمَتُ اللَّهِ وَبَرَكَاتُهُ عَلَيْكُمْ أَهْلَ الْبَيْتِ ۚ إِنَّهُ حَمِيدٌ مَجِيدٌ",
  },
  {
    id: "1547",
    sura: "11",
    VerseIDAr: "74",
    ayatAR:
      "فَلَمَّا ذَهَبَ عَنْ إِبْرَاهِيمَ الرَّوْعُ وَجَاءَتْهُ الْبُشْرَىٰ يُجَادِلُنَا فِي قَوْمِ لُوطٍ",
  },
  {
    id: "1548",
    sura: "11",
    VerseIDAr: "75",
    ayatAR: "إِنَّ إِبْرَاهِيمَ لَحَلِيمٌ أَوَّاهٌ مُنِيبٌ",
  },
  {
    id: "1549",
    sura: "11",
    VerseIDAr: "76",
    ayatAR:
      "يَا إِبْرَاهِيمُ أَعْرِضْ عَنْ هَٰذَا ۖ إِنَّهُ قَدْ جَاءَ أَمْرُ رَبِّكَ ۖ وَإِنَّهُمْ آتِيهِمْ عَذَابٌ غَيْرُ مَرْدُودٍ",
  },
  {
    id: "1550",
    sura: "11",
    VerseIDAr: "77",
    ayatAR:
      "وَلَمَّا جَاءَتْ رُسُلُنَا لُوطًا سِيءَ بِهِمْ وَضَاقَ بِهِمْ ذَرْعًا وَقَالَ هَٰذَا يَوْمٌ عَصِيبٌ",
  },
  {
    id: "1551",
    sura: "11",
    VerseIDAr: "78",
    ayatAR:
      "وَجَاءَهُ قَوْمُهُ يُهْرَعُونَ إِلَيْهِ وَمِنْ قَبْلُ كَانُوا يَعْمَلُونَ السَّيِّئَاتِ ۚ قَالَ يَا قَوْمِ هَٰؤُلَاءِ بَنَاتِي هُنَّ أَطْهَرُ لَكُمْ ۖ فَاتَّقُوا اللَّهَ وَلَا تُخْزُونِ فِي ضَيْفِي ۖ أَلَيْسَ مِنْكُمْ رَجُلٌ رَشِيدٌ",
  },
  {
    id: "1552",
    sura: "11",
    VerseIDAr: "79",
    ayatAR:
      "قَالُوا لَقَدْ عَلِمْتَ مَا لَنَا فِي بَنَاتِكَ مِنْ حَقٍّ وَإِنَّكَ لَتَعْلَمُ مَا نُرِيدُ",
  },
  {
    id: "1553",
    sura: "11",
    VerseIDAr: "80",
    ayatAR:
      "قَالَ لَوْ أَنَّ لِي بِكُمْ قُوَّةً أَوْ آوِي إِلَىٰ رُكْنٍ شَدِيدٍ",
  },
  {
    id: "1554",
    sura: "11",
    VerseIDAr: "81",
    ayatAR:
      "قَالُوا يَا لُوطُ إِنَّا رُسُلُ رَبِّكَ لَنْ يَصِلُوا إِلَيْكَ ۖ فَأَسْرِ بِأَهْلِكَ بِقِطْعٍ مِنَ اللَّيْلِ وَلَا يَلْتَفِتْ مِنْكُمْ أَحَدٌ إِلَّا امْرَأَتَكَ ۖ إِنَّهُ مُصِيبُهَا مَا أَصَابَهُمْ ۚ إِنَّ مَوْعِدَهُمُ الصُّبْحُ ۚ أَلَيْسَ الصُّبْحُ بِقَرِيبٍ",
  },
  {
    id: "1555",
    sura: "11",
    VerseIDAr: "82",
    ayatAR:
      "فَلَمَّا جَاءَ أَمْرُنَا جَعَلْنَا عَالِيَهَا سَافِلَهَا وَأَمْطَرْنَا عَلَيْهَا حِجَارَةً مِنْ سِجِّيلٍ مَنْضُودٍ",
  },
  {
    id: "1556",
    sura: "11",
    VerseIDAr: "83",
    ayatAR:
      "مُسَوَّمَةً عِنْدَ رَبِّكَ ۖ وَمَا هِيَ مِنَ الظَّالِمِينَ بِبَعِيدٍ",
  },
  {
    id: "1557",
    sura: "11",
    VerseIDAr: "84",
    ayatAR:
      "وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًا ۚ قَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ وَلَا تَنْقُصُوا الْمِكْيَالَ وَالْمِيزَانَ ۚ إِنِّي أَرَاكُمْ بِخَيْرٍ وَإِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ مُحِيطٍ",
  },
  {
    id: "1558",
    sura: "11",
    VerseIDAr: "85",
    ayatAR:
      "وَيَا قَوْمِ أَوْفُوا الْمِكْيَالَ وَالْمِيزَانَ بِالْقِسْطِ ۖ وَلَا تَبْخَسُوا النَّاسَ أَشْيَاءَهُمْ وَلَا تَعْثَوْا فِي الْأَرْضِ مُفْسِدِينَ",
  },
  {
    id: "1559",
    sura: "11",
    VerseIDAr: "86",
    ayatAR:
      "بَقِيَّتُ اللَّهِ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ ۚ وَمَا أَنَا عَلَيْكُمْ بِحَفِيظٍ",
  },
  {
    id: "1560",
    sura: "11",
    VerseIDAr: "87",
    ayatAR:
      "قَالُوا يَا شُعَيْبُ أَصَلَاتُكَ تَأْمُرُكَ أَنْ نَتْرُكَ مَا يَعْبُدُ آبَاؤُنَا أَوْ أَنْ نَفْعَلَ فِي أَمْوَالِنَا مَا نَشَاءُ ۖ إِنَّكَ لَأَنْتَ الْحَلِيمُ الرَّشِيدُ",
  },
  {
    id: "1561",
    sura: "11",
    VerseIDAr: "88",
    ayatAR:
      "قَالَ يَا قَوْمِ أَرَأَيْتُمْ إِنْ كُنْتُ عَلَىٰ بَيِّنَةٍ مِنْ رَبِّي وَرَزَقَنِي مِنْهُ رِزْقًا حَسَنًا ۚ وَمَا أُرِيدُ أَنْ أُخَالِفَكُمْ إِلَىٰ مَا أَنْهَاكُمْ عَنْهُ ۚ إِنْ أُرِيدُ إِلَّا الْإِصْلَاحَ مَا اسْتَطَعْتُ ۚ وَمَا تَوْفِيقِي إِلَّا بِاللَّهِ ۚ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ",
  },
  {
    id: "1562",
    sura: "11",
    VerseIDAr: "89",
    ayatAR:
      "وَيَا قَوْمِ لَا يَجْرِمَنَّكُمْ شِقَاقِي أَنْ يُصِيبَكُمْ مِثْلُ مَا أَصَابَ قَوْمَ نُوحٍ أَوْ قَوْمَ هُودٍ أَوْ قَوْمَ صَالِحٍ ۚ وَمَا قَوْمُ لُوطٍ مِنْكُمْ بِبَعِيدٍ",
  },
  {
    id: "1563",
    sura: "11",
    VerseIDAr: "90",
    ayatAR:
      "وَاسْتَغْفِرُوا رَبَّكُمْ ثُمَّ تُوبُوا إِلَيْهِ ۚ إِنَّ رَبِّي رَحِيمٌ وَدُودٌ",
  },
  {
    id: "1564",
    sura: "11",
    VerseIDAr: "91",
    ayatAR:
      "قَالُوا يَا شُعَيْبُ مَا نَفْقَهُ كَثِيرًا مِمَّا تَقُولُ وَإِنَّا لَنَرَاكَ فِينَا ضَعِيفًا ۖ وَلَوْلَا رَهْطُكَ لَرَجَمْنَاكَ ۖ وَمَا أَنْتَ عَلَيْنَا بِعَزِيزٍ",
  },
  {
    id: "1565",
    sura: "11",
    VerseIDAr: "92",
    ayatAR:
      "قَالَ يَا قَوْمِ أَرَهْطِي أَعَزُّ عَلَيْكُمْ مِنَ اللَّهِ وَاتَّخَذْتُمُوهُ وَرَاءَكُمْ ظِهْرِيًّا ۖ إِنَّ رَبِّي بِمَا تَعْمَلُونَ مُحِيطٌ",
  },
  {
    id: "1566",
    sura: "11",
    VerseIDAr: "93",
    ayatAR:
      "وَيَا قَوْمِ اعْمَلُوا عَلَىٰ مَكَانَتِكُمْ إِنِّي عَامِلٌ ۖ سَوْفَ تَعْلَمُونَ مَنْ يَأْتِيهِ عَذَابٌ يُخْزِيهِ وَمَنْ هُوَ كَاذِبٌ ۖ وَارْتَقِبُوا إِنِّي مَعَكُمْ رَقِيبٌ",
  },
  {
    id: "1567",
    sura: "11",
    VerseIDAr: "94",
    ayatAR:
      "وَلَمَّا جَاءَ أَمْرُنَا نَجَّيْنَا شُعَيْبًا وَالَّذِينَ آمَنُوا مَعَهُ بِرَحْمَةٍ مِنَّا وَأَخَذَتِ الَّذِينَ ظَلَمُوا الصَّيْحَةُ فَأَصْبَحُوا فِي دِيَارِهِمْ جَاثِمِينَ",
  },
  {
    id: "1568",
    sura: "11",
    VerseIDAr: "95",
    ayatAR:
      "كَأَنْ لَمْ يَغْنَوْا فِيهَا ۗ أَلَا بُعْدًا لِمَدْيَنَ كَمَا بَعِدَتْ ثَمُودُ",
  },
  {
    id: "1569",
    sura: "11",
    VerseIDAr: "96",
    ayatAR: "وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِآيَاتِنَا وَسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "1570",
    sura: "11",
    VerseIDAr: "97",
    ayatAR:
      "إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ فَاتَّبَعُوا أَمْرَ فِرْعَوْنَ ۖ وَمَا أَمْرُ فِرْعَوْنَ بِرَشِيدٍ",
  },
  {
    id: "1571",
    sura: "11",
    VerseIDAr: "98",
    ayatAR:
      "يَقْدُمُ قَوْمَهُ يَوْمَ الْقِيَامَةِ فَأَوْرَدَهُمُ النَّارَ ۖ وَبِئْسَ الْوِرْدُ الْمَوْرُودُ",
  },
  {
    id: "1572",
    sura: "11",
    VerseIDAr: "99",
    ayatAR:
      "وَأُتْبِعُوا فِي هَٰذِهِ لَعْنَةً وَيَوْمَ الْقِيَامَةِ ۚ بِئْسَ الرِّفْدُ الْمَرْفُودُ",
  },
  {
    id: "1573",
    sura: "11",
    VerseIDAr: "100",
    ayatAR:
      "ذَٰلِكَ مِنْ أَنْبَاءِ الْقُرَىٰ نَقُصُّهُ عَلَيْكَ ۖ مِنْهَا قَائِمٌ وَحَصِيدٌ",
  },
  {
    id: "1574",
    sura: "11",
    VerseIDAr: "101",
    ayatAR:
      "وَمَا ظَلَمْنَاهُمْ وَلَٰكِنْ ظَلَمُوا أَنْفُسَهُمْ ۖ فَمَا أَغْنَتْ عَنْهُمْ آلِهَتُهُمُ الَّتِي يَدْعُونَ مِنْ دُونِ اللَّهِ مِنْ شَيْءٍ لَمَّا جَاءَ أَمْرُ رَبِّكَ ۖ وَمَا زَادُوهُمْ غَيْرَ تَتْبِيبٍ",
  },
  {
    id: "1575",
    sura: "11",
    VerseIDAr: "102",
    ayatAR:
      "وَكَذَٰلِكَ أَخْذُ رَبِّكَ إِذَا أَخَذَ الْقُرَىٰ وَهِيَ ظَالِمَةٌ ۚ إِنَّ أَخْذَهُ أَلِيمٌ شَدِيدٌ",
  },
  {
    id: "1576",
    sura: "11",
    VerseIDAr: "103",
    ayatAR:
      "إِنَّ فِي ذَٰلِكَ لَآيَةً لِمَنْ خَافَ عَذَابَ الْآخِرَةِ ۚ ذَٰلِكَ يَوْمٌ مَجْمُوعٌ لَهُ النَّاسُ وَذَٰلِكَ يَوْمٌ مَشْهُودٌ",
  },
  {
    id: "1577",
    sura: "11",
    VerseIDAr: "104",
    ayatAR: "وَمَا نُؤَخِّرُهُ إِلَّا لِأَجَلٍ مَعْدُودٍ",
  },
  {
    id: "1578",
    sura: "11",
    VerseIDAr: "105",
    ayatAR:
      "يَوْمَ يَأْتِ لَا تَكَلَّمُ نَفْسٌ إِلَّا بِإِذْنِهِ ۚ فَمِنْهُمْ شَقِيٌّ وَسَعِيدٌ",
  },
  {
    id: "1579",
    sura: "11",
    VerseIDAr: "106",
    ayatAR:
      "فَأَمَّا الَّذِينَ شَقُوا فَفِي النَّارِ لَهُمْ فِيهَا زَفِيرٌ وَشَهِيقٌ",
  },
  {
    id: "1580",
    sura: "11",
    VerseIDAr: "107",
    ayatAR:
      "خَالِدِينَ فِيهَا مَا دَامَتِ السَّمَاوَاتُ وَالْأَرْضُ إِلَّا مَا شَاءَ رَبُّكَ ۚ إِنَّ رَبَّكَ فَعَّالٌ لِمَا يُرِيدُ",
  },
  {
    id: "1581",
    sura: "11",
    VerseIDAr: "108",
    ayatAR:
      "وَأَمَّا الَّذِينَ سُعِدُوا فَفِي الْجَنَّةِ خَالِدِينَ فِيهَا مَا دَامَتِ السَّمَاوَاتُ وَالْأَرْضُ إِلَّا مَا شَاءَ رَبُّكَ ۖ عَطَاءً غَيْرَ مَجْذُوذٍ",
  },
  {
    id: "1582",
    sura: "11",
    VerseIDAr: "109",
    ayatAR:
      "فَلَا تَكُ فِي مِرْيَةٍ مِمَّا يَعْبُدُ هَٰؤُلَاءِ ۚ مَا يَعْبُدُونَ إِلَّا كَمَا يَعْبُدُ آبَاؤُهُمْ مِنْ قَبْلُ ۚ وَإِنَّا لَمُوَفُّوهُمْ نَصِيبَهُمْ غَيْرَ مَنْقُوصٍ",
  },
  {
    id: "1583",
    sura: "11",
    VerseIDAr: "110",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ فَاخْتُلِفَ فِيهِ ۚ وَلَوْلَا كَلِمَةٌ سَبَقَتْ مِنْ رَبِّكَ لَقُضِيَ بَيْنَهُمْ ۚ وَإِنَّهُمْ لَفِي شَكٍّ مِنْهُ مُرِيبٍ",
  },
  {
    id: "1584",
    sura: "11",
    VerseIDAr: "111",
    ayatAR:
      "وَإِنَّ كُلًّا لَمَّا لَيُوَفِّيَنَّهُمْ رَبُّكَ أَعْمَالَهُمْ ۚ إِنَّهُ بِمَا يَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "1585",
    sura: "11",
    VerseIDAr: "112",
    ayatAR:
      "فَاسْتَقِمْ كَمَا أُمِرْتَ وَمَنْ تَابَ مَعَكَ وَلَا تَطْغَوْا ۚ إِنَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "1586",
    sura: "11",
    VerseIDAr: "113",
    ayatAR:
      "وَلَا تَرْكَنُوا إِلَى الَّذِينَ ظَلَمُوا فَتَمَسَّكُمُ النَّارُ وَمَا لَكُمْ مِنْ دُونِ اللَّهِ مِنْ أَوْلِيَاءَ ثُمَّ لَا تُنْصَرُونَ",
  },
  {
    id: "1587",
    sura: "11",
    VerseIDAr: "114",
    ayatAR:
      "وَأَقِمِ الصَّلَاةَ طَرَفَيِ النَّهَارِ وَزُلَفًا مِنَ اللَّيْلِ ۚ إِنَّ الْحَسَنَاتِ يُذْهِبْنَ السَّيِّئَاتِ ۚ ذَٰلِكَ ذِكْرَىٰ لِلذَّاكِرِينَ",
  },
  {
    id: "1588",
    sura: "11",
    VerseIDAr: "115",
    ayatAR: "وَاصْبِرْ فَإِنَّ اللَّهَ لَا يُضِيعُ أَجْرَ الْمُحْسِنِينَ",
  },
  {
    id: "1589",
    sura: "11",
    VerseIDAr: "116",
    ayatAR:
      "فَلَوْلَا كَانَ مِنَ الْقُرُونِ مِنْ قَبْلِكُمْ أُولُو بَقِيَّةٍ يَنْهَوْنَ عَنِ الْفَسَادِ فِي الْأَرْضِ إِلَّا قَلِيلًا مِمَّنْ أَنْجَيْنَا مِنْهُمْ ۗ وَاتَّبَعَ الَّذِينَ ظَلَمُوا مَا أُتْرِفُوا فِيهِ وَكَانُوا مُجْرِمِينَ",
  },
  {
    id: "1590",
    sura: "11",
    VerseIDAr: "117",
    ayatAR:
      "وَمَا كَانَ رَبُّكَ لِيُهْلِكَ الْقُرَىٰ بِظُلْمٍ وَأَهْلُهَا مُصْلِحُونَ",
  },
  {
    id: "1591",
    sura: "11",
    VerseIDAr: "118",
    ayatAR:
      "وَلَوْ شَاءَ رَبُّكَ لَجَعَلَ النَّاسَ أُمَّةً وَاحِدَةً ۖ وَلَا يَزَالُونَ مُخْتَلِفِينَ",
  },
  {
    id: "1592",
    sura: "11",
    VerseIDAr: "119",
    ayatAR:
      "إِلَّا مَنْ رَحِمَ رَبُّكَ ۚ وَلِذَٰلِكَ خَلَقَهُمْ ۗ وَتَمَّتْ كَلِمَةُ رَبِّكَ لَأَمْلَأَنَّ جَهَنَّمَ مِنَ الْجِنَّةِ وَالنَّاسِ أَجْمَعِينَ",
  },
  {
    id: "1593",
    sura: "11",
    VerseIDAr: "120",
    ayatAR:
      "وَكُلًّا نَقُصُّ عَلَيْكَ مِنْ أَنْبَاءِ الرُّسُلِ مَا نُثَبِّتُ بِهِ فُؤَادَكَ ۚ وَجَاءَكَ فِي هَٰذِهِ الْحَقُّ وَمَوْعِظَةٌ وَذِكْرَىٰ لِلْمُؤْمِنِينَ",
  },
  {
    id: "1594",
    sura: "11",
    VerseIDAr: "121",
    ayatAR:
      "وَقُلْ لِلَّذِينَ لَا يُؤْمِنُونَ اعْمَلُوا عَلَىٰ مَكَانَتِكُمْ إِنَّا عَامِلُونَ",
  },
  {
    id: "1595",
    sura: "11",
    VerseIDAr: "122",
    ayatAR: "وَانْتَظِرُوا إِنَّا مُنْتَظِرُونَ",
  },
  {
    id: "1596",
    sura: "11",
    VerseIDAr: "123",
    ayatAR:
      "وَلِلَّهِ غَيْبُ السَّمَاوَاتِ وَالْأَرْضِ وَإِلَيْهِ يُرْجَعُ الْأَمْرُ كُلُّهُ فَاعْبُدْهُ وَتَوَكَّلْ عَلَيْهِ ۚ وَمَا رَبُّكَ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "1597",
    sura: "12",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الر ۚ تِلْكَ آيَاتُ الْكِتَابِ الْمُبِينِ",
  },
  {
    id: "1598",
    sura: "12",
    VerseIDAr: "2",
    ayatAR: "إِنَّا أَنْزَلْنَاهُ قُرْآنًا عَرَبِيًّا لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "1599",
    sura: "12",
    VerseIDAr: "3",
    ayatAR:
      "نَحْنُ نَقُصُّ عَلَيْكَ أَحْسَنَ الْقَصَصِ بِمَا أَوْحَيْنَا إِلَيْكَ هَٰذَا الْقُرْآنَ وَإِنْ كُنْتَ مِنْ قَبْلِهِ لَمِنَ الْغَافِلِينَ",
  },
  {
    id: "1600",
    sura: "12",
    VerseIDAr: "4",
    ayatAR:
      "إِذْ قَالَ يُوسُفُ لِأَبِيهِ يَا أَبَتِ إِنِّي رَأَيْتُ أَحَدَ عَشَرَ كَوْكَبًا وَالشَّمْسَ وَالْقَمَرَ رَأَيْتُهُمْ لِي سَاجِدِينَ",
  },
  {
    id: "1601",
    sura: "12",
    VerseIDAr: "5",
    ayatAR:
      "قَالَ يَا بُنَيَّ لَا تَقْصُصْ رُؤْيَاكَ عَلَىٰ إِخْوَتِكَ فَيَكِيدُوا لَكَ كَيْدًا ۖ إِنَّ الشَّيْطَانَ لِلْإِنْسَانِ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "1602",
    sura: "12",
    VerseIDAr: "6",
    ayatAR:
      "وَكَذَٰلِكَ يَجْتَبِيكَ رَبُّكَ وَيُعَلِّمُكَ مِنْ تَأْوِيلِ الْأَحَادِيثِ وَيُتِمُّ نِعْمَتَهُ عَلَيْكَ وَعَلَىٰ آلِ يَعْقُوبَ كَمَا أَتَمَّهَا عَلَىٰ أَبَوَيْكَ مِنْ قَبْلُ إِبْرَاهِيمَ وَإِسْحَاقَ ۚ إِنَّ رَبَّكَ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "1603",
    sura: "12",
    VerseIDAr: "7",
    ayatAR: "لَقَدْ كَانَ فِي يُوسُفَ وَإِخْوَتِهِ آيَاتٌ لِلسَّائِلِينَ",
  },
  {
    id: "1604",
    sura: "12",
    VerseIDAr: "8",
    ayatAR:
      "إِذْ قَالُوا لَيُوسُفُ وَأَخُوهُ أَحَبُّ إِلَىٰ أَبِينَا مِنَّا وَنَحْنُ عُصْبَةٌ إِنَّ أَبَانَا لَفِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "1605",
    sura: "12",
    VerseIDAr: "9",
    ayatAR:
      "اقْتُلُوا يُوسُفَ أَوِ اطْرَحُوهُ أَرْضًا يَخْلُ لَكُمْ وَجْهُ أَبِيكُمْ وَتَكُونُوا مِنْ بَعْدِهِ قَوْمًا صَالِحِينَ",
  },
  {
    id: "1606",
    sura: "12",
    VerseIDAr: "10",
    ayatAR:
      "قَالَ قَائِلٌ مِنْهُمْ لَا تَقْتُلُوا يُوسُفَ وَأَلْقُوهُ فِي غَيَابَتِ الْجُبِّ يَلْتَقِطْهُ بَعْضُ السَّيَّارَةِ إِنْ كُنْتُمْ فَاعِلِينَ",
  },
  {
    id: "1607",
    sura: "12",
    VerseIDAr: "11",
    ayatAR:
      "قَالُوا يَا أَبَانَا مَا لَكَ لَا تَأْمَنَّا عَلَىٰ يُوسُفَ وَإِنَّا لَهُ لَنَاصِحُونَ",
  },
  {
    id: "1608",
    sura: "12",
    VerseIDAr: "12",
    ayatAR:
      "أَرْسِلْهُ مَعَنَا غَدًا يَرْتَعْ وَيَلْعَبْ وَإِنَّا لَهُ لَحَافِظُونَ",
  },
  {
    id: "1609",
    sura: "12",
    VerseIDAr: "13",
    ayatAR:
      "قَالَ إِنِّي لَيَحْزُنُنِي أَنْ تَذْهَبُوا بِهِ وَأَخَافُ أَنْ يَأْكُلَهُ الذِّئْبُ وَأَنْتُمْ عَنْهُ غَافِلُونَ",
  },
  {
    id: "1610",
    sura: "12",
    VerseIDAr: "14",
    ayatAR:
      "قَالُوا لَئِنْ أَكَلَهُ الذِّئْبُ وَنَحْنُ عُصْبَةٌ إِنَّا إِذًا لَخَاسِرُونَ",
  },
  {
    id: "1611",
    sura: "12",
    VerseIDAr: "15",
    ayatAR:
      "فَلَمَّا ذَهَبُوا بِهِ وَأَجْمَعُوا أَنْ يَجْعَلُوهُ فِي غَيَابَتِ الْجُبِّ ۚ وَأَوْحَيْنَا إِلَيْهِ لَتُنَبِّئَنَّهُمْ بِأَمْرِهِمْ هَٰذَا وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "1612",
    sura: "12",
    VerseIDAr: "16",
    ayatAR: "وَجَاءُوا أَبَاهُمْ عِشَاءً يَبْكُونَ",
  },
  {
    id: "1613",
    sura: "12",
    VerseIDAr: "17",
    ayatAR:
      "قَالُوا يَا أَبَانَا إِنَّا ذَهَبْنَا نَسْتَبِقُ وَتَرَكْنَا يُوسُفَ عِنْدَ مَتَاعِنَا فَأَكَلَهُ الذِّئْبُ ۖ وَمَا أَنْتَ بِمُؤْمِنٍ لَنَا وَلَوْ كُنَّا صَادِقِينَ",
  },
  {
    id: "1614",
    sura: "12",
    VerseIDAr: "18",
    ayatAR:
      "وَجَاءُوا عَلَىٰ قَمِيصِهِ بِدَمٍ كَذِبٍ ۚ قَالَ بَلْ سَوَّلَتْ لَكُمْ أَنْفُسُكُمْ أَمْرًا ۖ فَصَبْرٌ جَمِيلٌ ۖ وَاللَّهُ الْمُسْتَعَانُ عَلَىٰ مَا تَصِفُونَ",
  },
  {
    id: "1615",
    sura: "12",
    VerseIDAr: "19",
    ayatAR:
      "وَجَاءَتْ سَيَّارَةٌ فَأَرْسَلُوا وَارِدَهُمْ فَأَدْلَىٰ دَلْوَهُ ۖ قَالَ يَا بُشْرَىٰ هَٰذَا غُلَامٌ ۚ وَأَسَرُّوهُ بِضَاعَةً ۚ وَاللَّهُ عَلِيمٌ بِمَا يَعْمَلُونَ",
  },
  {
    id: "1616",
    sura: "12",
    VerseIDAr: "20",
    ayatAR:
      "وَشَرَوْهُ بِثَمَنٍ بَخْسٍ دَرَاهِمَ مَعْدُودَةٍ وَكَانُوا فِيهِ مِنَ الزَّاهِدِينَ",
  },
  {
    id: "1617",
    sura: "12",
    VerseIDAr: "21",
    ayatAR:
      "وَقَالَ الَّذِي اشْتَرَاهُ مِنْ مِصْرَ لِامْرَأَتِهِ أَكْرِمِي مَثْوَاهُ عَسَىٰ أَنْ يَنْفَعَنَا أَوْ نَتَّخِذَهُ وَلَدًا ۚ وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِي الْأَرْضِ وَلِنُعَلِّمَهُ مِنْ تَأْوِيلِ الْأَحَادِيثِ ۚ وَاللَّهُ غَالِبٌ عَلَىٰ أَمْرِهِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "1618",
    sura: "12",
    VerseIDAr: "22",
    ayatAR:
      "وَلَمَّا بَلَغَ أَشُدَّهُ آتَيْنَاهُ حُكْمًا وَعِلْمًا ۚ وَكَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "1619",
    sura: "12",
    VerseIDAr: "23",
    ayatAR:
      "وَرَاوَدَتْهُ الَّتِي هُوَ فِي بَيْتِهَا عَنْ نَفْسِهِ وَغَلَّقَتِ الْأَبْوَابَ وَقَالَتْ هَيْتَ لَكَ ۚ قَالَ مَعَاذَ اللَّهِ ۖ إِنَّهُ رَبِّي أَحْسَنَ مَثْوَايَ ۖ إِنَّهُ لَا يُفْلِحُ الظَّالِمُونَ",
  },
  {
    id: "1620",
    sura: "12",
    VerseIDAr: "24",
    ayatAR:
      "وَلَقَدْ هَمَّتْ بِهِ ۖ وَهَمَّ بِهَا لَوْلَا أَنْ رَأَىٰ بُرْهَانَ رَبِّهِ ۚ كَذَٰلِكَ لِنَصْرِفَ عَنْهُ السُّوءَ وَالْفَحْشَاءَ ۚ إِنَّهُ مِنْ عِبَادِنَا الْمُخْلَصِينَ",
  },
  {
    id: "1621",
    sura: "12",
    VerseIDAr: "25",
    ayatAR:
      "وَاسْتَبَقَا الْبَابَ وَقَدَّتْ قَمِيصَهُ مِنْ دُبُرٍ وَأَلْفَيَا سَيِّدَهَا لَدَى الْبَابِ ۚ قَالَتْ مَا جَزَاءُ مَنْ أَرَادَ بِأَهْلِكَ سُوءًا إِلَّا أَنْ يُسْجَنَ أَوْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1622",
    sura: "12",
    VerseIDAr: "26",
    ayatAR:
      "قَالَ هِيَ رَاوَدَتْنِي عَنْ نَفْسِي ۚ وَشَهِدَ شَاهِدٌ مِنْ أَهْلِهَا إِنْ كَانَ قَمِيصُهُ قُدَّ مِنْ قُبُلٍ فَصَدَقَتْ وَهُوَ مِنَ الْكَاذِبِينَ",
  },
  {
    id: "1623",
    sura: "12",
    VerseIDAr: "27",
    ayatAR:
      "وَإِنْ كَانَ قَمِيصُهُ قُدَّ مِنْ دُبُرٍ فَكَذَبَتْ وَهُوَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "1624",
    sura: "12",
    VerseIDAr: "28",
    ayatAR:
      "فَلَمَّا رَأَىٰ قَمِيصَهُ قُدَّ مِنْ دُبُرٍ قَالَ إِنَّهُ مِنْ كَيْدِكُنَّ ۖ إِنَّ كَيْدَكُنَّ عَظِيمٌ",
  },
  {
    id: "1625",
    sura: "12",
    VerseIDAr: "29",
    ayatAR:
      "يُوسُفُ أَعْرِضْ عَنْ هَٰذَا ۚ وَاسْتَغْفِرِي لِذَنْبِكِ ۖ إِنَّكِ كُنْتِ مِنَ الْخَاطِئِينَ",
  },
  {
    id: "1626",
    sura: "12",
    VerseIDAr: "30",
    ayatAR:
      "وَقَالَ نِسْوَةٌ فِي الْمَدِينَةِ امْرَأَتُ الْعَزِيزِ تُرَاوِدُ فَتَاهَا عَنْ نَفْسِهِ ۖ قَدْ شَغَفَهَا حُبًّا ۖ إِنَّا لَنَرَاهَا فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "1627",
    sura: "12",
    VerseIDAr: "31",
    ayatAR:
      "فَلَمَّا سَمِعَتْ بِمَكْرِهِنَّ أَرْسَلَتْ إِلَيْهِنَّ وَأَعْتَدَتْ لَهُنَّ مُتَّكَأً وَآتَتْ كُلَّ وَاحِدَةٍ مِنْهُنَّ سِكِّينًا وَقَالَتِ اخْرُجْ عَلَيْهِنَّ ۖ فَلَمَّا رَأَيْنَهُ أَكْبَرْنَهُ وَقَطَّعْنَ أَيْدِيَهُنَّ وَقُلْنَ حَاشَ لِلَّهِ مَا هَٰذَا بَشَرًا إِنْ هَٰذَا إِلَّا مَلَكٌ كَرِيمٌ",
  },
  {
    id: "1628",
    sura: "12",
    VerseIDAr: "32",
    ayatAR:
      "قَالَتْ فَذَٰلِكُنَّ الَّذِي لُمْتُنَّنِي فِيهِ ۖ وَلَقَدْ رَاوَدْتُهُ عَنْ نَفْسِهِ فَاسْتَعْصَمَ ۖ وَلَئِنْ لَمْ يَفْعَلْ مَا آمُرُهُ لَيُسْجَنَنَّ وَلَيَكُونًا مِنَ الصَّاغِرِينَ",
  },
  {
    id: "1629",
    sura: "12",
    VerseIDAr: "33",
    ayatAR:
      "قَالَ رَبِّ السِّجْنُ أَحَبُّ إِلَيَّ مِمَّا يَدْعُونَنِي إِلَيْهِ ۖ وَإِلَّا تَصْرِفْ عَنِّي كَيْدَهُنَّ أَصْبُ إِلَيْهِنَّ وَأَكُنْ مِنَ الْجَاهِلِينَ",
  },
  {
    id: "1630",
    sura: "12",
    VerseIDAr: "34",
    ayatAR:
      "فَاسْتَجَابَ لَهُ رَبُّهُ فَصَرَفَ عَنْهُ كَيْدَهُنَّ ۚ إِنَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "1631",
    sura: "12",
    VerseIDAr: "35",
    ayatAR:
      "ثُمَّ بَدَا لَهُمْ مِنْ بَعْدِ مَا رَأَوُا الْآيَاتِ لَيَسْجُنُنَّهُ حَتَّىٰ حِينٍ",
  },
  {
    id: "1632",
    sura: "12",
    VerseIDAr: "36",
    ayatAR:
      "وَدَخَلَ مَعَهُ السِّجْنَ فَتَيَانِ ۖ قَالَ أَحَدُهُمَا إِنِّي أَرَانِي أَعْصِرُ خَمْرًا ۖ وَقَالَ الْآخَرُ إِنِّي أَرَانِي أَحْمِلُ فَوْقَ رَأْسِي خُبْزًا تَأْكُلُ الطَّيْرُ مِنْهُ ۖ نَبِّئْنَا بِتَأْوِيلِهِ ۖ إِنَّا نَرَاكَ مِنَ الْمُحْسِنِينَ",
  },
  {
    id: "1633",
    sura: "12",
    VerseIDAr: "37",
    ayatAR:
      "قَالَ لَا يَأْتِيكُمَا طَعَامٌ تُرْزَقَانِهِ إِلَّا نَبَّأْتُكُمَا بِتَأْوِيلِهِ قَبْلَ أَنْ يَأْتِيَكُمَا ۚ ذَٰلِكُمَا مِمَّا عَلَّمَنِي رَبِّي ۚ إِنِّي تَرَكْتُ مِلَّةَ قَوْمٍ لَا يُؤْمِنُونَ بِاللَّهِ وَهُمْ بِالْآخِرَةِ هُمْ كَافِرُونَ",
  },
  {
    id: "1634",
    sura: "12",
    VerseIDAr: "38",
    ayatAR:
      "وَاتَّبَعْتُ مِلَّةَ آبَائِي إِبْرَاهِيمَ وَإِسْحَاقَ وَيَعْقُوبَ ۚ مَا كَانَ لَنَا أَنْ نُشْرِكَ بِاللَّهِ مِنْ شَيْءٍ ۚ ذَٰلِكَ مِنْ فَضْلِ اللَّهِ عَلَيْنَا وَعَلَى النَّاسِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَشْكُرُونَ",
  },
  {
    id: "1635",
    sura: "12",
    VerseIDAr: "39",
    ayatAR:
      "يَا صَاحِبَيِ السِّجْنِ أَأَرْبَابٌ مُتَفَرِّقُونَ خَيْرٌ أَمِ اللَّهُ الْوَاحِدُ الْقَهَّارُ",
  },
  {
    id: "1636",
    sura: "12",
    VerseIDAr: "40",
    ayatAR:
      "مَا تَعْبُدُونَ مِنْ دُونِهِ إِلَّا أَسْمَاءً سَمَّيْتُمُوهَا أَنْتُمْ وَآبَاؤُكُمْ مَا أَنْزَلَ اللَّهُ بِهَا مِنْ سُلْطَانٍ ۚ إِنِ الْحُكْمُ إِلَّا لِلَّهِ ۚ أَمَرَ أَلَّا تَعْبُدُوا إِلَّا إِيَّاهُ ۚ ذَٰلِكَ الدِّينُ الْقَيِّمُ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "1637",
    sura: "12",
    VerseIDAr: "41",
    ayatAR:
      "يَا صَاحِبَيِ السِّجْنِ أَمَّا أَحَدُكُمَا فَيَسْقِي رَبَّهُ خَمْرًا ۖ وَأَمَّا الْآخَرُ فَيُصْلَبُ فَتَأْكُلُ الطَّيْرُ مِنْ رَأْسِهِ ۚ قُضِيَ الْأَمْرُ الَّذِي فِيهِ تَسْتَفْتِيَانِ",
  },
  {
    id: "1638",
    sura: "12",
    VerseIDAr: "42",
    ayatAR:
      "وَقَالَ لِلَّذِي ظَنَّ أَنَّهُ نَاجٍ مِنْهُمَا اذْكُرْنِي عِنْدَ رَبِّكَ فَأَنْسَاهُ الشَّيْطَانُ ذِكْرَ رَبِّهِ فَلَبِثَ فِي السِّجْنِ بِضْعَ سِنِينَ",
  },
  {
    id: "1639",
    sura: "12",
    VerseIDAr: "43",
    ayatAR:
      "وَقَالَ الْمَلِكُ إِنِّي أَرَىٰ سَبْعَ بَقَرَاتٍ سِمَانٍ يَأْكُلُهُنَّ سَبْعٌ عِجَافٌ وَسَبْعَ سُنْبُلَاتٍ خُضْرٍ وَأُخَرَ يَابِسَاتٍ ۖ يَا أَيُّهَا الْمَلَأُ أَفْتُونِي فِي رُؤْيَايَ إِنْ كُنْتُمْ لِلرُّؤْيَا تَعْبُرُونَ",
  },
  {
    id: "1640",
    sura: "12",
    VerseIDAr: "44",
    ayatAR:
      "قَالُوا أَضْغَاثُ أَحْلَامٍ ۖ وَمَا نَحْنُ بِتَأْوِيلِ الْأَحْلَامِ بِعَالِمِينَ",
  },
  {
    id: "1641",
    sura: "12",
    VerseIDAr: "45",
    ayatAR:
      "وَقَالَ الَّذِي نَجَا مِنْهُمَا وَادَّكَرَ بَعْدَ أُمَّةٍ أَنَا أُنَبِّئُكُمْ بِتَأْوِيلِهِ فَأَرْسِلُونِ",
  },
  {
    id: "1642",
    sura: "12",
    VerseIDAr: "46",
    ayatAR:
      "يُوسُفُ أَيُّهَا الصِّدِّيقُ أَفْتِنَا فِي سَبْعِ بَقَرَاتٍ سِمَانٍ يَأْكُلُهُنَّ سَبْعٌ عِجَافٌ وَسَبْعِ سُنْبُلَاتٍ خُضْرٍ وَأُخَرَ يَابِسَاتٍ لَعَلِّي أَرْجِعُ إِلَى النَّاسِ لَعَلَّهُمْ يَعْلَمُونَ",
  },
  {
    id: "1643",
    sura: "12",
    VerseIDAr: "47",
    ayatAR:
      "قَالَ تَزْرَعُونَ سَبْعَ سِنِينَ دَأَبًا فَمَا حَصَدْتُمْ فَذَرُوهُ فِي سُنْبُلِهِ إِلَّا قَلِيلًا مِمَّا تَأْكُلُونَ",
  },
  {
    id: "1644",
    sura: "12",
    VerseIDAr: "48",
    ayatAR:
      "ثُمَّ يَأْتِي مِنْ بَعْدِ ذَٰلِكَ سَبْعٌ شِدَادٌ يَأْكُلْنَ مَا قَدَّمْتُمْ لَهُنَّ إِلَّا قَلِيلًا مِمَّا تُحْصِنُونَ",
  },
  {
    id: "1645",
    sura: "12",
    VerseIDAr: "49",
    ayatAR:
      "ثُمَّ يَأْتِي مِنْ بَعْدِ ذَٰلِكَ عَامٌ فِيهِ يُغَاثُ النَّاسُ وَفِيهِ يَعْصِرُونَ",
  },
  {
    id: "1646",
    sura: "12",
    VerseIDAr: "50",
    ayatAR:
      "وَقَالَ الْمَلِكُ ائْتُونِي بِهِ ۖ فَلَمَّا جَاءَهُ الرَّسُولُ قَالَ ارْجِعْ إِلَىٰ رَبِّكَ فَاسْأَلْهُ مَا بَالُ النِّسْوَةِ اللَّاتِي قَطَّعْنَ أَيْدِيَهُنَّ ۚ إِنَّ رَبِّي بِكَيْدِهِنَّ عَلِيمٌ",
  },
  {
    id: "1647",
    sura: "12",
    VerseIDAr: "51",
    ayatAR:
      "قَالَ مَا خَطْبُكُنَّ إِذْ رَاوَدْتُنَّ يُوسُفَ عَنْ نَفْسِهِ ۚ قُلْنَ حَاشَ لِلَّهِ مَا عَلِمْنَا عَلَيْهِ مِنْ سُوءٍ ۚ قَالَتِ امْرَأَتُ الْعَزِيزِ الْآنَ حَصْحَصَ الْحَقُّ أَنَا رَاوَدْتُهُ عَنْ نَفْسِهِ وَإِنَّهُ لَمِنَ الصَّادِقِينَ",
  },
  {
    id: "1648",
    sura: "12",
    VerseIDAr: "52",
    ayatAR:
      "ذَٰلِكَ لِيَعْلَمَ أَنِّي لَمْ أَخُنْهُ بِالْغَيْبِ وَأَنَّ اللَّهَ لَا يَهْدِي كَيْدَ الْخَائِنِينَ",
  },
  {
    id: "1649",
    sura: "12",
    VerseIDAr: "53",
    ayatAR:
      "وَمَا أُبَرِّئُ نَفْسِي ۚ إِنَّ النَّفْسَ لَأَمَّارَةٌ بِالسُّوءِ إِلَّا مَا رَحِمَ رَبِّي ۚ إِنَّ رَبِّي غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1650",
    sura: "12",
    VerseIDAr: "54",
    ayatAR:
      "وَقَالَ الْمَلِكُ ائْتُونِي بِهِ أَسْتَخْلِصْهُ لِنَفْسِي ۖ فَلَمَّا كَلَّمَهُ قَالَ إِنَّكَ الْيَوْمَ لَدَيْنَا مَكِينٌ أَمِينٌ",
  },
  {
    id: "1651",
    sura: "12",
    VerseIDAr: "55",
    ayatAR:
      "قَالَ اجْعَلْنِي عَلَىٰ خَزَائِنِ الْأَرْضِ ۖ إِنِّي حَفِيظٌ عَلِيمٌ",
  },
  {
    id: "1652",
    sura: "12",
    VerseIDAr: "56",
    ayatAR:
      "وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِي الْأَرْضِ يَتَبَوَّأُ مِنْهَا حَيْثُ يَشَاءُ ۚ نُصِيبُ بِرَحْمَتِنَا مَنْ نَشَاءُ ۖ وَلَا نُضِيعُ أَجْرَ الْمُحْسِنِينَ",
  },
  {
    id: "1653",
    sura: "12",
    VerseIDAr: "57",
    ayatAR:
      "وَلَأَجْرُ الْآخِرَةِ خَيْرٌ لِلَّذِينَ آمَنُوا وَكَانُوا يَتَّقُونَ",
  },
  {
    id: "1654",
    sura: "12",
    VerseIDAr: "58",
    ayatAR:
      "وَجَاءَ إِخْوَةُ يُوسُفَ فَدَخَلُوا عَلَيْهِ فَعَرَفَهُمْ وَهُمْ لَهُ مُنْكِرُونَ",
  },
  {
    id: "1655",
    sura: "12",
    VerseIDAr: "59",
    ayatAR:
      "وَلَمَّا جَهَّزَهُمْ بِجَهَازِهِمْ قَالَ ائْتُونِي بِأَخٍ لَكُمْ مِنْ أَبِيكُمْ ۚ أَلَا تَرَوْنَ أَنِّي أُوفِي الْكَيْلَ وَأَنَا خَيْرُ الْمُنْزِلِينَ",
  },
  {
    id: "1656",
    sura: "12",
    VerseIDAr: "60",
    ayatAR:
      "فَإِنْ لَمْ تَأْتُونِي بِهِ فَلَا كَيْلَ لَكُمْ عِنْدِي وَلَا تَقْرَبُونِ",
  },
  {
    id: "1657",
    sura: "12",
    VerseIDAr: "61",
    ayatAR: "قَالُوا سَنُرَاوِدُ عَنْهُ أَبَاهُ وَإِنَّا لَفَاعِلُونَ",
  },
  {
    id: "1658",
    sura: "12",
    VerseIDAr: "62",
    ayatAR:
      "وَقَالَ لِفِتْيَانِهِ اجْعَلُوا بِضَاعَتَهُمْ فِي رِحَالِهِمْ لَعَلَّهُمْ يَعْرِفُونَهَا إِذَا انْقَلَبُوا إِلَىٰ أَهْلِهِمْ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "1659",
    sura: "12",
    VerseIDAr: "63",
    ayatAR:
      "فَلَمَّا رَجَعُوا إِلَىٰ أَبِيهِمْ قَالُوا يَا أَبَانَا مُنِعَ مِنَّا الْكَيْلُ فَأَرْسِلْ مَعَنَا أَخَانَا نَكْتَلْ وَإِنَّا لَهُ لَحَافِظُونَ",
  },
  {
    id: "1660",
    sura: "12",
    VerseIDAr: "64",
    ayatAR:
      "قَالَ هَلْ آمَنُكُمْ عَلَيْهِ إِلَّا كَمَا أَمِنْتُكُمْ عَلَىٰ أَخِيهِ مِنْ قَبْلُ ۖ فَاللَّهُ خَيْرٌ حَافِظًا ۖ وَهُوَ أَرْحَمُ الرَّاحِمِينَ",
  },
  {
    id: "1661",
    sura: "12",
    VerseIDAr: "65",
    ayatAR:
      "وَلَمَّا فَتَحُوا مَتَاعَهُمْ وَجَدُوا بِضَاعَتَهُمْ رُدَّتْ إِلَيْهِمْ ۖ قَالُوا يَا أَبَانَا مَا نَبْغِي ۖ هَٰذِهِ بِضَاعَتُنَا رُدَّتْ إِلَيْنَا ۖ وَنَمِيرُ أَهْلَنَا وَنَحْفَظُ أَخَانَا وَنَزْدَادُ كَيْلَ بَعِيرٍ ۖ ذَٰلِكَ كَيْلٌ يَسِيرٌ",
  },
  {
    id: "1662",
    sura: "12",
    VerseIDAr: "66",
    ayatAR:
      "قَالَ لَنْ أُرْسِلَهُ مَعَكُمْ حَتَّىٰ تُؤْتُونِ مَوْثِقًا مِنَ اللَّهِ لَتَأْتُنَّنِي بِهِ إِلَّا أَنْ يُحَاطَ بِكُمْ ۖ فَلَمَّا آتَوْهُ مَوْثِقَهُمْ قَالَ اللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٌ",
  },
  {
    id: "1663",
    sura: "12",
    VerseIDAr: "67",
    ayatAR:
      "وَقَالَ يَا بَنِيَّ لَا تَدْخُلُوا مِنْ بَابٍ وَاحِدٍ وَادْخُلُوا مِنْ أَبْوَابٍ مُتَفَرِّقَةٍ ۖ وَمَا أُغْنِي عَنْكُمْ مِنَ اللَّهِ مِنْ شَيْءٍ ۖ إِنِ الْحُكْمُ إِلَّا لِلَّهِ ۖ عَلَيْهِ تَوَكَّلْتُ ۖ وَعَلَيْهِ فَلْيَتَوَكَّلِ الْمُتَوَكِّلُونَ",
  },
  {
    id: "1664",
    sura: "12",
    VerseIDAr: "68",
    ayatAR:
      "وَلَمَّا دَخَلُوا مِنْ حَيْثُ أَمَرَهُمْ أَبُوهُمْ مَا كَانَ يُغْنِي عَنْهُمْ مِنَ اللَّهِ مِنْ شَيْءٍ إِلَّا حَاجَةً فِي نَفْسِ يَعْقُوبَ قَضَاهَا ۚ وَإِنَّهُ لَذُو عِلْمٍ لِمَا عَلَّمْنَاهُ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "1665",
    sura: "12",
    VerseIDAr: "69",
    ayatAR:
      "وَلَمَّا دَخَلُوا عَلَىٰ يُوسُفَ آوَىٰ إِلَيْهِ أَخَاهُ ۖ قَالَ إِنِّي أَنَا أَخُوكَ فَلَا تَبْتَئِسْ بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1666",
    sura: "12",
    VerseIDAr: "70",
    ayatAR:
      "فَلَمَّا جَهَّزَهُمْ بِجَهَازِهِمْ جَعَلَ السِّقَايَةَ فِي رَحْلِ أَخِيهِ ثُمَّ أَذَّنَ مُؤَذِّنٌ أَيَّتُهَا الْعِيرُ إِنَّكُمْ لَسَارِقُونَ",
  },
  {
    id: "1667",
    sura: "12",
    VerseIDAr: "71",
    ayatAR: "قَالُوا وَأَقْبَلُوا عَلَيْهِمْ مَاذَا تَفْقِدُونَ",
  },
  {
    id: "1668",
    sura: "12",
    VerseIDAr: "72",
    ayatAR:
      "قَالُوا نَفْقِدُ صُوَاعَ الْمَلِكِ وَلِمَنْ جَاءَ بِهِ حِمْلُ بَعِيرٍ وَأَنَا بِهِ زَعِيمٌ",
  },
  {
    id: "1669",
    sura: "12",
    VerseIDAr: "73",
    ayatAR:
      "قَالُوا تَاللَّهِ لَقَدْ عَلِمْتُمْ مَا جِئْنَا لِنُفْسِدَ فِي الْأَرْضِ وَمَا كُنَّا سَارِقِينَ",
  },
  {
    id: "1670",
    sura: "12",
    VerseIDAr: "74",
    ayatAR: "قَالُوا فَمَا جَزَاؤُهُ إِنْ كُنْتُمْ كَاذِبِينَ",
  },
  {
    id: "1671",
    sura: "12",
    VerseIDAr: "75",
    ayatAR:
      "قَالُوا جَزَاؤُهُ مَنْ وُجِدَ فِي رَحْلِهِ فَهُوَ جَزَاؤُهُ ۚ كَذَٰلِكَ نَجْزِي الظَّالِمِينَ",
  },
  {
    id: "1672",
    sura: "12",
    VerseIDAr: "76",
    ayatAR:
      "فَبَدَأَ بِأَوْعِيَتِهِمْ قَبْلَ وِعَاءِ أَخِيهِ ثُمَّ اسْتَخْرَجَهَا مِنْ وِعَاءِ أَخِيهِ ۚ كَذَٰلِكَ كِدْنَا لِيُوسُفَ ۖ مَا كَانَ لِيَأْخُذَ أَخَاهُ فِي دِينِ الْمَلِكِ إِلَّا أَنْ يَشَاءَ اللَّهُ ۚ نَرْفَعُ دَرَجَاتٍ مَنْ نَشَاءُ ۗ وَفَوْقَ كُلِّ ذِي عِلْمٍ عَلِيمٌ",
  },
  {
    id: "1673",
    sura: "12",
    VerseIDAr: "77",
    ayatAR:
      "قَالُوا إِنْ يَسْرِقْ فَقَدْ سَرَقَ أَخٌ لَهُ مِنْ قَبْلُ ۚ فَأَسَرَّهَا يُوسُفُ فِي نَفْسِهِ وَلَمْ يُبْدِهَا لَهُمْ ۚ قَالَ أَنْتُمْ شَرٌّ مَكَانًا ۖ وَاللَّهُ أَعْلَمُ بِمَا تَصِفُونَ",
  },
  {
    id: "1674",
    sura: "12",
    VerseIDAr: "78",
    ayatAR:
      "قَالُوا يَا أَيُّهَا الْعَزِيزُ إِنَّ لَهُ أَبًا شَيْخًا كَبِيرًا فَخُذْ أَحَدَنَا مَكَانَهُ ۖ إِنَّا نَرَاكَ مِنَ الْمُحْسِنِينَ",
  },
  {
    id: "1675",
    sura: "12",
    VerseIDAr: "79",
    ayatAR:
      "قَالَ مَعَاذَ اللَّهِ أَنْ نَأْخُذَ إِلَّا مَنْ وَجَدْنَا مَتَاعَنَا عِنْدَهُ إِنَّا إِذًا لَظَالِمُونَ",
  },
  {
    id: "1676",
    sura: "12",
    VerseIDAr: "80",
    ayatAR:
      "فَلَمَّا اسْتَيْأَسُوا مِنْهُ خَلَصُوا نَجِيًّا ۖ قَالَ كَبِيرُهُمْ أَلَمْ تَعْلَمُوا أَنَّ أَبَاكُمْ قَدْ أَخَذَ عَلَيْكُمْ مَوْثِقًا مِنَ اللَّهِ وَمِنْ قَبْلُ مَا فَرَّطْتُمْ فِي يُوسُفَ ۖ فَلَنْ أَبْرَحَ الْأَرْضَ حَتَّىٰ يَأْذَنَ لِي أَبِي أَوْ يَحْكُمَ اللَّهُ لِي ۖ وَهُوَ خَيْرُ الْحَاكِمِينَ",
  },
  {
    id: "1677",
    sura: "12",
    VerseIDAr: "81",
    ayatAR:
      "ارْجِعُوا إِلَىٰ أَبِيكُمْ فَقُولُوا يَا أَبَانَا إِنَّ ابْنَكَ سَرَقَ وَمَا شَهِدْنَا إِلَّا بِمَا عَلِمْنَا وَمَا كُنَّا لِلْغَيْبِ حَافِظِينَ",
  },
  {
    id: "1678",
    sura: "12",
    VerseIDAr: "82",
    ayatAR:
      "وَاسْأَلِ الْقَرْيَةَ الَّتِي كُنَّا فِيهَا وَالْعِيرَ الَّتِي أَقْبَلْنَا فِيهَا ۖ وَإِنَّا لَصَادِقُونَ",
  },
  {
    id: "1679",
    sura: "12",
    VerseIDAr: "83",
    ayatAR:
      "قَالَ بَلْ سَوَّلَتْ لَكُمْ أَنْفُسُكُمْ أَمْرًا ۖ فَصَبْرٌ جَمِيلٌ ۖ عَسَى اللَّهُ أَنْ يَأْتِيَنِي بِهِمْ جَمِيعًا ۚ إِنَّهُ هُوَ الْعَلِيمُ الْحَكِيمُ",
  },
  {
    id: "1680",
    sura: "12",
    VerseIDAr: "84",
    ayatAR:
      "وَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَا أَسَفَىٰ عَلَىٰ يُوسُفَ وَابْيَضَّتْ عَيْنَاهُ مِنَ الْحُزْنِ فَهُوَ كَظِيمٌ",
  },
  {
    id: "1681",
    sura: "12",
    VerseIDAr: "85",
    ayatAR:
      "قَالُوا تَاللَّهِ تَفْتَأُ تَذْكُرُ يُوسُفَ حَتَّىٰ تَكُونَ حَرَضًا أَوْ تَكُونَ مِنَ الْهَالِكِينَ",
  },
  {
    id: "1682",
    sura: "12",
    VerseIDAr: "86",
    ayatAR:
      "قَالَ إِنَّمَا أَشْكُو بَثِّي وَحُزْنِي إِلَى اللَّهِ وَأَعْلَمُ مِنَ اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "1683",
    sura: "12",
    VerseIDAr: "87",
    ayatAR:
      "يَا بَنِيَّ اذْهَبُوا فَتَحَسَّسُوا مِنْ يُوسُفَ وَأَخِيهِ وَلَا تَيْأَسُوا مِنْ رَوْحِ اللَّهِ ۖ إِنَّهُ لَا يَيْأَسُ مِنْ رَوْحِ اللَّهِ إِلَّا الْقَوْمُ الْكَافِرُونَ",
  },
  {
    id: "1684",
    sura: "12",
    VerseIDAr: "88",
    ayatAR:
      "فَلَمَّا دَخَلُوا عَلَيْهِ قَالُوا يَا أَيُّهَا الْعَزِيزُ مَسَّنَا وَأَهْلَنَا الضُّرُّ وَجِئْنَا بِبِضَاعَةٍ مُزْجَاةٍ فَأَوْفِ لَنَا الْكَيْلَ وَتَصَدَّقْ عَلَيْنَا ۖ إِنَّ اللَّهَ يَجْزِي الْمُتَصَدِّقِينَ",
  },
  {
    id: "1685",
    sura: "12",
    VerseIDAr: "89",
    ayatAR:
      "قَالَ هَلْ عَلِمْتُمْ مَا فَعَلْتُمْ بِيُوسُفَ وَأَخِيهِ إِذْ أَنْتُمْ جَاهِلُونَ",
  },
  {
    id: "1686",
    sura: "12",
    VerseIDAr: "90",
    ayatAR:
      "قَالُوا أَإِنَّكَ لَأَنْتَ يُوسُفُ ۖ قَالَ أَنَا يُوسُفُ وَهَٰذَا أَخِي ۖ قَدْ مَنَّ اللَّهُ عَلَيْنَا ۖ إِنَّهُ مَنْ يَتَّقِ وَيَصْبِرْ فَإِنَّ اللَّهَ لَا يُضِيعُ أَجْرَ الْمُحْسِنِينَ",
  },
  {
    id: "1687",
    sura: "12",
    VerseIDAr: "91",
    ayatAR:
      "قَالُوا تَاللَّهِ لَقَدْ آثَرَكَ اللَّهُ عَلَيْنَا وَإِنْ كُنَّا لَخَاطِئِينَ",
  },
  {
    id: "1688",
    sura: "12",
    VerseIDAr: "92",
    ayatAR:
      "قَالَ لَا تَثْرِيبَ عَلَيْكُمُ الْيَوْمَ ۖ يَغْفِرُ اللَّهُ لَكُمْ ۖ وَهُوَ أَرْحَمُ الرَّاحِمِينَ",
  },
  {
    id: "1689",
    sura: "12",
    VerseIDAr: "93",
    ayatAR:
      "اذْهَبُوا بِقَمِيصِي هَٰذَا فَأَلْقُوهُ عَلَىٰ وَجْهِ أَبِي يَأْتِ بَصِيرًا وَأْتُونِي بِأَهْلِكُمْ أَجْمَعِينَ",
  },
  {
    id: "1690",
    sura: "12",
    VerseIDAr: "94",
    ayatAR:
      "وَلَمَّا فَصَلَتِ الْعِيرُ قَالَ أَبُوهُمْ إِنِّي لَأَجِدُ رِيحَ يُوسُفَ ۖ لَوْلَا أَنْ تُفَنِّدُونِ",
  },
  {
    id: "1691",
    sura: "12",
    VerseIDAr: "95",
    ayatAR: "قَالُوا تَاللَّهِ إِنَّكَ لَفِي ضَلَالِكَ الْقَدِيمِ",
  },
  {
    id: "1692",
    sura: "12",
    VerseIDAr: "96",
    ayatAR:
      "فَلَمَّا أَنْ جَاءَ الْبَشِيرُ أَلْقَاهُ عَلَىٰ وَجْهِهِ فَارْتَدَّ بَصِيرًا ۖ قَالَ أَلَمْ أَقُلْ لَكُمْ إِنِّي أَعْلَمُ مِنَ اللَّهِ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "1693",
    sura: "12",
    VerseIDAr: "97",
    ayatAR:
      "قَالُوا يَا أَبَانَا اسْتَغْفِرْ لَنَا ذُنُوبَنَا إِنَّا كُنَّا خَاطِئِينَ",
  },
  {
    id: "1694",
    sura: "12",
    VerseIDAr: "98",
    ayatAR:
      "قَالَ سَوْفَ أَسْتَغْفِرُ لَكُمْ رَبِّي ۖ إِنَّهُ هُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "1695",
    sura: "12",
    VerseIDAr: "99",
    ayatAR:
      "فَلَمَّا دَخَلُوا عَلَىٰ يُوسُفَ آوَىٰ إِلَيْهِ أَبَوَيْهِ وَقَالَ ادْخُلُوا مِصْرَ إِنْ شَاءَ اللَّهُ آمِنِينَ",
  },
  {
    id: "1696",
    sura: "12",
    VerseIDAr: "100",
    ayatAR:
      "وَرَفَعَ أَبَوَيْهِ عَلَى الْعَرْشِ وَخَرُّوا لَهُ سُجَّدًا ۖ وَقَالَ يَا أَبَتِ هَٰذَا تَأْوِيلُ رُؤْيَايَ مِنْ قَبْلُ قَدْ جَعَلَهَا رَبِّي حَقًّا ۖ وَقَدْ أَحْسَنَ بِي إِذْ أَخْرَجَنِي مِنَ السِّجْنِ وَجَاءَ بِكُمْ مِنَ الْبَدْوِ مِنْ بَعْدِ أَنْ نَزَغَ الشَّيْطَانُ بَيْنِي وَبَيْنَ إِخْوَتِي ۚ إِنَّ رَبِّي لَطِيفٌ لِمَا يَشَاءُ ۚ إِنَّهُ هُوَ الْعَلِيمُ الْحَكِيمُ",
  },
  {
    id: "1697",
    sura: "12",
    VerseIDAr: "101",
    ayatAR:
      "رَبِّ قَدْ آتَيْتَنِي مِنَ الْمُلْكِ وَعَلَّمْتَنِي مِنْ تَأْوِيلِ الْأَحَادِيثِ ۚ فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ أَنْتَ وَلِيِّي فِي الدُّنْيَا وَالْآخِرَةِ ۖ تَوَفَّنِي مُسْلِمًا وَأَلْحِقْنِي بِالصَّالِحِينَ",
  },
  {
    id: "1698",
    sura: "12",
    VerseIDAr: "102",
    ayatAR:
      "ذَٰلِكَ مِنْ أَنْبَاءِ الْغَيْبِ نُوحِيهِ إِلَيْكَ ۖ وَمَا كُنْتَ لَدَيْهِمْ إِذْ أَجْمَعُوا أَمْرَهُمْ وَهُمْ يَمْكُرُونَ",
  },
  {
    id: "1699",
    sura: "12",
    VerseIDAr: "103",
    ayatAR: "وَمَا أَكْثَرُ النَّاسِ وَلَوْ حَرَصْتَ بِمُؤْمِنِينَ",
  },
  {
    id: "1700",
    sura: "12",
    VerseIDAr: "104",
    ayatAR:
      "وَمَا تَسْأَلُهُمْ عَلَيْهِ مِنْ أَجْرٍ ۚ إِنْ هُوَ إِلَّا ذِكْرٌ لِلْعَالَمِينَ",
  },
  {
    id: "1701",
    sura: "12",
    VerseIDAr: "105",
    ayatAR:
      "وَكَأَيِّنْ مِنْ آيَةٍ فِي السَّمَاوَاتِ وَالْأَرْضِ يَمُرُّونَ عَلَيْهَا وَهُمْ عَنْهَا مُعْرِضُونَ",
  },
  {
    id: "1702",
    sura: "12",
    VerseIDAr: "106",
    ayatAR: "وَمَا يُؤْمِنُ أَكْثَرُهُمْ بِاللَّهِ إِلَّا وَهُمْ مُشْرِكُونَ",
  },
  {
    id: "1703",
    sura: "12",
    VerseIDAr: "107",
    ayatAR:
      "أَفَأَمِنُوا أَنْ تَأْتِيَهُمْ غَاشِيَةٌ مِنْ عَذَابِ اللَّهِ أَوْ تَأْتِيَهُمُ السَّاعَةُ بَغْتَةً وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "1704",
    sura: "12",
    VerseIDAr: "108",
    ayatAR:
      "قُلْ هَٰذِهِ سَبِيلِي أَدْعُو إِلَى اللَّهِ ۚ عَلَىٰ بَصِيرَةٍ أَنَا وَمَنِ اتَّبَعَنِي ۖ وَسُبْحَانَ اللَّهِ وَمَا أَنَا مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "1705",
    sura: "12",
    VerseIDAr: "109",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ قَبْلِكَ إِلَّا رِجَالًا نُوحِي إِلَيْهِمْ مِنْ أَهْلِ الْقُرَىٰ ۗ أَفَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلِهِمْ ۗ وَلَدَارُ الْآخِرَةِ خَيْرٌ لِلَّذِينَ اتَّقَوْا ۗ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "1706",
    sura: "12",
    VerseIDAr: "110",
    ayatAR:
      "حَتَّىٰ إِذَا اسْتَيْأَسَ الرُّسُلُ وَظَنُّوا أَنَّهُمْ قَدْ كُذِبُوا جَاءَهُمْ نَصْرُنَا فَنُجِّيَ مَنْ نَشَاءُ ۖ وَلَا يُرَدُّ بَأْسُنَا عَنِ الْقَوْمِ الْمُجْرِمِينَ",
  },
  {
    id: "1707",
    sura: "12",
    VerseIDAr: "111",
    ayatAR:
      "لَقَدْ كَانَ فِي قَصَصِهِمْ عِبْرَةٌ لِأُولِي الْأَلْبَابِ ۗ مَا كَانَ حَدِيثًا يُفْتَرَىٰ وَلَٰكِنْ تَصْدِيقَ الَّذِي بَيْنَ يَدَيْهِ وَتَفْصِيلَ كُلِّ شَيْءٍ وَهُدًى وَرَحْمَةً لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1708",
    sura: "13",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ المر ۚ تِلْكَ آيَاتُ الْكِتَابِ ۗ وَالَّذِي أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ الْحَقُّ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يُؤْمِنُونَ",
  },
  {
    id: "1709",
    sura: "13",
    VerseIDAr: "2",
    ayatAR:
      "اللَّهُ الَّذِي رَفَعَ السَّمَاوَاتِ بِغَيْرِ عَمَدٍ تَرَوْنَهَا ۖ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ ۖ وَسَخَّرَ الشَّمْسَ وَالْقَمَرَ ۖ كُلٌّ يَجْرِي لِأَجَلٍ مُسَمًّى ۚ يُدَبِّرُ الْأَمْرَ يُفَصِّلُ الْآيَاتِ لَعَلَّكُمْ بِلِقَاءِ رَبِّكُمْ تُوقِنُونَ",
  },
  {
    id: "1710",
    sura: "13",
    VerseIDAr: "3",
    ayatAR:
      "وَهُوَ الَّذِي مَدَّ الْأَرْضَ وَجَعَلَ فِيهَا رَوَاسِيَ وَأَنْهَارًا ۖ وَمِنْ كُلِّ الثَّمَرَاتِ جَعَلَ فِيهَا زَوْجَيْنِ اثْنَيْنِ ۖ يُغْشِي اللَّيْلَ النَّهَارَ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "1711",
    sura: "13",
    VerseIDAr: "4",
    ayatAR:
      "وَفِي الْأَرْضِ قِطَعٌ مُتَجَاوِرَاتٌ وَجَنَّاتٌ مِنْ أَعْنَابٍ وَزَرْعٌ وَنَخِيلٌ صِنْوَانٌ وَغَيْرُ صِنْوَانٍ يُسْقَىٰ بِمَاءٍ وَاحِدٍ وَنُفَضِّلُ بَعْضَهَا عَلَىٰ بَعْضٍ فِي الْأُكُلِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "1712",
    sura: "13",
    VerseIDAr: "5",
    ayatAR:
      "وَإِنْ تَعْجَبْ فَعَجَبٌ قَوْلُهُمْ أَإِذَا كُنَّا تُرَابًا أَإِنَّا لَفِي خَلْقٍ جَدِيدٍ ۗ أُولَٰئِكَ الَّذِينَ كَفَرُوا بِرَبِّهِمْ ۖ وَأُولَٰئِكَ الْأَغْلَالُ فِي أَعْنَاقِهِمْ ۖ وَأُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "1713",
    sura: "13",
    VerseIDAr: "6",
    ayatAR:
      "وَيَسْتَعْجِلُونَكَ بِالسَّيِّئَةِ قَبْلَ الْحَسَنَةِ وَقَدْ خَلَتْ مِنْ قَبْلِهِمُ الْمَثُلَاتُ ۗ وَإِنَّ رَبَّكَ لَذُو مَغْفِرَةٍ لِلنَّاسِ عَلَىٰ ظُلْمِهِمْ ۖ وَإِنَّ رَبَّكَ لَشَدِيدُ الْعِقَابِ",
  },
  {
    id: "1714",
    sura: "13",
    VerseIDAr: "7",
    ayatAR:
      "وَيَقُولُ الَّذِينَ كَفَرُوا لَوْلَا أُنْزِلَ عَلَيْهِ آيَةٌ مِنْ رَبِّهِ ۗ إِنَّمَا أَنْتَ مُنْذِرٌ ۖ وَلِكُلِّ قَوْمٍ هَادٍ",
  },
  {
    id: "1715",
    sura: "13",
    VerseIDAr: "8",
    ayatAR:
      "اللَّهُ يَعْلَمُ مَا تَحْمِلُ كُلُّ أُنْثَىٰ وَمَا تَغِيضُ الْأَرْحَامُ وَمَا تَزْدَادُ ۖ وَكُلُّ شَيْءٍ عِنْدَهُ بِمِقْدَارٍ",
  },
  {
    id: "1716",
    sura: "13",
    VerseIDAr: "9",
    ayatAR: "عَالِمُ الْغَيْبِ وَالشَّهَادَةِ الْكَبِيرُ الْمُتَعَالِ",
  },
  {
    id: "1717",
    sura: "13",
    VerseIDAr: "10",
    ayatAR:
      "سَوَاءٌ مِنْكُمْ مَنْ أَسَرَّ الْقَوْلَ وَمَنْ جَهَرَ بِهِ وَمَنْ هُوَ مُسْتَخْفٍ بِاللَّيْلِ وَسَارِبٌ بِالنَّهَارِ",
  },
  {
    id: "1718",
    sura: "13",
    VerseIDAr: "11",
    ayatAR:
      "لَهُ مُعَقِّبَاتٌ مِنْ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِ يَحْفَظُونَهُ مِنْ أَمْرِ اللَّهِ ۗ إِنَّ اللَّهَ لَا يُغَيِّرُ مَا بِقَوْمٍ حَتَّىٰ يُغَيِّرُوا مَا بِأَنْفُسِهِمْ ۗ وَإِذَا أَرَادَ اللَّهُ بِقَوْمٍ سُوءًا فَلَا مَرَدَّ لَهُ ۚ وَمَا لَهُمْ مِنْ دُونِهِ مِنْ وَالٍ",
  },
  {
    id: "1719",
    sura: "13",
    VerseIDAr: "12",
    ayatAR:
      "هُوَ الَّذِي يُرِيكُمُ الْبَرْقَ خَوْفًا وَطَمَعًا وَيُنْشِئُ السَّحَابَ الثِّقَالَ",
  },
  {
    id: "1720",
    sura: "13",
    VerseIDAr: "13",
    ayatAR:
      "وَيُسَبِّحُ الرَّعْدُ بِحَمْدِهِ وَالْمَلَائِكَةُ مِنْ خِيفَتِهِ وَيُرْسِلُ الصَّوَاعِقَ فَيُصِيبُ بِهَا مَنْ يَشَاءُ وَهُمْ يُجَادِلُونَ فِي اللَّهِ وَهُوَ شَدِيدُ الْمِحَالِ",
  },
  {
    id: "1721",
    sura: "13",
    VerseIDAr: "14",
    ayatAR:
      "لَهُ دَعْوَةُ الْحَقِّ ۖ وَالَّذِينَ يَدْعُونَ مِنْ دُونِهِ لَا يَسْتَجِيبُونَ لَهُمْ بِشَيْءٍ إِلَّا كَبَاسِطِ كَفَّيْهِ إِلَى الْمَاءِ لِيَبْلُغَ فَاهُ وَمَا هُوَ بِبَالِغِهِ ۚ وَمَا دُعَاءُ الْكَافِرِينَ إِلَّا فِي ضَلَالٍ",
  },
  {
    id: "1722",
    sura: "13",
    VerseIDAr: "15",
    ayatAR:
      "وَلِلَّهِ يَسْجُدُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ طَوْعًا وَكَرْهًا وَظِلَالُهُمْ بِالْغُدُوِّ وَالْآصَالِ ۩",
  },
  {
    id: "1723",
    sura: "13",
    VerseIDAr: "16",
    ayatAR:
      "قُلْ مَنْ رَبُّ السَّمَاوَاتِ وَالْأَرْضِ قُلِ اللَّهُ ۚ قُلْ أَفَاتَّخَذْتُمْ مِنْ دُونِهِ أَوْلِيَاءَ لَا يَمْلِكُونَ لِأَنْفُسِهِمْ نَفْعًا وَلَا ضَرًّا ۚ قُلْ هَلْ يَسْتَوِي الْأَعْمَىٰ وَالْبَصِيرُ أَمْ هَلْ تَسْتَوِي الظُّلُمَاتُ وَالنُّورُ ۗ أَمْ جَعَلُوا لِلَّهِ شُرَكَاءَ خَلَقُوا كَخَلْقِهِ فَتَشَابَهَ الْخَلْقُ عَلَيْهِمْ ۚ قُلِ اللَّهُ خَالِقُ كُلِّ شَيْءٍ وَهُوَ الْوَاحِدُ الْقَهَّارُ",
  },
  {
    id: "1724",
    sura: "13",
    VerseIDAr: "17",
    ayatAR:
      "أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَسَالَتْ أَوْدِيَةٌ بِقَدَرِهَا فَاحْتَمَلَ السَّيْلُ زَبَدًا رَابِيًا ۚ وَمِمَّا يُوقِدُونَ عَلَيْهِ فِي النَّارِ ابْتِغَاءَ حِلْيَةٍ أَوْ مَتَاعٍ زَبَدٌ مِثْلُهُ ۚ كَذَٰلِكَ يَضْرِبُ اللَّهُ الْحَقَّ وَالْبَاطِلَ ۚ فَأَمَّا الزَّبَدُ فَيَذْهَبُ جُفَاءً ۖ وَأَمَّا مَا يَنْفَعُ النَّاسَ فَيَمْكُثُ فِي الْأَرْضِ ۚ كَذَٰلِكَ يَضْرِبُ اللَّهُ الْأَمْثَالَ",
  },
  {
    id: "1725",
    sura: "13",
    VerseIDAr: "18",
    ayatAR:
      "لِلَّذِينَ اسْتَجَابُوا لِرَبِّهِمُ الْحُسْنَىٰ ۚ وَالَّذِينَ لَمْ يَسْتَجِيبُوا لَهُ لَوْ أَنَّ لَهُمْ مَا فِي الْأَرْضِ جَمِيعًا وَمِثْلَهُ مَعَهُ لَافْتَدَوْا بِهِ ۚ أُولَٰئِكَ لَهُمْ سُوءُ الْحِسَابِ وَمَأْوَاهُمْ جَهَنَّمُ ۖ وَبِئْسَ الْمِهَادُ",
  },
  {
    id: "1726",
    sura: "13",
    VerseIDAr: "19",
    ayatAR:
      "أَفَمَنْ يَعْلَمُ أَنَّمَا أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ الْحَقُّ كَمَنْ هُوَ أَعْمَىٰ ۚ إِنَّمَا يَتَذَكَّرُ أُولُو الْأَلْبَابِ",
  },
  {
    id: "1727",
    sura: "13",
    VerseIDAr: "20",
    ayatAR: "الَّذِينَ يُوفُونَ بِعَهْدِ اللَّهِ وَلَا يَنْقُضُونَ الْمِيثَاقَ",
  },
  {
    id: "1728",
    sura: "13",
    VerseIDAr: "21",
    ayatAR:
      "وَالَّذِينَ يَصِلُونَ مَا أَمَرَ اللَّهُ بِهِ أَنْ يُوصَلَ وَيَخْشَوْنَ رَبَّهُمْ وَيَخَافُونَ سُوءَ الْحِسَابِ",
  },
  {
    id: "1729",
    sura: "13",
    VerseIDAr: "22",
    ayatAR:
      "وَالَّذِينَ صَبَرُوا ابْتِغَاءَ وَجْهِ رَبِّهِمْ وَأَقَامُوا الصَّلَاةَ وَأَنْفَقُوا مِمَّا رَزَقْنَاهُمْ سِرًّا وَعَلَانِيَةً وَيَدْرَءُونَ بِالْحَسَنَةِ السَّيِّئَةَ أُولَٰئِكَ لَهُمْ عُقْبَى الدَّارِ",
  },
  {
    id: "1730",
    sura: "13",
    VerseIDAr: "23",
    ayatAR:
      "جَنَّاتُ عَدْنٍ يَدْخُلُونَهَا وَمَنْ صَلَحَ مِنْ آبَائِهِمْ وَأَزْوَاجِهِمْ وَذُرِّيَّاتِهِمْ ۖ وَالْمَلَائِكَةُ يَدْخُلُونَ عَلَيْهِمْ مِنْ كُلِّ بَابٍ",
  },
  {
    id: "1731",
    sura: "13",
    VerseIDAr: "24",
    ayatAR: "سَلَامٌ عَلَيْكُمْ بِمَا صَبَرْتُمْ ۚ فَنِعْمَ عُقْبَى الدَّارِ",
  },
  {
    id: "1732",
    sura: "13",
    VerseIDAr: "25",
    ayatAR:
      "وَالَّذِينَ يَنْقُضُونَ عَهْدَ اللَّهِ مِنْ بَعْدِ مِيثَاقِهِ وَيَقْطَعُونَ مَا أَمَرَ اللَّهُ بِهِ أَنْ يُوصَلَ وَيُفْسِدُونَ فِي الْأَرْضِ ۙ أُولَٰئِكَ لَهُمُ اللَّعْنَةُ وَلَهُمْ سُوءُ الدَّارِ",
  },
  {
    id: "1733",
    sura: "13",
    VerseIDAr: "26",
    ayatAR:
      "اللَّهُ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ ۚ وَفَرِحُوا بِالْحَيَاةِ الدُّنْيَا وَمَا الْحَيَاةُ الدُّنْيَا فِي الْآخِرَةِ إِلَّا مَتَاعٌ",
  },
  {
    id: "1734",
    sura: "13",
    VerseIDAr: "27",
    ayatAR:
      "وَيَقُولُ الَّذِينَ كَفَرُوا لَوْلَا أُنْزِلَ عَلَيْهِ آيَةٌ مِنْ رَبِّهِ ۗ قُلْ إِنَّ اللَّهَ يُضِلُّ مَنْ يَشَاءُ وَيَهْدِي إِلَيْهِ مَنْ أَنَابَ",
  },
  {
    id: "1735",
    sura: "13",
    VerseIDAr: "28",
    ayatAR:
      "الَّذِينَ آمَنُوا وَتَطْمَئِنُّ قُلُوبُهُمْ بِذِكْرِ اللَّهِ ۗ أَلَا بِذِكْرِ اللَّهِ تَطْمَئِنُّ الْقُلُوبُ",
  },
  {
    id: "1736",
    sura: "13",
    VerseIDAr: "29",
    ayatAR:
      "الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ طُوبَىٰ لَهُمْ وَحُسْنُ مَآبٍ",
  },
  {
    id: "1737",
    sura: "13",
    VerseIDAr: "30",
    ayatAR:
      "كَذَٰلِكَ أَرْسَلْنَاكَ فِي أُمَّةٍ قَدْ خَلَتْ مِنْ قَبْلِهَا أُمَمٌ لِتَتْلُوَ عَلَيْهِمُ الَّذِي أَوْحَيْنَا إِلَيْكَ وَهُمْ يَكْفُرُونَ بِالرَّحْمَٰنِ ۚ قُلْ هُوَ رَبِّي لَا إِلَٰهَ إِلَّا هُوَ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ مَتَابِ",
  },
  {
    id: "1738",
    sura: "13",
    VerseIDAr: "31",
    ayatAR:
      "وَلَوْ أَنَّ قُرْآنًا سُيِّرَتْ بِهِ الْجِبَالُ أَوْ قُطِّعَتْ بِهِ الْأَرْضُ أَوْ كُلِّمَ بِهِ الْمَوْتَىٰ ۗ بَلْ لِلَّهِ الْأَمْرُ جَمِيعًا ۗ أَفَلَمْ يَيْأَسِ الَّذِينَ آمَنُوا أَنْ لَوْ يَشَاءُ اللَّهُ لَهَدَى النَّاسَ جَمِيعًا ۗ وَلَا يَزَالُ الَّذِينَ كَفَرُوا تُصِيبُهُمْ بِمَا صَنَعُوا قَارِعَةٌ أَوْ تَحُلُّ قَرِيبًا مِنْ دَارِهِمْ حَتَّىٰ يَأْتِيَ وَعْدُ اللَّهِ ۚ إِنَّ اللَّهَ لَا يُخْلِفُ الْمِيعَادَ",
  },
  {
    id: "1739",
    sura: "13",
    VerseIDAr: "32",
    ayatAR:
      "وَلَقَدِ اسْتُهْزِئَ بِرُسُلٍ مِنْ قَبْلِكَ فَأَمْلَيْتُ لِلَّذِينَ كَفَرُوا ثُمَّ أَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ عِقَابِ",
  },
  {
    id: "1740",
    sura: "13",
    VerseIDAr: "33",
    ayatAR:
      "أَفَمَنْ هُوَ قَائِمٌ عَلَىٰ كُلِّ نَفْسٍ بِمَا كَسَبَتْ ۗ وَجَعَلُوا لِلَّهِ شُرَكَاءَ قُلْ سَمُّوهُمْ ۚ أَمْ تُنَبِّئُونَهُ بِمَا لَا يَعْلَمُ فِي الْأَرْضِ أَمْ بِظَاهِرٍ مِنَ الْقَوْلِ ۗ بَلْ زُيِّنَ لِلَّذِينَ كَفَرُوا مَكْرُهُمْ وَصُدُّوا عَنِ السَّبِيلِ ۗ وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ هَادٍ",
  },
  {
    id: "1741",
    sura: "13",
    VerseIDAr: "34",
    ayatAR:
      "لَهُمْ عَذَابٌ فِي الْحَيَاةِ الدُّنْيَا ۖ وَلَعَذَابُ الْآخِرَةِ أَشَقُّ ۖ وَمَا لَهُمْ مِنَ اللَّهِ مِنْ وَاقٍ",
  },
  {
    id: "1742",
    sura: "13",
    VerseIDAr: "35",
    ayatAR:
      "مَثَلُ الْجَنَّةِ الَّتِي وُعِدَ الْمُتَّقُونَ ۖ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ أُكُلُهَا دَائِمٌ وَظِلُّهَا ۚ تِلْكَ عُقْبَى الَّذِينَ اتَّقَوْا ۖ وَعُقْبَى الْكَافِرِينَ النَّارُ",
  },
  {
    id: "1743",
    sura: "13",
    VerseIDAr: "36",
    ayatAR:
      "وَالَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يَفْرَحُونَ بِمَا أُنْزِلَ إِلَيْكَ ۖ وَمِنَ الْأَحْزَابِ مَنْ يُنْكِرُ بَعْضَهُ ۚ قُلْ إِنَّمَا أُمِرْتُ أَنْ أَعْبُدَ اللَّهَ وَلَا أُشْرِكَ بِهِ ۚ إِلَيْهِ أَدْعُو وَإِلَيْهِ مَآبِ",
  },
  {
    id: "1744",
    sura: "13",
    VerseIDAr: "37",
    ayatAR:
      "وَكَذَٰلِكَ أَنْزَلْنَاهُ حُكْمًا عَرَبِيًّا ۚ وَلَئِنِ اتَّبَعْتَ أَهْوَاءَهُمْ بَعْدَمَا جَاءَكَ مِنَ الْعِلْمِ مَا لَكَ مِنَ اللَّهِ مِنْ وَلِيٍّ وَلَا وَاقٍ",
  },
  {
    id: "1745",
    sura: "13",
    VerseIDAr: "38",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا رُسُلًا مِنْ قَبْلِكَ وَجَعَلْنَا لَهُمْ أَزْوَاجًا وَذُرِّيَّةً ۚ وَمَا كَانَ لِرَسُولٍ أَنْ يَأْتِيَ بِآيَةٍ إِلَّا بِإِذْنِ اللَّهِ ۗ لِكُلِّ أَجَلٍ كِتَابٌ",
  },
  {
    id: "1746",
    sura: "13",
    VerseIDAr: "39",
    ayatAR:
      "يَمْحُو اللَّهُ مَا يَشَاءُ وَيُثْبِتُ ۖ وَعِنْدَهُ أُمُّ الْكِتَابِ",
  },
  {
    id: "1747",
    sura: "13",
    VerseIDAr: "40",
    ayatAR:
      "وَإِنْ مَا نُرِيَنَّكَ بَعْضَ الَّذِي نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِنَّمَا عَلَيْكَ الْبَلَاغُ وَعَلَيْنَا الْحِسَابُ",
  },
  {
    id: "1748",
    sura: "13",
    VerseIDAr: "41",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّا نَأْتِي الْأَرْضَ نَنْقُصُهَا مِنْ أَطْرَافِهَا ۚ وَاللَّهُ يَحْكُمُ لَا مُعَقِّبَ لِحُكْمِهِ ۚ وَهُوَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "1749",
    sura: "13",
    VerseIDAr: "42",
    ayatAR:
      "وَقَدْ مَكَرَ الَّذِينَ مِنْ قَبْلِهِمْ فَلِلَّهِ الْمَكْرُ جَمِيعًا ۖ يَعْلَمُ مَا تَكْسِبُ كُلُّ نَفْسٍ ۗ وَسَيَعْلَمُ الْكُفَّارُ لِمَنْ عُقْبَى الدَّارِ",
  },
  {
    id: "1750",
    sura: "13",
    VerseIDAr: "43",
    ayatAR:
      "وَيَقُولُ الَّذِينَ كَفَرُوا لَسْتَ مُرْسَلًا ۚ قُلْ كَفَىٰ بِاللَّهِ شَهِيدًا بَيْنِي وَبَيْنَكُمْ وَمَنْ عِنْدَهُ عِلْمُ الْكِتَابِ",
  },
  {
    id: "1751",
    sura: "14",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الر ۚ كِتَابٌ أَنْزَلْنَاهُ إِلَيْكَ لِتُخْرِجَ النَّاسَ مِنَ الظُّلُمَاتِ إِلَى النُّورِ بِإِذْنِ رَبِّهِمْ إِلَىٰ صِرَاطِ الْعَزِيزِ الْحَمِيدِ",
  },
  {
    id: "1752",
    sura: "14",
    VerseIDAr: "2",
    ayatAR:
      "اللَّهِ الَّذِي لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَوَيْلٌ لِلْكَافِرِينَ مِنْ عَذَابٍ شَدِيدٍ",
  },
  {
    id: "1753",
    sura: "14",
    VerseIDAr: "3",
    ayatAR:
      "الَّذِينَ يَسْتَحِبُّونَ الْحَيَاةَ الدُّنْيَا عَلَى الْآخِرَةِ وَيَصُدُّونَ عَنْ سَبِيلِ اللَّهِ وَيَبْغُونَهَا عِوَجًا ۚ أُولَٰئِكَ فِي ضَلَالٍ بَعِيدٍ",
  },
  {
    id: "1754",
    sura: "14",
    VerseIDAr: "4",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ رَسُولٍ إِلَّا بِلِسَانِ قَوْمِهِ لِيُبَيِّنَ لَهُمْ ۖ فَيُضِلُّ اللَّهُ مَنْ يَشَاءُ وَيَهْدِي مَنْ يَشَاءُ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "1755",
    sura: "14",
    VerseIDAr: "5",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِآيَاتِنَا أَنْ أَخْرِجْ قَوْمَكَ مِنَ الظُّلُمَاتِ إِلَى النُّورِ وَذَكِّرْهُمْ بِأَيَّامِ اللَّهِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِكُلِّ صَبَّارٍ شَكُورٍ",
  },
  {
    id: "1756",
    sura: "14",
    VerseIDAr: "6",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ اذْكُرُوا نِعْمَةَ اللَّهِ عَلَيْكُمْ إِذْ أَنْجَاكُمْ مِنْ آلِ فِرْعَوْنَ يَسُومُونَكُمْ سُوءَ الْعَذَابِ وَيُذَبِّحُونَ أَبْنَاءَكُمْ وَيَسْتَحْيُونَ نِسَاءَكُمْ ۚ وَفِي ذَٰلِكُمْ بَلَاءٌ مِنْ رَبِّكُمْ عَظِيمٌ",
  },
  {
    id: "1757",
    sura: "14",
    VerseIDAr: "7",
    ayatAR:
      "وَإِذْ تَأَذَّنَ رَبُّكُمْ لَئِنْ شَكَرْتُمْ لَأَزِيدَنَّكُمْ ۖ وَلَئِنْ كَفَرْتُمْ إِنَّ عَذَابِي لَشَدِيدٌ",
  },
  {
    id: "1758",
    sura: "14",
    VerseIDAr: "8",
    ayatAR:
      "وَقَالَ مُوسَىٰ إِنْ تَكْفُرُوا أَنْتُمْ وَمَنْ فِي الْأَرْضِ جَمِيعًا فَإِنَّ اللَّهَ لَغَنِيٌّ حَمِيدٌ",
  },
  {
    id: "1759",
    sura: "14",
    VerseIDAr: "9",
    ayatAR:
      "أَلَمْ يَأْتِكُمْ نَبَأُ الَّذِينَ مِنْ قَبْلِكُمْ قَوْمِ نُوحٍ وَعَادٍ وَثَمُودَ ۛ وَالَّذِينَ مِنْ بَعْدِهِمْ ۛ لَا يَعْلَمُهُمْ إِلَّا اللَّهُ ۚ جَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ فَرَدُّوا أَيْدِيَهُمْ فِي أَفْوَاهِهِمْ وَقَالُوا إِنَّا كَفَرْنَا بِمَا أُرْسِلْتُمْ بِهِ وَإِنَّا لَفِي شَكٍّ مِمَّا تَدْعُونَنَا إِلَيْهِ مُرِيبٍ",
  },
  {
    id: "1760",
    sura: "14",
    VerseIDAr: "10",
    ayatAR:
      "قَالَتْ رُسُلُهُمْ أَفِي اللَّهِ شَكٌّ فَاطِرِ السَّمَاوَاتِ وَالْأَرْضِ ۖ يَدْعُوكُمْ لِيَغْفِرَ لَكُمْ مِنْ ذُنُوبِكُمْ وَيُؤَخِّرَكُمْ إِلَىٰ أَجَلٍ مُسَمًّى ۚ قَالُوا إِنْ أَنْتُمْ إِلَّا بَشَرٌ مِثْلُنَا تُرِيدُونَ أَنْ تَصُدُّونَا عَمَّا كَانَ يَعْبُدُ آبَاؤُنَا فَأْتُونَا بِسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "1761",
    sura: "14",
    VerseIDAr: "11",
    ayatAR:
      "قَالَتْ لَهُمْ رُسُلُهُمْ إِنْ نَحْنُ إِلَّا بَشَرٌ مِثْلُكُمْ وَلَٰكِنَّ اللَّهَ يَمُنُّ عَلَىٰ مَنْ يَشَاءُ مِنْ عِبَادِهِ ۖ وَمَا كَانَ لَنَا أَنْ نَأْتِيَكُمْ بِسُلْطَانٍ إِلَّا بِإِذْنِ اللَّهِ ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "1762",
    sura: "14",
    VerseIDAr: "12",
    ayatAR:
      "وَمَا لَنَا أَلَّا نَتَوَكَّلَ عَلَى اللَّهِ وَقَدْ هَدَانَا سُبُلَنَا ۚ وَلَنَصْبِرَنَّ عَلَىٰ مَا آذَيْتُمُونَا ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُتَوَكِّلُونَ",
  },
  {
    id: "1763",
    sura: "14",
    VerseIDAr: "13",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لِرُسُلِهِمْ لَنُخْرِجَنَّكُمْ مِنْ أَرْضِنَا أَوْ لَتَعُودُنَّ فِي مِلَّتِنَا ۖ فَأَوْحَىٰ إِلَيْهِمْ رَبُّهُمْ لَنُهْلِكَنَّ الظَّالِمِينَ",
  },
  {
    id: "1764",
    sura: "14",
    VerseIDAr: "14",
    ayatAR:
      "وَلَنُسْكِنَنَّكُمُ الْأَرْضَ مِنْ بَعْدِهِمْ ۚ ذَٰلِكَ لِمَنْ خَافَ مَقَامِي وَخَافَ وَعِيدِ",
  },
  {
    id: "1765",
    sura: "14",
    VerseIDAr: "15",
    ayatAR: "وَاسْتَفْتَحُوا وَخَابَ كُلُّ جَبَّارٍ عَنِيدٍ",
  },
  {
    id: "1766",
    sura: "14",
    VerseIDAr: "16",
    ayatAR: "مِنْ وَرَائِهِ جَهَنَّمُ وَيُسْقَىٰ مِنْ مَاءٍ صَدِيدٍ",
  },
  {
    id: "1767",
    sura: "14",
    VerseIDAr: "17",
    ayatAR:
      "يَتَجَرَّعُهُ وَلَا يَكَادُ يُسِيغُهُ وَيَأْتِيهِ الْمَوْتُ مِنْ كُلِّ مَكَانٍ وَمَا هُوَ بِمَيِّتٍ ۖ وَمِنْ وَرَائِهِ عَذَابٌ غَلِيظٌ",
  },
  {
    id: "1768",
    sura: "14",
    VerseIDAr: "18",
    ayatAR:
      "مَثَلُ الَّذِينَ كَفَرُوا بِرَبِّهِمْ ۖ أَعْمَالُهُمْ كَرَمَادٍ اشْتَدَّتْ بِهِ الرِّيحُ فِي يَوْمٍ عَاصِفٍ ۖ لَا يَقْدِرُونَ مِمَّا كَسَبُوا عَلَىٰ شَيْءٍ ۚ ذَٰلِكَ هُوَ الضَّلَالُ الْبَعِيدُ",
  },
  {
    id: "1769",
    sura: "14",
    VerseIDAr: "19",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ ۚ إِنْ يَشَأْ يُذْهِبْكُمْ وَيَأْتِ بِخَلْقٍ جَدِيدٍ",
  },
  {
    id: "1770",
    sura: "14",
    VerseIDAr: "20",
    ayatAR: "وَمَا ذَٰلِكَ عَلَى اللَّهِ بِعَزِيزٍ",
  },
  {
    id: "1771",
    sura: "14",
    VerseIDAr: "21",
    ayatAR:
      "وَبَرَزُوا لِلَّهِ جَمِيعًا فَقَالَ الضُّعَفَاءُ لِلَّذِينَ اسْتَكْبَرُوا إِنَّا كُنَّا لَكُمْ تَبَعًا فَهَلْ أَنْتُمْ مُغْنُونَ عَنَّا مِنْ عَذَابِ اللَّهِ مِنْ شَيْءٍ ۚ قَالُوا لَوْ هَدَانَا اللَّهُ لَهَدَيْنَاكُمْ ۖ سَوَاءٌ عَلَيْنَا أَجَزِعْنَا أَمْ صَبَرْنَا مَا لَنَا مِنْ مَحِيصٍ",
  },
  {
    id: "1772",
    sura: "14",
    VerseIDAr: "22",
    ayatAR:
      "وَقَالَ الشَّيْطَانُ لَمَّا قُضِيَ الْأَمْرُ إِنَّ اللَّهَ وَعَدَكُمْ وَعْدَ الْحَقِّ وَوَعَدْتُكُمْ فَأَخْلَفْتُكُمْ ۖ وَمَا كَانَ لِيَ عَلَيْكُمْ مِنْ سُلْطَانٍ إِلَّا أَنْ دَعَوْتُكُمْ فَاسْتَجَبْتُمْ لِي ۖ فَلَا تَلُومُونِي وَلُومُوا أَنْفُسَكُمْ ۖ مَا أَنَا بِمُصْرِخِكُمْ وَمَا أَنْتُمْ بِمُصْرِخِيَّ ۖ إِنِّي كَفَرْتُ بِمَا أَشْرَكْتُمُونِ مِنْ قَبْلُ ۗ إِنَّ الظَّالِمِينَ لَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1773",
    sura: "14",
    VerseIDAr: "23",
    ayatAR:
      "وَأُدْخِلَ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا بِإِذْنِ رَبِّهِمْ ۖ تَحِيَّتُهُمْ فِيهَا سَلَامٌ",
  },
  {
    id: "1774",
    sura: "14",
    VerseIDAr: "24",
    ayatAR:
      "أَلَمْ تَرَ كَيْفَ ضَرَبَ اللَّهُ مَثَلًا كَلِمَةً طَيِّبَةً كَشَجَرَةٍ طَيِّبَةٍ أَصْلُهَا ثَابِتٌ وَفَرْعُهَا فِي السَّمَاءِ",
  },
  {
    id: "1775",
    sura: "14",
    VerseIDAr: "25",
    ayatAR:
      "تُؤْتِي أُكُلَهَا كُلَّ حِينٍ بِإِذْنِ رَبِّهَا ۗ وَيَضْرِبُ اللَّهُ الْأَمْثَالَ لِلنَّاسِ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "1776",
    sura: "14",
    VerseIDAr: "26",
    ayatAR:
      "وَمَثَلُ كَلِمَةٍ خَبِيثَةٍ كَشَجَرَةٍ خَبِيثَةٍ اجْتُثَّتْ مِنْ فَوْقِ الْأَرْضِ مَا لَهَا مِنْ قَرَارٍ",
  },
  {
    id: "1777",
    sura: "14",
    VerseIDAr: "27",
    ayatAR:
      "يُثَبِّتُ اللَّهُ الَّذِينَ آمَنُوا بِالْقَوْلِ الثَّابِتِ فِي الْحَيَاةِ الدُّنْيَا وَفِي الْآخِرَةِ ۖ وَيُضِلُّ اللَّهُ الظَّالِمِينَ ۚ وَيَفْعَلُ اللَّهُ مَا يَشَاءُ",
  },
  {
    id: "1778",
    sura: "14",
    VerseIDAr: "28",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ بَدَّلُوا نِعْمَتَ اللَّهِ كُفْرًا وَأَحَلُّوا قَوْمَهُمْ دَارَ الْبَوَارِ",
  },
  {
    id: "1779",
    sura: "14",
    VerseIDAr: "29",
    ayatAR: "جَهَنَّمَ يَصْلَوْنَهَا ۖ وَبِئْسَ الْقَرَارُ",
  },
  {
    id: "1780",
    sura: "14",
    VerseIDAr: "30",
    ayatAR:
      "وَجَعَلُوا لِلَّهِ أَنْدَادًا لِيُضِلُّوا عَنْ سَبِيلِهِ ۗ قُلْ تَمَتَّعُوا فَإِنَّ مَصِيرَكُمْ إِلَى النَّارِ",
  },
  {
    id: "1781",
    sura: "14",
    VerseIDAr: "31",
    ayatAR:
      "قُلْ لِعِبَادِيَ الَّذِينَ آمَنُوا يُقِيمُوا الصَّلَاةَ وَيُنْفِقُوا مِمَّا رَزَقْنَاهُمْ سِرًّا وَعَلَانِيَةً مِنْ قَبْلِ أَنْ يَأْتِيَ يَوْمٌ لَا بَيْعٌ فِيهِ وَلَا خِلَالٌ",
  },
  {
    id: "1782",
    sura: "14",
    VerseIDAr: "32",
    ayatAR:
      "اللَّهُ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَأَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَخْرَجَ بِهِ مِنَ الثَّمَرَاتِ رِزْقًا لَكُمْ ۖ وَسَخَّرَ لَكُمُ الْفُلْكَ لِتَجْرِيَ فِي الْبَحْرِ بِأَمْرِهِ ۖ وَسَخَّرَ لَكُمُ الْأَنْهَارَ",
  },
  {
    id: "1783",
    sura: "14",
    VerseIDAr: "33",
    ayatAR:
      "وَسَخَّرَ لَكُمُ الشَّمْسَ وَالْقَمَرَ دَائِبَيْنِ ۖ وَسَخَّرَ لَكُمُ اللَّيْلَ وَالنَّهَارَ",
  },
  {
    id: "1784",
    sura: "14",
    VerseIDAr: "34",
    ayatAR:
      "وَآتَاكُمْ مِنْ كُلِّ مَا سَأَلْتُمُوهُ ۚ وَإِنْ تَعُدُّوا نِعْمَتَ اللَّهِ لَا تُحْصُوهَا ۗ إِنَّ الْإِنْسَانَ لَظَلُومٌ كَفَّارٌ",
  },
  {
    id: "1785",
    sura: "14",
    VerseIDAr: "35",
    ayatAR:
      "وَإِذْ قَالَ إِبْرَاهِيمُ رَبِّ اجْعَلْ هَٰذَا الْبَلَدَ آمِنًا وَاجْنُبْنِي وَبَنِيَّ أَنْ نَعْبُدَ الْأَصْنَامَ",
  },
  {
    id: "1786",
    sura: "14",
    VerseIDAr: "36",
    ayatAR:
      "رَبِّ إِنَّهُنَّ أَضْلَلْنَ كَثِيرًا مِنَ النَّاسِ ۖ فَمَنْ تَبِعَنِي فَإِنَّهُ مِنِّي ۖ وَمَنْ عَصَانِي فَإِنَّكَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "1787",
    sura: "14",
    VerseIDAr: "37",
    ayatAR:
      "رَبَّنَا إِنِّي أَسْكَنْتُ مِنْ ذُرِّيَّتِي بِوَادٍ غَيْرِ ذِي زَرْعٍ عِنْدَ بَيْتِكَ الْمُحَرَّمِ رَبَّنَا لِيُقِيمُوا الصَّلَاةَ فَاجْعَلْ أَفْئِدَةً مِنَ النَّاسِ تَهْوِي إِلَيْهِمْ وَارْزُقْهُمْ مِنَ الثَّمَرَاتِ لَعَلَّهُمْ يَشْكُرُونَ",
  },
  {
    id: "1788",
    sura: "14",
    VerseIDAr: "38",
    ayatAR:
      "رَبَّنَا إِنَّكَ تَعْلَمُ مَا نُخْفِي وَمَا نُعْلِنُ ۗ وَمَا يَخْفَىٰ عَلَى اللَّهِ مِنْ شَيْءٍ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ",
  },
  {
    id: "1789",
    sura: "14",
    VerseIDAr: "39",
    ayatAR:
      "الْحَمْدُ لِلَّهِ الَّذِي وَهَبَ لِي عَلَى الْكِبَرِ إِسْمَاعِيلَ وَإِسْحَاقَ ۚ إِنَّ رَبِّي لَسَمِيعُ الدُّعَاءِ",
  },
  {
    id: "1790",
    sura: "14",
    VerseIDAr: "40",
    ayatAR:
      "رَبِّ اجْعَلْنِي مُقِيمَ الصَّلَاةِ وَمِنْ ذُرِّيَّتِي ۚ رَبَّنَا وَتَقَبَّلْ دُعَاءِ",
  },
  {
    id: "1791",
    sura: "14",
    VerseIDAr: "41",
    ayatAR:
      "رَبَّنَا اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ",
  },
  {
    id: "1792",
    sura: "14",
    VerseIDAr: "42",
    ayatAR:
      "وَلَا تَحْسَبَنَّ اللَّهَ غَافِلًا عَمَّا يَعْمَلُ الظَّالِمُونَ ۚ إِنَّمَا يُؤَخِّرُهُمْ لِيَوْمٍ تَشْخَصُ فِيهِ الْأَبْصَارُ",
  },
  {
    id: "1793",
    sura: "14",
    VerseIDAr: "43",
    ayatAR:
      "مُهْطِعِينَ مُقْنِعِي رُءُوسِهِمْ لَا يَرْتَدُّ إِلَيْهِمْ طَرْفُهُمْ ۖ وَأَفْئِدَتُهُمْ هَوَاءٌ",
  },
  {
    id: "1794",
    sura: "14",
    VerseIDAr: "44",
    ayatAR:
      "وَأَنْذِرِ النَّاسَ يَوْمَ يَأْتِيهِمُ الْعَذَابُ فَيَقُولُ الَّذِينَ ظَلَمُوا رَبَّنَا أَخِّرْنَا إِلَىٰ أَجَلٍ قَرِيبٍ نُجِبْ دَعْوَتَكَ وَنَتَّبِعِ الرُّسُلَ ۗ أَوَلَمْ تَكُونُوا أَقْسَمْتُمْ مِنْ قَبْلُ مَا لَكُمْ مِنْ زَوَالٍ",
  },
  {
    id: "1795",
    sura: "14",
    VerseIDAr: "45",
    ayatAR:
      "وَسَكَنْتُمْ فِي مَسَاكِنِ الَّذِينَ ظَلَمُوا أَنْفُسَهُمْ وَتَبَيَّنَ لَكُمْ كَيْفَ فَعَلْنَا بِهِمْ وَضَرَبْنَا لَكُمُ الْأَمْثَالَ",
  },
  {
    id: "1796",
    sura: "14",
    VerseIDAr: "46",
    ayatAR:
      "وَقَدْ مَكَرُوا مَكْرَهُمْ وَعِنْدَ اللَّهِ مَكْرُهُمْ وَإِنْ كَانَ مَكْرُهُمْ لِتَزُولَ مِنْهُ الْجِبَالُ",
  },
  {
    id: "1797",
    sura: "14",
    VerseIDAr: "47",
    ayatAR:
      "فَلَا تَحْسَبَنَّ اللَّهَ مُخْلِفَ وَعْدِهِ رُسُلَهُ ۗ إِنَّ اللَّهَ عَزِيزٌ ذُو انْتِقَامٍ",
  },
  {
    id: "1798",
    sura: "14",
    VerseIDAr: "48",
    ayatAR:
      "يَوْمَ تُبَدَّلُ الْأَرْضُ غَيْرَ الْأَرْضِ وَالسَّمَاوَاتُ ۖ وَبَرَزُوا لِلَّهِ الْوَاحِدِ الْقَهَّارِ",
  },
  {
    id: "1799",
    sura: "14",
    VerseIDAr: "49",
    ayatAR: "وَتَرَى الْمُجْرِمِينَ يَوْمَئِذٍ مُقَرَّنِينَ فِي الْأَصْفَادِ",
  },
  {
    id: "1800",
    sura: "14",
    VerseIDAr: "50",
    ayatAR: "سَرَابِيلُهُمْ مِنْ قَطِرَانٍ وَتَغْشَىٰ وُجُوهَهُمُ النَّارُ",
  },
  {
    id: "1801",
    sura: "14",
    VerseIDAr: "51",
    ayatAR:
      "لِيَجْزِيَ اللَّهُ كُلَّ نَفْسٍ مَا كَسَبَتْ ۚ إِنَّ اللَّهَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "1802",
    sura: "14",
    VerseIDAr: "52",
    ayatAR:
      "هَٰذَا بَلَاغٌ لِلنَّاسِ وَلِيُنْذَرُوا بِهِ وَلِيَعْلَمُوا أَنَّمَا هُوَ إِلَٰهٌ وَاحِدٌ وَلِيَذَّكَّرَ أُولُو الْأَلْبَابِ",
  },
  {
    id: "1803",
    sura: "15",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الر ۚ تِلْكَ آيَاتُ الْكِتَابِ وَقُرْآنٍ مُبِينٍ",
  },
  {
    id: "1804",
    sura: "15",
    VerseIDAr: "2",
    ayatAR: "رُبَمَا يَوَدُّ الَّذِينَ كَفَرُوا لَوْ كَانُوا مُسْلِمِينَ",
  },
  {
    id: "1805",
    sura: "15",
    VerseIDAr: "3",
    ayatAR:
      "ذَرْهُمْ يَأْكُلُوا وَيَتَمَتَّعُوا وَيُلْهِهِمُ الْأَمَلُ ۖ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "1806",
    sura: "15",
    VerseIDAr: "4",
    ayatAR: "وَمَا أَهْلَكْنَا مِنْ قَرْيَةٍ إِلَّا وَلَهَا كِتَابٌ مَعْلُومٌ",
  },
  {
    id: "1807",
    sura: "15",
    VerseIDAr: "5",
    ayatAR: "مَا تَسْبِقُ مِنْ أُمَّةٍ أَجَلَهَا وَمَا يَسْتَأْخِرُونَ",
  },
  {
    id: "1808",
    sura: "15",
    VerseIDAr: "6",
    ayatAR:
      "وَقَالُوا يَا أَيُّهَا الَّذِي نُزِّلَ عَلَيْهِ الذِّكْرُ إِنَّكَ لَمَجْنُونٌ",
  },
  {
    id: "1809",
    sura: "15",
    VerseIDAr: "7",
    ayatAR:
      "لَوْ مَا تَأْتِينَا بِالْمَلَائِكَةِ إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "1810",
    sura: "15",
    VerseIDAr: "8",
    ayatAR:
      "مَا نُنَزِّلُ الْمَلَائِكَةَ إِلَّا بِالْحَقِّ وَمَا كَانُوا إِذًا مُنْظَرِينَ",
  },
  {
    id: "1811",
    sura: "15",
    VerseIDAr: "9",
    ayatAR: "إِنَّا نَحْنُ نَزَّلْنَا الذِّكْرَ وَإِنَّا لَهُ لَحَافِظُونَ",
  },
  {
    id: "1812",
    sura: "15",
    VerseIDAr: "10",
    ayatAR: "وَلَقَدْ أَرْسَلْنَا مِنْ قَبْلِكَ فِي شِيَعِ الْأَوَّلِينَ",
  },
  {
    id: "1813",
    sura: "15",
    VerseIDAr: "11",
    ayatAR:
      "وَمَا يَأْتِيهِمْ مِنْ رَسُولٍ إِلَّا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "1814",
    sura: "15",
    VerseIDAr: "12",
    ayatAR: "كَذَٰلِكَ نَسْلُكُهُ فِي قُلُوبِ الْمُجْرِمِينَ",
  },
  {
    id: "1815",
    sura: "15",
    VerseIDAr: "13",
    ayatAR: "لَا يُؤْمِنُونَ بِهِ ۖ وَقَدْ خَلَتْ سُنَّةُ الْأَوَّلِينَ",
  },
  {
    id: "1816",
    sura: "15",
    VerseIDAr: "14",
    ayatAR:
      "وَلَوْ فَتَحْنَا عَلَيْهِمْ بَابًا مِنَ السَّمَاءِ فَظَلُّوا فِيهِ يَعْرُجُونَ",
  },
  {
    id: "1817",
    sura: "15",
    VerseIDAr: "15",
    ayatAR:
      "لَقَالُوا إِنَّمَا سُكِّرَتْ أَبْصَارُنَا بَلْ نَحْنُ قَوْمٌ مَسْحُورُونَ",
  },
  {
    id: "1818",
    sura: "15",
    VerseIDAr: "16",
    ayatAR:
      "وَلَقَدْ جَعَلْنَا فِي السَّمَاءِ بُرُوجًا وَزَيَّنَّاهَا لِلنَّاظِرِينَ",
  },
  {
    id: "1819",
    sura: "15",
    VerseIDAr: "17",
    ayatAR: "وَحَفِظْنَاهَا مِنْ كُلِّ شَيْطَانٍ رَجِيمٍ",
  },
  {
    id: "1820",
    sura: "15",
    VerseIDAr: "18",
    ayatAR: "إِلَّا مَنِ اسْتَرَقَ السَّمْعَ فَأَتْبَعَهُ شِهَابٌ مُبِينٌ",
  },
  {
    id: "1821",
    sura: "15",
    VerseIDAr: "19",
    ayatAR:
      "وَالْأَرْضَ مَدَدْنَاهَا وَأَلْقَيْنَا فِيهَا رَوَاسِيَ وَأَنْبَتْنَا فِيهَا مِنْ كُلِّ شَيْءٍ مَوْزُونٍ",
  },
  {
    id: "1822",
    sura: "15",
    VerseIDAr: "20",
    ayatAR:
      "وَجَعَلْنَا لَكُمْ فِيهَا مَعَايِشَ وَمَنْ لَسْتُمْ لَهُ بِرَازِقِينَ",
  },
  {
    id: "1823",
    sura: "15",
    VerseIDAr: "21",
    ayatAR:
      "وَإِنْ مِنْ شَيْءٍ إِلَّا عِنْدَنَا خَزَائِنُهُ وَمَا نُنَزِّلُهُ إِلَّا بِقَدَرٍ مَعْلُومٍ",
  },
  {
    id: "1824",
    sura: "15",
    VerseIDAr: "22",
    ayatAR:
      "وَأَرْسَلْنَا الرِّيَاحَ لَوَاقِحَ فَأَنْزَلْنَا مِنَ السَّمَاءِ مَاءً فَأَسْقَيْنَاكُمُوهُ وَمَا أَنْتُمْ لَهُ بِخَازِنِينَ",
  },
  {
    id: "1825",
    sura: "15",
    VerseIDAr: "23",
    ayatAR: "وَإِنَّا لَنَحْنُ نُحْيِي وَنُمِيتُ وَنَحْنُ الْوَارِثُونَ",
  },
  {
    id: "1826",
    sura: "15",
    VerseIDAr: "24",
    ayatAR:
      "وَلَقَدْ عَلِمْنَا الْمُسْتَقْدِمِينَ مِنْكُمْ وَلَقَدْ عَلِمْنَا الْمُسْتَأْخِرِينَ",
  },
  {
    id: "1827",
    sura: "15",
    VerseIDAr: "25",
    ayatAR: "وَإِنَّ رَبَّكَ هُوَ يَحْشُرُهُمْ ۚ إِنَّهُ حَكِيمٌ عَلِيمٌ",
  },
  {
    id: "1828",
    sura: "15",
    VerseIDAr: "26",
    ayatAR:
      "وَلَقَدْ خَلَقْنَا الْإِنْسَانَ مِنْ صَلْصَالٍ مِنْ حَمَإٍ مَسْنُونٍ",
  },
  {
    id: "1829",
    sura: "15",
    VerseIDAr: "27",
    ayatAR: "وَالْجَانَّ خَلَقْنَاهُ مِنْ قَبْلُ مِنْ نَارِ السَّمُومِ",
  },
  {
    id: "1830",
    sura: "15",
    VerseIDAr: "28",
    ayatAR:
      "وَإِذْ قَالَ رَبُّكَ لِلْمَلَائِكَةِ إِنِّي خَالِقٌ بَشَرًا مِنْ صَلْصَالٍ مِنْ حَمَإٍ مَسْنُونٍ",
  },
  {
    id: "1831",
    sura: "15",
    VerseIDAr: "29",
    ayatAR:
      "فَإِذَا سَوَّيْتُهُ وَنَفَخْتُ فِيهِ مِنْ رُوحِي فَقَعُوا لَهُ سَاجِدِينَ",
  },
  {
    id: "1832",
    sura: "15",
    VerseIDAr: "30",
    ayatAR: "فَسَجَدَ الْمَلَائِكَةُ كُلُّهُمْ أَجْمَعُونَ",
  },
  {
    id: "1833",
    sura: "15",
    VerseIDAr: "31",
    ayatAR: "إِلَّا إِبْلِيسَ أَبَىٰ أَنْ يَكُونَ مَعَ السَّاجِدِينَ",
  },
  {
    id: "1834",
    sura: "15",
    VerseIDAr: "32",
    ayatAR: "قَالَ يَا إِبْلِيسُ مَا لَكَ أَلَّا تَكُونَ مَعَ السَّاجِدِينَ",
  },
  {
    id: "1835",
    sura: "15",
    VerseIDAr: "33",
    ayatAR:
      "قَالَ لَمْ أَكُنْ لِأَسْجُدَ لِبَشَرٍ خَلَقْتَهُ مِنْ صَلْصَالٍ مِنْ حَمَإٍ مَسْنُونٍ",
  },
  {
    id: "1836",
    sura: "15",
    VerseIDAr: "34",
    ayatAR: "قَالَ فَاخْرُجْ مِنْهَا فَإِنَّكَ رَجِيمٌ",
  },
  {
    id: "1837",
    sura: "15",
    VerseIDAr: "35",
    ayatAR: "وَإِنَّ عَلَيْكَ اللَّعْنَةَ إِلَىٰ يَوْمِ الدِّينِ",
  },
  {
    id: "1838",
    sura: "15",
    VerseIDAr: "36",
    ayatAR: "قَالَ رَبِّ فَأَنْظِرْنِي إِلَىٰ يَوْمِ يُبْعَثُونَ",
  },
  {
    id: "1839",
    sura: "15",
    VerseIDAr: "37",
    ayatAR: "قَالَ فَإِنَّكَ مِنَ الْمُنْظَرِينَ",
  },
  {
    id: "1840",
    sura: "15",
    VerseIDAr: "38",
    ayatAR: "إِلَىٰ يَوْمِ الْوَقْتِ الْمَعْلُومِ",
  },
  {
    id: "1841",
    sura: "15",
    VerseIDAr: "39",
    ayatAR:
      "قَالَ رَبِّ بِمَا أَغْوَيْتَنِي لَأُزَيِّنَنَّ لَهُمْ فِي الْأَرْضِ وَلَأُغْوِيَنَّهُمْ أَجْمَعِينَ",
  },
  {
    id: "1842",
    sura: "15",
    VerseIDAr: "40",
    ayatAR: "إِلَّا عِبَادَكَ مِنْهُمُ الْمُخْلَصِينَ",
  },
  {
    id: "1843",
    sura: "15",
    VerseIDAr: "41",
    ayatAR: "قَالَ هَٰذَا صِرَاطٌ عَلَيَّ مُسْتَقِيمٌ",
  },
  {
    id: "1844",
    sura: "15",
    VerseIDAr: "42",
    ayatAR:
      "إِنَّ عِبَادِي لَيْسَ لَكَ عَلَيْهِمْ سُلْطَانٌ إِلَّا مَنِ اتَّبَعَكَ مِنَ الْغَاوِينَ",
  },
  {
    id: "1845",
    sura: "15",
    VerseIDAr: "43",
    ayatAR: "وَإِنَّ جَهَنَّمَ لَمَوْعِدُهُمْ أَجْمَعِينَ",
  },
  {
    id: "1846",
    sura: "15",
    VerseIDAr: "44",
    ayatAR: "لَهَا سَبْعَةُ أَبْوَابٍ لِكُلِّ بَابٍ مِنْهُمْ جُزْءٌ مَقْسُومٌ",
  },
  {
    id: "1847",
    sura: "15",
    VerseIDAr: "45",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي جَنَّاتٍ وَعُيُونٍ",
  },
  {
    id: "1848",
    sura: "15",
    VerseIDAr: "46",
    ayatAR: "ادْخُلُوهَا بِسَلَامٍ آمِنِينَ",
  },
  {
    id: "1849",
    sura: "15",
    VerseIDAr: "47",
    ayatAR:
      "وَنَزَعْنَا مَا فِي صُدُورِهِمْ مِنْ غِلٍّ إِخْوَانًا عَلَىٰ سُرُرٍ مُتَقَابِلِينَ",
  },
  {
    id: "1850",
    sura: "15",
    VerseIDAr: "48",
    ayatAR: "لَا يَمَسُّهُمْ فِيهَا نَصَبٌ وَمَا هُمْ مِنْهَا بِمُخْرَجِينَ",
  },
  {
    id: "1851",
    sura: "15",
    VerseIDAr: "49",
    ayatAR: "نَبِّئْ عِبَادِي أَنِّي أَنَا الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "1852",
    sura: "15",
    VerseIDAr: "50",
    ayatAR: "وَأَنَّ عَذَابِي هُوَ الْعَذَابُ الْأَلِيمُ",
  },
  {
    id: "1853",
    sura: "15",
    VerseIDAr: "51",
    ayatAR: "وَنَبِّئْهُمْ عَنْ ضَيْفِ إِبْرَاهِيمَ",
  },
  {
    id: "1854",
    sura: "15",
    VerseIDAr: "52",
    ayatAR:
      "إِذْ دَخَلُوا عَلَيْهِ فَقَالُوا سَلَامًا قَالَ إِنَّا مِنْكُمْ وَجِلُونَ",
  },
  {
    id: "1855",
    sura: "15",
    VerseIDAr: "53",
    ayatAR: "قَالُوا لَا تَوْجَلْ إِنَّا نُبَشِّرُكَ بِغُلَامٍ عَلِيمٍ",
  },
  {
    id: "1856",
    sura: "15",
    VerseIDAr: "54",
    ayatAR:
      "قَالَ أَبَشَّرْتُمُونِي عَلَىٰ أَنْ مَسَّنِيَ الْكِبَرُ فَبِمَ تُبَشِّرُونَ",
  },
  {
    id: "1857",
    sura: "15",
    VerseIDAr: "55",
    ayatAR: "قَالُوا بَشَّرْنَاكَ بِالْحَقِّ فَلَا تَكُنْ مِنَ الْقَانِطِينَ",
  },
  {
    id: "1858",
    sura: "15",
    VerseIDAr: "56",
    ayatAR: "قَالَ وَمَنْ يَقْنَطُ مِنْ رَحْمَةِ رَبِّهِ إِلَّا الضَّالُّونَ",
  },
  {
    id: "1859",
    sura: "15",
    VerseIDAr: "57",
    ayatAR: "قَالَ فَمَا خَطْبُكُمْ أَيُّهَا الْمُرْسَلُونَ",
  },
  {
    id: "1860",
    sura: "15",
    VerseIDAr: "58",
    ayatAR: "قَالُوا إِنَّا أُرْسِلْنَا إِلَىٰ قَوْمٍ مُجْرِمِينَ",
  },
  {
    id: "1861",
    sura: "15",
    VerseIDAr: "59",
    ayatAR: "إِلَّا آلَ لُوطٍ إِنَّا لَمُنَجُّوهُمْ أَجْمَعِينَ",
  },
  {
    id: "1862",
    sura: "15",
    VerseIDAr: "60",
    ayatAR: "إِلَّا امْرَأَتَهُ قَدَّرْنَا ۙ إِنَّهَا لَمِنَ الْغَابِرِينَ",
  },
  {
    id: "1863",
    sura: "15",
    VerseIDAr: "61",
    ayatAR: "فَلَمَّا جَاءَ آلَ لُوطٍ الْمُرْسَلُونَ",
  },
  {
    id: "1864",
    sura: "15",
    VerseIDAr: "62",
    ayatAR: "قَالَ إِنَّكُمْ قَوْمٌ مُنْكَرُونَ",
  },
  {
    id: "1865",
    sura: "15",
    VerseIDAr: "63",
    ayatAR: "قَالُوا بَلْ جِئْنَاكَ بِمَا كَانُوا فِيهِ يَمْتَرُونَ",
  },
  {
    id: "1866",
    sura: "15",
    VerseIDAr: "64",
    ayatAR: "وَأَتَيْنَاكَ بِالْحَقِّ وَإِنَّا لَصَادِقُونَ",
  },
  {
    id: "1867",
    sura: "15",
    VerseIDAr: "65",
    ayatAR:
      "فَأَسْرِ بِأَهْلِكَ بِقِطْعٍ مِنَ اللَّيْلِ وَاتَّبِعْ أَدْبَارَهُمْ وَلَا يَلْتَفِتْ مِنْكُمْ أَحَدٌ وَامْضُوا حَيْثُ تُؤْمَرُونَ",
  },
  {
    id: "1868",
    sura: "15",
    VerseIDAr: "66",
    ayatAR:
      "وَقَضَيْنَا إِلَيْهِ ذَٰلِكَ الْأَمْرَ أَنَّ دَابِرَ هَٰؤُلَاءِ مَقْطُوعٌ مُصْبِحِينَ",
  },
  {
    id: "1869",
    sura: "15",
    VerseIDAr: "67",
    ayatAR: "وَجَاءَ أَهْلُ الْمَدِينَةِ يَسْتَبْشِرُونَ",
  },
  {
    id: "1870",
    sura: "15",
    VerseIDAr: "68",
    ayatAR: "قَالَ إِنَّ هَٰؤُلَاءِ ضَيْفِي فَلَا تَفْضَحُونِ",
  },
  {
    id: "1871",
    sura: "15",
    VerseIDAr: "69",
    ayatAR: "وَاتَّقُوا اللَّهَ وَلَا تُخْزُونِ",
  },
  {
    id: "1872",
    sura: "15",
    VerseIDAr: "70",
    ayatAR: "قَالُوا أَوَلَمْ نَنْهَكَ عَنِ الْعَالَمِينَ",
  },
  {
    id: "1873",
    sura: "15",
    VerseIDAr: "71",
    ayatAR: "قَالَ هَٰؤُلَاءِ بَنَاتِي إِنْ كُنْتُمْ فَاعِلِينَ",
  },
  {
    id: "1874",
    sura: "15",
    VerseIDAr: "72",
    ayatAR: "لَعَمْرُكَ إِنَّهُمْ لَفِي سَكْرَتِهِمْ يَعْمَهُونَ",
  },
  {
    id: "1875",
    sura: "15",
    VerseIDAr: "73",
    ayatAR: "فَأَخَذَتْهُمُ الصَّيْحَةُ مُشْرِقِينَ",
  },
  {
    id: "1876",
    sura: "15",
    VerseIDAr: "74",
    ayatAR:
      "فَجَعَلْنَا عَالِيَهَا سَافِلَهَا وَأَمْطَرْنَا عَلَيْهِمْ حِجَارَةً مِنْ سِجِّيلٍ",
  },
  {
    id: "1877",
    sura: "15",
    VerseIDAr: "75",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِلْمُتَوَسِّمِينَ",
  },
  {
    id: "1878",
    sura: "15",
    VerseIDAr: "76",
    ayatAR: "وَإِنَّهَا لَبِسَبِيلٍ مُقِيمٍ",
  },
  {
    id: "1879",
    sura: "15",
    VerseIDAr: "77",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً لِلْمُؤْمِنِينَ",
  },
  {
    id: "1880",
    sura: "15",
    VerseIDAr: "78",
    ayatAR: "وَإِنْ كَانَ أَصْحَابُ الْأَيْكَةِ لَظَالِمِينَ",
  },
  {
    id: "1881",
    sura: "15",
    VerseIDAr: "79",
    ayatAR: "فَانْتَقَمْنَا مِنْهُمْ وَإِنَّهُمَا لَبِإِمَامٍ مُبِينٍ",
  },
  {
    id: "1882",
    sura: "15",
    VerseIDAr: "80",
    ayatAR: "وَلَقَدْ كَذَّبَ أَصْحَابُ الْحِجْرِ الْمُرْسَلِينَ",
  },
  {
    id: "1883",
    sura: "15",
    VerseIDAr: "81",
    ayatAR: "وَآتَيْنَاهُمْ آيَاتِنَا فَكَانُوا عَنْهَا مُعْرِضِينَ",
  },
  {
    id: "1884",
    sura: "15",
    VerseIDAr: "82",
    ayatAR: "وَكَانُوا يَنْحِتُونَ مِنَ الْجِبَالِ بُيُوتًا آمِنِينَ",
  },
  {
    id: "1885",
    sura: "15",
    VerseIDAr: "83",
    ayatAR: "فَأَخَذَتْهُمُ الصَّيْحَةُ مُصْبِحِينَ",
  },
  {
    id: "1886",
    sura: "15",
    VerseIDAr: "84",
    ayatAR: "فَمَا أَغْنَىٰ عَنْهُمْ مَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "1887",
    sura: "15",
    VerseIDAr: "85",
    ayatAR:
      "وَمَا خَلَقْنَا السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا إِلَّا بِالْحَقِّ ۗ وَإِنَّ السَّاعَةَ لَآتِيَةٌ ۖ فَاصْفَحِ الصَّفْحَ الْجَمِيلَ",
  },
  {
    id: "1888",
    sura: "15",
    VerseIDAr: "86",
    ayatAR: "إِنَّ رَبَّكَ هُوَ الْخَلَّاقُ الْعَلِيمُ",
  },
  {
    id: "1889",
    sura: "15",
    VerseIDAr: "87",
    ayatAR:
      "وَلَقَدْ آتَيْنَاكَ سَبْعًا مِنَ الْمَثَانِي وَالْقُرْآنَ الْعَظِيمَ",
  },
  {
    id: "1890",
    sura: "15",
    VerseIDAr: "88",
    ayatAR:
      "لَا تَمُدَّنَّ عَيْنَيْكَ إِلَىٰ مَا مَتَّعْنَا بِهِ أَزْوَاجًا مِنْهُمْ وَلَا تَحْزَنْ عَلَيْهِمْ وَاخْفِضْ جَنَاحَكَ لِلْمُؤْمِنِينَ",
  },
  {
    id: "1891",
    sura: "15",
    VerseIDAr: "89",
    ayatAR: "وَقُلْ إِنِّي أَنَا النَّذِيرُ الْمُبِينُ",
  },
  {
    id: "1892",
    sura: "15",
    VerseIDAr: "90",
    ayatAR: "كَمَا أَنْزَلْنَا عَلَى الْمُقْتَسِمِينَ",
  },
  {
    id: "1893",
    sura: "15",
    VerseIDAr: "91",
    ayatAR: "الَّذِينَ جَعَلُوا الْقُرْآنَ عِضِينَ",
  },
  {
    id: "1894",
    sura: "15",
    VerseIDAr: "92",
    ayatAR: "فَوَرَبِّكَ لَنَسْأَلَنَّهُمْ أَجْمَعِينَ",
  },
  {
    id: "1895",
    sura: "15",
    VerseIDAr: "93",
    ayatAR: "عَمَّا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1896",
    sura: "15",
    VerseIDAr: "94",
    ayatAR: "فَاصْدَعْ بِمَا تُؤْمَرُ وَأَعْرِضْ عَنِ الْمُشْرِكِينَ",
  },
  {
    id: "1897",
    sura: "15",
    VerseIDAr: "95",
    ayatAR: "إِنَّا كَفَيْنَاكَ الْمُسْتَهْزِئِينَ",
  },
  {
    id: "1898",
    sura: "15",
    VerseIDAr: "96",
    ayatAR:
      "الَّذِينَ يَجْعَلُونَ مَعَ اللَّهِ إِلَٰهًا آخَرَ ۚ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "1899",
    sura: "15",
    VerseIDAr: "97",
    ayatAR: "وَلَقَدْ نَعْلَمُ أَنَّكَ يَضِيقُ صَدْرُكَ بِمَا يَقُولُونَ",
  },
  {
    id: "1900",
    sura: "15",
    VerseIDAr: "98",
    ayatAR: "فَسَبِّحْ بِحَمْدِ رَبِّكَ وَكُنْ مِنَ السَّاجِدِينَ",
  },
  {
    id: "1901",
    sura: "15",
    VerseIDAr: "99",
    ayatAR: "وَاعْبُدْ رَبَّكَ حَتَّىٰ يَأْتِيَكَ الْيَقِينُ",
  },
  {
    id: "1902",
    sura: "16",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ أَتَىٰ أَمْرُ اللَّهِ فَلَا تَسْتَعْجِلُوهُ ۚ سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "1903",
    sura: "16",
    VerseIDAr: "2",
    ayatAR:
      "يُنَزِّلُ الْمَلَائِكَةَ بِالرُّوحِ مِنْ أَمْرِهِ عَلَىٰ مَنْ يَشَاءُ مِنْ عِبَادِهِ أَنْ أَنْذِرُوا أَنَّهُ لَا إِلَٰهَ إِلَّا أَنَا فَاتَّقُونِ",
  },
  {
    id: "1904",
    sura: "16",
    VerseIDAr: "3",
    ayatAR:
      "خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ ۚ تَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "1905",
    sura: "16",
    VerseIDAr: "4",
    ayatAR: "خَلَقَ الْإِنْسَانَ مِنْ نُطْفَةٍ فَإِذَا هُوَ خَصِيمٌ مُبِينٌ",
  },
  {
    id: "1906",
    sura: "16",
    VerseIDAr: "5",
    ayatAR:
      "وَالْأَنْعَامَ خَلَقَهَا ۗ لَكُمْ فِيهَا دِفْءٌ وَمَنَافِعُ وَمِنْهَا تَأْكُلُونَ",
  },
  {
    id: "1907",
    sura: "16",
    VerseIDAr: "6",
    ayatAR: "وَلَكُمْ فِيهَا جَمَالٌ حِينَ تُرِيحُونَ وَحِينَ تَسْرَحُونَ",
  },
  {
    id: "1908",
    sura: "16",
    VerseIDAr: "7",
    ayatAR:
      "وَتَحْمِلُ أَثْقَالَكُمْ إِلَىٰ بَلَدٍ لَمْ تَكُونُوا بَالِغِيهِ إِلَّا بِشِقِّ الْأَنْفُسِ ۚ إِنَّ رَبَّكُمْ لَرَءُوفٌ رَحِيمٌ",
  },
  {
    id: "1909",
    sura: "16",
    VerseIDAr: "8",
    ayatAR:
      "وَالْخَيْلَ وَالْبِغَالَ وَالْحَمِيرَ لِتَرْكَبُوهَا وَزِينَةً ۚ وَيَخْلُقُ مَا لَا تَعْلَمُونَ",
  },
  {
    id: "1910",
    sura: "16",
    VerseIDAr: "9",
    ayatAR:
      "وَعَلَى اللَّهِ قَصْدُ السَّبِيلِ وَمِنْهَا جَائِرٌ ۚ وَلَوْ شَاءَ لَهَدَاكُمْ أَجْمَعِينَ",
  },
  {
    id: "1911",
    sura: "16",
    VerseIDAr: "10",
    ayatAR:
      "هُوَ الَّذِي أَنْزَلَ مِنَ السَّمَاءِ مَاءً ۖ لَكُمْ مِنْهُ شَرَابٌ وَمِنْهُ شَجَرٌ فِيهِ تُسِيمُونَ",
  },
  {
    id: "1912",
    sura: "16",
    VerseIDAr: "11",
    ayatAR:
      "يُنْبِتُ لَكُمْ بِهِ الزَّرْعَ وَالزَّيْتُونَ وَالنَّخِيلَ وَالْأَعْنَابَ وَمِنْ كُلِّ الثَّمَرَاتِ ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "1913",
    sura: "16",
    VerseIDAr: "12",
    ayatAR:
      "وَسَخَّرَ لَكُمُ اللَّيْلَ وَالنَّهَارَ وَالشَّمْسَ وَالْقَمَرَ ۖ وَالنُّجُومُ مُسَخَّرَاتٌ بِأَمْرِهِ ۗ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "1914",
    sura: "16",
    VerseIDAr: "13",
    ayatAR:
      "وَمَا ذَرَأَ لَكُمْ فِي الْأَرْضِ مُخْتَلِفًا أَلْوَانُهُ ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَذَّكَّرُونَ",
  },
  {
    id: "1915",
    sura: "16",
    VerseIDAr: "14",
    ayatAR:
      "وَهُوَ الَّذِي سَخَّرَ الْبَحْرَ لِتَأْكُلُوا مِنْهُ لَحْمًا طَرِيًّا وَتَسْتَخْرِجُوا مِنْهُ حِلْيَةً تَلْبَسُونَهَا وَتَرَى الْفُلْكَ مَوَاخِرَ فِيهِ وَلِتَبْتَغُوا مِنْ فَضْلِهِ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "1916",
    sura: "16",
    VerseIDAr: "15",
    ayatAR:
      "وَأَلْقَىٰ فِي الْأَرْضِ رَوَاسِيَ أَنْ تَمِيدَ بِكُمْ وَأَنْهَارًا وَسُبُلًا لَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "1917",
    sura: "16",
    VerseIDAr: "16",
    ayatAR: "وَعَلَامَاتٍ ۚ وَبِالنَّجْمِ هُمْ يَهْتَدُونَ",
  },
  {
    id: "1918",
    sura: "16",
    VerseIDAr: "17",
    ayatAR: "أَفَمَنْ يَخْلُقُ كَمَنْ لَا يَخْلُقُ ۗ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "1919",
    sura: "16",
    VerseIDAr: "18",
    ayatAR:
      "وَإِنْ تَعُدُّوا نِعْمَةَ اللَّهِ لَا تُحْصُوهَا ۗ إِنَّ اللَّهَ لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "1920",
    sura: "16",
    VerseIDAr: "19",
    ayatAR: "وَاللَّهُ يَعْلَمُ مَا تُسِرُّونَ وَمَا تُعْلِنُونَ",
  },
  {
    id: "1921",
    sura: "16",
    VerseIDAr: "20",
    ayatAR:
      "وَالَّذِينَ يَدْعُونَ مِنْ دُونِ اللَّهِ لَا يَخْلُقُونَ شَيْئًا وَهُمْ يُخْلَقُونَ",
  },
  {
    id: "1922",
    sura: "16",
    VerseIDAr: "21",
    ayatAR:
      "أَمْوَاتٌ غَيْرُ أَحْيَاءٍ ۖ وَمَا يَشْعُرُونَ أَيَّانَ يُبْعَثُونَ",
  },
  {
    id: "1923",
    sura: "16",
    VerseIDAr: "22",
    ayatAR:
      "إِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ ۚ فَالَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ قُلُوبُهُمْ مُنْكِرَةٌ وَهُمْ مُسْتَكْبِرُونَ",
  },
  {
    id: "1924",
    sura: "16",
    VerseIDAr: "23",
    ayatAR:
      "لَا جَرَمَ أَنَّ اللَّهَ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ ۚ إِنَّهُ لَا يُحِبُّ الْمُسْتَكْبِرِينَ",
  },
  {
    id: "1925",
    sura: "16",
    VerseIDAr: "24",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ مَاذَا أَنْزَلَ رَبُّكُمْ ۙ قَالُوا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "1926",
    sura: "16",
    VerseIDAr: "25",
    ayatAR:
      "لِيَحْمِلُوا أَوْزَارَهُمْ كَامِلَةً يَوْمَ الْقِيَامَةِ ۙ وَمِنْ أَوْزَارِ الَّذِينَ يُضِلُّونَهُمْ بِغَيْرِ عِلْمٍ ۗ أَلَا سَاءَ مَا يَزِرُونَ",
  },
  {
    id: "1927",
    sura: "16",
    VerseIDAr: "26",
    ayatAR:
      "قَدْ مَكَرَ الَّذِينَ مِنْ قَبْلِهِمْ فَأَتَى اللَّهُ بُنْيَانَهُمْ مِنَ الْقَوَاعِدِ فَخَرَّ عَلَيْهِمُ السَّقْفُ مِنْ فَوْقِهِمْ وَأَتَاهُمُ الْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ",
  },
  {
    id: "1928",
    sura: "16",
    VerseIDAr: "27",
    ayatAR:
      "ثُمَّ يَوْمَ الْقِيَامَةِ يُخْزِيهِمْ وَيَقُولُ أَيْنَ شُرَكَائِيَ الَّذِينَ كُنْتُمْ تُشَاقُّونَ فِيهِمْ ۚ قَالَ الَّذِينَ أُوتُوا الْعِلْمَ إِنَّ الْخِزْيَ الْيَوْمَ وَالسُّوءَ عَلَى الْكَافِرِينَ",
  },
  {
    id: "1929",
    sura: "16",
    VerseIDAr: "28",
    ayatAR:
      "الَّذِينَ تَتَوَفَّاهُمُ الْمَلَائِكَةُ ظَالِمِي أَنْفُسِهِمْ ۖ فَأَلْقَوُا السَّلَمَ مَا كُنَّا نَعْمَلُ مِنْ سُوءٍ ۚ بَلَىٰ إِنَّ اللَّهَ عَلِيمٌ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1930",
    sura: "16",
    VerseIDAr: "29",
    ayatAR:
      "فَادْخُلُوا أَبْوَابَ جَهَنَّمَ خَالِدِينَ فِيهَا ۖ فَلَبِئْسَ مَثْوَى الْمُتَكَبِّرِينَ",
  },
  {
    id: "1931",
    sura: "16",
    VerseIDAr: "30",
    ayatAR:
      "وَقِيلَ لِلَّذِينَ اتَّقَوْا مَاذَا أَنْزَلَ رَبُّكُمْ ۚ قَالُوا خَيْرًا ۗ لِلَّذِينَ أَحْسَنُوا فِي هَٰذِهِ الدُّنْيَا حَسَنَةٌ ۚ وَلَدَارُ الْآخِرَةِ خَيْرٌ ۚ وَلَنِعْمَ دَارُ الْمُتَّقِينَ",
  },
  {
    id: "1932",
    sura: "16",
    VerseIDAr: "31",
    ayatAR:
      "جَنَّاتُ عَدْنٍ يَدْخُلُونَهَا تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ لَهُمْ فِيهَا مَا يَشَاءُونَ ۚ كَذَٰلِكَ يَجْزِي اللَّهُ الْمُتَّقِينَ",
  },
  {
    id: "1933",
    sura: "16",
    VerseIDAr: "32",
    ayatAR:
      "الَّذِينَ تَتَوَفَّاهُمُ الْمَلَائِكَةُ طَيِّبِينَ ۙ يَقُولُونَ سَلَامٌ عَلَيْكُمُ ادْخُلُوا الْجَنَّةَ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1934",
    sura: "16",
    VerseIDAr: "33",
    ayatAR:
      "هَلْ يَنْظُرُونَ إِلَّا أَنْ تَأْتِيَهُمُ الْمَلَائِكَةُ أَوْ يَأْتِيَ أَمْرُ رَبِّكَ ۚ كَذَٰلِكَ فَعَلَ الَّذِينَ مِنْ قَبْلِهِمْ ۚ وَمَا ظَلَمَهُمُ اللَّهُ وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "1935",
    sura: "16",
    VerseIDAr: "34",
    ayatAR:
      "فَأَصَابَهُمْ سَيِّئَاتُ مَا عَمِلُوا وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "1936",
    sura: "16",
    VerseIDAr: "35",
    ayatAR:
      "وَقَالَ الَّذِينَ أَشْرَكُوا لَوْ شَاءَ اللَّهُ مَا عَبَدْنَا مِنْ دُونِهِ مِنْ شَيْءٍ نَحْنُ وَلَا آبَاؤُنَا وَلَا حَرَّمْنَا مِنْ دُونِهِ مِنْ شَيْءٍ ۚ كَذَٰلِكَ فَعَلَ الَّذِينَ مِنْ قَبْلِهِمْ ۚ فَهَلْ عَلَى الرُّسُلِ إِلَّا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "1937",
    sura: "16",
    VerseIDAr: "36",
    ayatAR:
      "وَلَقَدْ بَعَثْنَا فِي كُلِّ أُمَّةٍ رَسُولًا أَنِ اعْبُدُوا اللَّهَ وَاجْتَنِبُوا الطَّاغُوتَ ۖ فَمِنْهُمْ مَنْ هَدَى اللَّهُ وَمِنْهُمْ مَنْ حَقَّتْ عَلَيْهِ الضَّلَالَةُ ۚ فَسِيرُوا فِي الْأَرْضِ فَانْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الْمُكَذِّبِينَ",
  },
  {
    id: "1938",
    sura: "16",
    VerseIDAr: "37",
    ayatAR:
      "إِنْ تَحْرِصْ عَلَىٰ هُدَاهُمْ فَإِنَّ اللَّهَ لَا يَهْدِي مَنْ يُضِلُّ ۖ وَمَا لَهُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "1939",
    sura: "16",
    VerseIDAr: "38",
    ayatAR:
      "وَأَقْسَمُوا بِاللَّهِ جَهْدَ أَيْمَانِهِمْ ۙ لَا يَبْعَثُ اللَّهُ مَنْ يَمُوتُ ۚ بَلَىٰ وَعْدًا عَلَيْهِ حَقًّا وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "1940",
    sura: "16",
    VerseIDAr: "39",
    ayatAR:
      "لِيُبَيِّنَ لَهُمُ الَّذِي يَخْتَلِفُونَ فِيهِ وَلِيَعْلَمَ الَّذِينَ كَفَرُوا أَنَّهُمْ كَانُوا كَاذِبِينَ",
  },
  {
    id: "1941",
    sura: "16",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّمَا قَوْلُنَا لِشَيْءٍ إِذَا أَرَدْنَاهُ أَنْ نَقُولَ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "1942",
    sura: "16",
    VerseIDAr: "41",
    ayatAR:
      "وَالَّذِينَ هَاجَرُوا فِي اللَّهِ مِنْ بَعْدِ مَا ظُلِمُوا لَنُبَوِّئَنَّهُمْ فِي الدُّنْيَا حَسَنَةً ۖ وَلَأَجْرُ الْآخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "1943",
    sura: "16",
    VerseIDAr: "42",
    ayatAR: "الَّذِينَ صَبَرُوا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ",
  },
  {
    id: "1944",
    sura: "16",
    VerseIDAr: "43",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ قَبْلِكَ إِلَّا رِجَالًا نُوحِي إِلَيْهِمْ ۚ فَاسْأَلُوا أَهْلَ الذِّكْرِ إِنْ كُنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "1945",
    sura: "16",
    VerseIDAr: "44",
    ayatAR:
      "بِالْبَيِّنَاتِ وَالزُّبُرِ ۗ وَأَنْزَلْنَا إِلَيْكَ الذِّكْرَ لِتُبَيِّنَ لِلنَّاسِ مَا نُزِّلَ إِلَيْهِمْ وَلَعَلَّهُمْ يَتَفَكَّرُونَ",
  },
  {
    id: "1946",
    sura: "16",
    VerseIDAr: "45",
    ayatAR:
      "أَفَأَمِنَ الَّذِينَ مَكَرُوا السَّيِّئَاتِ أَنْ يَخْسِفَ اللَّهُ بِهِمُ الْأَرْضَ أَوْ يَأْتِيَهُمُ الْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ",
  },
  {
    id: "1947",
    sura: "16",
    VerseIDAr: "46",
    ayatAR: "أَوْ يَأْخُذَهُمْ فِي تَقَلُّبِهِمْ فَمَا هُمْ بِمُعْجِزِينَ",
  },
  {
    id: "1948",
    sura: "16",
    VerseIDAr: "47",
    ayatAR:
      "أَوْ يَأْخُذَهُمْ عَلَىٰ تَخَوُّفٍ فَإِنَّ رَبَّكُمْ لَرَءُوفٌ رَحِيمٌ",
  },
  {
    id: "1949",
    sura: "16",
    VerseIDAr: "48",
    ayatAR:
      "أَوَلَمْ يَرَوْا إِلَىٰ مَا خَلَقَ اللَّهُ مِنْ شَيْءٍ يَتَفَيَّأُ ظِلَالُهُ عَنِ الْيَمِينِ وَالشَّمَائِلِ سُجَّدًا لِلَّهِ وَهُمْ دَاخِرُونَ",
  },
  {
    id: "1950",
    sura: "16",
    VerseIDAr: "49",
    ayatAR:
      "وَلِلَّهِ يَسْجُدُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ مِنْ دَابَّةٍ وَالْمَلَائِكَةُ وَهُمْ لَا يَسْتَكْبِرُونَ",
  },
  {
    id: "1951",
    sura: "16",
    VerseIDAr: "50",
    ayatAR:
      "يَخَافُونَ رَبَّهُمْ مِنْ فَوْقِهِمْ وَيَفْعَلُونَ مَا يُؤْمَرُونَ ۩",
  },
  {
    id: "1952",
    sura: "16",
    VerseIDAr: "51",
    ayatAR:
      "وَقَالَ اللَّهُ لَا تَتَّخِذُوا إِلَٰهَيْنِ اثْنَيْنِ ۖ إِنَّمَا هُوَ إِلَٰهٌ وَاحِدٌ ۖ فَإِيَّايَ فَارْهَبُونِ",
  },
  {
    id: "1953",
    sura: "16",
    VerseIDAr: "52",
    ayatAR:
      "وَلَهُ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ وَلَهُ الدِّينُ وَاصِبًا ۚ أَفَغَيْرَ اللَّهِ تَتَّقُونَ",
  },
  {
    id: "1954",
    sura: "16",
    VerseIDAr: "53",
    ayatAR:
      "وَمَا بِكُمْ مِنْ نِعْمَةٍ فَمِنَ اللَّهِ ۖ ثُمَّ إِذَا مَسَّكُمُ الضُّرُّ فَإِلَيْهِ تَجْأَرُونَ",
  },
  {
    id: "1955",
    sura: "16",
    VerseIDAr: "54",
    ayatAR:
      "ثُمَّ إِذَا كَشَفَ الضُّرَّ عَنْكُمْ إِذَا فَرِيقٌ مِنْكُمْ بِرَبِّهِمْ يُشْرِكُونَ",
  },
  {
    id: "1956",
    sura: "16",
    VerseIDAr: "55",
    ayatAR:
      "لِيَكْفُرُوا بِمَا آتَيْنَاهُمْ ۚ فَتَمَتَّعُوا ۖ فَسَوْفَ تَعْلَمُونَ",
  },
  {
    id: "1957",
    sura: "16",
    VerseIDAr: "56",
    ayatAR:
      "وَيَجْعَلُونَ لِمَا لَا يَعْلَمُونَ نَصِيبًا مِمَّا رَزَقْنَاهُمْ ۗ تَاللَّهِ لَتُسْأَلُنَّ عَمَّا كُنْتُمْ تَفْتَرُونَ",
  },
  {
    id: "1958",
    sura: "16",
    VerseIDAr: "57",
    ayatAR:
      "وَيَجْعَلُونَ لِلَّهِ الْبَنَاتِ سُبْحَانَهُ ۙ وَلَهُمْ مَا يَشْتَهُونَ",
  },
  {
    id: "1959",
    sura: "16",
    VerseIDAr: "58",
    ayatAR:
      "وَإِذَا بُشِّرَ أَحَدُهُمْ بِالْأُنْثَىٰ ظَلَّ وَجْهُهُ مُسْوَدًّا وَهُوَ كَظِيمٌ",
  },
  {
    id: "1960",
    sura: "16",
    VerseIDAr: "59",
    ayatAR:
      "يَتَوَارَىٰ مِنَ الْقَوْمِ مِنْ سُوءِ مَا بُشِّرَ بِهِ ۚ أَيُمْسِكُهُ عَلَىٰ هُونٍ أَمْ يَدُسُّهُ فِي التُّرَابِ ۗ أَلَا سَاءَ مَا يَحْكُمُونَ",
  },
  {
    id: "1961",
    sura: "16",
    VerseIDAr: "60",
    ayatAR:
      "لِلَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ مَثَلُ السَّوْءِ ۖ وَلِلَّهِ الْمَثَلُ الْأَعْلَىٰ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "1962",
    sura: "16",
    VerseIDAr: "61",
    ayatAR:
      "وَلَوْ يُؤَاخِذُ اللَّهُ النَّاسَ بِظُلْمِهِمْ مَا تَرَكَ عَلَيْهَا مِنْ دَابَّةٍ وَلَٰكِنْ يُؤَخِّرُهُمْ إِلَىٰ أَجَلٍ مُسَمًّى ۖ فَإِذَا جَاءَ أَجَلُهُمْ لَا يَسْتَأْخِرُونَ سَاعَةً ۖ وَلَا يَسْتَقْدِمُونَ",
  },
  {
    id: "1963",
    sura: "16",
    VerseIDAr: "62",
    ayatAR:
      "وَيَجْعَلُونَ لِلَّهِ مَا يَكْرَهُونَ وَتَصِفُ أَلْسِنَتُهُمُ الْكَذِبَ أَنَّ لَهُمُ الْحُسْنَىٰ ۖ لَا جَرَمَ أَنَّ لَهُمُ النَّارَ وَأَنَّهُمْ مُفْرَطُونَ",
  },
  {
    id: "1964",
    sura: "16",
    VerseIDAr: "63",
    ayatAR:
      "تَاللَّهِ لَقَدْ أَرْسَلْنَا إِلَىٰ أُمَمٍ مِنْ قَبْلِكَ فَزَيَّنَ لَهُمُ الشَّيْطَانُ أَعْمَالَهُمْ فَهُوَ وَلِيُّهُمُ الْيَوْمَ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "1965",
    sura: "16",
    VerseIDAr: "64",
    ayatAR:
      "وَمَا أَنْزَلْنَا عَلَيْكَ الْكِتَابَ إِلَّا لِتُبَيِّنَ لَهُمُ الَّذِي اخْتَلَفُوا فِيهِ ۙ وَهُدًى وَرَحْمَةً لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1966",
    sura: "16",
    VerseIDAr: "65",
    ayatAR:
      "وَاللَّهُ أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَحْيَا بِهِ الْأَرْضَ بَعْدَ مَوْتِهَا ۚ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَسْمَعُونَ",
  },
  {
    id: "1967",
    sura: "16",
    VerseIDAr: "66",
    ayatAR:
      "وَإِنَّ لَكُمْ فِي الْأَنْعَامِ لَعِبْرَةً ۖ نُسْقِيكُمْ مِمَّا فِي بُطُونِهِ مِنْ بَيْنِ فَرْثٍ وَدَمٍ لَبَنًا خَالِصًا سَائِغًا لِلشَّارِبِينَ",
  },
  {
    id: "1968",
    sura: "16",
    VerseIDAr: "67",
    ayatAR:
      "وَمِنْ ثَمَرَاتِ النَّخِيلِ وَالْأَعْنَابِ تَتَّخِذُونَ مِنْهُ سَكَرًا وَرِزْقًا حَسَنًا ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "1969",
    sura: "16",
    VerseIDAr: "68",
    ayatAR:
      "وَأَوْحَىٰ رَبُّكَ إِلَى النَّحْلِ أَنِ اتَّخِذِي مِنَ الْجِبَالِ بُيُوتًا وَمِنَ الشَّجَرِ وَمِمَّا يَعْرِشُونَ",
  },
  {
    id: "1970",
    sura: "16",
    VerseIDAr: "69",
    ayatAR:
      "ثُمَّ كُلِي مِنْ كُلِّ الثَّمَرَاتِ فَاسْلُكِي سُبُلَ رَبِّكِ ذُلُلًا ۚ يَخْرُجُ مِنْ بُطُونِهَا شَرَابٌ مُخْتَلِفٌ أَلْوَانُهُ فِيهِ شِفَاءٌ لِلنَّاسِ ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "1971",
    sura: "16",
    VerseIDAr: "70",
    ayatAR:
      "وَاللَّهُ خَلَقَكُمْ ثُمَّ يَتَوَفَّاكُمْ ۚ وَمِنْكُمْ مَنْ يُرَدُّ إِلَىٰ أَرْذَلِ الْعُمُرِ لِكَيْ لَا يَعْلَمَ بَعْدَ عِلْمٍ شَيْئًا ۚ إِنَّ اللَّهَ عَلِيمٌ قَدِيرٌ",
  },
  {
    id: "1972",
    sura: "16",
    VerseIDAr: "71",
    ayatAR:
      "وَاللَّهُ فَضَّلَ بَعْضَكُمْ عَلَىٰ بَعْضٍ فِي الرِّزْقِ ۚ فَمَا الَّذِينَ فُضِّلُوا بِرَادِّي رِزْقِهِمْ عَلَىٰ مَا مَلَكَتْ أَيْمَانُهُمْ فَهُمْ فِيهِ سَوَاءٌ ۚ أَفَبِنِعْمَةِ اللَّهِ يَجْحَدُونَ",
  },
  {
    id: "1973",
    sura: "16",
    VerseIDAr: "72",
    ayatAR:
      "وَاللَّهُ جَعَلَ لَكُمْ مِنْ أَنْفُسِكُمْ أَزْوَاجًا وَجَعَلَ لَكُمْ مِنْ أَزْوَاجِكُمْ بَنِينَ وَحَفَدَةً وَرَزَقَكُمْ مِنَ الطَّيِّبَاتِ ۚ أَفَبِالْبَاطِلِ يُؤْمِنُونَ وَبِنِعْمَتِ اللَّهِ هُمْ يَكْفُرُونَ",
  },
  {
    id: "1974",
    sura: "16",
    VerseIDAr: "73",
    ayatAR:
      "وَيَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَا يَمْلِكُ لَهُمْ رِزْقًا مِنَ السَّمَاوَاتِ وَالْأَرْضِ شَيْئًا وَلَا يَسْتَطِيعُونَ",
  },
  {
    id: "1975",
    sura: "16",
    VerseIDAr: "74",
    ayatAR:
      "فَلَا تَضْرِبُوا لِلَّهِ الْأَمْثَالَ ۚ إِنَّ اللَّهَ يَعْلَمُ وَأَنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "1976",
    sura: "16",
    VerseIDAr: "75",
    ayatAR:
      "ضَرَبَ اللَّهُ مَثَلًا عَبْدًا مَمْلُوكًا لَا يَقْدِرُ عَلَىٰ شَيْءٍ وَمَنْ رَزَقْنَاهُ مِنَّا رِزْقًا حَسَنًا فَهُوَ يُنْفِقُ مِنْهُ سِرًّا وَجَهْرًا ۖ هَلْ يَسْتَوُونَ ۚ الْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "1977",
    sura: "16",
    VerseIDAr: "76",
    ayatAR:
      "وَضَرَبَ اللَّهُ مَثَلًا رَجُلَيْنِ أَحَدُهُمَا أَبْكَمُ لَا يَقْدِرُ عَلَىٰ شَيْءٍ وَهُوَ كَلٌّ عَلَىٰ مَوْلَاهُ أَيْنَمَا يُوَجِّهْهُ لَا يَأْتِ بِخَيْرٍ ۖ هَلْ يَسْتَوِي هُوَ وَمَنْ يَأْمُرُ بِالْعَدْلِ ۙ وَهُوَ عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "1978",
    sura: "16",
    VerseIDAr: "77",
    ayatAR:
      "وَلِلَّهِ غَيْبُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَمَا أَمْرُ السَّاعَةِ إِلَّا كَلَمْحِ الْبَصَرِ أَوْ هُوَ أَقْرَبُ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "1979",
    sura: "16",
    VerseIDAr: "78",
    ayatAR:
      "وَاللَّهُ أَخْرَجَكُمْ مِنْ بُطُونِ أُمَّهَاتِكُمْ لَا تَعْلَمُونَ شَيْئًا وَجَعَلَ لَكُمُ السَّمْعَ وَالْأَبْصَارَ وَالْأَفْئِدَةَ ۙ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "1980",
    sura: "16",
    VerseIDAr: "79",
    ayatAR:
      "أَلَمْ يَرَوْا إِلَى الطَّيْرِ مُسَخَّرَاتٍ فِي جَوِّ السَّمَاءِ مَا يُمْسِكُهُنَّ إِلَّا اللَّهُ ۗ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "1981",
    sura: "16",
    VerseIDAr: "80",
    ayatAR:
      "وَاللَّهُ جَعَلَ لَكُمْ مِنْ بُيُوتِكُمْ سَكَنًا وَجَعَلَ لَكُمْ مِنْ جُلُودِ الْأَنْعَامِ بُيُوتًا تَسْتَخِفُّونَهَا يَوْمَ ظَعْنِكُمْ وَيَوْمَ إِقَامَتِكُمْ ۙ وَمِنْ أَصْوَافِهَا وَأَوْبَارِهَا وَأَشْعَارِهَا أَثَاثًا وَمَتَاعًا إِلَىٰ حِينٍ",
  },
  {
    id: "1982",
    sura: "16",
    VerseIDAr: "81",
    ayatAR:
      "وَاللَّهُ جَعَلَ لَكُمْ مِمَّا خَلَقَ ظِلَالًا وَجَعَلَ لَكُمْ مِنَ الْجِبَالِ أَكْنَانًا وَجَعَلَ لَكُمْ سَرَابِيلَ تَقِيكُمُ الْحَرَّ وَسَرَابِيلَ تَقِيكُمْ بَأْسَكُمْ ۚ كَذَٰلِكَ يُتِمُّ نِعْمَتَهُ عَلَيْكُمْ لَعَلَّكُمْ تُسْلِمُونَ",
  },
  {
    id: "1983",
    sura: "16",
    VerseIDAr: "82",
    ayatAR: "فَإِنْ تَوَلَّوْا فَإِنَّمَا عَلَيْكَ الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "1984",
    sura: "16",
    VerseIDAr: "83",
    ayatAR:
      "يَعْرِفُونَ نِعْمَتَ اللَّهِ ثُمَّ يُنْكِرُونَهَا وَأَكْثَرُهُمُ الْكَافِرُونَ",
  },
  {
    id: "1985",
    sura: "16",
    VerseIDAr: "84",
    ayatAR:
      "وَيَوْمَ نَبْعَثُ مِنْ كُلِّ أُمَّةٍ شَهِيدًا ثُمَّ لَا يُؤْذَنُ لِلَّذِينَ كَفَرُوا وَلَا هُمْ يُسْتَعْتَبُونَ",
  },
  {
    id: "1986",
    sura: "16",
    VerseIDAr: "85",
    ayatAR:
      "وَإِذَا رَأَى الَّذِينَ ظَلَمُوا الْعَذَابَ فَلَا يُخَفَّفُ عَنْهُمْ وَلَا هُمْ يُنْظَرُونَ",
  },
  {
    id: "1987",
    sura: "16",
    VerseIDAr: "86",
    ayatAR:
      "وَإِذَا رَأَى الَّذِينَ أَشْرَكُوا شُرَكَاءَهُمْ قَالُوا رَبَّنَا هَٰؤُلَاءِ شُرَكَاؤُنَا الَّذِينَ كُنَّا نَدْعُو مِنْ دُونِكَ ۖ فَأَلْقَوْا إِلَيْهِمُ الْقَوْلَ إِنَّكُمْ لَكَاذِبُونَ",
  },
  {
    id: "1988",
    sura: "16",
    VerseIDAr: "87",
    ayatAR:
      "وَأَلْقَوْا إِلَى اللَّهِ يَوْمَئِذٍ السَّلَمَ ۖ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "1989",
    sura: "16",
    VerseIDAr: "88",
    ayatAR:
      "الَّذِينَ كَفَرُوا وَصَدُّوا عَنْ سَبِيلِ اللَّهِ زِدْنَاهُمْ عَذَابًا فَوْقَ الْعَذَابِ بِمَا كَانُوا يُفْسِدُونَ",
  },
  {
    id: "1990",
    sura: "16",
    VerseIDAr: "89",
    ayatAR:
      "وَيَوْمَ نَبْعَثُ فِي كُلِّ أُمَّةٍ شَهِيدًا عَلَيْهِمْ مِنْ أَنْفُسِهِمْ ۖ وَجِئْنَا بِكَ شَهِيدًا عَلَىٰ هَٰؤُلَاءِ ۚ وَنَزَّلْنَا عَلَيْكَ الْكِتَابَ تِبْيَانًا لِكُلِّ شَيْءٍ وَهُدًى وَرَحْمَةً وَبُشْرَىٰ لِلْمُسْلِمِينَ",
  },
  {
    id: "1991",
    sura: "16",
    VerseIDAr: "90",
    ayatAR:
      "إِنَّ اللَّهَ يَأْمُرُ بِالْعَدْلِ وَالْإِحْسَانِ وَإِيتَاءِ ذِي الْقُرْبَىٰ وَيَنْهَىٰ عَنِ الْفَحْشَاءِ وَالْمُنْكَرِ وَالْبَغْيِ ۚ يَعِظُكُمْ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "1992",
    sura: "16",
    VerseIDAr: "91",
    ayatAR:
      "وَأَوْفُوا بِعَهْدِ اللَّهِ إِذَا عَاهَدْتُمْ وَلَا تَنْقُضُوا الْأَيْمَانَ بَعْدَ تَوْكِيدِهَا وَقَدْ جَعَلْتُمُ اللَّهَ عَلَيْكُمْ كَفِيلًا ۚ إِنَّ اللَّهَ يَعْلَمُ مَا تَفْعَلُونَ",
  },
  {
    id: "1993",
    sura: "16",
    VerseIDAr: "92",
    ayatAR:
      "وَلَا تَكُونُوا كَالَّتِي نَقَضَتْ غَزْلَهَا مِنْ بَعْدِ قُوَّةٍ أَنْكَاثًا تَتَّخِذُونَ أَيْمَانَكُمْ دَخَلًا بَيْنَكُمْ أَنْ تَكُونَ أُمَّةٌ هِيَ أَرْبَىٰ مِنْ أُمَّةٍ ۚ إِنَّمَا يَبْلُوكُمُ اللَّهُ بِهِ ۚ وَلَيُبَيِّنَنَّ لَكُمْ يَوْمَ الْقِيَامَةِ مَا كُنْتُمْ فِيهِ تَخْتَلِفُونَ",
  },
  {
    id: "1994",
    sura: "16",
    VerseIDAr: "93",
    ayatAR:
      "وَلَوْ شَاءَ اللَّهُ لَجَعَلَكُمْ أُمَّةً وَاحِدَةً وَلَٰكِنْ يُضِلُّ مَنْ يَشَاءُ وَيَهْدِي مَنْ يَشَاءُ ۚ وَلَتُسْأَلُنَّ عَمَّا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "1995",
    sura: "16",
    VerseIDAr: "94",
    ayatAR:
      "وَلَا تَتَّخِذُوا أَيْمَانَكُمْ دَخَلًا بَيْنَكُمْ فَتَزِلَّ قَدَمٌ بَعْدَ ثُبُوتِهَا وَتَذُوقُوا السُّوءَ بِمَا صَدَدْتُمْ عَنْ سَبِيلِ اللَّهِ ۖ وَلَكُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "1996",
    sura: "16",
    VerseIDAr: "95",
    ayatAR:
      "وَلَا تَشْتَرُوا بِعَهْدِ اللَّهِ ثَمَنًا قَلِيلًا ۚ إِنَّمَا عِنْدَ اللَّهِ هُوَ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "1997",
    sura: "16",
    VerseIDAr: "96",
    ayatAR:
      "مَا عِنْدَكُمْ يَنْفَدُ ۖ وَمَا عِنْدَ اللَّهِ بَاقٍ ۗ وَلَنَجْزِيَنَّ الَّذِينَ صَبَرُوا أَجْرَهُمْ بِأَحْسَنِ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1998",
    sura: "16",
    VerseIDAr: "97",
    ayatAR:
      "مَنْ عَمِلَ صَالِحًا مِنْ ذَكَرٍ أَوْ أُنْثَىٰ وَهُوَ مُؤْمِنٌ فَلَنُحْيِيَنَّهُ حَيَاةً طَيِّبَةً ۖ وَلَنَجْزِيَنَّهُمْ أَجْرَهُمْ بِأَحْسَنِ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "1999",
    sura: "16",
    VerseIDAr: "98",
    ayatAR:
      "فَإِذَا قَرَأْتَ الْقُرْآنَ فَاسْتَعِذْ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ",
  },
  {
    id: "2000",
    sura: "16",
    VerseIDAr: "99",
    ayatAR:
      "إِنَّهُ لَيْسَ لَهُ سُلْطَانٌ عَلَى الَّذِينَ آمَنُوا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ",
  },
  {
    id: "2001",
    sura: "16",
    VerseIDAr: "100",
    ayatAR:
      "إِنَّمَا سُلْطَانُهُ عَلَى الَّذِينَ يَتَوَلَّوْنَهُ وَالَّذِينَ هُمْ بِهِ مُشْرِكُونَ",
  },
  {
    id: "2002",
    sura: "16",
    VerseIDAr: "101",
    ayatAR:
      "وَإِذَا بَدَّلْنَا آيَةً مَكَانَ آيَةٍ ۙ وَاللَّهُ أَعْلَمُ بِمَا يُنَزِّلُ قَالُوا إِنَّمَا أَنْتَ مُفْتَرٍ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "2003",
    sura: "16",
    VerseIDAr: "102",
    ayatAR:
      "قُلْ نَزَّلَهُ رُوحُ الْقُدُسِ مِنْ رَبِّكَ بِالْحَقِّ لِيُثَبِّتَ الَّذِينَ آمَنُوا وَهُدًى وَبُشْرَىٰ لِلْمُسْلِمِينَ",
  },
  {
    id: "2004",
    sura: "16",
    VerseIDAr: "103",
    ayatAR:
      "وَلَقَدْ نَعْلَمُ أَنَّهُمْ يَقُولُونَ إِنَّمَا يُعَلِّمُهُ بَشَرٌ ۗ لِسَانُ الَّذِي يُلْحِدُونَ إِلَيْهِ أَعْجَمِيٌّ وَهَٰذَا لِسَانٌ عَرَبِيٌّ مُبِينٌ",
  },
  {
    id: "2005",
    sura: "16",
    VerseIDAr: "104",
    ayatAR:
      "إِنَّ الَّذِينَ لَا يُؤْمِنُونَ بِآيَاتِ اللَّهِ لَا يَهْدِيهِمُ اللَّهُ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "2006",
    sura: "16",
    VerseIDAr: "105",
    ayatAR:
      "إِنَّمَا يَفْتَرِي الْكَذِبَ الَّذِينَ لَا يُؤْمِنُونَ بِآيَاتِ اللَّهِ ۖ وَأُولَٰئِكَ هُمُ الْكَاذِبُونَ",
  },
  {
    id: "2007",
    sura: "16",
    VerseIDAr: "106",
    ayatAR:
      "مَنْ كَفَرَ بِاللَّهِ مِنْ بَعْدِ إِيمَانِهِ إِلَّا مَنْ أُكْرِهَ وَقَلْبُهُ مُطْمَئِنٌّ بِالْإِيمَانِ وَلَٰكِنْ مَنْ شَرَحَ بِالْكُفْرِ صَدْرًا فَعَلَيْهِمْ غَضَبٌ مِنَ اللَّهِ وَلَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "2008",
    sura: "16",
    VerseIDAr: "107",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمُ اسْتَحَبُّوا الْحَيَاةَ الدُّنْيَا عَلَى الْآخِرَةِ وَأَنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الْكَافِرِينَ",
  },
  {
    id: "2009",
    sura: "16",
    VerseIDAr: "108",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ طَبَعَ اللَّهُ عَلَىٰ قُلُوبِهِمْ وَسَمْعِهِمْ وَأَبْصَارِهِمْ ۖ وَأُولَٰئِكَ هُمُ الْغَافِلُونَ",
  },
  {
    id: "2010",
    sura: "16",
    VerseIDAr: "109",
    ayatAR: "لَا جَرَمَ أَنَّهُمْ فِي الْآخِرَةِ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "2011",
    sura: "16",
    VerseIDAr: "110",
    ayatAR:
      "ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ هَاجَرُوا مِنْ بَعْدِ مَا فُتِنُوا ثُمَّ جَاهَدُوا وَصَبَرُوا إِنَّ رَبَّكَ مِنْ بَعْدِهَا لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "2012",
    sura: "16",
    VerseIDAr: "111",
    ayatAR:
      "يَوْمَ تَأْتِي كُلُّ نَفْسٍ تُجَادِلُ عَنْ نَفْسِهَا وَتُوَفَّىٰ كُلُّ نَفْسٍ مَا عَمِلَتْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "2013",
    sura: "16",
    VerseIDAr: "112",
    ayatAR:
      "وَضَرَبَ اللَّهُ مَثَلًا قَرْيَةً كَانَتْ آمِنَةً مُطْمَئِنَّةً يَأْتِيهَا رِزْقُهَا رَغَدًا مِنْ كُلِّ مَكَانٍ فَكَفَرَتْ بِأَنْعُمِ اللَّهِ فَأَذَاقَهَا اللَّهُ لِبَاسَ الْجُوعِ وَالْخَوْفِ بِمَا كَانُوا يَصْنَعُونَ",
  },
  {
    id: "2014",
    sura: "16",
    VerseIDAr: "113",
    ayatAR:
      "وَلَقَدْ جَاءَهُمْ رَسُولٌ مِنْهُمْ فَكَذَّبُوهُ فَأَخَذَهُمُ الْعَذَابُ وَهُمْ ظَالِمُونَ",
  },
  {
    id: "2015",
    sura: "16",
    VerseIDAr: "114",
    ayatAR:
      "فَكُلُوا مِمَّا رَزَقَكُمُ اللَّهُ حَلَالًا طَيِّبًا وَاشْكُرُوا نِعْمَتَ اللَّهِ إِنْ كُنْتُمْ إِيَّاهُ تَعْبُدُونَ",
  },
  {
    id: "2016",
    sura: "16",
    VerseIDAr: "115",
    ayatAR:
      "إِنَّمَا حَرَّمَ عَلَيْكُمُ الْمَيْتَةَ وَالدَّمَ وَلَحْمَ الْخِنْزِيرِ وَمَا أُهِلَّ لِغَيْرِ اللَّهِ بِهِ ۖ فَمَنِ اضْطُرَّ غَيْرَ بَاغٍ وَلَا عَادٍ فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "2017",
    sura: "16",
    VerseIDAr: "116",
    ayatAR:
      "وَلَا تَقُولُوا لِمَا تَصِفُ أَلْسِنَتُكُمُ الْكَذِبَ هَٰذَا حَلَالٌ وَهَٰذَا حَرَامٌ لِتَفْتَرُوا عَلَى اللَّهِ الْكَذِبَ ۚ إِنَّ الَّذِينَ يَفْتَرُونَ عَلَى اللَّهِ الْكَذِبَ لَا يُفْلِحُونَ",
  },
  {
    id: "2018",
    sura: "16",
    VerseIDAr: "117",
    ayatAR: "مَتَاعٌ قَلِيلٌ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "2019",
    sura: "16",
    VerseIDAr: "118",
    ayatAR:
      "وَعَلَى الَّذِينَ هَادُوا حَرَّمْنَا مَا قَصَصْنَا عَلَيْكَ مِنْ قَبْلُ ۖ وَمَا ظَلَمْنَاهُمْ وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "2020",
    sura: "16",
    VerseIDAr: "119",
    ayatAR:
      "ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ عَمِلُوا السُّوءَ بِجَهَالَةٍ ثُمَّ تَابُوا مِنْ بَعْدِ ذَٰلِكَ وَأَصْلَحُوا إِنَّ رَبَّكَ مِنْ بَعْدِهَا لَغَفُورٌ رَحِيمٌ",
  },
  {
    id: "2021",
    sura: "16",
    VerseIDAr: "120",
    ayatAR:
      "إِنَّ إِبْرَاهِيمَ كَانَ أُمَّةً قَانِتًا لِلَّهِ حَنِيفًا وَلَمْ يَكُ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "2022",
    sura: "16",
    VerseIDAr: "121",
    ayatAR:
      "شَاكِرًا لِأَنْعُمِهِ ۚ اجْتَبَاهُ وَهَدَاهُ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "2023",
    sura: "16",
    VerseIDAr: "122",
    ayatAR:
      "وَآتَيْنَاهُ فِي الدُّنْيَا حَسَنَةً ۖ وَإِنَّهُ فِي الْآخِرَةِ لَمِنَ الصَّالِحِينَ",
  },
  {
    id: "2024",
    sura: "16",
    VerseIDAr: "123",
    ayatAR:
      "ثُمَّ أَوْحَيْنَا إِلَيْكَ أَنِ اتَّبِعْ مِلَّةَ إِبْرَاهِيمَ حَنِيفًا ۖ وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "2025",
    sura: "16",
    VerseIDAr: "124",
    ayatAR:
      "إِنَّمَا جُعِلَ السَّبْتُ عَلَى الَّذِينَ اخْتَلَفُوا فِيهِ ۚ وَإِنَّ رَبَّكَ لَيَحْكُمُ بَيْنَهُمْ يَوْمَ الْقِيَامَةِ فِيمَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "2026",
    sura: "16",
    VerseIDAr: "125",
    ayatAR:
      "ادْعُ إِلَىٰ سَبِيلِ رَبِّكَ بِالْحِكْمَةِ وَالْمَوْعِظَةِ الْحَسَنَةِ ۖ وَجَادِلْهُمْ بِالَّتِي هِيَ أَحْسَنُ ۚ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَنْ ضَلَّ عَنْ سَبِيلِهِ ۖ وَهُوَ أَعْلَمُ بِالْمُهْتَدِينَ",
  },
  {
    id: "2027",
    sura: "16",
    VerseIDAr: "126",
    ayatAR:
      "وَإِنْ عَاقَبْتُمْ فَعَاقِبُوا بِمِثْلِ مَا عُوقِبْتُمْ بِهِ ۖ وَلَئِنْ صَبَرْتُمْ لَهُوَ خَيْرٌ لِلصَّابِرِينَ",
  },
  {
    id: "2028",
    sura: "16",
    VerseIDAr: "127",
    ayatAR:
      "وَاصْبِرْ وَمَا صَبْرُكَ إِلَّا بِاللَّهِ ۚ وَلَا تَحْزَنْ عَلَيْهِمْ وَلَا تَكُ فِي ضَيْقٍ مِمَّا يَمْكُرُونَ",
  },
  {
    id: "2029",
    sura: "16",
    VerseIDAr: "128",
    ayatAR:
      "إِنَّ اللَّهَ مَعَ الَّذِينَ اتَّقَوْا وَالَّذِينَ هُمْ مُحْسِنُونَ",
  },
  {
    id: "2030",
    sura: "17",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سُبْحَانَ الَّذِي أَسْرَىٰ بِعَبْدِهِ لَيْلًا مِنَ الْمَسْجِدِ الْحَرَامِ إِلَى الْمَسْجِدِ الْأَقْصَى الَّذِي بَارَكْنَا حَوْلَهُ لِنُرِيَهُ مِنْ آيَاتِنَا ۚ إِنَّهُ هُوَ السَّمِيعُ الْبَصِيرُ",
  },
  {
    id: "2031",
    sura: "17",
    VerseIDAr: "2",
    ayatAR:
      "وَآتَيْنَا مُوسَى الْكِتَابَ وَجَعَلْنَاهُ هُدًى لِبَنِي إِسْرَائِيلَ أَلَّا تَتَّخِذُوا مِنْ دُونِي وَكِيلًا",
  },
  {
    id: "2032",
    sura: "17",
    VerseIDAr: "3",
    ayatAR:
      "ذُرِّيَّةَ مَنْ حَمَلْنَا مَعَ نُوحٍ ۚ إِنَّهُ كَانَ عَبْدًا شَكُورًا",
  },
  {
    id: "2033",
    sura: "17",
    VerseIDAr: "4",
    ayatAR:
      "وَقَضَيْنَا إِلَىٰ بَنِي إِسْرَائِيلَ فِي الْكِتَابِ لَتُفْسِدُنَّ فِي الْأَرْضِ مَرَّتَيْنِ وَلَتَعْلُنَّ عُلُوًّا كَبِيرًا",
  },
  {
    id: "2034",
    sura: "17",
    VerseIDAr: "5",
    ayatAR:
      "فَإِذَا جَاءَ وَعْدُ أُولَاهُمَا بَعَثْنَا عَلَيْكُمْ عِبَادًا لَنَا أُولِي بَأْسٍ شَدِيدٍ فَجَاسُوا خِلَالَ الدِّيَارِ ۚ وَكَانَ وَعْدًا مَفْعُولًا",
  },
  {
    id: "2035",
    sura: "17",
    VerseIDAr: "6",
    ayatAR:
      "ثُمَّ رَدَدْنَا لَكُمُ الْكَرَّةَ عَلَيْهِمْ وَأَمْدَدْنَاكُمْ بِأَمْوَالٍ وَبَنِينَ وَجَعَلْنَاكُمْ أَكْثَرَ نَفِيرًا",
  },
  {
    id: "2036",
    sura: "17",
    VerseIDAr: "7",
    ayatAR:
      "إِنْ أَحْسَنْتُمْ أَحْسَنْتُمْ لِأَنْفُسِكُمْ ۖ وَإِنْ أَسَأْتُمْ فَلَهَا ۚ فَإِذَا جَاءَ وَعْدُ الْآخِرَةِ لِيَسُوءُوا وُجُوهَكُمْ وَلِيَدْخُلُوا الْمَسْجِدَ كَمَا دَخَلُوهُ أَوَّلَ مَرَّةٍ وَلِيُتَبِّرُوا مَا عَلَوْا تَتْبِيرًا",
  },
  {
    id: "2037",
    sura: "17",
    VerseIDAr: "8",
    ayatAR:
      "عَسَىٰ رَبُّكُمْ أَنْ يَرْحَمَكُمْ ۚ وَإِنْ عُدْتُمْ عُدْنَا ۘ وَجَعَلْنَا جَهَنَّمَ لِلْكَافِرِينَ حَصِيرًا",
  },
  {
    id: "2038",
    sura: "17",
    VerseIDAr: "9",
    ayatAR:
      "إِنَّ هَٰذَا الْقُرْآنَ يَهْدِي لِلَّتِي هِيَ أَقْوَمُ وَيُبَشِّرُ الْمُؤْمِنِينَ الَّذِينَ يَعْمَلُونَ الصَّالِحَاتِ أَنَّ لَهُمْ أَجْرًا كَبِيرًا",
  },
  {
    id: "2039",
    sura: "17",
    VerseIDAr: "10",
    ayatAR:
      "وَأَنَّ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ أَعْتَدْنَا لَهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "2040",
    sura: "17",
    VerseIDAr: "11",
    ayatAR:
      "وَيَدْعُ الْإِنْسَانُ بِالشَّرِّ دُعَاءَهُ بِالْخَيْرِ ۖ وَكَانَ الْإِنْسَانُ عَجُولًا",
  },
  {
    id: "2041",
    sura: "17",
    VerseIDAr: "12",
    ayatAR:
      "وَجَعَلْنَا اللَّيْلَ وَالنَّهَارَ آيَتَيْنِ ۖ فَمَحَوْنَا آيَةَ اللَّيْلِ وَجَعَلْنَا آيَةَ النَّهَارِ مُبْصِرَةً لِتَبْتَغُوا فَضْلًا مِنْ رَبِّكُمْ وَلِتَعْلَمُوا عَدَدَ السِّنِينَ وَالْحِسَابَ ۚ وَكُلَّ شَيْءٍ فَصَّلْنَاهُ تَفْصِيلًا",
  },
  {
    id: "2042",
    sura: "17",
    VerseIDAr: "13",
    ayatAR:
      "وَكُلَّ إِنْسَانٍ أَلْزَمْنَاهُ طَائِرَهُ فِي عُنُقِهِ ۖ وَنُخْرِجُ لَهُ يَوْمَ الْقِيَامَةِ كِتَابًا يَلْقَاهُ مَنْشُورًا",
  },
  {
    id: "2043",
    sura: "17",
    VerseIDAr: "14",
    ayatAR: "اقْرَأْ كِتَابَكَ كَفَىٰ بِنَفْسِكَ الْيَوْمَ عَلَيْكَ حَسِيبًا",
  },
  {
    id: "2044",
    sura: "17",
    VerseIDAr: "15",
    ayatAR:
      "مَنِ اهْتَدَىٰ فَإِنَّمَا يَهْتَدِي لِنَفْسِهِ ۖ وَمَنْ ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۚ وَلَا تَزِرُ وَازِرَةٌ وِزْرَ أُخْرَىٰ ۗ وَمَا كُنَّا مُعَذِّبِينَ حَتَّىٰ نَبْعَثَ رَسُولًا",
  },
  {
    id: "2045",
    sura: "17",
    VerseIDAr: "16",
    ayatAR:
      "وَإِذَا أَرَدْنَا أَنْ نُهْلِكَ قَرْيَةً أَمَرْنَا مُتْرَفِيهَا فَفَسَقُوا فِيهَا فَحَقَّ عَلَيْهَا الْقَوْلُ فَدَمَّرْنَاهَا تَدْمِيرًا",
  },
  {
    id: "2046",
    sura: "17",
    VerseIDAr: "17",
    ayatAR:
      "وَكَمْ أَهْلَكْنَا مِنَ الْقُرُونِ مِنْ بَعْدِ نُوحٍ ۗ وَكَفَىٰ بِرَبِّكَ بِذُنُوبِ عِبَادِهِ خَبِيرًا بَصِيرًا",
  },
  {
    id: "2047",
    sura: "17",
    VerseIDAr: "18",
    ayatAR:
      "مَنْ كَانَ يُرِيدُ الْعَاجِلَةَ عَجَّلْنَا لَهُ فِيهَا مَا نَشَاءُ لِمَنْ نُرِيدُ ثُمَّ جَعَلْنَا لَهُ جَهَنَّمَ يَصْلَاهَا مَذْمُومًا مَدْحُورًا",
  },
  {
    id: "2048",
    sura: "17",
    VerseIDAr: "19",
    ayatAR:
      "وَمَنْ أَرَادَ الْآخِرَةَ وَسَعَىٰ لَهَا سَعْيَهَا وَهُوَ مُؤْمِنٌ فَأُولَٰئِكَ كَانَ سَعْيُهُمْ مَشْكُورًا",
  },
  {
    id: "2049",
    sura: "17",
    VerseIDAr: "20",
    ayatAR:
      "كُلًّا نُمِدُّ هَٰؤُلَاءِ وَهَٰؤُلَاءِ مِنْ عَطَاءِ رَبِّكَ ۚ وَمَا كَانَ عَطَاءُ رَبِّكَ مَحْظُورًا",
  },
  {
    id: "2050",
    sura: "17",
    VerseIDAr: "21",
    ayatAR:
      "انْظُرْ كَيْفَ فَضَّلْنَا بَعْضَهُمْ عَلَىٰ بَعْضٍ ۚ وَلَلْآخِرَةُ أَكْبَرُ دَرَجَاتٍ وَأَكْبَرُ تَفْضِيلًا",
  },
  {
    id: "2051",
    sura: "17",
    VerseIDAr: "22",
    ayatAR:
      "لَا تَجْعَلْ مَعَ اللَّهِ إِلَٰهًا آخَرَ فَتَقْعُدَ مَذْمُومًا مَخْذُولًا",
  },
  {
    id: "2052",
    sura: "17",
    VerseIDAr: "23",
    ayatAR:
      "وَقَضَىٰ رَبُّكَ أَلَّا تَعْبُدُوا إِلَّا إِيَّاهُ وَبِالْوَالِدَيْنِ إِحْسَانًا ۚ إِمَّا يَبْلُغَنَّ عِنْدَكَ الْكِبَرَ أَحَدُهُمَا أَوْ كِلَاهُمَا فَلَا تَقُلْ لَهُمَا أُفٍّ وَلَا تَنْهَرْهُمَا وَقُلْ لَهُمَا قَوْلًا كَرِيمًا",
  },
  {
    id: "2053",
    sura: "17",
    VerseIDAr: "24",
    ayatAR:
      "وَاخْفِضْ لَهُمَا جَنَاحَ الذُّلِّ مِنَ الرَّحْمَةِ وَقُلْ رَبِّ ارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا",
  },
  {
    id: "2054",
    sura: "17",
    VerseIDAr: "25",
    ayatAR:
      "رَبُّكُمْ أَعْلَمُ بِمَا فِي نُفُوسِكُمْ ۚ إِنْ تَكُونُوا صَالِحِينَ فَإِنَّهُ كَانَ لِلْأَوَّابِينَ غَفُورًا",
  },
  {
    id: "2055",
    sura: "17",
    VerseIDAr: "26",
    ayatAR:
      "وَآتِ ذَا الْقُرْبَىٰ حَقَّهُ وَالْمِسْكِينَ وَابْنَ السَّبِيلِ وَلَا تُبَذِّرْ تَبْذِيرًا",
  },
  {
    id: "2056",
    sura: "17",
    VerseIDAr: "27",
    ayatAR:
      "إِنَّ الْمُبَذِّرِينَ كَانُوا إِخْوَانَ الشَّيَاطِينِ ۖ وَكَانَ الشَّيْطَانُ لِرَبِّهِ كَفُورًا",
  },
  {
    id: "2057",
    sura: "17",
    VerseIDAr: "28",
    ayatAR:
      "وَإِمَّا تُعْرِضَنَّ عَنْهُمُ ابْتِغَاءَ رَحْمَةٍ مِنْ رَبِّكَ تَرْجُوهَا فَقُلْ لَهُمْ قَوْلًا مَيْسُورًا",
  },
  {
    id: "2058",
    sura: "17",
    VerseIDAr: "29",
    ayatAR:
      "وَلَا تَجْعَلْ يَدَكَ مَغْلُولَةً إِلَىٰ عُنُقِكَ وَلَا تَبْسُطْهَا كُلَّ الْبَسْطِ فَتَقْعُدَ مَلُومًا مَحْسُورًا",
  },
  {
    id: "2059",
    sura: "17",
    VerseIDAr: "30",
    ayatAR:
      "إِنَّ رَبَّكَ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ ۚ إِنَّهُ كَانَ بِعِبَادِهِ خَبِيرًا بَصِيرًا",
  },
  {
    id: "2060",
    sura: "17",
    VerseIDAr: "31",
    ayatAR:
      "وَلَا تَقْتُلُوا أَوْلَادَكُمْ خَشْيَةَ إِمْلَاقٍ ۖ نَحْنُ نَرْزُقُهُمْ وَإِيَّاكُمْ ۚ إِنَّ قَتْلَهُمْ كَانَ خِطْئًا كَبِيرًا",
  },
  {
    id: "2061",
    sura: "17",
    VerseIDAr: "32",
    ayatAR:
      "وَلَا تَقْرَبُوا الزِّنَا ۖ إِنَّهُ كَانَ فَاحِشَةً وَسَاءَ سَبِيلًا",
  },
  {
    id: "2062",
    sura: "17",
    VerseIDAr: "33",
    ayatAR:
      "وَلَا تَقْتُلُوا النَّفْسَ الَّتِي حَرَّمَ اللَّهُ إِلَّا بِالْحَقِّ ۗ وَمَنْ قُتِلَ مَظْلُومًا فَقَدْ جَعَلْنَا لِوَلِيِّهِ سُلْطَانًا فَلَا يُسْرِفْ فِي الْقَتْلِ ۖ إِنَّهُ كَانَ مَنْصُورًا",
  },
  {
    id: "2063",
    sura: "17",
    VerseIDAr: "34",
    ayatAR:
      "وَلَا تَقْرَبُوا مَالَ الْيَتِيمِ إِلَّا بِالَّتِي هِيَ أَحْسَنُ حَتَّىٰ يَبْلُغَ أَشُدَّهُ ۚ وَأَوْفُوا بِالْعَهْدِ ۖ إِنَّ الْعَهْدَ كَانَ مَسْئُولًا",
  },
  {
    id: "2064",
    sura: "17",
    VerseIDAr: "35",
    ayatAR:
      "وَأَوْفُوا الْكَيْلَ إِذَا كِلْتُمْ وَزِنُوا بِالْقِسْطَاسِ الْمُسْتَقِيمِ ۚ ذَٰلِكَ خَيْرٌ وَأَحْسَنُ تَأْوِيلًا",
  },
  {
    id: "2065",
    sura: "17",
    VerseIDAr: "36",
    ayatAR:
      "وَلَا تَقْفُ مَا لَيْسَ لَكَ بِهِ عِلْمٌ ۚ إِنَّ السَّمْعَ وَالْبَصَرَ وَالْفُؤَادَ كُلُّ أُولَٰئِكَ كَانَ عَنْهُ مَسْئُولًا",
  },
  {
    id: "2066",
    sura: "17",
    VerseIDAr: "37",
    ayatAR:
      "وَلَا تَمْشِ فِي الْأَرْضِ مَرَحًا ۖ إِنَّكَ لَنْ تَخْرِقَ الْأَرْضَ وَلَنْ تَبْلُغَ الْجِبَالَ طُولًا",
  },
  {
    id: "2067",
    sura: "17",
    VerseIDAr: "38",
    ayatAR: "كُلُّ ذَٰلِكَ كَانَ سَيِّئُهُ عِنْدَ رَبِّكَ مَكْرُوهًا",
  },
  {
    id: "2068",
    sura: "17",
    VerseIDAr: "39",
    ayatAR:
      "ذَٰلِكَ مِمَّا أَوْحَىٰ إِلَيْكَ رَبُّكَ مِنَ الْحِكْمَةِ ۗ وَلَا تَجْعَلْ مَعَ اللَّهِ إِلَٰهًا آخَرَ فَتُلْقَىٰ فِي جَهَنَّمَ مَلُومًا مَدْحُورًا",
  },
  {
    id: "2069",
    sura: "17",
    VerseIDAr: "40",
    ayatAR:
      "أَفَأَصْفَاكُمْ رَبُّكُمْ بِالْبَنِينَ وَاتَّخَذَ مِنَ الْمَلَائِكَةِ إِنَاثًا ۚ إِنَّكُمْ لَتَقُولُونَ قَوْلًا عَظِيمًا",
  },
  {
    id: "2070",
    sura: "17",
    VerseIDAr: "41",
    ayatAR:
      "وَلَقَدْ صَرَّفْنَا فِي هَٰذَا الْقُرْآنِ لِيَذَّكَّرُوا وَمَا يَزِيدُهُمْ إِلَّا نُفُورًا",
  },
  {
    id: "2071",
    sura: "17",
    VerseIDAr: "42",
    ayatAR:
      "قُلْ لَوْ كَانَ مَعَهُ آلِهَةٌ كَمَا يَقُولُونَ إِذًا لَابْتَغَوْا إِلَىٰ ذِي الْعَرْشِ سَبِيلًا",
  },
  {
    id: "2072",
    sura: "17",
    VerseIDAr: "43",
    ayatAR: "سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يَقُولُونَ عُلُوًّا كَبِيرًا",
  },
  {
    id: "2073",
    sura: "17",
    VerseIDAr: "44",
    ayatAR:
      "تُسَبِّحُ لَهُ السَّمَاوَاتُ السَّبْعُ وَالْأَرْضُ وَمَنْ فِيهِنَّ ۚ وَإِنْ مِنْ شَيْءٍ إِلَّا يُسَبِّحُ بِحَمْدِهِ وَلَٰكِنْ لَا تَفْقَهُونَ تَسْبِيحَهُمْ ۗ إِنَّهُ كَانَ حَلِيمًا غَفُورًا",
  },
  {
    id: "2074",
    sura: "17",
    VerseIDAr: "45",
    ayatAR:
      "وَإِذَا قَرَأْتَ الْقُرْآنَ جَعَلْنَا بَيْنَكَ وَبَيْنَ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ حِجَابًا مَسْتُورًا",
  },
  {
    id: "2075",
    sura: "17",
    VerseIDAr: "46",
    ayatAR:
      "وَجَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَنْ يَفْقَهُوهُ وَفِي آذَانِهِمْ وَقْرًا ۚ وَإِذَا ذَكَرْتَ رَبَّكَ فِي الْقُرْآنِ وَحْدَهُ وَلَّوْا عَلَىٰ أَدْبَارِهِمْ نُفُورًا",
  },
  {
    id: "2076",
    sura: "17",
    VerseIDAr: "47",
    ayatAR:
      "نَحْنُ أَعْلَمُ بِمَا يَسْتَمِعُونَ بِهِ إِذْ يَسْتَمِعُونَ إِلَيْكَ وَإِذْ هُمْ نَجْوَىٰ إِذْ يَقُولُ الظَّالِمُونَ إِنْ تَتَّبِعُونَ إِلَّا رَجُلًا مَسْحُورًا",
  },
  {
    id: "2077",
    sura: "17",
    VerseIDAr: "48",
    ayatAR:
      "انْظُرْ كَيْفَ ضَرَبُوا لَكَ الْأَمْثَالَ فَضَلُّوا فَلَا يَسْتَطِيعُونَ سَبِيلًا",
  },
  {
    id: "2078",
    sura: "17",
    VerseIDAr: "49",
    ayatAR:
      "وَقَالُوا أَإِذَا كُنَّا عِظَامًا وَرُفَاتًا أَإِنَّا لَمَبْعُوثُونَ خَلْقًا جَدِيدًا",
  },
  {
    id: "2079",
    sura: "17",
    VerseIDAr: "50",
    ayatAR: "قُلْ كُونُوا حِجَارَةً أَوْ حَدِيدًا",
  },
  {
    id: "2080",
    sura: "17",
    VerseIDAr: "51",
    ayatAR:
      "أَوْ خَلْقًا مِمَّا يَكْبُرُ فِي صُدُورِكُمْ ۚ فَسَيَقُولُونَ مَنْ يُعِيدُنَا ۖ قُلِ الَّذِي فَطَرَكُمْ أَوَّلَ مَرَّةٍ ۚ فَسَيُنْغِضُونَ إِلَيْكَ رُءُوسَهُمْ وَيَقُولُونَ مَتَىٰ هُوَ ۖ قُلْ عَسَىٰ أَنْ يَكُونَ قَرِيبًا",
  },
  {
    id: "2081",
    sura: "17",
    VerseIDAr: "52",
    ayatAR:
      "يَوْمَ يَدْعُوكُمْ فَتَسْتَجِيبُونَ بِحَمْدِهِ وَتَظُنُّونَ إِنْ لَبِثْتُمْ إِلَّا قَلِيلًا",
  },
  {
    id: "2082",
    sura: "17",
    VerseIDAr: "53",
    ayatAR:
      "وَقُلْ لِعِبَادِي يَقُولُوا الَّتِي هِيَ أَحْسَنُ ۚ إِنَّ الشَّيْطَانَ يَنْزَغُ بَيْنَهُمْ ۚ إِنَّ الشَّيْطَانَ كَانَ لِلْإِنْسَانِ عَدُوًّا مُبِينًا",
  },
  {
    id: "2083",
    sura: "17",
    VerseIDAr: "54",
    ayatAR:
      "رَبُّكُمْ أَعْلَمُ بِكُمْ ۖ إِنْ يَشَأْ يَرْحَمْكُمْ أَوْ إِنْ يَشَأْ يُعَذِّبْكُمْ ۚ وَمَا أَرْسَلْنَاكَ عَلَيْهِمْ وَكِيلًا",
  },
  {
    id: "2084",
    sura: "17",
    VerseIDAr: "55",
    ayatAR:
      "وَرَبُّكَ أَعْلَمُ بِمَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ ۗ وَلَقَدْ فَضَّلْنَا بَعْضَ النَّبِيِّينَ عَلَىٰ بَعْضٍ ۖ وَآتَيْنَا دَاوُودَ زَبُورًا",
  },
  {
    id: "2085",
    sura: "17",
    VerseIDAr: "56",
    ayatAR:
      "قُلِ ادْعُوا الَّذِينَ زَعَمْتُمْ مِنْ دُونِهِ فَلَا يَمْلِكُونَ كَشْفَ الضُّرِّ عَنْكُمْ وَلَا تَحْوِيلًا",
  },
  {
    id: "2086",
    sura: "17",
    VerseIDAr: "57",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ يَدْعُونَ يَبْتَغُونَ إِلَىٰ رَبِّهِمُ الْوَسِيلَةَ أَيُّهُمْ أَقْرَبُ وَيَرْجُونَ رَحْمَتَهُ وَيَخَافُونَ عَذَابَهُ ۚ إِنَّ عَذَابَ رَبِّكَ كَانَ مَحْذُورًا",
  },
  {
    id: "2087",
    sura: "17",
    VerseIDAr: "58",
    ayatAR:
      "وَإِنْ مِنْ قَرْيَةٍ إِلَّا نَحْنُ مُهْلِكُوهَا قَبْلَ يَوْمِ الْقِيَامَةِ أَوْ مُعَذِّبُوهَا عَذَابًا شَدِيدًا ۚ كَانَ ذَٰلِكَ فِي الْكِتَابِ مَسْطُورًا",
  },
  {
    id: "2088",
    sura: "17",
    VerseIDAr: "59",
    ayatAR:
      "وَمَا مَنَعَنَا أَنْ نُرْسِلَ بِالْآيَاتِ إِلَّا أَنْ كَذَّبَ بِهَا الْأَوَّلُونَ ۚ وَآتَيْنَا ثَمُودَ النَّاقَةَ مُبْصِرَةً فَظَلَمُوا بِهَا ۚ وَمَا نُرْسِلُ بِالْآيَاتِ إِلَّا تَخْوِيفًا",
  },
  {
    id: "2089",
    sura: "17",
    VerseIDAr: "60",
    ayatAR:
      "وَإِذْ قُلْنَا لَكَ إِنَّ رَبَّكَ أَحَاطَ بِالنَّاسِ ۚ وَمَا جَعَلْنَا الرُّؤْيَا الَّتِي أَرَيْنَاكَ إِلَّا فِتْنَةً لِلنَّاسِ وَالشَّجَرَةَ الْمَلْعُونَةَ فِي الْقُرْآنِ ۚ وَنُخَوِّفُهُمْ فَمَا يَزِيدُهُمْ إِلَّا طُغْيَانًا كَبِيرًا",
  },
  {
    id: "2090",
    sura: "17",
    VerseIDAr: "61",
    ayatAR:
      "وَإِذْ قُلْنَا لِلْمَلَائِكَةِ اسْجُدُوا لِآدَمَ فَسَجَدُوا إِلَّا إِبْلِيسَ قَالَ أَأَسْجُدُ لِمَنْ خَلَقْتَ طِينًا",
  },
  {
    id: "2091",
    sura: "17",
    VerseIDAr: "62",
    ayatAR:
      "قَالَ أَرَأَيْتَكَ هَٰذَا الَّذِي كَرَّمْتَ عَلَيَّ لَئِنْ أَخَّرْتَنِ إِلَىٰ يَوْمِ الْقِيَامَةِ لَأَحْتَنِكَنَّ ذُرِّيَّتَهُ إِلَّا قَلِيلًا",
  },
  {
    id: "2092",
    sura: "17",
    VerseIDAr: "63",
    ayatAR:
      "قَالَ اذْهَبْ فَمَنْ تَبِعَكَ مِنْهُمْ فَإِنَّ جَهَنَّمَ جَزَاؤُكُمْ جَزَاءً مَوْفُورًا",
  },
  {
    id: "2093",
    sura: "17",
    VerseIDAr: "64",
    ayatAR:
      "وَاسْتَفْزِزْ مَنِ اسْتَطَعْتَ مِنْهُمْ بِصَوْتِكَ وَأَجْلِبْ عَلَيْهِمْ بِخَيْلِكَ وَرَجِلِكَ وَشَارِكْهُمْ فِي الْأَمْوَالِ وَالْأَوْلَادِ وَعِدْهُمْ ۚ وَمَا يَعِدُهُمُ الشَّيْطَانُ إِلَّا غُرُورًا",
  },
  {
    id: "2094",
    sura: "17",
    VerseIDAr: "65",
    ayatAR:
      "إِنَّ عِبَادِي لَيْسَ لَكَ عَلَيْهِمْ سُلْطَانٌ ۚ وَكَفَىٰ بِرَبِّكَ وَكِيلًا",
  },
  {
    id: "2095",
    sura: "17",
    VerseIDAr: "66",
    ayatAR:
      "رَبُّكُمُ الَّذِي يُزْجِي لَكُمُ الْفُلْكَ فِي الْبَحْرِ لِتَبْتَغُوا مِنْ فَضْلِهِ ۚ إِنَّهُ كَانَ بِكُمْ رَحِيمًا",
  },
  {
    id: "2096",
    sura: "17",
    VerseIDAr: "67",
    ayatAR:
      "وَإِذَا مَسَّكُمُ الضُّرُّ فِي الْبَحْرِ ضَلَّ مَنْ تَدْعُونَ إِلَّا إِيَّاهُ ۖ فَلَمَّا نَجَّاكُمْ إِلَى الْبَرِّ أَعْرَضْتُمْ ۚ وَكَانَ الْإِنْسَانُ كَفُورًا",
  },
  {
    id: "2097",
    sura: "17",
    VerseIDAr: "68",
    ayatAR:
      "أَفَأَمِنْتُمْ أَنْ يَخْسِفَ بِكُمْ جَانِبَ الْبَرِّ أَوْ يُرْسِلَ عَلَيْكُمْ حَاصِبًا ثُمَّ لَا تَجِدُوا لَكُمْ وَكِيلًا",
  },
  {
    id: "2098",
    sura: "17",
    VerseIDAr: "69",
    ayatAR:
      "أَمْ أَمِنْتُمْ أَنْ يُعِيدَكُمْ فِيهِ تَارَةً أُخْرَىٰ فَيُرْسِلَ عَلَيْكُمْ قَاصِفًا مِنَ الرِّيحِ فَيُغْرِقَكُمْ بِمَا كَفَرْتُمْ ۙ ثُمَّ لَا تَجِدُوا لَكُمْ عَلَيْنَا بِهِ تَبِيعًا",
  },
  {
    id: "2099",
    sura: "17",
    VerseIDAr: "70",
    ayatAR:
      "وَلَقَدْ كَرَّمْنَا بَنِي آدَمَ وَحَمَلْنَاهُمْ فِي الْبَرِّ وَالْبَحْرِ وَرَزَقْنَاهُمْ مِنَ الطَّيِّبَاتِ وَفَضَّلْنَاهُمْ عَلَىٰ كَثِيرٍ مِمَّنْ خَلَقْنَا تَفْضِيلًا",
  },
  {
    id: "2100",
    sura: "17",
    VerseIDAr: "71",
    ayatAR:
      "يَوْمَ نَدْعُو كُلَّ أُنَاسٍ بِإِمَامِهِمْ ۖ فَمَنْ أُوتِيَ كِتَابَهُ بِيَمِينِهِ فَأُولَٰئِكَ يَقْرَءُونَ كِتَابَهُمْ وَلَا يُظْلَمُونَ فَتِيلًا",
  },
  {
    id: "2101",
    sura: "17",
    VerseIDAr: "72",
    ayatAR:
      "وَمَنْ كَانَ فِي هَٰذِهِ أَعْمَىٰ فَهُوَ فِي الْآخِرَةِ أَعْمَىٰ وَأَضَلُّ سَبِيلًا",
  },
  {
    id: "2102",
    sura: "17",
    VerseIDAr: "73",
    ayatAR:
      "وَإِنْ كَادُوا لَيَفْتِنُونَكَ عَنِ الَّذِي أَوْحَيْنَا إِلَيْكَ لِتَفْتَرِيَ عَلَيْنَا غَيْرَهُ ۖ وَإِذًا لَاتَّخَذُوكَ خَلِيلًا",
  },
  {
    id: "2103",
    sura: "17",
    VerseIDAr: "74",
    ayatAR:
      "وَلَوْلَا أَنْ ثَبَّتْنَاكَ لَقَدْ كِدْتَ تَرْكَنُ إِلَيْهِمْ شَيْئًا قَلِيلًا",
  },
  {
    id: "2104",
    sura: "17",
    VerseIDAr: "75",
    ayatAR:
      "إِذًا لَأَذَقْنَاكَ ضِعْفَ الْحَيَاةِ وَضِعْفَ الْمَمَاتِ ثُمَّ لَا تَجِدُ لَكَ عَلَيْنَا نَصِيرًا",
  },
  {
    id: "2105",
    sura: "17",
    VerseIDAr: "76",
    ayatAR:
      "وَإِنْ كَادُوا لَيَسْتَفِزُّونَكَ مِنَ الْأَرْضِ لِيُخْرِجُوكَ مِنْهَا ۖ وَإِذًا لَا يَلْبَثُونَ خِلَافَكَ إِلَّا قَلِيلًا",
  },
  {
    id: "2106",
    sura: "17",
    VerseIDAr: "77",
    ayatAR:
      "سُنَّةَ مَنْ قَدْ أَرْسَلْنَا قَبْلَكَ مِنْ رُسُلِنَا ۖ وَلَا تَجِدُ لِسُنَّتِنَا تَحْوِيلًا",
  },
  {
    id: "2107",
    sura: "17",
    VerseIDAr: "78",
    ayatAR:
      "أَقِمِ الصَّلَاةَ لِدُلُوكِ الشَّمْسِ إِلَىٰ غَسَقِ اللَّيْلِ وَقُرْآنَ الْفَجْرِ ۖ إِنَّ قُرْآنَ الْفَجْرِ كَانَ مَشْهُودًا",
  },
  {
    id: "2108",
    sura: "17",
    VerseIDAr: "79",
    ayatAR:
      "وَمِنَ اللَّيْلِ فَتَهَجَّدْ بِهِ نَافِلَةً لَكَ عَسَىٰ أَنْ يَبْعَثَكَ رَبُّكَ مَقَامًا مَحْمُودًا",
  },
  {
    id: "2109",
    sura: "17",
    VerseIDAr: "80",
    ayatAR:
      "وَقُلْ رَبِّ أَدْخِلْنِي مُدْخَلَ صِدْقٍ وَأَخْرِجْنِي مُخْرَجَ صِدْقٍ وَاجْعَلْ لِي مِنْ لَدُنْكَ سُلْطَانًا نَصِيرًا",
  },
  {
    id: "2110",
    sura: "17",
    VerseIDAr: "81",
    ayatAR:
      "وَقُلْ جَاءَ الْحَقُّ وَزَهَقَ الْبَاطِلُ ۚ إِنَّ الْبَاطِلَ كَانَ زَهُوقًا",
  },
  {
    id: "2111",
    sura: "17",
    VerseIDAr: "82",
    ayatAR:
      "وَنُنَزِّلُ مِنَ الْقُرْآنِ مَا هُوَ شِفَاءٌ وَرَحْمَةٌ لِلْمُؤْمِنِينَ ۙ وَلَا يَزِيدُ الظَّالِمِينَ إِلَّا خَسَارًا",
  },
  {
    id: "2112",
    sura: "17",
    VerseIDAr: "83",
    ayatAR:
      "وَإِذَا أَنْعَمْنَا عَلَى الْإِنْسَانِ أَعْرَضَ وَنَأَىٰ بِجَانِبِهِ ۖ وَإِذَا مَسَّهُ الشَّرُّ كَانَ يَئُوسًا",
  },
  {
    id: "2113",
    sura: "17",
    VerseIDAr: "84",
    ayatAR:
      "قُلْ كُلٌّ يَعْمَلُ عَلَىٰ شَاكِلَتِهِ فَرَبُّكُمْ أَعْلَمُ بِمَنْ هُوَ أَهْدَىٰ سَبِيلًا",
  },
  {
    id: "2114",
    sura: "17",
    VerseIDAr: "85",
    ayatAR:
      "وَيَسْأَلُونَكَ عَنِ الرُّوحِ ۖ قُلِ الرُّوحُ مِنْ أَمْرِ رَبِّي وَمَا أُوتِيتُمْ مِنَ الْعِلْمِ إِلَّا قَلِيلًا",
  },
  {
    id: "2115",
    sura: "17",
    VerseIDAr: "86",
    ayatAR:
      "وَلَئِنْ شِئْنَا لَنَذْهَبَنَّ بِالَّذِي أَوْحَيْنَا إِلَيْكَ ثُمَّ لَا تَجِدُ لَكَ بِهِ عَلَيْنَا وَكِيلًا",
  },
  {
    id: "2116",
    sura: "17",
    VerseIDAr: "87",
    ayatAR:
      "إِلَّا رَحْمَةً مِنْ رَبِّكَ ۚ إِنَّ فَضْلَهُ كَانَ عَلَيْكَ كَبِيرًا",
  },
  {
    id: "2117",
    sura: "17",
    VerseIDAr: "88",
    ayatAR:
      "قُلْ لَئِنِ اجْتَمَعَتِ الْإِنْسُ وَالْجِنُّ عَلَىٰ أَنْ يَأْتُوا بِمِثْلِ هَٰذَا الْقُرْآنِ لَا يَأْتُونَ بِمِثْلِهِ وَلَوْ كَانَ بَعْضُهُمْ لِبَعْضٍ ظَهِيرًا",
  },
  {
    id: "2118",
    sura: "17",
    VerseIDAr: "89",
    ayatAR:
      "وَلَقَدْ صَرَّفْنَا لِلنَّاسِ فِي هَٰذَا الْقُرْآنِ مِنْ كُلِّ مَثَلٍ فَأَبَىٰ أَكْثَرُ النَّاسِ إِلَّا كُفُورًا",
  },
  {
    id: "2119",
    sura: "17",
    VerseIDAr: "90",
    ayatAR:
      "وَقَالُوا لَنْ نُؤْمِنَ لَكَ حَتَّىٰ تَفْجُرَ لَنَا مِنَ الْأَرْضِ يَنْبُوعًا",
  },
  {
    id: "2120",
    sura: "17",
    VerseIDAr: "91",
    ayatAR:
      "أَوْ تَكُونَ لَكَ جَنَّةٌ مِنْ نَخِيلٍ وَعِنَبٍ فَتُفَجِّرَ الْأَنْهَارَ خِلَالَهَا تَفْجِيرًا",
  },
  {
    id: "2121",
    sura: "17",
    VerseIDAr: "92",
    ayatAR:
      "أَوْ تُسْقِطَ السَّمَاءَ كَمَا زَعَمْتَ عَلَيْنَا كِسَفًا أَوْ تَأْتِيَ بِاللَّهِ وَالْمَلَائِكَةِ قَبِيلًا",
  },
  {
    id: "2122",
    sura: "17",
    VerseIDAr: "93",
    ayatAR:
      "أَوْ يَكُونَ لَكَ بَيْتٌ مِنْ زُخْرُفٍ أَوْ تَرْقَىٰ فِي السَّمَاءِ وَلَنْ نُؤْمِنَ لِرُقِيِّكَ حَتَّىٰ تُنَزِّلَ عَلَيْنَا كِتَابًا نَقْرَؤُهُ ۗ قُلْ سُبْحَانَ رَبِّي هَلْ كُنْتُ إِلَّا بَشَرًا رَسُولًا",
  },
  {
    id: "2123",
    sura: "17",
    VerseIDAr: "94",
    ayatAR:
      "وَمَا مَنَعَ النَّاسَ أَنْ يُؤْمِنُوا إِذْ جَاءَهُمُ الْهُدَىٰ إِلَّا أَنْ قَالُوا أَبَعَثَ اللَّهُ بَشَرًا رَسُولًا",
  },
  {
    id: "2124",
    sura: "17",
    VerseIDAr: "95",
    ayatAR:
      "قُلْ لَوْ كَانَ فِي الْأَرْضِ مَلَائِكَةٌ يَمْشُونَ مُطْمَئِنِّينَ لَنَزَّلْنَا عَلَيْهِمْ مِنَ السَّمَاءِ مَلَكًا رَسُولًا",
  },
  {
    id: "2125",
    sura: "17",
    VerseIDAr: "96",
    ayatAR:
      "قُلْ كَفَىٰ بِاللَّهِ شَهِيدًا بَيْنِي وَبَيْنَكُمْ ۚ إِنَّهُ كَانَ بِعِبَادِهِ خَبِيرًا بَصِيرًا",
  },
  {
    id: "2126",
    sura: "17",
    VerseIDAr: "97",
    ayatAR:
      "وَمَنْ يَهْدِ اللَّهُ فَهُوَ الْمُهْتَدِ ۖ وَمَنْ يُضْلِلْ فَلَنْ تَجِدَ لَهُمْ أَوْلِيَاءَ مِنْ دُونِهِ ۖ وَنَحْشُرُهُمْ يَوْمَ الْقِيَامَةِ عَلَىٰ وُجُوهِهِمْ عُمْيًا وَبُكْمًا وَصُمًّا ۖ مَأْوَاهُمْ جَهَنَّمُ ۖ كُلَّمَا خَبَتْ زِدْنَاهُمْ سَعِيرًا",
  },
  {
    id: "2127",
    sura: "17",
    VerseIDAr: "98",
    ayatAR:
      "ذَٰلِكَ جَزَاؤُهُمْ بِأَنَّهُمْ كَفَرُوا بِآيَاتِنَا وَقَالُوا أَإِذَا كُنَّا عِظَامًا وَرُفَاتًا أَإِنَّا لَمَبْعُوثُونَ خَلْقًا جَدِيدًا",
  },
  {
    id: "2128",
    sura: "17",
    VerseIDAr: "99",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّ اللَّهَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ قَادِرٌ عَلَىٰ أَنْ يَخْلُقَ مِثْلَهُمْ وَجَعَلَ لَهُمْ أَجَلًا لَا رَيْبَ فِيهِ فَأَبَى الظَّالِمُونَ إِلَّا كُفُورًا",
  },
  {
    id: "2129",
    sura: "17",
    VerseIDAr: "100",
    ayatAR:
      "قُلْ لَوْ أَنْتُمْ تَمْلِكُونَ خَزَائِنَ رَحْمَةِ رَبِّي إِذًا لَأَمْسَكْتُمْ خَشْيَةَ الْإِنْفَاقِ ۚ وَكَانَ الْإِنْسَانُ قَتُورًا",
  },
  {
    id: "2130",
    sura: "17",
    VerseIDAr: "101",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَىٰ تِسْعَ آيَاتٍ بَيِّنَاتٍ ۖ فَاسْأَلْ بَنِي إِسْرَائِيلَ إِذْ جَاءَهُمْ فَقَالَ لَهُ فِرْعَوْنُ إِنِّي لَأَظُنُّكَ يَا مُوسَىٰ مَسْحُورًا",
  },
  {
    id: "2131",
    sura: "17",
    VerseIDAr: "102",
    ayatAR:
      "قَالَ لَقَدْ عَلِمْتَ مَا أَنْزَلَ هَٰؤُلَاءِ إِلَّا رَبُّ السَّمَاوَاتِ وَالْأَرْضِ بَصَائِرَ وَإِنِّي لَأَظُنُّكَ يَا فِرْعَوْنُ مَثْبُورًا",
  },
  {
    id: "2132",
    sura: "17",
    VerseIDAr: "103",
    ayatAR:
      "فَأَرَادَ أَنْ يَسْتَفِزَّهُمْ مِنَ الْأَرْضِ فَأَغْرَقْنَاهُ وَمَنْ مَعَهُ جَمِيعًا",
  },
  {
    id: "2133",
    sura: "17",
    VerseIDAr: "104",
    ayatAR:
      "وَقُلْنَا مِنْ بَعْدِهِ لِبَنِي إِسْرَائِيلَ اسْكُنُوا الْأَرْضَ فَإِذَا جَاءَ وَعْدُ الْآخِرَةِ جِئْنَا بِكُمْ لَفِيفًا",
  },
  {
    id: "2134",
    sura: "17",
    VerseIDAr: "105",
    ayatAR:
      "وَبِالْحَقِّ أَنْزَلْنَاهُ وَبِالْحَقِّ نَزَلَ ۗ وَمَا أَرْسَلْنَاكَ إِلَّا مُبَشِّرًا وَنَذِيرًا",
  },
  {
    id: "2135",
    sura: "17",
    VerseIDAr: "106",
    ayatAR:
      "وَقُرْآنًا فَرَقْنَاهُ لِتَقْرَأَهُ عَلَى النَّاسِ عَلَىٰ مُكْثٍ وَنَزَّلْنَاهُ تَنْزِيلًا",
  },
  {
    id: "2136",
    sura: "17",
    VerseIDAr: "107",
    ayatAR:
      "قُلْ آمِنُوا بِهِ أَوْ لَا تُؤْمِنُوا ۚ إِنَّ الَّذِينَ أُوتُوا الْعِلْمَ مِنْ قَبْلِهِ إِذَا يُتْلَىٰ عَلَيْهِمْ يَخِرُّونَ لِلْأَذْقَانِ سُجَّدًا",
  },
  {
    id: "2137",
    sura: "17",
    VerseIDAr: "108",
    ayatAR:
      "وَيَقُولُونَ سُبْحَانَ رَبِّنَا إِنْ كَانَ وَعْدُ رَبِّنَا لَمَفْعُولًا",
  },
  {
    id: "2138",
    sura: "17",
    VerseIDAr: "109",
    ayatAR: "وَيَخِرُّونَ لِلْأَذْقَانِ يَبْكُونَ وَيَزِيدُهُمْ خُشُوعًا ۩",
  },
  {
    id: "2139",
    sura: "17",
    VerseIDAr: "110",
    ayatAR:
      "قُلِ ادْعُوا اللَّهَ أَوِ ادْعُوا الرَّحْمَٰنَ ۖ أَيًّا مَا تَدْعُوا فَلَهُ الْأَسْمَاءُ الْحُسْنَىٰ ۚ وَلَا تَجْهَرْ بِصَلَاتِكَ وَلَا تُخَافِتْ بِهَا وَابْتَغِ بَيْنَ ذَٰلِكَ سَبِيلًا",
  },
  {
    id: "2140",
    sura: "17",
    VerseIDAr: "111",
    ayatAR:
      "وَقُلِ الْحَمْدُ لِلَّهِ الَّذِي لَمْ يَتَّخِذْ وَلَدًا وَلَمْ يَكُنْ لَهُ شَرِيكٌ فِي الْمُلْكِ وَلَمْ يَكُنْ لَهُ وَلِيٌّ مِنَ الذُّلِّ ۖ وَكَبِّرْهُ تَكْبِيرًا",
  },
  {
    id: "2141",
    sura: "18",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْحَمْدُ لِلَّهِ الَّذِي أَنْزَلَ عَلَىٰ عَبْدِهِ الْكِتَابَ وَلَمْ يَجْعَلْ لَهُ عِوَجًا ۜ",
  },
  {
    id: "2142",
    sura: "18",
    VerseIDAr: "2",
    ayatAR:
      "قَيِّمًا لِيُنْذِرَ بَأْسًا شَدِيدًا مِنْ لَدُنْهُ وَيُبَشِّرَ الْمُؤْمِنِينَ الَّذِينَ يَعْمَلُونَ الصَّالِحَاتِ أَنَّ لَهُمْ أَجْرًا حَسَنًا",
  },
  {
    id: "2143",
    sura: "18",
    VerseIDAr: "3",
    ayatAR: "مَاكِثِينَ فِيهِ أَبَدًا",
  },
  {
    id: "2144",
    sura: "18",
    VerseIDAr: "4",
    ayatAR: "وَيُنْذِرَ الَّذِينَ قَالُوا اتَّخَذَ اللَّهُ وَلَدًا",
  },
  {
    id: "2145",
    sura: "18",
    VerseIDAr: "5",
    ayatAR:
      "مَا لَهُمْ بِهِ مِنْ عِلْمٍ وَلَا لِآبَائِهِمْ ۚ كَبُرَتْ كَلِمَةً تَخْرُجُ مِنْ أَفْوَاهِهِمْ ۚ إِنْ يَقُولُونَ إِلَّا كَذِبًا",
  },
  {
    id: "2146",
    sura: "18",
    VerseIDAr: "6",
    ayatAR:
      "فَلَعَلَّكَ بَاخِعٌ نَفْسَكَ عَلَىٰ آثَارِهِمْ إِنْ لَمْ يُؤْمِنُوا بِهَٰذَا الْحَدِيثِ أَسَفًا",
  },
  {
    id: "2147",
    sura: "18",
    VerseIDAr: "7",
    ayatAR:
      "إِنَّا جَعَلْنَا مَا عَلَى الْأَرْضِ زِينَةً لَهَا لِنَبْلُوَهُمْ أَيُّهُمْ أَحْسَنُ عَمَلًا",
  },
  {
    id: "2148",
    sura: "18",
    VerseIDAr: "8",
    ayatAR: "وَإِنَّا لَجَاعِلُونَ مَا عَلَيْهَا صَعِيدًا جُرُزًا",
  },
  {
    id: "2149",
    sura: "18",
    VerseIDAr: "9",
    ayatAR:
      "أَمْ حَسِبْتَ أَنَّ أَصْحَابَ الْكَهْفِ وَالرَّقِيمِ كَانُوا مِنْ آيَاتِنَا عَجَبًا",
  },
  {
    id: "2150",
    sura: "18",
    VerseIDAr: "10",
    ayatAR:
      "إِذْ أَوَى الْفِتْيَةُ إِلَى الْكَهْفِ فَقَالُوا رَبَّنَا آتِنَا مِنْ لَدُنْكَ رَحْمَةً وَهَيِّئْ لَنَا مِنْ أَمْرِنَا رَشَدًا",
  },
  {
    id: "2151",
    sura: "18",
    VerseIDAr: "11",
    ayatAR: "فَضَرَبْنَا عَلَىٰ آذَانِهِمْ فِي الْكَهْفِ سِنِينَ عَدَدًا",
  },
  {
    id: "2152",
    sura: "18",
    VerseIDAr: "12",
    ayatAR:
      "ثُمَّ بَعَثْنَاهُمْ لِنَعْلَمَ أَيُّ الْحِزْبَيْنِ أَحْصَىٰ لِمَا لَبِثُوا أَمَدًا",
  },
  {
    id: "2153",
    sura: "18",
    VerseIDAr: "13",
    ayatAR:
      "نَحْنُ نَقُصُّ عَلَيْكَ نَبَأَهُمْ بِالْحَقِّ ۚ إِنَّهُمْ فِتْيَةٌ آمَنُوا بِرَبِّهِمْ وَزِدْنَاهُمْ هُدًى",
  },
  {
    id: "2154",
    sura: "18",
    VerseIDAr: "14",
    ayatAR:
      "وَرَبَطْنَا عَلَىٰ قُلُوبِهِمْ إِذْ قَامُوا فَقَالُوا رَبُّنَا رَبُّ السَّمَاوَاتِ وَالْأَرْضِ لَنْ نَدْعُوَ مِنْ دُونِهِ إِلَٰهًا ۖ لَقَدْ قُلْنَا إِذًا شَطَطًا",
  },
  {
    id: "2155",
    sura: "18",
    VerseIDAr: "15",
    ayatAR:
      "هَٰؤُلَاءِ قَوْمُنَا اتَّخَذُوا مِنْ دُونِهِ آلِهَةً ۖ لَوْلَا يَأْتُونَ عَلَيْهِمْ بِسُلْطَانٍ بَيِّنٍ ۖ فَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا",
  },
  {
    id: "2156",
    sura: "18",
    VerseIDAr: "16",
    ayatAR:
      "وَإِذِ اعْتَزَلْتُمُوهُمْ وَمَا يَعْبُدُونَ إِلَّا اللَّهَ فَأْوُوا إِلَى الْكَهْفِ يَنْشُرْ لَكُمْ رَبُّكُمْ مِنْ رَحْمَتِهِ وَيُهَيِّئْ لَكُمْ مِنْ أَمْرِكُمْ مِرْفَقًا",
  },
  {
    id: "2157",
    sura: "18",
    VerseIDAr: "17",
    ayatAR:
      "وَتَرَى الشَّمْسَ إِذَا طَلَعَتْ تَزَاوَرُ عَنْ كَهْفِهِمْ ذَاتَ الْيَمِينِ وَإِذَا غَرَبَتْ تَقْرِضُهُمْ ذَاتَ الشِّمَالِ وَهُمْ فِي فَجْوَةٍ مِنْهُ ۚ ذَٰلِكَ مِنْ آيَاتِ اللَّهِ ۗ مَنْ يَهْدِ اللَّهُ فَهُوَ الْمُهْتَدِ ۖ وَمَنْ يُضْلِلْ فَلَنْ تَجِدَ لَهُ وَلِيًّا مُرْشِدًا",
  },
  {
    id: "2158",
    sura: "18",
    VerseIDAr: "18",
    ayatAR:
      "وَتَحْسَبُهُمْ أَيْقَاظًا وَهُمْ رُقُودٌ ۚ وَنُقَلِّبُهُمْ ذَاتَ الْيَمِينِ وَذَاتَ الشِّمَالِ ۖ وَكَلْبُهُمْ بَاسِطٌ ذِرَاعَيْهِ بِالْوَصِيدِ ۚ لَوِ اطَّلَعْتَ عَلَيْهِمْ لَوَلَّيْتَ مِنْهُمْ فِرَارًا وَلَمُلِئْتَ مِنْهُمْ رُعْبًا",
  },
  {
    id: "2159",
    sura: "18",
    VerseIDAr: "19",
    ayatAR:
      "وَكَذَٰلِكَ بَعَثْنَاهُمْ لِيَتَسَاءَلُوا بَيْنَهُمْ ۚ قَالَ قَائِلٌ مِنْهُمْ كَمْ لَبِثْتُمْ ۖ قَالُوا لَبِثْنَا يَوْمًا أَوْ بَعْضَ يَوْمٍ ۚ قَالُوا رَبُّكُمْ أَعْلَمُ بِمَا لَبِثْتُمْ فَابْعَثُوا أَحَدَكُمْ بِوَرِقِكُمْ هَٰذِهِ إِلَى الْمَدِينَةِ فَلْيَنْظُرْ أَيُّهَا أَزْكَىٰ طَعَامًا فَلْيَأْتِكُمْ بِرِزْقٍ مِنْهُ وَلْيَتَلَطَّفْ وَلَا يُشْعِرَنَّ بِكُمْ أَحَدًا",
  },
  {
    id: "2160",
    sura: "18",
    VerseIDAr: "20",
    ayatAR:
      "إِنَّهُمْ إِنْ يَظْهَرُوا عَلَيْكُمْ يَرْجُمُوكُمْ أَوْ يُعِيدُوكُمْ فِي مِلَّتِهِمْ وَلَنْ تُفْلِحُوا إِذًا أَبَدًا",
  },
  {
    id: "2161",
    sura: "18",
    VerseIDAr: "21",
    ayatAR:
      "وَكَذَٰلِكَ أَعْثَرْنَا عَلَيْهِمْ لِيَعْلَمُوا أَنَّ وَعْدَ اللَّهِ حَقٌّ وَأَنَّ السَّاعَةَ لَا رَيْبَ فِيهَا إِذْ يَتَنَازَعُونَ بَيْنَهُمْ أَمْرَهُمْ ۖ فَقَالُوا ابْنُوا عَلَيْهِمْ بُنْيَانًا ۖ رَبُّهُمْ أَعْلَمُ بِهِمْ ۚ قَالَ الَّذِينَ غَلَبُوا عَلَىٰ أَمْرِهِمْ لَنَتَّخِذَنَّ عَلَيْهِمْ مَسْجِدًا",
  },
  {
    id: "2162",
    sura: "18",
    VerseIDAr: "22",
    ayatAR:
      "سَيَقُولُونَ ثَلَاثَةٌ رَابِعُهُمْ كَلْبُهُمْ وَيَقُولُونَ خَمْسَةٌ سَادِسُهُمْ كَلْبُهُمْ رَجْمًا بِالْغَيْبِ ۖ وَيَقُولُونَ سَبْعَةٌ وَثَامِنُهُمْ كَلْبُهُمْ ۚ قُلْ رَبِّي أَعْلَمُ بِعِدَّتِهِمْ مَا يَعْلَمُهُمْ إِلَّا قَلِيلٌ ۗ فَلَا تُمَارِ فِيهِمْ إِلَّا مِرَاءً ظَاهِرًا وَلَا تَسْتَفْتِ فِيهِمْ مِنْهُمْ أَحَدًا",
  },
  {
    id: "2163",
    sura: "18",
    VerseIDAr: "23",
    ayatAR: "وَلَا تَقُولَنَّ لِشَيْءٍ إِنِّي فَاعِلٌ ذَٰلِكَ غَدًا",
  },
  {
    id: "2164",
    sura: "18",
    VerseIDAr: "24",
    ayatAR:
      "إِلَّا أَنْ يَشَاءَ اللَّهُ ۚ وَاذْكُرْ رَبَّكَ إِذَا نَسِيتَ وَقُلْ عَسَىٰ أَنْ يَهْدِيَنِ رَبِّي لِأَقْرَبَ مِنْ هَٰذَا رَشَدًا",
  },
  {
    id: "2165",
    sura: "18",
    VerseIDAr: "25",
    ayatAR:
      "وَلَبِثُوا فِي كَهْفِهِمْ ثَلَاثَ مِائَةٍ سِنِينَ وَازْدَادُوا تِسْعًا",
  },
  {
    id: "2166",
    sura: "18",
    VerseIDAr: "26",
    ayatAR:
      "قُلِ اللَّهُ أَعْلَمُ بِمَا لَبِثُوا ۖ لَهُ غَيْبُ السَّمَاوَاتِ وَالْأَرْضِ ۖ أَبْصِرْ بِهِ وَأَسْمِعْ ۚ مَا لَهُمْ مِنْ دُونِهِ مِنْ وَلِيٍّ وَلَا يُشْرِكُ فِي حُكْمِهِ أَحَدًا",
  },
  {
    id: "2167",
    sura: "18",
    VerseIDAr: "27",
    ayatAR:
      "وَاتْلُ مَا أُوحِيَ إِلَيْكَ مِنْ كِتَابِ رَبِّكَ ۖ لَا مُبَدِّلَ لِكَلِمَاتِهِ وَلَنْ تَجِدَ مِنْ دُونِهِ مُلْتَحَدًا",
  },
  {
    id: "2168",
    sura: "18",
    VerseIDAr: "28",
    ayatAR:
      "وَاصْبِرْ نَفْسَكَ مَعَ الَّذِينَ يَدْعُونَ رَبَّهُمْ بِالْغَدَاةِ وَالْعَشِيِّ يُرِيدُونَ وَجْهَهُ ۖ وَلَا تَعْدُ عَيْنَاكَ عَنْهُمْ تُرِيدُ زِينَةَ الْحَيَاةِ الدُّنْيَا ۖ وَلَا تُطِعْ مَنْ أَغْفَلْنَا قَلْبَهُ عَنْ ذِكْرِنَا وَاتَّبَعَ هَوَاهُ وَكَانَ أَمْرُهُ فُرُطًا",
  },
  {
    id: "2169",
    sura: "18",
    VerseIDAr: "29",
    ayatAR:
      "وَقُلِ الْحَقُّ مِنْ رَبِّكُمْ ۖ فَمَنْ شَاءَ فَلْيُؤْمِنْ وَمَنْ شَاءَ فَلْيَكْفُرْ ۚ إِنَّا أَعْتَدْنَا لِلظَّالِمِينَ نَارًا أَحَاطَ بِهِمْ سُرَادِقُهَا ۚ وَإِنْ يَسْتَغِيثُوا يُغَاثُوا بِمَاءٍ كَالْمُهْلِ يَشْوِي الْوُجُوهَ ۚ بِئْسَ الشَّرَابُ وَسَاءَتْ مُرْتَفَقًا",
  },
  {
    id: "2170",
    sura: "18",
    VerseIDAr: "30",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ إِنَّا لَا نُضِيعُ أَجْرَ مَنْ أَحْسَنَ عَمَلًا",
  },
  {
    id: "2171",
    sura: "18",
    VerseIDAr: "31",
    ayatAR:
      "أُولَٰئِكَ لَهُمْ جَنَّاتُ عَدْنٍ تَجْرِي مِنْ تَحْتِهِمُ الْأَنْهَارُ يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِنْ ذَهَبٍ وَيَلْبَسُونَ ثِيَابًا خُضْرًا مِنْ سُنْدُسٍ وَإِسْتَبْرَقٍ مُتَّكِئِينَ فِيهَا عَلَى الْأَرَائِكِ ۚ نِعْمَ الثَّوَابُ وَحَسُنَتْ مُرْتَفَقًا",
  },
  {
    id: "2172",
    sura: "18",
    VerseIDAr: "32",
    ayatAR:
      "وَاضْرِبْ لَهُمْ مَثَلًا رَجُلَيْنِ جَعَلْنَا لِأَحَدِهِمَا جَنَّتَيْنِ مِنْ أَعْنَابٍ وَحَفَفْنَاهُمَا بِنَخْلٍ وَجَعَلْنَا بَيْنَهُمَا زَرْعًا",
  },
  {
    id: "2173",
    sura: "18",
    VerseIDAr: "33",
    ayatAR:
      "كِلْتَا الْجَنَّتَيْنِ آتَتْ أُكُلَهَا وَلَمْ تَظْلِمْ مِنْهُ شَيْئًا ۚ وَفَجَّرْنَا خِلَالَهُمَا نَهَرًا",
  },
  {
    id: "2174",
    sura: "18",
    VerseIDAr: "34",
    ayatAR:
      "وَكَانَ لَهُ ثَمَرٌ فَقَالَ لِصَاحِبِهِ وَهُوَ يُحَاوِرُهُ أَنَا أَكْثَرُ مِنْكَ مَالًا وَأَعَزُّ نَفَرًا",
  },
  {
    id: "2175",
    sura: "18",
    VerseIDAr: "35",
    ayatAR:
      "وَدَخَلَ جَنَّتَهُ وَهُوَ ظَالِمٌ لِنَفْسِهِ قَالَ مَا أَظُنُّ أَنْ تَبِيدَ هَٰذِهِ أَبَدًا",
  },
  {
    id: "2176",
    sura: "18",
    VerseIDAr: "36",
    ayatAR:
      "وَمَا أَظُنُّ السَّاعَةَ قَائِمَةً وَلَئِنْ رُدِدْتُ إِلَىٰ رَبِّي لَأَجِدَنَّ خَيْرًا مِنْهَا مُنْقَلَبًا",
  },
  {
    id: "2177",
    sura: "18",
    VerseIDAr: "37",
    ayatAR:
      "قَالَ لَهُ صَاحِبُهُ وَهُوَ يُحَاوِرُهُ أَكَفَرْتَ بِالَّذِي خَلَقَكَ مِنْ تُرَابٍ ثُمَّ مِنْ نُطْفَةٍ ثُمَّ سَوَّاكَ رَجُلًا",
  },
  {
    id: "2178",
    sura: "18",
    VerseIDAr: "38",
    ayatAR: "لَٰكِنَّا هُوَ اللَّهُ رَبِّي وَلَا أُشْرِكُ بِرَبِّي أَحَدًا",
  },
  {
    id: "2179",
    sura: "18",
    VerseIDAr: "39",
    ayatAR:
      "وَلَوْلَا إِذْ دَخَلْتَ جَنَّتَكَ قُلْتَ مَا شَاءَ اللَّهُ لَا قُوَّةَ إِلَّا بِاللَّهِ ۚ إِنْ تَرَنِ أَنَا أَقَلَّ مِنْكَ مَالًا وَوَلَدًا",
  },
  {
    id: "2180",
    sura: "18",
    VerseIDAr: "40",
    ayatAR:
      "فَعَسَىٰ رَبِّي أَنْ يُؤْتِيَنِ خَيْرًا مِنْ جَنَّتِكَ وَيُرْسِلَ عَلَيْهَا حُسْبَانًا مِنَ السَّمَاءِ فَتُصْبِحَ صَعِيدًا زَلَقًا",
  },
  {
    id: "2181",
    sura: "18",
    VerseIDAr: "41",
    ayatAR: "أَوْ يُصْبِحَ مَاؤُهَا غَوْرًا فَلَنْ تَسْتَطِيعَ لَهُ طَلَبًا",
  },
  {
    id: "2182",
    sura: "18",
    VerseIDAr: "42",
    ayatAR:
      "وَأُحِيطَ بِثَمَرِهِ فَأَصْبَحَ يُقَلِّبُ كَفَّيْهِ عَلَىٰ مَا أَنْفَقَ فِيهَا وَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَيَقُولُ يَا لَيْتَنِي لَمْ أُشْرِكْ بِرَبِّي أَحَدًا",
  },
  {
    id: "2183",
    sura: "18",
    VerseIDAr: "43",
    ayatAR:
      "وَلَمْ تَكُنْ لَهُ فِئَةٌ يَنْصُرُونَهُ مِنْ دُونِ اللَّهِ وَمَا كَانَ مُنْتَصِرًا",
  },
  {
    id: "2184",
    sura: "18",
    VerseIDAr: "44",
    ayatAR:
      "هُنَالِكَ الْوَلَايَةُ لِلَّهِ الْحَقِّ ۚ هُوَ خَيْرٌ ثَوَابًا وَخَيْرٌ عُقْبًا",
  },
  {
    id: "2185",
    sura: "18",
    VerseIDAr: "45",
    ayatAR:
      "وَاضْرِبْ لَهُمْ مَثَلَ الْحَيَاةِ الدُّنْيَا كَمَاءٍ أَنْزَلْنَاهُ مِنَ السَّمَاءِ فَاخْتَلَطَ بِهِ نَبَاتُ الْأَرْضِ فَأَصْبَحَ هَشِيمًا تَذْرُوهُ الرِّيَاحُ ۗ وَكَانَ اللَّهُ عَلَىٰ كُلِّ شَيْءٍ مُقْتَدِرًا",
  },
  {
    id: "2186",
    sura: "18",
    VerseIDAr: "46",
    ayatAR:
      "الْمَالُ وَالْبَنُونَ زِينَةُ الْحَيَاةِ الدُّنْيَا ۖ وَالْبَاقِيَاتُ الصَّالِحَاتُ خَيْرٌ عِنْدَ رَبِّكَ ثَوَابًا وَخَيْرٌ أَمَلًا",
  },
  {
    id: "2187",
    sura: "18",
    VerseIDAr: "47",
    ayatAR:
      "وَيَوْمَ نُسَيِّرُ الْجِبَالَ وَتَرَى الْأَرْضَ بَارِزَةً وَحَشَرْنَاهُمْ فَلَمْ نُغَادِرْ مِنْهُمْ أَحَدًا",
  },
  {
    id: "2188",
    sura: "18",
    VerseIDAr: "48",
    ayatAR:
      "وَعُرِضُوا عَلَىٰ رَبِّكَ صَفًّا لَقَدْ جِئْتُمُونَا كَمَا خَلَقْنَاكُمْ أَوَّلَ مَرَّةٍ ۚ بَلْ زَعَمْتُمْ أَلَّنْ نَجْعَلَ لَكُمْ مَوْعِدًا",
  },
  {
    id: "2189",
    sura: "18",
    VerseIDAr: "49",
    ayatAR:
      "وَوُضِعَ الْكِتَابُ فَتَرَى الْمُجْرِمِينَ مُشْفِقِينَ مِمَّا فِيهِ وَيَقُولُونَ يَا وَيْلَتَنَا مَالِ هَٰذَا الْكِتَابِ لَا يُغَادِرُ صَغِيرَةً وَلَا كَبِيرَةً إِلَّا أَحْصَاهَا ۚ وَوَجَدُوا مَا عَمِلُوا حَاضِرًا ۗ وَلَا يَظْلِمُ رَبُّكَ أَحَدًا",
  },
  {
    id: "2190",
    sura: "18",
    VerseIDAr: "50",
    ayatAR:
      "وَإِذْ قُلْنَا لِلْمَلَائِكَةِ اسْجُدُوا لِآدَمَ فَسَجَدُوا إِلَّا إِبْلِيسَ كَانَ مِنَ الْجِنِّ فَفَسَقَ عَنْ أَمْرِ رَبِّهِ ۗ أَفَتَتَّخِذُونَهُ وَذُرِّيَّتَهُ أَوْلِيَاءَ مِنْ دُونِي وَهُمْ لَكُمْ عَدُوٌّ ۚ بِئْسَ لِلظَّالِمِينَ بَدَلًا",
  },
  {
    id: "2191",
    sura: "18",
    VerseIDAr: "51",
    ayatAR:
      "مَا أَشْهَدْتُهُمْ خَلْقَ السَّمَاوَاتِ وَالْأَرْضِ وَلَا خَلْقَ أَنْفُسِهِمْ وَمَا كُنْتُ مُتَّخِذَ الْمُضِلِّينَ عَضُدًا",
  },
  {
    id: "2192",
    sura: "18",
    VerseIDAr: "52",
    ayatAR:
      "وَيَوْمَ يَقُولُ نَادُوا شُرَكَائِيَ الَّذِينَ زَعَمْتُمْ فَدَعَوْهُمْ فَلَمْ يَسْتَجِيبُوا لَهُمْ وَجَعَلْنَا بَيْنَهُمْ مَوْبِقًا",
  },
  {
    id: "2193",
    sura: "18",
    VerseIDAr: "53",
    ayatAR:
      "وَرَأَى الْمُجْرِمُونَ النَّارَ فَظَنُّوا أَنَّهُمْ مُوَاقِعُوهَا وَلَمْ يَجِدُوا عَنْهَا مَصْرِفًا",
  },
  {
    id: "2194",
    sura: "18",
    VerseIDAr: "54",
    ayatAR:
      "وَلَقَدْ صَرَّفْنَا فِي هَٰذَا الْقُرْآنِ لِلنَّاسِ مِنْ كُلِّ مَثَلٍ ۚ وَكَانَ الْإِنْسَانُ أَكْثَرَ شَيْءٍ جَدَلًا",
  },
  {
    id: "2195",
    sura: "18",
    VerseIDAr: "55",
    ayatAR:
      "وَمَا مَنَعَ النَّاسَ أَنْ يُؤْمِنُوا إِذْ جَاءَهُمُ الْهُدَىٰ وَيَسْتَغْفِرُوا رَبَّهُمْ إِلَّا أَنْ تَأْتِيَهُمْ سُنَّةُ الْأَوَّلِينَ أَوْ يَأْتِيَهُمُ الْعَذَابُ قُبُلًا",
  },
  {
    id: "2196",
    sura: "18",
    VerseIDAr: "56",
    ayatAR:
      "وَمَا نُرْسِلُ الْمُرْسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنْذِرِينَ ۚ وَيُجَادِلُ الَّذِينَ كَفَرُوا بِالْبَاطِلِ لِيُدْحِضُوا بِهِ الْحَقَّ ۖ وَاتَّخَذُوا آيَاتِي وَمَا أُنْذِرُوا هُزُوًا",
  },
  {
    id: "2197",
    sura: "18",
    VerseIDAr: "57",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنْ ذُكِّرَ بِآيَاتِ رَبِّهِ فَأَعْرَضَ عَنْهَا وَنَسِيَ مَا قَدَّمَتْ يَدَاهُ ۚ إِنَّا جَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَنْ يَفْقَهُوهُ وَفِي آذَانِهِمْ وَقْرًا ۖ وَإِنْ تَدْعُهُمْ إِلَى الْهُدَىٰ فَلَنْ يَهْتَدُوا إِذًا أَبَدًا",
  },
  {
    id: "2198",
    sura: "18",
    VerseIDAr: "58",
    ayatAR:
      "وَرَبُّكَ الْغَفُورُ ذُو الرَّحْمَةِ ۖ لَوْ يُؤَاخِذُهُمْ بِمَا كَسَبُوا لَعَجَّلَ لَهُمُ الْعَذَابَ ۚ بَلْ لَهُمْ مَوْعِدٌ لَنْ يَجِدُوا مِنْ دُونِهِ مَوْئِلًا",
  },
  {
    id: "2199",
    sura: "18",
    VerseIDAr: "59",
    ayatAR:
      "وَتِلْكَ الْقُرَىٰ أَهْلَكْنَاهُمْ لَمَّا ظَلَمُوا وَجَعَلْنَا لِمَهْلِكِهِمْ مَوْعِدًا",
  },
  {
    id: "2200",
    sura: "18",
    VerseIDAr: "60",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِفَتَاهُ لَا أَبْرَحُ حَتَّىٰ أَبْلُغَ مَجْمَعَ الْبَحْرَيْنِ أَوْ أَمْضِيَ حُقُبًا",
  },
  {
    id: "2201",
    sura: "18",
    VerseIDAr: "61",
    ayatAR:
      "فَلَمَّا بَلَغَا مَجْمَعَ بَيْنِهِمَا نَسِيَا حُوتَهُمَا فَاتَّخَذَ سَبِيلَهُ فِي الْبَحْرِ سَرَبًا",
  },
  {
    id: "2202",
    sura: "18",
    VerseIDAr: "62",
    ayatAR:
      "فَلَمَّا جَاوَزَا قَالَ لِفَتَاهُ آتِنَا غَدَاءَنَا لَقَدْ لَقِينَا مِنْ سَفَرِنَا هَٰذَا نَصَبًا",
  },
  {
    id: "2203",
    sura: "18",
    VerseIDAr: "63",
    ayatAR:
      "قَالَ أَرَأَيْتَ إِذْ أَوَيْنَا إِلَى الصَّخْرَةِ فَإِنِّي نَسِيتُ الْحُوتَ وَمَا أَنْسَانِيهُ إِلَّا الشَّيْطَانُ أَنْ أَذْكُرَهُ ۚ وَاتَّخَذَ سَبِيلَهُ فِي الْبَحْرِ عَجَبًا",
  },
  {
    id: "2204",
    sura: "18",
    VerseIDAr: "64",
    ayatAR:
      "قَالَ ذَٰلِكَ مَا كُنَّا نَبْغِ ۚ فَارْتَدَّا عَلَىٰ آثَارِهِمَا قَصَصًا",
  },
  {
    id: "2205",
    sura: "18",
    VerseIDAr: "65",
    ayatAR:
      "فَوَجَدَا عَبْدًا مِنْ عِبَادِنَا آتَيْنَاهُ رَحْمَةً مِنْ عِنْدِنَا وَعَلَّمْنَاهُ مِنْ لَدُنَّا عِلْمًا",
  },
  {
    id: "2206",
    sura: "18",
    VerseIDAr: "66",
    ayatAR:
      "قَالَ لَهُ مُوسَىٰ هَلْ أَتَّبِعُكَ عَلَىٰ أَنْ تُعَلِّمَنِ مِمَّا عُلِّمْتَ رُشْدًا",
  },
  {
    id: "2207",
    sura: "18",
    VerseIDAr: "67",
    ayatAR: "قَالَ إِنَّكَ لَنْ تَسْتَطِيعَ مَعِيَ صَبْرًا",
  },
  {
    id: "2208",
    sura: "18",
    VerseIDAr: "68",
    ayatAR: "وَكَيْفَ تَصْبِرُ عَلَىٰ مَا لَمْ تُحِطْ بِهِ خُبْرًا",
  },
  {
    id: "2209",
    sura: "18",
    VerseIDAr: "69",
    ayatAR:
      "قَالَ سَتَجِدُنِي إِنْ شَاءَ اللَّهُ صَابِرًا وَلَا أَعْصِي لَكَ أَمْرًا",
  },
  {
    id: "2210",
    sura: "18",
    VerseIDAr: "70",
    ayatAR:
      "قَالَ فَإِنِ اتَّبَعْتَنِي فَلَا تَسْأَلْنِي عَنْ شَيْءٍ حَتَّىٰ أُحْدِثَ لَكَ مِنْهُ ذِكْرًا",
  },
  {
    id: "2211",
    sura: "18",
    VerseIDAr: "71",
    ayatAR:
      "فَانْطَلَقَا حَتَّىٰ إِذَا رَكِبَا فِي السَّفِينَةِ خَرَقَهَا ۖ قَالَ أَخَرَقْتَهَا لِتُغْرِقَ أَهْلَهَا لَقَدْ جِئْتَ شَيْئًا إِمْرًا",
  },
  {
    id: "2212",
    sura: "18",
    VerseIDAr: "72",
    ayatAR: "قَالَ أَلَمْ أَقُلْ إِنَّكَ لَنْ تَسْتَطِيعَ مَعِيَ صَبْرًا",
  },
  {
    id: "2213",
    sura: "18",
    VerseIDAr: "73",
    ayatAR:
      "قَالَ لَا تُؤَاخِذْنِي بِمَا نَسِيتُ وَلَا تُرْهِقْنِي مِنْ أَمْرِي عُسْرًا",
  },
  {
    id: "2214",
    sura: "18",
    VerseIDAr: "74",
    ayatAR:
      "فَانْطَلَقَا حَتَّىٰ إِذَا لَقِيَا غُلَامًا فَقَتَلَهُ قَالَ أَقَتَلْتَ نَفْسًا زَكِيَّةً بِغَيْرِ نَفْسٍ لَقَدْ جِئْتَ شَيْئًا نُكْرًا",
  },
  {
    id: "2215",
    sura: "18",
    VerseIDAr: "75",
    ayatAR: "قَالَ أَلَمْ أَقُلْ لَكَ إِنَّكَ لَنْ تَسْتَطِيعَ مَعِيَ صَبْرًا",
  },
  {
    id: "2216",
    sura: "18",
    VerseIDAr: "76",
    ayatAR:
      "قَالَ إِنْ سَأَلْتُكَ عَنْ شَيْءٍ بَعْدَهَا فَلَا تُصَاحِبْنِي ۖ قَدْ بَلَغْتَ مِنْ لَدُنِّي عُذْرًا",
  },
  {
    id: "2217",
    sura: "18",
    VerseIDAr: "77",
    ayatAR:
      "فَانْطَلَقَا حَتَّىٰ إِذَا أَتَيَا أَهْلَ قَرْيَةٍ اسْتَطْعَمَا أَهْلَهَا فَأَبَوْا أَنْ يُضَيِّفُوهُمَا فَوَجَدَا فِيهَا جِدَارًا يُرِيدُ أَنْ يَنْقَضَّ فَأَقَامَهُ ۖ قَالَ لَوْ شِئْتَ لَاتَّخَذْتَ عَلَيْهِ أَجْرًا",
  },
  {
    id: "2218",
    sura: "18",
    VerseIDAr: "78",
    ayatAR:
      "قَالَ هَٰذَا فِرَاقُ بَيْنِي وَبَيْنِكَ ۚ سَأُنَبِّئُكَ بِتَأْوِيلِ مَا لَمْ تَسْتَطِعْ عَلَيْهِ صَبْرًا",
  },
  {
    id: "2219",
    sura: "18",
    VerseIDAr: "79",
    ayatAR:
      "أَمَّا السَّفِينَةُ فَكَانَتْ لِمَسَاكِينَ يَعْمَلُونَ فِي الْبَحْرِ فَأَرَدْتُ أَنْ أَعِيبَهَا وَكَانَ وَرَاءَهُمْ مَلِكٌ يَأْخُذُ كُلَّ سَفِينَةٍ غَصْبًا",
  },
  {
    id: "2220",
    sura: "18",
    VerseIDAr: "80",
    ayatAR:
      "وَأَمَّا الْغُلَامُ فَكَانَ أَبَوَاهُ مُؤْمِنَيْنِ فَخَشِينَا أَنْ يُرْهِقَهُمَا طُغْيَانًا وَكُفْرًا",
  },
  {
    id: "2221",
    sura: "18",
    VerseIDAr: "81",
    ayatAR:
      "فَأَرَدْنَا أَنْ يُبْدِلَهُمَا رَبُّهُمَا خَيْرًا مِنْهُ زَكَاةً وَأَقْرَبَ رُحْمًا",
  },
  {
    id: "2222",
    sura: "18",
    VerseIDAr: "82",
    ayatAR:
      "وَأَمَّا الْجِدَارُ فَكَانَ لِغُلَامَيْنِ يَتِيمَيْنِ فِي الْمَدِينَةِ وَكَانَ تَحْتَهُ كَنْزٌ لَهُمَا وَكَانَ أَبُوهُمَا صَالِحًا فَأَرَادَ رَبُّكَ أَنْ يَبْلُغَا أَشُدَّهُمَا وَيَسْتَخْرِجَا كَنْزَهُمَا رَحْمَةً مِنْ رَبِّكَ ۚ وَمَا فَعَلْتُهُ عَنْ أَمْرِي ۚ ذَٰلِكَ تَأْوِيلُ مَا لَمْ تَسْطِعْ عَلَيْهِ صَبْرًا",
  },
  {
    id: "2223",
    sura: "18",
    VerseIDAr: "83",
    ayatAR:
      "وَيَسْأَلُونَكَ عَنْ ذِي الْقَرْنَيْنِ ۖ قُلْ سَأَتْلُو عَلَيْكُمْ مِنْهُ ذِكْرًا",
  },
  {
    id: "2224",
    sura: "18",
    VerseIDAr: "84",
    ayatAR:
      "إِنَّا مَكَّنَّا لَهُ فِي الْأَرْضِ وَآتَيْنَاهُ مِنْ كُلِّ شَيْءٍ سَبَبًا",
  },
  { id: "2225", sura: "18", VerseIDAr: "85", ayatAR: "فَأَتْبَعَ سَبَبًا" },
  {
    id: "2226",
    sura: "18",
    VerseIDAr: "86",
    ayatAR:
      "حَتَّىٰ إِذَا بَلَغَ مَغْرِبَ الشَّمْسِ وَجَدَهَا تَغْرُبُ فِي عَيْنٍ حَمِئَةٍ وَوَجَدَ عِنْدَهَا قَوْمًا ۗ قُلْنَا يَا ذَا الْقَرْنَيْنِ إِمَّا أَنْ تُعَذِّبَ وَإِمَّا أَنْ تَتَّخِذَ فِيهِمْ حُسْنًا",
  },
  {
    id: "2227",
    sura: "18",
    VerseIDAr: "87",
    ayatAR:
      "قَالَ أَمَّا مَنْ ظَلَمَ فَسَوْفَ نُعَذِّبُهُ ثُمَّ يُرَدُّ إِلَىٰ رَبِّهِ فَيُعَذِّبُهُ عَذَابًا نُكْرًا",
  },
  {
    id: "2228",
    sura: "18",
    VerseIDAr: "88",
    ayatAR:
      "وَأَمَّا مَنْ آمَنَ وَعَمِلَ صَالِحًا فَلَهُ جَزَاءً الْحُسْنَىٰ ۖ وَسَنَقُولُ لَهُ مِنْ أَمْرِنَا يُسْرًا",
  },
  { id: "2229", sura: "18", VerseIDAr: "89", ayatAR: "ثُمَّ أَتْبَعَ سَبَبًا" },
  {
    id: "2230",
    sura: "18",
    VerseIDAr: "90",
    ayatAR:
      "حَتَّىٰ إِذَا بَلَغَ مَطْلِعَ الشَّمْسِ وَجَدَهَا تَطْلُعُ عَلَىٰ قَوْمٍ لَمْ نَجْعَلْ لَهُمْ مِنْ دُونِهَا سِتْرًا",
  },
  {
    id: "2231",
    sura: "18",
    VerseIDAr: "91",
    ayatAR: "كَذَٰلِكَ وَقَدْ أَحَطْنَا بِمَا لَدَيْهِ خُبْرًا",
  },
  { id: "2232", sura: "18", VerseIDAr: "92", ayatAR: "ثُمَّ أَتْبَعَ سَبَبًا" },
  {
    id: "2233",
    sura: "18",
    VerseIDAr: "93",
    ayatAR:
      "حَتَّىٰ إِذَا بَلَغَ بَيْنَ السَّدَّيْنِ وَجَدَ مِنْ دُونِهِمَا قَوْمًا لَا يَكَادُونَ يَفْقَهُونَ قَوْلًا",
  },
  {
    id: "2234",
    sura: "18",
    VerseIDAr: "94",
    ayatAR:
      "قَالُوا يَا ذَا الْقَرْنَيْنِ إِنَّ يَأْجُوجَ وَمَأْجُوجَ مُفْسِدُونَ فِي الْأَرْضِ فَهَلْ نَجْعَلُ لَكَ خَرْجًا عَلَىٰ أَنْ تَجْعَلَ بَيْنَنَا وَبَيْنَهُمْ سَدًّا",
  },
  {
    id: "2235",
    sura: "18",
    VerseIDAr: "95",
    ayatAR:
      "قَالَ مَا مَكَّنِّي فِيهِ رَبِّي خَيْرٌ فَأَعِينُونِي بِقُوَّةٍ أَجْعَلْ بَيْنَكُمْ وَبَيْنَهُمْ رَدْمًا",
  },
  {
    id: "2236",
    sura: "18",
    VerseIDAr: "96",
    ayatAR:
      "آتُونِي زُبَرَ الْحَدِيدِ ۖ حَتَّىٰ إِذَا سَاوَىٰ بَيْنَ الصَّدَفَيْنِ قَالَ انْفُخُوا ۖ حَتَّىٰ إِذَا جَعَلَهُ نَارًا قَالَ آتُونِي أُفْرِغْ عَلَيْهِ قِطْرًا",
  },
  {
    id: "2237",
    sura: "18",
    VerseIDAr: "97",
    ayatAR: "فَمَا اسْطَاعُوا أَنْ يَظْهَرُوهُ وَمَا اسْتَطَاعُوا لَهُ نَقْبًا",
  },
  {
    id: "2238",
    sura: "18",
    VerseIDAr: "98",
    ayatAR:
      "قَالَ هَٰذَا رَحْمَةٌ مِنْ رَبِّي ۖ فَإِذَا جَاءَ وَعْدُ رَبِّي جَعَلَهُ دَكَّاءَ ۖ وَكَانَ وَعْدُ رَبِّي حَقًّا",
  },
  {
    id: "2239",
    sura: "18",
    VerseIDAr: "99",
    ayatAR:
      "وَتَرَكْنَا بَعْضَهُمْ يَوْمَئِذٍ يَمُوجُ فِي بَعْضٍ ۖ وَنُفِخَ فِي الصُّورِ فَجَمَعْنَاهُمْ جَمْعًا",
  },
  {
    id: "2240",
    sura: "18",
    VerseIDAr: "100",
    ayatAR: "وَعَرَضْنَا جَهَنَّمَ يَوْمَئِذٍ لِلْكَافِرِينَ عَرْضًا",
  },
  {
    id: "2241",
    sura: "18",
    VerseIDAr: "101",
    ayatAR:
      "الَّذِينَ كَانَتْ أَعْيُنُهُمْ فِي غِطَاءٍ عَنْ ذِكْرِي وَكَانُوا لَا يَسْتَطِيعُونَ سَمْعًا",
  },
  {
    id: "2242",
    sura: "18",
    VerseIDAr: "102",
    ayatAR:
      "أَفَحَسِبَ الَّذِينَ كَفَرُوا أَنْ يَتَّخِذُوا عِبَادِي مِنْ دُونِي أَوْلِيَاءَ ۚ إِنَّا أَعْتَدْنَا جَهَنَّمَ لِلْكَافِرِينَ نُزُلًا",
  },
  {
    id: "2243",
    sura: "18",
    VerseIDAr: "103",
    ayatAR: "قُلْ هَلْ نُنَبِّئُكُمْ بِالْأَخْسَرِينَ أَعْمَالًا",
  },
  {
    id: "2244",
    sura: "18",
    VerseIDAr: "104",
    ayatAR:
      "الَّذِينَ ضَلَّ سَعْيُهُمْ فِي الْحَيَاةِ الدُّنْيَا وَهُمْ يَحْسَبُونَ أَنَّهُمْ يُحْسِنُونَ صُنْعًا",
  },
  {
    id: "2245",
    sura: "18",
    VerseIDAr: "105",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ كَفَرُوا بِآيَاتِ رَبِّهِمْ وَلِقَائِهِ فَحَبِطَتْ أَعْمَالُهُمْ فَلَا نُقِيمُ لَهُمْ يَوْمَ الْقِيَامَةِ وَزْنًا",
  },
  {
    id: "2246",
    sura: "18",
    VerseIDAr: "106",
    ayatAR:
      "ذَٰلِكَ جَزَاؤُهُمْ جَهَنَّمُ بِمَا كَفَرُوا وَاتَّخَذُوا آيَاتِي وَرُسُلِي هُزُوًا",
  },
  {
    id: "2247",
    sura: "18",
    VerseIDAr: "107",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ كَانَتْ لَهُمْ جَنَّاتُ الْفِرْدَوْسِ نُزُلًا",
  },
  {
    id: "2248",
    sura: "18",
    VerseIDAr: "108",
    ayatAR: "خَالِدِينَ فِيهَا لَا يَبْغُونَ عَنْهَا حِوَلًا",
  },
  {
    id: "2249",
    sura: "18",
    VerseIDAr: "109",
    ayatAR:
      "قُلْ لَوْ كَانَ الْبَحْرُ مِدَادًا لِكَلِمَاتِ رَبِّي لَنَفِدَ الْبَحْرُ قَبْلَ أَنْ تَنْفَدَ كَلِمَاتُ رَبِّي وَلَوْ جِئْنَا بِمِثْلِهِ مَدَدًا",
  },
  {
    id: "2250",
    sura: "18",
    VerseIDAr: "110",
    ayatAR:
      "قُلْ إِنَّمَا أَنَا بَشَرٌ مِثْلُكُمْ يُوحَىٰ إِلَيَّ أَنَّمَا إِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ ۖ فَمَنْ كَانَ يَرْجُو لِقَاءَ رَبِّهِ فَلْيَعْمَلْ عَمَلًا صَالِحًا وَلَا يُشْرِكْ بِعِبَادَةِ رَبِّهِ أَحَدًا",
  },
  {
    id: "2251",
    sura: "19",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ كهيعص",
  },
  {
    id: "2252",
    sura: "19",
    VerseIDAr: "2",
    ayatAR: "ذِكْرُ رَحْمَتِ رَبِّكَ عَبْدَهُ زَكَرِيَّا",
  },
  {
    id: "2253",
    sura: "19",
    VerseIDAr: "3",
    ayatAR: "إِذْ نَادَىٰ رَبَّهُ نِدَاءً خَفِيًّا",
  },
  {
    id: "2254",
    sura: "19",
    VerseIDAr: "4",
    ayatAR:
      "قَالَ رَبِّ إِنِّي وَهَنَ الْعَظْمُ مِنِّي وَاشْتَعَلَ الرَّأْسُ شَيْبًا وَلَمْ أَكُنْ بِدُعَائِكَ رَبِّ شَقِيًّا",
  },
  {
    id: "2255",
    sura: "19",
    VerseIDAr: "5",
    ayatAR:
      "وَإِنِّي خِفْتُ الْمَوَالِيَ مِنْ وَرَائِي وَكَانَتِ امْرَأَتِي عَاقِرًا فَهَبْ لِي مِنْ لَدُنْكَ وَلِيًّا",
  },
  {
    id: "2256",
    sura: "19",
    VerseIDAr: "6",
    ayatAR:
      "يَرِثُنِي وَيَرِثُ مِنْ آلِ يَعْقُوبَ ۖ وَاجْعَلْهُ رَبِّ رَضِيًّا",
  },
  {
    id: "2257",
    sura: "19",
    VerseIDAr: "7",
    ayatAR:
      "يَا زَكَرِيَّا إِنَّا نُبَشِّرُكَ بِغُلَامٍ اسْمُهُ يَحْيَىٰ لَمْ نَجْعَلْ لَهُ مِنْ قَبْلُ سَمِيًّا",
  },
  {
    id: "2258",
    sura: "19",
    VerseIDAr: "8",
    ayatAR:
      "قَالَ رَبِّ أَنَّىٰ يَكُونُ لِي غُلَامٌ وَكَانَتِ امْرَأَتِي عَاقِرًا وَقَدْ بَلَغْتُ مِنَ الْكِبَرِ عِتِيًّا",
  },
  {
    id: "2259",
    sura: "19",
    VerseIDAr: "9",
    ayatAR:
      "قَالَ كَذَٰلِكَ قَالَ رَبُّكَ هُوَ عَلَيَّ هَيِّنٌ وَقَدْ خَلَقْتُكَ مِنْ قَبْلُ وَلَمْ تَكُ شَيْئًا",
  },
  {
    id: "2260",
    sura: "19",
    VerseIDAr: "10",
    ayatAR:
      "قَالَ رَبِّ اجْعَلْ لِي آيَةً ۚ قَالَ آيَتُكَ أَلَّا تُكَلِّمَ النَّاسَ ثَلَاثَ لَيَالٍ سَوِيًّا",
  },
  {
    id: "2261",
    sura: "19",
    VerseIDAr: "11",
    ayatAR:
      "فَخَرَجَ عَلَىٰ قَوْمِهِ مِنَ الْمِحْرَابِ فَأَوْحَىٰ إِلَيْهِمْ أَنْ سَبِّحُوا بُكْرَةً وَعَشِيًّا",
  },
  {
    id: "2262",
    sura: "19",
    VerseIDAr: "12",
    ayatAR:
      "يَا يَحْيَىٰ خُذِ الْكِتَابَ بِقُوَّةٍ ۖ وَآتَيْنَاهُ الْحُكْمَ صَبِيًّا",
  },
  {
    id: "2263",
    sura: "19",
    VerseIDAr: "13",
    ayatAR: "وَحَنَانًا مِنْ لَدُنَّا وَزَكَاةً ۖ وَكَانَ تَقِيًّا",
  },
  {
    id: "2264",
    sura: "19",
    VerseIDAr: "14",
    ayatAR: "وَبَرًّا بِوَالِدَيْهِ وَلَمْ يَكُنْ جَبَّارًا عَصِيًّا",
  },
  {
    id: "2265",
    sura: "19",
    VerseIDAr: "15",
    ayatAR:
      "وَسَلَامٌ عَلَيْهِ يَوْمَ وُلِدَ وَيَوْمَ يَمُوتُ وَيَوْمَ يُبْعَثُ حَيًّا",
  },
  {
    id: "2266",
    sura: "19",
    VerseIDAr: "16",
    ayatAR:
      "وَاذْكُرْ فِي الْكِتَابِ مَرْيَمَ إِذِ انْتَبَذَتْ مِنْ أَهْلِهَا مَكَانًا شَرْقِيًّا",
  },
  {
    id: "2267",
    sura: "19",
    VerseIDAr: "17",
    ayatAR:
      "فَاتَّخَذَتْ مِنْ دُونِهِمْ حِجَابًا فَأَرْسَلْنَا إِلَيْهَا رُوحَنَا فَتَمَثَّلَ لَهَا بَشَرًا سَوِيًّا",
  },
  {
    id: "2268",
    sura: "19",
    VerseIDAr: "18",
    ayatAR: "قَالَتْ إِنِّي أَعُوذُ بِالرَّحْمَٰنِ مِنْكَ إِنْ كُنْتَ تَقِيًّا",
  },
  {
    id: "2269",
    sura: "19",
    VerseIDAr: "19",
    ayatAR:
      "قَالَ إِنَّمَا أَنَا رَسُولُ رَبِّكِ لِأَهَبَ لَكِ غُلَامًا زَكِيًّا",
  },
  {
    id: "2270",
    sura: "19",
    VerseIDAr: "20",
    ayatAR:
      "قَالَتْ أَنَّىٰ يَكُونُ لِي غُلَامٌ وَلَمْ يَمْسَسْنِي بَشَرٌ وَلَمْ أَكُ بَغِيًّا",
  },
  {
    id: "2271",
    sura: "19",
    VerseIDAr: "21",
    ayatAR:
      "قَالَ كَذَٰلِكِ قَالَ رَبُّكِ هُوَ عَلَيَّ هَيِّنٌ ۖ وَلِنَجْعَلَهُ آيَةً لِلنَّاسِ وَرَحْمَةً مِنَّا ۚ وَكَانَ أَمْرًا مَقْضِيًّا",
  },
  {
    id: "2272",
    sura: "19",
    VerseIDAr: "22",
    ayatAR: "فَحَمَلَتْهُ فَانْتَبَذَتْ بِهِ مَكَانًا قَصِيًّا",
  },
  {
    id: "2273",
    sura: "19",
    VerseIDAr: "23",
    ayatAR:
      "فَأَجَاءَهَا الْمَخَاضُ إِلَىٰ جِذْعِ النَّخْلَةِ قَالَتْ يَا لَيْتَنِي مِتُّ قَبْلَ هَٰذَا وَكُنْتُ نَسْيًا مَنْسِيًّا",
  },
  {
    id: "2274",
    sura: "19",
    VerseIDAr: "24",
    ayatAR:
      "فَنَادَاهَا مِنْ تَحْتِهَا أَلَّا تَحْزَنِي قَدْ جَعَلَ رَبُّكِ تَحْتَكِ سَرِيًّا",
  },
  {
    id: "2275",
    sura: "19",
    VerseIDAr: "25",
    ayatAR:
      "وَهُزِّي إِلَيْكِ بِجِذْعِ النَّخْلَةِ تُسَاقِطْ عَلَيْكِ رُطَبًا جَنِيًّا",
  },
  {
    id: "2276",
    sura: "19",
    VerseIDAr: "26",
    ayatAR:
      "فَكُلِي وَاشْرَبِي وَقَرِّي عَيْنًا ۖ فَإِمَّا تَرَيِنَّ مِنَ الْبَشَرِ أَحَدًا فَقُولِي إِنِّي نَذَرْتُ لِلرَّحْمَٰنِ صَوْمًا فَلَنْ أُكَلِّمَ الْيَوْمَ إِنْسِيًّا",
  },
  {
    id: "2277",
    sura: "19",
    VerseIDAr: "27",
    ayatAR:
      "فَأَتَتْ بِهِ قَوْمَهَا تَحْمِلُهُ ۖ قَالُوا يَا مَرْيَمُ لَقَدْ جِئْتِ شَيْئًا فَرِيًّا",
  },
  {
    id: "2278",
    sura: "19",
    VerseIDAr: "28",
    ayatAR:
      "يَا أُخْتَ هَارُونَ مَا كَانَ أَبُوكِ امْرَأَ سَوْءٍ وَمَا كَانَتْ أُمُّكِ بَغِيًّا",
  },
  {
    id: "2279",
    sura: "19",
    VerseIDAr: "29",
    ayatAR:
      "فَأَشَارَتْ إِلَيْهِ ۖ قَالُوا كَيْفَ نُكَلِّمُ مَنْ كَانَ فِي الْمَهْدِ صَبِيًّا",
  },
  {
    id: "2280",
    sura: "19",
    VerseIDAr: "30",
    ayatAR:
      "قَالَ إِنِّي عَبْدُ اللَّهِ آتَانِيَ الْكِتَابَ وَجَعَلَنِي نَبِيًّا",
  },
  {
    id: "2281",
    sura: "19",
    VerseIDAr: "31",
    ayatAR:
      "وَجَعَلَنِي مُبَارَكًا أَيْنَ مَا كُنْتُ وَأَوْصَانِي بِالصَّلَاةِ وَالزَّكَاةِ مَا دُمْتُ حَيًّا",
  },
  {
    id: "2282",
    sura: "19",
    VerseIDAr: "32",
    ayatAR: "وَبَرًّا بِوَالِدَتِي وَلَمْ يَجْعَلْنِي جَبَّارًا شَقِيًّا",
  },
  {
    id: "2283",
    sura: "19",
    VerseIDAr: "33",
    ayatAR:
      "وَالسَّلَامُ عَلَيَّ يَوْمَ وُلِدْتُ وَيَوْمَ أَمُوتُ وَيَوْمَ أُبْعَثُ حَيًّا",
  },
  {
    id: "2284",
    sura: "19",
    VerseIDAr: "34",
    ayatAR:
      "ذَٰلِكَ عِيسَى ابْنُ مَرْيَمَ ۚ قَوْلَ الْحَقِّ الَّذِي فِيهِ يَمْتَرُونَ",
  },
  {
    id: "2285",
    sura: "19",
    VerseIDAr: "35",
    ayatAR:
      "مَا كَانَ لِلَّهِ أَنْ يَتَّخِذَ مِنْ وَلَدٍ ۖ سُبْحَانَهُ ۚ إِذَا قَضَىٰ أَمْرًا فَإِنَّمَا يَقُولُ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "2286",
    sura: "19",
    VerseIDAr: "36",
    ayatAR:
      "وَإِنَّ اللَّهَ رَبِّي وَرَبُّكُمْ فَاعْبُدُوهُ ۚ هَٰذَا صِرَاطٌ مُسْتَقِيمٌ",
  },
  {
    id: "2287",
    sura: "19",
    VerseIDAr: "37",
    ayatAR:
      "فَاخْتَلَفَ الْأَحْزَابُ مِنْ بَيْنِهِمْ ۖ فَوَيْلٌ لِلَّذِينَ كَفَرُوا مِنْ مَشْهَدِ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "2288",
    sura: "19",
    VerseIDAr: "38",
    ayatAR:
      "أَسْمِعْ بِهِمْ وَأَبْصِرْ يَوْمَ يَأْتُونَنَا ۖ لَٰكِنِ الظَّالِمُونَ الْيَوْمَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "2289",
    sura: "19",
    VerseIDAr: "39",
    ayatAR:
      "وَأَنْذِرْهُمْ يَوْمَ الْحَسْرَةِ إِذْ قُضِيَ الْأَمْرُ وَهُمْ فِي غَفْلَةٍ وَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "2290",
    sura: "19",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّا نَحْنُ نَرِثُ الْأَرْضَ وَمَنْ عَلَيْهَا وَإِلَيْنَا يُرْجَعُونَ",
  },
  {
    id: "2291",
    sura: "19",
    VerseIDAr: "41",
    ayatAR:
      "وَاذْكُرْ فِي الْكِتَابِ إِبْرَاهِيمَ ۚ إِنَّهُ كَانَ صِدِّيقًا نَبِيًّا",
  },
  {
    id: "2292",
    sura: "19",
    VerseIDAr: "42",
    ayatAR:
      "إِذْ قَالَ لِأَبِيهِ يَا أَبَتِ لِمَ تَعْبُدُ مَا لَا يَسْمَعُ وَلَا يُبْصِرُ وَلَا يُغْنِي عَنْكَ شَيْئًا",
  },
  {
    id: "2293",
    sura: "19",
    VerseIDAr: "43",
    ayatAR:
      "يَا أَبَتِ إِنِّي قَدْ جَاءَنِي مِنَ الْعِلْمِ مَا لَمْ يَأْتِكَ فَاتَّبِعْنِي أَهْدِكَ صِرَاطًا سَوِيًّا",
  },
  {
    id: "2294",
    sura: "19",
    VerseIDAr: "44",
    ayatAR:
      "يَا أَبَتِ لَا تَعْبُدِ الشَّيْطَانَ ۖ إِنَّ الشَّيْطَانَ كَانَ لِلرَّحْمَٰنِ عَصِيًّا",
  },
  {
    id: "2295",
    sura: "19",
    VerseIDAr: "45",
    ayatAR:
      "يَا أَبَتِ إِنِّي أَخَافُ أَنْ يَمَسَّكَ عَذَابٌ مِنَ الرَّحْمَٰنِ فَتَكُونَ لِلشَّيْطَانِ وَلِيًّا",
  },
  {
    id: "2296",
    sura: "19",
    VerseIDAr: "46",
    ayatAR:
      "قَالَ أَرَاغِبٌ أَنْتَ عَنْ آلِهَتِي يَا إِبْرَاهِيمُ ۖ لَئِنْ لَمْ تَنْتَهِ لَأَرْجُمَنَّكَ ۖ وَاهْجُرْنِي مَلِيًّا",
  },
  {
    id: "2297",
    sura: "19",
    VerseIDAr: "47",
    ayatAR:
      "قَالَ سَلَامٌ عَلَيْكَ ۖ سَأَسْتَغْفِرُ لَكَ رَبِّي ۖ إِنَّهُ كَانَ بِي حَفِيًّا",
  },
  {
    id: "2298",
    sura: "19",
    VerseIDAr: "48",
    ayatAR:
      "وَأَعْتَزِلُكُمْ وَمَا تَدْعُونَ مِنْ دُونِ اللَّهِ وَأَدْعُو رَبِّي عَسَىٰ أَلَّا أَكُونَ بِدُعَاءِ رَبِّي شَقِيًّا",
  },
  {
    id: "2299",
    sura: "19",
    VerseIDAr: "49",
    ayatAR:
      "فَلَمَّا اعْتَزَلَهُمْ وَمَا يَعْبُدُونَ مِنْ دُونِ اللَّهِ وَهَبْنَا لَهُ إِسْحَاقَ وَيَعْقُوبَ ۖ وَكُلًّا جَعَلْنَا نَبِيًّا",
  },
  {
    id: "2300",
    sura: "19",
    VerseIDAr: "50",
    ayatAR:
      "وَوَهَبْنَا لَهُمْ مِنْ رَحْمَتِنَا وَجَعَلْنَا لَهُمْ لِسَانَ صِدْقٍ عَلِيًّا",
  },
  {
    id: "2301",
    sura: "19",
    VerseIDAr: "51",
    ayatAR:
      "وَاذْكُرْ فِي الْكِتَابِ مُوسَىٰ ۚ إِنَّهُ كَانَ مُخْلَصًا وَكَانَ رَسُولًا نَبِيًّا",
  },
  {
    id: "2302",
    sura: "19",
    VerseIDAr: "52",
    ayatAR:
      "وَنَادَيْنَاهُ مِنْ جَانِبِ الطُّورِ الْأَيْمَنِ وَقَرَّبْنَاهُ نَجِيًّا",
  },
  {
    id: "2303",
    sura: "19",
    VerseIDAr: "53",
    ayatAR: "وَوَهَبْنَا لَهُ مِنْ رَحْمَتِنَا أَخَاهُ هَارُونَ نَبِيًّا",
  },
  {
    id: "2304",
    sura: "19",
    VerseIDAr: "54",
    ayatAR:
      "وَاذْكُرْ فِي الْكِتَابِ إِسْمَاعِيلَ ۚ إِنَّهُ كَانَ صَادِقَ الْوَعْدِ وَكَانَ رَسُولًا نَبِيًّا",
  },
  {
    id: "2305",
    sura: "19",
    VerseIDAr: "55",
    ayatAR:
      "وَكَانَ يَأْمُرُ أَهْلَهُ بِالصَّلَاةِ وَالزَّكَاةِ وَكَانَ عِنْدَ رَبِّهِ مَرْضِيًّا",
  },
  {
    id: "2306",
    sura: "19",
    VerseIDAr: "56",
    ayatAR:
      "وَاذْكُرْ فِي الْكِتَابِ إِدْرِيسَ ۚ إِنَّهُ كَانَ صِدِّيقًا نَبِيًّا",
  },
  {
    id: "2307",
    sura: "19",
    VerseIDAr: "57",
    ayatAR: "وَرَفَعْنَاهُ مَكَانًا عَلِيًّا",
  },
  {
    id: "2308",
    sura: "19",
    VerseIDAr: "58",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ أَنْعَمَ اللَّهُ عَلَيْهِمْ مِنَ النَّبِيِّينَ مِنْ ذُرِّيَّةِ آدَمَ وَمِمَّنْ حَمَلْنَا مَعَ نُوحٍ وَمِنْ ذُرِّيَّةِ إِبْرَاهِيمَ وَإِسْرَائِيلَ وَمِمَّنْ هَدَيْنَا وَاجْتَبَيْنَا ۚ إِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُ الرَّحْمَٰنِ خَرُّوا سُجَّدًا وَبُكِيًّا ۩",
  },
  {
    id: "2309",
    sura: "19",
    VerseIDAr: "59",
    ayatAR:
      "فَخَلَفَ مِنْ بَعْدِهِمْ خَلْفٌ أَضَاعُوا الصَّلَاةَ وَاتَّبَعُوا الشَّهَوَاتِ ۖ فَسَوْفَ يَلْقَوْنَ غَيًّا",
  },
  {
    id: "2310",
    sura: "19",
    VerseIDAr: "60",
    ayatAR:
      "إِلَّا مَنْ تَابَ وَآمَنَ وَعَمِلَ صَالِحًا فَأُولَٰئِكَ يَدْخُلُونَ الْجَنَّةَ وَلَا يُظْلَمُونَ شَيْئًا",
  },
  {
    id: "2311",
    sura: "19",
    VerseIDAr: "61",
    ayatAR:
      "جَنَّاتِ عَدْنٍ الَّتِي وَعَدَ الرَّحْمَٰنُ عِبَادَهُ بِالْغَيْبِ ۚ إِنَّهُ كَانَ وَعْدُهُ مَأْتِيًّا",
  },
  {
    id: "2312",
    sura: "19",
    VerseIDAr: "62",
    ayatAR:
      "لَا يَسْمَعُونَ فِيهَا لَغْوًا إِلَّا سَلَامًا ۖ وَلَهُمْ رِزْقُهُمْ فِيهَا بُكْرَةً وَعَشِيًّا",
  },
  {
    id: "2313",
    sura: "19",
    VerseIDAr: "63",
    ayatAR:
      "تِلْكَ الْجَنَّةُ الَّتِي نُورِثُ مِنْ عِبَادِنَا مَنْ كَانَ تَقِيًّا",
  },
  {
    id: "2314",
    sura: "19",
    VerseIDAr: "64",
    ayatAR:
      "وَمَا نَتَنَزَّلُ إِلَّا بِأَمْرِ رَبِّكَ ۖ لَهُ مَا بَيْنَ أَيْدِينَا وَمَا خَلْفَنَا وَمَا بَيْنَ ذَٰلِكَ ۚ وَمَا كَانَ رَبُّكَ نَسِيًّا",
  },
  {
    id: "2315",
    sura: "19",
    VerseIDAr: "65",
    ayatAR:
      "رَبُّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا فَاعْبُدْهُ وَاصْطَبِرْ لِعِبَادَتِهِ ۚ هَلْ تَعْلَمُ لَهُ سَمِيًّا",
  },
  {
    id: "2316",
    sura: "19",
    VerseIDAr: "66",
    ayatAR: "وَيَقُولُ الْإِنْسَانُ أَإِذَا مَا مِتُّ لَسَوْفَ أُخْرَجُ حَيًّا",
  },
  {
    id: "2317",
    sura: "19",
    VerseIDAr: "67",
    ayatAR:
      "أَوَلَا يَذْكُرُ الْإِنْسَانُ أَنَّا خَلَقْنَاهُ مِنْ قَبْلُ وَلَمْ يَكُ شَيْئًا",
  },
  {
    id: "2318",
    sura: "19",
    VerseIDAr: "68",
    ayatAR:
      "فَوَرَبِّكَ لَنَحْشُرَنَّهُمْ وَالشَّيَاطِينَ ثُمَّ لَنُحْضِرَنَّهُمْ حَوْلَ جَهَنَّمَ جِثِيًّا",
  },
  {
    id: "2319",
    sura: "19",
    VerseIDAr: "69",
    ayatAR:
      "ثُمَّ لَنَنْزِعَنَّ مِنْ كُلِّ شِيعَةٍ أَيُّهُمْ أَشَدُّ عَلَى الرَّحْمَٰنِ عِتِيًّا",
  },
  {
    id: "2320",
    sura: "19",
    VerseIDAr: "70",
    ayatAR: "ثُمَّ لَنَحْنُ أَعْلَمُ بِالَّذِينَ هُمْ أَوْلَىٰ بِهَا صِلِيًّا",
  },
  {
    id: "2321",
    sura: "19",
    VerseIDAr: "71",
    ayatAR:
      "وَإِنْ مِنْكُمْ إِلَّا وَارِدُهَا ۚ كَانَ عَلَىٰ رَبِّكَ حَتْمًا مَقْضِيًّا",
  },
  {
    id: "2322",
    sura: "19",
    VerseIDAr: "72",
    ayatAR:
      "ثُمَّ نُنَجِّي الَّذِينَ اتَّقَوْا وَنَذَرُ الظَّالِمِينَ فِيهَا جِثِيًّا",
  },
  {
    id: "2323",
    sura: "19",
    VerseIDAr: "73",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ قَالَ الَّذِينَ كَفَرُوا لِلَّذِينَ آمَنُوا أَيُّ الْفَرِيقَيْنِ خَيْرٌ مَقَامًا وَأَحْسَنُ نَدِيًّا",
  },
  {
    id: "2324",
    sura: "19",
    VerseIDAr: "74",
    ayatAR:
      "وَكَمْ أَهْلَكْنَا قَبْلَهُمْ مِنْ قَرْنٍ هُمْ أَحْسَنُ أَثَاثًا وَرِئْيًا",
  },
  {
    id: "2325",
    sura: "19",
    VerseIDAr: "75",
    ayatAR:
      "قُلْ مَنْ كَانَ فِي الضَّلَالَةِ فَلْيَمْدُدْ لَهُ الرَّحْمَٰنُ مَدًّا ۚ حَتَّىٰ إِذَا رَأَوْا مَا يُوعَدُونَ إِمَّا الْعَذَابَ وَإِمَّا السَّاعَةَ فَسَيَعْلَمُونَ مَنْ هُوَ شَرٌّ مَكَانًا وَأَضْعَفُ جُنْدًا",
  },
  {
    id: "2326",
    sura: "19",
    VerseIDAr: "76",
    ayatAR:
      "وَيَزِيدُ اللَّهُ الَّذِينَ اهْتَدَوْا هُدًى ۗ وَالْبَاقِيَاتُ الصَّالِحَاتُ خَيْرٌ عِنْدَ رَبِّكَ ثَوَابًا وَخَيْرٌ مَرَدًّا",
  },
  {
    id: "2327",
    sura: "19",
    VerseIDAr: "77",
    ayatAR:
      "أَفَرَأَيْتَ الَّذِي كَفَرَ بِآيَاتِنَا وَقَالَ لَأُوتَيَنَّ مَالًا وَوَلَدًا",
  },
  {
    id: "2328",
    sura: "19",
    VerseIDAr: "78",
    ayatAR: "أَطَّلَعَ الْغَيْبَ أَمِ اتَّخَذَ عِنْدَ الرَّحْمَٰنِ عَهْدًا",
  },
  {
    id: "2329",
    sura: "19",
    VerseIDAr: "79",
    ayatAR:
      "كَلَّا ۚ سَنَكْتُبُ مَا يَقُولُ وَنَمُدُّ لَهُ مِنَ الْعَذَابِ مَدًّا",
  },
  {
    id: "2330",
    sura: "19",
    VerseIDAr: "80",
    ayatAR: "وَنَرِثُهُ مَا يَقُولُ وَيَأْتِينَا فَرْدًا",
  },
  {
    id: "2331",
    sura: "19",
    VerseIDAr: "81",
    ayatAR: "وَاتَّخَذُوا مِنْ دُونِ اللَّهِ آلِهَةً لِيَكُونُوا لَهُمْ عِزًّا",
  },
  {
    id: "2332",
    sura: "19",
    VerseIDAr: "82",
    ayatAR:
      "كَلَّا ۚ سَيَكْفُرُونَ بِعِبَادَتِهِمْ وَيَكُونُونَ عَلَيْهِمْ ضِدًّا",
  },
  {
    id: "2333",
    sura: "19",
    VerseIDAr: "83",
    ayatAR:
      "أَلَمْ تَرَ أَنَّا أَرْسَلْنَا الشَّيَاطِينَ عَلَى الْكَافِرِينَ تَؤُزُّهُمْ أَزًّا",
  },
  {
    id: "2334",
    sura: "19",
    VerseIDAr: "84",
    ayatAR: "فَلَا تَعْجَلْ عَلَيْهِمْ ۖ إِنَّمَا نَعُدُّ لَهُمْ عَدًّا",
  },
  {
    id: "2335",
    sura: "19",
    VerseIDAr: "85",
    ayatAR: "يَوْمَ نَحْشُرُ الْمُتَّقِينَ إِلَى الرَّحْمَٰنِ وَفْدًا",
  },
  {
    id: "2336",
    sura: "19",
    VerseIDAr: "86",
    ayatAR: "وَنَسُوقُ الْمُجْرِمِينَ إِلَىٰ جَهَنَّمَ وِرْدًا",
  },
  {
    id: "2337",
    sura: "19",
    VerseIDAr: "87",
    ayatAR:
      "لَا يَمْلِكُونَ الشَّفَاعَةَ إِلَّا مَنِ اتَّخَذَ عِنْدَ الرَّحْمَٰنِ عَهْدًا",
  },
  {
    id: "2338",
    sura: "19",
    VerseIDAr: "88",
    ayatAR: "وَقَالُوا اتَّخَذَ الرَّحْمَٰنُ وَلَدًا",
  },
  {
    id: "2339",
    sura: "19",
    VerseIDAr: "89",
    ayatAR: "لَقَدْ جِئْتُمْ شَيْئًا إِدًّا",
  },
  {
    id: "2340",
    sura: "19",
    VerseIDAr: "90",
    ayatAR:
      "تَكَادُ السَّمَاوَاتُ يَتَفَطَّرْنَ مِنْهُ وَتَنْشَقُّ الْأَرْضُ وَتَخِرُّ الْجِبَالُ هَدًّا",
  },
  {
    id: "2341",
    sura: "19",
    VerseIDAr: "91",
    ayatAR: "أَنْ دَعَوْا لِلرَّحْمَٰنِ وَلَدًا",
  },
  {
    id: "2342",
    sura: "19",
    VerseIDAr: "92",
    ayatAR: "وَمَا يَنْبَغِي لِلرَّحْمَٰنِ أَنْ يَتَّخِذَ وَلَدًا",
  },
  {
    id: "2343",
    sura: "19",
    VerseIDAr: "93",
    ayatAR:
      "إِنْ كُلُّ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ إِلَّا آتِي الرَّحْمَٰنِ عَبْدًا",
  },
  {
    id: "2344",
    sura: "19",
    VerseIDAr: "94",
    ayatAR: "لَقَدْ أَحْصَاهُمْ وَعَدَّهُمْ عَدًّا",
  },
  {
    id: "2345",
    sura: "19",
    VerseIDAr: "95",
    ayatAR: "وَكُلُّهُمْ آتِيهِ يَوْمَ الْقِيَامَةِ فَرْدًا",
  },
  {
    id: "2346",
    sura: "19",
    VerseIDAr: "96",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ سَيَجْعَلُ لَهُمُ الرَّحْمَٰنُ وُدًّا",
  },
  {
    id: "2347",
    sura: "19",
    VerseIDAr: "97",
    ayatAR:
      "فَإِنَّمَا يَسَّرْنَاهُ بِلِسَانِكَ لِتُبَشِّرَ بِهِ الْمُتَّقِينَ وَتُنْذِرَ بِهِ قَوْمًا لُدًّا",
  },
  {
    id: "2348",
    sura: "19",
    VerseIDAr: "98",
    ayatAR:
      "وَكَمْ أَهْلَكْنَا قَبْلَهُمْ مِنْ قَرْنٍ هَلْ تُحِسُّ مِنْهُمْ مِنْ أَحَدٍ أَوْ تَسْمَعُ لَهُمْ رِكْزًا",
  },
  {
    id: "2349",
    sura: "20",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ طه",
  },
  {
    id: "2350",
    sura: "20",
    VerseIDAr: "2",
    ayatAR: "مَا أَنْزَلْنَا عَلَيْكَ الْقُرْآنَ لِتَشْقَىٰ",
  },
  {
    id: "2351",
    sura: "20",
    VerseIDAr: "3",
    ayatAR: "إِلَّا تَذْكِرَةً لِمَنْ يَخْشَىٰ",
  },
  {
    id: "2352",
    sura: "20",
    VerseIDAr: "4",
    ayatAR: "تَنْزِيلًا مِمَّنْ خَلَقَ الْأَرْضَ وَالسَّمَاوَاتِ الْعُلَى",
  },
  {
    id: "2353",
    sura: "20",
    VerseIDAr: "5",
    ayatAR: "الرَّحْمَٰنُ عَلَى الْعَرْشِ اسْتَوَىٰ",
  },
  {
    id: "2354",
    sura: "20",
    VerseIDAr: "6",
    ayatAR:
      "لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ وَمَا بَيْنَهُمَا وَمَا تَحْتَ الثَّرَىٰ",
  },
  {
    id: "2355",
    sura: "20",
    VerseIDAr: "7",
    ayatAR: "وَإِنْ تَجْهَرْ بِالْقَوْلِ فَإِنَّهُ يَعْلَمُ السِّرَّ وَأَخْفَى",
  },
  {
    id: "2356",
    sura: "20",
    VerseIDAr: "8",
    ayatAR: "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ ۖ لَهُ الْأَسْمَاءُ الْحُسْنَىٰ",
  },
  {
    id: "2357",
    sura: "20",
    VerseIDAr: "9",
    ayatAR: "وَهَلْ أَتَاكَ حَدِيثُ مُوسَىٰ",
  },
  {
    id: "2358",
    sura: "20",
    VerseIDAr: "10",
    ayatAR:
      "إِذْ رَأَىٰ نَارًا فَقَالَ لِأَهْلِهِ امْكُثُوا إِنِّي آنَسْتُ نَارًا لَعَلِّي آتِيكُمْ مِنْهَا بِقَبَسٍ أَوْ أَجِدُ عَلَى النَّارِ هُدًى",
  },
  {
    id: "2359",
    sura: "20",
    VerseIDAr: "11",
    ayatAR: "فَلَمَّا أَتَاهَا نُودِيَ يَا مُوسَىٰ",
  },
  {
    id: "2360",
    sura: "20",
    VerseIDAr: "12",
    ayatAR:
      "إِنِّي أَنَا رَبُّكَ فَاخْلَعْ نَعْلَيْكَ ۖ إِنَّكَ بِالْوَادِ الْمُقَدَّسِ طُوًى",
  },
  {
    id: "2361",
    sura: "20",
    VerseIDAr: "13",
    ayatAR: "وَأَنَا اخْتَرْتُكَ فَاسْتَمِعْ لِمَا يُوحَىٰ",
  },
  {
    id: "2362",
    sura: "20",
    VerseIDAr: "14",
    ayatAR:
      "إِنَّنِي أَنَا اللَّهُ لَا إِلَٰهَ إِلَّا أَنَا فَاعْبُدْنِي وَأَقِمِ الصَّلَاةَ لِذِكْرِي",
  },
  {
    id: "2363",
    sura: "20",
    VerseIDAr: "15",
    ayatAR:
      "إِنَّ السَّاعَةَ آتِيَةٌ أَكَادُ أُخْفِيهَا لِتُجْزَىٰ كُلُّ نَفْسٍ بِمَا تَسْعَىٰ",
  },
  {
    id: "2364",
    sura: "20",
    VerseIDAr: "16",
    ayatAR:
      "فَلَا يَصُدَّنَّكَ عَنْهَا مَنْ لَا يُؤْمِنُ بِهَا وَاتَّبَعَ هَوَاهُ فَتَرْدَىٰ",
  },
  {
    id: "2365",
    sura: "20",
    VerseIDAr: "17",
    ayatAR: "وَمَا تِلْكَ بِيَمِينِكَ يَا مُوسَىٰ",
  },
  {
    id: "2366",
    sura: "20",
    VerseIDAr: "18",
    ayatAR:
      "قَالَ هِيَ عَصَايَ أَتَوَكَّأُ عَلَيْهَا وَأَهُشُّ بِهَا عَلَىٰ غَنَمِي وَلِيَ فِيهَا مَآرِبُ أُخْرَىٰ",
  },
  {
    id: "2367",
    sura: "20",
    VerseIDAr: "19",
    ayatAR: "قَالَ أَلْقِهَا يَا مُوسَىٰ",
  },
  {
    id: "2368",
    sura: "20",
    VerseIDAr: "20",
    ayatAR: "فَأَلْقَاهَا فَإِذَا هِيَ حَيَّةٌ تَسْعَىٰ",
  },
  {
    id: "2369",
    sura: "20",
    VerseIDAr: "21",
    ayatAR: "قَالَ خُذْهَا وَلَا تَخَفْ ۖ سَنُعِيدُهَا سِيرَتَهَا الْأُولَىٰ",
  },
  {
    id: "2370",
    sura: "20",
    VerseIDAr: "22",
    ayatAR:
      "وَاضْمُمْ يَدَكَ إِلَىٰ جَنَاحِكَ تَخْرُجْ بَيْضَاءَ مِنْ غَيْرِ سُوءٍ آيَةً أُخْرَىٰ",
  },
  {
    id: "2371",
    sura: "20",
    VerseIDAr: "23",
    ayatAR: "لِنُرِيَكَ مِنْ آيَاتِنَا الْكُبْرَى",
  },
  {
    id: "2372",
    sura: "20",
    VerseIDAr: "24",
    ayatAR: "اذْهَبْ إِلَىٰ فِرْعَوْنَ إِنَّهُ طَغَىٰ",
  },
  {
    id: "2373",
    sura: "20",
    VerseIDAr: "25",
    ayatAR: "قَالَ رَبِّ اشْرَحْ لِي صَدْرِي",
  },
  { id: "2374", sura: "20", VerseIDAr: "26", ayatAR: "وَيَسِّرْ لِي أَمْرِي" },
  {
    id: "2375",
    sura: "20",
    VerseIDAr: "27",
    ayatAR: "وَاحْلُلْ عُقْدَةً مِنْ لِسَانِي",
  },
  { id: "2376", sura: "20", VerseIDAr: "28", ayatAR: "يَفْقَهُوا قَوْلِي" },
  {
    id: "2377",
    sura: "20",
    VerseIDAr: "29",
    ayatAR: "وَاجْعَلْ لِي وَزِيرًا مِنْ أَهْلِي",
  },
  { id: "2378", sura: "20", VerseIDAr: "30", ayatAR: "هَارُونَ أَخِي" },
  { id: "2379", sura: "20", VerseIDAr: "31", ayatAR: "اشْدُدْ بِهِ أَزْرِي" },
  {
    id: "2380",
    sura: "20",
    VerseIDAr: "32",
    ayatAR: "وَأَشْرِكْهُ فِي أَمْرِي",
  },
  {
    id: "2381",
    sura: "20",
    VerseIDAr: "33",
    ayatAR: "كَيْ نُسَبِّحَكَ كَثِيرًا",
  },
  { id: "2382", sura: "20", VerseIDAr: "34", ayatAR: "وَنَذْكُرَكَ كَثِيرًا" },
  {
    id: "2383",
    sura: "20",
    VerseIDAr: "35",
    ayatAR: "إِنَّكَ كُنْتَ بِنَا بَصِيرًا",
  },
  {
    id: "2384",
    sura: "20",
    VerseIDAr: "36",
    ayatAR: "قَالَ قَدْ أُوتِيتَ سُؤْلَكَ يَا مُوسَىٰ",
  },
  {
    id: "2385",
    sura: "20",
    VerseIDAr: "37",
    ayatAR: "وَلَقَدْ مَنَنَّا عَلَيْكَ مَرَّةً أُخْرَىٰ",
  },
  {
    id: "2386",
    sura: "20",
    VerseIDAr: "38",
    ayatAR: "إِذْ أَوْحَيْنَا إِلَىٰ أُمِّكَ مَا يُوحَىٰ",
  },
  {
    id: "2387",
    sura: "20",
    VerseIDAr: "39",
    ayatAR:
      "أَنِ اقْذِفِيهِ فِي التَّابُوتِ فَاقْذِفِيهِ فِي الْيَمِّ فَلْيُلْقِهِ الْيَمُّ بِالسَّاحِلِ يَأْخُذْهُ عَدُوٌّ لِي وَعَدُوٌّ لَهُ ۚ وَأَلْقَيْتُ عَلَيْكَ مَحَبَّةً مِنِّي وَلِتُصْنَعَ عَلَىٰ عَيْنِي",
  },
  {
    id: "2388",
    sura: "20",
    VerseIDAr: "40",
    ayatAR:
      "إِذْ تَمْشِي أُخْتُكَ فَتَقُولُ هَلْ أَدُلُّكُمْ عَلَىٰ مَنْ يَكْفُلُهُ ۖ فَرَجَعْنَاكَ إِلَىٰ أُمِّكَ كَيْ تَقَرَّ عَيْنُهَا وَلَا تَحْزَنَ ۚ وَقَتَلْتَ نَفْسًا فَنَجَّيْنَاكَ مِنَ الْغَمِّ وَفَتَنَّاكَ فُتُونًا ۚ فَلَبِثْتَ سِنِينَ فِي أَهْلِ مَدْيَنَ ثُمَّ جِئْتَ عَلَىٰ قَدَرٍ يَا مُوسَىٰ",
  },
  {
    id: "2389",
    sura: "20",
    VerseIDAr: "41",
    ayatAR: "وَاصْطَنَعْتُكَ لِنَفْسِي",
  },
  {
    id: "2390",
    sura: "20",
    VerseIDAr: "42",
    ayatAR: "اذْهَبْ أَنْتَ وَأَخُوكَ بِآيَاتِي وَلَا تَنِيَا فِي ذِكْرِي",
  },
  {
    id: "2391",
    sura: "20",
    VerseIDAr: "43",
    ayatAR: "اذْهَبَا إِلَىٰ فِرْعَوْنَ إِنَّهُ طَغَىٰ",
  },
  {
    id: "2392",
    sura: "20",
    VerseIDAr: "44",
    ayatAR:
      "فَقُولَا لَهُ قَوْلًا لَيِّنًا لَعَلَّهُ يَتَذَكَّرُ أَوْ يَخْشَىٰ",
  },
  {
    id: "2393",
    sura: "20",
    VerseIDAr: "45",
    ayatAR:
      "قَالَا رَبَّنَا إِنَّنَا نَخَافُ أَنْ يَفْرُطَ عَلَيْنَا أَوْ أَنْ يَطْغَىٰ",
  },
  {
    id: "2394",
    sura: "20",
    VerseIDAr: "46",
    ayatAR: "قَالَ لَا تَخَافَا ۖ إِنَّنِي مَعَكُمَا أَسْمَعُ وَأَرَىٰ",
  },
  {
    id: "2395",
    sura: "20",
    VerseIDAr: "47",
    ayatAR:
      "فَأْتِيَاهُ فَقُولَا إِنَّا رَسُولَا رَبِّكَ فَأَرْسِلْ مَعَنَا بَنِي إِسْرَائِيلَ وَلَا تُعَذِّبْهُمْ ۖ قَدْ جِئْنَاكَ بِآيَةٍ مِنْ رَبِّكَ ۖ وَالسَّلَامُ عَلَىٰ مَنِ اتَّبَعَ الْهُدَىٰ",
  },
  {
    id: "2396",
    sura: "20",
    VerseIDAr: "48",
    ayatAR:
      "إِنَّا قَدْ أُوحِيَ إِلَيْنَا أَنَّ الْعَذَابَ عَلَىٰ مَنْ كَذَّبَ وَتَوَلَّىٰ",
  },
  {
    id: "2397",
    sura: "20",
    VerseIDAr: "49",
    ayatAR: "قَالَ فَمَنْ رَبُّكُمَا يَا مُوسَىٰ",
  },
  {
    id: "2398",
    sura: "20",
    VerseIDAr: "50",
    ayatAR:
      "قَالَ رَبُّنَا الَّذِي أَعْطَىٰ كُلَّ شَيْءٍ خَلْقَهُ ثُمَّ هَدَىٰ",
  },
  {
    id: "2399",
    sura: "20",
    VerseIDAr: "51",
    ayatAR: "قَالَ فَمَا بَالُ الْقُرُونِ الْأُولَىٰ",
  },
  {
    id: "2400",
    sura: "20",
    VerseIDAr: "52",
    ayatAR:
      "قَالَ عِلْمُهَا عِنْدَ رَبِّي فِي كِتَابٍ ۖ لَا يَضِلُّ رَبِّي وَلَا يَنْسَى",
  },
  {
    id: "2401",
    sura: "20",
    VerseIDAr: "53",
    ayatAR:
      "الَّذِي جَعَلَ لَكُمُ الْأَرْضَ مَهْدًا وَسَلَكَ لَكُمْ فِيهَا سُبُلًا وَأَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَخْرَجْنَا بِهِ أَزْوَاجًا مِنْ نَبَاتٍ شَتَّىٰ",
  },
  {
    id: "2402",
    sura: "20",
    VerseIDAr: "54",
    ayatAR:
      "كُلُوا وَارْعَوْا أَنْعَامَكُمْ ۗ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِأُولِي النُّهَىٰ",
  },
  {
    id: "2403",
    sura: "20",
    VerseIDAr: "55",
    ayatAR:
      "مِنْهَا خَلَقْنَاكُمْ وَفِيهَا نُعِيدُكُمْ وَمِنْهَا نُخْرِجُكُمْ تَارَةً أُخْرَىٰ",
  },
  {
    id: "2404",
    sura: "20",
    VerseIDAr: "56",
    ayatAR: "وَلَقَدْ أَرَيْنَاهُ آيَاتِنَا كُلَّهَا فَكَذَّبَ وَأَبَىٰ",
  },
  {
    id: "2405",
    sura: "20",
    VerseIDAr: "57",
    ayatAR:
      "قَالَ أَجِئْتَنَا لِتُخْرِجَنَا مِنْ أَرْضِنَا بِسِحْرِكَ يَا مُوسَىٰ",
  },
  {
    id: "2406",
    sura: "20",
    VerseIDAr: "58",
    ayatAR:
      "فَلَنَأْتِيَنَّكَ بِسِحْرٍ مِثْلِهِ فَاجْعَلْ بَيْنَنَا وَبَيْنَكَ مَوْعِدًا لَا نُخْلِفُهُ نَحْنُ وَلَا أَنْتَ مَكَانًا سُوًى",
  },
  {
    id: "2407",
    sura: "20",
    VerseIDAr: "59",
    ayatAR:
      "قَالَ مَوْعِدُكُمْ يَوْمُ الزِّينَةِ وَأَنْ يُحْشَرَ النَّاسُ ضُحًى",
  },
  {
    id: "2408",
    sura: "20",
    VerseIDAr: "60",
    ayatAR: "فَتَوَلَّىٰ فِرْعَوْنُ فَجَمَعَ كَيْدَهُ ثُمَّ أَتَىٰ",
  },
  {
    id: "2409",
    sura: "20",
    VerseIDAr: "61",
    ayatAR:
      "قَالَ لَهُمْ مُوسَىٰ وَيْلَكُمْ لَا تَفْتَرُوا عَلَى اللَّهِ كَذِبًا فَيُسْحِتَكُمْ بِعَذَابٍ ۖ وَقَدْ خَابَ مَنِ افْتَرَىٰ",
  },
  {
    id: "2410",
    sura: "20",
    VerseIDAr: "62",
    ayatAR: "فَتَنَازَعُوا أَمْرَهُمْ بَيْنَهُمْ وَأَسَرُّوا النَّجْوَىٰ",
  },
  {
    id: "2411",
    sura: "20",
    VerseIDAr: "63",
    ayatAR:
      "قَالُوا إِنْ هَٰذَانِ لَسَاحِرَانِ يُرِيدَانِ أَنْ يُخْرِجَاكُمْ مِنْ أَرْضِكُمْ بِسِحْرِهِمَا وَيَذْهَبَا بِطَرِيقَتِكُمُ الْمُثْلَىٰ",
  },
  {
    id: "2412",
    sura: "20",
    VerseIDAr: "64",
    ayatAR:
      "فَأَجْمِعُوا كَيْدَكُمْ ثُمَّ ائْتُوا صَفًّا ۚ وَقَدْ أَفْلَحَ الْيَوْمَ مَنِ اسْتَعْلَىٰ",
  },
  {
    id: "2413",
    sura: "20",
    VerseIDAr: "65",
    ayatAR:
      "قَالُوا يَا مُوسَىٰ إِمَّا أَنْ تُلْقِيَ وَإِمَّا أَنْ نَكُونَ أَوَّلَ مَنْ أَلْقَىٰ",
  },
  {
    id: "2414",
    sura: "20",
    VerseIDAr: "66",
    ayatAR:
      "قَالَ بَلْ أَلْقُوا ۖ فَإِذَا حِبَالُهُمْ وَعِصِيُّهُمْ يُخَيَّلُ إِلَيْهِ مِنْ سِحْرِهِمْ أَنَّهَا تَسْعَىٰ",
  },
  {
    id: "2415",
    sura: "20",
    VerseIDAr: "67",
    ayatAR: "فَأَوْجَسَ فِي نَفْسِهِ خِيفَةً مُوسَىٰ",
  },
  {
    id: "2416",
    sura: "20",
    VerseIDAr: "68",
    ayatAR: "قُلْنَا لَا تَخَفْ إِنَّكَ أَنْتَ الْأَعْلَىٰ",
  },
  {
    id: "2417",
    sura: "20",
    VerseIDAr: "69",
    ayatAR:
      "وَأَلْقِ مَا فِي يَمِينِكَ تَلْقَفْ مَا صَنَعُوا ۖ إِنَّمَا صَنَعُوا كَيْدُ سَاحِرٍ ۖ وَلَا يُفْلِحُ السَّاحِرُ حَيْثُ أَتَىٰ",
  },
  {
    id: "2418",
    sura: "20",
    VerseIDAr: "70",
    ayatAR:
      "فَأُلْقِيَ السَّحَرَةُ سُجَّدًا قَالُوا آمَنَّا بِرَبِّ هَارُونَ وَمُوسَىٰ",
  },
  {
    id: "2419",
    sura: "20",
    VerseIDAr: "71",
    ayatAR:
      "قَالَ آمَنْتُمْ لَهُ قَبْلَ أَنْ آذَنَ لَكُمْ ۖ إِنَّهُ لَكَبِيرُكُمُ الَّذِي عَلَّمَكُمُ السِّحْرَ ۖ فَلَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُمْ مِنْ خِلَافٍ وَلَأُصَلِّبَنَّكُمْ فِي جُذُوعِ النَّخْلِ وَلَتَعْلَمُنَّ أَيُّنَا أَشَدُّ عَذَابًا وَأَبْقَىٰ",
  },
  {
    id: "2420",
    sura: "20",
    VerseIDAr: "72",
    ayatAR:
      "قَالُوا لَنْ نُؤْثِرَكَ عَلَىٰ مَا جَاءَنَا مِنَ الْبَيِّنَاتِ وَالَّذِي فَطَرَنَا ۖ فَاقْضِ مَا أَنْتَ قَاضٍ ۖ إِنَّمَا تَقْضِي هَٰذِهِ الْحَيَاةَ الدُّنْيَا",
  },
  {
    id: "2421",
    sura: "20",
    VerseIDAr: "73",
    ayatAR:
      "إِنَّا آمَنَّا بِرَبِّنَا لِيَغْفِرَ لَنَا خَطَايَانَا وَمَا أَكْرَهْتَنَا عَلَيْهِ مِنَ السِّحْرِ ۗ وَاللَّهُ خَيْرٌ وَأَبْقَىٰ",
  },
  {
    id: "2422",
    sura: "20",
    VerseIDAr: "74",
    ayatAR:
      "إِنَّهُ مَنْ يَأْتِ رَبَّهُ مُجْرِمًا فَإِنَّ لَهُ جَهَنَّمَ لَا يَمُوتُ فِيهَا وَلَا يَحْيَىٰ",
  },
  {
    id: "2423",
    sura: "20",
    VerseIDAr: "75",
    ayatAR:
      "وَمَنْ يَأْتِهِ مُؤْمِنًا قَدْ عَمِلَ الصَّالِحَاتِ فَأُولَٰئِكَ لَهُمُ الدَّرَجَاتُ الْعُلَىٰ",
  },
  {
    id: "2424",
    sura: "20",
    VerseIDAr: "76",
    ayatAR:
      "جَنَّاتُ عَدْنٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ وَذَٰلِكَ جَزَاءُ مَنْ تَزَكَّىٰ",
  },
  {
    id: "2425",
    sura: "20",
    VerseIDAr: "77",
    ayatAR:
      "وَلَقَدْ أَوْحَيْنَا إِلَىٰ مُوسَىٰ أَنْ أَسْرِ بِعِبَادِي فَاضْرِبْ لَهُمْ طَرِيقًا فِي الْبَحْرِ يَبَسًا لَا تَخَافُ دَرَكًا وَلَا تَخْشَىٰ",
  },
  {
    id: "2426",
    sura: "20",
    VerseIDAr: "78",
    ayatAR:
      "فَأَتْبَعَهُمْ فِرْعَوْنُ بِجُنُودِهِ فَغَشِيَهُمْ مِنَ الْيَمِّ مَا غَشِيَهُمْ",
  },
  {
    id: "2427",
    sura: "20",
    VerseIDAr: "79",
    ayatAR: "وَأَضَلَّ فِرْعَوْنُ قَوْمَهُ وَمَا هَدَىٰ",
  },
  {
    id: "2428",
    sura: "20",
    VerseIDAr: "80",
    ayatAR:
      "يَا بَنِي إِسْرَائِيلَ قَدْ أَنْجَيْنَاكُمْ مِنْ عَدُوِّكُمْ وَوَاعَدْنَاكُمْ جَانِبَ الطُّورِ الْأَيْمَنَ وَنَزَّلْنَا عَلَيْكُمُ الْمَنَّ وَالسَّلْوَىٰ",
  },
  {
    id: "2429",
    sura: "20",
    VerseIDAr: "81",
    ayatAR:
      "كُلُوا مِنْ طَيِّبَاتِ مَا رَزَقْنَاكُمْ وَلَا تَطْغَوْا فِيهِ فَيَحِلَّ عَلَيْكُمْ غَضَبِي ۖ وَمَنْ يَحْلِلْ عَلَيْهِ غَضَبِي فَقَدْ هَوَىٰ",
  },
  {
    id: "2430",
    sura: "20",
    VerseIDAr: "82",
    ayatAR:
      "وَإِنِّي لَغَفَّارٌ لِمَنْ تَابَ وَآمَنَ وَعَمِلَ صَالِحًا ثُمَّ اهْتَدَىٰ",
  },
  {
    id: "2431",
    sura: "20",
    VerseIDAr: "83",
    ayatAR: "وَمَا أَعْجَلَكَ عَنْ قَوْمِكَ يَا مُوسَىٰ",
  },
  {
    id: "2432",
    sura: "20",
    VerseIDAr: "84",
    ayatAR:
      "قَالَ هُمْ أُولَاءِ عَلَىٰ أَثَرِي وَعَجِلْتُ إِلَيْكَ رَبِّ لِتَرْضَىٰ",
  },
  {
    id: "2433",
    sura: "20",
    VerseIDAr: "85",
    ayatAR:
      "قَالَ فَإِنَّا قَدْ فَتَنَّا قَوْمَكَ مِنْ بَعْدِكَ وَأَضَلَّهُمُ السَّامِرِيُّ",
  },
  {
    id: "2434",
    sura: "20",
    VerseIDAr: "86",
    ayatAR:
      "فَرَجَعَ مُوسَىٰ إِلَىٰ قَوْمِهِ غَضْبَانَ أَسِفًا ۚ قَالَ يَا قَوْمِ أَلَمْ يَعِدْكُمْ رَبُّكُمْ وَعْدًا حَسَنًا ۚ أَفَطَالَ عَلَيْكُمُ الْعَهْدُ أَمْ أَرَدْتُمْ أَنْ يَحِلَّ عَلَيْكُمْ غَضَبٌ مِنْ رَبِّكُمْ فَأَخْلَفْتُمْ مَوْعِدِي",
  },
  {
    id: "2435",
    sura: "20",
    VerseIDAr: "87",
    ayatAR:
      "قَالُوا مَا أَخْلَفْنَا مَوْعِدَكَ بِمَلْكِنَا وَلَٰكِنَّا حُمِّلْنَا أَوْزَارًا مِنْ زِينَةِ الْقَوْمِ فَقَذَفْنَاهَا فَكَذَٰلِكَ أَلْقَى السَّامِرِيُّ",
  },
  {
    id: "2436",
    sura: "20",
    VerseIDAr: "88",
    ayatAR:
      "فَأَخْرَجَ لَهُمْ عِجْلًا جَسَدًا لَهُ خُوَارٌ فَقَالُوا هَٰذَا إِلَٰهُكُمْ وَإِلَٰهُ مُوسَىٰ فَنَسِيَ",
  },
  {
    id: "2437",
    sura: "20",
    VerseIDAr: "89",
    ayatAR:
      "أَفَلَا يَرَوْنَ أَلَّا يَرْجِعُ إِلَيْهِمْ قَوْلًا وَلَا يَمْلِكُ لَهُمْ ضَرًّا وَلَا نَفْعًا",
  },
  {
    id: "2438",
    sura: "20",
    VerseIDAr: "90",
    ayatAR:
      "وَلَقَدْ قَالَ لَهُمْ هَارُونُ مِنْ قَبْلُ يَا قَوْمِ إِنَّمَا فُتِنْتُمْ بِهِ ۖ وَإِنَّ رَبَّكُمُ الرَّحْمَٰنُ فَاتَّبِعُونِي وَأَطِيعُوا أَمْرِي",
  },
  {
    id: "2439",
    sura: "20",
    VerseIDAr: "91",
    ayatAR:
      "قَالُوا لَنْ نَبْرَحَ عَلَيْهِ عَاكِفِينَ حَتَّىٰ يَرْجِعَ إِلَيْنَا مُوسَىٰ",
  },
  {
    id: "2440",
    sura: "20",
    VerseIDAr: "92",
    ayatAR: "قَالَ يَا هَارُونُ مَا مَنَعَكَ إِذْ رَأَيْتَهُمْ ضَلُّوا",
  },
  {
    id: "2441",
    sura: "20",
    VerseIDAr: "93",
    ayatAR: "أَلَّا تَتَّبِعَنِ ۖ أَفَعَصَيْتَ أَمْرِي",
  },
  {
    id: "2442",
    sura: "20",
    VerseIDAr: "94",
    ayatAR:
      "قَالَ يَا ابْنَ أُمَّ لَا تَأْخُذْ بِلِحْيَتِي وَلَا بِرَأْسِي ۖ إِنِّي خَشِيتُ أَنْ تَقُولَ فَرَّقْتَ بَيْنَ بَنِي إِسْرَائِيلَ وَلَمْ تَرْقُبْ قَوْلِي",
  },
  {
    id: "2443",
    sura: "20",
    VerseIDAr: "95",
    ayatAR: "قَالَ فَمَا خَطْبُكَ يَا سَامِرِيُّ",
  },
  {
    id: "2444",
    sura: "20",
    VerseIDAr: "96",
    ayatAR:
      "قَالَ بَصُرْتُ بِمَا لَمْ يَبْصُرُوا بِهِ فَقَبَضْتُ قَبْضَةً مِنْ أَثَرِ الرَّسُولِ فَنَبَذْتُهَا وَكَذَٰلِكَ سَوَّلَتْ لِي نَفْسِي",
  },
  {
    id: "2445",
    sura: "20",
    VerseIDAr: "97",
    ayatAR:
      "قَالَ فَاذْهَبْ فَإِنَّ لَكَ فِي الْحَيَاةِ أَنْ تَقُولَ لَا مِسَاسَ ۖ وَإِنَّ لَكَ مَوْعِدًا لَنْ تُخْلَفَهُ ۖ وَانْظُرْ إِلَىٰ إِلَٰهِكَ الَّذِي ظَلْتَ عَلَيْهِ عَاكِفًا ۖ لَنُحَرِّقَنَّهُ ثُمَّ لَنَنْسِفَنَّهُ فِي الْيَمِّ نَسْفًا",
  },
  {
    id: "2446",
    sura: "20",
    VerseIDAr: "98",
    ayatAR:
      "إِنَّمَا إِلَٰهُكُمُ اللَّهُ الَّذِي لَا إِلَٰهَ إِلَّا هُوَ ۚ وَسِعَ كُلَّ شَيْءٍ عِلْمًا",
  },
  {
    id: "2447",
    sura: "20",
    VerseIDAr: "99",
    ayatAR:
      "كَذَٰلِكَ نَقُصُّ عَلَيْكَ مِنْ أَنْبَاءِ مَا قَدْ سَبَقَ ۚ وَقَدْ آتَيْنَاكَ مِنْ لَدُنَّا ذِكْرًا",
  },
  {
    id: "2448",
    sura: "20",
    VerseIDAr: "100",
    ayatAR:
      "مَنْ أَعْرَضَ عَنْهُ فَإِنَّهُ يَحْمِلُ يَوْمَ الْقِيَامَةِ وِزْرًا",
  },
  {
    id: "2449",
    sura: "20",
    VerseIDAr: "101",
    ayatAR: "خَالِدِينَ فِيهِ ۖ وَسَاءَ لَهُمْ يَوْمَ الْقِيَامَةِ حِمْلًا",
  },
  {
    id: "2450",
    sura: "20",
    VerseIDAr: "102",
    ayatAR:
      "يَوْمَ يُنْفَخُ فِي الصُّورِ ۚ وَنَحْشُرُ الْمُجْرِمِينَ يَوْمَئِذٍ زُرْقًا",
  },
  {
    id: "2451",
    sura: "20",
    VerseIDAr: "103",
    ayatAR: "يَتَخَافَتُونَ بَيْنَهُمْ إِنْ لَبِثْتُمْ إِلَّا عَشْرًا",
  },
  {
    id: "2452",
    sura: "20",
    VerseIDAr: "104",
    ayatAR:
      "نَحْنُ أَعْلَمُ بِمَا يَقُولُونَ إِذْ يَقُولُ أَمْثَلُهُمْ طَرِيقَةً إِنْ لَبِثْتُمْ إِلَّا يَوْمًا",
  },
  {
    id: "2453",
    sura: "20",
    VerseIDAr: "105",
    ayatAR: "وَيَسْأَلُونَكَ عَنِ الْجِبَالِ فَقُلْ يَنْسِفُهَا رَبِّي نَسْفًا",
  },
  {
    id: "2454",
    sura: "20",
    VerseIDAr: "106",
    ayatAR: "فَيَذَرُهَا قَاعًا صَفْصَفًا",
  },
  {
    id: "2455",
    sura: "20",
    VerseIDAr: "107",
    ayatAR: "لَا تَرَىٰ فِيهَا عِوَجًا وَلَا أَمْتًا",
  },
  {
    id: "2456",
    sura: "20",
    VerseIDAr: "108",
    ayatAR:
      "يَوْمَئِذٍ يَتَّبِعُونَ الدَّاعِيَ لَا عِوَجَ لَهُ ۖ وَخَشَعَتِ الْأَصْوَاتُ لِلرَّحْمَٰنِ فَلَا تَسْمَعُ إِلَّا هَمْسًا",
  },
  {
    id: "2457",
    sura: "20",
    VerseIDAr: "109",
    ayatAR:
      "يَوْمَئِذٍ لَا تَنْفَعُ الشَّفَاعَةُ إِلَّا مَنْ أَذِنَ لَهُ الرَّحْمَٰنُ وَرَضِيَ لَهُ قَوْلًا",
  },
  {
    id: "2458",
    sura: "20",
    VerseIDAr: "110",
    ayatAR:
      "يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلَا يُحِيطُونَ بِهِ عِلْمًا",
  },
  {
    id: "2459",
    sura: "20",
    VerseIDAr: "111",
    ayatAR:
      "وَعَنَتِ الْوُجُوهُ لِلْحَيِّ الْقَيُّومِ ۖ وَقَدْ خَابَ مَنْ حَمَلَ ظُلْمًا",
  },
  {
    id: "2460",
    sura: "20",
    VerseIDAr: "112",
    ayatAR:
      "وَمَنْ يَعْمَلْ مِنَ الصَّالِحَاتِ وَهُوَ مُؤْمِنٌ فَلَا يَخَافُ ظُلْمًا وَلَا هَضْمًا",
  },
  {
    id: "2461",
    sura: "20",
    VerseIDAr: "113",
    ayatAR:
      "وَكَذَٰلِكَ أَنْزَلْنَاهُ قُرْآنًا عَرَبِيًّا وَصَرَّفْنَا فِيهِ مِنَ الْوَعِيدِ لَعَلَّهُمْ يَتَّقُونَ أَوْ يُحْدِثُ لَهُمْ ذِكْرًا",
  },
  {
    id: "2462",
    sura: "20",
    VerseIDAr: "114",
    ayatAR:
      "فَتَعَالَى اللَّهُ الْمَلِكُ الْحَقُّ ۗ وَلَا تَعْجَلْ بِالْقُرْآنِ مِنْ قَبْلِ أَنْ يُقْضَىٰ إِلَيْكَ وَحْيُهُ ۖ وَقُلْ رَبِّ زِدْنِي عِلْمًا",
  },
  {
    id: "2463",
    sura: "20",
    VerseIDAr: "115",
    ayatAR:
      "وَلَقَدْ عَهِدْنَا إِلَىٰ آدَمَ مِنْ قَبْلُ فَنَسِيَ وَلَمْ نَجِدْ لَهُ عَزْمًا",
  },
  {
    id: "2464",
    sura: "20",
    VerseIDAr: "116",
    ayatAR:
      "وَإِذْ قُلْنَا لِلْمَلَائِكَةِ اسْجُدُوا لِآدَمَ فَسَجَدُوا إِلَّا إِبْلِيسَ أَبَىٰ",
  },
  {
    id: "2465",
    sura: "20",
    VerseIDAr: "117",
    ayatAR:
      "فَقُلْنَا يَا آدَمُ إِنَّ هَٰذَا عَدُوٌّ لَكَ وَلِزَوْجِكَ فَلَا يُخْرِجَنَّكُمَا مِنَ الْجَنَّةِ فَتَشْقَىٰ",
  },
  {
    id: "2466",
    sura: "20",
    VerseIDAr: "118",
    ayatAR: "إِنَّ لَكَ أَلَّا تَجُوعَ فِيهَا وَلَا تَعْرَىٰ",
  },
  {
    id: "2467",
    sura: "20",
    VerseIDAr: "119",
    ayatAR: "وَأَنَّكَ لَا تَظْمَأُ فِيهَا وَلَا تَضْحَىٰ",
  },
  {
    id: "2468",
    sura: "20",
    VerseIDAr: "120",
    ayatAR:
      "فَوَسْوَسَ إِلَيْهِ الشَّيْطَانُ قَالَ يَا آدَمُ هَلْ أَدُلُّكَ عَلَىٰ شَجَرَةِ الْخُلْدِ وَمُلْكٍ لَا يَبْلَىٰ",
  },
  {
    id: "2469",
    sura: "20",
    VerseIDAr: "121",
    ayatAR:
      "فَأَكَلَا مِنْهَا فَبَدَتْ لَهُمَا سَوْآتُهُمَا وَطَفِقَا يَخْصِفَانِ عَلَيْهِمَا مِنْ وَرَقِ الْجَنَّةِ ۚ وَعَصَىٰ آدَمُ رَبَّهُ فَغَوَىٰ",
  },
  {
    id: "2470",
    sura: "20",
    VerseIDAr: "122",
    ayatAR: "ثُمَّ اجْتَبَاهُ رَبُّهُ فَتَابَ عَلَيْهِ وَهَدَىٰ",
  },
  {
    id: "2471",
    sura: "20",
    VerseIDAr: "123",
    ayatAR:
      "قَالَ اهْبِطَا مِنْهَا جَمِيعًا ۖ بَعْضُكُمْ لِبَعْضٍ عَدُوٌّ ۖ فَإِمَّا يَأْتِيَنَّكُمْ مِنِّي هُدًى فَمَنِ اتَّبَعَ هُدَايَ فَلَا يَضِلُّ وَلَا يَشْقَىٰ",
  },
  {
    id: "2472",
    sura: "20",
    VerseIDAr: "124",
    ayatAR:
      "وَمَنْ أَعْرَضَ عَنْ ذِكْرِي فَإِنَّ لَهُ مَعِيشَةً ضَنْكًا وَنَحْشُرُهُ يَوْمَ الْقِيَامَةِ أَعْمَىٰ",
  },
  {
    id: "2473",
    sura: "20",
    VerseIDAr: "125",
    ayatAR: "قَالَ رَبِّ لِمَ حَشَرْتَنِي أَعْمَىٰ وَقَدْ كُنْتُ بَصِيرًا",
  },
  {
    id: "2474",
    sura: "20",
    VerseIDAr: "126",
    ayatAR:
      "قَالَ كَذَٰلِكَ أَتَتْكَ آيَاتُنَا فَنَسِيتَهَا ۖ وَكَذَٰلِكَ الْيَوْمَ تُنْسَىٰ",
  },
  {
    id: "2475",
    sura: "20",
    VerseIDAr: "127",
    ayatAR:
      "وَكَذَٰلِكَ نَجْزِي مَنْ أَسْرَفَ وَلَمْ يُؤْمِنْ بِآيَاتِ رَبِّهِ ۚ وَلَعَذَابُ الْآخِرَةِ أَشَدُّ وَأَبْقَىٰ",
  },
  {
    id: "2476",
    sura: "20",
    VerseIDAr: "128",
    ayatAR:
      "أَفَلَمْ يَهْدِ لَهُمْ كَمْ أَهْلَكْنَا قَبْلَهُمْ مِنَ الْقُرُونِ يَمْشُونَ فِي مَسَاكِنِهِمْ ۗ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِأُولِي النُّهَىٰ",
  },
  {
    id: "2477",
    sura: "20",
    VerseIDAr: "129",
    ayatAR:
      "وَلَوْلَا كَلِمَةٌ سَبَقَتْ مِنْ رَبِّكَ لَكَانَ لِزَامًا وَأَجَلٌ مُسَمًّى",
  },
  {
    id: "2478",
    sura: "20",
    VerseIDAr: "130",
    ayatAR:
      "فَاصْبِرْ عَلَىٰ مَا يَقُولُونَ وَسَبِّحْ بِحَمْدِ رَبِّكَ قَبْلَ طُلُوعِ الشَّمْسِ وَقَبْلَ غُرُوبِهَا ۖ وَمِنْ آنَاءِ اللَّيْلِ فَسَبِّحْ وَأَطْرَافَ النَّهَارِ لَعَلَّكَ تَرْضَىٰ",
  },
  {
    id: "2479",
    sura: "20",
    VerseIDAr: "131",
    ayatAR:
      "وَلَا تَمُدَّنَّ عَيْنَيْكَ إِلَىٰ مَا مَتَّعْنَا بِهِ أَزْوَاجًا مِنْهُمْ زَهْرَةَ الْحَيَاةِ الدُّنْيَا لِنَفْتِنَهُمْ فِيهِ ۚ وَرِزْقُ رَبِّكَ خَيْرٌ وَأَبْقَىٰ",
  },
  {
    id: "2480",
    sura: "20",
    VerseIDAr: "132",
    ayatAR:
      "وَأْمُرْ أَهْلَكَ بِالصَّلَاةِ وَاصْطَبِرْ عَلَيْهَا ۖ لَا نَسْأَلُكَ رِزْقًا ۖ نَحْنُ نَرْزُقُكَ ۗ وَالْعَاقِبَةُ لِلتَّقْوَىٰ",
  },
  {
    id: "2481",
    sura: "20",
    VerseIDAr: "133",
    ayatAR:
      "وَقَالُوا لَوْلَا يَأْتِينَا بِآيَةٍ مِنْ رَبِّهِ ۚ أَوَلَمْ تَأْتِهِمْ بَيِّنَةُ مَا فِي الصُّحُفِ الْأُولَىٰ",
  },
  {
    id: "2482",
    sura: "20",
    VerseIDAr: "134",
    ayatAR:
      "وَلَوْ أَنَّا أَهْلَكْنَاهُمْ بِعَذَابٍ مِنْ قَبْلِهِ لَقَالُوا رَبَّنَا لَوْلَا أَرْسَلْتَ إِلَيْنَا رَسُولًا فَنَتَّبِعَ آيَاتِكَ مِنْ قَبْلِ أَنْ نَذِلَّ وَنَخْزَىٰ",
  },
  {
    id: "2483",
    sura: "20",
    VerseIDAr: "135",
    ayatAR:
      "قُلْ كُلٌّ مُتَرَبِّصٌ فَتَرَبَّصُوا ۖ فَسَتَعْلَمُونَ مَنْ أَصْحَابُ الصِّرَاطِ السَّوِيِّ وَمَنِ اهْتَدَىٰ",
  },
  {
    id: "2484",
    sura: "21",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ اقْتَرَبَ لِلنَّاسِ حِسَابُهُمْ وَهُمْ فِي غَفْلَةٍ مُعْرِضُونَ",
  },
  {
    id: "2485",
    sura: "21",
    VerseIDAr: "2",
    ayatAR:
      "مَا يَأْتِيهِمْ مِنْ ذِكْرٍ مِنْ رَبِّهِمْ مُحْدَثٍ إِلَّا اسْتَمَعُوهُ وَهُمْ يَلْعَبُونَ",
  },
  {
    id: "2486",
    sura: "21",
    VerseIDAr: "3",
    ayatAR:
      "لَاهِيَةً قُلُوبُهُمْ ۗ وَأَسَرُّوا النَّجْوَى الَّذِينَ ظَلَمُوا هَلْ هَٰذَا إِلَّا بَشَرٌ مِثْلُكُمْ ۖ أَفَتَأْتُونَ السِّحْرَ وَأَنْتُمْ تُبْصِرُونَ",
  },
  {
    id: "2487",
    sura: "21",
    VerseIDAr: "4",
    ayatAR:
      "قَالَ رَبِّي يَعْلَمُ الْقَوْلَ فِي السَّمَاءِ وَالْأَرْضِ ۖ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "2488",
    sura: "21",
    VerseIDAr: "5",
    ayatAR:
      "بَلْ قَالُوا أَضْغَاثُ أَحْلَامٍ بَلِ افْتَرَاهُ بَلْ هُوَ شَاعِرٌ فَلْيَأْتِنَا بِآيَةٍ كَمَا أُرْسِلَ الْأَوَّلُونَ",
  },
  {
    id: "2489",
    sura: "21",
    VerseIDAr: "6",
    ayatAR:
      "مَا آمَنَتْ قَبْلَهُمْ مِنْ قَرْيَةٍ أَهْلَكْنَاهَا ۖ أَفَهُمْ يُؤْمِنُونَ",
  },
  {
    id: "2490",
    sura: "21",
    VerseIDAr: "7",
    ayatAR:
      "وَمَا أَرْسَلْنَا قَبْلَكَ إِلَّا رِجَالًا نُوحِي إِلَيْهِمْ ۖ فَاسْأَلُوا أَهْلَ الذِّكْرِ إِنْ كُنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "2491",
    sura: "21",
    VerseIDAr: "8",
    ayatAR:
      "وَمَا جَعَلْنَاهُمْ جَسَدًا لَا يَأْكُلُونَ الطَّعَامَ وَمَا كَانُوا خَالِدِينَ",
  },
  {
    id: "2492",
    sura: "21",
    VerseIDAr: "9",
    ayatAR:
      "ثُمَّ صَدَقْنَاهُمُ الْوَعْدَ فَأَنْجَيْنَاهُمْ وَمَنْ نَشَاءُ وَأَهْلَكْنَا الْمُسْرِفِينَ",
  },
  {
    id: "2493",
    sura: "21",
    VerseIDAr: "10",
    ayatAR:
      "لَقَدْ أَنْزَلْنَا إِلَيْكُمْ كِتَابًا فِيهِ ذِكْرُكُمْ ۖ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "2494",
    sura: "21",
    VerseIDAr: "11",
    ayatAR:
      "وَكَمْ قَصَمْنَا مِنْ قَرْيَةٍ كَانَتْ ظَالِمَةً وَأَنْشَأْنَا بَعْدَهَا قَوْمًا آخَرِينَ",
  },
  {
    id: "2495",
    sura: "21",
    VerseIDAr: "12",
    ayatAR: "فَلَمَّا أَحَسُّوا بَأْسَنَا إِذَا هُمْ مِنْهَا يَرْكُضُونَ",
  },
  {
    id: "2496",
    sura: "21",
    VerseIDAr: "13",
    ayatAR:
      "لَا تَرْكُضُوا وَارْجِعُوا إِلَىٰ مَا أُتْرِفْتُمْ فِيهِ وَمَسَاكِنِكُمْ لَعَلَّكُمْ تُسْأَلُونَ",
  },
  {
    id: "2497",
    sura: "21",
    VerseIDAr: "14",
    ayatAR: "قَالُوا يَا وَيْلَنَا إِنَّا كُنَّا ظَالِمِينَ",
  },
  {
    id: "2498",
    sura: "21",
    VerseIDAr: "15",
    ayatAR:
      "فَمَا زَالَتْ تِلْكَ دَعْوَاهُمْ حَتَّىٰ جَعَلْنَاهُمْ حَصِيدًا خَامِدِينَ",
  },
  {
    id: "2499",
    sura: "21",
    VerseIDAr: "16",
    ayatAR:
      "وَمَا خَلَقْنَا السَّمَاءَ وَالْأَرْضَ وَمَا بَيْنَهُمَا لَاعِبِينَ",
  },
  {
    id: "2500",
    sura: "21",
    VerseIDAr: "17",
    ayatAR:
      "لَوْ أَرَدْنَا أَنْ نَتَّخِذَ لَهْوًا لَاتَّخَذْنَاهُ مِنْ لَدُنَّا إِنْ كُنَّا فَاعِلِينَ",
  },
  {
    id: "2501",
    sura: "21",
    VerseIDAr: "18",
    ayatAR:
      "بَلْ نَقْذِفُ بِالْحَقِّ عَلَى الْبَاطِلِ فَيَدْمَغُهُ فَإِذَا هُوَ زَاهِقٌ ۚ وَلَكُمُ الْوَيْلُ مِمَّا تَصِفُونَ",
  },
  {
    id: "2502",
    sura: "21",
    VerseIDAr: "19",
    ayatAR:
      "وَلَهُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ وَمَنْ عِنْدَهُ لَا يَسْتَكْبِرُونَ عَنْ عِبَادَتِهِ وَلَا يَسْتَحْسِرُونَ",
  },
  {
    id: "2503",
    sura: "21",
    VerseIDAr: "20",
    ayatAR: "يُسَبِّحُونَ اللَّيْلَ وَالنَّهَارَ لَا يَفْتُرُونَ",
  },
  {
    id: "2504",
    sura: "21",
    VerseIDAr: "21",
    ayatAR: "أَمِ اتَّخَذُوا آلِهَةً مِنَ الْأَرْضِ هُمْ يُنْشِرُونَ",
  },
  {
    id: "2505",
    sura: "21",
    VerseIDAr: "22",
    ayatAR:
      "لَوْ كَانَ فِيهِمَا آلِهَةٌ إِلَّا اللَّهُ لَفَسَدَتَا ۚ فَسُبْحَانَ اللَّهِ رَبِّ الْعَرْشِ عَمَّا يَصِفُونَ",
  },
  {
    id: "2506",
    sura: "21",
    VerseIDAr: "23",
    ayatAR: "لَا يُسْأَلُ عَمَّا يَفْعَلُ وَهُمْ يُسْأَلُونَ",
  },
  {
    id: "2507",
    sura: "21",
    VerseIDAr: "24",
    ayatAR:
      "أَمِ اتَّخَذُوا مِنْ دُونِهِ آلِهَةً ۖ قُلْ هَاتُوا بُرْهَانَكُمْ ۖ هَٰذَا ذِكْرُ مَنْ مَعِيَ وَذِكْرُ مَنْ قَبْلِي ۗ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ الْحَقَّ ۖ فَهُمْ مُعْرِضُونَ",
  },
  {
    id: "2508",
    sura: "21",
    VerseIDAr: "25",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ قَبْلِكَ مِنْ رَسُولٍ إِلَّا نُوحِي إِلَيْهِ أَنَّهُ لَا إِلَٰهَ إِلَّا أَنَا فَاعْبُدُونِ",
  },
  {
    id: "2509",
    sura: "21",
    VerseIDAr: "26",
    ayatAR:
      "وَقَالُوا اتَّخَذَ الرَّحْمَٰنُ وَلَدًا ۗ سُبْحَانَهُ ۚ بَلْ عِبَادٌ مُكْرَمُونَ",
  },
  {
    id: "2510",
    sura: "21",
    VerseIDAr: "27",
    ayatAR: "لَا يَسْبِقُونَهُ بِالْقَوْلِ وَهُمْ بِأَمْرِهِ يَعْمَلُونَ",
  },
  {
    id: "2511",
    sura: "21",
    VerseIDAr: "28",
    ayatAR:
      "يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلَا يَشْفَعُونَ إِلَّا لِمَنِ ارْتَضَىٰ وَهُمْ مِنْ خَشْيَتِهِ مُشْفِقُونَ",
  },
  {
    id: "2512",
    sura: "21",
    VerseIDAr: "29",
    ayatAR:
      "وَمَنْ يَقُلْ مِنْهُمْ إِنِّي إِلَٰهٌ مِنْ دُونِهِ فَذَٰلِكَ نَجْزِيهِ جَهَنَّمَ ۚ كَذَٰلِكَ نَجْزِي الظَّالِمِينَ",
  },
  {
    id: "2513",
    sura: "21",
    VerseIDAr: "30",
    ayatAR:
      "أَوَلَمْ يَرَ الَّذِينَ كَفَرُوا أَنَّ السَّمَاوَاتِ وَالْأَرْضَ كَانَتَا رَتْقًا فَفَتَقْنَاهُمَا ۖ وَجَعَلْنَا مِنَ الْمَاءِ كُلَّ شَيْءٍ حَيٍّ ۖ أَفَلَا يُؤْمِنُونَ",
  },
  {
    id: "2514",
    sura: "21",
    VerseIDAr: "31",
    ayatAR:
      "وَجَعَلْنَا فِي الْأَرْضِ رَوَاسِيَ أَنْ تَمِيدَ بِهِمْ وَجَعَلْنَا فِيهَا فِجَاجًا سُبُلًا لَعَلَّهُمْ يَهْتَدُونَ",
  },
  {
    id: "2515",
    sura: "21",
    VerseIDAr: "32",
    ayatAR:
      "وَجَعَلْنَا السَّمَاءَ سَقْفًا مَحْفُوظًا ۖ وَهُمْ عَنْ آيَاتِهَا مُعْرِضُونَ",
  },
  {
    id: "2516",
    sura: "21",
    VerseIDAr: "33",
    ayatAR:
      "وَهُوَ الَّذِي خَلَقَ اللَّيْلَ وَالنَّهَارَ وَالشَّمْسَ وَالْقَمَرَ ۖ كُلٌّ فِي فَلَكٍ يَسْبَحُونَ",
  },
  {
    id: "2517",
    sura: "21",
    VerseIDAr: "34",
    ayatAR:
      "وَمَا جَعَلْنَا لِبَشَرٍ مِنْ قَبْلِكَ الْخُلْدَ ۖ أَفَإِنْ مِتَّ فَهُمُ الْخَالِدُونَ",
  },
  {
    id: "2518",
    sura: "21",
    VerseIDAr: "35",
    ayatAR:
      "كُلُّ نَفْسٍ ذَائِقَةُ الْمَوْتِ ۗ وَنَبْلُوكُمْ بِالشَّرِّ وَالْخَيْرِ فِتْنَةً ۖ وَإِلَيْنَا تُرْجَعُونَ",
  },
  {
    id: "2519",
    sura: "21",
    VerseIDAr: "36",
    ayatAR:
      "وَإِذَا رَآكَ الَّذِينَ كَفَرُوا إِنْ يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا الَّذِي يَذْكُرُ آلِهَتَكُمْ وَهُمْ بِذِكْرِ الرَّحْمَٰنِ هُمْ كَافِرُونَ",
  },
  {
    id: "2520",
    sura: "21",
    VerseIDAr: "37",
    ayatAR:
      "خُلِقَ الْإِنْسَانُ مِنْ عَجَلٍ ۚ سَأُرِيكُمْ آيَاتِي فَلَا تَسْتَعْجِلُونِ",
  },
  {
    id: "2521",
    sura: "21",
    VerseIDAr: "38",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "2522",
    sura: "21",
    VerseIDAr: "39",
    ayatAR:
      "لَوْ يَعْلَمُ الَّذِينَ كَفَرُوا حِينَ لَا يَكُفُّونَ عَنْ وُجُوهِهِمُ النَّارَ وَلَا عَنْ ظُهُورِهِمْ وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "2523",
    sura: "21",
    VerseIDAr: "40",
    ayatAR:
      "بَلْ تَأْتِيهِمْ بَغْتَةً فَتَبْهَتُهُمْ فَلَا يَسْتَطِيعُونَ رَدَّهَا وَلَا هُمْ يُنْظَرُونَ",
  },
  {
    id: "2524",
    sura: "21",
    VerseIDAr: "41",
    ayatAR:
      "وَلَقَدِ اسْتُهْزِئَ بِرُسُلٍ مِنْ قَبْلِكَ فَحَاقَ بِالَّذِينَ سَخِرُوا مِنْهُمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "2525",
    sura: "21",
    VerseIDAr: "42",
    ayatAR:
      "قُلْ مَنْ يَكْلَؤُكُمْ بِاللَّيْلِ وَالنَّهَارِ مِنَ الرَّحْمَٰنِ ۗ بَلْ هُمْ عَنْ ذِكْرِ رَبِّهِمْ مُعْرِضُونَ",
  },
  {
    id: "2526",
    sura: "21",
    VerseIDAr: "43",
    ayatAR:
      "أَمْ لَهُمْ آلِهَةٌ تَمْنَعُهُمْ مِنْ دُونِنَا ۚ لَا يَسْتَطِيعُونَ نَصْرَ أَنْفُسِهِمْ وَلَا هُمْ مِنَّا يُصْحَبُونَ",
  },
  {
    id: "2527",
    sura: "21",
    VerseIDAr: "44",
    ayatAR:
      "بَلْ مَتَّعْنَا هَٰؤُلَاءِ وَآبَاءَهُمْ حَتَّىٰ طَالَ عَلَيْهِمُ الْعُمُرُ ۗ أَفَلَا يَرَوْنَ أَنَّا نَأْتِي الْأَرْضَ نَنْقُصُهَا مِنْ أَطْرَافِهَا ۚ أَفَهُمُ الْغَالِبُونَ",
  },
  {
    id: "2528",
    sura: "21",
    VerseIDAr: "45",
    ayatAR:
      "قُلْ إِنَّمَا أُنْذِرُكُمْ بِالْوَحْيِ ۚ وَلَا يَسْمَعُ الصُّمُّ الدُّعَاءَ إِذَا مَا يُنْذَرُونَ",
  },
  {
    id: "2529",
    sura: "21",
    VerseIDAr: "46",
    ayatAR:
      "وَلَئِنْ مَسَّتْهُمْ نَفْحَةٌ مِنْ عَذَابِ رَبِّكَ لَيَقُولُنَّ يَا وَيْلَنَا إِنَّا كُنَّا ظَالِمِينَ",
  },
  {
    id: "2530",
    sura: "21",
    VerseIDAr: "47",
    ayatAR:
      "وَنَضَعُ الْمَوَازِينَ الْقِسْطَ لِيَوْمِ الْقِيَامَةِ فَلَا تُظْلَمُ نَفْسٌ شَيْئًا ۖ وَإِنْ كَانَ مِثْقَالَ حَبَّةٍ مِنْ خَرْدَلٍ أَتَيْنَا بِهَا ۗ وَكَفَىٰ بِنَا حَاسِبِينَ",
  },
  {
    id: "2531",
    sura: "21",
    VerseIDAr: "48",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَىٰ وَهَارُونَ الْفُرْقَانَ وَضِيَاءً وَذِكْرًا لِلْمُتَّقِينَ",
  },
  {
    id: "2532",
    sura: "21",
    VerseIDAr: "49",
    ayatAR:
      "الَّذِينَ يَخْشَوْنَ رَبَّهُمْ بِالْغَيْبِ وَهُمْ مِنَ السَّاعَةِ مُشْفِقُونَ",
  },
  {
    id: "2533",
    sura: "21",
    VerseIDAr: "50",
    ayatAR:
      "وَهَٰذَا ذِكْرٌ مُبَارَكٌ أَنْزَلْنَاهُ ۚ أَفَأَنْتُمْ لَهُ مُنْكِرُونَ",
  },
  {
    id: "2534",
    sura: "21",
    VerseIDAr: "51",
    ayatAR:
      "وَلَقَدْ آتَيْنَا إِبْرَاهِيمَ رُشْدَهُ مِنْ قَبْلُ وَكُنَّا بِهِ عَالِمِينَ",
  },
  {
    id: "2535",
    sura: "21",
    VerseIDAr: "52",
    ayatAR:
      "إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِ مَا هَٰذِهِ التَّمَاثِيلُ الَّتِي أَنْتُمْ لَهَا عَاكِفُونَ",
  },
  {
    id: "2536",
    sura: "21",
    VerseIDAr: "53",
    ayatAR: "قَالُوا وَجَدْنَا آبَاءَنَا لَهَا عَابِدِينَ",
  },
  {
    id: "2537",
    sura: "21",
    VerseIDAr: "54",
    ayatAR: "قَالَ لَقَدْ كُنْتُمْ أَنْتُمْ وَآبَاؤُكُمْ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "2538",
    sura: "21",
    VerseIDAr: "55",
    ayatAR: "قَالُوا أَجِئْتَنَا بِالْحَقِّ أَمْ أَنْتَ مِنَ اللَّاعِبِينَ",
  },
  {
    id: "2539",
    sura: "21",
    VerseIDAr: "56",
    ayatAR:
      "قَالَ بَلْ رَبُّكُمْ رَبُّ السَّمَاوَاتِ وَالْأَرْضِ الَّذِي فَطَرَهُنَّ وَأَنَا عَلَىٰ ذَٰلِكُمْ مِنَ الشَّاهِدِينَ",
  },
  {
    id: "2540",
    sura: "21",
    VerseIDAr: "57",
    ayatAR:
      "وَتَاللَّهِ لَأَكِيدَنَّ أَصْنَامَكُمْ بَعْدَ أَنْ تُوَلُّوا مُدْبِرِينَ",
  },
  {
    id: "2541",
    sura: "21",
    VerseIDAr: "58",
    ayatAR:
      "فَجَعَلَهُمْ جُذَاذًا إِلَّا كَبِيرًا لَهُمْ لَعَلَّهُمْ إِلَيْهِ يَرْجِعُونَ",
  },
  {
    id: "2542",
    sura: "21",
    VerseIDAr: "59",
    ayatAR:
      "قَالُوا مَنْ فَعَلَ هَٰذَا بِآلِهَتِنَا إِنَّهُ لَمِنَ الظَّالِمِينَ",
  },
  {
    id: "2543",
    sura: "21",
    VerseIDAr: "60",
    ayatAR: "قَالُوا سَمِعْنَا فَتًى يَذْكُرُهُمْ يُقَالُ لَهُ إِبْرَاهِيمُ",
  },
  {
    id: "2544",
    sura: "21",
    VerseIDAr: "61",
    ayatAR:
      "قَالُوا فَأْتُوا بِهِ عَلَىٰ أَعْيُنِ النَّاسِ لَعَلَّهُمْ يَشْهَدُونَ",
  },
  {
    id: "2545",
    sura: "21",
    VerseIDAr: "62",
    ayatAR: "قَالُوا أَأَنْتَ فَعَلْتَ هَٰذَا بِآلِهَتِنَا يَا إِبْرَاهِيمُ",
  },
  {
    id: "2546",
    sura: "21",
    VerseIDAr: "63",
    ayatAR:
      "قَالَ بَلْ فَعَلَهُ كَبِيرُهُمْ هَٰذَا فَاسْأَلُوهُمْ إِنْ كَانُوا يَنْطِقُونَ",
  },
  {
    id: "2547",
    sura: "21",
    VerseIDAr: "64",
    ayatAR:
      "فَرَجَعُوا إِلَىٰ أَنْفُسِهِمْ فَقَالُوا إِنَّكُمْ أَنْتُمُ الظَّالِمُونَ",
  },
  {
    id: "2548",
    sura: "21",
    VerseIDAr: "65",
    ayatAR:
      "ثُمَّ نُكِسُوا عَلَىٰ رُءُوسِهِمْ لَقَدْ عَلِمْتَ مَا هَٰؤُلَاءِ يَنْطِقُونَ",
  },
  {
    id: "2549",
    sura: "21",
    VerseIDAr: "66",
    ayatAR:
      "قَالَ أَفَتَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَا يَنْفَعُكُمْ شَيْئًا وَلَا يَضُرُّكُمْ",
  },
  {
    id: "2550",
    sura: "21",
    VerseIDAr: "67",
    ayatAR:
      "أُفٍّ لَكُمْ وَلِمَا تَعْبُدُونَ مِنْ دُونِ اللَّهِ ۖ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "2551",
    sura: "21",
    VerseIDAr: "68",
    ayatAR:
      "قَالُوا حَرِّقُوهُ وَانْصُرُوا آلِهَتَكُمْ إِنْ كُنْتُمْ فَاعِلِينَ",
  },
  {
    id: "2552",
    sura: "21",
    VerseIDAr: "69",
    ayatAR: "قُلْنَا يَا نَارُ كُونِي بَرْدًا وَسَلَامًا عَلَىٰ إِبْرَاهِيمَ",
  },
  {
    id: "2553",
    sura: "21",
    VerseIDAr: "70",
    ayatAR: "وَأَرَادُوا بِهِ كَيْدًا فَجَعَلْنَاهُمُ الْأَخْسَرِينَ",
  },
  {
    id: "2554",
    sura: "21",
    VerseIDAr: "71",
    ayatAR:
      "وَنَجَّيْنَاهُ وَلُوطًا إِلَى الْأَرْضِ الَّتِي بَارَكْنَا فِيهَا لِلْعَالَمِينَ",
  },
  {
    id: "2555",
    sura: "21",
    VerseIDAr: "72",
    ayatAR:
      "وَوَهَبْنَا لَهُ إِسْحَاقَ وَيَعْقُوبَ نَافِلَةً ۖ وَكُلًّا جَعَلْنَا صَالِحِينَ",
  },
  {
    id: "2556",
    sura: "21",
    VerseIDAr: "73",
    ayatAR:
      "وَجَعَلْنَاهُمْ أَئِمَّةً يَهْدُونَ بِأَمْرِنَا وَأَوْحَيْنَا إِلَيْهِمْ فِعْلَ الْخَيْرَاتِ وَإِقَامَ الصَّلَاةِ وَإِيتَاءَ الزَّكَاةِ ۖ وَكَانُوا لَنَا عَابِدِينَ",
  },
  {
    id: "2557",
    sura: "21",
    VerseIDAr: "74",
    ayatAR:
      "وَلُوطًا آتَيْنَاهُ حُكْمًا وَعِلْمًا وَنَجَّيْنَاهُ مِنَ الْقَرْيَةِ الَّتِي كَانَتْ تَعْمَلُ الْخَبَائِثَ ۗ إِنَّهُمْ كَانُوا قَوْمَ سَوْءٍ فَاسِقِينَ",
  },
  {
    id: "2558",
    sura: "21",
    VerseIDAr: "75",
    ayatAR: "وَأَدْخَلْنَاهُ فِي رَحْمَتِنَا ۖ إِنَّهُ مِنَ الصَّالِحِينَ",
  },
  {
    id: "2559",
    sura: "21",
    VerseIDAr: "76",
    ayatAR:
      "وَنُوحًا إِذْ نَادَىٰ مِنْ قَبْلُ فَاسْتَجَبْنَا لَهُ فَنَجَّيْنَاهُ وَأَهْلَهُ مِنَ الْكَرْبِ الْعَظِيمِ",
  },
  {
    id: "2560",
    sura: "21",
    VerseIDAr: "77",
    ayatAR:
      "وَنَصَرْنَاهُ مِنَ الْقَوْمِ الَّذِينَ كَذَّبُوا بِآيَاتِنَا ۚ إِنَّهُمْ كَانُوا قَوْمَ سَوْءٍ فَأَغْرَقْنَاهُمْ أَجْمَعِينَ",
  },
  {
    id: "2561",
    sura: "21",
    VerseIDAr: "78",
    ayatAR:
      "وَدَاوُودَ وَسُلَيْمَانَ إِذْ يَحْكُمَانِ فِي الْحَرْثِ إِذْ نَفَشَتْ فِيهِ غَنَمُ الْقَوْمِ وَكُنَّا لِحُكْمِهِمْ شَاهِدِينَ",
  },
  {
    id: "2562",
    sura: "21",
    VerseIDAr: "79",
    ayatAR:
      "فَفَهَّمْنَاهَا سُلَيْمَانَ ۚ وَكُلًّا آتَيْنَا حُكْمًا وَعِلْمًا ۚ وَسَخَّرْنَا مَعَ دَاوُودَ الْجِبَالَ يُسَبِّحْنَ وَالطَّيْرَ ۚ وَكُنَّا فَاعِلِينَ",
  },
  {
    id: "2563",
    sura: "21",
    VerseIDAr: "80",
    ayatAR:
      "وَعَلَّمْنَاهُ صَنْعَةَ لَبُوسٍ لَكُمْ لِتُحْصِنَكُمْ مِنْ بَأْسِكُمْ ۖ فَهَلْ أَنْتُمْ شَاكِرُونَ",
  },
  {
    id: "2564",
    sura: "21",
    VerseIDAr: "81",
    ayatAR:
      "وَلِسُلَيْمَانَ الرِّيحَ عَاصِفَةً تَجْرِي بِأَمْرِهِ إِلَى الْأَرْضِ الَّتِي بَارَكْنَا فِيهَا ۚ وَكُنَّا بِكُلِّ شَيْءٍ عَالِمِينَ",
  },
  {
    id: "2565",
    sura: "21",
    VerseIDAr: "82",
    ayatAR:
      "وَمِنَ الشَّيَاطِينِ مَنْ يَغُوصُونَ لَهُ وَيَعْمَلُونَ عَمَلًا دُونَ ذَٰلِكَ ۖ وَكُنَّا لَهُمْ حَافِظِينَ",
  },
  {
    id: "2566",
    sura: "21",
    VerseIDAr: "83",
    ayatAR:
      "وَأَيُّوبَ إِذْ نَادَىٰ رَبَّهُ أَنِّي مَسَّنِيَ الضُّرُّ وَأَنْتَ أَرْحَمُ الرَّاحِمِينَ",
  },
  {
    id: "2567",
    sura: "21",
    VerseIDAr: "84",
    ayatAR:
      "فَاسْتَجَبْنَا لَهُ فَكَشَفْنَا مَا بِهِ مِنْ ضُرٍّ ۖ وَآتَيْنَاهُ أَهْلَهُ وَمِثْلَهُمْ مَعَهُمْ رَحْمَةً مِنْ عِنْدِنَا وَذِكْرَىٰ لِلْعَابِدِينَ",
  },
  {
    id: "2568",
    sura: "21",
    VerseIDAr: "85",
    ayatAR:
      "وَإِسْمَاعِيلَ وَإِدْرِيسَ وَذَا الْكِفْلِ ۖ كُلٌّ مِنَ الصَّابِرِينَ",
  },
  {
    id: "2569",
    sura: "21",
    VerseIDAr: "86",
    ayatAR: "وَأَدْخَلْنَاهُمْ فِي رَحْمَتِنَا ۖ إِنَّهُمْ مِنَ الصَّالِحِينَ",
  },
  {
    id: "2570",
    sura: "21",
    VerseIDAr: "87",
    ayatAR:
      "وَذَا النُّونِ إِذْ ذَهَبَ مُغَاضِبًا فَظَنَّ أَنْ لَنْ نَقْدِرَ عَلَيْهِ فَنَادَىٰ فِي الظُّلُمَاتِ أَنْ لَا إِلَٰهَ إِلَّا أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ",
  },
  {
    id: "2571",
    sura: "21",
    VerseIDAr: "88",
    ayatAR:
      "فَاسْتَجَبْنَا لَهُ وَنَجَّيْنَاهُ مِنَ الْغَمِّ ۚ وَكَذَٰلِكَ نُنْجِي الْمُؤْمِنِينَ",
  },
  {
    id: "2572",
    sura: "21",
    VerseIDAr: "89",
    ayatAR:
      "وَزَكَرِيَّا إِذْ نَادَىٰ رَبَّهُ رَبِّ لَا تَذَرْنِي فَرْدًا وَأَنْتَ خَيْرُ الْوَارِثِينَ",
  },
  {
    id: "2573",
    sura: "21",
    VerseIDAr: "90",
    ayatAR:
      "فَاسْتَجَبْنَا لَهُ وَوَهَبْنَا لَهُ يَحْيَىٰ وَأَصْلَحْنَا لَهُ زَوْجَهُ ۚ إِنَّهُمْ كَانُوا يُسَارِعُونَ فِي الْخَيْرَاتِ وَيَدْعُونَنَا رَغَبًا وَرَهَبًا ۖ وَكَانُوا لَنَا خَاشِعِينَ",
  },
  {
    id: "2574",
    sura: "21",
    VerseIDAr: "91",
    ayatAR:
      "وَالَّتِي أَحْصَنَتْ فَرْجَهَا فَنَفَخْنَا فِيهَا مِنْ رُوحِنَا وَجَعَلْنَاهَا وَابْنَهَا آيَةً لِلْعَالَمِينَ",
  },
  {
    id: "2575",
    sura: "21",
    VerseIDAr: "92",
    ayatAR:
      "إِنَّ هَٰذِهِ أُمَّتُكُمْ أُمَّةً وَاحِدَةً وَأَنَا رَبُّكُمْ فَاعْبُدُونِ",
  },
  {
    id: "2576",
    sura: "21",
    VerseIDAr: "93",
    ayatAR: "وَتَقَطَّعُوا أَمْرَهُمْ بَيْنَهُمْ ۖ كُلٌّ إِلَيْنَا رَاجِعُونَ",
  },
  {
    id: "2577",
    sura: "21",
    VerseIDAr: "94",
    ayatAR:
      "فَمَنْ يَعْمَلْ مِنَ الصَّالِحَاتِ وَهُوَ مُؤْمِنٌ فَلَا كُفْرَانَ لِسَعْيِهِ وَإِنَّا لَهُ كَاتِبُونَ",
  },
  {
    id: "2578",
    sura: "21",
    VerseIDAr: "95",
    ayatAR:
      "وَحَرَامٌ عَلَىٰ قَرْيَةٍ أَهْلَكْنَاهَا أَنَّهُمْ لَا يَرْجِعُونَ",
  },
  {
    id: "2579",
    sura: "21",
    VerseIDAr: "96",
    ayatAR:
      "حَتَّىٰ إِذَا فُتِحَتْ يَأْجُوجُ وَمَأْجُوجُ وَهُمْ مِنْ كُلِّ حَدَبٍ يَنْسِلُونَ",
  },
  {
    id: "2580",
    sura: "21",
    VerseIDAr: "97",
    ayatAR:
      "وَاقْتَرَبَ الْوَعْدُ الْحَقُّ فَإِذَا هِيَ شَاخِصَةٌ أَبْصَارُ الَّذِينَ كَفَرُوا يَا وَيْلَنَا قَدْ كُنَّا فِي غَفْلَةٍ مِنْ هَٰذَا بَلْ كُنَّا ظَالِمِينَ",
  },
  {
    id: "2581",
    sura: "21",
    VerseIDAr: "98",
    ayatAR:
      "إِنَّكُمْ وَمَا تَعْبُدُونَ مِنْ دُونِ اللَّهِ حَصَبُ جَهَنَّمَ أَنْتُمْ لَهَا وَارِدُونَ",
  },
  {
    id: "2582",
    sura: "21",
    VerseIDAr: "99",
    ayatAR:
      "لَوْ كَانَ هَٰؤُلَاءِ آلِهَةً مَا وَرَدُوهَا ۖ وَكُلٌّ فِيهَا خَالِدُونَ",
  },
  {
    id: "2583",
    sura: "21",
    VerseIDAr: "100",
    ayatAR: "لَهُمْ فِيهَا زَفِيرٌ وَهُمْ فِيهَا لَا يَسْمَعُونَ",
  },
  {
    id: "2584",
    sura: "21",
    VerseIDAr: "101",
    ayatAR:
      "إِنَّ الَّذِينَ سَبَقَتْ لَهُمْ مِنَّا الْحُسْنَىٰ أُولَٰئِكَ عَنْهَا مُبْعَدُونَ",
  },
  {
    id: "2585",
    sura: "21",
    VerseIDAr: "102",
    ayatAR:
      "لَا يَسْمَعُونَ حَسِيسَهَا ۖ وَهُمْ فِي مَا اشْتَهَتْ أَنْفُسُهُمْ خَالِدُونَ",
  },
  {
    id: "2586",
    sura: "21",
    VerseIDAr: "103",
    ayatAR:
      "لَا يَحْزُنُهُمُ الْفَزَعُ الْأَكْبَرُ وَتَتَلَقَّاهُمُ الْمَلَائِكَةُ هَٰذَا يَوْمُكُمُ الَّذِي كُنْتُمْ تُوعَدُونَ",
  },
  {
    id: "2587",
    sura: "21",
    VerseIDAr: "104",
    ayatAR:
      "يَوْمَ نَطْوِي السَّمَاءَ كَطَيِّ السِّجِلِّ لِلْكُتُبِ ۚ كَمَا بَدَأْنَا أَوَّلَ خَلْقٍ نُعِيدُهُ ۚ وَعْدًا عَلَيْنَا ۚ إِنَّا كُنَّا فَاعِلِينَ",
  },
  {
    id: "2588",
    sura: "21",
    VerseIDAr: "105",
    ayatAR:
      "وَلَقَدْ كَتَبْنَا فِي الزَّبُورِ مِنْ بَعْدِ الذِّكْرِ أَنَّ الْأَرْضَ يَرِثُهَا عِبَادِيَ الصَّالِحُونَ",
  },
  {
    id: "2589",
    sura: "21",
    VerseIDAr: "106",
    ayatAR: "إِنَّ فِي هَٰذَا لَبَلَاغًا لِقَوْمٍ عَابِدِينَ",
  },
  {
    id: "2590",
    sura: "21",
    VerseIDAr: "107",
    ayatAR: "وَمَا أَرْسَلْنَاكَ إِلَّا رَحْمَةً لِلْعَالَمِينَ",
  },
  {
    id: "2591",
    sura: "21",
    VerseIDAr: "108",
    ayatAR:
      "قُلْ إِنَّمَا يُوحَىٰ إِلَيَّ أَنَّمَا إِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ ۖ فَهَلْ أَنْتُمْ مُسْلِمُونَ",
  },
  {
    id: "2592",
    sura: "21",
    VerseIDAr: "109",
    ayatAR:
      "فَإِنْ تَوَلَّوْا فَقُلْ آذَنْتُكُمْ عَلَىٰ سَوَاءٍ ۖ وَإِنْ أَدْرِي أَقَرِيبٌ أَمْ بَعِيدٌ مَا تُوعَدُونَ",
  },
  {
    id: "2593",
    sura: "21",
    VerseIDAr: "110",
    ayatAR:
      "إِنَّهُ يَعْلَمُ الْجَهْرَ مِنَ الْقَوْلِ وَيَعْلَمُ مَا تَكْتُمُونَ",
  },
  {
    id: "2594",
    sura: "21",
    VerseIDAr: "111",
    ayatAR: "وَإِنْ أَدْرِي لَعَلَّهُ فِتْنَةٌ لَكُمْ وَمَتَاعٌ إِلَىٰ حِينٍ",
  },
  {
    id: "2595",
    sura: "21",
    VerseIDAr: "112",
    ayatAR:
      "قَالَ رَبِّ احْكُمْ بِالْحَقِّ ۗ وَرَبُّنَا الرَّحْمَٰنُ الْمُسْتَعَانُ عَلَىٰ مَا تَصِفُونَ",
  },
  {
    id: "2596",
    sura: "22",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا النَّاسُ اتَّقُوا رَبَّكُمْ ۚ إِنَّ زَلْزَلَةَ السَّاعَةِ شَيْءٌ عَظِيمٌ",
  },
  {
    id: "2597",
    sura: "22",
    VerseIDAr: "2",
    ayatAR:
      "يَوْمَ تَرَوْنَهَا تَذْهَلُ كُلُّ مُرْضِعَةٍ عَمَّا أَرْضَعَتْ وَتَضَعُ كُلُّ ذَاتِ حَمْلٍ حَمْلَهَا وَتَرَى النَّاسَ سُكَارَىٰ وَمَا هُمْ بِسُكَارَىٰ وَلَٰكِنَّ عَذَابَ اللَّهِ شَدِيدٌ",
  },
  {
    id: "2598",
    sura: "22",
    VerseIDAr: "3",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يُجَادِلُ فِي اللَّهِ بِغَيْرِ عِلْمٍ وَيَتَّبِعُ كُلَّ شَيْطَانٍ مَرِيدٍ",
  },
  {
    id: "2599",
    sura: "22",
    VerseIDAr: "4",
    ayatAR:
      "كُتِبَ عَلَيْهِ أَنَّهُ مَنْ تَوَلَّاهُ فَأَنَّهُ يُضِلُّهُ وَيَهْدِيهِ إِلَىٰ عَذَابِ السَّعِيرِ",
  },
  {
    id: "2600",
    sura: "22",
    VerseIDAr: "5",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ إِنْ كُنْتُمْ فِي رَيْبٍ مِنَ الْبَعْثِ فَإِنَّا خَلَقْنَاكُمْ مِنْ تُرَابٍ ثُمَّ مِنْ نُطْفَةٍ ثُمَّ مِنْ عَلَقَةٍ ثُمَّ مِنْ مُضْغَةٍ مُخَلَّقَةٍ وَغَيْرِ مُخَلَّقَةٍ لِنُبَيِّنَ لَكُمْ ۚ وَنُقِرُّ فِي الْأَرْحَامِ مَا نَشَاءُ إِلَىٰ أَجَلٍ مُسَمًّى ثُمَّ نُخْرِجُكُمْ طِفْلًا ثُمَّ لِتَبْلُغُوا أَشُدَّكُمْ ۖ وَمِنْكُمْ مَنْ يُتَوَفَّىٰ وَمِنْكُمْ مَنْ يُرَدُّ إِلَىٰ أَرْذَلِ الْعُمُرِ لِكَيْلَا يَعْلَمَ مِنْ بَعْدِ عِلْمٍ شَيْئًا ۚ وَتَرَى الْأَرْضَ هَامِدَةً فَإِذَا أَنْزَلْنَا عَلَيْهَا الْمَاءَ اهْتَزَّتْ وَرَبَتْ وَأَنْبَتَتْ مِنْ كُلِّ زَوْجٍ بَهِيجٍ",
  },
  {
    id: "2601",
    sura: "22",
    VerseIDAr: "6",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ هُوَ الْحَقُّ وَأَنَّهُ يُحْيِي الْمَوْتَىٰ وَأَنَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "2602",
    sura: "22",
    VerseIDAr: "7",
    ayatAR:
      "وَأَنَّ السَّاعَةَ آتِيَةٌ لَا رَيْبَ فِيهَا وَأَنَّ اللَّهَ يَبْعَثُ مَنْ فِي الْقُبُورِ",
  },
  {
    id: "2603",
    sura: "22",
    VerseIDAr: "8",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يُجَادِلُ فِي اللَّهِ بِغَيْرِ عِلْمٍ وَلَا هُدًى وَلَا كِتَابٍ مُنِيرٍ",
  },
  {
    id: "2604",
    sura: "22",
    VerseIDAr: "9",
    ayatAR:
      "ثَانِيَ عِطْفِهِ لِيُضِلَّ عَنْ سَبِيلِ اللَّهِ ۖ لَهُ فِي الدُّنْيَا خِزْيٌ ۖ وَنُذِيقُهُ يَوْمَ الْقِيَامَةِ عَذَابَ الْحَرِيقِ",
  },
  {
    id: "2605",
    sura: "22",
    VerseIDAr: "10",
    ayatAR:
      "ذَٰلِكَ بِمَا قَدَّمَتْ يَدَاكَ وَأَنَّ اللَّهَ لَيْسَ بِظَلَّامٍ لِلْعَبِيدِ",
  },
  {
    id: "2606",
    sura: "22",
    VerseIDAr: "11",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَعْبُدُ اللَّهَ عَلَىٰ حَرْفٍ ۖ فَإِنْ أَصَابَهُ خَيْرٌ اطْمَأَنَّ بِهِ ۖ وَإِنْ أَصَابَتْهُ فِتْنَةٌ انْقَلَبَ عَلَىٰ وَجْهِهِ خَسِرَ الدُّنْيَا وَالْآخِرَةَ ۚ ذَٰلِكَ هُوَ الْخُسْرَانُ الْمُبِينُ",
  },
  {
    id: "2607",
    sura: "22",
    VerseIDAr: "12",
    ayatAR:
      "يَدْعُو مِنْ دُونِ اللَّهِ مَا لَا يَضُرُّهُ وَمَا لَا يَنْفَعُهُ ۚ ذَٰلِكَ هُوَ الضَّلَالُ الْبَعِيدُ",
  },
  {
    id: "2608",
    sura: "22",
    VerseIDAr: "13",
    ayatAR:
      "يَدْعُو لَمَنْ ضَرُّهُ أَقْرَبُ مِنْ نَفْعِهِ ۚ لَبِئْسَ الْمَوْلَىٰ وَلَبِئْسَ الْعَشِيرُ",
  },
  {
    id: "2609",
    sura: "22",
    VerseIDAr: "14",
    ayatAR:
      "إِنَّ اللَّهَ يُدْخِلُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۚ إِنَّ اللَّهَ يَفْعَلُ مَا يُرِيدُ",
  },
  {
    id: "2610",
    sura: "22",
    VerseIDAr: "15",
    ayatAR:
      "مَنْ كَانَ يَظُنُّ أَنْ لَنْ يَنْصُرَهُ اللَّهُ فِي الدُّنْيَا وَالْآخِرَةِ فَلْيَمْدُدْ بِسَبَبٍ إِلَى السَّمَاءِ ثُمَّ لْيَقْطَعْ فَلْيَنْظُرْ هَلْ يُذْهِبَنَّ كَيْدُهُ مَا يَغِيظُ",
  },
  {
    id: "2611",
    sura: "22",
    VerseIDAr: "16",
    ayatAR:
      "وَكَذَٰلِكَ أَنْزَلْنَاهُ آيَاتٍ بَيِّنَاتٍ وَأَنَّ اللَّهَ يَهْدِي مَنْ يُرِيدُ",
  },
  {
    id: "2612",
    sura: "22",
    VerseIDAr: "17",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَالَّذِينَ هَادُوا وَالصَّابِئِينَ وَالنَّصَارَىٰ وَالْمَجُوسَ وَالَّذِينَ أَشْرَكُوا إِنَّ اللَّهَ يَفْصِلُ بَيْنَهُمْ يَوْمَ الْقِيَامَةِ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "2613",
    sura: "22",
    VerseIDAr: "18",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ يَسْجُدُ لَهُ مَنْ فِي السَّمَاوَاتِ وَمَنْ فِي الْأَرْضِ وَالشَّمْسُ وَالْقَمَرُ وَالنُّجُومُ وَالْجِبَالُ وَالشَّجَرُ وَالدَّوَابُّ وَكَثِيرٌ مِنَ النَّاسِ ۖ وَكَثِيرٌ حَقَّ عَلَيْهِ الْعَذَابُ ۗ وَمَنْ يُهِنِ اللَّهُ فَمَا لَهُ مِنْ مُكْرِمٍ ۚ إِنَّ اللَّهَ يَفْعَلُ مَا يَشَاءُ ۩",
  },
  {
    id: "2614",
    sura: "22",
    VerseIDAr: "19",
    ayatAR:
      "هَٰذَانِ خَصْمَانِ اخْتَصَمُوا فِي رَبِّهِمْ ۖ فَالَّذِينَ كَفَرُوا قُطِّعَتْ لَهُمْ ثِيَابٌ مِنْ نَارٍ يُصَبُّ مِنْ فَوْقِ رُءُوسِهِمُ الْحَمِيمُ",
  },
  {
    id: "2615",
    sura: "22",
    VerseIDAr: "20",
    ayatAR: "يُصْهَرُ بِهِ مَا فِي بُطُونِهِمْ وَالْجُلُودُ",
  },
  {
    id: "2616",
    sura: "22",
    VerseIDAr: "21",
    ayatAR: "وَلَهُمْ مَقَامِعُ مِنْ حَدِيدٍ",
  },
  {
    id: "2617",
    sura: "22",
    VerseIDAr: "22",
    ayatAR:
      "كُلَّمَا أَرَادُوا أَنْ يَخْرُجُوا مِنْهَا مِنْ غَمٍّ أُعِيدُوا فِيهَا وَذُوقُوا عَذَابَ الْحَرِيقِ",
  },
  {
    id: "2618",
    sura: "22",
    VerseIDAr: "23",
    ayatAR:
      "إِنَّ اللَّهَ يُدْخِلُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِنْ ذَهَبٍ وَلُؤْلُؤًا ۖ وَلِبَاسُهُمْ فِيهَا حَرِيرٌ",
  },
  {
    id: "2619",
    sura: "22",
    VerseIDAr: "24",
    ayatAR:
      "وَهُدُوا إِلَى الطَّيِّبِ مِنَ الْقَوْلِ وَهُدُوا إِلَىٰ صِرَاطِ الْحَمِيدِ",
  },
  {
    id: "2620",
    sura: "22",
    VerseIDAr: "25",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَيَصُدُّونَ عَنْ سَبِيلِ اللَّهِ وَالْمَسْجِدِ الْحَرَامِ الَّذِي جَعَلْنَاهُ لِلنَّاسِ سَوَاءً الْعَاكِفُ فِيهِ وَالْبَادِ ۚ وَمَنْ يُرِدْ فِيهِ بِإِلْحَادٍ بِظُلْمٍ نُذِقْهُ مِنْ عَذَابٍ أَلِيمٍ",
  },
  {
    id: "2621",
    sura: "22",
    VerseIDAr: "26",
    ayatAR:
      "وَإِذْ بَوَّأْنَا لِإِبْرَاهِيمَ مَكَانَ الْبَيْتِ أَنْ لَا تُشْرِكْ بِي شَيْئًا وَطَهِّرْ بَيْتِيَ لِلطَّائِفِينَ وَالْقَائِمِينَ وَالرُّكَّعِ السُّجُودِ",
  },
  {
    id: "2622",
    sura: "22",
    VerseIDAr: "27",
    ayatAR:
      "وَأَذِّنْ فِي النَّاسِ بِالْحَجِّ يَأْتُوكَ رِجَالًا وَعَلَىٰ كُلِّ ضَامِرٍ يَأْتِينَ مِنْ كُلِّ فَجٍّ عَمِيقٍ",
  },
  {
    id: "2623",
    sura: "22",
    VerseIDAr: "28",
    ayatAR:
      "لِيَشْهَدُوا مَنَافِعَ لَهُمْ وَيَذْكُرُوا اسْمَ اللَّهِ فِي أَيَّامٍ مَعْلُومَاتٍ عَلَىٰ مَا رَزَقَهُمْ مِنْ بَهِيمَةِ الْأَنْعَامِ ۖ فَكُلُوا مِنْهَا وَأَطْعِمُوا الْبَائِسَ الْفَقِيرَ",
  },
  {
    id: "2624",
    sura: "22",
    VerseIDAr: "29",
    ayatAR:
      "ثُمَّ لْيَقْضُوا تَفَثَهُمْ وَلْيُوفُوا نُذُورَهُمْ وَلْيَطَّوَّفُوا بِالْبَيْتِ الْعَتِيقِ",
  },
  {
    id: "2625",
    sura: "22",
    VerseIDAr: "30",
    ayatAR:
      "ذَٰلِكَ وَمَنْ يُعَظِّمْ حُرُمَاتِ اللَّهِ فَهُوَ خَيْرٌ لَهُ عِنْدَ رَبِّهِ ۗ وَأُحِلَّتْ لَكُمُ الْأَنْعَامُ إِلَّا مَا يُتْلَىٰ عَلَيْكُمْ ۖ فَاجْتَنِبُوا الرِّجْسَ مِنَ الْأَوْثَانِ وَاجْتَنِبُوا قَوْلَ الزُّورِ",
  },
  {
    id: "2626",
    sura: "22",
    VerseIDAr: "31",
    ayatAR:
      "حُنَفَاءَ لِلَّهِ غَيْرَ مُشْرِكِينَ بِهِ ۚ وَمَنْ يُشْرِكْ بِاللَّهِ فَكَأَنَّمَا خَرَّ مِنَ السَّمَاءِ فَتَخْطَفُهُ الطَّيْرُ أَوْ تَهْوِي بِهِ الرِّيحُ فِي مَكَانٍ سَحِيقٍ",
  },
  {
    id: "2627",
    sura: "22",
    VerseIDAr: "32",
    ayatAR:
      "ذَٰلِكَ وَمَنْ يُعَظِّمْ شَعَائِرَ اللَّهِ فَإِنَّهَا مِنْ تَقْوَى الْقُلُوبِ",
  },
  {
    id: "2628",
    sura: "22",
    VerseIDAr: "33",
    ayatAR:
      "لَكُمْ فِيهَا مَنَافِعُ إِلَىٰ أَجَلٍ مُسَمًّى ثُمَّ مَحِلُّهَا إِلَى الْبَيْتِ الْعَتِيقِ",
  },
  {
    id: "2629",
    sura: "22",
    VerseIDAr: "34",
    ayatAR:
      "وَلِكُلِّ أُمَّةٍ جَعَلْنَا مَنْسَكًا لِيَذْكُرُوا اسْمَ اللَّهِ عَلَىٰ مَا رَزَقَهُمْ مِنْ بَهِيمَةِ الْأَنْعَامِ ۗ فَإِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ فَلَهُ أَسْلِمُوا ۗ وَبَشِّرِ الْمُخْبِتِينَ",
  },
  {
    id: "2630",
    sura: "22",
    VerseIDAr: "35",
    ayatAR:
      "الَّذِينَ إِذَا ذُكِرَ اللَّهُ وَجِلَتْ قُلُوبُهُمْ وَالصَّابِرِينَ عَلَىٰ مَا أَصَابَهُمْ وَالْمُقِيمِي الصَّلَاةِ وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "2631",
    sura: "22",
    VerseIDAr: "36",
    ayatAR:
      "وَالْبُدْنَ جَعَلْنَاهَا لَكُمْ مِنْ شَعَائِرِ اللَّهِ لَكُمْ فِيهَا خَيْرٌ ۖ فَاذْكُرُوا اسْمَ اللَّهِ عَلَيْهَا صَوَافَّ ۖ فَإِذَا وَجَبَتْ جُنُوبُهَا فَكُلُوا مِنْهَا وَأَطْعِمُوا الْقَانِعَ وَالْمُعْتَرَّ ۚ كَذَٰلِكَ سَخَّرْنَاهَا لَكُمْ لَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "2632",
    sura: "22",
    VerseIDAr: "37",
    ayatAR:
      "لَنْ يَنَالَ اللَّهَ لُحُومُهَا وَلَا دِمَاؤُهَا وَلَٰكِنْ يَنَالُهُ التَّقْوَىٰ مِنْكُمْ ۚ كَذَٰلِكَ سَخَّرَهَا لَكُمْ لِتُكَبِّرُوا اللَّهَ عَلَىٰ مَا هَدَاكُمْ ۗ وَبَشِّرِ الْمُحْسِنِينَ",
  },
  {
    id: "2633",
    sura: "22",
    VerseIDAr: "38",
    ayatAR:
      "إِنَّ اللَّهَ يُدَافِعُ عَنِ الَّذِينَ آمَنُوا ۗ إِنَّ اللَّهَ لَا يُحِبُّ كُلَّ خَوَّانٍ كَفُورٍ",
  },
  {
    id: "2634",
    sura: "22",
    VerseIDAr: "39",
    ayatAR:
      "أُذِنَ لِلَّذِينَ يُقَاتَلُونَ بِأَنَّهُمْ ظُلِمُوا ۚ وَإِنَّ اللَّهَ عَلَىٰ نَصْرِهِمْ لَقَدِيرٌ",
  },
  {
    id: "2635",
    sura: "22",
    VerseIDAr: "40",
    ayatAR:
      "الَّذِينَ أُخْرِجُوا مِنْ دِيَارِهِمْ بِغَيْرِ حَقٍّ إِلَّا أَنْ يَقُولُوا رَبُّنَا اللَّهُ ۗ وَلَوْلَا دَفْعُ اللَّهِ النَّاسَ بَعْضَهُمْ بِبَعْضٍ لَهُدِّمَتْ صَوَامِعُ وَبِيَعٌ وَصَلَوَاتٌ وَمَسَاجِدُ يُذْكَرُ فِيهَا اسْمُ اللَّهِ كَثِيرًا ۗ وَلَيَنْصُرَنَّ اللَّهُ مَنْ يَنْصُرُهُ ۗ إِنَّ اللَّهَ لَقَوِيٌّ عَزِيزٌ",
  },
  {
    id: "2636",
    sura: "22",
    VerseIDAr: "41",
    ayatAR:
      "الَّذِينَ إِنْ مَكَّنَّاهُمْ فِي الْأَرْضِ أَقَامُوا الصَّلَاةَ وَآتَوُا الزَّكَاةَ وَأَمَرُوا بِالْمَعْرُوفِ وَنَهَوْا عَنِ الْمُنْكَرِ ۗ وَلِلَّهِ عَاقِبَةُ الْأُمُورِ",
  },
  {
    id: "2637",
    sura: "22",
    VerseIDAr: "42",
    ayatAR:
      "وَإِنْ يُكَذِّبُوكَ فَقَدْ كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍ وَعَادٌ وَثَمُودُ",
  },
  {
    id: "2638",
    sura: "22",
    VerseIDAr: "43",
    ayatAR: "وَقَوْمُ إِبْرَاهِيمَ وَقَوْمُ لُوطٍ",
  },
  {
    id: "2639",
    sura: "22",
    VerseIDAr: "44",
    ayatAR:
      "وَأَصْحَابُ مَدْيَنَ ۖ وَكُذِّبَ مُوسَىٰ فَأَمْلَيْتُ لِلْكَافِرِينَ ثُمَّ أَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ نَكِيرِ",
  },
  {
    id: "2640",
    sura: "22",
    VerseIDAr: "45",
    ayatAR:
      "فَكَأَيِّنْ مِنْ قَرْيَةٍ أَهْلَكْنَاهَا وَهِيَ ظَالِمَةٌ فَهِيَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَبِئْرٍ مُعَطَّلَةٍ وَقَصْرٍ مَشِيدٍ",
  },
  {
    id: "2641",
    sura: "22",
    VerseIDAr: "46",
    ayatAR:
      "أَفَلَمْ يَسِيرُوا فِي الْأَرْضِ فَتَكُونَ لَهُمْ قُلُوبٌ يَعْقِلُونَ بِهَا أَوْ آذَانٌ يَسْمَعُونَ بِهَا ۖ فَإِنَّهَا لَا تَعْمَى الْأَبْصَارُ وَلَٰكِنْ تَعْمَى الْقُلُوبُ الَّتِي فِي الصُّدُورِ",
  },
  {
    id: "2642",
    sura: "22",
    VerseIDAr: "47",
    ayatAR:
      "وَيَسْتَعْجِلُونَكَ بِالْعَذَابِ وَلَنْ يُخْلِفَ اللَّهُ وَعْدَهُ ۚ وَإِنَّ يَوْمًا عِنْدَ رَبِّكَ كَأَلْفِ سَنَةٍ مِمَّا تَعُدُّونَ",
  },
  {
    id: "2643",
    sura: "22",
    VerseIDAr: "48",
    ayatAR:
      "وَكَأَيِّنْ مِنْ قَرْيَةٍ أَمْلَيْتُ لَهَا وَهِيَ ظَالِمَةٌ ثُمَّ أَخَذْتُهَا وَإِلَيَّ الْمَصِيرُ",
  },
  {
    id: "2644",
    sura: "22",
    VerseIDAr: "49",
    ayatAR: "قُلْ يَا أَيُّهَا النَّاسُ إِنَّمَا أَنَا لَكُمْ نَذِيرٌ مُبِينٌ",
  },
  {
    id: "2645",
    sura: "22",
    VerseIDAr: "50",
    ayatAR:
      "فَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ مَغْفِرَةٌ وَرِزْقٌ كَرِيمٌ",
  },
  {
    id: "2646",
    sura: "22",
    VerseIDAr: "51",
    ayatAR:
      "وَالَّذِينَ سَعَوْا فِي آيَاتِنَا مُعَاجِزِينَ أُولَٰئِكَ أَصْحَابُ الْجَحِيمِ",
  },
  {
    id: "2647",
    sura: "22",
    VerseIDAr: "52",
    ayatAR:
      "وَمَا أَرْسَلْنَا مِنْ قَبْلِكَ مِنْ رَسُولٍ وَلَا نَبِيٍّ إِلَّا إِذَا تَمَنَّىٰ أَلْقَى الشَّيْطَانُ فِي أُمْنِيَّتِهِ فَيَنْسَخُ اللَّهُ مَا يُلْقِي الشَّيْطَانُ ثُمَّ يُحْكِمُ اللَّهُ آيَاتِهِ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "2648",
    sura: "22",
    VerseIDAr: "53",
    ayatAR:
      "لِيَجْعَلَ مَا يُلْقِي الشَّيْطَانُ فِتْنَةً لِلَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ وَالْقَاسِيَةِ قُلُوبُهُمْ ۗ وَإِنَّ الظَّالِمِينَ لَفِي شِقَاقٍ بَعِيدٍ",
  },
  {
    id: "2649",
    sura: "22",
    VerseIDAr: "54",
    ayatAR:
      "وَلِيَعْلَمَ الَّذِينَ أُوتُوا الْعِلْمَ أَنَّهُ الْحَقُّ مِنْ رَبِّكَ فَيُؤْمِنُوا بِهِ فَتُخْبِتَ لَهُ قُلُوبُهُمْ ۗ وَإِنَّ اللَّهَ لَهَادِ الَّذِينَ آمَنُوا إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "2650",
    sura: "22",
    VerseIDAr: "55",
    ayatAR:
      "وَلَا يَزَالُ الَّذِينَ كَفَرُوا فِي مِرْيَةٍ مِنْهُ حَتَّىٰ تَأْتِيَهُمُ السَّاعَةُ بَغْتَةً أَوْ يَأْتِيَهُمْ عَذَابُ يَوْمٍ عَقِيمٍ",
  },
  {
    id: "2651",
    sura: "22",
    VerseIDAr: "56",
    ayatAR:
      "الْمُلْكُ يَوْمَئِذٍ لِلَّهِ يَحْكُمُ بَيْنَهُمْ ۚ فَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فِي جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "2652",
    sura: "22",
    VerseIDAr: "57",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا فَأُولَٰئِكَ لَهُمْ عَذَابٌ مُهِينٌ",
  },
  {
    id: "2653",
    sura: "22",
    VerseIDAr: "58",
    ayatAR:
      "وَالَّذِينَ هَاجَرُوا فِي سَبِيلِ اللَّهِ ثُمَّ قُتِلُوا أَوْ مَاتُوا لَيَرْزُقَنَّهُمُ اللَّهُ رِزْقًا حَسَنًا ۚ وَإِنَّ اللَّهَ لَهُوَ خَيْرُ الرَّازِقِينَ",
  },
  {
    id: "2654",
    sura: "22",
    VerseIDAr: "59",
    ayatAR:
      "لَيُدْخِلَنَّهُمْ مُدْخَلًا يَرْضَوْنَهُ ۗ وَإِنَّ اللَّهَ لَعَلِيمٌ حَلِيمٌ",
  },
  {
    id: "2655",
    sura: "22",
    VerseIDAr: "60",
    ayatAR:
      "ذَٰلِكَ وَمَنْ عَاقَبَ بِمِثْلِ مَا عُوقِبَ بِهِ ثُمَّ بُغِيَ عَلَيْهِ لَيَنْصُرَنَّهُ اللَّهُ ۗ إِنَّ اللَّهَ لَعَفُوٌّ غَفُورٌ",
  },
  {
    id: "2656",
    sura: "22",
    VerseIDAr: "61",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ يُولِجُ اللَّيْلَ فِي النَّهَارِ وَيُولِجُ النَّهَارَ فِي اللَّيْلِ وَأَنَّ اللَّهَ سَمِيعٌ بَصِيرٌ",
  },
  {
    id: "2657",
    sura: "22",
    VerseIDAr: "62",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ هُوَ الْحَقُّ وَأَنَّ مَا يَدْعُونَ مِنْ دُونِهِ هُوَ الْبَاطِلُ وَأَنَّ اللَّهَ هُوَ الْعَلِيُّ الْكَبِيرُ",
  },
  {
    id: "2658",
    sura: "22",
    VerseIDAr: "63",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَتُصْبِحُ الْأَرْضُ مُخْضَرَّةً ۗ إِنَّ اللَّهَ لَطِيفٌ خَبِيرٌ",
  },
  {
    id: "2659",
    sura: "22",
    VerseIDAr: "64",
    ayatAR:
      "لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ وَإِنَّ اللَّهَ لَهُوَ الْغَنِيُّ الْحَمِيدُ",
  },
  {
    id: "2660",
    sura: "22",
    VerseIDAr: "65",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ سَخَّرَ لَكُمْ مَا فِي الْأَرْضِ وَالْفُلْكَ تَجْرِي فِي الْبَحْرِ بِأَمْرِهِ وَيُمْسِكُ السَّمَاءَ أَنْ تَقَعَ عَلَى الْأَرْضِ إِلَّا بِإِذْنِهِ ۗ إِنَّ اللَّهَ بِالنَّاسِ لَرَءُوفٌ رَحِيمٌ",
  },
  {
    id: "2661",
    sura: "22",
    VerseIDAr: "66",
    ayatAR:
      "وَهُوَ الَّذِي أَحْيَاكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ۗ إِنَّ الْإِنْسَانَ لَكَفُورٌ",
  },
  {
    id: "2662",
    sura: "22",
    VerseIDAr: "67",
    ayatAR:
      "لِكُلِّ أُمَّةٍ جَعَلْنَا مَنْسَكًا هُمْ نَاسِكُوهُ ۖ فَلَا يُنَازِعُنَّكَ فِي الْأَمْرِ ۚ وَادْعُ إِلَىٰ رَبِّكَ ۖ إِنَّكَ لَعَلَىٰ هُدًى مُسْتَقِيمٍ",
  },
  {
    id: "2663",
    sura: "22",
    VerseIDAr: "68",
    ayatAR: "وَإِنْ جَادَلُوكَ فَقُلِ اللَّهُ أَعْلَمُ بِمَا تَعْمَلُونَ",
  },
  {
    id: "2664",
    sura: "22",
    VerseIDAr: "69",
    ayatAR:
      "اللَّهُ يَحْكُمُ بَيْنَكُمْ يَوْمَ الْقِيَامَةِ فِيمَا كُنْتُمْ فِيهِ تَخْتَلِفُونَ",
  },
  {
    id: "2665",
    sura: "22",
    VerseIDAr: "70",
    ayatAR:
      "أَلَمْ تَعْلَمْ أَنَّ اللَّهَ يَعْلَمُ مَا فِي السَّمَاءِ وَالْأَرْضِ ۗ إِنَّ ذَٰلِكَ فِي كِتَابٍ ۚ إِنَّ ذَٰلِكَ عَلَى اللَّهِ يَسِيرٌ",
  },
  {
    id: "2666",
    sura: "22",
    VerseIDAr: "71",
    ayatAR:
      "وَيَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَمْ يُنَزِّلْ بِهِ سُلْطَانًا وَمَا لَيْسَ لَهُمْ بِهِ عِلْمٌ ۗ وَمَا لِلظَّالِمِينَ مِنْ نَصِيرٍ",
  },
  {
    id: "2667",
    sura: "22",
    VerseIDAr: "72",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ تَعْرِفُ فِي وُجُوهِ الَّذِينَ كَفَرُوا الْمُنْكَرَ ۖ يَكَادُونَ يَسْطُونَ بِالَّذِينَ يَتْلُونَ عَلَيْهِمْ آيَاتِنَا ۗ قُلْ أَفَأُنَبِّئُكُمْ بِشَرٍّ مِنْ ذَٰلِكُمُ ۗ النَّارُ وَعَدَهَا اللَّهُ الَّذِينَ كَفَرُوا ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "2668",
    sura: "22",
    VerseIDAr: "73",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ ضُرِبَ مَثَلٌ فَاسْتَمِعُوا لَهُ ۚ إِنَّ الَّذِينَ تَدْعُونَ مِنْ دُونِ اللَّهِ لَنْ يَخْلُقُوا ذُبَابًا وَلَوِ اجْتَمَعُوا لَهُ ۖ وَإِنْ يَسْلُبْهُمُ الذُّبَابُ شَيْئًا لَا يَسْتَنْقِذُوهُ مِنْهُ ۚ ضَعُفَ الطَّالِبُ وَالْمَطْلُوبُ",
  },
  {
    id: "2669",
    sura: "22",
    VerseIDAr: "74",
    ayatAR:
      "مَا قَدَرُوا اللَّهَ حَقَّ قَدْرِهِ ۗ إِنَّ اللَّهَ لَقَوِيٌّ عَزِيزٌ",
  },
  {
    id: "2670",
    sura: "22",
    VerseIDAr: "75",
    ayatAR:
      "اللَّهُ يَصْطَفِي مِنَ الْمَلَائِكَةِ رُسُلًا وَمِنَ النَّاسِ ۚ إِنَّ اللَّهَ سَمِيعٌ بَصِيرٌ",
  },
  {
    id: "2671",
    sura: "22",
    VerseIDAr: "76",
    ayatAR:
      "يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۗ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "2672",
    sura: "22",
    VerseIDAr: "77",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا ارْكَعُوا وَاسْجُدُوا وَاعْبُدُوا رَبَّكُمْ وَافْعَلُوا الْخَيْرَ لَعَلَّكُمْ تُفْلِحُونَ ۩",
  },
  {
    id: "2673",
    sura: "22",
    VerseIDAr: "78",
    ayatAR:
      "وَجَاهِدُوا فِي اللَّهِ حَقَّ جِهَادِهِ ۚ هُوَ اجْتَبَاكُمْ وَمَا جَعَلَ عَلَيْكُمْ فِي الدِّينِ مِنْ حَرَجٍ ۚ مِلَّةَ أَبِيكُمْ إِبْرَاهِيمَ ۚ هُوَ سَمَّاكُمُ الْمُسْلِمِينَ مِنْ قَبْلُ وَفِي هَٰذَا لِيَكُونَ الرَّسُولُ شَهِيدًا عَلَيْكُمْ وَتَكُونُوا شُهَدَاءَ عَلَى النَّاسِ ۚ فَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَاعْتَصِمُوا بِاللَّهِ هُوَ مَوْلَاكُمْ ۖ فَنِعْمَ الْمَوْلَىٰ وَنِعْمَ النَّصِيرُ",
  },
  {
    id: "2674",
    sura: "23",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قَدْ أَفْلَحَ الْمُؤْمِنُونَ",
  },
  {
    id: "2675",
    sura: "23",
    VerseIDAr: "2",
    ayatAR: "الَّذِينَ هُمْ فِي صَلَاتِهِمْ خَاشِعُونَ",
  },
  {
    id: "2676",
    sura: "23",
    VerseIDAr: "3",
    ayatAR: "وَالَّذِينَ هُمْ عَنِ اللَّغْوِ مُعْرِضُونَ",
  },
  {
    id: "2677",
    sura: "23",
    VerseIDAr: "4",
    ayatAR: "وَالَّذِينَ هُمْ لِلزَّكَاةِ فَاعِلُونَ",
  },
  {
    id: "2678",
    sura: "23",
    VerseIDAr: "5",
    ayatAR: "وَالَّذِينَ هُمْ لِفُرُوجِهِمْ حَافِظُونَ",
  },
  {
    id: "2679",
    sura: "23",
    VerseIDAr: "6",
    ayatAR:
      "إِلَّا عَلَىٰ أَزْوَاجِهِمْ أَوْ مَا مَلَكَتْ أَيْمَانُهُمْ فَإِنَّهُمْ غَيْرُ مَلُومِينَ",
  },
  {
    id: "2680",
    sura: "23",
    VerseIDAr: "7",
    ayatAR: "فَمَنِ ابْتَغَىٰ وَرَاءَ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الْعَادُونَ",
  },
  {
    id: "2681",
    sura: "23",
    VerseIDAr: "8",
    ayatAR: "وَالَّذِينَ هُمْ لِأَمَانَاتِهِمْ وَعَهْدِهِمْ رَاعُونَ",
  },
  {
    id: "2682",
    sura: "23",
    VerseIDAr: "9",
    ayatAR: "وَالَّذِينَ هُمْ عَلَىٰ صَلَوَاتِهِمْ يُحَافِظُونَ",
  },
  {
    id: "2683",
    sura: "23",
    VerseIDAr: "10",
    ayatAR: "أُولَٰئِكَ هُمُ الْوَارِثُونَ",
  },
  {
    id: "2684",
    sura: "23",
    VerseIDAr: "11",
    ayatAR: "الَّذِينَ يَرِثُونَ الْفِرْدَوْسَ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "2685",
    sura: "23",
    VerseIDAr: "12",
    ayatAR: "وَلَقَدْ خَلَقْنَا الْإِنْسَانَ مِنْ سُلَالَةٍ مِنْ طِينٍ",
  },
  {
    id: "2686",
    sura: "23",
    VerseIDAr: "13",
    ayatAR: "ثُمَّ جَعَلْنَاهُ نُطْفَةً فِي قَرَارٍ مَكِينٍ",
  },
  {
    id: "2687",
    sura: "23",
    VerseIDAr: "14",
    ayatAR:
      "ثُمَّ خَلَقْنَا النُّطْفَةَ عَلَقَةً فَخَلَقْنَا الْعَلَقَةَ مُضْغَةً فَخَلَقْنَا الْمُضْغَةَ عِظَامًا فَكَسَوْنَا الْعِظَامَ لَحْمًا ثُمَّ أَنْشَأْنَاهُ خَلْقًا آخَرَ ۚ فَتَبَارَكَ اللَّهُ أَحْسَنُ الْخَالِقِينَ",
  },
  {
    id: "2688",
    sura: "23",
    VerseIDAr: "15",
    ayatAR: "ثُمَّ إِنَّكُمْ بَعْدَ ذَٰلِكَ لَمَيِّتُونَ",
  },
  {
    id: "2689",
    sura: "23",
    VerseIDAr: "16",
    ayatAR: "ثُمَّ إِنَّكُمْ يَوْمَ الْقِيَامَةِ تُبْعَثُونَ",
  },
  {
    id: "2690",
    sura: "23",
    VerseIDAr: "17",
    ayatAR:
      "وَلَقَدْ خَلَقْنَا فَوْقَكُمْ سَبْعَ طَرَائِقَ وَمَا كُنَّا عَنِ الْخَلْقِ غَافِلِينَ",
  },
  {
    id: "2691",
    sura: "23",
    VerseIDAr: "18",
    ayatAR:
      "وَأَنْزَلْنَا مِنَ السَّمَاءِ مَاءً بِقَدَرٍ فَأَسْكَنَّاهُ فِي الْأَرْضِ ۖ وَإِنَّا عَلَىٰ ذَهَابٍ بِهِ لَقَادِرُونَ",
  },
  {
    id: "2692",
    sura: "23",
    VerseIDAr: "19",
    ayatAR:
      "فَأَنْشَأْنَا لَكُمْ بِهِ جَنَّاتٍ مِنْ نَخِيلٍ وَأَعْنَابٍ لَكُمْ فِيهَا فَوَاكِهُ كَثِيرَةٌ وَمِنْهَا تَأْكُلُونَ",
  },
  {
    id: "2693",
    sura: "23",
    VerseIDAr: "20",
    ayatAR:
      "وَشَجَرَةً تَخْرُجُ مِنْ طُورِ سَيْنَاءَ تَنْبُتُ بِالدُّهْنِ وَصِبْغٍ لِلْآكِلِينَ",
  },
  {
    id: "2694",
    sura: "23",
    VerseIDAr: "21",
    ayatAR:
      "وَإِنَّ لَكُمْ فِي الْأَنْعَامِ لَعِبْرَةً ۖ نُسْقِيكُمْ مِمَّا فِي بُطُونِهَا وَلَكُمْ فِيهَا مَنَافِعُ كَثِيرَةٌ وَمِنْهَا تَأْكُلُونَ",
  },
  {
    id: "2695",
    sura: "23",
    VerseIDAr: "22",
    ayatAR: "وَعَلَيْهَا وَعَلَى الْفُلْكِ تُحْمَلُونَ",
  },
  {
    id: "2696",
    sura: "23",
    VerseIDAr: "23",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِ فَقَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ أَفَلَا تَتَّقُونَ",
  },
  {
    id: "2697",
    sura: "23",
    VerseIDAr: "24",
    ayatAR:
      "فَقَالَ الْمَلَأُ الَّذِينَ كَفَرُوا مِنْ قَوْمِهِ مَا هَٰذَا إِلَّا بَشَرٌ مِثْلُكُمْ يُرِيدُ أَنْ يَتَفَضَّلَ عَلَيْكُمْ وَلَوْ شَاءَ اللَّهُ لَأَنْزَلَ مَلَائِكَةً مَا سَمِعْنَا بِهَٰذَا فِي آبَائِنَا الْأَوَّلِينَ",
  },
  {
    id: "2698",
    sura: "23",
    VerseIDAr: "25",
    ayatAR:
      "إِنْ هُوَ إِلَّا رَجُلٌ بِهِ جِنَّةٌ فَتَرَبَّصُوا بِهِ حَتَّىٰ حِينٍ",
  },
  {
    id: "2699",
    sura: "23",
    VerseIDAr: "26",
    ayatAR: "قَالَ رَبِّ انْصُرْنِي بِمَا كَذَّبُونِ",
  },
  {
    id: "2700",
    sura: "23",
    VerseIDAr: "27",
    ayatAR:
      "فَأَوْحَيْنَا إِلَيْهِ أَنِ اصْنَعِ الْفُلْكَ بِأَعْيُنِنَا وَوَحْيِنَا فَإِذَا جَاءَ أَمْرُنَا وَفَارَ التَّنُّورُ ۙ فَاسْلُكْ فِيهَا مِنْ كُلٍّ زَوْجَيْنِ اثْنَيْنِ وَأَهْلَكَ إِلَّا مَنْ سَبَقَ عَلَيْهِ الْقَوْلُ مِنْهُمْ ۖ وَلَا تُخَاطِبْنِي فِي الَّذِينَ ظَلَمُوا ۖ إِنَّهُمْ مُغْرَقُونَ",
  },
  {
    id: "2701",
    sura: "23",
    VerseIDAr: "28",
    ayatAR:
      "فَإِذَا اسْتَوَيْتَ أَنْتَ وَمَنْ مَعَكَ عَلَى الْفُلْكِ فَقُلِ الْحَمْدُ لِلَّهِ الَّذِي نَجَّانَا مِنَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "2702",
    sura: "23",
    VerseIDAr: "29",
    ayatAR:
      "وَقُلْ رَبِّ أَنْزِلْنِي مُنْزَلًا مُبَارَكًا وَأَنْتَ خَيْرُ الْمُنْزِلِينَ",
  },
  {
    id: "2703",
    sura: "23",
    VerseIDAr: "30",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَاتٍ وَإِنْ كُنَّا لَمُبْتَلِينَ",
  },
  {
    id: "2704",
    sura: "23",
    VerseIDAr: "31",
    ayatAR: "ثُمَّ أَنْشَأْنَا مِنْ بَعْدِهِمْ قَرْنًا آخَرِينَ",
  },
  {
    id: "2705",
    sura: "23",
    VerseIDAr: "32",
    ayatAR:
      "فَأَرْسَلْنَا فِيهِمْ رَسُولًا مِنْهُمْ أَنِ اعْبُدُوا اللَّهَ مَا لَكُمْ مِنْ إِلَٰهٍ غَيْرُهُ ۖ أَفَلَا تَتَّقُونَ",
  },
  {
    id: "2706",
    sura: "23",
    VerseIDAr: "33",
    ayatAR:
      "وَقَالَ الْمَلَأُ مِنْ قَوْمِهِ الَّذِينَ كَفَرُوا وَكَذَّبُوا بِلِقَاءِ الْآخِرَةِ وَأَتْرَفْنَاهُمْ فِي الْحَيَاةِ الدُّنْيَا مَا هَٰذَا إِلَّا بَشَرٌ مِثْلُكُمْ يَأْكُلُ مِمَّا تَأْكُلُونَ مِنْهُ وَيَشْرَبُ مِمَّا تَشْرَبُونَ",
  },
  {
    id: "2707",
    sura: "23",
    VerseIDAr: "34",
    ayatAR:
      "وَلَئِنْ أَطَعْتُمْ بَشَرًا مِثْلَكُمْ إِنَّكُمْ إِذًا لَخَاسِرُونَ",
  },
  {
    id: "2708",
    sura: "23",
    VerseIDAr: "35",
    ayatAR:
      "أَيَعِدُكُمْ أَنَّكُمْ إِذَا مِتُّمْ وَكُنْتُمْ تُرَابًا وَعِظَامًا أَنَّكُمْ مُخْرَجُونَ",
  },
  {
    id: "2709",
    sura: "23",
    VerseIDAr: "36",
    ayatAR: "هَيْهَاتَ هَيْهَاتَ لِمَا تُوعَدُونَ",
  },
  {
    id: "2710",
    sura: "23",
    VerseIDAr: "37",
    ayatAR:
      "إِنْ هِيَ إِلَّا حَيَاتُنَا الدُّنْيَا نَمُوتُ وَنَحْيَا وَمَا نَحْنُ بِمَبْعُوثِينَ",
  },
  {
    id: "2711",
    sura: "23",
    VerseIDAr: "38",
    ayatAR:
      "إِنْ هُوَ إِلَّا رَجُلٌ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا وَمَا نَحْنُ لَهُ بِمُؤْمِنِينَ",
  },
  {
    id: "2712",
    sura: "23",
    VerseIDAr: "39",
    ayatAR: "قَالَ رَبِّ انْصُرْنِي بِمَا كَذَّبُونِ",
  },
  {
    id: "2713",
    sura: "23",
    VerseIDAr: "40",
    ayatAR: "قَالَ عَمَّا قَلِيلٍ لَيُصْبِحُنَّ نَادِمِينَ",
  },
  {
    id: "2714",
    sura: "23",
    VerseIDAr: "41",
    ayatAR:
      "فَأَخَذَتْهُمُ الصَّيْحَةُ بِالْحَقِّ فَجَعَلْنَاهُمْ غُثَاءً ۚ فَبُعْدًا لِلْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "2715",
    sura: "23",
    VerseIDAr: "42",
    ayatAR: "ثُمَّ أَنْشَأْنَا مِنْ بَعْدِهِمْ قُرُونًا آخَرِينَ",
  },
  {
    id: "2716",
    sura: "23",
    VerseIDAr: "43",
    ayatAR: "مَا تَسْبِقُ مِنْ أُمَّةٍ أَجَلَهَا وَمَا يَسْتَأْخِرُونَ",
  },
  {
    id: "2717",
    sura: "23",
    VerseIDAr: "44",
    ayatAR:
      "ثُمَّ أَرْسَلْنَا رُسُلَنَا تَتْرَىٰ ۖ كُلَّ مَا جَاءَ أُمَّةً رَسُولُهَا كَذَّبُوهُ ۚ فَأَتْبَعْنَا بَعْضَهُمْ بَعْضًا وَجَعَلْنَاهُمْ أَحَادِيثَ ۚ فَبُعْدًا لِقَوْمٍ لَا يُؤْمِنُونَ",
  },
  {
    id: "2718",
    sura: "23",
    VerseIDAr: "45",
    ayatAR:
      "ثُمَّ أَرْسَلْنَا مُوسَىٰ وَأَخَاهُ هَارُونَ بِآيَاتِنَا وَسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "2719",
    sura: "23",
    VerseIDAr: "46",
    ayatAR:
      "إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ فَاسْتَكْبَرُوا وَكَانُوا قَوْمًا عَالِينَ",
  },
  {
    id: "2720",
    sura: "23",
    VerseIDAr: "47",
    ayatAR:
      "فَقَالُوا أَنُؤْمِنُ لِبَشَرَيْنِ مِثْلِنَا وَقَوْمُهُمَا لَنَا عَابِدُونَ",
  },
  {
    id: "2721",
    sura: "23",
    VerseIDAr: "48",
    ayatAR: "فَكَذَّبُوهُمَا فَكَانُوا مِنَ الْمُهْلَكِينَ",
  },
  {
    id: "2722",
    sura: "23",
    VerseIDAr: "49",
    ayatAR: "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ لَعَلَّهُمْ يَهْتَدُونَ",
  },
  {
    id: "2723",
    sura: "23",
    VerseIDAr: "50",
    ayatAR:
      "وَجَعَلْنَا ابْنَ مَرْيَمَ وَأُمَّهُ آيَةً وَآوَيْنَاهُمَا إِلَىٰ رَبْوَةٍ ذَاتِ قَرَارٍ وَمَعِينٍ",
  },
  {
    id: "2724",
    sura: "23",
    VerseIDAr: "51",
    ayatAR:
      "يَا أَيُّهَا الرُّسُلُ كُلُوا مِنَ الطَّيِّبَاتِ وَاعْمَلُوا صَالِحًا ۖ إِنِّي بِمَا تَعْمَلُونَ عَلِيمٌ",
  },
  {
    id: "2725",
    sura: "23",
    VerseIDAr: "52",
    ayatAR:
      "وَإِنَّ هَٰذِهِ أُمَّتُكُمْ أُمَّةً وَاحِدَةً وَأَنَا رَبُّكُمْ فَاتَّقُونِ",
  },
  {
    id: "2726",
    sura: "23",
    VerseIDAr: "53",
    ayatAR:
      "فَتَقَطَّعُوا أَمْرَهُمْ بَيْنَهُمْ زُبُرًا ۖ كُلُّ حِزْبٍ بِمَا لَدَيْهِمْ فَرِحُونَ",
  },
  {
    id: "2727",
    sura: "23",
    VerseIDAr: "54",
    ayatAR: "فَذَرْهُمْ فِي غَمْرَتِهِمْ حَتَّىٰ حِينٍ",
  },
  {
    id: "2728",
    sura: "23",
    VerseIDAr: "55",
    ayatAR: "أَيَحْسَبُونَ أَنَّمَا نُمِدُّهُمْ بِهِ مِنْ مَالٍ وَبَنِينَ",
  },
  {
    id: "2729",
    sura: "23",
    VerseIDAr: "56",
    ayatAR: "نُسَارِعُ لَهُمْ فِي الْخَيْرَاتِ ۚ بَلْ لَا يَشْعُرُونَ",
  },
  {
    id: "2730",
    sura: "23",
    VerseIDAr: "57",
    ayatAR: "إِنَّ الَّذِينَ هُمْ مِنْ خَشْيَةِ رَبِّهِمْ مُشْفِقُونَ",
  },
  {
    id: "2731",
    sura: "23",
    VerseIDAr: "58",
    ayatAR: "وَالَّذِينَ هُمْ بِآيَاتِ رَبِّهِمْ يُؤْمِنُونَ",
  },
  {
    id: "2732",
    sura: "23",
    VerseIDAr: "59",
    ayatAR: "وَالَّذِينَ هُمْ بِرَبِّهِمْ لَا يُشْرِكُونَ",
  },
  {
    id: "2733",
    sura: "23",
    VerseIDAr: "60",
    ayatAR:
      "وَالَّذِينَ يُؤْتُونَ مَا آتَوْا وَقُلُوبُهُمْ وَجِلَةٌ أَنَّهُمْ إِلَىٰ رَبِّهِمْ رَاجِعُونَ",
  },
  {
    id: "2734",
    sura: "23",
    VerseIDAr: "61",
    ayatAR: "أُولَٰئِكَ يُسَارِعُونَ فِي الْخَيْرَاتِ وَهُمْ لَهَا سَابِقُونَ",
  },
  {
    id: "2735",
    sura: "23",
    VerseIDAr: "62",
    ayatAR:
      "وَلَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَا ۖ وَلَدَيْنَا كِتَابٌ يَنْطِقُ بِالْحَقِّ ۚ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "2736",
    sura: "23",
    VerseIDAr: "63",
    ayatAR:
      "بَلْ قُلُوبُهُمْ فِي غَمْرَةٍ مِنْ هَٰذَا وَلَهُمْ أَعْمَالٌ مِنْ دُونِ ذَٰلِكَ هُمْ لَهَا عَامِلُونَ",
  },
  {
    id: "2737",
    sura: "23",
    VerseIDAr: "64",
    ayatAR:
      "حَتَّىٰ إِذَا أَخَذْنَا مُتْرَفِيهِمْ بِالْعَذَابِ إِذَا هُمْ يَجْأَرُونَ",
  },
  {
    id: "2738",
    sura: "23",
    VerseIDAr: "65",
    ayatAR: "لَا تَجْأَرُوا الْيَوْمَ ۖ إِنَّكُمْ مِنَّا لَا تُنْصَرُونَ",
  },
  {
    id: "2739",
    sura: "23",
    VerseIDAr: "66",
    ayatAR:
      "قَدْ كَانَتْ آيَاتِي تُتْلَىٰ عَلَيْكُمْ فَكُنْتُمْ عَلَىٰ أَعْقَابِكُمْ تَنْكِصُونَ",
  },
  {
    id: "2740",
    sura: "23",
    VerseIDAr: "67",
    ayatAR: "مُسْتَكْبِرِينَ بِهِ سَامِرًا تَهْجُرُونَ",
  },
  {
    id: "2741",
    sura: "23",
    VerseIDAr: "68",
    ayatAR:
      "أَفَلَمْ يَدَّبَّرُوا الْقَوْلَ أَمْ جَاءَهُمْ مَا لَمْ يَأْتِ آبَاءَهُمُ الْأَوَّلِينَ",
  },
  {
    id: "2742",
    sura: "23",
    VerseIDAr: "69",
    ayatAR: "أَمْ لَمْ يَعْرِفُوا رَسُولَهُمْ فَهُمْ لَهُ مُنْكِرُونَ",
  },
  {
    id: "2743",
    sura: "23",
    VerseIDAr: "70",
    ayatAR:
      "أَمْ يَقُولُونَ بِهِ جِنَّةٌ ۚ بَلْ جَاءَهُمْ بِالْحَقِّ وَأَكْثَرُهُمْ لِلْحَقِّ كَارِهُونَ",
  },
  {
    id: "2744",
    sura: "23",
    VerseIDAr: "71",
    ayatAR:
      "وَلَوِ اتَّبَعَ الْحَقُّ أَهْوَاءَهُمْ لَفَسَدَتِ السَّمَاوَاتُ وَالْأَرْضُ وَمَنْ فِيهِنَّ ۚ بَلْ أَتَيْنَاهُمْ بِذِكْرِهِمْ فَهُمْ عَنْ ذِكْرِهِمْ مُعْرِضُونَ",
  },
  {
    id: "2745",
    sura: "23",
    VerseIDAr: "72",
    ayatAR:
      "أَمْ تَسْأَلُهُمْ خَرْجًا فَخَرَاجُ رَبِّكَ خَيْرٌ ۖ وَهُوَ خَيْرُ الرَّازِقِينَ",
  },
  {
    id: "2746",
    sura: "23",
    VerseIDAr: "73",
    ayatAR: "وَإِنَّكَ لَتَدْعُوهُمْ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "2747",
    sura: "23",
    VerseIDAr: "74",
    ayatAR:
      "وَإِنَّ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ عَنِ الصِّرَاطِ لَنَاكِبُونَ",
  },
  {
    id: "2748",
    sura: "23",
    VerseIDAr: "75",
    ayatAR:
      "وَلَوْ رَحِمْنَاهُمْ وَكَشَفْنَا مَا بِهِمْ مِنْ ضُرٍّ لَلَجُّوا فِي طُغْيَانِهِمْ يَعْمَهُونَ",
  },
  {
    id: "2749",
    sura: "23",
    VerseIDAr: "76",
    ayatAR:
      "وَلَقَدْ أَخَذْنَاهُمْ بِالْعَذَابِ فَمَا اسْتَكَانُوا لِرَبِّهِمْ وَمَا يَتَضَرَّعُونَ",
  },
  {
    id: "2750",
    sura: "23",
    VerseIDAr: "77",
    ayatAR:
      "حَتَّىٰ إِذَا فَتَحْنَا عَلَيْهِمْ بَابًا ذَا عَذَابٍ شَدِيدٍ إِذَا هُمْ فِيهِ مُبْلِسُونَ",
  },
  {
    id: "2751",
    sura: "23",
    VerseIDAr: "78",
    ayatAR:
      "وَهُوَ الَّذِي أَنْشَأَ لَكُمُ السَّمْعَ وَالْأَبْصَارَ وَالْأَفْئِدَةَ ۚ قَلِيلًا مَا تَشْكُرُونَ",
  },
  {
    id: "2752",
    sura: "23",
    VerseIDAr: "79",
    ayatAR: "وَهُوَ الَّذِي ذَرَأَكُمْ فِي الْأَرْضِ وَإِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "2753",
    sura: "23",
    VerseIDAr: "80",
    ayatAR:
      "وَهُوَ الَّذِي يُحْيِي وَيُمِيتُ وَلَهُ اخْتِلَافُ اللَّيْلِ وَالنَّهَارِ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "2754",
    sura: "23",
    VerseIDAr: "81",
    ayatAR: "بَلْ قَالُوا مِثْلَ مَا قَالَ الْأَوَّلُونَ",
  },
  {
    id: "2755",
    sura: "23",
    VerseIDAr: "82",
    ayatAR:
      "قَالُوا أَإِذَا مِتْنَا وَكُنَّا تُرَابًا وَعِظَامًا أَإِنَّا لَمَبْعُوثُونَ",
  },
  {
    id: "2756",
    sura: "23",
    VerseIDAr: "83",
    ayatAR:
      "لَقَدْ وُعِدْنَا نَحْنُ وَآبَاؤُنَا هَٰذَا مِنْ قَبْلُ إِنْ هَٰذَا إِلَّا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "2757",
    sura: "23",
    VerseIDAr: "84",
    ayatAR: "قُلْ لِمَنِ الْأَرْضُ وَمَنْ فِيهَا إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "2758",
    sura: "23",
    VerseIDAr: "85",
    ayatAR: "سَيَقُولُونَ لِلَّهِ ۚ قُلْ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "2759",
    sura: "23",
    VerseIDAr: "86",
    ayatAR:
      "قُلْ مَنْ رَبُّ السَّمَاوَاتِ السَّبْعِ وَرَبُّ الْعَرْشِ الْعَظِيمِ",
  },
  {
    id: "2760",
    sura: "23",
    VerseIDAr: "87",
    ayatAR: "سَيَقُولُونَ لِلَّهِ ۚ قُلْ أَفَلَا تَتَّقُونَ",
  },
  {
    id: "2761",
    sura: "23",
    VerseIDAr: "88",
    ayatAR:
      "قُلْ مَنْ بِيَدِهِ مَلَكُوتُ كُلِّ شَيْءٍ وَهُوَ يُجِيرُ وَلَا يُجَارُ عَلَيْهِ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "2762",
    sura: "23",
    VerseIDAr: "89",
    ayatAR: "سَيَقُولُونَ لِلَّهِ ۚ قُلْ فَأَنَّىٰ تُسْحَرُونَ",
  },
  {
    id: "2763",
    sura: "23",
    VerseIDAr: "90",
    ayatAR: "بَلْ أَتَيْنَاهُمْ بِالْحَقِّ وَإِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "2764",
    sura: "23",
    VerseIDAr: "91",
    ayatAR:
      "مَا اتَّخَذَ اللَّهُ مِنْ وَلَدٍ وَمَا كَانَ مَعَهُ مِنْ إِلَٰهٍ ۚ إِذًا لَذَهَبَ كُلُّ إِلَٰهٍ بِمَا خَلَقَ وَلَعَلَا بَعْضُهُمْ عَلَىٰ بَعْضٍ ۚ سُبْحَانَ اللَّهِ عَمَّا يَصِفُونَ",
  },
  {
    id: "2765",
    sura: "23",
    VerseIDAr: "92",
    ayatAR: "عَالِمِ الْغَيْبِ وَالشَّهَادَةِ فَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "2766",
    sura: "23",
    VerseIDAr: "93",
    ayatAR: "قُلْ رَبِّ إِمَّا تُرِيَنِّي مَا يُوعَدُونَ",
  },
  {
    id: "2767",
    sura: "23",
    VerseIDAr: "94",
    ayatAR: "رَبِّ فَلَا تَجْعَلْنِي فِي الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "2768",
    sura: "23",
    VerseIDAr: "95",
    ayatAR: "وَإِنَّا عَلَىٰ أَنْ نُرِيَكَ مَا نَعِدُهُمْ لَقَادِرُونَ",
  },
  {
    id: "2769",
    sura: "23",
    VerseIDAr: "96",
    ayatAR:
      "ادْفَعْ بِالَّتِي هِيَ أَحْسَنُ السَّيِّئَةَ ۚ نَحْنُ أَعْلَمُ بِمَا يَصِفُونَ",
  },
  {
    id: "2770",
    sura: "23",
    VerseIDAr: "97",
    ayatAR: "وَقُلْ رَبِّ أَعُوذُ بِكَ مِنْ هَمَزَاتِ الشَّيَاطِينِ",
  },
  {
    id: "2771",
    sura: "23",
    VerseIDAr: "98",
    ayatAR: "وَأَعُوذُ بِكَ رَبِّ أَنْ يَحْضُرُونِ",
  },
  {
    id: "2772",
    sura: "23",
    VerseIDAr: "99",
    ayatAR: "حَتَّىٰ إِذَا جَاءَ أَحَدَهُمُ الْمَوْتُ قَالَ رَبِّ ارْجِعُونِ",
  },
  {
    id: "2773",
    sura: "23",
    VerseIDAr: "100",
    ayatAR:
      "لَعَلِّي أَعْمَلُ صَالِحًا فِيمَا تَرَكْتُ ۚ كَلَّا ۚ إِنَّهَا كَلِمَةٌ هُوَ قَائِلُهَا ۖ وَمِنْ وَرَائِهِمْ بَرْزَخٌ إِلَىٰ يَوْمِ يُبْعَثُونَ",
  },
  {
    id: "2774",
    sura: "23",
    VerseIDAr: "101",
    ayatAR:
      "فَإِذَا نُفِخَ فِي الصُّورِ فَلَا أَنْسَابَ بَيْنَهُمْ يَوْمَئِذٍ وَلَا يَتَسَاءَلُونَ",
  },
  {
    id: "2775",
    sura: "23",
    VerseIDAr: "102",
    ayatAR: "فَمَنْ ثَقُلَتْ مَوَازِينُهُ فَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "2776",
    sura: "23",
    VerseIDAr: "103",
    ayatAR:
      "وَمَنْ خَفَّتْ مَوَازِينُهُ فَأُولَٰئِكَ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ فِي جَهَنَّمَ خَالِدُونَ",
  },
  {
    id: "2777",
    sura: "23",
    VerseIDAr: "104",
    ayatAR: "تَلْفَحُ وُجُوهَهُمُ النَّارُ وَهُمْ فِيهَا كَالِحُونَ",
  },
  {
    id: "2778",
    sura: "23",
    VerseIDAr: "105",
    ayatAR:
      "أَلَمْ تَكُنْ آيَاتِي تُتْلَىٰ عَلَيْكُمْ فَكُنْتُمْ بِهَا تُكَذِّبُونَ",
  },
  {
    id: "2779",
    sura: "23",
    VerseIDAr: "106",
    ayatAR:
      "قَالُوا رَبَّنَا غَلَبَتْ عَلَيْنَا شِقْوَتُنَا وَكُنَّا قَوْمًا ضَالِّينَ",
  },
  {
    id: "2780",
    sura: "23",
    VerseIDAr: "107",
    ayatAR: "رَبَّنَا أَخْرِجْنَا مِنْهَا فَإِنْ عُدْنَا فَإِنَّا ظَالِمُونَ",
  },
  {
    id: "2781",
    sura: "23",
    VerseIDAr: "108",
    ayatAR: "قَالَ اخْسَئُوا فِيهَا وَلَا تُكَلِّمُونِ",
  },
  {
    id: "2782",
    sura: "23",
    VerseIDAr: "109",
    ayatAR:
      "إِنَّهُ كَانَ فَرِيقٌ مِنْ عِبَادِي يَقُولُونَ رَبَّنَا آمَنَّا فَاغْفِرْ لَنَا وَارْحَمْنَا وَأَنْتَ خَيْرُ الرَّاحِمِينَ",
  },
  {
    id: "2783",
    sura: "23",
    VerseIDAr: "110",
    ayatAR:
      "فَاتَّخَذْتُمُوهُمْ سِخْرِيًّا حَتَّىٰ أَنْسَوْكُمْ ذِكْرِي وَكُنْتُمْ مِنْهُمْ تَضْحَكُونَ",
  },
  {
    id: "2784",
    sura: "23",
    VerseIDAr: "111",
    ayatAR:
      "إِنِّي جَزَيْتُهُمُ الْيَوْمَ بِمَا صَبَرُوا أَنَّهُمْ هُمُ الْفَائِزُونَ",
  },
  {
    id: "2785",
    sura: "23",
    VerseIDAr: "112",
    ayatAR: "قَالَ كَمْ لَبِثْتُمْ فِي الْأَرْضِ عَدَدَ سِنِينَ",
  },
  {
    id: "2786",
    sura: "23",
    VerseIDAr: "113",
    ayatAR:
      "قَالُوا لَبِثْنَا يَوْمًا أَوْ بَعْضَ يَوْمٍ فَاسْأَلِ الْعَادِّينَ",
  },
  {
    id: "2787",
    sura: "23",
    VerseIDAr: "114",
    ayatAR:
      "قَالَ إِنْ لَبِثْتُمْ إِلَّا قَلِيلًا ۖ لَوْ أَنَّكُمْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "2788",
    sura: "23",
    VerseIDAr: "115",
    ayatAR:
      "أَفَحَسِبْتُمْ أَنَّمَا خَلَقْنَاكُمْ عَبَثًا وَأَنَّكُمْ إِلَيْنَا لَا تُرْجَعُونَ",
  },
  {
    id: "2789",
    sura: "23",
    VerseIDAr: "116",
    ayatAR:
      "فَتَعَالَى اللَّهُ الْمَلِكُ الْحَقُّ ۖ لَا إِلَٰهَ إِلَّا هُوَ رَبُّ الْعَرْشِ الْكَرِيمِ",
  },
  {
    id: "2790",
    sura: "23",
    VerseIDAr: "117",
    ayatAR:
      "وَمَنْ يَدْعُ مَعَ اللَّهِ إِلَٰهًا آخَرَ لَا بُرْهَانَ لَهُ بِهِ فَإِنَّمَا حِسَابُهُ عِنْدَ رَبِّهِ ۚ إِنَّهُ لَا يُفْلِحُ الْكَافِرُونَ",
  },
  {
    id: "2791",
    sura: "23",
    VerseIDAr: "118",
    ayatAR: "وَقُلْ رَبِّ اغْفِرْ وَارْحَمْ وَأَنْتَ خَيْرُ الرَّاحِمِينَ",
  },
  {
    id: "2792",
    sura: "24",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سُورَةٌ أَنْزَلْنَاهَا وَفَرَضْنَاهَا وَأَنْزَلْنَا فِيهَا آيَاتٍ بَيِّنَاتٍ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "2793",
    sura: "24",
    VerseIDAr: "2",
    ayatAR:
      "الزَّانِيَةُ وَالزَّانِي فَاجْلِدُوا كُلَّ وَاحِدٍ مِنْهُمَا مِائَةَ جَلْدَةٍ ۖ وَلَا تَأْخُذْكُمْ بِهِمَا رَأْفَةٌ فِي دِينِ اللَّهِ إِنْ كُنْتُمْ تُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۖ وَلْيَشْهَدْ عَذَابَهُمَا طَائِفَةٌ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "2794",
    sura: "24",
    VerseIDAr: "3",
    ayatAR:
      "الزَّانِي لَا يَنْكِحُ إِلَّا زَانِيَةً أَوْ مُشْرِكَةً وَالزَّانِيَةُ لَا يَنْكِحُهَا إِلَّا زَانٍ أَوْ مُشْرِكٌ ۚ وَحُرِّمَ ذَٰلِكَ عَلَى الْمُؤْمِنِينَ",
  },
  {
    id: "2795",
    sura: "24",
    VerseIDAr: "4",
    ayatAR:
      "وَالَّذِينَ يَرْمُونَ الْمُحْصَنَاتِ ثُمَّ لَمْ يَأْتُوا بِأَرْبَعَةِ شُهَدَاءَ فَاجْلِدُوهُمْ ثَمَانِينَ جَلْدَةً وَلَا تَقْبَلُوا لَهُمْ شَهَادَةً أَبَدًا ۚ وَأُولَٰئِكَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "2796",
    sura: "24",
    VerseIDAr: "5",
    ayatAR:
      "إِلَّا الَّذِينَ تَابُوا مِنْ بَعْدِ ذَٰلِكَ وَأَصْلَحُوا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "2797",
    sura: "24",
    VerseIDAr: "6",
    ayatAR:
      "وَالَّذِينَ يَرْمُونَ أَزْوَاجَهُمْ وَلَمْ يَكُنْ لَهُمْ شُهَدَاءُ إِلَّا أَنْفُسُهُمْ فَشَهَادَةُ أَحَدِهِمْ أَرْبَعُ شَهَادَاتٍ بِاللَّهِ ۙ إِنَّهُ لَمِنَ الصَّادِقِينَ",
  },
  {
    id: "2798",
    sura: "24",
    VerseIDAr: "7",
    ayatAR:
      "وَالْخَامِسَةُ أَنَّ لَعْنَتَ اللَّهِ عَلَيْهِ إِنْ كَانَ مِنَ الْكَاذِبِينَ",
  },
  {
    id: "2799",
    sura: "24",
    VerseIDAr: "8",
    ayatAR:
      "وَيَدْرَأُ عَنْهَا الْعَذَابَ أَنْ تَشْهَدَ أَرْبَعَ شَهَادَاتٍ بِاللَّهِ ۙ إِنَّهُ لَمِنَ الْكَاذِبِينَ",
  },
  {
    id: "2800",
    sura: "24",
    VerseIDAr: "9",
    ayatAR:
      "وَالْخَامِسَةَ أَنَّ غَضَبَ اللَّهِ عَلَيْهَا إِنْ كَانَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "2801",
    sura: "24",
    VerseIDAr: "10",
    ayatAR:
      "وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ وَأَنَّ اللَّهَ تَوَّابٌ حَكِيمٌ",
  },
  {
    id: "2802",
    sura: "24",
    VerseIDAr: "11",
    ayatAR:
      "إِنَّ الَّذِينَ جَاءُوا بِالْإِفْكِ عُصْبَةٌ مِنْكُمْ ۚ لَا تَحْسَبُوهُ شَرًّا لَكُمْ ۖ بَلْ هُوَ خَيْرٌ لَكُمْ ۚ لِكُلِّ امْرِئٍ مِنْهُمْ مَا اكْتَسَبَ مِنَ الْإِثْمِ ۚ وَالَّذِي تَوَلَّىٰ كِبْرَهُ مِنْهُمْ لَهُ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "2803",
    sura: "24",
    VerseIDAr: "12",
    ayatAR:
      "لَوْلَا إِذْ سَمِعْتُمُوهُ ظَنَّ الْمُؤْمِنُونَ وَالْمُؤْمِنَاتُ بِأَنْفُسِهِمْ خَيْرًا وَقَالُوا هَٰذَا إِفْكٌ مُبِينٌ",
  },
  {
    id: "2804",
    sura: "24",
    VerseIDAr: "13",
    ayatAR:
      "لَوْلَا جَاءُوا عَلَيْهِ بِأَرْبَعَةِ شُهَدَاءَ ۚ فَإِذْ لَمْ يَأْتُوا بِالشُّهَدَاءِ فَأُولَٰئِكَ عِنْدَ اللَّهِ هُمُ الْكَاذِبُونَ",
  },
  {
    id: "2805",
    sura: "24",
    VerseIDAr: "14",
    ayatAR:
      "وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ فِي الدُّنْيَا وَالْآخِرَةِ لَمَسَّكُمْ فِي مَا أَفَضْتُمْ فِيهِ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "2806",
    sura: "24",
    VerseIDAr: "15",
    ayatAR:
      "إِذْ تَلَقَّوْنَهُ بِأَلْسِنَتِكُمْ وَتَقُولُونَ بِأَفْوَاهِكُمْ مَا لَيْسَ لَكُمْ بِهِ عِلْمٌ وَتَحْسَبُونَهُ هَيِّنًا وَهُوَ عِنْدَ اللَّهِ عَظِيمٌ",
  },
  {
    id: "2807",
    sura: "24",
    VerseIDAr: "16",
    ayatAR:
      "وَلَوْلَا إِذْ سَمِعْتُمُوهُ قُلْتُمْ مَا يَكُونُ لَنَا أَنْ نَتَكَلَّمَ بِهَٰذَا سُبْحَانَكَ هَٰذَا بُهْتَانٌ عَظِيمٌ",
  },
  {
    id: "2808",
    sura: "24",
    VerseIDAr: "17",
    ayatAR:
      "يَعِظُكُمُ اللَّهُ أَنْ تَعُودُوا لِمِثْلِهِ أَبَدًا إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "2809",
    sura: "24",
    VerseIDAr: "18",
    ayatAR: "وَيُبَيِّنُ اللَّهُ لَكُمُ الْآيَاتِ ۚ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "2810",
    sura: "24",
    VerseIDAr: "19",
    ayatAR:
      "إِنَّ الَّذِينَ يُحِبُّونَ أَنْ تَشِيعَ الْفَاحِشَةُ فِي الَّذِينَ آمَنُوا لَهُمْ عَذَابٌ أَلِيمٌ فِي الدُّنْيَا وَالْآخِرَةِ ۚ وَاللَّهُ يَعْلَمُ وَأَنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "2811",
    sura: "24",
    VerseIDAr: "20",
    ayatAR:
      "وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ وَأَنَّ اللَّهَ رَءُوفٌ رَحِيمٌ",
  },
  {
    id: "2812",
    sura: "24",
    VerseIDAr: "21",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّبِعُوا خُطُوَاتِ الشَّيْطَانِ ۚ وَمَنْ يَتَّبِعْ خُطُوَاتِ الشَّيْطَانِ فَإِنَّهُ يَأْمُرُ بِالْفَحْشَاءِ وَالْمُنْكَرِ ۚ وَلَوْلَا فَضْلُ اللَّهِ عَلَيْكُمْ وَرَحْمَتُهُ مَا زَكَىٰ مِنْكُمْ مِنْ أَحَدٍ أَبَدًا وَلَٰكِنَّ اللَّهَ يُزَكِّي مَنْ يَشَاءُ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "2813",
    sura: "24",
    VerseIDAr: "22",
    ayatAR:
      "وَلَا يَأْتَلِ أُولُو الْفَضْلِ مِنْكُمْ وَالسَّعَةِ أَنْ يُؤْتُوا أُولِي الْقُرْبَىٰ وَالْمَسَاكِينَ وَالْمُهَاجِرِينَ فِي سَبِيلِ اللَّهِ ۖ وَلْيَعْفُوا وَلْيَصْفَحُوا ۗ أَلَا تُحِبُّونَ أَنْ يَغْفِرَ اللَّهُ لَكُمْ ۗ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "2814",
    sura: "24",
    VerseIDAr: "23",
    ayatAR:
      "إِنَّ الَّذِينَ يَرْمُونَ الْمُحْصَنَاتِ الْغَافِلَاتِ الْمُؤْمِنَاتِ لُعِنُوا فِي الدُّنْيَا وَالْآخِرَةِ وَلَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "2815",
    sura: "24",
    VerseIDAr: "24",
    ayatAR:
      "يَوْمَ تَشْهَدُ عَلَيْهِمْ أَلْسِنَتُهُمْ وَأَيْدِيهِمْ وَأَرْجُلُهُمْ بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "2816",
    sura: "24",
    VerseIDAr: "25",
    ayatAR:
      "يَوْمَئِذٍ يُوَفِّيهِمُ اللَّهُ دِينَهُمُ الْحَقَّ وَيَعْلَمُونَ أَنَّ اللَّهَ هُوَ الْحَقُّ الْمُبِينُ",
  },
  {
    id: "2817",
    sura: "24",
    VerseIDAr: "26",
    ayatAR:
      "الْخَبِيثَاتُ لِلْخَبِيثِينَ وَالْخَبِيثُونَ لِلْخَبِيثَاتِ ۖ وَالطَّيِّبَاتُ لِلطَّيِّبِينَ وَالطَّيِّبُونَ لِلطَّيِّبَاتِ ۚ أُولَٰئِكَ مُبَرَّءُونَ مِمَّا يَقُولُونَ ۖ لَهُمْ مَغْفِرَةٌ وَرِزْقٌ كَرِيمٌ",
  },
  {
    id: "2818",
    sura: "24",
    VerseIDAr: "27",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَدْخُلُوا بُيُوتًا غَيْرَ بُيُوتِكُمْ حَتَّىٰ تَسْتَأْنِسُوا وَتُسَلِّمُوا عَلَىٰ أَهْلِهَا ۚ ذَٰلِكُمْ خَيْرٌ لَكُمْ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "2819",
    sura: "24",
    VerseIDAr: "28",
    ayatAR:
      "فَإِنْ لَمْ تَجِدُوا فِيهَا أَحَدًا فَلَا تَدْخُلُوهَا حَتَّىٰ يُؤْذَنَ لَكُمْ ۖ وَإِنْ قِيلَ لَكُمُ ارْجِعُوا فَارْجِعُوا ۖ هُوَ أَزْكَىٰ لَكُمْ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ عَلِيمٌ",
  },
  {
    id: "2820",
    sura: "24",
    VerseIDAr: "29",
    ayatAR:
      "لَيْسَ عَلَيْكُمْ جُنَاحٌ أَنْ تَدْخُلُوا بُيُوتًا غَيْرَ مَسْكُونَةٍ فِيهَا مَتَاعٌ لَكُمْ ۚ وَاللَّهُ يَعْلَمُ مَا تُبْدُونَ وَمَا تَكْتُمُونَ",
  },
  {
    id: "2821",
    sura: "24",
    VerseIDAr: "30",
    ayatAR:
      "قُلْ لِلْمُؤْمِنِينَ يَغُضُّوا مِنْ أَبْصَارِهِمْ وَيَحْفَظُوا فُرُوجَهُمْ ۚ ذَٰلِكَ أَزْكَىٰ لَهُمْ ۗ إِنَّ اللَّهَ خَبِيرٌ بِمَا يَصْنَعُونَ",
  },
  {
    id: "2822",
    sura: "24",
    VerseIDAr: "31",
    ayatAR:
      "وَقُلْ لِلْمُؤْمِنَاتِ يَغْضُضْنَ مِنْ أَبْصَارِهِنَّ وَيَحْفَظْنَ فُرُوجَهُنَّ وَلَا يُبْدِينَ زِينَتَهُنَّ إِلَّا مَا ظَهَرَ مِنْهَا ۖ وَلْيَضْرِبْنَ بِخُمُرِهِنَّ عَلَىٰ جُيُوبِهِنَّ ۖ وَلَا يُبْدِينَ زِينَتَهُنَّ إِلَّا لِبُعُولَتِهِنَّ أَوْ آبَائِهِنَّ أَوْ آبَاءِ بُعُولَتِهِنَّ أَوْ أَبْنَائِهِنَّ أَوْ أَبْنَاءِ بُعُولَتِهِنَّ أَوْ إِخْوَانِهِنَّ أَوْ بَنِي إِخْوَانِهِنَّ أَوْ بَنِي أَخَوَاتِهِنَّ أَوْ نِسَائِهِنَّ أَوْ مَا مَلَكَتْ أَيْمَانُهُنَّ أَوِ التَّابِعِينَ غَيْرِ أُولِي الْإِرْبَةِ مِنَ الرِّجَالِ أَوِ الطِّفْلِ الَّذِينَ لَمْ يَظْهَرُوا عَلَىٰ عَوْرَاتِ النِّسَاءِ ۖ وَلَا يَضْرِبْنَ بِأَرْجُلِهِنَّ لِيُعْلَمَ مَا يُخْفِينَ مِنْ زِينَتِهِنَّ ۚ وَتُوبُوا إِلَى اللَّهِ جَمِيعًا أَيُّهَ الْمُؤْمِنُونَ لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "2823",
    sura: "24",
    VerseIDAr: "32",
    ayatAR:
      "وَأَنْكِحُوا الْأَيَامَىٰ مِنْكُمْ وَالصَّالِحِينَ مِنْ عِبَادِكُمْ وَإِمَائِكُمْ ۚ إِنْ يَكُونُوا فُقَرَاءَ يُغْنِهِمُ اللَّهُ مِنْ فَضْلِهِ ۗ وَاللَّهُ وَاسِعٌ عَلِيمٌ",
  },
  {
    id: "2824",
    sura: "24",
    VerseIDAr: "33",
    ayatAR:
      "وَلْيَسْتَعْفِفِ الَّذِينَ لَا يَجِدُونَ نِكَاحًا حَتَّىٰ يُغْنِيَهُمُ اللَّهُ مِنْ فَضْلِهِ ۗ وَالَّذِينَ يَبْتَغُونَ الْكِتَابَ مِمَّا مَلَكَتْ أَيْمَانُكُمْ فَكَاتِبُوهُمْ إِنْ عَلِمْتُمْ فِيهِمْ خَيْرًا ۖ وَآتُوهُمْ مِنْ مَالِ اللَّهِ الَّذِي آتَاكُمْ ۚ وَلَا تُكْرِهُوا فَتَيَاتِكُمْ عَلَى الْبِغَاءِ إِنْ أَرَدْنَ تَحَصُّنًا لِتَبْتَغُوا عَرَضَ الْحَيَاةِ الدُّنْيَا ۚ وَمَنْ يُكْرِهْهُنَّ فَإِنَّ اللَّهَ مِنْ بَعْدِ إِكْرَاهِهِنَّ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "2825",
    sura: "24",
    VerseIDAr: "34",
    ayatAR:
      "وَلَقَدْ أَنْزَلْنَا إِلَيْكُمْ آيَاتٍ مُبَيِّنَاتٍ وَمَثَلًا مِنَ الَّذِينَ خَلَوْا مِنْ قَبْلِكُمْ وَمَوْعِظَةً لِلْمُتَّقِينَ",
  },
  {
    id: "2826",
    sura: "24",
    VerseIDAr: "35",
    ayatAR:
      "اللَّهُ نُورُ السَّمَاوَاتِ وَالْأَرْضِ ۚ مَثَلُ نُورِهِ كَمِشْكَاةٍ فِيهَا مِصْبَاحٌ ۖ الْمِصْبَاحُ فِي زُجَاجَةٍ ۖ الزُّجَاجَةُ كَأَنَّهَا كَوْكَبٌ دُرِّيٌّ يُوقَدُ مِنْ شَجَرَةٍ مُبَارَكَةٍ زَيْتُونَةٍ لَا شَرْقِيَّةٍ وَلَا غَرْبِيَّةٍ يَكَادُ زَيْتُهَا يُضِيءُ وَلَوْ لَمْ تَمْسَسْهُ نَارٌ ۚ نُورٌ عَلَىٰ نُورٍ ۗ يَهْدِي اللَّهُ لِنُورِهِ مَنْ يَشَاءُ ۚ وَيَضْرِبُ اللَّهُ الْأَمْثَالَ لِلنَّاسِ ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "2827",
    sura: "24",
    VerseIDAr: "36",
    ayatAR:
      "فِي بُيُوتٍ أَذِنَ اللَّهُ أَنْ تُرْفَعَ وَيُذْكَرَ فِيهَا اسْمُهُ يُسَبِّحُ لَهُ فِيهَا بِالْغُدُوِّ وَالْآصَالِ",
  },
  {
    id: "2828",
    sura: "24",
    VerseIDAr: "37",
    ayatAR:
      "رِجَالٌ لَا تُلْهِيهِمْ تِجَارَةٌ وَلَا بَيْعٌ عَنْ ذِكْرِ اللَّهِ وَإِقَامِ الصَّلَاةِ وَإِيتَاءِ الزَّكَاةِ ۙ يَخَافُونَ يَوْمًا تَتَقَلَّبُ فِيهِ الْقُلُوبُ وَالْأَبْصَارُ",
  },
  {
    id: "2829",
    sura: "24",
    VerseIDAr: "38",
    ayatAR:
      "لِيَجْزِيَهُمُ اللَّهُ أَحْسَنَ مَا عَمِلُوا وَيَزِيدَهُمْ مِنْ فَضْلِهِ ۗ وَاللَّهُ يَرْزُقُ مَنْ يَشَاءُ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "2830",
    sura: "24",
    VerseIDAr: "39",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا أَعْمَالُهُمْ كَسَرَابٍ بِقِيعَةٍ يَحْسَبُهُ الظَّمْآنُ مَاءً حَتَّىٰ إِذَا جَاءَهُ لَمْ يَجِدْهُ شَيْئًا وَوَجَدَ اللَّهَ عِنْدَهُ فَوَفَّاهُ حِسَابَهُ ۗ وَاللَّهُ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "2831",
    sura: "24",
    VerseIDAr: "40",
    ayatAR:
      "أَوْ كَظُلُمَاتٍ فِي بَحْرٍ لُجِّيٍّ يَغْشَاهُ مَوْجٌ مِنْ فَوْقِهِ مَوْجٌ مِنْ فَوْقِهِ سَحَابٌ ۚ ظُلُمَاتٌ بَعْضُهَا فَوْقَ بَعْضٍ إِذَا أَخْرَجَ يَدَهُ لَمْ يَكَدْ يَرَاهَا ۗ وَمَنْ لَمْ يَجْعَلِ اللَّهُ لَهُ نُورًا فَمَا لَهُ مِنْ نُورٍ",
  },
  {
    id: "2832",
    sura: "24",
    VerseIDAr: "41",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ يُسَبِّحُ لَهُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ وَالطَّيْرُ صَافَّاتٍ ۖ كُلٌّ قَدْ عَلِمَ صَلَاتَهُ وَتَسْبِيحَهُ ۗ وَاللَّهُ عَلِيمٌ بِمَا يَفْعَلُونَ",
  },
  {
    id: "2833",
    sura: "24",
    VerseIDAr: "42",
    ayatAR:
      "وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۖ وَإِلَى اللَّهِ الْمَصِيرُ",
  },
  {
    id: "2834",
    sura: "24",
    VerseIDAr: "43",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ يُزْجِي سَحَابًا ثُمَّ يُؤَلِّفُ بَيْنَهُ ثُمَّ يَجْعَلُهُ رُكَامًا فَتَرَى الْوَدْقَ يَخْرُجُ مِنْ خِلَالِهِ وَيُنَزِّلُ مِنَ السَّمَاءِ مِنْ جِبَالٍ فِيهَا مِنْ بَرَدٍ فَيُصِيبُ بِهِ مَنْ يَشَاءُ وَيَصْرِفُهُ عَنْ مَنْ يَشَاءُ ۖ يَكَادُ سَنَا بَرْقِهِ يَذْهَبُ بِالْأَبْصَارِ",
  },
  {
    id: "2835",
    sura: "24",
    VerseIDAr: "44",
    ayatAR:
      "يُقَلِّبُ اللَّهُ اللَّيْلَ وَالنَّهَارَ ۚ إِنَّ فِي ذَٰلِكَ لَعِبْرَةً لِأُولِي الْأَبْصَارِ",
  },
  {
    id: "2836",
    sura: "24",
    VerseIDAr: "45",
    ayatAR:
      "وَاللَّهُ خَلَقَ كُلَّ دَابَّةٍ مِنْ مَاءٍ ۖ فَمِنْهُمْ مَنْ يَمْشِي عَلَىٰ بَطْنِهِ وَمِنْهُمْ مَنْ يَمْشِي عَلَىٰ رِجْلَيْنِ وَمِنْهُمْ مَنْ يَمْشِي عَلَىٰ أَرْبَعٍ ۚ يَخْلُقُ اللَّهُ مَا يَشَاءُ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "2837",
    sura: "24",
    VerseIDAr: "46",
    ayatAR:
      "لَقَدْ أَنْزَلْنَا آيَاتٍ مُبَيِّنَاتٍ ۚ وَاللَّهُ يَهْدِي مَنْ يَشَاءُ إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "2838",
    sura: "24",
    VerseIDAr: "47",
    ayatAR:
      "وَيَقُولُونَ آمَنَّا بِاللَّهِ وَبِالرَّسُولِ وَأَطَعْنَا ثُمَّ يَتَوَلَّىٰ فَرِيقٌ مِنْهُمْ مِنْ بَعْدِ ذَٰلِكَ ۚ وَمَا أُولَٰئِكَ بِالْمُؤْمِنِينَ",
  },
  {
    id: "2839",
    sura: "24",
    VerseIDAr: "48",
    ayatAR:
      "وَإِذَا دُعُوا إِلَى اللَّهِ وَرَسُولِهِ لِيَحْكُمَ بَيْنَهُمْ إِذَا فَرِيقٌ مِنْهُمْ مُعْرِضُونَ",
  },
  {
    id: "2840",
    sura: "24",
    VerseIDAr: "49",
    ayatAR: "وَإِنْ يَكُنْ لَهُمُ الْحَقُّ يَأْتُوا إِلَيْهِ مُذْعِنِينَ",
  },
  {
    id: "2841",
    sura: "24",
    VerseIDAr: "50",
    ayatAR:
      "أَفِي قُلُوبِهِمْ مَرَضٌ أَمِ ارْتَابُوا أَمْ يَخَافُونَ أَنْ يَحِيفَ اللَّهُ عَلَيْهِمْ وَرَسُولُهُ ۚ بَلْ أُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "2842",
    sura: "24",
    VerseIDAr: "51",
    ayatAR:
      "إِنَّمَا كَانَ قَوْلَ الْمُؤْمِنِينَ إِذَا دُعُوا إِلَى اللَّهِ وَرَسُولِهِ لِيَحْكُمَ بَيْنَهُمْ أَنْ يَقُولُوا سَمِعْنَا وَأَطَعْنَا ۚ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "2843",
    sura: "24",
    VerseIDAr: "52",
    ayatAR:
      "وَمَنْ يُطِعِ اللَّهَ وَرَسُولَهُ وَيَخْشَ اللَّهَ وَيَتَّقْهِ فَأُولَٰئِكَ هُمُ الْفَائِزُونَ",
  },
  {
    id: "2844",
    sura: "24",
    VerseIDAr: "53",
    ayatAR:
      "وَأَقْسَمُوا بِاللَّهِ جَهْدَ أَيْمَانِهِمْ لَئِنْ أَمَرْتَهُمْ لَيَخْرُجُنَّ ۖ قُلْ لَا تُقْسِمُوا ۖ طَاعَةٌ مَعْرُوفَةٌ ۚ إِنَّ اللَّهَ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "2845",
    sura: "24",
    VerseIDAr: "54",
    ayatAR:
      "قُلْ أَطِيعُوا اللَّهَ وَأَطِيعُوا الرَّسُولَ ۖ فَإِنْ تَوَلَّوْا فَإِنَّمَا عَلَيْهِ مَا حُمِّلَ وَعَلَيْكُمْ مَا حُمِّلْتُمْ ۖ وَإِنْ تُطِيعُوهُ تَهْتَدُوا ۚ وَمَا عَلَى الرَّسُولِ إِلَّا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "2846",
    sura: "24",
    VerseIDAr: "55",
    ayatAR:
      "وَعَدَ اللَّهُ الَّذِينَ آمَنُوا مِنْكُمْ وَعَمِلُوا الصَّالِحَاتِ لَيَسْتَخْلِفَنَّهُمْ فِي الْأَرْضِ كَمَا اسْتَخْلَفَ الَّذِينَ مِنْ قَبْلِهِمْ وَلَيُمَكِّنَنَّ لَهُمْ دِينَهُمُ الَّذِي ارْتَضَىٰ لَهُمْ وَلَيُبَدِّلَنَّهُمْ مِنْ بَعْدِ خَوْفِهِمْ أَمْنًا ۚ يَعْبُدُونَنِي لَا يُشْرِكُونَ بِي شَيْئًا ۚ وَمَنْ كَفَرَ بَعْدَ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "2847",
    sura: "24",
    VerseIDAr: "56",
    ayatAR:
      "وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَأَطِيعُوا الرَّسُولَ لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "2848",
    sura: "24",
    VerseIDAr: "57",
    ayatAR:
      "لَا تَحْسَبَنَّ الَّذِينَ كَفَرُوا مُعْجِزِينَ فِي الْأَرْضِ ۚ وَمَأْوَاهُمُ النَّارُ ۖ وَلَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "2849",
    sura: "24",
    VerseIDAr: "58",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لِيَسْتَأْذِنْكُمُ الَّذِينَ مَلَكَتْ أَيْمَانُكُمْ وَالَّذِينَ لَمْ يَبْلُغُوا الْحُلُمَ مِنْكُمْ ثَلَاثَ مَرَّاتٍ ۚ مِنْ قَبْلِ صَلَاةِ الْفَجْرِ وَحِينَ تَضَعُونَ ثِيَابَكُمْ مِنَ الظَّهِيرَةِ وَمِنْ بَعْدِ صَلَاةِ الْعِشَاءِ ۚ ثَلَاثُ عَوْرَاتٍ لَكُمْ ۚ لَيْسَ عَلَيْكُمْ وَلَا عَلَيْهِمْ جُنَاحٌ بَعْدَهُنَّ ۚ طَوَّافُونَ عَلَيْكُمْ بَعْضُكُمْ عَلَىٰ بَعْضٍ ۚ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمُ الْآيَاتِ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "2850",
    sura: "24",
    VerseIDAr: "59",
    ayatAR:
      "وَإِذَا بَلَغَ الْأَطْفَالُ مِنْكُمُ الْحُلُمَ فَلْيَسْتَأْذِنُوا كَمَا اسْتَأْذَنَ الَّذِينَ مِنْ قَبْلِهِمْ ۚ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمْ آيَاتِهِ ۗ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "2851",
    sura: "24",
    VerseIDAr: "60",
    ayatAR:
      "وَالْقَوَاعِدُ مِنَ النِّسَاءِ اللَّاتِي لَا يَرْجُونَ نِكَاحًا فَلَيْسَ عَلَيْهِنَّ جُنَاحٌ أَنْ يَضَعْنَ ثِيَابَهُنَّ غَيْرَ مُتَبَرِّجَاتٍ بِزِينَةٍ ۖ وَأَنْ يَسْتَعْفِفْنَ خَيْرٌ لَهُنَّ ۗ وَاللَّهُ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "2852",
    sura: "24",
    VerseIDAr: "61",
    ayatAR:
      "لَيْسَ عَلَى الْأَعْمَىٰ حَرَجٌ وَلَا عَلَى الْأَعْرَجِ حَرَجٌ وَلَا عَلَى الْمَرِيضِ حَرَجٌ وَلَا عَلَىٰ أَنْفُسِكُمْ أَنْ تَأْكُلُوا مِنْ بُيُوتِكُمْ أَوْ بُيُوتِ آبَائِكُمْ أَوْ بُيُوتِ أُمَّهَاتِكُمْ أَوْ بُيُوتِ إِخْوَانِكُمْ أَوْ بُيُوتِ أَخَوَاتِكُمْ أَوْ بُيُوتِ أَعْمَامِكُمْ أَوْ بُيُوتِ عَمَّاتِكُمْ أَوْ بُيُوتِ أَخْوَالِكُمْ أَوْ بُيُوتِ خَالَاتِكُمْ أَوْ مَا مَلَكْتُمْ مَفَاتِحَهُ أَوْ صَدِيقِكُمْ ۚ لَيْسَ عَلَيْكُمْ جُنَاحٌ أَنْ تَأْكُلُوا جَمِيعًا أَوْ أَشْتَاتًا ۚ فَإِذَا دَخَلْتُمْ بُيُوتًا فَسَلِّمُوا عَلَىٰ أَنْفُسِكُمْ تَحِيَّةً مِنْ عِنْدِ اللَّهِ مُبَارَكَةً طَيِّبَةً ۚ كَذَٰلِكَ يُبَيِّنُ اللَّهُ لَكُمُ الْآيَاتِ لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "2853",
    sura: "24",
    VerseIDAr: "62",
    ayatAR:
      "إِنَّمَا الْمُؤْمِنُونَ الَّذِينَ آمَنُوا بِاللَّهِ وَرَسُولِهِ وَإِذَا كَانُوا مَعَهُ عَلَىٰ أَمْرٍ جَامِعٍ لَمْ يَذْهَبُوا حَتَّىٰ يَسْتَأْذِنُوهُ ۚ إِنَّ الَّذِينَ يَسْتَأْذِنُونَكَ أُولَٰئِكَ الَّذِينَ يُؤْمِنُونَ بِاللَّهِ وَرَسُولِهِ ۚ فَإِذَا اسْتَأْذَنُوكَ لِبَعْضِ شَأْنِهِمْ فَأْذَنْ لِمَنْ شِئْتَ مِنْهُمْ وَاسْتَغْفِرْ لَهُمُ اللَّهَ ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "2854",
    sura: "24",
    VerseIDAr: "63",
    ayatAR:
      "لَا تَجْعَلُوا دُعَاءَ الرَّسُولِ بَيْنَكُمْ كَدُعَاءِ بَعْضِكُمْ بَعْضًا ۚ قَدْ يَعْلَمُ اللَّهُ الَّذِينَ يَتَسَلَّلُونَ مِنْكُمْ لِوَاذًا ۚ فَلْيَحْذَرِ الَّذِينَ يُخَالِفُونَ عَنْ أَمْرِهِ أَنْ تُصِيبَهُمْ فِتْنَةٌ أَوْ يُصِيبَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "2855",
    sura: "24",
    VerseIDAr: "64",
    ayatAR:
      "أَلَا إِنَّ لِلَّهِ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ قَدْ يَعْلَمُ مَا أَنْتُمْ عَلَيْهِ وَيَوْمَ يُرْجَعُونَ إِلَيْهِ فَيُنَبِّئُهُمْ بِمَا عَمِلُوا ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "2856",
    sura: "25",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ تَبَارَكَ الَّذِي نَزَّلَ الْفُرْقَانَ عَلَىٰ عَبْدِهِ لِيَكُونَ لِلْعَالَمِينَ نَذِيرًا",
  },
  {
    id: "2857",
    sura: "25",
    VerseIDAr: "2",
    ayatAR:
      "الَّذِي لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَلَمْ يَتَّخِذْ وَلَدًا وَلَمْ يَكُنْ لَهُ شَرِيكٌ فِي الْمُلْكِ وَخَلَقَ كُلَّ شَيْءٍ فَقَدَّرَهُ تَقْدِيرًا",
  },
  {
    id: "2858",
    sura: "25",
    VerseIDAr: "3",
    ayatAR:
      "وَاتَّخَذُوا مِنْ دُونِهِ آلِهَةً لَا يَخْلُقُونَ شَيْئًا وَهُمْ يُخْلَقُونَ وَلَا يَمْلِكُونَ لِأَنْفُسِهِمْ ضَرًّا وَلَا نَفْعًا وَلَا يَمْلِكُونَ مَوْتًا وَلَا حَيَاةً وَلَا نُشُورًا",
  },
  {
    id: "2859",
    sura: "25",
    VerseIDAr: "4",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا إِنْ هَٰذَا إِلَّا إِفْكٌ افْتَرَاهُ وَأَعَانَهُ عَلَيْهِ قَوْمٌ آخَرُونَ ۖ فَقَدْ جَاءُوا ظُلْمًا وَزُورًا",
  },
  {
    id: "2860",
    sura: "25",
    VerseIDAr: "5",
    ayatAR:
      "وَقَالُوا أَسَاطِيرُ الْأَوَّلِينَ اكْتَتَبَهَا فَهِيَ تُمْلَىٰ عَلَيْهِ بُكْرَةً وَأَصِيلًا",
  },
  {
    id: "2861",
    sura: "25",
    VerseIDAr: "6",
    ayatAR:
      "قُلْ أَنْزَلَهُ الَّذِي يَعْلَمُ السِّرَّ فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ إِنَّهُ كَانَ غَفُورًا رَحِيمًا",
  },
  {
    id: "2862",
    sura: "25",
    VerseIDAr: "7",
    ayatAR:
      "وَقَالُوا مَالِ هَٰذَا الرَّسُولِ يَأْكُلُ الطَّعَامَ وَيَمْشِي فِي الْأَسْوَاقِ ۙ لَوْلَا أُنْزِلَ إِلَيْهِ مَلَكٌ فَيَكُونَ مَعَهُ نَذِيرًا",
  },
  {
    id: "2863",
    sura: "25",
    VerseIDAr: "8",
    ayatAR:
      "أَوْ يُلْقَىٰ إِلَيْهِ كَنْزٌ أَوْ تَكُونُ لَهُ جَنَّةٌ يَأْكُلُ مِنْهَا ۚ وَقَالَ الظَّالِمُونَ إِنْ تَتَّبِعُونَ إِلَّا رَجُلًا مَسْحُورًا",
  },
  {
    id: "2864",
    sura: "25",
    VerseIDAr: "9",
    ayatAR:
      "انْظُرْ كَيْفَ ضَرَبُوا لَكَ الْأَمْثَالَ فَضَلُّوا فَلَا يَسْتَطِيعُونَ سَبِيلًا",
  },
  {
    id: "2865",
    sura: "25",
    VerseIDAr: "10",
    ayatAR:
      "تَبَارَكَ الَّذِي إِنْ شَاءَ جَعَلَ لَكَ خَيْرًا مِنْ ذَٰلِكَ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ وَيَجْعَلْ لَكَ قُصُورًا",
  },
  {
    id: "2866",
    sura: "25",
    VerseIDAr: "11",
    ayatAR:
      "بَلْ كَذَّبُوا بِالسَّاعَةِ ۖ وَأَعْتَدْنَا لِمَنْ كَذَّبَ بِالسَّاعَةِ سَعِيرًا",
  },
  {
    id: "2867",
    sura: "25",
    VerseIDAr: "12",
    ayatAR:
      "إِذَا رَأَتْهُمْ مِنْ مَكَانٍ بَعِيدٍ سَمِعُوا لَهَا تَغَيُّظًا وَزَفِيرًا",
  },
  {
    id: "2868",
    sura: "25",
    VerseIDAr: "13",
    ayatAR:
      "وَإِذَا أُلْقُوا مِنْهَا مَكَانًا ضَيِّقًا مُقَرَّنِينَ دَعَوْا هُنَالِكَ ثُبُورًا",
  },
  {
    id: "2869",
    sura: "25",
    VerseIDAr: "14",
    ayatAR:
      "لَا تَدْعُوا الْيَوْمَ ثُبُورًا وَاحِدًا وَادْعُوا ثُبُورًا كَثِيرًا",
  },
  {
    id: "2870",
    sura: "25",
    VerseIDAr: "15",
    ayatAR:
      "قُلْ أَذَٰلِكَ خَيْرٌ أَمْ جَنَّةُ الْخُلْدِ الَّتِي وُعِدَ الْمُتَّقُونَ ۚ كَانَتْ لَهُمْ جَزَاءً وَمَصِيرًا",
  },
  {
    id: "2871",
    sura: "25",
    VerseIDAr: "16",
    ayatAR:
      "لَهُمْ فِيهَا مَا يَشَاءُونَ خَالِدِينَ ۚ كَانَ عَلَىٰ رَبِّكَ وَعْدًا مَسْئُولًا",
  },
  {
    id: "2872",
    sura: "25",
    VerseIDAr: "17",
    ayatAR:
      "وَيَوْمَ يَحْشُرُهُمْ وَمَا يَعْبُدُونَ مِنْ دُونِ اللَّهِ فَيَقُولُ أَأَنْتُمْ أَضْلَلْتُمْ عِبَادِي هَٰؤُلَاءِ أَمْ هُمْ ضَلُّوا السَّبِيلَ",
  },
  {
    id: "2873",
    sura: "25",
    VerseIDAr: "18",
    ayatAR:
      "قَالُوا سُبْحَانَكَ مَا كَانَ يَنْبَغِي لَنَا أَنْ نَتَّخِذَ مِنْ دُونِكَ مِنْ أَوْلِيَاءَ وَلَٰكِنْ مَتَّعْتَهُمْ وَآبَاءَهُمْ حَتَّىٰ نَسُوا الذِّكْرَ وَكَانُوا قَوْمًا بُورًا",
  },
  {
    id: "2874",
    sura: "25",
    VerseIDAr: "19",
    ayatAR:
      "فَقَدْ كَذَّبُوكُمْ بِمَا تَقُولُونَ فَمَا تَسْتَطِيعُونَ صَرْفًا وَلَا نَصْرًا ۚ وَمَنْ يَظْلِمْ مِنْكُمْ نُذِقْهُ عَذَابًا كَبِيرًا",
  },
  {
    id: "2875",
    sura: "25",
    VerseIDAr: "20",
    ayatAR:
      "وَمَا أَرْسَلْنَا قَبْلَكَ مِنَ الْمُرْسَلِينَ إِلَّا إِنَّهُمْ لَيَأْكُلُونَ الطَّعَامَ وَيَمْشُونَ فِي الْأَسْوَاقِ ۗ وَجَعَلْنَا بَعْضَكُمْ لِبَعْضٍ فِتْنَةً أَتَصْبِرُونَ ۗ وَكَانَ رَبُّكَ بَصِيرًا",
  },
  {
    id: "2876",
    sura: "25",
    VerseIDAr: "21",
    ayatAR:
      "وَقَالَ الَّذِينَ لَا يَرْجُونَ لِقَاءَنَا لَوْلَا أُنْزِلَ عَلَيْنَا الْمَلَائِكَةُ أَوْ نَرَىٰ رَبَّنَا ۗ لَقَدِ اسْتَكْبَرُوا فِي أَنْفُسِهِمْ وَعَتَوْا عُتُوًّا كَبِيرًا",
  },
  {
    id: "2877",
    sura: "25",
    VerseIDAr: "22",
    ayatAR:
      "يَوْمَ يَرَوْنَ الْمَلَائِكَةَ لَا بُشْرَىٰ يَوْمَئِذٍ لِلْمُجْرِمِينَ وَيَقُولُونَ حِجْرًا مَحْجُورًا",
  },
  {
    id: "2878",
    sura: "25",
    VerseIDAr: "23",
    ayatAR:
      "وَقَدِمْنَا إِلَىٰ مَا عَمِلُوا مِنْ عَمَلٍ فَجَعَلْنَاهُ هَبَاءً مَنْثُورًا",
  },
  {
    id: "2879",
    sura: "25",
    VerseIDAr: "24",
    ayatAR:
      "أَصْحَابُ الْجَنَّةِ يَوْمَئِذٍ خَيْرٌ مُسْتَقَرًّا وَأَحْسَنُ مَقِيلًا",
  },
  {
    id: "2880",
    sura: "25",
    VerseIDAr: "25",
    ayatAR:
      "وَيَوْمَ تَشَقَّقُ السَّمَاءُ بِالْغَمَامِ وَنُزِّلَ الْمَلَائِكَةُ تَنْزِيلًا",
  },
  {
    id: "2881",
    sura: "25",
    VerseIDAr: "26",
    ayatAR:
      "الْمُلْكُ يَوْمَئِذٍ الْحَقُّ لِلرَّحْمَٰنِ ۚ وَكَانَ يَوْمًا عَلَى الْكَافِرِينَ عَسِيرًا",
  },
  {
    id: "2882",
    sura: "25",
    VerseIDAr: "27",
    ayatAR:
      "وَيَوْمَ يَعَضُّ الظَّالِمُ عَلَىٰ يَدَيْهِ يَقُولُ يَا لَيْتَنِي اتَّخَذْتُ مَعَ الرَّسُولِ سَبِيلًا",
  },
  {
    id: "2883",
    sura: "25",
    VerseIDAr: "28",
    ayatAR: "يَا وَيْلَتَىٰ لَيْتَنِي لَمْ أَتَّخِذْ فُلَانًا خَلِيلًا",
  },
  {
    id: "2884",
    sura: "25",
    VerseIDAr: "29",
    ayatAR:
      "لَقَدْ أَضَلَّنِي عَنِ الذِّكْرِ بَعْدَ إِذْ جَاءَنِي ۗ وَكَانَ الشَّيْطَانُ لِلْإِنْسَانِ خَذُولًا",
  },
  {
    id: "2885",
    sura: "25",
    VerseIDAr: "30",
    ayatAR:
      "وَقَالَ الرَّسُولُ يَا رَبِّ إِنَّ قَوْمِي اتَّخَذُوا هَٰذَا الْقُرْآنَ مَهْجُورًا",
  },
  {
    id: "2886",
    sura: "25",
    VerseIDAr: "31",
    ayatAR:
      "وَكَذَٰلِكَ جَعَلْنَا لِكُلِّ نَبِيٍّ عَدُوًّا مِنَ الْمُجْرِمِينَ ۗ وَكَفَىٰ بِرَبِّكَ هَادِيًا وَنَصِيرًا",
  },
  {
    id: "2887",
    sura: "25",
    VerseIDAr: "32",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لَوْلَا نُزِّلَ عَلَيْهِ الْقُرْآنُ جُمْلَةً وَاحِدَةً ۚ كَذَٰلِكَ لِنُثَبِّتَ بِهِ فُؤَادَكَ ۖ وَرَتَّلْنَاهُ تَرْتِيلًا",
  },
  {
    id: "2888",
    sura: "25",
    VerseIDAr: "33",
    ayatAR:
      "وَلَا يَأْتُونَكَ بِمَثَلٍ إِلَّا جِئْنَاكَ بِالْحَقِّ وَأَحْسَنَ تَفْسِيرًا",
  },
  {
    id: "2889",
    sura: "25",
    VerseIDAr: "34",
    ayatAR:
      "الَّذِينَ يُحْشَرُونَ عَلَىٰ وُجُوهِهِمْ إِلَىٰ جَهَنَّمَ أُولَٰئِكَ شَرٌّ مَكَانًا وَأَضَلُّ سَبِيلًا",
  },
  {
    id: "2890",
    sura: "25",
    VerseIDAr: "35",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ وَجَعَلْنَا مَعَهُ أَخَاهُ هَارُونَ وَزِيرًا",
  },
  {
    id: "2891",
    sura: "25",
    VerseIDAr: "36",
    ayatAR:
      "فَقُلْنَا اذْهَبَا إِلَى الْقَوْمِ الَّذِينَ كَذَّبُوا بِآيَاتِنَا فَدَمَّرْنَاهُمْ تَدْمِيرًا",
  },
  {
    id: "2892",
    sura: "25",
    VerseIDAr: "37",
    ayatAR:
      "وَقَوْمَ نُوحٍ لَمَّا كَذَّبُوا الرُّسُلَ أَغْرَقْنَاهُمْ وَجَعَلْنَاهُمْ لِلنَّاسِ آيَةً ۖ وَأَعْتَدْنَا لِلظَّالِمِينَ عَذَابًا أَلِيمًا",
  },
  {
    id: "2893",
    sura: "25",
    VerseIDAr: "38",
    ayatAR:
      "وَعَادًا وَثَمُودَ وَأَصْحَابَ الرَّسِّ وَقُرُونًا بَيْنَ ذَٰلِكَ كَثِيرًا",
  },
  {
    id: "2894",
    sura: "25",
    VerseIDAr: "39",
    ayatAR:
      "وَكُلًّا ضَرَبْنَا لَهُ الْأَمْثَالَ ۖ وَكُلًّا تَبَّرْنَا تَتْبِيرًا",
  },
  {
    id: "2895",
    sura: "25",
    VerseIDAr: "40",
    ayatAR:
      "وَلَقَدْ أَتَوْا عَلَى الْقَرْيَةِ الَّتِي أُمْطِرَتْ مَطَرَ السَّوْءِ ۚ أَفَلَمْ يَكُونُوا يَرَوْنَهَا ۚ بَلْ كَانُوا لَا يَرْجُونَ نُشُورًا",
  },
  {
    id: "2896",
    sura: "25",
    VerseIDAr: "41",
    ayatAR:
      "وَإِذَا رَأَوْكَ إِنْ يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا الَّذِي بَعَثَ اللَّهُ رَسُولًا",
  },
  {
    id: "2897",
    sura: "25",
    VerseIDAr: "42",
    ayatAR:
      "إِنْ كَادَ لَيُضِلُّنَا عَنْ آلِهَتِنَا لَوْلَا أَنْ صَبَرْنَا عَلَيْهَا ۚ وَسَوْفَ يَعْلَمُونَ حِينَ يَرَوْنَ الْعَذَابَ مَنْ أَضَلُّ سَبِيلًا",
  },
  {
    id: "2898",
    sura: "25",
    VerseIDAr: "43",
    ayatAR:
      "أَرَأَيْتَ مَنِ اتَّخَذَ إِلَٰهَهُ هَوَاهُ أَفَأَنْتَ تَكُونُ عَلَيْهِ وَكِيلًا",
  },
  {
    id: "2899",
    sura: "25",
    VerseIDAr: "44",
    ayatAR:
      "أَمْ تَحْسَبُ أَنَّ أَكْثَرَهُمْ يَسْمَعُونَ أَوْ يَعْقِلُونَ ۚ إِنْ هُمْ إِلَّا كَالْأَنْعَامِ ۖ بَلْ هُمْ أَضَلُّ سَبِيلًا",
  },
  {
    id: "2900",
    sura: "25",
    VerseIDAr: "45",
    ayatAR:
      "أَلَمْ تَرَ إِلَىٰ رَبِّكَ كَيْفَ مَدَّ الظِّلَّ وَلَوْ شَاءَ لَجَعَلَهُ سَاكِنًا ثُمَّ جَعَلْنَا الشَّمْسَ عَلَيْهِ دَلِيلًا",
  },
  {
    id: "2901",
    sura: "25",
    VerseIDAr: "46",
    ayatAR: "ثُمَّ قَبَضْنَاهُ إِلَيْنَا قَبْضًا يَسِيرًا",
  },
  {
    id: "2902",
    sura: "25",
    VerseIDAr: "47",
    ayatAR:
      "وَهُوَ الَّذِي جَعَلَ لَكُمُ اللَّيْلَ لِبَاسًا وَالنَّوْمَ سُبَاتًا وَجَعَلَ النَّهَارَ نُشُورًا",
  },
  {
    id: "2903",
    sura: "25",
    VerseIDAr: "48",
    ayatAR:
      "وَهُوَ الَّذِي أَرْسَلَ الرِّيَاحَ بُشْرًا بَيْنَ يَدَيْ رَحْمَتِهِ ۚ وَأَنْزَلْنَا مِنَ السَّمَاءِ مَاءً طَهُورًا",
  },
  {
    id: "2904",
    sura: "25",
    VerseIDAr: "49",
    ayatAR:
      "لِنُحْيِيَ بِهِ بَلْدَةً مَيْتًا وَنُسْقِيَهُ مِمَّا خَلَقْنَا أَنْعَامًا وَأَنَاسِيَّ كَثِيرًا",
  },
  {
    id: "2905",
    sura: "25",
    VerseIDAr: "50",
    ayatAR:
      "وَلَقَدْ صَرَّفْنَاهُ بَيْنَهُمْ لِيَذَّكَّرُوا فَأَبَىٰ أَكْثَرُ النَّاسِ إِلَّا كُفُورًا",
  },
  {
    id: "2906",
    sura: "25",
    VerseIDAr: "51",
    ayatAR: "وَلَوْ شِئْنَا لَبَعَثْنَا فِي كُلِّ قَرْيَةٍ نَذِيرًا",
  },
  {
    id: "2907",
    sura: "25",
    VerseIDAr: "52",
    ayatAR: "فَلَا تُطِعِ الْكَافِرِينَ وَجَاهِدْهُمْ بِهِ جِهَادًا كَبِيرًا",
  },
  {
    id: "2908",
    sura: "25",
    VerseIDAr: "53",
    ayatAR:
      "وَهُوَ الَّذِي مَرَجَ الْبَحْرَيْنِ هَٰذَا عَذْبٌ فُرَاتٌ وَهَٰذَا مِلْحٌ أُجَاجٌ وَجَعَلَ بَيْنَهُمَا بَرْزَخًا وَحِجْرًا مَحْجُورًا",
  },
  {
    id: "2909",
    sura: "25",
    VerseIDAr: "54",
    ayatAR:
      "وَهُوَ الَّذِي خَلَقَ مِنَ الْمَاءِ بَشَرًا فَجَعَلَهُ نَسَبًا وَصِهْرًا ۗ وَكَانَ رَبُّكَ قَدِيرًا",
  },
  {
    id: "2910",
    sura: "25",
    VerseIDAr: "55",
    ayatAR:
      "وَيَعْبُدُونَ مِنْ دُونِ اللَّهِ مَا لَا يَنْفَعُهُمْ وَلَا يَضُرُّهُمْ ۗ وَكَانَ الْكَافِرُ عَلَىٰ رَبِّهِ ظَهِيرًا",
  },
  {
    id: "2911",
    sura: "25",
    VerseIDAr: "56",
    ayatAR: "وَمَا أَرْسَلْنَاكَ إِلَّا مُبَشِّرًا وَنَذِيرًا",
  },
  {
    id: "2912",
    sura: "25",
    VerseIDAr: "57",
    ayatAR:
      "قُلْ مَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ إِلَّا مَنْ شَاءَ أَنْ يَتَّخِذَ إِلَىٰ رَبِّهِ سَبِيلًا",
  },
  {
    id: "2913",
    sura: "25",
    VerseIDAr: "58",
    ayatAR:
      "وَتَوَكَّلْ عَلَى الْحَيِّ الَّذِي لَا يَمُوتُ وَسَبِّحْ بِحَمْدِهِ ۚ وَكَفَىٰ بِهِ بِذُنُوبِ عِبَادِهِ خَبِيرًا",
  },
  {
    id: "2914",
    sura: "25",
    VerseIDAr: "59",
    ayatAR:
      "الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا فِي سِتَّةِ أَيَّامٍ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ ۚ الرَّحْمَٰنُ فَاسْأَلْ بِهِ خَبِيرًا",
  },
  {
    id: "2915",
    sura: "25",
    VerseIDAr: "60",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمُ اسْجُدُوا لِلرَّحْمَٰنِ قَالُوا وَمَا الرَّحْمَٰنُ أَنَسْجُدُ لِمَا تَأْمُرُنَا وَزَادَهُمْ نُفُورًا ۩",
  },
  {
    id: "2916",
    sura: "25",
    VerseIDAr: "61",
    ayatAR:
      "تَبَارَكَ الَّذِي جَعَلَ فِي السَّمَاءِ بُرُوجًا وَجَعَلَ فِيهَا سِرَاجًا وَقَمَرًا مُنِيرًا",
  },
  {
    id: "2917",
    sura: "25",
    VerseIDAr: "62",
    ayatAR:
      "وَهُوَ الَّذِي جَعَلَ اللَّيْلَ وَالنَّهَارَ خِلْفَةً لِمَنْ أَرَادَ أَنْ يَذَّكَّرَ أَوْ أَرَادَ شُكُورًا",
  },
  {
    id: "2918",
    sura: "25",
    VerseIDAr: "63",
    ayatAR:
      "وَعِبَادُ الرَّحْمَٰنِ الَّذِينَ يَمْشُونَ عَلَى الْأَرْضِ هَوْنًا وَإِذَا خَاطَبَهُمُ الْجَاهِلُونَ قَالُوا سَلَامًا",
  },
  {
    id: "2919",
    sura: "25",
    VerseIDAr: "64",
    ayatAR: "وَالَّذِينَ يَبِيتُونَ لِرَبِّهِمْ سُجَّدًا وَقِيَامًا",
  },
  {
    id: "2920",
    sura: "25",
    VerseIDAr: "65",
    ayatAR:
      "وَالَّذِينَ يَقُولُونَ رَبَّنَا اصْرِفْ عَنَّا عَذَابَ جَهَنَّمَ ۖ إِنَّ عَذَابَهَا كَانَ غَرَامًا",
  },
  {
    id: "2921",
    sura: "25",
    VerseIDAr: "66",
    ayatAR: "إِنَّهَا سَاءَتْ مُسْتَقَرًّا وَمُقَامًا",
  },
  {
    id: "2922",
    sura: "25",
    VerseIDAr: "67",
    ayatAR:
      "وَالَّذِينَ إِذَا أَنْفَقُوا لَمْ يُسْرِفُوا وَلَمْ يَقْتُرُوا وَكَانَ بَيْنَ ذَٰلِكَ قَوَامًا",
  },
  {
    id: "2923",
    sura: "25",
    VerseIDAr: "68",
    ayatAR:
      "وَالَّذِينَ لَا يَدْعُونَ مَعَ اللَّهِ إِلَٰهًا آخَرَ وَلَا يَقْتُلُونَ النَّفْسَ الَّتِي حَرَّمَ اللَّهُ إِلَّا بِالْحَقِّ وَلَا يَزْنُونَ ۚ وَمَنْ يَفْعَلْ ذَٰلِكَ يَلْقَ أَثَامًا",
  },
  {
    id: "2924",
    sura: "25",
    VerseIDAr: "69",
    ayatAR:
      "يُضَاعَفْ لَهُ الْعَذَابُ يَوْمَ الْقِيَامَةِ وَيَخْلُدْ فِيهِ مُهَانًا",
  },
  {
    id: "2925",
    sura: "25",
    VerseIDAr: "70",
    ayatAR:
      "إِلَّا مَنْ تَابَ وَآمَنَ وَعَمِلَ عَمَلًا صَالِحًا فَأُولَٰئِكَ يُبَدِّلُ اللَّهُ سَيِّئَاتِهِمْ حَسَنَاتٍ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "2926",
    sura: "25",
    VerseIDAr: "71",
    ayatAR:
      "وَمَنْ تَابَ وَعَمِلَ صَالِحًا فَإِنَّهُ يَتُوبُ إِلَى اللَّهِ مَتَابًا",
  },
  {
    id: "2927",
    sura: "25",
    VerseIDAr: "72",
    ayatAR:
      "وَالَّذِينَ لَا يَشْهَدُونَ الزُّورَ وَإِذَا مَرُّوا بِاللَّغْوِ مَرُّوا كِرَامًا",
  },
  {
    id: "2928",
    sura: "25",
    VerseIDAr: "73",
    ayatAR:
      "وَالَّذِينَ إِذَا ذُكِّرُوا بِآيَاتِ رَبِّهِمْ لَمْ يَخِرُّوا عَلَيْهَا صُمًّا وَعُمْيَانًا",
  },
  {
    id: "2929",
    sura: "25",
    VerseIDAr: "74",
    ayatAR:
      "وَالَّذِينَ يَقُولُونَ رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
  },
  {
    id: "2930",
    sura: "25",
    VerseIDAr: "75",
    ayatAR:
      "أُولَٰئِكَ يُجْزَوْنَ الْغُرْفَةَ بِمَا صَبَرُوا وَيُلَقَّوْنَ فِيهَا تَحِيَّةً وَسَلَامًا",
  },
  {
    id: "2931",
    sura: "25",
    VerseIDAr: "76",
    ayatAR: "خَالِدِينَ فِيهَا ۚ حَسُنَتْ مُسْتَقَرًّا وَمُقَامًا",
  },
  {
    id: "2932",
    sura: "25",
    VerseIDAr: "77",
    ayatAR:
      "قُلْ مَا يَعْبَأُ بِكُمْ رَبِّي لَوْلَا دُعَاؤُكُمْ ۖ فَقَدْ كَذَّبْتُمْ فَسَوْفَ يَكُونُ لِزَامًا",
  },
  {
    id: "2933",
    sura: "26",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ طسم",
  },
  {
    id: "2934",
    sura: "26",
    VerseIDAr: "2",
    ayatAR: "تِلْكَ آيَاتُ الْكِتَابِ الْمُبِينِ",
  },
  {
    id: "2935",
    sura: "26",
    VerseIDAr: "3",
    ayatAR: "لَعَلَّكَ بَاخِعٌ نَفْسَكَ أَلَّا يَكُونُوا مُؤْمِنِينَ",
  },
  {
    id: "2936",
    sura: "26",
    VerseIDAr: "4",
    ayatAR:
      "إِنْ نَشَأْ نُنَزِّلْ عَلَيْهِمْ مِنَ السَّمَاءِ آيَةً فَظَلَّتْ أَعْنَاقُهُمْ لَهَا خَاضِعِينَ",
  },
  {
    id: "2937",
    sura: "26",
    VerseIDAr: "5",
    ayatAR:
      "وَمَا يَأْتِيهِمْ مِنْ ذِكْرٍ مِنَ الرَّحْمَٰنِ مُحْدَثٍ إِلَّا كَانُوا عَنْهُ مُعْرِضِينَ",
  },
  {
    id: "2938",
    sura: "26",
    VerseIDAr: "6",
    ayatAR:
      "فَقَدْ كَذَّبُوا فَسَيَأْتِيهِمْ أَنْبَاءُ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "2939",
    sura: "26",
    VerseIDAr: "7",
    ayatAR:
      "أَوَلَمْ يَرَوْا إِلَى الْأَرْضِ كَمْ أَنْبَتْنَا فِيهَا مِنْ كُلِّ زَوْجٍ كَرِيمٍ",
  },
  {
    id: "2940",
    sura: "26",
    VerseIDAr: "8",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "2941",
    sura: "26",
    VerseIDAr: "9",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "2942",
    sura: "26",
    VerseIDAr: "10",
    ayatAR: "وَإِذْ نَادَىٰ رَبُّكَ مُوسَىٰ أَنِ ائْتِ الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "2943",
    sura: "26",
    VerseIDAr: "11",
    ayatAR: "قَوْمَ فِرْعَوْنَ ۚ أَلَا يَتَّقُونَ",
  },
  {
    id: "2944",
    sura: "26",
    VerseIDAr: "12",
    ayatAR: "قَالَ رَبِّ إِنِّي أَخَافُ أَنْ يُكَذِّبُونِ",
  },
  {
    id: "2945",
    sura: "26",
    VerseIDAr: "13",
    ayatAR:
      "وَيَضِيقُ صَدْرِي وَلَا يَنْطَلِقُ لِسَانِي فَأَرْسِلْ إِلَىٰ هَارُونَ",
  },
  {
    id: "2946",
    sura: "26",
    VerseIDAr: "14",
    ayatAR: "وَلَهُمْ عَلَيَّ ذَنْبٌ فَأَخَافُ أَنْ يَقْتُلُونِ",
  },
  {
    id: "2947",
    sura: "26",
    VerseIDAr: "15",
    ayatAR:
      "قَالَ كَلَّا ۖ فَاذْهَبَا بِآيَاتِنَا ۖ إِنَّا مَعَكُمْ مُسْتَمِعُونَ",
  },
  {
    id: "2948",
    sura: "26",
    VerseIDAr: "16",
    ayatAR: "فَأْتِيَا فِرْعَوْنَ فَقُولَا إِنَّا رَسُولُ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "2949",
    sura: "26",
    VerseIDAr: "17",
    ayatAR: "أَنْ أَرْسِلْ مَعَنَا بَنِي إِسْرَائِيلَ",
  },
  {
    id: "2950",
    sura: "26",
    VerseIDAr: "18",
    ayatAR:
      "قَالَ أَلَمْ نُرَبِّكَ فِينَا وَلِيدًا وَلَبِثْتَ فِينَا مِنْ عُمُرِكَ سِنِينَ",
  },
  {
    id: "2951",
    sura: "26",
    VerseIDAr: "19",
    ayatAR:
      "وَفَعَلْتَ فَعْلَتَكَ الَّتِي فَعَلْتَ وَأَنْتَ مِنَ الْكَافِرِينَ",
  },
  {
    id: "2952",
    sura: "26",
    VerseIDAr: "20",
    ayatAR: "قَالَ فَعَلْتُهَا إِذًا وَأَنَا مِنَ الضَّالِّينَ",
  },
  {
    id: "2953",
    sura: "26",
    VerseIDAr: "21",
    ayatAR:
      "فَفَرَرْتُ مِنْكُمْ لَمَّا خِفْتُكُمْ فَوَهَبَ لِي رَبِّي حُكْمًا وَجَعَلَنِي مِنَ الْمُرْسَلِينَ",
  },
  {
    id: "2954",
    sura: "26",
    VerseIDAr: "22",
    ayatAR:
      "وَتِلْكَ نِعْمَةٌ تَمُنُّهَا عَلَيَّ أَنْ عَبَّدْتَ بَنِي إِسْرَائِيلَ",
  },
  {
    id: "2955",
    sura: "26",
    VerseIDAr: "23",
    ayatAR: "قَالَ فِرْعَوْنُ وَمَا رَبُّ الْعَالَمِينَ",
  },
  {
    id: "2956",
    sura: "26",
    VerseIDAr: "24",
    ayatAR:
      "قَالَ رَبُّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا ۖ إِنْ كُنْتُمْ مُوقِنِينَ",
  },
  {
    id: "2957",
    sura: "26",
    VerseIDAr: "25",
    ayatAR: "قَالَ لِمَنْ حَوْلَهُ أَلَا تَسْتَمِعُونَ",
  },
  {
    id: "2958",
    sura: "26",
    VerseIDAr: "26",
    ayatAR: "قَالَ رَبُّكُمْ وَرَبُّ آبَائِكُمُ الْأَوَّلِينَ",
  },
  {
    id: "2959",
    sura: "26",
    VerseIDAr: "27",
    ayatAR: "قَالَ إِنَّ رَسُولَكُمُ الَّذِي أُرْسِلَ إِلَيْكُمْ لَمَجْنُونٌ",
  },
  {
    id: "2960",
    sura: "26",
    VerseIDAr: "28",
    ayatAR:
      "قَالَ رَبُّ الْمَشْرِقِ وَالْمَغْرِبِ وَمَا بَيْنَهُمَا ۖ إِنْ كُنْتُمْ تَعْقِلُونَ",
  },
  {
    id: "2961",
    sura: "26",
    VerseIDAr: "29",
    ayatAR:
      "قَالَ لَئِنِ اتَّخَذْتَ إِلَٰهًا غَيْرِي لَأَجْعَلَنَّكَ مِنَ الْمَسْجُونِينَ",
  },
  {
    id: "2962",
    sura: "26",
    VerseIDAr: "30",
    ayatAR: "قَالَ أَوَلَوْ جِئْتُكَ بِشَيْءٍ مُبِينٍ",
  },
  {
    id: "2963",
    sura: "26",
    VerseIDAr: "31",
    ayatAR: "قَالَ فَأْتِ بِهِ إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "2964",
    sura: "26",
    VerseIDAr: "32",
    ayatAR: "فَأَلْقَىٰ عَصَاهُ فَإِذَا هِيَ ثُعْبَانٌ مُبِينٌ",
  },
  {
    id: "2965",
    sura: "26",
    VerseIDAr: "33",
    ayatAR: "وَنَزَعَ يَدَهُ فَإِذَا هِيَ بَيْضَاءُ لِلنَّاظِرِينَ",
  },
  {
    id: "2966",
    sura: "26",
    VerseIDAr: "34",
    ayatAR: "قَالَ لِلْمَلَإِ حَوْلَهُ إِنَّ هَٰذَا لَسَاحِرٌ عَلِيمٌ",
  },
  {
    id: "2967",
    sura: "26",
    VerseIDAr: "35",
    ayatAR:
      "يُرِيدُ أَنْ يُخْرِجَكُمْ مِنْ أَرْضِكُمْ بِسِحْرِهِ فَمَاذَا تَأْمُرُونَ",
  },
  {
    id: "2968",
    sura: "26",
    VerseIDAr: "36",
    ayatAR: "قَالُوا أَرْجِهْ وَأَخَاهُ وَابْعَثْ فِي الْمَدَائِنِ حَاشِرِينَ",
  },
  {
    id: "2969",
    sura: "26",
    VerseIDAr: "37",
    ayatAR: "يَأْتُوكَ بِكُلِّ سَحَّارٍ عَلِيمٍ",
  },
  {
    id: "2970",
    sura: "26",
    VerseIDAr: "38",
    ayatAR: "فَجُمِعَ السَّحَرَةُ لِمِيقَاتِ يَوْمٍ مَعْلُومٍ",
  },
  {
    id: "2971",
    sura: "26",
    VerseIDAr: "39",
    ayatAR: "وَقِيلَ لِلنَّاسِ هَلْ أَنْتُمْ مُجْتَمِعُونَ",
  },
  {
    id: "2972",
    sura: "26",
    VerseIDAr: "40",
    ayatAR: "لَعَلَّنَا نَتَّبِعُ السَّحَرَةَ إِنْ كَانُوا هُمُ الْغَالِبِينَ",
  },
  {
    id: "2973",
    sura: "26",
    VerseIDAr: "41",
    ayatAR:
      "فَلَمَّا جَاءَ السَّحَرَةُ قَالُوا لِفِرْعَوْنَ أَئِنَّ لَنَا لَأَجْرًا إِنْ كُنَّا نَحْنُ الْغَالِبِينَ",
  },
  {
    id: "2974",
    sura: "26",
    VerseIDAr: "42",
    ayatAR: "قَالَ نَعَمْ وَإِنَّكُمْ إِذًا لَمِنَ الْمُقَرَّبِينَ",
  },
  {
    id: "2975",
    sura: "26",
    VerseIDAr: "43",
    ayatAR: "قَالَ لَهُمْ مُوسَىٰ أَلْقُوا مَا أَنْتُمْ مُلْقُونَ",
  },
  {
    id: "2976",
    sura: "26",
    VerseIDAr: "44",
    ayatAR:
      "فَأَلْقَوْا حِبَالَهُمْ وَعِصِيَّهُمْ وَقَالُوا بِعِزَّةِ فِرْعَوْنَ إِنَّا لَنَحْنُ الْغَالِبُونَ",
  },
  {
    id: "2977",
    sura: "26",
    VerseIDAr: "45",
    ayatAR: "فَأَلْقَىٰ مُوسَىٰ عَصَاهُ فَإِذَا هِيَ تَلْقَفُ مَا يَأْفِكُونَ",
  },
  {
    id: "2978",
    sura: "26",
    VerseIDAr: "46",
    ayatAR: "فَأُلْقِيَ السَّحَرَةُ سَاجِدِينَ",
  },
  {
    id: "2979",
    sura: "26",
    VerseIDAr: "47",
    ayatAR: "قَالُوا آمَنَّا بِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "2980",
    sura: "26",
    VerseIDAr: "48",
    ayatAR: "رَبِّ مُوسَىٰ وَهَارُونَ",
  },
  {
    id: "2981",
    sura: "26",
    VerseIDAr: "49",
    ayatAR:
      "قَالَ آمَنْتُمْ لَهُ قَبْلَ أَنْ آذَنَ لَكُمْ ۖ إِنَّهُ لَكَبِيرُكُمُ الَّذِي عَلَّمَكُمُ السِّحْرَ فَلَسَوْفَ تَعْلَمُونَ ۚ لَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُمْ مِنْ خِلَافٍ وَلَأُصَلِّبَنَّكُمْ أَجْمَعِينَ",
  },
  {
    id: "2982",
    sura: "26",
    VerseIDAr: "50",
    ayatAR: "قَالُوا لَا ضَيْرَ ۖ إِنَّا إِلَىٰ رَبِّنَا مُنْقَلِبُونَ",
  },
  {
    id: "2983",
    sura: "26",
    VerseIDAr: "51",
    ayatAR:
      "إِنَّا نَطْمَعُ أَنْ يَغْفِرَ لَنَا رَبُّنَا خَطَايَانَا أَنْ كُنَّا أَوَّلَ الْمُؤْمِنِينَ",
  },
  {
    id: "2984",
    sura: "26",
    VerseIDAr: "52",
    ayatAR:
      "وَأَوْحَيْنَا إِلَىٰ مُوسَىٰ أَنْ أَسْرِ بِعِبَادِي إِنَّكُمْ مُتَّبَعُونَ",
  },
  {
    id: "2985",
    sura: "26",
    VerseIDAr: "53",
    ayatAR: "فَأَرْسَلَ فِرْعَوْنُ فِي الْمَدَائِنِ حَاشِرِينَ",
  },
  {
    id: "2986",
    sura: "26",
    VerseIDAr: "54",
    ayatAR: "إِنَّ هَٰؤُلَاءِ لَشِرْذِمَةٌ قَلِيلُونَ",
  },
  {
    id: "2987",
    sura: "26",
    VerseIDAr: "55",
    ayatAR: "وَإِنَّهُمْ لَنَا لَغَائِظُونَ",
  },
  {
    id: "2988",
    sura: "26",
    VerseIDAr: "56",
    ayatAR: "وَإِنَّا لَجَمِيعٌ حَاذِرُونَ",
  },
  {
    id: "2989",
    sura: "26",
    VerseIDAr: "57",
    ayatAR: "فَأَخْرَجْنَاهُمْ مِنْ جَنَّاتٍ وَعُيُونٍ",
  },
  {
    id: "2990",
    sura: "26",
    VerseIDAr: "58",
    ayatAR: "وَكُنُوزٍ وَمَقَامٍ كَرِيمٍ",
  },
  {
    id: "2991",
    sura: "26",
    VerseIDAr: "59",
    ayatAR: "كَذَٰلِكَ وَأَوْرَثْنَاهَا بَنِي إِسْرَائِيلَ",
  },
  {
    id: "2992",
    sura: "26",
    VerseIDAr: "60",
    ayatAR: "فَأَتْبَعُوهُمْ مُشْرِقِينَ",
  },
  {
    id: "2993",
    sura: "26",
    VerseIDAr: "61",
    ayatAR:
      "فَلَمَّا تَرَاءَى الْجَمْعَانِ قَالَ أَصْحَابُ مُوسَىٰ إِنَّا لَمُدْرَكُونَ",
  },
  {
    id: "2994",
    sura: "26",
    VerseIDAr: "62",
    ayatAR: "قَالَ كَلَّا ۖ إِنَّ مَعِيَ رَبِّي سَيَهْدِينِ",
  },
  {
    id: "2995",
    sura: "26",
    VerseIDAr: "63",
    ayatAR:
      "فَأَوْحَيْنَا إِلَىٰ مُوسَىٰ أَنِ اضْرِبْ بِعَصَاكَ الْبَحْرَ ۖ فَانْفَلَقَ فَكَانَ كُلُّ فِرْقٍ كَالطَّوْدِ الْعَظِيمِ",
  },
  {
    id: "2996",
    sura: "26",
    VerseIDAr: "64",
    ayatAR: "وَأَزْلَفْنَا ثَمَّ الْآخَرِينَ",
  },
  {
    id: "2997",
    sura: "26",
    VerseIDAr: "65",
    ayatAR: "وَأَنْجَيْنَا مُوسَىٰ وَمَنْ مَعَهُ أَجْمَعِينَ",
  },
  {
    id: "2998",
    sura: "26",
    VerseIDAr: "66",
    ayatAR: "ثُمَّ أَغْرَقْنَا الْآخَرِينَ",
  },
  {
    id: "2999",
    sura: "26",
    VerseIDAr: "67",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3000",
    sura: "26",
    VerseIDAr: "68",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3001",
    sura: "26",
    VerseIDAr: "69",
    ayatAR: "وَاتْلُ عَلَيْهِمْ نَبَأَ إِبْرَاهِيمَ",
  },
  {
    id: "3002",
    sura: "26",
    VerseIDAr: "70",
    ayatAR: "إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِ مَا تَعْبُدُونَ",
  },
  {
    id: "3003",
    sura: "26",
    VerseIDAr: "71",
    ayatAR: "قَالُوا نَعْبُدُ أَصْنَامًا فَنَظَلُّ لَهَا عَاكِفِينَ",
  },
  {
    id: "3004",
    sura: "26",
    VerseIDAr: "72",
    ayatAR: "قَالَ هَلْ يَسْمَعُونَكُمْ إِذْ تَدْعُونَ",
  },
  {
    id: "3005",
    sura: "26",
    VerseIDAr: "73",
    ayatAR: "أَوْ يَنْفَعُونَكُمْ أَوْ يَضُرُّونَ",
  },
  {
    id: "3006",
    sura: "26",
    VerseIDAr: "74",
    ayatAR: "قَالُوا بَلْ وَجَدْنَا آبَاءَنَا كَذَٰلِكَ يَفْعَلُونَ",
  },
  {
    id: "3007",
    sura: "26",
    VerseIDAr: "75",
    ayatAR: "قَالَ أَفَرَأَيْتُمْ مَا كُنْتُمْ تَعْبُدُونَ",
  },
  {
    id: "3008",
    sura: "26",
    VerseIDAr: "76",
    ayatAR: "أَنْتُمْ وَآبَاؤُكُمُ الْأَقْدَمُونَ",
  },
  {
    id: "3009",
    sura: "26",
    VerseIDAr: "77",
    ayatAR: "فَإِنَّهُمْ عَدُوٌّ لِي إِلَّا رَبَّ الْعَالَمِينَ",
  },
  {
    id: "3010",
    sura: "26",
    VerseIDAr: "78",
    ayatAR: "الَّذِي خَلَقَنِي فَهُوَ يَهْدِينِ",
  },
  {
    id: "3011",
    sura: "26",
    VerseIDAr: "79",
    ayatAR: "وَالَّذِي هُوَ يُطْعِمُنِي وَيَسْقِينِ",
  },
  {
    id: "3012",
    sura: "26",
    VerseIDAr: "80",
    ayatAR: "وَإِذَا مَرِضْتُ فَهُوَ يَشْفِينِ",
  },
  {
    id: "3013",
    sura: "26",
    VerseIDAr: "81",
    ayatAR: "وَالَّذِي يُمِيتُنِي ثُمَّ يُحْيِينِ",
  },
  {
    id: "3014",
    sura: "26",
    VerseIDAr: "82",
    ayatAR: "وَالَّذِي أَطْمَعُ أَنْ يَغْفِرَ لِي خَطِيئَتِي يَوْمَ الدِّينِ",
  },
  {
    id: "3015",
    sura: "26",
    VerseIDAr: "83",
    ayatAR: "رَبِّ هَبْ لِي حُكْمًا وَأَلْحِقْنِي بِالصَّالِحِينَ",
  },
  {
    id: "3016",
    sura: "26",
    VerseIDAr: "84",
    ayatAR: "وَاجْعَلْ لِي لِسَانَ صِدْقٍ فِي الْآخِرِينَ",
  },
  {
    id: "3017",
    sura: "26",
    VerseIDAr: "85",
    ayatAR: "وَاجْعَلْنِي مِنْ وَرَثَةِ جَنَّةِ النَّعِيمِ",
  },
  {
    id: "3018",
    sura: "26",
    VerseIDAr: "86",
    ayatAR: "وَاغْفِرْ لِأَبِي إِنَّهُ كَانَ مِنَ الضَّالِّينَ",
  },
  {
    id: "3019",
    sura: "26",
    VerseIDAr: "87",
    ayatAR: "وَلَا تُخْزِنِي يَوْمَ يُبْعَثُونَ",
  },
  {
    id: "3020",
    sura: "26",
    VerseIDAr: "88",
    ayatAR: "يَوْمَ لَا يَنْفَعُ مَالٌ وَلَا بَنُونَ",
  },
  {
    id: "3021",
    sura: "26",
    VerseIDAr: "89",
    ayatAR: "إِلَّا مَنْ أَتَى اللَّهَ بِقَلْبٍ سَلِيمٍ",
  },
  {
    id: "3022",
    sura: "26",
    VerseIDAr: "90",
    ayatAR: "وَأُزْلِفَتِ الْجَنَّةُ لِلْمُتَّقِينَ",
  },
  {
    id: "3023",
    sura: "26",
    VerseIDAr: "91",
    ayatAR: "وَبُرِّزَتِ الْجَحِيمُ لِلْغَاوِينَ",
  },
  {
    id: "3024",
    sura: "26",
    VerseIDAr: "92",
    ayatAR: "وَقِيلَ لَهُمْ أَيْنَ مَا كُنْتُمْ تَعْبُدُونَ",
  },
  {
    id: "3025",
    sura: "26",
    VerseIDAr: "93",
    ayatAR: "مِنْ دُونِ اللَّهِ هَلْ يَنْصُرُونَكُمْ أَوْ يَنْتَصِرُونَ",
  },
  {
    id: "3026",
    sura: "26",
    VerseIDAr: "94",
    ayatAR: "فَكُبْكِبُوا فِيهَا هُمْ وَالْغَاوُونَ",
  },
  {
    id: "3027",
    sura: "26",
    VerseIDAr: "95",
    ayatAR: "وَجُنُودُ إِبْلِيسَ أَجْمَعُونَ",
  },
  {
    id: "3028",
    sura: "26",
    VerseIDAr: "96",
    ayatAR: "قَالُوا وَهُمْ فِيهَا يَخْتَصِمُونَ",
  },
  {
    id: "3029",
    sura: "26",
    VerseIDAr: "97",
    ayatAR: "تَاللَّهِ إِنْ كُنَّا لَفِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3030",
    sura: "26",
    VerseIDAr: "98",
    ayatAR: "إِذْ نُسَوِّيكُمْ بِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "3031",
    sura: "26",
    VerseIDAr: "99",
    ayatAR: "وَمَا أَضَلَّنَا إِلَّا الْمُجْرِمُونَ",
  },
  {
    id: "3032",
    sura: "26",
    VerseIDAr: "100",
    ayatAR: "فَمَا لَنَا مِنْ شَافِعِينَ",
  },
  { id: "3033", sura: "26", VerseIDAr: "101", ayatAR: "وَلَا صَدِيقٍ حَمِيمٍ" },
  {
    id: "3034",
    sura: "26",
    VerseIDAr: "102",
    ayatAR: "فَلَوْ أَنَّ لَنَا كَرَّةً فَنَكُونَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3035",
    sura: "26",
    VerseIDAr: "103",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3036",
    sura: "26",
    VerseIDAr: "104",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3037",
    sura: "26",
    VerseIDAr: "105",
    ayatAR: "كَذَّبَتْ قَوْمُ نُوحٍ الْمُرْسَلِينَ",
  },
  {
    id: "3038",
    sura: "26",
    VerseIDAr: "106",
    ayatAR: "إِذْ قَالَ لَهُمْ أَخُوهُمْ نُوحٌ أَلَا تَتَّقُونَ",
  },
  {
    id: "3039",
    sura: "26",
    VerseIDAr: "107",
    ayatAR: "إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "3040",
    sura: "26",
    VerseIDAr: "108",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3041",
    sura: "26",
    VerseIDAr: "109",
    ayatAR:
      "وَمَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَىٰ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3042",
    sura: "26",
    VerseIDAr: "110",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3043",
    sura: "26",
    VerseIDAr: "111",
    ayatAR: "قَالُوا أَنُؤْمِنُ لَكَ وَاتَّبَعَكَ الْأَرْذَلُونَ",
  },
  {
    id: "3044",
    sura: "26",
    VerseIDAr: "112",
    ayatAR: "قَالَ وَمَا عِلْمِي بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3045",
    sura: "26",
    VerseIDAr: "113",
    ayatAR: "إِنْ حِسَابُهُمْ إِلَّا عَلَىٰ رَبِّي ۖ لَوْ تَشْعُرُونَ",
  },
  {
    id: "3046",
    sura: "26",
    VerseIDAr: "114",
    ayatAR: "وَمَا أَنَا بِطَارِدِ الْمُؤْمِنِينَ",
  },
  {
    id: "3047",
    sura: "26",
    VerseIDAr: "115",
    ayatAR: "إِنْ أَنَا إِلَّا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "3048",
    sura: "26",
    VerseIDAr: "116",
    ayatAR:
      "قَالُوا لَئِنْ لَمْ تَنْتَهِ يَا نُوحُ لَتَكُونَنَّ مِنَ الْمَرْجُومِينَ",
  },
  {
    id: "3049",
    sura: "26",
    VerseIDAr: "117",
    ayatAR: "قَالَ رَبِّ إِنَّ قَوْمِي كَذَّبُونِ",
  },
  {
    id: "3050",
    sura: "26",
    VerseIDAr: "118",
    ayatAR:
      "فَافْتَحْ بَيْنِي وَبَيْنَهُمْ فَتْحًا وَنَجِّنِي وَمَنْ مَعِيَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3051",
    sura: "26",
    VerseIDAr: "119",
    ayatAR: "فَأَنْجَيْنَاهُ وَمَنْ مَعَهُ فِي الْفُلْكِ الْمَشْحُونِ",
  },
  {
    id: "3052",
    sura: "26",
    VerseIDAr: "120",
    ayatAR: "ثُمَّ أَغْرَقْنَا بَعْدُ الْبَاقِينَ",
  },
  {
    id: "3053",
    sura: "26",
    VerseIDAr: "121",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3054",
    sura: "26",
    VerseIDAr: "122",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3055",
    sura: "26",
    VerseIDAr: "123",
    ayatAR: "كَذَّبَتْ عَادٌ الْمُرْسَلِينَ",
  },
  {
    id: "3056",
    sura: "26",
    VerseIDAr: "124",
    ayatAR: "إِذْ قَالَ لَهُمْ أَخُوهُمْ هُودٌ أَلَا تَتَّقُونَ",
  },
  {
    id: "3057",
    sura: "26",
    VerseIDAr: "125",
    ayatAR: "إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "3058",
    sura: "26",
    VerseIDAr: "126",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3059",
    sura: "26",
    VerseIDAr: "127",
    ayatAR:
      "وَمَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَىٰ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3060",
    sura: "26",
    VerseIDAr: "128",
    ayatAR: "أَتَبْنُونَ بِكُلِّ رِيعٍ آيَةً تَعْبَثُونَ",
  },
  {
    id: "3061",
    sura: "26",
    VerseIDAr: "129",
    ayatAR: "وَتَتَّخِذُونَ مَصَانِعَ لَعَلَّكُمْ تَخْلُدُونَ",
  },
  {
    id: "3062",
    sura: "26",
    VerseIDAr: "130",
    ayatAR: "وَإِذَا بَطَشْتُمْ بَطَشْتُمْ جَبَّارِينَ",
  },
  {
    id: "3063",
    sura: "26",
    VerseIDAr: "131",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3064",
    sura: "26",
    VerseIDAr: "132",
    ayatAR: "وَاتَّقُوا الَّذِي أَمَدَّكُمْ بِمَا تَعْلَمُونَ",
  },
  {
    id: "3065",
    sura: "26",
    VerseIDAr: "133",
    ayatAR: "أَمَدَّكُمْ بِأَنْعَامٍ وَبَنِينَ",
  },
  { id: "3066", sura: "26", VerseIDAr: "134", ayatAR: "وَجَنَّاتٍ وَعُيُونٍ" },
  {
    id: "3067",
    sura: "26",
    VerseIDAr: "135",
    ayatAR: "إِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "3068",
    sura: "26",
    VerseIDAr: "136",
    ayatAR:
      "قَالُوا سَوَاءٌ عَلَيْنَا أَوَعَظْتَ أَمْ لَمْ تَكُنْ مِنَ الْوَاعِظِينَ",
  },
  {
    id: "3069",
    sura: "26",
    VerseIDAr: "137",
    ayatAR: "إِنْ هَٰذَا إِلَّا خُلُقُ الْأَوَّلِينَ",
  },
  {
    id: "3070",
    sura: "26",
    VerseIDAr: "138",
    ayatAR: "وَمَا نَحْنُ بِمُعَذَّبِينَ",
  },
  {
    id: "3071",
    sura: "26",
    VerseIDAr: "139",
    ayatAR:
      "فَكَذَّبُوهُ فَأَهْلَكْنَاهُمْ ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3072",
    sura: "26",
    VerseIDAr: "140",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3073",
    sura: "26",
    VerseIDAr: "141",
    ayatAR: "كَذَّبَتْ ثَمُودُ الْمُرْسَلِينَ",
  },
  {
    id: "3074",
    sura: "26",
    VerseIDAr: "142",
    ayatAR: "إِذْ قَالَ لَهُمْ أَخُوهُمْ صَالِحٌ أَلَا تَتَّقُونَ",
  },
  {
    id: "3075",
    sura: "26",
    VerseIDAr: "143",
    ayatAR: "إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "3076",
    sura: "26",
    VerseIDAr: "144",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3077",
    sura: "26",
    VerseIDAr: "145",
    ayatAR:
      "وَمَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَىٰ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3078",
    sura: "26",
    VerseIDAr: "146",
    ayatAR: "أَتُتْرَكُونَ فِي مَا هَاهُنَا آمِنِينَ",
  },
  {
    id: "3079",
    sura: "26",
    VerseIDAr: "147",
    ayatAR: "فِي جَنَّاتٍ وَعُيُونٍ",
  },
  {
    id: "3080",
    sura: "26",
    VerseIDAr: "148",
    ayatAR: "وَزُرُوعٍ وَنَخْلٍ طَلْعُهَا هَضِيمٌ",
  },
  {
    id: "3081",
    sura: "26",
    VerseIDAr: "149",
    ayatAR: "وَتَنْحِتُونَ مِنَ الْجِبَالِ بُيُوتًا فَارِهِينَ",
  },
  {
    id: "3082",
    sura: "26",
    VerseIDAr: "150",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3083",
    sura: "26",
    VerseIDAr: "151",
    ayatAR: "وَلَا تُطِيعُوا أَمْرَ الْمُسْرِفِينَ",
  },
  {
    id: "3084",
    sura: "26",
    VerseIDAr: "152",
    ayatAR: "الَّذِينَ يُفْسِدُونَ فِي الْأَرْضِ وَلَا يُصْلِحُونَ",
  },
  {
    id: "3085",
    sura: "26",
    VerseIDAr: "153",
    ayatAR: "قَالُوا إِنَّمَا أَنْتَ مِنَ الْمُسَحَّرِينَ",
  },
  {
    id: "3086",
    sura: "26",
    VerseIDAr: "154",
    ayatAR:
      "مَا أَنْتَ إِلَّا بَشَرٌ مِثْلُنَا فَأْتِ بِآيَةٍ إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "3087",
    sura: "26",
    VerseIDAr: "155",
    ayatAR:
      "قَالَ هَٰذِهِ نَاقَةٌ لَهَا شِرْبٌ وَلَكُمْ شِرْبُ يَوْمٍ مَعْلُومٍ",
  },
  {
    id: "3088",
    sura: "26",
    VerseIDAr: "156",
    ayatAR: "وَلَا تَمَسُّوهَا بِسُوءٍ فَيَأْخُذَكُمْ عَذَابُ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "3089",
    sura: "26",
    VerseIDAr: "157",
    ayatAR: "فَعَقَرُوهَا فَأَصْبَحُوا نَادِمِينَ",
  },
  {
    id: "3090",
    sura: "26",
    VerseIDAr: "158",
    ayatAR:
      "فَأَخَذَهُمُ الْعَذَابُ ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3091",
    sura: "26",
    VerseIDAr: "159",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3092",
    sura: "26",
    VerseIDAr: "160",
    ayatAR: "كَذَّبَتْ قَوْمُ لُوطٍ الْمُرْسَلِينَ",
  },
  {
    id: "3093",
    sura: "26",
    VerseIDAr: "161",
    ayatAR: "إِذْ قَالَ لَهُمْ أَخُوهُمْ لُوطٌ أَلَا تَتَّقُونَ",
  },
  {
    id: "3094",
    sura: "26",
    VerseIDAr: "162",
    ayatAR: "إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "3095",
    sura: "26",
    VerseIDAr: "163",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3096",
    sura: "26",
    VerseIDAr: "164",
    ayatAR:
      "وَمَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَىٰ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3097",
    sura: "26",
    VerseIDAr: "165",
    ayatAR: "أَتَأْتُونَ الذُّكْرَانَ مِنَ الْعَالَمِينَ",
  },
  {
    id: "3098",
    sura: "26",
    VerseIDAr: "166",
    ayatAR:
      "وَتَذَرُونَ مَا خَلَقَ لَكُمْ رَبُّكُمْ مِنْ أَزْوَاجِكُمْ ۚ بَلْ أَنْتُمْ قَوْمٌ عَادُونَ",
  },
  {
    id: "3099",
    sura: "26",
    VerseIDAr: "167",
    ayatAR:
      "قَالُوا لَئِنْ لَمْ تَنْتَهِ يَا لُوطُ لَتَكُونَنَّ مِنَ الْمُخْرَجِينَ",
  },
  {
    id: "3100",
    sura: "26",
    VerseIDAr: "168",
    ayatAR: "قَالَ إِنِّي لِعَمَلِكُمْ مِنَ الْقَالِينَ",
  },
  {
    id: "3101",
    sura: "26",
    VerseIDAr: "169",
    ayatAR: "رَبِّ نَجِّنِي وَأَهْلِي مِمَّا يَعْمَلُونَ",
  },
  {
    id: "3102",
    sura: "26",
    VerseIDAr: "170",
    ayatAR: "فَنَجَّيْنَاهُ وَأَهْلَهُ أَجْمَعِينَ",
  },
  {
    id: "3103",
    sura: "26",
    VerseIDAr: "171",
    ayatAR: "إِلَّا عَجُوزًا فِي الْغَابِرِينَ",
  },
  {
    id: "3104",
    sura: "26",
    VerseIDAr: "172",
    ayatAR: "ثُمَّ دَمَّرْنَا الْآخَرِينَ",
  },
  {
    id: "3105",
    sura: "26",
    VerseIDAr: "173",
    ayatAR: "وَأَمْطَرْنَا عَلَيْهِمْ مَطَرًا ۖ فَسَاءَ مَطَرُ الْمُنْذَرِينَ",
  },
  {
    id: "3106",
    sura: "26",
    VerseIDAr: "174",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3107",
    sura: "26",
    VerseIDAr: "175",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3108",
    sura: "26",
    VerseIDAr: "176",
    ayatAR: "كَذَّبَ أَصْحَابُ الْأَيْكَةِ الْمُرْسَلِينَ",
  },
  {
    id: "3109",
    sura: "26",
    VerseIDAr: "177",
    ayatAR: "إِذْ قَالَ لَهُمْ شُعَيْبٌ أَلَا تَتَّقُونَ",
  },
  {
    id: "3110",
    sura: "26",
    VerseIDAr: "178",
    ayatAR: "إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "3111",
    sura: "26",
    VerseIDAr: "179",
    ayatAR: "فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "3112",
    sura: "26",
    VerseIDAr: "180",
    ayatAR:
      "وَمَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِيَ إِلَّا عَلَىٰ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3113",
    sura: "26",
    VerseIDAr: "181",
    ayatAR: "أَوْفُوا الْكَيْلَ وَلَا تَكُونُوا مِنَ الْمُخْسِرِينَ",
  },
  {
    id: "3114",
    sura: "26",
    VerseIDAr: "182",
    ayatAR: "وَزِنُوا بِالْقِسْطَاسِ الْمُسْتَقِيمِ",
  },
  {
    id: "3115",
    sura: "26",
    VerseIDAr: "183",
    ayatAR:
      "وَلَا تَبْخَسُوا النَّاسَ أَشْيَاءَهُمْ وَلَا تَعْثَوْا فِي الْأَرْضِ مُفْسِدِينَ",
  },
  {
    id: "3116",
    sura: "26",
    VerseIDAr: "184",
    ayatAR: "وَاتَّقُوا الَّذِي خَلَقَكُمْ وَالْجِبِلَّةَ الْأَوَّلِينَ",
  },
  {
    id: "3117",
    sura: "26",
    VerseIDAr: "185",
    ayatAR: "قَالُوا إِنَّمَا أَنْتَ مِنَ الْمُسَحَّرِينَ",
  },
  {
    id: "3118",
    sura: "26",
    VerseIDAr: "186",
    ayatAR:
      "وَمَا أَنْتَ إِلَّا بَشَرٌ مِثْلُنَا وَإِنْ نَظُنُّكَ لَمِنَ الْكَاذِبِينَ",
  },
  {
    id: "3119",
    sura: "26",
    VerseIDAr: "187",
    ayatAR:
      "فَأَسْقِطْ عَلَيْنَا كِسَفًا مِنَ السَّمَاءِ إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "3120",
    sura: "26",
    VerseIDAr: "188",
    ayatAR: "قَالَ رَبِّي أَعْلَمُ بِمَا تَعْمَلُونَ",
  },
  {
    id: "3121",
    sura: "26",
    VerseIDAr: "189",
    ayatAR:
      "فَكَذَّبُوهُ فَأَخَذَهُمْ عَذَابُ يَوْمِ الظُّلَّةِ ۚ إِنَّهُ كَانَ عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "3122",
    sura: "26",
    VerseIDAr: "190",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَآيَةً ۖ وَمَا كَانَ أَكْثَرُهُمْ مُؤْمِنِينَ",
  },
  {
    id: "3123",
    sura: "26",
    VerseIDAr: "191",
    ayatAR: "وَإِنَّ رَبَّكَ لَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3124",
    sura: "26",
    VerseIDAr: "192",
    ayatAR: "وَإِنَّهُ لَتَنْزِيلُ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3125",
    sura: "26",
    VerseIDAr: "193",
    ayatAR: "نَزَلَ بِهِ الرُّوحُ الْأَمِينُ",
  },
  {
    id: "3126",
    sura: "26",
    VerseIDAr: "194",
    ayatAR: "عَلَىٰ قَلْبِكَ لِتَكُونَ مِنَ الْمُنْذِرِينَ",
  },
  {
    id: "3127",
    sura: "26",
    VerseIDAr: "195",
    ayatAR: "بِلِسَانٍ عَرَبِيٍّ مُبِينٍ",
  },
  {
    id: "3128",
    sura: "26",
    VerseIDAr: "196",
    ayatAR: "وَإِنَّهُ لَفِي زُبُرِ الْأَوَّلِينَ",
  },
  {
    id: "3129",
    sura: "26",
    VerseIDAr: "197",
    ayatAR:
      "أَوَلَمْ يَكُنْ لَهُمْ آيَةً أَنْ يَعْلَمَهُ عُلَمَاءُ بَنِي إِسْرَائِيلَ",
  },
  {
    id: "3130",
    sura: "26",
    VerseIDAr: "198",
    ayatAR: "وَلَوْ نَزَّلْنَاهُ عَلَىٰ بَعْضِ الْأَعْجَمِينَ",
  },
  {
    id: "3131",
    sura: "26",
    VerseIDAr: "199",
    ayatAR: "فَقَرَأَهُ عَلَيْهِمْ مَا كَانُوا بِهِ مُؤْمِنِينَ",
  },
  {
    id: "3132",
    sura: "26",
    VerseIDAr: "200",
    ayatAR: "كَذَٰلِكَ سَلَكْنَاهُ فِي قُلُوبِ الْمُجْرِمِينَ",
  },
  {
    id: "3133",
    sura: "26",
    VerseIDAr: "201",
    ayatAR: "لَا يُؤْمِنُونَ بِهِ حَتَّىٰ يَرَوُا الْعَذَابَ الْأَلِيمَ",
  },
  {
    id: "3134",
    sura: "26",
    VerseIDAr: "202",
    ayatAR: "فَيَأْتِيَهُمْ بَغْتَةً وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3135",
    sura: "26",
    VerseIDAr: "203",
    ayatAR: "فَيَقُولُوا هَلْ نَحْنُ مُنْظَرُونَ",
  },
  {
    id: "3136",
    sura: "26",
    VerseIDAr: "204",
    ayatAR: "أَفَبِعَذَابِنَا يَسْتَعْجِلُونَ",
  },
  {
    id: "3137",
    sura: "26",
    VerseIDAr: "205",
    ayatAR: "أَفَرَأَيْتَ إِنْ مَتَّعْنَاهُمْ سِنِينَ",
  },
  {
    id: "3138",
    sura: "26",
    VerseIDAr: "206",
    ayatAR: "ثُمَّ جَاءَهُمْ مَا كَانُوا يُوعَدُونَ",
  },
  {
    id: "3139",
    sura: "26",
    VerseIDAr: "207",
    ayatAR: "مَا أَغْنَىٰ عَنْهُمْ مَا كَانُوا يُمَتَّعُونَ",
  },
  {
    id: "3140",
    sura: "26",
    VerseIDAr: "208",
    ayatAR: "وَمَا أَهْلَكْنَا مِنْ قَرْيَةٍ إِلَّا لَهَا مُنْذِرُونَ",
  },
  {
    id: "3141",
    sura: "26",
    VerseIDAr: "209",
    ayatAR: "ذِكْرَىٰ وَمَا كُنَّا ظَالِمِينَ",
  },
  {
    id: "3142",
    sura: "26",
    VerseIDAr: "210",
    ayatAR: "وَمَا تَنَزَّلَتْ بِهِ الشَّيَاطِينُ",
  },
  {
    id: "3143",
    sura: "26",
    VerseIDAr: "211",
    ayatAR: "وَمَا يَنْبَغِي لَهُمْ وَمَا يَسْتَطِيعُونَ",
  },
  {
    id: "3144",
    sura: "26",
    VerseIDAr: "212",
    ayatAR: "إِنَّهُمْ عَنِ السَّمْعِ لَمَعْزُولُونَ",
  },
  {
    id: "3145",
    sura: "26",
    VerseIDAr: "213",
    ayatAR:
      "فَلَا تَدْعُ مَعَ اللَّهِ إِلَٰهًا آخَرَ فَتَكُونَ مِنَ الْمُعَذَّبِينَ",
  },
  {
    id: "3146",
    sura: "26",
    VerseIDAr: "214",
    ayatAR: "وَأَنْذِرْ عَشِيرَتَكَ الْأَقْرَبِينَ",
  },
  {
    id: "3147",
    sura: "26",
    VerseIDAr: "215",
    ayatAR: "وَاخْفِضْ جَنَاحَكَ لِمَنِ اتَّبَعَكَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3148",
    sura: "26",
    VerseIDAr: "216",
    ayatAR: "فَإِنْ عَصَوْكَ فَقُلْ إِنِّي بَرِيءٌ مِمَّا تَعْمَلُونَ",
  },
  {
    id: "3149",
    sura: "26",
    VerseIDAr: "217",
    ayatAR: "وَتَوَكَّلْ عَلَى الْعَزِيزِ الرَّحِيمِ",
  },
  {
    id: "3150",
    sura: "26",
    VerseIDAr: "218",
    ayatAR: "الَّذِي يَرَاكَ حِينَ تَقُومُ",
  },
  {
    id: "3151",
    sura: "26",
    VerseIDAr: "219",
    ayatAR: "وَتَقَلُّبَكَ فِي السَّاجِدِينَ",
  },
  {
    id: "3152",
    sura: "26",
    VerseIDAr: "220",
    ayatAR: "إِنَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "3153",
    sura: "26",
    VerseIDAr: "221",
    ayatAR: "هَلْ أُنَبِّئُكُمْ عَلَىٰ مَنْ تَنَزَّلُ الشَّيَاطِينُ",
  },
  {
    id: "3154",
    sura: "26",
    VerseIDAr: "222",
    ayatAR: "تَنَزَّلُ عَلَىٰ كُلِّ أَفَّاكٍ أَثِيمٍ",
  },
  {
    id: "3155",
    sura: "26",
    VerseIDAr: "223",
    ayatAR: "يُلْقُونَ السَّمْعَ وَأَكْثَرُهُمْ كَاذِبُونَ",
  },
  {
    id: "3156",
    sura: "26",
    VerseIDAr: "224",
    ayatAR: "وَالشُّعَرَاءُ يَتَّبِعُهُمُ الْغَاوُونَ",
  },
  {
    id: "3157",
    sura: "26",
    VerseIDAr: "225",
    ayatAR: "أَلَمْ تَرَ أَنَّهُمْ فِي كُلِّ وَادٍ يَهِيمُونَ",
  },
  {
    id: "3158",
    sura: "26",
    VerseIDAr: "226",
    ayatAR: "وَأَنَّهُمْ يَقُولُونَ مَا لَا يَفْعَلُونَ",
  },
  {
    id: "3159",
    sura: "26",
    VerseIDAr: "227",
    ayatAR:
      "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَذَكَرُوا اللَّهَ كَثِيرًا وَانْتَصَرُوا مِنْ بَعْدِ مَا ظُلِمُوا ۗ وَسَيَعْلَمُ الَّذِينَ ظَلَمُوا أَيَّ مُنْقَلَبٍ يَنْقَلِبُونَ",
  },
  {
    id: "3160",
    sura: "27",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ طس ۚ تِلْكَ آيَاتُ الْقُرْآنِ وَكِتَابٍ مُبِينٍ",
  },
  {
    id: "3161",
    sura: "27",
    VerseIDAr: "2",
    ayatAR: "هُدًى وَبُشْرَىٰ لِلْمُؤْمِنِينَ",
  },
  {
    id: "3162",
    sura: "27",
    VerseIDAr: "3",
    ayatAR:
      "الَّذِينَ يُقِيمُونَ الصَّلَاةَ وَيُؤْتُونَ الزَّكَاةَ وَهُمْ بِالْآخِرَةِ هُمْ يُوقِنُونَ",
  },
  {
    id: "3163",
    sura: "27",
    VerseIDAr: "4",
    ayatAR:
      "إِنَّ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ زَيَّنَّا لَهُمْ أَعْمَالَهُمْ فَهُمْ يَعْمَهُونَ",
  },
  {
    id: "3164",
    sura: "27",
    VerseIDAr: "5",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ لَهُمْ سُوءُ الْعَذَابِ وَهُمْ فِي الْآخِرَةِ هُمُ الْأَخْسَرُونَ",
  },
  {
    id: "3165",
    sura: "27",
    VerseIDAr: "6",
    ayatAR: "وَإِنَّكَ لَتُلَقَّى الْقُرْآنَ مِنْ لَدُنْ حَكِيمٍ عَلِيمٍ",
  },
  {
    id: "3166",
    sura: "27",
    VerseIDAr: "7",
    ayatAR:
      "إِذْ قَالَ مُوسَىٰ لِأَهْلِهِ إِنِّي آنَسْتُ نَارًا سَآتِيكُمْ مِنْهَا بِخَبَرٍ أَوْ آتِيكُمْ بِشِهَابٍ قَبَسٍ لَعَلَّكُمْ تَصْطَلُونَ",
  },
  {
    id: "3167",
    sura: "27",
    VerseIDAr: "8",
    ayatAR:
      "فَلَمَّا جَاءَهَا نُودِيَ أَنْ بُورِكَ مَنْ فِي النَّارِ وَمَنْ حَوْلَهَا وَسُبْحَانَ اللَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3168",
    sura: "27",
    VerseIDAr: "9",
    ayatAR: "يَا مُوسَىٰ إِنَّهُ أَنَا اللَّهُ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3169",
    sura: "27",
    VerseIDAr: "10",
    ayatAR:
      "وَأَلْقِ عَصَاكَ ۚ فَلَمَّا رَآهَا تَهْتَزُّ كَأَنَّهَا جَانٌّ وَلَّىٰ مُدْبِرًا وَلَمْ يُعَقِّبْ ۚ يَا مُوسَىٰ لَا تَخَفْ إِنِّي لَا يَخَافُ لَدَيَّ الْمُرْسَلُونَ",
  },
  {
    id: "3170",
    sura: "27",
    VerseIDAr: "11",
    ayatAR:
      "إِلَّا مَنْ ظَلَمَ ثُمَّ بَدَّلَ حُسْنًا بَعْدَ سُوءٍ فَإِنِّي غَفُورٌ رَحِيمٌ",
  },
  {
    id: "3171",
    sura: "27",
    VerseIDAr: "12",
    ayatAR:
      "وَأَدْخِلْ يَدَكَ فِي جَيْبِكَ تَخْرُجْ بَيْضَاءَ مِنْ غَيْرِ سُوءٍ ۖ فِي تِسْعِ آيَاتٍ إِلَىٰ فِرْعَوْنَ وَقَوْمِهِ ۚ إِنَّهُمْ كَانُوا قَوْمًا فَاسِقِينَ",
  },
  {
    id: "3172",
    sura: "27",
    VerseIDAr: "13",
    ayatAR:
      "فَلَمَّا جَاءَتْهُمْ آيَاتُنَا مُبْصِرَةً قَالُوا هَٰذَا سِحْرٌ مُبِينٌ",
  },
  {
    id: "3173",
    sura: "27",
    VerseIDAr: "14",
    ayatAR:
      "وَجَحَدُوا بِهَا وَاسْتَيْقَنَتْهَا أَنْفُسُهُمْ ظُلْمًا وَعُلُوًّا ۚ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُفْسِدِينَ",
  },
  {
    id: "3174",
    sura: "27",
    VerseIDAr: "15",
    ayatAR:
      "وَلَقَدْ آتَيْنَا دَاوُودَ وَسُلَيْمَانَ عِلْمًا ۖ وَقَالَا الْحَمْدُ لِلَّهِ الَّذِي فَضَّلَنَا عَلَىٰ كَثِيرٍ مِنْ عِبَادِهِ الْمُؤْمِنِينَ",
  },
  {
    id: "3175",
    sura: "27",
    VerseIDAr: "16",
    ayatAR:
      "وَوَرِثَ سُلَيْمَانُ دَاوُودَ ۖ وَقَالَ يَا أَيُّهَا النَّاسُ عُلِّمْنَا مَنْطِقَ الطَّيْرِ وَأُوتِينَا مِنْ كُلِّ شَيْءٍ ۖ إِنَّ هَٰذَا لَهُوَ الْفَضْلُ الْمُبِينُ",
  },
  {
    id: "3176",
    sura: "27",
    VerseIDAr: "17",
    ayatAR:
      "وَحُشِرَ لِسُلَيْمَانَ جُنُودُهُ مِنَ الْجِنِّ وَالْإِنْسِ وَالطَّيْرِ فَهُمْ يُوزَعُونَ",
  },
  {
    id: "3177",
    sura: "27",
    VerseIDAr: "18",
    ayatAR:
      "حَتَّىٰ إِذَا أَتَوْا عَلَىٰ وَادِ النَّمْلِ قَالَتْ نَمْلَةٌ يَا أَيُّهَا النَّمْلُ ادْخُلُوا مَسَاكِنَكُمْ لَا يَحْطِمَنَّكُمْ سُلَيْمَانُ وَجُنُودُهُ وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3178",
    sura: "27",
    VerseIDAr: "19",
    ayatAR:
      "فَتَبَسَّمَ ضَاحِكًا مِنْ قَوْلِهَا وَقَالَ رَبِّ أَوْزِعْنِي أَنْ أَشْكُرَ نِعْمَتَكَ الَّتِي أَنْعَمْتَ عَلَيَّ وَعَلَىٰ وَالِدَيَّ وَأَنْ أَعْمَلَ صَالِحًا تَرْضَاهُ وَأَدْخِلْنِي بِرَحْمَتِكَ فِي عِبَادِكَ الصَّالِحِينَ",
  },
  {
    id: "3179",
    sura: "27",
    VerseIDAr: "20",
    ayatAR:
      "وَتَفَقَّدَ الطَّيْرَ فَقَالَ مَا لِيَ لَا أَرَى الْهُدْهُدَ أَمْ كَانَ مِنَ الْغَائِبِينَ",
  },
  {
    id: "3180",
    sura: "27",
    VerseIDAr: "21",
    ayatAR:
      "لَأُعَذِّبَنَّهُ عَذَابًا شَدِيدًا أَوْ لَأَذْبَحَنَّهُ أَوْ لَيَأْتِيَنِّي بِسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "3181",
    sura: "27",
    VerseIDAr: "22",
    ayatAR:
      "فَمَكَثَ غَيْرَ بَعِيدٍ فَقَالَ أَحَطْتُ بِمَا لَمْ تُحِطْ بِهِ وَجِئْتُكَ مِنْ سَبَإٍ بِنَبَإٍ يَقِينٍ",
  },
  {
    id: "3182",
    sura: "27",
    VerseIDAr: "23",
    ayatAR:
      "إِنِّي وَجَدْتُ امْرَأَةً تَمْلِكُهُمْ وَأُوتِيَتْ مِنْ كُلِّ شَيْءٍ وَلَهَا عَرْشٌ عَظِيمٌ",
  },
  {
    id: "3183",
    sura: "27",
    VerseIDAr: "24",
    ayatAR:
      "وَجَدْتُهَا وَقَوْمَهَا يَسْجُدُونَ لِلشَّمْسِ مِنْ دُونِ اللَّهِ وَزَيَّنَ لَهُمُ الشَّيْطَانُ أَعْمَالَهُمْ فَصَدَّهُمْ عَنِ السَّبِيلِ فَهُمْ لَا يَهْتَدُونَ",
  },
  {
    id: "3184",
    sura: "27",
    VerseIDAr: "25",
    ayatAR:
      "أَلَّا يَسْجُدُوا لِلَّهِ الَّذِي يُخْرِجُ الْخَبْءَ فِي السَّمَاوَاتِ وَالْأَرْضِ وَيَعْلَمُ مَا تُخْفُونَ وَمَا تُعْلِنُونَ",
  },
  {
    id: "3185",
    sura: "27",
    VerseIDAr: "26",
    ayatAR: "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ رَبُّ الْعَرْشِ الْعَظِيمِ ۩",
  },
  {
    id: "3186",
    sura: "27",
    VerseIDAr: "27",
    ayatAR: "قَالَ سَنَنْظُرُ أَصَدَقْتَ أَمْ كُنْتَ مِنَ الْكَاذِبِينَ",
  },
  {
    id: "3187",
    sura: "27",
    VerseIDAr: "28",
    ayatAR:
      "اذْهَبْ بِكِتَابِي هَٰذَا فَأَلْقِهْ إِلَيْهِمْ ثُمَّ تَوَلَّ عَنْهُمْ فَانْظُرْ مَاذَا يَرْجِعُونَ",
  },
  {
    id: "3188",
    sura: "27",
    VerseIDAr: "29",
    ayatAR:
      "قَالَتْ يَا أَيُّهَا الْمَلَأُ إِنِّي أُلْقِيَ إِلَيَّ كِتَابٌ كَرِيمٌ",
  },
  {
    id: "3189",
    sura: "27",
    VerseIDAr: "30",
    ayatAR:
      "إِنَّهُ مِنْ سُلَيْمَانَ وَإِنَّهُ بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  },
  {
    id: "3190",
    sura: "27",
    VerseIDAr: "31",
    ayatAR: "أَلَّا تَعْلُوا عَلَيَّ وَأْتُونِي مُسْلِمِينَ",
  },
  {
    id: "3191",
    sura: "27",
    VerseIDAr: "32",
    ayatAR:
      "قَالَتْ يَا أَيُّهَا الْمَلَأُ أَفْتُونِي فِي أَمْرِي مَا كُنْتُ قَاطِعَةً أَمْرًا حَتَّىٰ تَشْهَدُونِ",
  },
  {
    id: "3192",
    sura: "27",
    VerseIDAr: "33",
    ayatAR:
      "قَالُوا نَحْنُ أُولُو قُوَّةٍ وَأُولُو بَأْسٍ شَدِيدٍ وَالْأَمْرُ إِلَيْكِ فَانْظُرِي مَاذَا تَأْمُرِينَ",
  },
  {
    id: "3193",
    sura: "27",
    VerseIDAr: "34",
    ayatAR:
      "قَالَتْ إِنَّ الْمُلُوكَ إِذَا دَخَلُوا قَرْيَةً أَفْسَدُوهَا وَجَعَلُوا أَعِزَّةَ أَهْلِهَا أَذِلَّةً ۖ وَكَذَٰلِكَ يَفْعَلُونَ",
  },
  {
    id: "3194",
    sura: "27",
    VerseIDAr: "35",
    ayatAR:
      "وَإِنِّي مُرْسِلَةٌ إِلَيْهِمْ بِهَدِيَّةٍ فَنَاظِرَةٌ بِمَ يَرْجِعُ الْمُرْسَلُونَ",
  },
  {
    id: "3195",
    sura: "27",
    VerseIDAr: "36",
    ayatAR:
      "فَلَمَّا جَاءَ سُلَيْمَانَ قَالَ أَتُمِدُّونَنِ بِمَالٍ فَمَا آتَانِيَ اللَّهُ خَيْرٌ مِمَّا آتَاكُمْ بَلْ أَنْتُمْ بِهَدِيَّتِكُمْ تَفْرَحُونَ",
  },
  {
    id: "3196",
    sura: "27",
    VerseIDAr: "37",
    ayatAR:
      "ارْجِعْ إِلَيْهِمْ فَلَنَأْتِيَنَّهُمْ بِجُنُودٍ لَا قِبَلَ لَهُمْ بِهَا وَلَنُخْرِجَنَّهُمْ مِنْهَا أَذِلَّةً وَهُمْ صَاغِرُونَ",
  },
  {
    id: "3197",
    sura: "27",
    VerseIDAr: "38",
    ayatAR:
      "قَالَ يَا أَيُّهَا الْمَلَأُ أَيُّكُمْ يَأْتِينِي بِعَرْشِهَا قَبْلَ أَنْ يَأْتُونِي مُسْلِمِينَ",
  },
  {
    id: "3198",
    sura: "27",
    VerseIDAr: "39",
    ayatAR:
      "قَالَ عِفْرِيتٌ مِنَ الْجِنِّ أَنَا آتِيكَ بِهِ قَبْلَ أَنْ تَقُومَ مِنْ مَقَامِكَ ۖ وَإِنِّي عَلَيْهِ لَقَوِيٌّ أَمِينٌ",
  },
  {
    id: "3199",
    sura: "27",
    VerseIDAr: "40",
    ayatAR:
      "قَالَ الَّذِي عِنْدَهُ عِلْمٌ مِنَ الْكِتَابِ أَنَا آتِيكَ بِهِ قَبْلَ أَنْ يَرْتَدَّ إِلَيْكَ طَرْفُكَ ۚ فَلَمَّا رَآهُ مُسْتَقِرًّا عِنْدَهُ قَالَ هَٰذَا مِنْ فَضْلِ رَبِّي لِيَبْلُوَنِي أَأَشْكُرُ أَمْ أَكْفُرُ ۖ وَمَنْ شَكَرَ فَإِنَّمَا يَشْكُرُ لِنَفْسِهِ ۖ وَمَنْ كَفَرَ فَإِنَّ رَبِّي غَنِيٌّ كَرِيمٌ",
  },
  {
    id: "3200",
    sura: "27",
    VerseIDAr: "41",
    ayatAR:
      "قَالَ نَكِّرُوا لَهَا عَرْشَهَا نَنْظُرْ أَتَهْتَدِي أَمْ تَكُونُ مِنَ الَّذِينَ لَا يَهْتَدُونَ",
  },
  {
    id: "3201",
    sura: "27",
    VerseIDAr: "42",
    ayatAR:
      "فَلَمَّا جَاءَتْ قِيلَ أَهَٰكَذَا عَرْشُكِ ۖ قَالَتْ كَأَنَّهُ هُوَ ۚ وَأُوتِينَا الْعِلْمَ مِنْ قَبْلِهَا وَكُنَّا مُسْلِمِينَ",
  },
  {
    id: "3202",
    sura: "27",
    VerseIDAr: "43",
    ayatAR:
      "وَصَدَّهَا مَا كَانَتْ تَعْبُدُ مِنْ دُونِ اللَّهِ ۖ إِنَّهَا كَانَتْ مِنْ قَوْمٍ كَافِرِينَ",
  },
  {
    id: "3203",
    sura: "27",
    VerseIDAr: "44",
    ayatAR:
      "قِيلَ لَهَا ادْخُلِي الصَّرْحَ ۖ فَلَمَّا رَأَتْهُ حَسِبَتْهُ لُجَّةً وَكَشَفَتْ عَنْ سَاقَيْهَا ۚ قَالَ إِنَّهُ صَرْحٌ مُمَرَّدٌ مِنْ قَوَارِيرَ ۗ قَالَتْ رَبِّ إِنِّي ظَلَمْتُ نَفْسِي وَأَسْلَمْتُ مَعَ سُلَيْمَانَ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3204",
    sura: "27",
    VerseIDAr: "45",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا إِلَىٰ ثَمُودَ أَخَاهُمْ صَالِحًا أَنِ اعْبُدُوا اللَّهَ فَإِذَا هُمْ فَرِيقَانِ يَخْتَصِمُونَ",
  },
  {
    id: "3205",
    sura: "27",
    VerseIDAr: "46",
    ayatAR:
      "قَالَ يَا قَوْمِ لِمَ تَسْتَعْجِلُونَ بِالسَّيِّئَةِ قَبْلَ الْحَسَنَةِ ۖ لَوْلَا تَسْتَغْفِرُونَ اللَّهَ لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "3206",
    sura: "27",
    VerseIDAr: "47",
    ayatAR:
      "قَالُوا اطَّيَّرْنَا بِكَ وَبِمَنْ مَعَكَ ۚ قَالَ طَائِرُكُمْ عِنْدَ اللَّهِ ۖ بَلْ أَنْتُمْ قَوْمٌ تُفْتَنُونَ",
  },
  {
    id: "3207",
    sura: "27",
    VerseIDAr: "48",
    ayatAR:
      "وَكَانَ فِي الْمَدِينَةِ تِسْعَةُ رَهْطٍ يُفْسِدُونَ فِي الْأَرْضِ وَلَا يُصْلِحُونَ",
  },
  {
    id: "3208",
    sura: "27",
    VerseIDAr: "49",
    ayatAR:
      "قَالُوا تَقَاسَمُوا بِاللَّهِ لَنُبَيِّتَنَّهُ وَأَهْلَهُ ثُمَّ لَنَقُولَنَّ لِوَلِيِّهِ مَا شَهِدْنَا مَهْلِكَ أَهْلِهِ وَإِنَّا لَصَادِقُونَ",
  },
  {
    id: "3209",
    sura: "27",
    VerseIDAr: "50",
    ayatAR: "وَمَكَرُوا مَكْرًا وَمَكَرْنَا مَكْرًا وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3210",
    sura: "27",
    VerseIDAr: "51",
    ayatAR:
      "فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ مَكْرِهِمْ أَنَّا دَمَّرْنَاهُمْ وَقَوْمَهُمْ أَجْمَعِينَ",
  },
  {
    id: "3211",
    sura: "27",
    VerseIDAr: "52",
    ayatAR:
      "فَتِلْكَ بُيُوتُهُمْ خَاوِيَةً بِمَا ظَلَمُوا ۗ إِنَّ فِي ذَٰلِكَ لَآيَةً لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "3212",
    sura: "27",
    VerseIDAr: "53",
    ayatAR: "وَأَنْجَيْنَا الَّذِينَ آمَنُوا وَكَانُوا يَتَّقُونَ",
  },
  {
    id: "3213",
    sura: "27",
    VerseIDAr: "54",
    ayatAR:
      "وَلُوطًا إِذْ قَالَ لِقَوْمِهِ أَتَأْتُونَ الْفَاحِشَةَ وَأَنْتُمْ تُبْصِرُونَ",
  },
  {
    id: "3214",
    sura: "27",
    VerseIDAr: "55",
    ayatAR:
      "أَئِنَّكُمْ لَتَأْتُونَ الرِّجَالَ شَهْوَةً مِنْ دُونِ النِّسَاءِ ۚ بَلْ أَنْتُمْ قَوْمٌ تَجْهَلُونَ",
  },
  {
    id: "3215",
    sura: "27",
    VerseIDAr: "56",
    ayatAR:
      "فَمَا كَانَ جَوَابَ قَوْمِهِ إِلَّا أَنْ قَالُوا أَخْرِجُوا آلَ لُوطٍ مِنْ قَرْيَتِكُمْ ۖ إِنَّهُمْ أُنَاسٌ يَتَطَهَّرُونَ",
  },
  {
    id: "3216",
    sura: "27",
    VerseIDAr: "57",
    ayatAR:
      "فَأَنْجَيْنَاهُ وَأَهْلَهُ إِلَّا امْرَأَتَهُ قَدَّرْنَاهَا مِنَ الْغَابِرِينَ",
  },
  {
    id: "3217",
    sura: "27",
    VerseIDAr: "58",
    ayatAR: "وَأَمْطَرْنَا عَلَيْهِمْ مَطَرًا ۖ فَسَاءَ مَطَرُ الْمُنْذَرِينَ",
  },
  {
    id: "3218",
    sura: "27",
    VerseIDAr: "59",
    ayatAR:
      "قُلِ الْحَمْدُ لِلَّهِ وَسَلَامٌ عَلَىٰ عِبَادِهِ الَّذِينَ اصْطَفَىٰ ۗ آللَّهُ خَيْرٌ أَمَّا يُشْرِكُونَ",
  },
  {
    id: "3219",
    sura: "27",
    VerseIDAr: "60",
    ayatAR:
      "أَمَّنْ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَأَنْزَلَ لَكُمْ مِنَ السَّمَاءِ مَاءً فَأَنْبَتْنَا بِهِ حَدَائِقَ ذَاتَ بَهْجَةٍ مَا كَانَ لَكُمْ أَنْ تُنْبِتُوا شَجَرَهَا ۗ أَإِلَٰهٌ مَعَ اللَّهِ ۚ بَلْ هُمْ قَوْمٌ يَعْدِلُونَ",
  },
  {
    id: "3220",
    sura: "27",
    VerseIDAr: "61",
    ayatAR:
      "أَمَّنْ جَعَلَ الْأَرْضَ قَرَارًا وَجَعَلَ خِلَالَهَا أَنْهَارًا وَجَعَلَ لَهَا رَوَاسِيَ وَجَعَلَ بَيْنَ الْبَحْرَيْنِ حَاجِزًا ۗ أَإِلَٰهٌ مَعَ اللَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "3221",
    sura: "27",
    VerseIDAr: "62",
    ayatAR:
      "أَمَّنْ يُجِيبُ الْمُضْطَرَّ إِذَا دَعَاهُ وَيَكْشِفُ السُّوءَ وَيَجْعَلُكُمْ خُلَفَاءَ الْأَرْضِ ۗ أَإِلَٰهٌ مَعَ اللَّهِ ۚ قَلِيلًا مَا تَذَكَّرُونَ",
  },
  {
    id: "3222",
    sura: "27",
    VerseIDAr: "63",
    ayatAR:
      "أَمَّنْ يَهْدِيكُمْ فِي ظُلُمَاتِ الْبَرِّ وَالْبَحْرِ وَمَنْ يُرْسِلُ الرِّيَاحَ بُشْرًا بَيْنَ يَدَيْ رَحْمَتِهِ ۗ أَإِلَٰهٌ مَعَ اللَّهِ ۚ تَعَالَى اللَّهُ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "3223",
    sura: "27",
    VerseIDAr: "64",
    ayatAR:
      "أَمَّنْ يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ وَمَنْ يَرْزُقُكُمْ مِنَ السَّمَاءِ وَالْأَرْضِ ۗ أَإِلَٰهٌ مَعَ اللَّهِ ۚ قُلْ هَاتُوا بُرْهَانَكُمْ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3224",
    sura: "27",
    VerseIDAr: "65",
    ayatAR:
      "قُلْ لَا يَعْلَمُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ الْغَيْبَ إِلَّا اللَّهُ ۚ وَمَا يَشْعُرُونَ أَيَّانَ يُبْعَثُونَ",
  },
  {
    id: "3225",
    sura: "27",
    VerseIDAr: "66",
    ayatAR:
      "بَلِ ادَّارَكَ عِلْمُهُمْ فِي الْآخِرَةِ ۚ بَلْ هُمْ فِي شَكٍّ مِنْهَا ۖ بَلْ هُمْ مِنْهَا عَمُونَ",
  },
  {
    id: "3226",
    sura: "27",
    VerseIDAr: "67",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا أَإِذَا كُنَّا تُرَابًا وَآبَاؤُنَا أَئِنَّا لَمُخْرَجُونَ",
  },
  {
    id: "3227",
    sura: "27",
    VerseIDAr: "68",
    ayatAR:
      "لَقَدْ وُعِدْنَا هَٰذَا نَحْنُ وَآبَاؤُنَا مِنْ قَبْلُ إِنْ هَٰذَا إِلَّا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "3228",
    sura: "27",
    VerseIDAr: "69",
    ayatAR:
      "قُلْ سِيرُوا فِي الْأَرْضِ فَانْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الْمُجْرِمِينَ",
  },
  {
    id: "3229",
    sura: "27",
    VerseIDAr: "70",
    ayatAR:
      "وَلَا تَحْزَنْ عَلَيْهِمْ وَلَا تَكُنْ فِي ضَيْقٍ مِمَّا يَمْكُرُونَ",
  },
  {
    id: "3230",
    sura: "27",
    VerseIDAr: "71",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3231",
    sura: "27",
    VerseIDAr: "72",
    ayatAR:
      "قُلْ عَسَىٰ أَنْ يَكُونَ رَدِفَ لَكُمْ بَعْضُ الَّذِي تَسْتَعْجِلُونَ",
  },
  {
    id: "3232",
    sura: "27",
    VerseIDAr: "73",
    ayatAR:
      "وَإِنَّ رَبَّكَ لَذُو فَضْلٍ عَلَى النَّاسِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَشْكُرُونَ",
  },
  {
    id: "3233",
    sura: "27",
    VerseIDAr: "74",
    ayatAR:
      "وَإِنَّ رَبَّكَ لَيَعْلَمُ مَا تُكِنُّ صُدُورُهُمْ وَمَا يُعْلِنُونَ",
  },
  {
    id: "3234",
    sura: "27",
    VerseIDAr: "75",
    ayatAR:
      "وَمَا مِنْ غَائِبَةٍ فِي السَّمَاءِ وَالْأَرْضِ إِلَّا فِي كِتَابٍ مُبِينٍ",
  },
  {
    id: "3235",
    sura: "27",
    VerseIDAr: "76",
    ayatAR:
      "إِنَّ هَٰذَا الْقُرْآنَ يَقُصُّ عَلَىٰ بَنِي إِسْرَائِيلَ أَكْثَرَ الَّذِي هُمْ فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "3236",
    sura: "27",
    VerseIDAr: "77",
    ayatAR: "وَإِنَّهُ لَهُدًى وَرَحْمَةٌ لِلْمُؤْمِنِينَ",
  },
  {
    id: "3237",
    sura: "27",
    VerseIDAr: "78",
    ayatAR:
      "إِنَّ رَبَّكَ يَقْضِي بَيْنَهُمْ بِحُكْمِهِ ۚ وَهُوَ الْعَزِيزُ الْعَلِيمُ",
  },
  {
    id: "3238",
    sura: "27",
    VerseIDAr: "79",
    ayatAR: "فَتَوَكَّلْ عَلَى اللَّهِ ۖ إِنَّكَ عَلَى الْحَقِّ الْمُبِينِ",
  },
  {
    id: "3239",
    sura: "27",
    VerseIDAr: "80",
    ayatAR:
      "إِنَّكَ لَا تُسْمِعُ الْمَوْتَىٰ وَلَا تُسْمِعُ الصُّمَّ الدُّعَاءَ إِذَا وَلَّوْا مُدْبِرِينَ",
  },
  {
    id: "3240",
    sura: "27",
    VerseIDAr: "81",
    ayatAR:
      "وَمَا أَنْتَ بِهَادِي الْعُمْيِ عَنْ ضَلَالَتِهِمْ ۖ إِنْ تُسْمِعُ إِلَّا مَنْ يُؤْمِنُ بِآيَاتِنَا فَهُمْ مُسْلِمُونَ",
  },
  {
    id: "3241",
    sura: "27",
    VerseIDAr: "82",
    ayatAR:
      "وَإِذَا وَقَعَ الْقَوْلُ عَلَيْهِمْ أَخْرَجْنَا لَهُمْ دَابَّةً مِنَ الْأَرْضِ تُكَلِّمُهُمْ أَنَّ النَّاسَ كَانُوا بِآيَاتِنَا لَا يُوقِنُونَ",
  },
  {
    id: "3242",
    sura: "27",
    VerseIDAr: "83",
    ayatAR:
      "وَيَوْمَ نَحْشُرُ مِنْ كُلِّ أُمَّةٍ فَوْجًا مِمَّنْ يُكَذِّبُ بِآيَاتِنَا فَهُمْ يُوزَعُونَ",
  },
  {
    id: "3243",
    sura: "27",
    VerseIDAr: "84",
    ayatAR:
      "حَتَّىٰ إِذَا جَاءُوا قَالَ أَكَذَّبْتُمْ بِآيَاتِي وَلَمْ تُحِيطُوا بِهَا عِلْمًا أَمَّاذَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3244",
    sura: "27",
    VerseIDAr: "85",
    ayatAR:
      "وَوَقَعَ الْقَوْلُ عَلَيْهِمْ بِمَا ظَلَمُوا فَهُمْ لَا يَنْطِقُونَ",
  },
  {
    id: "3245",
    sura: "27",
    VerseIDAr: "86",
    ayatAR:
      "أَلَمْ يَرَوْا أَنَّا جَعَلْنَا اللَّيْلَ لِيَسْكُنُوا فِيهِ وَالنَّهَارَ مُبْصِرًا ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "3246",
    sura: "27",
    VerseIDAr: "87",
    ayatAR:
      "وَيَوْمَ يُنْفَخُ فِي الصُّورِ فَفَزِعَ مَنْ فِي السَّمَاوَاتِ وَمَنْ فِي الْأَرْضِ إِلَّا مَنْ شَاءَ اللَّهُ ۚ وَكُلٌّ أَتَوْهُ دَاخِرِينَ",
  },
  {
    id: "3247",
    sura: "27",
    VerseIDAr: "88",
    ayatAR:
      "وَتَرَى الْجِبَالَ تَحْسَبُهَا جَامِدَةً وَهِيَ تَمُرُّ مَرَّ السَّحَابِ ۚ صُنْعَ اللَّهِ الَّذِي أَتْقَنَ كُلَّ شَيْءٍ ۚ إِنَّهُ خَبِيرٌ بِمَا تَفْعَلُونَ",
  },
  {
    id: "3248",
    sura: "27",
    VerseIDAr: "89",
    ayatAR:
      "مَنْ جَاءَ بِالْحَسَنَةِ فَلَهُ خَيْرٌ مِنْهَا وَهُمْ مِنْ فَزَعٍ يَوْمَئِذٍ آمِنُونَ",
  },
  {
    id: "3249",
    sura: "27",
    VerseIDAr: "90",
    ayatAR:
      "وَمَنْ جَاءَ بِالسَّيِّئَةِ فَكُبَّتْ وُجُوهُهُمْ فِي النَّارِ هَلْ تُجْزَوْنَ إِلَّا مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3250",
    sura: "27",
    VerseIDAr: "91",
    ayatAR:
      "إِنَّمَا أُمِرْتُ أَنْ أَعْبُدَ رَبَّ هَٰذِهِ الْبَلْدَةِ الَّذِي حَرَّمَهَا وَلَهُ كُلُّ شَيْءٍ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "3251",
    sura: "27",
    VerseIDAr: "92",
    ayatAR:
      "وَأَنْ أَتْلُوَ الْقُرْآنَ ۖ فَمَنِ اهْتَدَىٰ فَإِنَّمَا يَهْتَدِي لِنَفْسِهِ ۖ وَمَنْ ضَلَّ فَقُلْ إِنَّمَا أَنَا مِنَ الْمُنْذِرِينَ",
  },
  {
    id: "3252",
    sura: "27",
    VerseIDAr: "93",
    ayatAR:
      "وَقُلِ الْحَمْدُ لِلَّهِ سَيُرِيكُمْ آيَاتِهِ فَتَعْرِفُونَهَا ۚ وَمَا رَبُّكَ بِغَافِلٍ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "3253",
    sura: "28",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ طسم",
  },
  {
    id: "3254",
    sura: "28",
    VerseIDAr: "2",
    ayatAR: "تِلْكَ آيَاتُ الْكِتَابِ الْمُبِينِ",
  },
  {
    id: "3255",
    sura: "28",
    VerseIDAr: "3",
    ayatAR:
      "نَتْلُو عَلَيْكَ مِنْ نَبَإِ مُوسَىٰ وَفِرْعَوْنَ بِالْحَقِّ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "3256",
    sura: "28",
    VerseIDAr: "4",
    ayatAR:
      "إِنَّ فِرْعَوْنَ عَلَا فِي الْأَرْضِ وَجَعَلَ أَهْلَهَا شِيَعًا يَسْتَضْعِفُ طَائِفَةً مِنْهُمْ يُذَبِّحُ أَبْنَاءَهُمْ وَيَسْتَحْيِي نِسَاءَهُمْ ۚ إِنَّهُ كَانَ مِنَ الْمُفْسِدِينَ",
  },
  {
    id: "3257",
    sura: "28",
    VerseIDAr: "5",
    ayatAR:
      "وَنُرِيدُ أَنْ نَمُنَّ عَلَى الَّذِينَ اسْتُضْعِفُوا فِي الْأَرْضِ وَنَجْعَلَهُمْ أَئِمَّةً وَنَجْعَلَهُمُ الْوَارِثِينَ",
  },
  {
    id: "3258",
    sura: "28",
    VerseIDAr: "6",
    ayatAR:
      "وَنُمَكِّنَ لَهُمْ فِي الْأَرْضِ وَنُرِيَ فِرْعَوْنَ وَهَامَانَ وَجُنُودَهُمَا مِنْهُمْ مَا كَانُوا يَحْذَرُونَ",
  },
  {
    id: "3259",
    sura: "28",
    VerseIDAr: "7",
    ayatAR:
      "وَأَوْحَيْنَا إِلَىٰ أُمِّ مُوسَىٰ أَنْ أَرْضِعِيهِ ۖ فَإِذَا خِفْتِ عَلَيْهِ فَأَلْقِيهِ فِي الْيَمِّ وَلَا تَخَافِي وَلَا تَحْزَنِي ۖ إِنَّا رَادُّوهُ إِلَيْكِ وَجَاعِلُوهُ مِنَ الْمُرْسَلِينَ",
  },
  {
    id: "3260",
    sura: "28",
    VerseIDAr: "8",
    ayatAR:
      "فَالْتَقَطَهُ آلُ فِرْعَوْنَ لِيَكُونَ لَهُمْ عَدُوًّا وَحَزَنًا ۗ إِنَّ فِرْعَوْنَ وَهَامَانَ وَجُنُودَهُمَا كَانُوا خَاطِئِينَ",
  },
  {
    id: "3261",
    sura: "28",
    VerseIDAr: "9",
    ayatAR:
      "وَقَالَتِ امْرَأَتُ فِرْعَوْنَ قُرَّتُ عَيْنٍ لِي وَلَكَ ۖ لَا تَقْتُلُوهُ عَسَىٰ أَنْ يَنْفَعَنَا أَوْ نَتَّخِذَهُ وَلَدًا وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3262",
    sura: "28",
    VerseIDAr: "10",
    ayatAR:
      "وَأَصْبَحَ فُؤَادُ أُمِّ مُوسَىٰ فَارِغًا ۖ إِنْ كَادَتْ لَتُبْدِي بِهِ لَوْلَا أَنْ رَبَطْنَا عَلَىٰ قَلْبِهَا لِتَكُونَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3263",
    sura: "28",
    VerseIDAr: "11",
    ayatAR:
      "وَقَالَتْ لِأُخْتِهِ قُصِّيهِ ۖ فَبَصُرَتْ بِهِ عَنْ جُنُبٍ وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3264",
    sura: "28",
    VerseIDAr: "12",
    ayatAR:
      "وَحَرَّمْنَا عَلَيْهِ الْمَرَاضِعَ مِنْ قَبْلُ فَقَالَتْ هَلْ أَدُلُّكُمْ عَلَىٰ أَهْلِ بَيْتٍ يَكْفُلُونَهُ لَكُمْ وَهُمْ لَهُ نَاصِحُونَ",
  },
  {
    id: "3265",
    sura: "28",
    VerseIDAr: "13",
    ayatAR:
      "فَرَدَدْنَاهُ إِلَىٰ أُمِّهِ كَيْ تَقَرَّ عَيْنُهَا وَلَا تَحْزَنَ وَلِتَعْلَمَ أَنَّ وَعْدَ اللَّهِ حَقٌّ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "3266",
    sura: "28",
    VerseIDAr: "14",
    ayatAR:
      "وَلَمَّا بَلَغَ أَشُدَّهُ وَاسْتَوَىٰ آتَيْنَاهُ حُكْمًا وَعِلْمًا ۚ وَكَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3267",
    sura: "28",
    VerseIDAr: "15",
    ayatAR:
      "وَدَخَلَ الْمَدِينَةَ عَلَىٰ حِينِ غَفْلَةٍ مِنْ أَهْلِهَا فَوَجَدَ فِيهَا رَجُلَيْنِ يَقْتَتِلَانِ هَٰذَا مِنْ شِيعَتِهِ وَهَٰذَا مِنْ عَدُوِّهِ ۖ فَاسْتَغَاثَهُ الَّذِي مِنْ شِيعَتِهِ عَلَى الَّذِي مِنْ عَدُوِّهِ فَوَكَزَهُ مُوسَىٰ فَقَضَىٰ عَلَيْهِ ۖ قَالَ هَٰذَا مِنْ عَمَلِ الشَّيْطَانِ ۖ إِنَّهُ عَدُوٌّ مُضِلٌّ مُبِينٌ",
  },
  {
    id: "3268",
    sura: "28",
    VerseIDAr: "16",
    ayatAR:
      "قَالَ رَبِّ إِنِّي ظَلَمْتُ نَفْسِي فَاغْفِرْ لِي فَغَفَرَ لَهُ ۚ إِنَّهُ هُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "3269",
    sura: "28",
    VerseIDAr: "17",
    ayatAR:
      "قَالَ رَبِّ بِمَا أَنْعَمْتَ عَلَيَّ فَلَنْ أَكُونَ ظَهِيرًا لِلْمُجْرِمِينَ",
  },
  {
    id: "3270",
    sura: "28",
    VerseIDAr: "18",
    ayatAR:
      "فَأَصْبَحَ فِي الْمَدِينَةِ خَائِفًا يَتَرَقَّبُ فَإِذَا الَّذِي اسْتَنْصَرَهُ بِالْأَمْسِ يَسْتَصْرِخُهُ ۚ قَالَ لَهُ مُوسَىٰ إِنَّكَ لَغَوِيٌّ مُبِينٌ",
  },
  {
    id: "3271",
    sura: "28",
    VerseIDAr: "19",
    ayatAR:
      "فَلَمَّا أَنْ أَرَادَ أَنْ يَبْطِشَ بِالَّذِي هُوَ عَدُوٌّ لَهُمَا قَالَ يَا مُوسَىٰ أَتُرِيدُ أَنْ تَقْتُلَنِي كَمَا قَتَلْتَ نَفْسًا بِالْأَمْسِ ۖ إِنْ تُرِيدُ إِلَّا أَنْ تَكُونَ جَبَّارًا فِي الْأَرْضِ وَمَا تُرِيدُ أَنْ تَكُونَ مِنَ الْمُصْلِحِينَ",
  },
  {
    id: "3272",
    sura: "28",
    VerseIDAr: "20",
    ayatAR:
      "وَجَاءَ رَجُلٌ مِنْ أَقْصَى الْمَدِينَةِ يَسْعَىٰ قَالَ يَا مُوسَىٰ إِنَّ الْمَلَأَ يَأْتَمِرُونَ بِكَ لِيَقْتُلُوكَ فَاخْرُجْ إِنِّي لَكَ مِنَ النَّاصِحِينَ",
  },
  {
    id: "3273",
    sura: "28",
    VerseIDAr: "21",
    ayatAR:
      "فَخَرَجَ مِنْهَا خَائِفًا يَتَرَقَّبُ ۖ قَالَ رَبِّ نَجِّنِي مِنَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "3274",
    sura: "28",
    VerseIDAr: "22",
    ayatAR:
      "وَلَمَّا تَوَجَّهَ تِلْقَاءَ مَدْيَنَ قَالَ عَسَىٰ رَبِّي أَنْ يَهْدِيَنِي سَوَاءَ السَّبِيلِ",
  },
  {
    id: "3275",
    sura: "28",
    VerseIDAr: "23",
    ayatAR:
      "وَلَمَّا وَرَدَ مَاءَ مَدْيَنَ وَجَدَ عَلَيْهِ أُمَّةً مِنَ النَّاسِ يَسْقُونَ وَوَجَدَ مِنْ دُونِهِمُ امْرَأَتَيْنِ تَذُودَانِ ۖ قَالَ مَا خَطْبُكُمَا ۖ قَالَتَا لَا نَسْقِي حَتَّىٰ يُصْدِرَ الرِّعَاءُ ۖ وَأَبُونَا شَيْخٌ كَبِيرٌ",
  },
  {
    id: "3276",
    sura: "28",
    VerseIDAr: "24",
    ayatAR:
      "فَسَقَىٰ لَهُمَا ثُمَّ تَوَلَّىٰ إِلَى الظِّلِّ فَقَالَ رَبِّ إِنِّي لِمَا أَنْزَلْتَ إِلَيَّ مِنْ خَيْرٍ فَقِيرٌ",
  },
  {
    id: "3277",
    sura: "28",
    VerseIDAr: "25",
    ayatAR:
      "فَجَاءَتْهُ إِحْدَاهُمَا تَمْشِي عَلَى اسْتِحْيَاءٍ قَالَتْ إِنَّ أَبِي يَدْعُوكَ لِيَجْزِيَكَ أَجْرَ مَا سَقَيْتَ لَنَا ۚ فَلَمَّا جَاءَهُ وَقَصَّ عَلَيْهِ الْقَصَصَ قَالَ لَا تَخَفْ ۖ نَجَوْتَ مِنَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "3278",
    sura: "28",
    VerseIDAr: "26",
    ayatAR:
      "قَالَتْ إِحْدَاهُمَا يَا أَبَتِ اسْتَأْجِرْهُ ۖ إِنَّ خَيْرَ مَنِ اسْتَأْجَرْتَ الْقَوِيُّ الْأَمِينُ",
  },
  {
    id: "3279",
    sura: "28",
    VerseIDAr: "27",
    ayatAR:
      "قَالَ إِنِّي أُرِيدُ أَنْ أُنْكِحَكَ إِحْدَى ابْنَتَيَّ هَاتَيْنِ عَلَىٰ أَنْ تَأْجُرَنِي ثَمَانِيَ حِجَجٍ ۖ فَإِنْ أَتْمَمْتَ عَشْرًا فَمِنْ عِنْدِكَ ۖ وَمَا أُرِيدُ أَنْ أَشُقَّ عَلَيْكَ ۚ سَتَجِدُنِي إِنْ شَاءَ اللَّهُ مِنَ الصَّالِحِينَ",
  },
  {
    id: "3280",
    sura: "28",
    VerseIDAr: "28",
    ayatAR:
      "قَالَ ذَٰلِكَ بَيْنِي وَبَيْنَكَ ۖ أَيَّمَا الْأَجَلَيْنِ قَضَيْتُ فَلَا عُدْوَانَ عَلَيَّ ۖ وَاللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٌ",
  },
  {
    id: "3281",
    sura: "28",
    VerseIDAr: "29",
    ayatAR:
      "فَلَمَّا قَضَىٰ مُوسَى الْأَجَلَ وَسَارَ بِأَهْلِهِ آنَسَ مِنْ جَانِبِ الطُّورِ نَارًا قَالَ لِأَهْلِهِ امْكُثُوا إِنِّي آنَسْتُ نَارًا لَعَلِّي آتِيكُمْ مِنْهَا بِخَبَرٍ أَوْ جَذْوَةٍ مِنَ النَّارِ لَعَلَّكُمْ تَصْطَلُونَ",
  },
  {
    id: "3282",
    sura: "28",
    VerseIDAr: "30",
    ayatAR:
      "فَلَمَّا أَتَاهَا نُودِيَ مِنْ شَاطِئِ الْوَادِ الْأَيْمَنِ فِي الْبُقْعَةِ الْمُبَارَكَةِ مِنَ الشَّجَرَةِ أَنْ يَا مُوسَىٰ إِنِّي أَنَا اللَّهُ رَبُّ الْعَالَمِينَ",
  },
  {
    id: "3283",
    sura: "28",
    VerseIDAr: "31",
    ayatAR:
      "وَأَنْ أَلْقِ عَصَاكَ ۖ فَلَمَّا رَآهَا تَهْتَزُّ كَأَنَّهَا جَانٌّ وَلَّىٰ مُدْبِرًا وَلَمْ يُعَقِّبْ ۚ يَا مُوسَىٰ أَقْبِلْ وَلَا تَخَفْ ۖ إِنَّكَ مِنَ الْآمِنِينَ",
  },
  {
    id: "3284",
    sura: "28",
    VerseIDAr: "32",
    ayatAR:
      "اسْلُكْ يَدَكَ فِي جَيْبِكَ تَخْرُجْ بَيْضَاءَ مِنْ غَيْرِ سُوءٍ وَاضْمُمْ إِلَيْكَ جَنَاحَكَ مِنَ الرَّهْبِ ۖ فَذَانِكَ بُرْهَانَانِ مِنْ رَبِّكَ إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ ۚ إِنَّهُمْ كَانُوا قَوْمًا فَاسِقِينَ",
  },
  {
    id: "3285",
    sura: "28",
    VerseIDAr: "33",
    ayatAR:
      "قَالَ رَبِّ إِنِّي قَتَلْتُ مِنْهُمْ نَفْسًا فَأَخَافُ أَنْ يَقْتُلُونِ",
  },
  {
    id: "3286",
    sura: "28",
    VerseIDAr: "34",
    ayatAR:
      "وَأَخِي هَارُونُ هُوَ أَفْصَحُ مِنِّي لِسَانًا فَأَرْسِلْهُ مَعِيَ رِدْءًا يُصَدِّقُنِي ۖ إِنِّي أَخَافُ أَنْ يُكَذِّبُونِ",
  },
  {
    id: "3287",
    sura: "28",
    VerseIDAr: "35",
    ayatAR:
      "قَالَ سَنَشُدُّ عَضُدَكَ بِأَخِيكَ وَنَجْعَلُ لَكُمَا سُلْطَانًا فَلَا يَصِلُونَ إِلَيْكُمَا ۚ بِآيَاتِنَا أَنْتُمَا وَمَنِ اتَّبَعَكُمَا الْغَالِبُونَ",
  },
  {
    id: "3288",
    sura: "28",
    VerseIDAr: "36",
    ayatAR:
      "فَلَمَّا جَاءَهُمْ مُوسَىٰ بِآيَاتِنَا بَيِّنَاتٍ قَالُوا مَا هَٰذَا إِلَّا سِحْرٌ مُفْتَرًى وَمَا سَمِعْنَا بِهَٰذَا فِي آبَائِنَا الْأَوَّلِينَ",
  },
  {
    id: "3289",
    sura: "28",
    VerseIDAr: "37",
    ayatAR:
      "وَقَالَ مُوسَىٰ رَبِّي أَعْلَمُ بِمَنْ جَاءَ بِالْهُدَىٰ مِنْ عِنْدِهِ وَمَنْ تَكُونُ لَهُ عَاقِبَةُ الدَّارِ ۖ إِنَّهُ لَا يُفْلِحُ الظَّالِمُونَ",
  },
  {
    id: "3290",
    sura: "28",
    VerseIDAr: "38",
    ayatAR:
      "وَقَالَ فِرْعَوْنُ يَا أَيُّهَا الْمَلَأُ مَا عَلِمْتُ لَكُمْ مِنْ إِلَٰهٍ غَيْرِي فَأَوْقِدْ لِي يَا هَامَانُ عَلَى الطِّينِ فَاجْعَلْ لِي صَرْحًا لَعَلِّي أَطَّلِعُ إِلَىٰ إِلَٰهِ مُوسَىٰ وَإِنِّي لَأَظُنُّهُ مِنَ الْكَاذِبِينَ",
  },
  {
    id: "3291",
    sura: "28",
    VerseIDAr: "39",
    ayatAR:
      "وَاسْتَكْبَرَ هُوَ وَجُنُودُهُ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ وَظَنُّوا أَنَّهُمْ إِلَيْنَا لَا يُرْجَعُونَ",
  },
  {
    id: "3292",
    sura: "28",
    VerseIDAr: "40",
    ayatAR:
      "فَأَخَذْنَاهُ وَجُنُودَهُ فَنَبَذْنَاهُمْ فِي الْيَمِّ ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الظَّالِمِينَ",
  },
  {
    id: "3293",
    sura: "28",
    VerseIDAr: "41",
    ayatAR:
      "وَجَعَلْنَاهُمْ أَئِمَّةً يَدْعُونَ إِلَى النَّارِ ۖ وَيَوْمَ الْقِيَامَةِ لَا يُنْصَرُونَ",
  },
  {
    id: "3294",
    sura: "28",
    VerseIDAr: "42",
    ayatAR:
      "وَأَتْبَعْنَاهُمْ فِي هَٰذِهِ الدُّنْيَا لَعْنَةً ۖ وَيَوْمَ الْقِيَامَةِ هُمْ مِنَ الْمَقْبُوحِينَ",
  },
  {
    id: "3295",
    sura: "28",
    VerseIDAr: "43",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ مِنْ بَعْدِ مَا أَهْلَكْنَا الْقُرُونَ الْأُولَىٰ بَصَائِرَ لِلنَّاسِ وَهُدًى وَرَحْمَةً لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "3296",
    sura: "28",
    VerseIDAr: "44",
    ayatAR:
      "وَمَا كُنْتَ بِجَانِبِ الْغَرْبِيِّ إِذْ قَضَيْنَا إِلَىٰ مُوسَى الْأَمْرَ وَمَا كُنْتَ مِنَ الشَّاهِدِينَ",
  },
  {
    id: "3297",
    sura: "28",
    VerseIDAr: "45",
    ayatAR:
      "وَلَٰكِنَّا أَنْشَأْنَا قُرُونًا فَتَطَاوَلَ عَلَيْهِمُ الْعُمُرُ ۚ وَمَا كُنْتَ ثَاوِيًا فِي أَهْلِ مَدْيَنَ تَتْلُو عَلَيْهِمْ آيَاتِنَا وَلَٰكِنَّا كُنَّا مُرْسِلِينَ",
  },
  {
    id: "3298",
    sura: "28",
    VerseIDAr: "46",
    ayatAR:
      "وَمَا كُنْتَ بِجَانِبِ الطُّورِ إِذْ نَادَيْنَا وَلَٰكِنْ رَحْمَةً مِنْ رَبِّكَ لِتُنْذِرَ قَوْمًا مَا أَتَاهُمْ مِنْ نَذِيرٍ مِنْ قَبْلِكَ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "3299",
    sura: "28",
    VerseIDAr: "47",
    ayatAR:
      "وَلَوْلَا أَنْ تُصِيبَهُمْ مُصِيبَةٌ بِمَا قَدَّمَتْ أَيْدِيهِمْ فَيَقُولُوا رَبَّنَا لَوْلَا أَرْسَلْتَ إِلَيْنَا رَسُولًا فَنَتَّبِعَ آيَاتِكَ وَنَكُونَ مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3300",
    sura: "28",
    VerseIDAr: "48",
    ayatAR:
      "فَلَمَّا جَاءَهُمُ الْحَقُّ مِنْ عِنْدِنَا قَالُوا لَوْلَا أُوتِيَ مِثْلَ مَا أُوتِيَ مُوسَىٰ ۚ أَوَلَمْ يَكْفُرُوا بِمَا أُوتِيَ مُوسَىٰ مِنْ قَبْلُ ۖ قَالُوا سِحْرَانِ تَظَاهَرَا وَقَالُوا إِنَّا بِكُلٍّ كَافِرُونَ",
  },
  {
    id: "3301",
    sura: "28",
    VerseIDAr: "49",
    ayatAR:
      "قُلْ فَأْتُوا بِكِتَابٍ مِنْ عِنْدِ اللَّهِ هُوَ أَهْدَىٰ مِنْهُمَا أَتَّبِعْهُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3302",
    sura: "28",
    VerseIDAr: "50",
    ayatAR:
      "فَإِنْ لَمْ يَسْتَجِيبُوا لَكَ فَاعْلَمْ أَنَّمَا يَتَّبِعُونَ أَهْوَاءَهُمْ ۚ وَمَنْ أَضَلُّ مِمَّنِ اتَّبَعَ هَوَاهُ بِغَيْرِ هُدًى مِنَ اللَّهِ ۚ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "3303",
    sura: "28",
    VerseIDAr: "51",
    ayatAR: "وَلَقَدْ وَصَّلْنَا لَهُمُ الْقَوْلَ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "3304",
    sura: "28",
    VerseIDAr: "52",
    ayatAR:
      "الَّذِينَ آتَيْنَاهُمُ الْكِتَابَ مِنْ قَبْلِهِ هُمْ بِهِ يُؤْمِنُونَ",
  },
  {
    id: "3305",
    sura: "28",
    VerseIDAr: "53",
    ayatAR:
      "وَإِذَا يُتْلَىٰ عَلَيْهِمْ قَالُوا آمَنَّا بِهِ إِنَّهُ الْحَقُّ مِنْ رَبِّنَا إِنَّا كُنَّا مِنْ قَبْلِهِ مُسْلِمِينَ",
  },
  {
    id: "3306",
    sura: "28",
    VerseIDAr: "54",
    ayatAR:
      "أُولَٰئِكَ يُؤْتَوْنَ أَجْرَهُمْ مَرَّتَيْنِ بِمَا صَبَرُوا وَيَدْرَءُونَ بِالْحَسَنَةِ السَّيِّئَةَ وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "3307",
    sura: "28",
    VerseIDAr: "55",
    ayatAR:
      "وَإِذَا سَمِعُوا اللَّغْوَ أَعْرَضُوا عَنْهُ وَقَالُوا لَنَا أَعْمَالُنَا وَلَكُمْ أَعْمَالُكُمْ سَلَامٌ عَلَيْكُمْ لَا نَبْتَغِي الْجَاهِلِينَ",
  },
  {
    id: "3308",
    sura: "28",
    VerseIDAr: "56",
    ayatAR:
      "إِنَّكَ لَا تَهْدِي مَنْ أَحْبَبْتَ وَلَٰكِنَّ اللَّهَ يَهْدِي مَنْ يَشَاءُ ۚ وَهُوَ أَعْلَمُ بِالْمُهْتَدِينَ",
  },
  {
    id: "3309",
    sura: "28",
    VerseIDAr: "57",
    ayatAR:
      "وَقَالُوا إِنْ نَتَّبِعِ الْهُدَىٰ مَعَكَ نُتَخَطَّفْ مِنْ أَرْضِنَا ۚ أَوَلَمْ نُمَكِّنْ لَهُمْ حَرَمًا آمِنًا يُجْبَىٰ إِلَيْهِ ثَمَرَاتُ كُلِّ شَيْءٍ رِزْقًا مِنْ لَدُنَّا وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "3310",
    sura: "28",
    VerseIDAr: "58",
    ayatAR:
      "وَكَمْ أَهْلَكْنَا مِنْ قَرْيَةٍ بَطِرَتْ مَعِيشَتَهَا ۖ فَتِلْكَ مَسَاكِنُهُمْ لَمْ تُسْكَنْ مِنْ بَعْدِهِمْ إِلَّا قَلِيلًا ۖ وَكُنَّا نَحْنُ الْوَارِثِينَ",
  },
  {
    id: "3311",
    sura: "28",
    VerseIDAr: "59",
    ayatAR:
      "وَمَا كَانَ رَبُّكَ مُهْلِكَ الْقُرَىٰ حَتَّىٰ يَبْعَثَ فِي أُمِّهَا رَسُولًا يَتْلُو عَلَيْهِمْ آيَاتِنَا ۚ وَمَا كُنَّا مُهْلِكِي الْقُرَىٰ إِلَّا وَأَهْلُهَا ظَالِمُونَ",
  },
  {
    id: "3312",
    sura: "28",
    VerseIDAr: "60",
    ayatAR:
      "وَمَا أُوتِيتُمْ مِنْ شَيْءٍ فَمَتَاعُ الْحَيَاةِ الدُّنْيَا وَزِينَتُهَا ۚ وَمَا عِنْدَ اللَّهِ خَيْرٌ وَأَبْقَىٰ ۚ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "3313",
    sura: "28",
    VerseIDAr: "61",
    ayatAR:
      "أَفَمَنْ وَعَدْنَاهُ وَعْدًا حَسَنًا فَهُوَ لَاقِيهِ كَمَنْ مَتَّعْنَاهُ مَتَاعَ الْحَيَاةِ الدُّنْيَا ثُمَّ هُوَ يَوْمَ الْقِيَامَةِ مِنَ الْمُحْضَرِينَ",
  },
  {
    id: "3314",
    sura: "28",
    VerseIDAr: "62",
    ayatAR:
      "وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ أَيْنَ شُرَكَائِيَ الَّذِينَ كُنْتُمْ تَزْعُمُونَ",
  },
  {
    id: "3315",
    sura: "28",
    VerseIDAr: "63",
    ayatAR:
      "قَالَ الَّذِينَ حَقَّ عَلَيْهِمُ الْقَوْلُ رَبَّنَا هَٰؤُلَاءِ الَّذِينَ أَغْوَيْنَا أَغْوَيْنَاهُمْ كَمَا غَوَيْنَا ۖ تَبَرَّأْنَا إِلَيْكَ ۖ مَا كَانُوا إِيَّانَا يَعْبُدُونَ",
  },
  {
    id: "3316",
    sura: "28",
    VerseIDAr: "64",
    ayatAR:
      "وَقِيلَ ادْعُوا شُرَكَاءَكُمْ فَدَعَوْهُمْ فَلَمْ يَسْتَجِيبُوا لَهُمْ وَرَأَوُا الْعَذَابَ ۚ لَوْ أَنَّهُمْ كَانُوا يَهْتَدُونَ",
  },
  {
    id: "3317",
    sura: "28",
    VerseIDAr: "65",
    ayatAR: "وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ مَاذَا أَجَبْتُمُ الْمُرْسَلِينَ",
  },
  {
    id: "3318",
    sura: "28",
    VerseIDAr: "66",
    ayatAR:
      "فَعَمِيَتْ عَلَيْهِمُ الْأَنْبَاءُ يَوْمَئِذٍ فَهُمْ لَا يَتَسَاءَلُونَ",
  },
  {
    id: "3319",
    sura: "28",
    VerseIDAr: "67",
    ayatAR:
      "فَأَمَّا مَنْ تَابَ وَآمَنَ وَعَمِلَ صَالِحًا فَعَسَىٰ أَنْ يَكُونَ مِنَ الْمُفْلِحِينَ",
  },
  {
    id: "3320",
    sura: "28",
    VerseIDAr: "68",
    ayatAR:
      "وَرَبُّكَ يَخْلُقُ مَا يَشَاءُ وَيَخْتَارُ ۗ مَا كَانَ لَهُمُ الْخِيَرَةُ ۚ سُبْحَانَ اللَّهِ وَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "3321",
    sura: "28",
    VerseIDAr: "69",
    ayatAR: "وَرَبُّكَ يَعْلَمُ مَا تُكِنُّ صُدُورُهُمْ وَمَا يُعْلِنُونَ",
  },
  {
    id: "3322",
    sura: "28",
    VerseIDAr: "70",
    ayatAR:
      "وَهُوَ اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ ۖ لَهُ الْحَمْدُ فِي الْأُولَىٰ وَالْآخِرَةِ ۖ وَلَهُ الْحُكْمُ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3323",
    sura: "28",
    VerseIDAr: "71",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ جَعَلَ اللَّهُ عَلَيْكُمُ اللَّيْلَ سَرْمَدًا إِلَىٰ يَوْمِ الْقِيَامَةِ مَنْ إِلَٰهٌ غَيْرُ اللَّهِ يَأْتِيكُمْ بِضِيَاءٍ ۖ أَفَلَا تَسْمَعُونَ",
  },
  {
    id: "3324",
    sura: "28",
    VerseIDAr: "72",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ جَعَلَ اللَّهُ عَلَيْكُمُ النَّهَارَ سَرْمَدًا إِلَىٰ يَوْمِ الْقِيَامَةِ مَنْ إِلَٰهٌ غَيْرُ اللَّهِ يَأْتِيكُمْ بِلَيْلٍ تَسْكُنُونَ فِيهِ ۖ أَفَلَا تُبْصِرُونَ",
  },
  {
    id: "3325",
    sura: "28",
    VerseIDAr: "73",
    ayatAR:
      "وَمِنْ رَحْمَتِهِ جَعَلَ لَكُمُ اللَّيْلَ وَالنَّهَارَ لِتَسْكُنُوا فِيهِ وَلِتَبْتَغُوا مِنْ فَضْلِهِ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "3326",
    sura: "28",
    VerseIDAr: "74",
    ayatAR:
      "وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ أَيْنَ شُرَكَائِيَ الَّذِينَ كُنْتُمْ تَزْعُمُونَ",
  },
  {
    id: "3327",
    sura: "28",
    VerseIDAr: "75",
    ayatAR:
      "وَنَزَعْنَا مِنْ كُلِّ أُمَّةٍ شَهِيدًا فَقُلْنَا هَاتُوا بُرْهَانَكُمْ فَعَلِمُوا أَنَّ الْحَقَّ لِلَّهِ وَضَلَّ عَنْهُمْ مَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "3328",
    sura: "28",
    VerseIDAr: "76",
    ayatAR:
      "إِنَّ قَارُونَ كَانَ مِنْ قَوْمِ مُوسَىٰ فَبَغَىٰ عَلَيْهِمْ ۖ وَآتَيْنَاهُ مِنَ الْكُنُوزِ مَا إِنَّ مَفَاتِحَهُ لَتَنُوءُ بِالْعُصْبَةِ أُولِي الْقُوَّةِ إِذْ قَالَ لَهُ قَوْمُهُ لَا تَفْرَحْ ۖ إِنَّ اللَّهَ لَا يُحِبُّ الْفَرِحِينَ",
  },
  {
    id: "3329",
    sura: "28",
    VerseIDAr: "77",
    ayatAR:
      "وَابْتَغِ فِيمَا آتَاكَ اللَّهُ الدَّارَ الْآخِرَةَ ۖ وَلَا تَنْسَ نَصِيبَكَ مِنَ الدُّنْيَا ۖ وَأَحْسِنْ كَمَا أَحْسَنَ اللَّهُ إِلَيْكَ ۖ وَلَا تَبْغِ الْفَسَادَ فِي الْأَرْضِ ۖ إِنَّ اللَّهَ لَا يُحِبُّ الْمُفْسِدِينَ",
  },
  {
    id: "3330",
    sura: "28",
    VerseIDAr: "78",
    ayatAR:
      "قَالَ إِنَّمَا أُوتِيتُهُ عَلَىٰ عِلْمٍ عِنْدِي ۚ أَوَلَمْ يَعْلَمْ أَنَّ اللَّهَ قَدْ أَهْلَكَ مِنْ قَبْلِهِ مِنَ الْقُرُونِ مَنْ هُوَ أَشَدُّ مِنْهُ قُوَّةً وَأَكْثَرُ جَمْعًا ۚ وَلَا يُسْأَلُ عَنْ ذُنُوبِهِمُ الْمُجْرِمُونَ",
  },
  {
    id: "3331",
    sura: "28",
    VerseIDAr: "79",
    ayatAR:
      "فَخَرَجَ عَلَىٰ قَوْمِهِ فِي زِينَتِهِ ۖ قَالَ الَّذِينَ يُرِيدُونَ الْحَيَاةَ الدُّنْيَا يَا لَيْتَ لَنَا مِثْلَ مَا أُوتِيَ قَارُونُ إِنَّهُ لَذُو حَظٍّ عَظِيمٍ",
  },
  {
    id: "3332",
    sura: "28",
    VerseIDAr: "80",
    ayatAR:
      "وَقَالَ الَّذِينَ أُوتُوا الْعِلْمَ وَيْلَكُمْ ثَوَابُ اللَّهِ خَيْرٌ لِمَنْ آمَنَ وَعَمِلَ صَالِحًا وَلَا يُلَقَّاهَا إِلَّا الصَّابِرُونَ",
  },
  {
    id: "3333",
    sura: "28",
    VerseIDAr: "81",
    ayatAR:
      "فَخَسَفْنَا بِهِ وَبِدَارِهِ الْأَرْضَ فَمَا كَانَ لَهُ مِنْ فِئَةٍ يَنْصُرُونَهُ مِنْ دُونِ اللَّهِ وَمَا كَانَ مِنَ الْمُنْتَصِرِينَ",
  },
  {
    id: "3334",
    sura: "28",
    VerseIDAr: "82",
    ayatAR:
      "وَأَصْبَحَ الَّذِينَ تَمَنَّوْا مَكَانَهُ بِالْأَمْسِ يَقُولُونَ وَيْكَأَنَّ اللَّهَ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ مِنْ عِبَادِهِ وَيَقْدِرُ ۖ لَوْلَا أَنْ مَنَّ اللَّهُ عَلَيْنَا لَخَسَفَ بِنَا ۖ وَيْكَأَنَّهُ لَا يُفْلِحُ الْكَافِرُونَ",
  },
  {
    id: "3335",
    sura: "28",
    VerseIDAr: "83",
    ayatAR:
      "تِلْكَ الدَّارُ الْآخِرَةُ نَجْعَلُهَا لِلَّذِينَ لَا يُرِيدُونَ عُلُوًّا فِي الْأَرْضِ وَلَا فَسَادًا ۚ وَالْعَاقِبَةُ لِلْمُتَّقِينَ",
  },
  {
    id: "3336",
    sura: "28",
    VerseIDAr: "84",
    ayatAR:
      "مَنْ جَاءَ بِالْحَسَنَةِ فَلَهُ خَيْرٌ مِنْهَا ۖ وَمَنْ جَاءَ بِالسَّيِّئَةِ فَلَا يُجْزَى الَّذِينَ عَمِلُوا السَّيِّئَاتِ إِلَّا مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3337",
    sura: "28",
    VerseIDAr: "85",
    ayatAR:
      "إِنَّ الَّذِي فَرَضَ عَلَيْكَ الْقُرْآنَ لَرَادُّكَ إِلَىٰ مَعَادٍ ۚ قُلْ رَبِّي أَعْلَمُ مَنْ جَاءَ بِالْهُدَىٰ وَمَنْ هُوَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3338",
    sura: "28",
    VerseIDAr: "86",
    ayatAR:
      "وَمَا كُنْتَ تَرْجُو أَنْ يُلْقَىٰ إِلَيْكَ الْكِتَابُ إِلَّا رَحْمَةً مِنْ رَبِّكَ ۖ فَلَا تَكُونَنَّ ظَهِيرًا لِلْكَافِرِينَ",
  },
  {
    id: "3339",
    sura: "28",
    VerseIDAr: "87",
    ayatAR:
      "وَلَا يَصُدُّنَّكَ عَنْ آيَاتِ اللَّهِ بَعْدَ إِذْ أُنْزِلَتْ إِلَيْكَ ۖ وَادْعُ إِلَىٰ رَبِّكَ ۖ وَلَا تَكُونَنَّ مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "3340",
    sura: "28",
    VerseIDAr: "88",
    ayatAR:
      "وَلَا تَدْعُ مَعَ اللَّهِ إِلَٰهًا آخَرَ ۘ لَا إِلَٰهَ إِلَّا هُوَ ۚ كُلُّ شَيْءٍ هَالِكٌ إِلَّا وَجْهَهُ ۚ لَهُ الْحُكْمُ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3341",
    sura: "29",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  {
    id: "3342",
    sura: "29",
    VerseIDAr: "2",
    ayatAR:
      "أَحَسِبَ النَّاسُ أَنْ يُتْرَكُوا أَنْ يَقُولُوا آمَنَّا وَهُمْ لَا يُفْتَنُونَ",
  },
  {
    id: "3343",
    sura: "29",
    VerseIDAr: "3",
    ayatAR:
      "وَلَقَدْ فَتَنَّا الَّذِينَ مِنْ قَبْلِهِمْ ۖ فَلَيَعْلَمَنَّ اللَّهُ الَّذِينَ صَدَقُوا وَلَيَعْلَمَنَّ الْكَاذِبِينَ",
  },
  {
    id: "3344",
    sura: "29",
    VerseIDAr: "4",
    ayatAR:
      "أَمْ حَسِبَ الَّذِينَ يَعْمَلُونَ السَّيِّئَاتِ أَنْ يَسْبِقُونَا ۚ سَاءَ مَا يَحْكُمُونَ",
  },
  {
    id: "3345",
    sura: "29",
    VerseIDAr: "5",
    ayatAR:
      "مَنْ كَانَ يَرْجُو لِقَاءَ اللَّهِ فَإِنَّ أَجَلَ اللَّهِ لَآتٍ ۚ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "3346",
    sura: "29",
    VerseIDAr: "6",
    ayatAR:
      "وَمَنْ جَاهَدَ فَإِنَّمَا يُجَاهِدُ لِنَفْسِهِ ۚ إِنَّ اللَّهَ لَغَنِيٌّ عَنِ الْعَالَمِينَ",
  },
  {
    id: "3347",
    sura: "29",
    VerseIDAr: "7",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَنُكَفِّرَنَّ عَنْهُمْ سَيِّئَاتِهِمْ وَلَنَجْزِيَنَّهُمْ أَحْسَنَ الَّذِي كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3348",
    sura: "29",
    VerseIDAr: "8",
    ayatAR:
      "وَوَصَّيْنَا الْإِنْسَانَ بِوَالِدَيْهِ حُسْنًا ۖ وَإِنْ جَاهَدَاكَ لِتُشْرِكَ بِي مَا لَيْسَ لَكَ بِهِ عِلْمٌ فَلَا تُطِعْهُمَا ۚ إِلَيَّ مَرْجِعُكُمْ فَأُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3349",
    sura: "29",
    VerseIDAr: "9",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَنُدْخِلَنَّهُمْ فِي الصَّالِحِينَ",
  },
  {
    id: "3350",
    sura: "29",
    VerseIDAr: "10",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَقُولُ آمَنَّا بِاللَّهِ فَإِذَا أُوذِيَ فِي اللَّهِ جَعَلَ فِتْنَةَ النَّاسِ كَعَذَابِ اللَّهِ وَلَئِنْ جَاءَ نَصْرٌ مِنْ رَبِّكَ لَيَقُولُنَّ إِنَّا كُنَّا مَعَكُمْ ۚ أَوَلَيْسَ اللَّهُ بِأَعْلَمَ بِمَا فِي صُدُورِ الْعَالَمِينَ",
  },
  {
    id: "3351",
    sura: "29",
    VerseIDAr: "11",
    ayatAR:
      "وَلَيَعْلَمَنَّ اللَّهُ الَّذِينَ آمَنُوا وَلَيَعْلَمَنَّ الْمُنَافِقِينَ",
  },
  {
    id: "3352",
    sura: "29",
    VerseIDAr: "12",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لِلَّذِينَ آمَنُوا اتَّبِعُوا سَبِيلَنَا وَلْنَحْمِلْ خَطَايَاكُمْ وَمَا هُمْ بِحَامِلِينَ مِنْ خَطَايَاهُمْ مِنْ شَيْءٍ ۖ إِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "3353",
    sura: "29",
    VerseIDAr: "13",
    ayatAR:
      "وَلَيَحْمِلُنَّ أَثْقَالَهُمْ وَأَثْقَالًا مَعَ أَثْقَالِهِمْ ۖ وَلَيُسْأَلُنَّ يَوْمَ الْقِيَامَةِ عَمَّا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "3354",
    sura: "29",
    VerseIDAr: "14",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِ فَلَبِثَ فِيهِمْ أَلْفَ سَنَةٍ إِلَّا خَمْسِينَ عَامًا فَأَخَذَهُمُ الطُّوفَانُ وَهُمْ ظَالِمُونَ",
  },
  {
    id: "3355",
    sura: "29",
    VerseIDAr: "15",
    ayatAR:
      "فَأَنْجَيْنَاهُ وَأَصْحَابَ السَّفِينَةِ وَجَعَلْنَاهَا آيَةً لِلْعَالَمِينَ",
  },
  {
    id: "3356",
    sura: "29",
    VerseIDAr: "16",
    ayatAR:
      "وَإِبْرَاهِيمَ إِذْ قَالَ لِقَوْمِهِ اعْبُدُوا اللَّهَ وَاتَّقُوهُ ۖ ذَٰلِكُمْ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "3357",
    sura: "29",
    VerseIDAr: "17",
    ayatAR:
      "إِنَّمَا تَعْبُدُونَ مِنْ دُونِ اللَّهِ أَوْثَانًا وَتَخْلُقُونَ إِفْكًا ۚ إِنَّ الَّذِينَ تَعْبُدُونَ مِنْ دُونِ اللَّهِ لَا يَمْلِكُونَ لَكُمْ رِزْقًا فَابْتَغُوا عِنْدَ اللَّهِ الرِّزْقَ وَاعْبُدُوهُ وَاشْكُرُوا لَهُ ۖ إِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3358",
    sura: "29",
    VerseIDAr: "18",
    ayatAR:
      "وَإِنْ تُكَذِّبُوا فَقَدْ كَذَّبَ أُمَمٌ مِنْ قَبْلِكُمْ ۖ وَمَا عَلَى الرَّسُولِ إِلَّا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "3359",
    sura: "29",
    VerseIDAr: "19",
    ayatAR:
      "أَوَلَمْ يَرَوْا كَيْفَ يُبْدِئُ اللَّهُ الْخَلْقَ ثُمَّ يُعِيدُهُ ۚ إِنَّ ذَٰلِكَ عَلَى اللَّهِ يَسِيرٌ",
  },
  {
    id: "3360",
    sura: "29",
    VerseIDAr: "20",
    ayatAR:
      "قُلْ سِيرُوا فِي الْأَرْضِ فَانْظُرُوا كَيْفَ بَدَأَ الْخَلْقَ ۚ ثُمَّ اللَّهُ يُنْشِئُ النَّشْأَةَ الْآخِرَةَ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "3361",
    sura: "29",
    VerseIDAr: "21",
    ayatAR:
      "يُعَذِّبُ مَنْ يَشَاءُ وَيَرْحَمُ مَنْ يَشَاءُ ۖ وَإِلَيْهِ تُقْلَبُونَ",
  },
  {
    id: "3362",
    sura: "29",
    VerseIDAr: "22",
    ayatAR:
      "وَمَا أَنْتُمْ بِمُعْجِزِينَ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ ۖ وَمَا لَكُمْ مِنْ دُونِ اللَّهِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "3363",
    sura: "29",
    VerseIDAr: "23",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا بِآيَاتِ اللَّهِ وَلِقَائِهِ أُولَٰئِكَ يَئِسُوا مِنْ رَحْمَتِي وَأُولَٰئِكَ لَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "3364",
    sura: "29",
    VerseIDAr: "24",
    ayatAR:
      "فَمَا كَانَ جَوَابَ قَوْمِهِ إِلَّا أَنْ قَالُوا اقْتُلُوهُ أَوْ حَرِّقُوهُ فَأَنْجَاهُ اللَّهُ مِنَ النَّارِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "3365",
    sura: "29",
    VerseIDAr: "25",
    ayatAR:
      "وَقَالَ إِنَّمَا اتَّخَذْتُمْ مِنْ دُونِ اللَّهِ أَوْثَانًا مَوَدَّةَ بَيْنِكُمْ فِي الْحَيَاةِ الدُّنْيَا ۖ ثُمَّ يَوْمَ الْقِيَامَةِ يَكْفُرُ بَعْضُكُمْ بِبَعْضٍ وَيَلْعَنُ بَعْضُكُمْ بَعْضًا وَمَأْوَاكُمُ النَّارُ وَمَا لَكُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "3366",
    sura: "29",
    VerseIDAr: "26",
    ayatAR:
      "فَآمَنَ لَهُ لُوطٌ ۘ وَقَالَ إِنِّي مُهَاجِرٌ إِلَىٰ رَبِّي ۖ إِنَّهُ هُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3367",
    sura: "29",
    VerseIDAr: "27",
    ayatAR:
      "وَوَهَبْنَا لَهُ إِسْحَاقَ وَيَعْقُوبَ وَجَعَلْنَا فِي ذُرِّيَّتِهِ النُّبُوَّةَ وَالْكِتَابَ وَآتَيْنَاهُ أَجْرَهُ فِي الدُّنْيَا ۖ وَإِنَّهُ فِي الْآخِرَةِ لَمِنَ الصَّالِحِينَ",
  },
  {
    id: "3368",
    sura: "29",
    VerseIDAr: "28",
    ayatAR:
      "وَلُوطًا إِذْ قَالَ لِقَوْمِهِ إِنَّكُمْ لَتَأْتُونَ الْفَاحِشَةَ مَا سَبَقَكُمْ بِهَا مِنْ أَحَدٍ مِنَ الْعَالَمِينَ",
  },
  {
    id: "3369",
    sura: "29",
    VerseIDAr: "29",
    ayatAR:
      "أَئِنَّكُمْ لَتَأْتُونَ الرِّجَالَ وَتَقْطَعُونَ السَّبِيلَ وَتَأْتُونَ فِي نَادِيكُمُ الْمُنْكَرَ ۖ فَمَا كَانَ جَوَابَ قَوْمِهِ إِلَّا أَنْ قَالُوا ائْتِنَا بِعَذَابِ اللَّهِ إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "3370",
    sura: "29",
    VerseIDAr: "30",
    ayatAR: "قَالَ رَبِّ انْصُرْنِي عَلَى الْقَوْمِ الْمُفْسِدِينَ",
  },
  {
    id: "3371",
    sura: "29",
    VerseIDAr: "31",
    ayatAR:
      "وَلَمَّا جَاءَتْ رُسُلُنَا إِبْرَاهِيمَ بِالْبُشْرَىٰ قَالُوا إِنَّا مُهْلِكُو أَهْلِ هَٰذِهِ الْقَرْيَةِ ۖ إِنَّ أَهْلَهَا كَانُوا ظَالِمِينَ",
  },
  {
    id: "3372",
    sura: "29",
    VerseIDAr: "32",
    ayatAR:
      "قَالَ إِنَّ فِيهَا لُوطًا ۚ قَالُوا نَحْنُ أَعْلَمُ بِمَنْ فِيهَا ۖ لَنُنَجِّيَنَّهُ وَأَهْلَهُ إِلَّا امْرَأَتَهُ كَانَتْ مِنَ الْغَابِرِينَ",
  },
  {
    id: "3373",
    sura: "29",
    VerseIDAr: "33",
    ayatAR:
      "وَلَمَّا أَنْ جَاءَتْ رُسُلُنَا لُوطًا سِيءَ بِهِمْ وَضَاقَ بِهِمْ ذَرْعًا وَقَالُوا لَا تَخَفْ وَلَا تَحْزَنْ ۖ إِنَّا مُنَجُّوكَ وَأَهْلَكَ إِلَّا امْرَأَتَكَ كَانَتْ مِنَ الْغَابِرِينَ",
  },
  {
    id: "3374",
    sura: "29",
    VerseIDAr: "34",
    ayatAR:
      "إِنَّا مُنْزِلُونَ عَلَىٰ أَهْلِ هَٰذِهِ الْقَرْيَةِ رِجْزًا مِنَ السَّمَاءِ بِمَا كَانُوا يَفْسُقُونَ",
  },
  {
    id: "3375",
    sura: "29",
    VerseIDAr: "35",
    ayatAR: "وَلَقَدْ تَرَكْنَا مِنْهَا آيَةً بَيِّنَةً لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "3376",
    sura: "29",
    VerseIDAr: "36",
    ayatAR:
      "وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًا فَقَالَ يَا قَوْمِ اعْبُدُوا اللَّهَ وَارْجُوا الْيَوْمَ الْآخِرَ وَلَا تَعْثَوْا فِي الْأَرْضِ مُفْسِدِينَ",
  },
  {
    id: "3377",
    sura: "29",
    VerseIDAr: "37",
    ayatAR:
      "فَكَذَّبُوهُ فَأَخَذَتْهُمُ الرَّجْفَةُ فَأَصْبَحُوا فِي دَارِهِمْ جَاثِمِينَ",
  },
  {
    id: "3378",
    sura: "29",
    VerseIDAr: "38",
    ayatAR:
      "وَعَادًا وَثَمُودَ وَقَدْ تَبَيَّنَ لَكُمْ مِنْ مَسَاكِنِهِمْ ۖ وَزَيَّنَ لَهُمُ الشَّيْطَانُ أَعْمَالَهُمْ فَصَدَّهُمْ عَنِ السَّبِيلِ وَكَانُوا مُسْتَبْصِرِينَ",
  },
  {
    id: "3379",
    sura: "29",
    VerseIDAr: "39",
    ayatAR:
      "وَقَارُونَ وَفِرْعَوْنَ وَهَامَانَ ۖ وَلَقَدْ جَاءَهُمْ مُوسَىٰ بِالْبَيِّنَاتِ فَاسْتَكْبَرُوا فِي الْأَرْضِ وَمَا كَانُوا سَابِقِينَ",
  },
  {
    id: "3380",
    sura: "29",
    VerseIDAr: "40",
    ayatAR:
      "فَكُلًّا أَخَذْنَا بِذَنْبِهِ ۖ فَمِنْهُمْ مَنْ أَرْسَلْنَا عَلَيْهِ حَاصِبًا وَمِنْهُمْ مَنْ أَخَذَتْهُ الصَّيْحَةُ وَمِنْهُمْ مَنْ خَسَفْنَا بِهِ الْأَرْضَ وَمِنْهُمْ مَنْ أَغْرَقْنَا ۚ وَمَا كَانَ اللَّهُ لِيَظْلِمَهُمْ وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "3381",
    sura: "29",
    VerseIDAr: "41",
    ayatAR:
      "مَثَلُ الَّذِينَ اتَّخَذُوا مِنْ دُونِ اللَّهِ أَوْلِيَاءَ كَمَثَلِ الْعَنْكَبُوتِ اتَّخَذَتْ بَيْتًا ۖ وَإِنَّ أَوْهَنَ الْبُيُوتِ لَبَيْتُ الْعَنْكَبُوتِ ۖ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "3382",
    sura: "29",
    VerseIDAr: "42",
    ayatAR:
      "إِنَّ اللَّهَ يَعْلَمُ مَا يَدْعُونَ مِنْ دُونِهِ مِنْ شَيْءٍ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3383",
    sura: "29",
    VerseIDAr: "43",
    ayatAR:
      "وَتِلْكَ الْأَمْثَالُ نَضْرِبُهَا لِلنَّاسِ ۖ وَمَا يَعْقِلُهَا إِلَّا الْعَالِمُونَ",
  },
  {
    id: "3384",
    sura: "29",
    VerseIDAr: "44",
    ayatAR:
      "خَلَقَ اللَّهُ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ ۚ إِنَّ فِي ذَٰلِكَ لَآيَةً لِلْمُؤْمِنِينَ",
  },
  {
    id: "3385",
    sura: "29",
    VerseIDAr: "45",
    ayatAR:
      "اتْلُ مَا أُوحِيَ إِلَيْكَ مِنَ الْكِتَابِ وَأَقِمِ الصَّلَاةَ ۖ إِنَّ الصَّلَاةَ تَنْهَىٰ عَنِ الْفَحْشَاءِ وَالْمُنْكَرِ ۗ وَلَذِكْرُ اللَّهِ أَكْبَرُ ۗ وَاللَّهُ يَعْلَمُ مَا تَصْنَعُونَ",
  },
  {
    id: "3386",
    sura: "29",
    VerseIDAr: "46",
    ayatAR:
      "وَلَا تُجَادِلُوا أَهْلَ الْكِتَابِ إِلَّا بِالَّتِي هِيَ أَحْسَنُ إِلَّا الَّذِينَ ظَلَمُوا مِنْهُمْ ۖ وَقُولُوا آمَنَّا بِالَّذِي أُنْزِلَ إِلَيْنَا وَأُنْزِلَ إِلَيْكُمْ وَإِلَٰهُنَا وَإِلَٰهُكُمْ وَاحِدٌ وَنَحْنُ لَهُ مُسْلِمُونَ",
  },
  {
    id: "3387",
    sura: "29",
    VerseIDAr: "47",
    ayatAR:
      "وَكَذَٰلِكَ أَنْزَلْنَا إِلَيْكَ الْكِتَابَ ۚ فَالَّذِينَ آتَيْنَاهُمُ الْكِتَابَ يُؤْمِنُونَ بِهِ ۖ وَمِنْ هَٰؤُلَاءِ مَنْ يُؤْمِنُ بِهِ ۚ وَمَا يَجْحَدُ بِآيَاتِنَا إِلَّا الْكَافِرُونَ",
  },
  {
    id: "3388",
    sura: "29",
    VerseIDAr: "48",
    ayatAR:
      "وَمَا كُنْتَ تَتْلُو مِنْ قَبْلِهِ مِنْ كِتَابٍ وَلَا تَخُطُّهُ بِيَمِينِكَ ۖ إِذًا لَارْتَابَ الْمُبْطِلُونَ",
  },
  {
    id: "3389",
    sura: "29",
    VerseIDAr: "49",
    ayatAR:
      "بَلْ هُوَ آيَاتٌ بَيِّنَاتٌ فِي صُدُورِ الَّذِينَ أُوتُوا الْعِلْمَ ۚ وَمَا يَجْحَدُ بِآيَاتِنَا إِلَّا الظَّالِمُونَ",
  },
  {
    id: "3390",
    sura: "29",
    VerseIDAr: "50",
    ayatAR:
      "وَقَالُوا لَوْلَا أُنْزِلَ عَلَيْهِ آيَاتٌ مِنْ رَبِّهِ ۖ قُلْ إِنَّمَا الْآيَاتُ عِنْدَ اللَّهِ وَإِنَّمَا أَنَا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "3391",
    sura: "29",
    VerseIDAr: "51",
    ayatAR:
      "أَوَلَمْ يَكْفِهِمْ أَنَّا أَنْزَلْنَا عَلَيْكَ الْكِتَابَ يُتْلَىٰ عَلَيْهِمْ ۚ إِنَّ فِي ذَٰلِكَ لَرَحْمَةً وَذِكْرَىٰ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "3392",
    sura: "29",
    VerseIDAr: "52",
    ayatAR:
      "قُلْ كَفَىٰ بِاللَّهِ بَيْنِي وَبَيْنَكُمْ شَهِيدًا ۖ يَعْلَمُ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۗ وَالَّذِينَ آمَنُوا بِالْبَاطِلِ وَكَفَرُوا بِاللَّهِ أُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "3393",
    sura: "29",
    VerseIDAr: "53",
    ayatAR:
      "وَيَسْتَعْجِلُونَكَ بِالْعَذَابِ ۚ وَلَوْلَا أَجَلٌ مُسَمًّى لَجَاءَهُمُ الْعَذَابُ وَلَيَأْتِيَنَّهُمْ بَغْتَةً وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "3394",
    sura: "29",
    VerseIDAr: "54",
    ayatAR:
      "يَسْتَعْجِلُونَكَ بِالْعَذَابِ وَإِنَّ جَهَنَّمَ لَمُحِيطَةٌ بِالْكَافِرِينَ",
  },
  {
    id: "3395",
    sura: "29",
    VerseIDAr: "55",
    ayatAR:
      "يَوْمَ يَغْشَاهُمُ الْعَذَابُ مِنْ فَوْقِهِمْ وَمِنْ تَحْتِ أَرْجُلِهِمْ وَيَقُولُ ذُوقُوا مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3396",
    sura: "29",
    VerseIDAr: "56",
    ayatAR:
      "يَا عِبَادِيَ الَّذِينَ آمَنُوا إِنَّ أَرْضِي وَاسِعَةٌ فَإِيَّايَ فَاعْبُدُونِ",
  },
  {
    id: "3397",
    sura: "29",
    VerseIDAr: "57",
    ayatAR: "كُلُّ نَفْسٍ ذَائِقَةُ الْمَوْتِ ۖ ثُمَّ إِلَيْنَا تُرْجَعُونَ",
  },
  {
    id: "3398",
    sura: "29",
    VerseIDAr: "58",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَنُبَوِّئَنَّهُمْ مِنَ الْجَنَّةِ غُرَفًا تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ نِعْمَ أَجْرُ الْعَامِلِينَ",
  },
  {
    id: "3399",
    sura: "29",
    VerseIDAr: "59",
    ayatAR: "الَّذِينَ صَبَرُوا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ",
  },
  {
    id: "3400",
    sura: "29",
    VerseIDAr: "60",
    ayatAR:
      "وَكَأَيِّنْ مِنْ دَابَّةٍ لَا تَحْمِلُ رِزْقَهَا اللَّهُ يَرْزُقُهَا وَإِيَّاكُمْ ۚ وَهُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "3401",
    sura: "29",
    VerseIDAr: "61",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَسَخَّرَ الشَّمْسَ وَالْقَمَرَ لَيَقُولُنَّ اللَّهُ ۖ فَأَنَّىٰ يُؤْفَكُونَ",
  },
  {
    id: "3402",
    sura: "29",
    VerseIDAr: "62",
    ayatAR:
      "اللَّهُ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ مِنْ عِبَادِهِ وَيَقْدِرُ لَهُ ۚ إِنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "3403",
    sura: "29",
    VerseIDAr: "63",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ نَزَّلَ مِنَ السَّمَاءِ مَاءً فَأَحْيَا بِهِ الْأَرْضَ مِنْ بَعْدِ مَوْتِهَا لَيَقُولُنَّ اللَّهُ ۚ قُلِ الْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْقِلُونَ",
  },
  {
    id: "3404",
    sura: "29",
    VerseIDAr: "64",
    ayatAR:
      "وَمَا هَٰذِهِ الْحَيَاةُ الدُّنْيَا إِلَّا لَهْوٌ وَلَعِبٌ ۚ وَإِنَّ الدَّارَ الْآخِرَةَ لَهِيَ الْحَيَوَانُ ۚ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "3405",
    sura: "29",
    VerseIDAr: "65",
    ayatAR:
      "فَإِذَا رَكِبُوا فِي الْفُلْكِ دَعَوُا اللَّهَ مُخْلِصِينَ لَهُ الدِّينَ فَلَمَّا نَجَّاهُمْ إِلَى الْبَرِّ إِذَا هُمْ يُشْرِكُونَ",
  },
  {
    id: "3406",
    sura: "29",
    VerseIDAr: "66",
    ayatAR:
      "لِيَكْفُرُوا بِمَا آتَيْنَاهُمْ وَلِيَتَمَتَّعُوا ۖ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "3407",
    sura: "29",
    VerseIDAr: "67",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّا جَعَلْنَا حَرَمًا آمِنًا وَيُتَخَطَّفُ النَّاسُ مِنْ حَوْلِهِمْ ۚ أَفَبِالْبَاطِلِ يُؤْمِنُونَ وَبِنِعْمَةِ اللَّهِ يَكْفُرُونَ",
  },
  {
    id: "3408",
    sura: "29",
    VerseIDAr: "68",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَوْ كَذَّبَ بِالْحَقِّ لَمَّا جَاءَهُ ۚ أَلَيْسَ فِي جَهَنَّمَ مَثْوًى لِلْكَافِرِينَ",
  },
  {
    id: "3409",
    sura: "29",
    VerseIDAr: "69",
    ayatAR:
      "وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا ۚ وَإِنَّ اللَّهَ لَمَعَ الْمُحْسِنِينَ",
  },
  {
    id: "3410",
    sura: "30",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  { id: "3411", sura: "30", VerseIDAr: "2", ayatAR: "غُلِبَتِ الرُّومُ" },
  {
    id: "3412",
    sura: "30",
    VerseIDAr: "3",
    ayatAR: "فِي أَدْنَى الْأَرْضِ وَهُمْ مِنْ بَعْدِ غَلَبِهِمْ سَيَغْلِبُونَ",
  },
  {
    id: "3413",
    sura: "30",
    VerseIDAr: "4",
    ayatAR:
      "فِي بِضْعِ سِنِينَ ۗ لِلَّهِ الْأَمْرُ مِنْ قَبْلُ وَمِنْ بَعْدُ ۚ وَيَوْمَئِذٍ يَفْرَحُ الْمُؤْمِنُونَ",
  },
  {
    id: "3414",
    sura: "30",
    VerseIDAr: "5",
    ayatAR:
      "بِنَصْرِ اللَّهِ ۚ يَنْصُرُ مَنْ يَشَاءُ ۖ وَهُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3415",
    sura: "30",
    VerseIDAr: "6",
    ayatAR:
      "وَعْدَ اللَّهِ ۖ لَا يُخْلِفُ اللَّهُ وَعْدَهُ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "3416",
    sura: "30",
    VerseIDAr: "7",
    ayatAR:
      "يَعْلَمُونَ ظَاهِرًا مِنَ الْحَيَاةِ الدُّنْيَا وَهُمْ عَنِ الْآخِرَةِ هُمْ غَافِلُونَ",
  },
  {
    id: "3417",
    sura: "30",
    VerseIDAr: "8",
    ayatAR:
      "أَوَلَمْ يَتَفَكَّرُوا فِي أَنْفُسِهِمْ ۗ مَا خَلَقَ اللَّهُ السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا إِلَّا بِالْحَقِّ وَأَجَلٍ مُسَمًّى ۗ وَإِنَّ كَثِيرًا مِنَ النَّاسِ بِلِقَاءِ رَبِّهِمْ لَكَافِرُونَ",
  },
  {
    id: "3418",
    sura: "30",
    VerseIDAr: "9",
    ayatAR:
      "أَوَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلِهِمْ ۚ كَانُوا أَشَدَّ مِنْهُمْ قُوَّةً وَأَثَارُوا الْأَرْضَ وَعَمَرُوهَا أَكْثَرَ مِمَّا عَمَرُوهَا وَجَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ ۖ فَمَا كَانَ اللَّهُ لِيَظْلِمَهُمْ وَلَٰكِنْ كَانُوا أَنْفُسَهُمْ يَظْلِمُونَ",
  },
  {
    id: "3419",
    sura: "30",
    VerseIDAr: "10",
    ayatAR:
      "ثُمَّ كَانَ عَاقِبَةَ الَّذِينَ أَسَاءُوا السُّوأَىٰ أَنْ كَذَّبُوا بِآيَاتِ اللَّهِ وَكَانُوا بِهَا يَسْتَهْزِئُونَ",
  },
  {
    id: "3420",
    sura: "30",
    VerseIDAr: "11",
    ayatAR:
      "اللَّهُ يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ ثُمَّ إِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3421",
    sura: "30",
    VerseIDAr: "12",
    ayatAR: "وَيَوْمَ تَقُومُ السَّاعَةُ يُبْلِسُ الْمُجْرِمُونَ",
  },
  {
    id: "3422",
    sura: "30",
    VerseIDAr: "13",
    ayatAR:
      "وَلَمْ يَكُنْ لَهُمْ مِنْ شُرَكَائِهِمْ شُفَعَاءُ وَكَانُوا بِشُرَكَائِهِمْ كَافِرِينَ",
  },
  {
    id: "3423",
    sura: "30",
    VerseIDAr: "14",
    ayatAR: "وَيَوْمَ تَقُومُ السَّاعَةُ يَوْمَئِذٍ يَتَفَرَّقُونَ",
  },
  {
    id: "3424",
    sura: "30",
    VerseIDAr: "15",
    ayatAR:
      "فَأَمَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَهُمْ فِي رَوْضَةٍ يُحْبَرُونَ",
  },
  {
    id: "3425",
    sura: "30",
    VerseIDAr: "16",
    ayatAR:
      "وَأَمَّا الَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا وَلِقَاءِ الْآخِرَةِ فَأُولَٰئِكَ فِي الْعَذَابِ مُحْضَرُونَ",
  },
  {
    id: "3426",
    sura: "30",
    VerseIDAr: "17",
    ayatAR: "فَسُبْحَانَ اللَّهِ حِينَ تُمْسُونَ وَحِينَ تُصْبِحُونَ",
  },
  {
    id: "3427",
    sura: "30",
    VerseIDAr: "18",
    ayatAR:
      "وَلَهُ الْحَمْدُ فِي السَّمَاوَاتِ وَالْأَرْضِ وَعَشِيًّا وَحِينَ تُظْهِرُونَ",
  },
  {
    id: "3428",
    sura: "30",
    VerseIDAr: "19",
    ayatAR:
      "يُخْرِجُ الْحَيَّ مِنَ الْمَيِّتِ وَيُخْرِجُ الْمَيِّتَ مِنَ الْحَيِّ وَيُحْيِي الْأَرْضَ بَعْدَ مَوْتِهَا ۚ وَكَذَٰلِكَ تُخْرَجُونَ",
  },
  {
    id: "3429",
    sura: "30",
    VerseIDAr: "20",
    ayatAR:
      "وَمِنْ آيَاتِهِ أَنْ خَلَقَكُمْ مِنْ تُرَابٍ ثُمَّ إِذَا أَنْتُمْ بَشَرٌ تَنْتَشِرُونَ",
  },
  {
    id: "3430",
    sura: "30",
    VerseIDAr: "21",
    ayatAR:
      "وَمِنْ آيَاتِهِ أَنْ خَلَقَ لَكُمْ مِنْ أَنْفُسِكُمْ أَزْوَاجًا لِتَسْكُنُوا إِلَيْهَا وَجَعَلَ بَيْنَكُمْ مَوَدَّةً وَرَحْمَةً ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "3431",
    sura: "30",
    VerseIDAr: "22",
    ayatAR:
      "وَمِنْ آيَاتِهِ خَلْقُ السَّمَاوَاتِ وَالْأَرْضِ وَاخْتِلَافُ أَلْسِنَتِكُمْ وَأَلْوَانِكُمْ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِلْعَالِمِينَ",
  },
  {
    id: "3432",
    sura: "30",
    VerseIDAr: "23",
    ayatAR:
      "وَمِنْ آيَاتِهِ مَنَامُكُمْ بِاللَّيْلِ وَالنَّهَارِ وَابْتِغَاؤُكُمْ مِنْ فَضْلِهِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَسْمَعُونَ",
  },
  {
    id: "3433",
    sura: "30",
    VerseIDAr: "24",
    ayatAR:
      "وَمِنْ آيَاتِهِ يُرِيكُمُ الْبَرْقَ خَوْفًا وَطَمَعًا وَيُنَزِّلُ مِنَ السَّمَاءِ مَاءً فَيُحْيِي بِهِ الْأَرْضَ بَعْدَ مَوْتِهَا ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "3434",
    sura: "30",
    VerseIDAr: "25",
    ayatAR:
      "وَمِنْ آيَاتِهِ أَنْ تَقُومَ السَّمَاءُ وَالْأَرْضُ بِأَمْرِهِ ۚ ثُمَّ إِذَا دَعَاكُمْ دَعْوَةً مِنَ الْأَرْضِ إِذَا أَنْتُمْ تَخْرُجُونَ",
  },
  {
    id: "3435",
    sura: "30",
    VerseIDAr: "26",
    ayatAR: "وَلَهُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ كُلٌّ لَهُ قَانِتُونَ",
  },
  {
    id: "3436",
    sura: "30",
    VerseIDAr: "27",
    ayatAR:
      "وَهُوَ الَّذِي يَبْدَأُ الْخَلْقَ ثُمَّ يُعِيدُهُ وَهُوَ أَهْوَنُ عَلَيْهِ ۚ وَلَهُ الْمَثَلُ الْأَعْلَىٰ فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3437",
    sura: "30",
    VerseIDAr: "28",
    ayatAR:
      "ضَرَبَ لَكُمْ مَثَلًا مِنْ أَنْفُسِكُمْ ۖ هَلْ لَكُمْ مِنْ مَا مَلَكَتْ أَيْمَانُكُمْ مِنْ شُرَكَاءَ فِي مَا رَزَقْنَاكُمْ فَأَنْتُمْ فِيهِ سَوَاءٌ تَخَافُونَهُمْ كَخِيفَتِكُمْ أَنْفُسَكُمْ ۚ كَذَٰلِكَ نُفَصِّلُ الْآيَاتِ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "3438",
    sura: "30",
    VerseIDAr: "29",
    ayatAR:
      "بَلِ اتَّبَعَ الَّذِينَ ظَلَمُوا أَهْوَاءَهُمْ بِغَيْرِ عِلْمٍ ۖ فَمَنْ يَهْدِي مَنْ أَضَلَّ اللَّهُ ۖ وَمَا لَهُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "3439",
    sura: "30",
    VerseIDAr: "30",
    ayatAR:
      "فَأَقِمْ وَجْهَكَ لِلدِّينِ حَنِيفًا ۚ فِطْرَتَ اللَّهِ الَّتِي فَطَرَ النَّاسَ عَلَيْهَا ۚ لَا تَبْدِيلَ لِخَلْقِ اللَّهِ ۚ ذَٰلِكَ الدِّينُ الْقَيِّمُ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "3440",
    sura: "30",
    VerseIDAr: "31",
    ayatAR:
      "مُنِيبِينَ إِلَيْهِ وَاتَّقُوهُ وَأَقِيمُوا الصَّلَاةَ وَلَا تَكُونُوا مِنَ الْمُشْرِكِينَ",
  },
  {
    id: "3441",
    sura: "30",
    VerseIDAr: "32",
    ayatAR:
      "مِنَ الَّذِينَ فَرَّقُوا دِينَهُمْ وَكَانُوا شِيَعًا ۖ كُلُّ حِزْبٍ بِمَا لَدَيْهِمْ فَرِحُونَ",
  },
  {
    id: "3442",
    sura: "30",
    VerseIDAr: "33",
    ayatAR:
      "وَإِذَا مَسَّ النَّاسَ ضُرٌّ دَعَوْا رَبَّهُمْ مُنِيبِينَ إِلَيْهِ ثُمَّ إِذَا أَذَاقَهُمْ مِنْهُ رَحْمَةً إِذَا فَرِيقٌ مِنْهُمْ بِرَبِّهِمْ يُشْرِكُونَ",
  },
  {
    id: "3443",
    sura: "30",
    VerseIDAr: "34",
    ayatAR:
      "لِيَكْفُرُوا بِمَا آتَيْنَاهُمْ ۚ فَتَمَتَّعُوا فَسَوْفَ تَعْلَمُونَ",
  },
  {
    id: "3444",
    sura: "30",
    VerseIDAr: "35",
    ayatAR:
      "أَمْ أَنْزَلْنَا عَلَيْهِمْ سُلْطَانًا فَهُوَ يَتَكَلَّمُ بِمَا كَانُوا بِهِ يُشْرِكُونَ",
  },
  {
    id: "3445",
    sura: "30",
    VerseIDAr: "36",
    ayatAR:
      "وَإِذَا أَذَقْنَا النَّاسَ رَحْمَةً فَرِحُوا بِهَا ۖ وَإِنْ تُصِبْهُمْ سَيِّئَةٌ بِمَا قَدَّمَتْ أَيْدِيهِمْ إِذَا هُمْ يَقْنَطُونَ",
  },
  {
    id: "3446",
    sura: "30",
    VerseIDAr: "37",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّ اللَّهَ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "3447",
    sura: "30",
    VerseIDAr: "38",
    ayatAR:
      "فَآتِ ذَا الْقُرْبَىٰ حَقَّهُ وَالْمِسْكِينَ وَابْنَ السَّبِيلِ ۚ ذَٰلِكَ خَيْرٌ لِلَّذِينَ يُرِيدُونَ وَجْهَ اللَّهِ ۖ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "3448",
    sura: "30",
    VerseIDAr: "39",
    ayatAR:
      "وَمَا آتَيْتُمْ مِنْ رِبًا لِيَرْبُوَ فِي أَمْوَالِ النَّاسِ فَلَا يَرْبُو عِنْدَ اللَّهِ ۖ وَمَا آتَيْتُمْ مِنْ زَكَاةٍ تُرِيدُونَ وَجْهَ اللَّهِ فَأُولَٰئِكَ هُمُ الْمُضْعِفُونَ",
  },
  {
    id: "3449",
    sura: "30",
    VerseIDAr: "40",
    ayatAR:
      "اللَّهُ الَّذِي خَلَقَكُمْ ثُمَّ رَزَقَكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ۖ هَلْ مِنْ شُرَكَائِكُمْ مَنْ يَفْعَلُ مِنْ ذَٰلِكُمْ مِنْ شَيْءٍ ۚ سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "3450",
    sura: "30",
    VerseIDAr: "41",
    ayatAR:
      "ظَهَرَ الْفَسَادُ فِي الْبَرِّ وَالْبَحْرِ بِمَا كَسَبَتْ أَيْدِي النَّاسِ لِيُذِيقَهُمْ بَعْضَ الَّذِي عَمِلُوا لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "3451",
    sura: "30",
    VerseIDAr: "42",
    ayatAR:
      "قُلْ سِيرُوا فِي الْأَرْضِ فَانْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلُ ۚ كَانَ أَكْثَرُهُمْ مُشْرِكِينَ",
  },
  {
    id: "3452",
    sura: "30",
    VerseIDAr: "43",
    ayatAR:
      "فَأَقِمْ وَجْهَكَ لِلدِّينِ الْقَيِّمِ مِنْ قَبْلِ أَنْ يَأْتِيَ يَوْمٌ لَا مَرَدَّ لَهُ مِنَ اللَّهِ ۖ يَوْمَئِذٍ يَصَّدَّعُونَ",
  },
  {
    id: "3453",
    sura: "30",
    VerseIDAr: "44",
    ayatAR:
      "مَنْ كَفَرَ فَعَلَيْهِ كُفْرُهُ ۖ وَمَنْ عَمِلَ صَالِحًا فَلِأَنْفُسِهِمْ يَمْهَدُونَ",
  },
  {
    id: "3454",
    sura: "30",
    VerseIDAr: "45",
    ayatAR:
      "لِيَجْزِيَ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ مِنْ فَضْلِهِ ۚ إِنَّهُ لَا يُحِبُّ الْكَافِرِينَ",
  },
  {
    id: "3455",
    sura: "30",
    VerseIDAr: "46",
    ayatAR:
      "وَمِنْ آيَاتِهِ أَنْ يُرْسِلَ الرِّيَاحَ مُبَشِّرَاتٍ وَلِيُذِيقَكُمْ مِنْ رَحْمَتِهِ وَلِتَجْرِيَ الْفُلْكُ بِأَمْرِهِ وَلِتَبْتَغُوا مِنْ فَضْلِهِ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "3456",
    sura: "30",
    VerseIDAr: "47",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا مِنْ قَبْلِكَ رُسُلًا إِلَىٰ قَوْمِهِمْ فَجَاءُوهُمْ بِالْبَيِّنَاتِ فَانْتَقَمْنَا مِنَ الَّذِينَ أَجْرَمُوا ۖ وَكَانَ حَقًّا عَلَيْنَا نَصْرُ الْمُؤْمِنِينَ",
  },
  {
    id: "3457",
    sura: "30",
    VerseIDAr: "48",
    ayatAR:
      "اللَّهُ الَّذِي يُرْسِلُ الرِّيَاحَ فَتُثِيرُ سَحَابًا فَيَبْسُطُهُ فِي السَّمَاءِ كَيْفَ يَشَاءُ وَيَجْعَلُهُ كِسَفًا فَتَرَى الْوَدْقَ يَخْرُجُ مِنْ خِلَالِهِ ۖ فَإِذَا أَصَابَ بِهِ مَنْ يَشَاءُ مِنْ عِبَادِهِ إِذَا هُمْ يَسْتَبْشِرُونَ",
  },
  {
    id: "3458",
    sura: "30",
    VerseIDAr: "49",
    ayatAR:
      "وَإِنْ كَانُوا مِنْ قَبْلِ أَنْ يُنَزَّلَ عَلَيْهِمْ مِنْ قَبْلِهِ لَمُبْلِسِينَ",
  },
  {
    id: "3459",
    sura: "30",
    VerseIDAr: "50",
    ayatAR:
      "فَانْظُرْ إِلَىٰ آثَارِ رَحْمَتِ اللَّهِ كَيْفَ يُحْيِي الْأَرْضَ بَعْدَ مَوْتِهَا ۚ إِنَّ ذَٰلِكَ لَمُحْيِي الْمَوْتَىٰ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "3460",
    sura: "30",
    VerseIDAr: "51",
    ayatAR:
      "وَلَئِنْ أَرْسَلْنَا رِيحًا فَرَأَوْهُ مُصْفَرًّا لَظَلُّوا مِنْ بَعْدِهِ يَكْفُرُونَ",
  },
  {
    id: "3461",
    sura: "30",
    VerseIDAr: "52",
    ayatAR:
      "فَإِنَّكَ لَا تُسْمِعُ الْمَوْتَىٰ وَلَا تُسْمِعُ الصُّمَّ الدُّعَاءَ إِذَا وَلَّوْا مُدْبِرِينَ",
  },
  {
    id: "3462",
    sura: "30",
    VerseIDAr: "53",
    ayatAR:
      "وَمَا أَنْتَ بِهَادِ الْعُمْيِ عَنْ ضَلَالَتِهِمْ ۖ إِنْ تُسْمِعُ إِلَّا مَنْ يُؤْمِنُ بِآيَاتِنَا فَهُمْ مُسْلِمُونَ",
  },
  {
    id: "3463",
    sura: "30",
    VerseIDAr: "54",
    ayatAR:
      "اللَّهُ الَّذِي خَلَقَكُمْ مِنْ ضَعْفٍ ثُمَّ جَعَلَ مِنْ بَعْدِ ضَعْفٍ قُوَّةً ثُمَّ جَعَلَ مِنْ بَعْدِ قُوَّةٍ ضَعْفًا وَشَيْبَةً ۚ يَخْلُقُ مَا يَشَاءُ ۖ وَهُوَ الْعَلِيمُ الْقَدِيرُ",
  },
  {
    id: "3464",
    sura: "30",
    VerseIDAr: "55",
    ayatAR:
      "وَيَوْمَ تَقُومُ السَّاعَةُ يُقْسِمُ الْمُجْرِمُونَ مَا لَبِثُوا غَيْرَ سَاعَةٍ ۚ كَذَٰلِكَ كَانُوا يُؤْفَكُونَ",
  },
  {
    id: "3465",
    sura: "30",
    VerseIDAr: "56",
    ayatAR:
      "وَقَالَ الَّذِينَ أُوتُوا الْعِلْمَ وَالْإِيمَانَ لَقَدْ لَبِثْتُمْ فِي كِتَابِ اللَّهِ إِلَىٰ يَوْمِ الْبَعْثِ ۖ فَهَٰذَا يَوْمُ الْبَعْثِ وَلَٰكِنَّكُمْ كُنْتُمْ لَا تَعْلَمُونَ",
  },
  {
    id: "3466",
    sura: "30",
    VerseIDAr: "57",
    ayatAR:
      "فَيَوْمَئِذٍ لَا يَنْفَعُ الَّذِينَ ظَلَمُوا مَعْذِرَتُهُمْ وَلَا هُمْ يُسْتَعْتَبُونَ",
  },
  {
    id: "3467",
    sura: "30",
    VerseIDAr: "58",
    ayatAR:
      "وَلَقَدْ ضَرَبْنَا لِلنَّاسِ فِي هَٰذَا الْقُرْآنِ مِنْ كُلِّ مَثَلٍ ۚ وَلَئِنْ جِئْتَهُمْ بِآيَةٍ لَيَقُولَنَّ الَّذِينَ كَفَرُوا إِنْ أَنْتُمْ إِلَّا مُبْطِلُونَ",
  },
  {
    id: "3468",
    sura: "30",
    VerseIDAr: "59",
    ayatAR:
      "كَذَٰلِكَ يَطْبَعُ اللَّهُ عَلَىٰ قُلُوبِ الَّذِينَ لَا يَعْلَمُونَ",
  },
  {
    id: "3469",
    sura: "30",
    VerseIDAr: "60",
    ayatAR:
      "فَاصْبِرْ إِنَّ وَعْدَ اللَّهِ حَقٌّ ۖ وَلَا يَسْتَخِفَّنَّكَ الَّذِينَ لَا يُوقِنُونَ",
  },
  {
    id: "3470",
    sura: "31",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  {
    id: "3471",
    sura: "31",
    VerseIDAr: "2",
    ayatAR: "تِلْكَ آيَاتُ الْكِتَابِ الْحَكِيمِ",
  },
  {
    id: "3472",
    sura: "31",
    VerseIDAr: "3",
    ayatAR: "هُدًى وَرَحْمَةً لِلْمُحْسِنِينَ",
  },
  {
    id: "3473",
    sura: "31",
    VerseIDAr: "4",
    ayatAR:
      "الَّذِينَ يُقِيمُونَ الصَّلَاةَ وَيُؤْتُونَ الزَّكَاةَ وَهُمْ بِالْآخِرَةِ هُمْ يُوقِنُونَ",
  },
  {
    id: "3474",
    sura: "31",
    VerseIDAr: "5",
    ayatAR:
      "أُولَٰئِكَ عَلَىٰ هُدًى مِنْ رَبِّهِمْ ۖ وَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "3475",
    sura: "31",
    VerseIDAr: "6",
    ayatAR:
      "وَمِنَ النَّاسِ مَنْ يَشْتَرِي لَهْوَ الْحَدِيثِ لِيُضِلَّ عَنْ سَبِيلِ اللَّهِ بِغَيْرِ عِلْمٍ وَيَتَّخِذَهَا هُزُوًا ۚ أُولَٰئِكَ لَهُمْ عَذَابٌ مُهِينٌ",
  },
  {
    id: "3476",
    sura: "31",
    VerseIDAr: "7",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِ آيَاتُنَا وَلَّىٰ مُسْتَكْبِرًا كَأَنْ لَمْ يَسْمَعْهَا كَأَنَّ فِي أُذُنَيْهِ وَقْرًا ۖ فَبَشِّرْهُ بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "3477",
    sura: "31",
    VerseIDAr: "8",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ جَنَّاتُ النَّعِيمِ",
  },
  {
    id: "3478",
    sura: "31",
    VerseIDAr: "9",
    ayatAR:
      "خَالِدِينَ فِيهَا ۖ وَعْدَ اللَّهِ حَقًّا ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3479",
    sura: "31",
    VerseIDAr: "10",
    ayatAR:
      "خَلَقَ السَّمَاوَاتِ بِغَيْرِ عَمَدٍ تَرَوْنَهَا ۖ وَأَلْقَىٰ فِي الْأَرْضِ رَوَاسِيَ أَنْ تَمِيدَ بِكُمْ وَبَثَّ فِيهَا مِنْ كُلِّ دَابَّةٍ ۚ وَأَنْزَلْنَا مِنَ السَّمَاءِ مَاءً فَأَنْبَتْنَا فِيهَا مِنْ كُلِّ زَوْجٍ كَرِيمٍ",
  },
  {
    id: "3480",
    sura: "31",
    VerseIDAr: "11",
    ayatAR:
      "هَٰذَا خَلْقُ اللَّهِ فَأَرُونِي مَاذَا خَلَقَ الَّذِينَ مِنْ دُونِهِ ۚ بَلِ الظَّالِمُونَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3481",
    sura: "31",
    VerseIDAr: "12",
    ayatAR:
      "وَلَقَدْ آتَيْنَا لُقْمَانَ الْحِكْمَةَ أَنِ اشْكُرْ لِلَّهِ ۚ وَمَنْ يَشْكُرْ فَإِنَّمَا يَشْكُرُ لِنَفْسِهِ ۖ وَمَنْ كَفَرَ فَإِنَّ اللَّهَ غَنِيٌّ حَمِيدٌ",
  },
  {
    id: "3482",
    sura: "31",
    VerseIDAr: "13",
    ayatAR:
      "وَإِذْ قَالَ لُقْمَانُ لِابْنِهِ وَهُوَ يَعِظُهُ يَا بُنَيَّ لَا تُشْرِكْ بِاللَّهِ ۖ إِنَّ الشِّرْكَ لَظُلْمٌ عَظِيمٌ",
  },
  {
    id: "3483",
    sura: "31",
    VerseIDAr: "14",
    ayatAR:
      "وَوَصَّيْنَا الْإِنْسَانَ بِوَالِدَيْهِ حَمَلَتْهُ أُمُّهُ وَهْنًا عَلَىٰ وَهْنٍ وَفِصَالُهُ فِي عَامَيْنِ أَنِ اشْكُرْ لِي وَلِوَالِدَيْكَ إِلَيَّ الْمَصِيرُ",
  },
  {
    id: "3484",
    sura: "31",
    VerseIDAr: "15",
    ayatAR:
      "وَإِنْ جَاهَدَاكَ عَلَىٰ أَنْ تُشْرِكَ بِي مَا لَيْسَ لَكَ بِهِ عِلْمٌ فَلَا تُطِعْهُمَا ۖ وَصَاحِبْهُمَا فِي الدُّنْيَا مَعْرُوفًا ۖ وَاتَّبِعْ سَبِيلَ مَنْ أَنَابَ إِلَيَّ ۚ ثُمَّ إِلَيَّ مَرْجِعُكُمْ فَأُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3485",
    sura: "31",
    VerseIDAr: "16",
    ayatAR:
      "يَا بُنَيَّ إِنَّهَا إِنْ تَكُ مِثْقَالَ حَبَّةٍ مِنْ خَرْدَلٍ فَتَكُنْ فِي صَخْرَةٍ أَوْ فِي السَّمَاوَاتِ أَوْ فِي الْأَرْضِ يَأْتِ بِهَا اللَّهُ ۚ إِنَّ اللَّهَ لَطِيفٌ خَبِيرٌ",
  },
  {
    id: "3486",
    sura: "31",
    VerseIDAr: "17",
    ayatAR:
      "يَا بُنَيَّ أَقِمِ الصَّلَاةَ وَأْمُرْ بِالْمَعْرُوفِ وَانْهَ عَنِ الْمُنْكَرِ وَاصْبِرْ عَلَىٰ مَا أَصَابَكَ ۖ إِنَّ ذَٰلِكَ مِنْ عَزْمِ الْأُمُورِ",
  },
  {
    id: "3487",
    sura: "31",
    VerseIDAr: "18",
    ayatAR:
      "وَلَا تُصَعِّرْ خَدَّكَ لِلنَّاسِ وَلَا تَمْشِ فِي الْأَرْضِ مَرَحًا ۖ إِنَّ اللَّهَ لَا يُحِبُّ كُلَّ مُخْتَالٍ فَخُورٍ",
  },
  {
    id: "3488",
    sura: "31",
    VerseIDAr: "19",
    ayatAR:
      "وَاقْصِدْ فِي مَشْيِكَ وَاغْضُضْ مِنْ صَوْتِكَ ۚ إِنَّ أَنْكَرَ الْأَصْوَاتِ لَصَوْتُ الْحَمِيرِ",
  },
  {
    id: "3489",
    sura: "31",
    VerseIDAr: "20",
    ayatAR:
      "أَلَمْ تَرَوْا أَنَّ اللَّهَ سَخَّرَ لَكُمْ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ وَأَسْبَغَ عَلَيْكُمْ نِعَمَهُ ظَاهِرَةً وَبَاطِنَةً ۗ وَمِنَ النَّاسِ مَنْ يُجَادِلُ فِي اللَّهِ بِغَيْرِ عِلْمٍ وَلَا هُدًى وَلَا كِتَابٍ مُنِيرٍ",
  },
  {
    id: "3490",
    sura: "31",
    VerseIDAr: "21",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمُ اتَّبِعُوا مَا أَنْزَلَ اللَّهُ قَالُوا بَلْ نَتَّبِعُ مَا وَجَدْنَا عَلَيْهِ آبَاءَنَا ۚ أَوَلَوْ كَانَ الشَّيْطَانُ يَدْعُوهُمْ إِلَىٰ عَذَابِ السَّعِيرِ",
  },
  {
    id: "3491",
    sura: "31",
    VerseIDAr: "22",
    ayatAR:
      "وَمَنْ يُسْلِمْ وَجْهَهُ إِلَى اللَّهِ وَهُوَ مُحْسِنٌ فَقَدِ اسْتَمْسَكَ بِالْعُرْوَةِ الْوُثْقَىٰ ۗ وَإِلَى اللَّهِ عَاقِبَةُ الْأُمُورِ",
  },
  {
    id: "3492",
    sura: "31",
    VerseIDAr: "23",
    ayatAR:
      "وَمَنْ كَفَرَ فَلَا يَحْزُنْكَ كُفْرُهُ ۚ إِلَيْنَا مَرْجِعُهُمْ فَنُنَبِّئُهُمْ بِمَا عَمِلُوا ۚ إِنَّ اللَّهَ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "3493",
    sura: "31",
    VerseIDAr: "24",
    ayatAR: "نُمَتِّعُهُمْ قَلِيلًا ثُمَّ نَضْطَرُّهُمْ إِلَىٰ عَذَابٍ غَلِيظٍ",
  },
  {
    id: "3494",
    sura: "31",
    VerseIDAr: "25",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ لَيَقُولُنَّ اللَّهُ ۚ قُلِ الْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "3495",
    sura: "31",
    VerseIDAr: "26",
    ayatAR:
      "لِلَّهِ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ إِنَّ اللَّهَ هُوَ الْغَنِيُّ الْحَمِيدُ",
  },
  {
    id: "3496",
    sura: "31",
    VerseIDAr: "27",
    ayatAR:
      "وَلَوْ أَنَّمَا فِي الْأَرْضِ مِنْ شَجَرَةٍ أَقْلَامٌ وَالْبَحْرُ يَمُدُّهُ مِنْ بَعْدِهِ سَبْعَةُ أَبْحُرٍ مَا نَفِدَتْ كَلِمَاتُ اللَّهِ ۗ إِنَّ اللَّهَ عَزِيزٌ حَكِيمٌ",
  },
  {
    id: "3497",
    sura: "31",
    VerseIDAr: "28",
    ayatAR:
      "مَا خَلْقُكُمْ وَلَا بَعْثُكُمْ إِلَّا كَنَفْسٍ وَاحِدَةٍ ۗ إِنَّ اللَّهَ سَمِيعٌ بَصِيرٌ",
  },
  {
    id: "3498",
    sura: "31",
    VerseIDAr: "29",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ يُولِجُ اللَّيْلَ فِي النَّهَارِ وَيُولِجُ النَّهَارَ فِي اللَّيْلِ وَسَخَّرَ الشَّمْسَ وَالْقَمَرَ كُلٌّ يَجْرِي إِلَىٰ أَجَلٍ مُسَمًّى وَأَنَّ اللَّهَ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "3499",
    sura: "31",
    VerseIDAr: "30",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ هُوَ الْحَقُّ وَأَنَّ مَا يَدْعُونَ مِنْ دُونِهِ الْبَاطِلُ وَأَنَّ اللَّهَ هُوَ الْعَلِيُّ الْكَبِيرُ",
  },
  {
    id: "3500",
    sura: "31",
    VerseIDAr: "31",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ الْفُلْكَ تَجْرِي فِي الْبَحْرِ بِنِعْمَتِ اللَّهِ لِيُرِيَكُمْ مِنْ آيَاتِهِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِكُلِّ صَبَّارٍ شَكُورٍ",
  },
  {
    id: "3501",
    sura: "31",
    VerseIDAr: "32",
    ayatAR:
      "وَإِذَا غَشِيَهُمْ مَوْجٌ كَالظُّلَلِ دَعَوُا اللَّهَ مُخْلِصِينَ لَهُ الدِّينَ فَلَمَّا نَجَّاهُمْ إِلَى الْبَرِّ فَمِنْهُمْ مُقْتَصِدٌ ۚ وَمَا يَجْحَدُ بِآيَاتِنَا إِلَّا كُلُّ خَتَّارٍ كَفُورٍ",
  },
  {
    id: "3502",
    sura: "31",
    VerseIDAr: "33",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ اتَّقُوا رَبَّكُمْ وَاخْشَوْا يَوْمًا لَا يَجْزِي وَالِدٌ عَنْ وَلَدِهِ وَلَا مَوْلُودٌ هُوَ جَازٍ عَنْ وَالِدِهِ شَيْئًا ۚ إِنَّ وَعْدَ اللَّهِ حَقٌّ ۖ فَلَا تَغُرَّنَّكُمُ الْحَيَاةُ الدُّنْيَا وَلَا يَغُرَّنَّكُمْ بِاللَّهِ الْغَرُورُ",
  },
  {
    id: "3503",
    sura: "31",
    VerseIDAr: "34",
    ayatAR:
      "إِنَّ اللَّهَ عِنْدَهُ عِلْمُ السَّاعَةِ وَيُنَزِّلُ الْغَيْثَ وَيَعْلَمُ مَا فِي الْأَرْحَامِ ۖ وَمَا تَدْرِي نَفْسٌ مَاذَا تَكْسِبُ غَدًا ۖ وَمَا تَدْرِي نَفْسٌ بِأَيِّ أَرْضٍ تَمُوتُ ۚ إِنَّ اللَّهَ عَلِيمٌ خَبِيرٌ",
  },
  {
    id: "3504",
    sura: "32",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الم",
  },
  {
    id: "3505",
    sura: "32",
    VerseIDAr: "2",
    ayatAR: "تَنْزِيلُ الْكِتَابِ لَا رَيْبَ فِيهِ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3506",
    sura: "32",
    VerseIDAr: "3",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَاهُ ۚ بَلْ هُوَ الْحَقُّ مِنْ رَبِّكَ لِتُنْذِرَ قَوْمًا مَا أَتَاهُمْ مِنْ نَذِيرٍ مِنْ قَبْلِكَ لَعَلَّهُمْ يَهْتَدُونَ",
  },
  {
    id: "3507",
    sura: "32",
    VerseIDAr: "4",
    ayatAR:
      "اللَّهُ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا فِي سِتَّةِ أَيَّامٍ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ ۖ مَا لَكُمْ مِنْ دُونِهِ مِنْ وَلِيٍّ وَلَا شَفِيعٍ ۚ أَفَلَا تَتَذَكَّرُونَ",
  },
  {
    id: "3508",
    sura: "32",
    VerseIDAr: "5",
    ayatAR:
      "يُدَبِّرُ الْأَمْرَ مِنَ السَّمَاءِ إِلَى الْأَرْضِ ثُمَّ يَعْرُجُ إِلَيْهِ فِي يَوْمٍ كَانَ مِقْدَارُهُ أَلْفَ سَنَةٍ مِمَّا تَعُدُّونَ",
  },
  {
    id: "3509",
    sura: "32",
    VerseIDAr: "6",
    ayatAR: "ذَٰلِكَ عَالِمُ الْغَيْبِ وَالشَّهَادَةِ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "3510",
    sura: "32",
    VerseIDAr: "7",
    ayatAR:
      "الَّذِي أَحْسَنَ كُلَّ شَيْءٍ خَلَقَهُ ۖ وَبَدَأَ خَلْقَ الْإِنْسَانِ مِنْ طِينٍ",
  },
  {
    id: "3511",
    sura: "32",
    VerseIDAr: "8",
    ayatAR: "ثُمَّ جَعَلَ نَسْلَهُ مِنْ سُلَالَةٍ مِنْ مَاءٍ مَهِينٍ",
  },
  {
    id: "3512",
    sura: "32",
    VerseIDAr: "9",
    ayatAR:
      "ثُمَّ سَوَّاهُ وَنَفَخَ فِيهِ مِنْ رُوحِهِ ۖ وَجَعَلَ لَكُمُ السَّمْعَ وَالْأَبْصَارَ وَالْأَفْئِدَةَ ۚ قَلِيلًا مَا تَشْكُرُونَ",
  },
  {
    id: "3513",
    sura: "32",
    VerseIDAr: "10",
    ayatAR:
      "وَقَالُوا أَإِذَا ضَلَلْنَا فِي الْأَرْضِ أَإِنَّا لَفِي خَلْقٍ جَدِيدٍ ۚ بَلْ هُمْ بِلِقَاءِ رَبِّهِمْ كَافِرُونَ",
  },
  {
    id: "3514",
    sura: "32",
    VerseIDAr: "11",
    ayatAR:
      "قُلْ يَتَوَفَّاكُمْ مَلَكُ الْمَوْتِ الَّذِي وُكِّلَ بِكُمْ ثُمَّ إِلَىٰ رَبِّكُمْ تُرْجَعُونَ",
  },
  {
    id: "3515",
    sura: "32",
    VerseIDAr: "12",
    ayatAR:
      "وَلَوْ تَرَىٰ إِذِ الْمُجْرِمُونَ نَاكِسُو رُءُوسِهِمْ عِنْدَ رَبِّهِمْ رَبَّنَا أَبْصَرْنَا وَسَمِعْنَا فَارْجِعْنَا نَعْمَلْ صَالِحًا إِنَّا مُوقِنُونَ",
  },
  {
    id: "3516",
    sura: "32",
    VerseIDAr: "13",
    ayatAR:
      "وَلَوْ شِئْنَا لَآتَيْنَا كُلَّ نَفْسٍ هُدَاهَا وَلَٰكِنْ حَقَّ الْقَوْلُ مِنِّي لَأَمْلَأَنَّ جَهَنَّمَ مِنَ الْجِنَّةِ وَالنَّاسِ أَجْمَعِينَ",
  },
  {
    id: "3517",
    sura: "32",
    VerseIDAr: "14",
    ayatAR:
      "فَذُوقُوا بِمَا نَسِيتُمْ لِقَاءَ يَوْمِكُمْ هَٰذَا إِنَّا نَسِينَاكُمْ ۖ وَذُوقُوا عَذَابَ الْخُلْدِ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3518",
    sura: "32",
    VerseIDAr: "15",
    ayatAR:
      "إِنَّمَا يُؤْمِنُ بِآيَاتِنَا الَّذِينَ إِذَا ذُكِّرُوا بِهَا خَرُّوا سُجَّدًا وَسَبَّحُوا بِحَمْدِ رَبِّهِمْ وَهُمْ لَا يَسْتَكْبِرُونَ ۩",
  },
  {
    id: "3519",
    sura: "32",
    VerseIDAr: "16",
    ayatAR:
      "تَتَجَافَىٰ جُنُوبُهُمْ عَنِ الْمَضَاجِعِ يَدْعُونَ رَبَّهُمْ خَوْفًا وَطَمَعًا وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "3520",
    sura: "32",
    VerseIDAr: "17",
    ayatAR:
      "فَلَا تَعْلَمُ نَفْسٌ مَا أُخْفِيَ لَهُمْ مِنْ قُرَّةِ أَعْيُنٍ جَزَاءً بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3521",
    sura: "32",
    VerseIDAr: "18",
    ayatAR: "أَفَمَنْ كَانَ مُؤْمِنًا كَمَنْ كَانَ فَاسِقًا ۚ لَا يَسْتَوُونَ",
  },
  {
    id: "3522",
    sura: "32",
    VerseIDAr: "19",
    ayatAR:
      "أَمَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَلَهُمْ جَنَّاتُ الْمَأْوَىٰ نُزُلًا بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3523",
    sura: "32",
    VerseIDAr: "20",
    ayatAR:
      "وَأَمَّا الَّذِينَ فَسَقُوا فَمَأْوَاهُمُ النَّارُ ۖ كُلَّمَا أَرَادُوا أَنْ يَخْرُجُوا مِنْهَا أُعِيدُوا فِيهَا وَقِيلَ لَهُمْ ذُوقُوا عَذَابَ النَّارِ الَّذِي كُنْتُمْ بِهِ تُكَذِّبُونَ",
  },
  {
    id: "3524",
    sura: "32",
    VerseIDAr: "21",
    ayatAR:
      "وَلَنُذِيقَنَّهُمْ مِنَ الْعَذَابِ الْأَدْنَىٰ دُونَ الْعَذَابِ الْأَكْبَرِ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "3525",
    sura: "32",
    VerseIDAr: "22",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنْ ذُكِّرَ بِآيَاتِ رَبِّهِ ثُمَّ أَعْرَضَ عَنْهَا ۚ إِنَّا مِنَ الْمُجْرِمِينَ مُنْتَقِمُونَ",
  },
  {
    id: "3526",
    sura: "32",
    VerseIDAr: "23",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ فَلَا تَكُنْ فِي مِرْيَةٍ مِنْ لِقَائِهِ ۖ وَجَعَلْنَاهُ هُدًى لِبَنِي إِسْرَائِيلَ",
  },
  {
    id: "3527",
    sura: "32",
    VerseIDAr: "24",
    ayatAR:
      "وَجَعَلْنَا مِنْهُمْ أَئِمَّةً يَهْدُونَ بِأَمْرِنَا لَمَّا صَبَرُوا ۖ وَكَانُوا بِآيَاتِنَا يُوقِنُونَ",
  },
  {
    id: "3528",
    sura: "32",
    VerseIDAr: "25",
    ayatAR:
      "إِنَّ رَبَّكَ هُوَ يَفْصِلُ بَيْنَهُمْ يَوْمَ الْقِيَامَةِ فِيمَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "3529",
    sura: "32",
    VerseIDAr: "26",
    ayatAR:
      "أَوَلَمْ يَهْدِ لَهُمْ كَمْ أَهْلَكْنَا مِنْ قَبْلِهِمْ مِنَ الْقُرُونِ يَمْشُونَ فِي مَسَاكِنِهِمْ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ ۖ أَفَلَا يَسْمَعُونَ",
  },
  {
    id: "3530",
    sura: "32",
    VerseIDAr: "27",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّا نَسُوقُ الْمَاءَ إِلَى الْأَرْضِ الْجُرُزِ فَنُخْرِجُ بِهِ زَرْعًا تَأْكُلُ مِنْهُ أَنْعَامُهُمْ وَأَنْفُسُهُمْ ۖ أَفَلَا يُبْصِرُونَ",
  },
  {
    id: "3531",
    sura: "32",
    VerseIDAr: "28",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْفَتْحُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3532",
    sura: "32",
    VerseIDAr: "29",
    ayatAR:
      "قُلْ يَوْمَ الْفَتْحِ لَا يَنْفَعُ الَّذِينَ كَفَرُوا إِيمَانُهُمْ وَلَا هُمْ يُنْظَرُونَ",
  },
  {
    id: "3533",
    sura: "32",
    VerseIDAr: "30",
    ayatAR: "فَأَعْرِضْ عَنْهُمْ وَانْتَظِرْ إِنَّهُمْ مُنْتَظِرُونَ",
  },
  {
    id: "3534",
    sura: "33",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا النَّبِيُّ اتَّقِ اللَّهَ وَلَا تُطِعِ الْكَافِرِينَ وَالْمُنَافِقِينَ ۗ إِنَّ اللَّهَ كَانَ عَلِيمًا حَكِيمًا",
  },
  {
    id: "3535",
    sura: "33",
    VerseIDAr: "2",
    ayatAR:
      "وَاتَّبِعْ مَا يُوحَىٰ إِلَيْكَ مِنْ رَبِّكَ ۚ إِنَّ اللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًا",
  },
  {
    id: "3536",
    sura: "33",
    VerseIDAr: "3",
    ayatAR: "وَتَوَكَّلْ عَلَى اللَّهِ ۚ وَكَفَىٰ بِاللَّهِ وَكِيلًا",
  },
  {
    id: "3537",
    sura: "33",
    VerseIDAr: "4",
    ayatAR:
      "مَا جَعَلَ اللَّهُ لِرَجُلٍ مِنْ قَلْبَيْنِ فِي جَوْفِهِ ۚ وَمَا جَعَلَ أَزْوَاجَكُمُ اللَّائِي تُظَاهِرُونَ مِنْهُنَّ أُمَّهَاتِكُمْ ۚ وَمَا جَعَلَ أَدْعِيَاءَكُمْ أَبْنَاءَكُمْ ۚ ذَٰلِكُمْ قَوْلُكُمْ بِأَفْوَاهِكُمْ ۖ وَاللَّهُ يَقُولُ الْحَقَّ وَهُوَ يَهْدِي السَّبِيلَ",
  },
  {
    id: "3538",
    sura: "33",
    VerseIDAr: "5",
    ayatAR:
      "ادْعُوهُمْ لِآبَائِهِمْ هُوَ أَقْسَطُ عِنْدَ اللَّهِ ۚ فَإِنْ لَمْ تَعْلَمُوا آبَاءَهُمْ فَإِخْوَانُكُمْ فِي الدِّينِ وَمَوَالِيكُمْ ۚ وَلَيْسَ عَلَيْكُمْ جُنَاحٌ فِيمَا أَخْطَأْتُمْ بِهِ وَلَٰكِنْ مَا تَعَمَّدَتْ قُلُوبُكُمْ ۚ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "3539",
    sura: "33",
    VerseIDAr: "6",
    ayatAR:
      "النَّبِيُّ أَوْلَىٰ بِالْمُؤْمِنِينَ مِنْ أَنْفُسِهِمْ ۖ وَأَزْوَاجُهُ أُمَّهَاتُهُمْ ۗ وَأُولُو الْأَرْحَامِ بَعْضُهُمْ أَوْلَىٰ بِبَعْضٍ فِي كِتَابِ اللَّهِ مِنَ الْمُؤْمِنِينَ وَالْمُهَاجِرِينَ إِلَّا أَنْ تَفْعَلُوا إِلَىٰ أَوْلِيَائِكُمْ مَعْرُوفًا ۚ كَانَ ذَٰلِكَ فِي الْكِتَابِ مَسْطُورًا",
  },
  {
    id: "3540",
    sura: "33",
    VerseIDAr: "7",
    ayatAR:
      "وَإِذْ أَخَذْنَا مِنَ النَّبِيِّينَ مِيثَاقَهُمْ وَمِنْكَ وَمِنْ نُوحٍ وَإِبْرَاهِيمَ وَمُوسَىٰ وَعِيسَى ابْنِ مَرْيَمَ ۖ وَأَخَذْنَا مِنْهُمْ مِيثَاقًا غَلِيظًا",
  },
  {
    id: "3541",
    sura: "33",
    VerseIDAr: "8",
    ayatAR:
      "لِيَسْأَلَ الصَّادِقِينَ عَنْ صِدْقِهِمْ ۚ وَأَعَدَّ لِلْكَافِرِينَ عَذَابًا أَلِيمًا",
  },
  {
    id: "3542",
    sura: "33",
    VerseIDAr: "9",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اذْكُرُوا نِعْمَةَ اللَّهِ عَلَيْكُمْ إِذْ جَاءَتْكُمْ جُنُودٌ فَأَرْسَلْنَا عَلَيْهِمْ رِيحًا وَجُنُودًا لَمْ تَرَوْهَا ۚ وَكَانَ اللَّهُ بِمَا تَعْمَلُونَ بَصِيرًا",
  },
  {
    id: "3543",
    sura: "33",
    VerseIDAr: "10",
    ayatAR:
      "إِذْ جَاءُوكُمْ مِنْ فَوْقِكُمْ وَمِنْ أَسْفَلَ مِنْكُمْ وَإِذْ زَاغَتِ الْأَبْصَارُ وَبَلَغَتِ الْقُلُوبُ الْحَنَاجِرَ وَتَظُنُّونَ بِاللَّهِ الظُّنُونَا",
  },
  {
    id: "3544",
    sura: "33",
    VerseIDAr: "11",
    ayatAR:
      "هُنَالِكَ ابْتُلِيَ الْمُؤْمِنُونَ وَزُلْزِلُوا زِلْزَالًا شَدِيدًا",
  },
  {
    id: "3545",
    sura: "33",
    VerseIDAr: "12",
    ayatAR:
      "وَإِذْ يَقُولُ الْمُنَافِقُونَ وَالَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ مَا وَعَدَنَا اللَّهُ وَرَسُولُهُ إِلَّا غُرُورًا",
  },
  {
    id: "3546",
    sura: "33",
    VerseIDAr: "13",
    ayatAR:
      "وَإِذْ قَالَتْ طَائِفَةٌ مِنْهُمْ يَا أَهْلَ يَثْرِبَ لَا مُقَامَ لَكُمْ فَارْجِعُوا ۚ وَيَسْتَأْذِنُ فَرِيقٌ مِنْهُمُ النَّبِيَّ يَقُولُونَ إِنَّ بُيُوتَنَا عَوْرَةٌ وَمَا هِيَ بِعَوْرَةٍ ۖ إِنْ يُرِيدُونَ إِلَّا فِرَارًا",
  },
  {
    id: "3547",
    sura: "33",
    VerseIDAr: "14",
    ayatAR:
      "وَلَوْ دُخِلَتْ عَلَيْهِمْ مِنْ أَقْطَارِهَا ثُمَّ سُئِلُوا الْفِتْنَةَ لَآتَوْهَا وَمَا تَلَبَّثُوا بِهَا إِلَّا يَسِيرًا",
  },
  {
    id: "3548",
    sura: "33",
    VerseIDAr: "15",
    ayatAR:
      "وَلَقَدْ كَانُوا عَاهَدُوا اللَّهَ مِنْ قَبْلُ لَا يُوَلُّونَ الْأَدْبَارَ ۚ وَكَانَ عَهْدُ اللَّهِ مَسْئُولًا",
  },
  {
    id: "3549",
    sura: "33",
    VerseIDAr: "16",
    ayatAR:
      "قُلْ لَنْ يَنْفَعَكُمُ الْفِرَارُ إِنْ فَرَرْتُمْ مِنَ الْمَوْتِ أَوِ الْقَتْلِ وَإِذًا لَا تُمَتَّعُونَ إِلَّا قَلِيلًا",
  },
  {
    id: "3550",
    sura: "33",
    VerseIDAr: "17",
    ayatAR:
      "قُلْ مَنْ ذَا الَّذِي يَعْصِمُكُمْ مِنَ اللَّهِ إِنْ أَرَادَ بِكُمْ سُوءًا أَوْ أَرَادَ بِكُمْ رَحْمَةً ۚ وَلَا يَجِدُونَ لَهُمْ مِنْ دُونِ اللَّهِ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "3551",
    sura: "33",
    VerseIDAr: "18",
    ayatAR:
      "قَدْ يَعْلَمُ اللَّهُ الْمُعَوِّقِينَ مِنْكُمْ وَالْقَائِلِينَ لِإِخْوَانِهِمْ هَلُمَّ إِلَيْنَا ۖ وَلَا يَأْتُونَ الْبَأْسَ إِلَّا قَلِيلًا",
  },
  {
    id: "3552",
    sura: "33",
    VerseIDAr: "19",
    ayatAR:
      "أَشِحَّةً عَلَيْكُمْ ۖ فَإِذَا جَاءَ الْخَوْفُ رَأَيْتَهُمْ يَنْظُرُونَ إِلَيْكَ تَدُورُ أَعْيُنُهُمْ كَالَّذِي يُغْشَىٰ عَلَيْهِ مِنَ الْمَوْتِ ۖ فَإِذَا ذَهَبَ الْخَوْفُ سَلَقُوكُمْ بِأَلْسِنَةٍ حِدَادٍ أَشِحَّةً عَلَى الْخَيْرِ ۚ أُولَٰئِكَ لَمْ يُؤْمِنُوا فَأَحْبَطَ اللَّهُ أَعْمَالَهُمْ ۚ وَكَانَ ذَٰلِكَ عَلَى اللَّهِ يَسِيرًا",
  },
  {
    id: "3553",
    sura: "33",
    VerseIDAr: "20",
    ayatAR:
      "يَحْسَبُونَ الْأَحْزَابَ لَمْ يَذْهَبُوا ۖ وَإِنْ يَأْتِ الْأَحْزَابُ يَوَدُّوا لَوْ أَنَّهُمْ بَادُونَ فِي الْأَعْرَابِ يَسْأَلُونَ عَنْ أَنْبَائِكُمْ ۖ وَلَوْ كَانُوا فِيكُمْ مَا قَاتَلُوا إِلَّا قَلِيلًا",
  },
  {
    id: "3554",
    sura: "33",
    VerseIDAr: "21",
    ayatAR:
      "لَقَدْ كَانَ لَكُمْ فِي رَسُولِ اللَّهِ أُسْوَةٌ حَسَنَةٌ لِمَنْ كَانَ يَرْجُو اللَّهَ وَالْيَوْمَ الْآخِرَ وَذَكَرَ اللَّهَ كَثِيرًا",
  },
  {
    id: "3555",
    sura: "33",
    VerseIDAr: "22",
    ayatAR:
      "وَلَمَّا رَأَى الْمُؤْمِنُونَ الْأَحْزَابَ قَالُوا هَٰذَا مَا وَعَدَنَا اللَّهُ وَرَسُولُهُ وَصَدَقَ اللَّهُ وَرَسُولُهُ ۚ وَمَا زَادَهُمْ إِلَّا إِيمَانًا وَتَسْلِيمًا",
  },
  {
    id: "3556",
    sura: "33",
    VerseIDAr: "23",
    ayatAR:
      "مِنَ الْمُؤْمِنِينَ رِجَالٌ صَدَقُوا مَا عَاهَدُوا اللَّهَ عَلَيْهِ ۖ فَمِنْهُمْ مَنْ قَضَىٰ نَحْبَهُ وَمِنْهُمْ مَنْ يَنْتَظِرُ ۖ وَمَا بَدَّلُوا تَبْدِيلًا",
  },
  {
    id: "3557",
    sura: "33",
    VerseIDAr: "24",
    ayatAR:
      "لِيَجْزِيَ اللَّهُ الصَّادِقِينَ بِصِدْقِهِمْ وَيُعَذِّبَ الْمُنَافِقِينَ إِنْ شَاءَ أَوْ يَتُوبَ عَلَيْهِمْ ۚ إِنَّ اللَّهَ كَانَ غَفُورًا رَحِيمًا",
  },
  {
    id: "3558",
    sura: "33",
    VerseIDAr: "25",
    ayatAR:
      "وَرَدَّ اللَّهُ الَّذِينَ كَفَرُوا بِغَيْظِهِمْ لَمْ يَنَالُوا خَيْرًا ۚ وَكَفَى اللَّهُ الْمُؤْمِنِينَ الْقِتَالَ ۚ وَكَانَ اللَّهُ قَوِيًّا عَزِيزًا",
  },
  {
    id: "3559",
    sura: "33",
    VerseIDAr: "26",
    ayatAR:
      "وَأَنْزَلَ الَّذِينَ ظَاهَرُوهُمْ مِنْ أَهْلِ الْكِتَابِ مِنْ صَيَاصِيهِمْ وَقَذَفَ فِي قُلُوبِهِمُ الرُّعْبَ فَرِيقًا تَقْتُلُونَ وَتَأْسِرُونَ فَرِيقًا",
  },
  {
    id: "3560",
    sura: "33",
    VerseIDAr: "27",
    ayatAR:
      "وَأَوْرَثَكُمْ أَرْضَهُمْ وَدِيَارَهُمْ وَأَمْوَالَهُمْ وَأَرْضًا لَمْ تَطَئُوهَا ۚ وَكَانَ اللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرًا",
  },
  {
    id: "3561",
    sura: "33",
    VerseIDAr: "28",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ قُلْ لِأَزْوَاجِكَ إِنْ كُنْتُنَّ تُرِدْنَ الْحَيَاةَ الدُّنْيَا وَزِينَتَهَا فَتَعَالَيْنَ أُمَتِّعْكُنَّ وَأُسَرِّحْكُنَّ سَرَاحًا جَمِيلًا",
  },
  {
    id: "3562",
    sura: "33",
    VerseIDAr: "29",
    ayatAR:
      "وَإِنْ كُنْتُنَّ تُرِدْنَ اللَّهَ وَرَسُولَهُ وَالدَّارَ الْآخِرَةَ فَإِنَّ اللَّهَ أَعَدَّ لِلْمُحْسِنَاتِ مِنْكُنَّ أَجْرًا عَظِيمًا",
  },
  {
    id: "3563",
    sura: "33",
    VerseIDAr: "30",
    ayatAR:
      "يَا نِسَاءَ النَّبِيِّ مَنْ يَأْتِ مِنْكُنَّ بِفَاحِشَةٍ مُبَيِّنَةٍ يُضَاعَفْ لَهَا الْعَذَابُ ضِعْفَيْنِ ۚ وَكَانَ ذَٰلِكَ عَلَى اللَّهِ يَسِيرًا",
  },
  {
    id: "3564",
    sura: "33",
    VerseIDAr: "31",
    ayatAR:
      "وَمَنْ يَقْنُتْ مِنْكُنَّ لِلَّهِ وَرَسُولِهِ وَتَعْمَلْ صَالِحًا نُؤْتِهَا أَجْرَهَا مَرَّتَيْنِ وَأَعْتَدْنَا لَهَا رِزْقًا كَرِيمًا",
  },
  {
    id: "3565",
    sura: "33",
    VerseIDAr: "32",
    ayatAR:
      "يَا نِسَاءَ النَّبِيِّ لَسْتُنَّ كَأَحَدٍ مِنَ النِّسَاءِ ۚ إِنِ اتَّقَيْتُنَّ فَلَا تَخْضَعْنَ بِالْقَوْلِ فَيَطْمَعَ الَّذِي فِي قَلْبِهِ مَرَضٌ وَقُلْنَ قَوْلًا مَعْرُوفًا",
  },
  {
    id: "3566",
    sura: "33",
    VerseIDAr: "33",
    ayatAR:
      "وَقَرْنَ فِي بُيُوتِكُنَّ وَلَا تَبَرَّجْنَ تَبَرُّجَ الْجَاهِلِيَّةِ الْأُولَىٰ ۖ وَأَقِمْنَ الصَّلَاةَ وَآتِينَ الزَّكَاةَ وَأَطِعْنَ اللَّهَ وَرَسُولَهُ ۚ إِنَّمَا يُرِيدُ اللَّهُ لِيُذْهِبَ عَنْكُمُ الرِّجْسَ أَهْلَ الْبَيْتِ وَيُطَهِّرَكُمْ تَطْهِيرًا",
  },
  {
    id: "3567",
    sura: "33",
    VerseIDAr: "34",
    ayatAR:
      "وَاذْكُرْنَ مَا يُتْلَىٰ فِي بُيُوتِكُنَّ مِنْ آيَاتِ اللَّهِ وَالْحِكْمَةِ ۚ إِنَّ اللَّهَ كَانَ لَطِيفًا خَبِيرًا",
  },
  {
    id: "3568",
    sura: "33",
    VerseIDAr: "35",
    ayatAR:
      "إِنَّ الْمُسْلِمِينَ وَالْمُسْلِمَاتِ وَالْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ وَالْقَانِتِينَ وَالْقَانِتَاتِ وَالصَّادِقِينَ وَالصَّادِقَاتِ وَالصَّابِرِينَ وَالصَّابِرَاتِ وَالْخَاشِعِينَ وَالْخَاشِعَاتِ وَالْمُتَصَدِّقِينَ وَالْمُتَصَدِّقَاتِ وَالصَّائِمِينَ وَالصَّائِمَاتِ وَالْحَافِظِينَ فُرُوجَهُمْ وَالْحَافِظَاتِ وَالذَّاكِرِينَ اللَّهَ كَثِيرًا وَالذَّاكِرَاتِ أَعَدَّ اللَّهُ لَهُمْ مَغْفِرَةً وَأَجْرًا عَظِيمًا",
  },
  {
    id: "3569",
    sura: "33",
    VerseIDAr: "36",
    ayatAR:
      "وَمَا كَانَ لِمُؤْمِنٍ وَلَا مُؤْمِنَةٍ إِذَا قَضَى اللَّهُ وَرَسُولُهُ أَمْرًا أَنْ يَكُونَ لَهُمُ الْخِيَرَةُ مِنْ أَمْرِهِمْ ۗ وَمَنْ يَعْصِ اللَّهَ وَرَسُولَهُ فَقَدْ ضَلَّ ضَلَالًا مُبِينًا",
  },
  {
    id: "3570",
    sura: "33",
    VerseIDAr: "37",
    ayatAR:
      "وَإِذْ تَقُولُ لِلَّذِي أَنْعَمَ اللَّهُ عَلَيْهِ وَأَنْعَمْتَ عَلَيْهِ أَمْسِكْ عَلَيْكَ زَوْجَكَ وَاتَّقِ اللَّهَ وَتُخْفِي فِي نَفْسِكَ مَا اللَّهُ مُبْدِيهِ وَتَخْشَى النَّاسَ وَاللَّهُ أَحَقُّ أَنْ تَخْشَاهُ ۖ فَلَمَّا قَضَىٰ زَيْدٌ مِنْهَا وَطَرًا زَوَّجْنَاكَهَا لِكَيْ لَا يَكُونَ عَلَى الْمُؤْمِنِينَ حَرَجٌ فِي أَزْوَاجِ أَدْعِيَائِهِمْ إِذَا قَضَوْا مِنْهُنَّ وَطَرًا ۚ وَكَانَ أَمْرُ اللَّهِ مَفْعُولًا",
  },
  {
    id: "3571",
    sura: "33",
    VerseIDAr: "38",
    ayatAR:
      "مَا كَانَ عَلَى النَّبِيِّ مِنْ حَرَجٍ فِيمَا فَرَضَ اللَّهُ لَهُ ۖ سُنَّةَ اللَّهِ فِي الَّذِينَ خَلَوْا مِنْ قَبْلُ ۚ وَكَانَ أَمْرُ اللَّهِ قَدَرًا مَقْدُورًا",
  },
  {
    id: "3572",
    sura: "33",
    VerseIDAr: "39",
    ayatAR:
      "الَّذِينَ يُبَلِّغُونَ رِسَالَاتِ اللَّهِ وَيَخْشَوْنَهُ وَلَا يَخْشَوْنَ أَحَدًا إِلَّا اللَّهَ ۗ وَكَفَىٰ بِاللَّهِ حَسِيبًا",
  },
  {
    id: "3573",
    sura: "33",
    VerseIDAr: "40",
    ayatAR:
      "مَا كَانَ مُحَمَّدٌ أَبَا أَحَدٍ مِنْ رِجَالِكُمْ وَلَٰكِنْ رَسُولَ اللَّهِ وَخَاتَمَ النَّبِيِّينَ ۗ وَكَانَ اللَّهُ بِكُلِّ شَيْءٍ عَلِيمًا",
  },
  {
    id: "3574",
    sura: "33",
    VerseIDAr: "41",
    ayatAR: "يَا أَيُّهَا الَّذِينَ آمَنُوا اذْكُرُوا اللَّهَ ذِكْرًا كَثِيرًا",
  },
  {
    id: "3575",
    sura: "33",
    VerseIDAr: "42",
    ayatAR: "وَسَبِّحُوهُ بُكْرَةً وَأَصِيلًا",
  },
  {
    id: "3576",
    sura: "33",
    VerseIDAr: "43",
    ayatAR:
      "هُوَ الَّذِي يُصَلِّي عَلَيْكُمْ وَمَلَائِكَتُهُ لِيُخْرِجَكُمْ مِنَ الظُّلُمَاتِ إِلَى النُّورِ ۚ وَكَانَ بِالْمُؤْمِنِينَ رَحِيمًا",
  },
  {
    id: "3577",
    sura: "33",
    VerseIDAr: "44",
    ayatAR:
      "تَحِيَّتُهُمْ يَوْمَ يَلْقَوْنَهُ سَلَامٌ ۚ وَأَعَدَّ لَهُمْ أَجْرًا كَرِيمًا",
  },
  {
    id: "3578",
    sura: "33",
    VerseIDAr: "45",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ إِنَّا أَرْسَلْنَاكَ شَاهِدًا وَمُبَشِّرًا وَنَذِيرًا",
  },
  {
    id: "3579",
    sura: "33",
    VerseIDAr: "46",
    ayatAR: "وَدَاعِيًا إِلَى اللَّهِ بِإِذْنِهِ وَسِرَاجًا مُنِيرًا",
  },
  {
    id: "3580",
    sura: "33",
    VerseIDAr: "47",
    ayatAR:
      "وَبَشِّرِ الْمُؤْمِنِينَ بِأَنَّ لَهُمْ مِنَ اللَّهِ فَضْلًا كَبِيرًا",
  },
  {
    id: "3581",
    sura: "33",
    VerseIDAr: "48",
    ayatAR:
      "وَلَا تُطِعِ الْكَافِرِينَ وَالْمُنَافِقِينَ وَدَعْ أَذَاهُمْ وَتَوَكَّلْ عَلَى اللَّهِ ۚ وَكَفَىٰ بِاللَّهِ وَكِيلًا",
  },
  {
    id: "3582",
    sura: "33",
    VerseIDAr: "49",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا نَكَحْتُمُ الْمُؤْمِنَاتِ ثُمَّ طَلَّقْتُمُوهُنَّ مِنْ قَبْلِ أَنْ تَمَسُّوهُنَّ فَمَا لَكُمْ عَلَيْهِنَّ مِنْ عِدَّةٍ تَعْتَدُّونَهَا ۖ فَمَتِّعُوهُنَّ وَسَرِّحُوهُنَّ سَرَاحًا جَمِيلًا",
  },
  {
    id: "3583",
    sura: "33",
    VerseIDAr: "50",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ إِنَّا أَحْلَلْنَا لَكَ أَزْوَاجَكَ اللَّاتِي آتَيْتَ أُجُورَهُنَّ وَمَا مَلَكَتْ يَمِينُكَ مِمَّا أَفَاءَ اللَّهُ عَلَيْكَ وَبَنَاتِ عَمِّكَ وَبَنَاتِ عَمَّاتِكَ وَبَنَاتِ خَالِكَ وَبَنَاتِ خَالَاتِكَ اللَّاتِي هَاجَرْنَ مَعَكَ وَامْرَأَةً مُؤْمِنَةً إِنْ وَهَبَتْ نَفْسَهَا لِلنَّبِيِّ إِنْ أَرَادَ النَّبِيُّ أَنْ يَسْتَنْكِحَهَا خَالِصَةً لَكَ مِنْ دُونِ الْمُؤْمِنِينَ ۗ قَدْ عَلِمْنَا مَا فَرَضْنَا عَلَيْهِمْ فِي أَزْوَاجِهِمْ وَمَا مَلَكَتْ أَيْمَانُهُمْ لِكَيْلَا يَكُونَ عَلَيْكَ حَرَجٌ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "3584",
    sura: "33",
    VerseIDAr: "51",
    ayatAR:
      "تُرْجِي مَنْ تَشَاءُ مِنْهُنَّ وَتُؤْوِي إِلَيْكَ مَنْ تَشَاءُ ۖ وَمَنِ ابْتَغَيْتَ مِمَّنْ عَزَلْتَ فَلَا جُنَاحَ عَلَيْكَ ۚ ذَٰلِكَ أَدْنَىٰ أَنْ تَقَرَّ أَعْيُنُهُنَّ وَلَا يَحْزَنَّ وَيَرْضَيْنَ بِمَا آتَيْتَهُنَّ كُلُّهُنَّ ۚ وَاللَّهُ يَعْلَمُ مَا فِي قُلُوبِكُمْ ۚ وَكَانَ اللَّهُ عَلِيمًا حَلِيمًا",
  },
  {
    id: "3585",
    sura: "33",
    VerseIDAr: "52",
    ayatAR:
      "لَا يَحِلُّ لَكَ النِّسَاءُ مِنْ بَعْدُ وَلَا أَنْ تَبَدَّلَ بِهِنَّ مِنْ أَزْوَاجٍ وَلَوْ أَعْجَبَكَ حُسْنُهُنَّ إِلَّا مَا مَلَكَتْ يَمِينُكَ ۗ وَكَانَ اللَّهُ عَلَىٰ كُلِّ شَيْءٍ رَقِيبًا",
  },
  {
    id: "3586",
    sura: "33",
    VerseIDAr: "53",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَدْخُلُوا بُيُوتَ النَّبِيِّ إِلَّا أَنْ يُؤْذَنَ لَكُمْ إِلَىٰ طَعَامٍ غَيْرَ نَاظِرِينَ إِنَاهُ وَلَٰكِنْ إِذَا دُعِيتُمْ فَادْخُلُوا فَإِذَا طَعِمْتُمْ فَانْتَشِرُوا وَلَا مُسْتَأْنِسِينَ لِحَدِيثٍ ۚ إِنَّ ذَٰلِكُمْ كَانَ يُؤْذِي النَّبِيَّ فَيَسْتَحْيِي مِنْكُمْ ۖ وَاللَّهُ لَا يَسْتَحْيِي مِنَ الْحَقِّ ۚ وَإِذَا سَأَلْتُمُوهُنَّ مَتَاعًا فَاسْأَلُوهُنَّ مِنْ وَرَاءِ حِجَابٍ ۚ ذَٰلِكُمْ أَطْهَرُ لِقُلُوبِكُمْ وَقُلُوبِهِنَّ ۚ وَمَا كَانَ لَكُمْ أَنْ تُؤْذُوا رَسُولَ اللَّهِ وَلَا أَنْ تَنْكِحُوا أَزْوَاجَهُ مِنْ بَعْدِهِ أَبَدًا ۚ إِنَّ ذَٰلِكُمْ كَانَ عِنْدَ اللَّهِ عَظِيمًا",
  },
  {
    id: "3587",
    sura: "33",
    VerseIDAr: "54",
    ayatAR:
      "إِنْ تُبْدُوا شَيْئًا أَوْ تُخْفُوهُ فَإِنَّ اللَّهَ كَانَ بِكُلِّ شَيْءٍ عَلِيمًا",
  },
  {
    id: "3588",
    sura: "33",
    VerseIDAr: "55",
    ayatAR:
      "لَا جُنَاحَ عَلَيْهِنَّ فِي آبَائِهِنَّ وَلَا أَبْنَائِهِنَّ وَلَا إِخْوَانِهِنَّ وَلَا أَبْنَاءِ إِخْوَانِهِنَّ وَلَا أَبْنَاءِ أَخَوَاتِهِنَّ وَلَا نِسَائِهِنَّ وَلَا مَا مَلَكَتْ أَيْمَانُهُنَّ ۗ وَاتَّقِينَ اللَّهَ ۚ إِنَّ اللَّهَ كَانَ عَلَىٰ كُلِّ شَيْءٍ شَهِيدًا",
  },
  {
    id: "3589",
    sura: "33",
    VerseIDAr: "56",
    ayatAR:
      "إِنَّ اللَّهَ وَمَلَائِكَتَهُ يُصَلُّونَ عَلَى النَّبِيِّ ۚ يَا أَيُّهَا الَّذِينَ آمَنُوا صَلُّوا عَلَيْهِ وَسَلِّمُوا تَسْلِيمًا",
  },
  {
    id: "3590",
    sura: "33",
    VerseIDAr: "57",
    ayatAR:
      "إِنَّ الَّذِينَ يُؤْذُونَ اللَّهَ وَرَسُولَهُ لَعَنَهُمُ اللَّهُ فِي الدُّنْيَا وَالْآخِرَةِ وَأَعَدَّ لَهُمْ عَذَابًا مُهِينًا",
  },
  {
    id: "3591",
    sura: "33",
    VerseIDAr: "58",
    ayatAR:
      "وَالَّذِينَ يُؤْذُونَ الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ بِغَيْرِ مَا اكْتَسَبُوا فَقَدِ احْتَمَلُوا بُهْتَانًا وَإِثْمًا مُبِينًا",
  },
  {
    id: "3592",
    sura: "33",
    VerseIDAr: "59",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ قُلْ لِأَزْوَاجِكَ وَبَنَاتِكَ وَنِسَاءِ الْمُؤْمِنِينَ يُدْنِينَ عَلَيْهِنَّ مِنْ جَلَابِيبِهِنَّ ۚ ذَٰلِكَ أَدْنَىٰ أَنْ يُعْرَفْنَ فَلَا يُؤْذَيْنَ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "3593",
    sura: "33",
    VerseIDAr: "60",
    ayatAR:
      "لَئِنْ لَمْ يَنْتَهِ الْمُنَافِقُونَ وَالَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ وَالْمُرْجِفُونَ فِي الْمَدِينَةِ لَنُغْرِيَنَّكَ بِهِمْ ثُمَّ لَا يُجَاوِرُونَكَ فِيهَا إِلَّا قَلِيلًا",
  },
  {
    id: "3594",
    sura: "33",
    VerseIDAr: "61",
    ayatAR: "مَلْعُونِينَ ۖ أَيْنَمَا ثُقِفُوا أُخِذُوا وَقُتِّلُوا تَقْتِيلًا",
  },
  {
    id: "3595",
    sura: "33",
    VerseIDAr: "62",
    ayatAR:
      "سُنَّةَ اللَّهِ فِي الَّذِينَ خَلَوْا مِنْ قَبْلُ ۖ وَلَنْ تَجِدَ لِسُنَّةِ اللَّهِ تَبْدِيلًا",
  },
  {
    id: "3596",
    sura: "33",
    VerseIDAr: "63",
    ayatAR:
      "يَسْأَلُكَ النَّاسُ عَنِ السَّاعَةِ ۖ قُلْ إِنَّمَا عِلْمُهَا عِنْدَ اللَّهِ ۚ وَمَا يُدْرِيكَ لَعَلَّ السَّاعَةَ تَكُونُ قَرِيبًا",
  },
  {
    id: "3597",
    sura: "33",
    VerseIDAr: "64",
    ayatAR: "إِنَّ اللَّهَ لَعَنَ الْكَافِرِينَ وَأَعَدَّ لَهُمْ سَعِيرًا",
  },
  {
    id: "3598",
    sura: "33",
    VerseIDAr: "65",
    ayatAR: "خَالِدِينَ فِيهَا أَبَدًا ۖ لَا يَجِدُونَ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "3599",
    sura: "33",
    VerseIDAr: "66",
    ayatAR:
      "يَوْمَ تُقَلَّبُ وُجُوهُهُمْ فِي النَّارِ يَقُولُونَ يَا لَيْتَنَا أَطَعْنَا اللَّهَ وَأَطَعْنَا الرَّسُولَا",
  },
  {
    id: "3600",
    sura: "33",
    VerseIDAr: "67",
    ayatAR:
      "وَقَالُوا رَبَّنَا إِنَّا أَطَعْنَا سَادَتَنَا وَكُبَرَاءَنَا فَأَضَلُّونَا السَّبِيلَا",
  },
  {
    id: "3601",
    sura: "33",
    VerseIDAr: "68",
    ayatAR:
      "رَبَّنَا آتِهِمْ ضِعْفَيْنِ مِنَ الْعَذَابِ وَالْعَنْهُمْ لَعْنًا كَبِيرًا",
  },
  {
    id: "3602",
    sura: "33",
    VerseIDAr: "69",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَكُونُوا كَالَّذِينَ آذَوْا مُوسَىٰ فَبَرَّأَهُ اللَّهُ مِمَّا قَالُوا ۚ وَكَانَ عِنْدَ اللَّهِ وَجِيهًا",
  },
  {
    id: "3603",
    sura: "33",
    VerseIDAr: "70",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَقُولُوا قَوْلًا سَدِيدًا",
  },
  {
    id: "3604",
    sura: "33",
    VerseIDAr: "71",
    ayatAR:
      "يُصْلِحْ لَكُمْ أَعْمَالَكُمْ وَيَغْفِرْ لَكُمْ ذُنُوبَكُمْ ۗ وَمَنْ يُطِعِ اللَّهَ وَرَسُولَهُ فَقَدْ فَازَ فَوْزًا عَظِيمًا",
  },
  {
    id: "3605",
    sura: "33",
    VerseIDAr: "72",
    ayatAR:
      "إِنَّا عَرَضْنَا الْأَمَانَةَ عَلَى السَّمَاوَاتِ وَالْأَرْضِ وَالْجِبَالِ فَأَبَيْنَ أَنْ يَحْمِلْنَهَا وَأَشْفَقْنَ مِنْهَا وَحَمَلَهَا الْإِنْسَانُ ۖ إِنَّهُ كَانَ ظَلُومًا جَهُولًا",
  },
  {
    id: "3606",
    sura: "33",
    VerseIDAr: "73",
    ayatAR:
      "لِيُعَذِّبَ اللَّهُ الْمُنَافِقِينَ وَالْمُنَافِقَاتِ وَالْمُشْرِكِينَ وَالْمُشْرِكَاتِ وَيَتُوبَ اللَّهُ عَلَى الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ ۗ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "3607",
    sura: "34",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْحَمْدُ لِلَّهِ الَّذِي لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ وَلَهُ الْحَمْدُ فِي الْآخِرَةِ ۚ وَهُوَ الْحَكِيمُ الْخَبِيرُ",
  },
  {
    id: "3608",
    sura: "34",
    VerseIDAr: "2",
    ayatAR:
      "يَعْلَمُ مَا يَلِجُ فِي الْأَرْضِ وَمَا يَخْرُجُ مِنْهَا وَمَا يَنْزِلُ مِنَ السَّمَاءِ وَمَا يَعْرُجُ فِيهَا ۚ وَهُوَ الرَّحِيمُ الْغَفُورُ",
  },
  {
    id: "3609",
    sura: "34",
    VerseIDAr: "3",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لَا تَأْتِينَا السَّاعَةُ ۖ قُلْ بَلَىٰ وَرَبِّي لَتَأْتِيَنَّكُمْ عَالِمِ الْغَيْبِ ۖ لَا يَعْزُبُ عَنْهُ مِثْقَالُ ذَرَّةٍ فِي السَّمَاوَاتِ وَلَا فِي الْأَرْضِ وَلَا أَصْغَرُ مِنْ ذَٰلِكَ وَلَا أَكْبَرُ إِلَّا فِي كِتَابٍ مُبِينٍ",
  },
  {
    id: "3610",
    sura: "34",
    VerseIDAr: "4",
    ayatAR:
      "لِيَجْزِيَ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ ۚ أُولَٰئِكَ لَهُمْ مَغْفِرَةٌ وَرِزْقٌ كَرِيمٌ",
  },
  {
    id: "3611",
    sura: "34",
    VerseIDAr: "5",
    ayatAR:
      "وَالَّذِينَ سَعَوْا فِي آيَاتِنَا مُعَاجِزِينَ أُولَٰئِكَ لَهُمْ عَذَابٌ مِنْ رِجْزٍ أَلِيمٌ",
  },
  {
    id: "3612",
    sura: "34",
    VerseIDAr: "6",
    ayatAR:
      "وَيَرَى الَّذِينَ أُوتُوا الْعِلْمَ الَّذِي أُنْزِلَ إِلَيْكَ مِنْ رَبِّكَ هُوَ الْحَقَّ وَيَهْدِي إِلَىٰ صِرَاطِ الْعَزِيزِ الْحَمِيدِ",
  },
  {
    id: "3613",
    sura: "34",
    VerseIDAr: "7",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا هَلْ نَدُلُّكُمْ عَلَىٰ رَجُلٍ يُنَبِّئُكُمْ إِذَا مُزِّقْتُمْ كُلَّ مُمَزَّقٍ إِنَّكُمْ لَفِي خَلْقٍ جَدِيدٍ",
  },
  {
    id: "3614",
    sura: "34",
    VerseIDAr: "8",
    ayatAR:
      "أَفْتَرَىٰ عَلَى اللَّهِ كَذِبًا أَمْ بِهِ جِنَّةٌ ۗ بَلِ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ فِي الْعَذَابِ وَالضَّلَالِ الْبَعِيدِ",
  },
  {
    id: "3615",
    sura: "34",
    VerseIDAr: "9",
    ayatAR:
      "أَفَلَمْ يَرَوْا إِلَىٰ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ مِنَ السَّمَاءِ وَالْأَرْضِ ۚ إِنْ نَشَأْ نَخْسِفْ بِهِمُ الْأَرْضَ أَوْ نُسْقِطْ عَلَيْهِمْ كِسَفًا مِنَ السَّمَاءِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَةً لِكُلِّ عَبْدٍ مُنِيبٍ",
  },
  {
    id: "3616",
    sura: "34",
    VerseIDAr: "10",
    ayatAR:
      "وَلَقَدْ آتَيْنَا دَاوُودَ مِنَّا فَضْلًا ۖ يَا جِبَالُ أَوِّبِي مَعَهُ وَالطَّيْرَ ۖ وَأَلَنَّا لَهُ الْحَدِيدَ",
  },
  {
    id: "3617",
    sura: "34",
    VerseIDAr: "11",
    ayatAR:
      "أَنِ اعْمَلْ سَابِغَاتٍ وَقَدِّرْ فِي السَّرْدِ ۖ وَاعْمَلُوا صَالِحًا ۖ إِنِّي بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "3618",
    sura: "34",
    VerseIDAr: "12",
    ayatAR:
      "وَلِسُلَيْمَانَ الرِّيحَ غُدُوُّهَا شَهْرٌ وَرَوَاحُهَا شَهْرٌ ۖ وَأَسَلْنَا لَهُ عَيْنَ الْقِطْرِ ۖ وَمِنَ الْجِنِّ مَنْ يَعْمَلُ بَيْنَ يَدَيْهِ بِإِذْنِ رَبِّهِ ۖ وَمَنْ يَزِغْ مِنْهُمْ عَنْ أَمْرِنَا نُذِقْهُ مِنْ عَذَابِ السَّعِيرِ",
  },
  {
    id: "3619",
    sura: "34",
    VerseIDAr: "13",
    ayatAR:
      "يَعْمَلُونَ لَهُ مَا يَشَاءُ مِنْ مَحَارِيبَ وَتَمَاثِيلَ وَجِفَانٍ كَالْجَوَابِ وَقُدُورٍ رَاسِيَاتٍ ۚ اعْمَلُوا آلَ دَاوُودَ شُكْرًا ۚ وَقَلِيلٌ مِنْ عِبَادِيَ الشَّكُورُ",
  },
  {
    id: "3620",
    sura: "34",
    VerseIDAr: "14",
    ayatAR:
      "فَلَمَّا قَضَيْنَا عَلَيْهِ الْمَوْتَ مَا دَلَّهُمْ عَلَىٰ مَوْتِهِ إِلَّا دَابَّةُ الْأَرْضِ تَأْكُلُ مِنْسَأَتَهُ ۖ فَلَمَّا خَرَّ تَبَيَّنَتِ الْجِنُّ أَنْ لَوْ كَانُوا يَعْلَمُونَ الْغَيْبَ مَا لَبِثُوا فِي الْعَذَابِ الْمُهِينِ",
  },
  {
    id: "3621",
    sura: "34",
    VerseIDAr: "15",
    ayatAR:
      "لَقَدْ كَانَ لِسَبَإٍ فِي مَسْكَنِهِمْ آيَةٌ ۖ جَنَّتَانِ عَنْ يَمِينٍ وَشِمَالٍ ۖ كُلُوا مِنْ رِزْقِ رَبِّكُمْ وَاشْكُرُوا لَهُ ۚ بَلْدَةٌ طَيِّبَةٌ وَرَبٌّ غَفُورٌ",
  },
  {
    id: "3622",
    sura: "34",
    VerseIDAr: "16",
    ayatAR:
      "فَأَعْرَضُوا فَأَرْسَلْنَا عَلَيْهِمْ سَيْلَ الْعَرِمِ وَبَدَّلْنَاهُمْ بِجَنَّتَيْهِمْ جَنَّتَيْنِ ذَوَاتَيْ أُكُلٍ خَمْطٍ وَأَثْلٍ وَشَيْءٍ مِنْ سِدْرٍ قَلِيلٍ",
  },
  {
    id: "3623",
    sura: "34",
    VerseIDAr: "17",
    ayatAR:
      "ذَٰلِكَ جَزَيْنَاهُمْ بِمَا كَفَرُوا ۖ وَهَلْ نُجَازِي إِلَّا الْكَفُورَ",
  },
  {
    id: "3624",
    sura: "34",
    VerseIDAr: "18",
    ayatAR:
      "وَجَعَلْنَا بَيْنَهُمْ وَبَيْنَ الْقُرَى الَّتِي بَارَكْنَا فِيهَا قُرًى ظَاهِرَةً وَقَدَّرْنَا فِيهَا السَّيْرَ ۖ سِيرُوا فِيهَا لَيَالِيَ وَأَيَّامًا آمِنِينَ",
  },
  {
    id: "3625",
    sura: "34",
    VerseIDAr: "19",
    ayatAR:
      "فَقَالُوا رَبَّنَا بَاعِدْ بَيْنَ أَسْفَارِنَا وَظَلَمُوا أَنْفُسَهُمْ فَجَعَلْنَاهُمْ أَحَادِيثَ وَمَزَّقْنَاهُمْ كُلَّ مُمَزَّقٍ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِكُلِّ صَبَّارٍ شَكُورٍ",
  },
  {
    id: "3626",
    sura: "34",
    VerseIDAr: "20",
    ayatAR:
      "وَلَقَدْ صَدَّقَ عَلَيْهِمْ إِبْلِيسُ ظَنَّهُ فَاتَّبَعُوهُ إِلَّا فَرِيقًا مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "3627",
    sura: "34",
    VerseIDAr: "21",
    ayatAR:
      "وَمَا كَانَ لَهُ عَلَيْهِمْ مِنْ سُلْطَانٍ إِلَّا لِنَعْلَمَ مَنْ يُؤْمِنُ بِالْآخِرَةِ مِمَّنْ هُوَ مِنْهَا فِي شَكٍّ ۗ وَرَبُّكَ عَلَىٰ كُلِّ شَيْءٍ حَفِيظٌ",
  },
  {
    id: "3628",
    sura: "34",
    VerseIDAr: "22",
    ayatAR:
      "قُلِ ادْعُوا الَّذِينَ زَعَمْتُمْ مِنْ دُونِ اللَّهِ ۖ لَا يَمْلِكُونَ مِثْقَالَ ذَرَّةٍ فِي السَّمَاوَاتِ وَلَا فِي الْأَرْضِ وَمَا لَهُمْ فِيهِمَا مِنْ شِرْكٍ وَمَا لَهُ مِنْهُمْ مِنْ ظَهِيرٍ",
  },
  {
    id: "3629",
    sura: "34",
    VerseIDAr: "23",
    ayatAR:
      "وَلَا تَنْفَعُ الشَّفَاعَةُ عِنْدَهُ إِلَّا لِمَنْ أَذِنَ لَهُ ۚ حَتَّىٰ إِذَا فُزِّعَ عَنْ قُلُوبِهِمْ قَالُوا مَاذَا قَالَ رَبُّكُمْ ۖ قَالُوا الْحَقَّ ۖ وَهُوَ الْعَلِيُّ الْكَبِيرُ",
  },
  {
    id: "3630",
    sura: "34",
    VerseIDAr: "24",
    ayatAR:
      "قُلْ مَنْ يَرْزُقُكُمْ مِنَ السَّمَاوَاتِ وَالْأَرْضِ ۖ قُلِ اللَّهُ ۖ وَإِنَّا أَوْ إِيَّاكُمْ لَعَلَىٰ هُدًى أَوْ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3631",
    sura: "34",
    VerseIDAr: "25",
    ayatAR:
      "قُلْ لَا تُسْأَلُونَ عَمَّا أَجْرَمْنَا وَلَا نُسْأَلُ عَمَّا تَعْمَلُونَ",
  },
  {
    id: "3632",
    sura: "34",
    VerseIDAr: "26",
    ayatAR:
      "قُلْ يَجْمَعُ بَيْنَنَا رَبُّنَا ثُمَّ يَفْتَحُ بَيْنَنَا بِالْحَقِّ وَهُوَ الْفَتَّاحُ الْعَلِيمُ",
  },
  {
    id: "3633",
    sura: "34",
    VerseIDAr: "27",
    ayatAR:
      "قُلْ أَرُونِيَ الَّذِينَ أَلْحَقْتُمْ بِهِ شُرَكَاءَ ۖ كَلَّا ۚ بَلْ هُوَ اللَّهُ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3634",
    sura: "34",
    VerseIDAr: "28",
    ayatAR:
      "وَمَا أَرْسَلْنَاكَ إِلَّا كَافَّةً لِلنَّاسِ بَشِيرًا وَنَذِيرًا وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "3635",
    sura: "34",
    VerseIDAr: "29",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3636",
    sura: "34",
    VerseIDAr: "30",
    ayatAR:
      "قُلْ لَكُمْ مِيعَادُ يَوْمٍ لَا تَسْتَأْخِرُونَ عَنْهُ سَاعَةً وَلَا تَسْتَقْدِمُونَ",
  },
  {
    id: "3637",
    sura: "34",
    VerseIDAr: "31",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لَنْ نُؤْمِنَ بِهَٰذَا الْقُرْآنِ وَلَا بِالَّذِي بَيْنَ يَدَيْهِ ۗ وَلَوْ تَرَىٰ إِذِ الظَّالِمُونَ مَوْقُوفُونَ عِنْدَ رَبِّهِمْ يَرْجِعُ بَعْضُهُمْ إِلَىٰ بَعْضٍ الْقَوْلَ يَقُولُ الَّذِينَ اسْتُضْعِفُوا لِلَّذِينَ اسْتَكْبَرُوا لَوْلَا أَنْتُمْ لَكُنَّا مُؤْمِنِينَ",
  },
  {
    id: "3638",
    sura: "34",
    VerseIDAr: "32",
    ayatAR:
      "قَالَ الَّذِينَ اسْتَكْبَرُوا لِلَّذِينَ اسْتُضْعِفُوا أَنَحْنُ صَدَدْنَاكُمْ عَنِ الْهُدَىٰ بَعْدَ إِذْ جَاءَكُمْ ۖ بَلْ كُنْتُمْ مُجْرِمِينَ",
  },
  {
    id: "3639",
    sura: "34",
    VerseIDAr: "33",
    ayatAR:
      "وَقَالَ الَّذِينَ اسْتُضْعِفُوا لِلَّذِينَ اسْتَكْبَرُوا بَلْ مَكْرُ اللَّيْلِ وَالنَّهَارِ إِذْ تَأْمُرُونَنَا أَنْ نَكْفُرَ بِاللَّهِ وَنَجْعَلَ لَهُ أَنْدَادًا ۚ وَأَسَرُّوا النَّدَامَةَ لَمَّا رَأَوُا الْعَذَابَ وَجَعَلْنَا الْأَغْلَالَ فِي أَعْنَاقِ الَّذِينَ كَفَرُوا ۚ هَلْ يُجْزَوْنَ إِلَّا مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "3640",
    sura: "34",
    VerseIDAr: "34",
    ayatAR:
      "وَمَا أَرْسَلْنَا فِي قَرْيَةٍ مِنْ نَذِيرٍ إِلَّا قَالَ مُتْرَفُوهَا إِنَّا بِمَا أُرْسِلْتُمْ بِهِ كَافِرُونَ",
  },
  {
    id: "3641",
    sura: "34",
    VerseIDAr: "35",
    ayatAR:
      "وَقَالُوا نَحْنُ أَكْثَرُ أَمْوَالًا وَأَوْلَادًا وَمَا نَحْنُ بِمُعَذَّبِينَ",
  },
  {
    id: "3642",
    sura: "34",
    VerseIDAr: "36",
    ayatAR:
      "قُلْ إِنَّ رَبِّي يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "3643",
    sura: "34",
    VerseIDAr: "37",
    ayatAR:
      "وَمَا أَمْوَالُكُمْ وَلَا أَوْلَادُكُمْ بِالَّتِي تُقَرِّبُكُمْ عِنْدَنَا زُلْفَىٰ إِلَّا مَنْ آمَنَ وَعَمِلَ صَالِحًا فَأُولَٰئِكَ لَهُمْ جَزَاءُ الضِّعْفِ بِمَا عَمِلُوا وَهُمْ فِي الْغُرُفَاتِ آمِنُونَ",
  },
  {
    id: "3644",
    sura: "34",
    VerseIDAr: "38",
    ayatAR:
      "وَالَّذِينَ يَسْعَوْنَ فِي آيَاتِنَا مُعَاجِزِينَ أُولَٰئِكَ فِي الْعَذَابِ مُحْضَرُونَ",
  },
  {
    id: "3645",
    sura: "34",
    VerseIDAr: "39",
    ayatAR:
      "قُلْ إِنَّ رَبِّي يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ مِنْ عِبَادِهِ وَيَقْدِرُ لَهُ ۚ وَمَا أَنْفَقْتُمْ مِنْ شَيْءٍ فَهُوَ يُخْلِفُهُ ۖ وَهُوَ خَيْرُ الرَّازِقِينَ",
  },
  {
    id: "3646",
    sura: "34",
    VerseIDAr: "40",
    ayatAR:
      "وَيَوْمَ يَحْشُرُهُمْ جَمِيعًا ثُمَّ يَقُولُ لِلْمَلَائِكَةِ أَهَٰؤُلَاءِ إِيَّاكُمْ كَانُوا يَعْبُدُونَ",
  },
  {
    id: "3647",
    sura: "34",
    VerseIDAr: "41",
    ayatAR:
      "قَالُوا سُبْحَانَكَ أَنْتَ وَلِيُّنَا مِنْ دُونِهِمْ ۖ بَلْ كَانُوا يَعْبُدُونَ الْجِنَّ ۖ أَكْثَرُهُمْ بِهِمْ مُؤْمِنُونَ",
  },
  {
    id: "3648",
    sura: "34",
    VerseIDAr: "42",
    ayatAR:
      "فَالْيَوْمَ لَا يَمْلِكُ بَعْضُكُمْ لِبَعْضٍ نَفْعًا وَلَا ضَرًّا وَنَقُولُ لِلَّذِينَ ظَلَمُوا ذُوقُوا عَذَابَ النَّارِ الَّتِي كُنْتُمْ بِهَا تُكَذِّبُونَ",
  },
  {
    id: "3649",
    sura: "34",
    VerseIDAr: "43",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ قَالُوا مَا هَٰذَا إِلَّا رَجُلٌ يُرِيدُ أَنْ يَصُدَّكُمْ عَمَّا كَانَ يَعْبُدُ آبَاؤُكُمْ وَقَالُوا مَا هَٰذَا إِلَّا إِفْكٌ مُفْتَرًى ۚ وَقَالَ الَّذِينَ كَفَرُوا لِلْحَقِّ لَمَّا جَاءَهُمْ إِنْ هَٰذَا إِلَّا سِحْرٌ مُبِينٌ",
  },
  {
    id: "3650",
    sura: "34",
    VerseIDAr: "44",
    ayatAR:
      "وَمَا آتَيْنَاهُمْ مِنْ كُتُبٍ يَدْرُسُونَهَا ۖ وَمَا أَرْسَلْنَا إِلَيْهِمْ قَبْلَكَ مِنْ نَذِيرٍ",
  },
  {
    id: "3651",
    sura: "34",
    VerseIDAr: "45",
    ayatAR:
      "وَكَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ وَمَا بَلَغُوا مِعْشَارَ مَا آتَيْنَاهُمْ فَكَذَّبُوا رُسُلِي ۖ فَكَيْفَ كَانَ نَكِيرِ",
  },
  {
    id: "3652",
    sura: "34",
    VerseIDAr: "46",
    ayatAR:
      "قُلْ إِنَّمَا أَعِظُكُمْ بِوَاحِدَةٍ ۖ أَنْ تَقُومُوا لِلَّهِ مَثْنَىٰ وَفُرَادَىٰ ثُمَّ تَتَفَكَّرُوا ۚ مَا بِصَاحِبِكُمْ مِنْ جِنَّةٍ ۚ إِنْ هُوَ إِلَّا نَذِيرٌ لَكُمْ بَيْنَ يَدَيْ عَذَابٍ شَدِيدٍ",
  },
  {
    id: "3653",
    sura: "34",
    VerseIDAr: "47",
    ayatAR:
      "قُلْ مَا سَأَلْتُكُمْ مِنْ أَجْرٍ فَهُوَ لَكُمْ ۖ إِنْ أَجْرِيَ إِلَّا عَلَى اللَّهِ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "3654",
    sura: "34",
    VerseIDAr: "48",
    ayatAR: "قُلْ إِنَّ رَبِّي يَقْذِفُ بِالْحَقِّ عَلَّامُ الْغُيُوبِ",
  },
  {
    id: "3655",
    sura: "34",
    VerseIDAr: "49",
    ayatAR: "قُلْ جَاءَ الْحَقُّ وَمَا يُبْدِئُ الْبَاطِلُ وَمَا يُعِيدُ",
  },
  {
    id: "3656",
    sura: "34",
    VerseIDAr: "50",
    ayatAR:
      "قُلْ إِنْ ضَلَلْتُ فَإِنَّمَا أَضِلُّ عَلَىٰ نَفْسِي ۖ وَإِنِ اهْتَدَيْتُ فَبِمَا يُوحِي إِلَيَّ رَبِّي ۚ إِنَّهُ سَمِيعٌ قَرِيبٌ",
  },
  {
    id: "3657",
    sura: "34",
    VerseIDAr: "51",
    ayatAR:
      "وَلَوْ تَرَىٰ إِذْ فَزِعُوا فَلَا فَوْتَ وَأُخِذُوا مِنْ مَكَانٍ قَرِيبٍ",
  },
  {
    id: "3658",
    sura: "34",
    VerseIDAr: "52",
    ayatAR:
      "وَقَالُوا آمَنَّا بِهِ وَأَنَّىٰ لَهُمُ التَّنَاوُشُ مِنْ مَكَانٍ بَعِيدٍ",
  },
  {
    id: "3659",
    sura: "34",
    VerseIDAr: "53",
    ayatAR:
      "وَقَدْ كَفَرُوا بِهِ مِنْ قَبْلُ ۖ وَيَقْذِفُونَ بِالْغَيْبِ مِنْ مَكَانٍ بَعِيدٍ",
  },
  {
    id: "3660",
    sura: "34",
    VerseIDAr: "54",
    ayatAR:
      "وَحِيلَ بَيْنَهُمْ وَبَيْنَ مَا يَشْتَهُونَ كَمَا فُعِلَ بِأَشْيَاعِهِمْ مِنْ قَبْلُ ۚ إِنَّهُمْ كَانُوا فِي شَكٍّ مُرِيبٍ",
  },
  {
    id: "3661",
    sura: "35",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْحَمْدُ لِلَّهِ فَاطِرِ السَّمَاوَاتِ وَالْأَرْضِ جَاعِلِ الْمَلَائِكَةِ رُسُلًا أُولِي أَجْنِحَةٍ مَثْنَىٰ وَثُلَاثَ وَرُبَاعَ ۚ يَزِيدُ فِي الْخَلْقِ مَا يَشَاءُ ۚ إِنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "3662",
    sura: "35",
    VerseIDAr: "2",
    ayatAR:
      "مَا يَفْتَحِ اللَّهُ لِلنَّاسِ مِنْ رَحْمَةٍ فَلَا مُمْسِكَ لَهَا ۖ وَمَا يُمْسِكْ فَلَا مُرْسِلَ لَهُ مِنْ بَعْدِهِ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "3663",
    sura: "35",
    VerseIDAr: "3",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ اذْكُرُوا نِعْمَتَ اللَّهِ عَلَيْكُمْ ۚ هَلْ مِنْ خَالِقٍ غَيْرُ اللَّهِ يَرْزُقُكُمْ مِنَ السَّمَاءِ وَالْأَرْضِ ۚ لَا إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُؤْفَكُونَ",
  },
  {
    id: "3664",
    sura: "35",
    VerseIDAr: "4",
    ayatAR:
      "وَإِنْ يُكَذِّبُوكَ فَقَدْ كُذِّبَتْ رُسُلٌ مِنْ قَبْلِكَ ۚ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "3665",
    sura: "35",
    VerseIDAr: "5",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ إِنَّ وَعْدَ اللَّهِ حَقٌّ ۖ فَلَا تَغُرَّنَّكُمُ الْحَيَاةُ الدُّنْيَا ۖ وَلَا يَغُرَّنَّكُمْ بِاللَّهِ الْغَرُورُ",
  },
  {
    id: "3666",
    sura: "35",
    VerseIDAr: "6",
    ayatAR:
      "إِنَّ الشَّيْطَانَ لَكُمْ عَدُوٌّ فَاتَّخِذُوهُ عَدُوًّا ۚ إِنَّمَا يَدْعُو حِزْبَهُ لِيَكُونُوا مِنْ أَصْحَابِ السَّعِيرِ",
  },
  {
    id: "3667",
    sura: "35",
    VerseIDAr: "7",
    ayatAR:
      "الَّذِينَ كَفَرُوا لَهُمْ عَذَابٌ شَدِيدٌ ۖ وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ مَغْفِرَةٌ وَأَجْرٌ كَبِيرٌ",
  },
  {
    id: "3668",
    sura: "35",
    VerseIDAr: "8",
    ayatAR:
      "أَفَمَنْ زُيِّنَ لَهُ سُوءُ عَمَلِهِ فَرَآهُ حَسَنًا ۖ فَإِنَّ اللَّهَ يُضِلُّ مَنْ يَشَاءُ وَيَهْدِي مَنْ يَشَاءُ ۖ فَلَا تَذْهَبْ نَفْسُكَ عَلَيْهِمْ حَسَرَاتٍ ۚ إِنَّ اللَّهَ عَلِيمٌ بِمَا يَصْنَعُونَ",
  },
  {
    id: "3669",
    sura: "35",
    VerseIDAr: "9",
    ayatAR:
      "وَاللَّهُ الَّذِي أَرْسَلَ الرِّيَاحَ فَتُثِيرُ سَحَابًا فَسُقْنَاهُ إِلَىٰ بَلَدٍ مَيِّتٍ فَأَحْيَيْنَا بِهِ الْأَرْضَ بَعْدَ مَوْتِهَا ۚ كَذَٰلِكَ النُّشُورُ",
  },
  {
    id: "3670",
    sura: "35",
    VerseIDAr: "10",
    ayatAR:
      "مَنْ كَانَ يُرِيدُ الْعِزَّةَ فَلِلَّهِ الْعِزَّةُ جَمِيعًا ۚ إِلَيْهِ يَصْعَدُ الْكَلِمُ الطَّيِّبُ وَالْعَمَلُ الصَّالِحُ يَرْفَعُهُ ۚ وَالَّذِينَ يَمْكُرُونَ السَّيِّئَاتِ لَهُمْ عَذَابٌ شَدِيدٌ ۖ وَمَكْرُ أُولَٰئِكَ هُوَ يَبُورُ",
  },
  {
    id: "3671",
    sura: "35",
    VerseIDAr: "11",
    ayatAR:
      "وَاللَّهُ خَلَقَكُمْ مِنْ تُرَابٍ ثُمَّ مِنْ نُطْفَةٍ ثُمَّ جَعَلَكُمْ أَزْوَاجًا ۚ وَمَا تَحْمِلُ مِنْ أُنْثَىٰ وَلَا تَضَعُ إِلَّا بِعِلْمِهِ ۚ وَمَا يُعَمَّرُ مِنْ مُعَمَّرٍ وَلَا يُنْقَصُ مِنْ عُمُرِهِ إِلَّا فِي كِتَابٍ ۚ إِنَّ ذَٰلِكَ عَلَى اللَّهِ يَسِيرٌ",
  },
  {
    id: "3672",
    sura: "35",
    VerseIDAr: "12",
    ayatAR:
      "وَمَا يَسْتَوِي الْبَحْرَانِ هَٰذَا عَذْبٌ فُرَاتٌ سَائِغٌ شَرَابُهُ وَهَٰذَا مِلْحٌ أُجَاجٌ ۖ وَمِنْ كُلٍّ تَأْكُلُونَ لَحْمًا طَرِيًّا وَتَسْتَخْرِجُونَ حِلْيَةً تَلْبَسُونَهَا ۖ وَتَرَى الْفُلْكَ فِيهِ مَوَاخِرَ لِتَبْتَغُوا مِنْ فَضْلِهِ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "3673",
    sura: "35",
    VerseIDAr: "13",
    ayatAR:
      "يُولِجُ اللَّيْلَ فِي النَّهَارِ وَيُولِجُ النَّهَارَ فِي اللَّيْلِ وَسَخَّرَ الشَّمْسَ وَالْقَمَرَ كُلٌّ يَجْرِي لِأَجَلٍ مُسَمًّى ۚ ذَٰلِكُمُ اللَّهُ رَبُّكُمْ لَهُ الْمُلْكُ ۚ وَالَّذِينَ تَدْعُونَ مِنْ دُونِهِ مَا يَمْلِكُونَ مِنْ قِطْمِيرٍ",
  },
  {
    id: "3674",
    sura: "35",
    VerseIDAr: "14",
    ayatAR:
      "إِنْ تَدْعُوهُمْ لَا يَسْمَعُوا دُعَاءَكُمْ وَلَوْ سَمِعُوا مَا اسْتَجَابُوا لَكُمْ ۖ وَيَوْمَ الْقِيَامَةِ يَكْفُرُونَ بِشِرْكِكُمْ ۚ وَلَا يُنَبِّئُكَ مِثْلُ خَبِيرٍ",
  },
  {
    id: "3675",
    sura: "35",
    VerseIDAr: "15",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ أَنْتُمُ الْفُقَرَاءُ إِلَى اللَّهِ ۖ وَاللَّهُ هُوَ الْغَنِيُّ الْحَمِيدُ",
  },
  {
    id: "3676",
    sura: "35",
    VerseIDAr: "16",
    ayatAR: "إِنْ يَشَأْ يُذْهِبْكُمْ وَيَأْتِ بِخَلْقٍ جَدِيدٍ",
  },
  {
    id: "3677",
    sura: "35",
    VerseIDAr: "17",
    ayatAR: "وَمَا ذَٰلِكَ عَلَى اللَّهِ بِعَزِيزٍ",
  },
  {
    id: "3678",
    sura: "35",
    VerseIDAr: "18",
    ayatAR:
      "وَلَا تَزِرُ وَازِرَةٌ وِزْرَ أُخْرَىٰ ۚ وَإِنْ تَدْعُ مُثْقَلَةٌ إِلَىٰ حِمْلِهَا لَا يُحْمَلْ مِنْهُ شَيْءٌ وَلَوْ كَانَ ذَا قُرْبَىٰ ۗ إِنَّمَا تُنْذِرُ الَّذِينَ يَخْشَوْنَ رَبَّهُمْ بِالْغَيْبِ وَأَقَامُوا الصَّلَاةَ ۚ وَمَنْ تَزَكَّىٰ فَإِنَّمَا يَتَزَكَّىٰ لِنَفْسِهِ ۚ وَإِلَى اللَّهِ الْمَصِيرُ",
  },
  {
    id: "3679",
    sura: "35",
    VerseIDAr: "19",
    ayatAR: "وَمَا يَسْتَوِي الْأَعْمَىٰ وَالْبَصِيرُ",
  },
  {
    id: "3680",
    sura: "35",
    VerseIDAr: "20",
    ayatAR: "وَلَا الظُّلُمَاتُ وَلَا النُّورُ",
  },
  {
    id: "3681",
    sura: "35",
    VerseIDAr: "21",
    ayatAR: "وَلَا الظِّلُّ وَلَا الْحَرُورُ",
  },
  {
    id: "3682",
    sura: "35",
    VerseIDAr: "22",
    ayatAR:
      "وَمَا يَسْتَوِي الْأَحْيَاءُ وَلَا الْأَمْوَاتُ ۚ إِنَّ اللَّهَ يُسْمِعُ مَنْ يَشَاءُ ۖ وَمَا أَنْتَ بِمُسْمِعٍ مَنْ فِي الْقُبُورِ",
  },
  {
    id: "3683",
    sura: "35",
    VerseIDAr: "23",
    ayatAR: "إِنْ أَنْتَ إِلَّا نَذِيرٌ",
  },
  {
    id: "3684",
    sura: "35",
    VerseIDAr: "24",
    ayatAR:
      "إِنَّا أَرْسَلْنَاكَ بِالْحَقِّ بَشِيرًا وَنَذِيرًا ۚ وَإِنْ مِنْ أُمَّةٍ إِلَّا خَلَا فِيهَا نَذِيرٌ",
  },
  {
    id: "3685",
    sura: "35",
    VerseIDAr: "25",
    ayatAR:
      "وَإِنْ يُكَذِّبُوكَ فَقَدْ كَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ جَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ وَبِالزُّبُرِ وَبِالْكِتَابِ الْمُنِيرِ",
  },
  {
    id: "3686",
    sura: "35",
    VerseIDAr: "26",
    ayatAR: "ثُمَّ أَخَذْتُ الَّذِينَ كَفَرُوا ۖ فَكَيْفَ كَانَ نَكِيرِ",
  },
  {
    id: "3687",
    sura: "35",
    VerseIDAr: "27",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَأَخْرَجْنَا بِهِ ثَمَرَاتٍ مُخْتَلِفًا أَلْوَانُهَا ۚ وَمِنَ الْجِبَالِ جُدَدٌ بِيضٌ وَحُمْرٌ مُخْتَلِفٌ أَلْوَانُهَا وَغَرَابِيبُ سُودٌ",
  },
  {
    id: "3688",
    sura: "35",
    VerseIDAr: "28",
    ayatAR:
      "وَمِنَ النَّاسِ وَالدَّوَابِّ وَالْأَنْعَامِ مُخْتَلِفٌ أَلْوَانُهُ كَذَٰلِكَ ۗ إِنَّمَا يَخْشَى اللَّهَ مِنْ عِبَادِهِ الْعُلَمَاءُ ۗ إِنَّ اللَّهَ عَزِيزٌ غَفُورٌ",
  },
  {
    id: "3689",
    sura: "35",
    VerseIDAr: "29",
    ayatAR:
      "إِنَّ الَّذِينَ يَتْلُونَ كِتَابَ اللَّهِ وَأَقَامُوا الصَّلَاةَ وَأَنْفَقُوا مِمَّا رَزَقْنَاهُمْ سِرًّا وَعَلَانِيَةً يَرْجُونَ تِجَارَةً لَنْ تَبُورَ",
  },
  {
    id: "3690",
    sura: "35",
    VerseIDAr: "30",
    ayatAR:
      "لِيُوَفِّيَهُمْ أُجُورَهُمْ وَيَزِيدَهُمْ مِنْ فَضْلِهِ ۚ إِنَّهُ غَفُورٌ شَكُورٌ",
  },
  {
    id: "3691",
    sura: "35",
    VerseIDAr: "31",
    ayatAR:
      "وَالَّذِي أَوْحَيْنَا إِلَيْكَ مِنَ الْكِتَابِ هُوَ الْحَقُّ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ ۗ إِنَّ اللَّهَ بِعِبَادِهِ لَخَبِيرٌ بَصِيرٌ",
  },
  {
    id: "3692",
    sura: "35",
    VerseIDAr: "32",
    ayatAR:
      "ثُمَّ أَوْرَثْنَا الْكِتَابَ الَّذِينَ اصْطَفَيْنَا مِنْ عِبَادِنَا ۖ فَمِنْهُمْ ظَالِمٌ لِنَفْسِهِ وَمِنْهُمْ مُقْتَصِدٌ وَمِنْهُمْ سَابِقٌ بِالْخَيْرَاتِ بِإِذْنِ اللَّهِ ۚ ذَٰلِكَ هُوَ الْفَضْلُ الْكَبِيرُ",
  },
  {
    id: "3693",
    sura: "35",
    VerseIDAr: "33",
    ayatAR:
      "جَنَّاتُ عَدْنٍ يَدْخُلُونَهَا يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِنْ ذَهَبٍ وَلُؤْلُؤًا ۖ وَلِبَاسُهُمْ فِيهَا حَرِيرٌ",
  },
  {
    id: "3694",
    sura: "35",
    VerseIDAr: "34",
    ayatAR:
      "وَقَالُوا الْحَمْدُ لِلَّهِ الَّذِي أَذْهَبَ عَنَّا الْحَزَنَ ۖ إِنَّ رَبَّنَا لَغَفُورٌ شَكُورٌ",
  },
  {
    id: "3695",
    sura: "35",
    VerseIDAr: "35",
    ayatAR:
      "الَّذِي أَحَلَّنَا دَارَ الْمُقَامَةِ مِنْ فَضْلِهِ لَا يَمَسُّنَا فِيهَا نَصَبٌ وَلَا يَمَسُّنَا فِيهَا لُغُوبٌ",
  },
  {
    id: "3696",
    sura: "35",
    VerseIDAr: "36",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا لَهُمْ نَارُ جَهَنَّمَ لَا يُقْضَىٰ عَلَيْهِمْ فَيَمُوتُوا وَلَا يُخَفَّفُ عَنْهُمْ مِنْ عَذَابِهَا ۚ كَذَٰلِكَ نَجْزِي كُلَّ كَفُورٍ",
  },
  {
    id: "3697",
    sura: "35",
    VerseIDAr: "37",
    ayatAR:
      "وَهُمْ يَصْطَرِخُونَ فِيهَا رَبَّنَا أَخْرِجْنَا نَعْمَلْ صَالِحًا غَيْرَ الَّذِي كُنَّا نَعْمَلُ ۚ أَوَلَمْ نُعَمِّرْكُمْ مَا يَتَذَكَّرُ فِيهِ مَنْ تَذَكَّرَ وَجَاءَكُمُ النَّذِيرُ ۖ فَذُوقُوا فَمَا لِلظَّالِمِينَ مِنْ نَصِيرٍ",
  },
  {
    id: "3698",
    sura: "35",
    VerseIDAr: "38",
    ayatAR:
      "إِنَّ اللَّهَ عَالِمُ غَيْبِ السَّمَاوَاتِ وَالْأَرْضِ ۚ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "3699",
    sura: "35",
    VerseIDAr: "39",
    ayatAR:
      "هُوَ الَّذِي جَعَلَكُمْ خَلَائِفَ فِي الْأَرْضِ ۚ فَمَنْ كَفَرَ فَعَلَيْهِ كُفْرُهُ ۖ وَلَا يَزِيدُ الْكَافِرِينَ كُفْرُهُمْ عِنْدَ رَبِّهِمْ إِلَّا مَقْتًا ۖ وَلَا يَزِيدُ الْكَافِرِينَ كُفْرُهُمْ إِلَّا خَسَارًا",
  },
  {
    id: "3700",
    sura: "35",
    VerseIDAr: "40",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ شُرَكَاءَكُمُ الَّذِينَ تَدْعُونَ مِنْ دُونِ اللَّهِ أَرُونِي مَاذَا خَلَقُوا مِنَ الْأَرْضِ أَمْ لَهُمْ شِرْكٌ فِي السَّمَاوَاتِ أَمْ آتَيْنَاهُمْ كِتَابًا فَهُمْ عَلَىٰ بَيِّنَتٍ مِنْهُ ۚ بَلْ إِنْ يَعِدُ الظَّالِمُونَ بَعْضُهُمْ بَعْضًا إِلَّا غُرُورًا",
  },
  {
    id: "3701",
    sura: "35",
    VerseIDAr: "41",
    ayatAR:
      "إِنَّ اللَّهَ يُمْسِكُ السَّمَاوَاتِ وَالْأَرْضَ أَنْ تَزُولَا ۚ وَلَئِنْ زَالَتَا إِنْ أَمْسَكَهُمَا مِنْ أَحَدٍ مِنْ بَعْدِهِ ۚ إِنَّهُ كَانَ حَلِيمًا غَفُورًا",
  },
  {
    id: "3702",
    sura: "35",
    VerseIDAr: "42",
    ayatAR:
      "وَأَقْسَمُوا بِاللَّهِ جَهْدَ أَيْمَانِهِمْ لَئِنْ جَاءَهُمْ نَذِيرٌ لَيَكُونُنَّ أَهْدَىٰ مِنْ إِحْدَى الْأُمَمِ ۖ فَلَمَّا جَاءَهُمْ نَذِيرٌ مَا زَادَهُمْ إِلَّا نُفُورًا",
  },
  {
    id: "3703",
    sura: "35",
    VerseIDAr: "43",
    ayatAR:
      "اسْتِكْبَارًا فِي الْأَرْضِ وَمَكْرَ السَّيِّئِ ۚ وَلَا يَحِيقُ الْمَكْرُ السَّيِّئُ إِلَّا بِأَهْلِهِ ۚ فَهَلْ يَنْظُرُونَ إِلَّا سُنَّتَ الْأَوَّلِينَ ۚ فَلَنْ تَجِدَ لِسُنَّتِ اللَّهِ تَبْدِيلًا ۖ وَلَنْ تَجِدَ لِسُنَّتِ اللَّهِ تَحْوِيلًا",
  },
  {
    id: "3704",
    sura: "35",
    VerseIDAr: "44",
    ayatAR:
      "أَوَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلِهِمْ وَكَانُوا أَشَدَّ مِنْهُمْ قُوَّةً ۚ وَمَا كَانَ اللَّهُ لِيُعْجِزَهُ مِنْ شَيْءٍ فِي السَّمَاوَاتِ وَلَا فِي الْأَرْضِ ۚ إِنَّهُ كَانَ عَلِيمًا قَدِيرًا",
  },
  {
    id: "3705",
    sura: "35",
    VerseIDAr: "45",
    ayatAR:
      "وَلَوْ يُؤَاخِذُ اللَّهُ النَّاسَ بِمَا كَسَبُوا مَا تَرَكَ عَلَىٰ ظَهْرِهَا مِنْ دَابَّةٍ وَلَٰكِنْ يُؤَخِّرُهُمْ إِلَىٰ أَجَلٍ مُسَمًّى ۖ فَإِذَا جَاءَ أَجَلُهُمْ فَإِنَّ اللَّهَ كَانَ بِعِبَادِهِ بَصِيرًا",
  },
  {
    id: "3706",
    sura: "36",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يس",
  },
  { id: "3707", sura: "36", VerseIDAr: "2", ayatAR: "وَالْقُرْآنِ الْحَكِيمِ" },
  {
    id: "3708",
    sura: "36",
    VerseIDAr: "3",
    ayatAR: "إِنَّكَ لَمِنَ الْمُرْسَلِينَ",
  },
  {
    id: "3709",
    sura: "36",
    VerseIDAr: "4",
    ayatAR: "عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "3710",
    sura: "36",
    VerseIDAr: "5",
    ayatAR: "تَنْزِيلَ الْعَزِيزِ الرَّحِيمِ",
  },
  {
    id: "3711",
    sura: "36",
    VerseIDAr: "6",
    ayatAR: "لِتُنْذِرَ قَوْمًا مَا أُنْذِرَ آبَاؤُهُمْ فَهُمْ غَافِلُونَ",
  },
  {
    id: "3712",
    sura: "36",
    VerseIDAr: "7",
    ayatAR: "لَقَدْ حَقَّ الْقَوْلُ عَلَىٰ أَكْثَرِهِمْ فَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "3713",
    sura: "36",
    VerseIDAr: "8",
    ayatAR:
      "إِنَّا جَعَلْنَا فِي أَعْنَاقِهِمْ أَغْلَالًا فَهِيَ إِلَى الْأَذْقَانِ فَهُمْ مُقْمَحُونَ",
  },
  {
    id: "3714",
    sura: "36",
    VerseIDAr: "9",
    ayatAR:
      "وَجَعَلْنَا مِنْ بَيْنِ أَيْدِيهِمْ سَدًّا وَمِنْ خَلْفِهِمْ سَدًّا فَأَغْشَيْنَاهُمْ فَهُمْ لَا يُبْصِرُونَ",
  },
  {
    id: "3715",
    sura: "36",
    VerseIDAr: "10",
    ayatAR:
      "وَسَوَاءٌ عَلَيْهِمْ أَأَنْذَرْتَهُمْ أَمْ لَمْ تُنْذِرْهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "3716",
    sura: "36",
    VerseIDAr: "11",
    ayatAR:
      "إِنَّمَا تُنْذِرُ مَنِ اتَّبَعَ الذِّكْرَ وَخَشِيَ الرَّحْمَٰنَ بِالْغَيْبِ ۖ فَبَشِّرْهُ بِمَغْفِرَةٍ وَأَجْرٍ كَرِيمٍ",
  },
  {
    id: "3717",
    sura: "36",
    VerseIDAr: "12",
    ayatAR:
      "إِنَّا نَحْنُ نُحْيِي الْمَوْتَىٰ وَنَكْتُبُ مَا قَدَّمُوا وَآثَارَهُمْ ۚ وَكُلَّ شَيْءٍ أَحْصَيْنَاهُ فِي إِمَامٍ مُبِينٍ",
  },
  {
    id: "3718",
    sura: "36",
    VerseIDAr: "13",
    ayatAR:
      "وَاضْرِبْ لَهُمْ مَثَلًا أَصْحَابَ الْقَرْيَةِ إِذْ جَاءَهَا الْمُرْسَلُونَ",
  },
  {
    id: "3719",
    sura: "36",
    VerseIDAr: "14",
    ayatAR:
      "إِذْ أَرْسَلْنَا إِلَيْهِمُ اثْنَيْنِ فَكَذَّبُوهُمَا فَعَزَّزْنَا بِثَالِثٍ فَقَالُوا إِنَّا إِلَيْكُمْ مُرْسَلُونَ",
  },
  {
    id: "3720",
    sura: "36",
    VerseIDAr: "15",
    ayatAR:
      "قَالُوا مَا أَنْتُمْ إِلَّا بَشَرٌ مِثْلُنَا وَمَا أَنْزَلَ الرَّحْمَٰنُ مِنْ شَيْءٍ إِنْ أَنْتُمْ إِلَّا تَكْذِبُونَ",
  },
  {
    id: "3721",
    sura: "36",
    VerseIDAr: "16",
    ayatAR: "قَالُوا رَبُّنَا يَعْلَمُ إِنَّا إِلَيْكُمْ لَمُرْسَلُونَ",
  },
  {
    id: "3722",
    sura: "36",
    VerseIDAr: "17",
    ayatAR: "وَمَا عَلَيْنَا إِلَّا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "3723",
    sura: "36",
    VerseIDAr: "18",
    ayatAR:
      "قَالُوا إِنَّا تَطَيَّرْنَا بِكُمْ ۖ لَئِنْ لَمْ تَنْتَهُوا لَنَرْجُمَنَّكُمْ وَلَيَمَسَّنَّكُمْ مِنَّا عَذَابٌ أَلِيمٌ",
  },
  {
    id: "3724",
    sura: "36",
    VerseIDAr: "19",
    ayatAR:
      "قَالُوا طَائِرُكُمْ مَعَكُمْ ۚ أَئِنْ ذُكِّرْتُمْ ۚ بَلْ أَنْتُمْ قَوْمٌ مُسْرِفُونَ",
  },
  {
    id: "3725",
    sura: "36",
    VerseIDAr: "20",
    ayatAR:
      "وَجَاءَ مِنْ أَقْصَى الْمَدِينَةِ رَجُلٌ يَسْعَىٰ قَالَ يَا قَوْمِ اتَّبِعُوا الْمُرْسَلِينَ",
  },
  {
    id: "3726",
    sura: "36",
    VerseIDAr: "21",
    ayatAR: "اتَّبِعُوا مَنْ لَا يَسْأَلُكُمْ أَجْرًا وَهُمْ مُهْتَدُونَ",
  },
  {
    id: "3727",
    sura: "36",
    VerseIDAr: "22",
    ayatAR: "وَمَا لِيَ لَا أَعْبُدُ الَّذِي فَطَرَنِي وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3728",
    sura: "36",
    VerseIDAr: "23",
    ayatAR:
      "أَأَتَّخِذُ مِنْ دُونِهِ آلِهَةً إِنْ يُرِدْنِ الرَّحْمَٰنُ بِضُرٍّ لَا تُغْنِ عَنِّي شَفَاعَتُهُمْ شَيْئًا وَلَا يُنْقِذُونِ",
  },
  {
    id: "3729",
    sura: "36",
    VerseIDAr: "24",
    ayatAR: "إِنِّي إِذًا لَفِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3730",
    sura: "36",
    VerseIDAr: "25",
    ayatAR: "إِنِّي آمَنْتُ بِرَبِّكُمْ فَاسْمَعُونِ",
  },
  {
    id: "3731",
    sura: "36",
    VerseIDAr: "26",
    ayatAR: "قِيلَ ادْخُلِ الْجَنَّةَ ۖ قَالَ يَا لَيْتَ قَوْمِي يَعْلَمُونَ",
  },
  {
    id: "3732",
    sura: "36",
    VerseIDAr: "27",
    ayatAR: "بِمَا غَفَرَ لِي رَبِّي وَجَعَلَنِي مِنَ الْمُكْرَمِينَ",
  },
  {
    id: "3733",
    sura: "36",
    VerseIDAr: "28",
    ayatAR:
      "وَمَا أَنْزَلْنَا عَلَىٰ قَوْمِهِ مِنْ بَعْدِهِ مِنْ جُنْدٍ مِنَ السَّمَاءِ وَمَا كُنَّا مُنْزِلِينَ",
  },
  {
    id: "3734",
    sura: "36",
    VerseIDAr: "29",
    ayatAR: "إِنْ كَانَتْ إِلَّا صَيْحَةً وَاحِدَةً فَإِذَا هُمْ خَامِدُونَ",
  },
  {
    id: "3735",
    sura: "36",
    VerseIDAr: "30",
    ayatAR:
      "يَا حَسْرَةً عَلَى الْعِبَادِ ۚ مَا يَأْتِيهِمْ مِنْ رَسُولٍ إِلَّا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "3736",
    sura: "36",
    VerseIDAr: "31",
    ayatAR:
      "أَلَمْ يَرَوْا كَمْ أَهْلَكْنَا قَبْلَهُمْ مِنَ الْقُرُونِ أَنَّهُمْ إِلَيْهِمْ لَا يَرْجِعُونَ",
  },
  {
    id: "3737",
    sura: "36",
    VerseIDAr: "32",
    ayatAR: "وَإِنْ كُلٌّ لَمَّا جَمِيعٌ لَدَيْنَا مُحْضَرُونَ",
  },
  {
    id: "3738",
    sura: "36",
    VerseIDAr: "33",
    ayatAR:
      "وَآيَةٌ لَهُمُ الْأَرْضُ الْمَيْتَةُ أَحْيَيْنَاهَا وَأَخْرَجْنَا مِنْهَا حَبًّا فَمِنْهُ يَأْكُلُونَ",
  },
  {
    id: "3739",
    sura: "36",
    VerseIDAr: "34",
    ayatAR:
      "وَجَعَلْنَا فِيهَا جَنَّاتٍ مِنْ نَخِيلٍ وَأَعْنَابٍ وَفَجَّرْنَا فِيهَا مِنَ الْعُيُونِ",
  },
  {
    id: "3740",
    sura: "36",
    VerseIDAr: "35",
    ayatAR:
      "لِيَأْكُلُوا مِنْ ثَمَرِهِ وَمَا عَمِلَتْهُ أَيْدِيهِمْ ۖ أَفَلَا يَشْكُرُونَ",
  },
  {
    id: "3741",
    sura: "36",
    VerseIDAr: "36",
    ayatAR:
      "سُبْحَانَ الَّذِي خَلَقَ الْأَزْوَاجَ كُلَّهَا مِمَّا تُنْبِتُ الْأَرْضُ وَمِنْ أَنْفُسِهِمْ وَمِمَّا لَا يَعْلَمُونَ",
  },
  {
    id: "3742",
    sura: "36",
    VerseIDAr: "37",
    ayatAR:
      "وَآيَةٌ لَهُمُ اللَّيْلُ نَسْلَخُ مِنْهُ النَّهَارَ فَإِذَا هُمْ مُظْلِمُونَ",
  },
  {
    id: "3743",
    sura: "36",
    VerseIDAr: "38",
    ayatAR:
      "وَالشَّمْسُ تَجْرِي لِمُسْتَقَرٍّ لَهَا ۚ ذَٰلِكَ تَقْدِيرُ الْعَزِيزِ الْعَلِيمِ",
  },
  {
    id: "3744",
    sura: "36",
    VerseIDAr: "39",
    ayatAR:
      "وَالْقَمَرَ قَدَّرْنَاهُ مَنَازِلَ حَتَّىٰ عَادَ كَالْعُرْجُونِ الْقَدِيمِ",
  },
  {
    id: "3745",
    sura: "36",
    VerseIDAr: "40",
    ayatAR:
      "لَا الشَّمْسُ يَنْبَغِي لَهَا أَنْ تُدْرِكَ الْقَمَرَ وَلَا اللَّيْلُ سَابِقُ النَّهَارِ ۚ وَكُلٌّ فِي فَلَكٍ يَسْبَحُونَ",
  },
  {
    id: "3746",
    sura: "36",
    VerseIDAr: "41",
    ayatAR:
      "وَآيَةٌ لَهُمْ أَنَّا حَمَلْنَا ذُرِّيَّتَهُمْ فِي الْفُلْكِ الْمَشْحُونِ",
  },
  {
    id: "3747",
    sura: "36",
    VerseIDAr: "42",
    ayatAR: "وَخَلَقْنَا لَهُمْ مِنْ مِثْلِهِ مَا يَرْكَبُونَ",
  },
  {
    id: "3748",
    sura: "36",
    VerseIDAr: "43",
    ayatAR:
      "وَإِنْ نَشَأْ نُغْرِقْهُمْ فَلَا صَرِيخَ لَهُمْ وَلَا هُمْ يُنْقَذُونَ",
  },
  {
    id: "3749",
    sura: "36",
    VerseIDAr: "44",
    ayatAR: "إِلَّا رَحْمَةً مِنَّا وَمَتَاعًا إِلَىٰ حِينٍ",
  },
  {
    id: "3750",
    sura: "36",
    VerseIDAr: "45",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمُ اتَّقُوا مَا بَيْنَ أَيْدِيكُمْ وَمَا خَلْفَكُمْ لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "3751",
    sura: "36",
    VerseIDAr: "46",
    ayatAR:
      "وَمَا تَأْتِيهِمْ مِنْ آيَةٍ مِنْ آيَاتِ رَبِّهِمْ إِلَّا كَانُوا عَنْهَا مُعْرِضِينَ",
  },
  {
    id: "3752",
    sura: "36",
    VerseIDAr: "47",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ أَنْفِقُوا مِمَّا رَزَقَكُمُ اللَّهُ قَالَ الَّذِينَ كَفَرُوا لِلَّذِينَ آمَنُوا أَنُطْعِمُ مَنْ لَوْ يَشَاءُ اللَّهُ أَطْعَمَهُ إِنْ أَنْتُمْ إِلَّا فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "3753",
    sura: "36",
    VerseIDAr: "48",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3754",
    sura: "36",
    VerseIDAr: "49",
    ayatAR:
      "مَا يَنْظُرُونَ إِلَّا صَيْحَةً وَاحِدَةً تَأْخُذُهُمْ وَهُمْ يَخِصِّمُونَ",
  },
  {
    id: "3755",
    sura: "36",
    VerseIDAr: "50",
    ayatAR:
      "فَلَا يَسْتَطِيعُونَ تَوْصِيَةً وَلَا إِلَىٰ أَهْلِهِمْ يَرْجِعُونَ",
  },
  {
    id: "3756",
    sura: "36",
    VerseIDAr: "51",
    ayatAR:
      "وَنُفِخَ فِي الصُّورِ فَإِذَا هُمْ مِنَ الْأَجْدَاثِ إِلَىٰ رَبِّهِمْ يَنْسِلُونَ",
  },
  {
    id: "3757",
    sura: "36",
    VerseIDAr: "52",
    ayatAR:
      "قَالُوا يَا وَيْلَنَا مَنْ بَعَثَنَا مِنْ مَرْقَدِنَا ۜ ۗ هَٰذَا مَا وَعَدَ الرَّحْمَٰنُ وَصَدَقَ الْمُرْسَلُونَ",
  },
  {
    id: "3758",
    sura: "36",
    VerseIDAr: "53",
    ayatAR:
      "إِنْ كَانَتْ إِلَّا صَيْحَةً وَاحِدَةً فَإِذَا هُمْ جَمِيعٌ لَدَيْنَا مُحْضَرُونَ",
  },
  {
    id: "3759",
    sura: "36",
    VerseIDAr: "54",
    ayatAR:
      "فَالْيَوْمَ لَا تُظْلَمُ نَفْسٌ شَيْئًا وَلَا تُجْزَوْنَ إِلَّا مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3760",
    sura: "36",
    VerseIDAr: "55",
    ayatAR: "إِنَّ أَصْحَابَ الْجَنَّةِ الْيَوْمَ فِي شُغُلٍ فَاكِهُونَ",
  },
  {
    id: "3761",
    sura: "36",
    VerseIDAr: "56",
    ayatAR: "هُمْ وَأَزْوَاجُهُمْ فِي ظِلَالٍ عَلَى الْأَرَائِكِ مُتَّكِئُونَ",
  },
  {
    id: "3762",
    sura: "36",
    VerseIDAr: "57",
    ayatAR: "لَهُمْ فِيهَا فَاكِهَةٌ وَلَهُمْ مَا يَدَّعُونَ",
  },
  {
    id: "3763",
    sura: "36",
    VerseIDAr: "58",
    ayatAR: "سَلَامٌ قَوْلًا مِنْ رَبٍّ رَحِيمٍ",
  },
  {
    id: "3764",
    sura: "36",
    VerseIDAr: "59",
    ayatAR: "وَامْتَازُوا الْيَوْمَ أَيُّهَا الْمُجْرِمُونَ",
  },
  {
    id: "3765",
    sura: "36",
    VerseIDAr: "60",
    ayatAR:
      "أَلَمْ أَعْهَدْ إِلَيْكُمْ يَا بَنِي آدَمَ أَنْ لَا تَعْبُدُوا الشَّيْطَانَ ۖ إِنَّهُ لَكُمْ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "3766",
    sura: "36",
    VerseIDAr: "61",
    ayatAR: "وَأَنِ اعْبُدُونِي ۚ هَٰذَا صِرَاطٌ مُسْتَقِيمٌ",
  },
  {
    id: "3767",
    sura: "36",
    VerseIDAr: "62",
    ayatAR:
      "وَلَقَدْ أَضَلَّ مِنْكُمْ جِبِلًّا كَثِيرًا ۖ أَفَلَمْ تَكُونُوا تَعْقِلُونَ",
  },
  {
    id: "3768",
    sura: "36",
    VerseIDAr: "63",
    ayatAR: "هَٰذِهِ جَهَنَّمُ الَّتِي كُنْتُمْ تُوعَدُونَ",
  },
  {
    id: "3769",
    sura: "36",
    VerseIDAr: "64",
    ayatAR: "اصْلَوْهَا الْيَوْمَ بِمَا كُنْتُمْ تَكْفُرُونَ",
  },
  {
    id: "3770",
    sura: "36",
    VerseIDAr: "65",
    ayatAR:
      "الْيَوْمَ نَخْتِمُ عَلَىٰ أَفْوَاهِهِمْ وَتُكَلِّمُنَا أَيْدِيهِمْ وَتَشْهَدُ أَرْجُلُهُمْ بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "3771",
    sura: "36",
    VerseIDAr: "66",
    ayatAR:
      "وَلَوْ نَشَاءُ لَطَمَسْنَا عَلَىٰ أَعْيُنِهِمْ فَاسْتَبَقُوا الصِّرَاطَ فَأَنَّىٰ يُبْصِرُونَ",
  },
  {
    id: "3772",
    sura: "36",
    VerseIDAr: "67",
    ayatAR:
      "وَلَوْ نَشَاءُ لَمَسَخْنَاهُمْ عَلَىٰ مَكَانَتِهِمْ فَمَا اسْتَطَاعُوا مُضِيًّا وَلَا يَرْجِعُونَ",
  },
  {
    id: "3773",
    sura: "36",
    VerseIDAr: "68",
    ayatAR:
      "وَمَنْ نُعَمِّرْهُ نُنَكِّسْهُ فِي الْخَلْقِ ۖ أَفَلَا يَعْقِلُونَ",
  },
  {
    id: "3774",
    sura: "36",
    VerseIDAr: "69",
    ayatAR:
      "وَمَا عَلَّمْنَاهُ الشِّعْرَ وَمَا يَنْبَغِي لَهُ ۚ إِنْ هُوَ إِلَّا ذِكْرٌ وَقُرْآنٌ مُبِينٌ",
  },
  {
    id: "3775",
    sura: "36",
    VerseIDAr: "70",
    ayatAR:
      "لِيُنْذِرَ مَنْ كَانَ حَيًّا وَيَحِقَّ الْقَوْلُ عَلَى الْكَافِرِينَ",
  },
  {
    id: "3776",
    sura: "36",
    VerseIDAr: "71",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّا خَلَقْنَا لَهُمْ مِمَّا عَمِلَتْ أَيْدِينَا أَنْعَامًا فَهُمْ لَهَا مَالِكُونَ",
  },
  {
    id: "3777",
    sura: "36",
    VerseIDAr: "72",
    ayatAR:
      "وَذَلَّلْنَاهَا لَهُمْ فَمِنْهَا رَكُوبُهُمْ وَمِنْهَا يَأْكُلُونَ",
  },
  {
    id: "3778",
    sura: "36",
    VerseIDAr: "73",
    ayatAR: "وَلَهُمْ فِيهَا مَنَافِعُ وَمَشَارِبُ ۖ أَفَلَا يَشْكُرُونَ",
  },
  {
    id: "3779",
    sura: "36",
    VerseIDAr: "74",
    ayatAR: "وَاتَّخَذُوا مِنْ دُونِ اللَّهِ آلِهَةً لَعَلَّهُمْ يُنْصَرُونَ",
  },
  {
    id: "3780",
    sura: "36",
    VerseIDAr: "75",
    ayatAR: "لَا يَسْتَطِيعُونَ نَصْرَهُمْ وَهُمْ لَهُمْ جُنْدٌ مُحْضَرُونَ",
  },
  {
    id: "3781",
    sura: "36",
    VerseIDAr: "76",
    ayatAR:
      "فَلَا يَحْزُنْكَ قَوْلُهُمْ ۘ إِنَّا نَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ",
  },
  {
    id: "3782",
    sura: "36",
    VerseIDAr: "77",
    ayatAR:
      "أَوَلَمْ يَرَ الْإِنْسَانُ أَنَّا خَلَقْنَاهُ مِنْ نُطْفَةٍ فَإِذَا هُوَ خَصِيمٌ مُبِينٌ",
  },
  {
    id: "3783",
    sura: "36",
    VerseIDAr: "78",
    ayatAR:
      "وَضَرَبَ لَنَا مَثَلًا وَنَسِيَ خَلْقَهُ ۖ قَالَ مَنْ يُحْيِي الْعِظَامَ وَهِيَ رَمِيمٌ",
  },
  {
    id: "3784",
    sura: "36",
    VerseIDAr: "79",
    ayatAR:
      "قُلْ يُحْيِيهَا الَّذِي أَنْشَأَهَا أَوَّلَ مَرَّةٍ ۖ وَهُوَ بِكُلِّ خَلْقٍ عَلِيمٌ",
  },
  {
    id: "3785",
    sura: "36",
    VerseIDAr: "80",
    ayatAR:
      "الَّذِي جَعَلَ لَكُمْ مِنَ الشَّجَرِ الْأَخْضَرِ نَارًا فَإِذَا أَنْتُمْ مِنْهُ تُوقِدُونَ",
  },
  {
    id: "3786",
    sura: "36",
    VerseIDAr: "81",
    ayatAR:
      "أَوَلَيْسَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِقَادِرٍ عَلَىٰ أَنْ يَخْلُقَ مِثْلَهُمْ ۚ بَلَىٰ وَهُوَ الْخَلَّاقُ الْعَلِيمُ",
  },
  {
    id: "3787",
    sura: "36",
    VerseIDAr: "82",
    ayatAR:
      "إِنَّمَا أَمْرُهُ إِذَا أَرَادَ شَيْئًا أَنْ يَقُولَ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "3788",
    sura: "36",
    VerseIDAr: "83",
    ayatAR:
      "فَسُبْحَانَ الَّذِي بِيَدِهِ مَلَكُوتُ كُلِّ شَيْءٍ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "3789",
    sura: "37",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالصَّافَّاتِ صَفًّا",
  },
  { id: "3790", sura: "37", VerseIDAr: "2", ayatAR: "فَالزَّاجِرَاتِ زَجْرًا" },
  { id: "3791", sura: "37", VerseIDAr: "3", ayatAR: "فَالتَّالِيَاتِ ذِكْرًا" },
  {
    id: "3792",
    sura: "37",
    VerseIDAr: "4",
    ayatAR: "إِنَّ إِلَٰهَكُمْ لَوَاحِدٌ",
  },
  {
    id: "3793",
    sura: "37",
    VerseIDAr: "5",
    ayatAR:
      "رَبُّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا وَرَبُّ الْمَشَارِقِ",
  },
  {
    id: "3794",
    sura: "37",
    VerseIDAr: "6",
    ayatAR: "إِنَّا زَيَّنَّا السَّمَاءَ الدُّنْيَا بِزِينَةٍ الْكَوَاكِبِ",
  },
  {
    id: "3795",
    sura: "37",
    VerseIDAr: "7",
    ayatAR: "وَحِفْظًا مِنْ كُلِّ شَيْطَانٍ مَارِدٍ",
  },
  {
    id: "3796",
    sura: "37",
    VerseIDAr: "8",
    ayatAR:
      "لَا يَسَّمَّعُونَ إِلَى الْمَلَإِ الْأَعْلَىٰ وَيُقْذَفُونَ مِنْ كُلِّ جَانِبٍ",
  },
  {
    id: "3797",
    sura: "37",
    VerseIDAr: "9",
    ayatAR: "دُحُورًا ۖ وَلَهُمْ عَذَابٌ وَاصِبٌ",
  },
  {
    id: "3798",
    sura: "37",
    VerseIDAr: "10",
    ayatAR: "إِلَّا مَنْ خَطِفَ الْخَطْفَةَ فَأَتْبَعَهُ شِهَابٌ ثَاقِبٌ",
  },
  {
    id: "3799",
    sura: "37",
    VerseIDAr: "11",
    ayatAR:
      "فَاسْتَفْتِهِمْ أَهُمْ أَشَدُّ خَلْقًا أَمْ مَنْ خَلَقْنَا ۚ إِنَّا خَلَقْنَاهُمْ مِنْ طِينٍ لَازِبٍ",
  },
  {
    id: "3800",
    sura: "37",
    VerseIDAr: "12",
    ayatAR: "بَلْ عَجِبْتَ وَيَسْخَرُونَ",
  },
  {
    id: "3801",
    sura: "37",
    VerseIDAr: "13",
    ayatAR: "وَإِذَا ذُكِّرُوا لَا يَذْكُرُونَ",
  },
  {
    id: "3802",
    sura: "37",
    VerseIDAr: "14",
    ayatAR: "وَإِذَا رَأَوْا آيَةً يَسْتَسْخِرُونَ",
  },
  {
    id: "3803",
    sura: "37",
    VerseIDAr: "15",
    ayatAR: "وَقَالُوا إِنْ هَٰذَا إِلَّا سِحْرٌ مُبِينٌ",
  },
  {
    id: "3804",
    sura: "37",
    VerseIDAr: "16",
    ayatAR:
      "أَإِذَا مِتْنَا وَكُنَّا تُرَابًا وَعِظَامًا أَإِنَّا لَمَبْعُوثُونَ",
  },
  {
    id: "3805",
    sura: "37",
    VerseIDAr: "17",
    ayatAR: "أَوَآبَاؤُنَا الْأَوَّلُونَ",
  },
  {
    id: "3806",
    sura: "37",
    VerseIDAr: "18",
    ayatAR: "قُلْ نَعَمْ وَأَنْتُمْ دَاخِرُونَ",
  },
  {
    id: "3807",
    sura: "37",
    VerseIDAr: "19",
    ayatAR: "فَإِنَّمَا هِيَ زَجْرَةٌ وَاحِدَةٌ فَإِذَا هُمْ يَنْظُرُونَ",
  },
  {
    id: "3808",
    sura: "37",
    VerseIDAr: "20",
    ayatAR: "وَقَالُوا يَا وَيْلَنَا هَٰذَا يَوْمُ الدِّينِ",
  },
  {
    id: "3809",
    sura: "37",
    VerseIDAr: "21",
    ayatAR: "هَٰذَا يَوْمُ الْفَصْلِ الَّذِي كُنْتُمْ بِهِ تُكَذِّبُونَ",
  },
  {
    id: "3810",
    sura: "37",
    VerseIDAr: "22",
    ayatAR:
      "احْشُرُوا الَّذِينَ ظَلَمُوا وَأَزْوَاجَهُمْ وَمَا كَانُوا يَعْبُدُونَ",
  },
  {
    id: "3811",
    sura: "37",
    VerseIDAr: "23",
    ayatAR: "مِنْ دُونِ اللَّهِ فَاهْدُوهُمْ إِلَىٰ صِرَاطِ الْجَحِيمِ",
  },
  {
    id: "3812",
    sura: "37",
    VerseIDAr: "24",
    ayatAR: "وَقِفُوهُمْ ۖ إِنَّهُمْ مَسْئُولُونَ",
  },
  {
    id: "3813",
    sura: "37",
    VerseIDAr: "25",
    ayatAR: "مَا لَكُمْ لَا تَنَاصَرُونَ",
  },
  {
    id: "3814",
    sura: "37",
    VerseIDAr: "26",
    ayatAR: "بَلْ هُمُ الْيَوْمَ مُسْتَسْلِمُونَ",
  },
  {
    id: "3815",
    sura: "37",
    VerseIDAr: "27",
    ayatAR: "وَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍ يَتَسَاءَلُونَ",
  },
  {
    id: "3816",
    sura: "37",
    VerseIDAr: "28",
    ayatAR: "قَالُوا إِنَّكُمْ كُنْتُمْ تَأْتُونَنَا عَنِ الْيَمِينِ",
  },
  {
    id: "3817",
    sura: "37",
    VerseIDAr: "29",
    ayatAR: "قَالُوا بَلْ لَمْ تَكُونُوا مُؤْمِنِينَ",
  },
  {
    id: "3818",
    sura: "37",
    VerseIDAr: "30",
    ayatAR:
      "وَمَا كَانَ لَنَا عَلَيْكُمْ مِنْ سُلْطَانٍ ۖ بَلْ كُنْتُمْ قَوْمًا طَاغِينَ",
  },
  {
    id: "3819",
    sura: "37",
    VerseIDAr: "31",
    ayatAR: "فَحَقَّ عَلَيْنَا قَوْلُ رَبِّنَا ۖ إِنَّا لَذَائِقُونَ",
  },
  {
    id: "3820",
    sura: "37",
    VerseIDAr: "32",
    ayatAR: "فَأَغْوَيْنَاكُمْ إِنَّا كُنَّا غَاوِينَ",
  },
  {
    id: "3821",
    sura: "37",
    VerseIDAr: "33",
    ayatAR: "فَإِنَّهُمْ يَوْمَئِذٍ فِي الْعَذَابِ مُشْتَرِكُونَ",
  },
  {
    id: "3822",
    sura: "37",
    VerseIDAr: "34",
    ayatAR: "إِنَّا كَذَٰلِكَ نَفْعَلُ بِالْمُجْرِمِينَ",
  },
  {
    id: "3823",
    sura: "37",
    VerseIDAr: "35",
    ayatAR:
      "إِنَّهُمْ كَانُوا إِذَا قِيلَ لَهُمْ لَا إِلَٰهَ إِلَّا اللَّهُ يَسْتَكْبِرُونَ",
  },
  {
    id: "3824",
    sura: "37",
    VerseIDAr: "36",
    ayatAR: "وَيَقُولُونَ أَئِنَّا لَتَارِكُو آلِهَتِنَا لِشَاعِرٍ مَجْنُونٍ",
  },
  {
    id: "3825",
    sura: "37",
    VerseIDAr: "37",
    ayatAR: "بَلْ جَاءَ بِالْحَقِّ وَصَدَّقَ الْمُرْسَلِينَ",
  },
  {
    id: "3826",
    sura: "37",
    VerseIDAr: "38",
    ayatAR: "إِنَّكُمْ لَذَائِقُو الْعَذَابِ الْأَلِيمِ",
  },
  {
    id: "3827",
    sura: "37",
    VerseIDAr: "39",
    ayatAR: "وَمَا تُجْزَوْنَ إِلَّا مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "3828",
    sura: "37",
    VerseIDAr: "40",
    ayatAR: "إِلَّا عِبَادَ اللَّهِ الْمُخْلَصِينَ",
  },
  {
    id: "3829",
    sura: "37",
    VerseIDAr: "41",
    ayatAR: "أُولَٰئِكَ لَهُمْ رِزْقٌ مَعْلُومٌ",
  },
  {
    id: "3830",
    sura: "37",
    VerseIDAr: "42",
    ayatAR: "فَوَاكِهُ ۖ وَهُمْ مُكْرَمُونَ",
  },
  {
    id: "3831",
    sura: "37",
    VerseIDAr: "43",
    ayatAR: "فِي جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "3832",
    sura: "37",
    VerseIDAr: "44",
    ayatAR: "عَلَىٰ سُرُرٍ مُتَقَابِلِينَ",
  },
  {
    id: "3833",
    sura: "37",
    VerseIDAr: "45",
    ayatAR: "يُطَافُ عَلَيْهِمْ بِكَأْسٍ مِنْ مَعِينٍ",
  },
  {
    id: "3834",
    sura: "37",
    VerseIDAr: "46",
    ayatAR: "بَيْضَاءَ لَذَّةٍ لِلشَّارِبِينَ",
  },
  {
    id: "3835",
    sura: "37",
    VerseIDAr: "47",
    ayatAR: "لَا فِيهَا غَوْلٌ وَلَا هُمْ عَنْهَا يُنْزَفُونَ",
  },
  {
    id: "3836",
    sura: "37",
    VerseIDAr: "48",
    ayatAR: "وَعِنْدَهُمْ قَاصِرَاتُ الطَّرْفِ عِينٌ",
  },
  {
    id: "3837",
    sura: "37",
    VerseIDAr: "49",
    ayatAR: "كَأَنَّهُنَّ بَيْضٌ مَكْنُونٌ",
  },
  {
    id: "3838",
    sura: "37",
    VerseIDAr: "50",
    ayatAR: "فَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍ يَتَسَاءَلُونَ",
  },
  {
    id: "3839",
    sura: "37",
    VerseIDAr: "51",
    ayatAR: "قَالَ قَائِلٌ مِنْهُمْ إِنِّي كَانَ لِي قَرِينٌ",
  },
  {
    id: "3840",
    sura: "37",
    VerseIDAr: "52",
    ayatAR: "يَقُولُ أَإِنَّكَ لَمِنَ الْمُصَدِّقِينَ",
  },
  {
    id: "3841",
    sura: "37",
    VerseIDAr: "53",
    ayatAR:
      "أَإِذَا مِتْنَا وَكُنَّا تُرَابًا وَعِظَامًا أَإِنَّا لَمَدِينُونَ",
  },
  {
    id: "3842",
    sura: "37",
    VerseIDAr: "54",
    ayatAR: "قَالَ هَلْ أَنْتُمْ مُطَّلِعُونَ",
  },
  {
    id: "3843",
    sura: "37",
    VerseIDAr: "55",
    ayatAR: "فَاطَّلَعَ فَرَآهُ فِي سَوَاءِ الْجَحِيمِ",
  },
  {
    id: "3844",
    sura: "37",
    VerseIDAr: "56",
    ayatAR: "قَالَ تَاللَّهِ إِنْ كِدْتَ لَتُرْدِينِ",
  },
  {
    id: "3845",
    sura: "37",
    VerseIDAr: "57",
    ayatAR: "وَلَوْلَا نِعْمَةُ رَبِّي لَكُنْتُ مِنَ الْمُحْضَرِينَ",
  },
  {
    id: "3846",
    sura: "37",
    VerseIDAr: "58",
    ayatAR: "أَفَمَا نَحْنُ بِمَيِّتِينَ",
  },
  {
    id: "3847",
    sura: "37",
    VerseIDAr: "59",
    ayatAR: "إِلَّا مَوْتَتَنَا الْأُولَىٰ وَمَا نَحْنُ بِمُعَذَّبِينَ",
  },
  {
    id: "3848",
    sura: "37",
    VerseIDAr: "60",
    ayatAR: "إِنَّ هَٰذَا لَهُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "3849",
    sura: "37",
    VerseIDAr: "61",
    ayatAR: "لِمِثْلِ هَٰذَا فَلْيَعْمَلِ الْعَامِلُونَ",
  },
  {
    id: "3850",
    sura: "37",
    VerseIDAr: "62",
    ayatAR: "أَذَٰلِكَ خَيْرٌ نُزُلًا أَمْ شَجَرَةُ الزَّقُّومِ",
  },
  {
    id: "3851",
    sura: "37",
    VerseIDAr: "63",
    ayatAR: "إِنَّا جَعَلْنَاهَا فِتْنَةً لِلظَّالِمِينَ",
  },
  {
    id: "3852",
    sura: "37",
    VerseIDAr: "64",
    ayatAR: "إِنَّهَا شَجَرَةٌ تَخْرُجُ فِي أَصْلِ الْجَحِيمِ",
  },
  {
    id: "3853",
    sura: "37",
    VerseIDAr: "65",
    ayatAR: "طَلْعُهَا كَأَنَّهُ رُءُوسُ الشَّيَاطِينِ",
  },
  {
    id: "3854",
    sura: "37",
    VerseIDAr: "66",
    ayatAR: "فَإِنَّهُمْ لَآكِلُونَ مِنْهَا فَمَالِئُونَ مِنْهَا الْبُطُونَ",
  },
  {
    id: "3855",
    sura: "37",
    VerseIDAr: "67",
    ayatAR: "ثُمَّ إِنَّ لَهُمْ عَلَيْهَا لَشَوْبًا مِنْ حَمِيمٍ",
  },
  {
    id: "3856",
    sura: "37",
    VerseIDAr: "68",
    ayatAR: "ثُمَّ إِنَّ مَرْجِعَهُمْ لَإِلَى الْجَحِيمِ",
  },
  {
    id: "3857",
    sura: "37",
    VerseIDAr: "69",
    ayatAR: "إِنَّهُمْ أَلْفَوْا آبَاءَهُمْ ضَالِّينَ",
  },
  {
    id: "3858",
    sura: "37",
    VerseIDAr: "70",
    ayatAR: "فَهُمْ عَلَىٰ آثَارِهِمْ يُهْرَعُونَ",
  },
  {
    id: "3859",
    sura: "37",
    VerseIDAr: "71",
    ayatAR: "وَلَقَدْ ضَلَّ قَبْلَهُمْ أَكْثَرُ الْأَوَّلِينَ",
  },
  {
    id: "3860",
    sura: "37",
    VerseIDAr: "72",
    ayatAR: "وَلَقَدْ أَرْسَلْنَا فِيهِمْ مُنْذِرِينَ",
  },
  {
    id: "3861",
    sura: "37",
    VerseIDAr: "73",
    ayatAR: "فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُنْذَرِينَ",
  },
  {
    id: "3862",
    sura: "37",
    VerseIDAr: "74",
    ayatAR: "إِلَّا عِبَادَ اللَّهِ الْمُخْلَصِينَ",
  },
  {
    id: "3863",
    sura: "37",
    VerseIDAr: "75",
    ayatAR: "وَلَقَدْ نَادَانَا نُوحٌ فَلَنِعْمَ الْمُجِيبُونَ",
  },
  {
    id: "3864",
    sura: "37",
    VerseIDAr: "76",
    ayatAR: "وَنَجَّيْنَاهُ وَأَهْلَهُ مِنَ الْكَرْبِ الْعَظِيمِ",
  },
  {
    id: "3865",
    sura: "37",
    VerseIDAr: "77",
    ayatAR: "وَجَعَلْنَا ذُرِّيَّتَهُ هُمُ الْبَاقِينَ",
  },
  {
    id: "3866",
    sura: "37",
    VerseIDAr: "78",
    ayatAR: "وَتَرَكْنَا عَلَيْهِ فِي الْآخِرِينَ",
  },
  {
    id: "3867",
    sura: "37",
    VerseIDAr: "79",
    ayatAR: "سَلَامٌ عَلَىٰ نُوحٍ فِي الْعَالَمِينَ",
  },
  {
    id: "3868",
    sura: "37",
    VerseIDAr: "80",
    ayatAR: "إِنَّا كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3869",
    sura: "37",
    VerseIDAr: "81",
    ayatAR: "إِنَّهُ مِنْ عِبَادِنَا الْمُؤْمِنِينَ",
  },
  {
    id: "3870",
    sura: "37",
    VerseIDAr: "82",
    ayatAR: "ثُمَّ أَغْرَقْنَا الْآخَرِينَ",
  },
  {
    id: "3871",
    sura: "37",
    VerseIDAr: "83",
    ayatAR: "وَإِنَّ مِنْ شِيعَتِهِ لَإِبْرَاهِيمَ",
  },
  {
    id: "3872",
    sura: "37",
    VerseIDAr: "84",
    ayatAR: "إِذْ جَاءَ رَبَّهُ بِقَلْبٍ سَلِيمٍ",
  },
  {
    id: "3873",
    sura: "37",
    VerseIDAr: "85",
    ayatAR: "إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِ مَاذَا تَعْبُدُونَ",
  },
  {
    id: "3874",
    sura: "37",
    VerseIDAr: "86",
    ayatAR: "أَئِفْكًا آلِهَةً دُونَ اللَّهِ تُرِيدُونَ",
  },
  {
    id: "3875",
    sura: "37",
    VerseIDAr: "87",
    ayatAR: "فَمَا ظَنُّكُمْ بِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "3876",
    sura: "37",
    VerseIDAr: "88",
    ayatAR: "فَنَظَرَ نَظْرَةً فِي النُّجُومِ",
  },
  { id: "3877", sura: "37", VerseIDAr: "89", ayatAR: "فَقَالَ إِنِّي سَقِيمٌ" },
  {
    id: "3878",
    sura: "37",
    VerseIDAr: "90",
    ayatAR: "فَتَوَلَّوْا عَنْهُ مُدْبِرِينَ",
  },
  {
    id: "3879",
    sura: "37",
    VerseIDAr: "91",
    ayatAR: "فَرَاغَ إِلَىٰ آلِهَتِهِمْ فَقَالَ أَلَا تَأْكُلُونَ",
  },
  {
    id: "3880",
    sura: "37",
    VerseIDAr: "92",
    ayatAR: "مَا لَكُمْ لَا تَنْطِقُونَ",
  },
  {
    id: "3881",
    sura: "37",
    VerseIDAr: "93",
    ayatAR: "فَرَاغَ عَلَيْهِمْ ضَرْبًا بِالْيَمِينِ",
  },
  {
    id: "3882",
    sura: "37",
    VerseIDAr: "94",
    ayatAR: "فَأَقْبَلُوا إِلَيْهِ يَزِفُّونَ",
  },
  {
    id: "3883",
    sura: "37",
    VerseIDAr: "95",
    ayatAR: "قَالَ أَتَعْبُدُونَ مَا تَنْحِتُونَ",
  },
  {
    id: "3884",
    sura: "37",
    VerseIDAr: "96",
    ayatAR: "وَاللَّهُ خَلَقَكُمْ وَمَا تَعْمَلُونَ",
  },
  {
    id: "3885",
    sura: "37",
    VerseIDAr: "97",
    ayatAR: "قَالُوا ابْنُوا لَهُ بُنْيَانًا فَأَلْقُوهُ فِي الْجَحِيمِ",
  },
  {
    id: "3886",
    sura: "37",
    VerseIDAr: "98",
    ayatAR: "فَأَرَادُوا بِهِ كَيْدًا فَجَعَلْنَاهُمُ الْأَسْفَلِينَ",
  },
  {
    id: "3887",
    sura: "37",
    VerseIDAr: "99",
    ayatAR: "وَقَالَ إِنِّي ذَاهِبٌ إِلَىٰ رَبِّي سَيَهْدِينِ",
  },
  {
    id: "3888",
    sura: "37",
    VerseIDAr: "100",
    ayatAR: "رَبِّ هَبْ لِي مِنَ الصَّالِحِينَ",
  },
  {
    id: "3889",
    sura: "37",
    VerseIDAr: "101",
    ayatAR: "فَبَشَّرْنَاهُ بِغُلَامٍ حَلِيمٍ",
  },
  {
    id: "3890",
    sura: "37",
    VerseIDAr: "102",
    ayatAR:
      "فَلَمَّا بَلَغَ مَعَهُ السَّعْيَ قَالَ يَا بُنَيَّ إِنِّي أَرَىٰ فِي الْمَنَامِ أَنِّي أَذْبَحُكَ فَانْظُرْ مَاذَا تَرَىٰ ۚ قَالَ يَا أَبَتِ افْعَلْ مَا تُؤْمَرُ ۖ سَتَجِدُنِي إِنْ شَاءَ اللَّهُ مِنَ الصَّابِرِينَ",
  },
  {
    id: "3891",
    sura: "37",
    VerseIDAr: "103",
    ayatAR: "فَلَمَّا أَسْلَمَا وَتَلَّهُ لِلْجَبِينِ",
  },
  {
    id: "3892",
    sura: "37",
    VerseIDAr: "104",
    ayatAR: "وَنَادَيْنَاهُ أَنْ يَا إِبْرَاهِيمُ",
  },
  {
    id: "3893",
    sura: "37",
    VerseIDAr: "105",
    ayatAR:
      "قَدْ صَدَّقْتَ الرُّؤْيَا ۚ إِنَّا كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3894",
    sura: "37",
    VerseIDAr: "106",
    ayatAR: "إِنَّ هَٰذَا لَهُوَ الْبَلَاءُ الْمُبِينُ",
  },
  {
    id: "3895",
    sura: "37",
    VerseIDAr: "107",
    ayatAR: "وَفَدَيْنَاهُ بِذِبْحٍ عَظِيمٍ",
  },
  {
    id: "3896",
    sura: "37",
    VerseIDAr: "108",
    ayatAR: "وَتَرَكْنَا عَلَيْهِ فِي الْآخِرِينَ",
  },
  {
    id: "3897",
    sura: "37",
    VerseIDAr: "109",
    ayatAR: "سَلَامٌ عَلَىٰ إِبْرَاهِيمَ",
  },
  {
    id: "3898",
    sura: "37",
    VerseIDAr: "110",
    ayatAR: "كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3899",
    sura: "37",
    VerseIDAr: "111",
    ayatAR: "إِنَّهُ مِنْ عِبَادِنَا الْمُؤْمِنِينَ",
  },
  {
    id: "3900",
    sura: "37",
    VerseIDAr: "112",
    ayatAR: "وَبَشَّرْنَاهُ بِإِسْحَاقَ نَبِيًّا مِنَ الصَّالِحِينَ",
  },
  {
    id: "3901",
    sura: "37",
    VerseIDAr: "113",
    ayatAR:
      "وَبَارَكْنَا عَلَيْهِ وَعَلَىٰ إِسْحَاقَ ۚ وَمِنْ ذُرِّيَّتِهِمَا مُحْسِنٌ وَظَالِمٌ لِنَفْسِهِ مُبِينٌ",
  },
  {
    id: "3902",
    sura: "37",
    VerseIDAr: "114",
    ayatAR: "وَلَقَدْ مَنَنَّا عَلَىٰ مُوسَىٰ وَهَارُونَ",
  },
  {
    id: "3903",
    sura: "37",
    VerseIDAr: "115",
    ayatAR: "وَنَجَّيْنَاهُمَا وَقَوْمَهُمَا مِنَ الْكَرْبِ الْعَظِيمِ",
  },
  {
    id: "3904",
    sura: "37",
    VerseIDAr: "116",
    ayatAR: "وَنَصَرْنَاهُمْ فَكَانُوا هُمُ الْغَالِبِينَ",
  },
  {
    id: "3905",
    sura: "37",
    VerseIDAr: "117",
    ayatAR: "وَآتَيْنَاهُمَا الْكِتَابَ الْمُسْتَبِينَ",
  },
  {
    id: "3906",
    sura: "37",
    VerseIDAr: "118",
    ayatAR: "وَهَدَيْنَاهُمَا الصِّرَاطَ الْمُسْتَقِيمَ",
  },
  {
    id: "3907",
    sura: "37",
    VerseIDAr: "119",
    ayatAR: "وَتَرَكْنَا عَلَيْهِمَا فِي الْآخِرِينَ",
  },
  {
    id: "3908",
    sura: "37",
    VerseIDAr: "120",
    ayatAR: "سَلَامٌ عَلَىٰ مُوسَىٰ وَهَارُونَ",
  },
  {
    id: "3909",
    sura: "37",
    VerseIDAr: "121",
    ayatAR: "إِنَّا كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3910",
    sura: "37",
    VerseIDAr: "122",
    ayatAR: "إِنَّهُمَا مِنْ عِبَادِنَا الْمُؤْمِنِينَ",
  },
  {
    id: "3911",
    sura: "37",
    VerseIDAr: "123",
    ayatAR: "وَإِنَّ إِلْيَاسَ لَمِنَ الْمُرْسَلِينَ",
  },
  {
    id: "3912",
    sura: "37",
    VerseIDAr: "124",
    ayatAR: "إِذْ قَالَ لِقَوْمِهِ أَلَا تَتَّقُونَ",
  },
  {
    id: "3913",
    sura: "37",
    VerseIDAr: "125",
    ayatAR: "أَتَدْعُونَ بَعْلًا وَتَذَرُونَ أَحْسَنَ الْخَالِقِينَ",
  },
  {
    id: "3914",
    sura: "37",
    VerseIDAr: "126",
    ayatAR: "اللَّهَ رَبَّكُمْ وَرَبَّ آبَائِكُمُ الْأَوَّلِينَ",
  },
  {
    id: "3915",
    sura: "37",
    VerseIDAr: "127",
    ayatAR: "فَكَذَّبُوهُ فَإِنَّهُمْ لَمُحْضَرُونَ",
  },
  {
    id: "3916",
    sura: "37",
    VerseIDAr: "128",
    ayatAR: "إِلَّا عِبَادَ اللَّهِ الْمُخْلَصِينَ",
  },
  {
    id: "3917",
    sura: "37",
    VerseIDAr: "129",
    ayatAR: "وَتَرَكْنَا عَلَيْهِ فِي الْآخِرِينَ",
  },
  {
    id: "3918",
    sura: "37",
    VerseIDAr: "130",
    ayatAR: "سَلَامٌ عَلَىٰ إِلْ يَاسِينَ",
  },
  {
    id: "3919",
    sura: "37",
    VerseIDAr: "131",
    ayatAR: "إِنَّا كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "3920",
    sura: "37",
    VerseIDAr: "132",
    ayatAR: "إِنَّهُ مِنْ عِبَادِنَا الْمُؤْمِنِينَ",
  },
  {
    id: "3921",
    sura: "37",
    VerseIDAr: "133",
    ayatAR: "وَإِنَّ لُوطًا لَمِنَ الْمُرْسَلِينَ",
  },
  {
    id: "3922",
    sura: "37",
    VerseIDAr: "134",
    ayatAR: "إِذْ نَجَّيْنَاهُ وَأَهْلَهُ أَجْمَعِينَ",
  },
  {
    id: "3923",
    sura: "37",
    VerseIDAr: "135",
    ayatAR: "إِلَّا عَجُوزًا فِي الْغَابِرِينَ",
  },
  {
    id: "3924",
    sura: "37",
    VerseIDAr: "136",
    ayatAR: "ثُمَّ دَمَّرْنَا الْآخَرِينَ",
  },
  {
    id: "3925",
    sura: "37",
    VerseIDAr: "137",
    ayatAR: "وَإِنَّكُمْ لَتَمُرُّونَ عَلَيْهِمْ مُصْبِحِينَ",
  },
  {
    id: "3926",
    sura: "37",
    VerseIDAr: "138",
    ayatAR: "وَبِاللَّيْلِ ۗ أَفَلَا تَعْقِلُونَ",
  },
  {
    id: "3927",
    sura: "37",
    VerseIDAr: "139",
    ayatAR: "وَإِنَّ يُونُسَ لَمِنَ الْمُرْسَلِينَ",
  },
  {
    id: "3928",
    sura: "37",
    VerseIDAr: "140",
    ayatAR: "إِذْ أَبَقَ إِلَى الْفُلْكِ الْمَشْحُونِ",
  },
  {
    id: "3929",
    sura: "37",
    VerseIDAr: "141",
    ayatAR: "فَسَاهَمَ فَكَانَ مِنَ الْمُدْحَضِينَ",
  },
  {
    id: "3930",
    sura: "37",
    VerseIDAr: "142",
    ayatAR: "فَالْتَقَمَهُ الْحُوتُ وَهُوَ مُلِيمٌ",
  },
  {
    id: "3931",
    sura: "37",
    VerseIDAr: "143",
    ayatAR: "فَلَوْلَا أَنَّهُ كَانَ مِنَ الْمُسَبِّحِينَ",
  },
  {
    id: "3932",
    sura: "37",
    VerseIDAr: "144",
    ayatAR: "لَلَبِثَ فِي بَطْنِهِ إِلَىٰ يَوْمِ يُبْعَثُونَ",
  },
  {
    id: "3933",
    sura: "37",
    VerseIDAr: "145",
    ayatAR: "فَنَبَذْنَاهُ بِالْعَرَاءِ وَهُوَ سَقِيمٌ",
  },
  {
    id: "3934",
    sura: "37",
    VerseIDAr: "146",
    ayatAR: "وَأَنْبَتْنَا عَلَيْهِ شَجَرَةً مِنْ يَقْطِينٍ",
  },
  {
    id: "3935",
    sura: "37",
    VerseIDAr: "147",
    ayatAR: "وَأَرْسَلْنَاهُ إِلَىٰ مِائَةِ أَلْفٍ أَوْ يَزِيدُونَ",
  },
  {
    id: "3936",
    sura: "37",
    VerseIDAr: "148",
    ayatAR: "فَآمَنُوا فَمَتَّعْنَاهُمْ إِلَىٰ حِينٍ",
  },
  {
    id: "3937",
    sura: "37",
    VerseIDAr: "149",
    ayatAR: "فَاسْتَفْتِهِمْ أَلِرَبِّكَ الْبَنَاتُ وَلَهُمُ الْبَنُونَ",
  },
  {
    id: "3938",
    sura: "37",
    VerseIDAr: "150",
    ayatAR: "أَمْ خَلَقْنَا الْمَلَائِكَةَ إِنَاثًا وَهُمْ شَاهِدُونَ",
  },
  {
    id: "3939",
    sura: "37",
    VerseIDAr: "151",
    ayatAR: "أَلَا إِنَّهُمْ مِنْ إِفْكِهِمْ لَيَقُولُونَ",
  },
  {
    id: "3940",
    sura: "37",
    VerseIDAr: "152",
    ayatAR: "وَلَدَ اللَّهُ وَإِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "3941",
    sura: "37",
    VerseIDAr: "153",
    ayatAR: "أَصْطَفَى الْبَنَاتِ عَلَى الْبَنِينَ",
  },
  {
    id: "3942",
    sura: "37",
    VerseIDAr: "154",
    ayatAR: "مَا لَكُمْ كَيْفَ تَحْكُمُونَ",
  },
  { id: "3943", sura: "37", VerseIDAr: "155", ayatAR: "أَفَلَا تَذَكَّرُونَ" },
  {
    id: "3944",
    sura: "37",
    VerseIDAr: "156",
    ayatAR: "أَمْ لَكُمْ سُلْطَانٌ مُبِينٌ",
  },
  {
    id: "3945",
    sura: "37",
    VerseIDAr: "157",
    ayatAR: "فَأْتُوا بِكِتَابِكُمْ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "3946",
    sura: "37",
    VerseIDAr: "158",
    ayatAR:
      "وَجَعَلُوا بَيْنَهُ وَبَيْنَ الْجِنَّةِ نَسَبًا ۚ وَلَقَدْ عَلِمَتِ الْجِنَّةُ إِنَّهُمْ لَمُحْضَرُونَ",
  },
  {
    id: "3947",
    sura: "37",
    VerseIDAr: "159",
    ayatAR: "سُبْحَانَ اللَّهِ عَمَّا يَصِفُونَ",
  },
  {
    id: "3948",
    sura: "37",
    VerseIDAr: "160",
    ayatAR: "إِلَّا عِبَادَ اللَّهِ الْمُخْلَصِينَ",
  },
  {
    id: "3949",
    sura: "37",
    VerseIDAr: "161",
    ayatAR: "فَإِنَّكُمْ وَمَا تَعْبُدُونَ",
  },
  {
    id: "3950",
    sura: "37",
    VerseIDAr: "162",
    ayatAR: "مَا أَنْتُمْ عَلَيْهِ بِفَاتِنِينَ",
  },
  {
    id: "3951",
    sura: "37",
    VerseIDAr: "163",
    ayatAR: "إِلَّا مَنْ هُوَ صَالِ الْجَحِيمِ",
  },
  {
    id: "3952",
    sura: "37",
    VerseIDAr: "164",
    ayatAR: "وَمَا مِنَّا إِلَّا لَهُ مَقَامٌ مَعْلُومٌ",
  },
  {
    id: "3953",
    sura: "37",
    VerseIDAr: "165",
    ayatAR: "وَإِنَّا لَنَحْنُ الصَّافُّونَ",
  },
  {
    id: "3954",
    sura: "37",
    VerseIDAr: "166",
    ayatAR: "وَإِنَّا لَنَحْنُ الْمُسَبِّحُونَ",
  },
  {
    id: "3955",
    sura: "37",
    VerseIDAr: "167",
    ayatAR: "وَإِنْ كَانُوا لَيَقُولُونَ",
  },
  {
    id: "3956",
    sura: "37",
    VerseIDAr: "168",
    ayatAR: "لَوْ أَنَّ عِنْدَنَا ذِكْرًا مِنَ الْأَوَّلِينَ",
  },
  {
    id: "3957",
    sura: "37",
    VerseIDAr: "169",
    ayatAR: "لَكُنَّا عِبَادَ اللَّهِ الْمُخْلَصِينَ",
  },
  {
    id: "3958",
    sura: "37",
    VerseIDAr: "170",
    ayatAR: "فَكَفَرُوا بِهِ ۖ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "3959",
    sura: "37",
    VerseIDAr: "171",
    ayatAR: "وَلَقَدْ سَبَقَتْ كَلِمَتُنَا لِعِبَادِنَا الْمُرْسَلِينَ",
  },
  {
    id: "3960",
    sura: "37",
    VerseIDAr: "172",
    ayatAR: "إِنَّهُمْ لَهُمُ الْمَنْصُورُونَ",
  },
  {
    id: "3961",
    sura: "37",
    VerseIDAr: "173",
    ayatAR: "وَإِنَّ جُنْدَنَا لَهُمُ الْغَالِبُونَ",
  },
  {
    id: "3962",
    sura: "37",
    VerseIDAr: "174",
    ayatAR: "فَتَوَلَّ عَنْهُمْ حَتَّىٰ حِينٍ",
  },
  {
    id: "3963",
    sura: "37",
    VerseIDAr: "175",
    ayatAR: "وَأَبْصِرْهُمْ فَسَوْفَ يُبْصِرُونَ",
  },
  {
    id: "3964",
    sura: "37",
    VerseIDAr: "176",
    ayatAR: "أَفَبِعَذَابِنَا يَسْتَعْجِلُونَ",
  },
  {
    id: "3965",
    sura: "37",
    VerseIDAr: "177",
    ayatAR: "فَإِذَا نَزَلَ بِسَاحَتِهِمْ فَسَاءَ صَبَاحُ الْمُنْذَرِينَ",
  },
  {
    id: "3966",
    sura: "37",
    VerseIDAr: "178",
    ayatAR: "وَتَوَلَّ عَنْهُمْ حَتَّىٰ حِينٍ",
  },
  {
    id: "3967",
    sura: "37",
    VerseIDAr: "179",
    ayatAR: "وَأَبْصِرْ فَسَوْفَ يُبْصِرُونَ",
  },
  {
    id: "3968",
    sura: "37",
    VerseIDAr: "180",
    ayatAR: "سُبْحَانَ رَبِّكَ رَبِّ الْعِزَّةِ عَمَّا يَصِفُونَ",
  },
  {
    id: "3969",
    sura: "37",
    VerseIDAr: "181",
    ayatAR: "وَسَلَامٌ عَلَى الْمُرْسَلِينَ",
  },
  {
    id: "3970",
    sura: "37",
    VerseIDAr: "182",
    ayatAR: "وَالْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "3971",
    sura: "38",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ ص ۚ وَالْقُرْآنِ ذِي الذِّكْرِ",
  },
  {
    id: "3972",
    sura: "38",
    VerseIDAr: "2",
    ayatAR: "بَلِ الَّذِينَ كَفَرُوا فِي عِزَّةٍ وَشِقَاقٍ",
  },
  {
    id: "3973",
    sura: "38",
    VerseIDAr: "3",
    ayatAR:
      "كَمْ أَهْلَكْنَا مِنْ قَبْلِهِمْ مِنْ قَرْنٍ فَنَادَوْا وَلَاتَ حِينَ مَنَاصٍ",
  },
  {
    id: "3974",
    sura: "38",
    VerseIDAr: "4",
    ayatAR:
      "وَعَجِبُوا أَنْ جَاءَهُمْ مُنْذِرٌ مِنْهُمْ ۖ وَقَالَ الْكَافِرُونَ هَٰذَا سَاحِرٌ كَذَّابٌ",
  },
  {
    id: "3975",
    sura: "38",
    VerseIDAr: "5",
    ayatAR:
      "أَجَعَلَ الْآلِهَةَ إِلَٰهًا وَاحِدًا ۖ إِنَّ هَٰذَا لَشَيْءٌ عُجَابٌ",
  },
  {
    id: "3976",
    sura: "38",
    VerseIDAr: "6",
    ayatAR:
      "وَانْطَلَقَ الْمَلَأُ مِنْهُمْ أَنِ امْشُوا وَاصْبِرُوا عَلَىٰ آلِهَتِكُمْ ۖ إِنَّ هَٰذَا لَشَيْءٌ يُرَادُ",
  },
  {
    id: "3977",
    sura: "38",
    VerseIDAr: "7",
    ayatAR:
      "مَا سَمِعْنَا بِهَٰذَا فِي الْمِلَّةِ الْآخِرَةِ إِنْ هَٰذَا إِلَّا اخْتِلَاقٌ",
  },
  {
    id: "3978",
    sura: "38",
    VerseIDAr: "8",
    ayatAR:
      "أَأُنْزِلَ عَلَيْهِ الذِّكْرُ مِنْ بَيْنِنَا ۚ بَلْ هُمْ فِي شَكٍّ مِنْ ذِكْرِي ۖ بَلْ لَمَّا يَذُوقُوا عَذَابِ",
  },
  {
    id: "3979",
    sura: "38",
    VerseIDAr: "9",
    ayatAR: "أَمْ عِنْدَهُمْ خَزَائِنُ رَحْمَةِ رَبِّكَ الْعَزِيزِ الْوَهَّابِ",
  },
  {
    id: "3980",
    sura: "38",
    VerseIDAr: "10",
    ayatAR:
      "أَمْ لَهُمْ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا ۖ فَلْيَرْتَقُوا فِي الْأَسْبَابِ",
  },
  {
    id: "3981",
    sura: "38",
    VerseIDAr: "11",
    ayatAR: "جُنْدٌ مَا هُنَالِكَ مَهْزُومٌ مِنَ الْأَحْزَابِ",
  },
  {
    id: "3982",
    sura: "38",
    VerseIDAr: "12",
    ayatAR:
      "كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍ وَعَادٌ وَفِرْعَوْنُ ذُو الْأَوْتَادِ",
  },
  {
    id: "3983",
    sura: "38",
    VerseIDAr: "13",
    ayatAR:
      "وَثَمُودُ وَقَوْمُ لُوطٍ وَأَصْحَابُ الْأَيْكَةِ ۚ أُولَٰئِكَ الْأَحْزَابُ",
  },
  {
    id: "3984",
    sura: "38",
    VerseIDAr: "14",
    ayatAR: "إِنْ كُلٌّ إِلَّا كَذَّبَ الرُّسُلَ فَحَقَّ عِقَابِ",
  },
  {
    id: "3985",
    sura: "38",
    VerseIDAr: "15",
    ayatAR:
      "وَمَا يَنْظُرُ هَٰؤُلَاءِ إِلَّا صَيْحَةً وَاحِدَةً مَا لَهَا مِنْ فَوَاقٍ",
  },
  {
    id: "3986",
    sura: "38",
    VerseIDAr: "16",
    ayatAR:
      "وَقَالُوا رَبَّنَا عَجِّلْ لَنَا قِطَّنَا قَبْلَ يَوْمِ الْحِسَابِ",
  },
  {
    id: "3987",
    sura: "38",
    VerseIDAr: "17",
    ayatAR:
      "اصْبِرْ عَلَىٰ مَا يَقُولُونَ وَاذْكُرْ عَبْدَنَا دَاوُودَ ذَا الْأَيْدِ ۖ إِنَّهُ أَوَّابٌ",
  },
  {
    id: "3988",
    sura: "38",
    VerseIDAr: "18",
    ayatAR:
      "إِنَّا سَخَّرْنَا الْجِبَالَ مَعَهُ يُسَبِّحْنَ بِالْعَشِيِّ وَالْإِشْرَاقِ",
  },
  {
    id: "3989",
    sura: "38",
    VerseIDAr: "19",
    ayatAR: "وَالطَّيْرَ مَحْشُورَةً ۖ كُلٌّ لَهُ أَوَّابٌ",
  },
  {
    id: "3990",
    sura: "38",
    VerseIDAr: "20",
    ayatAR: "وَشَدَدْنَا مُلْكَهُ وَآتَيْنَاهُ الْحِكْمَةَ وَفَصْلَ الْخِطَابِ",
  },
  {
    id: "3991",
    sura: "38",
    VerseIDAr: "21",
    ayatAR: "وَهَلْ أَتَاكَ نَبَأُ الْخَصْمِ إِذْ تَسَوَّرُوا الْمِحْرَابَ",
  },
  {
    id: "3992",
    sura: "38",
    VerseIDAr: "22",
    ayatAR:
      "إِذْ دَخَلُوا عَلَىٰ دَاوُودَ فَفَزِعَ مِنْهُمْ ۖ قَالُوا لَا تَخَفْ ۖ خَصْمَانِ بَغَىٰ بَعْضُنَا عَلَىٰ بَعْضٍ فَاحْكُمْ بَيْنَنَا بِالْحَقِّ وَلَا تُشْطِطْ وَاهْدِنَا إِلَىٰ سَوَاءِ الصِّرَاطِ",
  },
  {
    id: "3993",
    sura: "38",
    VerseIDAr: "23",
    ayatAR:
      "إِنَّ هَٰذَا أَخِي لَهُ تِسْعٌ وَتِسْعُونَ نَعْجَةً وَلِيَ نَعْجَةٌ وَاحِدَةٌ فَقَالَ أَكْفِلْنِيهَا وَعَزَّنِي فِي الْخِطَابِ",
  },
  {
    id: "3994",
    sura: "38",
    VerseIDAr: "24",
    ayatAR:
      "قَالَ لَقَدْ ظَلَمَكَ بِسُؤَالِ نَعْجَتِكَ إِلَىٰ نِعَاجِهِ ۖ وَإِنَّ كَثِيرًا مِنَ الْخُلَطَاءِ لَيَبْغِي بَعْضُهُمْ عَلَىٰ بَعْضٍ إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَقَلِيلٌ مَا هُمْ ۗ وَظَنَّ دَاوُودُ أَنَّمَا فَتَنَّاهُ فَاسْتَغْفَرَ رَبَّهُ وَخَرَّ رَاكِعًا وَأَنَابَ ۩",
  },
  {
    id: "3995",
    sura: "38",
    VerseIDAr: "25",
    ayatAR:
      "فَغَفَرْنَا لَهُ ذَٰلِكَ ۖ وَإِنَّ لَهُ عِنْدَنَا لَزُلْفَىٰ وَحُسْنَ مَآبٍ",
  },
  {
    id: "3996",
    sura: "38",
    VerseIDAr: "26",
    ayatAR:
      "يَا دَاوُودُ إِنَّا جَعَلْنَاكَ خَلِيفَةً فِي الْأَرْضِ فَاحْكُمْ بَيْنَ النَّاسِ بِالْحَقِّ وَلَا تَتَّبِعِ الْهَوَىٰ فَيُضِلَّكَ عَنْ سَبِيلِ اللَّهِ ۚ إِنَّ الَّذِينَ يَضِلُّونَ عَنْ سَبِيلِ اللَّهِ لَهُمْ عَذَابٌ شَدِيدٌ بِمَا نَسُوا يَوْمَ الْحِسَابِ",
  },
  {
    id: "3997",
    sura: "38",
    VerseIDAr: "27",
    ayatAR:
      "وَمَا خَلَقْنَا السَّمَاءَ وَالْأَرْضَ وَمَا بَيْنَهُمَا بَاطِلًا ۚ ذَٰلِكَ ظَنُّ الَّذِينَ كَفَرُوا ۚ فَوَيْلٌ لِلَّذِينَ كَفَرُوا مِنَ النَّارِ",
  },
  {
    id: "3998",
    sura: "38",
    VerseIDAr: "28",
    ayatAR:
      "أَمْ نَجْعَلُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ كَالْمُفْسِدِينَ فِي الْأَرْضِ أَمْ نَجْعَلُ الْمُتَّقِينَ كَالْفُجَّارِ",
  },
  {
    id: "3999",
    sura: "38",
    VerseIDAr: "29",
    ayatAR:
      "كِتَابٌ أَنْزَلْنَاهُ إِلَيْكَ مُبَارَكٌ لِيَدَّبَّرُوا آيَاتِهِ وَلِيَتَذَكَّرَ أُولُو الْأَلْبَابِ",
  },
  {
    id: "4000",
    sura: "38",
    VerseIDAr: "30",
    ayatAR:
      "وَوَهَبْنَا لِدَاوُودَ سُلَيْمَانَ ۚ نِعْمَ الْعَبْدُ ۖ إِنَّهُ أَوَّابٌ",
  },
  {
    id: "4001",
    sura: "38",
    VerseIDAr: "31",
    ayatAR: "إِذْ عُرِضَ عَلَيْهِ بِالْعَشِيِّ الصَّافِنَاتُ الْجِيَادُ",
  },
  {
    id: "4002",
    sura: "38",
    VerseIDAr: "32",
    ayatAR:
      "فَقَالَ إِنِّي أَحْبَبْتُ حُبَّ الْخَيْرِ عَنْ ذِكْرِ رَبِّي حَتَّىٰ تَوَارَتْ بِالْحِجَابِ",
  },
  {
    id: "4003",
    sura: "38",
    VerseIDAr: "33",
    ayatAR: "رُدُّوهَا عَلَيَّ ۖ فَطَفِقَ مَسْحًا بِالسُّوقِ وَالْأَعْنَاقِ",
  },
  {
    id: "4004",
    sura: "38",
    VerseIDAr: "34",
    ayatAR:
      "وَلَقَدْ فَتَنَّا سُلَيْمَانَ وَأَلْقَيْنَا عَلَىٰ كُرْسِيِّهِ جَسَدًا ثُمَّ أَنَابَ",
  },
  {
    id: "4005",
    sura: "38",
    VerseIDAr: "35",
    ayatAR:
      "قَالَ رَبِّ اغْفِرْ لِي وَهَبْ لِي مُلْكًا لَا يَنْبَغِي لِأَحَدٍ مِنْ بَعْدِي ۖ إِنَّكَ أَنْتَ الْوَهَّابُ",
  },
  {
    id: "4006",
    sura: "38",
    VerseIDAr: "36",
    ayatAR:
      "فَسَخَّرْنَا لَهُ الرِّيحَ تَجْرِي بِأَمْرِهِ رُخَاءً حَيْثُ أَصَابَ",
  },
  {
    id: "4007",
    sura: "38",
    VerseIDAr: "37",
    ayatAR: "وَالشَّيَاطِينَ كُلَّ بَنَّاءٍ وَغَوَّاصٍ",
  },
  {
    id: "4008",
    sura: "38",
    VerseIDAr: "38",
    ayatAR: "وَآخَرِينَ مُقَرَّنِينَ فِي الْأَصْفَادِ",
  },
  {
    id: "4009",
    sura: "38",
    VerseIDAr: "39",
    ayatAR: "هَٰذَا عَطَاؤُنَا فَامْنُنْ أَوْ أَمْسِكْ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "4010",
    sura: "38",
    VerseIDAr: "40",
    ayatAR: "وَإِنَّ لَهُ عِنْدَنَا لَزُلْفَىٰ وَحُسْنَ مَآبٍ",
  },
  {
    id: "4011",
    sura: "38",
    VerseIDAr: "41",
    ayatAR:
      "وَاذْكُرْ عَبْدَنَا أَيُّوبَ إِذْ نَادَىٰ رَبَّهُ أَنِّي مَسَّنِيَ الشَّيْطَانُ بِنُصْبٍ وَعَذَابٍ",
  },
  {
    id: "4012",
    sura: "38",
    VerseIDAr: "42",
    ayatAR: "ارْكُضْ بِرِجْلِكَ ۖ هَٰذَا مُغْتَسَلٌ بَارِدٌ وَشَرَابٌ",
  },
  {
    id: "4013",
    sura: "38",
    VerseIDAr: "43",
    ayatAR:
      "وَوَهَبْنَا لَهُ أَهْلَهُ وَمِثْلَهُمْ مَعَهُمْ رَحْمَةً مِنَّا وَذِكْرَىٰ لِأُولِي الْأَلْبَابِ",
  },
  {
    id: "4014",
    sura: "38",
    VerseIDAr: "44",
    ayatAR:
      "وَخُذْ بِيَدِكَ ضِغْثًا فَاضْرِبْ بِهِ وَلَا تَحْنَثْ ۗ إِنَّا وَجَدْنَاهُ صَابِرًا ۚ نِعْمَ الْعَبْدُ ۖ إِنَّهُ أَوَّابٌ",
  },
  {
    id: "4015",
    sura: "38",
    VerseIDAr: "45",
    ayatAR:
      "وَاذْكُرْ عِبَادَنَا إِبْرَاهِيمَ وَإِسْحَاقَ وَيَعْقُوبَ أُولِي الْأَيْدِي وَالْأَبْصَارِ",
  },
  {
    id: "4016",
    sura: "38",
    VerseIDAr: "46",
    ayatAR: "إِنَّا أَخْلَصْنَاهُمْ بِخَالِصَةٍ ذِكْرَى الدَّارِ",
  },
  {
    id: "4017",
    sura: "38",
    VerseIDAr: "47",
    ayatAR: "وَإِنَّهُمْ عِنْدَنَا لَمِنَ الْمُصْطَفَيْنَ الْأَخْيَارِ",
  },
  {
    id: "4018",
    sura: "38",
    VerseIDAr: "48",
    ayatAR:
      "وَاذْكُرْ إِسْمَاعِيلَ وَالْيَسَعَ وَذَا الْكِفْلِ ۖ وَكُلٌّ مِنَ الْأَخْيَارِ",
  },
  {
    id: "4019",
    sura: "38",
    VerseIDAr: "49",
    ayatAR: "هَٰذَا ذِكْرٌ ۚ وَإِنَّ لِلْمُتَّقِينَ لَحُسْنَ مَآبٍ",
  },
  {
    id: "4020",
    sura: "38",
    VerseIDAr: "50",
    ayatAR: "جَنَّاتِ عَدْنٍ مُفَتَّحَةً لَهُمُ الْأَبْوَابُ",
  },
  {
    id: "4021",
    sura: "38",
    VerseIDAr: "51",
    ayatAR:
      "مُتَّكِئِينَ فِيهَا يَدْعُونَ فِيهَا بِفَاكِهَةٍ كَثِيرَةٍ وَشَرَابٍ",
  },
  {
    id: "4022",
    sura: "38",
    VerseIDAr: "52",
    ayatAR: "وَعِنْدَهُمْ قَاصِرَاتُ الطَّرْفِ أَتْرَابٌ",
  },
  {
    id: "4023",
    sura: "38",
    VerseIDAr: "53",
    ayatAR: "هَٰذَا مَا تُوعَدُونَ لِيَوْمِ الْحِسَابِ",
  },
  {
    id: "4024",
    sura: "38",
    VerseIDAr: "54",
    ayatAR: "إِنَّ هَٰذَا لَرِزْقُنَا مَا لَهُ مِنْ نَفَادٍ",
  },
  {
    id: "4025",
    sura: "38",
    VerseIDAr: "55",
    ayatAR: "هَٰذَا ۚ وَإِنَّ لِلطَّاغِينَ لَشَرَّ مَآبٍ",
  },
  {
    id: "4026",
    sura: "38",
    VerseIDAr: "56",
    ayatAR: "جَهَنَّمَ يَصْلَوْنَهَا فَبِئْسَ الْمِهَادُ",
  },
  {
    id: "4027",
    sura: "38",
    VerseIDAr: "57",
    ayatAR: "هَٰذَا فَلْيَذُوقُوهُ حَمِيمٌ وَغَسَّاقٌ",
  },
  {
    id: "4028",
    sura: "38",
    VerseIDAr: "58",
    ayatAR: "وَآخَرُ مِنْ شَكْلِهِ أَزْوَاجٌ",
  },
  {
    id: "4029",
    sura: "38",
    VerseIDAr: "59",
    ayatAR:
      "هَٰذَا فَوْجٌ مُقْتَحِمٌ مَعَكُمْ ۖ لَا مَرْحَبًا بِهِمْ ۚ إِنَّهُمْ صَالُو النَّارِ",
  },
  {
    id: "4030",
    sura: "38",
    VerseIDAr: "60",
    ayatAR:
      "قَالُوا بَلْ أَنْتُمْ لَا مَرْحَبًا بِكُمْ ۖ أَنْتُمْ قَدَّمْتُمُوهُ لَنَا ۖ فَبِئْسَ الْقَرَارُ",
  },
  {
    id: "4031",
    sura: "38",
    VerseIDAr: "61",
    ayatAR:
      "قَالُوا رَبَّنَا مَنْ قَدَّمَ لَنَا هَٰذَا فَزِدْهُ عَذَابًا ضِعْفًا فِي النَّارِ",
  },
  {
    id: "4032",
    sura: "38",
    VerseIDAr: "62",
    ayatAR:
      "وَقَالُوا مَا لَنَا لَا نَرَىٰ رِجَالًا كُنَّا نَعُدُّهُمْ مِنَ الْأَشْرَارِ",
  },
  {
    id: "4033",
    sura: "38",
    VerseIDAr: "63",
    ayatAR: "أَتَّخَذْنَاهُمْ سِخْرِيًّا أَمْ زَاغَتْ عَنْهُمُ الْأَبْصَارُ",
  },
  {
    id: "4034",
    sura: "38",
    VerseIDAr: "64",
    ayatAR: "إِنَّ ذَٰلِكَ لَحَقٌّ تَخَاصُمُ أَهْلِ النَّارِ",
  },
  {
    id: "4035",
    sura: "38",
    VerseIDAr: "65",
    ayatAR:
      "قُلْ إِنَّمَا أَنَا مُنْذِرٌ ۖ وَمَا مِنْ إِلَٰهٍ إِلَّا اللَّهُ الْوَاحِدُ الْقَهَّارُ",
  },
  {
    id: "4036",
    sura: "38",
    VerseIDAr: "66",
    ayatAR:
      "رَبُّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا الْعَزِيزُ الْغَفَّارُ",
  },
  {
    id: "4037",
    sura: "38",
    VerseIDAr: "67",
    ayatAR: "قُلْ هُوَ نَبَأٌ عَظِيمٌ",
  },
  {
    id: "4038",
    sura: "38",
    VerseIDAr: "68",
    ayatAR: "أَنْتُمْ عَنْهُ مُعْرِضُونَ",
  },
  {
    id: "4039",
    sura: "38",
    VerseIDAr: "69",
    ayatAR:
      "مَا كَانَ لِيَ مِنْ عِلْمٍ بِالْمَلَإِ الْأَعْلَىٰ إِذْ يَخْتَصِمُونَ",
  },
  {
    id: "4040",
    sura: "38",
    VerseIDAr: "70",
    ayatAR: "إِنْ يُوحَىٰ إِلَيَّ إِلَّا أَنَّمَا أَنَا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "4041",
    sura: "38",
    VerseIDAr: "71",
    ayatAR:
      "إِذْ قَالَ رَبُّكَ لِلْمَلَائِكَةِ إِنِّي خَالِقٌ بَشَرًا مِنْ طِينٍ",
  },
  {
    id: "4042",
    sura: "38",
    VerseIDAr: "72",
    ayatAR:
      "فَإِذَا سَوَّيْتُهُ وَنَفَخْتُ فِيهِ مِنْ رُوحِي فَقَعُوا لَهُ سَاجِدِينَ",
  },
  {
    id: "4043",
    sura: "38",
    VerseIDAr: "73",
    ayatAR: "فَسَجَدَ الْمَلَائِكَةُ كُلُّهُمْ أَجْمَعُونَ",
  },
  {
    id: "4044",
    sura: "38",
    VerseIDAr: "74",
    ayatAR: "إِلَّا إِبْلِيسَ اسْتَكْبَرَ وَكَانَ مِنَ الْكَافِرِينَ",
  },
  {
    id: "4045",
    sura: "38",
    VerseIDAr: "75",
    ayatAR:
      "قَالَ يَا إِبْلِيسُ مَا مَنَعَكَ أَنْ تَسْجُدَ لِمَا خَلَقْتُ بِيَدَيَّ ۖ أَسْتَكْبَرْتَ أَمْ كُنْتَ مِنَ الْعَالِينَ",
  },
  {
    id: "4046",
    sura: "38",
    VerseIDAr: "76",
    ayatAR:
      "قَالَ أَنَا خَيْرٌ مِنْهُ ۖ خَلَقْتَنِي مِنْ نَارٍ وَخَلَقْتَهُ مِنْ طِينٍ",
  },
  {
    id: "4047",
    sura: "38",
    VerseIDAr: "77",
    ayatAR: "قَالَ فَاخْرُجْ مِنْهَا فَإِنَّكَ رَجِيمٌ",
  },
  {
    id: "4048",
    sura: "38",
    VerseIDAr: "78",
    ayatAR: "وَإِنَّ عَلَيْكَ لَعْنَتِي إِلَىٰ يَوْمِ الدِّينِ",
  },
  {
    id: "4049",
    sura: "38",
    VerseIDAr: "79",
    ayatAR: "قَالَ رَبِّ فَأَنْظِرْنِي إِلَىٰ يَوْمِ يُبْعَثُونَ",
  },
  {
    id: "4050",
    sura: "38",
    VerseIDAr: "80",
    ayatAR: "قَالَ فَإِنَّكَ مِنَ الْمُنْظَرِينَ",
  },
  {
    id: "4051",
    sura: "38",
    VerseIDAr: "81",
    ayatAR: "إِلَىٰ يَوْمِ الْوَقْتِ الْمَعْلُومِ",
  },
  {
    id: "4052",
    sura: "38",
    VerseIDAr: "82",
    ayatAR: "قَالَ فَبِعِزَّتِكَ لَأُغْوِيَنَّهُمْ أَجْمَعِينَ",
  },
  {
    id: "4053",
    sura: "38",
    VerseIDAr: "83",
    ayatAR: "إِلَّا عِبَادَكَ مِنْهُمُ الْمُخْلَصِينَ",
  },
  {
    id: "4054",
    sura: "38",
    VerseIDAr: "84",
    ayatAR: "قَالَ فَالْحَقُّ وَالْحَقَّ أَقُولُ",
  },
  {
    id: "4055",
    sura: "38",
    VerseIDAr: "85",
    ayatAR:
      "لَأَمْلَأَنَّ جَهَنَّمَ مِنْكَ وَمِمَّنْ تَبِعَكَ مِنْهُمْ أَجْمَعِينَ",
  },
  {
    id: "4056",
    sura: "38",
    VerseIDAr: "86",
    ayatAR:
      "قُلْ مَا أَسْأَلُكُمْ عَلَيْهِ مِنْ أَجْرٍ وَمَا أَنَا مِنَ الْمُتَكَلِّفِينَ",
  },
  {
    id: "4057",
    sura: "38",
    VerseIDAr: "87",
    ayatAR: "إِنْ هُوَ إِلَّا ذِكْرٌ لِلْعَالَمِينَ",
  },
  {
    id: "4058",
    sura: "38",
    VerseIDAr: "88",
    ayatAR: "وَلَتَعْلَمُنَّ نَبَأَهُ بَعْدَ حِينٍ",
  },
  {
    id: "4059",
    sura: "39",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ تَنْزِيلُ الْكِتَابِ مِنَ اللَّهِ الْعَزِيزِ الْحَكِيمِ",
  },
  {
    id: "4060",
    sura: "39",
    VerseIDAr: "2",
    ayatAR:
      "إِنَّا أَنْزَلْنَا إِلَيْكَ الْكِتَابَ بِالْحَقِّ فَاعْبُدِ اللَّهَ مُخْلِصًا لَهُ الدِّينَ",
  },
  {
    id: "4061",
    sura: "39",
    VerseIDAr: "3",
    ayatAR:
      "أَلَا لِلَّهِ الدِّينُ الْخَالِصُ ۚ وَالَّذِينَ اتَّخَذُوا مِنْ دُونِهِ أَوْلِيَاءَ مَا نَعْبُدُهُمْ إِلَّا لِيُقَرِّبُونَا إِلَى اللَّهِ زُلْفَىٰ إِنَّ اللَّهَ يَحْكُمُ بَيْنَهُمْ فِي مَا هُمْ فِيهِ يَخْتَلِفُونَ ۗ إِنَّ اللَّهَ لَا يَهْدِي مَنْ هُوَ كَاذِبٌ كَفَّارٌ",
  },
  {
    id: "4062",
    sura: "39",
    VerseIDAr: "4",
    ayatAR:
      "لَوْ أَرَادَ اللَّهُ أَنْ يَتَّخِذَ وَلَدًا لَاصْطَفَىٰ مِمَّا يَخْلُقُ مَا يَشَاءُ ۚ سُبْحَانَهُ ۖ هُوَ اللَّهُ الْوَاحِدُ الْقَهَّارُ",
  },
  {
    id: "4063",
    sura: "39",
    VerseIDAr: "5",
    ayatAR:
      "خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ ۖ يُكَوِّرُ اللَّيْلَ عَلَى النَّهَارِ وَيُكَوِّرُ النَّهَارَ عَلَى اللَّيْلِ ۖ وَسَخَّرَ الشَّمْسَ وَالْقَمَرَ ۖ كُلٌّ يَجْرِي لِأَجَلٍ مُسَمًّى ۗ أَلَا هُوَ الْعَزِيزُ الْغَفَّارُ",
  },
  {
    id: "4064",
    sura: "39",
    VerseIDAr: "6",
    ayatAR:
      "خَلَقَكُمْ مِنْ نَفْسٍ وَاحِدَةٍ ثُمَّ جَعَلَ مِنْهَا زَوْجَهَا وَأَنْزَلَ لَكُمْ مِنَ الْأَنْعَامِ ثَمَانِيَةَ أَزْوَاجٍ ۚ يَخْلُقُكُمْ فِي بُطُونِ أُمَّهَاتِكُمْ خَلْقًا مِنْ بَعْدِ خَلْقٍ فِي ظُلُمَاتٍ ثَلَاثٍ ۚ ذَٰلِكُمُ اللَّهُ رَبُّكُمْ لَهُ الْمُلْكُ ۖ لَا إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُصْرَفُونَ",
  },
  {
    id: "4065",
    sura: "39",
    VerseIDAr: "7",
    ayatAR:
      "إِنْ تَكْفُرُوا فَإِنَّ اللَّهَ غَنِيٌّ عَنْكُمْ ۖ وَلَا يَرْضَىٰ لِعِبَادِهِ الْكُفْرَ ۖ وَإِنْ تَشْكُرُوا يَرْضَهُ لَكُمْ ۗ وَلَا تَزِرُ وَازِرَةٌ وِزْرَ أُخْرَىٰ ۗ ثُمَّ إِلَىٰ رَبِّكُمْ مَرْجِعُكُمْ فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ ۚ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "4066",
    sura: "39",
    VerseIDAr: "8",
    ayatAR:
      "وَإِذَا مَسَّ الْإِنْسَانَ ضُرٌّ دَعَا رَبَّهُ مُنِيبًا إِلَيْهِ ثُمَّ إِذَا خَوَّلَهُ نِعْمَةً مِنْهُ نَسِيَ مَا كَانَ يَدْعُو إِلَيْهِ مِنْ قَبْلُ وَجَعَلَ لِلَّهِ أَنْدَادًا لِيُضِلَّ عَنْ سَبِيلِهِ ۚ قُلْ تَمَتَّعْ بِكُفْرِكَ قَلِيلًا ۖ إِنَّكَ مِنْ أَصْحَابِ النَّارِ",
  },
  {
    id: "4067",
    sura: "39",
    VerseIDAr: "9",
    ayatAR:
      "أَمَّنْ هُوَ قَانِتٌ آنَاءَ اللَّيْلِ سَاجِدًا وَقَائِمًا يَحْذَرُ الْآخِرَةَ وَيَرْجُو رَحْمَةَ رَبِّهِ ۗ قُلْ هَلْ يَسْتَوِي الَّذِينَ يَعْلَمُونَ وَالَّذِينَ لَا يَعْلَمُونَ ۗ إِنَّمَا يَتَذَكَّرُ أُولُو الْأَلْبَابِ",
  },
  {
    id: "4068",
    sura: "39",
    VerseIDAr: "10",
    ayatAR:
      "قُلْ يَا عِبَادِ الَّذِينَ آمَنُوا اتَّقُوا رَبَّكُمْ ۚ لِلَّذِينَ أَحْسَنُوا فِي هَٰذِهِ الدُّنْيَا حَسَنَةٌ ۗ وَأَرْضُ اللَّهِ وَاسِعَةٌ ۗ إِنَّمَا يُوَفَّى الصَّابِرُونَ أَجْرَهُمْ بِغَيْرِ حِسَابٍ",
  },
  {
    id: "4069",
    sura: "39",
    VerseIDAr: "11",
    ayatAR:
      "قُلْ إِنِّي أُمِرْتُ أَنْ أَعْبُدَ اللَّهَ مُخْلِصًا لَهُ الدِّينَ",
  },
  {
    id: "4070",
    sura: "39",
    VerseIDAr: "12",
    ayatAR: "وَأُمِرْتُ لِأَنْ أَكُونَ أَوَّلَ الْمُسْلِمِينَ",
  },
  {
    id: "4071",
    sura: "39",
    VerseIDAr: "13",
    ayatAR: "قُلْ إِنِّي أَخَافُ إِنْ عَصَيْتُ رَبِّي عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "4072",
    sura: "39",
    VerseIDAr: "14",
    ayatAR: "قُلِ اللَّهَ أَعْبُدُ مُخْلِصًا لَهُ دِينِي",
  },
  {
    id: "4073",
    sura: "39",
    VerseIDAr: "15",
    ayatAR:
      "فَاعْبُدُوا مَا شِئْتُمْ مِنْ دُونِهِ ۗ قُلْ إِنَّ الْخَاسِرِينَ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ وَأَهْلِيهِمْ يَوْمَ الْقِيَامَةِ ۗ أَلَا ذَٰلِكَ هُوَ الْخُسْرَانُ الْمُبِينُ",
  },
  {
    id: "4074",
    sura: "39",
    VerseIDAr: "16",
    ayatAR:
      "لَهُمْ مِنْ فَوْقِهِمْ ظُلَلٌ مِنَ النَّارِ وَمِنْ تَحْتِهِمْ ظُلَلٌ ۚ ذَٰلِكَ يُخَوِّفُ اللَّهُ بِهِ عِبَادَهُ ۚ يَا عِبَادِ فَاتَّقُونِ",
  },
  {
    id: "4075",
    sura: "39",
    VerseIDAr: "17",
    ayatAR:
      "وَالَّذِينَ اجْتَنَبُوا الطَّاغُوتَ أَنْ يَعْبُدُوهَا وَأَنَابُوا إِلَى اللَّهِ لَهُمُ الْبُشْرَىٰ ۚ فَبَشِّرْ عِبَادِ",
  },
  {
    id: "4076",
    sura: "39",
    VerseIDAr: "18",
    ayatAR:
      "الَّذِينَ يَسْتَمِعُونَ الْقَوْلَ فَيَتَّبِعُونَ أَحْسَنَهُ ۚ أُولَٰئِكَ الَّذِينَ هَدَاهُمُ اللَّهُ ۖ وَأُولَٰئِكَ هُمْ أُولُو الْأَلْبَابِ",
  },
  {
    id: "4077",
    sura: "39",
    VerseIDAr: "19",
    ayatAR:
      "أَفَمَنْ حَقَّ عَلَيْهِ كَلِمَةُ الْعَذَابِ أَفَأَنْتَ تُنْقِذُ مَنْ فِي النَّارِ",
  },
  {
    id: "4078",
    sura: "39",
    VerseIDAr: "20",
    ayatAR:
      "لَٰكِنِ الَّذِينَ اتَّقَوْا رَبَّهُمْ لَهُمْ غُرَفٌ مِنْ فَوْقِهَا غُرَفٌ مَبْنِيَّةٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ وَعْدَ اللَّهِ ۖ لَا يُخْلِفُ اللَّهُ الْمِيعَادَ",
  },
  {
    id: "4079",
    sura: "39",
    VerseIDAr: "21",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ أَنْزَلَ مِنَ السَّمَاءِ مَاءً فَسَلَكَهُ يَنَابِيعَ فِي الْأَرْضِ ثُمَّ يُخْرِجُ بِهِ زَرْعًا مُخْتَلِفًا أَلْوَانُهُ ثُمَّ يَهِيجُ فَتَرَاهُ مُصْفَرًّا ثُمَّ يَجْعَلُهُ حُطَامًا ۚ إِنَّ فِي ذَٰلِكَ لَذِكْرَىٰ لِأُولِي الْأَلْبَابِ",
  },
  {
    id: "4080",
    sura: "39",
    VerseIDAr: "22",
    ayatAR:
      "أَفَمَنْ شَرَحَ اللَّهُ صَدْرَهُ لِلْإِسْلَامِ فَهُوَ عَلَىٰ نُورٍ مِنْ رَبِّهِ ۚ فَوَيْلٌ لِلْقَاسِيَةِ قُلُوبُهُمْ مِنْ ذِكْرِ اللَّهِ ۚ أُولَٰئِكَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "4081",
    sura: "39",
    VerseIDAr: "23",
    ayatAR:
      "اللَّهُ نَزَّلَ أَحْسَنَ الْحَدِيثِ كِتَابًا مُتَشَابِهًا مَثَانِيَ تَقْشَعِرُّ مِنْهُ جُلُودُ الَّذِينَ يَخْشَوْنَ رَبَّهُمْ ثُمَّ تَلِينُ جُلُودُهُمْ وَقُلُوبُهُمْ إِلَىٰ ذِكْرِ اللَّهِ ۚ ذَٰلِكَ هُدَى اللَّهِ يَهْدِي بِهِ مَنْ يَشَاءُ ۚ وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ هَادٍ",
  },
  {
    id: "4082",
    sura: "39",
    VerseIDAr: "24",
    ayatAR:
      "أَفَمَنْ يَتَّقِي بِوَجْهِهِ سُوءَ الْعَذَابِ يَوْمَ الْقِيَامَةِ ۚ وَقِيلَ لِلظَّالِمِينَ ذُوقُوا مَا كُنْتُمْ تَكْسِبُونَ",
  },
  {
    id: "4083",
    sura: "39",
    VerseIDAr: "25",
    ayatAR:
      "كَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ فَأَتَاهُمُ الْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ",
  },
  {
    id: "4084",
    sura: "39",
    VerseIDAr: "26",
    ayatAR:
      "فَأَذَاقَهُمُ اللَّهُ الْخِزْيَ فِي الْحَيَاةِ الدُّنْيَا ۖ وَلَعَذَابُ الْآخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "4085",
    sura: "39",
    VerseIDAr: "27",
    ayatAR:
      "وَلَقَدْ ضَرَبْنَا لِلنَّاسِ فِي هَٰذَا الْقُرْآنِ مِنْ كُلِّ مَثَلٍ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "4086",
    sura: "39",
    VerseIDAr: "28",
    ayatAR: "قُرْآنًا عَرَبِيًّا غَيْرَ ذِي عِوَجٍ لَعَلَّهُمْ يَتَّقُونَ",
  },
  {
    id: "4087",
    sura: "39",
    VerseIDAr: "29",
    ayatAR:
      "ضَرَبَ اللَّهُ مَثَلًا رَجُلًا فِيهِ شُرَكَاءُ مُتَشَاكِسُونَ وَرَجُلًا سَلَمًا لِرَجُلٍ هَلْ يَسْتَوِيَانِ مَثَلًا ۚ الْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "4088",
    sura: "39",
    VerseIDAr: "30",
    ayatAR: "إِنَّكَ مَيِّتٌ وَإِنَّهُمْ مَيِّتُونَ",
  },
  {
    id: "4089",
    sura: "39",
    VerseIDAr: "31",
    ayatAR:
      "ثُمَّ إِنَّكُمْ يَوْمَ الْقِيَامَةِ عِنْدَ رَبِّكُمْ تَخْتَصِمُونَ",
  },
  {
    id: "4090",
    sura: "39",
    VerseIDAr: "32",
    ayatAR:
      "فَمَنْ أَظْلَمُ مِمَّنْ كَذَبَ عَلَى اللَّهِ وَكَذَّبَ بِالصِّدْقِ إِذْ جَاءَهُ ۚ أَلَيْسَ فِي جَهَنَّمَ مَثْوًى لِلْكَافِرِينَ",
  },
  {
    id: "4091",
    sura: "39",
    VerseIDAr: "33",
    ayatAR:
      "وَالَّذِي جَاءَ بِالصِّدْقِ وَصَدَّقَ بِهِ ۙ أُولَٰئِكَ هُمُ الْمُتَّقُونَ",
  },
  {
    id: "4092",
    sura: "39",
    VerseIDAr: "34",
    ayatAR:
      "لَهُمْ مَا يَشَاءُونَ عِنْدَ رَبِّهِمْ ۚ ذَٰلِكَ جَزَاءُ الْمُحْسِنِينَ",
  },
  {
    id: "4093",
    sura: "39",
    VerseIDAr: "35",
    ayatAR:
      "لِيُكَفِّرَ اللَّهُ عَنْهُمْ أَسْوَأَ الَّذِي عَمِلُوا وَيَجْزِيَهُمْ أَجْرَهُمْ بِأَحْسَنِ الَّذِي كَانُوا يَعْمَلُونَ",
  },
  {
    id: "4094",
    sura: "39",
    VerseIDAr: "36",
    ayatAR:
      "أَلَيْسَ اللَّهُ بِكَافٍ عَبْدَهُ ۖ وَيُخَوِّفُونَكَ بِالَّذِينَ مِنْ دُونِهِ ۚ وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ هَادٍ",
  },
  {
    id: "4095",
    sura: "39",
    VerseIDAr: "37",
    ayatAR:
      "وَمَنْ يَهْدِ اللَّهُ فَمَا لَهُ مِنْ مُضِلٍّ ۗ أَلَيْسَ اللَّهُ بِعَزِيزٍ ذِي انْتِقَامٍ",
  },
  {
    id: "4096",
    sura: "39",
    VerseIDAr: "38",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ لَيَقُولُنَّ اللَّهُ ۚ قُلْ أَفَرَأَيْتُمْ مَا تَدْعُونَ مِنْ دُونِ اللَّهِ إِنْ أَرَادَنِيَ اللَّهُ بِضُرٍّ هَلْ هُنَّ كَاشِفَاتُ ضُرِّهِ أَوْ أَرَادَنِي بِرَحْمَةٍ هَلْ هُنَّ مُمْسِكَاتُ رَحْمَتِهِ ۚ قُلْ حَسْبِيَ اللَّهُ ۖ عَلَيْهِ يَتَوَكَّلُ الْمُتَوَكِّلُونَ",
  },
  {
    id: "4097",
    sura: "39",
    VerseIDAr: "39",
    ayatAR:
      "قُلْ يَا قَوْمِ اعْمَلُوا عَلَىٰ مَكَانَتِكُمْ إِنِّي عَامِلٌ ۖ فَسَوْفَ تَعْلَمُونَ",
  },
  {
    id: "4098",
    sura: "39",
    VerseIDAr: "40",
    ayatAR:
      "مَنْ يَأْتِيهِ عَذَابٌ يُخْزِيهِ وَيَحِلُّ عَلَيْهِ عَذَابٌ مُقِيمٌ",
  },
  {
    id: "4099",
    sura: "39",
    VerseIDAr: "41",
    ayatAR:
      "إِنَّا أَنْزَلْنَا عَلَيْكَ الْكِتَابَ لِلنَّاسِ بِالْحَقِّ ۖ فَمَنِ اهْتَدَىٰ فَلِنَفْسِهِ ۖ وَمَنْ ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۖ وَمَا أَنْتَ عَلَيْهِمْ بِوَكِيلٍ",
  },
  {
    id: "4100",
    sura: "39",
    VerseIDAr: "42",
    ayatAR:
      "اللَّهُ يَتَوَفَّى الْأَنْفُسَ حِينَ مَوْتِهَا وَالَّتِي لَمْ تَمُتْ فِي مَنَامِهَا ۖ فَيُمْسِكُ الَّتِي قَضَىٰ عَلَيْهَا الْمَوْتَ وَيُرْسِلُ الْأُخْرَىٰ إِلَىٰ أَجَلٍ مُسَمًّى ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "4101",
    sura: "39",
    VerseIDAr: "43",
    ayatAR:
      "أَمِ اتَّخَذُوا مِنْ دُونِ اللَّهِ شُفَعَاءَ ۚ قُلْ أَوَلَوْ كَانُوا لَا يَمْلِكُونَ شَيْئًا وَلَا يَعْقِلُونَ",
  },
  {
    id: "4102",
    sura: "39",
    VerseIDAr: "44",
    ayatAR:
      "قُلْ لِلَّهِ الشَّفَاعَةُ جَمِيعًا ۖ لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۖ ثُمَّ إِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "4103",
    sura: "39",
    VerseIDAr: "45",
    ayatAR:
      "وَإِذَا ذُكِرَ اللَّهُ وَحْدَهُ اشْمَأَزَّتْ قُلُوبُ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ ۖ وَإِذَا ذُكِرَ الَّذِينَ مِنْ دُونِهِ إِذَا هُمْ يَسْتَبْشِرُونَ",
  },
  {
    id: "4104",
    sura: "39",
    VerseIDAr: "46",
    ayatAR:
      "قُلِ اللَّهُمَّ فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ عَالِمَ الْغَيْبِ وَالشَّهَادَةِ أَنْتَ تَحْكُمُ بَيْنَ عِبَادِكَ فِي مَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "4105",
    sura: "39",
    VerseIDAr: "47",
    ayatAR:
      "وَلَوْ أَنَّ لِلَّذِينَ ظَلَمُوا مَا فِي الْأَرْضِ جَمِيعًا وَمِثْلَهُ مَعَهُ لَافْتَدَوْا بِهِ مِنْ سُوءِ الْعَذَابِ يَوْمَ الْقِيَامَةِ ۚ وَبَدَا لَهُمْ مِنَ اللَّهِ مَا لَمْ يَكُونُوا يَحْتَسِبُونَ",
  },
  {
    id: "4106",
    sura: "39",
    VerseIDAr: "48",
    ayatAR:
      "وَبَدَا لَهُمْ سَيِّئَاتُ مَا كَسَبُوا وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "4107",
    sura: "39",
    VerseIDAr: "49",
    ayatAR:
      "فَإِذَا مَسَّ الْإِنْسَانَ ضُرٌّ دَعَانَا ثُمَّ إِذَا خَوَّلْنَاهُ نِعْمَةً مِنَّا قَالَ إِنَّمَا أُوتِيتُهُ عَلَىٰ عِلْمٍ ۚ بَلْ هِيَ فِتْنَةٌ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "4108",
    sura: "39",
    VerseIDAr: "50",
    ayatAR:
      "قَدْ قَالَهَا الَّذِينَ مِنْ قَبْلِهِمْ فَمَا أَغْنَىٰ عَنْهُمْ مَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "4109",
    sura: "39",
    VerseIDAr: "51",
    ayatAR:
      "فَأَصَابَهُمْ سَيِّئَاتُ مَا كَسَبُوا ۚ وَالَّذِينَ ظَلَمُوا مِنْ هَٰؤُلَاءِ سَيُصِيبُهُمْ سَيِّئَاتُ مَا كَسَبُوا وَمَا هُمْ بِمُعْجِزِينَ",
  },
  {
    id: "4110",
    sura: "39",
    VerseIDAr: "52",
    ayatAR:
      "أَوَلَمْ يَعْلَمُوا أَنَّ اللَّهَ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يُؤْمِنُونَ",
  },
  {
    id: "4111",
    sura: "39",
    VerseIDAr: "53",
    ayatAR:
      "قُلْ يَا عِبَادِيَ الَّذِينَ أَسْرَفُوا عَلَىٰ أَنْفُسِهِمْ لَا تَقْنَطُوا مِنْ رَحْمَةِ اللَّهِ ۚ إِنَّ اللَّهَ يَغْفِرُ الذُّنُوبَ جَمِيعًا ۚ إِنَّهُ هُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "4112",
    sura: "39",
    VerseIDAr: "54",
    ayatAR:
      "وَأَنِيبُوا إِلَىٰ رَبِّكُمْ وَأَسْلِمُوا لَهُ مِنْ قَبْلِ أَنْ يَأْتِيَكُمُ الْعَذَابُ ثُمَّ لَا تُنْصَرُونَ",
  },
  {
    id: "4113",
    sura: "39",
    VerseIDAr: "55",
    ayatAR:
      "وَاتَّبِعُوا أَحْسَنَ مَا أُنْزِلَ إِلَيْكُمْ مِنْ رَبِّكُمْ مِنْ قَبْلِ أَنْ يَأْتِيَكُمُ الْعَذَابُ بَغْتَةً وَأَنْتُمْ لَا تَشْعُرُونَ",
  },
  {
    id: "4114",
    sura: "39",
    VerseIDAr: "56",
    ayatAR:
      "أَنْ تَقُولَ نَفْسٌ يَا حَسْرَتَا عَلَىٰ مَا فَرَّطْتُ فِي جَنْبِ اللَّهِ وَإِنْ كُنْتُ لَمِنَ السَّاخِرِينَ",
  },
  {
    id: "4115",
    sura: "39",
    VerseIDAr: "57",
    ayatAR:
      "أَوْ تَقُولَ لَوْ أَنَّ اللَّهَ هَدَانِي لَكُنْتُ مِنَ الْمُتَّقِينَ",
  },
  {
    id: "4116",
    sura: "39",
    VerseIDAr: "58",
    ayatAR:
      "أَوْ تَقُولَ حِينَ تَرَى الْعَذَابَ لَوْ أَنَّ لِي كَرَّةً فَأَكُونَ مِنَ الْمُحْسِنِينَ",
  },
  {
    id: "4117",
    sura: "39",
    VerseIDAr: "59",
    ayatAR:
      "بَلَىٰ قَدْ جَاءَتْكَ آيَاتِي فَكَذَّبْتَ بِهَا وَاسْتَكْبَرْتَ وَكُنْتَ مِنَ الْكَافِرِينَ",
  },
  {
    id: "4118",
    sura: "39",
    VerseIDAr: "60",
    ayatAR:
      "وَيَوْمَ الْقِيَامَةِ تَرَى الَّذِينَ كَذَبُوا عَلَى اللَّهِ وُجُوهُهُمْ مُسْوَدَّةٌ ۚ أَلَيْسَ فِي جَهَنَّمَ مَثْوًى لِلْمُتَكَبِّرِينَ",
  },
  {
    id: "4119",
    sura: "39",
    VerseIDAr: "61",
    ayatAR:
      "وَيُنَجِّي اللَّهُ الَّذِينَ اتَّقَوْا بِمَفَازَتِهِمْ لَا يَمَسُّهُمُ السُّوءُ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "4120",
    sura: "39",
    VerseIDAr: "62",
    ayatAR: "اللَّهُ خَالِقُ كُلِّ شَيْءٍ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ وَكِيلٌ",
  },
  {
    id: "4121",
    sura: "39",
    VerseIDAr: "63",
    ayatAR:
      "لَهُ مَقَالِيدُ السَّمَاوَاتِ وَالْأَرْضِ ۗ وَالَّذِينَ كَفَرُوا بِآيَاتِ اللَّهِ أُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "4122",
    sura: "39",
    VerseIDAr: "64",
    ayatAR:
      "قُلْ أَفَغَيْرَ اللَّهِ تَأْمُرُونِّي أَعْبُدُ أَيُّهَا الْجَاهِلُونَ",
  },
  {
    id: "4123",
    sura: "39",
    VerseIDAr: "65",
    ayatAR:
      "وَلَقَدْ أُوحِيَ إِلَيْكَ وَإِلَى الَّذِينَ مِنْ قَبْلِكَ لَئِنْ أَشْرَكْتَ لَيَحْبَطَنَّ عَمَلُكَ وَلَتَكُونَنَّ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "4124",
    sura: "39",
    VerseIDAr: "66",
    ayatAR: "بَلِ اللَّهَ فَاعْبُدْ وَكُنْ مِنَ الشَّاكِرِينَ",
  },
  {
    id: "4125",
    sura: "39",
    VerseIDAr: "67",
    ayatAR:
      "وَمَا قَدَرُوا اللَّهَ حَقَّ قَدْرِهِ وَالْأَرْضُ جَمِيعًا قَبْضَتُهُ يَوْمَ الْقِيَامَةِ وَالسَّمَاوَاتُ مَطْوِيَّاتٌ بِيَمِينِهِ ۚ سُبْحَانَهُ وَتَعَالَىٰ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "4126",
    sura: "39",
    VerseIDAr: "68",
    ayatAR:
      "وَنُفِخَ فِي الصُّورِ فَصَعِقَ مَنْ فِي السَّمَاوَاتِ وَمَنْ فِي الْأَرْضِ إِلَّا مَنْ شَاءَ اللَّهُ ۖ ثُمَّ نُفِخَ فِيهِ أُخْرَىٰ فَإِذَا هُمْ قِيَامٌ يَنْظُرُونَ",
  },
  {
    id: "4127",
    sura: "39",
    VerseIDAr: "69",
    ayatAR:
      "وَأَشْرَقَتِ الْأَرْضُ بِنُورِ رَبِّهَا وَوُضِعَ الْكِتَابُ وَجِيءَ بِالنَّبِيِّينَ وَالشُّهَدَاءِ وَقُضِيَ بَيْنَهُمْ بِالْحَقِّ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "4128",
    sura: "39",
    VerseIDAr: "70",
    ayatAR:
      "وَوُفِّيَتْ كُلُّ نَفْسٍ مَا عَمِلَتْ وَهُوَ أَعْلَمُ بِمَا يَفْعَلُونَ",
  },
  {
    id: "4129",
    sura: "39",
    VerseIDAr: "71",
    ayatAR:
      "وَسِيقَ الَّذِينَ كَفَرُوا إِلَىٰ جَهَنَّمَ زُمَرًا ۖ حَتَّىٰ إِذَا جَاءُوهَا فُتِحَتْ أَبْوَابُهَا وَقَالَ لَهُمْ خَزَنَتُهَا أَلَمْ يَأْتِكُمْ رُسُلٌ مِنْكُمْ يَتْلُونَ عَلَيْكُمْ آيَاتِ رَبِّكُمْ وَيُنْذِرُونَكُمْ لِقَاءَ يَوْمِكُمْ هَٰذَا ۚ قَالُوا بَلَىٰ وَلَٰكِنْ حَقَّتْ كَلِمَةُ الْعَذَابِ عَلَى الْكَافِرِينَ",
  },
  {
    id: "4130",
    sura: "39",
    VerseIDAr: "72",
    ayatAR:
      "قِيلَ ادْخُلُوا أَبْوَابَ جَهَنَّمَ خَالِدِينَ فِيهَا ۖ فَبِئْسَ مَثْوَى الْمُتَكَبِّرِينَ",
  },
  {
    id: "4131",
    sura: "39",
    VerseIDAr: "73",
    ayatAR:
      "وَسِيقَ الَّذِينَ اتَّقَوْا رَبَّهُمْ إِلَى الْجَنَّةِ زُمَرًا ۖ حَتَّىٰ إِذَا جَاءُوهَا وَفُتِحَتْ أَبْوَابُهَا وَقَالَ لَهُمْ خَزَنَتُهَا سَلَامٌ عَلَيْكُمْ طِبْتُمْ فَادْخُلُوهَا خَالِدِينَ",
  },
  {
    id: "4132",
    sura: "39",
    VerseIDAr: "74",
    ayatAR:
      "وَقَالُوا الْحَمْدُ لِلَّهِ الَّذِي صَدَقَنَا وَعْدَهُ وَأَوْرَثَنَا الْأَرْضَ نَتَبَوَّأُ مِنَ الْجَنَّةِ حَيْثُ نَشَاءُ ۖ فَنِعْمَ أَجْرُ الْعَامِلِينَ",
  },
  {
    id: "4133",
    sura: "39",
    VerseIDAr: "75",
    ayatAR:
      "وَتَرَى الْمَلَائِكَةَ حَافِّينَ مِنْ حَوْلِ الْعَرْشِ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ ۖ وَقُضِيَ بَيْنَهُمْ بِالْحَقِّ وَقِيلَ الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "4134",
    sura: "40",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  {
    id: "4135",
    sura: "40",
    VerseIDAr: "2",
    ayatAR: "تَنْزِيلُ الْكِتَابِ مِنَ اللَّهِ الْعَزِيزِ الْعَلِيمِ",
  },
  {
    id: "4136",
    sura: "40",
    VerseIDAr: "3",
    ayatAR:
      "غَافِرِ الذَّنْبِ وَقَابِلِ التَّوْبِ شَدِيدِ الْعِقَابِ ذِي الطَّوْلِ ۖ لَا إِلَٰهَ إِلَّا هُوَ ۖ إِلَيْهِ الْمَصِيرُ",
  },
  {
    id: "4137",
    sura: "40",
    VerseIDAr: "4",
    ayatAR:
      "مَا يُجَادِلُ فِي آيَاتِ اللَّهِ إِلَّا الَّذِينَ كَفَرُوا فَلَا يَغْرُرْكَ تَقَلُّبُهُمْ فِي الْبِلَادِ",
  },
  {
    id: "4138",
    sura: "40",
    VerseIDAr: "5",
    ayatAR:
      "كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍ وَالْأَحْزَابُ مِنْ بَعْدِهِمْ ۖ وَهَمَّتْ كُلُّ أُمَّةٍ بِرَسُولِهِمْ لِيَأْخُذُوهُ ۖ وَجَادَلُوا بِالْبَاطِلِ لِيُدْحِضُوا بِهِ الْحَقَّ فَأَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ عِقَابِ",
  },
  {
    id: "4139",
    sura: "40",
    VerseIDAr: "6",
    ayatAR:
      "وَكَذَٰلِكَ حَقَّتْ كَلِمَتُ رَبِّكَ عَلَى الَّذِينَ كَفَرُوا أَنَّهُمْ أَصْحَابُ النَّارِ",
  },
  {
    id: "4140",
    sura: "40",
    VerseIDAr: "7",
    ayatAR:
      "الَّذِينَ يَحْمِلُونَ الْعَرْشَ وَمَنْ حَوْلَهُ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ وَيُؤْمِنُونَ بِهِ وَيَسْتَغْفِرُونَ لِلَّذِينَ آمَنُوا رَبَّنَا وَسِعْتَ كُلَّ شَيْءٍ رَحْمَةً وَعِلْمًا فَاغْفِرْ لِلَّذِينَ تَابُوا وَاتَّبَعُوا سَبِيلَكَ وَقِهِمْ عَذَابَ الْجَحِيمِ",
  },
  {
    id: "4141",
    sura: "40",
    VerseIDAr: "8",
    ayatAR:
      "رَبَّنَا وَأَدْخِلْهُمْ جَنَّاتِ عَدْنٍ الَّتِي وَعَدْتَهُمْ وَمَنْ صَلَحَ مِنْ آبَائِهِمْ وَأَزْوَاجِهِمْ وَذُرِّيَّاتِهِمْ ۚ إِنَّكَ أَنْتَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "4142",
    sura: "40",
    VerseIDAr: "9",
    ayatAR:
      "وَقِهِمُ السَّيِّئَاتِ ۚ وَمَنْ تَقِ السَّيِّئَاتِ يَوْمَئِذٍ فَقَدْ رَحِمْتَهُ ۚ وَذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "4143",
    sura: "40",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا يُنَادَوْنَ لَمَقْتُ اللَّهِ أَكْبَرُ مِنْ مَقْتِكُمْ أَنْفُسَكُمْ إِذْ تُدْعَوْنَ إِلَى الْإِيمَانِ فَتَكْفُرُونَ",
  },
  {
    id: "4144",
    sura: "40",
    VerseIDAr: "11",
    ayatAR:
      "قَالُوا رَبَّنَا أَمَتَّنَا اثْنَتَيْنِ وَأَحْيَيْتَنَا اثْنَتَيْنِ فَاعْتَرَفْنَا بِذُنُوبِنَا فَهَلْ إِلَىٰ خُرُوجٍ مِنْ سَبِيلٍ",
  },
  {
    id: "4145",
    sura: "40",
    VerseIDAr: "12",
    ayatAR:
      "ذَٰلِكُمْ بِأَنَّهُ إِذَا دُعِيَ اللَّهُ وَحْدَهُ كَفَرْتُمْ ۖ وَإِنْ يُشْرَكْ بِهِ تُؤْمِنُوا ۚ فَالْحُكْمُ لِلَّهِ الْعَلِيِّ الْكَبِيرِ",
  },
  {
    id: "4146",
    sura: "40",
    VerseIDAr: "13",
    ayatAR:
      "هُوَ الَّذِي يُرِيكُمْ آيَاتِهِ وَيُنَزِّلُ لَكُمْ مِنَ السَّمَاءِ رِزْقًا ۚ وَمَا يَتَذَكَّرُ إِلَّا مَنْ يُنِيبُ",
  },
  {
    id: "4147",
    sura: "40",
    VerseIDAr: "14",
    ayatAR:
      "فَادْعُوا اللَّهَ مُخْلِصِينَ لَهُ الدِّينَ وَلَوْ كَرِهَ الْكَافِرُونَ",
  },
  {
    id: "4148",
    sura: "40",
    VerseIDAr: "15",
    ayatAR:
      "رَفِيعُ الدَّرَجَاتِ ذُو الْعَرْشِ يُلْقِي الرُّوحَ مِنْ أَمْرِهِ عَلَىٰ مَنْ يَشَاءُ مِنْ عِبَادِهِ لِيُنْذِرَ يَوْمَ التَّلَاقِ",
  },
  {
    id: "4149",
    sura: "40",
    VerseIDAr: "16",
    ayatAR:
      "يَوْمَ هُمْ بَارِزُونَ ۖ لَا يَخْفَىٰ عَلَى اللَّهِ مِنْهُمْ شَيْءٌ ۚ لِمَنِ الْمُلْكُ الْيَوْمَ ۖ لِلَّهِ الْوَاحِدِ الْقَهَّارِ",
  },
  {
    id: "4150",
    sura: "40",
    VerseIDAr: "17",
    ayatAR:
      "الْيَوْمَ تُجْزَىٰ كُلُّ نَفْسٍ بِمَا كَسَبَتْ ۚ لَا ظُلْمَ الْيَوْمَ ۚ إِنَّ اللَّهَ سَرِيعُ الْحِسَابِ",
  },
  {
    id: "4151",
    sura: "40",
    VerseIDAr: "18",
    ayatAR:
      "وَأَنْذِرْهُمْ يَوْمَ الْآزِفَةِ إِذِ الْقُلُوبُ لَدَى الْحَنَاجِرِ كَاظِمِينَ ۚ مَا لِلظَّالِمِينَ مِنْ حَمِيمٍ وَلَا شَفِيعٍ يُطَاعُ",
  },
  {
    id: "4152",
    sura: "40",
    VerseIDAr: "19",
    ayatAR: "يَعْلَمُ خَائِنَةَ الْأَعْيُنِ وَمَا تُخْفِي الصُّدُورُ",
  },
  {
    id: "4153",
    sura: "40",
    VerseIDAr: "20",
    ayatAR:
      "وَاللَّهُ يَقْضِي بِالْحَقِّ ۖ وَالَّذِينَ يَدْعُونَ مِنْ دُونِهِ لَا يَقْضُونَ بِشَيْءٍ ۗ إِنَّ اللَّهَ هُوَ السَّمِيعُ الْبَصِيرُ",
  },
  {
    id: "4154",
    sura: "40",
    VerseIDAr: "21",
    ayatAR:
      "أَوَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ كَانُوا مِنْ قَبْلِهِمْ ۚ كَانُوا هُمْ أَشَدَّ مِنْهُمْ قُوَّةً وَآثَارًا فِي الْأَرْضِ فَأَخَذَهُمُ اللَّهُ بِذُنُوبِهِمْ وَمَا كَانَ لَهُمْ مِنَ اللَّهِ مِنْ وَاقٍ",
  },
  {
    id: "4155",
    sura: "40",
    VerseIDAr: "22",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ كَانَتْ تَأْتِيهِمْ رُسُلُهُمْ بِالْبَيِّنَاتِ فَكَفَرُوا فَأَخَذَهُمُ اللَّهُ ۚ إِنَّهُ قَوِيٌّ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "4156",
    sura: "40",
    VerseIDAr: "23",
    ayatAR: "وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِآيَاتِنَا وَسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "4157",
    sura: "40",
    VerseIDAr: "24",
    ayatAR:
      "إِلَىٰ فِرْعَوْنَ وَهَامَانَ وَقَارُونَ فَقَالُوا سَاحِرٌ كَذَّابٌ",
  },
  {
    id: "4158",
    sura: "40",
    VerseIDAr: "25",
    ayatAR:
      "فَلَمَّا جَاءَهُمْ بِالْحَقِّ مِنْ عِنْدِنَا قَالُوا اقْتُلُوا أَبْنَاءَ الَّذِينَ آمَنُوا مَعَهُ وَاسْتَحْيُوا نِسَاءَهُمْ ۚ وَمَا كَيْدُ الْكَافِرِينَ إِلَّا فِي ضَلَالٍ",
  },
  {
    id: "4159",
    sura: "40",
    VerseIDAr: "26",
    ayatAR:
      "وَقَالَ فِرْعَوْنُ ذَرُونِي أَقْتُلْ مُوسَىٰ وَلْيَدْعُ رَبَّهُ ۖ إِنِّي أَخَافُ أَنْ يُبَدِّلَ دِينَكُمْ أَوْ أَنْ يُظْهِرَ فِي الْأَرْضِ الْفَسَادَ",
  },
  {
    id: "4160",
    sura: "40",
    VerseIDAr: "27",
    ayatAR:
      "وَقَالَ مُوسَىٰ إِنِّي عُذْتُ بِرَبِّي وَرَبِّكُمْ مِنْ كُلِّ مُتَكَبِّرٍ لَا يُؤْمِنُ بِيَوْمِ الْحِسَابِ",
  },
  {
    id: "4161",
    sura: "40",
    VerseIDAr: "28",
    ayatAR:
      "وَقَالَ رَجُلٌ مُؤْمِنٌ مِنْ آلِ فِرْعَوْنَ يَكْتُمُ إِيمَانَهُ أَتَقْتُلُونَ رَجُلًا أَنْ يَقُولَ رَبِّيَ اللَّهُ وَقَدْ جَاءَكُمْ بِالْبَيِّنَاتِ مِنْ رَبِّكُمْ ۖ وَإِنْ يَكُ كَاذِبًا فَعَلَيْهِ كَذِبُهُ ۖ وَإِنْ يَكُ صَادِقًا يُصِبْكُمْ بَعْضُ الَّذِي يَعِدُكُمْ ۖ إِنَّ اللَّهَ لَا يَهْدِي مَنْ هُوَ مُسْرِفٌ كَذَّابٌ",
  },
  {
    id: "4162",
    sura: "40",
    VerseIDAr: "29",
    ayatAR:
      "يَا قَوْمِ لَكُمُ الْمُلْكُ الْيَوْمَ ظَاهِرِينَ فِي الْأَرْضِ فَمَنْ يَنْصُرُنَا مِنْ بَأْسِ اللَّهِ إِنْ جَاءَنَا ۚ قَالَ فِرْعَوْنُ مَا أُرِيكُمْ إِلَّا مَا أَرَىٰ وَمَا أَهْدِيكُمْ إِلَّا سَبِيلَ الرَّشَادِ",
  },
  {
    id: "4163",
    sura: "40",
    VerseIDAr: "30",
    ayatAR:
      "وَقَالَ الَّذِي آمَنَ يَا قَوْمِ إِنِّي أَخَافُ عَلَيْكُمْ مِثْلَ يَوْمِ الْأَحْزَابِ",
  },
  {
    id: "4164",
    sura: "40",
    VerseIDAr: "31",
    ayatAR:
      "مِثْلَ دَأْبِ قَوْمِ نُوحٍ وَعَادٍ وَثَمُودَ وَالَّذِينَ مِنْ بَعْدِهِمْ ۚ وَمَا اللَّهُ يُرِيدُ ظُلْمًا لِلْعِبَادِ",
  },
  {
    id: "4165",
    sura: "40",
    VerseIDAr: "32",
    ayatAR: "وَيَا قَوْمِ إِنِّي أَخَافُ عَلَيْكُمْ يَوْمَ التَّنَادِ",
  },
  {
    id: "4166",
    sura: "40",
    VerseIDAr: "33",
    ayatAR:
      "يَوْمَ تُوَلُّونَ مُدْبِرِينَ مَا لَكُمْ مِنَ اللَّهِ مِنْ عَاصِمٍ ۗ وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ هَادٍ",
  },
  {
    id: "4167",
    sura: "40",
    VerseIDAr: "34",
    ayatAR:
      "وَلَقَدْ جَاءَكُمْ يُوسُفُ مِنْ قَبْلُ بِالْبَيِّنَاتِ فَمَا زِلْتُمْ فِي شَكٍّ مِمَّا جَاءَكُمْ بِهِ ۖ حَتَّىٰ إِذَا هَلَكَ قُلْتُمْ لَنْ يَبْعَثَ اللَّهُ مِنْ بَعْدِهِ رَسُولًا ۚ كَذَٰلِكَ يُضِلُّ اللَّهُ مَنْ هُوَ مُسْرِفٌ مُرْتَابٌ",
  },
  {
    id: "4168",
    sura: "40",
    VerseIDAr: "35",
    ayatAR:
      "الَّذِينَ يُجَادِلُونَ فِي آيَاتِ اللَّهِ بِغَيْرِ سُلْطَانٍ أَتَاهُمْ ۖ كَبُرَ مَقْتًا عِنْدَ اللَّهِ وَعِنْدَ الَّذِينَ آمَنُوا ۚ كَذَٰلِكَ يَطْبَعُ اللَّهُ عَلَىٰ كُلِّ قَلْبِ مُتَكَبِّرٍ جَبَّارٍ",
  },
  {
    id: "4169",
    sura: "40",
    VerseIDAr: "36",
    ayatAR:
      "وَقَالَ فِرْعَوْنُ يَا هَامَانُ ابْنِ لِي صَرْحًا لَعَلِّي أَبْلُغُ الْأَسْبَابَ",
  },
  {
    id: "4170",
    sura: "40",
    VerseIDAr: "37",
    ayatAR:
      "أَسْبَابَ السَّمَاوَاتِ فَأَطَّلِعَ إِلَىٰ إِلَٰهِ مُوسَىٰ وَإِنِّي لَأَظُنُّهُ كَاذِبًا ۚ وَكَذَٰلِكَ زُيِّنَ لِفِرْعَوْنَ سُوءُ عَمَلِهِ وَصُدَّ عَنِ السَّبِيلِ ۚ وَمَا كَيْدُ فِرْعَوْنَ إِلَّا فِي تَبَابٍ",
  },
  {
    id: "4171",
    sura: "40",
    VerseIDAr: "38",
    ayatAR:
      "وَقَالَ الَّذِي آمَنَ يَا قَوْمِ اتَّبِعُونِ أَهْدِكُمْ سَبِيلَ الرَّشَادِ",
  },
  {
    id: "4172",
    sura: "40",
    VerseIDAr: "39",
    ayatAR:
      "يَا قَوْمِ إِنَّمَا هَٰذِهِ الْحَيَاةُ الدُّنْيَا مَتَاعٌ وَإِنَّ الْآخِرَةَ هِيَ دَارُ الْقَرَارِ",
  },
  {
    id: "4173",
    sura: "40",
    VerseIDAr: "40",
    ayatAR:
      "مَنْ عَمِلَ سَيِّئَةً فَلَا يُجْزَىٰ إِلَّا مِثْلَهَا ۖ وَمَنْ عَمِلَ صَالِحًا مِنْ ذَكَرٍ أَوْ أُنْثَىٰ وَهُوَ مُؤْمِنٌ فَأُولَٰئِكَ يَدْخُلُونَ الْجَنَّةَ يُرْزَقُونَ فِيهَا بِغَيْرِ حِسَابٍ",
  },
  {
    id: "4174",
    sura: "40",
    VerseIDAr: "41",
    ayatAR:
      "وَيَا قَوْمِ مَا لِي أَدْعُوكُمْ إِلَى النَّجَاةِ وَتَدْعُونَنِي إِلَى النَّارِ",
  },
  {
    id: "4175",
    sura: "40",
    VerseIDAr: "42",
    ayatAR:
      "تَدْعُونَنِي لِأَكْفُرَ بِاللَّهِ وَأُشْرِكَ بِهِ مَا لَيْسَ لِي بِهِ عِلْمٌ وَأَنَا أَدْعُوكُمْ إِلَى الْعَزِيزِ الْغَفَّارِ",
  },
  {
    id: "4176",
    sura: "40",
    VerseIDAr: "43",
    ayatAR:
      "لَا جَرَمَ أَنَّمَا تَدْعُونَنِي إِلَيْهِ لَيْسَ لَهُ دَعْوَةٌ فِي الدُّنْيَا وَلَا فِي الْآخِرَةِ وَأَنَّ مَرَدَّنَا إِلَى اللَّهِ وَأَنَّ الْمُسْرِفِينَ هُمْ أَصْحَابُ النَّارِ",
  },
  {
    id: "4177",
    sura: "40",
    VerseIDAr: "44",
    ayatAR:
      "فَسَتَذْكُرُونَ مَا أَقُولُ لَكُمْ ۚ وَأُفَوِّضُ أَمْرِي إِلَى اللَّهِ ۚ إِنَّ اللَّهَ بَصِيرٌ بِالْعِبَادِ",
  },
  {
    id: "4178",
    sura: "40",
    VerseIDAr: "45",
    ayatAR:
      "فَوَقَاهُ اللَّهُ سَيِّئَاتِ مَا مَكَرُوا ۖ وَحَاقَ بِآلِ فِرْعَوْنَ سُوءُ الْعَذَابِ",
  },
  {
    id: "4179",
    sura: "40",
    VerseIDAr: "46",
    ayatAR:
      "النَّارُ يُعْرَضُونَ عَلَيْهَا غُدُوًّا وَعَشِيًّا ۖ وَيَوْمَ تَقُومُ السَّاعَةُ أَدْخِلُوا آلَ فِرْعَوْنَ أَشَدَّ الْعَذَابِ",
  },
  {
    id: "4180",
    sura: "40",
    VerseIDAr: "47",
    ayatAR:
      "وَإِذْ يَتَحَاجُّونَ فِي النَّارِ فَيَقُولُ الضُّعَفَاءُ لِلَّذِينَ اسْتَكْبَرُوا إِنَّا كُنَّا لَكُمْ تَبَعًا فَهَلْ أَنْتُمْ مُغْنُونَ عَنَّا نَصِيبًا مِنَ النَّارِ",
  },
  {
    id: "4181",
    sura: "40",
    VerseIDAr: "48",
    ayatAR:
      "قَالَ الَّذِينَ اسْتَكْبَرُوا إِنَّا كُلٌّ فِيهَا إِنَّ اللَّهَ قَدْ حَكَمَ بَيْنَ الْعِبَادِ",
  },
  {
    id: "4182",
    sura: "40",
    VerseIDAr: "49",
    ayatAR:
      "وَقَالَ الَّذِينَ فِي النَّارِ لِخَزَنَةِ جَهَنَّمَ ادْعُوا رَبَّكُمْ يُخَفِّفْ عَنَّا يَوْمًا مِنَ الْعَذَابِ",
  },
  {
    id: "4183",
    sura: "40",
    VerseIDAr: "50",
    ayatAR:
      "قَالُوا أَوَلَمْ تَكُ تَأْتِيكُمْ رُسُلُكُمْ بِالْبَيِّنَاتِ ۖ قَالُوا بَلَىٰ ۚ قَالُوا فَادْعُوا ۗ وَمَا دُعَاءُ الْكَافِرِينَ إِلَّا فِي ضَلَالٍ",
  },
  {
    id: "4184",
    sura: "40",
    VerseIDAr: "51",
    ayatAR:
      "إِنَّا لَنَنْصُرُ رُسُلَنَا وَالَّذِينَ آمَنُوا فِي الْحَيَاةِ الدُّنْيَا وَيَوْمَ يَقُومُ الْأَشْهَادُ",
  },
  {
    id: "4185",
    sura: "40",
    VerseIDAr: "52",
    ayatAR:
      "يَوْمَ لَا يَنْفَعُ الظَّالِمِينَ مَعْذِرَتُهُمْ ۖ وَلَهُمُ اللَّعْنَةُ وَلَهُمْ سُوءُ الدَّارِ",
  },
  {
    id: "4186",
    sura: "40",
    VerseIDAr: "53",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْهُدَىٰ وَأَوْرَثْنَا بَنِي إِسْرَائِيلَ الْكِتَابَ",
  },
  {
    id: "4187",
    sura: "40",
    VerseIDAr: "54",
    ayatAR: "هُدًى وَذِكْرَىٰ لِأُولِي الْأَلْبَابِ",
  },
  {
    id: "4188",
    sura: "40",
    VerseIDAr: "55",
    ayatAR:
      "فَاصْبِرْ إِنَّ وَعْدَ اللَّهِ حَقٌّ وَاسْتَغْفِرْ لِذَنْبِكَ وَسَبِّحْ بِحَمْدِ رَبِّكَ بِالْعَشِيِّ وَالْإِبْكَارِ",
  },
  {
    id: "4189",
    sura: "40",
    VerseIDAr: "56",
    ayatAR:
      "إِنَّ الَّذِينَ يُجَادِلُونَ فِي آيَاتِ اللَّهِ بِغَيْرِ سُلْطَانٍ أَتَاهُمْ ۙ إِنْ فِي صُدُورِهِمْ إِلَّا كِبْرٌ مَا هُمْ بِبَالِغِيهِ ۚ فَاسْتَعِذْ بِاللَّهِ ۖ إِنَّهُ هُوَ السَّمِيعُ الْبَصِيرُ",
  },
  {
    id: "4190",
    sura: "40",
    VerseIDAr: "57",
    ayatAR:
      "لَخَلْقُ السَّمَاوَاتِ وَالْأَرْضِ أَكْبَرُ مِنْ خَلْقِ النَّاسِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "4191",
    sura: "40",
    VerseIDAr: "58",
    ayatAR:
      "وَمَا يَسْتَوِي الْأَعْمَىٰ وَالْبَصِيرُ وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَلَا الْمُسِيءُ ۚ قَلِيلًا مَا تَتَذَكَّرُونَ",
  },
  {
    id: "4192",
    sura: "40",
    VerseIDAr: "59",
    ayatAR:
      "إِنَّ السَّاعَةَ لَآتِيَةٌ لَا رَيْبَ فِيهَا وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يُؤْمِنُونَ",
  },
  {
    id: "4193",
    sura: "40",
    VerseIDAr: "60",
    ayatAR:
      "وَقَالَ رَبُّكُمُ ادْعُونِي أَسْتَجِبْ لَكُمْ ۚ إِنَّ الَّذِينَ يَسْتَكْبِرُونَ عَنْ عِبَادَتِي سَيَدْخُلُونَ جَهَنَّمَ دَاخِرِينَ",
  },
  {
    id: "4194",
    sura: "40",
    VerseIDAr: "61",
    ayatAR:
      "اللَّهُ الَّذِي جَعَلَ لَكُمُ اللَّيْلَ لِتَسْكُنُوا فِيهِ وَالنَّهَارَ مُبْصِرًا ۚ إِنَّ اللَّهَ لَذُو فَضْلٍ عَلَى النَّاسِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَشْكُرُونَ",
  },
  {
    id: "4195",
    sura: "40",
    VerseIDAr: "62",
    ayatAR:
      "ذَٰلِكُمُ اللَّهُ رَبُّكُمْ خَالِقُ كُلِّ شَيْءٍ لَا إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُؤْفَكُونَ",
  },
  {
    id: "4196",
    sura: "40",
    VerseIDAr: "63",
    ayatAR: "كَذَٰلِكَ يُؤْفَكُ الَّذِينَ كَانُوا بِآيَاتِ اللَّهِ يَجْحَدُونَ",
  },
  {
    id: "4197",
    sura: "40",
    VerseIDAr: "64",
    ayatAR:
      "اللَّهُ الَّذِي جَعَلَ لَكُمُ الْأَرْضَ قَرَارًا وَالسَّمَاءَ بِنَاءً وَصَوَّرَكُمْ فَأَحْسَنَ صُوَرَكُمْ وَرَزَقَكُمْ مِنَ الطَّيِّبَاتِ ۚ ذَٰلِكُمُ اللَّهُ رَبُّكُمْ ۖ فَتَبَارَكَ اللَّهُ رَبُّ الْعَالَمِينَ",
  },
  {
    id: "4198",
    sura: "40",
    VerseIDAr: "65",
    ayatAR:
      "هُوَ الْحَيُّ لَا إِلَٰهَ إِلَّا هُوَ فَادْعُوهُ مُخْلِصِينَ لَهُ الدِّينَ ۗ الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "4199",
    sura: "40",
    VerseIDAr: "66",
    ayatAR:
      "قُلْ إِنِّي نُهِيتُ أَنْ أَعْبُدَ الَّذِينَ تَدْعُونَ مِنْ دُونِ اللَّهِ لَمَّا جَاءَنِيَ الْبَيِّنَاتُ مِنْ رَبِّي وَأُمِرْتُ أَنْ أُسْلِمَ لِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "4200",
    sura: "40",
    VerseIDAr: "67",
    ayatAR:
      "هُوَ الَّذِي خَلَقَكُمْ مِنْ تُرَابٍ ثُمَّ مِنْ نُطْفَةٍ ثُمَّ مِنْ عَلَقَةٍ ثُمَّ يُخْرِجُكُمْ طِفْلًا ثُمَّ لِتَبْلُغُوا أَشُدَّكُمْ ثُمَّ لِتَكُونُوا شُيُوخًا ۚ وَمِنْكُمْ مَنْ يُتَوَفَّىٰ مِنْ قَبْلُ ۖ وَلِتَبْلُغُوا أَجَلًا مُسَمًّى وَلَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "4201",
    sura: "40",
    VerseIDAr: "68",
    ayatAR:
      "هُوَ الَّذِي يُحْيِي وَيُمِيتُ ۖ فَإِذَا قَضَىٰ أَمْرًا فَإِنَّمَا يَقُولُ لَهُ كُنْ فَيَكُونُ",
  },
  {
    id: "4202",
    sura: "40",
    VerseIDAr: "69",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ يُجَادِلُونَ فِي آيَاتِ اللَّهِ أَنَّىٰ يُصْرَفُونَ",
  },
  {
    id: "4203",
    sura: "40",
    VerseIDAr: "70",
    ayatAR:
      "الَّذِينَ كَذَّبُوا بِالْكِتَابِ وَبِمَا أَرْسَلْنَا بِهِ رُسُلَنَا ۖ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "4204",
    sura: "40",
    VerseIDAr: "71",
    ayatAR: "إِذِ الْأَغْلَالُ فِي أَعْنَاقِهِمْ وَالسَّلَاسِلُ يُسْحَبُونَ",
  },
  {
    id: "4205",
    sura: "40",
    VerseIDAr: "72",
    ayatAR: "فِي الْحَمِيمِ ثُمَّ فِي النَّارِ يُسْجَرُونَ",
  },
  {
    id: "4206",
    sura: "40",
    VerseIDAr: "73",
    ayatAR: "ثُمَّ قِيلَ لَهُمْ أَيْنَ مَا كُنْتُمْ تُشْرِكُونَ",
  },
  {
    id: "4207",
    sura: "40",
    VerseIDAr: "74",
    ayatAR:
      "مِنْ دُونِ اللَّهِ ۖ قَالُوا ضَلُّوا عَنَّا بَلْ لَمْ نَكُنْ نَدْعُو مِنْ قَبْلُ شَيْئًا ۚ كَذَٰلِكَ يُضِلُّ اللَّهُ الْكَافِرِينَ",
  },
  {
    id: "4208",
    sura: "40",
    VerseIDAr: "75",
    ayatAR:
      "ذَٰلِكُمْ بِمَا كُنْتُمْ تَفْرَحُونَ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ وَبِمَا كُنْتُمْ تَمْرَحُونَ",
  },
  {
    id: "4209",
    sura: "40",
    VerseIDAr: "76",
    ayatAR:
      "ادْخُلُوا أَبْوَابَ جَهَنَّمَ خَالِدِينَ فِيهَا ۖ فَبِئْسَ مَثْوَى الْمُتَكَبِّرِينَ",
  },
  {
    id: "4210",
    sura: "40",
    VerseIDAr: "77",
    ayatAR:
      "فَاصْبِرْ إِنَّ وَعْدَ اللَّهِ حَقٌّ ۚ فَإِمَّا نُرِيَنَّكَ بَعْضَ الَّذِي نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِلَيْنَا يُرْجَعُونَ",
  },
  {
    id: "4211",
    sura: "40",
    VerseIDAr: "78",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا رُسُلًا مِنْ قَبْلِكَ مِنْهُمْ مَنْ قَصَصْنَا عَلَيْكَ وَمِنْهُمْ مَنْ لَمْ نَقْصُصْ عَلَيْكَ ۗ وَمَا كَانَ لِرَسُولٍ أَنْ يَأْتِيَ بِآيَةٍ إِلَّا بِإِذْنِ اللَّهِ ۚ فَإِذَا جَاءَ أَمْرُ اللَّهِ قُضِيَ بِالْحَقِّ وَخَسِرَ هُنَالِكَ الْمُبْطِلُونَ",
  },
  {
    id: "4212",
    sura: "40",
    VerseIDAr: "79",
    ayatAR:
      "اللَّهُ الَّذِي جَعَلَ لَكُمُ الْأَنْعَامَ لِتَرْكَبُوا مِنْهَا وَمِنْهَا تَأْكُلُونَ",
  },
  {
    id: "4213",
    sura: "40",
    VerseIDAr: "80",
    ayatAR:
      "وَلَكُمْ فِيهَا مَنَافِعُ وَلِتَبْلُغُوا عَلَيْهَا حَاجَةً فِي صُدُورِكُمْ وَعَلَيْهَا وَعَلَى الْفُلْكِ تُحْمَلُونَ",
  },
  {
    id: "4214",
    sura: "40",
    VerseIDAr: "81",
    ayatAR: "وَيُرِيكُمْ آيَاتِهِ فَأَيَّ آيَاتِ اللَّهِ تُنْكِرُونَ",
  },
  {
    id: "4215",
    sura: "40",
    VerseIDAr: "82",
    ayatAR:
      "أَفَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلِهِمْ ۚ كَانُوا أَكْثَرَ مِنْهُمْ وَأَشَدَّ قُوَّةً وَآثَارًا فِي الْأَرْضِ فَمَا أَغْنَىٰ عَنْهُمْ مَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "4216",
    sura: "40",
    VerseIDAr: "83",
    ayatAR:
      "فَلَمَّا جَاءَتْهُمْ رُسُلُهُمْ بِالْبَيِّنَاتِ فَرِحُوا بِمَا عِنْدَهُمْ مِنَ الْعِلْمِ وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "4217",
    sura: "40",
    VerseIDAr: "84",
    ayatAR:
      "فَلَمَّا رَأَوْا بَأْسَنَا قَالُوا آمَنَّا بِاللَّهِ وَحْدَهُ وَكَفَرْنَا بِمَا كُنَّا بِهِ مُشْرِكِينَ",
  },
  {
    id: "4218",
    sura: "40",
    VerseIDAr: "85",
    ayatAR:
      "فَلَمْ يَكُ يَنْفَعُهُمْ إِيمَانُهُمْ لَمَّا رَأَوْا بَأْسَنَا ۖ سُنَّتَ اللَّهِ الَّتِي قَدْ خَلَتْ فِي عِبَادِهِ ۖ وَخَسِرَ هُنَالِكَ الْكَافِرُونَ",
  },
  {
    id: "4219",
    sura: "41",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  {
    id: "4220",
    sura: "41",
    VerseIDAr: "2",
    ayatAR: "تَنْزِيلٌ مِنَ الرَّحْمَٰنِ الرَّحِيمِ",
  },
  {
    id: "4221",
    sura: "41",
    VerseIDAr: "3",
    ayatAR:
      "كِتَابٌ فُصِّلَتْ آيَاتُهُ قُرْآنًا عَرَبِيًّا لِقَوْمٍ يَعْلَمُونَ",
  },
  {
    id: "4222",
    sura: "41",
    VerseIDAr: "4",
    ayatAR:
      "بَشِيرًا وَنَذِيرًا فَأَعْرَضَ أَكْثَرُهُمْ فَهُمْ لَا يَسْمَعُونَ",
  },
  {
    id: "4223",
    sura: "41",
    VerseIDAr: "5",
    ayatAR:
      "وَقَالُوا قُلُوبُنَا فِي أَكِنَّةٍ مِمَّا تَدْعُونَا إِلَيْهِ وَفِي آذَانِنَا وَقْرٌ وَمِنْ بَيْنِنَا وَبَيْنِكَ حِجَابٌ فَاعْمَلْ إِنَّنَا عَامِلُونَ",
  },
  {
    id: "4224",
    sura: "41",
    VerseIDAr: "6",
    ayatAR:
      "قُلْ إِنَّمَا أَنَا بَشَرٌ مِثْلُكُمْ يُوحَىٰ إِلَيَّ أَنَّمَا إِلَٰهُكُمْ إِلَٰهٌ وَاحِدٌ فَاسْتَقِيمُوا إِلَيْهِ وَاسْتَغْفِرُوهُ ۗ وَوَيْلٌ لِلْمُشْرِكِينَ",
  },
  {
    id: "4225",
    sura: "41",
    VerseIDAr: "7",
    ayatAR:
      "الَّذِينَ لَا يُؤْتُونَ الزَّكَاةَ وَهُمْ بِالْآخِرَةِ هُمْ كَافِرُونَ",
  },
  {
    id: "4226",
    sura: "41",
    VerseIDAr: "8",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍ",
  },
  {
    id: "4227",
    sura: "41",
    VerseIDAr: "9",
    ayatAR:
      "قُلْ أَئِنَّكُمْ لَتَكْفُرُونَ بِالَّذِي خَلَقَ الْأَرْضَ فِي يَوْمَيْنِ وَتَجْعَلُونَ لَهُ أَنْدَادًا ۚ ذَٰلِكَ رَبُّ الْعَالَمِينَ",
  },
  {
    id: "4228",
    sura: "41",
    VerseIDAr: "10",
    ayatAR:
      "وَجَعَلَ فِيهَا رَوَاسِيَ مِنْ فَوْقِهَا وَبَارَكَ فِيهَا وَقَدَّرَ فِيهَا أَقْوَاتَهَا فِي أَرْبَعَةِ أَيَّامٍ سَوَاءً لِلسَّائِلِينَ",
  },
  {
    id: "4229",
    sura: "41",
    VerseIDAr: "11",
    ayatAR:
      "ثُمَّ اسْتَوَىٰ إِلَى السَّمَاءِ وَهِيَ دُخَانٌ فَقَالَ لَهَا وَلِلْأَرْضِ ائْتِيَا طَوْعًا أَوْ كَرْهًا قَالَتَا أَتَيْنَا طَائِعِينَ",
  },
  {
    id: "4230",
    sura: "41",
    VerseIDAr: "12",
    ayatAR:
      "فَقَضَاهُنَّ سَبْعَ سَمَاوَاتٍ فِي يَوْمَيْنِ وَأَوْحَىٰ فِي كُلِّ سَمَاءٍ أَمْرَهَا ۚ وَزَيَّنَّا السَّمَاءَ الدُّنْيَا بِمَصَابِيحَ وَحِفْظًا ۚ ذَٰلِكَ تَقْدِيرُ الْعَزِيزِ الْعَلِيمِ",
  },
  {
    id: "4231",
    sura: "41",
    VerseIDAr: "13",
    ayatAR:
      "فَإِنْ أَعْرَضُوا فَقُلْ أَنْذَرْتُكُمْ صَاعِقَةً مِثْلَ صَاعِقَةِ عَادٍ وَثَمُودَ",
  },
  {
    id: "4232",
    sura: "41",
    VerseIDAr: "14",
    ayatAR:
      "إِذْ جَاءَتْهُمُ الرُّسُلُ مِنْ بَيْنِ أَيْدِيهِمْ وَمِنْ خَلْفِهِمْ أَلَّا تَعْبُدُوا إِلَّا اللَّهَ ۖ قَالُوا لَوْ شَاءَ رَبُّنَا لَأَنْزَلَ مَلَائِكَةً فَإِنَّا بِمَا أُرْسِلْتُمْ بِهِ كَافِرُونَ",
  },
  {
    id: "4233",
    sura: "41",
    VerseIDAr: "15",
    ayatAR:
      "فَأَمَّا عَادٌ فَاسْتَكْبَرُوا فِي الْأَرْضِ بِغَيْرِ الْحَقِّ وَقَالُوا مَنْ أَشَدُّ مِنَّا قُوَّةً ۖ أَوَلَمْ يَرَوْا أَنَّ اللَّهَ الَّذِي خَلَقَهُمْ هُوَ أَشَدُّ مِنْهُمْ قُوَّةً ۖ وَكَانُوا بِآيَاتِنَا يَجْحَدُونَ",
  },
  {
    id: "4234",
    sura: "41",
    VerseIDAr: "16",
    ayatAR:
      "فَأَرْسَلْنَا عَلَيْهِمْ رِيحًا صَرْصَرًا فِي أَيَّامٍ نَحِسَاتٍ لِنُذِيقَهُمْ عَذَابَ الْخِزْيِ فِي الْحَيَاةِ الدُّنْيَا ۖ وَلَعَذَابُ الْآخِرَةِ أَخْزَىٰ ۖ وَهُمْ لَا يُنْصَرُونَ",
  },
  {
    id: "4235",
    sura: "41",
    VerseIDAr: "17",
    ayatAR:
      "وَأَمَّا ثَمُودُ فَهَدَيْنَاهُمْ فَاسْتَحَبُّوا الْعَمَىٰ عَلَى الْهُدَىٰ فَأَخَذَتْهُمْ صَاعِقَةُ الْعَذَابِ الْهُونِ بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "4236",
    sura: "41",
    VerseIDAr: "18",
    ayatAR: "وَنَجَّيْنَا الَّذِينَ آمَنُوا وَكَانُوا يَتَّقُونَ",
  },
  {
    id: "4237",
    sura: "41",
    VerseIDAr: "19",
    ayatAR:
      "وَيَوْمَ يُحْشَرُ أَعْدَاءُ اللَّهِ إِلَى النَّارِ فَهُمْ يُوزَعُونَ",
  },
  {
    id: "4238",
    sura: "41",
    VerseIDAr: "20",
    ayatAR:
      "حَتَّىٰ إِذَا مَا جَاءُوهَا شَهِدَ عَلَيْهِمْ سَمْعُهُمْ وَأَبْصَارُهُمْ وَجُلُودُهُمْ بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "4239",
    sura: "41",
    VerseIDAr: "21",
    ayatAR:
      "وَقَالُوا لِجُلُودِهِمْ لِمَ شَهِدْتُمْ عَلَيْنَا ۖ قَالُوا أَنْطَقَنَا اللَّهُ الَّذِي أَنْطَقَ كُلَّ شَيْءٍ وَهُوَ خَلَقَكُمْ أَوَّلَ مَرَّةٍ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "4240",
    sura: "41",
    VerseIDAr: "22",
    ayatAR:
      "وَمَا كُنْتُمْ تَسْتَتِرُونَ أَنْ يَشْهَدَ عَلَيْكُمْ سَمْعُكُمْ وَلَا أَبْصَارُكُمْ وَلَا جُلُودُكُمْ وَلَٰكِنْ ظَنَنْتُمْ أَنَّ اللَّهَ لَا يَعْلَمُ كَثِيرًا مِمَّا تَعْمَلُونَ",
  },
  {
    id: "4241",
    sura: "41",
    VerseIDAr: "23",
    ayatAR:
      "وَذَٰلِكُمْ ظَنُّكُمُ الَّذِي ظَنَنْتُمْ بِرَبِّكُمْ أَرْدَاكُمْ فَأَصْبَحْتُمْ مِنَ الْخَاسِرِينَ",
  },
  {
    id: "4242",
    sura: "41",
    VerseIDAr: "24",
    ayatAR:
      "فَإِنْ يَصْبِرُوا فَالنَّارُ مَثْوًى لَهُمْ ۖ وَإِنْ يَسْتَعْتِبُوا فَمَا هُمْ مِنَ الْمُعْتَبِينَ",
  },
  {
    id: "4243",
    sura: "41",
    VerseIDAr: "25",
    ayatAR:
      "وَقَيَّضْنَا لَهُمْ قُرَنَاءَ فَزَيَّنُوا لَهُمْ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَحَقَّ عَلَيْهِمُ الْقَوْلُ فِي أُمَمٍ قَدْ خَلَتْ مِنْ قَبْلِهِمْ مِنَ الْجِنِّ وَالْإِنْسِ ۖ إِنَّهُمْ كَانُوا خَاسِرِينَ",
  },
  {
    id: "4244",
    sura: "41",
    VerseIDAr: "26",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لَا تَسْمَعُوا لِهَٰذَا الْقُرْآنِ وَالْغَوْا فِيهِ لَعَلَّكُمْ تَغْلِبُونَ",
  },
  {
    id: "4245",
    sura: "41",
    VerseIDAr: "27",
    ayatAR:
      "فَلَنُذِيقَنَّ الَّذِينَ كَفَرُوا عَذَابًا شَدِيدًا وَلَنَجْزِيَنَّهُمْ أَسْوَأَ الَّذِي كَانُوا يَعْمَلُونَ",
  },
  {
    id: "4246",
    sura: "41",
    VerseIDAr: "28",
    ayatAR:
      "ذَٰلِكَ جَزَاءُ أَعْدَاءِ اللَّهِ النَّارُ ۖ لَهُمْ فِيهَا دَارُ الْخُلْدِ ۖ جَزَاءً بِمَا كَانُوا بِآيَاتِنَا يَجْحَدُونَ",
  },
  {
    id: "4247",
    sura: "41",
    VerseIDAr: "29",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا رَبَّنَا أَرِنَا اللَّذَيْنِ أَضَلَّانَا مِنَ الْجِنِّ وَالْإِنْسِ نَجْعَلْهُمَا تَحْتَ أَقْدَامِنَا لِيَكُونَا مِنَ الْأَسْفَلِينَ",
  },
  {
    id: "4248",
    sura: "41",
    VerseIDAr: "30",
    ayatAR:
      "إِنَّ الَّذِينَ قَالُوا رَبُّنَا اللَّهُ ثُمَّ اسْتَقَامُوا تَتَنَزَّلُ عَلَيْهِمُ الْمَلَائِكَةُ أَلَّا تَخَافُوا وَلَا تَحْزَنُوا وَأَبْشِرُوا بِالْجَنَّةِ الَّتِي كُنْتُمْ تُوعَدُونَ",
  },
  {
    id: "4249",
    sura: "41",
    VerseIDAr: "31",
    ayatAR:
      "نَحْنُ أَوْلِيَاؤُكُمْ فِي الْحَيَاةِ الدُّنْيَا وَفِي الْآخِرَةِ ۖ وَلَكُمْ فِيهَا مَا تَشْتَهِي أَنْفُسُكُمْ وَلَكُمْ فِيهَا مَا تَدَّعُونَ",
  },
  {
    id: "4250",
    sura: "41",
    VerseIDAr: "32",
    ayatAR: "نُزُلًا مِنْ غَفُورٍ رَحِيمٍ",
  },
  {
    id: "4251",
    sura: "41",
    VerseIDAr: "33",
    ayatAR:
      "وَمَنْ أَحْسَنُ قَوْلًا مِمَّنْ دَعَا إِلَى اللَّهِ وَعَمِلَ صَالِحًا وَقَالَ إِنَّنِي مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "4252",
    sura: "41",
    VerseIDAr: "34",
    ayatAR:
      "وَلَا تَسْتَوِي الْحَسَنَةُ وَلَا السَّيِّئَةُ ۚ ادْفَعْ بِالَّتِي هِيَ أَحْسَنُ فَإِذَا الَّذِي بَيْنَكَ وَبَيْنَهُ عَدَاوَةٌ كَأَنَّهُ وَلِيٌّ حَمِيمٌ",
  },
  {
    id: "4253",
    sura: "41",
    VerseIDAr: "35",
    ayatAR:
      "وَمَا يُلَقَّاهَا إِلَّا الَّذِينَ صَبَرُوا وَمَا يُلَقَّاهَا إِلَّا ذُو حَظٍّ عَظِيمٍ",
  },
  {
    id: "4254",
    sura: "41",
    VerseIDAr: "36",
    ayatAR:
      "وَإِمَّا يَنْزَغَنَّكَ مِنَ الشَّيْطَانِ نَزْغٌ فَاسْتَعِذْ بِاللَّهِ ۖ إِنَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "4255",
    sura: "41",
    VerseIDAr: "37",
    ayatAR:
      "وَمِنْ آيَاتِهِ اللَّيْلُ وَالنَّهَارُ وَالشَّمْسُ وَالْقَمَرُ ۚ لَا تَسْجُدُوا لِلشَّمْسِ وَلَا لِلْقَمَرِ وَاسْجُدُوا لِلَّهِ الَّذِي خَلَقَهُنَّ إِنْ كُنْتُمْ إِيَّاهُ تَعْبُدُونَ",
  },
  {
    id: "4256",
    sura: "41",
    VerseIDAr: "38",
    ayatAR:
      "فَإِنِ اسْتَكْبَرُوا فَالَّذِينَ عِنْدَ رَبِّكَ يُسَبِّحُونَ لَهُ بِاللَّيْلِ وَالنَّهَارِ وَهُمْ لَا يَسْأَمُونَ ۩",
  },
  {
    id: "4257",
    sura: "41",
    VerseIDAr: "39",
    ayatAR:
      "وَمِنْ آيَاتِهِ أَنَّكَ تَرَى الْأَرْضَ خَاشِعَةً فَإِذَا أَنْزَلْنَا عَلَيْهَا الْمَاءَ اهْتَزَّتْ وَرَبَتْ ۚ إِنَّ الَّذِي أَحْيَاهَا لَمُحْيِي الْمَوْتَىٰ ۚ إِنَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "4258",
    sura: "41",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّ الَّذِينَ يُلْحِدُونَ فِي آيَاتِنَا لَا يَخْفَوْنَ عَلَيْنَا ۗ أَفَمَنْ يُلْقَىٰ فِي النَّارِ خَيْرٌ أَمْ مَنْ يَأْتِي آمِنًا يَوْمَ الْقِيَامَةِ ۚ اعْمَلُوا مَا شِئْتُمْ ۖ إِنَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "4259",
    sura: "41",
    VerseIDAr: "41",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا بِالذِّكْرِ لَمَّا جَاءَهُمْ ۖ وَإِنَّهُ لَكِتَابٌ عَزِيزٌ",
  },
  {
    id: "4260",
    sura: "41",
    VerseIDAr: "42",
    ayatAR:
      "لَا يَأْتِيهِ الْبَاطِلُ مِنْ بَيْنِ يَدَيْهِ وَلَا مِنْ خَلْفِهِ ۖ تَنْزِيلٌ مِنْ حَكِيمٍ حَمِيدٍ",
  },
  {
    id: "4261",
    sura: "41",
    VerseIDAr: "43",
    ayatAR:
      "مَا يُقَالُ لَكَ إِلَّا مَا قَدْ قِيلَ لِلرُّسُلِ مِنْ قَبْلِكَ ۚ إِنَّ رَبَّكَ لَذُو مَغْفِرَةٍ وَذُو عِقَابٍ أَلِيمٍ",
  },
  {
    id: "4262",
    sura: "41",
    VerseIDAr: "44",
    ayatAR:
      "وَلَوْ جَعَلْنَاهُ قُرْآنًا أَعْجَمِيًّا لَقَالُوا لَوْلَا فُصِّلَتْ آيَاتُهُ ۖ أَأَعْجَمِيٌّ وَعَرَبِيٌّ ۗ قُلْ هُوَ لِلَّذِينَ آمَنُوا هُدًى وَشِفَاءٌ ۖ وَالَّذِينَ لَا يُؤْمِنُونَ فِي آذَانِهِمْ وَقْرٌ وَهُوَ عَلَيْهِمْ عَمًى ۚ أُولَٰئِكَ يُنَادَوْنَ مِنْ مَكَانٍ بَعِيدٍ",
  },
  {
    id: "4263",
    sura: "41",
    VerseIDAr: "45",
    ayatAR:
      "وَلَقَدْ آتَيْنَا مُوسَى الْكِتَابَ فَاخْتُلِفَ فِيهِ ۗ وَلَوْلَا كَلِمَةٌ سَبَقَتْ مِنْ رَبِّكَ لَقُضِيَ بَيْنَهُمْ ۚ وَإِنَّهُمْ لَفِي شَكٍّ مِنْهُ مُرِيبٍ",
  },
  {
    id: "4264",
    sura: "41",
    VerseIDAr: "46",
    ayatAR:
      "مَنْ عَمِلَ صَالِحًا فَلِنَفْسِهِ ۖ وَمَنْ أَسَاءَ فَعَلَيْهَا ۗ وَمَا رَبُّكَ بِظَلَّامٍ لِلْعَبِيدِ",
  },
  {
    id: "4265",
    sura: "41",
    VerseIDAr: "47",
    ayatAR:
      "إِلَيْهِ يُرَدُّ عِلْمُ السَّاعَةِ ۚ وَمَا تَخْرُجُ مِنْ ثَمَرَاتٍ مِنْ أَكْمَامِهَا وَمَا تَحْمِلُ مِنْ أُنْثَىٰ وَلَا تَضَعُ إِلَّا بِعِلْمِهِ ۚ وَيَوْمَ يُنَادِيهِمْ أَيْنَ شُرَكَائِي قَالُوا آذَنَّاكَ مَا مِنَّا مِنْ شَهِيدٍ",
  },
  {
    id: "4266",
    sura: "41",
    VerseIDAr: "48",
    ayatAR:
      "وَضَلَّ عَنْهُمْ مَا كَانُوا يَدْعُونَ مِنْ قَبْلُ ۖ وَظَنُّوا مَا لَهُمْ مِنْ مَحِيصٍ",
  },
  {
    id: "4267",
    sura: "41",
    VerseIDAr: "49",
    ayatAR:
      "لَا يَسْأَمُ الْإِنْسَانُ مِنْ دُعَاءِ الْخَيْرِ وَإِنْ مَسَّهُ الشَّرُّ فَيَئُوسٌ قَنُوطٌ",
  },
  {
    id: "4268",
    sura: "41",
    VerseIDAr: "50",
    ayatAR:
      "وَلَئِنْ أَذَقْنَاهُ رَحْمَةً مِنَّا مِنْ بَعْدِ ضَرَّاءَ مَسَّتْهُ لَيَقُولَنَّ هَٰذَا لِي وَمَا أَظُنُّ السَّاعَةَ قَائِمَةً وَلَئِنْ رُجِعْتُ إِلَىٰ رَبِّي إِنَّ لِي عِنْدَهُ لَلْحُسْنَىٰ ۚ فَلَنُنَبِّئَنَّ الَّذِينَ كَفَرُوا بِمَا عَمِلُوا وَلَنُذِيقَنَّهُمْ مِنْ عَذَابٍ غَلِيظٍ",
  },
  {
    id: "4269",
    sura: "41",
    VerseIDAr: "51",
    ayatAR:
      "وَإِذَا أَنْعَمْنَا عَلَى الْإِنْسَانِ أَعْرَضَ وَنَأَىٰ بِجَانِبِهِ وَإِذَا مَسَّهُ الشَّرُّ فَذُو دُعَاءٍ عَرِيضٍ",
  },
  {
    id: "4270",
    sura: "41",
    VerseIDAr: "52",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ كَانَ مِنْ عِنْدِ اللَّهِ ثُمَّ كَفَرْتُمْ بِهِ مَنْ أَضَلُّ مِمَّنْ هُوَ فِي شِقَاقٍ بَعِيدٍ",
  },
  {
    id: "4271",
    sura: "41",
    VerseIDAr: "53",
    ayatAR:
      "سَنُرِيهِمْ آيَاتِنَا فِي الْآفَاقِ وَفِي أَنْفُسِهِمْ حَتَّىٰ يَتَبَيَّنَ لَهُمْ أَنَّهُ الْحَقُّ ۗ أَوَلَمْ يَكْفِ بِرَبِّكَ أَنَّهُ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "4272",
    sura: "41",
    VerseIDAr: "54",
    ayatAR:
      "أَلَا إِنَّهُمْ فِي مِرْيَةٍ مِنْ لِقَاءِ رَبِّهِمْ ۗ أَلَا إِنَّهُ بِكُلِّ شَيْءٍ مُحِيطٌ",
  },
  {
    id: "4273",
    sura: "42",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  { id: "4274", sura: "42", VerseIDAr: "2", ayatAR: "عسق" },
  {
    id: "4275",
    sura: "42",
    VerseIDAr: "3",
    ayatAR:
      "كَذَٰلِكَ يُوحِي إِلَيْكَ وَإِلَى الَّذِينَ مِنْ قَبْلِكَ اللَّهُ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "4276",
    sura: "42",
    VerseIDAr: "4",
    ayatAR:
      "لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۖ وَهُوَ الْعَلِيُّ الْعَظِيمُ",
  },
  {
    id: "4277",
    sura: "42",
    VerseIDAr: "5",
    ayatAR:
      "تَكَادُ السَّمَاوَاتُ يَتَفَطَّرْنَ مِنْ فَوْقِهِنَّ ۚ وَالْمَلَائِكَةُ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ وَيَسْتَغْفِرُونَ لِمَنْ فِي الْأَرْضِ ۗ أَلَا إِنَّ اللَّهَ هُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "4278",
    sura: "42",
    VerseIDAr: "6",
    ayatAR:
      "وَالَّذِينَ اتَّخَذُوا مِنْ دُونِهِ أَوْلِيَاءَ اللَّهُ حَفِيظٌ عَلَيْهِمْ وَمَا أَنْتَ عَلَيْهِمْ بِوَكِيلٍ",
  },
  {
    id: "4279",
    sura: "42",
    VerseIDAr: "7",
    ayatAR:
      "وَكَذَٰلِكَ أَوْحَيْنَا إِلَيْكَ قُرْآنًا عَرَبِيًّا لِتُنْذِرَ أُمَّ الْقُرَىٰ وَمَنْ حَوْلَهَا وَتُنْذِرَ يَوْمَ الْجَمْعِ لَا رَيْبَ فِيهِ ۚ فَرِيقٌ فِي الْجَنَّةِ وَفَرِيقٌ فِي السَّعِيرِ",
  },
  {
    id: "4280",
    sura: "42",
    VerseIDAr: "8",
    ayatAR:
      "وَلَوْ شَاءَ اللَّهُ لَجَعَلَهُمْ أُمَّةً وَاحِدَةً وَلَٰكِنْ يُدْخِلُ مَنْ يَشَاءُ فِي رَحْمَتِهِ ۚ وَالظَّالِمُونَ مَا لَهُمْ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "4281",
    sura: "42",
    VerseIDAr: "9",
    ayatAR:
      "أَمِ اتَّخَذُوا مِنْ دُونِهِ أَوْلِيَاءَ ۖ فَاللَّهُ هُوَ الْوَلِيُّ وَهُوَ يُحْيِي الْمَوْتَىٰ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "4282",
    sura: "42",
    VerseIDAr: "10",
    ayatAR:
      "وَمَا اخْتَلَفْتُمْ فِيهِ مِنْ شَيْءٍ فَحُكْمُهُ إِلَى اللَّهِ ۚ ذَٰلِكُمُ اللَّهُ رَبِّي عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ",
  },
  {
    id: "4283",
    sura: "42",
    VerseIDAr: "11",
    ayatAR:
      "فَاطِرُ السَّمَاوَاتِ وَالْأَرْضِ ۚ جَعَلَ لَكُمْ مِنْ أَنْفُسِكُمْ أَزْوَاجًا وَمِنَ الْأَنْعَامِ أَزْوَاجًا ۖ يَذْرَؤُكُمْ فِيهِ ۚ لَيْسَ كَمِثْلِهِ شَيْءٌ ۖ وَهُوَ السَّمِيعُ الْبَصِيرُ",
  },
  {
    id: "4284",
    sura: "42",
    VerseIDAr: "12",
    ayatAR:
      "لَهُ مَقَالِيدُ السَّمَاوَاتِ وَالْأَرْضِ ۖ يَبْسُطُ الرِّزْقَ لِمَنْ يَشَاءُ وَيَقْدِرُ ۚ إِنَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "4285",
    sura: "42",
    VerseIDAr: "13",
    ayatAR:
      "شَرَعَ لَكُمْ مِنَ الدِّينِ مَا وَصَّىٰ بِهِ نُوحًا وَالَّذِي أَوْحَيْنَا إِلَيْكَ وَمَا وَصَّيْنَا بِهِ إِبْرَاهِيمَ وَمُوسَىٰ وَعِيسَىٰ ۖ أَنْ أَقِيمُوا الدِّينَ وَلَا تَتَفَرَّقُوا فِيهِ ۚ كَبُرَ عَلَى الْمُشْرِكِينَ مَا تَدْعُوهُمْ إِلَيْهِ ۚ اللَّهُ يَجْتَبِي إِلَيْهِ مَنْ يَشَاءُ وَيَهْدِي إِلَيْهِ مَنْ يُنِيبُ",
  },
  {
    id: "4286",
    sura: "42",
    VerseIDAr: "14",
    ayatAR:
      "وَمَا تَفَرَّقُوا إِلَّا مِنْ بَعْدِ مَا جَاءَهُمُ الْعِلْمُ بَغْيًا بَيْنَهُمْ ۚ وَلَوْلَا كَلِمَةٌ سَبَقَتْ مِنْ رَبِّكَ إِلَىٰ أَجَلٍ مُسَمًّى لَقُضِيَ بَيْنَهُمْ ۚ وَإِنَّ الَّذِينَ أُورِثُوا الْكِتَابَ مِنْ بَعْدِهِمْ لَفِي شَكٍّ مِنْهُ مُرِيبٍ",
  },
  {
    id: "4287",
    sura: "42",
    VerseIDAr: "15",
    ayatAR:
      "فَلِذَٰلِكَ فَادْعُ ۖ وَاسْتَقِمْ كَمَا أُمِرْتَ ۖ وَلَا تَتَّبِعْ أَهْوَاءَهُمْ ۖ وَقُلْ آمَنْتُ بِمَا أَنْزَلَ اللَّهُ مِنْ كِتَابٍ ۖ وَأُمِرْتُ لِأَعْدِلَ بَيْنَكُمُ ۖ اللَّهُ رَبُّنَا وَرَبُّكُمْ ۖ لَنَا أَعْمَالُنَا وَلَكُمْ أَعْمَالُكُمْ ۖ لَا حُجَّةَ بَيْنَنَا وَبَيْنَكُمُ ۖ اللَّهُ يَجْمَعُ بَيْنَنَا ۖ وَإِلَيْهِ الْمَصِيرُ",
  },
  {
    id: "4288",
    sura: "42",
    VerseIDAr: "16",
    ayatAR:
      "وَالَّذِينَ يُحَاجُّونَ فِي اللَّهِ مِنْ بَعْدِ مَا اسْتُجِيبَ لَهُ حُجَّتُهُمْ دَاحِضَةٌ عِنْدَ رَبِّهِمْ وَعَلَيْهِمْ غَضَبٌ وَلَهُمْ عَذَابٌ شَدِيدٌ",
  },
  {
    id: "4289",
    sura: "42",
    VerseIDAr: "17",
    ayatAR:
      "اللَّهُ الَّذِي أَنْزَلَ الْكِتَابَ بِالْحَقِّ وَالْمِيزَانَ ۗ وَمَا يُدْرِيكَ لَعَلَّ السَّاعَةَ قَرِيبٌ",
  },
  {
    id: "4290",
    sura: "42",
    VerseIDAr: "18",
    ayatAR:
      "يَسْتَعْجِلُ بِهَا الَّذِينَ لَا يُؤْمِنُونَ بِهَا ۖ وَالَّذِينَ آمَنُوا مُشْفِقُونَ مِنْهَا وَيَعْلَمُونَ أَنَّهَا الْحَقُّ ۗ أَلَا إِنَّ الَّذِينَ يُمَارُونَ فِي السَّاعَةِ لَفِي ضَلَالٍ بَعِيدٍ",
  },
  {
    id: "4291",
    sura: "42",
    VerseIDAr: "19",
    ayatAR:
      "اللَّهُ لَطِيفٌ بِعِبَادِهِ يَرْزُقُ مَنْ يَشَاءُ ۖ وَهُوَ الْقَوِيُّ الْعَزِيزُ",
  },
  {
    id: "4292",
    sura: "42",
    VerseIDAr: "20",
    ayatAR:
      "مَنْ كَانَ يُرِيدُ حَرْثَ الْآخِرَةِ نَزِدْ لَهُ فِي حَرْثِهِ ۖ وَمَنْ كَانَ يُرِيدُ حَرْثَ الدُّنْيَا نُؤْتِهِ مِنْهَا وَمَا لَهُ فِي الْآخِرَةِ مِنْ نَصِيبٍ",
  },
  {
    id: "4293",
    sura: "42",
    VerseIDAr: "21",
    ayatAR:
      "أَمْ لَهُمْ شُرَكَاءُ شَرَعُوا لَهُمْ مِنَ الدِّينِ مَا لَمْ يَأْذَنْ بِهِ اللَّهُ ۚ وَلَوْلَا كَلِمَةُ الْفَصْلِ لَقُضِيَ بَيْنَهُمْ ۗ وَإِنَّ الظَّالِمِينَ لَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "4294",
    sura: "42",
    VerseIDAr: "22",
    ayatAR:
      "تَرَى الظَّالِمِينَ مُشْفِقِينَ مِمَّا كَسَبُوا وَهُوَ وَاقِعٌ بِهِمْ ۗ وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فِي رَوْضَاتِ الْجَنَّاتِ ۖ لَهُمْ مَا يَشَاءُونَ عِنْدَ رَبِّهِمْ ۚ ذَٰلِكَ هُوَ الْفَضْلُ الْكَبِيرُ",
  },
  {
    id: "4295",
    sura: "42",
    VerseIDAr: "23",
    ayatAR:
      "ذَٰلِكَ الَّذِي يُبَشِّرُ اللَّهُ عِبَادَهُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ ۗ قُلْ لَا أَسْأَلُكُمْ عَلَيْهِ أَجْرًا إِلَّا الْمَوَدَّةَ فِي الْقُرْبَىٰ ۗ وَمَنْ يَقْتَرِفْ حَسَنَةً نَزِدْ لَهُ فِيهَا حُسْنًا ۚ إِنَّ اللَّهَ غَفُورٌ شَكُورٌ",
  },
  {
    id: "4296",
    sura: "42",
    VerseIDAr: "24",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَىٰ عَلَى اللَّهِ كَذِبًا ۖ فَإِنْ يَشَإِ اللَّهُ يَخْتِمْ عَلَىٰ قَلْبِكَ ۗ وَيَمْحُ اللَّهُ الْبَاطِلَ وَيُحِقُّ الْحَقَّ بِكَلِمَاتِهِ ۚ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "4297",
    sura: "42",
    VerseIDAr: "25",
    ayatAR:
      "وَهُوَ الَّذِي يَقْبَلُ التَّوْبَةَ عَنْ عِبَادِهِ وَيَعْفُو عَنِ السَّيِّئَاتِ وَيَعْلَمُ مَا تَفْعَلُونَ",
  },
  {
    id: "4298",
    sura: "42",
    VerseIDAr: "26",
    ayatAR:
      "وَيَسْتَجِيبُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَيَزِيدُهُمْ مِنْ فَضْلِهِ ۚ وَالْكَافِرُونَ لَهُمْ عَذَابٌ شَدِيدٌ",
  },
  {
    id: "4299",
    sura: "42",
    VerseIDAr: "27",
    ayatAR:
      "وَلَوْ بَسَطَ اللَّهُ الرِّزْقَ لِعِبَادِهِ لَبَغَوْا فِي الْأَرْضِ وَلَٰكِنْ يُنَزِّلُ بِقَدَرٍ مَا يَشَاءُ ۚ إِنَّهُ بِعِبَادِهِ خَبِيرٌ بَصِيرٌ",
  },
  {
    id: "4300",
    sura: "42",
    VerseIDAr: "28",
    ayatAR:
      "وَهُوَ الَّذِي يُنَزِّلُ الْغَيْثَ مِنْ بَعْدِ مَا قَنَطُوا وَيَنْشُرُ رَحْمَتَهُ ۚ وَهُوَ الْوَلِيُّ الْحَمِيدُ",
  },
  {
    id: "4301",
    sura: "42",
    VerseIDAr: "29",
    ayatAR:
      "وَمِنْ آيَاتِهِ خَلْقُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَثَّ فِيهِمَا مِنْ دَابَّةٍ ۚ وَهُوَ عَلَىٰ جَمْعِهِمْ إِذَا يَشَاءُ قَدِيرٌ",
  },
  {
    id: "4302",
    sura: "42",
    VerseIDAr: "30",
    ayatAR:
      "وَمَا أَصَابَكُمْ مِنْ مُصِيبَةٍ فَبِمَا كَسَبَتْ أَيْدِيكُمْ وَيَعْفُو عَنْ كَثِيرٍ",
  },
  {
    id: "4303",
    sura: "42",
    VerseIDAr: "31",
    ayatAR:
      "وَمَا أَنْتُمْ بِمُعْجِزِينَ فِي الْأَرْضِ ۖ وَمَا لَكُمْ مِنْ دُونِ اللَّهِ مِنْ وَلِيٍّ وَلَا نَصِيرٍ",
  },
  {
    id: "4304",
    sura: "42",
    VerseIDAr: "32",
    ayatAR: "وَمِنْ آيَاتِهِ الْجَوَارِ فِي الْبَحْرِ كَالْأَعْلَامِ",
  },
  {
    id: "4305",
    sura: "42",
    VerseIDAr: "33",
    ayatAR:
      "إِنْ يَشَأْ يُسْكِنِ الرِّيحَ فَيَظْلَلْنَ رَوَاكِدَ عَلَىٰ ظَهْرِهِ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِكُلِّ صَبَّارٍ شَكُورٍ",
  },
  {
    id: "4306",
    sura: "42",
    VerseIDAr: "34",
    ayatAR: "أَوْ يُوبِقْهُنَّ بِمَا كَسَبُوا وَيَعْفُ عَنْ كَثِيرٍ",
  },
  {
    id: "4307",
    sura: "42",
    VerseIDAr: "35",
    ayatAR:
      "وَيَعْلَمَ الَّذِينَ يُجَادِلُونَ فِي آيَاتِنَا مَا لَهُمْ مِنْ مَحِيصٍ",
  },
  {
    id: "4308",
    sura: "42",
    VerseIDAr: "36",
    ayatAR:
      "فَمَا أُوتِيتُمْ مِنْ شَيْءٍ فَمَتَاعُ الْحَيَاةِ الدُّنْيَا ۖ وَمَا عِنْدَ اللَّهِ خَيْرٌ وَأَبْقَىٰ لِلَّذِينَ آمَنُوا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ",
  },
  {
    id: "4309",
    sura: "42",
    VerseIDAr: "37",
    ayatAR:
      "وَالَّذِينَ يَجْتَنِبُونَ كَبَائِرَ الْإِثْمِ وَالْفَوَاحِشَ وَإِذَا مَا غَضِبُوا هُمْ يَغْفِرُونَ",
  },
  {
    id: "4310",
    sura: "42",
    VerseIDAr: "38",
    ayatAR:
      "وَالَّذِينَ اسْتَجَابُوا لِرَبِّهِمْ وَأَقَامُوا الصَّلَاةَ وَأَمْرُهُمْ شُورَىٰ بَيْنَهُمْ وَمِمَّا رَزَقْنَاهُمْ يُنْفِقُونَ",
  },
  {
    id: "4311",
    sura: "42",
    VerseIDAr: "39",
    ayatAR: "وَالَّذِينَ إِذَا أَصَابَهُمُ الْبَغْيُ هُمْ يَنْتَصِرُونَ",
  },
  {
    id: "4312",
    sura: "42",
    VerseIDAr: "40",
    ayatAR:
      "وَجَزَاءُ سَيِّئَةٍ سَيِّئَةٌ مِثْلُهَا ۖ فَمَنْ عَفَا وَأَصْلَحَ فَأَجْرُهُ عَلَى اللَّهِ ۚ إِنَّهُ لَا يُحِبُّ الظَّالِمِينَ",
  },
  {
    id: "4313",
    sura: "42",
    VerseIDAr: "41",
    ayatAR:
      "وَلَمَنِ انْتَصَرَ بَعْدَ ظُلْمِهِ فَأُولَٰئِكَ مَا عَلَيْهِمْ مِنْ سَبِيلٍ",
  },
  {
    id: "4314",
    sura: "42",
    VerseIDAr: "42",
    ayatAR:
      "إِنَّمَا السَّبِيلُ عَلَى الَّذِينَ يَظْلِمُونَ النَّاسَ وَيَبْغُونَ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ ۚ أُولَٰئِكَ لَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "4315",
    sura: "42",
    VerseIDAr: "43",
    ayatAR: "وَلَمَنْ صَبَرَ وَغَفَرَ إِنَّ ذَٰلِكَ لَمِنْ عَزْمِ الْأُمُورِ",
  },
  {
    id: "4316",
    sura: "42",
    VerseIDAr: "44",
    ayatAR:
      "وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ وَلِيٍّ مِنْ بَعْدِهِ ۗ وَتَرَى الظَّالِمِينَ لَمَّا رَأَوُا الْعَذَابَ يَقُولُونَ هَلْ إِلَىٰ مَرَدٍّ مِنْ سَبِيلٍ",
  },
  {
    id: "4317",
    sura: "42",
    VerseIDAr: "45",
    ayatAR:
      "وَتَرَاهُمْ يُعْرَضُونَ عَلَيْهَا خَاشِعِينَ مِنَ الذُّلِّ يَنْظُرُونَ مِنْ طَرْفٍ خَفِيٍّ ۗ وَقَالَ الَّذِينَ آمَنُوا إِنَّ الْخَاسِرِينَ الَّذِينَ خَسِرُوا أَنْفُسَهُمْ وَأَهْلِيهِمْ يَوْمَ الْقِيَامَةِ ۗ أَلَا إِنَّ الظَّالِمِينَ فِي عَذَابٍ مُقِيمٍ",
  },
  {
    id: "4318",
    sura: "42",
    VerseIDAr: "46",
    ayatAR:
      "وَمَا كَانَ لَهُمْ مِنْ أَوْلِيَاءَ يَنْصُرُونَهُمْ مِنْ دُونِ اللَّهِ ۗ وَمَنْ يُضْلِلِ اللَّهُ فَمَا لَهُ مِنْ سَبِيلٍ",
  },
  {
    id: "4319",
    sura: "42",
    VerseIDAr: "47",
    ayatAR:
      "اسْتَجِيبُوا لِرَبِّكُمْ مِنْ قَبْلِ أَنْ يَأْتِيَ يَوْمٌ لَا مَرَدَّ لَهُ مِنَ اللَّهِ ۚ مَا لَكُمْ مِنْ مَلْجَإٍ يَوْمَئِذٍ وَمَا لَكُمْ مِنْ نَكِيرٍ",
  },
  {
    id: "4320",
    sura: "42",
    VerseIDAr: "48",
    ayatAR:
      "فَإِنْ أَعْرَضُوا فَمَا أَرْسَلْنَاكَ عَلَيْهِمْ حَفِيظًا ۖ إِنْ عَلَيْكَ إِلَّا الْبَلَاغُ ۗ وَإِنَّا إِذَا أَذَقْنَا الْإِنْسَانَ مِنَّا رَحْمَةً فَرِحَ بِهَا ۖ وَإِنْ تُصِبْهُمْ سَيِّئَةٌ بِمَا قَدَّمَتْ أَيْدِيهِمْ فَإِنَّ الْإِنْسَانَ كَفُورٌ",
  },
  {
    id: "4321",
    sura: "42",
    VerseIDAr: "49",
    ayatAR:
      "لِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۚ يَخْلُقُ مَا يَشَاءُ ۚ يَهَبُ لِمَنْ يَشَاءُ إِنَاثًا وَيَهَبُ لِمَنْ يَشَاءُ الذُّكُورَ",
  },
  {
    id: "4322",
    sura: "42",
    VerseIDAr: "50",
    ayatAR:
      "أَوْ يُزَوِّجُهُمْ ذُكْرَانًا وَإِنَاثًا ۖ وَيَجْعَلُ مَنْ يَشَاءُ عَقِيمًا ۚ إِنَّهُ عَلِيمٌ قَدِيرٌ",
  },
  {
    id: "4323",
    sura: "42",
    VerseIDAr: "51",
    ayatAR:
      "وَمَا كَانَ لِبَشَرٍ أَنْ يُكَلِّمَهُ اللَّهُ إِلَّا وَحْيًا أَوْ مِنْ وَرَاءِ حِجَابٍ أَوْ يُرْسِلَ رَسُولًا فَيُوحِيَ بِإِذْنِهِ مَا يَشَاءُ ۚ إِنَّهُ عَلِيٌّ حَكِيمٌ",
  },
  {
    id: "4324",
    sura: "42",
    VerseIDAr: "52",
    ayatAR:
      "وَكَذَٰلِكَ أَوْحَيْنَا إِلَيْكَ رُوحًا مِنْ أَمْرِنَا ۚ مَا كُنْتَ تَدْرِي مَا الْكِتَابُ وَلَا الْإِيمَانُ وَلَٰكِنْ جَعَلْنَاهُ نُورًا نَهْدِي بِهِ مَنْ نَشَاءُ مِنْ عِبَادِنَا ۚ وَإِنَّكَ لَتَهْدِي إِلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "4325",
    sura: "42",
    VerseIDAr: "53",
    ayatAR:
      "صِرَاطِ اللَّهِ الَّذِي لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ أَلَا إِلَى اللَّهِ تَصِيرُ الْأُمُورُ",
  },
  {
    id: "4326",
    sura: "43",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  { id: "4327", sura: "43", VerseIDAr: "2", ayatAR: "وَالْكِتَابِ الْمُبِينِ" },
  {
    id: "4328",
    sura: "43",
    VerseIDAr: "3",
    ayatAR: "إِنَّا جَعَلْنَاهُ قُرْآنًا عَرَبِيًّا لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "4329",
    sura: "43",
    VerseIDAr: "4",
    ayatAR: "وَإِنَّهُ فِي أُمِّ الْكِتَابِ لَدَيْنَا لَعَلِيٌّ حَكِيمٌ",
  },
  {
    id: "4330",
    sura: "43",
    VerseIDAr: "5",
    ayatAR:
      "أَفَنَضْرِبُ عَنْكُمُ الذِّكْرَ صَفْحًا أَنْ كُنْتُمْ قَوْمًا مُسْرِفِينَ",
  },
  {
    id: "4331",
    sura: "43",
    VerseIDAr: "6",
    ayatAR: "وَكَمْ أَرْسَلْنَا مِنْ نَبِيٍّ فِي الْأَوَّلِينَ",
  },
  {
    id: "4332",
    sura: "43",
    VerseIDAr: "7",
    ayatAR:
      "وَمَا يَأْتِيهِمْ مِنْ نَبِيٍّ إِلَّا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "4333",
    sura: "43",
    VerseIDAr: "8",
    ayatAR:
      "فَأَهْلَكْنَا أَشَدَّ مِنْهُمْ بَطْشًا وَمَضَىٰ مَثَلُ الْأَوَّلِينَ",
  },
  {
    id: "4334",
    sura: "43",
    VerseIDAr: "9",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ لَيَقُولُنَّ خَلَقَهُنَّ الْعَزِيزُ الْعَلِيمُ",
  },
  {
    id: "4335",
    sura: "43",
    VerseIDAr: "10",
    ayatAR:
      "الَّذِي جَعَلَ لَكُمُ الْأَرْضَ مَهْدًا وَجَعَلَ لَكُمْ فِيهَا سُبُلًا لَعَلَّكُمْ تَهْتَدُونَ",
  },
  {
    id: "4336",
    sura: "43",
    VerseIDAr: "11",
    ayatAR:
      "وَالَّذِي نَزَّلَ مِنَ السَّمَاءِ مَاءً بِقَدَرٍ فَأَنْشَرْنَا بِهِ بَلْدَةً مَيْتًا ۚ كَذَٰلِكَ تُخْرَجُونَ",
  },
  {
    id: "4337",
    sura: "43",
    VerseIDAr: "12",
    ayatAR:
      "وَالَّذِي خَلَقَ الْأَزْوَاجَ كُلَّهَا وَجَعَلَ لَكُمْ مِنَ الْفُلْكِ وَالْأَنْعَامِ مَا تَرْكَبُونَ",
  },
  {
    id: "4338",
    sura: "43",
    VerseIDAr: "13",
    ayatAR:
      "لِتَسْتَوُوا عَلَىٰ ظُهُورِهِ ثُمَّ تَذْكُرُوا نِعْمَةَ رَبِّكُمْ إِذَا اسْتَوَيْتُمْ عَلَيْهِ وَتَقُولُوا سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَٰذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ",
  },
  {
    id: "4339",
    sura: "43",
    VerseIDAr: "14",
    ayatAR: "وَإِنَّا إِلَىٰ رَبِّنَا لَمُنْقَلِبُونَ",
  },
  {
    id: "4340",
    sura: "43",
    VerseIDAr: "15",
    ayatAR:
      "وَجَعَلُوا لَهُ مِنْ عِبَادِهِ جُزْءًا ۚ إِنَّ الْإِنْسَانَ لَكَفُورٌ مُبِينٌ",
  },
  {
    id: "4341",
    sura: "43",
    VerseIDAr: "16",
    ayatAR: "أَمِ اتَّخَذَ مِمَّا يَخْلُقُ بَنَاتٍ وَأَصْفَاكُمْ بِالْبَنِينَ",
  },
  {
    id: "4342",
    sura: "43",
    VerseIDAr: "17",
    ayatAR:
      "وَإِذَا بُشِّرَ أَحَدُهُمْ بِمَا ضَرَبَ لِلرَّحْمَٰنِ مَثَلًا ظَلَّ وَجْهُهُ مُسْوَدًّا وَهُوَ كَظِيمٌ",
  },
  {
    id: "4343",
    sura: "43",
    VerseIDAr: "18",
    ayatAR:
      "أَوَمَنْ يُنَشَّأُ فِي الْحِلْيَةِ وَهُوَ فِي الْخِصَامِ غَيْرُ مُبِينٍ",
  },
  {
    id: "4344",
    sura: "43",
    VerseIDAr: "19",
    ayatAR:
      "وَجَعَلُوا الْمَلَائِكَةَ الَّذِينَ هُمْ عِبَادُ الرَّحْمَٰنِ إِنَاثًا ۚ أَشَهِدُوا خَلْقَهُمْ ۚ سَتُكْتَبُ شَهَادَتُهُمْ وَيُسْأَلُونَ",
  },
  {
    id: "4345",
    sura: "43",
    VerseIDAr: "20",
    ayatAR:
      "وَقَالُوا لَوْ شَاءَ الرَّحْمَٰنُ مَا عَبَدْنَاهُمْ ۗ مَا لَهُمْ بِذَٰلِكَ مِنْ عِلْمٍ ۖ إِنْ هُمْ إِلَّا يَخْرُصُونَ",
  },
  {
    id: "4346",
    sura: "43",
    VerseIDAr: "21",
    ayatAR:
      "أَمْ آتَيْنَاهُمْ كِتَابًا مِنْ قَبْلِهِ فَهُمْ بِهِ مُسْتَمْسِكُونَ",
  },
  {
    id: "4347",
    sura: "43",
    VerseIDAr: "22",
    ayatAR:
      "بَلْ قَالُوا إِنَّا وَجَدْنَا آبَاءَنَا عَلَىٰ أُمَّةٍ وَإِنَّا عَلَىٰ آثَارِهِمْ مُهْتَدُونَ",
  },
  {
    id: "4348",
    sura: "43",
    VerseIDAr: "23",
    ayatAR:
      "وَكَذَٰلِكَ مَا أَرْسَلْنَا مِنْ قَبْلِكَ فِي قَرْيَةٍ مِنْ نَذِيرٍ إِلَّا قَالَ مُتْرَفُوهَا إِنَّا وَجَدْنَا آبَاءَنَا عَلَىٰ أُمَّةٍ وَإِنَّا عَلَىٰ آثَارِهِمْ مُقْتَدُونَ",
  },
  {
    id: "4349",
    sura: "43",
    VerseIDAr: "24",
    ayatAR:
      "قَالَ أَوَلَوْ جِئْتُكُمْ بِأَهْدَىٰ مِمَّا وَجَدْتُمْ عَلَيْهِ آبَاءَكُمْ ۖ قَالُوا إِنَّا بِمَا أُرْسِلْتُمْ بِهِ كَافِرُونَ",
  },
  {
    id: "4350",
    sura: "43",
    VerseIDAr: "25",
    ayatAR:
      "فَانْتَقَمْنَا مِنْهُمْ ۖ فَانْظُرْ كَيْفَ كَانَ عَاقِبَةُ الْمُكَذِّبِينَ",
  },
  {
    id: "4351",
    sura: "43",
    VerseIDAr: "26",
    ayatAR:
      "وَإِذْ قَالَ إِبْرَاهِيمُ لِأَبِيهِ وَقَوْمِهِ إِنَّنِي بَرَاءٌ مِمَّا تَعْبُدُونَ",
  },
  {
    id: "4352",
    sura: "43",
    VerseIDAr: "27",
    ayatAR: "إِلَّا الَّذِي فَطَرَنِي فَإِنَّهُ سَيَهْدِينِ",
  },
  {
    id: "4353",
    sura: "43",
    VerseIDAr: "28",
    ayatAR:
      "وَجَعَلَهَا كَلِمَةً بَاقِيَةً فِي عَقِبِهِ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "4354",
    sura: "43",
    VerseIDAr: "29",
    ayatAR:
      "بَلْ مَتَّعْتُ هَٰؤُلَاءِ وَآبَاءَهُمْ حَتَّىٰ جَاءَهُمُ الْحَقُّ وَرَسُولٌ مُبِينٌ",
  },
  {
    id: "4355",
    sura: "43",
    VerseIDAr: "30",
    ayatAR:
      "وَلَمَّا جَاءَهُمُ الْحَقُّ قَالُوا هَٰذَا سِحْرٌ وَإِنَّا بِهِ كَافِرُونَ",
  },
  {
    id: "4356",
    sura: "43",
    VerseIDAr: "31",
    ayatAR:
      "وَقَالُوا لَوْلَا نُزِّلَ هَٰذَا الْقُرْآنُ عَلَىٰ رَجُلٍ مِنَ الْقَرْيَتَيْنِ عَظِيمٍ",
  },
  {
    id: "4357",
    sura: "43",
    VerseIDAr: "32",
    ayatAR:
      "أَهُمْ يَقْسِمُونَ رَحْمَتَ رَبِّكَ ۚ نَحْنُ قَسَمْنَا بَيْنَهُمْ مَعِيشَتَهُمْ فِي الْحَيَاةِ الدُّنْيَا ۚ وَرَفَعْنَا بَعْضَهُمْ فَوْقَ بَعْضٍ دَرَجَاتٍ لِيَتَّخِذَ بَعْضُهُمْ بَعْضًا سُخْرِيًّا ۗ وَرَحْمَتُ رَبِّكَ خَيْرٌ مِمَّا يَجْمَعُونَ",
  },
  {
    id: "4358",
    sura: "43",
    VerseIDAr: "33",
    ayatAR:
      "وَلَوْلَا أَنْ يَكُونَ النَّاسُ أُمَّةً وَاحِدَةً لَجَعَلْنَا لِمَنْ يَكْفُرُ بِالرَّحْمَٰنِ لِبُيُوتِهِمْ سُقُفًا مِنْ فِضَّةٍ وَمَعَارِجَ عَلَيْهَا يَظْهَرُونَ",
  },
  {
    id: "4359",
    sura: "43",
    VerseIDAr: "34",
    ayatAR: "وَلِبُيُوتِهِمْ أَبْوَابًا وَسُرُرًا عَلَيْهَا يَتَّكِئُونَ",
  },
  {
    id: "4360",
    sura: "43",
    VerseIDAr: "35",
    ayatAR:
      "وَزُخْرُفًا ۚ وَإِنْ كُلُّ ذَٰلِكَ لَمَّا مَتَاعُ الْحَيَاةِ الدُّنْيَا ۚ وَالْآخِرَةُ عِنْدَ رَبِّكَ لِلْمُتَّقِينَ",
  },
  {
    id: "4361",
    sura: "43",
    VerseIDAr: "36",
    ayatAR:
      "وَمَنْ يَعْشُ عَنْ ذِكْرِ الرَّحْمَٰنِ نُقَيِّضْ لَهُ شَيْطَانًا فَهُوَ لَهُ قَرِينٌ",
  },
  {
    id: "4362",
    sura: "43",
    VerseIDAr: "37",
    ayatAR:
      "وَإِنَّهُمْ لَيَصُدُّونَهُمْ عَنِ السَّبِيلِ وَيَحْسَبُونَ أَنَّهُمْ مُهْتَدُونَ",
  },
  {
    id: "4363",
    sura: "43",
    VerseIDAr: "38",
    ayatAR:
      "حَتَّىٰ إِذَا جَاءَنَا قَالَ يَا لَيْتَ بَيْنِي وَبَيْنَكَ بُعْدَ الْمَشْرِقَيْنِ فَبِئْسَ الْقَرِينُ",
  },
  {
    id: "4364",
    sura: "43",
    VerseIDAr: "39",
    ayatAR:
      "وَلَنْ يَنْفَعَكُمُ الْيَوْمَ إِذْ ظَلَمْتُمْ أَنَّكُمْ فِي الْعَذَابِ مُشْتَرِكُونَ",
  },
  {
    id: "4365",
    sura: "43",
    VerseIDAr: "40",
    ayatAR:
      "أَفَأَنْتَ تُسْمِعُ الصُّمَّ أَوْ تَهْدِي الْعُمْيَ وَمَنْ كَانَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "4366",
    sura: "43",
    VerseIDAr: "41",
    ayatAR: "فَإِمَّا نَذْهَبَنَّ بِكَ فَإِنَّا مِنْهُمْ مُنْتَقِمُونَ",
  },
  {
    id: "4367",
    sura: "43",
    VerseIDAr: "42",
    ayatAR:
      "أَوْ نُرِيَنَّكَ الَّذِي وَعَدْنَاهُمْ فَإِنَّا عَلَيْهِمْ مُقْتَدِرُونَ",
  },
  {
    id: "4368",
    sura: "43",
    VerseIDAr: "43",
    ayatAR:
      "فَاسْتَمْسِكْ بِالَّذِي أُوحِيَ إِلَيْكَ ۖ إِنَّكَ عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "4369",
    sura: "43",
    VerseIDAr: "44",
    ayatAR: "وَإِنَّهُ لَذِكْرٌ لَكَ وَلِقَوْمِكَ ۖ وَسَوْفَ تُسْأَلُونَ",
  },
  {
    id: "4370",
    sura: "43",
    VerseIDAr: "45",
    ayatAR:
      "وَاسْأَلْ مَنْ أَرْسَلْنَا مِنْ قَبْلِكَ مِنْ رُسُلِنَا أَجَعَلْنَا مِنْ دُونِ الرَّحْمَٰنِ آلِهَةً يُعْبَدُونَ",
  },
  {
    id: "4371",
    sura: "43",
    VerseIDAr: "46",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِآيَاتِنَا إِلَىٰ فِرْعَوْنَ وَمَلَئِهِ فَقَالَ إِنِّي رَسُولُ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "4372",
    sura: "43",
    VerseIDAr: "47",
    ayatAR: "فَلَمَّا جَاءَهُمْ بِآيَاتِنَا إِذَا هُمْ مِنْهَا يَضْحَكُونَ",
  },
  {
    id: "4373",
    sura: "43",
    VerseIDAr: "48",
    ayatAR:
      "وَمَا نُرِيهِمْ مِنْ آيَةٍ إِلَّا هِيَ أَكْبَرُ مِنْ أُخْتِهَا ۖ وَأَخَذْنَاهُمْ بِالْعَذَابِ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "4374",
    sura: "43",
    VerseIDAr: "49",
    ayatAR:
      "وَقَالُوا يَا أَيُّهَ السَّاحِرُ ادْعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِنْدَكَ إِنَّنَا لَمُهْتَدُونَ",
  },
  {
    id: "4375",
    sura: "43",
    VerseIDAr: "50",
    ayatAR: "فَلَمَّا كَشَفْنَا عَنْهُمُ الْعَذَابَ إِذَا هُمْ يَنْكُثُونَ",
  },
  {
    id: "4376",
    sura: "43",
    VerseIDAr: "51",
    ayatAR:
      "وَنَادَىٰ فِرْعَوْنُ فِي قَوْمِهِ قَالَ يَا قَوْمِ أَلَيْسَ لِي مُلْكُ مِصْرَ وَهَٰذِهِ الْأَنْهَارُ تَجْرِي مِنْ تَحْتِي ۖ أَفَلَا تُبْصِرُونَ",
  },
  {
    id: "4377",
    sura: "43",
    VerseIDAr: "52",
    ayatAR:
      "أَمْ أَنَا خَيْرٌ مِنْ هَٰذَا الَّذِي هُوَ مَهِينٌ وَلَا يَكَادُ يُبِينُ",
  },
  {
    id: "4378",
    sura: "43",
    VerseIDAr: "53",
    ayatAR:
      "فَلَوْلَا أُلْقِيَ عَلَيْهِ أَسْوِرَةٌ مِنْ ذَهَبٍ أَوْ جَاءَ مَعَهُ الْمَلَائِكَةُ مُقْتَرِنِينَ",
  },
  {
    id: "4379",
    sura: "43",
    VerseIDAr: "54",
    ayatAR:
      "فَاسْتَخَفَّ قَوْمَهُ فَأَطَاعُوهُ ۚ إِنَّهُمْ كَانُوا قَوْمًا فَاسِقِينَ",
  },
  {
    id: "4380",
    sura: "43",
    VerseIDAr: "55",
    ayatAR:
      "فَلَمَّا آسَفُونَا انْتَقَمْنَا مِنْهُمْ فَأَغْرَقْنَاهُمْ أَجْمَعِينَ",
  },
  {
    id: "4381",
    sura: "43",
    VerseIDAr: "56",
    ayatAR: "فَجَعَلْنَاهُمْ سَلَفًا وَمَثَلًا لِلْآخِرِينَ",
  },
  {
    id: "4382",
    sura: "43",
    VerseIDAr: "57",
    ayatAR:
      "وَلَمَّا ضُرِبَ ابْنُ مَرْيَمَ مَثَلًا إِذَا قَوْمُكَ مِنْهُ يَصِدُّونَ",
  },
  {
    id: "4383",
    sura: "43",
    VerseIDAr: "58",
    ayatAR:
      "وَقَالُوا أَآلِهَتُنَا خَيْرٌ أَمْ هُوَ ۚ مَا ضَرَبُوهُ لَكَ إِلَّا جَدَلًا ۚ بَلْ هُمْ قَوْمٌ خَصِمُونَ",
  },
  {
    id: "4384",
    sura: "43",
    VerseIDAr: "59",
    ayatAR:
      "إِنْ هُوَ إِلَّا عَبْدٌ أَنْعَمْنَا عَلَيْهِ وَجَعَلْنَاهُ مَثَلًا لِبَنِي إِسْرَائِيلَ",
  },
  {
    id: "4385",
    sura: "43",
    VerseIDAr: "60",
    ayatAR:
      "وَلَوْ نَشَاءُ لَجَعَلْنَا مِنْكُمْ مَلَائِكَةً فِي الْأَرْضِ يَخْلُفُونَ",
  },
  {
    id: "4386",
    sura: "43",
    VerseIDAr: "61",
    ayatAR:
      "وَإِنَّهُ لَعِلْمٌ لِلسَّاعَةِ فَلَا تَمْتَرُنَّ بِهَا وَاتَّبِعُونِ ۚ هَٰذَا صِرَاطٌ مُسْتَقِيمٌ",
  },
  {
    id: "4387",
    sura: "43",
    VerseIDAr: "62",
    ayatAR:
      "وَلَا يَصُدَّنَّكُمُ الشَّيْطَانُ ۖ إِنَّهُ لَكُمْ عَدُوٌّ مُبِينٌ",
  },
  {
    id: "4388",
    sura: "43",
    VerseIDAr: "63",
    ayatAR:
      "وَلَمَّا جَاءَ عِيسَىٰ بِالْبَيِّنَاتِ قَالَ قَدْ جِئْتُكُمْ بِالْحِكْمَةِ وَلِأُبَيِّنَ لَكُمْ بَعْضَ الَّذِي تَخْتَلِفُونَ فِيهِ ۖ فَاتَّقُوا اللَّهَ وَأَطِيعُونِ",
  },
  {
    id: "4389",
    sura: "43",
    VerseIDAr: "64",
    ayatAR:
      "إِنَّ اللَّهَ هُوَ رَبِّي وَرَبُّكُمْ فَاعْبُدُوهُ ۚ هَٰذَا صِرَاطٌ مُسْتَقِيمٌ",
  },
  {
    id: "4390",
    sura: "43",
    VerseIDAr: "65",
    ayatAR:
      "فَاخْتَلَفَ الْأَحْزَابُ مِنْ بَيْنِهِمْ ۖ فَوَيْلٌ لِلَّذِينَ ظَلَمُوا مِنْ عَذَابِ يَوْمٍ أَلِيمٍ",
  },
  {
    id: "4391",
    sura: "43",
    VerseIDAr: "66",
    ayatAR:
      "هَلْ يَنْظُرُونَ إِلَّا السَّاعَةَ أَنْ تَأْتِيَهُمْ بَغْتَةً وَهُمْ لَا يَشْعُرُونَ",
  },
  {
    id: "4392",
    sura: "43",
    VerseIDAr: "67",
    ayatAR:
      "الْأَخِلَّاءُ يَوْمَئِذٍ بَعْضُهُمْ لِبَعْضٍ عَدُوٌّ إِلَّا الْمُتَّقِينَ",
  },
  {
    id: "4393",
    sura: "43",
    VerseIDAr: "68",
    ayatAR:
      "يَا عِبَادِ لَا خَوْفٌ عَلَيْكُمُ الْيَوْمَ وَلَا أَنْتُمْ تَحْزَنُونَ",
  },
  {
    id: "4394",
    sura: "43",
    VerseIDAr: "69",
    ayatAR: "الَّذِينَ آمَنُوا بِآيَاتِنَا وَكَانُوا مُسْلِمِينَ",
  },
  {
    id: "4395",
    sura: "43",
    VerseIDAr: "70",
    ayatAR: "ادْخُلُوا الْجَنَّةَ أَنْتُمْ وَأَزْوَاجُكُمْ تُحْبَرُونَ",
  },
  {
    id: "4396",
    sura: "43",
    VerseIDAr: "71",
    ayatAR:
      "يُطَافُ عَلَيْهِمْ بِصِحَافٍ مِنْ ذَهَبٍ وَأَكْوَابٍ ۖ وَفِيهَا مَا تَشْتَهِيهِ الْأَنْفُسُ وَتَلَذُّ الْأَعْيُنُ ۖ وَأَنْتُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "4397",
    sura: "43",
    VerseIDAr: "72",
    ayatAR:
      "وَتِلْكَ الْجَنَّةُ الَّتِي أُورِثْتُمُوهَا بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "4398",
    sura: "43",
    VerseIDAr: "73",
    ayatAR: "لَكُمْ فِيهَا فَاكِهَةٌ كَثِيرَةٌ مِنْهَا تَأْكُلُونَ",
  },
  {
    id: "4399",
    sura: "43",
    VerseIDAr: "74",
    ayatAR: "إِنَّ الْمُجْرِمِينَ فِي عَذَابِ جَهَنَّمَ خَالِدُونَ",
  },
  {
    id: "4400",
    sura: "43",
    VerseIDAr: "75",
    ayatAR: "لَا يُفَتَّرُ عَنْهُمْ وَهُمْ فِيهِ مُبْلِسُونَ",
  },
  {
    id: "4401",
    sura: "43",
    VerseIDAr: "76",
    ayatAR: "وَمَا ظَلَمْنَاهُمْ وَلَٰكِنْ كَانُوا هُمُ الظَّالِمِينَ",
  },
  {
    id: "4402",
    sura: "43",
    VerseIDAr: "77",
    ayatAR:
      "وَنَادَوْا يَا مَالِكُ لِيَقْضِ عَلَيْنَا رَبُّكَ ۖ قَالَ إِنَّكُمْ مَاكِثُونَ",
  },
  {
    id: "4403",
    sura: "43",
    VerseIDAr: "78",
    ayatAR:
      "لَقَدْ جِئْنَاكُمْ بِالْحَقِّ وَلَٰكِنَّ أَكْثَرَكُمْ لِلْحَقِّ كَارِهُونَ",
  },
  {
    id: "4404",
    sura: "43",
    VerseIDAr: "79",
    ayatAR: "أَمْ أَبْرَمُوا أَمْرًا فَإِنَّا مُبْرِمُونَ",
  },
  {
    id: "4405",
    sura: "43",
    VerseIDAr: "80",
    ayatAR:
      "أَمْ يَحْسَبُونَ أَنَّا لَا نَسْمَعُ سِرَّهُمْ وَنَجْوَاهُمْ ۚ بَلَىٰ وَرُسُلُنَا لَدَيْهِمْ يَكْتُبُونَ",
  },
  {
    id: "4406",
    sura: "43",
    VerseIDAr: "81",
    ayatAR:
      "قُلْ إِنْ كَانَ لِلرَّحْمَٰنِ وَلَدٌ فَأَنَا أَوَّلُ الْعَابِدِينَ",
  },
  {
    id: "4407",
    sura: "43",
    VerseIDAr: "82",
    ayatAR:
      "سُبْحَانَ رَبِّ السَّمَاوَاتِ وَالْأَرْضِ رَبِّ الْعَرْشِ عَمَّا يَصِفُونَ",
  },
  {
    id: "4408",
    sura: "43",
    VerseIDAr: "83",
    ayatAR:
      "فَذَرْهُمْ يَخُوضُوا وَيَلْعَبُوا حَتَّىٰ يُلَاقُوا يَوْمَهُمُ الَّذِي يُوعَدُونَ",
  },
  {
    id: "4409",
    sura: "43",
    VerseIDAr: "84",
    ayatAR:
      "وَهُوَ الَّذِي فِي السَّمَاءِ إِلَٰهٌ وَفِي الْأَرْضِ إِلَٰهٌ ۚ وَهُوَ الْحَكِيمُ الْعَلِيمُ",
  },
  {
    id: "4410",
    sura: "43",
    VerseIDAr: "85",
    ayatAR:
      "وَتَبَارَكَ الَّذِي لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا وَعِنْدَهُ عِلْمُ السَّاعَةِ وَإِلَيْهِ تُرْجَعُونَ",
  },
  {
    id: "4411",
    sura: "43",
    VerseIDAr: "86",
    ayatAR:
      "وَلَا يَمْلِكُ الَّذِينَ يَدْعُونَ مِنْ دُونِهِ الشَّفَاعَةَ إِلَّا مَنْ شَهِدَ بِالْحَقِّ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "4412",
    sura: "43",
    VerseIDAr: "87",
    ayatAR:
      "وَلَئِنْ سَأَلْتَهُمْ مَنْ خَلَقَهُمْ لَيَقُولُنَّ اللَّهُ ۖ فَأَنَّىٰ يُؤْفَكُونَ",
  },
  {
    id: "4413",
    sura: "43",
    VerseIDAr: "88",
    ayatAR: "وَقِيلِهِ يَا رَبِّ إِنَّ هَٰؤُلَاءِ قَوْمٌ لَا يُؤْمِنُونَ",
  },
  {
    id: "4414",
    sura: "43",
    VerseIDAr: "89",
    ayatAR: "فَاصْفَحْ عَنْهُمْ وَقُلْ سَلَامٌ ۚ فَسَوْفَ يَعْلَمُونَ",
  },
  {
    id: "4415",
    sura: "44",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  { id: "4416", sura: "44", VerseIDAr: "2", ayatAR: "وَالْكِتَابِ الْمُبِينِ" },
  {
    id: "4417",
    sura: "44",
    VerseIDAr: "3",
    ayatAR:
      "إِنَّا أَنْزَلْنَاهُ فِي لَيْلَةٍ مُبَارَكَةٍ ۚ إِنَّا كُنَّا مُنْذِرِينَ",
  },
  {
    id: "4418",
    sura: "44",
    VerseIDAr: "4",
    ayatAR: "فِيهَا يُفْرَقُ كُلُّ أَمْرٍ حَكِيمٍ",
  },
  {
    id: "4419",
    sura: "44",
    VerseIDAr: "5",
    ayatAR: "أَمْرًا مِنْ عِنْدِنَا ۚ إِنَّا كُنَّا مُرْسِلِينَ",
  },
  {
    id: "4420",
    sura: "44",
    VerseIDAr: "6",
    ayatAR: "رَحْمَةً مِنْ رَبِّكَ ۚ إِنَّهُ هُوَ السَّمِيعُ الْعَلِيمُ",
  },
  {
    id: "4421",
    sura: "44",
    VerseIDAr: "7",
    ayatAR:
      "رَبِّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا ۖ إِنْ كُنْتُمْ مُوقِنِينَ",
  },
  {
    id: "4422",
    sura: "44",
    VerseIDAr: "8",
    ayatAR:
      "لَا إِلَٰهَ إِلَّا هُوَ يُحْيِي وَيُمِيتُ ۖ رَبُّكُمْ وَرَبُّ آبَائِكُمُ الْأَوَّلِينَ",
  },
  {
    id: "4423",
    sura: "44",
    VerseIDAr: "9",
    ayatAR: "بَلْ هُمْ فِي شَكٍّ يَلْعَبُونَ",
  },
  {
    id: "4424",
    sura: "44",
    VerseIDAr: "10",
    ayatAR: "فَارْتَقِبْ يَوْمَ تَأْتِي السَّمَاءُ بِدُخَانٍ مُبِينٍ",
  },
  {
    id: "4425",
    sura: "44",
    VerseIDAr: "11",
    ayatAR: "يَغْشَى النَّاسَ ۖ هَٰذَا عَذَابٌ أَلِيمٌ",
  },
  {
    id: "4426",
    sura: "44",
    VerseIDAr: "12",
    ayatAR: "رَبَّنَا اكْشِفْ عَنَّا الْعَذَابَ إِنَّا مُؤْمِنُونَ",
  },
  {
    id: "4427",
    sura: "44",
    VerseIDAr: "13",
    ayatAR: "أَنَّىٰ لَهُمُ الذِّكْرَىٰ وَقَدْ جَاءَهُمْ رَسُولٌ مُبِينٌ",
  },
  {
    id: "4428",
    sura: "44",
    VerseIDAr: "14",
    ayatAR: "ثُمَّ تَوَلَّوْا عَنْهُ وَقَالُوا مُعَلَّمٌ مَجْنُونٌ",
  },
  {
    id: "4429",
    sura: "44",
    VerseIDAr: "15",
    ayatAR: "إِنَّا كَاشِفُو الْعَذَابِ قَلِيلًا ۚ إِنَّكُمْ عَائِدُونَ",
  },
  {
    id: "4430",
    sura: "44",
    VerseIDAr: "16",
    ayatAR: "يَوْمَ نَبْطِشُ الْبَطْشَةَ الْكُبْرَىٰ إِنَّا مُنْتَقِمُونَ",
  },
  {
    id: "4431",
    sura: "44",
    VerseIDAr: "17",
    ayatAR:
      "وَلَقَدْ فَتَنَّا قَبْلَهُمْ قَوْمَ فِرْعَوْنَ وَجَاءَهُمْ رَسُولٌ كَرِيمٌ",
  },
  {
    id: "4432",
    sura: "44",
    VerseIDAr: "18",
    ayatAR:
      "أَنْ أَدُّوا إِلَيَّ عِبَادَ اللَّهِ ۖ إِنِّي لَكُمْ رَسُولٌ أَمِينٌ",
  },
  {
    id: "4433",
    sura: "44",
    VerseIDAr: "19",
    ayatAR:
      "وَأَنْ لَا تَعْلُوا عَلَى اللَّهِ ۖ إِنِّي آتِيكُمْ بِسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "4434",
    sura: "44",
    VerseIDAr: "20",
    ayatAR: "وَإِنِّي عُذْتُ بِرَبِّي وَرَبِّكُمْ أَنْ تَرْجُمُونِ",
  },
  {
    id: "4435",
    sura: "44",
    VerseIDAr: "21",
    ayatAR: "وَإِنْ لَمْ تُؤْمِنُوا لِي فَاعْتَزِلُونِ",
  },
  {
    id: "4436",
    sura: "44",
    VerseIDAr: "22",
    ayatAR: "فَدَعَا رَبَّهُ أَنَّ هَٰؤُلَاءِ قَوْمٌ مُجْرِمُونَ",
  },
  {
    id: "4437",
    sura: "44",
    VerseIDAr: "23",
    ayatAR: "فَأَسْرِ بِعِبَادِي لَيْلًا إِنَّكُمْ مُتَّبَعُونَ",
  },
  {
    id: "4438",
    sura: "44",
    VerseIDAr: "24",
    ayatAR: "وَاتْرُكِ الْبَحْرَ رَهْوًا ۖ إِنَّهُمْ جُنْدٌ مُغْرَقُونَ",
  },
  {
    id: "4439",
    sura: "44",
    VerseIDAr: "25",
    ayatAR: "كَمْ تَرَكُوا مِنْ جَنَّاتٍ وَعُيُونٍ",
  },
  {
    id: "4440",
    sura: "44",
    VerseIDAr: "26",
    ayatAR: "وَزُرُوعٍ وَمَقَامٍ كَرِيمٍ",
  },
  {
    id: "4441",
    sura: "44",
    VerseIDAr: "27",
    ayatAR: "وَنَعْمَةٍ كَانُوا فِيهَا فَاكِهِينَ",
  },
  {
    id: "4442",
    sura: "44",
    VerseIDAr: "28",
    ayatAR: "كَذَٰلِكَ ۖ وَأَوْرَثْنَاهَا قَوْمًا آخَرِينَ",
  },
  {
    id: "4443",
    sura: "44",
    VerseIDAr: "29",
    ayatAR:
      "فَمَا بَكَتْ عَلَيْهِمُ السَّمَاءُ وَالْأَرْضُ وَمَا كَانُوا مُنْظَرِينَ",
  },
  {
    id: "4444",
    sura: "44",
    VerseIDAr: "30",
    ayatAR: "وَلَقَدْ نَجَّيْنَا بَنِي إِسْرَائِيلَ مِنَ الْعَذَابِ الْمُهِينِ",
  },
  {
    id: "4445",
    sura: "44",
    VerseIDAr: "31",
    ayatAR: "مِنْ فِرْعَوْنَ ۚ إِنَّهُ كَانَ عَالِيًا مِنَ الْمُسْرِفِينَ",
  },
  {
    id: "4446",
    sura: "44",
    VerseIDAr: "32",
    ayatAR: "وَلَقَدِ اخْتَرْنَاهُمْ عَلَىٰ عِلْمٍ عَلَى الْعَالَمِينَ",
  },
  {
    id: "4447",
    sura: "44",
    VerseIDAr: "33",
    ayatAR: "وَآتَيْنَاهُمْ مِنَ الْآيَاتِ مَا فِيهِ بَلَاءٌ مُبِينٌ",
  },
  {
    id: "4448",
    sura: "44",
    VerseIDAr: "34",
    ayatAR: "إِنَّ هَٰؤُلَاءِ لَيَقُولُونَ",
  },
  {
    id: "4449",
    sura: "44",
    VerseIDAr: "35",
    ayatAR:
      "إِنْ هِيَ إِلَّا مَوْتَتُنَا الْأُولَىٰ وَمَا نَحْنُ بِمُنْشَرِينَ",
  },
  {
    id: "4450",
    sura: "44",
    VerseIDAr: "36",
    ayatAR: "فَأْتُوا بِآبَائِنَا إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "4451",
    sura: "44",
    VerseIDAr: "37",
    ayatAR:
      "أَهُمْ خَيْرٌ أَمْ قَوْمُ تُبَّعٍ وَالَّذِينَ مِنْ قَبْلِهِمْ ۚ أَهْلَكْنَاهُمْ ۖ إِنَّهُمْ كَانُوا مُجْرِمِينَ",
  },
  {
    id: "4452",
    sura: "44",
    VerseIDAr: "38",
    ayatAR:
      "وَمَا خَلَقْنَا السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا لَاعِبِينَ",
  },
  {
    id: "4453",
    sura: "44",
    VerseIDAr: "39",
    ayatAR:
      "مَا خَلَقْنَاهُمَا إِلَّا بِالْحَقِّ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "4454",
    sura: "44",
    VerseIDAr: "40",
    ayatAR: "إِنَّ يَوْمَ الْفَصْلِ مِيقَاتُهُمْ أَجْمَعِينَ",
  },
  {
    id: "4455",
    sura: "44",
    VerseIDAr: "41",
    ayatAR:
      "يَوْمَ لَا يُغْنِي مَوْلًى عَنْ مَوْلًى شَيْئًا وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "4456",
    sura: "44",
    VerseIDAr: "42",
    ayatAR: "إِلَّا مَنْ رَحِمَ اللَّهُ ۚ إِنَّهُ هُوَ الْعَزِيزُ الرَّحِيمُ",
  },
  {
    id: "4457",
    sura: "44",
    VerseIDAr: "43",
    ayatAR: "إِنَّ شَجَرَتَ الزَّقُّومِ",
  },
  { id: "4458", sura: "44", VerseIDAr: "44", ayatAR: "طَعَامُ الْأَثِيمِ" },
  {
    id: "4459",
    sura: "44",
    VerseIDAr: "45",
    ayatAR: "كَالْمُهْلِ يَغْلِي فِي الْبُطُونِ",
  },
  { id: "4460", sura: "44", VerseIDAr: "46", ayatAR: "كَغَلْيِ الْحَمِيمِ" },
  {
    id: "4461",
    sura: "44",
    VerseIDAr: "47",
    ayatAR: "خُذُوهُ فَاعْتِلُوهُ إِلَىٰ سَوَاءِ الْجَحِيمِ",
  },
  {
    id: "4462",
    sura: "44",
    VerseIDAr: "48",
    ayatAR: "ثُمَّ صُبُّوا فَوْقَ رَأْسِهِ مِنْ عَذَابِ الْحَمِيمِ",
  },
  {
    id: "4463",
    sura: "44",
    VerseIDAr: "49",
    ayatAR: "ذُقْ إِنَّكَ أَنْتَ الْعَزِيزُ الْكَرِيمُ",
  },
  {
    id: "4464",
    sura: "44",
    VerseIDAr: "50",
    ayatAR: "إِنَّ هَٰذَا مَا كُنْتُمْ بِهِ تَمْتَرُونَ",
  },
  {
    id: "4465",
    sura: "44",
    VerseIDAr: "51",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي مَقَامٍ أَمِينٍ",
  },
  { id: "4466", sura: "44", VerseIDAr: "52", ayatAR: "فِي جَنَّاتٍ وَعُيُونٍ" },
  {
    id: "4467",
    sura: "44",
    VerseIDAr: "53",
    ayatAR: "يَلْبَسُونَ مِنْ سُنْدُسٍ وَإِسْتَبْرَقٍ مُتَقَابِلِينَ",
  },
  {
    id: "4468",
    sura: "44",
    VerseIDAr: "54",
    ayatAR: "كَذَٰلِكَ وَزَوَّجْنَاهُمْ بِحُورٍ عِينٍ",
  },
  {
    id: "4469",
    sura: "44",
    VerseIDAr: "55",
    ayatAR: "يَدْعُونَ فِيهَا بِكُلِّ فَاكِهَةٍ آمِنِينَ",
  },
  {
    id: "4470",
    sura: "44",
    VerseIDAr: "56",
    ayatAR:
      "لَا يَذُوقُونَ فِيهَا الْمَوْتَ إِلَّا الْمَوْتَةَ الْأُولَىٰ ۖ وَوَقَاهُمْ عَذَابَ الْجَحِيمِ",
  },
  {
    id: "4471",
    sura: "44",
    VerseIDAr: "57",
    ayatAR: "فَضْلًا مِنْ رَبِّكَ ۚ ذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "4472",
    sura: "44",
    VerseIDAr: "58",
    ayatAR: "فَإِنَّمَا يَسَّرْنَاهُ بِلِسَانِكَ لَعَلَّهُمْ يَتَذَكَّرُونَ",
  },
  {
    id: "4473",
    sura: "44",
    VerseIDAr: "59",
    ayatAR: "فَارْتَقِبْ إِنَّهُمْ مُرْتَقِبُونَ",
  },
  {
    id: "4474",
    sura: "45",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  {
    id: "4475",
    sura: "45",
    VerseIDAr: "2",
    ayatAR: "تَنْزِيلُ الْكِتَابِ مِنَ اللَّهِ الْعَزِيزِ الْحَكِيمِ",
  },
  {
    id: "4476",
    sura: "45",
    VerseIDAr: "3",
    ayatAR: "إِنَّ فِي السَّمَاوَاتِ وَالْأَرْضِ لَآيَاتٍ لِلْمُؤْمِنِينَ",
  },
  {
    id: "4477",
    sura: "45",
    VerseIDAr: "4",
    ayatAR:
      "وَفِي خَلْقِكُمْ وَمَا يَبُثُّ مِنْ دَابَّةٍ آيَاتٌ لِقَوْمٍ يُوقِنُونَ",
  },
  {
    id: "4478",
    sura: "45",
    VerseIDAr: "5",
    ayatAR:
      "وَاخْتِلَافِ اللَّيْلِ وَالنَّهَارِ وَمَا أَنْزَلَ اللَّهُ مِنَ السَّمَاءِ مِنْ رِزْقٍ فَأَحْيَا بِهِ الْأَرْضَ بَعْدَ مَوْتِهَا وَتَصْرِيفِ الرِّيَاحِ آيَاتٌ لِقَوْمٍ يَعْقِلُونَ",
  },
  {
    id: "4479",
    sura: "45",
    VerseIDAr: "6",
    ayatAR:
      "تِلْكَ آيَاتُ اللَّهِ نَتْلُوهَا عَلَيْكَ بِالْحَقِّ ۖ فَبِأَيِّ حَدِيثٍ بَعْدَ اللَّهِ وَآيَاتِهِ يُؤْمِنُونَ",
  },
  {
    id: "4480",
    sura: "45",
    VerseIDAr: "7",
    ayatAR: "وَيْلٌ لِكُلِّ أَفَّاكٍ أَثِيمٍ",
  },
  {
    id: "4481",
    sura: "45",
    VerseIDAr: "8",
    ayatAR:
      "يَسْمَعُ آيَاتِ اللَّهِ تُتْلَىٰ عَلَيْهِ ثُمَّ يُصِرُّ مُسْتَكْبِرًا كَأَنْ لَمْ يَسْمَعْهَا ۖ فَبَشِّرْهُ بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "4482",
    sura: "45",
    VerseIDAr: "9",
    ayatAR:
      "وَإِذَا عَلِمَ مِنْ آيَاتِنَا شَيْئًا اتَّخَذَهَا هُزُوًا ۚ أُولَٰئِكَ لَهُمْ عَذَابٌ مُهِينٌ",
  },
  {
    id: "4483",
    sura: "45",
    VerseIDAr: "10",
    ayatAR:
      "مِنْ وَرَائِهِمْ جَهَنَّمُ ۖ وَلَا يُغْنِي عَنْهُمْ مَا كَسَبُوا شَيْئًا وَلَا مَا اتَّخَذُوا مِنْ دُونِ اللَّهِ أَوْلِيَاءَ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌ",
  },
  {
    id: "4484",
    sura: "45",
    VerseIDAr: "11",
    ayatAR:
      "هَٰذَا هُدًى ۖ وَالَّذِينَ كَفَرُوا بِآيَاتِ رَبِّهِمْ لَهُمْ عَذَابٌ مِنْ رِجْزٍ أَلِيمٌ",
  },
  {
    id: "4485",
    sura: "45",
    VerseIDAr: "12",
    ayatAR:
      "اللَّهُ الَّذِي سَخَّرَ لَكُمُ الْبَحْرَ لِتَجْرِيَ الْفُلْكُ فِيهِ بِأَمْرِهِ وَلِتَبْتَغُوا مِنْ فَضْلِهِ وَلَعَلَّكُمْ تَشْكُرُونَ",
  },
  {
    id: "4486",
    sura: "45",
    VerseIDAr: "13",
    ayatAR:
      "وَسَخَّرَ لَكُمْ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ جَمِيعًا مِنْهُ ۚ إِنَّ فِي ذَٰلِكَ لَآيَاتٍ لِقَوْمٍ يَتَفَكَّرُونَ",
  },
  {
    id: "4487",
    sura: "45",
    VerseIDAr: "14",
    ayatAR:
      "قُلْ لِلَّذِينَ آمَنُوا يَغْفِرُوا لِلَّذِينَ لَا يَرْجُونَ أَيَّامَ اللَّهِ لِيَجْزِيَ قَوْمًا بِمَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "4488",
    sura: "45",
    VerseIDAr: "15",
    ayatAR:
      "مَنْ عَمِلَ صَالِحًا فَلِنَفْسِهِ ۖ وَمَنْ أَسَاءَ فَعَلَيْهَا ۖ ثُمَّ إِلَىٰ رَبِّكُمْ تُرْجَعُونَ",
  },
  {
    id: "4489",
    sura: "45",
    VerseIDAr: "16",
    ayatAR:
      "وَلَقَدْ آتَيْنَا بَنِي إِسْرَائِيلَ الْكِتَابَ وَالْحُكْمَ وَالنُّبُوَّةَ وَرَزَقْنَاهُمْ مِنَ الطَّيِّبَاتِ وَفَضَّلْنَاهُمْ عَلَى الْعَالَمِينَ",
  },
  {
    id: "4490",
    sura: "45",
    VerseIDAr: "17",
    ayatAR:
      "وَآتَيْنَاهُمْ بَيِّنَاتٍ مِنَ الْأَمْرِ ۖ فَمَا اخْتَلَفُوا إِلَّا مِنْ بَعْدِ مَا جَاءَهُمُ الْعِلْمُ بَغْيًا بَيْنَهُمْ ۚ إِنَّ رَبَّكَ يَقْضِي بَيْنَهُمْ يَوْمَ الْقِيَامَةِ فِيمَا كَانُوا فِيهِ يَخْتَلِفُونَ",
  },
  {
    id: "4491",
    sura: "45",
    VerseIDAr: "18",
    ayatAR:
      "ثُمَّ جَعَلْنَاكَ عَلَىٰ شَرِيعَةٍ مِنَ الْأَمْرِ فَاتَّبِعْهَا وَلَا تَتَّبِعْ أَهْوَاءَ الَّذِينَ لَا يَعْلَمُونَ",
  },
  {
    id: "4492",
    sura: "45",
    VerseIDAr: "19",
    ayatAR:
      "إِنَّهُمْ لَنْ يُغْنُوا عَنْكَ مِنَ اللَّهِ شَيْئًا ۚ وَإِنَّ الظَّالِمِينَ بَعْضُهُمْ أَوْلِيَاءُ بَعْضٍ ۖ وَاللَّهُ وَلِيُّ الْمُتَّقِينَ",
  },
  {
    id: "4493",
    sura: "45",
    VerseIDAr: "20",
    ayatAR: "هَٰذَا بَصَائِرُ لِلنَّاسِ وَهُدًى وَرَحْمَةٌ لِقَوْمٍ يُوقِنُونَ",
  },
  {
    id: "4494",
    sura: "45",
    VerseIDAr: "21",
    ayatAR:
      "أَمْ حَسِبَ الَّذِينَ اجْتَرَحُوا السَّيِّئَاتِ أَنْ نَجْعَلَهُمْ كَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ سَوَاءً مَحْيَاهُمْ وَمَمَاتُهُمْ ۚ سَاءَ مَا يَحْكُمُونَ",
  },
  {
    id: "4495",
    sura: "45",
    VerseIDAr: "22",
    ayatAR:
      "وَخَلَقَ اللَّهُ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ وَلِتُجْزَىٰ كُلُّ نَفْسٍ بِمَا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "4496",
    sura: "45",
    VerseIDAr: "23",
    ayatAR:
      "أَفَرَأَيْتَ مَنِ اتَّخَذَ إِلَٰهَهُ هَوَاهُ وَأَضَلَّهُ اللَّهُ عَلَىٰ عِلْمٍ وَخَتَمَ عَلَىٰ سَمْعِهِ وَقَلْبِهِ وَجَعَلَ عَلَىٰ بَصَرِهِ غِشَاوَةً فَمَنْ يَهْدِيهِ مِنْ بَعْدِ اللَّهِ ۚ أَفَلَا تَذَكَّرُونَ",
  },
  {
    id: "4497",
    sura: "45",
    VerseIDAr: "24",
    ayatAR:
      "وَقَالُوا مَا هِيَ إِلَّا حَيَاتُنَا الدُّنْيَا نَمُوتُ وَنَحْيَا وَمَا يُهْلِكُنَا إِلَّا الدَّهْرُ ۚ وَمَا لَهُمْ بِذَٰلِكَ مِنْ عِلْمٍ ۖ إِنْ هُمْ إِلَّا يَظُنُّونَ",
  },
  {
    id: "4498",
    sura: "45",
    VerseIDAr: "25",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ مَا كَانَ حُجَّتَهُمْ إِلَّا أَنْ قَالُوا ائْتُوا بِآبَائِنَا إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "4499",
    sura: "45",
    VerseIDAr: "26",
    ayatAR:
      "قُلِ اللَّهُ يُحْيِيكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يَجْمَعُكُمْ إِلَىٰ يَوْمِ الْقِيَامَةِ لَا رَيْبَ فِيهِ وَلَٰكِنَّ أَكْثَرَ النَّاسِ لَا يَعْلَمُونَ",
  },
  {
    id: "4500",
    sura: "45",
    VerseIDAr: "27",
    ayatAR:
      "وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَيَوْمَ تَقُومُ السَّاعَةُ يَوْمَئِذٍ يَخْسَرُ الْمُبْطِلُونَ",
  },
  {
    id: "4501",
    sura: "45",
    VerseIDAr: "28",
    ayatAR:
      "وَتَرَىٰ كُلَّ أُمَّةٍ جَاثِيَةً ۚ كُلُّ أُمَّةٍ تُدْعَىٰ إِلَىٰ كِتَابِهَا الْيَوْمَ تُجْزَوْنَ مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "4502",
    sura: "45",
    VerseIDAr: "29",
    ayatAR:
      "هَٰذَا كِتَابُنَا يَنْطِقُ عَلَيْكُمْ بِالْحَقِّ ۚ إِنَّا كُنَّا نَسْتَنْسِخُ مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "4503",
    sura: "45",
    VerseIDAr: "30",
    ayatAR:
      "فَأَمَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَيُدْخِلُهُمْ رَبُّهُمْ فِي رَحْمَتِهِ ۚ ذَٰلِكَ هُوَ الْفَوْزُ الْمُبِينُ",
  },
  {
    id: "4504",
    sura: "45",
    VerseIDAr: "31",
    ayatAR:
      "وَأَمَّا الَّذِينَ كَفَرُوا أَفَلَمْ تَكُنْ آيَاتِي تُتْلَىٰ عَلَيْكُمْ فَاسْتَكْبَرْتُمْ وَكُنْتُمْ قَوْمًا مُجْرِمِينَ",
  },
  {
    id: "4505",
    sura: "45",
    VerseIDAr: "32",
    ayatAR:
      "وَإِذَا قِيلَ إِنَّ وَعْدَ اللَّهِ حَقٌّ وَالسَّاعَةُ لَا رَيْبَ فِيهَا قُلْتُمْ مَا نَدْرِي مَا السَّاعَةُ إِنْ نَظُنُّ إِلَّا ظَنًّا وَمَا نَحْنُ بِمُسْتَيْقِنِينَ",
  },
  {
    id: "4506",
    sura: "45",
    VerseIDAr: "33",
    ayatAR:
      "وَبَدَا لَهُمْ سَيِّئَاتُ مَا عَمِلُوا وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "4507",
    sura: "45",
    VerseIDAr: "34",
    ayatAR:
      "وَقِيلَ الْيَوْمَ نَنْسَاكُمْ كَمَا نَسِيتُمْ لِقَاءَ يَوْمِكُمْ هَٰذَا وَمَأْوَاكُمُ النَّارُ وَمَا لَكُمْ مِنْ نَاصِرِينَ",
  },
  {
    id: "4508",
    sura: "45",
    VerseIDAr: "35",
    ayatAR:
      "ذَٰلِكُمْ بِأَنَّكُمُ اتَّخَذْتُمْ آيَاتِ اللَّهِ هُزُوًا وَغَرَّتْكُمُ الْحَيَاةُ الدُّنْيَا ۚ فَالْيَوْمَ لَا يُخْرَجُونَ مِنْهَا وَلَا هُمْ يُسْتَعْتَبُونَ",
  },
  {
    id: "4509",
    sura: "45",
    VerseIDAr: "36",
    ayatAR:
      "فَلِلَّهِ الْحَمْدُ رَبِّ السَّمَاوَاتِ وَرَبِّ الْأَرْضِ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "4510",
    sura: "45",
    VerseIDAr: "37",
    ayatAR:
      "وَلَهُ الْكِبْرِيَاءُ فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "4511",
    sura: "46",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ حم",
  },
  {
    id: "4512",
    sura: "46",
    VerseIDAr: "2",
    ayatAR: "تَنْزِيلُ الْكِتَابِ مِنَ اللَّهِ الْعَزِيزِ الْحَكِيمِ",
  },
  {
    id: "4513",
    sura: "46",
    VerseIDAr: "3",
    ayatAR:
      "مَا خَلَقْنَا السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا إِلَّا بِالْحَقِّ وَأَجَلٍ مُسَمًّى ۚ وَالَّذِينَ كَفَرُوا عَمَّا أُنْذِرُوا مُعْرِضُونَ",
  },
  {
    id: "4514",
    sura: "46",
    VerseIDAr: "4",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ مَا تَدْعُونَ مِنْ دُونِ اللَّهِ أَرُونِي مَاذَا خَلَقُوا مِنَ الْأَرْضِ أَمْ لَهُمْ شِرْكٌ فِي السَّمَاوَاتِ ۖ ائْتُونِي بِكِتَابٍ مِنْ قَبْلِ هَٰذَا أَوْ أَثَارَةٍ مِنْ عِلْمٍ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "4515",
    sura: "46",
    VerseIDAr: "5",
    ayatAR:
      "وَمَنْ أَضَلُّ مِمَّنْ يَدْعُو مِنْ دُونِ اللَّهِ مَنْ لَا يَسْتَجِيبُ لَهُ إِلَىٰ يَوْمِ الْقِيَامَةِ وَهُمْ عَنْ دُعَائِهِمْ غَافِلُونَ",
  },
  {
    id: "4516",
    sura: "46",
    VerseIDAr: "6",
    ayatAR:
      "وَإِذَا حُشِرَ النَّاسُ كَانُوا لَهُمْ أَعْدَاءً وَكَانُوا بِعِبَادَتِهِمْ كَافِرِينَ",
  },
  {
    id: "4517",
    sura: "46",
    VerseIDAr: "7",
    ayatAR:
      "وَإِذَا تُتْلَىٰ عَلَيْهِمْ آيَاتُنَا بَيِّنَاتٍ قَالَ الَّذِينَ كَفَرُوا لِلْحَقِّ لَمَّا جَاءَهُمْ هَٰذَا سِحْرٌ مُبِينٌ",
  },
  {
    id: "4518",
    sura: "46",
    VerseIDAr: "8",
    ayatAR:
      "أَمْ يَقُولُونَ افْتَرَاهُ ۖ قُلْ إِنِ افْتَرَيْتُهُ فَلَا تَمْلِكُونَ لِي مِنَ اللَّهِ شَيْئًا ۖ هُوَ أَعْلَمُ بِمَا تُفِيضُونَ فِيهِ ۖ كَفَىٰ بِهِ شَهِيدًا بَيْنِي وَبَيْنَكُمْ ۖ وَهُوَ الْغَفُورُ الرَّحِيمُ",
  },
  {
    id: "4519",
    sura: "46",
    VerseIDAr: "9",
    ayatAR:
      "قُلْ مَا كُنْتُ بِدْعًا مِنَ الرُّسُلِ وَمَا أَدْرِي مَا يُفْعَلُ بِي وَلَا بِكُمْ ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰ إِلَيَّ وَمَا أَنَا إِلَّا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "4520",
    sura: "46",
    VerseIDAr: "10",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ كَانَ مِنْ عِنْدِ اللَّهِ وَكَفَرْتُمْ بِهِ وَشَهِدَ شَاهِدٌ مِنْ بَنِي إِسْرَائِيلَ عَلَىٰ مِثْلِهِ فَآمَنَ وَاسْتَكْبَرْتُمْ ۖ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "4521",
    sura: "46",
    VerseIDAr: "11",
    ayatAR:
      "وَقَالَ الَّذِينَ كَفَرُوا لِلَّذِينَ آمَنُوا لَوْ كَانَ خَيْرًا مَا سَبَقُونَا إِلَيْهِ ۚ وَإِذْ لَمْ يَهْتَدُوا بِهِ فَسَيَقُولُونَ هَٰذَا إِفْكٌ قَدِيمٌ",
  },
  {
    id: "4522",
    sura: "46",
    VerseIDAr: "12",
    ayatAR:
      "وَمِنْ قَبْلِهِ كِتَابُ مُوسَىٰ إِمَامًا وَرَحْمَةً ۚ وَهَٰذَا كِتَابٌ مُصَدِّقٌ لِسَانًا عَرَبِيًّا لِيُنْذِرَ الَّذِينَ ظَلَمُوا وَبُشْرَىٰ لِلْمُحْسِنِينَ",
  },
  {
    id: "4523",
    sura: "46",
    VerseIDAr: "13",
    ayatAR:
      "إِنَّ الَّذِينَ قَالُوا رَبُّنَا اللَّهُ ثُمَّ اسْتَقَامُوا فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ",
  },
  {
    id: "4524",
    sura: "46",
    VerseIDAr: "14",
    ayatAR:
      "أُولَٰئِكَ أَصْحَابُ الْجَنَّةِ خَالِدِينَ فِيهَا جَزَاءً بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "4525",
    sura: "46",
    VerseIDAr: "15",
    ayatAR:
      "وَوَصَّيْنَا الْإِنْسَانَ بِوَالِدَيْهِ إِحْسَانًا ۖ حَمَلَتْهُ أُمُّهُ كُرْهًا وَوَضَعَتْهُ كُرْهًا ۖ وَحَمْلُهُ وَفِصَالُهُ ثَلَاثُونَ شَهْرًا ۚ حَتَّىٰ إِذَا بَلَغَ أَشُدَّهُ وَبَلَغَ أَرْبَعِينَ سَنَةً قَالَ رَبِّ أَوْزِعْنِي أَنْ أَشْكُرَ نِعْمَتَكَ الَّتِي أَنْعَمْتَ عَلَيَّ وَعَلَىٰ وَالِدَيَّ وَأَنْ أَعْمَلَ صَالِحًا تَرْضَاهُ وَأَصْلِحْ لِي فِي ذُرِّيَّتِي ۖ إِنِّي تُبْتُ إِلَيْكَ وَإِنِّي مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "4526",
    sura: "46",
    VerseIDAr: "16",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ نَتَقَبَّلُ عَنْهُمْ أَحْسَنَ مَا عَمِلُوا وَنَتَجَاوَزُ عَنْ سَيِّئَاتِهِمْ فِي أَصْحَابِ الْجَنَّةِ ۖ وَعْدَ الصِّدْقِ الَّذِي كَانُوا يُوعَدُونَ",
  },
  {
    id: "4527",
    sura: "46",
    VerseIDAr: "17",
    ayatAR:
      "وَالَّذِي قَالَ لِوَالِدَيْهِ أُفٍّ لَكُمَا أَتَعِدَانِنِي أَنْ أُخْرَجَ وَقَدْ خَلَتِ الْقُرُونُ مِنْ قَبْلِي وَهُمَا يَسْتَغِيثَانِ اللَّهَ وَيْلَكَ آمِنْ إِنَّ وَعْدَ اللَّهِ حَقٌّ فَيَقُولُ مَا هَٰذَا إِلَّا أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "4528",
    sura: "46",
    VerseIDAr: "18",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ حَقَّ عَلَيْهِمُ الْقَوْلُ فِي أُمَمٍ قَدْ خَلَتْ مِنْ قَبْلِهِمْ مِنَ الْجِنِّ وَالْإِنْسِ ۖ إِنَّهُمْ كَانُوا خَاسِرِينَ",
  },
  {
    id: "4529",
    sura: "46",
    VerseIDAr: "19",
    ayatAR:
      "وَلِكُلٍّ دَرَجَاتٌ مِمَّا عَمِلُوا ۖ وَلِيُوَفِّيَهُمْ أَعْمَالَهُمْ وَهُمْ لَا يُظْلَمُونَ",
  },
  {
    id: "4530",
    sura: "46",
    VerseIDAr: "20",
    ayatAR:
      "وَيَوْمَ يُعْرَضُ الَّذِينَ كَفَرُوا عَلَى النَّارِ أَذْهَبْتُمْ طَيِّبَاتِكُمْ فِي حَيَاتِكُمُ الدُّنْيَا وَاسْتَمْتَعْتُمْ بِهَا فَالْيَوْمَ تُجْزَوْنَ عَذَابَ الْهُونِ بِمَا كُنْتُمْ تَسْتَكْبِرُونَ فِي الْأَرْضِ بِغَيْرِ الْحَقِّ وَبِمَا كُنْتُمْ تَفْسُقُونَ",
  },
  {
    id: "4531",
    sura: "46",
    VerseIDAr: "21",
    ayatAR:
      "وَاذْكُرْ أَخَا عَادٍ إِذْ أَنْذَرَ قَوْمَهُ بِالْأَحْقَافِ وَقَدْ خَلَتِ النُّذُرُ مِنْ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِ أَلَّا تَعْبُدُوا إِلَّا اللَّهَ إِنِّي أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍ",
  },
  {
    id: "4532",
    sura: "46",
    VerseIDAr: "22",
    ayatAR:
      "قَالُوا أَجِئْتَنَا لِتَأْفِكَنَا عَنْ آلِهَتِنَا فَأْتِنَا بِمَا تَعِدُنَا إِنْ كُنْتَ مِنَ الصَّادِقِينَ",
  },
  {
    id: "4533",
    sura: "46",
    VerseIDAr: "23",
    ayatAR:
      "قَالَ إِنَّمَا الْعِلْمُ عِنْدَ اللَّهِ وَأُبَلِّغُكُمْ مَا أُرْسِلْتُ بِهِ وَلَٰكِنِّي أَرَاكُمْ قَوْمًا تَجْهَلُونَ",
  },
  {
    id: "4534",
    sura: "46",
    VerseIDAr: "24",
    ayatAR:
      "فَلَمَّا رَأَوْهُ عَارِضًا مُسْتَقْبِلَ أَوْدِيَتِهِمْ قَالُوا هَٰذَا عَارِضٌ مُمْطِرُنَا ۚ بَلْ هُوَ مَا اسْتَعْجَلْتُمْ بِهِ ۖ رِيحٌ فِيهَا عَذَابٌ أَلِيمٌ",
  },
  {
    id: "4535",
    sura: "46",
    VerseIDAr: "25",
    ayatAR:
      "تُدَمِّرُ كُلَّ شَيْءٍ بِأَمْرِ رَبِّهَا فَأَصْبَحُوا لَا يُرَىٰ إِلَّا مَسَاكِنُهُمْ ۚ كَذَٰلِكَ نَجْزِي الْقَوْمَ الْمُجْرِمِينَ",
  },
  {
    id: "4536",
    sura: "46",
    VerseIDAr: "26",
    ayatAR:
      "وَلَقَدْ مَكَّنَّاهُمْ فِيمَا إِنْ مَكَّنَّاكُمْ فِيهِ وَجَعَلْنَا لَهُمْ سَمْعًا وَأَبْصَارًا وَأَفْئِدَةً فَمَا أَغْنَىٰ عَنْهُمْ سَمْعُهُمْ وَلَا أَبْصَارُهُمْ وَلَا أَفْئِدَتُهُمْ مِنْ شَيْءٍ إِذْ كَانُوا يَجْحَدُونَ بِآيَاتِ اللَّهِ وَحَاقَ بِهِمْ مَا كَانُوا بِهِ يَسْتَهْزِئُونَ",
  },
  {
    id: "4537",
    sura: "46",
    VerseIDAr: "27",
    ayatAR:
      "وَلَقَدْ أَهْلَكْنَا مَا حَوْلَكُمْ مِنَ الْقُرَىٰ وَصَرَّفْنَا الْآيَاتِ لَعَلَّهُمْ يَرْجِعُونَ",
  },
  {
    id: "4538",
    sura: "46",
    VerseIDAr: "28",
    ayatAR:
      "فَلَوْلَا نَصَرَهُمُ الَّذِينَ اتَّخَذُوا مِنْ دُونِ اللَّهِ قُرْبَانًا آلِهَةً ۖ بَلْ ضَلُّوا عَنْهُمْ ۚ وَذَٰلِكَ إِفْكُهُمْ وَمَا كَانُوا يَفْتَرُونَ",
  },
  {
    id: "4539",
    sura: "46",
    VerseIDAr: "29",
    ayatAR:
      "وَإِذْ صَرَفْنَا إِلَيْكَ نَفَرًا مِنَ الْجِنِّ يَسْتَمِعُونَ الْقُرْآنَ فَلَمَّا حَضَرُوهُ قَالُوا أَنْصِتُوا ۖ فَلَمَّا قُضِيَ وَلَّوْا إِلَىٰ قَوْمِهِمْ مُنْذِرِينَ",
  },
  {
    id: "4540",
    sura: "46",
    VerseIDAr: "30",
    ayatAR:
      "قَالُوا يَا قَوْمَنَا إِنَّا سَمِعْنَا كِتَابًا أُنْزِلَ مِنْ بَعْدِ مُوسَىٰ مُصَدِّقًا لِمَا بَيْنَ يَدَيْهِ يَهْدِي إِلَى الْحَقِّ وَإِلَىٰ طَرِيقٍ مُسْتَقِيمٍ",
  },
  {
    id: "4541",
    sura: "46",
    VerseIDAr: "31",
    ayatAR:
      "يَا قَوْمَنَا أَجِيبُوا دَاعِيَ اللَّهِ وَآمِنُوا بِهِ يَغْفِرْ لَكُمْ مِنْ ذُنُوبِكُمْ وَيُجِرْكُمْ مِنْ عَذَابٍ أَلِيمٍ",
  },
  {
    id: "4542",
    sura: "46",
    VerseIDAr: "32",
    ayatAR:
      "وَمَنْ لَا يُجِبْ دَاعِيَ اللَّهِ فَلَيْسَ بِمُعْجِزٍ فِي الْأَرْضِ وَلَيْسَ لَهُ مِنْ دُونِهِ أَوْلِيَاءُ ۚ أُولَٰئِكَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "4543",
    sura: "46",
    VerseIDAr: "33",
    ayatAR:
      "أَوَلَمْ يَرَوْا أَنَّ اللَّهَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ وَلَمْ يَعْيَ بِخَلْقِهِنَّ بِقَادِرٍ عَلَىٰ أَنْ يُحْيِيَ الْمَوْتَىٰ ۚ بَلَىٰ إِنَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "4544",
    sura: "46",
    VerseIDAr: "34",
    ayatAR:
      "وَيَوْمَ يُعْرَضُ الَّذِينَ كَفَرُوا عَلَى النَّارِ أَلَيْسَ هَٰذَا بِالْحَقِّ ۖ قَالُوا بَلَىٰ وَرَبِّنَا ۚ قَالَ فَذُوقُوا الْعَذَابَ بِمَا كُنْتُمْ تَكْفُرُونَ",
  },
  {
    id: "4545",
    sura: "46",
    VerseIDAr: "35",
    ayatAR:
      "فَاصْبِرْ كَمَا صَبَرَ أُولُو الْعَزْمِ مِنَ الرُّسُلِ وَلَا تَسْتَعْجِلْ لَهُمْ ۚ كَأَنَّهُمْ يَوْمَ يَرَوْنَ مَا يُوعَدُونَ لَمْ يَلْبَثُوا إِلَّا سَاعَةً مِنْ نَهَارٍ ۚ بَلَاغٌ ۚ فَهَلْ يُهْلَكُ إِلَّا الْقَوْمُ الْفَاسِقُونَ",
  },
  {
    id: "4546",
    sura: "47",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الَّذِينَ كَفَرُوا وَصَدُّوا عَنْ سَبِيلِ اللَّهِ أَضَلَّ أَعْمَالَهُمْ",
  },
  {
    id: "4547",
    sura: "47",
    VerseIDAr: "2",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَآمَنُوا بِمَا نُزِّلَ عَلَىٰ مُحَمَّدٍ وَهُوَ الْحَقُّ مِنْ رَبِّهِمْ ۙ كَفَّرَ عَنْهُمْ سَيِّئَاتِهِمْ وَأَصْلَحَ بَالَهُمْ",
  },
  {
    id: "4548",
    sura: "47",
    VerseIDAr: "3",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ الَّذِينَ كَفَرُوا اتَّبَعُوا الْبَاطِلَ وَأَنَّ الَّذِينَ آمَنُوا اتَّبَعُوا الْحَقَّ مِنْ رَبِّهِمْ ۚ كَذَٰلِكَ يَضْرِبُ اللَّهُ لِلنَّاسِ أَمْثَالَهُمْ",
  },
  {
    id: "4549",
    sura: "47",
    VerseIDAr: "4",
    ayatAR:
      "فَإِذَا لَقِيتُمُ الَّذِينَ كَفَرُوا فَضَرْبَ الرِّقَابِ حَتَّىٰ إِذَا أَثْخَنْتُمُوهُمْ فَشُدُّوا الْوَثَاقَ فَإِمَّا مَنًّا بَعْدُ وَإِمَّا فِدَاءً حَتَّىٰ تَضَعَ الْحَرْبُ أَوْزَارَهَا ۚ ذَٰلِكَ وَلَوْ يَشَاءُ اللَّهُ لَانْتَصَرَ مِنْهُمْ وَلَٰكِنْ لِيَبْلُوَ بَعْضَكُمْ بِبَعْضٍ ۗ وَالَّذِينَ قُتِلُوا فِي سَبِيلِ اللَّهِ فَلَنْ يُضِلَّ أَعْمَالَهُمْ",
  },
  {
    id: "4550",
    sura: "47",
    VerseIDAr: "5",
    ayatAR: "سَيَهْدِيهِمْ وَيُصْلِحُ بَالَهُمْ",
  },
  {
    id: "4551",
    sura: "47",
    VerseIDAr: "6",
    ayatAR: "وَيُدْخِلُهُمُ الْجَنَّةَ عَرَّفَهَا لَهُمْ",
  },
  {
    id: "4552",
    sura: "47",
    VerseIDAr: "7",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنْ تَنْصُرُوا اللَّهَ يَنْصُرْكُمْ وَيُثَبِّتْ أَقْدَامَكُمْ",
  },
  {
    id: "4553",
    sura: "47",
    VerseIDAr: "8",
    ayatAR: "وَالَّذِينَ كَفَرُوا فَتَعْسًا لَهُمْ وَأَضَلَّ أَعْمَالَهُمْ",
  },
  {
    id: "4554",
    sura: "47",
    VerseIDAr: "9",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ كَرِهُوا مَا أَنْزَلَ اللَّهُ فَأَحْبَطَ أَعْمَالَهُمْ",
  },
  {
    id: "4555",
    sura: "47",
    VerseIDAr: "10",
    ayatAR:
      "أَفَلَمْ يَسِيرُوا فِي الْأَرْضِ فَيَنْظُرُوا كَيْفَ كَانَ عَاقِبَةُ الَّذِينَ مِنْ قَبْلِهِمْ ۚ دَمَّرَ اللَّهُ عَلَيْهِمْ ۖ وَلِلْكَافِرِينَ أَمْثَالُهَا",
  },
  {
    id: "4556",
    sura: "47",
    VerseIDAr: "11",
    ayatAR:
      "ذَٰلِكَ بِأَنَّ اللَّهَ مَوْلَى الَّذِينَ آمَنُوا وَأَنَّ الْكَافِرِينَ لَا مَوْلَىٰ لَهُمْ",
  },
  {
    id: "4557",
    sura: "47",
    VerseIDAr: "12",
    ayatAR:
      "إِنَّ اللَّهَ يُدْخِلُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ وَالَّذِينَ كَفَرُوا يَتَمَتَّعُونَ وَيَأْكُلُونَ كَمَا تَأْكُلُ الْأَنْعَامُ وَالنَّارُ مَثْوًى لَهُمْ",
  },
  {
    id: "4558",
    sura: "47",
    VerseIDAr: "13",
    ayatAR:
      "وَكَأَيِّنْ مِنْ قَرْيَةٍ هِيَ أَشَدُّ قُوَّةً مِنْ قَرْيَتِكَ الَّتِي أَخْرَجَتْكَ أَهْلَكْنَاهُمْ فَلَا نَاصِرَ لَهُمْ",
  },
  {
    id: "4559",
    sura: "47",
    VerseIDAr: "14",
    ayatAR:
      "أَفَمَنْ كَانَ عَلَىٰ بَيِّنَةٍ مِنْ رَبِّهِ كَمَنْ زُيِّنَ لَهُ سُوءُ عَمَلِهِ وَاتَّبَعُوا أَهْوَاءَهُمْ",
  },
  {
    id: "4560",
    sura: "47",
    VerseIDAr: "15",
    ayatAR:
      "مَثَلُ الْجَنَّةِ الَّتِي وُعِدَ الْمُتَّقُونَ ۖ فِيهَا أَنْهَارٌ مِنْ مَاءٍ غَيْرِ آسِنٍ وَأَنْهَارٌ مِنْ لَبَنٍ لَمْ يَتَغَيَّرْ طَعْمُهُ وَأَنْهَارٌ مِنْ خَمْرٍ لَذَّةٍ لِلشَّارِبِينَ وَأَنْهَارٌ مِنْ عَسَلٍ مُصَفًّى ۖ وَلَهُمْ فِيهَا مِنْ كُلِّ الثَّمَرَاتِ وَمَغْفِرَةٌ مِنْ رَبِّهِمْ ۖ كَمَنْ هُوَ خَالِدٌ فِي النَّارِ وَسُقُوا مَاءً حَمِيمًا فَقَطَّعَ أَمْعَاءَهُمْ",
  },
  {
    id: "4561",
    sura: "47",
    VerseIDAr: "16",
    ayatAR:
      "وَمِنْهُمْ مَنْ يَسْتَمِعُ إِلَيْكَ حَتَّىٰ إِذَا خَرَجُوا مِنْ عِنْدِكَ قَالُوا لِلَّذِينَ أُوتُوا الْعِلْمَ مَاذَا قَالَ آنِفًا ۚ أُولَٰئِكَ الَّذِينَ طَبَعَ اللَّهُ عَلَىٰ قُلُوبِهِمْ وَاتَّبَعُوا أَهْوَاءَهُمْ",
  },
  {
    id: "4562",
    sura: "47",
    VerseIDAr: "17",
    ayatAR: "وَالَّذِينَ اهْتَدَوْا زَادَهُمْ هُدًى وَآتَاهُمْ تَقْوَاهُمْ",
  },
  {
    id: "4563",
    sura: "47",
    VerseIDAr: "18",
    ayatAR:
      "فَهَلْ يَنْظُرُونَ إِلَّا السَّاعَةَ أَنْ تَأْتِيَهُمْ بَغْتَةً ۖ فَقَدْ جَاءَ أَشْرَاطُهَا ۚ فَأَنَّىٰ لَهُمْ إِذَا جَاءَتْهُمْ ذِكْرَاهُمْ",
  },
  {
    id: "4564",
    sura: "47",
    VerseIDAr: "19",
    ayatAR:
      "فَاعْلَمْ أَنَّهُ لَا إِلَٰهَ إِلَّا اللَّهُ وَاسْتَغْفِرْ لِذَنْبِكَ وَلِلْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ ۗ وَاللَّهُ يَعْلَمُ مُتَقَلَّبَكُمْ وَمَثْوَاكُمْ",
  },
  {
    id: "4565",
    sura: "47",
    VerseIDAr: "20",
    ayatAR:
      "وَيَقُولُ الَّذِينَ آمَنُوا لَوْلَا نُزِّلَتْ سُورَةٌ ۖ فَإِذَا أُنْزِلَتْ سُورَةٌ مُحْكَمَةٌ وَذُكِرَ فِيهَا الْقِتَالُ ۙ رَأَيْتَ الَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ يَنْظُرُونَ إِلَيْكَ نَظَرَ الْمَغْشِيِّ عَلَيْهِ مِنَ الْمَوْتِ ۖ فَأَوْلَىٰ لَهُمْ",
  },
  {
    id: "4566",
    sura: "47",
    VerseIDAr: "21",
    ayatAR:
      "طَاعَةٌ وَقَوْلٌ مَعْرُوفٌ ۚ فَإِذَا عَزَمَ الْأَمْرُ فَلَوْ صَدَقُوا اللَّهَ لَكَانَ خَيْرًا لَهُمْ",
  },
  {
    id: "4567",
    sura: "47",
    VerseIDAr: "22",
    ayatAR:
      "فَهَلْ عَسَيْتُمْ إِنْ تَوَلَّيْتُمْ أَنْ تُفْسِدُوا فِي الْأَرْضِ وَتُقَطِّعُوا أَرْحَامَكُمْ",
  },
  {
    id: "4568",
    sura: "47",
    VerseIDAr: "23",
    ayatAR:
      "أُولَٰئِكَ الَّذِينَ لَعَنَهُمُ اللَّهُ فَأَصَمَّهُمْ وَأَعْمَىٰ أَبْصَارَهُمْ",
  },
  {
    id: "4569",
    sura: "47",
    VerseIDAr: "24",
    ayatAR:
      "أَفَلَا يَتَدَبَّرُونَ الْقُرْآنَ أَمْ عَلَىٰ قُلُوبٍ أَقْفَالُهَا",
  },
  {
    id: "4570",
    sura: "47",
    VerseIDAr: "25",
    ayatAR:
      "إِنَّ الَّذِينَ ارْتَدُّوا عَلَىٰ أَدْبَارِهِمْ مِنْ بَعْدِ مَا تَبَيَّنَ لَهُمُ الْهُدَى ۙ الشَّيْطَانُ سَوَّلَ لَهُمْ وَأَمْلَىٰ لَهُمْ",
  },
  {
    id: "4571",
    sura: "47",
    VerseIDAr: "26",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ قَالُوا لِلَّذِينَ كَرِهُوا مَا نَزَّلَ اللَّهُ سَنُطِيعُكُمْ فِي بَعْضِ الْأَمْرِ ۖ وَاللَّهُ يَعْلَمُ إِسْرَارَهُمْ",
  },
  {
    id: "4572",
    sura: "47",
    VerseIDAr: "27",
    ayatAR:
      "فَكَيْفَ إِذَا تَوَفَّتْهُمُ الْمَلَائِكَةُ يَضْرِبُونَ وُجُوهَهُمْ وَأَدْبَارَهُمْ",
  },
  {
    id: "4573",
    sura: "47",
    VerseIDAr: "28",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمُ اتَّبَعُوا مَا أَسْخَطَ اللَّهَ وَكَرِهُوا رِضْوَانَهُ فَأَحْبَطَ أَعْمَالَهُمْ",
  },
  {
    id: "4574",
    sura: "47",
    VerseIDAr: "29",
    ayatAR:
      "أَمْ حَسِبَ الَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ أَنْ لَنْ يُخْرِجَ اللَّهُ أَضْغَانَهُمْ",
  },
  {
    id: "4575",
    sura: "47",
    VerseIDAr: "30",
    ayatAR:
      "وَلَوْ نَشَاءُ لَأَرَيْنَاكَهُمْ فَلَعَرَفْتَهُمْ بِسِيمَاهُمْ ۚ وَلَتَعْرِفَنَّهُمْ فِي لَحْنِ الْقَوْلِ ۚ وَاللَّهُ يَعْلَمُ أَعْمَالَكُمْ",
  },
  {
    id: "4576",
    sura: "47",
    VerseIDAr: "31",
    ayatAR:
      "وَلَنَبْلُوَنَّكُمْ حَتَّىٰ نَعْلَمَ الْمُجَاهِدِينَ مِنْكُمْ وَالصَّابِرِينَ وَنَبْلُوَ أَخْبَارَكُمْ",
  },
  {
    id: "4577",
    sura: "47",
    VerseIDAr: "32",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَصَدُّوا عَنْ سَبِيلِ اللَّهِ وَشَاقُّوا الرَّسُولَ مِنْ بَعْدِ مَا تَبَيَّنَ لَهُمُ الْهُدَىٰ لَنْ يَضُرُّوا اللَّهَ شَيْئًا وَسَيُحْبِطُ أَعْمَالَهُمْ",
  },
  {
    id: "4578",
    sura: "47",
    VerseIDAr: "33",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا أَطِيعُوا اللَّهَ وَأَطِيعُوا الرَّسُولَ وَلَا تُبْطِلُوا أَعْمَالَكُمْ",
  },
  {
    id: "4579",
    sura: "47",
    VerseIDAr: "34",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا وَصَدُّوا عَنْ سَبِيلِ اللَّهِ ثُمَّ مَاتُوا وَهُمْ كُفَّارٌ فَلَنْ يَغْفِرَ اللَّهُ لَهُمْ",
  },
  {
    id: "4580",
    sura: "47",
    VerseIDAr: "35",
    ayatAR:
      "فَلَا تَهِنُوا وَتَدْعُوا إِلَى السَّلْمِ وَأَنْتُمُ الْأَعْلَوْنَ وَاللَّهُ مَعَكُمْ وَلَنْ يَتِرَكُمْ أَعْمَالَكُمْ",
  },
  {
    id: "4581",
    sura: "47",
    VerseIDAr: "36",
    ayatAR:
      "إِنَّمَا الْحَيَاةُ الدُّنْيَا لَعِبٌ وَلَهْوٌ ۚ وَإِنْ تُؤْمِنُوا وَتَتَّقُوا يُؤْتِكُمْ أُجُورَكُمْ وَلَا يَسْأَلْكُمْ أَمْوَالَكُمْ",
  },
  {
    id: "4582",
    sura: "47",
    VerseIDAr: "37",
    ayatAR:
      "إِنْ يَسْأَلْكُمُوهَا فَيُحْفِكُمْ تَبْخَلُوا وَيُخْرِجْ أَضْغَانَكُمْ",
  },
  {
    id: "4583",
    sura: "47",
    VerseIDAr: "38",
    ayatAR:
      "هَا أَنْتُمْ هَٰؤُلَاءِ تُدْعَوْنَ لِتُنْفِقُوا فِي سَبِيلِ اللَّهِ فَمِنْكُمْ مَنْ يَبْخَلُ ۖ وَمَنْ يَبْخَلْ فَإِنَّمَا يَبْخَلُ عَنْ نَفْسِهِ ۚ وَاللَّهُ الْغَنِيُّ وَأَنْتُمُ الْفُقَرَاءُ ۚ وَإِنْ تَتَوَلَّوْا يَسْتَبْدِلْ قَوْمًا غَيْرَكُمْ ثُمَّ لَا يَكُونُوا أَمْثَالَكُمْ",
  },
  {
    id: "4584",
    sura: "48",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِنَّا فَتَحْنَا لَكَ فَتْحًا مُبِينًا",
  },
  {
    id: "4585",
    sura: "48",
    VerseIDAr: "2",
    ayatAR:
      "لِيَغْفِرَ لَكَ اللَّهُ مَا تَقَدَّمَ مِنْ ذَنْبِكَ وَمَا تَأَخَّرَ وَيُتِمَّ نِعْمَتَهُ عَلَيْكَ وَيَهْدِيَكَ صِرَاطًا مُسْتَقِيمًا",
  },
  {
    id: "4586",
    sura: "48",
    VerseIDAr: "3",
    ayatAR: "وَيَنْصُرَكَ اللَّهُ نَصْرًا عَزِيزًا",
  },
  {
    id: "4587",
    sura: "48",
    VerseIDAr: "4",
    ayatAR:
      "هُوَ الَّذِي أَنْزَلَ السَّكِينَةَ فِي قُلُوبِ الْمُؤْمِنِينَ لِيَزْدَادُوا إِيمَانًا مَعَ إِيمَانِهِمْ ۗ وَلِلَّهِ جُنُودُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَكَانَ اللَّهُ عَلِيمًا حَكِيمًا",
  },
  {
    id: "4588",
    sura: "48",
    VerseIDAr: "5",
    ayatAR:
      "لِيُدْخِلَ الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا وَيُكَفِّرَ عَنْهُمْ سَيِّئَاتِهِمْ ۚ وَكَانَ ذَٰلِكَ عِنْدَ اللَّهِ فَوْزًا عَظِيمًا",
  },
  {
    id: "4589",
    sura: "48",
    VerseIDAr: "6",
    ayatAR:
      "وَيُعَذِّبَ الْمُنَافِقِينَ وَالْمُنَافِقَاتِ وَالْمُشْرِكِينَ وَالْمُشْرِكَاتِ الظَّانِّينَ بِاللَّهِ ظَنَّ السَّوْءِ ۚ عَلَيْهِمْ دَائِرَةُ السَّوْءِ ۖ وَغَضِبَ اللَّهُ عَلَيْهِمْ وَلَعَنَهُمْ وَأَعَدَّ لَهُمْ جَهَنَّمَ ۖ وَسَاءَتْ مَصِيرًا",
  },
  {
    id: "4590",
    sura: "48",
    VerseIDAr: "7",
    ayatAR:
      "وَلِلَّهِ جُنُودُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَكَانَ اللَّهُ عَزِيزًا حَكِيمًا",
  },
  {
    id: "4591",
    sura: "48",
    VerseIDAr: "8",
    ayatAR: "إِنَّا أَرْسَلْنَاكَ شَاهِدًا وَمُبَشِّرًا وَنَذِيرًا",
  },
  {
    id: "4592",
    sura: "48",
    VerseIDAr: "9",
    ayatAR:
      "لِتُؤْمِنُوا بِاللَّهِ وَرَسُولِهِ وَتُعَزِّرُوهُ وَتُوَقِّرُوهُ وَتُسَبِّحُوهُ بُكْرَةً وَأَصِيلًا",
  },
  {
    id: "4593",
    sura: "48",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّ الَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ اللَّهَ يَدُ اللَّهِ فَوْقَ أَيْدِيهِمْ ۚ فَمَنْ نَكَثَ فَإِنَّمَا يَنْكُثُ عَلَىٰ نَفْسِهِ ۖ وَمَنْ أَوْفَىٰ بِمَا عَاهَدَ عَلَيْهُ اللَّهَ فَسَيُؤْتِيهِ أَجْرًا عَظِيمًا",
  },
  {
    id: "4594",
    sura: "48",
    VerseIDAr: "11",
    ayatAR:
      "سَيَقُولُ لَكَ الْمُخَلَّفُونَ مِنَ الْأَعْرَابِ شَغَلَتْنَا أَمْوَالُنَا وَأَهْلُونَا فَاسْتَغْفِرْ لَنَا ۚ يَقُولُونَ بِأَلْسِنَتِهِمْ مَا لَيْسَ فِي قُلُوبِهِمْ ۚ قُلْ فَمَنْ يَمْلِكُ لَكُمْ مِنَ اللَّهِ شَيْئًا إِنْ أَرَادَ بِكُمْ ضَرًّا أَوْ أَرَادَ بِكُمْ نَفْعًا ۚ بَلْ كَانَ اللَّهُ بِمَا تَعْمَلُونَ خَبِيرًا",
  },
  {
    id: "4595",
    sura: "48",
    VerseIDAr: "12",
    ayatAR:
      "بَلْ ظَنَنْتُمْ أَنْ لَنْ يَنْقَلِبَ الرَّسُولُ وَالْمُؤْمِنُونَ إِلَىٰ أَهْلِيهِمْ أَبَدًا وَزُيِّنَ ذَٰلِكَ فِي قُلُوبِكُمْ وَظَنَنْتُمْ ظَنَّ السَّوْءِ وَكُنْتُمْ قَوْمًا بُورًا",
  },
  {
    id: "4596",
    sura: "48",
    VerseIDAr: "13",
    ayatAR:
      "وَمَنْ لَمْ يُؤْمِنْ بِاللَّهِ وَرَسُولِهِ فَإِنَّا أَعْتَدْنَا لِلْكَافِرِينَ سَعِيرًا",
  },
  {
    id: "4597",
    sura: "48",
    VerseIDAr: "14",
    ayatAR:
      "وَلِلَّهِ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۚ يَغْفِرُ لِمَنْ يَشَاءُ وَيُعَذِّبُ مَنْ يَشَاءُ ۚ وَكَانَ اللَّهُ غَفُورًا رَحِيمًا",
  },
  {
    id: "4598",
    sura: "48",
    VerseIDAr: "15",
    ayatAR:
      "سَيَقُولُ الْمُخَلَّفُونَ إِذَا انْطَلَقْتُمْ إِلَىٰ مَغَانِمَ لِتَأْخُذُوهَا ذَرُونَا نَتَّبِعْكُمْ ۖ يُرِيدُونَ أَنْ يُبَدِّلُوا كَلَامَ اللَّهِ ۚ قُلْ لَنْ تَتَّبِعُونَا كَذَٰلِكُمْ قَالَ اللَّهُ مِنْ قَبْلُ ۖ فَسَيَقُولُونَ بَلْ تَحْسُدُونَنَا ۚ بَلْ كَانُوا لَا يَفْقَهُونَ إِلَّا قَلِيلًا",
  },
  {
    id: "4599",
    sura: "48",
    VerseIDAr: "16",
    ayatAR:
      "قُلْ لِلْمُخَلَّفِينَ مِنَ الْأَعْرَابِ سَتُدْعَوْنَ إِلَىٰ قَوْمٍ أُولِي بَأْسٍ شَدِيدٍ تُقَاتِلُونَهُمْ أَوْ يُسْلِمُونَ ۖ فَإِنْ تُطِيعُوا يُؤْتِكُمُ اللَّهُ أَجْرًا حَسَنًا ۖ وَإِنْ تَتَوَلَّوْا كَمَا تَوَلَّيْتُمْ مِنْ قَبْلُ يُعَذِّبْكُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "4600",
    sura: "48",
    VerseIDAr: "17",
    ayatAR:
      "لَيْسَ عَلَى الْأَعْمَىٰ حَرَجٌ وَلَا عَلَى الْأَعْرَجِ حَرَجٌ وَلَا عَلَى الْمَرِيضِ حَرَجٌ ۗ وَمَنْ يُطِعِ اللَّهَ وَرَسُولَهُ يُدْخِلْهُ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۖ وَمَنْ يَتَوَلَّ يُعَذِّبْهُ عَذَابًا أَلِيمًا",
  },
  {
    id: "4601",
    sura: "48",
    VerseIDAr: "18",
    ayatAR:
      "لَقَدْ رَضِيَ اللَّهُ عَنِ الْمُؤْمِنِينَ إِذْ يُبَايِعُونَكَ تَحْتَ الشَّجَرَةِ فَعَلِمَ مَا فِي قُلُوبِهِمْ فَأَنْزَلَ السَّكِينَةَ عَلَيْهِمْ وَأَثَابَهُمْ فَتْحًا قَرِيبًا",
  },
  {
    id: "4602",
    sura: "48",
    VerseIDAr: "19",
    ayatAR:
      "وَمَغَانِمَ كَثِيرَةً يَأْخُذُونَهَا ۗ وَكَانَ اللَّهُ عَزِيزًا حَكِيمًا",
  },
  {
    id: "4603",
    sura: "48",
    VerseIDAr: "20",
    ayatAR:
      "وَعَدَكُمُ اللَّهُ مَغَانِمَ كَثِيرَةً تَأْخُذُونَهَا فَعَجَّلَ لَكُمْ هَٰذِهِ وَكَفَّ أَيْدِيَ النَّاسِ عَنْكُمْ وَلِتَكُونَ آيَةً لِلْمُؤْمِنِينَ وَيَهْدِيَكُمْ صِرَاطًا مُسْتَقِيمًا",
  },
  {
    id: "4604",
    sura: "48",
    VerseIDAr: "21",
    ayatAR:
      "وَأُخْرَىٰ لَمْ تَقْدِرُوا عَلَيْهَا قَدْ أَحَاطَ اللَّهُ بِهَا ۚ وَكَانَ اللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرًا",
  },
  {
    id: "4605",
    sura: "48",
    VerseIDAr: "22",
    ayatAR:
      "وَلَوْ قَاتَلَكُمُ الَّذِينَ كَفَرُوا لَوَلَّوُا الْأَدْبَارَ ثُمَّ لَا يَجِدُونَ وَلِيًّا وَلَا نَصِيرًا",
  },
  {
    id: "4606",
    sura: "48",
    VerseIDAr: "23",
    ayatAR:
      "سُنَّةَ اللَّهِ الَّتِي قَدْ خَلَتْ مِنْ قَبْلُ ۖ وَلَنْ تَجِدَ لِسُنَّةِ اللَّهِ تَبْدِيلًا",
  },
  {
    id: "4607",
    sura: "48",
    VerseIDAr: "24",
    ayatAR:
      "وَهُوَ الَّذِي كَفَّ أَيْدِيَهُمْ عَنْكُمْ وَأَيْدِيَكُمْ عَنْهُمْ بِبَطْنِ مَكَّةَ مِنْ بَعْدِ أَنْ أَظْفَرَكُمْ عَلَيْهِمْ ۚ وَكَانَ اللَّهُ بِمَا تَعْمَلُونَ بَصِيرًا",
  },
  {
    id: "4608",
    sura: "48",
    VerseIDAr: "25",
    ayatAR:
      "هُمُ الَّذِينَ كَفَرُوا وَصَدُّوكُمْ عَنِ الْمَسْجِدِ الْحَرَامِ وَالْهَدْيَ مَعْكُوفًا أَنْ يَبْلُغَ مَحِلَّهُ ۚ وَلَوْلَا رِجَالٌ مُؤْمِنُونَ وَنِسَاءٌ مُؤْمِنَاتٌ لَمْ تَعْلَمُوهُمْ أَنْ تَطَئُوهُمْ فَتُصِيبَكُمْ مِنْهُمْ مَعَرَّةٌ بِغَيْرِ عِلْمٍ ۖ لِيُدْخِلَ اللَّهُ فِي رَحْمَتِهِ مَنْ يَشَاءُ ۚ لَوْ تَزَيَّلُوا لَعَذَّبْنَا الَّذِينَ كَفَرُوا مِنْهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "4609",
    sura: "48",
    VerseIDAr: "26",
    ayatAR:
      "إِذْ جَعَلَ الَّذِينَ كَفَرُوا فِي قُلُوبِهِمُ الْحَمِيَّةَ حَمِيَّةَ الْجَاهِلِيَّةِ فَأَنْزَلَ اللَّهُ سَكِينَتَهُ عَلَىٰ رَسُولِهِ وَعَلَى الْمُؤْمِنِينَ وَأَلْزَمَهُمْ كَلِمَةَ التَّقْوَىٰ وَكَانُوا أَحَقَّ بِهَا وَأَهْلَهَا ۚ وَكَانَ اللَّهُ بِكُلِّ شَيْءٍ عَلِيمًا",
  },
  {
    id: "4610",
    sura: "48",
    VerseIDAr: "27",
    ayatAR:
      "لَقَدْ صَدَقَ اللَّهُ رَسُولَهُ الرُّؤْيَا بِالْحَقِّ ۖ لَتَدْخُلُنَّ الْمَسْجِدَ الْحَرَامَ إِنْ شَاءَ اللَّهُ آمِنِينَ مُحَلِّقِينَ رُءُوسَكُمْ وَمُقَصِّرِينَ لَا تَخَافُونَ ۖ فَعَلِمَ مَا لَمْ تَعْلَمُوا فَجَعَلَ مِنْ دُونِ ذَٰلِكَ فَتْحًا قَرِيبًا",
  },
  {
    id: "4611",
    sura: "48",
    VerseIDAr: "28",
    ayatAR:
      "هُوَ الَّذِي أَرْسَلَ رَسُولَهُ بِالْهُدَىٰ وَدِينِ الْحَقِّ لِيُظْهِرَهُ عَلَى الدِّينِ كُلِّهِ ۚ وَكَفَىٰ بِاللَّهِ شَهِيدًا",
  },
  {
    id: "4612",
    sura: "48",
    VerseIDAr: "29",
    ayatAR:
      "مُحَمَّدٌ رَسُولُ اللَّهِ ۚ وَالَّذِينَ مَعَهُ أَشِدَّاءُ عَلَى الْكُفَّارِ رُحَمَاءُ بَيْنَهُمْ ۖ تَرَاهُمْ رُكَّعًا سُجَّدًا يَبْتَغُونَ فَضْلًا مِنَ اللَّهِ وَرِضْوَانًا ۖ سِيمَاهُمْ فِي وُجُوهِهِمْ مِنْ أَثَرِ السُّجُودِ ۚ ذَٰلِكَ مَثَلُهُمْ فِي التَّوْرَاةِ ۚ وَمَثَلُهُمْ فِي الْإِنْجِيلِ كَزَرْعٍ أَخْرَجَ شَطْأَهُ فَآزَرَهُ فَاسْتَغْلَظَ فَاسْتَوَىٰ عَلَىٰ سُوقِهِ يُعْجِبُ الزُّرَّاعَ لِيَغِيظَ بِهِمُ الْكُفَّارَ ۗ وَعَدَ اللَّهُ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ مِنْهُمْ مَغْفِرَةً وَأَجْرًا عَظِيمًا",
  },
  {
    id: "4613",
    sura: "49",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تُقَدِّمُوا بَيْنَ يَدَيِ اللَّهِ وَرَسُولِهِ ۖ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ سَمِيعٌ عَلِيمٌ",
  },
  {
    id: "4614",
    sura: "49",
    VerseIDAr: "2",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَرْفَعُوا أَصْوَاتَكُمْ فَوْقَ صَوْتِ النَّبِيِّ وَلَا تَجْهَرُوا لَهُ بِالْقَوْلِ كَجَهْرِ بَعْضِكُمْ لِبَعْضٍ أَنْ تَحْبَطَ أَعْمَالُكُمْ وَأَنْتُمْ لَا تَشْعُرُونَ",
  },
  {
    id: "4615",
    sura: "49",
    VerseIDAr: "3",
    ayatAR:
      "إِنَّ الَّذِينَ يَغُضُّونَ أَصْوَاتَهُمْ عِنْدَ رَسُولِ اللَّهِ أُولَٰئِكَ الَّذِينَ امْتَحَنَ اللَّهُ قُلُوبَهُمْ لِلتَّقْوَىٰ ۚ لَهُمْ مَغْفِرَةٌ وَأَجْرٌ عَظِيمٌ",
  },
  {
    id: "4616",
    sura: "49",
    VerseIDAr: "4",
    ayatAR:
      "إِنَّ الَّذِينَ يُنَادُونَكَ مِنْ وَرَاءِ الْحُجُرَاتِ أَكْثَرُهُمْ لَا يَعْقِلُونَ",
  },
  {
    id: "4617",
    sura: "49",
    VerseIDAr: "5",
    ayatAR:
      "وَلَوْ أَنَّهُمْ صَبَرُوا حَتَّىٰ تَخْرُجَ إِلَيْهِمْ لَكَانَ خَيْرًا لَهُمْ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "4618",
    sura: "49",
    VerseIDAr: "6",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنْ جَاءَكُمْ فَاسِقٌ بِنَبَإٍ فَتَبَيَّنُوا أَنْ تُصِيبُوا قَوْمًا بِجَهَالَةٍ فَتُصْبِحُوا عَلَىٰ مَا فَعَلْتُمْ نَادِمِينَ",
  },
  {
    id: "4619",
    sura: "49",
    VerseIDAr: "7",
    ayatAR:
      "وَاعْلَمُوا أَنَّ فِيكُمْ رَسُولَ اللَّهِ ۚ لَوْ يُطِيعُكُمْ فِي كَثِيرٍ مِنَ الْأَمْرِ لَعَنِتُّمْ وَلَٰكِنَّ اللَّهَ حَبَّبَ إِلَيْكُمُ الْإِيمَانَ وَزَيَّنَهُ فِي قُلُوبِكُمْ وَكَرَّهَ إِلَيْكُمُ الْكُفْرَ وَالْفُسُوقَ وَالْعِصْيَانَ ۚ أُولَٰئِكَ هُمُ الرَّاشِدُونَ",
  },
  {
    id: "4620",
    sura: "49",
    VerseIDAr: "8",
    ayatAR: "فَضْلًا مِنَ اللَّهِ وَنِعْمَةً ۚ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "4621",
    sura: "49",
    VerseIDAr: "9",
    ayatAR:
      "وَإِنْ طَائِفَتَانِ مِنَ الْمُؤْمِنِينَ اقْتَتَلُوا فَأَصْلِحُوا بَيْنَهُمَا ۖ فَإِنْ بَغَتْ إِحْدَاهُمَا عَلَى الْأُخْرَىٰ فَقَاتِلُوا الَّتِي تَبْغِي حَتَّىٰ تَفِيءَ إِلَىٰ أَمْرِ اللَّهِ ۚ فَإِنْ فَاءَتْ فَأَصْلِحُوا بَيْنَهُمَا بِالْعَدْلِ وَأَقْسِطُوا ۖ إِنَّ اللَّهَ يُحِبُّ الْمُقْسِطِينَ",
  },
  {
    id: "4622",
    sura: "49",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّمَا الْمُؤْمِنُونَ إِخْوَةٌ فَأَصْلِحُوا بَيْنَ أَخَوَيْكُمْ ۚ وَاتَّقُوا اللَّهَ لَعَلَّكُمْ تُرْحَمُونَ",
  },
  {
    id: "4623",
    sura: "49",
    VerseIDAr: "11",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا يَسْخَرْ قَوْمٌ مِنْ قَوْمٍ عَسَىٰ أَنْ يَكُونُوا خَيْرًا مِنْهُمْ وَلَا نِسَاءٌ مِنْ نِسَاءٍ عَسَىٰ أَنْ يَكُنَّ خَيْرًا مِنْهُنَّ ۖ وَلَا تَلْمِزُوا أَنْفُسَكُمْ وَلَا تَنَابَزُوا بِالْأَلْقَابِ ۖ بِئْسَ الِاسْمُ الْفُسُوقُ بَعْدَ الْإِيمَانِ ۚ وَمَنْ لَمْ يَتُبْ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "4624",
    sura: "49",
    VerseIDAr: "12",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اجْتَنِبُوا كَثِيرًا مِنَ الظَّنِّ إِنَّ بَعْضَ الظَّنِّ إِثْمٌ ۖ وَلَا تَجَسَّسُوا وَلَا يَغْتَبْ بَعْضُكُمْ بَعْضًا ۚ أَيُحِبُّ أَحَدُكُمْ أَنْ يَأْكُلَ لَحْمَ أَخِيهِ مَيْتًا فَكَرِهْتُمُوهُ ۚ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ تَوَّابٌ رَحِيمٌ",
  },
  {
    id: "4625",
    sura: "49",
    VerseIDAr: "13",
    ayatAR:
      "يَا أَيُّهَا النَّاسُ إِنَّا خَلَقْنَاكُمْ مِنْ ذَكَرٍ وَأُنْثَىٰ وَجَعَلْنَاكُمْ شُعُوبًا وَقَبَائِلَ لِتَعَارَفُوا ۚ إِنَّ أَكْرَمَكُمْ عِنْدَ اللَّهِ أَتْقَاكُمْ ۚ إِنَّ اللَّهَ عَلِيمٌ خَبِيرٌ",
  },
  {
    id: "4626",
    sura: "49",
    VerseIDAr: "14",
    ayatAR:
      "قَالَتِ الْأَعْرَابُ آمَنَّا ۖ قُلْ لَمْ تُؤْمِنُوا وَلَٰكِنْ قُولُوا أَسْلَمْنَا وَلَمَّا يَدْخُلِ الْإِيمَانُ فِي قُلُوبِكُمْ ۖ وَإِنْ تُطِيعُوا اللَّهَ وَرَسُولَهُ لَا يَلِتْكُمْ مِنْ أَعْمَالِكُمْ شَيْئًا ۚ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "4627",
    sura: "49",
    VerseIDAr: "15",
    ayatAR:
      "إِنَّمَا الْمُؤْمِنُونَ الَّذِينَ آمَنُوا بِاللَّهِ وَرَسُولِهِ ثُمَّ لَمْ يَرْتَابُوا وَجَاهَدُوا بِأَمْوَالِهِمْ وَأَنْفُسِهِمْ فِي سَبِيلِ اللَّهِ ۚ أُولَٰئِكَ هُمُ الصَّادِقُونَ",
  },
  {
    id: "4628",
    sura: "49",
    VerseIDAr: "16",
    ayatAR:
      "قُلْ أَتُعَلِّمُونَ اللَّهَ بِدِينِكُمْ وَاللَّهُ يَعْلَمُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۚ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "4629",
    sura: "49",
    VerseIDAr: "17",
    ayatAR:
      "يَمُنُّونَ عَلَيْكَ أَنْ أَسْلَمُوا ۖ قُلْ لَا تَمُنُّوا عَلَيَّ إِسْلَامَكُمْ ۖ بَلِ اللَّهُ يَمُنُّ عَلَيْكُمْ أَنْ هَدَاكُمْ لِلْإِيمَانِ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "4630",
    sura: "49",
    VerseIDAr: "18",
    ayatAR:
      "إِنَّ اللَّهَ يَعْلَمُ غَيْبَ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَاللَّهُ بَصِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "4631",
    sura: "50",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ ق ۚ وَالْقُرْآنِ الْمَجِيدِ",
  },
  {
    id: "4632",
    sura: "50",
    VerseIDAr: "2",
    ayatAR:
      "بَلْ عَجِبُوا أَنْ جَاءَهُمْ مُنْذِرٌ مِنْهُمْ فَقَالَ الْكَافِرُونَ هَٰذَا شَيْءٌ عَجِيبٌ",
  },
  {
    id: "4633",
    sura: "50",
    VerseIDAr: "3",
    ayatAR: "أَإِذَا مِتْنَا وَكُنَّا تُرَابًا ۖ ذَٰلِكَ رَجْعٌ بَعِيدٌ",
  },
  {
    id: "4634",
    sura: "50",
    VerseIDAr: "4",
    ayatAR:
      "قَدْ عَلِمْنَا مَا تَنْقُصُ الْأَرْضُ مِنْهُمْ ۖ وَعِنْدَنَا كِتَابٌ حَفِيظٌ",
  },
  {
    id: "4635",
    sura: "50",
    VerseIDAr: "5",
    ayatAR:
      "بَلْ كَذَّبُوا بِالْحَقِّ لَمَّا جَاءَهُمْ فَهُمْ فِي أَمْرٍ مَرِيجٍ",
  },
  {
    id: "4636",
    sura: "50",
    VerseIDAr: "6",
    ayatAR:
      "أَفَلَمْ يَنْظُرُوا إِلَى السَّمَاءِ فَوْقَهُمْ كَيْفَ بَنَيْنَاهَا وَزَيَّنَّاهَا وَمَا لَهَا مِنْ فُرُوجٍ",
  },
  {
    id: "4637",
    sura: "50",
    VerseIDAr: "7",
    ayatAR:
      "وَالْأَرْضَ مَدَدْنَاهَا وَأَلْقَيْنَا فِيهَا رَوَاسِيَ وَأَنْبَتْنَا فِيهَا مِنْ كُلِّ زَوْجٍ بَهِيجٍ",
  },
  {
    id: "4638",
    sura: "50",
    VerseIDAr: "8",
    ayatAR: "تَبْصِرَةً وَذِكْرَىٰ لِكُلِّ عَبْدٍ مُنِيبٍ",
  },
  {
    id: "4639",
    sura: "50",
    VerseIDAr: "9",
    ayatAR:
      "وَنَزَّلْنَا مِنَ السَّمَاءِ مَاءً مُبَارَكًا فَأَنْبَتْنَا بِهِ جَنَّاتٍ وَحَبَّ الْحَصِيدِ",
  },
  {
    id: "4640",
    sura: "50",
    VerseIDAr: "10",
    ayatAR: "وَالنَّخْلَ بَاسِقَاتٍ لَهَا طَلْعٌ نَضِيدٌ",
  },
  {
    id: "4641",
    sura: "50",
    VerseIDAr: "11",
    ayatAR:
      "رِزْقًا لِلْعِبَادِ ۖ وَأَحْيَيْنَا بِهِ بَلْدَةً مَيْتًا ۚ كَذَٰلِكَ الْخُرُوجُ",
  },
  {
    id: "4642",
    sura: "50",
    VerseIDAr: "12",
    ayatAR: "كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍ وَأَصْحَابُ الرَّسِّ وَثَمُودُ",
  },
  {
    id: "4643",
    sura: "50",
    VerseIDAr: "13",
    ayatAR: "وَعَادٌ وَفِرْعَوْنُ وَإِخْوَانُ لُوطٍ",
  },
  {
    id: "4644",
    sura: "50",
    VerseIDAr: "14",
    ayatAR:
      "وَأَصْحَابُ الْأَيْكَةِ وَقَوْمُ تُبَّعٍ ۚ كُلٌّ كَذَّبَ الرُّسُلَ فَحَقَّ وَعِيدِ",
  },
  {
    id: "4645",
    sura: "50",
    VerseIDAr: "15",
    ayatAR:
      "أَفَعَيِينَا بِالْخَلْقِ الْأَوَّلِ ۚ بَلْ هُمْ فِي لَبْسٍ مِنْ خَلْقٍ جَدِيدٍ",
  },
  {
    id: "4646",
    sura: "50",
    VerseIDAr: "16",
    ayatAR:
      "وَلَقَدْ خَلَقْنَا الْإِنْسَانَ وَنَعْلَمُ مَا تُوَسْوِسُ بِهِ نَفْسُهُ ۖ وَنَحْنُ أَقْرَبُ إِلَيْهِ مِنْ حَبْلِ الْوَرِيدِ",
  },
  {
    id: "4647",
    sura: "50",
    VerseIDAr: "17",
    ayatAR:
      "إِذْ يَتَلَقَّى الْمُتَلَقِّيَانِ عَنِ الْيَمِينِ وَعَنِ الشِّمَالِ قَعِيدٌ",
  },
  {
    id: "4648",
    sura: "50",
    VerseIDAr: "18",
    ayatAR: "مَا يَلْفِظُ مِنْ قَوْلٍ إِلَّا لَدَيْهِ رَقِيبٌ عَتِيدٌ",
  },
  {
    id: "4649",
    sura: "50",
    VerseIDAr: "19",
    ayatAR:
      "وَجَاءَتْ سَكْرَةُ الْمَوْتِ بِالْحَقِّ ۖ ذَٰلِكَ مَا كُنْتَ مِنْهُ تَحِيدُ",
  },
  {
    id: "4650",
    sura: "50",
    VerseIDAr: "20",
    ayatAR: "وَنُفِخَ فِي الصُّورِ ۚ ذَٰلِكَ يَوْمُ الْوَعِيدِ",
  },
  {
    id: "4651",
    sura: "50",
    VerseIDAr: "21",
    ayatAR: "وَجَاءَتْ كُلُّ نَفْسٍ مَعَهَا سَائِقٌ وَشَهِيدٌ",
  },
  {
    id: "4652",
    sura: "50",
    VerseIDAr: "22",
    ayatAR:
      "لَقَدْ كُنْتَ فِي غَفْلَةٍ مِنْ هَٰذَا فَكَشَفْنَا عَنْكَ غِطَاءَكَ فَبَصَرُكَ الْيَوْمَ حَدِيدٌ",
  },
  {
    id: "4653",
    sura: "50",
    VerseIDAr: "23",
    ayatAR: "وَقَالَ قَرِينُهُ هَٰذَا مَا لَدَيَّ عَتِيدٌ",
  },
  {
    id: "4654",
    sura: "50",
    VerseIDAr: "24",
    ayatAR: "أَلْقِيَا فِي جَهَنَّمَ كُلَّ كَفَّارٍ عَنِيدٍ",
  },
  {
    id: "4655",
    sura: "50",
    VerseIDAr: "25",
    ayatAR: "مَنَّاعٍ لِلْخَيْرِ مُعْتَدٍ مُرِيبٍ",
  },
  {
    id: "4656",
    sura: "50",
    VerseIDAr: "26",
    ayatAR:
      "الَّذِي جَعَلَ مَعَ اللَّهِ إِلَٰهًا آخَرَ فَأَلْقِيَاهُ فِي الْعَذَابِ الشَّدِيدِ",
  },
  {
    id: "4657",
    sura: "50",
    VerseIDAr: "27",
    ayatAR:
      "قَالَ قَرِينُهُ رَبَّنَا مَا أَطْغَيْتُهُ وَلَٰكِنْ كَانَ فِي ضَلَالٍ بَعِيدٍ",
  },
  {
    id: "4658",
    sura: "50",
    VerseIDAr: "28",
    ayatAR:
      "قَالَ لَا تَخْتَصِمُوا لَدَيَّ وَقَدْ قَدَّمْتُ إِلَيْكُمْ بِالْوَعِيدِ",
  },
  {
    id: "4659",
    sura: "50",
    VerseIDAr: "29",
    ayatAR:
      "مَا يُبَدَّلُ الْقَوْلُ لَدَيَّ وَمَا أَنَا بِظَلَّامٍ لِلْعَبِيدِ",
  },
  {
    id: "4660",
    sura: "50",
    VerseIDAr: "30",
    ayatAR:
      "يَوْمَ نَقُولُ لِجَهَنَّمَ هَلِ امْتَلَأْتِ وَتَقُولُ هَلْ مِنْ مَزِيدٍ",
  },
  {
    id: "4661",
    sura: "50",
    VerseIDAr: "31",
    ayatAR: "وَأُزْلِفَتِ الْجَنَّةُ لِلْمُتَّقِينَ غَيْرَ بَعِيدٍ",
  },
  {
    id: "4662",
    sura: "50",
    VerseIDAr: "32",
    ayatAR: "هَٰذَا مَا تُوعَدُونَ لِكُلِّ أَوَّابٍ حَفِيظٍ",
  },
  {
    id: "4663",
    sura: "50",
    VerseIDAr: "33",
    ayatAR: "مَنْ خَشِيَ الرَّحْمَٰنَ بِالْغَيْبِ وَجَاءَ بِقَلْبٍ مُنِيبٍ",
  },
  {
    id: "4664",
    sura: "50",
    VerseIDAr: "34",
    ayatAR: "ادْخُلُوهَا بِسَلَامٍ ۖ ذَٰلِكَ يَوْمُ الْخُلُودِ",
  },
  {
    id: "4665",
    sura: "50",
    VerseIDAr: "35",
    ayatAR: "لَهُمْ مَا يَشَاءُونَ فِيهَا وَلَدَيْنَا مَزِيدٌ",
  },
  {
    id: "4666",
    sura: "50",
    VerseIDAr: "36",
    ayatAR:
      "وَكَمْ أَهْلَكْنَا قَبْلَهُمْ مِنْ قَرْنٍ هُمْ أَشَدُّ مِنْهُمْ بَطْشًا فَنَقَّبُوا فِي الْبِلَادِ هَلْ مِنْ مَحِيصٍ",
  },
  {
    id: "4667",
    sura: "50",
    VerseIDAr: "37",
    ayatAR:
      "إِنَّ فِي ذَٰلِكَ لَذِكْرَىٰ لِمَنْ كَانَ لَهُ قَلْبٌ أَوْ أَلْقَى السَّمْعَ وَهُوَ شَهِيدٌ",
  },
  {
    id: "4668",
    sura: "50",
    VerseIDAr: "38",
    ayatAR:
      "وَلَقَدْ خَلَقْنَا السَّمَاوَاتِ وَالْأَرْضَ وَمَا بَيْنَهُمَا فِي سِتَّةِ أَيَّامٍ وَمَا مَسَّنَا مِنْ لُغُوبٍ",
  },
  {
    id: "4669",
    sura: "50",
    VerseIDAr: "39",
    ayatAR:
      "فَاصْبِرْ عَلَىٰ مَا يَقُولُونَ وَسَبِّحْ بِحَمْدِ رَبِّكَ قَبْلَ طُلُوعِ الشَّمْسِ وَقَبْلَ الْغُرُوبِ",
  },
  {
    id: "4670",
    sura: "50",
    VerseIDAr: "40",
    ayatAR: "وَمِنَ اللَّيْلِ فَسَبِّحْهُ وَأَدْبَارَ السُّجُودِ",
  },
  {
    id: "4671",
    sura: "50",
    VerseIDAr: "41",
    ayatAR: "وَاسْتَمِعْ يَوْمَ يُنَادِ الْمُنَادِ مِنْ مَكَانٍ قَرِيبٍ",
  },
  {
    id: "4672",
    sura: "50",
    VerseIDAr: "42",
    ayatAR:
      "يَوْمَ يَسْمَعُونَ الصَّيْحَةَ بِالْحَقِّ ۚ ذَٰلِكَ يَوْمُ الْخُرُوجِ",
  },
  {
    id: "4673",
    sura: "50",
    VerseIDAr: "43",
    ayatAR: "إِنَّا نَحْنُ نُحْيِي وَنُمِيتُ وَإِلَيْنَا الْمَصِيرُ",
  },
  {
    id: "4674",
    sura: "50",
    VerseIDAr: "44",
    ayatAR:
      "يَوْمَ تَشَقَّقُ الْأَرْضُ عَنْهُمْ سِرَاعًا ۚ ذَٰلِكَ حَشْرٌ عَلَيْنَا يَسِيرٌ",
  },
  {
    id: "4675",
    sura: "50",
    VerseIDAr: "45",
    ayatAR:
      "نَحْنُ أَعْلَمُ بِمَا يَقُولُونَ ۖ وَمَا أَنْتَ عَلَيْهِمْ بِجَبَّارٍ ۖ فَذَكِّرْ بِالْقُرْآنِ مَنْ يَخَافُ وَعِيدِ",
  },
  {
    id: "4676",
    sura: "51",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالذَّارِيَاتِ ذَرْوًا",
  },
  { id: "4677", sura: "51", VerseIDAr: "2", ayatAR: "فَالْحَامِلَاتِ وِقْرًا" },
  { id: "4678", sura: "51", VerseIDAr: "3", ayatAR: "فَالْجَارِيَاتِ يُسْرًا" },
  {
    id: "4679",
    sura: "51",
    VerseIDAr: "4",
    ayatAR: "فَالْمُقَسِّمَاتِ أَمْرًا",
  },
  {
    id: "4680",
    sura: "51",
    VerseIDAr: "5",
    ayatAR: "إِنَّمَا تُوعَدُونَ لَصَادِقٌ",
  },
  {
    id: "4681",
    sura: "51",
    VerseIDAr: "6",
    ayatAR: "وَإِنَّ الدِّينَ لَوَاقِعٌ",
  },
  {
    id: "4682",
    sura: "51",
    VerseIDAr: "7",
    ayatAR: "وَالسَّمَاءِ ذَاتِ الْحُبُكِ",
  },
  {
    id: "4683",
    sura: "51",
    VerseIDAr: "8",
    ayatAR: "إِنَّكُمْ لَفِي قَوْلٍ مُخْتَلِفٍ",
  },
  {
    id: "4684",
    sura: "51",
    VerseIDAr: "9",
    ayatAR: "يُؤْفَكُ عَنْهُ مَنْ أُفِكَ",
  },
  { id: "4685", sura: "51", VerseIDAr: "10", ayatAR: "قُتِلَ الْخَرَّاصُونَ" },
  {
    id: "4686",
    sura: "51",
    VerseIDAr: "11",
    ayatAR: "الَّذِينَ هُمْ فِي غَمْرَةٍ سَاهُونَ",
  },
  {
    id: "4687",
    sura: "51",
    VerseIDAr: "12",
    ayatAR: "يَسْأَلُونَ أَيَّانَ يَوْمُ الدِّينِ",
  },
  {
    id: "4688",
    sura: "51",
    VerseIDAr: "13",
    ayatAR: "يَوْمَ هُمْ عَلَى النَّارِ يُفْتَنُونَ",
  },
  {
    id: "4689",
    sura: "51",
    VerseIDAr: "14",
    ayatAR: "ذُوقُوا فِتْنَتَكُمْ هَٰذَا الَّذِي كُنْتُمْ بِهِ تَسْتَعْجِلُونَ",
  },
  {
    id: "4690",
    sura: "51",
    VerseIDAr: "15",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي جَنَّاتٍ وَعُيُونٍ",
  },
  {
    id: "4691",
    sura: "51",
    VerseIDAr: "16",
    ayatAR:
      "آخِذِينَ مَا آتَاهُمْ رَبُّهُمْ ۚ إِنَّهُمْ كَانُوا قَبْلَ ذَٰلِكَ مُحْسِنِينَ",
  },
  {
    id: "4692",
    sura: "51",
    VerseIDAr: "17",
    ayatAR: "كَانُوا قَلِيلًا مِنَ اللَّيْلِ مَا يَهْجَعُونَ",
  },
  {
    id: "4693",
    sura: "51",
    VerseIDAr: "18",
    ayatAR: "وَبِالْأَسْحَارِ هُمْ يَسْتَغْفِرُونَ",
  },
  {
    id: "4694",
    sura: "51",
    VerseIDAr: "19",
    ayatAR: "وَفِي أَمْوَالِهِمْ حَقٌّ لِلسَّائِلِ وَالْمَحْرُومِ",
  },
  {
    id: "4695",
    sura: "51",
    VerseIDAr: "20",
    ayatAR: "وَفِي الْأَرْضِ آيَاتٌ لِلْمُوقِنِينَ",
  },
  {
    id: "4696",
    sura: "51",
    VerseIDAr: "21",
    ayatAR: "وَفِي أَنْفُسِكُمْ ۚ أَفَلَا تُبْصِرُونَ",
  },
  {
    id: "4697",
    sura: "51",
    VerseIDAr: "22",
    ayatAR: "وَفِي السَّمَاءِ رِزْقُكُمْ وَمَا تُوعَدُونَ",
  },
  {
    id: "4698",
    sura: "51",
    VerseIDAr: "23",
    ayatAR:
      "فَوَرَبِّ السَّمَاءِ وَالْأَرْضِ إِنَّهُ لَحَقٌّ مِثْلَ مَا أَنَّكُمْ تَنْطِقُونَ",
  },
  {
    id: "4699",
    sura: "51",
    VerseIDAr: "24",
    ayatAR: "هَلْ أَتَاكَ حَدِيثُ ضَيْفِ إِبْرَاهِيمَ الْمُكْرَمِينَ",
  },
  {
    id: "4700",
    sura: "51",
    VerseIDAr: "25",
    ayatAR:
      "إِذْ دَخَلُوا عَلَيْهِ فَقَالُوا سَلَامًا ۖ قَالَ سَلَامٌ قَوْمٌ مُنْكَرُونَ",
  },
  {
    id: "4701",
    sura: "51",
    VerseIDAr: "26",
    ayatAR: "فَرَاغَ إِلَىٰ أَهْلِهِ فَجَاءَ بِعِجْلٍ سَمِينٍ",
  },
  {
    id: "4702",
    sura: "51",
    VerseIDAr: "27",
    ayatAR: "فَقَرَّبَهُ إِلَيْهِمْ قَالَ أَلَا تَأْكُلُونَ",
  },
  {
    id: "4703",
    sura: "51",
    VerseIDAr: "28",
    ayatAR:
      "فَأَوْجَسَ مِنْهُمْ خِيفَةً ۖ قَالُوا لَا تَخَفْ ۖ وَبَشَّرُوهُ بِغُلَامٍ عَلِيمٍ",
  },
  {
    id: "4704",
    sura: "51",
    VerseIDAr: "29",
    ayatAR:
      "فَأَقْبَلَتِ امْرَأَتُهُ فِي صَرَّةٍ فَصَكَّتْ وَجْهَهَا وَقَالَتْ عَجُوزٌ عَقِيمٌ",
  },
  {
    id: "4705",
    sura: "51",
    VerseIDAr: "30",
    ayatAR:
      "قَالُوا كَذَٰلِكِ قَالَ رَبُّكِ ۖ إِنَّهُ هُوَ الْحَكِيمُ الْعَلِيمُ",
  },
  {
    id: "4706",
    sura: "51",
    VerseIDAr: "31",
    ayatAR: "قَالَ فَمَا خَطْبُكُمْ أَيُّهَا الْمُرْسَلُونَ",
  },
  {
    id: "4707",
    sura: "51",
    VerseIDAr: "32",
    ayatAR: "قَالُوا إِنَّا أُرْسِلْنَا إِلَىٰ قَوْمٍ مُجْرِمِينَ",
  },
  {
    id: "4708",
    sura: "51",
    VerseIDAr: "33",
    ayatAR: "لِنُرْسِلَ عَلَيْهِمْ حِجَارَةً مِنْ طِينٍ",
  },
  {
    id: "4709",
    sura: "51",
    VerseIDAr: "34",
    ayatAR: "مُسَوَّمَةً عِنْدَ رَبِّكَ لِلْمُسْرِفِينَ",
  },
  {
    id: "4710",
    sura: "51",
    VerseIDAr: "35",
    ayatAR: "فَأَخْرَجْنَا مَنْ كَانَ فِيهَا مِنَ الْمُؤْمِنِينَ",
  },
  {
    id: "4711",
    sura: "51",
    VerseIDAr: "36",
    ayatAR: "فَمَا وَجَدْنَا فِيهَا غَيْرَ بَيْتٍ مِنَ الْمُسْلِمِينَ",
  },
  {
    id: "4712",
    sura: "51",
    VerseIDAr: "37",
    ayatAR:
      "وَتَرَكْنَا فِيهَا آيَةً لِلَّذِينَ يَخَافُونَ الْعَذَابَ الْأَلِيمَ",
  },
  {
    id: "4713",
    sura: "51",
    VerseIDAr: "38",
    ayatAR:
      "وَفِي مُوسَىٰ إِذْ أَرْسَلْنَاهُ إِلَىٰ فِرْعَوْنَ بِسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "4714",
    sura: "51",
    VerseIDAr: "39",
    ayatAR: "فَتَوَلَّىٰ بِرُكْنِهِ وَقَالَ سَاحِرٌ أَوْ مَجْنُونٌ",
  },
  {
    id: "4715",
    sura: "51",
    VerseIDAr: "40",
    ayatAR:
      "فَأَخَذْنَاهُ وَجُنُودَهُ فَنَبَذْنَاهُمْ فِي الْيَمِّ وَهُوَ مُلِيمٌ",
  },
  {
    id: "4716",
    sura: "51",
    VerseIDAr: "41",
    ayatAR: "وَفِي عَادٍ إِذْ أَرْسَلْنَا عَلَيْهِمُ الرِّيحَ الْعَقِيمَ",
  },
  {
    id: "4717",
    sura: "51",
    VerseIDAr: "42",
    ayatAR:
      "مَا تَذَرُ مِنْ شَيْءٍ أَتَتْ عَلَيْهِ إِلَّا جَعَلَتْهُ كَالرَّمِيمِ",
  },
  {
    id: "4718",
    sura: "51",
    VerseIDAr: "43",
    ayatAR: "وَفِي ثَمُودَ إِذْ قِيلَ لَهُمْ تَمَتَّعُوا حَتَّىٰ حِينٍ",
  },
  {
    id: "4719",
    sura: "51",
    VerseIDAr: "44",
    ayatAR:
      "فَعَتَوْا عَنْ أَمْرِ رَبِّهِمْ فَأَخَذَتْهُمُ الصَّاعِقَةُ وَهُمْ يَنْظُرُونَ",
  },
  {
    id: "4720",
    sura: "51",
    VerseIDAr: "45",
    ayatAR: "فَمَا اسْتَطَاعُوا مِنْ قِيَامٍ وَمَا كَانُوا مُنْتَصِرِينَ",
  },
  {
    id: "4721",
    sura: "51",
    VerseIDAr: "46",
    ayatAR: "وَقَوْمَ نُوحٍ مِنْ قَبْلُ ۖ إِنَّهُمْ كَانُوا قَوْمًا فَاسِقِينَ",
  },
  {
    id: "4722",
    sura: "51",
    VerseIDAr: "47",
    ayatAR: "وَالسَّمَاءَ بَنَيْنَاهَا بِأَيْدٍ وَإِنَّا لَمُوسِعُونَ",
  },
  {
    id: "4723",
    sura: "51",
    VerseIDAr: "48",
    ayatAR: "وَالْأَرْضَ فَرَشْنَاهَا فَنِعْمَ الْمَاهِدُونَ",
  },
  {
    id: "4724",
    sura: "51",
    VerseIDAr: "49",
    ayatAR: "وَمِنْ كُلِّ شَيْءٍ خَلَقْنَا زَوْجَيْنِ لَعَلَّكُمْ تَذَكَّرُونَ",
  },
  {
    id: "4725",
    sura: "51",
    VerseIDAr: "50",
    ayatAR: "فَفِرُّوا إِلَى اللَّهِ ۖ إِنِّي لَكُمْ مِنْهُ نَذِيرٌ مُبِينٌ",
  },
  {
    id: "4726",
    sura: "51",
    VerseIDAr: "51",
    ayatAR:
      "وَلَا تَجْعَلُوا مَعَ اللَّهِ إِلَٰهًا آخَرَ ۖ إِنِّي لَكُمْ مِنْهُ نَذِيرٌ مُبِينٌ",
  },
  {
    id: "4727",
    sura: "51",
    VerseIDAr: "52",
    ayatAR:
      "كَذَٰلِكَ مَا أَتَى الَّذِينَ مِنْ قَبْلِهِمْ مِنْ رَسُولٍ إِلَّا قَالُوا سَاحِرٌ أَوْ مَجْنُونٌ",
  },
  {
    id: "4728",
    sura: "51",
    VerseIDAr: "53",
    ayatAR: "أَتَوَاصَوْا بِهِ ۚ بَلْ هُمْ قَوْمٌ طَاغُونَ",
  },
  {
    id: "4729",
    sura: "51",
    VerseIDAr: "54",
    ayatAR: "فَتَوَلَّ عَنْهُمْ فَمَا أَنْتَ بِمَلُومٍ",
  },
  {
    id: "4730",
    sura: "51",
    VerseIDAr: "55",
    ayatAR: "وَذَكِّرْ فَإِنَّ الذِّكْرَىٰ تَنْفَعُ الْمُؤْمِنِينَ",
  },
  {
    id: "4731",
    sura: "51",
    VerseIDAr: "56",
    ayatAR: "وَمَا خَلَقْتُ الْجِنَّ وَالْإِنْسَ إِلَّا لِيَعْبُدُونِ",
  },
  {
    id: "4732",
    sura: "51",
    VerseIDAr: "57",
    ayatAR: "مَا أُرِيدُ مِنْهُمْ مِنْ رِزْقٍ وَمَا أُرِيدُ أَنْ يُطْعِمُونِ",
  },
  {
    id: "4733",
    sura: "51",
    VerseIDAr: "58",
    ayatAR: "إِنَّ اللَّهَ هُوَ الرَّزَّاقُ ذُو الْقُوَّةِ الْمَتِينُ",
  },
  {
    id: "4734",
    sura: "51",
    VerseIDAr: "59",
    ayatAR:
      "فَإِنَّ لِلَّذِينَ ظَلَمُوا ذَنُوبًا مِثْلَ ذَنُوبِ أَصْحَابِهِمْ فَلَا يَسْتَعْجِلُونِ",
  },
  {
    id: "4735",
    sura: "51",
    VerseIDAr: "60",
    ayatAR: "فَوَيْلٌ لِلَّذِينَ كَفَرُوا مِنْ يَوْمِهِمُ الَّذِي يُوعَدُونَ",
  },
  {
    id: "4736",
    sura: "52",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالطُّورِ",
  },
  { id: "4737", sura: "52", VerseIDAr: "2", ayatAR: "وَكِتَابٍ مَسْطُورٍ" },
  { id: "4738", sura: "52", VerseIDAr: "3", ayatAR: "فِي رَقٍّ مَنْشُورٍ" },
  {
    id: "4739",
    sura: "52",
    VerseIDAr: "4",
    ayatAR: "وَالْبَيْتِ الْمَعْمُورِ",
  },
  {
    id: "4740",
    sura: "52",
    VerseIDAr: "5",
    ayatAR: "وَالسَّقْفِ الْمَرْفُوعِ",
  },
  {
    id: "4741",
    sura: "52",
    VerseIDAr: "6",
    ayatAR: "وَالْبَحْرِ الْمَسْجُورِ",
  },
  {
    id: "4742",
    sura: "52",
    VerseIDAr: "7",
    ayatAR: "إِنَّ عَذَابَ رَبِّكَ لَوَاقِعٌ",
  },
  { id: "4743", sura: "52", VerseIDAr: "8", ayatAR: "مَا لَهُ مِنْ دَافِعٍ" },
  {
    id: "4744",
    sura: "52",
    VerseIDAr: "9",
    ayatAR: "يَوْمَ تَمُورُ السَّمَاءُ مَوْرًا",
  },
  {
    id: "4745",
    sura: "52",
    VerseIDAr: "10",
    ayatAR: "وَتَسِيرُ الْجِبَالُ سَيْرًا",
  },
  {
    id: "4746",
    sura: "52",
    VerseIDAr: "11",
    ayatAR: "فَوَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "4747",
    sura: "52",
    VerseIDAr: "12",
    ayatAR: "الَّذِينَ هُمْ فِي خَوْضٍ يَلْعَبُونَ",
  },
  {
    id: "4748",
    sura: "52",
    VerseIDAr: "13",
    ayatAR: "يَوْمَ يُدَعُّونَ إِلَىٰ نَارِ جَهَنَّمَ دَعًّا",
  },
  {
    id: "4749",
    sura: "52",
    VerseIDAr: "14",
    ayatAR: "هَٰذِهِ النَّارُ الَّتِي كُنْتُمْ بِهَا تُكَذِّبُونَ",
  },
  {
    id: "4750",
    sura: "52",
    VerseIDAr: "15",
    ayatAR: "أَفَسِحْرٌ هَٰذَا أَمْ أَنْتُمْ لَا تُبْصِرُونَ",
  },
  {
    id: "4751",
    sura: "52",
    VerseIDAr: "16",
    ayatAR:
      "اصْلَوْهَا فَاصْبِرُوا أَوْ لَا تَصْبِرُوا سَوَاءٌ عَلَيْكُمْ ۖ إِنَّمَا تُجْزَوْنَ مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "4752",
    sura: "52",
    VerseIDAr: "17",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي جَنَّاتٍ وَنَعِيمٍ",
  },
  {
    id: "4753",
    sura: "52",
    VerseIDAr: "18",
    ayatAR:
      "فَاكِهِينَ بِمَا آتَاهُمْ رَبُّهُمْ وَوَقَاهُمْ رَبُّهُمْ عَذَابَ الْجَحِيمِ",
  },
  {
    id: "4754",
    sura: "52",
    VerseIDAr: "19",
    ayatAR: "كُلُوا وَاشْرَبُوا هَنِيئًا بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "4755",
    sura: "52",
    VerseIDAr: "20",
    ayatAR:
      "مُتَّكِئِينَ عَلَىٰ سُرُرٍ مَصْفُوفَةٍ ۖ وَزَوَّجْنَاهُمْ بِحُورٍ عِينٍ",
  },
  {
    id: "4756",
    sura: "52",
    VerseIDAr: "21",
    ayatAR:
      "وَالَّذِينَ آمَنُوا وَاتَّبَعَتْهُمْ ذُرِّيَّتُهُمْ بِإِيمَانٍ أَلْحَقْنَا بِهِمْ ذُرِّيَّتَهُمْ وَمَا أَلَتْنَاهُمْ مِنْ عَمَلِهِمْ مِنْ شَيْءٍ ۚ كُلُّ امْرِئٍ بِمَا كَسَبَ رَهِينٌ",
  },
  {
    id: "4757",
    sura: "52",
    VerseIDAr: "22",
    ayatAR: "وَأَمْدَدْنَاهُمْ بِفَاكِهَةٍ وَلَحْمٍ مِمَّا يَشْتَهُونَ",
  },
  {
    id: "4758",
    sura: "52",
    VerseIDAr: "23",
    ayatAR: "يَتَنَازَعُونَ فِيهَا كَأْسًا لَا لَغْوٌ فِيهَا وَلَا تَأْثِيمٌ",
  },
  {
    id: "4759",
    sura: "52",
    VerseIDAr: "24",
    ayatAR:
      "وَيَطُوفُ عَلَيْهِمْ غِلْمَانٌ لَهُمْ كَأَنَّهُمْ لُؤْلُؤٌ مَكْنُونٌ",
  },
  {
    id: "4760",
    sura: "52",
    VerseIDAr: "25",
    ayatAR: "وَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍ يَتَسَاءَلُونَ",
  },
  {
    id: "4761",
    sura: "52",
    VerseIDAr: "26",
    ayatAR: "قَالُوا إِنَّا كُنَّا قَبْلُ فِي أَهْلِنَا مُشْفِقِينَ",
  },
  {
    id: "4762",
    sura: "52",
    VerseIDAr: "27",
    ayatAR: "فَمَنَّ اللَّهُ عَلَيْنَا وَوَقَانَا عَذَابَ السَّمُومِ",
  },
  {
    id: "4763",
    sura: "52",
    VerseIDAr: "28",
    ayatAR:
      "إِنَّا كُنَّا مِنْ قَبْلُ نَدْعُوهُ ۖ إِنَّهُ هُوَ الْبَرُّ الرَّحِيمُ",
  },
  {
    id: "4764",
    sura: "52",
    VerseIDAr: "29",
    ayatAR:
      "فَذَكِّرْ فَمَا أَنْتَ بِنِعْمَتِ رَبِّكَ بِكَاهِنٍ وَلَا مَجْنُونٍ",
  },
  {
    id: "4765",
    sura: "52",
    VerseIDAr: "30",
    ayatAR: "أَمْ يَقُولُونَ شَاعِرٌ نَتَرَبَّصُ بِهِ رَيْبَ الْمَنُونِ",
  },
  {
    id: "4766",
    sura: "52",
    VerseIDAr: "31",
    ayatAR: "قُلْ تَرَبَّصُوا فَإِنِّي مَعَكُمْ مِنَ الْمُتَرَبِّصِينَ",
  },
  {
    id: "4767",
    sura: "52",
    VerseIDAr: "32",
    ayatAR:
      "أَمْ تَأْمُرُهُمْ أَحْلَامُهُمْ بِهَٰذَا ۚ أَمْ هُمْ قَوْمٌ طَاغُونَ",
  },
  {
    id: "4768",
    sura: "52",
    VerseIDAr: "33",
    ayatAR: "أَمْ يَقُولُونَ تَقَوَّلَهُ ۚ بَلْ لَا يُؤْمِنُونَ",
  },
  {
    id: "4769",
    sura: "52",
    VerseIDAr: "34",
    ayatAR: "فَلْيَأْتُوا بِحَدِيثٍ مِثْلِهِ إِنْ كَانُوا صَادِقِينَ",
  },
  {
    id: "4770",
    sura: "52",
    VerseIDAr: "35",
    ayatAR: "أَمْ خُلِقُوا مِنْ غَيْرِ شَيْءٍ أَمْ هُمُ الْخَالِقُونَ",
  },
  {
    id: "4771",
    sura: "52",
    VerseIDAr: "36",
    ayatAR: "أَمْ خَلَقُوا السَّمَاوَاتِ وَالْأَرْضَ ۚ بَلْ لَا يُوقِنُونَ",
  },
  {
    id: "4772",
    sura: "52",
    VerseIDAr: "37",
    ayatAR: "أَمْ عِنْدَهُمْ خَزَائِنُ رَبِّكَ أَمْ هُمُ الْمُصَيْطِرُونَ",
  },
  {
    id: "4773",
    sura: "52",
    VerseIDAr: "38",
    ayatAR:
      "أَمْ لَهُمْ سُلَّمٌ يَسْتَمِعُونَ فِيهِ ۖ فَلْيَأْتِ مُسْتَمِعُهُمْ بِسُلْطَانٍ مُبِينٍ",
  },
  {
    id: "4774",
    sura: "52",
    VerseIDAr: "39",
    ayatAR: "أَمْ لَهُ الْبَنَاتُ وَلَكُمُ الْبَنُونَ",
  },
  {
    id: "4775",
    sura: "52",
    VerseIDAr: "40",
    ayatAR: "أَمْ تَسْأَلُهُمْ أَجْرًا فَهُمْ مِنْ مَغْرَمٍ مُثْقَلُونَ",
  },
  {
    id: "4776",
    sura: "52",
    VerseIDAr: "41",
    ayatAR: "أَمْ عِنْدَهُمُ الْغَيْبُ فَهُمْ يَكْتُبُونَ",
  },
  {
    id: "4777",
    sura: "52",
    VerseIDAr: "42",
    ayatAR: "أَمْ يُرِيدُونَ كَيْدًا ۖ فَالَّذِينَ كَفَرُوا هُمُ الْمَكِيدُونَ",
  },
  {
    id: "4778",
    sura: "52",
    VerseIDAr: "43",
    ayatAR:
      "أَمْ لَهُمْ إِلَٰهٌ غَيْرُ اللَّهِ ۚ سُبْحَانَ اللَّهِ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "4779",
    sura: "52",
    VerseIDAr: "44",
    ayatAR:
      "وَإِنْ يَرَوْا كِسْفًا مِنَ السَّمَاءِ سَاقِطًا يَقُولُوا سَحَابٌ مَرْكُومٌ",
  },
  {
    id: "4780",
    sura: "52",
    VerseIDAr: "45",
    ayatAR: "فَذَرْهُمْ حَتَّىٰ يُلَاقُوا يَوْمَهُمُ الَّذِي فِيهِ يُصْعَقُونَ",
  },
  {
    id: "4781",
    sura: "52",
    VerseIDAr: "46",
    ayatAR:
      "يَوْمَ لَا يُغْنِي عَنْهُمْ كَيْدُهُمْ شَيْئًا وَلَا هُمْ يُنْصَرُونَ",
  },
  {
    id: "4782",
    sura: "52",
    VerseIDAr: "47",
    ayatAR:
      "وَإِنَّ لِلَّذِينَ ظَلَمُوا عَذَابًا دُونَ ذَٰلِكَ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ",
  },
  {
    id: "4783",
    sura: "52",
    VerseIDAr: "48",
    ayatAR:
      "وَاصْبِرْ لِحُكْمِ رَبِّكَ فَإِنَّكَ بِأَعْيُنِنَا ۖ وَسَبِّحْ بِحَمْدِ رَبِّكَ حِينَ تَقُومُ",
  },
  {
    id: "4784",
    sura: "52",
    VerseIDAr: "49",
    ayatAR: "وَمِنَ اللَّيْلِ فَسَبِّحْهُ وَإِدْبَارَ النُّجُومِ",
  },
  {
    id: "4785",
    sura: "53",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالنَّجْمِ إِذَا هَوَىٰ",
  },
  {
    id: "4786",
    sura: "53",
    VerseIDAr: "2",
    ayatAR: "مَا ضَلَّ صَاحِبُكُمْ وَمَا غَوَىٰ",
  },
  {
    id: "4787",
    sura: "53",
    VerseIDAr: "3",
    ayatAR: "وَمَا يَنْطِقُ عَنِ الْهَوَىٰ",
  },
  {
    id: "4788",
    sura: "53",
    VerseIDAr: "4",
    ayatAR: "إِنْ هُوَ إِلَّا وَحْيٌ يُوحَىٰ",
  },
  {
    id: "4789",
    sura: "53",
    VerseIDAr: "5",
    ayatAR: "عَلَّمَهُ شَدِيدُ الْقُوَىٰ",
  },
  { id: "4790", sura: "53", VerseIDAr: "6", ayatAR: "ذُو مِرَّةٍ فَاسْتَوَىٰ" },
  {
    id: "4791",
    sura: "53",
    VerseIDAr: "7",
    ayatAR: "وَهُوَ بِالْأُفُقِ الْأَعْلَىٰ",
  },
  { id: "4792", sura: "53", VerseIDAr: "8", ayatAR: "ثُمَّ دَنَا فَتَدَلَّىٰ" },
  {
    id: "4793",
    sura: "53",
    VerseIDAr: "9",
    ayatAR: "فَكَانَ قَابَ قَوْسَيْنِ أَوْ أَدْنَىٰ",
  },
  {
    id: "4794",
    sura: "53",
    VerseIDAr: "10",
    ayatAR: "فَأَوْحَىٰ إِلَىٰ عَبْدِهِ مَا أَوْحَىٰ",
  },
  {
    id: "4795",
    sura: "53",
    VerseIDAr: "11",
    ayatAR: "مَا كَذَبَ الْفُؤَادُ مَا رَأَىٰ",
  },
  {
    id: "4796",
    sura: "53",
    VerseIDAr: "12",
    ayatAR: "أَفَتُمَارُونَهُ عَلَىٰ مَا يَرَىٰ",
  },
  {
    id: "4797",
    sura: "53",
    VerseIDAr: "13",
    ayatAR: "وَلَقَدْ رَآهُ نَزْلَةً أُخْرَىٰ",
  },
  {
    id: "4798",
    sura: "53",
    VerseIDAr: "14",
    ayatAR: "عِنْدَ سِدْرَةِ الْمُنْتَهَىٰ",
  },
  {
    id: "4799",
    sura: "53",
    VerseIDAr: "15",
    ayatAR: "عِنْدَهَا جَنَّةُ الْمَأْوَىٰ",
  },
  {
    id: "4800",
    sura: "53",
    VerseIDAr: "16",
    ayatAR: "إِذْ يَغْشَى السِّدْرَةَ مَا يَغْشَىٰ",
  },
  {
    id: "4801",
    sura: "53",
    VerseIDAr: "17",
    ayatAR: "مَا زَاغَ الْبَصَرُ وَمَا طَغَىٰ",
  },
  {
    id: "4802",
    sura: "53",
    VerseIDAr: "18",
    ayatAR: "لَقَدْ رَأَىٰ مِنْ آيَاتِ رَبِّهِ الْكُبْرَىٰ",
  },
  {
    id: "4803",
    sura: "53",
    VerseIDAr: "19",
    ayatAR: "أَفَرَأَيْتُمُ اللَّاتَ وَالْعُزَّىٰ",
  },
  {
    id: "4804",
    sura: "53",
    VerseIDAr: "20",
    ayatAR: "وَمَنَاةَ الثَّالِثَةَ الْأُخْرَىٰ",
  },
  {
    id: "4805",
    sura: "53",
    VerseIDAr: "21",
    ayatAR: "أَلَكُمُ الذَّكَرُ وَلَهُ الْأُنْثَىٰ",
  },
  {
    id: "4806",
    sura: "53",
    VerseIDAr: "22",
    ayatAR: "تِلْكَ إِذًا قِسْمَةٌ ضِيزَىٰ",
  },
  {
    id: "4807",
    sura: "53",
    VerseIDAr: "23",
    ayatAR:
      "إِنْ هِيَ إِلَّا أَسْمَاءٌ سَمَّيْتُمُوهَا أَنْتُمْ وَآبَاؤُكُمْ مَا أَنْزَلَ اللَّهُ بِهَا مِنْ سُلْطَانٍ ۚ إِنْ يَتَّبِعُونَ إِلَّا الظَّنَّ وَمَا تَهْوَى الْأَنْفُسُ ۖ وَلَقَدْ جَاءَهُمْ مِنْ رَبِّهِمُ الْهُدَىٰ",
  },
  {
    id: "4808",
    sura: "53",
    VerseIDAr: "24",
    ayatAR: "أَمْ لِلْإِنْسَانِ مَا تَمَنَّىٰ",
  },
  {
    id: "4809",
    sura: "53",
    VerseIDAr: "25",
    ayatAR: "فَلِلَّهِ الْآخِرَةُ وَالْأُولَىٰ",
  },
  {
    id: "4810",
    sura: "53",
    VerseIDAr: "26",
    ayatAR:
      "وَكَمْ مِنْ مَلَكٍ فِي السَّمَاوَاتِ لَا تُغْنِي شَفَاعَتُهُمْ شَيْئًا إِلَّا مِنْ بَعْدِ أَنْ يَأْذَنَ اللَّهُ لِمَنْ يَشَاءُ وَيَرْضَىٰ",
  },
  {
    id: "4811",
    sura: "53",
    VerseIDAr: "27",
    ayatAR:
      "إِنَّ الَّذِينَ لَا يُؤْمِنُونَ بِالْآخِرَةِ لَيُسَمُّونَ الْمَلَائِكَةَ تَسْمِيَةَ الْأُنْثَىٰ",
  },
  {
    id: "4812",
    sura: "53",
    VerseIDAr: "28",
    ayatAR:
      "وَمَا لَهُمْ بِهِ مِنْ عِلْمٍ ۖ إِنْ يَتَّبِعُونَ إِلَّا الظَّنَّ ۖ وَإِنَّ الظَّنَّ لَا يُغْنِي مِنَ الْحَقِّ شَيْئًا",
  },
  {
    id: "4813",
    sura: "53",
    VerseIDAr: "29",
    ayatAR:
      "فَأَعْرِضْ عَنْ مَنْ تَوَلَّىٰ عَنْ ذِكْرِنَا وَلَمْ يُرِدْ إِلَّا الْحَيَاةَ الدُّنْيَا",
  },
  {
    id: "4814",
    sura: "53",
    VerseIDAr: "30",
    ayatAR:
      "ذَٰلِكَ مَبْلَغُهُمْ مِنَ الْعِلْمِ ۚ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَنْ ضَلَّ عَنْ سَبِيلِهِ وَهُوَ أَعْلَمُ بِمَنِ اهْتَدَىٰ",
  },
  {
    id: "4815",
    sura: "53",
    VerseIDAr: "31",
    ayatAR:
      "وَلِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ لِيَجْزِيَ الَّذِينَ أَسَاءُوا بِمَا عَمِلُوا وَيَجْزِيَ الَّذِينَ أَحْسَنُوا بِالْحُسْنَى",
  },
  {
    id: "4816",
    sura: "53",
    VerseIDAr: "32",
    ayatAR:
      "الَّذِينَ يَجْتَنِبُونَ كَبَائِرَ الْإِثْمِ وَالْفَوَاحِشَ إِلَّا اللَّمَمَ ۚ إِنَّ رَبَّكَ وَاسِعُ الْمَغْفِرَةِ ۚ هُوَ أَعْلَمُ بِكُمْ إِذْ أَنْشَأَكُمْ مِنَ الْأَرْضِ وَإِذْ أَنْتُمْ أَجِنَّةٌ فِي بُطُونِ أُمَّهَاتِكُمْ ۖ فَلَا تُزَكُّوا أَنْفُسَكُمْ ۖ هُوَ أَعْلَمُ بِمَنِ اتَّقَىٰ",
  },
  {
    id: "4817",
    sura: "53",
    VerseIDAr: "33",
    ayatAR: "أَفَرَأَيْتَ الَّذِي تَوَلَّىٰ",
  },
  {
    id: "4818",
    sura: "53",
    VerseIDAr: "34",
    ayatAR: "وَأَعْطَىٰ قَلِيلًا وَأَكْدَىٰ",
  },
  {
    id: "4819",
    sura: "53",
    VerseIDAr: "35",
    ayatAR: "أَعِنْدَهُ عِلْمُ الْغَيْبِ فَهُوَ يَرَىٰ",
  },
  {
    id: "4820",
    sura: "53",
    VerseIDAr: "36",
    ayatAR: "أَمْ لَمْ يُنَبَّأْ بِمَا فِي صُحُفِ مُوسَىٰ",
  },
  {
    id: "4821",
    sura: "53",
    VerseIDAr: "37",
    ayatAR: "وَإِبْرَاهِيمَ الَّذِي وَفَّىٰ",
  },
  {
    id: "4822",
    sura: "53",
    VerseIDAr: "38",
    ayatAR: "أَلَّا تَزِرُ وَازِرَةٌ وِزْرَ أُخْرَىٰ",
  },
  {
    id: "4823",
    sura: "53",
    VerseIDAr: "39",
    ayatAR: "وَأَنْ لَيْسَ لِلْإِنْسَانِ إِلَّا مَا سَعَىٰ",
  },
  {
    id: "4824",
    sura: "53",
    VerseIDAr: "40",
    ayatAR: "وَأَنَّ سَعْيَهُ سَوْفَ يُرَىٰ",
  },
  {
    id: "4825",
    sura: "53",
    VerseIDAr: "41",
    ayatAR: "ثُمَّ يُجْزَاهُ الْجَزَاءَ الْأَوْفَىٰ",
  },
  {
    id: "4826",
    sura: "53",
    VerseIDAr: "42",
    ayatAR: "وَأَنَّ إِلَىٰ رَبِّكَ الْمُنْتَهَىٰ",
  },
  {
    id: "4827",
    sura: "53",
    VerseIDAr: "43",
    ayatAR: "وَأَنَّهُ هُوَ أَضْحَكَ وَأَبْكَىٰ",
  },
  {
    id: "4828",
    sura: "53",
    VerseIDAr: "44",
    ayatAR: "وَأَنَّهُ هُوَ أَمَاتَ وَأَحْيَا",
  },
  {
    id: "4829",
    sura: "53",
    VerseIDAr: "45",
    ayatAR: "وَأَنَّهُ خَلَقَ الزَّوْجَيْنِ الذَّكَرَ وَالْأُنْثَىٰ",
  },
  {
    id: "4830",
    sura: "53",
    VerseIDAr: "46",
    ayatAR: "مِنْ نُطْفَةٍ إِذَا تُمْنَىٰ",
  },
  {
    id: "4831",
    sura: "53",
    VerseIDAr: "47",
    ayatAR: "وَأَنَّ عَلَيْهِ النَّشْأَةَ الْأُخْرَىٰ",
  },
  {
    id: "4832",
    sura: "53",
    VerseIDAr: "48",
    ayatAR: "وَأَنَّهُ هُوَ أَغْنَىٰ وَأَقْنَىٰ",
  },
  {
    id: "4833",
    sura: "53",
    VerseIDAr: "49",
    ayatAR: "وَأَنَّهُ هُوَ رَبُّ الشِّعْرَىٰ",
  },
  {
    id: "4834",
    sura: "53",
    VerseIDAr: "50",
    ayatAR: "وَأَنَّهُ أَهْلَكَ عَادًا الْأُولَىٰ",
  },
  {
    id: "4835",
    sura: "53",
    VerseIDAr: "51",
    ayatAR: "وَثَمُودَ فَمَا أَبْقَىٰ",
  },
  {
    id: "4836",
    sura: "53",
    VerseIDAr: "52",
    ayatAR:
      "وَقَوْمَ نُوحٍ مِنْ قَبْلُ ۖ إِنَّهُمْ كَانُوا هُمْ أَظْلَمَ وَأَطْغَىٰ",
  },
  {
    id: "4837",
    sura: "53",
    VerseIDAr: "53",
    ayatAR: "وَالْمُؤْتَفِكَةَ أَهْوَىٰ",
  },
  {
    id: "4838",
    sura: "53",
    VerseIDAr: "54",
    ayatAR: "فَغَشَّاهَا مَا غَشَّىٰ",
  },
  {
    id: "4839",
    sura: "53",
    VerseIDAr: "55",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكَ تَتَمَارَىٰ",
  },
  {
    id: "4840",
    sura: "53",
    VerseIDAr: "56",
    ayatAR: "هَٰذَا نَذِيرٌ مِنَ النُّذُرِ الْأُولَىٰ",
  },
  { id: "4841", sura: "53", VerseIDAr: "57", ayatAR: "أَزِفَتِ الْآزِفَةُ" },
  {
    id: "4842",
    sura: "53",
    VerseIDAr: "58",
    ayatAR: "لَيْسَ لَهَا مِنْ دُونِ اللَّهِ كَاشِفَةٌ",
  },
  {
    id: "4843",
    sura: "53",
    VerseIDAr: "59",
    ayatAR: "أَفَمِنْ هَٰذَا الْحَدِيثِ تَعْجَبُونَ",
  },
  {
    id: "4844",
    sura: "53",
    VerseIDAr: "60",
    ayatAR: "وَتَضْحَكُونَ وَلَا تَبْكُونَ",
  },
  { id: "4845", sura: "53", VerseIDAr: "61", ayatAR: "وَأَنْتُمْ سَامِدُونَ" },
  {
    id: "4846",
    sura: "53",
    VerseIDAr: "62",
    ayatAR: "فَاسْجُدُوا لِلَّهِ وَاعْبُدُوا ۩",
  },
  {
    id: "4847",
    sura: "54",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ اقْتَرَبَتِ السَّاعَةُ وَانْشَقَّ الْقَمَرُ",
  },
  {
    id: "4848",
    sura: "54",
    VerseIDAr: "2",
    ayatAR: "وَإِنْ يَرَوْا آيَةً يُعْرِضُوا وَيَقُولُوا سِحْرٌ مُسْتَمِرٌّ",
  },
  {
    id: "4849",
    sura: "54",
    VerseIDAr: "3",
    ayatAR:
      "وَكَذَّبُوا وَاتَّبَعُوا أَهْوَاءَهُمْ ۚ وَكُلُّ أَمْرٍ مُسْتَقِرٌّ",
  },
  {
    id: "4850",
    sura: "54",
    VerseIDAr: "4",
    ayatAR: "وَلَقَدْ جَاءَهُمْ مِنَ الْأَنْبَاءِ مَا فِيهِ مُزْدَجَرٌ",
  },
  {
    id: "4851",
    sura: "54",
    VerseIDAr: "5",
    ayatAR: "حِكْمَةٌ بَالِغَةٌ ۖ فَمَا تُغْنِ النُّذُرُ",
  },
  {
    id: "4852",
    sura: "54",
    VerseIDAr: "6",
    ayatAR: "فَتَوَلَّ عَنْهُمْ ۘ يَوْمَ يَدْعُ الدَّاعِ إِلَىٰ شَيْءٍ نُكُرٍ",
  },
  {
    id: "4853",
    sura: "54",
    VerseIDAr: "7",
    ayatAR:
      "خُشَّعًا أَبْصَارُهُمْ يَخْرُجُونَ مِنَ الْأَجْدَاثِ كَأَنَّهُمْ جَرَادٌ مُنْتَشِرٌ",
  },
  {
    id: "4854",
    sura: "54",
    VerseIDAr: "8",
    ayatAR:
      "مُهْطِعِينَ إِلَى الدَّاعِ ۖ يَقُولُ الْكَافِرُونَ هَٰذَا يَوْمٌ عَسِرٌ",
  },
  {
    id: "4855",
    sura: "54",
    VerseIDAr: "9",
    ayatAR:
      "كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍ فَكَذَّبُوا عَبْدَنَا وَقَالُوا مَجْنُونٌ وَازْدُجِرَ",
  },
  {
    id: "4856",
    sura: "54",
    VerseIDAr: "10",
    ayatAR: "فَدَعَا رَبَّهُ أَنِّي مَغْلُوبٌ فَانْتَصِرْ",
  },
  {
    id: "4857",
    sura: "54",
    VerseIDAr: "11",
    ayatAR: "فَفَتَحْنَا أَبْوَابَ السَّمَاءِ بِمَاءٍ مُنْهَمِرٍ",
  },
  {
    id: "4858",
    sura: "54",
    VerseIDAr: "12",
    ayatAR:
      "وَفَجَّرْنَا الْأَرْضَ عُيُونًا فَالْتَقَى الْمَاءُ عَلَىٰ أَمْرٍ قَدْ قُدِرَ",
  },
  {
    id: "4859",
    sura: "54",
    VerseIDAr: "13",
    ayatAR: "وَحَمَلْنَاهُ عَلَىٰ ذَاتِ أَلْوَاحٍ وَدُسُرٍ",
  },
  {
    id: "4860",
    sura: "54",
    VerseIDAr: "14",
    ayatAR: "تَجْرِي بِأَعْيُنِنَا جَزَاءً لِمَنْ كَانَ كُفِرَ",
  },
  {
    id: "4861",
    sura: "54",
    VerseIDAr: "15",
    ayatAR: "وَلَقَدْ تَرَكْنَاهَا آيَةً فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4862",
    sura: "54",
    VerseIDAr: "16",
    ayatAR: "فَكَيْفَ كَانَ عَذَابِي وَنُذُرِ",
  },
  {
    id: "4863",
    sura: "54",
    VerseIDAr: "17",
    ayatAR: "وَلَقَدْ يَسَّرْنَا الْقُرْآنَ لِلذِّكْرِ فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4864",
    sura: "54",
    VerseIDAr: "18",
    ayatAR: "كَذَّبَتْ عَادٌ فَكَيْفَ كَانَ عَذَابِي وَنُذُرِ",
  },
  {
    id: "4865",
    sura: "54",
    VerseIDAr: "19",
    ayatAR:
      "إِنَّا أَرْسَلْنَا عَلَيْهِمْ رِيحًا صَرْصَرًا فِي يَوْمِ نَحْسٍ مُسْتَمِرٍّ",
  },
  {
    id: "4866",
    sura: "54",
    VerseIDAr: "20",
    ayatAR: "تَنْزِعُ النَّاسَ كَأَنَّهُمْ أَعْجَازُ نَخْلٍ مُنْقَعِرٍ",
  },
  {
    id: "4867",
    sura: "54",
    VerseIDAr: "21",
    ayatAR: "فَكَيْفَ كَانَ عَذَابِي وَنُذُرِ",
  },
  {
    id: "4868",
    sura: "54",
    VerseIDAr: "22",
    ayatAR: "وَلَقَدْ يَسَّرْنَا الْقُرْآنَ لِلذِّكْرِ فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4869",
    sura: "54",
    VerseIDAr: "23",
    ayatAR: "كَذَّبَتْ ثَمُودُ بِالنُّذُرِ",
  },
  {
    id: "4870",
    sura: "54",
    VerseIDAr: "24",
    ayatAR:
      "فَقَالُوا أَبَشَرًا مِنَّا وَاحِدًا نَتَّبِعُهُ إِنَّا إِذًا لَفِي ضَلَالٍ وَسُعُرٍ",
  },
  {
    id: "4871",
    sura: "54",
    VerseIDAr: "25",
    ayatAR:
      "أَأُلْقِيَ الذِّكْرُ عَلَيْهِ مِنْ بَيْنِنَا بَلْ هُوَ كَذَّابٌ أَشِرٌ",
  },
  {
    id: "4872",
    sura: "54",
    VerseIDAr: "26",
    ayatAR: "سَيَعْلَمُونَ غَدًا مَنِ الْكَذَّابُ الْأَشِرُ",
  },
  {
    id: "4873",
    sura: "54",
    VerseIDAr: "27",
    ayatAR:
      "إِنَّا مُرْسِلُو النَّاقَةِ فِتْنَةً لَهُمْ فَارْتَقِبْهُمْ وَاصْطَبِرْ",
  },
  {
    id: "4874",
    sura: "54",
    VerseIDAr: "28",
    ayatAR:
      "وَنَبِّئْهُمْ أَنَّ الْمَاءَ قِسْمَةٌ بَيْنَهُمْ ۖ كُلُّ شِرْبٍ مُحْتَضَرٌ",
  },
  {
    id: "4875",
    sura: "54",
    VerseIDAr: "29",
    ayatAR: "فَنَادَوْا صَاحِبَهُمْ فَتَعَاطَىٰ فَعَقَرَ",
  },
  {
    id: "4876",
    sura: "54",
    VerseIDAr: "30",
    ayatAR: "فَكَيْفَ كَانَ عَذَابِي وَنُذُرِ",
  },
  {
    id: "4877",
    sura: "54",
    VerseIDAr: "31",
    ayatAR:
      "إِنَّا أَرْسَلْنَا عَلَيْهِمْ صَيْحَةً وَاحِدَةً فَكَانُوا كَهَشِيمِ الْمُحْتَظِرِ",
  },
  {
    id: "4878",
    sura: "54",
    VerseIDAr: "32",
    ayatAR: "وَلَقَدْ يَسَّرْنَا الْقُرْآنَ لِلذِّكْرِ فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4879",
    sura: "54",
    VerseIDAr: "33",
    ayatAR: "كَذَّبَتْ قَوْمُ لُوطٍ بِالنُّذُرِ",
  },
  {
    id: "4880",
    sura: "54",
    VerseIDAr: "34",
    ayatAR:
      "إِنَّا أَرْسَلْنَا عَلَيْهِمْ حَاصِبًا إِلَّا آلَ لُوطٍ ۖ نَجَّيْنَاهُمْ بِسَحَرٍ",
  },
  {
    id: "4881",
    sura: "54",
    VerseIDAr: "35",
    ayatAR: "نِعْمَةً مِنْ عِنْدِنَا ۚ كَذَٰلِكَ نَجْزِي مَنْ شَكَرَ",
  },
  {
    id: "4882",
    sura: "54",
    VerseIDAr: "36",
    ayatAR: "وَلَقَدْ أَنْذَرَهُمْ بَطْشَتَنَا فَتَمَارَوْا بِالنُّذُرِ",
  },
  {
    id: "4883",
    sura: "54",
    VerseIDAr: "37",
    ayatAR:
      "وَلَقَدْ رَاوَدُوهُ عَنْ ضَيْفِهِ فَطَمَسْنَا أَعْيُنَهُمْ فَذُوقُوا عَذَابِي وَنُذُرِ",
  },
  {
    id: "4884",
    sura: "54",
    VerseIDAr: "38",
    ayatAR: "وَلَقَدْ صَبَّحَهُمْ بُكْرَةً عَذَابٌ مُسْتَقِرٌّ",
  },
  {
    id: "4885",
    sura: "54",
    VerseIDAr: "39",
    ayatAR: "فَذُوقُوا عَذَابِي وَنُذُرِ",
  },
  {
    id: "4886",
    sura: "54",
    VerseIDAr: "40",
    ayatAR: "وَلَقَدْ يَسَّرْنَا الْقُرْآنَ لِلذِّكْرِ فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4887",
    sura: "54",
    VerseIDAr: "41",
    ayatAR: "وَلَقَدْ جَاءَ آلَ فِرْعَوْنَ النُّذُرُ",
  },
  {
    id: "4888",
    sura: "54",
    VerseIDAr: "42",
    ayatAR:
      "كَذَّبُوا بِآيَاتِنَا كُلِّهَا فَأَخَذْنَاهُمْ أَخْذَ عَزِيزٍ مُقْتَدِرٍ",
  },
  {
    id: "4889",
    sura: "54",
    VerseIDAr: "43",
    ayatAR:
      "أَكُفَّارُكُمْ خَيْرٌ مِنْ أُولَٰئِكُمْ أَمْ لَكُمْ بَرَاءَةٌ فِي الزُّبُرِ",
  },
  {
    id: "4890",
    sura: "54",
    VerseIDAr: "44",
    ayatAR: "أَمْ يَقُولُونَ نَحْنُ جَمِيعٌ مُنْتَصِرٌ",
  },
  {
    id: "4891",
    sura: "54",
    VerseIDAr: "45",
    ayatAR: "سَيُهْزَمُ الْجَمْعُ وَيُوَلُّونَ الدُّبُرَ",
  },
  {
    id: "4892",
    sura: "54",
    VerseIDAr: "46",
    ayatAR: "بَلِ السَّاعَةُ مَوْعِدُهُمْ وَالسَّاعَةُ أَدْهَىٰ وَأَمَرُّ",
  },
  {
    id: "4893",
    sura: "54",
    VerseIDAr: "47",
    ayatAR: "إِنَّ الْمُجْرِمِينَ فِي ضَلَالٍ وَسُعُرٍ",
  },
  {
    id: "4894",
    sura: "54",
    VerseIDAr: "48",
    ayatAR:
      "يَوْمَ يُسْحَبُونَ فِي النَّارِ عَلَىٰ وُجُوهِهِمْ ذُوقُوا مَسَّ سَقَرَ",
  },
  {
    id: "4895",
    sura: "54",
    VerseIDAr: "49",
    ayatAR: "إِنَّا كُلَّ شَيْءٍ خَلَقْنَاهُ بِقَدَرٍ",
  },
  {
    id: "4896",
    sura: "54",
    VerseIDAr: "50",
    ayatAR: "وَمَا أَمْرُنَا إِلَّا وَاحِدَةٌ كَلَمْحٍ بِالْبَصَرِ",
  },
  {
    id: "4897",
    sura: "54",
    VerseIDAr: "51",
    ayatAR: "وَلَقَدْ أَهْلَكْنَا أَشْيَاعَكُمْ فَهَلْ مِنْ مُدَّكِرٍ",
  },
  {
    id: "4898",
    sura: "54",
    VerseIDAr: "52",
    ayatAR: "وَكُلُّ شَيْءٍ فَعَلُوهُ فِي الزُّبُرِ",
  },
  {
    id: "4899",
    sura: "54",
    VerseIDAr: "53",
    ayatAR: "وَكُلُّ صَغِيرٍ وَكَبِيرٍ مُسْتَطَرٌ",
  },
  {
    id: "4900",
    sura: "54",
    VerseIDAr: "54",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي جَنَّاتٍ وَنَهَرٍ",
  },
  {
    id: "4901",
    sura: "54",
    VerseIDAr: "55",
    ayatAR: "فِي مَقْعَدِ صِدْقٍ عِنْدَ مَلِيكٍ مُقْتَدِرٍ",
  },
  {
    id: "4902",
    sura: "55",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الرَّحْمَٰنُ",
  },
  { id: "4903", sura: "55", VerseIDAr: "2", ayatAR: "عَلَّمَ الْقُرْآنَ" },
  { id: "4904", sura: "55", VerseIDAr: "3", ayatAR: "خَلَقَ الْإِنْسَانَ" },
  { id: "4905", sura: "55", VerseIDAr: "4", ayatAR: "عَلَّمَهُ الْبَيَانَ" },
  {
    id: "4906",
    sura: "55",
    VerseIDAr: "5",
    ayatAR: "الشَّمْسُ وَالْقَمَرُ بِحُسْبَانٍ",
  },
  {
    id: "4907",
    sura: "55",
    VerseIDAr: "6",
    ayatAR: "وَالنَّجْمُ وَالشَّجَرُ يَسْجُدَانِ",
  },
  {
    id: "4908",
    sura: "55",
    VerseIDAr: "7",
    ayatAR: "وَالسَّمَاءَ رَفَعَهَا وَوَضَعَ الْمِيزَانَ",
  },
  {
    id: "4909",
    sura: "55",
    VerseIDAr: "8",
    ayatAR: "أَلَّا تَطْغَوْا فِي الْمِيزَانِ",
  },
  {
    id: "4910",
    sura: "55",
    VerseIDAr: "9",
    ayatAR: "وَأَقِيمُوا الْوَزْنَ بِالْقِسْطِ وَلَا تُخْسِرُوا الْمِيزَانَ",
  },
  {
    id: "4911",
    sura: "55",
    VerseIDAr: "10",
    ayatAR: "وَالْأَرْضَ وَضَعَهَا لِلْأَنَامِ",
  },
  {
    id: "4912",
    sura: "55",
    VerseIDAr: "11",
    ayatAR: "فِيهَا فَاكِهَةٌ وَالنَّخْلُ ذَاتُ الْأَكْمَامِ",
  },
  {
    id: "4913",
    sura: "55",
    VerseIDAr: "12",
    ayatAR: "وَالْحَبُّ ذُو الْعَصْفِ وَالرَّيْحَانُ",
  },
  {
    id: "4914",
    sura: "55",
    VerseIDAr: "13",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4915",
    sura: "55",
    VerseIDAr: "14",
    ayatAR: "خَلَقَ الْإِنْسَانَ مِنْ صَلْصَالٍ كَالْفَخَّارِ",
  },
  {
    id: "4916",
    sura: "55",
    VerseIDAr: "15",
    ayatAR: "وَخَلَقَ الْجَانَّ مِنْ مَارِجٍ مِنْ نَارٍ",
  },
  {
    id: "4917",
    sura: "55",
    VerseIDAr: "16",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4918",
    sura: "55",
    VerseIDAr: "17",
    ayatAR: "رَبُّ الْمَشْرِقَيْنِ وَرَبُّ الْمَغْرِبَيْنِ",
  },
  {
    id: "4919",
    sura: "55",
    VerseIDAr: "18",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4920",
    sura: "55",
    VerseIDAr: "19",
    ayatAR: "مَرَجَ الْبَحْرَيْنِ يَلْتَقِيَانِ",
  },
  {
    id: "4921",
    sura: "55",
    VerseIDAr: "20",
    ayatAR: "بَيْنَهُمَا بَرْزَخٌ لَا يَبْغِيَانِ",
  },
  {
    id: "4922",
    sura: "55",
    VerseIDAr: "21",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4923",
    sura: "55",
    VerseIDAr: "22",
    ayatAR: "يَخْرُجُ مِنْهُمَا اللُّؤْلُؤُ وَالْمَرْجَانُ",
  },
  {
    id: "4924",
    sura: "55",
    VerseIDAr: "23",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4925",
    sura: "55",
    VerseIDAr: "24",
    ayatAR: "وَلَهُ الْجَوَارِ الْمُنْشَآتُ فِي الْبَحْرِ كَالْأَعْلَامِ",
  },
  {
    id: "4926",
    sura: "55",
    VerseIDAr: "25",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4927",
    sura: "55",
    VerseIDAr: "26",
    ayatAR: "كُلُّ مَنْ عَلَيْهَا فَانٍ",
  },
  {
    id: "4928",
    sura: "55",
    VerseIDAr: "27",
    ayatAR: "وَيَبْقَىٰ وَجْهُ رَبِّكَ ذُو الْجَلَالِ وَالْإِكْرَامِ",
  },
  {
    id: "4929",
    sura: "55",
    VerseIDAr: "28",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4930",
    sura: "55",
    VerseIDAr: "29",
    ayatAR:
      "يَسْأَلُهُ مَنْ فِي السَّمَاوَاتِ وَالْأَرْضِ ۚ كُلَّ يَوْمٍ هُوَ فِي شَأْنٍ",
  },
  {
    id: "4931",
    sura: "55",
    VerseIDAr: "30",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4932",
    sura: "55",
    VerseIDAr: "31",
    ayatAR: "سَنَفْرُغُ لَكُمْ أَيُّهَ الثَّقَلَانِ",
  },
  {
    id: "4933",
    sura: "55",
    VerseIDAr: "32",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4934",
    sura: "55",
    VerseIDAr: "33",
    ayatAR:
      "يَا مَعْشَرَ الْجِنِّ وَالْإِنْسِ إِنِ اسْتَطَعْتُمْ أَنْ تَنْفُذُوا مِنْ أَقْطَارِ السَّمَاوَاتِ وَالْأَرْضِ فَانْفُذُوا ۚ لَا تَنْفُذُونَ إِلَّا بِسُلْطَانٍ",
  },
  {
    id: "4935",
    sura: "55",
    VerseIDAr: "34",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4936",
    sura: "55",
    VerseIDAr: "35",
    ayatAR:
      "يُرْسَلُ عَلَيْكُمَا شُوَاظٌ مِنْ نَارٍ وَنُحَاسٌ فَلَا تَنْتَصِرَانِ",
  },
  {
    id: "4937",
    sura: "55",
    VerseIDAr: "36",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4938",
    sura: "55",
    VerseIDAr: "37",
    ayatAR: "فَإِذَا انْشَقَّتِ السَّمَاءُ فَكَانَتْ وَرْدَةً كَالدِّهَانِ",
  },
  {
    id: "4939",
    sura: "55",
    VerseIDAr: "38",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4940",
    sura: "55",
    VerseIDAr: "39",
    ayatAR: "فَيَوْمَئِذٍ لَا يُسْأَلُ عَنْ ذَنْبِهِ إِنْسٌ وَلَا جَانٌّ",
  },
  {
    id: "4941",
    sura: "55",
    VerseIDAr: "40",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4942",
    sura: "55",
    VerseIDAr: "41",
    ayatAR:
      "يُعْرَفُ الْمُجْرِمُونَ بِسِيمَاهُمْ فَيُؤْخَذُ بِالنَّوَاصِي وَالْأَقْدَامِ",
  },
  {
    id: "4943",
    sura: "55",
    VerseIDAr: "42",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4944",
    sura: "55",
    VerseIDAr: "43",
    ayatAR: "هَٰذِهِ جَهَنَّمُ الَّتِي يُكَذِّبُ بِهَا الْمُجْرِمُونَ",
  },
  {
    id: "4945",
    sura: "55",
    VerseIDAr: "44",
    ayatAR: "يَطُوفُونَ بَيْنَهَا وَبَيْنَ حَمِيمٍ آنٍ",
  },
  {
    id: "4946",
    sura: "55",
    VerseIDAr: "45",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4947",
    sura: "55",
    VerseIDAr: "46",
    ayatAR: "وَلِمَنْ خَافَ مَقَامَ رَبِّهِ جَنَّتَانِ",
  },
  {
    id: "4948",
    sura: "55",
    VerseIDAr: "47",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  { id: "4949", sura: "55", VerseIDAr: "48", ayatAR: "ذَوَاتَا أَفْنَانٍ" },
  {
    id: "4950",
    sura: "55",
    VerseIDAr: "49",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4951",
    sura: "55",
    VerseIDAr: "50",
    ayatAR: "فِيهِمَا عَيْنَانِ تَجْرِيَانِ",
  },
  {
    id: "4952",
    sura: "55",
    VerseIDAr: "51",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4953",
    sura: "55",
    VerseIDAr: "52",
    ayatAR: "فِيهِمَا مِنْ كُلِّ فَاكِهَةٍ زَوْجَانِ",
  },
  {
    id: "4954",
    sura: "55",
    VerseIDAr: "53",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4955",
    sura: "55",
    VerseIDAr: "54",
    ayatAR:
      "مُتَّكِئِينَ عَلَىٰ فُرُشٍ بَطَائِنُهَا مِنْ إِسْتَبْرَقٍ ۚ وَجَنَى الْجَنَّتَيْنِ دَانٍ",
  },
  {
    id: "4956",
    sura: "55",
    VerseIDAr: "55",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4957",
    sura: "55",
    VerseIDAr: "56",
    ayatAR:
      "فِيهِنَّ قَاصِرَاتُ الطَّرْفِ لَمْ يَطْمِثْهُنَّ إِنْسٌ قَبْلَهُمْ وَلَا جَانٌّ",
  },
  {
    id: "4958",
    sura: "55",
    VerseIDAr: "57",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4959",
    sura: "55",
    VerseIDAr: "58",
    ayatAR: "كَأَنَّهُنَّ الْيَاقُوتُ وَالْمَرْجَانُ",
  },
  {
    id: "4960",
    sura: "55",
    VerseIDAr: "59",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4961",
    sura: "55",
    VerseIDAr: "60",
    ayatAR: "هَلْ جَزَاءُ الْإِحْسَانِ إِلَّا الْإِحْسَانُ",
  },
  {
    id: "4962",
    sura: "55",
    VerseIDAr: "61",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4963",
    sura: "55",
    VerseIDAr: "62",
    ayatAR: "وَمِنْ دُونِهِمَا جَنَّتَانِ",
  },
  {
    id: "4964",
    sura: "55",
    VerseIDAr: "63",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  { id: "4965", sura: "55", VerseIDAr: "64", ayatAR: "مُدْهَامَّتَانِ" },
  {
    id: "4966",
    sura: "55",
    VerseIDAr: "65",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4967",
    sura: "55",
    VerseIDAr: "66",
    ayatAR: "فِيهِمَا عَيْنَانِ نَضَّاخَتَانِ",
  },
  {
    id: "4968",
    sura: "55",
    VerseIDAr: "67",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4969",
    sura: "55",
    VerseIDAr: "68",
    ayatAR: "فِيهِمَا فَاكِهَةٌ وَنَخْلٌ وَرُمَّانٌ",
  },
  {
    id: "4970",
    sura: "55",
    VerseIDAr: "69",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4971",
    sura: "55",
    VerseIDAr: "70",
    ayatAR: "فِيهِنَّ خَيْرَاتٌ حِسَانٌ",
  },
  {
    id: "4972",
    sura: "55",
    VerseIDAr: "71",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4973",
    sura: "55",
    VerseIDAr: "72",
    ayatAR: "حُورٌ مَقْصُورَاتٌ فِي الْخِيَامِ",
  },
  {
    id: "4974",
    sura: "55",
    VerseIDAr: "73",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4975",
    sura: "55",
    VerseIDAr: "74",
    ayatAR: "لَمْ يَطْمِثْهُنَّ إِنْسٌ قَبْلَهُمْ وَلَا جَانٌّ",
  },
  {
    id: "4976",
    sura: "55",
    VerseIDAr: "75",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4977",
    sura: "55",
    VerseIDAr: "76",
    ayatAR: "مُتَّكِئِينَ عَلَىٰ رَفْرَفٍ خُضْرٍ وَعَبْقَرِيٍّ حِسَانٍ",
  },
  {
    id: "4978",
    sura: "55",
    VerseIDAr: "77",
    ayatAR: "فَبِأَيِّ آلَاءِ رَبِّكُمَا تُكَذِّبَانِ",
  },
  {
    id: "4979",
    sura: "55",
    VerseIDAr: "78",
    ayatAR: "تَبَارَكَ اسْمُ رَبِّكَ ذِي الْجَلَالِ وَالْإِكْرَامِ",
  },
  {
    id: "4980",
    sura: "56",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا وَقَعَتِ الْوَاقِعَةُ",
  },
  {
    id: "4981",
    sura: "56",
    VerseIDAr: "2",
    ayatAR: "لَيْسَ لِوَقْعَتِهَا كَاذِبَةٌ",
  },
  { id: "4982", sura: "56", VerseIDAr: "3", ayatAR: "خَافِضَةٌ رَافِعَةٌ" },
  {
    id: "4983",
    sura: "56",
    VerseIDAr: "4",
    ayatAR: "إِذَا رُجَّتِ الْأَرْضُ رَجًّا",
  },
  {
    id: "4984",
    sura: "56",
    VerseIDAr: "5",
    ayatAR: "وَبُسَّتِ الْجِبَالُ بَسًّا",
  },
  {
    id: "4985",
    sura: "56",
    VerseIDAr: "6",
    ayatAR: "فَكَانَتْ هَبَاءً مُنْبَثًّا",
  },
  {
    id: "4986",
    sura: "56",
    VerseIDAr: "7",
    ayatAR: "وَكُنْتُمْ أَزْوَاجًا ثَلَاثَةً",
  },
  {
    id: "4987",
    sura: "56",
    VerseIDAr: "8",
    ayatAR: "فَأَصْحَابُ الْمَيْمَنَةِ مَا أَصْحَابُ الْمَيْمَنَةِ",
  },
  {
    id: "4988",
    sura: "56",
    VerseIDAr: "9",
    ayatAR: "وَأَصْحَابُ الْمَشْأَمَةِ مَا أَصْحَابُ الْمَشْأَمَةِ",
  },
  {
    id: "4989",
    sura: "56",
    VerseIDAr: "10",
    ayatAR: "وَالسَّابِقُونَ السَّابِقُونَ",
  },
  {
    id: "4990",
    sura: "56",
    VerseIDAr: "11",
    ayatAR: "أُولَٰئِكَ الْمُقَرَّبُونَ",
  },
  {
    id: "4991",
    sura: "56",
    VerseIDAr: "12",
    ayatAR: "فِي جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "4992",
    sura: "56",
    VerseIDAr: "13",
    ayatAR: "ثُلَّةٌ مِنَ الْأَوَّلِينَ",
  },
  {
    id: "4993",
    sura: "56",
    VerseIDAr: "14",
    ayatAR: "وَقَلِيلٌ مِنَ الْآخِرِينَ",
  },
  {
    id: "4994",
    sura: "56",
    VerseIDAr: "15",
    ayatAR: "عَلَىٰ سُرُرٍ مَوْضُونَةٍ",
  },
  {
    id: "4995",
    sura: "56",
    VerseIDAr: "16",
    ayatAR: "مُتَّكِئِينَ عَلَيْهَا مُتَقَابِلِينَ",
  },
  {
    id: "4996",
    sura: "56",
    VerseIDAr: "17",
    ayatAR: "يَطُوفُ عَلَيْهِمْ وِلْدَانٌ مُخَلَّدُونَ",
  },
  {
    id: "4997",
    sura: "56",
    VerseIDAr: "18",
    ayatAR: "بِأَكْوَابٍ وَأَبَارِيقَ وَكَأْسٍ مِنْ مَعِينٍ",
  },
  {
    id: "4998",
    sura: "56",
    VerseIDAr: "19",
    ayatAR: "لَا يُصَدَّعُونَ عَنْهَا وَلَا يُنْزِفُونَ",
  },
  {
    id: "4999",
    sura: "56",
    VerseIDAr: "20",
    ayatAR: "وَفَاكِهَةٍ مِمَّا يَتَخَيَّرُونَ",
  },
  {
    id: "5000",
    sura: "56",
    VerseIDAr: "21",
    ayatAR: "وَلَحْمِ طَيْرٍ مِمَّا يَشْتَهُونَ",
  },
  { id: "5001", sura: "56", VerseIDAr: "22", ayatAR: "وَحُورٌ عِينٌ" },
  {
    id: "5002",
    sura: "56",
    VerseIDAr: "23",
    ayatAR: "كَأَمْثَالِ اللُّؤْلُؤِ الْمَكْنُونِ",
  },
  {
    id: "5003",
    sura: "56",
    VerseIDAr: "24",
    ayatAR: "جَزَاءً بِمَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "5004",
    sura: "56",
    VerseIDAr: "25",
    ayatAR: "لَا يَسْمَعُونَ فِيهَا لَغْوًا وَلَا تَأْثِيمًا",
  },
  {
    id: "5005",
    sura: "56",
    VerseIDAr: "26",
    ayatAR: "إِلَّا قِيلًا سَلَامًا سَلَامًا",
  },
  {
    id: "5006",
    sura: "56",
    VerseIDAr: "27",
    ayatAR: "وَأَصْحَابُ الْيَمِينِ مَا أَصْحَابُ الْيَمِينِ",
  },
  { id: "5007", sura: "56", VerseIDAr: "28", ayatAR: "فِي سِدْرٍ مَخْضُودٍ" },
  { id: "5008", sura: "56", VerseIDAr: "29", ayatAR: "وَطَلْحٍ مَنْضُودٍ" },
  { id: "5009", sura: "56", VerseIDAr: "30", ayatAR: "وَظِلٍّ مَمْدُودٍ" },
  { id: "5010", sura: "56", VerseIDAr: "31", ayatAR: "وَمَاءٍ مَسْكُوبٍ" },
  { id: "5011", sura: "56", VerseIDAr: "32", ayatAR: "وَفَاكِهَةٍ كَثِيرَةٍ" },
  {
    id: "5012",
    sura: "56",
    VerseIDAr: "33",
    ayatAR: "لَا مَقْطُوعَةٍ وَلَا مَمْنُوعَةٍ",
  },
  { id: "5013", sura: "56", VerseIDAr: "34", ayatAR: "وَفُرُشٍ مَرْفُوعَةٍ" },
  {
    id: "5014",
    sura: "56",
    VerseIDAr: "35",
    ayatAR: "إِنَّا أَنْشَأْنَاهُنَّ إِنْشَاءً",
  },
  {
    id: "5015",
    sura: "56",
    VerseIDAr: "36",
    ayatAR: "فَجَعَلْنَاهُنَّ أَبْكَارًا",
  },
  { id: "5016", sura: "56", VerseIDAr: "37", ayatAR: "عُرُبًا أَتْرَابًا" },
  { id: "5017", sura: "56", VerseIDAr: "38", ayatAR: "لِأَصْحَابِ الْيَمِينِ" },
  {
    id: "5018",
    sura: "56",
    VerseIDAr: "39",
    ayatAR: "ثُلَّةٌ مِنَ الْأَوَّلِينَ",
  },
  {
    id: "5019",
    sura: "56",
    VerseIDAr: "40",
    ayatAR: "وَثُلَّةٌ مِنَ الْآخِرِينَ",
  },
  {
    id: "5020",
    sura: "56",
    VerseIDAr: "41",
    ayatAR: "وَأَصْحَابُ الشِّمَالِ مَا أَصْحَابُ الشِّمَالِ",
  },
  { id: "5021", sura: "56", VerseIDAr: "42", ayatAR: "فِي سَمُومٍ وَحَمِيمٍ" },
  { id: "5022", sura: "56", VerseIDAr: "43", ayatAR: "وَظِلٍّ مِنْ يَحْمُومٍ" },
  {
    id: "5023",
    sura: "56",
    VerseIDAr: "44",
    ayatAR: "لَا بَارِدٍ وَلَا كَرِيمٍ",
  },
  {
    id: "5024",
    sura: "56",
    VerseIDAr: "45",
    ayatAR: "إِنَّهُمْ كَانُوا قَبْلَ ذَٰلِكَ مُتْرَفِينَ",
  },
  {
    id: "5025",
    sura: "56",
    VerseIDAr: "46",
    ayatAR: "وَكَانُوا يُصِرُّونَ عَلَى الْحِنْثِ الْعَظِيمِ",
  },
  {
    id: "5026",
    sura: "56",
    VerseIDAr: "47",
    ayatAR:
      "وَكَانُوا يَقُولُونَ أَئِذَا مِتْنَا وَكُنَّا تُرَابًا وَعِظَامًا أَإِنَّا لَمَبْعُوثُونَ",
  },
  {
    id: "5027",
    sura: "56",
    VerseIDAr: "48",
    ayatAR: "أَوَآبَاؤُنَا الْأَوَّلُونَ",
  },
  {
    id: "5028",
    sura: "56",
    VerseIDAr: "49",
    ayatAR: "قُلْ إِنَّ الْأَوَّلِينَ وَالْآخِرِينَ",
  },
  {
    id: "5029",
    sura: "56",
    VerseIDAr: "50",
    ayatAR: "لَمَجْمُوعُونَ إِلَىٰ مِيقَاتِ يَوْمٍ مَعْلُومٍ",
  },
  {
    id: "5030",
    sura: "56",
    VerseIDAr: "51",
    ayatAR: "ثُمَّ إِنَّكُمْ أَيُّهَا الضَّالُّونَ الْمُكَذِّبُونَ",
  },
  {
    id: "5031",
    sura: "56",
    VerseIDAr: "52",
    ayatAR: "لَآكِلُونَ مِنْ شَجَرٍ مِنْ زَقُّومٍ",
  },
  {
    id: "5032",
    sura: "56",
    VerseIDAr: "53",
    ayatAR: "فَمَالِئُونَ مِنْهَا الْبُطُونَ",
  },
  {
    id: "5033",
    sura: "56",
    VerseIDAr: "54",
    ayatAR: "فَشَارِبُونَ عَلَيْهِ مِنَ الْحَمِيمِ",
  },
  {
    id: "5034",
    sura: "56",
    VerseIDAr: "55",
    ayatAR: "فَشَارِبُونَ شُرْبَ الْهِيمِ",
  },
  {
    id: "5035",
    sura: "56",
    VerseIDAr: "56",
    ayatAR: "هَٰذَا نُزُلُهُمْ يَوْمَ الدِّينِ",
  },
  {
    id: "5036",
    sura: "56",
    VerseIDAr: "57",
    ayatAR: "نَحْنُ خَلَقْنَاكُمْ فَلَوْلَا تُصَدِّقُونَ",
  },
  {
    id: "5037",
    sura: "56",
    VerseIDAr: "58",
    ayatAR: "أَفَرَأَيْتُمْ مَا تُمْنُونَ",
  },
  {
    id: "5038",
    sura: "56",
    VerseIDAr: "59",
    ayatAR: "أَأَنْتُمْ تَخْلُقُونَهُ أَمْ نَحْنُ الْخَالِقُونَ",
  },
  {
    id: "5039",
    sura: "56",
    VerseIDAr: "60",
    ayatAR:
      "نَحْنُ قَدَّرْنَا بَيْنَكُمُ الْمَوْتَ وَمَا نَحْنُ بِمَسْبُوقِينَ",
  },
  {
    id: "5040",
    sura: "56",
    VerseIDAr: "61",
    ayatAR:
      "عَلَىٰ أَنْ نُبَدِّلَ أَمْثَالَكُمْ وَنُنْشِئَكُمْ فِي مَا لَا تَعْلَمُونَ",
  },
  {
    id: "5041",
    sura: "56",
    VerseIDAr: "62",
    ayatAR: "وَلَقَدْ عَلِمْتُمُ النَّشْأَةَ الْأُولَىٰ فَلَوْلَا تَذَكَّرُونَ",
  },
  {
    id: "5042",
    sura: "56",
    VerseIDAr: "63",
    ayatAR: "أَفَرَأَيْتُمْ مَا تَحْرُثُونَ",
  },
  {
    id: "5043",
    sura: "56",
    VerseIDAr: "64",
    ayatAR: "أَأَنْتُمْ تَزْرَعُونَهُ أَمْ نَحْنُ الزَّارِعُونَ",
  },
  {
    id: "5044",
    sura: "56",
    VerseIDAr: "65",
    ayatAR: "لَوْ نَشَاءُ لَجَعَلْنَاهُ حُطَامًا فَظَلْتُمْ تَفَكَّهُونَ",
  },
  { id: "5045", sura: "56", VerseIDAr: "66", ayatAR: "إِنَّا لَمُغْرَمُونَ" },
  {
    id: "5046",
    sura: "56",
    VerseIDAr: "67",
    ayatAR: "بَلْ نَحْنُ مَحْرُومُونَ",
  },
  {
    id: "5047",
    sura: "56",
    VerseIDAr: "68",
    ayatAR: "أَفَرَأَيْتُمُ الْمَاءَ الَّذِي تَشْرَبُونَ",
  },
  {
    id: "5048",
    sura: "56",
    VerseIDAr: "69",
    ayatAR:
      "أَأَنْتُمْ أَنْزَلْتُمُوهُ مِنَ الْمُزْنِ أَمْ نَحْنُ الْمُنْزِلُونَ",
  },
  {
    id: "5049",
    sura: "56",
    VerseIDAr: "70",
    ayatAR: "لَوْ نَشَاءُ جَعَلْنَاهُ أُجَاجًا فَلَوْلَا تَشْكُرُونَ",
  },
  {
    id: "5050",
    sura: "56",
    VerseIDAr: "71",
    ayatAR: "أَفَرَأَيْتُمُ النَّارَ الَّتِي تُورُونَ",
  },
  {
    id: "5051",
    sura: "56",
    VerseIDAr: "72",
    ayatAR: "أَأَنْتُمْ أَنْشَأْتُمْ شَجَرَتَهَا أَمْ نَحْنُ الْمُنْشِئُونَ",
  },
  {
    id: "5052",
    sura: "56",
    VerseIDAr: "73",
    ayatAR: "نَحْنُ جَعَلْنَاهَا تَذْكِرَةً وَمَتَاعًا لِلْمُقْوِينَ",
  },
  {
    id: "5053",
    sura: "56",
    VerseIDAr: "74",
    ayatAR: "فَسَبِّحْ بِاسْمِ رَبِّكَ الْعَظِيمِ",
  },
  {
    id: "5054",
    sura: "56",
    VerseIDAr: "75",
    ayatAR: "فَلَا أُقْسِمُ بِمَوَاقِعِ النُّجُومِ",
  },
  {
    id: "5055",
    sura: "56",
    VerseIDAr: "76",
    ayatAR: "وَإِنَّهُ لَقَسَمٌ لَوْ تَعْلَمُونَ عَظِيمٌ",
  },
  {
    id: "5056",
    sura: "56",
    VerseIDAr: "77",
    ayatAR: "إِنَّهُ لَقُرْآنٌ كَرِيمٌ",
  },
  { id: "5057", sura: "56", VerseIDAr: "78", ayatAR: "فِي كِتَابٍ مَكْنُونٍ" },
  {
    id: "5058",
    sura: "56",
    VerseIDAr: "79",
    ayatAR: "لَا يَمَسُّهُ إِلَّا الْمُطَهَّرُونَ",
  },
  {
    id: "5059",
    sura: "56",
    VerseIDAr: "80",
    ayatAR: "تَنْزِيلٌ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "5060",
    sura: "56",
    VerseIDAr: "81",
    ayatAR: "أَفَبِهَٰذَا الْحَدِيثِ أَنْتُمْ مُدْهِنُونَ",
  },
  {
    id: "5061",
    sura: "56",
    VerseIDAr: "82",
    ayatAR: "وَتَجْعَلُونَ رِزْقَكُمْ أَنَّكُمْ تُكَذِّبُونَ",
  },
  {
    id: "5062",
    sura: "56",
    VerseIDAr: "83",
    ayatAR: "فَلَوْلَا إِذَا بَلَغَتِ الْحُلْقُومَ",
  },
  {
    id: "5063",
    sura: "56",
    VerseIDAr: "84",
    ayatAR: "وَأَنْتُمْ حِينَئِذٍ تَنْظُرُونَ",
  },
  {
    id: "5064",
    sura: "56",
    VerseIDAr: "85",
    ayatAR: "وَنَحْنُ أَقْرَبُ إِلَيْهِ مِنْكُمْ وَلَٰكِنْ لَا تُبْصِرُونَ",
  },
  {
    id: "5065",
    sura: "56",
    VerseIDAr: "86",
    ayatAR: "فَلَوْلَا إِنْ كُنْتُمْ غَيْرَ مَدِينِينَ",
  },
  {
    id: "5066",
    sura: "56",
    VerseIDAr: "87",
    ayatAR: "تَرْجِعُونَهَا إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "5067",
    sura: "56",
    VerseIDAr: "88",
    ayatAR: "فَأَمَّا إِنْ كَانَ مِنَ الْمُقَرَّبِينَ",
  },
  {
    id: "5068",
    sura: "56",
    VerseIDAr: "89",
    ayatAR: "فَرَوْحٌ وَرَيْحَانٌ وَجَنَّتُ نَعِيمٍ",
  },
  {
    id: "5069",
    sura: "56",
    VerseIDAr: "90",
    ayatAR: "وَأَمَّا إِنْ كَانَ مِنْ أَصْحَابِ الْيَمِينِ",
  },
  {
    id: "5070",
    sura: "56",
    VerseIDAr: "91",
    ayatAR: "فَسَلَامٌ لَكَ مِنْ أَصْحَابِ الْيَمِينِ",
  },
  {
    id: "5071",
    sura: "56",
    VerseIDAr: "92",
    ayatAR: "وَأَمَّا إِنْ كَانَ مِنَ الْمُكَذِّبِينَ الضَّالِّينَ",
  },
  { id: "5072", sura: "56", VerseIDAr: "93", ayatAR: "فَنُزُلٌ مِنْ حَمِيمٍ" },
  { id: "5073", sura: "56", VerseIDAr: "94", ayatAR: "وَتَصْلِيَةُ جَحِيمٍ" },
  {
    id: "5074",
    sura: "56",
    VerseIDAr: "95",
    ayatAR: "إِنَّ هَٰذَا لَهُوَ حَقُّ الْيَقِينِ",
  },
  {
    id: "5075",
    sura: "56",
    VerseIDAr: "96",
    ayatAR: "فَسَبِّحْ بِاسْمِ رَبِّكَ الْعَظِيمِ",
  },
  {
    id: "5076",
    sura: "57",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5077",
    sura: "57",
    VerseIDAr: "2",
    ayatAR:
      "لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۖ يُحْيِي وَيُمِيتُ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "5078",
    sura: "57",
    VerseIDAr: "3",
    ayatAR:
      "هُوَ الْأَوَّلُ وَالْآخِرُ وَالظَّاهِرُ وَالْبَاطِنُ ۖ وَهُوَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "5079",
    sura: "57",
    VerseIDAr: "4",
    ayatAR:
      "هُوَ الَّذِي خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ فِي سِتَّةِ أَيَّامٍ ثُمَّ اسْتَوَىٰ عَلَى الْعَرْشِ ۚ يَعْلَمُ مَا يَلِجُ فِي الْأَرْضِ وَمَا يَخْرُجُ مِنْهَا وَمَا يَنْزِلُ مِنَ السَّمَاءِ وَمَا يَعْرُجُ فِيهَا ۖ وَهُوَ مَعَكُمْ أَيْنَ مَا كُنْتُمْ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "5080",
    sura: "57",
    VerseIDAr: "5",
    ayatAR:
      "لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَإِلَى اللَّهِ تُرْجَعُ الْأُمُورُ",
  },
  {
    id: "5081",
    sura: "57",
    VerseIDAr: "6",
    ayatAR:
      "يُولِجُ اللَّيْلَ فِي النَّهَارِ وَيُولِجُ النَّهَارَ فِي اللَّيْلِ ۚ وَهُوَ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "5082",
    sura: "57",
    VerseIDAr: "7",
    ayatAR:
      "آمِنُوا بِاللَّهِ وَرَسُولِهِ وَأَنْفِقُوا مِمَّا جَعَلَكُمْ مُسْتَخْلَفِينَ فِيهِ ۖ فَالَّذِينَ آمَنُوا مِنْكُمْ وَأَنْفَقُوا لَهُمْ أَجْرٌ كَبِيرٌ",
  },
  {
    id: "5083",
    sura: "57",
    VerseIDAr: "8",
    ayatAR:
      "وَمَا لَكُمْ لَا تُؤْمِنُونَ بِاللَّهِ ۙ وَالرَّسُولُ يَدْعُوكُمْ لِتُؤْمِنُوا بِرَبِّكُمْ وَقَدْ أَخَذَ مِيثَاقَكُمْ إِنْ كُنْتُمْ مُؤْمِنِينَ",
  },
  {
    id: "5084",
    sura: "57",
    VerseIDAr: "9",
    ayatAR:
      "هُوَ الَّذِي يُنَزِّلُ عَلَىٰ عَبْدِهِ آيَاتٍ بَيِّنَاتٍ لِيُخْرِجَكُمْ مِنَ الظُّلُمَاتِ إِلَى النُّورِ ۚ وَإِنَّ اللَّهَ بِكُمْ لَرَءُوفٌ رَحِيمٌ",
  },
  {
    id: "5085",
    sura: "57",
    VerseIDAr: "10",
    ayatAR:
      "وَمَا لَكُمْ أَلَّا تُنْفِقُوا فِي سَبِيلِ اللَّهِ وَلِلَّهِ مِيرَاثُ السَّمَاوَاتِ وَالْأَرْضِ ۚ لَا يَسْتَوِي مِنْكُمْ مَنْ أَنْفَقَ مِنْ قَبْلِ الْفَتْحِ وَقَاتَلَ ۚ أُولَٰئِكَ أَعْظَمُ دَرَجَةً مِنَ الَّذِينَ أَنْفَقُوا مِنْ بَعْدُ وَقَاتَلُوا ۚ وَكُلًّا وَعَدَ اللَّهُ الْحُسْنَىٰ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "5086",
    sura: "57",
    VerseIDAr: "11",
    ayatAR:
      "مَنْ ذَا الَّذِي يُقْرِضُ اللَّهَ قَرْضًا حَسَنًا فَيُضَاعِفَهُ لَهُ وَلَهُ أَجْرٌ كَرِيمٌ",
  },
  {
    id: "5087",
    sura: "57",
    VerseIDAr: "12",
    ayatAR:
      "يَوْمَ تَرَى الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ يَسْعَىٰ نُورُهُمْ بَيْنَ أَيْدِيهِمْ وَبِأَيْمَانِهِمْ بُشْرَاكُمُ الْيَوْمَ جَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ ذَٰلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "5088",
    sura: "57",
    VerseIDAr: "13",
    ayatAR:
      "يَوْمَ يَقُولُ الْمُنَافِقُونَ وَالْمُنَافِقَاتُ لِلَّذِينَ آمَنُوا انْظُرُونَا نَقْتَبِسْ مِنْ نُورِكُمْ قِيلَ ارْجِعُوا وَرَاءَكُمْ فَالْتَمِسُوا نُورًا فَضُرِبَ بَيْنَهُمْ بِسُورٍ لَهُ بَابٌ بَاطِنُهُ فِيهِ الرَّحْمَةُ وَظَاهِرُهُ مِنْ قِبَلِهِ الْعَذَابُ",
  },
  {
    id: "5089",
    sura: "57",
    VerseIDAr: "14",
    ayatAR:
      "يُنَادُونَهُمْ أَلَمْ نَكُنْ مَعَكُمْ ۖ قَالُوا بَلَىٰ وَلَٰكِنَّكُمْ فَتَنْتُمْ أَنْفُسَكُمْ وَتَرَبَّصْتُمْ وَارْتَبْتُمْ وَغَرَّتْكُمُ الْأَمَانِيُّ حَتَّىٰ جَاءَ أَمْرُ اللَّهِ وَغَرَّكُمْ بِاللَّهِ الْغَرُورُ",
  },
  {
    id: "5090",
    sura: "57",
    VerseIDAr: "15",
    ayatAR:
      "فَالْيَوْمَ لَا يُؤْخَذُ مِنْكُمْ فِدْيَةٌ وَلَا مِنَ الَّذِينَ كَفَرُوا ۚ مَأْوَاكُمُ النَّارُ ۖ هِيَ مَوْلَاكُمْ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "5091",
    sura: "57",
    VerseIDAr: "16",
    ayatAR:
      "أَلَمْ يَأْنِ لِلَّذِينَ آمَنُوا أَنْ تَخْشَعَ قُلُوبُهُمْ لِذِكْرِ اللَّهِ وَمَا نَزَلَ مِنَ الْحَقِّ وَلَا يَكُونُوا كَالَّذِينَ أُوتُوا الْكِتَابَ مِنْ قَبْلُ فَطَالَ عَلَيْهِمُ الْأَمَدُ فَقَسَتْ قُلُوبُهُمْ ۖ وَكَثِيرٌ مِنْهُمْ فَاسِقُونَ",
  },
  {
    id: "5092",
    sura: "57",
    VerseIDAr: "17",
    ayatAR:
      "اعْلَمُوا أَنَّ اللَّهَ يُحْيِي الْأَرْضَ بَعْدَ مَوْتِهَا ۚ قَدْ بَيَّنَّا لَكُمُ الْآيَاتِ لَعَلَّكُمْ تَعْقِلُونَ",
  },
  {
    id: "5093",
    sura: "57",
    VerseIDAr: "18",
    ayatAR:
      "إِنَّ الْمُصَّدِّقِينَ وَالْمُصَّدِّقَاتِ وَأَقْرَضُوا اللَّهَ قَرْضًا حَسَنًا يُضَاعَفُ لَهُمْ وَلَهُمْ أَجْرٌ كَرِيمٌ",
  },
  {
    id: "5094",
    sura: "57",
    VerseIDAr: "19",
    ayatAR:
      "وَالَّذِينَ آمَنُوا بِاللَّهِ وَرُسُلِهِ أُولَٰئِكَ هُمُ الصِّدِّيقُونَ ۖ وَالشُّهَدَاءُ عِنْدَ رَبِّهِمْ لَهُمْ أَجْرُهُمْ وَنُورُهُمْ ۖ وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا أُولَٰئِكَ أَصْحَابُ الْجَحِيمِ",
  },
  {
    id: "5095",
    sura: "57",
    VerseIDAr: "20",
    ayatAR:
      "اعْلَمُوا أَنَّمَا الْحَيَاةُ الدُّنْيَا لَعِبٌ وَلَهْوٌ وَزِينَةٌ وَتَفَاخُرٌ بَيْنَكُمْ وَتَكَاثُرٌ فِي الْأَمْوَالِ وَالْأَوْلَادِ ۖ كَمَثَلِ غَيْثٍ أَعْجَبَ الْكُفَّارَ نَبَاتُهُ ثُمَّ يَهِيجُ فَتَرَاهُ مُصْفَرًّا ثُمَّ يَكُونُ حُطَامًا ۖ وَفِي الْآخِرَةِ عَذَابٌ شَدِيدٌ وَمَغْفِرَةٌ مِنَ اللَّهِ وَرِضْوَانٌ ۚ وَمَا الْحَيَاةُ الدُّنْيَا إِلَّا مَتَاعُ الْغُرُورِ",
  },
  {
    id: "5096",
    sura: "57",
    VerseIDAr: "21",
    ayatAR:
      "سَابِقُوا إِلَىٰ مَغْفِرَةٍ مِنْ رَبِّكُمْ وَجَنَّةٍ عَرْضُهَا كَعَرْضِ السَّمَاءِ وَالْأَرْضِ أُعِدَّتْ لِلَّذِينَ آمَنُوا بِاللَّهِ وَرُسُلِهِ ۚ ذَٰلِكَ فَضْلُ اللَّهِ يُؤْتِيهِ مَنْ يَشَاءُ ۚ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "5097",
    sura: "57",
    VerseIDAr: "22",
    ayatAR:
      "مَا أَصَابَ مِنْ مُصِيبَةٍ فِي الْأَرْضِ وَلَا فِي أَنْفُسِكُمْ إِلَّا فِي كِتَابٍ مِنْ قَبْلِ أَنْ نَبْرَأَهَا ۚ إِنَّ ذَٰلِكَ عَلَى اللَّهِ يَسِيرٌ",
  },
  {
    id: "5098",
    sura: "57",
    VerseIDAr: "23",
    ayatAR:
      "لِكَيْلَا تَأْسَوْا عَلَىٰ مَا فَاتَكُمْ وَلَا تَفْرَحُوا بِمَا آتَاكُمْ ۗ وَاللَّهُ لَا يُحِبُّ كُلَّ مُخْتَالٍ فَخُورٍ",
  },
  {
    id: "5099",
    sura: "57",
    VerseIDAr: "24",
    ayatAR:
      "الَّذِينَ يَبْخَلُونَ وَيَأْمُرُونَ النَّاسَ بِالْبُخْلِ ۗ وَمَنْ يَتَوَلَّ فَإِنَّ اللَّهَ هُوَ الْغَنِيُّ الْحَمِيدُ",
  },
  {
    id: "5100",
    sura: "57",
    VerseIDAr: "25",
    ayatAR:
      "لَقَدْ أَرْسَلْنَا رُسُلَنَا بِالْبَيِّنَاتِ وَأَنْزَلْنَا مَعَهُمُ الْكِتَابَ وَالْمِيزَانَ لِيَقُومَ النَّاسُ بِالْقِسْطِ ۖ وَأَنْزَلْنَا الْحَدِيدَ فِيهِ بَأْسٌ شَدِيدٌ وَمَنَافِعُ لِلنَّاسِ وَلِيَعْلَمَ اللَّهُ مَنْ يَنْصُرُهُ وَرُسُلَهُ بِالْغَيْبِ ۚ إِنَّ اللَّهَ قَوِيٌّ عَزِيزٌ",
  },
  {
    id: "5101",
    sura: "57",
    VerseIDAr: "26",
    ayatAR:
      "وَلَقَدْ أَرْسَلْنَا نُوحًا وَإِبْرَاهِيمَ وَجَعَلْنَا فِي ذُرِّيَّتِهِمَا النُّبُوَّةَ وَالْكِتَابَ ۖ فَمِنْهُمْ مُهْتَدٍ ۖ وَكَثِيرٌ مِنْهُمْ فَاسِقُونَ",
  },
  {
    id: "5102",
    sura: "57",
    VerseIDAr: "27",
    ayatAR:
      "ثُمَّ قَفَّيْنَا عَلَىٰ آثَارِهِمْ بِرُسُلِنَا وَقَفَّيْنَا بِعِيسَى ابْنِ مَرْيَمَ وَآتَيْنَاهُ الْإِنْجِيلَ وَجَعَلْنَا فِي قُلُوبِ الَّذِينَ اتَّبَعُوهُ رَأْفَةً وَرَحْمَةً وَرَهْبَانِيَّةً ابْتَدَعُوهَا مَا كَتَبْنَاهَا عَلَيْهِمْ إِلَّا ابْتِغَاءَ رِضْوَانِ اللَّهِ فَمَا رَعَوْهَا حَقَّ رِعَايَتِهَا ۖ فَآتَيْنَا الَّذِينَ آمَنُوا مِنْهُمْ أَجْرَهُمْ ۖ وَكَثِيرٌ مِنْهُمْ فَاسِقُونَ",
  },
  {
    id: "5103",
    sura: "57",
    VerseIDAr: "28",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَآمِنُوا بِرَسُولِهِ يُؤْتِكُمْ كِفْلَيْنِ مِنْ رَحْمَتِهِ وَيَجْعَلْ لَكُمْ نُورًا تَمْشُونَ بِهِ وَيَغْفِرْ لَكُمْ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5104",
    sura: "57",
    VerseIDAr: "29",
    ayatAR:
      "لِئَلَّا يَعْلَمَ أَهْلُ الْكِتَابِ أَلَّا يَقْدِرُونَ عَلَىٰ شَيْءٍ مِنْ فَضْلِ اللَّهِ ۙ وَأَنَّ الْفَضْلَ بِيَدِ اللَّهِ يُؤْتِيهِ مَنْ يَشَاءُ ۚ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "5105",
    sura: "58",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قَدْ سَمِعَ اللَّهُ قَوْلَ الَّتِي تُجَادِلُكَ فِي زَوْجِهَا وَتَشْتَكِي إِلَى اللَّهِ وَاللَّهُ يَسْمَعُ تَحَاوُرَكُمَا ۚ إِنَّ اللَّهَ سَمِيعٌ بَصِيرٌ",
  },
  {
    id: "5106",
    sura: "58",
    VerseIDAr: "2",
    ayatAR:
      "الَّذِينَ يُظَاهِرُونَ مِنْكُمْ مِنْ نِسَائِهِمْ مَا هُنَّ أُمَّهَاتِهِمْ ۖ إِنْ أُمَّهَاتُهُمْ إِلَّا اللَّائِي وَلَدْنَهُمْ ۚ وَإِنَّهُمْ لَيَقُولُونَ مُنْكَرًا مِنَ الْقَوْلِ وَزُورًا ۚ وَإِنَّ اللَّهَ لَعَفُوٌّ غَفُورٌ",
  },
  {
    id: "5107",
    sura: "58",
    VerseIDAr: "3",
    ayatAR:
      "وَالَّذِينَ يُظَاهِرُونَ مِنْ نِسَائِهِمْ ثُمَّ يَعُودُونَ لِمَا قَالُوا فَتَحْرِيرُ رَقَبَةٍ مِنْ قَبْلِ أَنْ يَتَمَاسَّا ۚ ذَٰلِكُمْ تُوعَظُونَ بِهِ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "5108",
    sura: "58",
    VerseIDAr: "4",
    ayatAR:
      "فَمَنْ لَمْ يَجِدْ فَصِيَامُ شَهْرَيْنِ مُتَتَابِعَيْنِ مِنْ قَبْلِ أَنْ يَتَمَاسَّا ۖ فَمَنْ لَمْ يَسْتَطِعْ فَإِطْعَامُ سِتِّينَ مِسْكِينًا ۚ ذَٰلِكَ لِتُؤْمِنُوا بِاللَّهِ وَرَسُولِهِ ۚ وَتِلْكَ حُدُودُ اللَّهِ ۗ وَلِلْكَافِرِينَ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "5109",
    sura: "58",
    VerseIDAr: "5",
    ayatAR:
      "إِنَّ الَّذِينَ يُحَادُّونَ اللَّهَ وَرَسُولَهُ كُبِتُوا كَمَا كُبِتَ الَّذِينَ مِنْ قَبْلِهِمْ ۚ وَقَدْ أَنْزَلْنَا آيَاتٍ بَيِّنَاتٍ ۚ وَلِلْكَافِرِينَ عَذَابٌ مُهِينٌ",
  },
  {
    id: "5110",
    sura: "58",
    VerseIDAr: "6",
    ayatAR:
      "يَوْمَ يَبْعَثُهُمُ اللَّهُ جَمِيعًا فَيُنَبِّئُهُمْ بِمَا عَمِلُوا ۚ أَحْصَاهُ اللَّهُ وَنَسُوهُ ۚ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "5111",
    sura: "58",
    VerseIDAr: "7",
    ayatAR:
      "أَلَمْ تَرَ أَنَّ اللَّهَ يَعْلَمُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۖ مَا يَكُونُ مِنْ نَجْوَىٰ ثَلَاثَةٍ إِلَّا هُوَ رَابِعُهُمْ وَلَا خَمْسَةٍ إِلَّا هُوَ سَادِسُهُمْ وَلَا أَدْنَىٰ مِنْ ذَٰلِكَ وَلَا أَكْثَرَ إِلَّا هُوَ مَعَهُمْ أَيْنَ مَا كَانُوا ۖ ثُمَّ يُنَبِّئُهُمْ بِمَا عَمِلُوا يَوْمَ الْقِيَامَةِ ۚ إِنَّ اللَّهَ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "5112",
    sura: "58",
    VerseIDAr: "8",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ نُهُوا عَنِ النَّجْوَىٰ ثُمَّ يَعُودُونَ لِمَا نُهُوا عَنْهُ وَيَتَنَاجَوْنَ بِالْإِثْمِ وَالْعُدْوَانِ وَمَعْصِيَتِ الرَّسُولِ وَإِذَا جَاءُوكَ حَيَّوْكَ بِمَا لَمْ يُحَيِّكَ بِهِ اللَّهُ وَيَقُولُونَ فِي أَنْفُسِهِمْ لَوْلَا يُعَذِّبُنَا اللَّهُ بِمَا نَقُولُ ۚ حَسْبُهُمْ جَهَنَّمُ يَصْلَوْنَهَا ۖ فَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "5113",
    sura: "58",
    VerseIDAr: "9",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا تَنَاجَيْتُمْ فَلَا تَتَنَاجَوْا بِالْإِثْمِ وَالْعُدْوَانِ وَمَعْصِيَتِ الرَّسُولِ وَتَنَاجَوْا بِالْبِرِّ وَالتَّقْوَىٰ ۖ وَاتَّقُوا اللَّهَ الَّذِي إِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "5114",
    sura: "58",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّمَا النَّجْوَىٰ مِنَ الشَّيْطَانِ لِيَحْزُنَ الَّذِينَ آمَنُوا وَلَيْسَ بِضَارِّهِمْ شَيْئًا إِلَّا بِإِذْنِ اللَّهِ ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "5115",
    sura: "58",
    VerseIDAr: "11",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا قِيلَ لَكُمْ تَفَسَّحُوا فِي الْمَجَالِسِ فَافْسَحُوا يَفْسَحِ اللَّهُ لَكُمْ ۖ وَإِذَا قِيلَ انْشُزُوا فَانْشُزُوا يَرْفَعِ اللَّهُ الَّذِينَ آمَنُوا مِنْكُمْ وَالَّذِينَ أُوتُوا الْعِلْمَ دَرَجَاتٍ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "5116",
    sura: "58",
    VerseIDAr: "12",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا نَاجَيْتُمُ الرَّسُولَ فَقَدِّمُوا بَيْنَ يَدَيْ نَجْوَاكُمْ صَدَقَةً ۚ ذَٰلِكَ خَيْرٌ لَكُمْ وَأَطْهَرُ ۚ فَإِنْ لَمْ تَجِدُوا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5117",
    sura: "58",
    VerseIDAr: "13",
    ayatAR:
      "أَأَشْفَقْتُمْ أَنْ تُقَدِّمُوا بَيْنَ يَدَيْ نَجْوَاكُمْ صَدَقَاتٍ ۚ فَإِذْ لَمْ تَفْعَلُوا وَتَابَ اللَّهُ عَلَيْكُمْ فَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَأَطِيعُوا اللَّهَ وَرَسُولَهُ ۚ وَاللَّهُ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "5118",
    sura: "58",
    VerseIDAr: "14",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ تَوَلَّوْا قَوْمًا غَضِبَ اللَّهُ عَلَيْهِمْ مَا هُمْ مِنْكُمْ وَلَا مِنْهُمْ وَيَحْلِفُونَ عَلَى الْكَذِبِ وَهُمْ يَعْلَمُونَ",
  },
  {
    id: "5119",
    sura: "58",
    VerseIDAr: "15",
    ayatAR:
      "أَعَدَّ اللَّهُ لَهُمْ عَذَابًا شَدِيدًا ۖ إِنَّهُمْ سَاءَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "5120",
    sura: "58",
    VerseIDAr: "16",
    ayatAR:
      "اتَّخَذُوا أَيْمَانَهُمْ جُنَّةً فَصَدُّوا عَنْ سَبِيلِ اللَّهِ فَلَهُمْ عَذَابٌ مُهِينٌ",
  },
  {
    id: "5121",
    sura: "58",
    VerseIDAr: "17",
    ayatAR:
      "لَنْ تُغْنِيَ عَنْهُمْ أَمْوَالُهُمْ وَلَا أَوْلَادُهُمْ مِنَ اللَّهِ شَيْئًا ۚ أُولَٰئِكَ أَصْحَابُ النَّارِ ۖ هُمْ فِيهَا خَالِدُونَ",
  },
  {
    id: "5122",
    sura: "58",
    VerseIDAr: "18",
    ayatAR:
      "يَوْمَ يَبْعَثُهُمُ اللَّهُ جَمِيعًا فَيَحْلِفُونَ لَهُ كَمَا يَحْلِفُونَ لَكُمْ ۖ وَيَحْسَبُونَ أَنَّهُمْ عَلَىٰ شَيْءٍ ۚ أَلَا إِنَّهُمْ هُمُ الْكَاذِبُونَ",
  },
  {
    id: "5123",
    sura: "58",
    VerseIDAr: "19",
    ayatAR:
      "اسْتَحْوَذَ عَلَيْهِمُ الشَّيْطَانُ فَأَنْسَاهُمْ ذِكْرَ اللَّهِ ۚ أُولَٰئِكَ حِزْبُ الشَّيْطَانِ ۚ أَلَا إِنَّ حِزْبَ الشَّيْطَانِ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "5124",
    sura: "58",
    VerseIDAr: "20",
    ayatAR:
      "إِنَّ الَّذِينَ يُحَادُّونَ اللَّهَ وَرَسُولَهُ أُولَٰئِكَ فِي الْأَذَلِّينَ",
  },
  {
    id: "5125",
    sura: "58",
    VerseIDAr: "21",
    ayatAR:
      "كَتَبَ اللَّهُ لَأَغْلِبَنَّ أَنَا وَرُسُلِي ۚ إِنَّ اللَّهَ قَوِيٌّ عَزِيزٌ",
  },
  {
    id: "5126",
    sura: "58",
    VerseIDAr: "22",
    ayatAR:
      "لَا تَجِدُ قَوْمًا يُؤْمِنُونَ بِاللَّهِ وَالْيَوْمِ الْآخِرِ يُوَادُّونَ مَنْ حَادَّ اللَّهَ وَرَسُولَهُ وَلَوْ كَانُوا آبَاءَهُمْ أَوْ أَبْنَاءَهُمْ أَوْ إِخْوَانَهُمْ أَوْ عَشِيرَتَهُمْ ۚ أُولَٰئِكَ كَتَبَ فِي قُلُوبِهِمُ الْإِيمَانَ وَأَيَّدَهُمْ بِرُوحٍ مِنْهُ ۖ وَيُدْخِلُهُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا ۚ رَضِيَ اللَّهُ عَنْهُمْ وَرَضُوا عَنْهُ ۚ أُولَٰئِكَ حِزْبُ اللَّهِ ۚ أَلَا إِنَّ حِزْبَ اللَّهِ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "5127",
    sura: "59",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۖ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5128",
    sura: "59",
    VerseIDAr: "2",
    ayatAR:
      "هُوَ الَّذِي أَخْرَجَ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ مِنْ دِيَارِهِمْ لِأَوَّلِ الْحَشْرِ ۚ مَا ظَنَنْتُمْ أَنْ يَخْرُجُوا ۖ وَظَنُّوا أَنَّهُمْ مَانِعَتُهُمْ حُصُونُهُمْ مِنَ اللَّهِ فَأَتَاهُمُ اللَّهُ مِنْ حَيْثُ لَمْ يَحْتَسِبُوا ۖ وَقَذَفَ فِي قُلُوبِهِمُ الرُّعْبَ ۚ يُخْرِبُونَ بُيُوتَهُمْ بِأَيْدِيهِمْ وَأَيْدِي الْمُؤْمِنِينَ فَاعْتَبِرُوا يَا أُولِي الْأَبْصَارِ",
  },
  {
    id: "5129",
    sura: "59",
    VerseIDAr: "3",
    ayatAR:
      "وَلَوْلَا أَنْ كَتَبَ اللَّهُ عَلَيْهِمُ الْجَلَاءَ لَعَذَّبَهُمْ فِي الدُّنْيَا ۖ وَلَهُمْ فِي الْآخِرَةِ عَذَابُ النَّارِ",
  },
  {
    id: "5130",
    sura: "59",
    VerseIDAr: "4",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ شَاقُّوا اللَّهَ وَرَسُولَهُ ۖ وَمَنْ يُشَاقِّ اللَّهَ فَإِنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "5131",
    sura: "59",
    VerseIDAr: "5",
    ayatAR:
      "مَا قَطَعْتُمْ مِنْ لِينَةٍ أَوْ تَرَكْتُمُوهَا قَائِمَةً عَلَىٰ أُصُولِهَا فَبِإِذْنِ اللَّهِ وَلِيُخْزِيَ الْفَاسِقِينَ",
  },
  {
    id: "5132",
    sura: "59",
    VerseIDAr: "6",
    ayatAR:
      "وَمَا أَفَاءَ اللَّهُ عَلَىٰ رَسُولِهِ مِنْهُمْ فَمَا أَوْجَفْتُمْ عَلَيْهِ مِنْ خَيْلٍ وَلَا رِكَابٍ وَلَٰكِنَّ اللَّهَ يُسَلِّطُ رُسُلَهُ عَلَىٰ مَنْ يَشَاءُ ۚ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "5133",
    sura: "59",
    VerseIDAr: "7",
    ayatAR:
      "مَا أَفَاءَ اللَّهُ عَلَىٰ رَسُولِهِ مِنْ أَهْلِ الْقُرَىٰ فَلِلَّهِ وَلِلرَّسُولِ وَلِذِي الْقُرْبَىٰ وَالْيَتَامَىٰ وَالْمَسَاكِينِ وَابْنِ السَّبِيلِ كَيْ لَا يَكُونَ دُولَةً بَيْنَ الْأَغْنِيَاءِ مِنْكُمْ ۚ وَمَا آتَاكُمُ الرَّسُولُ فَخُذُوهُ وَمَا نَهَاكُمْ عَنْهُ فَانْتَهُوا ۚ وَاتَّقُوا اللَّهَ ۖ إِنَّ اللَّهَ شَدِيدُ الْعِقَابِ",
  },
  {
    id: "5134",
    sura: "59",
    VerseIDAr: "8",
    ayatAR:
      "لِلْفُقَرَاءِ الْمُهَاجِرِينَ الَّذِينَ أُخْرِجُوا مِنْ دِيَارِهِمْ وَأَمْوَالِهِمْ يَبْتَغُونَ فَضْلًا مِنَ اللَّهِ وَرِضْوَانًا وَيَنْصُرُونَ اللَّهَ وَرَسُولَهُ ۚ أُولَٰئِكَ هُمُ الصَّادِقُونَ",
  },
  {
    id: "5135",
    sura: "59",
    VerseIDAr: "9",
    ayatAR:
      "وَالَّذِينَ تَبَوَّءُوا الدَّارَ وَالْإِيمَانَ مِنْ قَبْلِهِمْ يُحِبُّونَ مَنْ هَاجَرَ إِلَيْهِمْ وَلَا يَجِدُونَ فِي صُدُورِهِمْ حَاجَةً مِمَّا أُوتُوا وَيُؤْثِرُونَ عَلَىٰ أَنْفُسِهِمْ وَلَوْ كَانَ بِهِمْ خَصَاصَةٌ ۚ وَمَنْ يُوقَ شُحَّ نَفْسِهِ فَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "5136",
    sura: "59",
    VerseIDAr: "10",
    ayatAR:
      "وَالَّذِينَ جَاءُوا مِنْ بَعْدِهِمْ يَقُولُونَ رَبَّنَا اغْفِرْ لَنَا وَلِإِخْوَانِنَا الَّذِينَ سَبَقُونَا بِالْإِيمَانِ وَلَا تَجْعَلْ فِي قُلُوبِنَا غِلًّا لِلَّذِينَ آمَنُوا رَبَّنَا إِنَّكَ رَءُوفٌ رَحِيمٌ",
  },
  {
    id: "5137",
    sura: "59",
    VerseIDAr: "11",
    ayatAR:
      "أَلَمْ تَرَ إِلَى الَّذِينَ نَافَقُوا يَقُولُونَ لِإِخْوَانِهِمُ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ لَئِنْ أُخْرِجْتُمْ لَنَخْرُجَنَّ مَعَكُمْ وَلَا نُطِيعُ فِيكُمْ أَحَدًا أَبَدًا وَإِنْ قُوتِلْتُمْ لَنَنْصُرَنَّكُمْ وَاللَّهُ يَشْهَدُ إِنَّهُمْ لَكَاذِبُونَ",
  },
  {
    id: "5138",
    sura: "59",
    VerseIDAr: "12",
    ayatAR:
      "لَئِنْ أُخْرِجُوا لَا يَخْرُجُونَ مَعَهُمْ وَلَئِنْ قُوتِلُوا لَا يَنْصُرُونَهُمْ وَلَئِنْ نَصَرُوهُمْ لَيُوَلُّنَّ الْأَدْبَارَ ثُمَّ لَا يُنْصَرُونَ",
  },
  {
    id: "5139",
    sura: "59",
    VerseIDAr: "13",
    ayatAR:
      "لَأَنْتُمْ أَشَدُّ رَهْبَةً فِي صُدُورِهِمْ مِنَ اللَّهِ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌ لَا يَفْقَهُونَ",
  },
  {
    id: "5140",
    sura: "59",
    VerseIDAr: "14",
    ayatAR:
      "لَا يُقَاتِلُونَكُمْ جَمِيعًا إِلَّا فِي قُرًى مُحَصَّنَةٍ أَوْ مِنْ وَرَاءِ جُدُرٍ ۚ بَأْسُهُمْ بَيْنَهُمْ شَدِيدٌ ۚ تَحْسَبُهُمْ جَمِيعًا وَقُلُوبُهُمْ شَتَّىٰ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌ لَا يَعْقِلُونَ",
  },
  {
    id: "5141",
    sura: "59",
    VerseIDAr: "15",
    ayatAR:
      "كَمَثَلِ الَّذِينَ مِنْ قَبْلِهِمْ قَرِيبًا ۖ ذَاقُوا وَبَالَ أَمْرِهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "5142",
    sura: "59",
    VerseIDAr: "16",
    ayatAR:
      "كَمَثَلِ الشَّيْطَانِ إِذْ قَالَ لِلْإِنْسَانِ اكْفُرْ فَلَمَّا كَفَرَ قَالَ إِنِّي بَرِيءٌ مِنْكَ إِنِّي أَخَافُ اللَّهَ رَبَّ الْعَالَمِينَ",
  },
  {
    id: "5143",
    sura: "59",
    VerseIDAr: "17",
    ayatAR:
      "فَكَانَ عَاقِبَتَهُمَا أَنَّهُمَا فِي النَّارِ خَالِدَيْنِ فِيهَا ۚ وَذَٰلِكَ جَزَاءُ الظَّالِمِينَ",
  },
  {
    id: "5144",
    sura: "59",
    VerseIDAr: "18",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا اتَّقُوا اللَّهَ وَلْتَنْظُرْ نَفْسٌ مَا قَدَّمَتْ لِغَدٍ ۖ وَاتَّقُوا اللَّهَ ۚ إِنَّ اللَّهَ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "5145",
    sura: "59",
    VerseIDAr: "19",
    ayatAR:
      "وَلَا تَكُونُوا كَالَّذِينَ نَسُوا اللَّهَ فَأَنْسَاهُمْ أَنْفُسَهُمْ ۚ أُولَٰئِكَ هُمُ الْفَاسِقُونَ",
  },
  {
    id: "5146",
    sura: "59",
    VerseIDAr: "20",
    ayatAR:
      "لَا يَسْتَوِي أَصْحَابُ النَّارِ وَأَصْحَابُ الْجَنَّةِ ۚ أَصْحَابُ الْجَنَّةِ هُمُ الْفَائِزُونَ",
  },
  {
    id: "5147",
    sura: "59",
    VerseIDAr: "21",
    ayatAR:
      "لَوْ أَنْزَلْنَا هَٰذَا الْقُرْآنَ عَلَىٰ جَبَلٍ لَرَأَيْتَهُ خَاشِعًا مُتَصَدِّعًا مِنْ خَشْيَةِ اللَّهِ ۚ وَتِلْكَ الْأَمْثَالُ نَضْرِبُهَا لِلنَّاسِ لَعَلَّهُمْ يَتَفَكَّرُونَ",
  },
  {
    id: "5148",
    sura: "59",
    VerseIDAr: "22",
    ayatAR:
      "هُوَ اللَّهُ الَّذِي لَا إِلَٰهَ إِلَّا هُوَ ۖ عَالِمُ الْغَيْبِ وَالشَّهَادَةِ ۖ هُوَ الرَّحْمَٰنُ الرَّحِيمُ",
  },
  {
    id: "5149",
    sura: "59",
    VerseIDAr: "23",
    ayatAR:
      "هُوَ اللَّهُ الَّذِي لَا إِلَٰهَ إِلَّا هُوَ الْمَلِكُ الْقُدُّوسُ السَّلَامُ الْمُؤْمِنُ الْمُهَيْمِنُ الْعَزِيزُ الْجَبَّارُ الْمُتَكَبِّرُ ۚ سُبْحَانَ اللَّهِ عَمَّا يُشْرِكُونَ",
  },
  {
    id: "5150",
    sura: "59",
    VerseIDAr: "24",
    ayatAR:
      "هُوَ اللَّهُ الْخَالِقُ الْبَارِئُ الْمُصَوِّرُ ۖ لَهُ الْأَسْمَاءُ الْحُسْنَىٰ ۚ يُسَبِّحُ لَهُ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ ۖ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5151",
    sura: "60",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَّخِذُوا عَدُوِّي وَعَدُوَّكُمْ أَوْلِيَاءَ تُلْقُونَ إِلَيْهِمْ بِالْمَوَدَّةِ وَقَدْ كَفَرُوا بِمَا جَاءَكُمْ مِنَ الْحَقِّ يُخْرِجُونَ الرَّسُولَ وَإِيَّاكُمْ ۙ أَنْ تُؤْمِنُوا بِاللَّهِ رَبِّكُمْ إِنْ كُنْتُمْ خَرَجْتُمْ جِهَادًا فِي سَبِيلِي وَابْتِغَاءَ مَرْضَاتِي ۚ تُسِرُّونَ إِلَيْهِمْ بِالْمَوَدَّةِ وَأَنَا أَعْلَمُ بِمَا أَخْفَيْتُمْ وَمَا أَعْلَنْتُمْ ۚ وَمَنْ يَفْعَلْهُ مِنْكُمْ فَقَدْ ضَلَّ سَوَاءَ السَّبِيلِ",
  },
  {
    id: "5152",
    sura: "60",
    VerseIDAr: "2",
    ayatAR:
      "إِنْ يَثْقَفُوكُمْ يَكُونُوا لَكُمْ أَعْدَاءً وَيَبْسُطُوا إِلَيْكُمْ أَيْدِيَهُمْ وَأَلْسِنَتَهُمْ بِالسُّوءِ وَوَدُّوا لَوْ تَكْفُرُونَ",
  },
  {
    id: "5153",
    sura: "60",
    VerseIDAr: "3",
    ayatAR:
      "لَنْ تَنْفَعَكُمْ أَرْحَامُكُمْ وَلَا أَوْلَادُكُمْ ۚ يَوْمَ الْقِيَامَةِ يَفْصِلُ بَيْنَكُمْ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "5154",
    sura: "60",
    VerseIDAr: "4",
    ayatAR:
      "قَدْ كَانَتْ لَكُمْ أُسْوَةٌ حَسَنَةٌ فِي إِبْرَاهِيمَ وَالَّذِينَ مَعَهُ إِذْ قَالُوا لِقَوْمِهِمْ إِنَّا بُرَآءُ مِنْكُمْ وَمِمَّا تَعْبُدُونَ مِنْ دُونِ اللَّهِ كَفَرْنَا بِكُمْ وَبَدَا بَيْنَنَا وَبَيْنَكُمُ الْعَدَاوَةُ وَالْبَغْضَاءُ أَبَدًا حَتَّىٰ تُؤْمِنُوا بِاللَّهِ وَحْدَهُ إِلَّا قَوْلَ إِبْرَاهِيمَ لِأَبِيهِ لَأَسْتَغْفِرَنَّ لَكَ وَمَا أَمْلِكُ لَكَ مِنَ اللَّهِ مِنْ شَيْءٍ ۖ رَبَّنَا عَلَيْكَ تَوَكَّلْنَا وَإِلَيْكَ أَنَبْنَا وَإِلَيْكَ الْمَصِيرُ",
  },
  {
    id: "5155",
    sura: "60",
    VerseIDAr: "5",
    ayatAR:
      "رَبَّنَا لَا تَجْعَلْنَا فِتْنَةً لِلَّذِينَ كَفَرُوا وَاغْفِرْ لَنَا رَبَّنَا ۖ إِنَّكَ أَنْتَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5156",
    sura: "60",
    VerseIDAr: "6",
    ayatAR:
      "لَقَدْ كَانَ لَكُمْ فِيهِمْ أُسْوَةٌ حَسَنَةٌ لِمَنْ كَانَ يَرْجُو اللَّهَ وَالْيَوْمَ الْآخِرَ ۚ وَمَنْ يَتَوَلَّ فَإِنَّ اللَّهَ هُوَ الْغَنِيُّ الْحَمِيدُ",
  },
  {
    id: "5157",
    sura: "60",
    VerseIDAr: "7",
    ayatAR:
      "عَسَى اللَّهُ أَنْ يَجْعَلَ بَيْنَكُمْ وَبَيْنَ الَّذِينَ عَادَيْتُمْ مِنْهُمْ مَوَدَّةً ۚ وَاللَّهُ قَدِيرٌ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5158",
    sura: "60",
    VerseIDAr: "8",
    ayatAR:
      "لَا يَنْهَاكُمُ اللَّهُ عَنِ الَّذِينَ لَمْ يُقَاتِلُوكُمْ فِي الدِّينِ وَلَمْ يُخْرِجُوكُمْ مِنْ دِيَارِكُمْ أَنْ تَبَرُّوهُمْ وَتُقْسِطُوا إِلَيْهِمْ ۚ إِنَّ اللَّهَ يُحِبُّ الْمُقْسِطِينَ",
  },
  {
    id: "5159",
    sura: "60",
    VerseIDAr: "9",
    ayatAR:
      "إِنَّمَا يَنْهَاكُمُ اللَّهُ عَنِ الَّذِينَ قَاتَلُوكُمْ فِي الدِّينِ وَأَخْرَجُوكُمْ مِنْ دِيَارِكُمْ وَظَاهَرُوا عَلَىٰ إِخْرَاجِكُمْ أَنْ تَوَلَّوْهُمْ ۚ وَمَنْ يَتَوَلَّهُمْ فَأُولَٰئِكَ هُمُ الظَّالِمُونَ",
  },
  {
    id: "5160",
    sura: "60",
    VerseIDAr: "10",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا جَاءَكُمُ الْمُؤْمِنَاتُ مُهَاجِرَاتٍ فَامْتَحِنُوهُنَّ ۖ اللَّهُ أَعْلَمُ بِإِيمَانِهِنَّ ۖ فَإِنْ عَلِمْتُمُوهُنَّ مُؤْمِنَاتٍ فَلَا تَرْجِعُوهُنَّ إِلَى الْكُفَّارِ ۖ لَا هُنَّ حِلٌّ لَهُمْ وَلَا هُمْ يَحِلُّونَ لَهُنَّ ۖ وَآتُوهُمْ مَا أَنْفَقُوا ۚ وَلَا جُنَاحَ عَلَيْكُمْ أَنْ تَنْكِحُوهُنَّ إِذَا آتَيْتُمُوهُنَّ أُجُورَهُنَّ ۚ وَلَا تُمْسِكُوا بِعِصَمِ الْكَوَافِرِ وَاسْأَلُوا مَا أَنْفَقْتُمْ وَلْيَسْأَلُوا مَا أَنْفَقُوا ۚ ذَٰلِكُمْ حُكْمُ اللَّهِ ۖ يَحْكُمُ بَيْنَكُمْ ۚ وَاللَّهُ عَلِيمٌ حَكِيمٌ",
  },
  {
    id: "5161",
    sura: "60",
    VerseIDAr: "11",
    ayatAR:
      "وَإِنْ فَاتَكُمْ شَيْءٌ مِنْ أَزْوَاجِكُمْ إِلَى الْكُفَّارِ فَعَاقَبْتُمْ فَآتُوا الَّذِينَ ذَهَبَتْ أَزْوَاجُهُمْ مِثْلَ مَا أَنْفَقُوا ۚ وَاتَّقُوا اللَّهَ الَّذِي أَنْتُمْ بِهِ مُؤْمِنُونَ",
  },
  {
    id: "5162",
    sura: "60",
    VerseIDAr: "12",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ إِذَا جَاءَكَ الْمُؤْمِنَاتُ يُبَايِعْنَكَ عَلَىٰ أَنْ لَا يُشْرِكْنَ بِاللَّهِ شَيْئًا وَلَا يَسْرِقْنَ وَلَا يَزْنِينَ وَلَا يَقْتُلْنَ أَوْلَادَهُنَّ وَلَا يَأْتِينَ بِبُهْتَانٍ يَفْتَرِينَهُ بَيْنَ أَيْدِيهِنَّ وَأَرْجُلِهِنَّ وَلَا يَعْصِينَكَ فِي مَعْرُوفٍ ۙ فَبَايِعْهُنَّ وَاسْتَغْفِرْ لَهُنَّ اللَّهَ ۖ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5163",
    sura: "60",
    VerseIDAr: "13",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تَتَوَلَّوْا قَوْمًا غَضِبَ اللَّهُ عَلَيْهِمْ قَدْ يَئِسُوا مِنَ الْآخِرَةِ كَمَا يَئِسَ الْكُفَّارُ مِنْ أَصْحَابِ الْقُبُورِ",
  },
  {
    id: "5164",
    sura: "61",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۖ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5165",
    sura: "61",
    VerseIDAr: "2",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لِمَ تَقُولُونَ مَا لَا تَفْعَلُونَ",
  },
  {
    id: "5166",
    sura: "61",
    VerseIDAr: "3",
    ayatAR: "كَبُرَ مَقْتًا عِنْدَ اللَّهِ أَنْ تَقُولُوا مَا لَا تَفْعَلُونَ",
  },
  {
    id: "5167",
    sura: "61",
    VerseIDAr: "4",
    ayatAR:
      "إِنَّ اللَّهَ يُحِبُّ الَّذِينَ يُقَاتِلُونَ فِي سَبِيلِهِ صَفًّا كَأَنَّهُمْ بُنْيَانٌ مَرْصُوصٌ",
  },
  {
    id: "5168",
    sura: "61",
    VerseIDAr: "5",
    ayatAR:
      "وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ يَا قَوْمِ لِمَ تُؤْذُونَنِي وَقَدْ تَعْلَمُونَ أَنِّي رَسُولُ اللَّهِ إِلَيْكُمْ ۖ فَلَمَّا زَاغُوا أَزَاغَ اللَّهُ قُلُوبَهُمْ ۚ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الْفَاسِقِينَ",
  },
  {
    id: "5169",
    sura: "61",
    VerseIDAr: "6",
    ayatAR:
      "وَإِذْ قَالَ عِيسَى ابْنُ مَرْيَمَ يَا بَنِي إِسْرَائِيلَ إِنِّي رَسُولُ اللَّهِ إِلَيْكُمْ مُصَدِّقًا لِمَا بَيْنَ يَدَيَّ مِنَ التَّوْرَاةِ وَمُبَشِّرًا بِرَسُولٍ يَأْتِي مِنْ بَعْدِي اسْمُهُ أَحْمَدُ ۖ فَلَمَّا جَاءَهُمْ بِالْبَيِّنَاتِ قَالُوا هَٰذَا سِحْرٌ مُبِينٌ",
  },
  {
    id: "5170",
    sura: "61",
    VerseIDAr: "7",
    ayatAR:
      "وَمَنْ أَظْلَمُ مِمَّنِ افْتَرَىٰ عَلَى اللَّهِ الْكَذِبَ وَهُوَ يُدْعَىٰ إِلَى الْإِسْلَامِ ۚ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "5171",
    sura: "61",
    VerseIDAr: "8",
    ayatAR:
      "يُرِيدُونَ لِيُطْفِئُوا نُورَ اللَّهِ بِأَفْوَاهِهِمْ وَاللَّهُ مُتِمُّ نُورِهِ وَلَوْ كَرِهَ الْكَافِرُونَ",
  },
  {
    id: "5172",
    sura: "61",
    VerseIDAr: "9",
    ayatAR:
      "هُوَ الَّذِي أَرْسَلَ رَسُولَهُ بِالْهُدَىٰ وَدِينِ الْحَقِّ لِيُظْهِرَهُ عَلَى الدِّينِ كُلِّهِ وَلَوْ كَرِهَ الْمُشْرِكُونَ",
  },
  {
    id: "5173",
    sura: "61",
    VerseIDAr: "10",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا هَلْ أَدُلُّكُمْ عَلَىٰ تِجَارَةٍ تُنْجِيكُمْ مِنْ عَذَابٍ أَلِيمٍ",
  },
  {
    id: "5174",
    sura: "61",
    VerseIDAr: "11",
    ayatAR:
      "تُؤْمِنُونَ بِاللَّهِ وَرَسُولِهِ وَتُجَاهِدُونَ فِي سَبِيلِ اللَّهِ بِأَمْوَالِكُمْ وَأَنْفُسِكُمْ ۚ ذَٰلِكُمْ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "5175",
    sura: "61",
    VerseIDAr: "12",
    ayatAR:
      "يَغْفِرْ لَكُمْ ذُنُوبَكُمْ وَيُدْخِلْكُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ وَمَسَاكِنَ طَيِّبَةً فِي جَنَّاتِ عَدْنٍ ۚ ذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "5176",
    sura: "61",
    VerseIDAr: "13",
    ayatAR:
      "وَأُخْرَىٰ تُحِبُّونَهَا ۖ نَصْرٌ مِنَ اللَّهِ وَفَتْحٌ قَرِيبٌ ۗ وَبَشِّرِ الْمُؤْمِنِينَ",
  },
  {
    id: "5177",
    sura: "61",
    VerseIDAr: "14",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا كُونُوا أَنْصَارَ اللَّهِ كَمَا قَالَ عِيسَى ابْنُ مَرْيَمَ لِلْحَوَارِيِّينَ مَنْ أَنْصَارِي إِلَى اللَّهِ ۖ قَالَ الْحَوَارِيُّونَ نَحْنُ أَنْصَارُ اللَّهِ ۖ فَآمَنَتْ طَائِفَةٌ مِنْ بَنِي إِسْرَائِيلَ وَكَفَرَتْ طَائِفَةٌ ۖ فَأَيَّدْنَا الَّذِينَ آمَنُوا عَلَىٰ عَدُوِّهِمْ فَأَصْبَحُوا ظَاهِرِينَ",
  },
  {
    id: "5178",
    sura: "62",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يُسَبِّحُ لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ الْمَلِكِ الْقُدُّوسِ الْعَزِيزِ الْحَكِيمِ",
  },
  {
    id: "5179",
    sura: "62",
    VerseIDAr: "2",
    ayatAR:
      "هُوَ الَّذِي بَعَثَ فِي الْأُمِّيِّينَ رَسُولًا مِنْهُمْ يَتْلُو عَلَيْهِمْ آيَاتِهِ وَيُزَكِّيهِمْ وَيُعَلِّمُهُمُ الْكِتَابَ وَالْحِكْمَةَ وَإِنْ كَانُوا مِنْ قَبْلُ لَفِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "5180",
    sura: "62",
    VerseIDAr: "3",
    ayatAR:
      "وَآخَرِينَ مِنْهُمْ لَمَّا يَلْحَقُوا بِهِمْ ۚ وَهُوَ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5181",
    sura: "62",
    VerseIDAr: "4",
    ayatAR:
      "ذَٰلِكَ فَضْلُ اللَّهِ يُؤْتِيهِ مَنْ يَشَاءُ ۚ وَاللَّهُ ذُو الْفَضْلِ الْعَظِيمِ",
  },
  {
    id: "5182",
    sura: "62",
    VerseIDAr: "5",
    ayatAR:
      "مَثَلُ الَّذِينَ حُمِّلُوا التَّوْرَاةَ ثُمَّ لَمْ يَحْمِلُوهَا كَمَثَلِ الْحِمَارِ يَحْمِلُ أَسْفَارًا ۚ بِئْسَ مَثَلُ الْقَوْمِ الَّذِينَ كَذَّبُوا بِآيَاتِ اللَّهِ ۚ وَاللَّهُ لَا يَهْدِي الْقَوْمَ الظَّالِمِينَ",
  },
  {
    id: "5183",
    sura: "62",
    VerseIDAr: "6",
    ayatAR:
      "قُلْ يَا أَيُّهَا الَّذِينَ هَادُوا إِنْ زَعَمْتُمْ أَنَّكُمْ أَوْلِيَاءُ لِلَّهِ مِنْ دُونِ النَّاسِ فَتَمَنَّوُا الْمَوْتَ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "5184",
    sura: "62",
    VerseIDAr: "7",
    ayatAR:
      "وَلَا يَتَمَنَّوْنَهُ أَبَدًا بِمَا قَدَّمَتْ أَيْدِيهِمْ ۚ وَاللَّهُ عَلِيمٌ بِالظَّالِمِينَ",
  },
  {
    id: "5185",
    sura: "62",
    VerseIDAr: "8",
    ayatAR:
      "قُلْ إِنَّ الْمَوْتَ الَّذِي تَفِرُّونَ مِنْهُ فَإِنَّهُ مُلَاقِيكُمْ ۖ ثُمَّ تُرَدُّونَ إِلَىٰ عَالِمِ الْغَيْبِ وَالشَّهَادَةِ فَيُنَبِّئُكُمْ بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "5186",
    sura: "62",
    VerseIDAr: "9",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِذَا نُودِيَ لِلصَّلَاةِ مِنْ يَوْمِ الْجُمُعَةِ فَاسْعَوْا إِلَىٰ ذِكْرِ اللَّهِ وَذَرُوا الْبَيْعَ ۚ ذَٰلِكُمْ خَيْرٌ لَكُمْ إِنْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "5187",
    sura: "62",
    VerseIDAr: "10",
    ayatAR:
      "فَإِذَا قُضِيَتِ الصَّلَاةُ فَانْتَشِرُوا فِي الْأَرْضِ وَابْتَغُوا مِنْ فَضْلِ اللَّهِ وَاذْكُرُوا اللَّهَ كَثِيرًا لَعَلَّكُمْ تُفْلِحُونَ",
  },
  {
    id: "5188",
    sura: "62",
    VerseIDAr: "11",
    ayatAR:
      "وَإِذَا رَأَوْا تِجَارَةً أَوْ لَهْوًا انْفَضُّوا إِلَيْهَا وَتَرَكُوكَ قَائِمًا ۚ قُلْ مَا عِنْدَ اللَّهِ خَيْرٌ مِنَ اللَّهْوِ وَمِنَ التِّجَارَةِ ۚ وَاللَّهُ خَيْرُ الرَّازِقِينَ",
  },
  {
    id: "5189",
    sura: "63",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا جَاءَكَ الْمُنَافِقُونَ قَالُوا نَشْهَدُ إِنَّكَ لَرَسُولُ اللَّهِ ۗ وَاللَّهُ يَعْلَمُ إِنَّكَ لَرَسُولُهُ وَاللَّهُ يَشْهَدُ إِنَّ الْمُنَافِقِينَ لَكَاذِبُونَ",
  },
  {
    id: "5190",
    sura: "63",
    VerseIDAr: "2",
    ayatAR:
      "اتَّخَذُوا أَيْمَانَهُمْ جُنَّةً فَصَدُّوا عَنْ سَبِيلِ اللَّهِ ۚ إِنَّهُمْ سَاءَ مَا كَانُوا يَعْمَلُونَ",
  },
  {
    id: "5191",
    sura: "63",
    VerseIDAr: "3",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُمْ آمَنُوا ثُمَّ كَفَرُوا فَطُبِعَ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَفْقَهُونَ",
  },
  {
    id: "5192",
    sura: "63",
    VerseIDAr: "4",
    ayatAR:
      "وَإِذَا رَأَيْتَهُمْ تُعْجِبُكَ أَجْسَامُهُمْ ۖ وَإِنْ يَقُولُوا تَسْمَعْ لِقَوْلِهِمْ ۖ كَأَنَّهُمْ خُشُبٌ مُسَنَّدَةٌ ۖ يَحْسَبُونَ كُلَّ صَيْحَةٍ عَلَيْهِمْ ۚ هُمُ الْعَدُوُّ فَاحْذَرْهُمْ ۚ قَاتَلَهُمُ اللَّهُ ۖ أَنَّىٰ يُؤْفَكُونَ",
  },
  {
    id: "5193",
    sura: "63",
    VerseIDAr: "5",
    ayatAR:
      "وَإِذَا قِيلَ لَهُمْ تَعَالَوْا يَسْتَغْفِرْ لَكُمْ رَسُولُ اللَّهِ لَوَّوْا رُءُوسَهُمْ وَرَأَيْتَهُمْ يَصُدُّونَ وَهُمْ مُسْتَكْبِرُونَ",
  },
  {
    id: "5194",
    sura: "63",
    VerseIDAr: "6",
    ayatAR:
      "سَوَاءٌ عَلَيْهِمْ أَسْتَغْفَرْتَ لَهُمْ أَمْ لَمْ تَسْتَغْفِرْ لَهُمْ لَنْ يَغْفِرَ اللَّهُ لَهُمْ ۚ إِنَّ اللَّهَ لَا يَهْدِي الْقَوْمَ الْفَاسِقِينَ",
  },
  {
    id: "5195",
    sura: "63",
    VerseIDAr: "7",
    ayatAR:
      "هُمُ الَّذِينَ يَقُولُونَ لَا تُنْفِقُوا عَلَىٰ مَنْ عِنْدَ رَسُولِ اللَّهِ حَتَّىٰ يَنْفَضُّوا ۗ وَلِلَّهِ خَزَائِنُ السَّمَاوَاتِ وَالْأَرْضِ وَلَٰكِنَّ الْمُنَافِقِينَ لَا يَفْقَهُونَ",
  },
  {
    id: "5196",
    sura: "63",
    VerseIDAr: "8",
    ayatAR:
      "يَقُولُونَ لَئِنْ رَجَعْنَا إِلَى الْمَدِينَةِ لَيُخْرِجَنَّ الْأَعَزُّ مِنْهَا الْأَذَلَّ ۚ وَلِلَّهِ الْعِزَّةُ وَلِرَسُولِهِ وَلِلْمُؤْمِنِينَ وَلَٰكِنَّ الْمُنَافِقِينَ لَا يَعْلَمُونَ",
  },
  {
    id: "5197",
    sura: "63",
    VerseIDAr: "9",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا لَا تُلْهِكُمْ أَمْوَالُكُمْ وَلَا أَوْلَادُكُمْ عَنْ ذِكْرِ اللَّهِ ۚ وَمَنْ يَفْعَلْ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الْخَاسِرُونَ",
  },
  {
    id: "5198",
    sura: "63",
    VerseIDAr: "10",
    ayatAR:
      "وَأَنْفِقُوا مِنْ مَا رَزَقْنَاكُمْ مِنْ قَبْلِ أَنْ يَأْتِيَ أَحَدَكُمُ الْمَوْتُ فَيَقُولَ رَبِّ لَوْلَا أَخَّرْتَنِي إِلَىٰ أَجَلٍ قَرِيبٍ فَأَصَّدَّقَ وَأَكُنْ مِنَ الصَّالِحِينَ",
  },
  {
    id: "5199",
    sura: "63",
    VerseIDAr: "11",
    ayatAR:
      "وَلَنْ يُؤَخِّرَ اللَّهُ نَفْسًا إِذَا جَاءَ أَجَلُهَا ۚ وَاللَّهُ خَبِيرٌ بِمَا تَعْمَلُونَ",
  },
  {
    id: "5200",
    sura: "64",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يُسَبِّحُ لِلَّهِ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۖ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ ۖ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "5201",
    sura: "64",
    VerseIDAr: "2",
    ayatAR:
      "هُوَ الَّذِي خَلَقَكُمْ فَمِنْكُمْ كَافِرٌ وَمِنْكُمْ مُؤْمِنٌ ۚ وَاللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ",
  },
  {
    id: "5202",
    sura: "64",
    VerseIDAr: "3",
    ayatAR:
      "خَلَقَ السَّمَاوَاتِ وَالْأَرْضَ بِالْحَقِّ وَصَوَّرَكُمْ فَأَحْسَنَ صُوَرَكُمْ ۖ وَإِلَيْهِ الْمَصِيرُ",
  },
  {
    id: "5203",
    sura: "64",
    VerseIDAr: "4",
    ayatAR:
      "يَعْلَمُ مَا فِي السَّمَاوَاتِ وَالْأَرْضِ وَيَعْلَمُ مَا تُسِرُّونَ وَمَا تُعْلِنُونَ ۚ وَاللَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "5204",
    sura: "64",
    VerseIDAr: "5",
    ayatAR:
      "أَلَمْ يَأْتِكُمْ نَبَأُ الَّذِينَ كَفَرُوا مِنْ قَبْلُ فَذَاقُوا وَبَالَ أَمْرِهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "5205",
    sura: "64",
    VerseIDAr: "6",
    ayatAR:
      "ذَٰلِكَ بِأَنَّهُ كَانَتْ تَأْتِيهِمْ رُسُلُهُمْ بِالْبَيِّنَاتِ فَقَالُوا أَبَشَرٌ يَهْدُونَنَا فَكَفَرُوا وَتَوَلَّوْا ۚ وَاسْتَغْنَى اللَّهُ ۚ وَاللَّهُ غَنِيٌّ حَمِيدٌ",
  },
  {
    id: "5206",
    sura: "64",
    VerseIDAr: "7",
    ayatAR:
      "زَعَمَ الَّذِينَ كَفَرُوا أَنْ لَنْ يُبْعَثُوا ۚ قُلْ بَلَىٰ وَرَبِّي لَتُبْعَثُنَّ ثُمَّ لَتُنَبَّؤُنَّ بِمَا عَمِلْتُمْ ۚ وَذَٰلِكَ عَلَى اللَّهِ يَسِيرٌ",
  },
  {
    id: "5207",
    sura: "64",
    VerseIDAr: "8",
    ayatAR:
      "فَآمِنُوا بِاللَّهِ وَرَسُولِهِ وَالنُّورِ الَّذِي أَنْزَلْنَا ۚ وَاللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌ",
  },
  {
    id: "5208",
    sura: "64",
    VerseIDAr: "9",
    ayatAR:
      "يَوْمَ يَجْمَعُكُمْ لِيَوْمِ الْجَمْعِ ۖ ذَٰلِكَ يَوْمُ التَّغَابُنِ ۗ وَمَنْ يُؤْمِنْ بِاللَّهِ وَيَعْمَلْ صَالِحًا يُكَفِّرْ عَنْهُ سَيِّئَاتِهِ وَيُدْخِلْهُ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۚ ذَٰلِكَ الْفَوْزُ الْعَظِيمُ",
  },
  {
    id: "5209",
    sura: "64",
    VerseIDAr: "10",
    ayatAR:
      "وَالَّذِينَ كَفَرُوا وَكَذَّبُوا بِآيَاتِنَا أُولَٰئِكَ أَصْحَابُ النَّارِ خَالِدِينَ فِيهَا ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "5210",
    sura: "64",
    VerseIDAr: "11",
    ayatAR:
      "مَا أَصَابَ مِنْ مُصِيبَةٍ إِلَّا بِإِذْنِ اللَّهِ ۗ وَمَنْ يُؤْمِنْ بِاللَّهِ يَهْدِ قَلْبَهُ ۚ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ",
  },
  {
    id: "5211",
    sura: "64",
    VerseIDAr: "12",
    ayatAR:
      "وَأَطِيعُوا اللَّهَ وَأَطِيعُوا الرَّسُولَ ۚ فَإِنْ تَوَلَّيْتُمْ فَإِنَّمَا عَلَىٰ رَسُولِنَا الْبَلَاغُ الْمُبِينُ",
  },
  {
    id: "5212",
    sura: "64",
    VerseIDAr: "13",
    ayatAR:
      "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ ۚ وَعَلَى اللَّهِ فَلْيَتَوَكَّلِ الْمُؤْمِنُونَ",
  },
  {
    id: "5213",
    sura: "64",
    VerseIDAr: "14",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا إِنَّ مِنْ أَزْوَاجِكُمْ وَأَوْلَادِكُمْ عَدُوًّا لَكُمْ فَاحْذَرُوهُمْ ۚ وَإِنْ تَعْفُوا وَتَصْفَحُوا وَتَغْفِرُوا فَإِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5214",
    sura: "64",
    VerseIDAr: "15",
    ayatAR:
      "إِنَّمَا أَمْوَالُكُمْ وَأَوْلَادُكُمْ فِتْنَةٌ ۚ وَاللَّهُ عِنْدَهُ أَجْرٌ عَظِيمٌ",
  },
  {
    id: "5215",
    sura: "64",
    VerseIDAr: "16",
    ayatAR:
      "فَاتَّقُوا اللَّهَ مَا اسْتَطَعْتُمْ وَاسْمَعُوا وَأَطِيعُوا وَأَنْفِقُوا خَيْرًا لِأَنْفُسِكُمْ ۗ وَمَنْ يُوقَ شُحَّ نَفْسِهِ فَأُولَٰئِكَ هُمُ الْمُفْلِحُونَ",
  },
  {
    id: "5216",
    sura: "64",
    VerseIDAr: "17",
    ayatAR:
      "إِنْ تُقْرِضُوا اللَّهَ قَرْضًا حَسَنًا يُضَاعِفْهُ لَكُمْ وَيَغْفِرْ لَكُمْ ۚ وَاللَّهُ شَكُورٌ حَلِيمٌ",
  },
  {
    id: "5217",
    sura: "64",
    VerseIDAr: "18",
    ayatAR: "عَالِمُ الْغَيْبِ وَالشَّهَادَةِ الْعَزِيزُ الْحَكِيمُ",
  },
  {
    id: "5218",
    sura: "65",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا النَّبِيُّ إِذَا طَلَّقْتُمُ النِّسَاءَ فَطَلِّقُوهُنَّ لِعِدَّتِهِنَّ وَأَحْصُوا الْعِدَّةَ ۖ وَاتَّقُوا اللَّهَ رَبَّكُمْ ۖ لَا تُخْرِجُوهُنَّ مِنْ بُيُوتِهِنَّ وَلَا يَخْرُجْنَ إِلَّا أَنْ يَأْتِينَ بِفَاحِشَةٍ مُبَيِّنَةٍ ۚ وَتِلْكَ حُدُودُ اللَّهِ ۚ وَمَنْ يَتَعَدَّ حُدُودَ اللَّهِ فَقَدْ ظَلَمَ نَفْسَهُ ۚ لَا تَدْرِي لَعَلَّ اللَّهَ يُحْدِثُ بَعْدَ ذَٰلِكَ أَمْرًا",
  },
  {
    id: "5219",
    sura: "65",
    VerseIDAr: "2",
    ayatAR:
      "فَإِذَا بَلَغْنَ أَجَلَهُنَّ فَأَمْسِكُوهُنَّ بِمَعْرُوفٍ أَوْ فَارِقُوهُنَّ بِمَعْرُوفٍ وَأَشْهِدُوا ذَوَيْ عَدْلٍ مِنْكُمْ وَأَقِيمُوا الشَّهَادَةَ لِلَّهِ ۚ ذَٰلِكُمْ يُوعَظُ بِهِ مَنْ كَانَ يُؤْمِنُ بِاللَّهِ وَالْيَوْمِ الْآخِرِ ۚ وَمَنْ يَتَّقِ اللَّهَ يَجْعَلْ لَهُ مَخْرَجًا",
  },
  {
    id: "5220",
    sura: "65",
    VerseIDAr: "3",
    ayatAR:
      "وَيَرْزُقْهُ مِنْ حَيْثُ لَا يَحْتَسِبُ ۚ وَمَنْ يَتَوَكَّلْ عَلَى اللَّهِ فَهُوَ حَسْبُهُ ۚ إِنَّ اللَّهَ بَالِغُ أَمْرِهِ ۚ قَدْ جَعَلَ اللَّهُ لِكُلِّ شَيْءٍ قَدْرًا",
  },
  {
    id: "5221",
    sura: "65",
    VerseIDAr: "4",
    ayatAR:
      "وَاللَّائِي يَئِسْنَ مِنَ الْمَحِيضِ مِنْ نِسَائِكُمْ إِنِ ارْتَبْتُمْ فَعِدَّتُهُنَّ ثَلَاثَةُ أَشْهُرٍ وَاللَّائِي لَمْ يَحِضْنَ ۚ وَأُولَاتُ الْأَحْمَالِ أَجَلُهُنَّ أَنْ يَضَعْنَ حَمْلَهُنَّ ۚ وَمَنْ يَتَّقِ اللَّهَ يَجْعَلْ لَهُ مِنْ أَمْرِهِ يُسْرًا",
  },
  {
    id: "5222",
    sura: "65",
    VerseIDAr: "5",
    ayatAR:
      "ذَٰلِكَ أَمْرُ اللَّهِ أَنْزَلَهُ إِلَيْكُمْ ۚ وَمَنْ يَتَّقِ اللَّهَ يُكَفِّرْ عَنْهُ سَيِّئَاتِهِ وَيُعْظِمْ لَهُ أَجْرًا",
  },
  {
    id: "5223",
    sura: "65",
    VerseIDAr: "6",
    ayatAR:
      "أَسْكِنُوهُنَّ مِنْ حَيْثُ سَكَنْتُمْ مِنْ وُجْدِكُمْ وَلَا تُضَارُّوهُنَّ لِتُضَيِّقُوا عَلَيْهِنَّ ۚ وَإِنْ كُنَّ أُولَاتِ حَمْلٍ فَأَنْفِقُوا عَلَيْهِنَّ حَتَّىٰ يَضَعْنَ حَمْلَهُنَّ ۚ فَإِنْ أَرْضَعْنَ لَكُمْ فَآتُوهُنَّ أُجُورَهُنَّ ۖ وَأْتَمِرُوا بَيْنَكُمْ بِمَعْرُوفٍ ۖ وَإِنْ تَعَاسَرْتُمْ فَسَتُرْضِعُ لَهُ أُخْرَىٰ",
  },
  {
    id: "5224",
    sura: "65",
    VerseIDAr: "7",
    ayatAR:
      "لِيُنْفِقْ ذُو سَعَةٍ مِنْ سَعَتِهِ ۖ وَمَنْ قُدِرَ عَلَيْهِ رِزْقُهُ فَلْيُنْفِقْ مِمَّا آتَاهُ اللَّهُ ۚ لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا مَا آتَاهَا ۚ سَيَجْعَلُ اللَّهُ بَعْدَ عُسْرٍ يُسْرًا",
  },
  {
    id: "5225",
    sura: "65",
    VerseIDAr: "8",
    ayatAR:
      "وَكَأَيِّنْ مِنْ قَرْيَةٍ عَتَتْ عَنْ أَمْرِ رَبِّهَا وَرُسُلِهِ فَحَاسَبْنَاهَا حِسَابًا شَدِيدًا وَعَذَّبْنَاهَا عَذَابًا نُكْرًا",
  },
  {
    id: "5226",
    sura: "65",
    VerseIDAr: "9",
    ayatAR: "فَذَاقَتْ وَبَالَ أَمْرِهَا وَكَانَ عَاقِبَةُ أَمْرِهَا خُسْرًا",
  },
  {
    id: "5227",
    sura: "65",
    VerseIDAr: "10",
    ayatAR:
      "أَعَدَّ اللَّهُ لَهُمْ عَذَابًا شَدِيدًا ۖ فَاتَّقُوا اللَّهَ يَا أُولِي الْأَلْبَابِ الَّذِينَ آمَنُوا ۚ قَدْ أَنْزَلَ اللَّهُ إِلَيْكُمْ ذِكْرًا",
  },
  {
    id: "5228",
    sura: "65",
    VerseIDAr: "11",
    ayatAR:
      "رَسُولًا يَتْلُو عَلَيْكُمْ آيَاتِ اللَّهِ مُبَيِّنَاتٍ لِيُخْرِجَ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ مِنَ الظُّلُمَاتِ إِلَى النُّورِ ۚ وَمَنْ يُؤْمِنْ بِاللَّهِ وَيَعْمَلْ صَالِحًا يُدْخِلْهُ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۖ قَدْ أَحْسَنَ اللَّهُ لَهُ رِزْقًا",
  },
  {
    id: "5229",
    sura: "65",
    VerseIDAr: "12",
    ayatAR:
      "اللَّهُ الَّذِي خَلَقَ سَبْعَ سَمَاوَاتٍ وَمِنَ الْأَرْضِ مِثْلَهُنَّ يَتَنَزَّلُ الْأَمْرُ بَيْنَهُنَّ لِتَعْلَمُوا أَنَّ اللَّهَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ وَأَنَّ اللَّهَ قَدْ أَحَاطَ بِكُلِّ شَيْءٍ عِلْمًا",
  },
  {
    id: "5230",
    sura: "66",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا النَّبِيُّ لِمَ تُحَرِّمُ مَا أَحَلَّ اللَّهُ لَكَ ۖ تَبْتَغِي مَرْضَاتَ أَزْوَاجِكَ ۚ وَاللَّهُ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5231",
    sura: "66",
    VerseIDAr: "2",
    ayatAR:
      "قَدْ فَرَضَ اللَّهُ لَكُمْ تَحِلَّةَ أَيْمَانِكُمْ ۚ وَاللَّهُ مَوْلَاكُمْ ۖ وَهُوَ الْعَلِيمُ الْحَكِيمُ",
  },
  {
    id: "5232",
    sura: "66",
    VerseIDAr: "3",
    ayatAR:
      "وَإِذْ أَسَرَّ النَّبِيُّ إِلَىٰ بَعْضِ أَزْوَاجِهِ حَدِيثًا فَلَمَّا نَبَّأَتْ بِهِ وَأَظْهَرَهُ اللَّهُ عَلَيْهِ عَرَّفَ بَعْضَهُ وَأَعْرَضَ عَنْ بَعْضٍ ۖ فَلَمَّا نَبَّأَهَا بِهِ قَالَتْ مَنْ أَنْبَأَكَ هَٰذَا ۖ قَالَ نَبَّأَنِيَ الْعَلِيمُ الْخَبِيرُ",
  },
  {
    id: "5233",
    sura: "66",
    VerseIDAr: "4",
    ayatAR:
      "إِنْ تَتُوبَا إِلَى اللَّهِ فَقَدْ صَغَتْ قُلُوبُكُمَا ۖ وَإِنْ تَظَاهَرَا عَلَيْهِ فَإِنَّ اللَّهَ هُوَ مَوْلَاهُ وَجِبْرِيلُ وَصَالِحُ الْمُؤْمِنِينَ ۖ وَالْمَلَائِكَةُ بَعْدَ ذَٰلِكَ ظَهِيرٌ",
  },
  {
    id: "5234",
    sura: "66",
    VerseIDAr: "5",
    ayatAR:
      "عَسَىٰ رَبُّهُ إِنْ طَلَّقَكُنَّ أَنْ يُبْدِلَهُ أَزْوَاجًا خَيْرًا مِنْكُنَّ مُسْلِمَاتٍ مُؤْمِنَاتٍ قَانِتَاتٍ تَائِبَاتٍ عَابِدَاتٍ سَائِحَاتٍ ثَيِّبَاتٍ وَأَبْكَارًا",
  },
  {
    id: "5235",
    sura: "66",
    VerseIDAr: "6",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا قُوا أَنْفُسَكُمْ وَأَهْلِيكُمْ نَارًا وَقُودُهَا النَّاسُ وَالْحِجَارَةُ عَلَيْهَا مَلَائِكَةٌ غِلَاظٌ شِدَادٌ لَا يَعْصُونَ اللَّهَ مَا أَمَرَهُمْ وَيَفْعَلُونَ مَا يُؤْمَرُونَ",
  },
  {
    id: "5236",
    sura: "66",
    VerseIDAr: "7",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ كَفَرُوا لَا تَعْتَذِرُوا الْيَوْمَ ۖ إِنَّمَا تُجْزَوْنَ مَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "5237",
    sura: "66",
    VerseIDAr: "8",
    ayatAR:
      "يَا أَيُّهَا الَّذِينَ آمَنُوا تُوبُوا إِلَى اللَّهِ تَوْبَةً نَصُوحًا عَسَىٰ رَبُّكُمْ أَنْ يُكَفِّرَ عَنْكُمْ سَيِّئَاتِكُمْ وَيُدْخِلَكُمْ جَنَّاتٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ يَوْمَ لَا يُخْزِي اللَّهُ النَّبِيَّ وَالَّذِينَ آمَنُوا مَعَهُ ۖ نُورُهُمْ يَسْعَىٰ بَيْنَ أَيْدِيهِمْ وَبِأَيْمَانِهِمْ يَقُولُونَ رَبَّنَا أَتْمِمْ لَنَا نُورَنَا وَاغْفِرْ لَنَا ۖ إِنَّكَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "5238",
    sura: "66",
    VerseIDAr: "9",
    ayatAR:
      "يَا أَيُّهَا النَّبِيُّ جَاهِدِ الْكُفَّارَ وَالْمُنَافِقِينَ وَاغْلُظْ عَلَيْهِمْ ۚ وَمَأْوَاهُمْ جَهَنَّمُ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "5239",
    sura: "66",
    VerseIDAr: "10",
    ayatAR:
      "ضَرَبَ اللَّهُ مَثَلًا لِلَّذِينَ كَفَرُوا امْرَأَتَ نُوحٍ وَامْرَأَتَ لُوطٍ ۖ كَانَتَا تَحْتَ عَبْدَيْنِ مِنْ عِبَادِنَا صَالِحَيْنِ فَخَانَتَاهُمَا فَلَمْ يُغْنِيَا عَنْهُمَا مِنَ اللَّهِ شَيْئًا وَقِيلَ ادْخُلَا النَّارَ مَعَ الدَّاخِلِينَ",
  },
  {
    id: "5240",
    sura: "66",
    VerseIDAr: "11",
    ayatAR:
      "وَضَرَبَ اللَّهُ مَثَلًا لِلَّذِينَ آمَنُوا امْرَأَتَ فِرْعَوْنَ إِذْ قَالَتْ رَبِّ ابْنِ لِي عِنْدَكَ بَيْتًا فِي الْجَنَّةِ وَنَجِّنِي مِنْ فِرْعَوْنَ وَعَمَلِهِ وَنَجِّنِي مِنَ الْقَوْمِ الظَّالِمِينَ",
  },
  {
    id: "5241",
    sura: "66",
    VerseIDAr: "12",
    ayatAR:
      "وَمَرْيَمَ ابْنَتَ عِمْرَانَ الَّتِي أَحْصَنَتْ فَرْجَهَا فَنَفَخْنَا فِيهِ مِنْ رُوحِنَا وَصَدَّقَتْ بِكَلِمَاتِ رَبِّهَا وَكُتُبِهِ وَكَانَتْ مِنَ الْقَانِتِينَ",
  },
  {
    id: "5242",
    sura: "67",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ تَبَارَكَ الَّذِي بِيَدِهِ الْمُلْكُ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
  },
  {
    id: "5243",
    sura: "67",
    VerseIDAr: "2",
    ayatAR:
      "الَّذِي خَلَقَ الْمَوْتَ وَالْحَيَاةَ لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًا ۚ وَهُوَ الْعَزِيزُ الْغَفُورُ",
  },
  {
    id: "5244",
    sura: "67",
    VerseIDAr: "3",
    ayatAR:
      "الَّذِي خَلَقَ سَبْعَ سَمَاوَاتٍ طِبَاقًا ۖ مَا تَرَىٰ فِي خَلْقِ الرَّحْمَٰنِ مِنْ تَفَاوُتٍ ۖ فَارْجِعِ الْبَصَرَ هَلْ تَرَىٰ مِنْ فُطُورٍ",
  },
  {
    id: "5245",
    sura: "67",
    VerseIDAr: "4",
    ayatAR:
      "ثُمَّ ارْجِعِ الْبَصَرَ كَرَّتَيْنِ يَنْقَلِبْ إِلَيْكَ الْبَصَرُ خَاسِئًا وَهُوَ حَسِيرٌ",
  },
  {
    id: "5246",
    sura: "67",
    VerseIDAr: "5",
    ayatAR:
      "وَلَقَدْ زَيَّنَّا السَّمَاءَ الدُّنْيَا بِمَصَابِيحَ وَجَعَلْنَاهَا رُجُومًا لِلشَّيَاطِينِ ۖ وَأَعْتَدْنَا لَهُمْ عَذَابَ السَّعِيرِ",
  },
  {
    id: "5247",
    sura: "67",
    VerseIDAr: "6",
    ayatAR:
      "وَلِلَّذِينَ كَفَرُوا بِرَبِّهِمْ عَذَابُ جَهَنَّمَ ۖ وَبِئْسَ الْمَصِيرُ",
  },
  {
    id: "5248",
    sura: "67",
    VerseIDAr: "7",
    ayatAR: "إِذَا أُلْقُوا فِيهَا سَمِعُوا لَهَا شَهِيقًا وَهِيَ تَفُورُ",
  },
  {
    id: "5249",
    sura: "67",
    VerseIDAr: "8",
    ayatAR:
      "تَكَادُ تَمَيَّزُ مِنَ الْغَيْظِ ۖ كُلَّمَا أُلْقِيَ فِيهَا فَوْجٌ سَأَلَهُمْ خَزَنَتُهَا أَلَمْ يَأْتِكُمْ نَذِيرٌ",
  },
  {
    id: "5250",
    sura: "67",
    VerseIDAr: "9",
    ayatAR:
      "قَالُوا بَلَىٰ قَدْ جَاءَنَا نَذِيرٌ فَكَذَّبْنَا وَقُلْنَا مَا نَزَّلَ اللَّهُ مِنْ شَيْءٍ إِنْ أَنْتُمْ إِلَّا فِي ضَلَالٍ كَبِيرٍ",
  },
  {
    id: "5251",
    sura: "67",
    VerseIDAr: "10",
    ayatAR:
      "وَقَالُوا لَوْ كُنَّا نَسْمَعُ أَوْ نَعْقِلُ مَا كُنَّا فِي أَصْحَابِ السَّعِيرِ",
  },
  {
    id: "5252",
    sura: "67",
    VerseIDAr: "11",
    ayatAR: "فَاعْتَرَفُوا بِذَنْبِهِمْ فَسُحْقًا لِأَصْحَابِ السَّعِيرِ",
  },
  {
    id: "5253",
    sura: "67",
    VerseIDAr: "12",
    ayatAR:
      "إِنَّ الَّذِينَ يَخْشَوْنَ رَبَّهُمْ بِالْغَيْبِ لَهُمْ مَغْفِرَةٌ وَأَجْرٌ كَبِيرٌ",
  },
  {
    id: "5254",
    sura: "67",
    VerseIDAr: "13",
    ayatAR:
      "وَأَسِرُّوا قَوْلَكُمْ أَوِ اجْهَرُوا بِهِ ۖ إِنَّهُ عَلِيمٌ بِذَاتِ الصُّدُورِ",
  },
  {
    id: "5255",
    sura: "67",
    VerseIDAr: "14",
    ayatAR: "أَلَا يَعْلَمُ مَنْ خَلَقَ وَهُوَ اللَّطِيفُ الْخَبِيرُ",
  },
  {
    id: "5256",
    sura: "67",
    VerseIDAr: "15",
    ayatAR:
      "هُوَ الَّذِي جَعَلَ لَكُمُ الْأَرْضَ ذَلُولًا فَامْشُوا فِي مَنَاكِبِهَا وَكُلُوا مِنْ رِزْقِهِ ۖ وَإِلَيْهِ النُّشُورُ",
  },
  {
    id: "5257",
    sura: "67",
    VerseIDAr: "16",
    ayatAR:
      "أَأَمِنْتُمْ مَنْ فِي السَّمَاءِ أَنْ يَخْسِفَ بِكُمُ الْأَرْضَ فَإِذَا هِيَ تَمُورُ",
  },
  {
    id: "5258",
    sura: "67",
    VerseIDAr: "17",
    ayatAR:
      "أَمْ أَمِنْتُمْ مَنْ فِي السَّمَاءِ أَنْ يُرْسِلَ عَلَيْكُمْ حَاصِبًا ۖ فَسَتَعْلَمُونَ كَيْفَ نَذِيرِ",
  },
  {
    id: "5259",
    sura: "67",
    VerseIDAr: "18",
    ayatAR: "وَلَقَدْ كَذَّبَ الَّذِينَ مِنْ قَبْلِهِمْ فَكَيْفَ كَانَ نَكِيرِ",
  },
  {
    id: "5260",
    sura: "67",
    VerseIDAr: "19",
    ayatAR:
      "أَوَلَمْ يَرَوْا إِلَى الطَّيْرِ فَوْقَهُمْ صَافَّاتٍ وَيَقْبِضْنَ ۚ مَا يُمْسِكُهُنَّ إِلَّا الرَّحْمَٰنُ ۚ إِنَّهُ بِكُلِّ شَيْءٍ بَصِيرٌ",
  },
  {
    id: "5261",
    sura: "67",
    VerseIDAr: "20",
    ayatAR:
      "أَمَّنْ هَٰذَا الَّذِي هُوَ جُنْدٌ لَكُمْ يَنْصُرُكُمْ مِنْ دُونِ الرَّحْمَٰنِ ۚ إِنِ الْكَافِرُونَ إِلَّا فِي غُرُورٍ",
  },
  {
    id: "5262",
    sura: "67",
    VerseIDAr: "21",
    ayatAR:
      "أَمَّنْ هَٰذَا الَّذِي يَرْزُقُكُمْ إِنْ أَمْسَكَ رِزْقَهُ ۚ بَلْ لَجُّوا فِي عُتُوٍّ وَنُفُورٍ",
  },
  {
    id: "5263",
    sura: "67",
    VerseIDAr: "22",
    ayatAR:
      "أَفَمَنْ يَمْشِي مُكِبًّا عَلَىٰ وَجْهِهِ أَهْدَىٰ أَمَّنْ يَمْشِي سَوِيًّا عَلَىٰ صِرَاطٍ مُسْتَقِيمٍ",
  },
  {
    id: "5264",
    sura: "67",
    VerseIDAr: "23",
    ayatAR:
      "قُلْ هُوَ الَّذِي أَنْشَأَكُمْ وَجَعَلَ لَكُمُ السَّمْعَ وَالْأَبْصَارَ وَالْأَفْئِدَةَ ۖ قَلِيلًا مَا تَشْكُرُونَ",
  },
  {
    id: "5265",
    sura: "67",
    VerseIDAr: "24",
    ayatAR: "قُلْ هُوَ الَّذِي ذَرَأَكُمْ فِي الْأَرْضِ وَإِلَيْهِ تُحْشَرُونَ",
  },
  {
    id: "5266",
    sura: "67",
    VerseIDAr: "25",
    ayatAR: "وَيَقُولُونَ مَتَىٰ هَٰذَا الْوَعْدُ إِنْ كُنْتُمْ صَادِقِينَ",
  },
  {
    id: "5267",
    sura: "67",
    VerseIDAr: "26",
    ayatAR:
      "قُلْ إِنَّمَا الْعِلْمُ عِنْدَ اللَّهِ وَإِنَّمَا أَنَا نَذِيرٌ مُبِينٌ",
  },
  {
    id: "5268",
    sura: "67",
    VerseIDAr: "27",
    ayatAR:
      "فَلَمَّا رَأَوْهُ زُلْفَةً سِيئَتْ وُجُوهُ الَّذِينَ كَفَرُوا وَقِيلَ هَٰذَا الَّذِي كُنْتُمْ بِهِ تَدَّعُونَ",
  },
  {
    id: "5269",
    sura: "67",
    VerseIDAr: "28",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ أَهْلَكَنِيَ اللَّهُ وَمَنْ مَعِيَ أَوْ رَحِمَنَا فَمَنْ يُجِيرُ الْكَافِرِينَ مِنْ عَذَابٍ أَلِيمٍ",
  },
  {
    id: "5270",
    sura: "67",
    VerseIDAr: "29",
    ayatAR:
      "قُلْ هُوَ الرَّحْمَٰنُ آمَنَّا بِهِ وَعَلَيْهِ تَوَكَّلْنَا ۖ فَسَتَعْلَمُونَ مَنْ هُوَ فِي ضَلَالٍ مُبِينٍ",
  },
  {
    id: "5271",
    sura: "67",
    VerseIDAr: "30",
    ayatAR:
      "قُلْ أَرَأَيْتُمْ إِنْ أَصْبَحَ مَاؤُكُمْ غَوْرًا فَمَنْ يَأْتِيكُمْ بِمَاءٍ مَعِينٍ",
  },
  {
    id: "5272",
    sura: "68",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ ن ۚ وَالْقَلَمِ وَمَا يَسْطُرُونَ",
  },
  {
    id: "5273",
    sura: "68",
    VerseIDAr: "2",
    ayatAR: "مَا أَنْتَ بِنِعْمَةِ رَبِّكَ بِمَجْنُونٍ",
  },
  {
    id: "5274",
    sura: "68",
    VerseIDAr: "3",
    ayatAR: "وَإِنَّ لَكَ لَأَجْرًا غَيْرَ مَمْنُونٍ",
  },
  {
    id: "5275",
    sura: "68",
    VerseIDAr: "4",
    ayatAR: "وَإِنَّكَ لَعَلَىٰ خُلُقٍ عَظِيمٍ",
  },
  {
    id: "5276",
    sura: "68",
    VerseIDAr: "5",
    ayatAR: "فَسَتُبْصِرُ وَيُبْصِرُونَ",
  },
  {
    id: "5277",
    sura: "68",
    VerseIDAr: "6",
    ayatAR: "بِأَيْيِكُمُ الْمَفْتُونُ",
  },
  {
    id: "5278",
    sura: "68",
    VerseIDAr: "7",
    ayatAR:
      "إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَنْ ضَلَّ عَنْ سَبِيلِهِ وَهُوَ أَعْلَمُ بِالْمُهْتَدِينَ",
  },
  {
    id: "5279",
    sura: "68",
    VerseIDAr: "8",
    ayatAR: "فَلَا تُطِعِ الْمُكَذِّبِينَ",
  },
  {
    id: "5280",
    sura: "68",
    VerseIDAr: "9",
    ayatAR: "وَدُّوا لَوْ تُدْهِنُ فَيُدْهِنُونَ",
  },
  {
    id: "5281",
    sura: "68",
    VerseIDAr: "10",
    ayatAR: "وَلَا تُطِعْ كُلَّ حَلَّافٍ مَهِينٍ",
  },
  {
    id: "5282",
    sura: "68",
    VerseIDAr: "11",
    ayatAR: "هَمَّازٍ مَشَّاءٍ بِنَمِيمٍ",
  },
  {
    id: "5283",
    sura: "68",
    VerseIDAr: "12",
    ayatAR: "مَنَّاعٍ لِلْخَيْرِ مُعْتَدٍ أَثِيمٍ",
  },
  {
    id: "5284",
    sura: "68",
    VerseIDAr: "13",
    ayatAR: "عُتُلٍّ بَعْدَ ذَٰلِكَ زَنِيمٍ",
  },
  {
    id: "5285",
    sura: "68",
    VerseIDAr: "14",
    ayatAR: "أَنْ كَانَ ذَا مَالٍ وَبَنِينَ",
  },
  {
    id: "5286",
    sura: "68",
    VerseIDAr: "15",
    ayatAR: "إِذَا تُتْلَىٰ عَلَيْهِ آيَاتُنَا قَالَ أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "5287",
    sura: "68",
    VerseIDAr: "16",
    ayatAR: "سَنَسِمُهُ عَلَى الْخُرْطُومِ",
  },
  {
    id: "5288",
    sura: "68",
    VerseIDAr: "17",
    ayatAR:
      "إِنَّا بَلَوْنَاهُمْ كَمَا بَلَوْنَا أَصْحَابَ الْجَنَّةِ إِذْ أَقْسَمُوا لَيَصْرِمُنَّهَا مُصْبِحِينَ",
  },
  { id: "5289", sura: "68", VerseIDAr: "18", ayatAR: "وَلَا يَسْتَثْنُونَ" },
  {
    id: "5290",
    sura: "68",
    VerseIDAr: "19",
    ayatAR: "فَطَافَ عَلَيْهَا طَائِفٌ مِنْ رَبِّكَ وَهُمْ نَائِمُونَ",
  },
  {
    id: "5291",
    sura: "68",
    VerseIDAr: "20",
    ayatAR: "فَأَصْبَحَتْ كَالصَّرِيمِ",
  },
  {
    id: "5292",
    sura: "68",
    VerseIDAr: "21",
    ayatAR: "فَتَنَادَوْا مُصْبِحِينَ",
  },
  {
    id: "5293",
    sura: "68",
    VerseIDAr: "22",
    ayatAR: "أَنِ اغْدُوا عَلَىٰ حَرْثِكُمْ إِنْ كُنْتُمْ صَارِمِينَ",
  },
  {
    id: "5294",
    sura: "68",
    VerseIDAr: "23",
    ayatAR: "فَانْطَلَقُوا وَهُمْ يَتَخَافَتُونَ",
  },
  {
    id: "5295",
    sura: "68",
    VerseIDAr: "24",
    ayatAR: "أَنْ لَا يَدْخُلَنَّهَا الْيَوْمَ عَلَيْكُمْ مِسْكِينٌ",
  },
  {
    id: "5296",
    sura: "68",
    VerseIDAr: "25",
    ayatAR: "وَغَدَوْا عَلَىٰ حَرْدٍ قَادِرِينَ",
  },
  {
    id: "5297",
    sura: "68",
    VerseIDAr: "26",
    ayatAR: "فَلَمَّا رَأَوْهَا قَالُوا إِنَّا لَضَالُّونَ",
  },
  {
    id: "5298",
    sura: "68",
    VerseIDAr: "27",
    ayatAR: "بَلْ نَحْنُ مَحْرُومُونَ",
  },
  {
    id: "5299",
    sura: "68",
    VerseIDAr: "28",
    ayatAR: "قَالَ أَوْسَطُهُمْ أَلَمْ أَقُلْ لَكُمْ لَوْلَا تُسَبِّحُونَ",
  },
  {
    id: "5300",
    sura: "68",
    VerseIDAr: "29",
    ayatAR: "قَالُوا سُبْحَانَ رَبِّنَا إِنَّا كُنَّا ظَالِمِينَ",
  },
  {
    id: "5301",
    sura: "68",
    VerseIDAr: "30",
    ayatAR: "فَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍ يَتَلَاوَمُونَ",
  },
  {
    id: "5302",
    sura: "68",
    VerseIDAr: "31",
    ayatAR: "قَالُوا يَا وَيْلَنَا إِنَّا كُنَّا طَاغِينَ",
  },
  {
    id: "5303",
    sura: "68",
    VerseIDAr: "32",
    ayatAR:
      "عَسَىٰ رَبُّنَا أَنْ يُبْدِلَنَا خَيْرًا مِنْهَا إِنَّا إِلَىٰ رَبِّنَا رَاغِبُونَ",
  },
  {
    id: "5304",
    sura: "68",
    VerseIDAr: "33",
    ayatAR:
      "كَذَٰلِكَ الْعَذَابُ ۖ وَلَعَذَابُ الْآخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا يَعْلَمُونَ",
  },
  {
    id: "5305",
    sura: "68",
    VerseIDAr: "34",
    ayatAR: "إِنَّ لِلْمُتَّقِينَ عِنْدَ رَبِّهِمْ جَنَّاتِ النَّعِيمِ",
  },
  {
    id: "5306",
    sura: "68",
    VerseIDAr: "35",
    ayatAR: "أَفَنَجْعَلُ الْمُسْلِمِينَ كَالْمُجْرِمِينَ",
  },
  {
    id: "5307",
    sura: "68",
    VerseIDAr: "36",
    ayatAR: "مَا لَكُمْ كَيْفَ تَحْكُمُونَ",
  },
  {
    id: "5308",
    sura: "68",
    VerseIDAr: "37",
    ayatAR: "أَمْ لَكُمْ كِتَابٌ فِيهِ تَدْرُسُونَ",
  },
  {
    id: "5309",
    sura: "68",
    VerseIDAr: "38",
    ayatAR: "إِنَّ لَكُمْ فِيهِ لَمَا تَخَيَّرُونَ",
  },
  {
    id: "5310",
    sura: "68",
    VerseIDAr: "39",
    ayatAR:
      "أَمْ لَكُمْ أَيْمَانٌ عَلَيْنَا بَالِغَةٌ إِلَىٰ يَوْمِ الْقِيَامَةِ ۙ إِنَّ لَكُمْ لَمَا تَحْكُمُونَ",
  },
  {
    id: "5311",
    sura: "68",
    VerseIDAr: "40",
    ayatAR: "سَلْهُمْ أَيُّهُمْ بِذَٰلِكَ زَعِيمٌ",
  },
  {
    id: "5312",
    sura: "68",
    VerseIDAr: "41",
    ayatAR:
      "أَمْ لَهُمْ شُرَكَاءُ فَلْيَأْتُوا بِشُرَكَائِهِمْ إِنْ كَانُوا صَادِقِينَ",
  },
  {
    id: "5313",
    sura: "68",
    VerseIDAr: "42",
    ayatAR:
      "يَوْمَ يُكْشَفُ عَنْ سَاقٍ وَيُدْعَوْنَ إِلَى السُّجُودِ فَلَا يَسْتَطِيعُونَ",
  },
  {
    id: "5314",
    sura: "68",
    VerseIDAr: "43",
    ayatAR:
      "خَاشِعَةً أَبْصَارُهُمْ تَرْهَقُهُمْ ذِلَّةٌ ۖ وَقَدْ كَانُوا يُدْعَوْنَ إِلَى السُّجُودِ وَهُمْ سَالِمُونَ",
  },
  {
    id: "5315",
    sura: "68",
    VerseIDAr: "44",
    ayatAR:
      "فَذَرْنِي وَمَنْ يُكَذِّبُ بِهَٰذَا الْحَدِيثِ ۖ سَنَسْتَدْرِجُهُمْ مِنْ حَيْثُ لَا يَعْلَمُونَ",
  },
  {
    id: "5316",
    sura: "68",
    VerseIDAr: "45",
    ayatAR: "وَأُمْلِي لَهُمْ ۚ إِنَّ كَيْدِي مَتِينٌ",
  },
  {
    id: "5317",
    sura: "68",
    VerseIDAr: "46",
    ayatAR: "أَمْ تَسْأَلُهُمْ أَجْرًا فَهُمْ مِنْ مَغْرَمٍ مُثْقَلُونَ",
  },
  {
    id: "5318",
    sura: "68",
    VerseIDAr: "47",
    ayatAR: "أَمْ عِنْدَهُمُ الْغَيْبُ فَهُمْ يَكْتُبُونَ",
  },
  {
    id: "5319",
    sura: "68",
    VerseIDAr: "48",
    ayatAR:
      "فَاصْبِرْ لِحُكْمِ رَبِّكَ وَلَا تَكُنْ كَصَاحِبِ الْحُوتِ إِذْ نَادَىٰ وَهُوَ مَكْظُومٌ",
  },
  {
    id: "5320",
    sura: "68",
    VerseIDAr: "49",
    ayatAR:
      "لَوْلَا أَنْ تَدَارَكَهُ نِعْمَةٌ مِنْ رَبِّهِ لَنُبِذَ بِالْعَرَاءِ وَهُوَ مَذْمُومٌ",
  },
  {
    id: "5321",
    sura: "68",
    VerseIDAr: "50",
    ayatAR: "فَاجْتَبَاهُ رَبُّهُ فَجَعَلَهُ مِنَ الصَّالِحِينَ",
  },
  {
    id: "5322",
    sura: "68",
    VerseIDAr: "51",
    ayatAR:
      "وَإِنْ يَكَادُ الَّذِينَ كَفَرُوا لَيُزْلِقُونَكَ بِأَبْصَارِهِمْ لَمَّا سَمِعُوا الذِّكْرَ وَيَقُولُونَ إِنَّهُ لَمَجْنُونٌ",
  },
  {
    id: "5323",
    sura: "68",
    VerseIDAr: "52",
    ayatAR: "وَمَا هُوَ إِلَّا ذِكْرٌ لِلْعَالَمِينَ",
  },
  {
    id: "5324",
    sura: "69",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْحَاقَّةُ",
  },
  { id: "5325", sura: "69", VerseIDAr: "2", ayatAR: "مَا الْحَاقَّةُ" },
  {
    id: "5326",
    sura: "69",
    VerseIDAr: "3",
    ayatAR: "وَمَا أَدْرَاكَ مَا الْحَاقَّةُ",
  },
  {
    id: "5327",
    sura: "69",
    VerseIDAr: "4",
    ayatAR: "كَذَّبَتْ ثَمُودُ وَعَادٌ بِالْقَارِعَةِ",
  },
  {
    id: "5328",
    sura: "69",
    VerseIDAr: "5",
    ayatAR: "فَأَمَّا ثَمُودُ فَأُهْلِكُوا بِالطَّاغِيَةِ",
  },
  {
    id: "5329",
    sura: "69",
    VerseIDAr: "6",
    ayatAR: "وَأَمَّا عَادٌ فَأُهْلِكُوا بِرِيحٍ صَرْصَرٍ عَاتِيَةٍ",
  },
  {
    id: "5330",
    sura: "69",
    VerseIDAr: "7",
    ayatAR:
      "سَخَّرَهَا عَلَيْهِمْ سَبْعَ لَيَالٍ وَثَمَانِيَةَ أَيَّامٍ حُسُومًا فَتَرَى الْقَوْمَ فِيهَا صَرْعَىٰ كَأَنَّهُمْ أَعْجَازُ نَخْلٍ خَاوِيَةٍ",
  },
  {
    id: "5331",
    sura: "69",
    VerseIDAr: "8",
    ayatAR: "فَهَلْ تَرَىٰ لَهُمْ مِنْ بَاقِيَةٍ",
  },
  {
    id: "5332",
    sura: "69",
    VerseIDAr: "9",
    ayatAR:
      "وَجَاءَ فِرْعَوْنُ وَمَنْ قَبْلَهُ وَالْمُؤْتَفِكَاتُ بِالْخَاطِئَةِ",
  },
  {
    id: "5333",
    sura: "69",
    VerseIDAr: "10",
    ayatAR: "فَعَصَوْا رَسُولَ رَبِّهِمْ فَأَخَذَهُمْ أَخْذَةً رَابِيَةً",
  },
  {
    id: "5334",
    sura: "69",
    VerseIDAr: "11",
    ayatAR: "إِنَّا لَمَّا طَغَى الْمَاءُ حَمَلْنَاكُمْ فِي الْجَارِيَةِ",
  },
  {
    id: "5335",
    sura: "69",
    VerseIDAr: "12",
    ayatAR: "لِنَجْعَلَهَا لَكُمْ تَذْكِرَةً وَتَعِيَهَا أُذُنٌ وَاعِيَةٌ",
  },
  {
    id: "5336",
    sura: "69",
    VerseIDAr: "13",
    ayatAR: "فَإِذَا نُفِخَ فِي الصُّورِ نَفْخَةٌ وَاحِدَةٌ",
  },
  {
    id: "5337",
    sura: "69",
    VerseIDAr: "14",
    ayatAR: "وَحُمِلَتِ الْأَرْضُ وَالْجِبَالُ فَدُكَّتَا دَكَّةً وَاحِدَةً",
  },
  {
    id: "5338",
    sura: "69",
    VerseIDAr: "15",
    ayatAR: "فَيَوْمَئِذٍ وَقَعَتِ الْوَاقِعَةُ",
  },
  {
    id: "5339",
    sura: "69",
    VerseIDAr: "16",
    ayatAR: "وَانْشَقَّتِ السَّمَاءُ فَهِيَ يَوْمَئِذٍ وَاهِيَةٌ",
  },
  {
    id: "5340",
    sura: "69",
    VerseIDAr: "17",
    ayatAR:
      "وَالْمَلَكُ عَلَىٰ أَرْجَائِهَا ۚ وَيَحْمِلُ عَرْشَ رَبِّكَ فَوْقَهُمْ يَوْمَئِذٍ ثَمَانِيَةٌ",
  },
  {
    id: "5341",
    sura: "69",
    VerseIDAr: "18",
    ayatAR: "يَوْمَئِذٍ تُعْرَضُونَ لَا تَخْفَىٰ مِنْكُمْ خَافِيَةٌ",
  },
  {
    id: "5342",
    sura: "69",
    VerseIDAr: "19",
    ayatAR:
      "فَأَمَّا مَنْ أُوتِيَ كِتَابَهُ بِيَمِينِهِ فَيَقُولُ هَاؤُمُ اقْرَءُوا كِتَابِيَهْ",
  },
  {
    id: "5343",
    sura: "69",
    VerseIDAr: "20",
    ayatAR: "إِنِّي ظَنَنْتُ أَنِّي مُلَاقٍ حِسَابِيَهْ",
  },
  {
    id: "5344",
    sura: "69",
    VerseIDAr: "21",
    ayatAR: "فَهُوَ فِي عِيشَةٍ رَاضِيَةٍ",
  },
  { id: "5345", sura: "69", VerseIDAr: "22", ayatAR: "فِي جَنَّةٍ عَالِيَةٍ" },
  { id: "5346", sura: "69", VerseIDAr: "23", ayatAR: "قُطُوفُهَا دَانِيَةٌ" },
  {
    id: "5347",
    sura: "69",
    VerseIDAr: "24",
    ayatAR:
      "كُلُوا وَاشْرَبُوا هَنِيئًا بِمَا أَسْلَفْتُمْ فِي الْأَيَّامِ الْخَالِيَةِ",
  },
  {
    id: "5348",
    sura: "69",
    VerseIDAr: "25",
    ayatAR:
      "وَأَمَّا مَنْ أُوتِيَ كِتَابَهُ بِشِمَالِهِ فَيَقُولُ يَا لَيْتَنِي لَمْ أُوتَ كِتَابِيَهْ",
  },
  {
    id: "5349",
    sura: "69",
    VerseIDAr: "26",
    ayatAR: "وَلَمْ أَدْرِ مَا حِسَابِيَهْ",
  },
  {
    id: "5350",
    sura: "69",
    VerseIDAr: "27",
    ayatAR: "يَا لَيْتَهَا كَانَتِ الْقَاضِيَةَ",
  },
  {
    id: "5351",
    sura: "69",
    VerseIDAr: "28",
    ayatAR: "مَا أَغْنَىٰ عَنِّي مَالِيَهْ ۜ",
  },
  {
    id: "5352",
    sura: "69",
    VerseIDAr: "29",
    ayatAR: "هَلَكَ عَنِّي سُلْطَانِيَهْ",
  },
  { id: "5353", sura: "69", VerseIDAr: "30", ayatAR: "خُذُوهُ فَغُلُّوهُ" },
  {
    id: "5354",
    sura: "69",
    VerseIDAr: "31",
    ayatAR: "ثُمَّ الْجَحِيمَ صَلُّوهُ",
  },
  {
    id: "5355",
    sura: "69",
    VerseIDAr: "32",
    ayatAR: "ثُمَّ فِي سِلْسِلَةٍ ذَرْعُهَا سَبْعُونَ ذِرَاعًا فَاسْلُكُوهُ",
  },
  {
    id: "5356",
    sura: "69",
    VerseIDAr: "33",
    ayatAR: "إِنَّهُ كَانَ لَا يُؤْمِنُ بِاللَّهِ الْعَظِيمِ",
  },
  {
    id: "5357",
    sura: "69",
    VerseIDAr: "34",
    ayatAR: "وَلَا يَحُضُّ عَلَىٰ طَعَامِ الْمِسْكِينِ",
  },
  {
    id: "5358",
    sura: "69",
    VerseIDAr: "35",
    ayatAR: "فَلَيْسَ لَهُ الْيَوْمَ هَاهُنَا حَمِيمٌ",
  },
  {
    id: "5359",
    sura: "69",
    VerseIDAr: "36",
    ayatAR: "وَلَا طَعَامٌ إِلَّا مِنْ غِسْلِينٍ",
  },
  {
    id: "5360",
    sura: "69",
    VerseIDAr: "37",
    ayatAR: "لَا يَأْكُلُهُ إِلَّا الْخَاطِئُونَ",
  },
  {
    id: "5361",
    sura: "69",
    VerseIDAr: "38",
    ayatAR: "فَلَا أُقْسِمُ بِمَا تُبْصِرُونَ",
  },
  { id: "5362", sura: "69", VerseIDAr: "39", ayatAR: "وَمَا لَا تُبْصِرُونَ" },
  {
    id: "5363",
    sura: "69",
    VerseIDAr: "40",
    ayatAR: "إِنَّهُ لَقَوْلُ رَسُولٍ كَرِيمٍ",
  },
  {
    id: "5364",
    sura: "69",
    VerseIDAr: "41",
    ayatAR: "وَمَا هُوَ بِقَوْلِ شَاعِرٍ ۚ قَلِيلًا مَا تُؤْمِنُونَ",
  },
  {
    id: "5365",
    sura: "69",
    VerseIDAr: "42",
    ayatAR: "وَلَا بِقَوْلِ كَاهِنٍ ۚ قَلِيلًا مَا تَذَكَّرُونَ",
  },
  {
    id: "5366",
    sura: "69",
    VerseIDAr: "43",
    ayatAR: "تَنْزِيلٌ مِنْ رَبِّ الْعَالَمِينَ",
  },
  {
    id: "5367",
    sura: "69",
    VerseIDAr: "44",
    ayatAR: "وَلَوْ تَقَوَّلَ عَلَيْنَا بَعْضَ الْأَقَاوِيلِ",
  },
  {
    id: "5368",
    sura: "69",
    VerseIDAr: "45",
    ayatAR: "لَأَخَذْنَا مِنْهُ بِالْيَمِينِ",
  },
  {
    id: "5369",
    sura: "69",
    VerseIDAr: "46",
    ayatAR: "ثُمَّ لَقَطَعْنَا مِنْهُ الْوَتِينَ",
  },
  {
    id: "5370",
    sura: "69",
    VerseIDAr: "47",
    ayatAR: "فَمَا مِنْكُمْ مِنْ أَحَدٍ عَنْهُ حَاجِزِينَ",
  },
  {
    id: "5371",
    sura: "69",
    VerseIDAr: "48",
    ayatAR: "وَإِنَّهُ لَتَذْكِرَةٌ لِلْمُتَّقِينَ",
  },
  {
    id: "5372",
    sura: "69",
    VerseIDAr: "49",
    ayatAR: "وَإِنَّا لَنَعْلَمُ أَنَّ مِنْكُمْ مُكَذِّبِينَ",
  },
  {
    id: "5373",
    sura: "69",
    VerseIDAr: "50",
    ayatAR: "وَإِنَّهُ لَحَسْرَةٌ عَلَى الْكَافِرِينَ",
  },
  {
    id: "5374",
    sura: "69",
    VerseIDAr: "51",
    ayatAR: "وَإِنَّهُ لَحَقُّ الْيَقِينِ",
  },
  {
    id: "5375",
    sura: "69",
    VerseIDAr: "52",
    ayatAR: "فَسَبِّحْ بِاسْمِ رَبِّكَ الْعَظِيمِ",
  },
  {
    id: "5376",
    sura: "70",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سَأَلَ سَائِلٌ بِعَذَابٍ وَاقِعٍ",
  },
  {
    id: "5377",
    sura: "70",
    VerseIDAr: "2",
    ayatAR: "لِلْكَافِرِينَ لَيْسَ لَهُ دَافِعٌ",
  },
  {
    id: "5378",
    sura: "70",
    VerseIDAr: "3",
    ayatAR: "مِنَ اللَّهِ ذِي الْمَعَارِجِ",
  },
  {
    id: "5379",
    sura: "70",
    VerseIDAr: "4",
    ayatAR:
      "تَعْرُجُ الْمَلَائِكَةُ وَالرُّوحُ إِلَيْهِ فِي يَوْمٍ كَانَ مِقْدَارُهُ خَمْسِينَ أَلْفَ سَنَةٍ",
  },
  {
    id: "5380",
    sura: "70",
    VerseIDAr: "5",
    ayatAR: "فَاصْبِرْ صَبْرًا جَمِيلًا",
  },
  {
    id: "5381",
    sura: "70",
    VerseIDAr: "6",
    ayatAR: "إِنَّهُمْ يَرَوْنَهُ بَعِيدًا",
  },
  { id: "5382", sura: "70", VerseIDAr: "7", ayatAR: "وَنَرَاهُ قَرِيبًا" },
  {
    id: "5383",
    sura: "70",
    VerseIDAr: "8",
    ayatAR: "يَوْمَ تَكُونُ السَّمَاءُ كَالْمُهْلِ",
  },
  {
    id: "5384",
    sura: "70",
    VerseIDAr: "9",
    ayatAR: "وَتَكُونُ الْجِبَالُ كَالْعِهْنِ",
  },
  {
    id: "5385",
    sura: "70",
    VerseIDAr: "10",
    ayatAR: "وَلَا يَسْأَلُ حَمِيمٌ حَمِيمًا",
  },
  {
    id: "5386",
    sura: "70",
    VerseIDAr: "11",
    ayatAR:
      "يُبَصَّرُونَهُمْ ۚ يَوَدُّ الْمُجْرِمُ لَوْ يَفْتَدِي مِنْ عَذَابِ يَوْمِئِذٍ بِبَنِيهِ",
  },
  {
    id: "5387",
    sura: "70",
    VerseIDAr: "12",
    ayatAR: "وَصَاحِبَتِهِ وَأَخِيهِ",
  },
  {
    id: "5388",
    sura: "70",
    VerseIDAr: "13",
    ayatAR: "وَفَصِيلَتِهِ الَّتِي تُؤْوِيهِ",
  },
  {
    id: "5389",
    sura: "70",
    VerseIDAr: "14",
    ayatAR: "وَمَنْ فِي الْأَرْضِ جَمِيعًا ثُمَّ يُنْجِيهِ",
  },
  {
    id: "5390",
    sura: "70",
    VerseIDAr: "15",
    ayatAR: "كَلَّا ۖ إِنَّهَا لَظَىٰ",
  },
  { id: "5391", sura: "70", VerseIDAr: "16", ayatAR: "نَزَّاعَةً لِلشَّوَىٰ" },
  {
    id: "5392",
    sura: "70",
    VerseIDAr: "17",
    ayatAR: "تَدْعُو مَنْ أَدْبَرَ وَتَوَلَّىٰ",
  },
  { id: "5393", sura: "70", VerseIDAr: "18", ayatAR: "وَجَمَعَ فَأَوْعَىٰ" },
  {
    id: "5394",
    sura: "70",
    VerseIDAr: "19",
    ayatAR: "إِنَّ الْإِنْسَانَ خُلِقَ هَلُوعًا",
  },
  {
    id: "5395",
    sura: "70",
    VerseIDAr: "20",
    ayatAR: "إِذَا مَسَّهُ الشَّرُّ جَزُوعًا",
  },
  {
    id: "5396",
    sura: "70",
    VerseIDAr: "21",
    ayatAR: "وَإِذَا مَسَّهُ الْخَيْرُ مَنُوعًا",
  },
  { id: "5397", sura: "70", VerseIDAr: "22", ayatAR: "إِلَّا الْمُصَلِّينَ" },
  {
    id: "5398",
    sura: "70",
    VerseIDAr: "23",
    ayatAR: "الَّذِينَ هُمْ عَلَىٰ صَلَاتِهِمْ دَائِمُونَ",
  },
  {
    id: "5399",
    sura: "70",
    VerseIDAr: "24",
    ayatAR: "وَالَّذِينَ فِي أَمْوَالِهِمْ حَقٌّ مَعْلُومٌ",
  },
  {
    id: "5400",
    sura: "70",
    VerseIDAr: "25",
    ayatAR: "لِلسَّائِلِ وَالْمَحْرُومِ",
  },
  {
    id: "5401",
    sura: "70",
    VerseIDAr: "26",
    ayatAR: "وَالَّذِينَ يُصَدِّقُونَ بِيَوْمِ الدِّينِ",
  },
  {
    id: "5402",
    sura: "70",
    VerseIDAr: "27",
    ayatAR: "وَالَّذِينَ هُمْ مِنْ عَذَابِ رَبِّهِمْ مُشْفِقُونَ",
  },
  {
    id: "5403",
    sura: "70",
    VerseIDAr: "28",
    ayatAR: "إِنَّ عَذَابَ رَبِّهِمْ غَيْرُ مَأْمُونٍ",
  },
  {
    id: "5404",
    sura: "70",
    VerseIDAr: "29",
    ayatAR: "وَالَّذِينَ هُمْ لِفُرُوجِهِمْ حَافِظُونَ",
  },
  {
    id: "5405",
    sura: "70",
    VerseIDAr: "30",
    ayatAR:
      "إِلَّا عَلَىٰ أَزْوَاجِهِمْ أَوْ مَا مَلَكَتْ أَيْمَانُهُمْ فَإِنَّهُمْ غَيْرُ مَلُومِينَ",
  },
  {
    id: "5406",
    sura: "70",
    VerseIDAr: "31",
    ayatAR: "فَمَنِ ابْتَغَىٰ وَرَاءَ ذَٰلِكَ فَأُولَٰئِكَ هُمُ الْعَادُونَ",
  },
  {
    id: "5407",
    sura: "70",
    VerseIDAr: "32",
    ayatAR: "وَالَّذِينَ هُمْ لِأَمَانَاتِهِمْ وَعَهْدِهِمْ رَاعُونَ",
  },
  {
    id: "5408",
    sura: "70",
    VerseIDAr: "33",
    ayatAR: "وَالَّذِينَ هُمْ بِشَهَادَاتِهِمْ قَائِمُونَ",
  },
  {
    id: "5409",
    sura: "70",
    VerseIDAr: "34",
    ayatAR: "وَالَّذِينَ هُمْ عَلَىٰ صَلَاتِهِمْ يُحَافِظُونَ",
  },
  {
    id: "5410",
    sura: "70",
    VerseIDAr: "35",
    ayatAR: "أُولَٰئِكَ فِي جَنَّاتٍ مُكْرَمُونَ",
  },
  {
    id: "5411",
    sura: "70",
    VerseIDAr: "36",
    ayatAR: "فَمَالِ الَّذِينَ كَفَرُوا قِبَلَكَ مُهْطِعِينَ",
  },
  {
    id: "5412",
    sura: "70",
    VerseIDAr: "37",
    ayatAR: "عَنِ الْيَمِينِ وَعَنِ الشِّمَالِ عِزِينَ",
  },
  {
    id: "5413",
    sura: "70",
    VerseIDAr: "38",
    ayatAR: "أَيَطْمَعُ كُلُّ امْرِئٍ مِنْهُمْ أَنْ يُدْخَلَ جَنَّةَ نَعِيمٍ",
  },
  {
    id: "5414",
    sura: "70",
    VerseIDAr: "39",
    ayatAR: "كَلَّا ۖ إِنَّا خَلَقْنَاهُمْ مِمَّا يَعْلَمُونَ",
  },
  {
    id: "5415",
    sura: "70",
    VerseIDAr: "40",
    ayatAR:
      "فَلَا أُقْسِمُ بِرَبِّ الْمَشَارِقِ وَالْمَغَارِبِ إِنَّا لَقَادِرُونَ",
  },
  {
    id: "5416",
    sura: "70",
    VerseIDAr: "41",
    ayatAR:
      "عَلَىٰ أَنْ نُبَدِّلَ خَيْرًا مِنْهُمْ وَمَا نَحْنُ بِمَسْبُوقِينَ",
  },
  {
    id: "5417",
    sura: "70",
    VerseIDAr: "42",
    ayatAR:
      "فَذَرْهُمْ يَخُوضُوا وَيَلْعَبُوا حَتَّىٰ يُلَاقُوا يَوْمَهُمُ الَّذِي يُوعَدُونَ",
  },
  {
    id: "5418",
    sura: "70",
    VerseIDAr: "43",
    ayatAR:
      "يَوْمَ يَخْرُجُونَ مِنَ الْأَجْدَاثِ سِرَاعًا كَأَنَّهُمْ إِلَىٰ نُصُبٍ يُوفِضُونَ",
  },
  {
    id: "5419",
    sura: "70",
    VerseIDAr: "44",
    ayatAR:
      "خَاشِعَةً أَبْصَارُهُمْ تَرْهَقُهُمْ ذِلَّةٌ ۚ ذَٰلِكَ الْيَوْمُ الَّذِي كَانُوا يُوعَدُونَ",
  },
  {
    id: "5420",
    sura: "71",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِنَّا أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِ أَنْ أَنْذِرْ قَوْمَكَ مِنْ قَبْلِ أَنْ يَأْتِيَهُمْ عَذَابٌ أَلِيمٌ",
  },
  {
    id: "5421",
    sura: "71",
    VerseIDAr: "2",
    ayatAR: "قَالَ يَا قَوْمِ إِنِّي لَكُمْ نَذِيرٌ مُبِينٌ",
  },
  {
    id: "5422",
    sura: "71",
    VerseIDAr: "3",
    ayatAR: "أَنِ اعْبُدُوا اللَّهَ وَاتَّقُوهُ وَأَطِيعُونِ",
  },
  {
    id: "5423",
    sura: "71",
    VerseIDAr: "4",
    ayatAR:
      "يَغْفِرْ لَكُمْ مِنْ ذُنُوبِكُمْ وَيُؤَخِّرْكُمْ إِلَىٰ أَجَلٍ مُسَمًّى ۚ إِنَّ أَجَلَ اللَّهِ إِذَا جَاءَ لَا يُؤَخَّرُ ۖ لَوْ كُنْتُمْ تَعْلَمُونَ",
  },
  {
    id: "5424",
    sura: "71",
    VerseIDAr: "5",
    ayatAR: "قَالَ رَبِّ إِنِّي دَعَوْتُ قَوْمِي لَيْلًا وَنَهَارًا",
  },
  {
    id: "5425",
    sura: "71",
    VerseIDAr: "6",
    ayatAR: "فَلَمْ يَزِدْهُمْ دُعَائِي إِلَّا فِرَارًا",
  },
  {
    id: "5426",
    sura: "71",
    VerseIDAr: "7",
    ayatAR:
      "وَإِنِّي كُلَّمَا دَعَوْتُهُمْ لِتَغْفِرَ لَهُمْ جَعَلُوا أَصَابِعَهُمْ فِي آذَانِهِمْ وَاسْتَغْشَوْا ثِيَابَهُمْ وَأَصَرُّوا وَاسْتَكْبَرُوا اسْتِكْبَارًا",
  },
  {
    id: "5427",
    sura: "71",
    VerseIDAr: "8",
    ayatAR: "ثُمَّ إِنِّي دَعَوْتُهُمْ جِهَارًا",
  },
  {
    id: "5428",
    sura: "71",
    VerseIDAr: "9",
    ayatAR: "ثُمَّ إِنِّي أَعْلَنْتُ لَهُمْ وَأَسْرَرْتُ لَهُمْ إِسْرَارًا",
  },
  {
    id: "5429",
    sura: "71",
    VerseIDAr: "10",
    ayatAR: "فَقُلْتُ اسْتَغْفِرُوا رَبَّكُمْ إِنَّهُ كَانَ غَفَّارًا",
  },
  {
    id: "5430",
    sura: "71",
    VerseIDAr: "11",
    ayatAR: "يُرْسِلِ السَّمَاءَ عَلَيْكُمْ مِدْرَارًا",
  },
  {
    id: "5431",
    sura: "71",
    VerseIDAr: "12",
    ayatAR:
      "وَيُمْدِدْكُمْ بِأَمْوَالٍ وَبَنِينَ وَيَجْعَلْ لَكُمْ جَنَّاتٍ وَيَجْعَلْ لَكُمْ أَنْهَارًا",
  },
  {
    id: "5432",
    sura: "71",
    VerseIDAr: "13",
    ayatAR: "مَا لَكُمْ لَا تَرْجُونَ لِلَّهِ وَقَارًا",
  },
  {
    id: "5433",
    sura: "71",
    VerseIDAr: "14",
    ayatAR: "وَقَدْ خَلَقَكُمْ أَطْوَارًا",
  },
  {
    id: "5434",
    sura: "71",
    VerseIDAr: "15",
    ayatAR: "أَلَمْ تَرَوْا كَيْفَ خَلَقَ اللَّهُ سَبْعَ سَمَاوَاتٍ طِبَاقًا",
  },
  {
    id: "5435",
    sura: "71",
    VerseIDAr: "16",
    ayatAR: "وَجَعَلَ الْقَمَرَ فِيهِنَّ نُورًا وَجَعَلَ الشَّمْسَ سِرَاجًا",
  },
  {
    id: "5436",
    sura: "71",
    VerseIDAr: "17",
    ayatAR: "وَاللَّهُ أَنْبَتَكُمْ مِنَ الْأَرْضِ نَبَاتًا",
  },
  {
    id: "5437",
    sura: "71",
    VerseIDAr: "18",
    ayatAR: "ثُمَّ يُعِيدُكُمْ فِيهَا وَيُخْرِجُكُمْ إِخْرَاجًا",
  },
  {
    id: "5438",
    sura: "71",
    VerseIDAr: "19",
    ayatAR: "وَاللَّهُ جَعَلَ لَكُمُ الْأَرْضَ بِسَاطًا",
  },
  {
    id: "5439",
    sura: "71",
    VerseIDAr: "20",
    ayatAR: "لِتَسْلُكُوا مِنْهَا سُبُلًا فِجَاجًا",
  },
  {
    id: "5440",
    sura: "71",
    VerseIDAr: "21",
    ayatAR:
      "قَالَ نُوحٌ رَبِّ إِنَّهُمْ عَصَوْنِي وَاتَّبَعُوا مَنْ لَمْ يَزِدْهُ مَالُهُ وَوَلَدُهُ إِلَّا خَسَارًا",
  },
  {
    id: "5441",
    sura: "71",
    VerseIDAr: "22",
    ayatAR: "وَمَكَرُوا مَكْرًا كُبَّارًا",
  },
  {
    id: "5442",
    sura: "71",
    VerseIDAr: "23",
    ayatAR:
      "وَقَالُوا لَا تَذَرُنَّ آلِهَتَكُمْ وَلَا تَذَرُنَّ وَدًّا وَلَا سُوَاعًا وَلَا يَغُوثَ وَيَعُوقَ وَنَسْرًا",
  },
  {
    id: "5443",
    sura: "71",
    VerseIDAr: "24",
    ayatAR:
      "وَقَدْ أَضَلُّوا كَثِيرًا ۖ وَلَا تَزِدِ الظَّالِمِينَ إِلَّا ضَلَالًا",
  },
  {
    id: "5444",
    sura: "71",
    VerseIDAr: "25",
    ayatAR:
      "مِمَّا خَطِيئَاتِهِمْ أُغْرِقُوا فَأُدْخِلُوا نَارًا فَلَمْ يَجِدُوا لَهُمْ مِنْ دُونِ اللَّهِ أَنْصَارًا",
  },
  {
    id: "5445",
    sura: "71",
    VerseIDAr: "26",
    ayatAR:
      "وَقَالَ نُوحٌ رَبِّ لَا تَذَرْ عَلَى الْأَرْضِ مِنَ الْكَافِرِينَ دَيَّارًا",
  },
  {
    id: "5446",
    sura: "71",
    VerseIDAr: "27",
    ayatAR:
      "إِنَّكَ إِنْ تَذَرْهُمْ يُضِلُّوا عِبَادَكَ وَلَا يَلِدُوا إِلَّا فَاجِرًا كَفَّارًا",
  },
  {
    id: "5447",
    sura: "71",
    VerseIDAr: "28",
    ayatAR:
      "رَبِّ اغْفِرْ لِي وَلِوَالِدَيَّ وَلِمَنْ دَخَلَ بَيْتِيَ مُؤْمِنًا وَلِلْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ وَلَا تَزِدِ الظَّالِمِينَ إِلَّا تَبَارًا",
  },
  {
    id: "5448",
    sura: "72",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قُلْ أُوحِيَ إِلَيَّ أَنَّهُ اسْتَمَعَ نَفَرٌ مِنَ الْجِنِّ فَقَالُوا إِنَّا سَمِعْنَا قُرْآنًا عَجَبًا",
  },
  {
    id: "5449",
    sura: "72",
    VerseIDAr: "2",
    ayatAR:
      "يَهْدِي إِلَى الرُّشْدِ فَآمَنَّا بِهِ ۖ وَلَنْ نُشْرِكَ بِرَبِّنَا أَحَدًا",
  },
  {
    id: "5450",
    sura: "72",
    VerseIDAr: "3",
    ayatAR:
      "وَأَنَّهُ تَعَالَىٰ جَدُّ رَبِّنَا مَا اتَّخَذَ صَاحِبَةً وَلَا وَلَدًا",
  },
  {
    id: "5451",
    sura: "72",
    VerseIDAr: "4",
    ayatAR: "وَأَنَّهُ كَانَ يَقُولُ سَفِيهُنَا عَلَى اللَّهِ شَطَطًا",
  },
  {
    id: "5452",
    sura: "72",
    VerseIDAr: "5",
    ayatAR:
      "وَأَنَّا ظَنَنَّا أَنْ لَنْ تَقُولَ الْإِنْسُ وَالْجِنُّ عَلَى اللَّهِ كَذِبًا",
  },
  {
    id: "5453",
    sura: "72",
    VerseIDAr: "6",
    ayatAR:
      "وَأَنَّهُ كَانَ رِجَالٌ مِنَ الْإِنْسِ يَعُوذُونَ بِرِجَالٍ مِنَ الْجِنِّ فَزَادُوهُمْ رَهَقًا",
  },
  {
    id: "5454",
    sura: "72",
    VerseIDAr: "7",
    ayatAR:
      "وَأَنَّهُمْ ظَنُّوا كَمَا ظَنَنْتُمْ أَنْ لَنْ يَبْعَثَ اللَّهُ أَحَدًا",
  },
  {
    id: "5455",
    sura: "72",
    VerseIDAr: "8",
    ayatAR:
      "وَأَنَّا لَمَسْنَا السَّمَاءَ فَوَجَدْنَاهَا مُلِئَتْ حَرَسًا شَدِيدًا وَشُهُبًا",
  },
  {
    id: "5456",
    sura: "72",
    VerseIDAr: "9",
    ayatAR:
      "وَأَنَّا كُنَّا نَقْعُدُ مِنْهَا مَقَاعِدَ لِلسَّمْعِ ۖ فَمَنْ يَسْتَمِعِ الْآنَ يَجِدْ لَهُ شِهَابًا رَصَدًا",
  },
  {
    id: "5457",
    sura: "72",
    VerseIDAr: "10",
    ayatAR:
      "وَأَنَّا لَا نَدْرِي أَشَرٌّ أُرِيدَ بِمَنْ فِي الْأَرْضِ أَمْ أَرَادَ بِهِمْ رَبُّهُمْ رَشَدًا",
  },
  {
    id: "5458",
    sura: "72",
    VerseIDAr: "11",
    ayatAR:
      "وَأَنَّا مِنَّا الصَّالِحُونَ وَمِنَّا دُونَ ذَٰلِكَ ۖ كُنَّا طَرَائِقَ قِدَدًا",
  },
  {
    id: "5459",
    sura: "72",
    VerseIDAr: "12",
    ayatAR:
      "وَأَنَّا ظَنَنَّا أَنْ لَنْ نُعْجِزَ اللَّهَ فِي الْأَرْضِ وَلَنْ نُعْجِزَهُ هَرَبًا",
  },
  {
    id: "5460",
    sura: "72",
    VerseIDAr: "13",
    ayatAR:
      "وَأَنَّا لَمَّا سَمِعْنَا الْهُدَىٰ آمَنَّا بِهِ ۖ فَمَنْ يُؤْمِنْ بِرَبِّهِ فَلَا يَخَافُ بَخْسًا وَلَا رَهَقًا",
  },
  {
    id: "5461",
    sura: "72",
    VerseIDAr: "14",
    ayatAR:
      "وَأَنَّا مِنَّا الْمُسْلِمُونَ وَمِنَّا الْقَاسِطُونَ ۖ فَمَنْ أَسْلَمَ فَأُولَٰئِكَ تَحَرَّوْا رَشَدًا",
  },
  {
    id: "5462",
    sura: "72",
    VerseIDAr: "15",
    ayatAR: "وَأَمَّا الْقَاسِطُونَ فَكَانُوا لِجَهَنَّمَ حَطَبًا",
  },
  {
    id: "5463",
    sura: "72",
    VerseIDAr: "16",
    ayatAR:
      "وَأَنْ لَوِ اسْتَقَامُوا عَلَى الطَّرِيقَةِ لَأَسْقَيْنَاهُمْ مَاءً غَدَقًا",
  },
  {
    id: "5464",
    sura: "72",
    VerseIDAr: "17",
    ayatAR:
      "لِنَفْتِنَهُمْ فِيهِ ۚ وَمَنْ يُعْرِضْ عَنْ ذِكْرِ رَبِّهِ يَسْلُكْهُ عَذَابًا صَعَدًا",
  },
  {
    id: "5465",
    sura: "72",
    VerseIDAr: "18",
    ayatAR: "وَأَنَّ الْمَسَاجِدَ لِلَّهِ فَلَا تَدْعُوا مَعَ اللَّهِ أَحَدًا",
  },
  {
    id: "5466",
    sura: "72",
    VerseIDAr: "19",
    ayatAR:
      "وَأَنَّهُ لَمَّا قَامَ عَبْدُ اللَّهِ يَدْعُوهُ كَادُوا يَكُونُونَ عَلَيْهِ لِبَدًا",
  },
  {
    id: "5467",
    sura: "72",
    VerseIDAr: "20",
    ayatAR: "قُلْ إِنَّمَا أَدْعُو رَبِّي وَلَا أُشْرِكُ بِهِ أَحَدًا",
  },
  {
    id: "5468",
    sura: "72",
    VerseIDAr: "21",
    ayatAR: "قُلْ إِنِّي لَا أَمْلِكُ لَكُمْ ضَرًّا وَلَا رَشَدًا",
  },
  {
    id: "5469",
    sura: "72",
    VerseIDAr: "22",
    ayatAR:
      "قُلْ إِنِّي لَنْ يُجِيرَنِي مِنَ اللَّهِ أَحَدٌ وَلَنْ أَجِدَ مِنْ دُونِهِ مُلْتَحَدًا",
  },
  {
    id: "5470",
    sura: "72",
    VerseIDAr: "23",
    ayatAR:
      "إِلَّا بَلَاغًا مِنَ اللَّهِ وَرِسَالَاتِهِ ۚ وَمَنْ يَعْصِ اللَّهَ وَرَسُولَهُ فَإِنَّ لَهُ نَارَ جَهَنَّمَ خَالِدِينَ فِيهَا أَبَدًا",
  },
  {
    id: "5471",
    sura: "72",
    VerseIDAr: "24",
    ayatAR:
      "حَتَّىٰ إِذَا رَأَوْا مَا يُوعَدُونَ فَسَيَعْلَمُونَ مَنْ أَضْعَفُ نَاصِرًا وَأَقَلُّ عَدَدًا",
  },
  {
    id: "5472",
    sura: "72",
    VerseIDAr: "25",
    ayatAR:
      "قُلْ إِنْ أَدْرِي أَقَرِيبٌ مَا تُوعَدُونَ أَمْ يَجْعَلُ لَهُ رَبِّي أَمَدًا",
  },
  {
    id: "5473",
    sura: "72",
    VerseIDAr: "26",
    ayatAR: "عَالِمُ الْغَيْبِ فَلَا يُظْهِرُ عَلَىٰ غَيْبِهِ أَحَدًا",
  },
  {
    id: "5474",
    sura: "72",
    VerseIDAr: "27",
    ayatAR:
      "إِلَّا مَنِ ارْتَضَىٰ مِنْ رَسُولٍ فَإِنَّهُ يَسْلُكُ مِنْ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِ رَصَدًا",
  },
  {
    id: "5475",
    sura: "72",
    VerseIDAr: "28",
    ayatAR:
      "لِيَعْلَمَ أَنْ قَدْ أَبْلَغُوا رِسَالَاتِ رَبِّهِمْ وَأَحَاطَ بِمَا لَدَيْهِمْ وَأَحْصَىٰ كُلَّ شَيْءٍ عَدَدًا",
  },
  {
    id: "5476",
    sura: "73",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا الْمُزَّمِّلُ",
  },
  {
    id: "5477",
    sura: "73",
    VerseIDAr: "2",
    ayatAR: "قُمِ اللَّيْلَ إِلَّا قَلِيلًا",
  },
  {
    id: "5478",
    sura: "73",
    VerseIDAr: "3",
    ayatAR: "نِصْفَهُ أَوِ انْقُصْ مِنْهُ قَلِيلًا",
  },
  {
    id: "5479",
    sura: "73",
    VerseIDAr: "4",
    ayatAR: "أَوْ زِدْ عَلَيْهِ وَرَتِّلِ الْقُرْآنَ تَرْتِيلًا",
  },
  {
    id: "5480",
    sura: "73",
    VerseIDAr: "5",
    ayatAR: "إِنَّا سَنُلْقِي عَلَيْكَ قَوْلًا ثَقِيلًا",
  },
  {
    id: "5481",
    sura: "73",
    VerseIDAr: "6",
    ayatAR: "إِنَّ نَاشِئَةَ اللَّيْلِ هِيَ أَشَدُّ وَطْئًا وَأَقْوَمُ قِيلًا",
  },
  {
    id: "5482",
    sura: "73",
    VerseIDAr: "7",
    ayatAR: "إِنَّ لَكَ فِي النَّهَارِ سَبْحًا طَوِيلًا",
  },
  {
    id: "5483",
    sura: "73",
    VerseIDAr: "8",
    ayatAR: "وَاذْكُرِ اسْمَ رَبِّكَ وَتَبَتَّلْ إِلَيْهِ تَبْتِيلًا",
  },
  {
    id: "5484",
    sura: "73",
    VerseIDAr: "9",
    ayatAR:
      "رَبُّ الْمَشْرِقِ وَالْمَغْرِبِ لَا إِلَٰهَ إِلَّا هُوَ فَاتَّخِذْهُ وَكِيلًا",
  },
  {
    id: "5485",
    sura: "73",
    VerseIDAr: "10",
    ayatAR: "وَاصْبِرْ عَلَىٰ مَا يَقُولُونَ وَاهْجُرْهُمْ هَجْرًا جَمِيلًا",
  },
  {
    id: "5486",
    sura: "73",
    VerseIDAr: "11",
    ayatAR:
      "وَذَرْنِي وَالْمُكَذِّبِينَ أُولِي النَّعْمَةِ وَمَهِّلْهُمْ قَلِيلًا",
  },
  {
    id: "5487",
    sura: "73",
    VerseIDAr: "12",
    ayatAR: "إِنَّ لَدَيْنَا أَنْكَالًا وَجَحِيمًا",
  },
  {
    id: "5488",
    sura: "73",
    VerseIDAr: "13",
    ayatAR: "وَطَعَامًا ذَا غُصَّةٍ وَعَذَابًا أَلِيمًا",
  },
  {
    id: "5489",
    sura: "73",
    VerseIDAr: "14",
    ayatAR:
      "يَوْمَ تَرْجُفُ الْأَرْضُ وَالْجِبَالُ وَكَانَتِ الْجِبَالُ كَثِيبًا مَهِيلًا",
  },
  {
    id: "5490",
    sura: "73",
    VerseIDAr: "15",
    ayatAR:
      "إِنَّا أَرْسَلْنَا إِلَيْكُمْ رَسُولًا شَاهِدًا عَلَيْكُمْ كَمَا أَرْسَلْنَا إِلَىٰ فِرْعَوْنَ رَسُولًا",
  },
  {
    id: "5491",
    sura: "73",
    VerseIDAr: "16",
    ayatAR: "فَعَصَىٰ فِرْعَوْنُ الرَّسُولَ فَأَخَذْنَاهُ أَخْذًا وَبِيلًا",
  },
  {
    id: "5492",
    sura: "73",
    VerseIDAr: "17",
    ayatAR:
      "فَكَيْفَ تَتَّقُونَ إِنْ كَفَرْتُمْ يَوْمًا يَجْعَلُ الْوِلْدَانَ شِيبًا",
  },
  {
    id: "5493",
    sura: "73",
    VerseIDAr: "18",
    ayatAR: "السَّمَاءُ مُنْفَطِرٌ بِهِ ۚ كَانَ وَعْدُهُ مَفْعُولًا",
  },
  {
    id: "5494",
    sura: "73",
    VerseIDAr: "19",
    ayatAR:
      "إِنَّ هَٰذِهِ تَذْكِرَةٌ ۖ فَمَنْ شَاءَ اتَّخَذَ إِلَىٰ رَبِّهِ سَبِيلًا",
  },
  {
    id: "5495",
    sura: "73",
    VerseIDAr: "20",
    ayatAR:
      "إِنَّ رَبَّكَ يَعْلَمُ أَنَّكَ تَقُومُ أَدْنَىٰ مِنْ ثُلُثَيِ اللَّيْلِ وَنِصْفَهُ وَثُلُثَهُ وَطَائِفَةٌ مِنَ الَّذِينَ مَعَكَ ۚ وَاللَّهُ يُقَدِّرُ اللَّيْلَ وَالنَّهَارَ ۚ عَلِمَ أَنْ لَنْ تُحْصُوهُ فَتَابَ عَلَيْكُمْ ۖ فَاقْرَءُوا مَا تَيَسَّرَ مِنَ الْقُرْآنِ ۚ عَلِمَ أَنْ سَيَكُونُ مِنْكُمْ مَرْضَىٰ ۙ وَآخَرُونَ يَضْرِبُونَ فِي الْأَرْضِ يَبْتَغُونَ مِنْ فَضْلِ اللَّهِ ۙ وَآخَرُونَ يُقَاتِلُونَ فِي سَبِيلِ اللَّهِ ۖ فَاقْرَءُوا مَا تَيَسَّرَ مِنْهُ ۚ وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَأَقْرِضُوا اللَّهَ قَرْضًا حَسَنًا ۚ وَمَا تُقَدِّمُوا لِأَنْفُسِكُمْ مِنْ خَيْرٍ تَجِدُوهُ عِنْدَ اللَّهِ هُوَ خَيْرًا وَأَعْظَمَ أَجْرًا ۚ وَاسْتَغْفِرُوا اللَّهَ ۖ إِنَّ اللَّهَ غَفُورٌ رَحِيمٌ",
  },
  {
    id: "5496",
    sura: "74",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ يَا أَيُّهَا الْمُدَّثِّرُ",
  },
  { id: "5497", sura: "74", VerseIDAr: "2", ayatAR: "قُمْ فَأَنْذِرْ" },
  { id: "5498", sura: "74", VerseIDAr: "3", ayatAR: "وَرَبَّكَ فَكَبِّرْ" },
  { id: "5499", sura: "74", VerseIDAr: "4", ayatAR: "وَثِيَابَكَ فَطَهِّرْ" },
  { id: "5500", sura: "74", VerseIDAr: "5", ayatAR: "وَالرُّجْزَ فَاهْجُرْ" },
  {
    id: "5501",
    sura: "74",
    VerseIDAr: "6",
    ayatAR: "وَلَا تَمْنُنْ تَسْتَكْثِرُ",
  },
  { id: "5502", sura: "74", VerseIDAr: "7", ayatAR: "وَلِرَبِّكَ فَاصْبِرْ" },
  {
    id: "5503",
    sura: "74",
    VerseIDAr: "8",
    ayatAR: "فَإِذَا نُقِرَ فِي النَّاقُورِ",
  },
  {
    id: "5504",
    sura: "74",
    VerseIDAr: "9",
    ayatAR: "فَذَٰلِكَ يَوْمَئِذٍ يَوْمٌ عَسِيرٌ",
  },
  {
    id: "5505",
    sura: "74",
    VerseIDAr: "10",
    ayatAR: "عَلَى الْكَافِرِينَ غَيْرُ يَسِيرٍ",
  },
  {
    id: "5506",
    sura: "74",
    VerseIDAr: "11",
    ayatAR: "ذَرْنِي وَمَنْ خَلَقْتُ وَحِيدًا",
  },
  {
    id: "5507",
    sura: "74",
    VerseIDAr: "12",
    ayatAR: "وَجَعَلْتُ لَهُ مَالًا مَمْدُودًا",
  },
  { id: "5508", sura: "74", VerseIDAr: "13", ayatAR: "وَبَنِينَ شُهُودًا" },
  {
    id: "5509",
    sura: "74",
    VerseIDAr: "14",
    ayatAR: "وَمَهَّدْتُ لَهُ تَمْهِيدًا",
  },
  {
    id: "5510",
    sura: "74",
    VerseIDAr: "15",
    ayatAR: "ثُمَّ يَطْمَعُ أَنْ أَزِيدَ",
  },
  {
    id: "5511",
    sura: "74",
    VerseIDAr: "16",
    ayatAR: "كَلَّا ۖ إِنَّهُ كَانَ لِآيَاتِنَا عَنِيدًا",
  },
  { id: "5512", sura: "74", VerseIDAr: "17", ayatAR: "سَأُرْهِقُهُ صَعُودًا" },
  {
    id: "5513",
    sura: "74",
    VerseIDAr: "18",
    ayatAR: "إِنَّهُ فَكَّرَ وَقَدَّرَ",
  },
  {
    id: "5514",
    sura: "74",
    VerseIDAr: "19",
    ayatAR: "فَقُتِلَ كَيْفَ قَدَّرَ",
  },
  {
    id: "5515",
    sura: "74",
    VerseIDAr: "20",
    ayatAR: "ثُمَّ قُتِلَ كَيْفَ قَدَّرَ",
  },
  { id: "5516", sura: "74", VerseIDAr: "21", ayatAR: "ثُمَّ نَظَرَ" },
  { id: "5517", sura: "74", VerseIDAr: "22", ayatAR: "ثُمَّ عَبَسَ وَبَسَرَ" },
  {
    id: "5518",
    sura: "74",
    VerseIDAr: "23",
    ayatAR: "ثُمَّ أَدْبَرَ وَاسْتَكْبَرَ",
  },
  {
    id: "5519",
    sura: "74",
    VerseIDAr: "24",
    ayatAR: "فَقَالَ إِنْ هَٰذَا إِلَّا سِحْرٌ يُؤْثَرُ",
  },
  {
    id: "5520",
    sura: "74",
    VerseIDAr: "25",
    ayatAR: "إِنْ هَٰذَا إِلَّا قَوْلُ الْبَشَرِ",
  },
  { id: "5521", sura: "74", VerseIDAr: "26", ayatAR: "سَأُصْلِيهِ سَقَرَ" },
  {
    id: "5522",
    sura: "74",
    VerseIDAr: "27",
    ayatAR: "وَمَا أَدْرَاكَ مَا سَقَرُ",
  },
  {
    id: "5523",
    sura: "74",
    VerseIDAr: "28",
    ayatAR: "لَا تُبْقِي وَلَا تَذَرُ",
  },
  { id: "5524", sura: "74", VerseIDAr: "29", ayatAR: "لَوَّاحَةٌ لِلْبَشَرِ" },
  {
    id: "5525",
    sura: "74",
    VerseIDAr: "30",
    ayatAR: "عَلَيْهَا تِسْعَةَ عَشَرَ",
  },
  {
    id: "5526",
    sura: "74",
    VerseIDAr: "31",
    ayatAR:
      "وَمَا جَعَلْنَا أَصْحَابَ النَّارِ إِلَّا مَلَائِكَةً ۙ وَمَا جَعَلْنَا عِدَّتَهُمْ إِلَّا فِتْنَةً لِلَّذِينَ كَفَرُوا لِيَسْتَيْقِنَ الَّذِينَ أُوتُوا الْكِتَابَ وَيَزْدَادَ الَّذِينَ آمَنُوا إِيمَانًا ۙ وَلَا يَرْتَابَ الَّذِينَ أُوتُوا الْكِتَابَ وَالْمُؤْمِنُونَ ۙ وَلِيَقُولَ الَّذِينَ فِي قُلُوبِهِمْ مَرَضٌ وَالْكَافِرُونَ مَاذَا أَرَادَ اللَّهُ بِهَٰذَا مَثَلًا ۚ كَذَٰلِكَ يُضِلُّ اللَّهُ مَنْ يَشَاءُ وَيَهْدِي مَنْ يَشَاءُ ۚ وَمَا يَعْلَمُ جُنُودَ رَبِّكَ إِلَّا هُوَ ۚ وَمَا هِيَ إِلَّا ذِكْرَىٰ لِلْبَشَرِ",
  },
  { id: "5527", sura: "74", VerseIDAr: "32", ayatAR: "كَلَّا وَالْقَمَرِ" },
  {
    id: "5528",
    sura: "74",
    VerseIDAr: "33",
    ayatAR: "وَاللَّيْلِ إِذْ أَدْبَرَ",
  },
  {
    id: "5529",
    sura: "74",
    VerseIDAr: "34",
    ayatAR: "وَالصُّبْحِ إِذَا أَسْفَرَ",
  },
  {
    id: "5530",
    sura: "74",
    VerseIDAr: "35",
    ayatAR: "إِنَّهَا لَإِحْدَى الْكُبَرِ",
  },
  { id: "5531", sura: "74", VerseIDAr: "36", ayatAR: "نَذِيرًا لِلْبَشَرِ" },
  {
    id: "5532",
    sura: "74",
    VerseIDAr: "37",
    ayatAR: "لِمَنْ شَاءَ مِنْكُمْ أَنْ يَتَقَدَّمَ أَوْ يَتَأَخَّرَ",
  },
  {
    id: "5533",
    sura: "74",
    VerseIDAr: "38",
    ayatAR: "كُلُّ نَفْسٍ بِمَا كَسَبَتْ رَهِينَةٌ",
  },
  {
    id: "5534",
    sura: "74",
    VerseIDAr: "39",
    ayatAR: "إِلَّا أَصْحَابَ الْيَمِينِ",
  },
  {
    id: "5535",
    sura: "74",
    VerseIDAr: "40",
    ayatAR: "فِي جَنَّاتٍ يَتَسَاءَلُونَ",
  },
  { id: "5536", sura: "74", VerseIDAr: "41", ayatAR: "عَنِ الْمُجْرِمِينَ" },
  {
    id: "5537",
    sura: "74",
    VerseIDAr: "42",
    ayatAR: "مَا سَلَكَكُمْ فِي سَقَرَ",
  },
  {
    id: "5538",
    sura: "74",
    VerseIDAr: "43",
    ayatAR: "قَالُوا لَمْ نَكُ مِنَ الْمُصَلِّينَ",
  },
  {
    id: "5539",
    sura: "74",
    VerseIDAr: "44",
    ayatAR: "وَلَمْ نَكُ نُطْعِمُ الْمِسْكِينَ",
  },
  {
    id: "5540",
    sura: "74",
    VerseIDAr: "45",
    ayatAR: "وَكُنَّا نَخُوضُ مَعَ الْخَائِضِينَ",
  },
  {
    id: "5541",
    sura: "74",
    VerseIDAr: "46",
    ayatAR: "وَكُنَّا نُكَذِّبُ بِيَوْمِ الدِّينِ",
  },
  {
    id: "5542",
    sura: "74",
    VerseIDAr: "47",
    ayatAR: "حَتَّىٰ أَتَانَا الْيَقِينُ",
  },
  {
    id: "5543",
    sura: "74",
    VerseIDAr: "48",
    ayatAR: "فَمَا تَنْفَعُهُمْ شَفَاعَةُ الشَّافِعِينَ",
  },
  {
    id: "5544",
    sura: "74",
    VerseIDAr: "49",
    ayatAR: "فَمَا لَهُمْ عَنِ التَّذْكِرَةِ مُعْرِضِينَ",
  },
  {
    id: "5545",
    sura: "74",
    VerseIDAr: "50",
    ayatAR: "كَأَنَّهُمْ حُمُرٌ مُسْتَنْفِرَةٌ",
  },
  {
    id: "5546",
    sura: "74",
    VerseIDAr: "51",
    ayatAR: "فَرَّتْ مِنْ قَسْوَرَةٍ",
  },
  {
    id: "5547",
    sura: "74",
    VerseIDAr: "52",
    ayatAR:
      "بَلْ يُرِيدُ كُلُّ امْرِئٍ مِنْهُمْ أَنْ يُؤْتَىٰ صُحُفًا مُنَشَّرَةً",
  },
  {
    id: "5548",
    sura: "74",
    VerseIDAr: "53",
    ayatAR: "كَلَّا ۖ بَلْ لَا يَخَافُونَ الْآخِرَةَ",
  },
  {
    id: "5549",
    sura: "74",
    VerseIDAr: "54",
    ayatAR: "كَلَّا إِنَّهُ تَذْكِرَةٌ",
  },
  { id: "5550", sura: "74", VerseIDAr: "55", ayatAR: "فَمَنْ شَاءَ ذَكَرَهُ" },
  {
    id: "5551",
    sura: "74",
    VerseIDAr: "56",
    ayatAR:
      "وَمَا يَذْكُرُونَ إِلَّا أَنْ يَشَاءَ اللَّهُ ۚ هُوَ أَهْلُ التَّقْوَىٰ وَأَهْلُ الْمَغْفِرَةِ",
  },
  {
    id: "5552",
    sura: "75",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ لَا أُقْسِمُ بِيَوْمِ الْقِيَامَةِ",
  },
  {
    id: "5553",
    sura: "75",
    VerseIDAr: "2",
    ayatAR: "وَلَا أُقْسِمُ بِالنَّفْسِ اللَّوَّامَةِ",
  },
  {
    id: "5554",
    sura: "75",
    VerseIDAr: "3",
    ayatAR: "أَيَحْسَبُ الْإِنْسَانُ أَلَّنْ نَجْمَعَ عِظَامَهُ",
  },
  {
    id: "5555",
    sura: "75",
    VerseIDAr: "4",
    ayatAR: "بَلَىٰ قَادِرِينَ عَلَىٰ أَنْ نُسَوِّيَ بَنَانَهُ",
  },
  {
    id: "5556",
    sura: "75",
    VerseIDAr: "5",
    ayatAR: "بَلْ يُرِيدُ الْإِنْسَانُ لِيَفْجُرَ أَمَامَهُ",
  },
  {
    id: "5557",
    sura: "75",
    VerseIDAr: "6",
    ayatAR: "يَسْأَلُ أَيَّانَ يَوْمُ الْقِيَامَةِ",
  },
  {
    id: "5558",
    sura: "75",
    VerseIDAr: "7",
    ayatAR: "فَإِذَا بَرِقَ الْبَصَرُ",
  },
  { id: "5559", sura: "75", VerseIDAr: "8", ayatAR: "وَخَسَفَ الْقَمَرُ" },
  {
    id: "5560",
    sura: "75",
    VerseIDAr: "9",
    ayatAR: "وَجُمِعَ الشَّمْسُ وَالْقَمَرُ",
  },
  {
    id: "5561",
    sura: "75",
    VerseIDAr: "10",
    ayatAR: "يَقُولُ الْإِنْسَانُ يَوْمَئِذٍ أَيْنَ الْمَفَرُّ",
  },
  { id: "5562", sura: "75", VerseIDAr: "11", ayatAR: "كَلَّا لَا وَزَرَ" },
  {
    id: "5563",
    sura: "75",
    VerseIDAr: "12",
    ayatAR: "إِلَىٰ رَبِّكَ يَوْمَئِذٍ الْمُسْتَقَرُّ",
  },
  {
    id: "5564",
    sura: "75",
    VerseIDAr: "13",
    ayatAR: "يُنَبَّأُ الْإِنْسَانُ يَوْمَئِذٍ بِمَا قَدَّمَ وَأَخَّرَ",
  },
  {
    id: "5565",
    sura: "75",
    VerseIDAr: "14",
    ayatAR: "بَلِ الْإِنْسَانُ عَلَىٰ نَفْسِهِ بَصِيرَةٌ",
  },
  {
    id: "5566",
    sura: "75",
    VerseIDAr: "15",
    ayatAR: "وَلَوْ أَلْقَىٰ مَعَاذِيرَهُ",
  },
  {
    id: "5567",
    sura: "75",
    VerseIDAr: "16",
    ayatAR: "لَا تُحَرِّكْ بِهِ لِسَانَكَ لِتَعْجَلَ بِهِ",
  },
  {
    id: "5568",
    sura: "75",
    VerseIDAr: "17",
    ayatAR: "إِنَّ عَلَيْنَا جَمْعَهُ وَقُرْآنَهُ",
  },
  {
    id: "5569",
    sura: "75",
    VerseIDAr: "18",
    ayatAR: "فَإِذَا قَرَأْنَاهُ فَاتَّبِعْ قُرْآنَهُ",
  },
  {
    id: "5570",
    sura: "75",
    VerseIDAr: "19",
    ayatAR: "ثُمَّ إِنَّ عَلَيْنَا بَيَانَهُ",
  },
  {
    id: "5571",
    sura: "75",
    VerseIDAr: "20",
    ayatAR: "كَلَّا بَلْ تُحِبُّونَ الْعَاجِلَةَ",
  },
  { id: "5572", sura: "75", VerseIDAr: "21", ayatAR: "وَتَذَرُونَ الْآخِرَةَ" },
  {
    id: "5573",
    sura: "75",
    VerseIDAr: "22",
    ayatAR: "وُجُوهٌ يَوْمَئِذٍ نَاضِرَةٌ",
  },
  {
    id: "5574",
    sura: "75",
    VerseIDAr: "23",
    ayatAR: "إِلَىٰ رَبِّهَا نَاظِرَةٌ",
  },
  {
    id: "5575",
    sura: "75",
    VerseIDAr: "24",
    ayatAR: "وَوُجُوهٌ يَوْمَئِذٍ بَاسِرَةٌ",
  },
  {
    id: "5576",
    sura: "75",
    VerseIDAr: "25",
    ayatAR: "تَظُنُّ أَنْ يُفْعَلَ بِهَا فَاقِرَةٌ",
  },
  {
    id: "5577",
    sura: "75",
    VerseIDAr: "26",
    ayatAR: "كَلَّا إِذَا بَلَغَتِ التَّرَاقِيَ",
  },
  { id: "5578", sura: "75", VerseIDAr: "27", ayatAR: "وَقِيلَ مَنْ ۜ رَاقٍ" },
  {
    id: "5579",
    sura: "75",
    VerseIDAr: "28",
    ayatAR: "وَظَنَّ أَنَّهُ الْفِرَاقُ",
  },
  {
    id: "5580",
    sura: "75",
    VerseIDAr: "29",
    ayatAR: "وَالْتَفَّتِ السَّاقُ بِالسَّاقِ",
  },
  {
    id: "5581",
    sura: "75",
    VerseIDAr: "30",
    ayatAR: "إِلَىٰ رَبِّكَ يَوْمَئِذٍ الْمَسَاقُ",
  },
  {
    id: "5582",
    sura: "75",
    VerseIDAr: "31",
    ayatAR: "فَلَا صَدَّقَ وَلَا صَلَّىٰ",
  },
  {
    id: "5583",
    sura: "75",
    VerseIDAr: "32",
    ayatAR: "وَلَٰكِنْ كَذَّبَ وَتَوَلَّىٰ",
  },
  {
    id: "5584",
    sura: "75",
    VerseIDAr: "33",
    ayatAR: "ثُمَّ ذَهَبَ إِلَىٰ أَهْلِهِ يَتَمَطَّىٰ",
  },
  {
    id: "5585",
    sura: "75",
    VerseIDAr: "34",
    ayatAR: "أَوْلَىٰ لَكَ فَأَوْلَىٰ",
  },
  {
    id: "5586",
    sura: "75",
    VerseIDAr: "35",
    ayatAR: "ثُمَّ أَوْلَىٰ لَكَ فَأَوْلَىٰ",
  },
  {
    id: "5587",
    sura: "75",
    VerseIDAr: "36",
    ayatAR: "أَيَحْسَبُ الْإِنْسَانُ أَنْ يُتْرَكَ سُدًى",
  },
  {
    id: "5588",
    sura: "75",
    VerseIDAr: "37",
    ayatAR: "أَلَمْ يَكُ نُطْفَةً مِنْ مَنِيٍّ يُمْنَىٰ",
  },
  {
    id: "5589",
    sura: "75",
    VerseIDAr: "38",
    ayatAR: "ثُمَّ كَانَ عَلَقَةً فَخَلَقَ فَسَوَّىٰ",
  },
  {
    id: "5590",
    sura: "75",
    VerseIDAr: "39",
    ayatAR: "فَجَعَلَ مِنْهُ الزَّوْجَيْنِ الذَّكَرَ وَالْأُنْثَىٰ",
  },
  {
    id: "5591",
    sura: "75",
    VerseIDAr: "40",
    ayatAR: "أَلَيْسَ ذَٰلِكَ بِقَادِرٍ عَلَىٰ أَنْ يُحْيِيَ الْمَوْتَىٰ",
  },
  {
    id: "5592",
    sura: "76",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ هَلْ أَتَىٰ عَلَى الْإِنْسَانِ حِينٌ مِنَ الدَّهْرِ لَمْ يَكُنْ شَيْئًا مَذْكُورًا",
  },
  {
    id: "5593",
    sura: "76",
    VerseIDAr: "2",
    ayatAR:
      "إِنَّا خَلَقْنَا الْإِنْسَانَ مِنْ نُطْفَةٍ أَمْشَاجٍ نَبْتَلِيهِ فَجَعَلْنَاهُ سَمِيعًا بَصِيرًا",
  },
  {
    id: "5594",
    sura: "76",
    VerseIDAr: "3",
    ayatAR: "إِنَّا هَدَيْنَاهُ السَّبِيلَ إِمَّا شَاكِرًا وَإِمَّا كَفُورًا",
  },
  {
    id: "5595",
    sura: "76",
    VerseIDAr: "4",
    ayatAR:
      "إِنَّا أَعْتَدْنَا لِلْكَافِرِينَ سَلَاسِلَ وَأَغْلَالًا وَسَعِيرًا",
  },
  {
    id: "5596",
    sura: "76",
    VerseIDAr: "5",
    ayatAR:
      "إِنَّ الْأَبْرَارَ يَشْرَبُونَ مِنْ كَأْسٍ كَانَ مِزَاجُهَا كَافُورًا",
  },
  {
    id: "5597",
    sura: "76",
    VerseIDAr: "6",
    ayatAR: "عَيْنًا يَشْرَبُ بِهَا عِبَادُ اللَّهِ يُفَجِّرُونَهَا تَفْجِيرًا",
  },
  {
    id: "5598",
    sura: "76",
    VerseIDAr: "7",
    ayatAR:
      "يُوفُونَ بِالنَّذْرِ وَيَخَافُونَ يَوْمًا كَانَ شَرُّهُ مُسْتَطِيرًا",
  },
  {
    id: "5599",
    sura: "76",
    VerseIDAr: "8",
    ayatAR:
      "وَيُطْعِمُونَ الطَّعَامَ عَلَىٰ حُبِّهِ مِسْكِينًا وَيَتِيمًا وَأَسِيرًا",
  },
  {
    id: "5600",
    sura: "76",
    VerseIDAr: "9",
    ayatAR:
      "إِنَّمَا نُطْعِمُكُمْ لِوَجْهِ اللَّهِ لَا نُرِيدُ مِنْكُمْ جَزَاءً وَلَا شُكُورًا",
  },
  {
    id: "5601",
    sura: "76",
    VerseIDAr: "10",
    ayatAR: "إِنَّا نَخَافُ مِنْ رَبِّنَا يَوْمًا عَبُوسًا قَمْطَرِيرًا",
  },
  {
    id: "5602",
    sura: "76",
    VerseIDAr: "11",
    ayatAR:
      "فَوَقَاهُمُ اللَّهُ شَرَّ ذَٰلِكَ الْيَوْمِ وَلَقَّاهُمْ نَضْرَةً وَسُرُورًا",
  },
  {
    id: "5603",
    sura: "76",
    VerseIDAr: "12",
    ayatAR: "وَجَزَاهُمْ بِمَا صَبَرُوا جَنَّةً وَحَرِيرًا",
  },
  {
    id: "5604",
    sura: "76",
    VerseIDAr: "13",
    ayatAR:
      "مُتَّكِئِينَ فِيهَا عَلَى الْأَرَائِكِ ۖ لَا يَرَوْنَ فِيهَا شَمْسًا وَلَا زَمْهَرِيرًا",
  },
  {
    id: "5605",
    sura: "76",
    VerseIDAr: "14",
    ayatAR:
      "وَدَانِيَةً عَلَيْهِمْ ظِلَالُهَا وَذُلِّلَتْ قُطُوفُهَا تَذْلِيلًا",
  },
  {
    id: "5606",
    sura: "76",
    VerseIDAr: "15",
    ayatAR:
      "وَيُطَافُ عَلَيْهِمْ بِآنِيَةٍ مِنْ فِضَّةٍ وَأَكْوَابٍ كَانَتْ قَوَارِيرَا",
  },
  {
    id: "5607",
    sura: "76",
    VerseIDAr: "16",
    ayatAR: "قَوَارِيرَ مِنْ فِضَّةٍ قَدَّرُوهَا تَقْدِيرًا",
  },
  {
    id: "5608",
    sura: "76",
    VerseIDAr: "17",
    ayatAR: "وَيُسْقَوْنَ فِيهَا كَأْسًا كَانَ مِزَاجُهَا زَنْجَبِيلًا",
  },
  {
    id: "5609",
    sura: "76",
    VerseIDAr: "18",
    ayatAR: "عَيْنًا فِيهَا تُسَمَّىٰ سَلْسَبِيلًا",
  },
  {
    id: "5610",
    sura: "76",
    VerseIDAr: "19",
    ayatAR:
      "وَيَطُوفُ عَلَيْهِمْ وِلْدَانٌ مُخَلَّدُونَ إِذَا رَأَيْتَهُمْ حَسِبْتَهُمْ لُؤْلُؤًا مَنْثُورًا",
  },
  {
    id: "5611",
    sura: "76",
    VerseIDAr: "20",
    ayatAR: "وَإِذَا رَأَيْتَ ثَمَّ رَأَيْتَ نَعِيمًا وَمُلْكًا كَبِيرًا",
  },
  {
    id: "5612",
    sura: "76",
    VerseIDAr: "21",
    ayatAR:
      "عَالِيَهُمْ ثِيَابُ سُنْدُسٍ خُضْرٌ وَإِسْتَبْرَقٌ ۖ وَحُلُّوا أَسَاوِرَ مِنْ فِضَّةٍ وَسَقَاهُمْ رَبُّهُمْ شَرَابًا طَهُورًا",
  },
  {
    id: "5613",
    sura: "76",
    VerseIDAr: "22",
    ayatAR: "إِنَّ هَٰذَا كَانَ لَكُمْ جَزَاءً وَكَانَ سَعْيُكُمْ مَشْكُورًا",
  },
  {
    id: "5614",
    sura: "76",
    VerseIDAr: "23",
    ayatAR: "إِنَّا نَحْنُ نَزَّلْنَا عَلَيْكَ الْقُرْآنَ تَنْزِيلًا",
  },
  {
    id: "5615",
    sura: "76",
    VerseIDAr: "24",
    ayatAR:
      "فَاصْبِرْ لِحُكْمِ رَبِّكَ وَلَا تُطِعْ مِنْهُمْ آثِمًا أَوْ كَفُورًا",
  },
  {
    id: "5616",
    sura: "76",
    VerseIDAr: "25",
    ayatAR: "وَاذْكُرِ اسْمَ رَبِّكَ بُكْرَةً وَأَصِيلًا",
  },
  {
    id: "5617",
    sura: "76",
    VerseIDAr: "26",
    ayatAR: "وَمِنَ اللَّيْلِ فَاسْجُدْ لَهُ وَسَبِّحْهُ لَيْلًا طَوِيلًا",
  },
  {
    id: "5618",
    sura: "76",
    VerseIDAr: "27",
    ayatAR:
      "إِنَّ هَٰؤُلَاءِ يُحِبُّونَ الْعَاجِلَةَ وَيَذَرُونَ وَرَاءَهُمْ يَوْمًا ثَقِيلًا",
  },
  {
    id: "5619",
    sura: "76",
    VerseIDAr: "28",
    ayatAR:
      "نَحْنُ خَلَقْنَاهُمْ وَشَدَدْنَا أَسْرَهُمْ ۖ وَإِذَا شِئْنَا بَدَّلْنَا أَمْثَالَهُمْ تَبْدِيلًا",
  },
  {
    id: "5620",
    sura: "76",
    VerseIDAr: "29",
    ayatAR:
      "إِنَّ هَٰذِهِ تَذْكِرَةٌ ۖ فَمَنْ شَاءَ اتَّخَذَ إِلَىٰ رَبِّهِ سَبِيلًا",
  },
  {
    id: "5621",
    sura: "76",
    VerseIDAr: "30",
    ayatAR:
      "وَمَا تَشَاءُونَ إِلَّا أَنْ يَشَاءَ اللَّهُ ۚ إِنَّ اللَّهَ كَانَ عَلِيمًا حَكِيمًا",
  },
  {
    id: "5622",
    sura: "76",
    VerseIDAr: "31",
    ayatAR:
      "يُدْخِلُ مَنْ يَشَاءُ فِي رَحْمَتِهِ ۚ وَالظَّالِمِينَ أَعَدَّ لَهُمْ عَذَابًا أَلِيمًا",
  },
  {
    id: "5623",
    sura: "77",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالْمُرْسَلَاتِ عُرْفًا",
  },
  { id: "5624", sura: "77", VerseIDAr: "2", ayatAR: "فَالْعَاصِفَاتِ عَصْفًا" },
  { id: "5625", sura: "77", VerseIDAr: "3", ayatAR: "وَالنَّاشِرَاتِ نَشْرًا" },
  { id: "5626", sura: "77", VerseIDAr: "4", ayatAR: "فَالْفَارِقَاتِ فَرْقًا" },
  {
    id: "5627",
    sura: "77",
    VerseIDAr: "5",
    ayatAR: "فَالْمُلْقِيَاتِ ذِكْرًا",
  },
  { id: "5628", sura: "77", VerseIDAr: "6", ayatAR: "عُذْرًا أَوْ نُذْرًا" },
  {
    id: "5629",
    sura: "77",
    VerseIDAr: "7",
    ayatAR: "إِنَّمَا تُوعَدُونَ لَوَاقِعٌ",
  },
  {
    id: "5630",
    sura: "77",
    VerseIDAr: "8",
    ayatAR: "فَإِذَا النُّجُومُ طُمِسَتْ",
  },
  {
    id: "5631",
    sura: "77",
    VerseIDAr: "9",
    ayatAR: "وَإِذَا السَّمَاءُ فُرِجَتْ",
  },
  {
    id: "5632",
    sura: "77",
    VerseIDAr: "10",
    ayatAR: "وَإِذَا الْجِبَالُ نُسِفَتْ",
  },
  {
    id: "5633",
    sura: "77",
    VerseIDAr: "11",
    ayatAR: "وَإِذَا الرُّسُلُ أُقِّتَتْ",
  },
  {
    id: "5634",
    sura: "77",
    VerseIDAr: "12",
    ayatAR: "لِأَيِّ يَوْمٍ أُجِّلَتْ",
  },
  { id: "5635", sura: "77", VerseIDAr: "13", ayatAR: "لِيَوْمِ الْفَصْلِ" },
  {
    id: "5636",
    sura: "77",
    VerseIDAr: "14",
    ayatAR: "وَمَا أَدْرَاكَ مَا يَوْمُ الْفَصْلِ",
  },
  {
    id: "5637",
    sura: "77",
    VerseIDAr: "15",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5638",
    sura: "77",
    VerseIDAr: "16",
    ayatAR: "أَلَمْ نُهْلِكِ الْأَوَّلِينَ",
  },
  {
    id: "5639",
    sura: "77",
    VerseIDAr: "17",
    ayatAR: "ثُمَّ نُتْبِعُهُمُ الْآخِرِينَ",
  },
  {
    id: "5640",
    sura: "77",
    VerseIDAr: "18",
    ayatAR: "كَذَٰلِكَ نَفْعَلُ بِالْمُجْرِمِينَ",
  },
  {
    id: "5641",
    sura: "77",
    VerseIDAr: "19",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5642",
    sura: "77",
    VerseIDAr: "20",
    ayatAR: "أَلَمْ نَخْلُقْكُمْ مِنْ مَاءٍ مَهِينٍ",
  },
  {
    id: "5643",
    sura: "77",
    VerseIDAr: "21",
    ayatAR: "فَجَعَلْنَاهُ فِي قَرَارٍ مَكِينٍ",
  },
  {
    id: "5644",
    sura: "77",
    VerseIDAr: "22",
    ayatAR: "إِلَىٰ قَدَرٍ مَعْلُومٍ",
  },
  {
    id: "5645",
    sura: "77",
    VerseIDAr: "23",
    ayatAR: "فَقَدَرْنَا فَنِعْمَ الْقَادِرُونَ",
  },
  {
    id: "5646",
    sura: "77",
    VerseIDAr: "24",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5647",
    sura: "77",
    VerseIDAr: "25",
    ayatAR: "أَلَمْ نَجْعَلِ الْأَرْضَ كِفَاتًا",
  },
  { id: "5648", sura: "77", VerseIDAr: "26", ayatAR: "أَحْيَاءً وَأَمْوَاتًا" },
  {
    id: "5649",
    sura: "77",
    VerseIDAr: "27",
    ayatAR:
      "وَجَعَلْنَا فِيهَا رَوَاسِيَ شَامِخَاتٍ وَأَسْقَيْنَاكُمْ مَاءً فُرَاتًا",
  },
  {
    id: "5650",
    sura: "77",
    VerseIDAr: "28",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5651",
    sura: "77",
    VerseIDAr: "29",
    ayatAR: "انْطَلِقُوا إِلَىٰ مَا كُنْتُمْ بِهِ تُكَذِّبُونَ",
  },
  {
    id: "5652",
    sura: "77",
    VerseIDAr: "30",
    ayatAR: "انْطَلِقُوا إِلَىٰ ظِلٍّ ذِي ثَلَاثِ شُعَبٍ",
  },
  {
    id: "5653",
    sura: "77",
    VerseIDAr: "31",
    ayatAR: "لَا ظَلِيلٍ وَلَا يُغْنِي مِنَ اللَّهَبِ",
  },
  {
    id: "5654",
    sura: "77",
    VerseIDAr: "32",
    ayatAR: "إِنَّهَا تَرْمِي بِشَرَرٍ كَالْقَصْرِ",
  },
  {
    id: "5655",
    sura: "77",
    VerseIDAr: "33",
    ayatAR: "كَأَنَّهُ جِمَالَتٌ صُفْرٌ",
  },
  {
    id: "5656",
    sura: "77",
    VerseIDAr: "34",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5657",
    sura: "77",
    VerseIDAr: "35",
    ayatAR: "هَٰذَا يَوْمُ لَا يَنْطِقُونَ",
  },
  {
    id: "5658",
    sura: "77",
    VerseIDAr: "36",
    ayatAR: "وَلَا يُؤْذَنُ لَهُمْ فَيَعْتَذِرُونَ",
  },
  {
    id: "5659",
    sura: "77",
    VerseIDAr: "37",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5660",
    sura: "77",
    VerseIDAr: "38",
    ayatAR: "هَٰذَا يَوْمُ الْفَصْلِ ۖ جَمَعْنَاكُمْ وَالْأَوَّلِينَ",
  },
  {
    id: "5661",
    sura: "77",
    VerseIDAr: "39",
    ayatAR: "فَإِنْ كَانَ لَكُمْ كَيْدٌ فَكِيدُونِ",
  },
  {
    id: "5662",
    sura: "77",
    VerseIDAr: "40",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5663",
    sura: "77",
    VerseIDAr: "41",
    ayatAR: "إِنَّ الْمُتَّقِينَ فِي ظِلَالٍ وَعُيُونٍ",
  },
  {
    id: "5664",
    sura: "77",
    VerseIDAr: "42",
    ayatAR: "وَفَوَاكِهَ مِمَّا يَشْتَهُونَ",
  },
  {
    id: "5665",
    sura: "77",
    VerseIDAr: "43",
    ayatAR: "كُلُوا وَاشْرَبُوا هَنِيئًا بِمَا كُنْتُمْ تَعْمَلُونَ",
  },
  {
    id: "5666",
    sura: "77",
    VerseIDAr: "44",
    ayatAR: "إِنَّا كَذَٰلِكَ نَجْزِي الْمُحْسِنِينَ",
  },
  {
    id: "5667",
    sura: "77",
    VerseIDAr: "45",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5668",
    sura: "77",
    VerseIDAr: "46",
    ayatAR: "كُلُوا وَتَمَتَّعُوا قَلِيلًا إِنَّكُمْ مُجْرِمُونَ",
  },
  {
    id: "5669",
    sura: "77",
    VerseIDAr: "47",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5670",
    sura: "77",
    VerseIDAr: "48",
    ayatAR: "وَإِذَا قِيلَ لَهُمُ ارْكَعُوا لَا يَرْكَعُونَ",
  },
  {
    id: "5671",
    sura: "77",
    VerseIDAr: "49",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5672",
    sura: "77",
    VerseIDAr: "50",
    ayatAR: "فَبِأَيِّ حَدِيثٍ بَعْدَهُ يُؤْمِنُونَ",
  },
  {
    id: "5673",
    sura: "78",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ عَمَّ يَتَسَاءَلُونَ",
  },
  {
    id: "5674",
    sura: "78",
    VerseIDAr: "2",
    ayatAR: "عَنِ النَّبَإِ الْعَظِيمِ",
  },
  {
    id: "5675",
    sura: "78",
    VerseIDAr: "3",
    ayatAR: "الَّذِي هُمْ فِيهِ مُخْتَلِفُونَ",
  },
  { id: "5676", sura: "78", VerseIDAr: "4", ayatAR: "كَلَّا سَيَعْلَمُونَ" },
  {
    id: "5677",
    sura: "78",
    VerseIDAr: "5",
    ayatAR: "ثُمَّ كَلَّا سَيَعْلَمُونَ",
  },
  {
    id: "5678",
    sura: "78",
    VerseIDAr: "6",
    ayatAR: "أَلَمْ نَجْعَلِ الْأَرْضَ مِهَادًا",
  },
  { id: "5679", sura: "78", VerseIDAr: "7", ayatAR: "وَالْجِبَالَ أَوْتَادًا" },
  {
    id: "5680",
    sura: "78",
    VerseIDAr: "8",
    ayatAR: "وَخَلَقْنَاكُمْ أَزْوَاجًا",
  },
  {
    id: "5681",
    sura: "78",
    VerseIDAr: "9",
    ayatAR: "وَجَعَلْنَا نَوْمَكُمْ سُبَاتًا",
  },
  {
    id: "5682",
    sura: "78",
    VerseIDAr: "10",
    ayatAR: "وَجَعَلْنَا اللَّيْلَ لِبَاسًا",
  },
  {
    id: "5683",
    sura: "78",
    VerseIDAr: "11",
    ayatAR: "وَجَعَلْنَا النَّهَارَ مَعَاشًا",
  },
  {
    id: "5684",
    sura: "78",
    VerseIDAr: "12",
    ayatAR: "وَبَنَيْنَا فَوْقَكُمْ سَبْعًا شِدَادًا",
  },
  {
    id: "5685",
    sura: "78",
    VerseIDAr: "13",
    ayatAR: "وَجَعَلْنَا سِرَاجًا وَهَّاجًا",
  },
  {
    id: "5686",
    sura: "78",
    VerseIDAr: "14",
    ayatAR: "وَأَنْزَلْنَا مِنَ الْمُعْصِرَاتِ مَاءً ثَجَّاجًا",
  },
  {
    id: "5687",
    sura: "78",
    VerseIDAr: "15",
    ayatAR: "لِنُخْرِجَ بِهِ حَبًّا وَنَبَاتًا",
  },
  { id: "5688", sura: "78", VerseIDAr: "16", ayatAR: "وَجَنَّاتٍ أَلْفَافًا" },
  {
    id: "5689",
    sura: "78",
    VerseIDAr: "17",
    ayatAR: "إِنَّ يَوْمَ الْفَصْلِ كَانَ مِيقَاتًا",
  },
  {
    id: "5690",
    sura: "78",
    VerseIDAr: "18",
    ayatAR: "يَوْمَ يُنْفَخُ فِي الصُّورِ فَتَأْتُونَ أَفْوَاجًا",
  },
  {
    id: "5691",
    sura: "78",
    VerseIDAr: "19",
    ayatAR: "وَفُتِحَتِ السَّمَاءُ فَكَانَتْ أَبْوَابًا",
  },
  {
    id: "5692",
    sura: "78",
    VerseIDAr: "20",
    ayatAR: "وَسُيِّرَتِ الْجِبَالُ فَكَانَتْ سَرَابًا",
  },
  {
    id: "5693",
    sura: "78",
    VerseIDAr: "21",
    ayatAR: "إِنَّ جَهَنَّمَ كَانَتْ مِرْصَادًا",
  },
  { id: "5694", sura: "78", VerseIDAr: "22", ayatAR: "لِلطَّاغِينَ مَآبًا" },
  {
    id: "5695",
    sura: "78",
    VerseIDAr: "23",
    ayatAR: "لَابِثِينَ فِيهَا أَحْقَابًا",
  },
  {
    id: "5696",
    sura: "78",
    VerseIDAr: "24",
    ayatAR: "لَا يَذُوقُونَ فِيهَا بَرْدًا وَلَا شَرَابًا",
  },
  {
    id: "5697",
    sura: "78",
    VerseIDAr: "25",
    ayatAR: "إِلَّا حَمِيمًا وَغَسَّاقًا",
  },
  { id: "5698", sura: "78", VerseIDAr: "26", ayatAR: "جَزَاءً وِفَاقًا" },
  {
    id: "5699",
    sura: "78",
    VerseIDAr: "27",
    ayatAR: "إِنَّهُمْ كَانُوا لَا يَرْجُونَ حِسَابًا",
  },
  {
    id: "5700",
    sura: "78",
    VerseIDAr: "28",
    ayatAR: "وَكَذَّبُوا بِآيَاتِنَا كِذَّابًا",
  },
  {
    id: "5701",
    sura: "78",
    VerseIDAr: "29",
    ayatAR: "وَكُلَّ شَيْءٍ أَحْصَيْنَاهُ كِتَابًا",
  },
  {
    id: "5702",
    sura: "78",
    VerseIDAr: "30",
    ayatAR: "فَذُوقُوا فَلَنْ نَزِيدَكُمْ إِلَّا عَذَابًا",
  },
  {
    id: "5703",
    sura: "78",
    VerseIDAr: "31",
    ayatAR: "إِنَّ لِلْمُتَّقِينَ مَفَازًا",
  },
  { id: "5704", sura: "78", VerseIDAr: "32", ayatAR: "حَدَائِقَ وَأَعْنَابًا" },
  { id: "5705", sura: "78", VerseIDAr: "33", ayatAR: "وَكَوَاعِبَ أَتْرَابًا" },
  { id: "5706", sura: "78", VerseIDAr: "34", ayatAR: "وَكَأْسًا دِهَاقًا" },
  {
    id: "5707",
    sura: "78",
    VerseIDAr: "35",
    ayatAR: "لَا يَسْمَعُونَ فِيهَا لَغْوًا وَلَا كِذَّابًا",
  },
  {
    id: "5708",
    sura: "78",
    VerseIDAr: "36",
    ayatAR: "جَزَاءً مِنْ رَبِّكَ عَطَاءً حِسَابًا",
  },
  {
    id: "5709",
    sura: "78",
    VerseIDAr: "37",
    ayatAR:
      "رَبِّ السَّمَاوَاتِ وَالْأَرْضِ وَمَا بَيْنَهُمَا الرَّحْمَٰنِ ۖ لَا يَمْلِكُونَ مِنْهُ خِطَابًا",
  },
  {
    id: "5710",
    sura: "78",
    VerseIDAr: "38",
    ayatAR:
      "يَوْمَ يَقُومُ الرُّوحُ وَالْمَلَائِكَةُ صَفًّا ۖ لَا يَتَكَلَّمُونَ إِلَّا مَنْ أَذِنَ لَهُ الرَّحْمَٰنُ وَقَالَ صَوَابًا",
  },
  {
    id: "5711",
    sura: "78",
    VerseIDAr: "39",
    ayatAR:
      "ذَٰلِكَ الْيَوْمُ الْحَقُّ ۖ فَمَنْ شَاءَ اتَّخَذَ إِلَىٰ رَبِّهِ مَآبًا",
  },
  {
    id: "5712",
    sura: "78",
    VerseIDAr: "40",
    ayatAR:
      "إِنَّا أَنْذَرْنَاكُمْ عَذَابًا قَرِيبًا يَوْمَ يَنْظُرُ الْمَرْءُ مَا قَدَّمَتْ يَدَاهُ وَيَقُولُ الْكَافِرُ يَا لَيْتَنِي كُنْتُ تُرَابًا",
  },
  {
    id: "5713",
    sura: "79",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالنَّازِعَاتِ غَرْقًا",
  },
  { id: "5714", sura: "79", VerseIDAr: "2", ayatAR: "وَالنَّاشِطَاتِ نَشْطًا" },
  { id: "5715", sura: "79", VerseIDAr: "3", ayatAR: "وَالسَّابِحَاتِ سَبْحًا" },
  { id: "5716", sura: "79", VerseIDAr: "4", ayatAR: "فَالسَّابِقَاتِ سَبْقًا" },
  {
    id: "5717",
    sura: "79",
    VerseIDAr: "5",
    ayatAR: "فَالْمُدَبِّرَاتِ أَمْرًا",
  },
  {
    id: "5718",
    sura: "79",
    VerseIDAr: "6",
    ayatAR: "يَوْمَ تَرْجُفُ الرَّاجِفَةُ",
  },
  {
    id: "5719",
    sura: "79",
    VerseIDAr: "7",
    ayatAR: "تَتْبَعُهَا الرَّادِفَةُ",
  },
  {
    id: "5720",
    sura: "79",
    VerseIDAr: "8",
    ayatAR: "قُلُوبٌ يَوْمَئِذٍ وَاجِفَةٌ",
  },
  { id: "5721", sura: "79", VerseIDAr: "9", ayatAR: "أَبْصَارُهَا خَاشِعَةٌ" },
  {
    id: "5722",
    sura: "79",
    VerseIDAr: "10",
    ayatAR: "يَقُولُونَ أَإِنَّا لَمَرْدُودُونَ فِي الْحَافِرَةِ",
  },
  {
    id: "5723",
    sura: "79",
    VerseIDAr: "11",
    ayatAR: "أَإِذَا كُنَّا عِظَامًا نَخِرَةً",
  },
  {
    id: "5724",
    sura: "79",
    VerseIDAr: "12",
    ayatAR: "قَالُوا تِلْكَ إِذًا كَرَّةٌ خَاسِرَةٌ",
  },
  {
    id: "5725",
    sura: "79",
    VerseIDAr: "13",
    ayatAR: "فَإِنَّمَا هِيَ زَجْرَةٌ وَاحِدَةٌ",
  },
  {
    id: "5726",
    sura: "79",
    VerseIDAr: "14",
    ayatAR: "فَإِذَا هُمْ بِالسَّاهِرَةِ",
  },
  {
    id: "5727",
    sura: "79",
    VerseIDAr: "15",
    ayatAR: "هَلْ أَتَاكَ حَدِيثُ مُوسَىٰ",
  },
  {
    id: "5728",
    sura: "79",
    VerseIDAr: "16",
    ayatAR: "إِذْ نَادَاهُ رَبُّهُ بِالْوَادِ الْمُقَدَّسِ طُوًى",
  },
  {
    id: "5729",
    sura: "79",
    VerseIDAr: "17",
    ayatAR: "اذْهَبْ إِلَىٰ فِرْعَوْنَ إِنَّهُ طَغَىٰ",
  },
  {
    id: "5730",
    sura: "79",
    VerseIDAr: "18",
    ayatAR: "فَقُلْ هَلْ لَكَ إِلَىٰ أَنْ تَزَكَّىٰ",
  },
  {
    id: "5731",
    sura: "79",
    VerseIDAr: "19",
    ayatAR: "وَأَهْدِيَكَ إِلَىٰ رَبِّكَ فَتَخْشَىٰ",
  },
  {
    id: "5732",
    sura: "79",
    VerseIDAr: "20",
    ayatAR: "فَأَرَاهُ الْآيَةَ الْكُبْرَىٰ",
  },
  { id: "5733", sura: "79", VerseIDAr: "21", ayatAR: "فَكَذَّبَ وَعَصَىٰ" },
  {
    id: "5734",
    sura: "79",
    VerseIDAr: "22",
    ayatAR: "ثُمَّ أَدْبَرَ يَسْعَىٰ",
  },
  { id: "5735", sura: "79", VerseIDAr: "23", ayatAR: "فَحَشَرَ فَنَادَىٰ" },
  {
    id: "5736",
    sura: "79",
    VerseIDAr: "24",
    ayatAR: "فَقَالَ أَنَا رَبُّكُمُ الْأَعْلَىٰ",
  },
  {
    id: "5737",
    sura: "79",
    VerseIDAr: "25",
    ayatAR: "فَأَخَذَهُ اللَّهُ نَكَالَ الْآخِرَةِ وَالْأُولَىٰ",
  },
  {
    id: "5738",
    sura: "79",
    VerseIDAr: "26",
    ayatAR: "إِنَّ فِي ذَٰلِكَ لَعِبْرَةً لِمَنْ يَخْشَىٰ",
  },
  {
    id: "5739",
    sura: "79",
    VerseIDAr: "27",
    ayatAR: "أَأَنْتُمْ أَشَدُّ خَلْقًا أَمِ السَّمَاءُ ۚ بَنَاهَا",
  },
  {
    id: "5740",
    sura: "79",
    VerseIDAr: "28",
    ayatAR: "رَفَعَ سَمْكَهَا فَسَوَّاهَا",
  },
  {
    id: "5741",
    sura: "79",
    VerseIDAr: "29",
    ayatAR: "وَأَغْطَشَ لَيْلَهَا وَأَخْرَجَ ضُحَاهَا",
  },
  {
    id: "5742",
    sura: "79",
    VerseIDAr: "30",
    ayatAR: "وَالْأَرْضَ بَعْدَ ذَٰلِكَ دَحَاهَا",
  },
  {
    id: "5743",
    sura: "79",
    VerseIDAr: "31",
    ayatAR: "أَخْرَجَ مِنْهَا مَاءَهَا وَمَرْعَاهَا",
  },
  {
    id: "5744",
    sura: "79",
    VerseIDAr: "32",
    ayatAR: "وَالْجِبَالَ أَرْسَاهَا",
  },
  {
    id: "5745",
    sura: "79",
    VerseIDAr: "33",
    ayatAR: "مَتَاعًا لَكُمْ وَلِأَنْعَامِكُمْ",
  },
  {
    id: "5746",
    sura: "79",
    VerseIDAr: "34",
    ayatAR: "فَإِذَا جَاءَتِ الطَّامَّةُ الْكُبْرَىٰ",
  },
  {
    id: "5747",
    sura: "79",
    VerseIDAr: "35",
    ayatAR: "يَوْمَ يَتَذَكَّرُ الْإِنْسَانُ مَا سَعَىٰ",
  },
  {
    id: "5748",
    sura: "79",
    VerseIDAr: "36",
    ayatAR: "وَبُرِّزَتِ الْجَحِيمُ لِمَنْ يَرَىٰ",
  },
  { id: "5749", sura: "79", VerseIDAr: "37", ayatAR: "فَأَمَّا مَنْ طَغَىٰ" },
  {
    id: "5750",
    sura: "79",
    VerseIDAr: "38",
    ayatAR: "وَآثَرَ الْحَيَاةَ الدُّنْيَا",
  },
  {
    id: "5751",
    sura: "79",
    VerseIDAr: "39",
    ayatAR: "فَإِنَّ الْجَحِيمَ هِيَ الْمَأْوَىٰ",
  },
  {
    id: "5752",
    sura: "79",
    VerseIDAr: "40",
    ayatAR:
      "وَأَمَّا مَنْ خَافَ مَقَامَ رَبِّهِ وَنَهَى النَّفْسَ عَنِ الْهَوَىٰ",
  },
  {
    id: "5753",
    sura: "79",
    VerseIDAr: "41",
    ayatAR: "فَإِنَّ الْجَنَّةَ هِيَ الْمَأْوَىٰ",
  },
  {
    id: "5754",
    sura: "79",
    VerseIDAr: "42",
    ayatAR: "يَسْأَلُونَكَ عَنِ السَّاعَةِ أَيَّانَ مُرْسَاهَا",
  },
  {
    id: "5755",
    sura: "79",
    VerseIDAr: "43",
    ayatAR: "فِيمَ أَنْتَ مِنْ ذِكْرَاهَا",
  },
  {
    id: "5756",
    sura: "79",
    VerseIDAr: "44",
    ayatAR: "إِلَىٰ رَبِّكَ مُنْتَهَاهَا",
  },
  {
    id: "5757",
    sura: "79",
    VerseIDAr: "45",
    ayatAR: "إِنَّمَا أَنْتَ مُنْذِرُ مَنْ يَخْشَاهَا",
  },
  {
    id: "5758",
    sura: "79",
    VerseIDAr: "46",
    ayatAR:
      "كَأَنَّهُمْ يَوْمَ يَرَوْنَهَا لَمْ يَلْبَثُوا إِلَّا عَشِيَّةً أَوْ ضُحَاهَا",
  },
  {
    id: "5759",
    sura: "80",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ عَبَسَ وَتَوَلَّىٰ",
  },
  {
    id: "5760",
    sura: "80",
    VerseIDAr: "2",
    ayatAR: "أَنْ جَاءَهُ الْأَعْمَىٰ",
  },
  {
    id: "5761",
    sura: "80",
    VerseIDAr: "3",
    ayatAR: "وَمَا يُدْرِيكَ لَعَلَّهُ يَزَّكَّىٰ",
  },
  {
    id: "5762",
    sura: "80",
    VerseIDAr: "4",
    ayatAR: "أَوْ يَذَّكَّرُ فَتَنْفَعَهُ الذِّكْرَىٰ",
  },
  { id: "5763", sura: "80", VerseIDAr: "5", ayatAR: "أَمَّا مَنِ اسْتَغْنَىٰ" },
  { id: "5764", sura: "80", VerseIDAr: "6", ayatAR: "فَأَنْتَ لَهُ تَصَدَّىٰ" },
  {
    id: "5765",
    sura: "80",
    VerseIDAr: "7",
    ayatAR: "وَمَا عَلَيْكَ أَلَّا يَزَّكَّىٰ",
  },
  {
    id: "5766",
    sura: "80",
    VerseIDAr: "8",
    ayatAR: "وَأَمَّا مَنْ جَاءَكَ يَسْعَىٰ",
  },
  { id: "5767", sura: "80", VerseIDAr: "9", ayatAR: "وَهُوَ يَخْشَىٰ" },
  {
    id: "5768",
    sura: "80",
    VerseIDAr: "10",
    ayatAR: "فَأَنْتَ عَنْهُ تَلَهَّىٰ",
  },
  {
    id: "5769",
    sura: "80",
    VerseIDAr: "11",
    ayatAR: "كَلَّا إِنَّهَا تَذْكِرَةٌ",
  },
  { id: "5770", sura: "80", VerseIDAr: "12", ayatAR: "فَمَنْ شَاءَ ذَكَرَهُ" },
  { id: "5771", sura: "80", VerseIDAr: "13", ayatAR: "فِي صُحُفٍ مُكَرَّمَةٍ" },
  {
    id: "5772",
    sura: "80",
    VerseIDAr: "14",
    ayatAR: "مَرْفُوعَةٍ مُطَهَّرَةٍ",
  },
  { id: "5773", sura: "80", VerseIDAr: "15", ayatAR: "بِأَيْدِي سَفَرَةٍ" },
  { id: "5774", sura: "80", VerseIDAr: "16", ayatAR: "كِرَامٍ بَرَرَةٍ" },
  {
    id: "5775",
    sura: "80",
    VerseIDAr: "17",
    ayatAR: "قُتِلَ الْإِنْسَانُ مَا أَكْفَرَهُ",
  },
  {
    id: "5776",
    sura: "80",
    VerseIDAr: "18",
    ayatAR: "مِنْ أَيِّ شَيْءٍ خَلَقَهُ",
  },
  {
    id: "5777",
    sura: "80",
    VerseIDAr: "19",
    ayatAR: "مِنْ نُطْفَةٍ خَلَقَهُ فَقَدَّرَهُ",
  },
  {
    id: "5778",
    sura: "80",
    VerseIDAr: "20",
    ayatAR: "ثُمَّ السَّبِيلَ يَسَّرَهُ",
  },
  {
    id: "5779",
    sura: "80",
    VerseIDAr: "21",
    ayatAR: "ثُمَّ أَمَاتَهُ فَأَقْبَرَهُ",
  },
  {
    id: "5780",
    sura: "80",
    VerseIDAr: "22",
    ayatAR: "ثُمَّ إِذَا شَاءَ أَنْشَرَهُ",
  },
  {
    id: "5781",
    sura: "80",
    VerseIDAr: "23",
    ayatAR: "كَلَّا لَمَّا يَقْضِ مَا أَمَرَهُ",
  },
  {
    id: "5782",
    sura: "80",
    VerseIDAr: "24",
    ayatAR: "فَلْيَنْظُرِ الْإِنْسَانُ إِلَىٰ طَعَامِهِ",
  },
  {
    id: "5783",
    sura: "80",
    VerseIDAr: "25",
    ayatAR: "أَنَّا صَبَبْنَا الْمَاءَ صَبًّا",
  },
  {
    id: "5784",
    sura: "80",
    VerseIDAr: "26",
    ayatAR: "ثُمَّ شَقَقْنَا الْأَرْضَ شَقًّا",
  },
  {
    id: "5785",
    sura: "80",
    VerseIDAr: "27",
    ayatAR: "فَأَنْبَتْنَا فِيهَا حَبًّا",
  },
  { id: "5786", sura: "80", VerseIDAr: "28", ayatAR: "وَعِنَبًا وَقَضْبًا" },
  { id: "5787", sura: "80", VerseIDAr: "29", ayatAR: "وَزَيْتُونًا وَنَخْلًا" },
  { id: "5788", sura: "80", VerseIDAr: "30", ayatAR: "وَحَدَائِقَ غُلْبًا" },
  { id: "5789", sura: "80", VerseIDAr: "31", ayatAR: "وَفَاكِهَةً وَأَبًّا" },
  {
    id: "5790",
    sura: "80",
    VerseIDAr: "32",
    ayatAR: "مَتَاعًا لَكُمْ وَلِأَنْعَامِكُمْ",
  },
  {
    id: "5791",
    sura: "80",
    VerseIDAr: "33",
    ayatAR: "فَإِذَا جَاءَتِ الصَّاخَّةُ",
  },
  {
    id: "5792",
    sura: "80",
    VerseIDAr: "34",
    ayatAR: "يَوْمَ يَفِرُّ الْمَرْءُ مِنْ أَخِيهِ",
  },
  { id: "5793", sura: "80", VerseIDAr: "35", ayatAR: "وَأُمِّهِ وَأَبِيهِ" },
  {
    id: "5794",
    sura: "80",
    VerseIDAr: "36",
    ayatAR: "وَصَاحِبَتِهِ وَبَنِيهِ",
  },
  {
    id: "5795",
    sura: "80",
    VerseIDAr: "37",
    ayatAR: "لِكُلِّ امْرِئٍ مِنْهُمْ يَوْمَئِذٍ شَأْنٌ يُغْنِيهِ",
  },
  {
    id: "5796",
    sura: "80",
    VerseIDAr: "38",
    ayatAR: "وُجُوهٌ يَوْمَئِذٍ مُسْفِرَةٌ",
  },
  {
    id: "5797",
    sura: "80",
    VerseIDAr: "39",
    ayatAR: "ضَاحِكَةٌ مُسْتَبْشِرَةٌ",
  },
  {
    id: "5798",
    sura: "80",
    VerseIDAr: "40",
    ayatAR: "وَوُجُوهٌ يَوْمَئِذٍ عَلَيْهَا غَبَرَةٌ",
  },
  { id: "5799", sura: "80", VerseIDAr: "41", ayatAR: "تَرْهَقُهَا قَتَرَةٌ" },
  {
    id: "5800",
    sura: "80",
    VerseIDAr: "42",
    ayatAR: "أُولَٰئِكَ هُمُ الْكَفَرَةُ الْفَجَرَةُ",
  },
  {
    id: "5801",
    sura: "81",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا الشَّمْسُ كُوِّرَتْ",
  },
  {
    id: "5802",
    sura: "81",
    VerseIDAr: "2",
    ayatAR: "وَإِذَا النُّجُومُ انْكَدَرَتْ",
  },
  {
    id: "5803",
    sura: "81",
    VerseIDAr: "3",
    ayatAR: "وَإِذَا الْجِبَالُ سُيِّرَتْ",
  },
  {
    id: "5804",
    sura: "81",
    VerseIDAr: "4",
    ayatAR: "وَإِذَا الْعِشَارُ عُطِّلَتْ",
  },
  {
    id: "5805",
    sura: "81",
    VerseIDAr: "5",
    ayatAR: "وَإِذَا الْوُحُوشُ حُشِرَتْ",
  },
  {
    id: "5806",
    sura: "81",
    VerseIDAr: "6",
    ayatAR: "وَإِذَا الْبِحَارُ سُجِّرَتْ",
  },
  {
    id: "5807",
    sura: "81",
    VerseIDAr: "7",
    ayatAR: "وَإِذَا النُّفُوسُ زُوِّجَتْ",
  },
  {
    id: "5808",
    sura: "81",
    VerseIDAr: "8",
    ayatAR: "وَإِذَا الْمَوْءُودَةُ سُئِلَتْ",
  },
  { id: "5809", sura: "81", VerseIDAr: "9", ayatAR: "بِأَيِّ ذَنْبٍ قُتِلَتْ" },
  {
    id: "5810",
    sura: "81",
    VerseIDAr: "10",
    ayatAR: "وَإِذَا الصُّحُفُ نُشِرَتْ",
  },
  {
    id: "5811",
    sura: "81",
    VerseIDAr: "11",
    ayatAR: "وَإِذَا السَّمَاءُ كُشِطَتْ",
  },
  {
    id: "5812",
    sura: "81",
    VerseIDAr: "12",
    ayatAR: "وَإِذَا الْجَحِيمُ سُعِّرَتْ",
  },
  {
    id: "5813",
    sura: "81",
    VerseIDAr: "13",
    ayatAR: "وَإِذَا الْجَنَّةُ أُزْلِفَتْ",
  },
  {
    id: "5814",
    sura: "81",
    VerseIDAr: "14",
    ayatAR: "عَلِمَتْ نَفْسٌ مَا أَحْضَرَتْ",
  },
  {
    id: "5815",
    sura: "81",
    VerseIDAr: "15",
    ayatAR: "فَلَا أُقْسِمُ بِالْخُنَّسِ",
  },
  { id: "5816", sura: "81", VerseIDAr: "16", ayatAR: "الْجَوَارِ الْكُنَّسِ" },
  {
    id: "5817",
    sura: "81",
    VerseIDAr: "17",
    ayatAR: "وَاللَّيْلِ إِذَا عَسْعَسَ",
  },
  {
    id: "5818",
    sura: "81",
    VerseIDAr: "18",
    ayatAR: "وَالصُّبْحِ إِذَا تَنَفَّسَ",
  },
  {
    id: "5819",
    sura: "81",
    VerseIDAr: "19",
    ayatAR: "إِنَّهُ لَقَوْلُ رَسُولٍ كَرِيمٍ",
  },
  {
    id: "5820",
    sura: "81",
    VerseIDAr: "20",
    ayatAR: "ذِي قُوَّةٍ عِنْدَ ذِي الْعَرْشِ مَكِينٍ",
  },
  { id: "5821", sura: "81", VerseIDAr: "21", ayatAR: "مُطَاعٍ ثَمَّ أَمِينٍ" },
  {
    id: "5822",
    sura: "81",
    VerseIDAr: "22",
    ayatAR: "وَمَا صَاحِبُكُمْ بِمَجْنُونٍ",
  },
  {
    id: "5823",
    sura: "81",
    VerseIDAr: "23",
    ayatAR: "وَلَقَدْ رَآهُ بِالْأُفُقِ الْمُبِينِ",
  },
  {
    id: "5824",
    sura: "81",
    VerseIDAr: "24",
    ayatAR: "وَمَا هُوَ عَلَى الْغَيْبِ بِضَنِينٍ",
  },
  {
    id: "5825",
    sura: "81",
    VerseIDAr: "25",
    ayatAR: "وَمَا هُوَ بِقَوْلِ شَيْطَانٍ رَجِيمٍ",
  },
  { id: "5826", sura: "81", VerseIDAr: "26", ayatAR: "فَأَيْنَ تَذْهَبُونَ" },
  {
    id: "5827",
    sura: "81",
    VerseIDAr: "27",
    ayatAR: "إِنْ هُوَ إِلَّا ذِكْرٌ لِلْعَالَمِينَ",
  },
  {
    id: "5828",
    sura: "81",
    VerseIDAr: "28",
    ayatAR: "لِمَنْ شَاءَ مِنْكُمْ أَنْ يَسْتَقِيمَ",
  },
  {
    id: "5829",
    sura: "81",
    VerseIDAr: "29",
    ayatAR: "وَمَا تَشَاءُونَ إِلَّا أَنْ يَشَاءَ اللَّهُ رَبُّ الْعَالَمِينَ",
  },
  {
    id: "5830",
    sura: "82",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا السَّمَاءُ انْفَطَرَتْ",
  },
  {
    id: "5831",
    sura: "82",
    VerseIDAr: "2",
    ayatAR: "وَإِذَا الْكَوَاكِبُ انْتَثَرَتْ",
  },
  {
    id: "5832",
    sura: "82",
    VerseIDAr: "3",
    ayatAR: "وَإِذَا الْبِحَارُ فُجِّرَتْ",
  },
  {
    id: "5833",
    sura: "82",
    VerseIDAr: "4",
    ayatAR: "وَإِذَا الْقُبُورُ بُعْثِرَتْ",
  },
  {
    id: "5834",
    sura: "82",
    VerseIDAr: "5",
    ayatAR: "عَلِمَتْ نَفْسٌ مَا قَدَّمَتْ وَأَخَّرَتْ",
  },
  {
    id: "5835",
    sura: "82",
    VerseIDAr: "6",
    ayatAR: "يَا أَيُّهَا الْإِنْسَانُ مَا غَرَّكَ بِرَبِّكَ الْكَرِيمِ",
  },
  {
    id: "5836",
    sura: "82",
    VerseIDAr: "7",
    ayatAR: "الَّذِي خَلَقَكَ فَسَوَّاكَ فَعَدَلَكَ",
  },
  {
    id: "5837",
    sura: "82",
    VerseIDAr: "8",
    ayatAR: "فِي أَيِّ صُورَةٍ مَا شَاءَ رَكَّبَكَ",
  },
  {
    id: "5838",
    sura: "82",
    VerseIDAr: "9",
    ayatAR: "كَلَّا بَلْ تُكَذِّبُونَ بِالدِّينِ",
  },
  {
    id: "5839",
    sura: "82",
    VerseIDAr: "10",
    ayatAR: "وَإِنَّ عَلَيْكُمْ لَحَافِظِينَ",
  },
  { id: "5840", sura: "82", VerseIDAr: "11", ayatAR: "كِرَامًا كَاتِبِينَ" },
  {
    id: "5841",
    sura: "82",
    VerseIDAr: "12",
    ayatAR: "يَعْلَمُونَ مَا تَفْعَلُونَ",
  },
  {
    id: "5842",
    sura: "82",
    VerseIDAr: "13",
    ayatAR: "إِنَّ الْأَبْرَارَ لَفِي نَعِيمٍ",
  },
  {
    id: "5843",
    sura: "82",
    VerseIDAr: "14",
    ayatAR: "وَإِنَّ الْفُجَّارَ لَفِي جَحِيمٍ",
  },
  {
    id: "5844",
    sura: "82",
    VerseIDAr: "15",
    ayatAR: "يَصْلَوْنَهَا يَوْمَ الدِّينِ",
  },
  {
    id: "5845",
    sura: "82",
    VerseIDAr: "16",
    ayatAR: "وَمَا هُمْ عَنْهَا بِغَائِبِينَ",
  },
  {
    id: "5846",
    sura: "82",
    VerseIDAr: "17",
    ayatAR: "وَمَا أَدْرَاكَ مَا يَوْمُ الدِّينِ",
  },
  {
    id: "5847",
    sura: "82",
    VerseIDAr: "18",
    ayatAR: "ثُمَّ مَا أَدْرَاكَ مَا يَوْمُ الدِّينِ",
  },
  {
    id: "5848",
    sura: "82",
    VerseIDAr: "19",
    ayatAR:
      "يَوْمَ لَا تَمْلِكُ نَفْسٌ لِنَفْسٍ شَيْئًا ۖ وَالْأَمْرُ يَوْمَئِذٍ لِلَّهِ",
  },
  {
    id: "5849",
    sura: "83",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَيْلٌ لِلْمُطَفِّفِينَ",
  },
  {
    id: "5850",
    sura: "83",
    VerseIDAr: "2",
    ayatAR: "الَّذِينَ إِذَا اكْتَالُوا عَلَى النَّاسِ يَسْتَوْفُونَ",
  },
  {
    id: "5851",
    sura: "83",
    VerseIDAr: "3",
    ayatAR: "وَإِذَا كَالُوهُمْ أَوْ وَزَنُوهُمْ يُخْسِرُونَ",
  },
  {
    id: "5852",
    sura: "83",
    VerseIDAr: "4",
    ayatAR: "أَلَا يَظُنُّ أُولَٰئِكَ أَنَّهُمْ مَبْعُوثُونَ",
  },
  { id: "5853", sura: "83", VerseIDAr: "5", ayatAR: "لِيَوْمٍ عَظِيمٍ" },
  {
    id: "5854",
    sura: "83",
    VerseIDAr: "6",
    ayatAR: "يَوْمَ يَقُومُ النَّاسُ لِرَبِّ الْعَالَمِينَ",
  },
  {
    id: "5855",
    sura: "83",
    VerseIDAr: "7",
    ayatAR: "كَلَّا إِنَّ كِتَابَ الْفُجَّارِ لَفِي سِجِّينٍ",
  },
  {
    id: "5856",
    sura: "83",
    VerseIDAr: "8",
    ayatAR: "وَمَا أَدْرَاكَ مَا سِجِّينٌ",
  },
  { id: "5857", sura: "83", VerseIDAr: "9", ayatAR: "كِتَابٌ مَرْقُومٌ" },
  {
    id: "5858",
    sura: "83",
    VerseIDAr: "10",
    ayatAR: "وَيْلٌ يَوْمَئِذٍ لِلْمُكَذِّبِينَ",
  },
  {
    id: "5859",
    sura: "83",
    VerseIDAr: "11",
    ayatAR: "الَّذِينَ يُكَذِّبُونَ بِيَوْمِ الدِّينِ",
  },
  {
    id: "5860",
    sura: "83",
    VerseIDAr: "12",
    ayatAR: "وَمَا يُكَذِّبُ بِهِ إِلَّا كُلُّ مُعْتَدٍ أَثِيمٍ",
  },
  {
    id: "5861",
    sura: "83",
    VerseIDAr: "13",
    ayatAR: "إِذَا تُتْلَىٰ عَلَيْهِ آيَاتُنَا قَالَ أَسَاطِيرُ الْأَوَّلِينَ",
  },
  {
    id: "5862",
    sura: "83",
    VerseIDAr: "14",
    ayatAR: "كَلَّا ۖ بَلْ ۜ رَانَ عَلَىٰ قُلُوبِهِمْ مَا كَانُوا يَكْسِبُونَ",
  },
  {
    id: "5863",
    sura: "83",
    VerseIDAr: "15",
    ayatAR: "كَلَّا إِنَّهُمْ عَنْ رَبِّهِمْ يَوْمَئِذٍ لَمَحْجُوبُونَ",
  },
  {
    id: "5864",
    sura: "83",
    VerseIDAr: "16",
    ayatAR: "ثُمَّ إِنَّهُمْ لَصَالُو الْجَحِيمِ",
  },
  {
    id: "5865",
    sura: "83",
    VerseIDAr: "17",
    ayatAR: "ثُمَّ يُقَالُ هَٰذَا الَّذِي كُنْتُمْ بِهِ تُكَذِّبُونَ",
  },
  {
    id: "5866",
    sura: "83",
    VerseIDAr: "18",
    ayatAR: "كَلَّا إِنَّ كِتَابَ الْأَبْرَارِ لَفِي عِلِّيِّينَ",
  },
  {
    id: "5867",
    sura: "83",
    VerseIDAr: "19",
    ayatAR: "وَمَا أَدْرَاكَ مَا عِلِّيُّونَ",
  },
  { id: "5868", sura: "83", VerseIDAr: "20", ayatAR: "كِتَابٌ مَرْقُومٌ" },
  {
    id: "5869",
    sura: "83",
    VerseIDAr: "21",
    ayatAR: "يَشْهَدُهُ الْمُقَرَّبُونَ",
  },
  {
    id: "5870",
    sura: "83",
    VerseIDAr: "22",
    ayatAR: "إِنَّ الْأَبْرَارَ لَفِي نَعِيمٍ",
  },
  {
    id: "5871",
    sura: "83",
    VerseIDAr: "23",
    ayatAR: "عَلَى الْأَرَائِكِ يَنْظُرُونَ",
  },
  {
    id: "5872",
    sura: "83",
    VerseIDAr: "24",
    ayatAR: "تَعْرِفُ فِي وُجُوهِهِمْ نَضْرَةَ النَّعِيمِ",
  },
  {
    id: "5873",
    sura: "83",
    VerseIDAr: "25",
    ayatAR: "يُسْقَوْنَ مِنْ رَحِيقٍ مَخْتُومٍ",
  },
  {
    id: "5874",
    sura: "83",
    VerseIDAr: "26",
    ayatAR:
      "خِتَامُهُ مِسْكٌ ۚ وَفِي ذَٰلِكَ فَلْيَتَنَافَسِ الْمُتَنَافِسُونَ",
  },
  {
    id: "5875",
    sura: "83",
    VerseIDAr: "27",
    ayatAR: "وَمِزَاجُهُ مِنْ تَسْنِيمٍ",
  },
  {
    id: "5876",
    sura: "83",
    VerseIDAr: "28",
    ayatAR: "عَيْنًا يَشْرَبُ بِهَا الْمُقَرَّبُونَ",
  },
  {
    id: "5877",
    sura: "83",
    VerseIDAr: "29",
    ayatAR:
      "إِنَّ الَّذِينَ أَجْرَمُوا كَانُوا مِنَ الَّذِينَ آمَنُوا يَضْحَكُونَ",
  },
  {
    id: "5878",
    sura: "83",
    VerseIDAr: "30",
    ayatAR: "وَإِذَا مَرُّوا بِهِمْ يَتَغَامَزُونَ",
  },
  {
    id: "5879",
    sura: "83",
    VerseIDAr: "31",
    ayatAR: "وَإِذَا انْقَلَبُوا إِلَىٰ أَهْلِهِمُ انْقَلَبُوا فَكِهِينَ",
  },
  {
    id: "5880",
    sura: "83",
    VerseIDAr: "32",
    ayatAR: "وَإِذَا رَأَوْهُمْ قَالُوا إِنَّ هَٰؤُلَاءِ لَضَالُّونَ",
  },
  {
    id: "5881",
    sura: "83",
    VerseIDAr: "33",
    ayatAR: "وَمَا أُرْسِلُوا عَلَيْهِمْ حَافِظِينَ",
  },
  {
    id: "5882",
    sura: "83",
    VerseIDAr: "34",
    ayatAR: "فَالْيَوْمَ الَّذِينَ آمَنُوا مِنَ الْكُفَّارِ يَضْحَكُونَ",
  },
  {
    id: "5883",
    sura: "83",
    VerseIDAr: "35",
    ayatAR: "عَلَى الْأَرَائِكِ يَنْظُرُونَ",
  },
  {
    id: "5884",
    sura: "83",
    VerseIDAr: "36",
    ayatAR: "هَلْ ثُوِّبَ الْكُفَّارُ مَا كَانُوا يَفْعَلُونَ",
  },
  {
    id: "5885",
    sura: "84",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا السَّمَاءُ انْشَقَّتْ",
  },
  {
    id: "5886",
    sura: "84",
    VerseIDAr: "2",
    ayatAR: "وَأَذِنَتْ لِرَبِّهَا وَحُقَّتْ",
  },
  {
    id: "5887",
    sura: "84",
    VerseIDAr: "3",
    ayatAR: "وَإِذَا الْأَرْضُ مُدَّتْ",
  },
  {
    id: "5888",
    sura: "84",
    VerseIDAr: "4",
    ayatAR: "وَأَلْقَتْ مَا فِيهَا وَتَخَلَّتْ",
  },
  {
    id: "5889",
    sura: "84",
    VerseIDAr: "5",
    ayatAR: "وَأَذِنَتْ لِرَبِّهَا وَحُقَّتْ",
  },
  {
    id: "5890",
    sura: "84",
    VerseIDAr: "6",
    ayatAR:
      "يَا أَيُّهَا الْإِنْسَانُ إِنَّكَ كَادِحٌ إِلَىٰ رَبِّكَ كَدْحًا فَمُلَاقِيهِ",
  },
  {
    id: "5891",
    sura: "84",
    VerseIDAr: "7",
    ayatAR: "فَأَمَّا مَنْ أُوتِيَ كِتَابَهُ بِيَمِينِهِ",
  },
  {
    id: "5892",
    sura: "84",
    VerseIDAr: "8",
    ayatAR: "فَسَوْفَ يُحَاسَبُ حِسَابًا يَسِيرًا",
  },
  {
    id: "5893",
    sura: "84",
    VerseIDAr: "9",
    ayatAR: "وَيَنْقَلِبُ إِلَىٰ أَهْلِهِ مَسْرُورًا",
  },
  {
    id: "5894",
    sura: "84",
    VerseIDAr: "10",
    ayatAR: "وَأَمَّا مَنْ أُوتِيَ كِتَابَهُ وَرَاءَ ظَهْرِهِ",
  },
  {
    id: "5895",
    sura: "84",
    VerseIDAr: "11",
    ayatAR: "فَسَوْفَ يَدْعُو ثُبُورًا",
  },
  { id: "5896", sura: "84", VerseIDAr: "12", ayatAR: "وَيَصْلَىٰ سَعِيرًا" },
  {
    id: "5897",
    sura: "84",
    VerseIDAr: "13",
    ayatAR: "إِنَّهُ كَانَ فِي أَهْلِهِ مَسْرُورًا",
  },
  {
    id: "5898",
    sura: "84",
    VerseIDAr: "14",
    ayatAR: "إِنَّهُ ظَنَّ أَنْ لَنْ يَحُورَ",
  },
  {
    id: "5899",
    sura: "84",
    VerseIDAr: "15",
    ayatAR: "بَلَىٰ إِنَّ رَبَّهُ كَانَ بِهِ بَصِيرًا",
  },
  {
    id: "5900",
    sura: "84",
    VerseIDAr: "16",
    ayatAR: "فَلَا أُقْسِمُ بِالشَّفَقِ",
  },
  {
    id: "5901",
    sura: "84",
    VerseIDAr: "17",
    ayatAR: "وَاللَّيْلِ وَمَا وَسَقَ",
  },
  {
    id: "5902",
    sura: "84",
    VerseIDAr: "18",
    ayatAR: "وَالْقَمَرِ إِذَا اتَّسَقَ",
  },
  {
    id: "5903",
    sura: "84",
    VerseIDAr: "19",
    ayatAR: "لَتَرْكَبُنَّ طَبَقًا عَنْ طَبَقٍ",
  },
  {
    id: "5904",
    sura: "84",
    VerseIDAr: "20",
    ayatAR: "فَمَا لَهُمْ لَا يُؤْمِنُونَ",
  },
  {
    id: "5905",
    sura: "84",
    VerseIDAr: "21",
    ayatAR: "وَإِذَا قُرِئَ عَلَيْهِمُ الْقُرْآنُ لَا يَسْجُدُونَ ۩",
  },
  {
    id: "5906",
    sura: "84",
    VerseIDAr: "22",
    ayatAR: "بَلِ الَّذِينَ كَفَرُوا يُكَذِّبُونَ",
  },
  {
    id: "5907",
    sura: "84",
    VerseIDAr: "23",
    ayatAR: "وَاللَّهُ أَعْلَمُ بِمَا يُوعُونَ",
  },
  {
    id: "5908",
    sura: "84",
    VerseIDAr: "24",
    ayatAR: "فَبَشِّرْهُمْ بِعَذَابٍ أَلِيمٍ",
  },
  {
    id: "5909",
    sura: "84",
    VerseIDAr: "25",
    ayatAR:
      "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍ",
  },
  {
    id: "5910",
    sura: "85",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالسَّمَاءِ ذَاتِ الْبُرُوجِ",
  },
  {
    id: "5911",
    sura: "85",
    VerseIDAr: "2",
    ayatAR: "وَالْيَوْمِ الْمَوْعُودِ",
  },
  { id: "5912", sura: "85", VerseIDAr: "3", ayatAR: "وَشَاهِدٍ وَمَشْهُودٍ" },
  {
    id: "5913",
    sura: "85",
    VerseIDAr: "4",
    ayatAR: "قُتِلَ أَصْحَابُ الْأُخْدُودِ",
  },
  {
    id: "5914",
    sura: "85",
    VerseIDAr: "5",
    ayatAR: "النَّارِ ذَاتِ الْوَقُودِ",
  },
  {
    id: "5915",
    sura: "85",
    VerseIDAr: "6",
    ayatAR: "إِذْ هُمْ عَلَيْهَا قُعُودٌ",
  },
  {
    id: "5916",
    sura: "85",
    VerseIDAr: "7",
    ayatAR: "وَهُمْ عَلَىٰ مَا يَفْعَلُونَ بِالْمُؤْمِنِينَ شُهُودٌ",
  },
  {
    id: "5917",
    sura: "85",
    VerseIDAr: "8",
    ayatAR:
      "وَمَا نَقَمُوا مِنْهُمْ إِلَّا أَنْ يُؤْمِنُوا بِاللَّهِ الْعَزِيزِ الْحَمِيدِ",
  },
  {
    id: "5918",
    sura: "85",
    VerseIDAr: "9",
    ayatAR:
      "الَّذِي لَهُ مُلْكُ السَّمَاوَاتِ وَالْأَرْضِ ۚ وَاللَّهُ عَلَىٰ كُلِّ شَيْءٍ شَهِيدٌ",
  },
  {
    id: "5919",
    sura: "85",
    VerseIDAr: "10",
    ayatAR:
      "إِنَّ الَّذِينَ فَتَنُوا الْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ ثُمَّ لَمْ يَتُوبُوا فَلَهُمْ عَذَابُ جَهَنَّمَ وَلَهُمْ عَذَابُ الْحَرِيقِ",
  },
  {
    id: "5920",
    sura: "85",
    VerseIDAr: "11",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ لَهُمْ جَنَّاتٌ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ ۚ ذَٰلِكَ الْفَوْزُ الْكَبِيرُ",
  },
  {
    id: "5921",
    sura: "85",
    VerseIDAr: "12",
    ayatAR: "إِنَّ بَطْشَ رَبِّكَ لَشَدِيدٌ",
  },
  {
    id: "5922",
    sura: "85",
    VerseIDAr: "13",
    ayatAR: "إِنَّهُ هُوَ يُبْدِئُ وَيُعِيدُ",
  },
  {
    id: "5923",
    sura: "85",
    VerseIDAr: "14",
    ayatAR: "وَهُوَ الْغَفُورُ الْوَدُودُ",
  },
  {
    id: "5924",
    sura: "85",
    VerseIDAr: "15",
    ayatAR: "ذُو الْعَرْشِ الْمَجِيدُ",
  },
  { id: "5925", sura: "85", VerseIDAr: "16", ayatAR: "فَعَّالٌ لِمَا يُرِيدُ" },
  {
    id: "5926",
    sura: "85",
    VerseIDAr: "17",
    ayatAR: "هَلْ أَتَاكَ حَدِيثُ الْجُنُودِ",
  },
  { id: "5927", sura: "85", VerseIDAr: "18", ayatAR: "فِرْعَوْنَ وَثَمُودَ" },
  {
    id: "5928",
    sura: "85",
    VerseIDAr: "19",
    ayatAR: "بَلِ الَّذِينَ كَفَرُوا فِي تَكْذِيبٍ",
  },
  {
    id: "5929",
    sura: "85",
    VerseIDAr: "20",
    ayatAR: "وَاللَّهُ مِنْ وَرَائِهِمْ مُحِيطٌ",
  },
  {
    id: "5930",
    sura: "85",
    VerseIDAr: "21",
    ayatAR: "بَلْ هُوَ قُرْآنٌ مَجِيدٌ",
  },
  { id: "5931", sura: "85", VerseIDAr: "22", ayatAR: "فِي لَوْحٍ مَحْفُوظٍ" },
  {
    id: "5932",
    sura: "86",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالسَّمَاءِ وَالطَّارِقِ",
  },
  {
    id: "5933",
    sura: "86",
    VerseIDAr: "2",
    ayatAR: "وَمَا أَدْرَاكَ مَا الطَّارِقُ",
  },
  { id: "5934", sura: "86", VerseIDAr: "3", ayatAR: "النَّجْمُ الثَّاقِبُ" },
  {
    id: "5935",
    sura: "86",
    VerseIDAr: "4",
    ayatAR: "إِنْ كُلُّ نَفْسٍ لَمَّا عَلَيْهَا حَافِظٌ",
  },
  {
    id: "5936",
    sura: "86",
    VerseIDAr: "5",
    ayatAR: "فَلْيَنْظُرِ الْإِنْسَانُ مِمَّ خُلِقَ",
  },
  {
    id: "5937",
    sura: "86",
    VerseIDAr: "6",
    ayatAR: "خُلِقَ مِنْ مَاءٍ دَافِقٍ",
  },
  {
    id: "5938",
    sura: "86",
    VerseIDAr: "7",
    ayatAR: "يَخْرُجُ مِنْ بَيْنِ الصُّلْبِ وَالتَّرَائِبِ",
  },
  {
    id: "5939",
    sura: "86",
    VerseIDAr: "8",
    ayatAR: "إِنَّهُ عَلَىٰ رَجْعِهِ لَقَادِرٌ",
  },
  {
    id: "5940",
    sura: "86",
    VerseIDAr: "9",
    ayatAR: "يَوْمَ تُبْلَى السَّرَائِرُ",
  },
  {
    id: "5941",
    sura: "86",
    VerseIDAr: "10",
    ayatAR: "فَمَا لَهُ مِنْ قُوَّةٍ وَلَا نَاصِرٍ",
  },
  {
    id: "5942",
    sura: "86",
    VerseIDAr: "11",
    ayatAR: "وَالسَّمَاءِ ذَاتِ الرَّجْعِ",
  },
  {
    id: "5943",
    sura: "86",
    VerseIDAr: "12",
    ayatAR: "وَالْأَرْضِ ذَاتِ الصَّدْعِ",
  },
  {
    id: "5944",
    sura: "86",
    VerseIDAr: "13",
    ayatAR: "إِنَّهُ لَقَوْلٌ فَصْلٌ",
  },
  { id: "5945", sura: "86", VerseIDAr: "14", ayatAR: "وَمَا هُوَ بِالْهَزْلِ" },
  {
    id: "5946",
    sura: "86",
    VerseIDAr: "15",
    ayatAR: "إِنَّهُمْ يَكِيدُونَ كَيْدًا",
  },
  { id: "5947", sura: "86", VerseIDAr: "16", ayatAR: "وَأَكِيدُ كَيْدًا" },
  {
    id: "5948",
    sura: "86",
    VerseIDAr: "17",
    ayatAR: "فَمَهِّلِ الْكَافِرِينَ أَمْهِلْهُمْ رُوَيْدًا",
  },
  {
    id: "5949",
    sura: "87",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ سَبِّحِ اسْمَ رَبِّكَ الْأَعْلَى",
  },
  {
    id: "5950",
    sura: "87",
    VerseIDAr: "2",
    ayatAR: "الَّذِي خَلَقَ فَسَوَّىٰ",
  },
  {
    id: "5951",
    sura: "87",
    VerseIDAr: "3",
    ayatAR: "وَالَّذِي قَدَّرَ فَهَدَىٰ",
  },
  {
    id: "5952",
    sura: "87",
    VerseIDAr: "4",
    ayatAR: "وَالَّذِي أَخْرَجَ الْمَرْعَىٰ",
  },
  {
    id: "5953",
    sura: "87",
    VerseIDAr: "5",
    ayatAR: "فَجَعَلَهُ غُثَاءً أَحْوَىٰ",
  },
  {
    id: "5954",
    sura: "87",
    VerseIDAr: "6",
    ayatAR: "سَنُقْرِئُكَ فَلَا تَنْسَىٰ",
  },
  {
    id: "5955",
    sura: "87",
    VerseIDAr: "7",
    ayatAR:
      "إِلَّا مَا شَاءَ اللَّهُ ۚ إِنَّهُ يَعْلَمُ الْجَهْرَ وَمَا يَخْفَىٰ",
  },
  {
    id: "5956",
    sura: "87",
    VerseIDAr: "8",
    ayatAR: "وَنُيَسِّرُكَ لِلْيُسْرَىٰ",
  },
  {
    id: "5957",
    sura: "87",
    VerseIDAr: "9",
    ayatAR: "فَذَكِّرْ إِنْ نَفَعَتِ الذِّكْرَىٰ",
  },
  {
    id: "5958",
    sura: "87",
    VerseIDAr: "10",
    ayatAR: "سَيَذَّكَّرُ مَنْ يَخْشَىٰ",
  },
  {
    id: "5959",
    sura: "87",
    VerseIDAr: "11",
    ayatAR: "وَيَتَجَنَّبُهَا الْأَشْقَى",
  },
  {
    id: "5960",
    sura: "87",
    VerseIDAr: "12",
    ayatAR: "الَّذِي يَصْلَى النَّارَ الْكُبْرَىٰ",
  },
  {
    id: "5961",
    sura: "87",
    VerseIDAr: "13",
    ayatAR: "ثُمَّ لَا يَمُوتُ فِيهَا وَلَا يَحْيَىٰ",
  },
  {
    id: "5962",
    sura: "87",
    VerseIDAr: "14",
    ayatAR: "قَدْ أَفْلَحَ مَنْ تَزَكَّىٰ",
  },
  {
    id: "5963",
    sura: "87",
    VerseIDAr: "15",
    ayatAR: "وَذَكَرَ اسْمَ رَبِّهِ فَصَلَّىٰ",
  },
  {
    id: "5964",
    sura: "87",
    VerseIDAr: "16",
    ayatAR: "بَلْ تُؤْثِرُونَ الْحَيَاةَ الدُّنْيَا",
  },
  {
    id: "5965",
    sura: "87",
    VerseIDAr: "17",
    ayatAR: "وَالْآخِرَةُ خَيْرٌ وَأَبْقَىٰ",
  },
  {
    id: "5966",
    sura: "87",
    VerseIDAr: "18",
    ayatAR: "إِنَّ هَٰذَا لَفِي الصُّحُفِ الْأُولَىٰ",
  },
  {
    id: "5967",
    sura: "87",
    VerseIDAr: "19",
    ayatAR: "صُحُفِ إِبْرَاهِيمَ وَمُوسَىٰ",
  },
  {
    id: "5968",
    sura: "88",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ هَلْ أَتَاكَ حَدِيثُ الْغَاشِيَةِ",
  },
  {
    id: "5969",
    sura: "88",
    VerseIDAr: "2",
    ayatAR: "وُجُوهٌ يَوْمَئِذٍ خَاشِعَةٌ",
  },
  { id: "5970", sura: "88", VerseIDAr: "3", ayatAR: "عَامِلَةٌ نَاصِبَةٌ" },
  {
    id: "5971",
    sura: "88",
    VerseIDAr: "4",
    ayatAR: "تَصْلَىٰ نَارًا حَامِيَةً",
  },
  {
    id: "5972",
    sura: "88",
    VerseIDAr: "5",
    ayatAR: "تُسْقَىٰ مِنْ عَيْنٍ آنِيَةٍ",
  },
  {
    id: "5973",
    sura: "88",
    VerseIDAr: "6",
    ayatAR: "لَيْسَ لَهُمْ طَعَامٌ إِلَّا مِنْ ضَرِيعٍ",
  },
  {
    id: "5974",
    sura: "88",
    VerseIDAr: "7",
    ayatAR: "لَا يُسْمِنُ وَلَا يُغْنِي مِنْ جُوعٍ",
  },
  {
    id: "5975",
    sura: "88",
    VerseIDAr: "8",
    ayatAR: "وُجُوهٌ يَوْمَئِذٍ نَاعِمَةٌ",
  },
  { id: "5976", sura: "88", VerseIDAr: "9", ayatAR: "لِسَعْيِهَا رَاضِيَةٌ" },
  { id: "5977", sura: "88", VerseIDAr: "10", ayatAR: "فِي جَنَّةٍ عَالِيَةٍ" },
  {
    id: "5978",
    sura: "88",
    VerseIDAr: "11",
    ayatAR: "لَا تَسْمَعُ فِيهَا لَاغِيَةً",
  },
  {
    id: "5979",
    sura: "88",
    VerseIDAr: "12",
    ayatAR: "فِيهَا عَيْنٌ جَارِيَةٌ",
  },
  {
    id: "5980",
    sura: "88",
    VerseIDAr: "13",
    ayatAR: "فِيهَا سُرُرٌ مَرْفُوعَةٌ",
  },
  {
    id: "5981",
    sura: "88",
    VerseIDAr: "14",
    ayatAR: "وَأَكْوَابٌ مَوْضُوعَةٌ",
  },
  {
    id: "5982",
    sura: "88",
    VerseIDAr: "15",
    ayatAR: "وَنَمَارِقُ مَصْفُوفَةٌ",
  },
  {
    id: "5983",
    sura: "88",
    VerseIDAr: "16",
    ayatAR: "وَزَرَابِيُّ مَبْثُوثَةٌ",
  },
  {
    id: "5984",
    sura: "88",
    VerseIDAr: "17",
    ayatAR: "أَفَلَا يَنْظُرُونَ إِلَى الْإِبِلِ كَيْفَ خُلِقَتْ",
  },
  {
    id: "5985",
    sura: "88",
    VerseIDAr: "18",
    ayatAR: "وَإِلَى السَّمَاءِ كَيْفَ رُفِعَتْ",
  },
  {
    id: "5986",
    sura: "88",
    VerseIDAr: "19",
    ayatAR: "وَإِلَى الْجِبَالِ كَيْفَ نُصِبَتْ",
  },
  {
    id: "5987",
    sura: "88",
    VerseIDAr: "20",
    ayatAR: "وَإِلَى الْأَرْضِ كَيْفَ سُطِحَتْ",
  },
  {
    id: "5988",
    sura: "88",
    VerseIDAr: "21",
    ayatAR: "فَذَكِّرْ إِنَّمَا أَنْتَ مُذَكِّرٌ",
  },
  {
    id: "5989",
    sura: "88",
    VerseIDAr: "22",
    ayatAR: "لَسْتَ عَلَيْهِمْ بِمُصَيْطِرٍ",
  },
  {
    id: "5990",
    sura: "88",
    VerseIDAr: "23",
    ayatAR: "إِلَّا مَنْ تَوَلَّىٰ وَكَفَرَ",
  },
  {
    id: "5991",
    sura: "88",
    VerseIDAr: "24",
    ayatAR: "فَيُعَذِّبُهُ اللَّهُ الْعَذَابَ الْأَكْبَرَ",
  },
  {
    id: "5992",
    sura: "88",
    VerseIDAr: "25",
    ayatAR: "إِنَّ إِلَيْنَا إِيَابَهُمْ",
  },
  {
    id: "5993",
    sura: "88",
    VerseIDAr: "26",
    ayatAR: "ثُمَّ إِنَّ عَلَيْنَا حِسَابَهُمْ",
  },
  {
    id: "5994",
    sura: "89",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالْفَجْرِ",
  },
  { id: "5995", sura: "89", VerseIDAr: "2", ayatAR: "وَلَيَالٍ عَشْرٍ" },
  { id: "5996", sura: "89", VerseIDAr: "3", ayatAR: "وَالشَّفْعِ وَالْوَتْرِ" },
  {
    id: "5997",
    sura: "89",
    VerseIDAr: "4",
    ayatAR: "وَاللَّيْلِ إِذَا يَسْرِ",
  },
  {
    id: "5998",
    sura: "89",
    VerseIDAr: "5",
    ayatAR: "هَلْ فِي ذَٰلِكَ قَسَمٌ لِذِي حِجْرٍ",
  },
  {
    id: "5999",
    sura: "89",
    VerseIDAr: "6",
    ayatAR: "أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِعَادٍ",
  },
  { id: "6000", sura: "89", VerseIDAr: "7", ayatAR: "إِرَمَ ذَاتِ الْعِمَادِ" },
  {
    id: "6001",
    sura: "89",
    VerseIDAr: "8",
    ayatAR: "الَّتِي لَمْ يُخْلَقْ مِثْلُهَا فِي الْبِلَادِ",
  },
  {
    id: "6002",
    sura: "89",
    VerseIDAr: "9",
    ayatAR: "وَثَمُودَ الَّذِينَ جَابُوا الصَّخْرَ بِالْوَادِ",
  },
  {
    id: "6003",
    sura: "89",
    VerseIDAr: "10",
    ayatAR: "وَفِرْعَوْنَ ذِي الْأَوْتَادِ",
  },
  {
    id: "6004",
    sura: "89",
    VerseIDAr: "11",
    ayatAR: "الَّذِينَ طَغَوْا فِي الْبِلَادِ",
  },
  {
    id: "6005",
    sura: "89",
    VerseIDAr: "12",
    ayatAR: "فَأَكْثَرُوا فِيهَا الْفَسَادَ",
  },
  {
    id: "6006",
    sura: "89",
    VerseIDAr: "13",
    ayatAR: "فَصَبَّ عَلَيْهِمْ رَبُّكَ سَوْطَ عَذَابٍ",
  },
  {
    id: "6007",
    sura: "89",
    VerseIDAr: "14",
    ayatAR: "إِنَّ رَبَّكَ لَبِالْمِرْصَادِ",
  },
  {
    id: "6008",
    sura: "89",
    VerseIDAr: "15",
    ayatAR:
      "فَأَمَّا الْإِنْسَانُ إِذَا مَا ابْتَلَاهُ رَبُّهُ فَأَكْرَمَهُ وَنَعَّمَهُ فَيَقُولُ رَبِّي أَكْرَمَنِ",
  },
  {
    id: "6009",
    sura: "89",
    VerseIDAr: "16",
    ayatAR:
      "وَأَمَّا إِذَا مَا ابْتَلَاهُ فَقَدَرَ عَلَيْهِ رِزْقَهُ فَيَقُولُ رَبِّي أَهَانَنِ",
  },
  {
    id: "6010",
    sura: "89",
    VerseIDAr: "17",
    ayatAR: "كَلَّا ۖ بَلْ لَا تُكْرِمُونَ الْيَتِيمَ",
  },
  {
    id: "6011",
    sura: "89",
    VerseIDAr: "18",
    ayatAR: "وَلَا تَحَاضُّونَ عَلَىٰ طَعَامِ الْمِسْكِينِ",
  },
  {
    id: "6012",
    sura: "89",
    VerseIDAr: "19",
    ayatAR: "وَتَأْكُلُونَ التُّرَاثَ أَكْلًا لَمًّا",
  },
  {
    id: "6013",
    sura: "89",
    VerseIDAr: "20",
    ayatAR: "وَتُحِبُّونَ الْمَالَ حُبًّا جَمًّا",
  },
  {
    id: "6014",
    sura: "89",
    VerseIDAr: "21",
    ayatAR: "كَلَّا إِذَا دُكَّتِ الْأَرْضُ دَكًّا دَكًّا",
  },
  {
    id: "6015",
    sura: "89",
    VerseIDAr: "22",
    ayatAR: "وَجَاءَ رَبُّكَ وَالْمَلَكُ صَفًّا صَفًّا",
  },
  {
    id: "6016",
    sura: "89",
    VerseIDAr: "23",
    ayatAR:
      "وَجِيءَ يَوْمَئِذٍ بِجَهَنَّمَ ۚ يَوْمَئِذٍ يَتَذَكَّرُ الْإِنْسَانُ وَأَنَّىٰ لَهُ الذِّكْرَىٰ",
  },
  {
    id: "6017",
    sura: "89",
    VerseIDAr: "24",
    ayatAR: "يَقُولُ يَا لَيْتَنِي قَدَّمْتُ لِحَيَاتِي",
  },
  {
    id: "6018",
    sura: "89",
    VerseIDAr: "25",
    ayatAR: "فَيَوْمَئِذٍ لَا يُعَذِّبُ عَذَابَهُ أَحَدٌ",
  },
  {
    id: "6019",
    sura: "89",
    VerseIDAr: "26",
    ayatAR: "وَلَا يُوثِقُ وَثَاقَهُ أَحَدٌ",
  },
  {
    id: "6020",
    sura: "89",
    VerseIDAr: "27",
    ayatAR: "يَا أَيَّتُهَا النَّفْسُ الْمُطْمَئِنَّةُ",
  },
  {
    id: "6021",
    sura: "89",
    VerseIDAr: "28",
    ayatAR: "ارْجِعِي إِلَىٰ رَبِّكِ رَاضِيَةً مَرْضِيَّةً",
  },
  {
    id: "6022",
    sura: "89",
    VerseIDAr: "29",
    ayatAR: "فَادْخُلِي فِي عِبَادِي",
  },
  { id: "6023", sura: "89", VerseIDAr: "30", ayatAR: "وَادْخُلِي جَنَّتِي" },
  {
    id: "6024",
    sura: "90",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ لَا أُقْسِمُ بِهَٰذَا الْبَلَدِ",
  },
  {
    id: "6025",
    sura: "90",
    VerseIDAr: "2",
    ayatAR: "وَأَنْتَ حِلٌّ بِهَٰذَا الْبَلَدِ",
  },
  { id: "6026", sura: "90", VerseIDAr: "3", ayatAR: "وَوَالِدٍ وَمَا وَلَدَ" },
  {
    id: "6027",
    sura: "90",
    VerseIDAr: "4",
    ayatAR: "لَقَدْ خَلَقْنَا الْإِنْسَانَ فِي كَبَدٍ",
  },
  {
    id: "6028",
    sura: "90",
    VerseIDAr: "5",
    ayatAR: "أَيَحْسَبُ أَنْ لَنْ يَقْدِرَ عَلَيْهِ أَحَدٌ",
  },
  {
    id: "6029",
    sura: "90",
    VerseIDAr: "6",
    ayatAR: "يَقُولُ أَهْلَكْتُ مَالًا لُبَدًا",
  },
  {
    id: "6030",
    sura: "90",
    VerseIDAr: "7",
    ayatAR: "أَيَحْسَبُ أَنْ لَمْ يَرَهُ أَحَدٌ",
  },
  {
    id: "6031",
    sura: "90",
    VerseIDAr: "8",
    ayatAR: "أَلَمْ نَجْعَلْ لَهُ عَيْنَيْنِ",
  },
  { id: "6032", sura: "90", VerseIDAr: "9", ayatAR: "وَلِسَانًا وَشَفَتَيْنِ" },
  {
    id: "6033",
    sura: "90",
    VerseIDAr: "10",
    ayatAR: "وَهَدَيْنَاهُ النَّجْدَيْنِ",
  },
  {
    id: "6034",
    sura: "90",
    VerseIDAr: "11",
    ayatAR: "فَلَا اقْتَحَمَ الْعَقَبَةَ",
  },
  {
    id: "6035",
    sura: "90",
    VerseIDAr: "12",
    ayatAR: "وَمَا أَدْرَاكَ مَا الْعَقَبَةُ",
  },
  { id: "6036", sura: "90", VerseIDAr: "13", ayatAR: "فَكُّ رَقَبَةٍ" },
  {
    id: "6037",
    sura: "90",
    VerseIDAr: "14",
    ayatAR: "أَوْ إِطْعَامٌ فِي يَوْمٍ ذِي مَسْغَبَةٍ",
  },
  {
    id: "6038",
    sura: "90",
    VerseIDAr: "15",
    ayatAR: "يَتِيمًا ذَا مَقْرَبَةٍ",
  },
  {
    id: "6039",
    sura: "90",
    VerseIDAr: "16",
    ayatAR: "أَوْ مِسْكِينًا ذَا مَتْرَبَةٍ",
  },
  {
    id: "6040",
    sura: "90",
    VerseIDAr: "17",
    ayatAR:
      "ثُمَّ كَانَ مِنَ الَّذِينَ آمَنُوا وَتَوَاصَوْا بِالصَّبْرِ وَتَوَاصَوْا بِالْمَرْحَمَةِ",
  },
  {
    id: "6041",
    sura: "90",
    VerseIDAr: "18",
    ayatAR: "أُولَٰئِكَ أَصْحَابُ الْمَيْمَنَةِ",
  },
  {
    id: "6042",
    sura: "90",
    VerseIDAr: "19",
    ayatAR: "وَالَّذِينَ كَفَرُوا بِآيَاتِنَا هُمْ أَصْحَابُ الْمَشْأَمَةِ",
  },
  {
    id: "6043",
    sura: "90",
    VerseIDAr: "20",
    ayatAR: "عَلَيْهِمْ نَارٌ مُؤْصَدَةٌ",
  },
  {
    id: "6044",
    sura: "91",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالشَّمْسِ وَضُحَاهَا",
  },
  {
    id: "6045",
    sura: "91",
    VerseIDAr: "2",
    ayatAR: "وَالْقَمَرِ إِذَا تَلَاهَا",
  },
  {
    id: "6046",
    sura: "91",
    VerseIDAr: "3",
    ayatAR: "وَالنَّهَارِ إِذَا جَلَّاهَا",
  },
  {
    id: "6047",
    sura: "91",
    VerseIDAr: "4",
    ayatAR: "وَاللَّيْلِ إِذَا يَغْشَاهَا",
  },
  {
    id: "6048",
    sura: "91",
    VerseIDAr: "5",
    ayatAR: "وَالسَّمَاءِ وَمَا بَنَاهَا",
  },
  {
    id: "6049",
    sura: "91",
    VerseIDAr: "6",
    ayatAR: "وَالْأَرْضِ وَمَا طَحَاهَا",
  },
  {
    id: "6050",
    sura: "91",
    VerseIDAr: "7",
    ayatAR: "وَنَفْسٍ وَمَا سَوَّاهَا",
  },
  {
    id: "6051",
    sura: "91",
    VerseIDAr: "8",
    ayatAR: "فَأَلْهَمَهَا فُجُورَهَا وَتَقْوَاهَا",
  },
  {
    id: "6052",
    sura: "91",
    VerseIDAr: "9",
    ayatAR: "قَدْ أَفْلَحَ مَنْ زَكَّاهَا",
  },
  {
    id: "6053",
    sura: "91",
    VerseIDAr: "10",
    ayatAR: "وَقَدْ خَابَ مَنْ دَسَّاهَا",
  },
  {
    id: "6054",
    sura: "91",
    VerseIDAr: "11",
    ayatAR: "كَذَّبَتْ ثَمُودُ بِطَغْوَاهَا",
  },
  {
    id: "6055",
    sura: "91",
    VerseIDAr: "12",
    ayatAR: "إِذِ انْبَعَثَ أَشْقَاهَا",
  },
  {
    id: "6056",
    sura: "91",
    VerseIDAr: "13",
    ayatAR: "فَقَالَ لَهُمْ رَسُولُ اللَّهِ نَاقَةَ اللَّهِ وَسُقْيَاهَا",
  },
  {
    id: "6057",
    sura: "91",
    VerseIDAr: "14",
    ayatAR:
      "فَكَذَّبُوهُ فَعَقَرُوهَا فَدَمْدَمَ عَلَيْهِمْ رَبُّهُمْ بِذَنْبِهِمْ فَسَوَّاهَا",
  },
  {
    id: "6058",
    sura: "91",
    VerseIDAr: "15",
    ayatAR: "وَلَا يَخَافُ عُقْبَاهَا",
  },
  {
    id: "6059",
    sura: "92",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَاللَّيْلِ إِذَا يَغْشَىٰ",
  },
  {
    id: "6060",
    sura: "92",
    VerseIDAr: "2",
    ayatAR: "وَالنَّهَارِ إِذَا تَجَلَّىٰ",
  },
  {
    id: "6061",
    sura: "92",
    VerseIDAr: "3",
    ayatAR: "وَمَا خَلَقَ الذَّكَرَ وَالْأُنْثَىٰ",
  },
  {
    id: "6062",
    sura: "92",
    VerseIDAr: "4",
    ayatAR: "إِنَّ سَعْيَكُمْ لَشَتَّىٰ",
  },
  {
    id: "6063",
    sura: "92",
    VerseIDAr: "5",
    ayatAR: "فَأَمَّا مَنْ أَعْطَىٰ وَاتَّقَىٰ",
  },
  { id: "6064", sura: "92", VerseIDAr: "6", ayatAR: "وَصَدَّقَ بِالْحُسْنَىٰ" },
  {
    id: "6065",
    sura: "92",
    VerseIDAr: "7",
    ayatAR: "فَسَنُيَسِّرُهُ لِلْيُسْرَىٰ",
  },
  {
    id: "6066",
    sura: "92",
    VerseIDAr: "8",
    ayatAR: "وَأَمَّا مَنْ بَخِلَ وَاسْتَغْنَىٰ",
  },
  { id: "6067", sura: "92", VerseIDAr: "9", ayatAR: "وَكَذَّبَ بِالْحُسْنَىٰ" },
  {
    id: "6068",
    sura: "92",
    VerseIDAr: "10",
    ayatAR: "فَسَنُيَسِّرُهُ لِلْعُسْرَىٰ",
  },
  {
    id: "6069",
    sura: "92",
    VerseIDAr: "11",
    ayatAR: "وَمَا يُغْنِي عَنْهُ مَالُهُ إِذَا تَرَدَّىٰ",
  },
  {
    id: "6070",
    sura: "92",
    VerseIDAr: "12",
    ayatAR: "إِنَّ عَلَيْنَا لَلْهُدَىٰ",
  },
  {
    id: "6071",
    sura: "92",
    VerseIDAr: "13",
    ayatAR: "وَإِنَّ لَنَا لَلْآخِرَةَ وَالْأُولَىٰ",
  },
  {
    id: "6072",
    sura: "92",
    VerseIDAr: "14",
    ayatAR: "فَأَنْذَرْتُكُمْ نَارًا تَلَظَّىٰ",
  },
  {
    id: "6073",
    sura: "92",
    VerseIDAr: "15",
    ayatAR: "لَا يَصْلَاهَا إِلَّا الْأَشْقَى",
  },
  {
    id: "6074",
    sura: "92",
    VerseIDAr: "16",
    ayatAR: "الَّذِي كَذَّبَ وَتَوَلَّىٰ",
  },
  {
    id: "6075",
    sura: "92",
    VerseIDAr: "17",
    ayatAR: "وَسَيُجَنَّبُهَا الْأَتْقَى",
  },
  {
    id: "6076",
    sura: "92",
    VerseIDAr: "18",
    ayatAR: "الَّذِي يُؤْتِي مَالَهُ يَتَزَكَّىٰ",
  },
  {
    id: "6077",
    sura: "92",
    VerseIDAr: "19",
    ayatAR: "وَمَا لِأَحَدٍ عِنْدَهُ مِنْ نِعْمَةٍ تُجْزَىٰ",
  },
  {
    id: "6078",
    sura: "92",
    VerseIDAr: "20",
    ayatAR: "إِلَّا ابْتِغَاءَ وَجْهِ رَبِّهِ الْأَعْلَىٰ",
  },
  { id: "6079", sura: "92", VerseIDAr: "21", ayatAR: "وَلَسَوْفَ يَرْضَىٰ" },
  {
    id: "6080",
    sura: "93",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالضُّحَىٰ",
  },
  {
    id: "6081",
    sura: "93",
    VerseIDAr: "2",
    ayatAR: "وَاللَّيْلِ إِذَا سَجَىٰ",
  },
  {
    id: "6082",
    sura: "93",
    VerseIDAr: "3",
    ayatAR: "مَا وَدَّعَكَ رَبُّكَ وَمَا قَلَىٰ",
  },
  {
    id: "6083",
    sura: "93",
    VerseIDAr: "4",
    ayatAR: "وَلَلْآخِرَةُ خَيْرٌ لَكَ مِنَ الْأُولَىٰ",
  },
  {
    id: "6084",
    sura: "93",
    VerseIDAr: "5",
    ayatAR: "وَلَسَوْفَ يُعْطِيكَ رَبُّكَ فَتَرْضَىٰ",
  },
  {
    id: "6085",
    sura: "93",
    VerseIDAr: "6",
    ayatAR: "أَلَمْ يَجِدْكَ يَتِيمًا فَآوَىٰ",
  },
  {
    id: "6086",
    sura: "93",
    VerseIDAr: "7",
    ayatAR: "وَوَجَدَكَ ضَالًّا فَهَدَىٰ",
  },
  {
    id: "6087",
    sura: "93",
    VerseIDAr: "8",
    ayatAR: "وَوَجَدَكَ عَائِلًا فَأَغْنَىٰ",
  },
  {
    id: "6088",
    sura: "93",
    VerseIDAr: "9",
    ayatAR: "فَأَمَّا الْيَتِيمَ فَلَا تَقْهَرْ",
  },
  {
    id: "6089",
    sura: "93",
    VerseIDAr: "10",
    ayatAR: "وَأَمَّا السَّائِلَ فَلَا تَنْهَرْ",
  },
  {
    id: "6090",
    sura: "93",
    VerseIDAr: "11",
    ayatAR: "وَأَمَّا بِنِعْمَةِ رَبِّكَ فَحَدِّثْ",
  },
  {
    id: "6091",
    sura: "94",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ أَلَمْ نَشْرَحْ لَكَ صَدْرَكَ",
  },
  {
    id: "6092",
    sura: "94",
    VerseIDAr: "2",
    ayatAR: "وَوَضَعْنَا عَنْكَ وِزْرَكَ",
  },
  {
    id: "6093",
    sura: "94",
    VerseIDAr: "3",
    ayatAR: "الَّذِي أَنْقَضَ ظَهْرَكَ",
  },
  {
    id: "6094",
    sura: "94",
    VerseIDAr: "4",
    ayatAR: "وَرَفَعْنَا لَكَ ذِكْرَكَ",
  },
  {
    id: "6095",
    sura: "94",
    VerseIDAr: "5",
    ayatAR: "فَإِنَّ مَعَ الْعُسْرِ يُسْرًا",
  },
  {
    id: "6096",
    sura: "94",
    VerseIDAr: "6",
    ayatAR: "إِنَّ مَعَ الْعُسْرِ يُسْرًا",
  },
  {
    id: "6097",
    sura: "94",
    VerseIDAr: "7",
    ayatAR: "فَإِذَا فَرَغْتَ فَانْصَبْ",
  },
  {
    id: "6098",
    sura: "94",
    VerseIDAr: "8",
    ayatAR: "وَإِلَىٰ رَبِّكَ فَارْغَبْ",
  },
  {
    id: "6099",
    sura: "95",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالتِّينِ وَالزَّيْتُونِ",
  },
  { id: "6100", sura: "95", VerseIDAr: "2", ayatAR: "وَطُورِ سِينِينَ" },
  {
    id: "6101",
    sura: "95",
    VerseIDAr: "3",
    ayatAR: "وَهَٰذَا الْبَلَدِ الْأَمِينِ",
  },
  {
    id: "6102",
    sura: "95",
    VerseIDAr: "4",
    ayatAR: "لَقَدْ خَلَقْنَا الْإِنْسَانَ فِي أَحْسَنِ تَقْوِيمٍ",
  },
  {
    id: "6103",
    sura: "95",
    VerseIDAr: "5",
    ayatAR: "ثُمَّ رَدَدْنَاهُ أَسْفَلَ سَافِلِينَ",
  },
  {
    id: "6104",
    sura: "95",
    VerseIDAr: "6",
    ayatAR:
      "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ فَلَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍ",
  },
  {
    id: "6105",
    sura: "95",
    VerseIDAr: "7",
    ayatAR: "فَمَا يُكَذِّبُكَ بَعْدُ بِالدِّينِ",
  },
  {
    id: "6106",
    sura: "95",
    VerseIDAr: "8",
    ayatAR: "أَلَيْسَ اللَّهُ بِأَحْكَمِ الْحَاكِمِينَ",
  },
  {
    id: "6107",
    sura: "96",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ اقْرَأْ بِاسْمِ رَبِّكَ الَّذِي خَلَقَ",
  },
  {
    id: "6108",
    sura: "96",
    VerseIDAr: "2",
    ayatAR: "خَلَقَ الْإِنْسَانَ مِنْ عَلَقٍ",
  },
  {
    id: "6109",
    sura: "96",
    VerseIDAr: "3",
    ayatAR: "اقْرَأْ وَرَبُّكَ الْأَكْرَمُ",
  },
  {
    id: "6110",
    sura: "96",
    VerseIDAr: "4",
    ayatAR: "الَّذِي عَلَّمَ بِالْقَلَمِ",
  },
  {
    id: "6111",
    sura: "96",
    VerseIDAr: "5",
    ayatAR: "عَلَّمَ الْإِنْسَانَ مَا لَمْ يَعْلَمْ",
  },
  {
    id: "6112",
    sura: "96",
    VerseIDAr: "6",
    ayatAR: "كَلَّا إِنَّ الْإِنْسَانَ لَيَطْغَىٰ",
  },
  { id: "6113", sura: "96", VerseIDAr: "7", ayatAR: "أَنْ رَآهُ اسْتَغْنَىٰ" },
  {
    id: "6114",
    sura: "96",
    VerseIDAr: "8",
    ayatAR: "إِنَّ إِلَىٰ رَبِّكَ الرُّجْعَىٰ",
  },
  {
    id: "6115",
    sura: "96",
    VerseIDAr: "9",
    ayatAR: "أَرَأَيْتَ الَّذِي يَنْهَىٰ",
  },
  { id: "6116", sura: "96", VerseIDAr: "10", ayatAR: "عَبْدًا إِذَا صَلَّىٰ" },
  {
    id: "6117",
    sura: "96",
    VerseIDAr: "11",
    ayatAR: "أَرَأَيْتَ إِنْ كَانَ عَلَى الْهُدَىٰ",
  },
  {
    id: "6118",
    sura: "96",
    VerseIDAr: "12",
    ayatAR: "أَوْ أَمَرَ بِالتَّقْوَىٰ",
  },
  {
    id: "6119",
    sura: "96",
    VerseIDAr: "13",
    ayatAR: "أَرَأَيْتَ إِنْ كَذَّبَ وَتَوَلَّىٰ",
  },
  {
    id: "6120",
    sura: "96",
    VerseIDAr: "14",
    ayatAR: "أَلَمْ يَعْلَمْ بِأَنَّ اللَّهَ يَرَىٰ",
  },
  {
    id: "6121",
    sura: "96",
    VerseIDAr: "15",
    ayatAR: "كَلَّا لَئِنْ لَمْ يَنْتَهِ لَنَسْفَعًا بِالنَّاصِيَةِ",
  },
  {
    id: "6122",
    sura: "96",
    VerseIDAr: "16",
    ayatAR: "نَاصِيَةٍ كَاذِبَةٍ خَاطِئَةٍ",
  },
  { id: "6123", sura: "96", VerseIDAr: "17", ayatAR: "فَلْيَدْعُ نَادِيَهُ" },
  {
    id: "6124",
    sura: "96",
    VerseIDAr: "18",
    ayatAR: "سَنَدْعُ الزَّبَانِيَةَ",
  },
  {
    id: "6125",
    sura: "96",
    VerseIDAr: "19",
    ayatAR: "كَلَّا لَا تُطِعْهُ وَاسْجُدْ وَاقْتَرِبْ ۩",
  },
  {
    id: "6126",
    sura: "97",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِنَّا أَنْزَلْنَاهُ فِي لَيْلَةِ الْقَدْرِ",
  },
  {
    id: "6127",
    sura: "97",
    VerseIDAr: "2",
    ayatAR: "وَمَا أَدْرَاكَ مَا لَيْلَةُ الْقَدْرِ",
  },
  {
    id: "6128",
    sura: "97",
    VerseIDAr: "3",
    ayatAR: "لَيْلَةُ الْقَدْرِ خَيْرٌ مِنْ أَلْفِ شَهْرٍ",
  },
  {
    id: "6129",
    sura: "97",
    VerseIDAr: "4",
    ayatAR:
      "تَنَزَّلُ الْمَلَائِكَةُ وَالرُّوحُ فِيهَا بِإِذْنِ رَبِّهِمْ مِنْ كُلِّ أَمْرٍ",
  },
  {
    id: "6130",
    sura: "97",
    VerseIDAr: "5",
    ayatAR: "سَلَامٌ هِيَ حَتَّىٰ مَطْلَعِ الْفَجْرِ",
  },
  {
    id: "6131",
    sura: "98",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ لَمْ يَكُنِ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ وَالْمُشْرِكِينَ مُنْفَكِّينَ حَتَّىٰ تَأْتِيَهُمُ الْبَيِّنَةُ",
  },
  {
    id: "6132",
    sura: "98",
    VerseIDAr: "2",
    ayatAR: "رَسُولٌ مِنَ اللَّهِ يَتْلُو صُحُفًا مُطَهَّرَةً",
  },
  { id: "6133", sura: "98", VerseIDAr: "3", ayatAR: "فِيهَا كُتُبٌ قَيِّمَةٌ" },
  {
    id: "6134",
    sura: "98",
    VerseIDAr: "4",
    ayatAR:
      "وَمَا تَفَرَّقَ الَّذِينَ أُوتُوا الْكِتَابَ إِلَّا مِنْ بَعْدِ مَا جَاءَتْهُمُ الْبَيِّنَةُ",
  },
  {
    id: "6135",
    sura: "98",
    VerseIDAr: "5",
    ayatAR:
      "وَمَا أُمِرُوا إِلَّا لِيَعْبُدُوا اللَّهَ مُخْلِصِينَ لَهُ الدِّينَ حُنَفَاءَ وَيُقِيمُوا الصَّلَاةَ وَيُؤْتُوا الزَّكَاةَ ۚ وَذَٰلِكَ دِينُ الْقَيِّمَةِ",
  },
  {
    id: "6136",
    sura: "98",
    VerseIDAr: "6",
    ayatAR:
      "إِنَّ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ وَالْمُشْرِكِينَ فِي نَارِ جَهَنَّمَ خَالِدِينَ فِيهَا ۚ أُولَٰئِكَ هُمْ شَرُّ الْبَرِيَّةِ",
  },
  {
    id: "6137",
    sura: "98",
    VerseIDAr: "7",
    ayatAR:
      "إِنَّ الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ أُولَٰئِكَ هُمْ خَيْرُ الْبَرِيَّةِ",
  },
  {
    id: "6138",
    sura: "98",
    VerseIDAr: "8",
    ayatAR:
      "جَزَاؤُهُمْ عِنْدَ رَبِّهِمْ جَنَّاتُ عَدْنٍ تَجْرِي مِنْ تَحْتِهَا الْأَنْهَارُ خَالِدِينَ فِيهَا أَبَدًا ۖ رَضِيَ اللَّهُ عَنْهُمْ وَرَضُوا عَنْهُ ۚ ذَٰلِكَ لِمَنْ خَشِيَ رَبَّهُ",
  },
  {
    id: "6139",
    sura: "99",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا زُلْزِلَتِ الْأَرْضُ زِلْزَالَهَا",
  },
  {
    id: "6140",
    sura: "99",
    VerseIDAr: "2",
    ayatAR: "وَأَخْرَجَتِ الْأَرْضُ أَثْقَالَهَا",
  },
  {
    id: "6141",
    sura: "99",
    VerseIDAr: "3",
    ayatAR: "وَقَالَ الْإِنْسَانُ مَا لَهَا",
  },
  {
    id: "6142",
    sura: "99",
    VerseIDAr: "4",
    ayatAR: "يَوْمَئِذٍ تُحَدِّثُ أَخْبَارَهَا",
  },
  {
    id: "6143",
    sura: "99",
    VerseIDAr: "5",
    ayatAR: "بِأَنَّ رَبَّكَ أَوْحَىٰ لَهَا",
  },
  {
    id: "6144",
    sura: "99",
    VerseIDAr: "6",
    ayatAR: "يَوْمَئِذٍ يَصْدُرُ النَّاسُ أَشْتَاتًا لِيُرَوْا أَعْمَالَهُمْ",
  },
  {
    id: "6145",
    sura: "99",
    VerseIDAr: "7",
    ayatAR: "فَمَنْ يَعْمَلْ مِثْقَالَ ذَرَّةٍ خَيْرًا يَرَهُ",
  },
  {
    id: "6146",
    sura: "99",
    VerseIDAr: "8",
    ayatAR: "وَمَنْ يَعْمَلْ مِثْقَالَ ذَرَّةٍ شَرًّا يَرَهُ",
  },
  {
    id: "6147",
    sura: "100",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالْعَادِيَاتِ ضَبْحًا",
  },
  {
    id: "6148",
    sura: "100",
    VerseIDAr: "2",
    ayatAR: "فَالْمُورِيَاتِ قَدْحًا",
  },
  {
    id: "6149",
    sura: "100",
    VerseIDAr: "3",
    ayatAR: "فَالْمُغِيرَاتِ صُبْحًا",
  },
  {
    id: "6150",
    sura: "100",
    VerseIDAr: "4",
    ayatAR: "فَأَثَرْنَ بِهِ نَقْعًا",
  },
  {
    id: "6151",
    sura: "100",
    VerseIDAr: "5",
    ayatAR: "فَوَسَطْنَ بِهِ جَمْعًا",
  },
  {
    id: "6152",
    sura: "100",
    VerseIDAr: "6",
    ayatAR: "إِنَّ الْإِنْسَانَ لِرَبِّهِ لَكَنُودٌ",
  },
  {
    id: "6153",
    sura: "100",
    VerseIDAr: "7",
    ayatAR: "وَإِنَّهُ عَلَىٰ ذَٰلِكَ لَشَهِيدٌ",
  },
  {
    id: "6154",
    sura: "100",
    VerseIDAr: "8",
    ayatAR: "وَإِنَّهُ لِحُبِّ الْخَيْرِ لَشَدِيدٌ",
  },
  {
    id: "6155",
    sura: "100",
    VerseIDAr: "9",
    ayatAR: "أَفَلَا يَعْلَمُ إِذَا بُعْثِرَ مَا فِي الْقُبُورِ",
  },
  {
    id: "6156",
    sura: "100",
    VerseIDAr: "10",
    ayatAR: "وَحُصِّلَ مَا فِي الصُّدُورِ",
  },
  {
    id: "6157",
    sura: "100",
    VerseIDAr: "11",
    ayatAR: "إِنَّ رَبَّهُمْ بِهِمْ يَوْمَئِذٍ لَخَبِيرٌ",
  },
  {
    id: "6158",
    sura: "101",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ الْقَارِعَةُ",
  },
  { id: "6159", sura: "101", VerseIDAr: "2", ayatAR: "مَا الْقَارِعَةُ" },
  {
    id: "6160",
    sura: "101",
    VerseIDAr: "3",
    ayatAR: "وَمَا أَدْرَاكَ مَا الْقَارِعَةُ",
  },
  {
    id: "6161",
    sura: "101",
    VerseIDAr: "4",
    ayatAR: "يَوْمَ يَكُونُ النَّاسُ كَالْفَرَاشِ الْمَبْثُوثِ",
  },
  {
    id: "6162",
    sura: "101",
    VerseIDAr: "5",
    ayatAR: "وَتَكُونُ الْجِبَالُ كَالْعِهْنِ الْمَنْفُوشِ",
  },
  {
    id: "6163",
    sura: "101",
    VerseIDAr: "6",
    ayatAR: "فَأَمَّا مَنْ ثَقُلَتْ مَوَازِينُهُ",
  },
  {
    id: "6164",
    sura: "101",
    VerseIDAr: "7",
    ayatAR: "فَهُوَ فِي عِيشَةٍ رَاضِيَةٍ",
  },
  {
    id: "6165",
    sura: "101",
    VerseIDAr: "8",
    ayatAR: "وَأَمَّا مَنْ خَفَّتْ مَوَازِينُهُ",
  },
  { id: "6166", sura: "101", VerseIDAr: "9", ayatAR: "فَأُمُّهُ هَاوِيَةٌ" },
  {
    id: "6167",
    sura: "101",
    VerseIDAr: "10",
    ayatAR: "وَمَا أَدْرَاكَ مَا هِيَهْ",
  },
  { id: "6168", sura: "101", VerseIDAr: "11", ayatAR: "نَارٌ حَامِيَةٌ" },
  {
    id: "6169",
    sura: "102",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ أَلْهَاكُمُ التَّكَاثُرُ",
  },
  {
    id: "6170",
    sura: "102",
    VerseIDAr: "2",
    ayatAR: "حَتَّىٰ زُرْتُمُ الْمَقَابِرَ",
  },
  {
    id: "6171",
    sura: "102",
    VerseIDAr: "3",
    ayatAR: "كَلَّا سَوْفَ تَعْلَمُونَ",
  },
  {
    id: "6172",
    sura: "102",
    VerseIDAr: "4",
    ayatAR: "ثُمَّ كَلَّا سَوْفَ تَعْلَمُونَ",
  },
  {
    id: "6173",
    sura: "102",
    VerseIDAr: "5",
    ayatAR: "كَلَّا لَوْ تَعْلَمُونَ عِلْمَ الْيَقِينِ",
  },
  { id: "6174", sura: "102", VerseIDAr: "6", ayatAR: "لَتَرَوُنَّ الْجَحِيمَ" },
  {
    id: "6175",
    sura: "102",
    VerseIDAr: "7",
    ayatAR: "ثُمَّ لَتَرَوُنَّهَا عَيْنَ الْيَقِينِ",
  },
  {
    id: "6176",
    sura: "102",
    VerseIDAr: "8",
    ayatAR: "ثُمَّ لَتُسْأَلُنَّ يَوْمَئِذٍ عَنِ النَّعِيمِ",
  },
  {
    id: "6177",
    sura: "103",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَالْعَصْرِ",
  },
  {
    id: "6178",
    sura: "103",
    VerseIDAr: "2",
    ayatAR: "إِنَّ الْإِنْسَانَ لَفِي خُسْرٍ",
  },
  {
    id: "6179",
    sura: "103",
    VerseIDAr: "3",
    ayatAR:
      "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَتَوَاصَوْا بِالْحَقِّ وَتَوَاصَوْا بِالصَّبْرِ",
  },
  {
    id: "6180",
    sura: "104",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ وَيْلٌ لِكُلِّ هُمَزَةٍ لُمَزَةٍ",
  },
  {
    id: "6181",
    sura: "104",
    VerseIDAr: "2",
    ayatAR: "الَّذِي جَمَعَ مَالًا وَعَدَّدَهُ",
  },
  {
    id: "6182",
    sura: "104",
    VerseIDAr: "3",
    ayatAR: "يَحْسَبُ أَنَّ مَالَهُ أَخْلَدَهُ",
  },
  {
    id: "6183",
    sura: "104",
    VerseIDAr: "4",
    ayatAR: "كَلَّا ۖ لَيُنْبَذَنَّ فِي الْحُطَمَةِ",
  },
  {
    id: "6184",
    sura: "104",
    VerseIDAr: "5",
    ayatAR: "وَمَا أَدْرَاكَ مَا الْحُطَمَةُ",
  },
  {
    id: "6185",
    sura: "104",
    VerseIDAr: "6",
    ayatAR: "نَارُ اللَّهِ الْمُوقَدَةُ",
  },
  {
    id: "6186",
    sura: "104",
    VerseIDAr: "7",
    ayatAR: "الَّتِي تَطَّلِعُ عَلَى الْأَفْئِدَةِ",
  },
  {
    id: "6187",
    sura: "104",
    VerseIDAr: "8",
    ayatAR: "إِنَّهَا عَلَيْهِمْ مُؤْصَدَةٌ",
  },
  { id: "6188", sura: "104", VerseIDAr: "9", ayatAR: "فِي عَمَدٍ مُمَدَّدَةٍ" },
  {
    id: "6189",
    sura: "105",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِأَصْحَابِ الْفِيلِ",
  },
  {
    id: "6190",
    sura: "105",
    VerseIDAr: "2",
    ayatAR: "أَلَمْ يَجْعَلْ كَيْدَهُمْ فِي تَضْلِيلٍ",
  },
  {
    id: "6191",
    sura: "105",
    VerseIDAr: "3",
    ayatAR: "وَأَرْسَلَ عَلَيْهِمْ طَيْرًا أَبَابِيلَ",
  },
  {
    id: "6192",
    sura: "105",
    VerseIDAr: "4",
    ayatAR: "تَرْمِيهِمْ بِحِجَارَةٍ مِنْ سِجِّيلٍ",
  },
  {
    id: "6193",
    sura: "105",
    VerseIDAr: "5",
    ayatAR: "فَجَعَلَهُمْ كَعَصْفٍ مَأْكُولٍ",
  },
  {
    id: "6194",
    sura: "106",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ لِإِيلَافِ قُرَيْشٍ",
  },
  {
    id: "6195",
    sura: "106",
    VerseIDAr: "2",
    ayatAR: "إِيلَافِهِمْ رِحْلَةَ الشِّتَاءِ وَالصَّيْفِ",
  },
  {
    id: "6196",
    sura: "106",
    VerseIDAr: "3",
    ayatAR: "فَلْيَعْبُدُوا رَبَّ هَٰذَا الْبَيْتِ",
  },
  {
    id: "6197",
    sura: "106",
    VerseIDAr: "4",
    ayatAR: "الَّذِي أَطْعَمَهُمْ مِنْ جُوعٍ وَآمَنَهُمْ مِنْ خَوْفٍ",
  },
  {
    id: "6198",
    sura: "107",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ أَرَأَيْتَ الَّذِي يُكَذِّبُ بِالدِّينِ",
  },
  {
    id: "6199",
    sura: "107",
    VerseIDAr: "2",
    ayatAR: "فَذَٰلِكَ الَّذِي يَدُعُّ الْيَتِيمَ",
  },
  {
    id: "6200",
    sura: "107",
    VerseIDAr: "3",
    ayatAR: "وَلَا يَحُضُّ عَلَىٰ طَعَامِ الْمِسْكِينِ",
  },
  {
    id: "6201",
    sura: "107",
    VerseIDAr: "4",
    ayatAR: "فَوَيْلٌ لِلْمُصَلِّينَ",
  },
  {
    id: "6202",
    sura: "107",
    VerseIDAr: "5",
    ayatAR: "الَّذِينَ هُمْ عَنْ صَلَاتِهِمْ سَاهُونَ",
  },
  {
    id: "6203",
    sura: "107",
    VerseIDAr: "6",
    ayatAR: "الَّذِينَ هُمْ يُرَاءُونَ",
  },
  {
    id: "6204",
    sura: "107",
    VerseIDAr: "7",
    ayatAR: "وَيَمْنَعُونَ الْمَاعُونَ",
  },
  {
    id: "6205",
    sura: "108",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِنَّا أَعْطَيْنَاكَ الْكَوْثَرَ",
  },
  {
    id: "6206",
    sura: "108",
    VerseIDAr: "2",
    ayatAR: "فَصَلِّ لِرَبِّكَ وَانْحَرْ",
  },
  {
    id: "6207",
    sura: "108",
    VerseIDAr: "3",
    ayatAR: "إِنَّ شَانِئَكَ هُوَ الْأَبْتَرُ",
  },
  {
    id: "6208",
    sura: "109",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قُلْ يَا أَيُّهَا الْكَافِرُونَ",
  },
  {
    id: "6209",
    sura: "109",
    VerseIDAr: "2",
    ayatAR: "لَا أَعْبُدُ مَا تَعْبُدُونَ",
  },
  {
    id: "6210",
    sura: "109",
    VerseIDAr: "3",
    ayatAR: "وَلَا أَنْتُمْ عَابِدُونَ مَا أَعْبُدُ",
  },
  {
    id: "6211",
    sura: "109",
    VerseIDAr: "4",
    ayatAR: "وَلَا أَنَا عَابِدٌ مَا عَبَدْتُمْ",
  },
  {
    id: "6212",
    sura: "109",
    VerseIDAr: "5",
    ayatAR: "وَلَا أَنْتُمْ عَابِدُونَ مَا أَعْبُدُ",
  },
  {
    id: "6213",
    sura: "109",
    VerseIDAr: "6",
    ayatAR: "لَكُمْ دِينُكُمْ وَلِيَ دِينِ",
  },
  {
    id: "6214",
    sura: "110",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ إِذَا جَاءَ نَصْرُ اللَّهِ وَالْفَتْحُ",
  },
  {
    id: "6215",
    sura: "110",
    VerseIDAr: "2",
    ayatAR: "وَرَأَيْتَ النَّاسَ يَدْخُلُونَ فِي دِينِ اللَّهِ أَفْوَاجًا",
  },
  {
    id: "6216",
    sura: "110",
    VerseIDAr: "3",
    ayatAR:
      "فَسَبِّحْ بِحَمْدِ رَبِّكَ وَاسْتَغْفِرْهُ ۚ إِنَّهُ كَانَ تَوَّابًا",
  },
  {
    id: "6217",
    sura: "111",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ تَبَّتْ يَدَا أَبِي لَهَبٍ وَتَبَّ",
  },
  {
    id: "6218",
    sura: "111",
    VerseIDAr: "2",
    ayatAR: "مَا أَغْنَىٰ عَنْهُ مَالُهُ وَمَا كَسَبَ",
  },
  {
    id: "6219",
    sura: "111",
    VerseIDAr: "3",
    ayatAR: "سَيَصْلَىٰ نَارًا ذَاتَ لَهَبٍ",
  },
  {
    id: "6220",
    sura: "111",
    VerseIDAr: "4",
    ayatAR: "وَامْرَأَتُهُ حَمَّالَةَ الْحَطَبِ",
  },
  {
    id: "6221",
    sura: "111",
    VerseIDAr: "5",
    ayatAR: "فِي جِيدِهَا حَبْلٌ مِنْ مَسَدٍ",
  },
  {
    id: "6222",
    sura: "112",
    VerseIDAr: "1",
    ayatAR: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قُلْ هُوَ اللَّهُ أَحَدٌ",
  },
  { id: "6223", sura: "112", VerseIDAr: "2", ayatAR: "اللَّهُ الصَّمَدُ" },
  {
    id: "6224",
    sura: "112",
    VerseIDAr: "3",
    ayatAR: "لَمْ يَلِدْ وَلَمْ يُولَدْ",
  },
  {
    id: "6225",
    sura: "112",
    VerseIDAr: "4",
    ayatAR: "وَلَمْ يَكُنْ لَهُ كُفُوًا أَحَدٌ",
  },
  {
    id: "6226",
    sura: "113",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ",
  },
  { id: "6227", sura: "113", VerseIDAr: "2", ayatAR: "مِنْ شَرِّ مَا خَلَقَ" },
  {
    id: "6228",
    sura: "113",
    VerseIDAr: "3",
    ayatAR: "وَمِنْ شَرِّ غَاسِقٍ إِذَا وَقَبَ",
  },
  {
    id: "6229",
    sura: "113",
    VerseIDAr: "4",
    ayatAR: "وَمِنْ شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ",
  },
  {
    id: "6230",
    sura: "113",
    VerseIDAr: "5",
    ayatAR: "وَمِنْ شَرِّ حَاسِدٍ إِذَا حَسَدَ",
  },
  {
    id: "6231",
    sura: "114",
    VerseIDAr: "1",
    ayatAR:
      "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ قُلْ أَعُوذُ بِرَبِّ النَّاسِ",
  },
  { id: "6232", sura: "114", VerseIDAr: "2", ayatAR: "مَلِكِ النَّاسِ" },
  { id: "6233", sura: "114", VerseIDAr: "3", ayatAR: "إِلَٰهِ النَّاسِ" },
  {
    id: "6234",
    sura: "114",
    VerseIDAr: "4",
    ayatAR: "مِنْ شَرِّ الْوَسْوَاسِ الْخَنَّاسِ",
  },
  {
    id: "6235",
    sura: "114",
    VerseIDAr: "5",
    ayatAR: "الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ",
  },
  {
    id: "6236",
    sura: "114",
    VerseIDAr: "6",
    ayatAR: "مِنَ الْجِنَّةِ وَالنَّاسِ",
  },
];

export default AYATH;
